let  champs = [
    {
      "id": 18,
      "name": "Abomination",
      "description": "A mind is a terrible thing to waste. So is a spleen, a kidney, a liver, an eye... - Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 74,
      "hash": "cj9Ej9Dj9CG2BG2Aj9Cj9Dj9Eeeeerzzgvqhtmnj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 28,
          "apCost": 0,
          "name": "Blood Frenzy",
          "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 1270,
          "apCost": 1,
          "name": "Tectonic Pulse",
          "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 2737,
              "apCost": 0,
              "name": "Physical Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Physical Aura 3.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 2262,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "charged_abuse"
            },
            {
              "default": true,
              "id": 2837,
              "apCost": 0,
              "name": "Psychotic Break",
              "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "psychotic_break"
            }
          ]
        }
      ]
    },
    {
      "id": 292,
      "name": "Abyssal Fiend",
      "description": "Scarge, tell those Nefari of yours to advance with the fiends...I tire of the elve's volleys and would like to watch them burn. - Maxxarek",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 66,
      "hash": "dj9Fj9EE8DF0AG2Aj9Bj9Cj9Dmsqjwqlersjlpfg",
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1505,
      "name": "Accursed Scrofula",
      "description": "\"For the Scrofulas misery loves company and we have all been invited!\" - Private Journal of Bokor Marcus",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 68,
      "hash": "ej9Bj9AE8DF0Be9Af1Bj9Ej9Feepfvkerhvfegpf",
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            },
            {
              "default": true,
              "id": 2288,
              "apCost": 0,
              "name": "Designate Scapegoat",
              "shortDescription": "Target friendly champion becomes the target of the next opposing spell. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2701,
              "apCost": 0,
              "name": "Shadestrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrain_dmz"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        }
      ]
    },
    {
      "id": 1500,
      "name": "Acid Dartwing",
      "description": "While not technically a Myx, the Acid Dartwing does share a number of genetic similarities to the Myx.  Additionally, these wasp-like creatures have been observed caring for Myx pupae.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 68,
      "hash": "ej9AJ8Jf1AF0Be9Af1AJ8Jj9Aeemlroyknerlyo",
      "artist": "Paul Guzenko",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2490,
              "apCost": 0,
              "name": "Brood Bond",
              "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "broodbond"
            },
            {
              "default": true,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": true,
              "id": 2497,
              "apCost": 0,
              "name": "Amplify: Acid",
              "shortDescription": "Acid damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_acid"
            },
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 311,
      "name": "Acid Dragoleech",
      "description": "The mines are just not producing like they should. Those blasted dragons are leeching the nora from us! High Mason reporting to the General.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 64,
      "hash": "dJ8IJ8HF0AF0AG2Aj9Bj9Cj9Dtjtqjnjrluxmuzg",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 492,
      "name": "Acid Elemental",
      "description": "The bile of the Sundered Lands brought forth a protector, worthy of guarding the Draksar Empire.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 75,
      "hash": "dj9Bj9Af1Bf1AE8Dj9Ej9Fj9Geiyvqolgeggkwfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1369,
          "apCost": 0,
          "name": "Deflect: Acid",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Acid damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 201,
              "apCost": 0,
              "name": "Death Nova: Acid",
              "shortDescription": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaacid"
            },
            {
              "default": false,
              "id": 1401,
              "apCost": 0,
              "name": "Acidic Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_acid"
            },
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2497,
              "apCost": 0,
              "name": "Amplify: Acid",
              "shortDescription": "Acid damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_acid"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": true,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            }
          ]
        }
      ]
    },
    {
      "id": 270,
      "name": "Afflicted Corpse",
      "description": "Queen J'orea, we have finally killed the risen magi but the shardmasters want to know what they should do before the dead take another of our tombs. - Magister, Jakei Mage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 50,
      "hash": "dj9Gj9Fe9AF0Af1AJ8Jj9Aj9Brqonssheiineeeg",
      "artist": "Trevor Claxton",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1847,
          "apCost": 0,
          "name": "Hunter: Diseased",
          "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "disease"
        },
        {
          "id": 1500,
          "apCost": 4,
          "name": "Locust Cloud",
          "shortDescription": "Area Effect 2, Range 5: Affected champions take 8 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Mini-locust Swarm (Opposing champions within the affected area have -2 DEF).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "locust_swarm"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            },
            {
              "default": false,
              "id": 156,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novadisease"
            },
            {
              "default": false,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3361,
              "apCost": 0,
              "name": "Spellsurge: Festering Wounds",
              "shortDescription": "When this champion is deployed, Festering Wounds spells are revealed from your runedock. Festering Wounds spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Festering Wounds spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": false,
              "id": 253,
              "apCost": 0,
              "name": "Damage Shield: Disease",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Disease damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_disease"
            }
          ]
        }
      ]
    },
    {
      "id": 675,
      "name": "Akakios",
      "description": "The Draksar Lord spent many months in hiding, deep within the kingdom of Valdac. When he finally emerged, his visage had changed. He had gained the power of the dragon gods.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 91,
      "hash": "dJ8HJ8Ge9BG2AF0BJ8IJ8Jj9Auxqfigvvklwvvxf",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 1886,
          "apCost": 4,
          "name": "Annihilate",
          "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "novafire"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 229,
          "apCost": 0,
          "name": "Damage Shield: Fire",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dmgshld_fire"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 1908,
          "apCost": 0,
          "name": "Fire Acolyte",
          "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "acolyte_fire"
        },
        {
          "id": 1887,
          "apCost": 0,
          "name": "Roar of the Fallen",
          "shortDescription": "When this unit is destroyed, all opposing champions have -1 DEF and -5 DMG for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "ondeath"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1700,
              "apCost": 0,
              "name": "Surge: Draksar",
              "shortDescription": "This unit has +1 DMG for each friendly Draksar.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_draksar"
            },
            {
              "default": false,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 870,
      "name": "Albino Fesh",
      "description": "Albino Fesh are the rarest form of Fesh in known existence. Finding one is considered a sign of great fortune for a Cyclops.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 0,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 63,
      "hash": "dj9Ej9Dg3AG2BG2Aj9Bj9Cj9Dfkepqusojlnjllg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2582,
          "apCost": 0,
          "name": "Impairing Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 896,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 2 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "mind_control"
        },
        {
          "id": 425,
          "apCost": 4,
          "name": "Possession",
          "shortDescription": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns, gains 2 AP and gains <ability value=1408>Chasm Walker</ability> for 4 turns. This unit gains <ability value=2474>Font Ignorance</ability> for 3 turns and becomes <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "possess"
        },
        {
          "id": 2430,
          "apCost": 0,
          "name": "Prognostication",
          "shortDescription": "After 3 turns, target champion within 4 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "passive"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2759,
              "apCost": 0,
              "name": "Guarded: Cyclops",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Cyclops within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2920,
              "apCost": 0,
              "name": "Guarded: Moga",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Moga within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            },
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            }
          ]
        }
      ]
    },
    {
      "id": 1406,
      "name": "Albino Katipo",
      "description": "It looks so cute, until it stings you with its venom - then everything turns red.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 2,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 66,
      "hash": "ej9Ej9Dg3AF0Ae9Ag3Aj9Dj9Eeeemegrhvsmsosf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1440,
          "apCost": 0,
          "name": "Confuse Attacker",
          "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "confuse"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 2836,
          "apCost": 0,
          "name": "Lethal Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion gains a stack of <condition value=lethal>Lethal</condition> if it does not have Avatar, Boss, Elite or Immunity: Poison. This condition can not be cleansed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "katipo_poison"
        },
        {
          "id": 16,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 1256,
              "apCost": 0,
              "name": "Sibling",
              "shortDescription": "When this champion is deployed, champions with the same name are revealed in your runedock. When you have a champion in play with the same name as this one, this champion gains +1 DEF, +1 SPD and +5 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "sibling"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": true,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            }
          ]
        }
      ]
    },
    {
      "id": 471,
      "name": "Almsgiver",
      "description": "The spirit of Forglar brings balance. Through this gift, we achieve serenity. - Malalain, Almsgiver ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Priest"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 71,
      "hash": "dJ8IJ8HF0Af1Ae9Aj9Fj9Gj9Hemuxtfpfepwfgeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1566,
          "apCost": 0,
          "name": "Balance",
          "shortDescription": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "soul_bond"
        },
        {
          "id": 592,
          "apCost": 3,
          "name": "Cleanse",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "cleanse"
        },
        {
          "id": 303,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 4 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "divine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": true,
              "id": 1462,
              "apCost": 2,
              "name": "Hydrate",
              "shortDescription": "Friendly champions within 2 spaces gain 2 AP and the spaces they are standing in turn to Water for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "terrainwater"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": false,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            },
            {
              "default": true,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            }
          ]
        }
      ]
    },
    {
      "id": 539,
      "name": "Alpine Cyclops",
      "description": "The Cyclopes of High Rock are solitary hunters, unlike their tribal brethren. This makes them more elusive.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 63,
      "hash": "dj9Gj9Fe9Af1Be9BJ8GJ8HJ8Ihgilnhgvkyrwiyg",
      "artist": "Anthony Lopes",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2348,
              "apCost": 4,
              "name": "Beast Herder",
              "shortDescription": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "desert_hearder"
            },
            {
              "default": true,
              "id": 1493,
              "apCost": 0,
              "name": "Pathfinding",
              "shortDescription": "All friendly champions that share a race with this one have <ability value=1306>Mountaineer</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "climb"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 970,
              "apCost": 0,
              "name": "Hidden: Rock",
              "shortDescription": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        }
      ]
    },
    {
      "id": 1355,
      "name": "Altered Lemure",
      "description": "Traditionally considered pests by the Nefari, the Lemures proved to be eager test subjects for the Hekatian' experiments.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp",
        "Mutant"
      ],
      "noraCost": 59,
      "hash": "ej9AJ8Jf1AF0Ae9Af1AJ8Jj9Aeipyggtszkrowo",
      "artist": "Conceptopolis",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 144,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novapoison"
            },
            {
              "default": false,
              "id": 426,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 2: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 145,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapoison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            },
            {
              "default": false,
              "id": 40,
              "apCost": 0,
              "name": "Immunity: Poison",
              "shortDescription": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_poison"
            },
            {
              "default": true,
              "id": 193,
              "apCost": 0,
              "name": "Death Nova: Poison",
              "shortDescription": "When this unit is destroyed, it deals 11 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovapoison"
            }
          ]
        }
      ]
    },
    {
      "id": 828,
      "name": "Ambassador Berkchani",
      "description": "\"The Tortuns ask for our aid in Gharivol. I sail to Maljara tonight on the back of the Ellie P to assess the situation. I expect to give a bleak report. They will need reinforcements.\" - Ambassador Berkchani",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 76,
      "hash": "dj9AJ8Jf1AG2Bf1AJ8Jj9Aj9Bjggvziiyzxkepfg",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 217,
          "apCost": 0,
          "name": "Dodge",
          "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1510,
      "name": "Amber Wing",
      "description": "A warrior with a little magical knowledge is a dangerous thing.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 67,
      "hash": "ej9Bj9Af1AF0Be9Af1BJ8Jj9Aeevkjgevsfgigpf",
      "artist": "Andrew Hou",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3004,
          "apCost": 0,
          "name": "Amber Sigil",
          "shortDescription": "This champion gains <ability value=1317>Absorb</ability> and +1 DEF for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "griffin_sigil"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 129,
              "apCost": 0,
              "name": "Magical Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novamagic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2632,
              "apCost": 0,
              "name": "Bold",
              "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "channel_defense"
            },
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 220,
      "name": "Ambling Frond",
      "description": "Made from stumps of trees and roots, fronds carry the memories from the lives of every creature they are made from. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 4,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Plant"
      ],
      "noraCost": 56,
      "hash": "dJ8IJ8HF0Ae9Be9Aj9Fj9Gj9Huqfemytmuztsqzg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 791,
          "apCost": 0,
          "name": "Hidden: Vegetation",
          "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1458,
              "apCost": 0,
              "name": "Forest Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terraingrass"
            },
            {
              "default": true,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            }
          ]
        }
      ]
    },
    {
      "id": 1478,
      "name": "Amethyst Wing",
      "description": "Known as Stormriders by some, the Amethyst Wings are the religious zealots of the Wings of Al'Mara.  Drafted from the most devoted recruits of the Inquisition, they go through rigorous training to channel and become the thunderstorms they embody.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 77,
      "hash": "eJ8IJ8HF0AF0Be9AF0AJ8HJ8Iemjepfvqjexojn",
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2984,
          "apCost": 0,
          "name": "Amethyst Sigil",
          "shortDescription": "This champion gains <ability value=1274>Vaporize</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "griffin_sigil"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 805,
          "apCost": 1,
          "name": "Chain Lightning",
          "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "electric"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 2030,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +2 DEF.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plusdefense"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 732,
              "apCost": 0,
              "name": "Fury",
              "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 446,
      "name": "Ancestral Avenger",
      "description": "The true father of our forests has awoken. His wrath will be merciless. - Menalaus, K'thir priest",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 16,
      "hitPoints": 69,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Garu",
        "Spirit"
      ],
      "noraCost": 108,
      "hash": "dJ8HJ8Ge9Bf1AF0AJ8HJ8IJ8Jeerzowfmnwfxfvf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2516,
          "apCost": 3,
          "name": "Ancestral Anger",
          "shortDescription": "Target champion within 5 spaces gains Berserker 3 and has a max range of 1 for 6 turns. If target champion is a Garu it also gains 2 ranks of Enrage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 30,
          "iconName": "ancestral_avenger"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1205,
          "apCost": 2,
          "name": "Corporeal Form",
          "shortDescription": "This champion loses <condition value=incorporeal>Incorporeal</condition>.  If it doesn't have Incorporeal, it gains Incorporeal instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 8,
          "iconName": "ethereal"
        },
        {
          "id": 2470,
          "apCost": 1,
          "name": "Howling Attack",
          "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "horrific_howl"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2450,
              "apCost": 0,
              "name": "Guarded: Garu",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Garu within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 1427,
      "name": "Ancient Slag",
      "description": "\"Dry as a fifty year old slag\" -- Moga adage.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 76,
      "hash": "ej9Fj9EG2AF0Be9AE8Dj9Bj9Ceerzmhgvhgknlpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2545,
          "apCost": 0,
          "name": "Guarded: Slag",
          "shortDescription": "The first time each turn this unit is successfully attacked, friendly Slag within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "guarded"
        },
        {
          "id": 2528,
          "apCost": 0,
          "name": "Ooze Tap",
          "shortDescription": "When a non-flying opposing champion within 5 spaces enters Ooze, it takes 2 Acid damage and friendly Slags occupying Ooze within 5 spaces of this unit each heal 2 HP. The damage effect of this ability does not stack and each friendly Slag can only be healed to a maximum of 6 HP from the champion entering Ooze.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2334,
              "apCost": 2,
              "name": "Petrifying Gaze",
              "shortDescription": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "petrifying_gaze"
            },
            {
              "default": true,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            },
            {
              "default": false,
              "id": 1248,
              "apCost": 3,
              "name": "Pull",
              "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "pull"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            },
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 313,
      "name": "Angel of Chaos",
      "description": "Her screams will send the Peaks into a frenzy. Her gift is chaos. - Il`Tara, Goddess of Discord",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 84,
      "hash": "dj9Bj9Af1Bf1Ae9BJ8GJ8HJ8Iwmjnwiepsfpfexf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 164,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_rend"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            }
          ]
        }
      ]
    },
    {
      "id": 1458,
      "name": "Angel of Chaos",
      "description": "Her screams will send the Peaks into a frenzy. Her gift is chaos. - Il`Tara, Goddess of Discord",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 84,
      "hash": "dj9Bj9Af1Bf1Ae9BJ8GJ8HJ8Iwmjnwiepsfpfexf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 164,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_rend"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            }
          ]
        }
      ]
    },
    {
      "id": 1872,
      "name": "Angel of Chaos",
      "description": "Her screams will send the Peaks into a frenzy. Her gift is chaos. - Il`Tara, Goddess of Discord",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 84,
      "hash": "ej9Cj9Bg3AG2BG2AG2Aj9Dj9Eeerzojgyxzgiluf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 164,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_rend"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            }
          ]
        }
      ]
    },
    {
      "id": 482,
      "name": "Angel of Death",
      "description": "Her grasp will silence the hearts of Elsarin. Her gift is death. - Il`Tara, Goddess of Discord",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Undead"
      ],
      "noraCost": 81,
      "hash": "dj9Bj9Af1Bf1AG2Aj9Bj9Cj9Dohtzrhgvkruklgg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2239,
          "apCost": 0,
          "name": "Corruption",
          "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1856,
              "apCost": 1,
              "name": "Thrash",
              "shortDescription": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 1461,
      "name": "Angel of Death",
      "description": "Her grasp will silence the hearts of Elsarin. Her gift is death. - Il`Tara, Goddess of Discord",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Undead"
      ],
      "noraCost": 81,
      "hash": "dj9Bj9Af1Bf1AG2Aj9Bj9Cj9Dohtzrhgvkruklgg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2239,
          "apCost": 0,
          "name": "Corruption",
          "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1856,
              "apCost": 1,
              "name": "Thrash",
              "shortDescription": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 1870,
      "name": "Angel of Death",
      "description": "Her grasp will silence the hearts of Elsarin. Her gift is death. - Il`Tara, Goddess of Discord",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Undead"
      ],
      "noraCost": 81,
      "hash": "ej9Cj9BG2AG2BG2AG2Aj9Bj9Ceeituxkyiieiwtf",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2239,
          "apCost": 0,
          "name": "Corruption",
          "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1856,
              "apCost": 1,
              "name": "Thrash",
              "shortDescription": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 1042,
      "name": "Angel of Mercy",
      "description": "\"She was the most beautiful creature I've ever laid eyes on.\" - Snogvie the Antbear",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin",
        "Priest"
      ],
      "races": [
        "Angel",
        "Spirit"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8IG2BE8De9AF0Bj9Cj9Diwiwkgtxqonhyo",
      "artist": "Alex Fang",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2808,
          "apCost": 0,
          "name": "Mark of Al'Mara",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is Branded (When a Paladin, Shaman or Priest makes a basic attack against this champion, the target takes 2 additional fire damage (ignores DEF). This does not stack) for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 1994,
              "apCost": 2,
              "name": "Sermon",
              "shortDescription": "Friendly champions that share a race with this one get +1 DEF, +2 DMG and +5 HP until this champion next moves. This ability does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 2478,
              "apCost": 0,
              "name": "Improve Range",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_range"
            },
            {
              "default": false,
              "id": 2479,
              "apCost": 0,
              "name": "Improve Speed",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_speed"
            }
          ]
        }
      ]
    },
    {
      "id": 485,
      "name": "Angel of Nourishment",
      "description": "Her generosity will feed the hungry souls of Forglar. Her gift is nourishment. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "dj9Dj9CG2Bf1Ae9BJ8GJ8HJ8Ijekjtjiigerztzg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 843,
              "apCost": 0,
              "name": "Resurrect",
              "shortDescription": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "revive"
            }
          ]
        }
      ]
    },
    {
      "id": 1464,
      "name": "Angel of Nourishment",
      "description": "Her generosity will feed the hungry souls of Forglar. Her gift is nourishment. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "dj9Dj9CG2Bf1Ae9BJ8GJ8HJ8Ijekjtjiigerztzg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 843,
              "apCost": 0,
              "name": "Resurrect",
              "shortDescription": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "revive"
            }
          ]
        }
      ]
    },
    {
      "id": 1866,
      "name": "Angel of Nourishment",
      "description": "Her generosity will feed the hungry souls of Forglar. Her gift is nourishment. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "ej9Cj9Be9BG2BG2AG2AJ8GJ8Hgytmyiiwvhnssqf",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 843,
              "apCost": 0,
              "name": "Resurrect",
              "shortDescription": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "revive"
            }
          ]
        }
      ]
    },
    {
      "id": 480,
      "name": "Angel of Pain",
      "description": "Her ire will bring misery to the depths of Sheoul. Her gift is pain. - Il`Tara, Goddess of Discord",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Demon"
      ],
      "noraCost": 82,
      "hash": "dj9Gj9Fe9Af1Af1Bj9Aj9Bj9Cevojgirwxqqqwfg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 3363,
              "apCost": 0,
              "name": "Bloodlust",
              "shortDescription": "This champion deals 30% additional damage to Bloodied champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1459,
      "name": "Angel of Pain",
      "description": "Her ire will bring misery to the depths of Sheoul. Her gift is pain. - Il`Tara, Goddess of Discord",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Demon"
      ],
      "noraCost": 82,
      "hash": "dj9Gj9Fe9Af1Af1Bj9Aj9Bj9Cevojgirwxqqqwfg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 3363,
              "apCost": 0,
              "name": "Bloodlust",
              "shortDescription": "This champion deals 30% additional damage to Bloodied champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1871,
      "name": "Angel of Pain",
      "description": "Her ire will bring misery to the depths of Sheoul. Her gift is pain. - Il`Tara, Goddess of Discord",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Demon"
      ],
      "noraCost": 82,
      "hash": "ej9Cj9BG2BG2BG2AG2Aj9Cj9Dqwtjrojnevvsftf",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 3363,
              "apCost": 0,
              "name": "Bloodlust",
              "shortDescription": "This champion deals 30% additional damage to Bloodied champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 486,
      "name": "Angel of Perseverance",
      "description": "Her spirit will inspire strength in the Jakei. Her gift is perseverance. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "dj9Dj9CG2Bf1AG2Bj9Cj9Dj9Eeemwzmyvfgvoukg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 1389,
          "apCost": 0,
          "name": "Perseverance",
          "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tgtdefensive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1912,
              "apCost": 0,
              "name": "Resonance",
              "shortDescription": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        }
      ]
    },
    {
      "id": 1465,
      "name": "Angel of Perseverance",
      "description": "Her spirit will inspire strength in the Jakei. Her gift is perseverance. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "dj9Dj9CG2Bf1AG2Bj9Cj9Dj9Eeemwzmyvfgvoukg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 1389,
          "apCost": 0,
          "name": "Perseverance",
          "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tgtdefensive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1912,
              "apCost": 0,
              "name": "Resonance",
              "shortDescription": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        }
      ]
    },
    {
      "id": 1867,
      "name": "Angel of Perseverance",
      "description": "Her spirit will inspire strength in the Jakei. Her gift is perseverance. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "ej9Cj9BF0AG2BG2AG2AJ8HJ8Iuszgymeetsowxqf",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 1389,
          "apCost": 0,
          "name": "Perseverance",
          "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tgtdefensive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1912,
              "apCost": 0,
              "name": "Resonance",
              "shortDescription": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        }
      ]
    },
    {
      "id": 484,
      "name": "Angel of Protection",
      "description": "Her strength will shield the dwarves from harm. Her gift is protection. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 83,
      "hash": "dj9Cj9BG2Af1Af1AJ8Jj9Aj9Bsqoqzmegtqonufg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        },
        {
          "id": 1304,
          "apCost": 0,
          "name": "Trail: Hallowed Ground",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=hallowed_ground>Hallowed Ground</mechanic>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "trail_hallowed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1129,
              "apCost": 0,
              "name": "Ally: K'thir Forest",
              "shortDescription": "While there are other friendly K'thir Forest champions in play, this champion gets +7 HP and +2 DMG. K'thir champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_kf"
            },
            {
              "default": true,
              "id": 1481,
              "apCost": 2,
              "name": "Shield Allies",
              "shortDescription": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2989,
              "apCost": 0,
              "name": "Glyph of Protection",
              "shortDescription": "When this champion is deployed, it gains a <condition value=buffered>Buffer</condition> of 6 HP. If this champion ends its turn within 3 spaces of a friendly non-Illusion champion, the Buffer is reset to 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "seal_of_protection"
            }
          ]
        }
      ]
    },
    {
      "id": 1463,
      "name": "Angel of Protection",
      "description": "Her strength will shield the dwarves from harm. Her gift is protection. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 83,
      "hash": "dj9Cj9BG2Af1Af1AJ8Jj9Aj9Bsqoqzmegtqonufg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        },
        {
          "id": 1304,
          "apCost": 0,
          "name": "Trail: Hallowed Ground",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=hallowed_ground>Hallowed Ground</mechanic>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "trail_hallowed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1129,
              "apCost": 0,
              "name": "Ally: K'thir Forest",
              "shortDescription": "While there are other friendly K'thir Forest champions in play, this champion gets +7 HP and +2 DMG. K'thir champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_kf"
            },
            {
              "default": true,
              "id": 1481,
              "apCost": 2,
              "name": "Shield Allies",
              "shortDescription": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2989,
              "apCost": 0,
              "name": "Glyph of Protection",
              "shortDescription": "When this champion is deployed, it gains a <condition value=buffered>Buffer</condition> of 6 HP. If this champion ends its turn within 3 spaces of a friendly non-Illusion champion, the Buffer is reset to 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "seal_of_protection"
            }
          ]
        }
      ]
    },
    {
      "id": 1868,
      "name": "Angel of Protection",
      "description": "Her strength will shield the dwarves from harm. Her gift is protection. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 83,
      "hash": "ej9Cj9BF0BG2BG2AG2AJ8IJ8Jukeepjrzrofggrf",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        },
        {
          "id": 1304,
          "apCost": 0,
          "name": "Trail: Hallowed Ground",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=hallowed_ground>Hallowed Ground</mechanic>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "trail_hallowed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1129,
              "apCost": 0,
              "name": "Ally: K'thir Forest",
              "shortDescription": "While there are other friendly K'thir Forest champions in play, this champion gets +7 HP and +2 DMG. K'thir champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_kf"
            },
            {
              "default": true,
              "id": 1481,
              "apCost": 2,
              "name": "Shield Allies",
              "shortDescription": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2989,
              "apCost": 0,
              "name": "Glyph of Protection",
              "shortDescription": "When this champion is deployed, it gains a <condition value=buffered>Buffer</condition> of 6 HP. If this champion ends its turn within 3 spaces of a friendly non-Illusion champion, the Buffer is reset to 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "seal_of_protection"
            }
          ]
        }
      ]
    },
    {
      "id": 483,
      "name": "Angel of Restoration",
      "description": "Her kind heart will mend the wounds of K`thir. Her gift is restoration. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 81,
      "hash": "dj9Cj9BG2Af1AF0AJ8HJ8IJ8Jeegkeetsuxtzvzg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1947,
          "apCost": 0,
          "name": "Entangling Attack",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "disable"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1128,
              "apCost": 0,
              "name": "Ally: Ironfist Stronghold",
              "shortDescription": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_is"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": true,
              "id": 1551,
              "apCost": 0,
              "name": "Enduring Aura",
              "shortDescription": "Damage to friendly champions within 3 spaces is reduced by 2. (this ability and its effects do not stack)",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 1462,
      "name": "Angel of Restoration",
      "description": "Her kind heart will mend the wounds of K`thir. Her gift is restoration. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 81,
      "hash": "dj9Cj9BG2Af1AF0AJ8HJ8IJ8Jeegkeetsuxtzvzg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1947,
          "apCost": 0,
          "name": "Entangling Attack",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "disable"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1128,
              "apCost": 0,
              "name": "Ally: Ironfist Stronghold",
              "shortDescription": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_is"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": true,
              "id": 1551,
              "apCost": 0,
              "name": "Enduring Aura",
              "shortDescription": "Damage to friendly champions within 3 spaces is reduced by 2. (this ability and its effects do not stack)",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 1869,
      "name": "Angel of Restoration",
      "description": "Her kind heart will mend the wounds of K`thir. Her gift is restoration. - Al`Mara, Goddess of Order",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 81,
      "hash": "ej9Cj9Bf1BG2BG2AG2Aj9Aj9Bohipwiwmuhvvqsf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1947,
          "apCost": 0,
          "name": "Entangling Attack",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "disable"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1128,
              "apCost": 0,
              "name": "Ally: Ironfist Stronghold",
              "shortDescription": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_is"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": true,
              "id": 1551,
              "apCost": 0,
              "name": "Enduring Aura",
              "shortDescription": "Damage to friendly champions within 3 spaces is reduced by 2. (this ability and its effects do not stack)",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 481,
      "name": "Angel of War",
      "description": "Her fervor will bring glory to the mighty Valdac. Her gift is war. -  Il`Tara, Goddess of Discord",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "dj9Ej9Dg3Af1AF0AJ8HJ8IJ8Jeepjlgygrjwmpfg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2098,
              "apCost": 0,
              "name": "Combo Attack: Drain",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, this unit heals an amount equal to the damage done on the second attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "comboatk_drain"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        }
      ]
    },
    {
      "id": 1460,
      "name": "Angel of War",
      "description": "Her fervor will bring glory to the mighty Valdac. Her gift is war. -  Il`Tara, Goddess of Discord",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "dj9Ej9Dg3Af1AF0AJ8HJ8IJ8Jeepjlgygrjwmpfg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2098,
              "apCost": 0,
              "name": "Combo Attack: Drain",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, this unit heals an amount equal to the damage done on the second attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "comboatk_drain"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        }
      ]
    },
    {
      "id": 1873,
      "name": "Angel of War",
      "description": "Her fervor will bring glory to the mighty Valdac. Her gift is war. -  Il`Tara, Goddess of Discord",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 82,
      "hash": "ej9Dj9CE8DG2BG2AG2Bj9Ej9Fmsqzvosofgtoqsf",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2098,
              "apCost": 0,
              "name": "Combo Attack: Drain",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, this unit heals an amount equal to the damage done on the second attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "comboatk_drain"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        }
      ]
    },
    {
      "id": 1025,
      "name": "Angel Singer",
      "description": "\"Dere I was, layin' in a puddle of me own blood 'bout to pass on to da nex' world when dis angel comes ta me, lays her hands on me and says, \"Your work is not done here dwarf, I will mend you.\" - Dwarven Seargeant Bultman",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Bard",
        "Priest"
      ],
      "races": [
        "Angel",
        "Elf"
      ],
      "noraCost": 76,
      "hash": "eJ8IJ8He9BE8De9AF0AJ8GJ8Heitshrjwvmjyvm",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2851,
          "apCost": 1,
          "name": "Grant: Mobility",
          "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 1750,
          "apCost": 1,
          "name": "Grant: Tempo",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 841,
          "apCost": 3,
          "name": "Nora Shield",
          "shortDescription": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "nora_barrier"
        },
        {
          "id": 842,
          "apCost": 0,
          "name": "Resurrect",
          "shortDescription": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
          "activationType": 1,
          "level": 1,
          "cooldown": 5,
          "noraCost": 2,
          "iconName": "revive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        }
      ]
    },
    {
      "id": 903,
      "name": "Animated Armor",
      "description": "At first, the Leoss were confused; why would the Stronghold send armor sized for dwarves? Then, the suits of armor rose, took up their weapons, and stood at attention.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 69,
      "hash": "dJ8HJ8Ge9Bg3AG2Aj9Bj9Cj9Dirjwxvftqjlemeg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 35,
          "apCost": 0,
          "name": "Immunity: Physical",
          "shortDescription": "Physical damage that would be dealt to this unit is prevented. This unit may not be <condition value=eviscerated popup=false>Eviscerated</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "immunity_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        }
      ]
    },
    {
      "id": 247,
      "name": "Animated Blade",
      "description": "A warrior's spirit is said to reside in his blade. How convenient. - Xulos, Apprentice to Serkan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 7,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Spirit",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "dj9AJ8Jf1Ae9BF0AJ8HJ8IJ8Jumymyvmumsjerwf",
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 164,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_rend"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        }
      ]
    },
    {
      "id": 241,
      "name": "Anthropomancer",
      "description": "How lucky we are to have access to all the great scholars of Old Elsarin, no matter how obscure their specialty. - Xulos, Apprentice to Serkan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1Ae9Bf1AJ8Jj9Aj9Buxkumuvvfvolnyg",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1618,
          "apCost": 0,
          "name": "Desecrated Zone",
          "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "terrain_dmz"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 890,
          "apCost": 0,
          "name": "Grace of the Dead",
          "shortDescription": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "healmass"
        },
        {
          "id": 2649,
          "apCost": 0,
          "name": "Void Shield",
          "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tetra_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        }
      ]
    },
    {
      "id": 174,
      "name": "Apprentice Mage",
      "description": "I know how to cast flame-bind, and weasel-form, and darkness, and... -- I wish I knew how to cast silence! - Apprentice Mages",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 66,
      "hash": "dj9Cj9BG2Ae9AF0BJ8IJ8Jj9Ahrhvhtxvmuzkpyg",
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 2343,
          "apCost": 3,
          "name": "Paralyze",
          "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "sentry"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 964,
              "apCost": 4,
              "name": "Reckless Teleport",
              "shortDescription": "Range 7: This champion is relocated to a random location within 2 spaces of target space.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            },
            {
              "default": false,
              "id": 2633,
              "apCost": 0,
              "name": "Amplify: Magic",
              "shortDescription": "Magic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_magic"
            },
            {
              "default": true,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            }
          ]
        }
      ]
    },
    {
      "id": 264,
      "name": "Arcadon",
      "description": "Send the cattle out...they may be our only hope for getting to the capital. - Jue, Jakei General during the Siege of the Fortress",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9BF0AE8Dj9Ej9Fj9Geruztosmjpjpyxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 909,
          "apCost": 0,
          "name": "Amplify: Frost",
          "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amp_frost"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 721,
          "apCost": 2,
          "name": "Shatter",
          "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "antiequip"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 232,
              "apCost": 0,
              "name": "Damage Shield: Frost",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Frost damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 231,
              "apCost": 0,
              "name": "Damage Shield: Frost",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Frost damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 233,
              "apCost": 0,
              "name": "Damage Shield: Frost",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Frost damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 776,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_chill"
            },
            {
              "default": true,
              "id": 775,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_chill"
            },
            {
              "default": false,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            }
          ]
        }
      ]
    },
    {
      "id": 844,
      "name": "Archangel of Al'Mara",
      "description": "The Archangels serve Al'Mara and her children. When a devout follower of Al'Mara is in danger, an Archangel will descend to save them.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 75,
      "hash": "dj9Cj9BG2AG2Be9Aj9Fj9Gj9Hvhytfvzgrfvzmjg",
      "artist": "Michele Chang",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            },
            {
              "default": true,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 605,
              "apCost": 3,
              "name": "Righteous Shield",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "aegis"
            }
          ]
        }
      ]
    },
    {
      "id": 621,
      "name": "Archer Commander",
      "description": "There is only one elf who can lead my archers in battle, and that is M`alrese. If anyone can make the best of our arrows, it's her. - L`ilim, Elven Archer",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "dj9Dj9CG2Bf1Bf1AJ8Jj9Aj9Bqwvkpukwmnpnlgg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 2298,
          "apCost": 1,
          "name": "Grant: Reflexes",
          "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1089,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 101,
              "apCost": 1,
              "name": "Barrage",
              "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "arrowaoe"
            },
            {
              "default": true,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1803,
              "apCost": 0,
              "name": "Volley Leader",
              "shortDescription": "Other friendly Archers within 5 spaces gain a rank of <ability value=1088>Rain of Arrows</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 668,
      "name": "Archfiend",
      "description": "Despicable cousin! Playing with your prey, like a kitten to his bird. These mortals are our sustenance, not our play things! Must you disgrace your kin for your own amusement? - Kalindras, Archfiend",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Undead",
        "Vampyre"
      ],
      "noraCost": 67,
      "hash": "dj9Ej9Dg3Af1BG2Bj9Cj9Dj9Eeeeeruzxkpnpnlg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3397,
          "apCost": 0,
          "name": "Vampiric Thirst",
          "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2197,
              "apCost": 3,
              "name": "Blood Magic",
              "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            },
            {
              "default": false,
              "id": 1618,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "terrain_dmz"
            },
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            }
          ]
        }
      ]
    },
    {
      "id": 132,
      "name": "Archnic",
      "description": "We thought they were crabs until they pulled our griffin riders from the sky. - Feofil, Assistant to the King",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Mutant"
      ],
      "noraCost": 63,
      "hash": "dJ8IJ8HF0Ae9Af1AJ8Jj9Aj9Bexxkjlgpfmetqwf",
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2369,
          "apCost": 0,
          "name": "Clamp",
          "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "clamp"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 846,
          "apCost": 1,
          "name": "Entangle",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "net"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 441,
      "name": "Arctic Beast",
      "description": "The wind shall no longer sting your skin, beast. It will drive you to destroy all warmth. - Xulos",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Undead"
      ],
      "noraCost": 63,
      "hash": "dj9Fj9EE8Df1AE8Dj9Ej9Fj9Geeemnpwxvzmnneg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 617,
          "apCost": 0,
          "name": "Gore",
          "shortDescription": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gore"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 185,
              "apCost": 0,
              "name": "Death Nova: Frost",
              "shortDescription": "When this unit is destroyed, it deals 11 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafrost"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": true,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            }
          ]
        }
      ]
    },
    {
      "id": 319,
      "name": "Arctic Delegate",
      "description": "I don't see how anything productive can come from discourse with a risen corpse. How can we reason with the dead?",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "dJ8JJ8IF0BF0AF0BJ8IJ8Jj9Aiwiwvmjljitmwxf",
      "artist": "Gabriel Garza",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 1751,
          "apCost": 1,
          "name": "Grant: Frost Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": true,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 476,
      "name": "Arctic Garu",
      "description": "The Garu of the arctic, powerful allies to the Jakei, help defend the Tundra with brute strength.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 74,
      "hash": "dJ8IJ8HF0Af1Af1Bj9Aj9Bj9Cerqfgroumnuqszg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest",
        "Savage Tundra"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1208,
          "apCost": 0,
          "name": "Debilitate",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "debuff"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 395,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-2 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +2 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 394,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1 space in a straight line through non-Impeding terrain and makes a close-combat attack at +1 DMG.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 1,
              "iconName": "charge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 672,
      "name": "Arctic Tiger",
      "description": "The tigers of J`thir are trained to hunt and, when it is necessary, to kill.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9BG2Ae9Aj9Fj9Gj9Huojieerlgpqsfeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 1868,
          "apCost": 0,
          "name": "Tameable",
          "shortDescription": "This champion has +4 DMG while a friendly Lonx is in play. If a friendly Lonx Beast Tamer is in play, it has +1 SPD.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "passive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            },
            {
              "default": false,
              "id": 3197,
              "apCost": 0,
              "name": "Homing Sense",
              "shortDescription": "This unit has <ability value=6>Mobility</ability>. At the beginning of its turns, if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>, this unit is relocated to the closest enemy champion within 5 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "homing_sense"
            }
          ]
        }
      ]
    },
    {
      "id": 126,
      "name": "Arctic Turtle",
      "description": "The Jakei valued them solely for wisdom. The Lonx, by contrast, considered them food, leather, shelter...",
      "maxRng": 1,
      "minRng": 1,
      "defense": 4,
      "speed": 5,
      "damage": 11,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 60,
      "hash": "dj9Gj9Fe9Ae9Af1AJ8Jj9Aj9Bknhrlyolytmlrzg",
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 233,
              "apCost": 0,
              "name": "Damage Shield: Frost",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Frost damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 1604,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "damageshield"
            }
          ]
        }
      ]
    },
    {
      "id": 1346,
      "name": "Aria the Priestess",
      "description": "Aria sometimes felt the need to wrestle with the morality of the Northern Cross' actions, but philosophy would have to wait until the people were safe from corruption.  ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin",
        "Priest"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 71,
      "hash": "eJ8JJ8If1BF0Ae9AF0Bj9Aj9Boqoqftxkrfknwo",
      "artist": "H. D. Mujica \"Andralexis\"",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2733,
          "apCost": 3,
          "name": "Call: Celestial Spear",
          "shortDescription": "Summon a Celestial Spear to target space within 3 spaces.  This ability is removed after use.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "deploy"
        },
        {
          "id": 1967,
          "apCost": 0,
          "name": "Relic Guardian",
          "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 1167,
          "apCost": 0,
          "name": "Taunt: Aria",
          "shortDescription": "Taunt your enemies.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1885,
              "apCost": 3,
              "name": "Cleansing Flame",
              "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2808,
              "apCost": 0,
              "name": "Mark of Al'Mara",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is Branded (When a Paladin, Shaman or Priest makes a basic attack against this champion, the target takes 2 additional fire damage (ignores DEF). This does not stack) for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        }
      ]
    },
    {
      "id": 1769,
      "name": "Armored Fesh",
      "description": "Cousins to the Goliath, Armored fesh are nightmares up close, even if they can't actually swallow their foes.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 7,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 65,
      "hash": "eJ8IJ8He9BF0BG2AF0AJ8GJ8Heevxzohvhvkpqo",
      "artist": "Danh Nguyen",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            },
            {
              "default": false,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 755,
              "apCost": 4,
              "name": "Tunnel: Earth",
              "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_earth"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 214,
      "name": "Armorer",
      "description": "Here, take this shield. It is dangerous where you are going. - Janist, Master Armorer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 4,
      "speed": 6,
      "damage": 6,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 54,
      "hash": "dJ8HJ8Ge9Be9BF0BJ8IJ8Jj9Aousonhnpuqhievf",
      "artist": "Trevor Claxton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 739,
          "apCost": 2,
          "name": "Enhance Armor",
          "shortDescription": "This unit gets -1 DEF and target champion gets +1 DEF. This ability may not be used if this unit has less than 1 DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1523,
          "apCost": 0,
          "name": "Train: Defense",
          "shortDescription": "Target friendly champion within 5 spaces permanently gains +1 DEF.  This ability costs 2 nora and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2030,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +2 DEF.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plusdefense"
            },
            {
              "default": false,
              "id": 2136,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +3 DEF.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "plusdefense"
            }
          ]
        }
      ]
    },
    {
      "id": 1176,
      "name": "Arrowsinger",
      "description": "\"There is no way she can hit us from that far away\" ~ Final words of Neb, G'hern Taskmaster",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Archer",
        "Bard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 77,
      "hash": "ej9Cj9Bg3Ae9Ae9AG2Aj9Dj9Eeerzxfigiirzvqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2780,
          "apCost": 2,
          "name": "Aim",
          "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "hunted"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        },
        {
          "id": 2565,
          "apCost": 3,
          "name": "Summon: Archery Bale",
          "shortDescription": "Summon an Archery Bale relic with <ability value=2495>Archery Bale</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "deploy"
        },
        {
          "id": 1316,
          "apCost": 0,
          "name": "Vulnerable",
          "shortDescription": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1803,
              "apCost": 0,
              "name": "Volley Leader",
              "shortDescription": "Other friendly Archers within 5 spaces gain a rank of <ability value=1088>Rain of Arrows</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 1933,
              "apCost": 0,
              "name": "Coordination",
              "shortDescription": "All friendly champions within 2 spaces of this unit gain <ability value=1214>Encouraged</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        }
      ]
    },
    {
      "id": 1644,
      "name": "Arroyo Echo",
      "description": "The Separation broke the Peaks, magically as well as physically. Residual spirit energy can easily become malformed into beings of broken resonance.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8Hf1AF0BG2AF0AJ8Jj9Aeemsoqzzkluzgpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1208,
          "apCost": 0,
          "name": "Debilitate",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "debuff"
        },
        {
          "id": 1619,
          "apCost": 0,
          "name": "Desecrated Zone",
          "shortDescription": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "terrain_dmz"
        },
        {
          "id": 3137,
          "apCost": 2,
          "name": "Dread Field",
          "shortDescription": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "dread_field"
        },
        {
          "id": 1737,
          "apCost": 0,
          "name": "Ethereal",
          "shortDescription": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 3247,
              "apCost": 3,
              "name": "Rift Nova",
              "shortDescription": "Area Effect 2, Range 5: Enemy champions occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> or Dread Field in the area lose 6 HP and lose 1 SPD for 2 turns for each friendly spirit within the AoE (to a maximum of -3).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "stormreader"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3235,
              "apCost": 2,
              "name": "Beckoning Guile",
              "shortDescription": "Target a space within 5 spaces. Enemy champions without <ability value=4>Iron Will</ability> within 5 spaces of the target move one space towards it.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "pull_guile"
            },
            {
              "default": false,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            },
            {
              "default": true,
              "id": 2100,
              "apCost": 3,
              "name": "Gale",
              "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "gale"
            }
          ]
        }
      ]
    },
    {
      "id": 1827,
      "name": "Arroyo Eye",
      "description": "From the portal emerged a great Eye, which gazed upon the surrounding land, until it spied the dwarf. Then the Eye grew hungry.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 50,
      "hash": "eJ8IJ8HE8DG2BG2AF0Aj9Ej9Feeinuftfinsonpf",
      "artist": "Jordy Knoop",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 2343,
          "apCost": 3,
          "name": "Paralyze",
          "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "sentry"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3249,
              "apCost": 0,
              "name": "Rift Bound",
              "shortDescription": "At the end of its turns, if this unit does not occupy Dead Magic Zone, it loses 2 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "rift_bound"
            },
            {
              "default": false,
              "id": 2001,
              "apCost": 0,
              "name": "Defenseless",
              "shortDescription": "This unit takes 30% more damage from melee attacks. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -5,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1760,
              "apCost": 0,
              "name": "Impatient",
              "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "impatient"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": true,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            }
          ]
        }
      ]
    },
    {
      "id": 1768,
      "name": "Arroyo Flamewisp",
      "description": "Beings of the Utterdark, the Arroyo are not actually once-living creatures; they sprang from the chaos and the darkness.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 55,
      "hash": "ej9Cj9BG2Af1BG2AG2Aj9Bj9Ceerqlgnpjexxqsf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 1404,
          "apCost": 0,
          "name": "Fire Feed",
          "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "eater_fire"
        },
        {
          "id": 380,
          "apCost": 3,
          "name": "Flame Nova",
          "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novafire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 89,
              "apCost": 0,
              "name": "Vulnerability: Frost",
              "shortDescription": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "vuln_frost"
            },
            {
              "default": true,
              "id": 3249,
              "apCost": 0,
              "name": "Rift Bound",
              "shortDescription": "At the end of its turns, if this unit does not occupy Dead Magic Zone, it loses 2 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "rift_bound"
            },
            {
              "default": false,
              "id": 1760,
              "apCost": 0,
              "name": "Impatient",
              "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "impatient"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        }
      ]
    },
    {
      "id": 1764,
      "name": "Arroyo Riftlord",
      "description": "The mere presence of the Arroyo disturbs the veil. A Riftlord can make these punctures more intentional.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 82,
      "hash": "ej9Bj9Ag3Af1BG2Af1Bj9Dj9Eeitjrsxvoqfiwtf",
      "artist": "Rogier van de Beek",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3250,
          "apCost": 3,
          "name": "Arroyo Rift",
          "shortDescription": "Area Effect 3, Range 5: Affected spaces become <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> for 5 turns and enemy champions are pulled towards the center by 1 spaces, lose 2AP and become Soultapped for 4 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 20,
          "iconName": "arroyo_rift"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 2315,
          "apCost": 0,
          "name": "Oblivion Shield",
          "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "aegis"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": true,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            }
          ]
        }
      ]
    },
    {
      "id": 1794,
      "name": "Arroyo Riftwalker",
      "description": "For the Arroyo, all alliances are utilitarian and painfully temporary. Not ties of kinship, nor even a bargain with Serkan will guard against their calculating caprice.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 81,
      "hash": "eJ8IJ8Hf1BG2AG2AF0Aj9Aj9Bvshgyievxxquqqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3274,
          "apCost": 3,
          "name": "Riftwalker",
          "shortDescription": "This champion is relocated to target <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> within 5 spaces. Enemy champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns. For each affected unit, this champion gains +1 AP and +1 DMG for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "riftwalker"
        },
        {
          "id": 2281,
          "apCost": 0,
          "name": "Soul Channeling",
          "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": true,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            },
            {
              "default": false,
              "id": 2991,
              "apCost": 4,
              "name": "Soulwrack",
              "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "soulwrack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            }
          ]
        }
      ]
    },
    {
      "id": 1761,
      "name": "Arroyo Shadestriker",
      "description": "The Arroyo have but one goal: the eradication of the Djinn, the culmination of centuries of war.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Knight"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 70,
      "hash": "ej9Bj9AE8Df1BG2Af1Bj9Ej9Fmsowillyouowxqf",
      "artist": "Grant Griffin",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1368,
          "apCost": 0,
          "name": "Deflect: Electric",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Electric damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect_electric"
        },
        {
          "id": 3213,
          "apCost": 1,
          "name": "Electric Attack",
          "shortDescription": "This unit makes an Electric attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "electric"
        },
        {
          "id": 3006,
          "apCost": 0,
          "name": "Nora Induction",
          "shortDescription": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ichor_utility"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 1619,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "terrain_dmz"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1331,
              "apCost": 0,
              "name": "Electricity Eater",
              "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_electric"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            },
            {
              "default": true,
              "id": 2854,
              "apCost": 2,
              "name": "Relocate: DMZ",
              "shortDescription": "Target friendly champion, within 5 spaces, who is standing on <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is relocated next to this unit.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1763,
      "name": "Arroyo Smokeform",
      "description": "It may be a blessing that the Arroyo cannot stray far from their apertures, but that's little solace to those stuck within their territory.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 75,
      "hash": "ej9Bj9Ae9Bf1BG2Af1BJ8GJ8Hqsjnpushyztukpf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3249,
          "apCost": 0,
          "name": "Rift Bound",
          "shortDescription": "At the end of its turns, if this unit does not occupy Dead Magic Zone, it loses 2 MAX HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "rift_bound"
        },
        {
          "id": 2701,
          "apCost": 0,
          "name": "Shadestrike",
          "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrain_dmz"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            },
            {
              "default": true,
              "id": 3247,
              "apCost": 3,
              "name": "Rift Nova",
              "shortDescription": "Area Effect 2, Range 5: Enemy champions occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> or Dread Field in the area lose 6 HP and lose 1 SPD for 2 turns for each friendly spirit within the AoE (to a maximum of -3).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "stormreader"
            },
            {
              "default": false,
              "id": 2480,
              "apCost": 3,
              "name": "Desecrate Earth",
              "shortDescription": "Area Effect 2, Range 5: Affected spaces becomes Desecrated Ground until the end of your next turn. (Desecrated Ground - At beginning of your turns and upon casting, champions without Race: Undead or Race: Spirit in this area lose 6 HP).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "desecrate_earth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            }
          ]
        }
      ]
    },
    {
      "id": 1767,
      "name": "Arroyo Storm Orb",
      "description": "Unable to completely manifest into the material world of Poxanthuru, the full extent of the Arroyo's power remains uncertain.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 56,
      "hash": "ej9Cj9Bf1Bf1BG2AG2Aj9Aj9Bufipquxowipqlrf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 594,
          "apCost": 0,
          "name": "Energy Thief",
          "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 1737,
          "apCost": 0,
          "name": "Ethereal",
          "shortDescription": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "ethereal"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2248,
              "apCost": 0,
              "name": "Spark Curse",
              "shortDescription": "Units that become <condition value=shocked popup=false>Shocked</condition> also becomes <condition value=cursed>Cursed</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spark_curse"
            },
            {
              "default": true,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2001,
              "apCost": 0,
              "name": "Defenseless",
              "shortDescription": "This unit takes 30% more damage from melee attacks. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -5,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 3249,
              "apCost": 0,
              "name": "Rift Bound",
              "shortDescription": "At the end of its turns, if this unit does not occupy Dead Magic Zone, it loses 2 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "rift_bound"
            },
            {
              "default": false,
              "id": 87,
              "apCost": 0,
              "name": "Vulnerability: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "vuln_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 121,
      "name": "Ash Demon",
      "description": "An infinite army, since everything shall become ash. - Maxxarek of Sheoul",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 56,
      "hash": "dJ8HJ8Ge9Be9Ag3Aj9Dj9Ej9Fzrwfgrsqfpnnwzg",
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 606,
          "apCost": 2,
          "name": "Fester",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=inhibited>Inhibited</condition> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "inhibit"
        },
        {
          "id": 380,
          "apCost": 3,
          "name": "Flame Nova",
          "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novafire"
        },
        {
          "id": 480,
          "apCost": 0,
          "name": "Lavawalker",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 767,
              "apCost": 1,
              "name": "Fire Attack",
              "shortDescription": "This unit makes a Fire attack at range 2-4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 229,
              "apCost": 0,
              "name": "Damage Shield: Fire",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_fire"
            },
            {
              "default": false,
              "id": 132,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafire"
            }
          ]
        }
      ]
    },
    {
      "id": 1408,
      "name": "Ash Maiden",
      "description": "She was once an elf who loved fire, but once it consumed her soul, she became the element itself.  Now, there are only traces of her former self that can be seen through the flame. \r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elemental",
        "Elf"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9Ee9AF0Be9AE8Dj9Fj9Gevfvhkuxkevmhpf",
      "artist": "Conceptopolis",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1376,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "resistance_ranged"
        },
        {
          "id": 6,
          "apCost": 0,
          "name": "Mobility",
          "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mobility"
        },
        {
          "id": 3061,
          "apCost": 3,
          "name": "Solar Flare",
          "shortDescription": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "fireaoe"
        },
        {
          "id": 3417,
          "apCost": 0,
          "name": "Spellsurge: Fiery Ambush",
          "shortDescription": "When this champion is deployed, Fiery Ambush spell runes are revealed in your runedock. Fiery Ambush spells cost 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Fiery Ambush spell is played.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 2853,
          "apCost": 0,
          "name": "Trail: Fire Wall",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "trail_firewall"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            }
          ]
        }
      ]
    },
    {
      "id": 861,
      "name": "Ash the Bandit Prince",
      "description": "\"What we have here, gentlemen and ladies, is someone who refuses to donate to a band of unfortunate, starving elves. The cruelty of such a villain must be punished, should it not? Strip him clean, take his loincloth too.\" - Ash, Prince of Bandits",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Archer",
        "Rogue"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 107,
      "hash": "dj9Dj9CG2BG2BG2Bj9Cj9Dj9Eeerumykjnegknlg",
      "artist": "Slawomir Maniak",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2212,
          "apCost": 0,
          "name": "Banditry",
          "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "banditry"
        },
        {
          "id": 2201,
          "apCost": 0,
          "name": "Marauder",
          "shortDescription": "When this champion is deployed, a Level 1 Deep Elf Renegade and a Level 1 Elven Scoundrel are summoned adjacent to it.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 30,
          "iconName": "marauder"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2260,
          "apCost": 0,
          "name": "Pariah",
          "shortDescription": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "possess"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2190,
              "apCost": 0,
              "name": "Charged Attack",
              "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "charged_attack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1009,
              "apCost": 0,
              "name": "Tariff",
              "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1089,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "arrowaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 894,
      "name": "Ash the Bandit Prince",
      "description": "\"What we have here, gentlemen and ladies, is someone who refuses to donate to a band of unfortunate, starving elves. The cruelty of such a villain must be punished, should it not? Strip him clean, take his loincloth too.\" - Ash, Prince of Bandits",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer",
        "Rogue"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 107,
      "hash": "dJ8HJ8Ge9Bg3AE8Dj9Ej9Fj9Geemsszowojtoyzg",
      "artist": "Slawomir Maniak",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2212,
          "apCost": 0,
          "name": "Banditry",
          "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "banditry"
        },
        {
          "id": 2201,
          "apCost": 0,
          "name": "Marauder",
          "shortDescription": "When this champion is deployed, a Level 1 Deep Elf Renegade and a Level 1 Elven Scoundrel are summoned adjacent to it.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 30,
          "iconName": "marauder"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2260,
          "apCost": 0,
          "name": "Pariah",
          "shortDescription": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "possess"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2190,
              "apCost": 0,
              "name": "Charged Attack",
              "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "charged_attack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1009,
              "apCost": 0,
              "name": "Tariff",
              "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1089,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "arrowaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 872,
      "name": "Aspect of Chaos",
      "description": "The storm tore through the settlement, sending Moga and G'hern in every direction. As it moved on, it abruptly stopped and turned. The aspect marveled at its wake.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 0,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 81,
      "hash": "dj9Ej9Dg3AG2Bg3Aj9Dj9Ej9Fpluqoyojwowoqoh",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 2160,
          "apCost": 0,
          "name": "Charged",
          "shortDescription": "When this unit comes into play, it gains 3 charges.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "heal_charged"
        },
        {
          "id": 2219,
          "apCost": 0,
          "name": "Eternal Storm",
          "shortDescription": "At the beginning of your opponent's turns, for every charge on this unit, it deals 1 damage (type is one of the following types: fire, frost, magic, sonic, electricity, disease, poison, and psychic) to each opposing champion within 6 spaces.  This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 30,
          "iconName": "eternal_storm"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1926,
          "apCost": 0,
          "name": "Inscrutable Form",
          "shortDescription": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "inhibit"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 805,
              "apCost": 1,
              "name": "Chain Lightning",
              "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "electric"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 2361,
              "apCost": 0,
              "name": "Repulsion",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly away from this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "repulsion"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1121,
              "apCost": 0,
              "name": "Wind Aura",
              "shortDescription": "Champions within 5 spaces of this champion are <condition value=grounded>Grounded</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "gale"
            },
            {
              "default": false,
              "id": 2655,
              "apCost": 4,
              "name": "Overload",
              "shortDescription": "Relics within 10 spaces take 10 Electricity damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 3360,
              "apCost": 0,
              "name": "Spellsurge: Elemental Vortex",
              "shortDescription": "When this champion is deployed, Elemental Vortex spells are revealed from your runedock. Elemental Vortex spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Elemental Vortex spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 882,
      "name": "Aspect of Death",
      "description": "The form wandered through Elsarin's streets, watching Serkan's dregs come and go, each completing its appointed task. As the aspect moved, a chill gripped the air and made it still. It had found its domain.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Angel",
        "Spirit",
        "Undead"
      ],
      "noraCost": 83,
      "hash": "dj9Fj9EE8Dg3Ag3Aj9Dj9Ej9Fukuftxkjphvvvkg",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2173,
          "apCost": 0,
          "name": "Death Charged",
          "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "charged_death"
        },
        {
          "id": 2241,
          "apCost": 0,
          "name": "Death Knell",
          "shortDescription": "Spend 8 charges. Target opposing non-Avatar, non-Elite, non-Boss champion within 6 spaces gains <ability value=875>Short-Lived 1</ability> and this champion loses all remaining charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "death_toll"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1791,
          "apCost": 0,
          "name": "Soulstrike",
          "shortDescription": "Whenever this champion successfully hits an opponent with a basic attack, target champion loses life equal to 25% of its max HP. This ability ignores immunities.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "lossoflife"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3137,
              "apCost": 2,
              "name": "Dread Field",
              "shortDescription": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "dread_field"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 301,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2518,
              "apCost": 3,
              "name": "Cast: Despoil",
              "shortDescription": "Area Effect 3, Range 4: A <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is created in the target area for 8 turns. For the next 6 turns, this area grows one space at the beginning of each of your turns. All nora globes that drop within the affected area are automatically collected by the casting player.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "desecrate_earth"
            }
          ]
        }
      ]
    },
    {
      "id": 845,
      "name": "Aspect of Divinity",
      "description": "The figure hovered in the sky, just above the walls of the Stronghold. Some believed it was the goddess Al'Mara, come to visit her loyal subjects.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 12,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God",
        "Priest"
      ],
      "races": [
        "Angel",
        "Spirit"
      ],
      "noraCost": 82,
      "hash": "dj9Cj9BG2AG2Be9BJ8GJ8HJ8Igiiiykruvhtowzg",
      "artist": "Simon Dominic",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2207,
          "apCost": 0,
          "name": "Ascendance",
          "shortDescription": "Spend 20 Charges. This champion becomes <condition value=ascended>Ascended</condition> and gains <ability value=1045>Elite</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "ascendance"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2300,
          "apCost": 0,
          "name": "Charged Blast",
          "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2169,
          "apCost": 0,
          "name": "Heal Charged",
          "shortDescription": "When any unit is healed, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "heal_charged"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": true,
              "id": 1205,
              "apCost": 2,
              "name": "Corporeal Form",
              "shortDescription": "This champion loses <condition value=incorporeal>Incorporeal</condition>.  If it doesn't have Incorporeal, it gains Incorporeal instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 2271,
              "apCost": 0,
              "name": "Sentinel",
              "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2485,
              "apCost": 2,
              "name": "Cast: Blessing of Al'Mara",
              "shortDescription": "Target champion gains Flight; if target champion has Class: Paladin or Priest, it also gains <ability value=1395>Hunter: Walker</ability> and Race: Angel.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "flight"
            },
            {
              "default": false,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 1160,
              "apCost": 0,
              "name": "Boost",
              "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            }
          ]
        }
      ]
    },
    {
      "id": 852,
      "name": "Aspect of Growth",
      "description": "As it stepped through the marsh, the surrounding plant life was invigorated. The waters began to glow a bright green, pulsing with each ponderous step. The aspect paused and smiled down at an elf wading towards it.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 2,
      "hitPoints": 20,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Plant",
        "Spirit"
      ],
      "noraCost": 76,
      "hash": "dj9Cj9BG2AG2Bg3Aj9Dj9Ej9Fsszzigpjtzojplg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2234,
          "apCost": 2,
          "name": "Grow",
          "shortDescription": "This champion gains HP and permanently gains MAX HP equal to its base HP. When this ability has been used 2 times, it permanently gains <ability value=1395>Hunter: Walker</ability>.  When this ability has been used 3 times, it gains <ability value=1244>Cleave</ability>.  When this ability has been used 4 times, it permanently gains <ability value=1272>Titan</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 5,
          "noraCost": 20,
          "iconName": "grow"
        },
        {
          "id": 2188,
          "apCost": 0,
          "name": "Recharge",
          "shortDescription": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "recharge"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 2797,
              "apCost": 0,
              "name": "Logistics: Range",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +2 MAX RNG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3291,
              "apCost": 3,
              "name": "Elemental Storm: Poison",
              "shortDescription": "Enemy champions within 3 spaces of at least one friendly Plant, Shaman or champion with Attack: Poison, including this one, take 5 Poison damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "novapoison"
            },
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 1085,
              "apCost": 0,
              "name": "Boost: Plant",
              "shortDescription": "Friendly champions with Race: Plant gain +5 MAX HP. This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "boost"
            }
          ]
        }
      ]
    },
    {
      "id": 833,
      "name": "Aspect of Infinity",
      "description": "The ice made her into many reflections. They moved about in a dance of infinitely many dancers. The aspect was motionless.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Angel",
        "Spirit"
      ],
      "noraCost": 77,
      "hash": "dj9Bj9Af1BG2BE8Dj9Ej9Fj9Gevxxvhyxmlggnhg",
      "artist": "Michele Chang",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 2186,
          "apCost": 0,
          "name": "Duplicity",
          "shortDescription": "Spend 8 Charges. Deploy a copy of this champion on target adjacent space and 1 illusion copy in an adjacent space. This champion loses all remaining charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "duplicate"
        },
        {
          "id": 2563,
          "apCost": 3,
          "name": "Flourish",
          "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 1895,
          "apCost": 0,
          "name": "Illusion of Lies",
          "shortDescription": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "planar"
        },
        {
          "id": 2209,
          "apCost": 0,
          "name": "Mirrored",
          "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "mirrored"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1037,
              "apCost": 5,
              "name": "Deception",
              "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "planar"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1568,
              "apCost": 0,
              "name": "Balance",
              "shortDescription": "When this unit comes into play, enemy champions take 4 Physical damage and friendly champions are healed for 3 HP.",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "soul_bond"
            }
          ]
        }
      ]
    },
    {
      "id": 855,
      "name": "Aspect of Life",
      "description": "She moved through the Seared Forest. With each step, flowers sprouted from the ground, leaving a beautiful trail behind her. The trees, once charred, began to pulse with new life. As the aspect ventured forward, she left behind a growing forest",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God",
        "Priest"
      ],
      "races": [
        "Angel",
        "Spirit"
      ],
      "noraCost": 79,
      "hash": "dj9Dj9CG2BG2Be9BJ8GJ8HJ8Iexxtmpnhnnphieg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2236,
          "apCost": 0,
          "name": "Boundless Vitality",
          "shortDescription": "When this champion has 20 or more charges, whenever it activates a base ability, the cooldown on that ability is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        },
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 1561,
          "apCost": 0,
          "name": "Growth",
          "shortDescription": "Friendly champions within 3 spaces are healed for 3 HP at the beginning of your turns.",
          "activationType": 0,
          "level": 4,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "plantregen"
        },
        {
          "id": 2169,
          "apCost": 0,
          "name": "Heal Charged",
          "shortDescription": "When any unit is healed, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "heal_charged"
        },
        {
          "id": 620,
          "apCost": 4,
          "name": "Lay Hands",
          "shortDescription": "Target champion within 2 spaces (including this champion) heals HP equal to its max HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "heal"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 608,
              "apCost": 0,
              "name": "Majestic",
              "shortDescription": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "majestic"
            },
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            },
            {
              "default": false,
              "id": 1160,
              "apCost": 0,
              "name": "Boost",
              "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": true,
              "id": 789,
              "apCost": 3,
              "name": "Healing Breath",
              "shortDescription": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 18 HP divided by the number of targets (rounded down to a max of 8 HP per target).",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 862,
      "name": "Aspect of Oblivion",
      "description": "The Aspect loomed toward the demons, staring down at each one from the nothingness inside it's cowl. It pointed to one. The demon was now enveloped in darkness and then ceased to be. This was the aspect of things to come, a glimpse of oblivion.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Spirit"
      ],
      "noraCost": 85,
      "hash": "dj9Dj9CG2BG2Bg3Aj9Dj9Ej9Fsszinshvvvfkemh",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2249,
          "apCost": 0,
          "name": "Journey to Oblivion",
          "shortDescription": "Spend 20 Charges. Target opposing non-Avatar, non-Boss, non-Elite champion within 5 spaces is removed from play, has its CD set to 6, and has 80% of its nora cost refunded at the beginning of its owner's next turn. That player has 4 of their revealed runes concealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "journey_to_oblivion"
        },
        {
          "id": 3379,
          "apCost": 0,
          "name": "Magic Ward",
          "shortDescription": "This champion cannot be the target of friendly spells.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "spell_resistance"
        },
        {
          "id": 2315,
          "apCost": 0,
          "name": "Oblivion Shield",
          "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "aegis"
        },
        {
          "id": 2180,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 3 charges at the start of its turn.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "supercharged"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 884,
      "name": "Aspect of Violence",
      "description": "The aspect cleaved through the trees around it. The defending elves began to flee, only to be torn apart by another swing. The aspect surveyed the destruction, then pursued the fleeing elves. It wanted more.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Spirit"
      ],
      "noraCost": 85,
      "hash": "dj9Gj9Fe9Ag3Ae9Aj9Fj9Gj9Hqzojlrfvkjnuhig",
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2203,
          "apCost": 0,
          "name": "Furious Attacks",
          "shortDescription": "Spend 12 charges. For 1 turn, basic attacks made by this champion costs a maximum of 1 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "furious_attacks"
        },
        {
          "id": 3379,
          "apCost": 0,
          "name": "Magic Ward",
          "shortDescription": "This champion cannot be the target of friendly spells.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "spell_resistance"
        },
        {
          "id": 3056,
          "apCost": 0,
          "name": "Overkill: Healing",
          "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overkill"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        },
        {
          "id": 2262,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": true,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 2737,
              "apCost": 0,
              "name": "Physical Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Physical Aura 3.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 760,
      "name": "Attendant Squire",
      "description": "The squires of the Ironfist Paladins are considered to be the backbone of their masters. They attend to their armor and weapons, even fight by their side when the need arises.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 64,
      "hash": "dj9Ej9Dg3AG2Af1AJ8Jj9Aj9Brszkevqsonetzig",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1983,
          "apCost": 2,
          "name": "Attendant",
          "shortDescription": "Target Paladin within 3 spaces has +3 DMG and <ability value=396>Charge 3</ability> for 1 turn.  This ability costs an additional 5 AP if this champion has attacked this turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "attendant"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 1982,
          "apCost": 0,
          "name": "Royal Blood",
          "shortDescription": "While Talgar is in play, this champion gains +2 DMG and <ability value=15>Multiattack 1</ability>. While Euan is in play, this champion gains +2 DEF and <ability value=31>Defender</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "majestic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": false,
              "id": 323,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 2 AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            },
            {
              "default": true,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 739,
              "apCost": 2,
              "name": "Enhance Armor",
              "shortDescription": "This unit gets -1 DEF and target champion gets +1 DEF. This ability may not be used if this unit has less than 1 DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1278,
      "name": "Augur of the Deep",
      "description": "Augurs hone their kinetic powers with years of isolation on a remote island in the Sea of Separation off the coast of the Marsh Tongue. It is said that these Monks can retrieve fish from the ocean without ever touching the water.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Monk"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 75,
      "hash": "ej9Cj9BG2Be9Be9AG2Aj9Cj9Dszgvfpyxvmletqf",
      "artist": "Christian Fell",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 2679,
          "apCost": 4,
          "name": "Water Vortex",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            },
            {
              "default": false,
              "id": 2095,
              "apCost": 0,
              "name": "Combo Attack: Slam",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion is knocked back 2 spaces.\r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "comboatk_slam"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": false,
              "id": 2244,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "jolt"
            },
            {
              "default": true,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 1618,
      "name": "Aurora Inspector",
      "description": "The investigative branch of the Aurora quickly dispatched numerous Inspectors following the first of the Nefari raids. De'lim, meanwhile, protested that the appropriate response to such an incursion is force, not detective work.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer",
        "Ranger",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9EE8DF0BG2AE8Dj9Ej9Feepnjinnjtxfpqf",
      "artist": "Jourdan Tuffan",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 295,
          "apCost": 0,
          "name": "Deflect",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect"
        },
        {
          "id": 3114,
          "apCost": 0,
          "name": "Discovery",
          "shortDescription": "When an enemy champion is deployed, it becomes <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate_unit"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1396,
              "apCost": 0,
              "name": "Fading Light",
              "shortDescription": "When this champion recovers a nora globe, it becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1681,
      "name": "Aurora Investigator",
      "description": " \"This ash... these footprints... a familiar sight in recent days, but perhaps too familiar for those with careful eyes.\" -- Chief Investigator Theria",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 70,
      "hash": "ej9Dj9CE8DF0BG2AG2Bj9Ej9Feeemsohkljlegrf",
      "artist": "Jourdan Tuffan",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3167,
          "apCost": 0,
          "name": "Aurora Investigations",
          "shortDescription": "The first time an enemy champion within 8 spaces of this champion makes a basic attack while a champion with this ability is in play, a \"Clue\" is created on the space it occupies.  When a friendly Elf or Fairy (including self) moves within 2 spaces of a space containing a \"Clue,\" the \"Clue\" is consumed and that champion gains 2 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "clue"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3176,
              "apCost": 0,
              "name": "Spellsurge: Blinding Flash",
              "shortDescription": "When this champion is deployed, Blinding Flash spells are revealed from your runedock.  Blinding Flash spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Blinding Flash spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        }
      ]
    },
    {
      "id": 1512,
      "name": "Aurora Lancer",
      "description": "De'lim, in a bid to retain control of the Circle by extending Menalaus' absence, convinced the Circle to delay an official rescue effort. The Aurora Lancers, a group with close ties to Menalaus, set sail on a Salaman transport ship to find him.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 74,
      "hash": "ej9Bj9AG2AF0Be9Af1Bj9Bj9Ceeilggtmsqufpqf",
      "artist": "Conceptopolis",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2987,
          "apCost": 1,
          "name": "Aurora Lance",
          "shortDescription": "This champion makes a Magical attack at RNG 2-5.  If the attack is successful, the target becomes <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "aurora_lance"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 1567,
              "apCost": 0,
              "name": "Balance",
              "shortDescription": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 3 HP.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "soul_bond"
            },
            {
              "default": false,
              "id": 2988,
              "apCost": 2,
              "name": "Lightseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=blinded>Blinded</condition> or <condition value=illuminated>Illuminated</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 129,
              "apCost": 0,
              "name": "Magical Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novamagic"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1562,
      "name": "Aurora Sunmage",
      "description": "Aurora Sunmages specialize in combining the traditional wizardry of the elves with one of the most potent forces of nature - the sun.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Je9Ae9BG2Af1Aj9Fj9Gusxvvfeetfruoqf",
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1367,
          "apCost": 0,
          "name": "Deflect: Fire",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Fire damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect_fire"
        },
        {
          "id": 3176,
          "apCost": 0,
          "name": "Spellsurge: Blinding Flash",
          "shortDescription": "When this champion is deployed, Blinding Flash spells are revealed from your runedock.  Blinding Flash spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Blinding Flash spell is played.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 3061,
              "apCost": 3,
              "name": "Solar Flare",
              "shortDescription": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1337,
      "name": "Auroral Slag",
      "description": "The creature descended the crags, its obscuring swathe of light left glints of energy in its wake. The scouts pondered and bickered over what it might be; as dawn broke, they were astonished to discover that they had been tracking a slag.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 6,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 74,
      "hash": "eJ8IJ8HG2AF0Ae9AF0Aj9Bj9Cerhemleieeplwo",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2762,
          "apCost": 0,
          "name": "Dazzling",
          "shortDescription": "The first time this champion is engaged each turn, adjacent champions become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "fascinate"
        },
        {
          "id": 760,
          "apCost": 3,
          "name": "Magic Nova",
          "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novamagic"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 129,
              "apCost": 0,
              "name": "Magical Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novamagic"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 2,
      "name": "Avenging Angel",
      "description": "Nature's karmic enforcer.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 66,
      "hash": "bj9Fj9Ej9Dg3Aj9Dj9Ej9Fj9Geeigkgegkletjyo",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2250,
              "apCost": 3,
              "name": "Scythe Whirl",
              "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "scythe_wirlwind"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1076,
              "apCost": 3,
              "name": "Heal Self",
              "shortDescription": "This unit recovers 12 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 143,
      "name": "Avenging Angel",
      "description": "Nature's karmic enforcer.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest",
        "Warrior"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 66,
      "hash": "dj9Fj9EE8De9Be9Aj9Fj9Gj9Hiwtukllpyxtoleg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2250,
              "apCost": 3,
              "name": "Scythe Whirl",
              "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "scythe_wirlwind"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1076,
              "apCost": 3,
              "name": "Heal Self",
              "shortDescription": "This unit recovers 12 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1552,
      "name": "Ayla the Huntress",
      "description": "Ayla and Thor always get their prey, as long as Thor isn't off rummaging for truffles anyway.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer",
        "Ranger"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9EG2Af1Ae9AE8Dj9Bj9Ceilerhtqsjemnpf",
      "artist": "Michele Chang",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "The Ronin",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2267,
          "apCost": 0,
          "name": "Pet: Tempest Boar",
          "shortDescription": "When this champion is deployed, a Level 1 Tempest Boar is summoned adjacent to it.  ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "pet"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1749,
              "apCost": 1,
              "name": "Grant: Lay Trap: Boulder",
              "shortDescription": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 975,
      "name": "Azaren the Shepherd",
      "description": "Azaren is the last remaining Shepherd of the Lonx, a group of shamans who were versed in the ways of the beast. A Shepherd's duty is to protect and guide the Tundra's natives to food and shelter.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 95,
      "hash": "dj9Ej9Dg3Ag3AE8Dj9Ej9Fj9Geeeevxfkgirqzkg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 9,
          "apCost": 0,
          "name": "Battlemaster",
          "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "aurapositive"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2386,
          "apCost": 0,
          "name": "Pet: Tusk the Mastodon",
          "shortDescription": "When this champion is deployed, Tusk the Mastodon without upgrades is summoned adjacent to it.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "pet"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 101,
              "apCost": 1,
              "name": "Barrage",
              "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "arrowaoe"
            },
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2348,
              "apCost": 4,
              "name": "Beast Herder",
              "shortDescription": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "desert_hearder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1859,
      "name": "Azaren the Shepherd",
      "description": "Azaren is the last remaining Shepherd of the Lonx. Devoting their life to being accepted as one of the beasts, a Shepherd's duty is to protect and guide the Tundra's natives to food and shelter.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 95,
      "hash": "ej9Bj9Af1AG2BG2Af1BJ8Jj9Aeiyzvmerhnphgrf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 9,
          "apCost": 0,
          "name": "Battlemaster",
          "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "aurapositive"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2386,
          "apCost": 0,
          "name": "Pet: Tusk the Mastodon",
          "shortDescription": "When this champion is deployed, Tusk the Mastodon without upgrades is summoned adjacent to it.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "pet"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 101,
              "apCost": 1,
              "name": "Barrage",
              "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "arrowaoe"
            },
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2348,
              "apCost": 4,
              "name": "Beast Herder",
              "shortDescription": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "desert_hearder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 891,
      "name": "Baby Furbull",
      "description": "Baby Furbulls are the size of a snowcat with a round body covered in soft fur. The first few weeks of their life they are docile and affectionate. After a few weeks, the soft fur is replaced with coarse hair and it's temperament turns vicious.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 3,
      "damage": 0,
      "hitPoints": 7,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 52,
      "hash": "dj9Gj9Fe9Ag3AG2Bj9Cj9Dj9Eeeeitohrhgkgtjg",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2252,
          "apCost": 0,
          "name": "Furring",
          "shortDescription": "When this unit has been in play for 6 turns, it is removed from play and a Furbull is deployed in the same location. If this unit was summoned, a Furbull without upgrades is summoned instead.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "furring"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 516,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 1,
              "iconName": "leap"
            },
            {
              "default": true,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 414,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Adjacent enemy champions become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 415,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "charm"
            }
          ]
        }
      ]
    },
    {
      "id": 1334,
      "name": "Baby Slag",
      "description": "Saa-swaag? ... SWAG!!!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 59,
      "hash": "eJ8IJ8HF0BF0Ae9AF0AJ8IJ8Jemnusoyvmwilln",
      "artist": "Conceptopolis",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 416,
          "apCost": 2,
          "name": "Charm",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "charm"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": true,
              "id": 152,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 3382,
              "apCost": 0,
              "name": "Hidden: Ooze",
              "shortDescription": "At the end of your turn, if this unit occupies Ooze, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 1362,
      "name": "Baby Slag",
      "description": "Saa-swaag? ... SWAG!!!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 59,
      "hash": "ej9Bj9Ae9BF0Ae9Af1BJ8GJ8Hshykeknsqwfxon",
      "artist": "Conceptopolis",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 416,
          "apCost": 2,
          "name": "Charm",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "charm"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": true,
              "id": 152,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 3382,
              "apCost": 0,
              "name": "Hidden: Ooze",
              "shortDescription": "At the end of your turn, if this unit occupies Ooze, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 1546,
      "name": "Badgerwulf",
      "description": "I could have sworn I cut his arm off. - Tyra, K'thir Blademaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 69,
      "hash": "ej9Fj9Ee9Af1Ae9AE8Dj9Fj9Gtjierlnuonhkjpf",
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 967,
      "name": "Balefire Knight",
      "description": "Balefire Knights share a demonic bond with their mounts. Through this bond, knight and dragon share control of their bodies. The dragon can possess the knight and the knight can control his dragon's every move.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Demon",
        "Dragon",
        "Elf"
      ],
      "noraCost": 80,
      "hash": "dj9Dj9CG2Bg3AF0BJ8IJ8Jj9Airfpwfiluftfmhg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1961,
          "apCost": 0,
          "name": "Channel: Damage",
          "shortDescription": "This champion has +1 DMG for 2 turns and <ability value=655>Skirmisher</ability> for 2 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "channel_damage"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 772,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 1733,
      "name": "Banshee of the Rose",
      "description": "Red is the color of my true love's hair / Her eyes pierce and lay my soul to bare / Her songs lifts and raise my spirit high / Drawing me into her arms wide",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Witch"
      ],
      "races": [
        "Spirit",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9FG2Af1BG2Ae9Aj9Bj9Cemnjpuowqszzmsf",
      "artist": "Conceptopolis",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1807,
          "apCost": 0,
          "name": "Deafening Aura",
          "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "deafening_aura"
        },
        {
          "id": 1248,
          "apCost": 3,
          "name": "Pull",
          "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "pull"
        },
        {
          "id": 1976,
          "apCost": 3,
          "name": "Wail of Grief",
          "shortDescription": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2197,
              "apCost": 3,
              "name": "Blood Magic",
              "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1619,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "terrain_dmz"
            },
            {
              "default": true,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        }
      ]
    },
    {
      "id": 648,
      "name": "Barbarian Archer",
      "description": "The barbarians learned archery from the elves of K`thir. Adding their own personal touch, Barbarian archery proved to be just as effective.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 13,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 69,
      "hash": "dj9Gj9Fe9AG2Ae9Aj9Fj9Gj9Hjgnhgrofinwtuhg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2780,
          "apCost": 2,
          "name": "Aim",
          "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "hunted"
        },
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1027,
      "name": "Barbarian Bolt",
      "description": "Anyone who has spent a few nights on the Sarnghaver Plains during a storm can tell you: The storm doesn't care all that much if you live or die. Bolts are that storm.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 75,
      "hash": "eJ8IJ8HF0BE8De9AF0AJ8IJ8Jerlekwkevhgygn",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 141,
          "apCost": 0,
          "name": "Electricity Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novaelectric"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        },
        {
          "id": 2872,
          "apCost": 0,
          "name": "Warchief: Storm Clan",
          "shortDescription": "This unit has <ability value=3158>Reckless</ability>. At the end of its turn, this unit gains one rank of <ability value=2289>Lightning Storm</ability>. When this unit is destroyed and there are no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "storm_clan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2247,
              "apCost": 0,
              "name": "Static Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=shocked>Shocked</condition> for 2 turns\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_static"
            },
            {
              "default": false,
              "id": 1355,
              "apCost": 3,
              "name": "Spark Charge",
              "shortDescription": "Until end of turn, all Electricity damage is increased by 2. This unit loses 6 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_lightning"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        }
      ]
    },
    {
      "id": 3,
      "name": "Barbarian Commander",
      "description": "Great warriors have not only the strength to fight, but the power to lead as well. - Rugolth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 15,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "cj9Fj9Ej9Dg3Ae9Aj9Dj9Ej9Fkpuztqqumytmplj",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 1209,
          "apCost": 0,
          "name": "Defiant",
          "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_rock"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": true,
              "id": 1431,
              "apCost": 0,
              "name": "Barbaric Assault",
              "shortDescription": "This unit gains <ability value=1348>Punish</ability> and <ability value=1242>Pace</ability> when another friendly Barbarian is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2872,
              "apCost": 0,
              "name": "Warchief: Storm Clan",
              "shortDescription": "This unit has <ability value=3158>Reckless</ability>. At the end of its turn, this unit gains one rank of <ability value=2289>Lightning Storm</ability>. When this unit is destroyed and there are no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "storm_clan"
            }
          ]
        }
      ]
    },
    {
      "id": 1720,
      "name": "Barbarian Diviner",
      "description": "\"What we carry with us, the places we hold dear -- in a life of scarcity on mountains and plains, these mean more than any spoken belief.\"",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 72,
      "hash": "ej9Dj9Cg3Af1AG2AG2Bj9Dj9Eerhvkwkyxmjeitf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1897,
          "apCost": 3,
          "name": "Incite Rage",
          "shortDescription": "Target friendly Barbarian within 5 spaces gains <ability value=2253>Manic</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "enrage"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 3362,
              "apCost": 0,
              "name": "Spellsurge: Suppress",
              "shortDescription": "When this champion is deployed, Suppress spells are revealed from your runedock. Suppress spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Suppress spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 172,
      "name": "Barbarian Druid",
      "description": "Rugolth, I write for my people.  The Draksar forces are razing the foothills. You are our last chance, please send help! - Sari, Speaker of the Valley",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 72,
      "hash": "dj9Cj9BG2Ae9Ae9Aj9Fj9Gj9Hgiphkyrofgtjygg",
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 592,
          "apCost": 3,
          "name": "Cleanse",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "cleanse"
        },
        {
          "id": 2411,
          "apCost": 2,
          "name": "Dark Raven Form",
          "shortDescription": "This unit becomes a Dark Raven and gains <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, <ability value=13>Detection 3</ability>, <ability value=1399>Hex 2</ability> and Race: Beast. It's RNG becomes 1-1 and it is <mechanic value=cleansed>Cleansed</mechanic>. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 399,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 2: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "forcebarrier"
            },
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 502,
      "name": "Barbarian Elite",
      "description": "They wear our badge of honor. Each bruise is a medallion, each scar a ribbon. - Zedin, Elder Barbarian",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2Af1AF0BJ8IJ8Jj9Arsxigkroyvkrjeg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 28,
          "apCost": 0,
          "name": "Blood Frenzy",
          "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 684,
          "apCost": 1,
          "name": "Execute",
          "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "execute"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3143,
              "apCost": 0,
              "name": "Lead the Charge",
              "shortDescription": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "lead_the_charge"
            },
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1431,
              "apCost": 0,
              "name": "Barbaric Assault",
              "shortDescription": "This unit gains <ability value=1348>Punish</ability> and <ability value=1242>Pace</ability> when another friendly Barbarian is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 1933,
      "name": "Barbarian Elite",
      "description": "They wear our badge of honor. Each bruise is a medallion, each scar a ribbon. - Zedin, Elder Barbarian",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9Eg3Ae9AG2BE8Dj9Dj9Eeemwvfkjwvxmhrf",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 28,
          "apCost": 0,
          "name": "Blood Frenzy",
          "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 684,
          "apCost": 1,
          "name": "Execute",
          "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "execute"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3143,
              "apCost": 0,
              "name": "Lead the Charge",
              "shortDescription": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "lead_the_charge"
            },
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1431,
              "apCost": 0,
              "name": "Barbaric Assault",
              "shortDescription": "This unit gains <ability value=1348>Punish</ability> and <ability value=1242>Pace</ability> when another friendly Barbarian is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 1165,
      "name": "Barbarian Exemplar",
      "description": "\"They may be uncivilized, but they are more valiant than most of the Inquisition's warriors.\" ~ Inquisitor Isran",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 82,
      "hash": "ej9Bj9AG2Be9Ae9Af1Bj9Cj9Dfkrzxkgyvhrzmpf",
      "artist": "Anthony Lopes",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 101,
          "apCost": 1,
          "name": "Barrage",
          "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "arrowaoe"
        },
        {
          "id": 2557,
          "apCost": 0,
          "name": "Martyrdom",
          "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 8 HP. If this unit shares a race with the destroyed unit, also gain +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "intensify"
        },
        {
          "id": 3294,
          "apCost": 0,
          "name": "Warlord",
          "shortDescription": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "warlord"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1445,
              "apCost": 0,
              "name": "Counter Attack: Ranged",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 2875,
              "apCost": 0,
              "name": "Warchief: Blood Clan",
              "shortDescription": "This unit is <ability value=3>Fearless</ability>. At the end of your turn, this unit gains 1 rank of <ability value=163>Rend</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_clan"
            }
          ]
        }
      ]
    },
    {
      "id": 560,
      "name": "Barbarian Guardian",
      "description": "As humanity waned, the guardians were the last aegis against annihilation. Rugolth recognized their bravery.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 10,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 75,
      "hash": "dJ8IJ8HF0Af1BF0BJ8IJ8Jj9Arlphilwknjluzxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2857,
          "apCost": 0,
          "name": "Courage",
          "shortDescription": "This unit has +2 DMG and +1 DEF for every 8 HP it is missing. This stacks up to 3 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "aurapositive"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        },
        {
          "id": 1264,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 841,
      "name": "Barbarian Huntress",
      "description": "The Huntresses of the Sarnghaver are known for two things: they always get their prey and they never stop hunting until they do.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer",
        "Ranger"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "dj9Bj9Af1BG2BG2Bj9Cj9Dj9Eeevfekjllymuojg",
      "artist": "Michele Chang",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2267,
          "apCost": 0,
          "name": "Pet: Tempest Boar",
          "shortDescription": "When this champion is deployed, a Level 1 Tempest Boar is summoned adjacent to it.  ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "pet"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1749,
              "apCost": 1,
              "name": "Grant: Lay Trap: Boulder",
              "shortDescription": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1731,
      "name": "Barbarian Skybreaker",
      "description": "Some look to the sky as a plane of freedom that they can never reach.  Others see it as a door to be opened and its power harnessed.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 75,
      "hash": "ej9Gj9Ff1Af1BG2Ae9AJ8Jj9Aeruxolrzrqfpyrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 141,
          "apCost": 0,
          "name": "Electricity Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novaelectric"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        },
        {
          "id": 2872,
          "apCost": 0,
          "name": "Warchief: Storm Clan",
          "shortDescription": "This unit has <ability value=3158>Reckless</ability>. At the end of its turn, this unit gains one rank of <ability value=2289>Lightning Storm</ability>. When this unit is destroyed and there are no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "storm_clan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2247,
              "apCost": 0,
              "name": "Static Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=shocked>Shocked</condition> for 2 turns\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_static"
            },
            {
              "default": false,
              "id": 1355,
              "apCost": 3,
              "name": "Spark Charge",
              "shortDescription": "Until end of turn, all Electricity damage is increased by 2. This unit loses 6 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_lightning"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        }
      ]
    },
    {
      "id": 965,
      "name": "Basilisk Templar",
      "description": "The Templars of Valdac worship the tenets of Sezinok and the Aspect of Violence. They ride atop basilisk mounts whose gaze turns the living into stone cold statues. Victims of the gaze are still alive and aware, but unable to move. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Beast",
        "Draksar"
      ],
      "noraCost": 83,
      "hash": "dj9Dj9CG2Bg3Ae9BJ8GJ8HJ8Ikpuhykpnwqwxmeg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2334,
          "apCost": 2,
          "name": "Petrifying Gaze",
          "shortDescription": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "petrifying_gaze"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 3203,
          "apCost": 0,
          "name": "Slothful",
          "shortDescription": "After using an activated ability (including basic attacks), this champion becomes <ability value=757>Immobile</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "slothful"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            }
          ]
        }
      ]
    },
    {
      "id": 790,
      "name": "Bastion Remnant",
      "description": "The Bastions are best known for their fighting style: a complex martial arts centered around two obsidian bucklers, tied to the forearms. They are known to strike with force, blocking blows as quickly as they attack.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 79,
      "hash": "dj9Gj9Fe9AG2BG2Aj9Bj9Cj9Dmykjrjnjwqfrzig",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2075,
          "apCost": 0,
          "name": "Pride of Ailur",
          "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "warriorspride"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        },
        {
          "id": 263,
          "apCost": 0,
          "name": "Warcry",
          "shortDescription": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 989,
      "name": "Bastion the Avenger",
      "description": "\"Tell your king the Sarnghaver is no longer his concern. I am their guardian now.\" - Bastion the Avenger",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Barbarian"
      ],
      "noraCost": 93,
      "hash": "ej9Fj9EF0BE8De9AE8DJ8IJ8Jolneinyojyxmnn",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1233,
          "apCost": 0,
          "name": "Hostile",
          "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 3352,
              "apCost": 0,
              "name": "Voice of the Clans",
              "shortDescription": "When this unit enters play, it gains a copy of <ability value=2875>Warchief: Blood Clan</ability>, <ability value=2873>Warchief: Stone Clan</ability>, <ability value=2872>Warchief: Storm Clan</ability> and <ability value=3403>Warchief: Beast Clan</ability> if any other friendly unit has that ability. When a friendly champion enters play that has one of those abilities, this unit gains a copy of that ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "savage"
            },
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1852,
      "name": "Bastion the Avenger",
      "description": "\"Tell your king the Sarnghaver is no longer his concern. I am their guardian now.\" - Bastion the Avenger",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Angel",
        "Barbarian"
      ],
      "noraCost": 93,
      "hash": "ej9AJ8JG2BG2BG2Af1Aj9Cj9Dzrhkleiwqoytqsf",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1233,
          "apCost": 0,
          "name": "Hostile",
          "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 3352,
              "apCost": 0,
              "name": "Voice of the Clans",
              "shortDescription": "When this unit enters play, it gains a copy of <ability value=2875>Warchief: Blood Clan</ability>, <ability value=2873>Warchief: Stone Clan</ability>, <ability value=2872>Warchief: Storm Clan</ability> and <ability value=3403>Warchief: Beast Clan</ability> if any other friendly unit has that ability. When a friendly champion enters play that has one of those abilities, this unit gains a copy of that ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "savage"
            },
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 158,
      "name": "Bat Swarm",
      "description": "The stone I threw must have scared 'em... 'cause soon the cave erupted in a swarm of giant bats! - Boghopper Scout upon returning from his rounds",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 34,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Voil"
      ],
      "noraCost": 71,
      "hash": "dj9AJ8Jf1Ae9AG2Aj9Bj9Cj9Degkexkwiggykgeg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 3311,
          "apCost": 0,
          "name": "Swarm: Bat Swarm",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Bat Swarm with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": true,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            }
          ]
        }
      ]
    },
    {
      "id": 332,
      "name": "Battle Matron",
      "description": "Hide?! I'm mother to 147 elite guard, including 3 generals! Who do you think taught them how to pick a proper fight? Now tell your ninny troops to stand in line, I'll be out to give 'em my orders shortly - Dora Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 68,
      "hash": "dj9AJ8Jf1AF0Af1AJ8Jj9Aj9Bpjnuohekjwkgrzg",
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1717,
          "apCost": 3,
          "name": "Command: Charge",
          "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "command_charge"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 1312,
          "apCost": 3,
          "name": "Sweep",
          "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1517,
              "apCost": 0,
              "name": "Train: Damage",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains +2 DMG. This ability costs 3 nora and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "cost"
            },
            {
              "default": true,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1953,
              "apCost": 0,
              "name": "Rouse",
              "shortDescription": "Other real friendly champions with less than 9 base DMG get +2 DMG while this unit is in play. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": true,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        }
      ]
    },
    {
      "id": 5,
      "name": "Battle Rager",
      "description": "Sometimes those that lose their heads are the ones that keep them. - Feofil, Assistant to Rugolth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 76,
      "hash": "cj9AJ8JJ8IF0Be9BJ8IJ8Jj9Aeiyrfkuzieerqsh",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 25,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "berserker"
        },
        {
          "id": 164,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_rend"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": true,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2837,
              "apCost": 0,
              "name": "Psychotic Break",
              "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "psychotic_break"
            },
            {
              "default": true,
              "id": 3364,
              "apCost": 0,
              "name": "Equip: Firebeard Brew",
              "shortDescription": "Unit is equipped with a Firebeard Brew (Equipped Champion is intoxicated. If the equipped champion is a dwarf it heals 3 hp per turn and gains burn rank 1. If not, it takes 3 fire damage per turn and is inhibited.)",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 1892,
              "apCost": 0,
              "name": "Quest: Damage",
              "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 6,
      "name": "Bile Zombie",
      "description": "Even the filth is disgusted.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 0,
      "hitPoints": 35,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 44,
      "hash": "cj9Cj9Bj9Af1BG2Bj9Aj9Bj9Ceerhethggkgymhi",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1111,
              "apCost": 1,
              "name": "Shrine Exertion",
              "shortDescription": "Your Shrine or Avatar loses 10 HP, and this champion recovers 3 AP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "shrinebad"
            },
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 536,
              "apCost": 0,
              "name": "Bile Explosion",
              "shortDescription": "When this unit is destroyed, units within 2 spaces take 15 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 15,
              "iconName": "deathnovaacid"
            }
          ]
        }
      ]
    },
    {
      "id": 1637,
      "name": "Blackblade Baron",
      "description": "\"...We kept cutting the leader down, but then another of 'em would pick that blade right back up, like it didn't even matter who was holdin' it.\" ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 82,
      "hash": "eJ8HJ8Gf1AF0BG2Ae9BJ8Jj9Aeeevhepyvsqfxo",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 3135,
          "apCost": 0,
          "name": "Gravebind",
          "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "swarm_skeleton"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 317,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 925,
              "apCost": 0,
              "name": "Surge: Skeleton",
              "shortDescription": "This unit has +1 DMG for each friendly Skeleton.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_skeleton"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 1034,
      "name": "Blackscale Centurion",
      "description": "\"They are merciless, cruel, and do not question orders. What more could you ask of a soldier?\" - Vex the Godmother",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 87,
      "hash": "eJ8JJ8Ie9AE8De9AF0Bj9Fj9Gkukuszouvkerqo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 1987,
          "apCost": 2,
          "name": "Hold the Line",
          "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 1548,
      "name": "Blackstone Gargoyle",
      "description": "King Rugolth had statues erected throughout the Stronghold, to remind his subjects of Old Valdac. These statues could be animated, to act as guardians.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute",
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 75,
      "hash": "ej9Fj9EF0Af1Ae9AE8DJ8HJ8Ievmuxztxfemyto",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1926,
          "apCost": 0,
          "name": "Inscrutable Form",
          "shortDescription": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "inhibit"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 1903,
          "apCost": 3,
          "name": "Statue Form",
          "shortDescription": "This champion becomes <ability value=757>Immobile</ability> and <ability value=669>Earthbound</ability> It gains <ability value=35>Immunity: Physical</ability>, <ability value=117>Regeneration 3</ability>, +3 DEF, -5 DMG and its range is set to 1.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 5,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1252,
              "apCost": 0,
              "name": "Readiness",
              "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1922,
              "apCost": 0,
              "name": "Revere: Drakon",
              "shortDescription": "While this champion is in play, Drakon costs 10% less nora to deploy. While Drakon is in play this unit has the <ability value=1899>Scale Armor</ability> ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1702,
              "apCost": 0,
              "name": "Blockade",
              "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "blockade"
            },
            {
              "default": false,
              "id": 1898,
              "apCost": 0,
              "name": "Blessing of the Fallen",
              "shortDescription": "When this unit is destroyed, friendly champions gain +1 DEF for 4 turns (this does not stack) and heal 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ondeath"
            },
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            }
          ]
        }
      ]
    },
    {
      "id": 8,
      "name": "Bladed Corpse",
      "description": "Do you think we could add another blade? - Xulos to Elsarin Corpse Surgeon",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 60,
      "hash": "cj9Fj9Ej9Dg3AG2Aj9Dj9Ej9Foyxtqjpszoheirj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 2285,
          "apCost": 0,
          "name": "Sword Breaker",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "wrecker"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1171,
      "name": "Blinking Creeper",
      "description": "It is a subject of great debate among the Elsari whether the Mindthief Creeper or the Blinking Creeper would win in a staring contest.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 78,
      "hash": "ej9Cj9BF0Be9Ae9AG2AJ8IJ8Jkufirfxkgvvmwo",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2504,
          "apCost": 3,
          "name": "Shrink",
          "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "shrink"
        },
        {
          "id": 1009,
          "apCost": 0,
          "name": "Tariff",
          "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "cost"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            },
            {
              "default": true,
              "id": 2553,
              "apCost": 0,
              "name": "Worm Lord",
              "shortDescription": "This champion has <ability value=2526>Necrosis</ability>.  When a real enemy champion is destroyed by a champion with Race: Worm or Necrosis within 5 spaces, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "creep_master"
            }
          ]
        }
      ]
    },
    {
      "id": 987,
      "name": "Bliss the Muse",
      "description": "\"Not a leader, no. She is a muse. Bliss inspires. She understands that there is no need for commands when one is truly inspired to act.\" - Menalaus",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Bard",
        "Shaman"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 93,
      "hash": "ej9Fj9Ee9BE8De9AE8DJ8GJ8Hinhrjrhpjtohgn",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2408,
          "apCost": 0,
          "name": "Creativity",
          "shortDescription": "When this champion makes a successful basic attack, non-champion runes in your runedock have their CD reduced by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "hallucinogenic"
        },
        {
          "id": 1081,
          "apCost": 0,
          "name": "Enlightened",
          "shortDescription": "When this champion is healed, the amount is increased by 6.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blessed"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1764,
          "apCost": 0,
          "name": "Magic Acolyte",
          "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "acolyte_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 887,
              "apCost": 1,
              "name": "Hawk Attack",
              "shortDescription": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "hawk_attack"
            },
            {
              "default": false,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": true,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 1861,
      "name": "Bliss the Muse",
      "description": "\"Not a leader, no. She is a muse. Bliss inspires. She understands that there is no need for commands when one is truly inspired to act.\" - Menalaus",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Bard",
        "Shaman"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 93,
      "hash": "ej9Bj9AG2AG2BG2Af1Bj9Bj9Cevofgtxtqztuqsf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2408,
          "apCost": 0,
          "name": "Creativity",
          "shortDescription": "When this champion makes a successful basic attack, non-champion runes in your runedock have their CD reduced by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "hallucinogenic"
        },
        {
          "id": 1081,
          "apCost": 0,
          "name": "Enlightened",
          "shortDescription": "When this champion is healed, the amount is increased by 6.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blessed"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1764,
          "apCost": 0,
          "name": "Magic Acolyte",
          "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "acolyte_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 887,
              "apCost": 1,
              "name": "Hawk Attack",
              "shortDescription": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "hawk_attack"
            },
            {
              "default": false,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": true,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 424,
      "name": "Blizzard Elemental",
      "description": "The bitter air has a mind of its own, and one cannot fly with frozen wings.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 72,
      "hash": "dJ8JJ8IF0BF0BF0AJ8HJ8IJ8Jeeeepjgtojiyrwf",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1324,
          "apCost": 0,
          "name": "Domain: Arctic",
          "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_snow"
        },
        {
          "id": 778,
          "apCost": 2,
          "name": "Snow-Fall",
          "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainsnow"
        },
        {
          "id": 1121,
          "apCost": 0,
          "name": "Wind Aura",
          "shortDescription": "Champions within 5 spaces of this champion are <condition value=grounded>Grounded</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "gale"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2667,
              "apCost": 2,
              "name": "Snow Shroud",
              "shortDescription": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "domain_snow"
            },
            {
              "default": true,
              "id": 390,
              "apCost": 1,
              "name": "Frost Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 2810,
              "apCost": 0,
              "name": "Spellsurge: Snowstorm",
              "shortDescription": "When this champion is deployed, Snowstorm spells are revealed from your runedock.  Snowstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Snowstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2819,
              "apCost": 0,
              "name": "Catalyst: Frost",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 3331,
              "apCost": 0,
              "name": "Tundra Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fangandfur"
            },
            {
              "default": false,
              "id": 898,
              "apCost": 0,
              "name": "Ice Eater",
              "shortDescription": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 9,
      "name": "Bloated Toad",
      "description": "They may all stink like muck, but they are good for a ride. - Boghopper youth",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Boghopper"
      ],
      "noraCost": 55,
      "hash": "cj9AJ8JJ8IF0BF0AJ8IJ8Jj9Aeemsjrusxtssxth",
      "artist": "Dan Kopycienski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1410,
          "apCost": 0,
          "name": "Boghopper Rider",
          "shortDescription": "When this unit is destroyed, no nora globe is dropped and a Boghopper with no upgrades is spawned in the location this unit occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "rider"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": true,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 5,
              "apCost": 0,
              "name": "Lumbering",
              "shortDescription": "This champion's AP cost for each movement is increased by 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -18,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 2012,
              "apCost": 0,
              "name": "Lethargic",
              "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 3064,
              "apCost": 0,
              "name": "Weighty",
              "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "weighty"
            }
          ]
        }
      ]
    },
    {
      "id": 1655,
      "name": "Blood Abhorrent",
      "description": "Given time and proper treatment, nora can develop a taste for almost anything.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 76,
      "hash": "eJ8JJ8IG2AF0BG2AF0Bj9Bj9Ceeeeeetjiilytqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3141,
          "apCost": 3,
          "name": "Blood Convergence",
          "shortDescription": "Target enemy champion within 5 spaces loses 4 HP per Blood Ball within 3 spaces of it. Those Blood Balls are consumed and this champion vampiric heals for 50% of the HP lost to a maximum of 20 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "bloodball"
        },
        {
          "id": 3151,
          "apCost": 0,
          "name": "Bloodspurt",
          "shortDescription": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blood_debt"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2708,
              "apCost": 1,
              "name": "Gluttony",
              "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "devour"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 417,
      "name": "Blood Fiend",
      "description": "Some creatures raised from the dead have been extinct so long their name was forgotten. We now call them Blood Fiends.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 11,
      "hitPoints": 60,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Worm"
      ],
      "noraCost": 55,
      "hash": "dJ8IJ8HF0AF0Bf1Bj9Aj9Bj9Ceevsfiilwzowoyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 24,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "berserker"
        },
        {
          "id": 1108,
          "apCost": 0,
          "name": "Blood Fueled",
          "shortDescription": "This champion loses 8 HP and gains 8 AP. This champion does not gain AP at the beginning of turn. This ability starts on cooldown",
          "activationType": 0,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "nexus_aura"
        },
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 374,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 1 AP. This ability begins on CD.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 1,
              "iconName": "crazed_charger"
            },
            {
              "default": true,
              "id": 375,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 2 AP. This ability begins on CD.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "crazed_charger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 98,
              "apCost": 0,
              "name": "Lifedrinker",
              "shortDescription": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ondeath"
            }
          ]
        }
      ]
    },
    {
      "id": 1692,
      "name": "Blood Owl",
      "description": "The Blood Owl is the first incarnation of Liquin. Praise be, Liquin the Third.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9Eg3Af1AG2AE8Dj9Dj9Eevklyrfkgvfepsf",
      "artist": "Darcie Banfield",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": false,
      "tradeable": false,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2595,
          "apCost": 0,
          "name": "Hunter: Bloodied",
          "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "blood_debt"
        },
        {
          "id": 1179,
          "apCost": 0,
          "name": "Taunt: Blood Owl",
          "shortDescription": "Taunt your enemies with the phrase \"Now you will see my true power!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 3112,
              "apCost": 0,
              "name": "Blood Casting",
              "shortDescription": "When this champion is deployed, all real enemy champions in play have a Blood Ball worth 5 HP created adjacent to them.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "bloodball"
            }
          ]
        }
      ]
    },
    {
      "id": 1576,
      "name": "Blood Phoenix",
      "description": "The greatest paragon of corruption, thrice dead and thrice cursed, and an omen of darkness to come.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 6,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 77,
      "hash": "ej9Cj9BG2Ae9BG2AG2Aj9Bj9Ceemjpssumssjgrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 890,
          "apCost": 0,
          "name": "Grace of the Dead",
          "shortDescription": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "healmass"
        },
        {
          "id": 3074,
          "apCost": 0,
          "name": "Rebirth",
          "shortDescription": "When this champion is destroyed, it drops no nora globe and is redeployed in the closest friendly deployment zone without this ability, but gains 5 AP and permanently gains +4 DMG and +25 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 35,
          "iconName": "revive"
        },
        {
          "id": 711,
          "apCost": 0,
          "name": "Siphoning Aura",
          "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "possess"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        }
      ]
    },
    {
      "id": 1125,
      "name": "Bloodbinder Count",
      "description": "Wizard's blood is the Bloodbinder Count's preferred tonic.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Undead",
        "Vampyre"
      ],
      "noraCost": 92,
      "hash": "eJ8HJ8Gg3Ae9Ae9Ae9Bj9Dj9Eeevklplwvxzgvo",
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2513,
          "apCost": 1,
          "name": "Blood Bind",
          "shortDescription": "This unit loses 5 HP and all opposing units within 4 spaces on a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> lose 5 HP and are <condition value=paralyzed>Paralyzed</condition> until the end of the next turn. This unit vampiric heals 5 HP for each affected champion. This ability enters play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "soul_siphon"
        },
        {
          "id": 3333,
          "apCost": 1,
          "name": "Blood Spear",
          "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. If the target is <condition value=bloodied>Bloodied</condition> or has less than 50% HP remaining, this champion vampiric heals for 8.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "novablood"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 3399,
          "apCost": 0,
          "name": "Lord of Strigoi",
          "shortDescription": "This champion has <ability value=977>Bleed</ability>. After this champion uses an ability, friendly champions with Race: Vampyre within 3 spaces of this champion gain +2 Max HP and -1 CD on their abilities. This may only trigger once per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "soul_siphon"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2464,
              "apCost": 2,
              "name": "Blood for Nora",
              "shortDescription": "This unit loses 20 health. The next spell you cast this turn has its Nora cost reduced by 20. This effect does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "nora_hex"
            },
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1507,
      "name": "Bloodbow Infantry",
      "description": "Death is a journey, and pain your companion.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 62,
      "hash": "ej9Bj9Ae9BF0Be9Af1BJ8GJ8Heerjwmneiemuqo",
      "artist": "Asa Enochs",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1706,
          "apCost": 0,
          "name": "Ammunition",
          "shortDescription": "Once this champion has made at least 2 successful attacks, its range becomes 1.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "gun"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2435,
          "apCost": 0,
          "name": "Bloodtracker",
          "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rend"
        },
        {
          "id": 3292,
          "apCost": 0,
          "name": "Reload",
          "shortDescription": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2214,
              "apCost": 0,
              "name": "Hunter: Scout",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_archer"
            },
            {
              "default": false,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1606,
      "name": "Bloodgoyle",
      "description": "Despite the name, Bloodgoyles are not constructs of any kind, instead, they are pure demonic energy driven by the lust for blood.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 76,
      "hash": "eJ8JJ8IG2AF0AG2AF0Bj9Bj9Ceeeeerqzgtzxqqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 3112,
          "apCost": 0,
          "name": "Blood Casting",
          "shortDescription": "When this champion is deployed, all real enemy champions in play have a Blood Ball worth 5 HP created adjacent to them.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "bloodball"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 2833,
          "apCost": 2,
          "name": "Teleport: Blood Ball",
          "shortDescription": "This champion relocates to a Blood Ball within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 2626,
              "apCost": 0,
              "name": "Scrapper",
              "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "scrapper"
            },
            {
              "default": false,
              "id": 3072,
              "apCost": 3,
              "name": "Elusive Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "dashing_dodge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 720,
      "name": "Bloodhowler Alpha",
      "description": "Bloodhowlers have neared the Slip, giving in to every feral whim and often leaving a trail of blood. These Kanen are the most feared of all.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 81,
      "hash": "dj9Cj9BG2Af1BG2Bj9Cj9Dj9Eeevfronevzvfpjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2146,
          "apCost": 0,
          "name": "Pack Leader",
          "shortDescription": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 1363,
          "apCost": 0,
          "name": "Unleash",
          "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "unleashed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": true,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1063,
              "apCost": 0,
              "name": "Kill Frenzy ",
              "shortDescription": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "furious_attacks"
            }
          ]
        }
      ]
    },
    {
      "id": 348,
      "name": "Bloodletter",
      "description": "These wicked fiends are frenzied in combat, often making a terrible mess of their opponent.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 60,
      "hash": "dj9Cj9BG2AF0Ae9BJ8GJ8HJ8Ionuofpfgtsjgexf",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 2435,
          "apCost": 0,
          "name": "Bloodtracker",
          "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rend"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 789,
      "name": "Bloodmane Ravager",
      "description": "The youngest of the warrior societies, the Bloodmanes believe that the Kanen's atrocities must be met with equal force. In battle, the Ravagers tear through the enemy ranks with their Rathclaw Blades.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 76,
      "hash": "dj9Gj9Fe9AG2Bf1Bj9Aj9Bj9Ceitshgevmhtmnhg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 28,
          "apCost": 0,
          "name": "Blood Frenzy",
          "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            }
          ]
        }
      ]
    },
    {
      "id": 1078,
      "name": "Bloodtracker",
      "description": "\"Found low or high, at midnight nigh, take heart, take flight, from beast of night\" - Moragen the Lost",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead",
        "Vampyre"
      ],
      "noraCost": 69,
      "hash": "ej9Dj9CF0BE8De9AG2BJ8IJ8Jinuxfgpyvzvhyo",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2435,
          "apCost": 0,
          "name": "Bloodtracker",
          "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rend"
        },
        {
          "id": 2250,
          "apCost": 3,
          "name": "Scythe Whirl",
          "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "scythe_wirlwind"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3142,
              "apCost": 0,
              "name": "Empowered: Speed",
              "shortDescription": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_speed"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3397,
              "apCost": 0,
              "name": "Vampiric Thirst",
              "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1228,
      "name": "Bloodworm",
      "description": "Legend tells of an ancient vampyre allowing himself to be devoured by a Creeper in an attempt to possess it, resulting in the Bloodworm.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Undead",
        "Vampyre",
        "Worm"
      ],
      "noraCost": 78,
      "hash": "ej9Gj9FG2Ae9Be9Ae9Aj9Bj9Ceiygtuzvhnpnlpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        },
        {
          "id": 3397,
          "apCost": 0,
          "name": "Vampiric Thirst",
          "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2526,
              "apCost": 0,
              "name": "Necrosis",
              "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 317,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2551,
              "apCost": 2,
              "name": "Bloodseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=bloodied>Bloodied</condition> or less than 50% HP and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": false,
              "id": 3363,
              "apCost": 0,
              "name": "Bloodlust",
              "shortDescription": "This champion deals 30% additional damage to Bloodied champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 898,
      "name": "Bluefist",
      "description": "\"You must move like water, strike swiftly and fluidly. Erode their defense first and they will fall.\" - Trinh, Bluefist Monk",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9Bg3Ae9BJ8GJ8HJ8Iyxiwfkrjiietjwf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2278,
          "apCost": 0,
          "name": "Charged Frost Kick",
          "shortDescription": "Spend 4 Charges. This unit makes a Frost attack at +2 DMG at its range against target unit.",
          "activationType": 3,
          "level": 0,
          "cooldown": 1,
          "noraCost": 8,
          "iconName": "chrg_frost_kick"
        },
        {
          "id": 217,
          "apCost": 0,
          "name": "Dodge",
          "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 2282,
          "apCost": 0,
          "name": "Ki Strike",
          "shortDescription": "This champion's next basic attack this turn has +DMG equal to the number of charges it currently has and the champion loses a third of its charges (rounded down).",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "ki_strike"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2167,
              "apCost": 0,
              "name": "Attack Charged",
              "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            },
            {
              "default": true,
              "id": 2178,
              "apCost": 0,
              "name": "Supercharged",
              "shortDescription": "This unit gains 1 charge at the start of its turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "supercharged"
            },
            {
              "default": false,
              "id": 2261,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            }
          ]
        }
      ]
    },
    {
      "id": 1670,
      "name": "Blueflame Arsonist",
      "description": "FIRE! BURN BURN BURN! Ooooh, FIRE! OH YEA! It's getting hot in here! BURN BURN BURN! Did you dye your hair red? No, it's just on fire!  HAHAHAH!",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue",
        "Wizard"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 64,
      "hash": "ej9Bj9Ag3AF0BG2Af1Bj9Dj9Eeevkuzmekjgvqsf",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 181,
          "apCost": 0,
          "name": "Death Nova: Fire",
          "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovafire"
        },
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1841,
      "name": "Boarspider",
      "description": "Chroniclers would have an interest in the myriad rare demons and beasts of the Underdepths, were they not so digusting and abjectly violent.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Arthropod",
        "Beast"
      ],
      "noraCost": 70,
      "hash": "eJ8JJ8IF0BG2BG2AF0BJ8IJ8Jwiwillpygthtoqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 730,
          "apCost": 1,
          "name": "Poison Sting",
          "shortDescription": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 241,
              "apCost": 0,
              "name": "Damage Shield: Poison",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Poison damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_poison"
            },
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            },
            {
              "default": false,
              "id": 1805,
              "apCost": 3,
              "name": "Weave Web",
              "shortDescription": "Area Effect 2, Range 3: Affected area is becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "web"
            }
          ]
        }
      ]
    },
    {
      "id": 11,
      "name": "Boghopper",
      "description": "Frog legs, anyone? - Dizzle, Draksar field-cook",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 60,
      "hash": "cj9Gj9Fj9EE8DF0Aj9Ej9Fj9Geerhrfeiyztmyii",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 217,
          "apCost": 0,
          "name": "Dodge",
          "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 895,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            },
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            }
          ]
        }
      ]
    },
    {
      "id": 977,
      "name": "Boghopper Blackhand",
      "description": "Blackhand's are an upstart order of Boghoppers versed in martial arts. They follow the Penumbra clan of J'thir. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Monk"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 82,
      "hash": "dj9Ej9Dg3Ag3Ae9BJ8GJ8HJ8Imsmjgrfeexitufg",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2094,
          "apCost": 0,
          "name": "Combo Attack: Stun",
          "shortDescription": "When this champion makes two successful basic attacks that deal damage against the same champion in a single turn, that champion becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "comboatk_rend"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1445,
              "apCost": 0,
              "name": "Counter Attack: Ranged",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "reflexes"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            },
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            }
          ]
        }
      ]
    },
    {
      "id": 118,
      "name": "Boghopper Bull",
      "description": "I thought you said they were smaller than dwarves! --  They were, they were!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9Be9AG2Aj9Bj9Cj9Dtjwzolgrqhrhexf",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 8,
          "apCost": 0,
          "name": "Battlemaster",
          "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "aurapositive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 622,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 2 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        }
      ]
    },
    {
      "id": 1713,
      "name": "Boghopper Dredger",
      "description": "\"The bull isn't going to catch us, not while holding onto that heavy thing.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9CE8Df1AG2AG2Bj9Ej9Fgyxvhiegeinhirf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2660,
          "apCost": 3,
          "name": "Grappling Hook",
          "shortDescription": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "pull"
        },
        {
          "id": 3218,
          "apCost": 3,
          "name": "Summon: Watershed Anchor",
          "shortDescription": "Summon a Watershed Anchor relic with <ability value=3185>Anchoring Force</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 18,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 304,
      "name": "Boghopper Elite",
      "description": "Griblic - Send a trio of Elites to flank that Earthshaker. Attack in waves to bypass the Tremor.  - Tidemaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8DF0AE8Dj9Ej9Fj9Geeerzgrzvzgtfeg",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 213,
          "apCost": 0,
          "name": "Block",
          "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "block"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1263,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 1565,
      "name": "Boghopper Glutton",
      "description": "When Blugrad was only a tad, the guardian warned him that if he ate too much, his final fate would be to be eaten. Sometimes, Blugrad still wonders what \"too much\" means.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Jf1Be9BG2Af1Aj9Aj9Bouossowkpqjyoqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 1467,
          "apCost": 4,
          "name": "Seismic Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "leap_massive"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 690,
      "name": "Boghopper Huntmaster",
      "description": "The huntmasters raise their wards from adolescence, teaching them to hunt like a hound.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0BG2AE8Dj9Ej9Fj9Geeeeeruvmjtzmeg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        },
        {
          "id": 1890,
          "apCost": 0,
          "name": "Pet: Pygmy Hippo",
          "shortDescription": "When this champion is deployed, a Pygmy Hippo with no upgrades is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "pet"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 626,
      "name": "Boghopper Mentor",
      "description": "Knowledge is not the only thing that can be taught, young one. Power, feats of strength, extraordinary acts of courage; these can be learned. - Hirlun, Boghopper Mentor",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 73,
      "hash": "dj9Ej9Dg3Af1BE8Dj9Ej9Fj9Geeerllnjemwfkjg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1728,
          "apCost": 0,
          "name": "Divert",
          "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deflect"
        },
        {
          "id": 2297,
          "apCost": 1,
          "name": "Grant: Evasive",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 2132,
          "apCost": 0,
          "name": "Water Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainwater"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2348,
              "apCost": 4,
              "name": "Beast Herder",
              "shortDescription": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "desert_hearder"
            },
            {
              "default": false,
              "id": 2472,
              "apCost": 4,
              "name": "Swamp Teachings",
              "shortDescription": "This unit loses 10 HP and target Boghopper Tad within 3 spaces is removed from play and a Boghopper Pupil with no upgrades is summoned in the same location the Boghopper Tad occupied. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 5,
              "noraCost": 8,
              "iconName": "semiaquatic"
            },
            {
              "default": true,
              "id": 3010,
              "apCost": 4,
              "name": "Bubble",
              "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "bubble"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2417,
              "apCost": 4,
              "name": "Summon: Boghopper Tad",
              "shortDescription": "Summon a Boghopper Tad with no upgrades to a target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "summon_tad"
            },
            {
              "default": false,
              "id": 1809,
              "apCost": 4,
              "name": "Marsh Lesson",
              "shortDescription": "Target friendly champion within 3 spaces loses <ability value=114>Aquatic</ability> and gains <ability value=859>Semi Aquatic</ability>. This ability cost 8 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "semiaquatic"
            },
            {
              "default": false,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            }
          ]
        }
      ]
    },
    {
      "id": 1055,
      "name": "Boghopper Paladin",
      "description": "While not as prolific as dwarves that bear the name 'paladin' they are no less stubborn or tenacious.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 66,
      "hash": "ej9Bj9Ae9AE8De9Af1Bj9Fj9Ggrwtumwtxzggyo",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1052,
          "apCost": 0,
          "name": "Purified",
          "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "cleanse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1076,
              "apCost": 3,
              "name": "Heal Self",
              "shortDescription": "This unit recovers 12 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": true,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 746,
      "name": "Boghopper Pupil",
      "description": "And do not fret over your future, young one. You will learn much from your teachers, as long as you listen and think on their lessons. Over time, you will grow into your own path. - Gekaal, the High One",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "None"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 63,
      "hash": "dj9Dj9CG2BG2Ae9Aj9Fj9Gj9Hwmhrofitjtmnsjg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1969,
          "apCost": 3,
          "name": "Become: Bull",
          "shortDescription": "This ability begins play on cooldown. This champion loses this ability and the ability Become: Shaman, is <mechanic value=cleansed>Cleansed</mechanic>, and gets +3 DMG, +10 MAX HP, +1 DEF, Class: Warrior, <ability value=597>Unstoppable</ability> and <ability value=108>Pummel 1</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "transform"
        },
        {
          "id": 1970,
          "apCost": 3,
          "name": "Become: Shaman",
          "shortDescription": "This ability begins play on cooldown. This champion is <mechanic value=cleansed>Cleansed</mechanic>, loses this ability and the ability Become: Bull, and then it gains <ability value=367>Heal Champion 2</ability>, <ability value=1443>Council: Spells</ability>, <ability value=544>Attack: Magical</ability>Class: Shaman, its range becomes RNG 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 516,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 1,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            },
            {
              "default": true,
              "id": 2032,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +4 HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plushealth"
            }
          ]
        }
      ]
    },
    {
      "id": 12,
      "name": "Boghopper Shaman",
      "description": "What the Shaman lacks in strength of hand it makes up for in strength of mind.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 71,
      "hash": "cj9Cj9Bj9Af1BF0Aj9Aj9Bj9Ceevzrfxietxfrzi",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 305,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 12 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "divine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 3010,
              "apCost": 4,
              "name": "Bubble",
              "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "bubble"
            },
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            }
          ]
        }
      ]
    },
    {
      "id": 1950,
      "name": "Boghopper Shaman",
      "description": "What the Shaman lacks in strength of hand it makes up for in strength of mind.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FG2Ae9AG2Be9Aj9Bj9Ceerqsfxxmjtmyrf",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 305,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 12 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "divine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 3010,
              "apCost": 4,
              "name": "Bubble",
              "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "bubble"
            },
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            }
          ]
        }
      ]
    },
    {
      "id": 177,
      "name": "Boghopper Spitter",
      "description": "No fair! You leaned! -- Boghopper youths practicing",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 71,
      "hash": "dj9Cj9BG2Ae9AG2Aj9Bj9Cj9Dzgyrjluzzkuhygg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 167,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1094,
              "apCost": 0,
              "name": "Poison Eater",
              "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_poison"
            },
            {
              "default": false,
              "id": 40,
              "apCost": 0,
              "name": "Immunity: Poison",
              "shortDescription": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_poison"
            }
          ]
        }
      ]
    },
    {
      "id": 175,
      "name": "Boghopper Tad",
      "description": "Tankt, you would do well to remember that it wasn't too long ago you were once the swamp. - Forglar Pool Shaman scolding a tad",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 34,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 48,
      "hash": "dj9Cj9BG2Ae9Af1AJ8Jj9Aj9Bgvvqzvshegtuzzg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 114,
          "apCost": 0,
          "name": "Aquatic",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "aquatic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2919,
          "apCost": 0,
          "name": "Guarded: Boghopper",
          "shortDescription": "The first time each turn this unit is successfully attacked, friendly Boghopper within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "guarded"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 516,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 1,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 855,
              "apCost": 0,
              "name": "Hidden: Water",
              "shortDescription": "At the end of your turn, if this champion occupies Water, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 1622,
      "name": "Boghopper Thunderfist",
      "description": "\"Bind my feet, and take my life, but you shall never take the life I grant these fists.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 67,
      "hash": "ej9Fj9Ef1BF0BG2AE8Dj9Aj9Bemegvzowfxtmuqf",
      "artist": "Grant Griffin",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2401,
              "apCost": 4,
              "name": "Lightning Skewer",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 805,
              "apCost": 1,
              "name": "Chain Lightning",
              "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "electric"
            },
            {
              "default": false,
              "id": 2168,
              "apCost": 0,
              "name": "Attack Charged",
              "shortDescription": "When this champion makes a basic attack, it gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_abuse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2190,
              "apCost": 0,
              "name": "Charged Attack",
              "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "charged_attack"
            }
          ]
        }
      ]
    },
    {
      "id": 404,
      "name": "Boghopper Toad",
      "description": "They were rarely seen away from their home until they learned their friends to the north were in trouble!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 81,
      "hash": "dJ8HJ8Ge9BF0Bg3Aj9Dj9Ej9Femsufgyvqojgneg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2227,
          "apCost": 0,
          "name": "Choking Stench",
          "shortDescription": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "choking_stench"
        },
        {
          "id": 3328,
          "apCost": 0,
          "name": "Hunter: Poisoned",
          "shortDescription": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "poison"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 169,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 1366,
              "apCost": 0,
              "name": "Deflect: Poison",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Poison damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_poison"
            },
            {
              "default": false,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 446,
              "apCost": 0,
              "name": "Lay Trap: Poison Cloud",
              "shortDescription": "Lay a Poison Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, all spaces within a range of 2 are covered in a <mechanic value=poison_cloud>poison cloud</mechanic> until end of the next turn.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trappoison"
            },
            {
              "default": true,
              "id": 145,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapoison"
            },
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 431,
      "name": "Boghopper Toad",
      "description": "They were rarely seen away from their home until they learned their friends to the north were in trouble!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 81,
      "hash": "dj9AJ8Jf1AF0BG2Bj9Cj9Dj9Eeeeeiggeruvzigg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2227,
          "apCost": 0,
          "name": "Choking Stench",
          "shortDescription": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "choking_stench"
        },
        {
          "id": 3328,
          "apCost": 0,
          "name": "Hunter: Poisoned",
          "shortDescription": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "poison"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 169,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 1366,
              "apCost": 0,
              "name": "Deflect: Poison",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Poison damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_poison"
            },
            {
              "default": false,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 446,
              "apCost": 0,
              "name": "Lay Trap: Poison Cloud",
              "shortDescription": "Lay a Poison Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, all spaces within a range of 2 are covered in a <mechanic value=poison_cloud>poison cloud</mechanic> until end of the next turn.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trappoison"
            },
            {
              "default": true,
              "id": 145,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapoison"
            },
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 995,
      "name": "Boghopper Zombie",
      "description": "\"Blarhgck\" - Ginj, newly risen Boghopper Zombie",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 4,
      "damage": 5,
      "hitPoints": 18,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Boghopper",
        "Undead",
        "Zombie"
      ],
      "noraCost": 49,
      "hash": "ej9Gj9FE8DE8De9Ae9Aj9Ej9Fyruqjtmwkwmsuo",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 877,
              "apCost": 0,
              "name": "Bodyguard",
              "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 516,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 1,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            }
          ]
        }
      ]
    },
    {
      "id": 1168,
      "name": "Bogwood Mireoak",
      "description": "The fireflies feed on the poisonous fumes that the Mireoaks produce, and ravenously attack anyone who dares to threaten the tree.  The tree itself is not without defenses, however.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 82,
      "hash": "ej9Cj9Be9Ae9Ae9AG2Aj9Fj9Ginuxxvmpwojyipf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1748,
          "apCost": 1,
          "name": "Grant: Poison Cloud Trap",
          "shortDescription": "Target champion within 5 spaces gains <ability value=446>Lay Trap: Poison Cloud</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 2558,
          "apCost": 4,
          "name": "Summon: Electric Fireflies",
          "shortDescription": "Summon 2 Electric Fireflies to adjacent spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "sumelectric_firefly"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            },
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 428,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 4: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 427,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poison_cloud"
            },
            {
              "default": true,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 981,
      "name": "Bok Enforcer",
      "description": "\"They do not fear the Bok? They have never known my army. They have never known fear.\" - Rallien, Bok Matron",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 74,
      "hash": "dj9Ej9Dg3Ag3Af1Bj9Aj9Bj9Ceeeeituzohtqzkg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1139,
          "apCost": 3,
          "name": "Command: Dodge",
          "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "command_dodge"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 3357,
          "apCost": 0,
          "name": "Obsidian Flight",
          "shortDescription": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3389,
              "apCost": 0,
              "name": "Infernal Armaments",
              "shortDescription": "When a friendly champion with Race: Minotaur, Race: Demon Elf or Race: Archdemon becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            }
          ]
        }
      ]
    },
    {
      "id": 1935,
      "name": "Bok Enforcer",
      "description": "\"They do not fear the Bok? They have never known my army. They have never known fear.\" - Rallien, Bok Matron",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9EE8De9AG2BE8Dj9Ej9Fkukymnymjpszkpf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1139,
          "apCost": 3,
          "name": "Command: Dodge",
          "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "command_dodge"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 3357,
          "apCost": 0,
          "name": "Obsidian Flight",
          "shortDescription": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3389,
              "apCost": 0,
              "name": "Infernal Armaments",
              "shortDescription": "When a friendly champion with Race: Minotaur, Race: Demon Elf or Race: Archdemon becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            }
          ]
        }
      ]
    },
    {
      "id": 229,
      "name": "Bok Gatekeeper",
      "description": "The gates to Sheoul need no locks, for the Bok suffice.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 7,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 68,
      "hash": "dJ8JJ8IF0Be9Be9Aj9Fj9Gj9Hukukjgerzmpnyzg",
      "artist": "Trevor Claxton",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1437,
          "apCost": 0,
          "name": "Camaraderie ",
          "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "cost"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 3357,
          "apCost": 0,
          "name": "Obsidian Flight",
          "shortDescription": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 1469,
              "apCost": 0,
              "name": "Nexus Aura",
              "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "nexus_aura"
            },
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 762,
              "apCost": 0,
              "name": "Defender of Chaos",
              "shortDescription": "When damage would be dealt to your Shrine, it is dealt to this unit instead.   Redirected damage cannot be reduced.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "shrinegood"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 13,
      "name": "Bok Guardian",
      "description": "I can never tell if they are truly protecting us, or just making sure we don't get away. - Deep Elf Merchant",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 65,
      "hash": "cJ8IJ8HJ8Ge9Bf1AJ8GJ8HJ8Irlggeevfggiwzoh",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 213,
          "apCost": 0,
          "name": "Block",
          "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "block"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 3357,
          "apCost": 0,
          "name": "Obsidian Flight",
          "shortDescription": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            },
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 287,
              "apCost": 0,
              "name": "Riposte",
              "shortDescription": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +1 DMG.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counter"
            }
          ]
        }
      ]
    },
    {
      "id": 864,
      "name": "Bok Mistress",
      "description": "\"My methods work every time, Erimalion. Your work is cruel. You break them until they kneel before you. I only need to convince them to kneel. And they do.\" - Marinos, Bok Mistress",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 73,
      "hash": "dj9Ej9Dg3AG2Be9Aj9Fj9Gj9Hiyxqjykgykrlllg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 2338,
          "apCost": 0,
          "name": "Psychic Magnetism",
          "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull"
        },
        {
          "id": 3380,
          "apCost": 0,
          "name": "Sanguine Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1783,
          "apCost": 0,
          "name": "Subsume",
          "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 2197,
              "apCost": 3,
              "name": "Blood Magic",
              "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3151,
              "apCost": 0,
              "name": "Bloodspurt",
              "shortDescription": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        }
      ]
    },
    {
      "id": 1230,
      "name": "Bok Raider",
      "description": "Though many Bok consider the Raider corp to be mere \"clean up\" crew, it is still a popular position due to the opportunity for unrestricted mayhem.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Archdemon",
        "Dragon"
      ],
      "noraCost": 76,
      "hash": "ej9Gj9Fg3Ae9Be9Ae9Aj9Dj9Eerqjwqqhexvmuqf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1457,
          "apCost": 0,
          "name": "Forage",
          "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "forage"
        },
        {
          "id": 3199,
          "apCost": 0,
          "name": "Raider",
          "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "raider"
        },
        {
          "id": 3380,
          "apCost": 0,
          "name": "Sanguine Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 1089,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": false,
              "id": 1803,
              "apCost": 0,
              "name": "Volley Leader",
              "shortDescription": "Other friendly Archers within 5 spaces gain a rank of <ability value=1088>Rain of Arrows</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 602,
      "name": "Bok Warden",
      "description": "I don't care what Grimlic says; you will listen to my orders above his. Belligerence is punished by death. - Kelziem, Bok Warden",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer",
        "Ranger"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 72,
      "hash": "dj9Bj9Af1Bf1Bf1AJ8Jj9Aj9Bqsofgtmhpytmpfg",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        },
        {
          "id": 3357,
          "apCost": 0,
          "name": "Obsidian Flight",
          "shortDescription": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1602,
      "name": "Bone Circle Archmage",
      "description": "Bone Circle Archmages embody the ethos of the order, who understand and embrace the fact that the cycle of death and undeath is eternal.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 74,
      "hash": "eJ8IJ8HG2BF0AG2AF0Aj9Cj9Drumyzkgyouvvqqf",
      "artist": "Alex Konstad",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3106,
          "apCost": 5,
          "name": "Bone Prison",
          "shortDescription": "3 Grave Warriors are summoned in the spaces closest to target enemy champion within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "bone_prison"
        },
        {
          "id": 1618,
          "apCost": 0,
          "name": "Desecrated Zone",
          "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "terrain_dmz"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 1399,
          "apCost": 1,
          "name": "Hex",
          "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "lossoflife"
        },
        {
          "id": 1786,
          "apCost": 3,
          "name": "Ritual of Destruction",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_damage"
        },
        {
          "id": 3107,
          "apCost": 3,
          "name": "Ritual of Healing",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_healing"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1769,
              "apCost": 0,
              "name": "One With Nora",
              "shortDescription": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 2315,
              "apCost": 0,
              "name": "Oblivion Shield",
              "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 2184,
              "apCost": 0,
              "name": "Eradicate",
              "shortDescription": "Spend all charges. Target champion within 5 spaces loses 2 HP for each charge spent this way (up to 20 HP).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "eradicate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": true,
              "id": 431,
              "apCost": 4,
              "name": "Summon: Skeleton",
              "shortDescription": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "sumskel"
            }
          ]
        }
      ]
    },
    {
      "id": 496,
      "name": "Bone Elemental",
      "description": "We know nothing of its true intentions. It did not rise from Serkan's hand! - Feyna, Necromancer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Knight"
      ],
      "races": [
        "Elemental",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 80,
      "hash": "dj9Bj9Af1Bf1Af1AJ8Jj9Aj9Bklrfpuqjygipleg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1320,
          "apCost": 0,
          "name": "Assault",
          "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1424,
          "apCost": 0,
          "name": "Bone Fracture",
          "shortDescription": "When this unit takes damage from any attack, a Lesser Bonemauler champion is summoned in the nearest available space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "bone_fracture"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        }
      ]
    },
    {
      "id": 1577,
      "name": "Bone Slave",
      "description": "Captured enemy combatants don't get the respite of a heroic death in the Wastes. Instead, they are put to work hauling remains excavated from the bone mines that litter the region.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 60,
      "hash": "ej9Cj9Bg3Ae9BG2AG2Aj9Dj9Eeeilrquhvosuqsf",
      "artist": "Alex Konstad",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 173,
          "apCost": 0,
          "name": "Death Nova: Physical",
          "shortDescription": "When this unit is destroyed, it deals 11 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "deathnovaphysical"
        },
        {
          "id": 3075,
          "apCost": 0,
          "name": "Death Nova: Skeletons",
          "shortDescription": "When this unit is destroyed, 2 Grave Warriors are randomly summoned within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "deathnovaskeletons"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1754,
              "apCost": 0,
              "name": "Hidden: Dead Magic Zone",
              "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 725,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            }
          ]
        }
      ]
    },
    {
      "id": 90,
      "name": "Bonecrusher",
      "description": "They know only how to destroy. Is that not enough? - Xulos, Apprentice to Serkan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 69,
      "hash": "cj9Cj9Bj9Af1BG2Aj9Aj9Bj9Cemjluhkyxvolegi",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 869,
          "apCost": 3,
          "name": "Tremor",
          "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 344,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +6 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 14,
      "name": "Boneguard Infantry",
      "description": "Most armies require food and water while on the march. Boneguard don't have that problem. - Boghopper Sentry",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 33,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 47,
      "hash": "cj9Bj9AJ8Jf1AG2AJ8Jj9Aj9Bsufthygtzithpyi",
      "artist": "Shayne Bingham",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 213,
          "apCost": 0,
          "name": "Block",
          "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "block"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 465,
      "name": "Bonemauler ",
      "description": "Broken child of Serkan, you can still serve us. We will never deny a soul that wishes to fight. - Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 9,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 74,
      "hash": "dj9Gj9Fe9Af1AG2Bj9Cj9Dj9Eeeitftfpuqqsxig",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1387,
          "apCost": 0,
          "name": "Assimilate",
          "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "assimilate"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 1258,
          "apCost": 0,
          "name": "Splintering",
          "shortDescription": "After this champion deals Physical damage to a champion on a close-combat attack, this champion loses 4 HP and gains +2 DMG and a Bone Spur is created in an adjacent space. When a champion with Race: Skeleton captures a Bone Spur, they gain +1 DMG for 1 turn and +2 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            }
          ]
        }
      ]
    },
    {
      "id": 1351,
      "name": "Boneshredder",
      "description": "The Boneshredder is an abomination of abominations, born from graveyards touched by the plague of Ba'lah, they are grotesque even to other undead.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Arthropod",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Je9AF0Ae9Af1Aj9Fj9Gklgkwvkrzzigepf",
      "artist": "Conceptopolis",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        },
        {
          "id": 2781,
          "apCost": 0,
          "name": "Summon: Bone Trap",
          "shortDescription": "Summon an Bone Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=2776>Bone Trap</ability> to target adjacent space. This ability does not break stealth",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3297,
              "apCost": 0,
              "name": "Zeal: Defense",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DEF for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_defense"
            },
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            }
          ]
        }
      ]
    },
    {
      "id": 1032,
      "name": "Bonewing",
      "description": "\"The screech you hear - fills heart with fear, the dread inside - strips strong of pride, when all alone - fear wings of bone.\" - Moragen the Lost\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 78,
      "hash": "eJ8IJ8Hg3AE8De9AF0Aj9Dj9Eeitoqsxoushexo",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3006,
          "apCost": 0,
          "name": "Nora Induction",
          "shortDescription": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ichor_utility"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            },
            {
              "default": false,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2797,
              "apCost": 0,
              "name": "Logistics: Range",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +2 MAX RNG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2781,
              "apCost": 0,
              "name": "Summon: Bone Trap",
              "shortDescription": "Summon an Bone Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=2776>Bone Trap</ability> to target adjacent space. This ability does not break stealth",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deploy"
            }
          ]
        }
      ]
    },
    {
      "id": 1663,
      "name": "Boras, Frostfall Tardigrade",
      "description": "Tardigrades have a tremendous ability to adapt to whatever environment they find themselves in, but seem partial to the Frostfall region of the Tundra.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 7,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 62,
      "hash": "ej9Bj9Ae9BF0BG2Af1BJ8GJ8Heevvkufmlwiygpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2352,
          "apCost": 0,
          "name": "Defensive Turtle",
          "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1385,
              "apCost": 0,
              "name": "Freezing Aura",
              "shortDescription": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novafrost"
            },
            {
              "default": true,
              "id": 2796,
              "apCost": 0,
              "name": "Snowbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 762,
      "name": "Borderguard Elite",
      "description": "As a union between Juya's Frostwings and Kento's Penumbra clan, the Borderguard Elites move swiftly and strike with incredible force. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 75,
      "hash": "dj9Ej9Dg3AG2AG2Aj9Bj9Cj9Dxmpfmssxxowzgkg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1987,
          "apCost": 2,
          "name": "Hold the Line",
          "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 1986,
          "apCost": 0,
          "name": "Honor Guard",
          "shortDescription": "While Juya White-Eyes or Jakei Frost Queen is in play, this champion has <ability value=15>Multiattack 1</ability> and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "revere"
        },
        {
          "id": 343,
          "apCost": 1,
          "name": "Power Attack",
          "shortDescription": "This unit makes an attack with +4 DMG.",
          "activationType": 1,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hammer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": true,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 1216,
              "apCost": 0,
              "name": "Equalize",
              "shortDescription": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        }
      ]
    },
    {
      "id": 971,
      "name": "Bowmage",
      "description": "When L'ilim brought his archers to K'thiras, his goal was to form a new soldier; one the Nefari would never expect. The result was a combination of wizardry and archery, a soldier equally skilled in both disciplines. The Bowmages were L'ilim's finest.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Archer",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 82,
      "hash": "dj9Dj9CG2Bg3AG2Aj9Bj9Cj9Doluolemhvzvsfkg",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2339,
          "apCost": 4,
          "name": "Imbue: Stun",
          "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 9,
          "iconName": "amped"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        },
        {
          "id": 2291,
          "apCost": 4,
          "name": "Lightning Storm ",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "electricaoe"
        },
        {
          "id": 3263,
          "apCost": 1,
          "name": "Ranged Stance",
          "shortDescription": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "ranged_stance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 504,
      "name": "Brewmaster",
      "description": "The best brewer knows when to fight and when to drink. The answer is always. - Hulmir, Brewmaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 75,
      "hash": "dj9Cj9BG2Af1AG2Aj9Bj9Cj9Dllgtzieiygtquhg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2473,
          "apCost": 1,
          "name": "Carouse",
          "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "carouse"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 3364,
          "apCost": 0,
          "name": "Equip: Firebeard Brew",
          "shortDescription": "Unit is equipped with a Firebeard Brew (Equipped Champion is intoxicated. If the equipped champion is a dwarf it heals 3 hp per turn and gains burn rank 1. If not, it takes 3 fire damage per turn and is inhibited.)",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 773,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 2295,
              "apCost": 0,
              "name": "Thirst for Battle",
              "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "thirst_for_battle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 3103,
              "apCost": 0,
              "name": "Drunken Revel",
              "shortDescription": "When a friendly champion becomes <condition value=intoxicated>Intoxicated</condition>, this champion gains 1 AP and +2 DMG for 2 turns. This effect stacks up to 3 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "carouse"
            }
          ]
        }
      ]
    },
    {
      "id": 1002,
      "name": "Bridal Ravenwraith",
      "description": "Some marry for love and some for riches. Then there are some who marry so that they can rip the soul from their lover's body and consume it. Those are the ones you look out for.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Witch"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 78,
      "hash": "ej9Gj9FG2AE8De9Ae9Aj9Bj9Cemshgygnetmnhpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 711,
          "apCost": 0,
          "name": "Siphoning Aura",
          "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "possess"
        },
        {
          "id": 1783,
          "apCost": 0,
          "name": "Subsume",
          "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 98,
              "apCost": 0,
              "name": "Lifedrinker",
              "shortDescription": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3023,
              "apCost": 0,
              "name": "Surge: Cursed",
              "shortDescription": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_cursed"
            },
            {
              "default": true,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            }
          ]
        }
      ]
    },
    {
      "id": 1762,
      "name": "Brightmoon Lich",
      "description": "Not all undead fear the light. Foes of the Brightmoon learn to crave darkness, and are justly rewarded.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "ej9Bj9Ae9Af1BG2Af1Bj9Fj9Ggekexiyvhgeggrf",
      "artist": "Grant Griffin",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 896,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 2 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 187,
      "name": "Broken Bones",
      "description": "Considering he's made from remnants alone... I can't believe he's walking! - Xulos, Apprentice to Serkan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 4,
      "damage": 7,
      "hitPoints": 31,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 34,
      "hash": "dj9Dj9CG2Be9AG2Aj9Bj9Cj9Dlegekwxmwqqjlgg",
      "artist": "Nicole Cardiff",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1259,
              "apCost": 0,
              "name": "Split",
              "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "duplicate"
            }
          ]
        }
      ]
    },
    {
      "id": 1398,
      "name": "Broodguardians",
      "description": "\"Inform the Broodguards that we will need their services. The godslayers must be found!\" Socho, Advisor to Valdac\r\n",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar",
        "Tortun"
      ],
      "noraCost": 76,
      "hash": "ej9Ej9De9AF0Ae9Ag3Aj9Fj9Ggyolemykjnexvqf",
      "artist": "Alex Konstad",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2828,
          "apCost": 0,
          "name": "Broodcaller",
          "shortDescription": "When this champion is deployed, a level 3 Broodling is summoned at every friendly font deployment zone. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "broodcaller"
        },
        {
          "id": 1053,
          "apCost": 3,
          "name": "Lay Hatchling",
          "shortDescription": "Unit summons a dragon egg relic to target adjacent space. At the end of the next turn, the egg will hatch into a Draksar Broodling.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "sumdragonegg"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1130,
              "apCost": 0,
              "name": "Ally: Forglar Swamp",
              "shortDescription": "While there are other friendly Forglar Swamp champions in play, this champion gets +7 HP and +2 DMG. Forglar champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fs"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2112,
              "apCost": 1,
              "name": "Grant: Draconic Force",
              "shortDescription": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 705,
      "name": "Broodmother",
      "description": "With the Broodmothers beside me, my army is infinite. - K`lzik, Matron of Lower Sheoul",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1AG2Af1AJ8Jj9Aj9Bpuzvxvzmwxojleg",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        },
        {
          "id": 1858,
          "apCost": 3,
          "name": "Summon: Spiderling",
          "shortDescription": "Summon a Spiderling champion with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "sumspider"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1805,
              "apCost": 3,
              "name": "Weave Web",
              "shortDescription": "Area Effect 2, Range 3: Affected area is becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "web"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            },
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 658,
      "name": "Brubaker Brothers",
      "description": "Brutally brained or cut in twain? Just depends on which one gets you first. - From the Tale of the Brubaker Devils",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 70,
      "hash": "dJ8JJ8IF0Bf1Bf1Bj9Aj9Bj9Ceeeeerumhtxiieg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1905,
          "apCost": 0,
          "name": "Brubaker Bond",
          "shortDescription": "When a champion of the same name is within 5 spaces of this unit, this unit gets <ability value=1320>Assault</ability> and <ability value=396>Charge 3</ability>. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "brubaker_bond"
        },
        {
          "id": 1906,
          "apCost": 0,
          "name": "Brubaker Resistance",
          "shortDescription": "If this champion is the first Brubaker Brother it has <ability value=47>Resistance: Physical 2</ability>. If this champion is the second Brubaker Brother it has <ability value=52>Resistance: Magical 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "defenseenhance"
        },
        {
          "id": 1256,
          "apCost": 0,
          "name": "Sibling",
          "shortDescription": "When this champion is deployed, champions with the same name are revealed in your runedock. When you have a champion in play with the same name as this one, this champion gains +1 DEF, +1 SPD and +5 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "sibling"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 2473,
              "apCost": 1,
              "name": "Carouse",
              "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "carouse"
            },
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1085,
      "name": "Brutality Barbarian",
      "description": "\"He's gone, Zedin. He's lost himself to them, to the rage.\" - Darbur, Barbarian Chieftain",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 12,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 69,
      "hash": "ej9Ej9DE8DE8De9Ag3Aj9Ej9Fqzvfmplgietsjpf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 23,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +2 DMG and <ability value=2005>Careless</ability>",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "berserker"
        },
        {
          "id": 1760,
          "apCost": 0,
          "name": "Impatient",
          "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "impatient"
        },
        {
          "id": 2253,
          "apCost": 0,
          "name": "Manic",
          "shortDescription": "At the end of its turn, if this champion has a MIN RNG of 1, it moves 2 spaces toward the closest enemy champion, and makes an attack against that champion if possible.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "manic"
        },
        {
          "id": 2295,
          "apCost": 0,
          "name": "Thirst for Battle",
          "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "thirst_for_battle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1063,
              "apCost": 0,
              "name": "Kill Frenzy ",
              "shortDescription": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "furious_attacks"
            },
            {
              "default": true,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 2875,
              "apCost": 0,
              "name": "Warchief: Blood Clan",
              "shortDescription": "This unit is <ability value=3>Fearless</ability>. At the end of your turn, this unit gains 1 rank of <ability value=163>Rend</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_clan"
            }
          ]
        }
      ]
    },
    {
      "id": 324,
      "name": "Buckethead",
      "description": "This is a Moga with a bucket on its head.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 34,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 42,
      "hash": "dJ8JJ8IF0BF0AG2Bj9Cj9Dj9Eeeeeeevfvqhvqfg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 24,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "berserker"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 125,
              "apCost": 0,
              "name": "Damage Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaphysical"
            }
          ]
        }
      ]
    },
    {
      "id": 601,
      "name": "Bunny Lord",
      "description": "The servants of the Underdepths pay homage to the Bunny Lord. His influence reaches far into the depths, even into Lower Sheoul. The sheer size of his army is unfathomable.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 84,
      "hash": "dj9Bj9Af1Bf1BF0BJ8IJ8Jj9Afrqljlnnwonsfeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        },
        {
          "id": 1808,
          "apCost": 0,
          "name": "Swarm: Magma Bunny",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Magma Bunny champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "swarm_magma_bunny"
        },
        {
          "id": 89,
          "apCost": 0,
          "name": "Vulnerability: Frost",
          "shortDescription": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1160,
              "apCost": 0,
              "name": "Boost",
              "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": false,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1329,
              "apCost": 0,
              "name": "Domain: Lava",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_lava"
            },
            {
              "default": true,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            }
          ]
        }
      ]
    },
    {
      "id": 1225,
      "name": "Cackling Witch",
      "description": "The cries of the Cackling Witch elicit visions of madness and horror that linger for weeks.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 67,
      "hash": "ej9Gj9FF0Be9Be9Ae9AJ8IJ8Jowzignnsmhyxvo",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1147,
          "apCost": 3,
          "name": "Sonic Roar",
          "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 245,
              "apCost": 0,
              "name": "Damage Shield: Sonic",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Sonic damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_sonic"
            },
            {
              "default": true,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            },
            {
              "default": false,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 2688,
              "apCost": 4,
              "name": "Screech",
              "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            }
          ]
        }
      ]
    },
    {
      "id": 451,
      "name": "Calcified Lurker",
      "description": "Infused by Nora, the Calcified Lurkers wander around underground in search of precious stones.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 68,
      "hash": "dj9Fj9EE8Df1Af1AJ8Jj9Aj9Bygyknytfxfiwzzg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1199,
          "apCost": 0,
          "name": "Calcify",
          "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novaphysical"
        },
        {
          "id": 2582,
          "apCost": 0,
          "name": "Impairing Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1778,
      "name": "Calm as Raging Tides",
      "description": "What has been too-long called fragility is but versatility well-disguised.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 69,
      "hash": "ej9Gj9Fe9BG2AG2Ae9AJ8GJ8Hqjerzmjtohvfmpf",
      "artist": "Grant Griffin",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2940,
          "apCost": 0,
          "name": "Alluring Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=charmed>Charmed</condition> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_alluring"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 2091,
              "apCost": 0,
              "name": "Dragging Attack",
              "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 754,
      "name": "Captive Lorekeeper",
      "description": "I know nothing about the Eternal Circle or any plot to seal the Mouth in Forglar. I know nothing! I am just a librarian! Release me from this infernal place! - Geril of the Eternal Circle ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 35,
      "hash": "dj9Dj9CG2BG2Ag3Aj9Dj9Ej9Folevosmwtzkyvmh",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 899,
          "apCost": 0,
          "name": "Demon Elf Bound",
          "shortDescription": "At the beginning of your enemy's turns, if there are no other friendly Demon Elves in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "possess"
        },
        {
          "id": 1866,
          "apCost": 0,
          "name": "Gift of Scrying",
          "shortDescription": "You have an additional rune reveal each of your turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "scry"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 1750,
          "apCost": 1,
          "name": "Grant: Tempo",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 399,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 2: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "forcebarrier"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 1718,
      "name": "Carrier Squire",
      "description": "Those not cut out for combat are relegated to less heroic duties.  However, in recent times even such duties have become increasingly dangerous.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 61,
      "hash": "ej9Dj9Cf1Bf1AG2AG2Bj9Aj9Bvvfxqsqufrhtosf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 3393,
          "apCost": 0,
          "name": "Ironfist Armaments",
          "shortDescription": "When a friendly champion with Race: Angel, Race: Barbarian, Race: Dwarf, or Race: Construct becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 1505,
          "apCost": 1,
          "name": "Throw Shield",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "throw_shield"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1998,
              "apCost": 2,
              "name": "Grant: Action Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 12,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 468,
      "name": "Carrion Colossus",
      "description": "This once majestic titan has been fouled by disease. Its body is host to hundreds of small carrionlings.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 14,
      "hitPoints": 65,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Worm",
        "Zombie"
      ],
      "noraCost": 105,
      "hash": "dJ8HJ8Ge9Bf1AE8Dj9Ej9Fj9Gemsxtzrwzgnwkyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1207,
          "apCost": 0,
          "name": "Death Spawn: Carrionling",
          "shortDescription": "When this champion is destroyed, a Death Carrionling champion with no upgrades is summoned in each space it occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "deathspawn_carrionling"
        },
        {
          "id": 1146,
          "apCost": 1,
          "name": "Disease Breath",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "diseaseaoe"
        },
        {
          "id": 1247,
          "apCost": 0,
          "name": "Propagate: Carrionling",
          "shortDescription": "When this unit takes 5 or more damage, a Death Carrionling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "propagate_carrionling"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1265,
              "apCost": 0,
              "name": "Swarm: Carrionling",
              "shortDescription": "When this champion destroys a champion on a basic attack, a Carrionling champion is with no upgrades is summoned under your control in the location the destroyed champion occupied.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "swarm_carrionling"
            },
            {
              "default": false,
              "id": 2553,
              "apCost": 0,
              "name": "Worm Lord",
              "shortDescription": "This champion has <ability value=2526>Necrosis</ability>.  When a real enemy champion is destroyed by a champion with Race: Worm or Necrosis within 5 spaces, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "creep_master"
            },
            {
              "default": false,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2965,
              "apCost": 0,
              "name": "Surge: Worm",
              "shortDescription": "This unit has +1 DMG for each friendly Worm.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_carrionling"
            },
            {
              "default": false,
              "id": 1846,
              "apCost": 0,
              "name": "Foul Strike",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, all opposing champions within 3 spaces of the target are <condition value=diseased>Diseased</condition> and <condition value=inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "diseaseaoe"
            },
            {
              "default": false,
              "id": 1006,
              "apCost": 0,
              "name": "Surge: Enemy",
              "shortDescription": "This unit has +1 DMG for each deployed enemy champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "surge_enemy"
            }
          ]
        }
      ]
    },
    {
      "id": 1016,
      "name": "Carrionling",
      "description": "The carrionlings sustain their host with the corpses unfit to join Serkan in battle.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 2,
      "hitPoints": 5,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "None"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 41,
      "hash": "dJ8HJ8Ge9Bf1Ae9Aj9Fj9Gj9Hyoqlnjytjnwitzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 156,
          "apCost": 0,
          "name": "Disease Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novadisease"
        },
        {
          "id": 1211,
          "apCost": 0,
          "name": "Disease Eater",
          "shortDescription": "When this champion would take Disease damage, it instead heals HP equal to half the damage that would have been dealt. This unit cannot be <condition value=diseased>Diseased</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_disease"
        },
        {
          "id": 2965,
          "apCost": 0,
          "name": "Surge: Worm",
          "shortDescription": "This unit has +1 DMG for each friendly Worm.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge_carrionling"
        },
        {
          "id": 1265,
          "apCost": 0,
          "name": "Swarm: Carrionling",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Carrionling champion is with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "swarm_carrionling"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 42,
              "apCost": 0,
              "name": "Immunity: Acid",
              "shortDescription": "Acid damage that would be dealt to this unit is prevented. This unit may not become <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 328,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes a 5 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 2 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 469,
      "name": "Carrionling",
      "description": "\"Damn it I hate worms almost as much as I hate bugs!\" - Slugbait, Boghopper Mentor",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 2,
      "hitPoints": 5,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "None"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 41,
      "hash": "dJ8HJ8Ge9Bf1Ae9Aj9Fj9Gj9Hyoqlnjytjnwitzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 156,
          "apCost": 0,
          "name": "Disease Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novadisease"
        },
        {
          "id": 1211,
          "apCost": 0,
          "name": "Disease Eater",
          "shortDescription": "When this champion would take Disease damage, it instead heals HP equal to half the damage that would have been dealt. This unit cannot be <condition value=diseased>Diseased</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_disease"
        },
        {
          "id": 2965,
          "apCost": 0,
          "name": "Surge: Worm",
          "shortDescription": "This unit has +1 DMG for each friendly Worm.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge_carrionling"
        },
        {
          "id": 1265,
          "apCost": 0,
          "name": "Swarm: Carrionling",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Carrionling champion is with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "swarm_carrionling"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 42,
              "apCost": 0,
              "name": "Immunity: Acid",
              "shortDescription": "Acid damage that would be dealt to this unit is prevented. This unit may not become <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 328,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes a 5 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 2 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1642,
      "name": "Caustic Slag",
      "description": "\"Caustic Slags can't replicate themselves entirely like others of their species. They can, however, duplicate their internal organs, which they jetison as a defensive mechanism.\" -- Notes of Tug and Pixy, explorers",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8HF0AF0BG2AF0AJ8HJ8Ieitjnyruofekuo",
      "artist": "Danh Nguyen",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        }
      ]
    },
    {
      "id": 164,
      "name": "Cave Dragon",
      "description": "Shhh... I don't think it can see us. - Boghopper Scout",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 71,
      "hash": "dj9Bj9Af1Be9AF0AJ8HJ8IJ8Jeerztukeevosuxf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 221,
          "apCost": 0,
          "name": "Damage Shield: Physical",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dmgshld_physical"
        },
        {
          "id": 751,
          "apCost": 3,
          "name": "Spike Nova",
          "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novaspike"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": true,
              "id": 2334,
              "apCost": 2,
              "name": "Petrifying Gaze",
              "shortDescription": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "petrifying_gaze"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 385,
      "name": "Cavernkeeper",
      "description": "These Moga care for the Voil in the cave, and in return are considered sacred to the wretched Voil",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 6,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 47,
      "hash": "dJ8JJ8IF0BF0BG2Aj9Bj9Cj9Deeeepnjllnhgkeg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1061,
          "apCost": 0,
          "name": "Immunity: Voil ",
          "shortDescription": "Damage dealt to this champion by Voil is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_sonic"
        },
        {
          "id": 1349,
          "apCost": 2,
          "name": "Relieve",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and all effects removed are applied to this unit.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "cleanse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            },
            {
              "default": false,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": true,
              "id": 370,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 3 HP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 387,
      "name": "Cavernspawn",
      "description": "Creatures with the power of the demon and the frenzied beast have spawned in caverns deeper than can be known.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 72,
      "hash": "dj9Gj9Fe9AF0BG2Aj9Bj9Cj9Djwvfiwoqztzohgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks",
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 164,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_rend"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 98,
              "apCost": 0,
              "name": "Lifedrinker",
              "shortDescription": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2833,
              "apCost": 2,
              "name": "Teleport: Blood Ball",
              "shortDescription": "This champion relocates to a Blood Ball within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 473,
      "name": "Cecaelia",
      "description": "Cecaelia, the Muse of Forglar, has awoken from her sleep to defend the swamp from its enemies.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 69,
      "hash": "dJ8IJ8HF0Af1AF0AJ8HJ8IJ8Jeeggnjpfxqqhnwf",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 1081,
          "apCost": 0,
          "name": "Enlightened",
          "shortDescription": "When this champion is healed, the amount is increased by 6.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blessed"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 415,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "charm"
            },
            {
              "default": true,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": false,
              "id": 1224,
              "apCost": 0,
              "name": "Bastion of Will",
              "shortDescription": "Friendly champions have <ability value=4>Iron Will</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "iron_will"
            }
          ]
        }
      ]
    },
    {
      "id": 16,
      "name": "Centaur Archer",
      "description": "Godwin's call to battle was answered first by the centaur for whom war became the newest and greatest of sports.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer",
        "Warrior"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 69,
      "hash": "bj9Bj9AJ8Jf1AJ8Jj9Aj9Bj9Cevfvmnhgnetumpl",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1437,
          "apCost": 0,
          "name": "Camaraderie ",
          "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": true,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 1806,
      "name": "Centaur Bolter",
      "description": "After the Draksar drew back their line, the Centaur, after many long years, got a chance to flex their muscles.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9DG2BG2AG2Ag3Aj9Cj9Dmsofpshvmhgrouf",
      "artist": "Markus Erdt",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 1509,
              "apCost": 0,
              "name": "Blitz",
              "shortDescription": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1807,
      "name": "Centaur Commander",
      "description": "\"Menalaus, leave the east to us. You mean well, but this terrain is not yours.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9Dg3AG2AG2Ag3Aj9Dj9Eeeemjrhkgnwkuvf",
      "artist": "Caio Monteiro",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 1344,
          "apCost": 0,
          "name": "Provision: Defense",
          "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "plunder"
        },
        {
          "id": 3294,
          "apCost": 0,
          "name": "Warlord",
          "shortDescription": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "warlord"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": false,
              "id": 3391,
              "apCost": 0,
              "name": "Verdant Armaments",
              "shortDescription": "When a friendly champion with Race: Elf, Race: Fairy or Race: Centaur becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": true,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            }
          ]
        }
      ]
    },
    {
      "id": 173,
      "name": "Centaur Interceptor",
      "description": "They have raided our homelands, and burned our pastures!  They will die for this! -Alla, Centaur Charger before the Battle of the Burning Fields",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 69,
      "hash": "dj9Cj9BG2Ae9AF0AJ8HJ8IJ8Jepnhkyvzzgtzgyg",
      "artist": "Gabriel Garza",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1505,
              "apCost": 1,
              "name": "Throw Shield",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "throw_shield"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 617,
      "name": "Centaur Regulator",
      "description": "The centaurs watch over our forest. They have always been our first line of defense and should be shown more respect. - Menalaus, Priest of K`thir",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight",
        "Priest"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 72,
      "hash": "dj9Dj9CG2Bf1Be9Aj9Fj9Gj9Hqjwzvfxiluqjnjg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 12,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "detection"
        },
        {
          "id": 371,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "healmass"
        },
        {
          "id": 410,
          "apCost": 1,
          "name": "Stun",
          "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "stun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        }
      ]
    },
    {
      "id": 1946,
      "name": "Centaur Regulator",
      "description": "The centaurs watch over our forest. They have always been our first line of defense and should be shown more respect. - Menalaus, Priest of K`thir",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Priest"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9FF0Ae9AG2Be9AJ8HJ8Iqsfirlrfgvkjgpf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broodcall",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 12,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "detection"
        },
        {
          "id": 371,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "healmass"
        },
        {
          "id": 410,
          "apCost": 1,
          "name": "Stun",
          "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "stun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        }
      ]
    },
    {
      "id": 1046,
      "name": "Centaur Savage",
      "description": "\"They're nasty, crude, barbaric, and they smell like 4 day old meat, but when the horns of war sound they're the first to the front lines. And they don't miss, they never miss.\" - Godwin to L'ilim  ",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Archer"
      ],
      "races": [
        "Barbarian",
        "Centaur"
      ],
      "noraCost": 82,
      "hash": "ej9AJ8Je9BE8De9Af1AJ8GJ8Hinssjwiljgvxfm",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold",
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1818,
          "apCost": 0,
          "name": "Defensive Strike",
          "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 2126,
          "apCost": 0,
          "name": "Pin Down",
          "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "pindown"
        },
        {
          "id": 3375,
          "apCost": 0,
          "name": "Zealot",
          "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 101,
              "apCost": 1,
              "name": "Barrage",
              "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 1089,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "arrowaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 619,
      "name": "Centaur Skirmisher",
      "description": "Unlike other Centaurs, the skirmishers have a vehemence in combat that is both admired and feared.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Centaur"
      ],
      "noraCost": 73,
      "hash": "dj9Dj9CG2Bf1BF0AJ8HJ8IJ8Jeeiyzohrouonleg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 2769,
          "apCost": 0,
          "name": "Running Strike",
          "shortDescription": "For every 2 spaces this champion moves in a single turn, it gains +1 DMG and +1 RNG for 1 turn.  This stacks up to 4 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "running_strike"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3136,
              "apCost": 0,
              "name": "Empowered: Offense",
              "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_offense"
            }
          ]
        }
      ]
    },
    {
      "id": 1256,
      "name": "Cerulean Wing",
      "description": "Specialized training of the griffin from a young age is required to achieve the additional dexterity its role requires. In peace time, these methods are often the target of protests among civilians for being \"cruel.\"",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Jf1Be9Be9Af1Aj9Aj9Bjwvmephvxzmlyo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 2715,
          "apCost": 0,
          "name": "Cerulean Sigil",
          "shortDescription": "This champion gains <ability value=1947>Entangling Attack</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "griffin_sigil"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        },
        {
          "id": 163,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rend"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 2076,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 20% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 1211,
      "name": "Chained Fae",
      "description": "Providing they survive, the memories of being Chained remain vivid for decades to the Fae that volunteer for the task.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 5,
      "hitPoints": 25,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 32,
      "hash": "ej9Fj9EE8De9Be9AE8Dj9Ej9Fukrllphytqwtuo",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2589,
          "apCost": 0,
          "name": "Chains of Amareth",
          "shortDescription": "When a friendly Fairy, Wizard or Elemental is deployed from the rune dock, it gains 5 MAX HP, this champion loses 5 MAX HP and you gain 5 nora. This ability does not stack",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "chains_of_amareth"
        },
        {
          "id": 1530,
          "apCost": 1,
          "name": "Magic Turret",
          "shortDescription": "This unit makes a Magic attack at RNG 2-7.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "magic"
        },
        {
          "id": 820,
          "apCost": 4,
          "name": "Portal",
          "shortDescription": "This unit may teleport to any deployment zone its controller controls.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "relocate"
        },
        {
          "id": 2118,
          "apCost": 0,
          "name": "Preordained",
          "shortDescription": "This rune is automatically revealed at the beginning of the game.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "scry"
        },
        {
          "id": 2233,
          "apCost": 0,
          "name": "Stationary",
          "shortDescription": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2556,
              "apCost": 0,
              "name": "Vitality: Nora",
              "shortDescription": "The first time each turn that nora is generated via spells, relics and abilities, this champion gains +2 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            }
          ]
        }
      ]
    },
    {
      "id": 966,
      "name": "Chaos Brave",
      "description": "The Chaos Braves follow their own interpretation of the Old Empire's original tenets. The prime tenet is to preserve the Empire at all costs. The Braves take this to mean Cyclops only; all others are expendable.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 85,
      "hash": "dj9Dj9CG2Bg3AF0AJ8HJ8IJ8Jeeerluosfiyxxfg",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2333,
          "apCost": 1,
          "name": "Chuck: Moga",
          "shortDescription": "This champion makes a ranged Physical attack at RNG 2-5. A summoned Moga Axeman with no upgrades is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "summoga"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1290,
          "apCost": 0,
          "name": "Warmonger",
          "shortDescription": "When a friendly real champion is destroyed, this champion gains -1 DEF and +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 2704,
              "apCost": 0,
              "name": "Crushing Blow",
              "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 1005,
      "name": "Charger Knight",
      "description": "\"Id dat dunder?\" - Dudd, Cyclops Hauler",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Barbarian",
        "Beast"
      ],
      "noraCost": 82,
      "hash": "eJ8HJ8Gf1AE8De9Ae9BJ8Jj9Aeeiyojpjekrwfm",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1142,
          "apCost": 0,
          "name": "Hunter: Hero",
          "shortDescription": "When this unit would deal damage with any attack to a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater that damage is increased by 2. When this unit would receive damage from any attack by a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "hunter_hero"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2773,
              "apCost": 0,
              "name": "Quest: Runner",
              "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1752,
              "apCost": 0,
              "name": "Heavy Charger",
              "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1509,
              "apCost": 0,
              "name": "Blitz",
              "shortDescription": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2427,
              "apCost": 0,
              "name": "Break the Line",
              "shortDescription": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1826,
      "name": "Chattering Maw",
      "description": "In the Fetid Marsh, Maws click, chatter, and buzz like the harmless insects of other lands. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 48,
      "hash": "eJ8HJ8Gg3AG2BG2Ae9Bj9Dj9Eeevkgnpsuhpufrf",
      "artist": "Danh Nguyen",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 594,
          "apCost": 0,
          "name": "Energy Thief",
          "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        },
        {
          "id": 876,
          "apCost": 0,
          "name": "Short Lived",
          "shortDescription": "This unit is destroyed after 8 turns.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": -15,
          "iconName": "ondeath"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1807,
              "apCost": 0,
              "name": "Deafening Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "deafening_aura"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 148,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 1780,
      "name": "Chilling Scale",
      "description": "\"From violence, to patience; from homogeneity, to diversity. The Snaptooth's natural zeal is admirable, and so their ability to change is all the more stunning.\" -- Jakei Grandmaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9FF0BG2AG2Ae9AJ8IJ8Jmegevkyrqjnlwqf",
      "artist": "Markus Erdt",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 3262,
          "apCost": 0,
          "name": "Frost Stance",
          "shortDescription": "Until this ability is activated again, this champion has -1 SPD and gains <ability value=2819>Catalyst: Frost</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "frost_stance"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2939,
              "apCost": 0,
              "name": "Chilling Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_chilling"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 2517,
              "apCost": 0,
              "name": "Murkwater Frenzy",
              "shortDescription": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "murkwater_frenzy"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 1743,
              "apCost": 1,
              "name": "Frigid Lance",
              "shortDescription": "This champion makes a Frost attack at RNG 2-5.  If the target is occupying Ice, Snow or is <condition value=frozen>Frozen</condition> and is successfully damaged, the target also becomes <condition value=chilled>Chilled</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ice"
            }
          ]
        }
      ]
    },
    {
      "id": 1623,
      "name": "Chipped Boulder",
      "description": "The Jakei expected to have nothing in common with the Boghoppers, but weather wears down artifice in the swamp just as well as in the tundra.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 14,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9EG2AF0BG2AE8Dj9Bj9Ceevxzgnyzzvoyrf",
      "artist": "Markus Erdt",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 1463,
          "apCost": 0,
          "name": "Iceguard",
          "shortDescription": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "iceguard"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 3194,
          "apCost": 0,
          "name": "Ponderous Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "lumbering"
        },
        {
          "id": 2651,
          "apCost": 2,
          "name": "Silent Contemplation",
          "shortDescription": "Until this champion moves, it has +4 MAX RNG, <ability value=680>Planar Bound</ability>, and <ability value=2271>Sentinel</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2679,
              "apCost": 4,
              "name": "Water Vortex",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": true,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1634,
      "name": "Chirai Anchorite",
      "description": "Those Leoss who are swiftest in their youth may best understand patience in their old age.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk",
        "Ranger"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 66,
      "hash": "eJ8HJ8Ge9BF0BG2Ae9BJ8GJ8Heeegkrlemshvmn",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 867,
          "apCost": 0,
          "name": "Blessed",
          "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 524,
          "apCost": 1,
          "name": "Hinder Movement",
          "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pindown"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            },
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2082,
              "apCost": 0,
              "name": "Jungle Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Jungle (Impeding Vegetation) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ferociousgrowth"
            }
          ]
        }
      ]
    },
    {
      "id": 787,
      "name": "Chirai Outrunner",
      "description": "The Chirai are referred to as the nimble cousin of the Leoss. In Ailur, Chirai often take the role of Outrunner; agile scouts, capable of patrolling large areas of land with ease.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk",
        "Ranger"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 75,
      "hash": "dj9Gj9Fe9AG2BF0BJ8IJ8Jj9Anuxfxfxiinemneg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 2773,
          "apCost": 0,
          "name": "Quest: Runner",
          "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 3058,
              "apCost": 1,
              "name": "Chuck: Wood",
              "shortDescription": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
              "activationType": 3,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "chuck_wood"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            }
          ]
        }
      ]
    },
    {
      "id": 1526,
      "name": "Chosen of Osarius",
      "description": "Sealed with the Hydra's bite, the Chosen are sworn guards of Grimlic.  They serve him with both their mortal and eternal souls.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9Ce9AF0Be9AG2Bj9Fj9Gerumlyohkpjytqf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3266,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "combat_awareness"
        },
        {
          "id": 3040,
          "apCost": 0,
          "name": "Mark of Osarius",
          "shortDescription": "After this champion has dealt 40 damage, a Head of Osarius relic is summoned to the closest available space to this champion and this ability is removed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "fate_osarius"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 132,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            }
          ]
        }
      ]
    },
    {
      "id": 970,
      "name": "Chronomancer",
      "description": "Chronomancers have full control over the flow of time. They can stretch a minute into several years, shrink an eon into a second, and even travel between periods of time with little effort. Only the wisest of K'ento's disciples are trained in Chronomancy.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "dj9Dj9CG2Bg3AG2Bj9Cj9Dj9Eeeemwvftxtxqsmh",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2318,
          "apCost": 0,
          "name": "Deploy Charged",
          "shortDescription": "When a champion is deployed from the runedock, this unit gains 2 charges.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 2340,
          "apCost": 3,
          "name": "Haste",
          "shortDescription": "Target champion within 5 spaces has +4 SPD for 3 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 2342,
          "apCost": 0,
          "name": "Spell Shift",
          "shortDescription": "Spend 8 charges.  All cooldowns on your spells are reduced by 5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 8,
          "iconName": "special"
        },
        {
          "id": 2341,
          "apCost": 3,
          "name": "Stall",
          "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "debuff"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 1172,
      "name": "Cinderpede",
      "description": "The earthen fire flowing through the Underdepths is at once beautiful and dangerous, and home to various horrors.\r\nThe Cinderpede is one such creature.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 80,
      "hash": "ej9Cj9Bf1Ae9Ae9AG2AJ8Jj9Aeevxoluxiwfiepf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 2400,
          "apCost": 4,
          "name": "Flamethrower",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "fireaoe"
        },
        {
          "id": 2552,
          "apCost": 0,
          "name": "Lava Born",
          "shortDescription": "When this champion is not occupying lava, its RNG becomes 1-1 and it gains <ability value=1209>Defiant</ability> and +2 DEF.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "domain_lava"
        },
        {
          "id": 1118,
          "apCost": 2,
          "name": "Lava-Fall",
          "shortDescription": "Spaces within 2 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        },
        {
          "id": 480,
          "apCost": 0,
          "name": "Lavawalker",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1447,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deathnovalava"
            },
            {
              "default": true,
              "id": 1329,
              "apCost": 0,
              "name": "Domain: Lava",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_lava"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1852,
              "apCost": 4,
              "name": "Tunnel: Lava",
              "shortDescription": "This unit is relocated to target Lava space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_lava"
            },
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            }
          ]
        }
      ]
    },
    {
      "id": 1279,
      "name": "Circadian Arcanist",
      "description": "Circadian Arcanists' training allows them to harness and utilize magical power expressed in their presence.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 71,
      "hash": "ej9Cj9Bg3Ae9Be9AG2Aj9Dj9Eeemnheetxtufxqf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2682,
          "apCost": 0,
          "name": "Adept Arcanist",
          "shortDescription": "When a unit within 8 spaces, including this one, takes damage, this champion permanently gains a basic attack of that damage type.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 2681,
          "apCost": 0,
          "name": "Mirefolk Transcendence",
          "shortDescription": "When this champion is deployed, friendly champions gain <ability value=544>Attack: Magical</ability> for 3 turns. If the affected champion is a Mirefolk, opposing champions within 3 spaces of it take 3 Magical damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mirefolk_revival"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            },
            {
              "default": true,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            }
          ]
        }
      ]
    },
    {
      "id": 1390,
      "name": "Circadian Chronologist",
      "description": "\"What the Darkmarsh don't seem to understand is that this is an unprecedented event.  Never in recorded history have so many leaders gone missing at once.  To blame us seems more politically motivated than anything.\" ~ Circadian Chronologist\r\n",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 78,
      "hash": "ej9Dj9CF0AF0Ae9AG2BJ8HJ8Iuqohievsqwohepf",
      "artist": "Anthony Lopes",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1750,
          "apCost": 1,
          "name": "Grant: Tempo",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 1462,
          "apCost": 2,
          "name": "Hydrate",
          "shortDescription": "Friendly champions within 2 spaces gain 2 AP and the spaces they are standing in turn to Water for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "terrainwater"
        },
        {
          "id": 841,
          "apCost": 3,
          "name": "Nora Shield",
          "shortDescription": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "nora_barrier"
        },
        {
          "id": 2822,
          "apCost": 0,
          "name": "Ripples",
          "shortDescription": "When a friendly champion is deployed from the rune dock, this champion's cooldowns are reduced by 1.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 3062,
          "apCost": 3,
          "name": "Shatter Summoned",
          "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            },
            {
              "default": false,
              "id": 2623,
              "apCost": 0,
              "name": "Anthomancy",
              "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "scry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            },
            {
              "default": false,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            }
          ]
        }
      ]
    },
    {
      "id": 1213,
      "name": "Circadian Enchantress",
      "description": "\"You call it meddling, we call it intervention.  The tides have told us that to leave you to your own devices would lead to all our destruction, and that we shall not abide.\" ~ Vira, Circadian Enchantress",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 69,
      "hash": "ej9Fj9Ee9Be9Be9AE8DJ8GJ8Hgtztmlytxfrukn",
      "artist": "Michele Chang",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2592,
          "apCost": 0,
          "name": "Mirefolk Revival",
          "shortDescription": "When this unit is deployed, friendly champions are healed for 6 HP.   If the affected champion is a Mirefolk, it also gains <ability value=1052>Purified</ability> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 1776,
          "apCost": 0,
          "name": "Premonition",
          "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 1714,
      "name": "Circadian Forcemage",
      "description": "The Forcemages can create kinetic barriers at distances far beyond other wizards.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9Ce9Af1AG2AG2Bj9Fj9Glexoymssxiipnsf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3219,
          "apCost": 0,
          "name": "Force Projection",
          "shortDescription": "When this champion makes a basic attack, the farthest adjacent accessible space from this champion to the target becomes Inaccessible for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "forcebarrier"
        },
        {
          "id": 623,
          "apCost": 0,
          "name": "Knockback",
          "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2679,
              "apCost": 4,
              "name": "Water Vortex",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2100,
              "apCost": 3,
              "name": "Gale",
              "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 400,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "forcebarrier"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            }
          ]
        }
      ]
    },
    {
      "id": 1621,
      "name": "Circadian Merchant",
      "description": "A traveling merchant of Circadian descent draws additional customers simply because Circadians are so rarely seen outside of the Swamp.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 63,
      "hash": "ej9Fj9Ef1AF0BG2AE8DJ8Jj9Aeeipjnyrzrfkpqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3146,
          "apCost": 0,
          "name": "Aquatic Armaments",
          "shortDescription": "When a friendly champion with Aquatic, Semi-Aquatic, Race: Salaman, or Race: Boghopper becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        },
        {
          "id": 1510,
          "apCost": 0,
          "name": "Market",
          "shortDescription": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "cost"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1455,
              "apCost": 0,
              "name": "Expedite",
              "shortDescription": "When this unit successfully attacks, you gain a rune reveal.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1426,
      "name": "Circadian Songmaster",
      "description": "Songmasters are beloved in the Swamp.  The Circadians are not afraid to use their fame to their advantage.\r\n",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Bard"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 76,
      "hash": "ej9Fj9Ef1BF0Be9AE8Dj9Aj9Bevsqoufmyolphpf",
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1750,
          "apCost": 1,
          "name": "Grant: Tempo",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 2593,
          "apCost": 0,
          "name": "Mirefolk Resurgence",
          "shortDescription": "When this unit is deployed, friendly champions gain 1 AP. If the affected champion is a Mirefolk, it also gains +2 DMG for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 2115,
          "apCost": 3,
          "name": "Soothing Serenade",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 400,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "forcebarrier"
            },
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            },
            {
              "default": true,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            }
          ]
        }
      ]
    },
    {
      "id": 1215,
      "name": "Circadian Templar",
      "description": "The Circadians have long set themselves apart from the rest of the Swamp, preferring to stay within the confines of the Emerald Lake.  So their recent insistence at being included has been viewed with great suspicion by others who call Forglar home.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 71,
      "hash": "ej9Fj9EF0Be9Be9AE8DJ8IJ8Jusszzkneeekgro",
      "artist": "Paul Guzenko",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2593,
          "apCost": 0,
          "name": "Mirefolk Resurgence",
          "shortDescription": "When this unit is deployed, friendly champions gain 1 AP. If the affected champion is a Mirefolk, it also gains +2 DMG for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2063,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "rebuke"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 355,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +3 DEF for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 723,
      "name": "Circle Messenger",
      "description": "As conflict escalated in K`thir, the Eternal Circle would lose messengers to Nefari ambushes. The messages began to arrive much more often once they began riding avia instead of horses.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Beast",
        "Elf"
      ],
      "noraCost": 66,
      "hash": "dj9AJ8Jf1AG2AG2Bj9Cj9Dj9Eeeeitjetoqwfvhg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1948,
          "apCost": 0,
          "name": "Channel: Speed",
          "shortDescription": "This champion has +1 SPD for 3 turns and <ability value=655>Skirmisher</ability> for 3 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "channel_speed"
        },
        {
          "id": 657,
          "apCost": 2,
          "name": "Relocate: Ally",
          "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        }
      ]
    },
    {
      "id": 1323,
      "name": "Civilized Wilderkin",
      "description": "The Wilderkin tribe elves that joined Bliss' elite corps were sometimes called 'civilized'.  At first, it was used as an insult by jealous peers, but after demonstrating their skill in battle, as a badge of honor.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 69,
      "hash": "eJ8HJ8GF0AF0Ae9Ae9BJ8HJ8Iemsfeetziyohem",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1509,
          "apCost": 0,
          "name": "Blitz",
          "shortDescription": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 217,
          "apCost": 0,
          "name": "Dodge",
          "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2928,
              "apCost": 0,
              "name": "Arrow Throw",
              "shortDescription": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +3 DMG.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 449,
      "name": "Clay Form ",
      "description": "That isn't Luga. A Voil impaled him through the heart. I don't know what that is. - Kubin, Boghopper Bull ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 75,
      "hash": "dj9Fj9EE8Df1AF0BJ8IJ8Jj9Aoqjwmwilepnlpyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1266,
          "apCost": 3,
          "name": "Take Form",
          "shortDescription": "This unit loses all abilities and conditions and becomes a cleansed copy with full HP of a target non-hero, non-planarbound champion of the same size within 10 spaces. Target champion can not have a nora cost of 80 or more. Equipment on the target champion is not copied.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 50,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3285,
              "apCost": 0,
              "name": "Sabotage: Lethargy",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DMG and <ability value=2012>Lethargic</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "sabotage_lethargy"
            },
            {
              "default": true,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 951,
              "apCost": 0,
              "name": "Trail: Mud",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, spaces this unit occupies become Mud (Impeding 1, Water) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_mud"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 17,
      "name": "Cleric of Unrest",
      "description": "Don't be fooled by the smile... - Vlandil, Dwarven Defender",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 5,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 63,
      "hash": "cj9Hj9Gj9Fe9AG2Bj9Fj9Gj9Hiwqossmyxkytuqj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1399,
          "apCost": 1,
          "name": "Hex",
          "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "lossoflife"
        },
        {
          "id": 579,
          "apCost": 2,
          "name": "Invigorate",
          "shortDescription": "Target champion within 2 spaces gains 4 AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1785,
              "apCost": 3,
              "name": "Rite of Healing",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "fascinate"
            },
            {
              "default": false,
              "id": 2958,
              "apCost": 3,
              "name": "Ritual of Power",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "deconstruct"
            },
            {
              "default": false,
              "id": 1787,
              "apCost": 3,
              "name": "Rite of Power",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed and friendly champions gain +1 DMG permanently and gain +1 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "final_judgement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1774,
              "apCost": 0,
              "name": "Phylactery Bound",
              "shortDescription": "When this unit is deployed from the runedock, a Phylactery relic is summoned in the closest friendly deployment zone.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 15,
              "iconName": "phylactery"
            },
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 729,
      "name": "Clockwork Swarm",
      "description": "\"Only difficult part was the smelting the elemental stone in burning slagblood, which burns so hot and fast and you just need so much of it. After that,the metal grows on its own, so its not that different from making a grobble.\" - Farlin Stoneskull",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 61,
      "hash": "dj9Bj9Af1BG2AF0BJ8IJ8Jj9Agvvsollnpfgnjeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2577,
          "apCost": 0,
          "name": "Complex Machine",
          "shortDescription": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "complex_machine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 2097,
              "apCost": 0,
              "name": "Combo Attack: Rend",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_rend"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3312,
              "apCost": 0,
              "name": "Swarm: Clockwork Swarm",
              "shortDescription": "When this champion destroys a champion on a basic attack, a Clockwork Swarm with no upgrades is summoned under your control in the location the destroyed champion occupied.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 18,
              "iconName": "swarm_kanen"
            },
            {
              "default": true,
              "id": 1259,
              "apCost": 0,
              "name": "Split",
              "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "duplicate"
            }
          ]
        }
      ]
    },
    {
      "id": 355,
      "name": "Cobra Spitter",
      "description": "Many smaller creatures were also effected by the same changes that created the Skeezick. Seeking refuge in the Sundered Lands, the large snakes would prove useful and loyal allies.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dj9Dj9CG2BF0AE8Dj9Ej9Fj9Gerhigrljpsqojgg",
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest",
        "Sundered Lands"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            },
            {
              "default": true,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2497,
              "apCost": 0,
              "name": "Amplify: Acid",
              "shortDescription": "Acid damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_acid"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            }
          ]
        }
      ]
    },
    {
      "id": 498,
      "name": "Collection of Souls",
      "description": "Lost souls often gather together for comfort. When the gathering is large, they begin to share thoughts.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "dj9Bj9Af1Bf1Ag3Aj9Dj9Ej9Fukwfkgrhnlwtmjg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2172,
          "apCost": 0,
          "name": "Death Charged",
          "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "charged_death"
        },
        {
          "id": 2184,
          "apCost": 0,
          "name": "Eradicate",
          "shortDescription": "Spend all charges. Target champion within 5 spaces loses 2 HP for each charge spent this way (up to 20 HP).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "eradicate"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2695,
          "apCost": 0,
          "name": "Harvest Organs",
          "shortDescription": "When this champion recovers a nora globe, it gains 3 charges and +4 MAX HP permanently.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "killing_stroke"
        },
        {
          "id": 3339,
          "apCost": 0,
          "name": "Soul Linked",
          "shortDescription": "When this unit is deployed, it gains 10 HP for every real (non-summoned, non-illusion) champion your enemy has in play, with a maximum of 100 HP. If your enemy does not have any champions in play, this unit is destroyed.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_linked"
        },
        {
          "id": 726,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 489,
              "apCost": 0,
              "name": "Soulsift",
              "shortDescription": "When this unit is destroyed, you gain nora equal to 40% of this units nora cost.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "soulsift"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2537,
              "apCost": 0,
              "name": "Revel in Misery",
              "shortDescription": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "forsaken_conduit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 3137,
              "apCost": 2,
              "name": "Dread Field",
              "shortDescription": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "dread_field"
            }
          ]
        }
      ]
    },
    {
      "id": 1566,
      "name": "Collective Ambassador",
      "description": "\"If we are to survive, the Swamp must remember that the enemy is not within. We may not always agree on the way to get there, but we all want the Swamp to thrive even in these troubled times.\" ~ Brasha, Collective Ambassador",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8JG2Be9BG2Af1Aj9Cj9Dplrfvftuvmhexqf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 2563,
          "apCost": 3,
          "name": "Flourish",
          "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            },
            {
              "default": true,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 2134,
              "apCost": 0,
              "name": "Abash",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intoxicate"
            },
            {
              "default": false,
              "id": 3065,
              "apCost": 0,
              "name": "Surge: Races",
              "shortDescription": "This unit has +1 DMG for each different Race on friendly champions.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_races"
            }
          ]
        }
      ]
    },
    {
      "id": 721,
      "name": "Colossal Boa",
      "description": "T`irin looked over the head of his companion. Fires burned to the east and the smell of ash filled the air. They were Nefari. He patted his mount and they advanced. Their first trial had begun.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 11,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dj9AJ8Jf1AG2Af1Bj9Aj9Bj9Ceevofpuohnlevfg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        }
      ]
    },
    {
      "id": 1810,
      "name": "Commander Nisk",
      "description": "\"However removed the Valdaci may be from our people, bravery and honor is not lost among them. I have seen this with my own eyes.\" -- Brom the Heretic",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Je9AG2BG2Af1Aj9Fj9Gowzohrojeerzgrf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": false,
      "tradeable": false,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 51,
          "apCost": 0,
          "name": "Resistance: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is reduced by 35% (after DEF, rounded up).",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "resistance_magic"
        },
        {
          "id": 1180,
          "apCost": 0,
          "name": "Taunt: Nisk",
          "shortDescription": "Taunt your enemies with the phrase \"That error has cost you this battle!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        },
        {
          "id": 1505,
          "apCost": 1,
          "name": "Throw Shield",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "throw_shield"
        },
        {
          "id": 3269,
          "apCost": 2,
          "name": "Valdaci Sacrifice: Shield",
          "shortDescription": "This champion loses 5 HP and target friendly champion within 5 spaces is equipped with Valdaci Shield (Equipped champion has <ability value=3266>Combat Awareness 1</ability>).",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 2,
          "iconName": "valdacisac_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 1268,
      "name": "Conclave Warden",
      "description": "Unlike the Wardens of other species, the Conclave Warden is the keeper of lore and secrets, not territory.  Seldom seen outside of the Conclave, they are viewed by outsiders as an ominous sign when they do emerge.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 66,
      "hash": "ej9Bj9AG2Be9Be9Af1Bj9Cj9Deeipnevhpyzzoqf",
      "artist": "Christian Fell",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1160,
          "apCost": 0,
          "name": "Boost",
          "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "boost"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1007,
      "name": "Condor Fury",
      "description": "\"Fury, in feathered form!\" - Jessem, Elven Alliterative Poet and Dandy",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Beast",
        "Elf"
      ],
      "noraCost": 79,
      "hash": "eJ8HJ8Ge9AE8De9Ae9Bj9Fj9Gemetsqhtherjin",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3143,
          "apCost": 0,
          "name": "Lead the Charge",
          "shortDescription": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "lead_the_charge"
        },
        {
          "id": 2008,
          "apCost": 0,
          "name": "Liability",
          "shortDescription": "Friendly champions within 5 spaces of this champion have -1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "dampen"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2213,
              "apCost": 0,
              "name": "Crazed Charger",
              "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "crazed_charger"
            },
            {
              "default": true,
              "id": 3059,
              "apCost": 0,
              "name": "Thunderous Charge",
              "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "thunderous_charge"
            }
          ]
        }
      ]
    },
    {
      "id": 649,
      "name": "Conscripted Warrior",
      "description": "You think all of Rugolth's soldiers were recruited willingly? Some of his men fight because they must. The barbarians owe a debt to him. - Feofil, Advisor to the King",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 54,
      "hash": "dj9Gj9Fe9AG2Ae9BJ8GJ8HJ8Iuqfxvouowftolyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2686,
          "apCost": 0,
          "name": "Logistics: Flanking",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 1782,
          "apCost": 0,
          "name": "Reinforce",
          "shortDescription": "When this unit is deployed the closest champion you own is returned to the rune dock with a cooldown of 10 and you gain 50% of its nora cost.\r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "tgtdefensive"
        },
        {
          "id": 2608,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1293,
      "name": "Contained Thrall",
      "description": "\"Impossible, I have never heard of such a thing in all my years. You are just spreading lies so you can, Vallassa. We will not waste more resources on your fairy tales!\" ~ Shardseer K'aeyun",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Jakei",
        "Undead",
        "Zombie"
      ],
      "noraCost": 62,
      "hash": "ej9Ej9DF0Ae9Be9Ag3AJ8HJ8Ikuofexkpnlyzgpf",
      "artist": "Christian Fell",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2678,
          "apCost": 3,
          "name": "Binding Chains",
          "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "disable"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1606,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 5 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "damageshield"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": true,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1657,
      "name": "Cora, Sun Blossom",
      "description": "\"Even I was not aware of the fantastical creatures that live inside the Conclave\" ~ Menalaus upon observing the Sun Blossom for the first time",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 67,
      "hash": "ej9AJ8Jf1BF0BG2Af1Aj9Aj9Bemevhyzxiwzztqf",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2486,
          "apCost": 3,
          "name": "Blind",
          "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "blind"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            }
          ]
        }
      ]
    },
    {
      "id": 1242,
      "name": "Coragh Two-Heads",
      "description": "\"Cory and Bragh.  Best friends in Life, forever joined in Undeath.\" ~ Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 84,
      "hash": "eJ8JJ8IF0Ae9Be9AF0BJ8HJ8Ioqoqjnyipjipjn",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2632,
          "apCost": 0,
          "name": "Bold",
          "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "channel_defense"
        },
        {
          "id": 1146,
          "apCost": 1,
          "name": "Disease Breath",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "diseaseaoe"
        },
        {
          "id": 2631,
          "apCost": 0,
          "name": "Double Trouble",
          "shortDescription": "When this champion is destroyed, instead of a nora globe, Cory the Zombie and Bragh the Zombie are spawned in the closest available spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "zombie_apoc"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 927,
              "apCost": 0,
              "name": "Amplify: Disease",
              "shortDescription": "Disease damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_disease"
            },
            {
              "default": true,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": true,
              "id": 2142,
              "apCost": 0,
              "name": "Zombie Apocalypse",
              "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "zombie_apoc"
            },
            {
              "default": false,
              "id": 2824,
              "apCost": 0,
              "name": "Incoherent Babbling",
              "shortDescription": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "rover_babbling"
            }
          ]
        }
      ]
    },
    {
      "id": 1471,
      "name": "Coragh Two-Heads",
      "description": "\"Cory and Bragh.  Best friends in Life, forever joined in Undeath.\" ~ Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 84,
      "hash": "eJ8HJ8Gg3AF0Be9Ae9Bj9Dj9Eeeeipllgtmuxfpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2632,
          "apCost": 0,
          "name": "Bold",
          "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "channel_defense"
        },
        {
          "id": 1146,
          "apCost": 1,
          "name": "Disease Breath",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "diseaseaoe"
        },
        {
          "id": 2631,
          "apCost": 0,
          "name": "Double Trouble",
          "shortDescription": "When this champion is destroyed, instead of a nora globe, Cory the Zombie and Bragh the Zombie are spawned in the closest available spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "zombie_apoc"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 927,
              "apCost": 0,
              "name": "Amplify: Disease",
              "shortDescription": "Disease damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_disease"
            },
            {
              "default": true,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": true,
              "id": 2142,
              "apCost": 0,
              "name": "Zombie Apocalypse",
              "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "zombie_apoc"
            },
            {
              "default": false,
              "id": 2824,
              "apCost": 0,
              "name": "Incoherent Babbling",
              "shortDescription": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "rover_babbling"
            }
          ]
        }
      ]
    },
    {
      "id": 1329,
      "name": "Coral Creeper",
      "description": "Eradicate... corruption... necessary...",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jellebrium",
        "Plant"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8Gg3AF0Ae9Ae9Bj9Dj9Eeerqousmuxoyzo",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2529,
          "apCost": 0,
          "name": "Jellebrium Mind",
          "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "jellebrium_mind"
        },
        {
          "id": 86,
          "apCost": 0,
          "name": "Vulnerability: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2753,
              "apCost": 2,
              "name": "Noble Sacrifice",
              "shortDescription": "This champion loses 8 HP and target other friendly champion that shares a race with this one within 3 spaces gains <ability value=1932>Loyalty</ability> for 8 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        }
      ]
    },
    {
      "id": 1559,
      "name": "Corgi Knight",
      "description": "Fae who, for one reason or another, are not able to keep up in flight, are trained to ride Corgis.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Beast",
        "Fairy"
      ],
      "noraCost": 71,
      "hash": "eJ8JJ8IG2Ae9BG2AF0Bj9Bj9Ceeeeeinszirwoqf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 6,
          "apCost": 0,
          "name": "Mobility",
          "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mobility"
        },
        {
          "id": 2572,
          "apCost": 0,
          "name": "Spur",
          "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "spur"
        },
        {
          "id": 3059,
          "apCost": 0,
          "name": "Thunderous Charge",
          "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "thunderous_charge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": true,
              "id": 2213,
              "apCost": 0,
              "name": "Crazed Charger",
              "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "crazed_charger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": true,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        }
      ]
    },
    {
      "id": 1598,
      "name": "Corgi Ranger",
      "description": "Mounted bowmen aren't a new thing, but it takes a certain agility to master the art with a Corgi mount whose cadence when running provides a certain challenge.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Fairy"
      ],
      "noraCost": 74,
      "hash": "eJ8HJ8Gf1BF0AG2Ae9Bj9Aj9Bevfepfvxqhrzzo",
      "artist": "Darcie Banfield",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 3101,
          "apCost": 0,
          "name": "Ferocious Bite",
          "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "ancestral_avenger"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2097,
              "apCost": 0,
              "name": "Combo Attack: Rend",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 741,
      "name": "Corpse Golem",
      "description": "The mass graves of Elsarin are odd, when infused by necromantic ritual. Instead of its intended effect, of raising several individual corpses from their rest, it raises the entire grave to its feet, as one entity. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2AG2Af1Bj9Aj9Bj9Cevshgnykufmnshg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 2634,
          "apCost": 0,
          "name": "Brain Eater",
          "shortDescription": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_disease"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 1847,
          "apCost": 0,
          "name": "Hunter: Diseased",
          "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "disease"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 927,
              "apCost": 0,
              "name": "Amplify: Disease",
              "shortDescription": "Disease damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_disease"
            },
            {
              "default": false,
              "id": 1250,
              "apCost": 1,
              "name": "Ravenous Torrent",
              "shortDescription": "This champion takes 5 HP Disease damage and makes a ranged-combat, Disease attack at DMG 10 and RNG 5. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 47,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 753,
      "name": "Corrupted Cultist",
      "description": "As he conjured, he could see it slowly creeping from the ether. First, its eyes, then, its head. Soon, the entire form, with arms, legs, and tail, was dancing about the brazier. His lessons hadn't failed him.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Demi-God",
        "Wizard"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 68,
      "hash": "dj9Dj9CG2BG2AG2Bj9Cj9Dj9Eeeigygpuzmleilg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1943,
          "apCost": 0,
          "name": "Attack: Loss of Life",
          "shortDescription": "This unit makes a <mechanic value=lossoflife>Loss of Life</mechanic> attack at its Range against target champion. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "lossoflife"
        },
        {
          "id": 1972,
          "apCost": 0,
          "name": "Sheoul's Bond",
          "shortDescription": "While a friendly Sheoul Demon is in play, this champion gains <ability value=936>Surge: Demon</ability>. If there are no friendly demons, this champion has -1 SPD.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "blockade"
        },
        {
          "id": 903,
          "apCost": 4,
          "name": "Summon: Young Imp",
          "shortDescription": "Summon a Young Imp with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 11,
          "iconName": "sumimp"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 1618,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "terrain_dmz"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1126,
              "apCost": 0,
              "name": "Ally: Shattered Peaks",
              "shortDescription": "While there are other friendly Shattered Peaks champions in play, this champion gets +7 HP and +2 DMG. Shattered Peaks champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_sp"
            },
            {
              "default": true,
              "id": 1125,
              "apCost": 0,
              "name": "Ally: Forsaken Waste",
              "shortDescription": "While there are other friendly Forsaken Wastes champions in play, this champion gets +7 HP and +2 DMG. Forsaken champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fw"
            },
            {
              "default": false,
              "id": 1127,
              "apCost": 0,
              "name": "Ally: Sundered Lands",
              "shortDescription": "While there are other friendly Sundered Lands champions in play, this champion gets +7 HP and +2 DMG. Sundered Lands champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_sl"
            }
          ]
        }
      ]
    },
    {
      "id": 1296,
      "name": "Corrupted Guardian",
      "description": "\"How good of Zeventrech to leave us the corpses of his ancient guards.\" ~ Xulos, Undead Sage",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops",
        "Undead",
        "Zombie"
      ],
      "noraCost": 83,
      "hash": "ej9Ej9Df1Be9Be9Ag3Aj9Aj9Bqolrzrhyzkeetqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2702,
          "apCost": 0,
          "name": "Ancient Corruption",
          "shortDescription": "This champion gains +3 DMG, <ability value=2707>Vivify</ability> and <ability value=1846>Foul Strike</ability> for 6 turns.  The duration of this effect is decreased by 1 whenever this champion is successfully attacked.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "defile_corpse"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2634,
          "apCost": 0,
          "name": "Brain Eater",
          "shortDescription": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_disease"
        },
        {
          "id": 2575,
          "apCost": 0,
          "name": "Defiling Aura",
          "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defile_corpse"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1479,
              "apCost": 0,
              "name": "Vigorous Cry",
              "shortDescription": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            }
          ]
        }
      ]
    },
    {
      "id": 1359,
      "name": "Corrupted Overlord",
      "description": "Even the brightest amongst the Circadian were unable to combat the corruption of some of the Mirefolk, though in some cases they were able to preserve some vestiges of their former selves.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Mirefolk",
        "Mutant"
      ],
      "noraCost": 80,
      "hash": "ej9AJ8Jg3AF0Ae9Af1Aj9Dj9Eemwquonsouoyrqf",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp",
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2789,
          "apCost": 0,
          "name": "Distichous: FS/UD",
          "shortDescription": "When an FS champion is deployed from the runedock, this champion gains <ability value=1317>Absorb</ability> for 4 turns. When a UD champion is deployed from the runedock, this champion gains <ability value=99>Life Siphon</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "distichous"
        },
        {
          "id": 260,
          "apCost": 0,
          "name": "Enrage",
          "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 1312,
          "apCost": 3,
          "name": "Sweep",
          "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 883,
              "apCost": 1,
              "name": "Tidal Wave",
              "shortDescription": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "tsunami"
            },
            {
              "default": false,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1886,
              "apCost": 4,
              "name": "Annihilate",
              "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "novafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            },
            {
              "default": false,
              "id": 480,
              "apCost": 0,
              "name": "Lavawalker",
              "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "terrainlava"
            }
          ]
        }
      ]
    },
    {
      "id": 937,
      "name": "Corruptor",
      "description": "\"I've seen them wander through the fields, sucking the life out of the grain. Mother says they come from Elsarin, that the magicks in the city have made them wicked. When I see them, I fear for our safety.\" - Journal found in Cerlornas, pre-Separation era",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 77,
      "hash": "dj9Bj9Af1Bg3Ae9Aj9Fj9Gj9Hmsqquqonnsuohig",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2239,
          "apCost": 0,
          "name": "Corruption",
          "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 486,
          "apCost": 0,
          "name": "Soulharvester",
          "shortDescription": "When this unit destroys an enemy champion, you gain nora equal to half the destroyed champion's nora cost.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "nora_eater"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": false,
              "id": 2958,
              "apCost": 3,
              "name": "Ritual of Power",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "deconstruct"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2480,
              "apCost": 3,
              "name": "Desecrate Earth",
              "shortDescription": "Area Effect 2, Range 5: Affected spaces becomes Desecrated Ground until the end of your next turn. (Desecrated Ground - At beginning of your turns and upon casting, champions without Race: Undead or Race: Spirit in this area lose 6 HP).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "desecrate_earth"
            },
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            },
            {
              "default": true,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1613,
      "name": "Cortices the Infinite",
      "description": "While the dark arts are not unknown in the Swamp, the Firk Voidmage's practices seem to draw from a different, but equally terrifying, power.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 84,
      "hash": "ej9AJ8JF0BF0AG2Af1AJ8IJ8Jklpjrsziykwzipf",
      "artist": "Markus Erdt",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        },
        {
          "id": 3102,
          "apCost": 4,
          "name": "Spatial Dysplasia",
          "shortDescription": "Area Effect 2, Range 5: Enemy champions are pulled 1 space towards the center tile and take 4 Psychic damage for every enemy champion within the affected area (this ignores DEF).",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "spatial_dysplasia"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 559,
      "name": "Council Elder",
      "description": "The Stronghold needs us to take action, not to sit and deliberate! Fetch my mace. - Mardin, Councilman",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 70,
      "hash": "dJ8IJ8HF0Af1BF0AJ8HJ8IJ8Jjrjlrjyxtxqsqwf",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 867,
          "apCost": 0,
          "name": "Blessed",
          "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 3031,
          "apCost": 0,
          "name": "Imposing Aura",
          "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "imposing_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            },
            {
              "default": false,
              "id": 735,
              "apCost": 4,
              "name": "Smite the Unholy",
              "shortDescription": "Target Undead, Demon or Forsaken Wastes unit takes 16 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "smite"
            },
            {
              "default": false,
              "id": 605,
              "apCost": 3,
              "name": "Righteous Shield",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "aegis"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2893,
              "apCost": 1,
              "name": "Death Sentence",
              "shortDescription": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=cleansed>Cleansed</mechanic> and it loses 5 HP for each condition removed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "final_judgement"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1516,
      "name": "Coven Claw",
      "description": "Their foes find the horrific technique of soul removal hard to understand and even harder to experience.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human",
        "Vampyre"
      ],
      "noraCost": 75,
      "hash": "ej9Cj9Be9AF0Be9AG2Aj9Fj9Geemeknwipfiyoqf",
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2999,
          "apCost": 4,
          "name": "Essence Claw",
          "shortDescription": "This champion makes a Psychic attack against target champion at RNG 1. If this destroys the champion, a 20 HP copy of the destroyed champion with <ability value=2372>Warding</ability> is summoned in its place under your control.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 13,
          "iconName": "deathnovapsychic"
        },
        {
          "id": 3397,
          "apCost": 0,
          "name": "Vampiric Thirst",
          "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 3023,
              "apCost": 0,
              "name": "Surge: Cursed",
              "shortDescription": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_cursed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": false,
              "id": 1618,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "terrain_dmz"
            },
            {
              "default": true,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1292,
      "name": "Crawling Corpse",
      "description": "\"Can he really make use of these? They are kind of mutilated.\" \"He is resourceful, I am sure he'll come up with something.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 67,
      "hash": "ej9Ej9De9Be9Be9Ag3AJ8GJ8Hygnsqwtxvkwfxo",
      "artist": "Christian Fell",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1146,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "diseaseaoe"
            },
            {
              "default": false,
              "id": 1144,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "diseaseaoe"
            },
            {
              "default": false,
              "id": 1145,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "diseaseaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 927,
      "name": "Crazed Warmandrils",
      "description": "The Draksar domesticated the Maljaran Mandril, turning the savage beasts into trained killers. The Warmandrils act as wardogs for the Draksar and Kanen.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 13,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 66,
      "hash": "dj9AJ8Jf1Ag3AE8Dj9Ej9Fj9Geeemnumwmhpuhgg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 348,
          "apCost": 0,
          "name": "Berserk Attack",
          "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "offenseenhance"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2217,
              "apCost": 0,
              "name": "Hunter: Brawler",
              "shortDescription": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_rogue"
            },
            {
              "default": true,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1938,
              "apCost": 0,
              "name": "Pack Mentality",
              "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "pack_leader"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": true,
              "id": 1436,
              "apCost": 0,
              "name": "Leverage: Beast",
              "shortDescription": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1665,
      "name": "Crimson Fadewisp",
      "description": "\"Oh, the things that lurk in the Utterdark. If only you could see them, Xulos. If only you could know the horrors I conjure from that place!\" - Serkan, Lich King",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Spirit",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "ej9Bj9AF0BF0BG2Af1BJ8IJ8Jeexxiemeiekyoqf",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1206,
          "apCost": 0,
          "name": "Cripple",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "debuff"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 167,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 20,
      "name": "Crokadar Guardian",
      "description": "Though sought for their tusks, Crokadar rarely fall prey to their hunters.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "cJ8JJ8IJ8HF0Af1BJ8HJ8IJ8Jiwiwiwigymnuosh",
      "artist": "Dan Kopycienski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 617,
          "apCost": 0,
          "name": "Gore",
          "shortDescription": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gore"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1752,
              "apCost": 0,
              "name": "Heavy Charger",
              "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 2427,
              "apCost": 0,
              "name": "Break the Line",
              "shortDescription": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1739,
      "name": "Croma Extinguisher",
      "description": "The Croma inner circle dabbles in magic far darker and more deadly than simple curses and hexes.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 74,
      "hash": "eJ8HJ8GF0Af1BG2Ae9BJ8HJ8Ierlgkufgnuvhto",
      "artist": "Grant Griffin",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3239,
          "apCost": 3,
          "name": "Clone Matter",
          "shortDescription": "Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one).",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "absorb_relic"
        },
        {
          "id": 3238,
          "apCost": 3,
          "name": "Extinguish Matter",
          "shortDescription": "Target relic or equipment on target champion within 3 spaces is destroyed and the closest enemy champion within 5 spaces to the target takes 10 Magical damage and becomes <condition value=cursed>Cursed 5</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "reclaim_materials"
        },
        {
          "id": 88,
          "apCost": 0,
          "name": "Vulnerability: Fire",
          "shortDescription": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": false,
              "id": 3290,
              "apCost": 0,
              "name": "Salvage Equipment",
              "shortDescription": "When an equipment or equipped champion is destroyed, this champion heals for 5 HP and gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "reclaim_materials"
            },
            {
              "default": true,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3097,
              "apCost": 2,
              "name": "Toss Equipment",
              "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            }
          ]
        }
      ]
    },
    {
      "id": 1701,
      "name": "Croma Visionary",
      "description": "The Croma are the de-facto leaders of Witches in Poxanthuru. All witches strive to be chosen for the coveted position of becoming a Croma.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 76,
      "hash": "ej9AJ8Jf1Bf1AG2Af1Aj9Aj9Bjiwmnsfipnlevqf",
      "artist": "Grant Griffin",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 3202,
          "apCost": 0,
          "name": "Prevailing Perception",
          "shortDescription": "This champion gains the upgraded abilities of the last enemy champion deployed from the runedock while this champion was in play.  This effect lasts until this ability is activated again.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "prevailingpreception"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1895,
              "apCost": 0,
              "name": "Illusion of Lies",
              "shortDescription": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "planar"
            },
            {
              "default": false,
              "id": 2948,
              "apCost": 2,
              "name": "Raven Tongue",
              "shortDescription": "Target summoned champion is destroyed, and a Raven Messenger with 10 HP and RNG 1-3 is summoned in its place, under your control",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        }
      ]
    },
    {
      "id": 138,
      "name": "Crossbone",
      "description": "The new recruits always ask, \"How do they aim without eyes?\"",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 71,
      "hash": "dJ8IJ8HF0Ae9Ag3Aj9Dj9Ej9Frwvvhkuzmszmjeg",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2780,
          "apCost": 2,
          "name": "Aim",
          "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "hunted"
        },
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            },
            {
              "default": true,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            }
          ]
        }
      ]
    },
    {
      "id": 330,
      "name": "Crowned Sauropod",
      "description": "The Voil have learned to tame many different beasts of burden. The saurapods, however, serve as a source of protection and food.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 68,
      "hash": "dj9AJ8Jf1AF0Ae9BJ8GJ8HJ8Ieiyzgrhexzirlwf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 877,
          "apCost": 0,
          "name": "Bodyguard",
          "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "block"
        },
        {
          "id": 812,
          "apCost": 0,
          "name": "Devourable",
          "shortDescription": "Adjacent champions may sacrifice this unit and heal equal to its current health.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "devour"
        },
        {
          "id": 1237,
          "apCost": 0,
          "name": "Impenetrable",
          "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ironwill"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 56,
              "apCost": 0,
              "name": "Resistance: Fire",
              "shortDescription": "When this unit takes Fire damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 1493,
              "apCost": 0,
              "name": "Pathfinding",
              "shortDescription": "All friendly champions that share a race with this one have <ability value=1306>Mountaineer</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "climb"
            }
          ]
        }
      ]
    },
    {
      "id": 1047,
      "name": "Crusader",
      "description": "\"They are our finest Paladins, they are everything the Inquisition aspires to be. Magnus would have been so proud.\" Isran Hahndor, Grand Inquisitor",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 69,
      "hash": "ej9AJ8JF0AE8De9Af1AJ8HJ8Iwvkykpjlrjtojn",
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2295,
          "apCost": 0,
          "name": "Thirst for Battle",
          "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "thirst_for_battle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": true,
              "id": 1304,
              "apCost": 0,
              "name": "Trail: Hallowed Ground",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes <mechanic value=hallowed_ground>Hallowed Ground</mechanic>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "trail_hallowed"
            },
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 744,
      "name": "Crypt Guardian",
      "description": "The Guardians of Zarimahl's tomb have stayed in their place since the first of Serkan's reign. Now, with a new master, they have been charged with protecting all of Elsarin.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2AG2Ag3Aj9Dj9Ej9Fnyruzxtqluqzklg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1967,
          "apCost": 0,
          "name": "Relic Guardian",
          "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 1390,
          "apCost": 2,
          "name": "Relocate: Relic",
          "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "relocate_relic"
        },
        {
          "id": 1966,
          "apCost": 0,
          "name": "Rotting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "disease"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 890,
              "apCost": 0,
              "name": "Grace of the Dead",
              "shortDescription": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": true,
              "id": 2634,
              "apCost": 0,
              "name": "Brain Eater",
              "shortDescription": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            },
            {
              "default": true,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            }
          ]
        }
      ]
    },
    {
      "id": 1203,
      "name": "Crystal Crawler",
      "description": "The Crystal Crawler was one of the first successful results of the C'ramil, an ancient artifact of unknown origin discovered in the Shyron Caverns.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod",
        "Elemental"
      ],
      "noraCost": 67,
      "hash": "ej9Ej9De9Be9Ae9Ag3AJ8GJ8Hmsmwmpsztsqhvo",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2581,
          "apCost": 0,
          "name": "Endless Devotion",
          "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "revere"
        },
        {
          "id": 2380,
          "apCost": 0,
          "name": "Scouring Luminescence",
          "shortDescription": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces take 4 Acid damage and become Scoured 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "scouring_luminesence"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1295,
              "apCost": 0,
              "name": "Trail: Ice",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ice for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_ice"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": true,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            }
          ]
        }
      ]
    },
    {
      "id": 1385,
      "name": "Crystal Dragon",
      "description": "The reclusive crystal dragons have pledged their support to Vallassa.  Only she knows what was offered in return.\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dragon",
        "Elemental"
      ],
      "noraCost": 74,
      "hash": "ej9Cj9BG2BF0Ae9AG2Aj9Cj9Dwzgnnuxzxzggvqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 673,
          "apCost": 3,
          "name": "Crystallize",
          "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "crystallize"
        },
        {
          "id": 2375,
          "apCost": 0,
          "name": "Draining Luminescence",
          "shortDescription": "When this unit is deployed and at the start of its turns, the controller of each opposing champion within 4 spaces loses 3 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "draining_luminesence"
        },
        {
          "id": 2581,
          "apCost": 0,
          "name": "Endless Devotion",
          "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "revere"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 137,
              "apCost": 0,
              "name": "Frost Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 1385,
              "apCost": 0,
              "name": "Freezing Aura",
              "shortDescription": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novafrost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            },
            {
              "default": true,
              "id": 390,
              "apCost": 1,
              "name": "Frost Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 512,
      "name": "Crystal Elemental",
      "description": "We have been given another warrior. Now is the time for action! We must take the offensive! - Meodi, Lonx Hunter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 72,
      "hash": "dj9Dj9CG2Bf1Af1Bj9Aj9Bj9Cerqfklggeekrshg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 1385,
          "apCost": 0,
          "name": "Freezing Aura",
          "shortDescription": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "novafrost"
        },
        {
          "id": 2209,
          "apCost": 0,
          "name": "Mirrored",
          "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "mirrored"
        },
        {
          "id": 2373,
          "apCost": 0,
          "name": "Nora Gem",
          "shortDescription": "This unit is a Nora Gem. It gains the Luminescence abilities of friendly Nora Gem within 5 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "nora_gem"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 137,
              "apCost": 0,
              "name": "Frost Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2478,
              "apCost": 0,
              "name": "Improve Range",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_range"
            },
            {
              "default": true,
              "id": 2479,
              "apCost": 0,
              "name": "Improve Speed",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_speed"
            },
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 857,
      "name": "Crystal Golem",
      "description": "\"It takes a special skill to shape crystal into construct. In my years, I've only seen a handful of shapers who could and even they had trouble with it.\" - Olan Pewterblade, Master Construct-shaper",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct",
        "Elemental"
      ],
      "noraCost": 71,
      "hash": "dj9Dj9CG2BG2BF0BJ8IJ8Jj9Auvzthilpqzthigg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2209,
          "apCost": 0,
          "name": "Mirrored",
          "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "mirrored"
        },
        {
          "id": 2373,
          "apCost": 0,
          "name": "Nora Gem",
          "shortDescription": "This unit is a Nora Gem. It gains the Luminescence abilities of friendly Nora Gem within 5 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "nora_gem"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 399,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 2: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "forcebarrier"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2527,
              "apCost": 0,
              "name": "Rock Defiance",
              "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "troll_defiance"
            },
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            }
          ]
        }
      ]
    },
    {
      "id": 421,
      "name": "Crystal Guardian",
      "description": "Forged from ice and crystal, the Crystal Guardian defends the Jakei with valor and fervor.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 71,
      "hash": "dJ8JJ8IF0BF0BE8Dj9Ej9Fj9Geeeeeerzonyrwzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 3230,
          "apCost": 3,
          "name": "Freezing Chains",
          "shortDescription": "Enemy champions within 3 spaces take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "grip_icelord"
        },
        {
          "id": 2373,
          "apCost": 0,
          "name": "Nora Gem",
          "shortDescription": "This unit is a Nora Gem. It gains the Luminescence abilities of friendly Nora Gem within 5 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "nora_gem"
        },
        {
          "id": 2374,
          "apCost": 0,
          "name": "Restricting Luminescence",
          "shortDescription": "Enemy champions within 5 spaces have <ability value=814>Unequippable</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "restricting_luminesence"
        },
        {
          "id": 1864,
          "apCost": 0,
          "name": "Slowing Armor",
          "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "conduit"
        },
        {
          "id": 1147,
          "apCost": 3,
          "name": "Sonic Roar",
          "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 877,
              "apCost": 0,
              "name": "Bodyguard",
              "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 2819,
              "apCost": 0,
              "name": "Catalyst: Frost",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        }
      ]
    },
    {
      "id": 1204,
      "name": "Crystal Howler",
      "description": "\"If you take away their will, what is left of them?\" ~ Vallassa, Jakei Elder",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 73,
      "hash": "ej9Ej9DF0Ae9Ae9Ag3AJ8HJ8Iygtzvkjgkgkeepf",
      "artist": "Paul Guzenko",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1212,
          "apCost": 0,
          "name": "Dissipate",
          "shortDescription": "Ranged attacks made by this champion have a penalty of -2 DMG for each space the target is beyond the champion's minimum range (to a maximum of -4 DMG).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "arrow"
        },
        {
          "id": 2615,
          "apCost": 0,
          "name": "Distracting Luminescence",
          "shortDescription": "This unit has <ability value=1807>Deafening Aura</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "destabilizing_luminesence"
        },
        {
          "id": 2581,
          "apCost": 0,
          "name": "Endless Devotion",
          "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "revere"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": true,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1206,
      "name": "Crystal Mastodon",
      "description": "With the creation of the Crystal Yeti, an aging Mastodon arrived at the gates of the Jakei city, seeking to be reborn via the power of the artifact it had heard so much about recently",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9Df1Ae9Ae9Ag3AJ8Jj9Aeeerqziwirhympf",
      "artist": "Paul Guzenko",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2581,
          "apCost": 0,
          "name": "Endless Devotion",
          "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "revere"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 2614,
          "apCost": 0,
          "name": "Impairing Luminescence",
          "shortDescription": "This unit has <ability value=2582>Impairing Feedback</ability> (When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired for 6 turns).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dispelling_luminesence"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 122,
      "name": "Crystal Phoenix",
      "description": "The Shardmasters' greatest wish was to create something enduring amongst the ever-changing ice.  For a long time, it was thought that Nature herself was responsible for the Crystal Phoenix.  Now, with the C'ramil, the Shardmasters' wish was granted.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 69,
      "hash": "dj9Gj9Fe9Ae9AF0AJ8HJ8IJ8Jeplwzoygvzmwvxf",
      "artist": "Gabriel Garza",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 185,
          "apCost": 0,
          "name": "Death Nova: Frost",
          "shortDescription": "When this unit is destroyed, it deals 11 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovafrost"
        },
        {
          "id": 304,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "divine"
        },
        {
          "id": 2581,
          "apCost": 0,
          "name": "Endless Devotion",
          "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "revere"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": true,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 137,
              "apCost": 0,
              "name": "Frost Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": true,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 1631,
      "name": "Crystal Rimeweaver",
      "description": "Shardmasters who undergo crystallization often lose the ability to channel shards of ice. Instead, the latent energy is converted to snow form, which some argue is just as useful.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 5,
      "damage": 10,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Jakei"
      ],
      "noraCost": 68,
      "hash": "ej9Gj9Ff1BF0BG2Ae9Aj9Aj9Bevoyxqhvqzrqzrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2221,
          "apCost": 0,
          "name": "Orb of Frostfall",
          "shortDescription": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
          "activationType": 1,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "trail_snow"
        },
        {
          "id": 2707,
          "apCost": 0,
          "name": "Vivify",
          "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2667,
              "apCost": 2,
              "name": "Snow Shroud",
              "shortDescription": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            },
            {
              "default": false,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            }
          ]
        }
      ]
    },
    {
      "id": 1723,
      "name": "Crystal Slag",
      "description": "Sometimes, the results of the C'ramil are more impressive than the Jakei anticipated.",
      "maxRng": 3,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental",
        "Slag"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9DF0Bf1AG2Ag3AJ8IJ8Jkukgrzknwfvkjrf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Savage Tundra",
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2376,
          "apCost": 0,
          "name": "Cleansing Luminescence",
          "shortDescription": "When this unit is deployed and at the start of its turns, friendly champions within 4 spaces become Cleansed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dispelling_luminesence"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 1469,
          "apCost": 0,
          "name": "Nexus Aura",
          "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "nexus_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2343,
              "apCost": 3,
              "name": "Paralyze",
              "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "sentry"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2216,
              "apCost": 0,
              "name": "Hunter: Mage",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "wizard_foe"
            },
            {
              "default": true,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 2581,
              "apCost": 0,
              "name": "Endless Devotion",
              "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "revere"
            }
          ]
        }
      ]
    },
    {
      "id": 1235,
      "name": "Crystal Wolverine",
      "description": "The transformation into crystal form has not dulled the Wolverine's natural speed in combat and thirst for blood. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 83,
      "hash": "eJ8IJ8Hf1Be9Be9AF0Aj9Aj9Brzkyztjgpftuqo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2581,
          "apCost": 0,
          "name": "Endless Devotion",
          "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "revere"
        },
        {
          "id": 2621,
          "apCost": 0,
          "name": "Eviscerating Luminescence",
          "shortDescription": "When this unit is deployed and at the start of its turns, opposing champions within 4 spaces take 4 Physical damage and become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "destabilizing_luminesence"
        },
        {
          "id": 2295,
          "apCost": 0,
          "name": "Thirst for Battle",
          "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "thirst_for_battle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 2078,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 50% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            },
            {
              "default": true,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1205,
      "name": "Crystal Yeti",
      "description": "All who are subjected to the C'ramil develop an illogical reverence for the Jakei.  Despite their strong sense of identity, Yetis were no exception to this rule.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Elemental",
        "Yeti"
      ],
      "noraCost": 76,
      "hash": "ej9Ej9DF0Be9Ae9Ag3AJ8IJ8Jygyiyoytzgpyipf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2375,
          "apCost": 0,
          "name": "Draining Luminescence",
          "shortDescription": "When this unit is deployed and at the start of its turns, the controller of each opposing champion within 4 spaces loses 3 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "draining_luminesence"
        },
        {
          "id": 2581,
          "apCost": 0,
          "name": "Endless Devotion",
          "shortDescription": "When this champion is within 5 spaces of a Jakei, it gains <ability value=2373>Nora Gem</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "revere"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1752,
              "apCost": 0,
              "name": "Heavy Charger",
              "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 3331,
              "apCost": 0,
              "name": "Tundra Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fangandfur"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": true,
              "id": 261,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +7 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            }
          ]
        }
      ]
    },
    {
      "id": 901,
      "name": "Crystalis",
      "description": "The Lonx were the first to discover the Crystalis, using the beautiful flower as a symbol of love. The priests of Ailur helped them realize its strong medicinal properties.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 0,
      "hitPoints": 10,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant"
      ],
      "noraCost": 29,
      "hash": "dJ8HJ8Ge9Bg3Af1AJ8Jj9Aj9Bqouqwxmwklufpyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 185,
          "apCost": 0,
          "name": "Death Nova: Frost",
          "shortDescription": "When this unit is destroyed, it deals 11 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovafrost"
        },
        {
          "id": 812,
          "apCost": 0,
          "name": "Devourable",
          "shortDescription": "Adjacent champions may sacrifice this unit and heal equal to its current health.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "devour"
        },
        {
          "id": 2283,
          "apCost": 0,
          "name": "Rapid Growth",
          "shortDescription": "Summon a copy of this champion with no upgrades on target space within 5 spaces. This ability costs 20 nora to activate and begins on CD.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 50,
          "iconName": "rapid_growth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2032,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +4 HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plushealth"
            },
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 757,
              "apCost": 0,
              "name": "Immobile",
              "shortDescription": "This unit cannot move or be relocated.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -30,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1169,
      "name": "Cyclonic Fesh",
      "description": "\"Whoever said lightning doesn't strike the same place twice obviously never met one of these!\" ~ Fleeing Dwarf\r\n",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 82,
      "hash": "ej9Cj9Be9Be9Ae9AG2AJ8GJ8Hygpfmwfevonwon",
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2270,
          "apCost": 0,
          "name": "Attack: Mouth Lightning",
          "shortDescription": "This unit makes an Electricity attack, from its freakin' mouth, at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2555,
          "apCost": 0,
          "name": "Electric Overload",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns. If that champion is already Shocked, it is equipped with a Lightning Rod. Equipment generated by this ability costs 0 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "jolt"
        },
        {
          "id": 3349,
          "apCost": 0,
          "name": "Peaks Exploit",
          "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "exploit_ironfist"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 1604,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 1331,
              "apCost": 0,
              "name": "Electricity Eater",
              "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_electric"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 1940,
      "name": "Cyclonic Fesh",
      "description": "\"Whoever said lightning doesn't strike the same place twice obviously never met one of these!\" ~ Fleeing Dwarf",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 82,
      "hash": "ej9Fj9Ef1Be9AG2BE8Dj9Aj9Bqwqhrwiwiyrhpqf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2270,
          "apCost": 0,
          "name": "Attack: Mouth Lightning",
          "shortDescription": "This unit makes an Electricity attack, from its freakin' mouth, at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2555,
          "apCost": 0,
          "name": "Electric Overload",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns. If that champion is already Shocked, it is equipped with a Lightning Rod. Equipment generated by this ability costs 0 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "jolt"
        },
        {
          "id": 3349,
          "apCost": 0,
          "name": "Peaks Exploit",
          "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "exploit_ironfist"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 1604,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 1331,
              "apCost": 0,
              "name": "Electricity Eater",
              "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_electric"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 1592,
      "name": "Cyclopalypse Cannon",
      "description": "\"The Cyclopean Empire once laid siege to its enemies with massive warmachines. Let us pray they never regain the ability to build such contraptions.\" ~ Advisor to the Voil Queen",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct",
        "Cyclops"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9EG2AF0AG2AE8Dj9Bj9Cemsfrszmpwzmwqf",
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3015,
          "apCost": 0,
          "name": "Cyclopean Machine",
          "shortDescription": "When this champion is within 4 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD, <ability value=6>Mobility</ability> and <ability value=1900>Tough 1</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "cyclopean_machine"
        },
        {
          "id": 1152,
          "apCost": 0,
          "name": "Recoil",
          "shortDescription": "When this champion makes a basic attack, it is knocked back 1 space in the direction opposite its target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "knockback"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1832,
      "name": "Cyclopean Boltcase",
      "description": "With memory recollection still in its infancy, the best cyclops artisans modified old forms with new innovations.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 40,
      "hash": "eJ8IJ8Hf1AG2BG2AF0AJ8Jj9Aeilnerwonevsoqf",
      "artist": "Danh Nguyen",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2253,
          "apCost": 0,
          "name": "Manic",
          "shortDescription": "At the end of its turn, if this champion has a MIN RNG of 1, it moves 2 spaces toward the closest enemy champion, and makes an attack against that champion if possible.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "manic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2768,
              "apCost": 0,
              "name": "Sole Purpose",
              "shortDescription": "When this champion makes a basic attack, it loses 3 Charges. For each charge it lacks, it loses 4 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "ondeath"
            },
            {
              "default": true,
              "id": 875,
              "apCost": 0,
              "name": "Short Lived",
              "shortDescription": "This unit is destroyed after 6 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": -20,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 876,
              "apCost": 0,
              "name": "Short Lived",
              "shortDescription": "This unit is destroyed after 8 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": -15,
              "iconName": "ondeath"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 188,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 8 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "deathnovaelec"
            }
          ]
        }
      ]
    },
    {
      "id": 1497,
      "name": "Cyclopean Firecase",
      "description": "\"Run you fools! Unless you think yourselves immune to flame!\"- Sole surviving Boghopper of the Nanjain incident",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 59,
      "hash": "ej9AJ8Je9BF0Be9Af1AJ8GJ8Heekepykeruxfmn",
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1447,
          "apCost": 0,
          "name": "Death Nova: Lava",
          "shortDescription": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "deathnovalava"
        },
        {
          "id": 133,
          "apCost": 0,
          "name": "Fire Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novafire"
        },
        {
          "id": 380,
          "apCost": 3,
          "name": "Flame Nova",
          "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novafire"
        },
        {
          "id": 894,
          "apCost": 1,
          "name": "Retreat",
          "shortDescription": "This champion can disengage for free and move 2 spaces.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "mobility"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2352,
              "apCost": 0,
              "name": "Defensive Turtle",
              "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "turtle"
            },
            {
              "default": false,
              "id": 647,
              "apCost": 3,
              "name": "Turtle",
              "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "turtle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 229,
              "apCost": 0,
              "name": "Damage Shield: Fire",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_fire"
            },
            {
              "default": false,
              "id": 3015,
              "apCost": 0,
              "name": "Cyclopean Machine",
              "shortDescription": "When this champion is within 4 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD, <ability value=6>Mobility</ability> and <ability value=1900>Tough 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "cyclopean_machine"
            }
          ]
        }
      ]
    },
    {
      "id": 1496,
      "name": "Cyclopean Warcart",
      "description": "\"Run away little Elf. I will find you soon. Then you shall die like the rest of your kin!\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct",
        "Cyclops"
      ],
      "noraCost": 75,
      "hash": "ej9AJ8Je9AF0Be9Af1Aj9Fj9Gevfinjeggvofgpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 3015,
          "apCost": 0,
          "name": "Cyclopean Machine",
          "shortDescription": "When this champion is within 4 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD, <ability value=6>Mobility</ability> and <ability value=1900>Tough 1</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "cyclopean_machine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            },
            {
              "default": true,
              "id": 2427,
              "apCost": 0,
              "name": "Break the Line",
              "shortDescription": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1752,
              "apCost": 0,
              "name": "Heavy Charger",
              "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1514,
      "name": "Cyclops Artificer",
      "description": "With the rediscovery of the old lands of the empire, older cyclops have begun to recover memories long forgotten.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 73,
      "hash": "ej9Bj9Ag3AF0Be9Af1Bj9Dj9Eeeruzkukpyigyrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2992,
          "apCost": 1,
          "name": "Chuck: Rusty Firecase",
          "shortDescription": "This champion makes a ranged Fire attack at RNG 2-5.  A summoned Rusty Firecase with no upgrades is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 15,
          "iconName": "summon_firecase"
        },
        {
          "id": 2687,
          "apCost": 3,
          "name": "Confuse",
          "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "confuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2578,
              "apCost": 3,
              "name": "Superior Tinkering",
              "shortDescription": "Target construct within 2 spaces gains +1 DMG and +10 MAX HP.  This effect does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "build_mine"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2993,
              "apCost": 0,
              "name": "Reclaim Materials",
              "shortDescription": "When a real friendly Construct is destroyed, you gain 3 nora. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reclaim_materials"
            },
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            }
          ]
        }
      ]
    },
    {
      "id": 445,
      "name": "Cyclops Battlefiend ",
      "description": "The guardians of the old Cyclops Empire, the Battlefiends are fueled by ancient fanaticism.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 6,
      "hitPoints": 60,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 69,
      "hash": "dj9Fj9EE8Df1Ae9Aj9Fj9Gj9Hygyolpsxtqjlygg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1191,
          "apCost": 0,
          "name": "Battlefiend",
          "shortDescription": "When this unit's DMG modifier is greater than 5, it gets +2 SPD, <ability value=732>Fury</ability>, <ability value=15>Multiattack 1</ability> and <ability value=25>Berserker 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "berserker"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 1290,
          "apCost": 0,
          "name": "Warmonger",
          "shortDescription": "When a friendly real champion is destroyed, this champion gains -1 DEF and +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2029,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +1 DEF.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plusdefense"
            }
          ]
        }
      ]
    },
    {
      "id": 1943,
      "name": "Cyclops Battlefiend",
      "description": "The guardians of the old Cyclops Empire, the Battlefiends are fueled by ancient fanaticism.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 6,
      "hitPoints": 60,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 69,
      "hash": "ej9Fj9EG2Be9AG2BE8Dj9Cj9Doheeexiiwosjyrf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Nora Surge",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1191,
          "apCost": 0,
          "name": "Battlefiend",
          "shortDescription": "When this unit's DMG modifier is greater than 5, it gets +2 SPD, <ability value=732>Fury</ability>, <ability value=15>Multiattack 1</ability> and <ability value=25>Berserker 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "berserker"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 1290,
          "apCost": 0,
          "name": "Warmonger",
          "shortDescription": "When a friendly real champion is destroyed, this champion gains -1 DEF and +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2029,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +1 DEF.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plusdefense"
            }
          ]
        }
      ]
    },
    {
      "id": 1766,
      "name": "Cyclops Blastmage",
      "description": "Across all tribal distinctions and talents, cyclops share a common trait: a love of force.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 73,
      "hash": "ej9Cj9BF0Bf1BG2AG2AJ8IJ8Jmsjneempjllexqf",
      "artist": "Anthony Lopes",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1440,
          "apCost": 0,
          "name": "Confuse Attacker",
          "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "confuse"
        },
        {
          "id": 3005,
          "apCost": 0,
          "name": "Kinetic Impulse",
          "shortDescription": "Ranged attacks made by this champion have a bonus of 2 DMG for each space the target is beyond the champion's minimum range (to a maximum of 4 DMG).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "rock"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1749,
              "apCost": 1,
              "name": "Grant: Lay Trap: Boulder",
              "shortDescription": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            }
          ]
        }
      ]
    },
    {
      "id": 389,
      "name": "Cyclops Chieftain",
      "description": "In the land of the blind, the one-eyed man is king. In the land of the one-eyed, the man with the biggest stick is king.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 81,
      "hash": "dj9Gj9Fe9AF0Bg3Aj9Dj9Ej9Fjljiigrhrfmuhig",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1072,
          "apCost": 1,
          "name": "Magical Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "magicaoe"
        },
        {
          "id": 1962,
          "apCost": 0,
          "name": "Weaken Spells",
          "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dark_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 3232,
              "apCost": 1,
              "name": "Chuck: Mangled Totem",
              "shortDescription": "This champion makes a Physical Attack at RNG 2-5.  A summoned Mangled Totem relic (20 HP with <ability value=2277>Punishing Aura</ability>) is summoned adjacent to the target if it is successfully damaged.",
              "activationType": 3,
              "level": 0,
              "cooldown": 4,
              "noraCost": 15,
              "iconName": "chuck_mangledtotem"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1067,
              "apCost": 0,
              "name": "Surge: Cyclops",
              "shortDescription": "This unit has +1 DMG for every friendly Cyclops champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_behemoth"
            }
          ]
        }
      ]
    },
    {
      "id": 432,
      "name": "Cyclops Chieftain",
      "description": "In the land of the blind, the one-eyed man is king. In the land of the one-eyed, the man with the biggest stick is king.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 81,
      "hash": "dj9Ej9Dg3AF0BG2Bj9Cj9Dj9Eeeeeemjemnjwzkg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1072,
          "apCost": 1,
          "name": "Magical Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "magicaoe"
        },
        {
          "id": 1962,
          "apCost": 0,
          "name": "Weaken Spells",
          "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dark_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 3232,
              "apCost": 1,
              "name": "Chuck: Mangled Totem",
              "shortDescription": "This champion makes a Physical Attack at RNG 2-5.  A summoned Mangled Totem relic (20 HP with <ability value=2277>Punishing Aura</ability>) is summoned adjacent to the target if it is successfully damaged.",
              "activationType": 3,
              "level": 0,
              "cooldown": 4,
              "noraCost": 15,
              "iconName": "chuck_mangledtotem"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1067,
              "apCost": 0,
              "name": "Surge: Cyclops",
              "shortDescription": "This unit has +1 DMG for every friendly Cyclops champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_behemoth"
            }
          ]
        }
      ]
    },
    {
      "id": 274,
      "name": "Cyclops Earthshaker",
      "description": "No donnada makedo madde...thenen shakeda shakeda!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 71,
      "hash": "dj9Dj9CG2Be9BE8Dj9Ej9Fj9Geigtzmpyzmumegg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 344,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +6 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 488,
      "name": "Cyclops Hauler ",
      "description": "Once revered by their subjects, the stronger Cyclopes are often relegated to manual labor.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 67,
      "hash": "dj9Fj9EE8DF0Bf1AJ8Jj9Aj9Beepuoufxmwmevzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 2414,
          "apCost": 1,
          "name": "Throw Boulder",
          "shortDescription": "This champion makes a Physical attack at RNG 2-5. This attack causes <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "rock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1028,
      "name": "Cyclops Hurler",
      "description": "It is one thing to have the strength to throw a boulder, and another to hit a target...  successfully, at a distance, with no depth perception! ",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 14,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 78,
      "hash": "eJ8JJ8IG2AE8De9AF0Bj9Bj9Ceeeeevmpfkjnuo",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 553,
          "apCost": 0,
          "name": "Attack: Boulder",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physicalaoe"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 3194,
          "apCost": 0,
          "name": "Ponderous Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "lumbering"
        },
        {
          "id": 869,
          "apCost": 3,
          "name": "Tremor",
          "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 596,
      "name": "Cyclops Lurker",
      "description": "The Lurkers are often found within the many chasms of the Shattered Peaks. They are known to capture unsuspecting travelers and then crush them with physical strength.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute",
        "Rogue"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 71,
      "hash": "dj9AJ8Jf1Af1Bg3Aj9Dj9Ej9Fuzouowxtohkjgig",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        },
        {
          "id": 2357,
          "apCost": 0,
          "name": "Shadowstrike",
          "shortDescription": "This champion becomes stealthed after making a basic attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            },
            {
              "default": false,
              "id": 1017,
              "apCost": 1,
              "name": "Knockout",
              "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "stun"
            }
          ]
        }
      ]
    },
    {
      "id": 159,
      "name": "Cyclops Mauler",
      "description": "If they weren't so useful, I'd have left them in their cliffs! - Eehiist, Voil Queen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 69,
      "hash": "dj9AJ8Jf1Ae9AG2Bj9Cj9Dj9Eeeevsziluztxqfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 25,
              "apCost": 0,
              "name": "Berserker",
              "shortDescription": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "berserker"
            },
            {
              "default": true,
              "id": 24,
              "apCost": 0,
              "name": "Berserker",
              "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "berserker"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 160,
      "name": "Cyclops Nemesis",
      "description": "Long before the land had separated, legend holds that the Cyclops, god of pain and ill fortune, was made entirely of stone.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 14,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 54,
      "hash": "dj9AJ8Jf1Ae9Ag3Aj9Dj9Ej9Fegyouoykgtzrfgg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1046,
          "apCost": 0,
          "name": "Nemesis: Earthmover",
          "shortDescription": "When this champion is deployed, an Earthmover with <ability value=4>Iron Will</ability> is deployed within 3 spaces of your enemy's Shrine or Avatar, under their control.  If this champion is destroyed, the Earthmover is also destroyed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -25,
          "iconName": "regen"
        },
        {
          "id": 343,
          "apCost": 1,
          "name": "Power Attack",
          "shortDescription": "This unit makes an attack with +4 DMG.",
          "activationType": 1,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hammer"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1335,
      "name": "Cyclops Primal",
      "description": "The primal's psyche is keyed to other cyclops, drawing on the strength of numbers.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 69,
      "hash": "eJ8IJ8Hf1AF0Ae9AF0AJ8Jj9Aemssqosmetqzon",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2619,
          "apCost": 0,
          "name": "Zeal: Speed",
          "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "channel_speed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        }
      ]
    },
    {
      "id": 1336,
      "name": "Cyclops Ritualist",
      "description": "Older Cyclops are bemused that the recent spotaneous manifestations of power are attributed as corruptions of Ba'lah, with Cyclops having dealt with and utilized similar \"corruptions\" for generations.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 70,
      "hash": "eJ8IJ8Hf1BF0Ae9AF0Aj9Aj9Bvkpwvkufgnlrso",
      "artist": "Conceptopolis",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1786,
          "apCost": 3,
          "name": "Ritual of Destruction",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_damage"
        },
        {
          "id": 3107,
          "apCost": 3,
          "name": "Ritual of Healing",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_healing"
        },
        {
          "id": 2958,
          "apCost": 3,
          "name": "Ritual of Power",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "deconstruct"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            },
            {
              "default": true,
              "id": 1748,
              "apCost": 1,
              "name": "Grant: Poison Cloud Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=446>Lay Trap: Poison Cloud</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 606,
              "apCost": 2,
              "name": "Fester",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=inhibited>Inhibited</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "inhibit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2759,
              "apCost": 0,
              "name": "Guarded: Cyclops",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Cyclops within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        }
      ]
    },
    {
      "id": 1740,
      "name": "Cyclops Rockshaper",
      "description": "Of all the races in Poxanthuru, none more revere their elders than the Cyclops. Where the young are unfailingly brutish and dull, the old apply the wisdom of centuries.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 77,
      "hash": "eJ8HJ8GF0Bf1BG2Ae9BJ8IJ8Jeetosjrsquxzxo",
      "artist": "Maciej Janaszek",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3232,
          "apCost": 1,
          "name": "Chuck: Mangled Totem",
          "shortDescription": "This champion makes a Physical Attack at RNG 2-5.  A summoned Mangled Totem relic (20 HP with <ability value=2277>Punishing Aura</ability>) is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 15,
          "iconName": "chuck_mangledtotem"
        },
        {
          "id": 2063,
          "apCost": 0,
          "name": "Rebuke",
          "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "rebuke"
        },
        {
          "id": 1253,
          "apCost": 2,
          "name": "Ruin",
          "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "terraingrass"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2636,
              "apCost": 3,
              "name": "Rev 'Em Up",
              "shortDescription": "Range 3: Target champion with Race: Construct gains <ability value=2253>Manic</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "build_mine"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1749,
              "apCost": 1,
              "name": "Grant: Lay Trap: Boulder",
              "shortDescription": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 624,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 8 HP. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "shrinegood"
            }
          ]
        }
      ]
    },
    {
      "id": 869,
      "name": "Cyclops Runt",
      "description": "Concerned over Protectorate involvement in Maljara, the Voil began sending Cyclops to capture territories. These warriors were given specially-crafted armor and weapons, made from the finest scraps of Voil armaments.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3AG2Bf1Bj9Aj9Bj9Ceeevqukuzignukg",
      "artist": "Simon Dominic",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        },
        {
          "id": 1067,
          "apCost": 0,
          "name": "Surge: Cyclops",
          "shortDescription": "This unit has +1 DMG for every friendly Cyclops champion.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge_behemoth"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 162,
      "name": "Cyclops Seer",
      "description": "Go'ah entuh cave, bringid back slime, den seentah future. - Rodaria, Cyclops Seer",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 73,
      "hash": "dj9Bj9Af1Be9Ae9Aj9Fj9Gj9Hiiwxzkpwqzvkpfg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1452,
          "apCost": 3,
          "name": "Dispel",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "dispel"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 694,
      "name": "Cyclops Shaman",
      "description": "Magic was an ancient knowledge they had forgotten long ago. But, with time, the Cyclopes would remember it.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 5,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0BG2AF0BJ8IJ8Jj9Aoqoqssmjlwiyoyg",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2129,
          "apCost": 1,
          "name": "Grant: Electricity Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        },
        {
          "id": 2291,
          "apCost": 4,
          "name": "Lightning Storm ",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "electricaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": false,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 1729,
      "name": "Cyclops Skywalker",
      "description": "\"There are many powers to harness and forces to control. Much would be dangerous in the wrong hands.\" - Zeventrech the Last",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 75,
      "hash": "ej9Gj9FF0Af1BG2Ae9AJ8HJ8Itqzkjtuxzvhipqf",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 550,
          "apCost": 0,
          "name": "Attack: Red Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "electric"
        },
        {
          "id": 3090,
          "apCost": 0,
          "name": "Catalyst: Electricity",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Electricity damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "breaker_electricity"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2339,
              "apCost": 4,
              "name": "Imbue: Stun",
              "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 9,
              "iconName": "amped"
            },
            {
              "default": false,
              "id": 2401,
              "apCost": 4,
              "name": "Lightning Skewer",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2329,
              "apCost": 0,
              "name": "Revere: Zeventrech",
              "shortDescription": "While this champion is in play, Zeventrech the Last costs 10% less nora to deploy. While Zeventrech the Last is in play, this champion gains <ability value=1131>Ally: Savage Tundra</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            },
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1338,
      "name": "Cyclops Stonecaller",
      "description": "\"Watch yer head, youngins. Ima carr'in some biguns.\" ~ Cyclops Stonecaller",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 76,
      "hash": "eJ8IJ8HG2BF0Ae9AF0Aj9Cj9Diyrwofmeipfgepf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 553,
          "apCost": 0,
          "name": "Attack: Boulder",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physicalaoe"
        },
        {
          "id": 3145,
          "apCost": 0,
          "name": "Empowered: Defense",
          "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "fragile_defense"
        },
        {
          "id": 2764,
          "apCost": 4,
          "name": "Stone Barrage",
          "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "physicalaoe"
        },
        {
          "id": 2811,
          "apCost": 0,
          "name": "Stone Shield",
          "shortDescription": "This champion has <ability value=1902>Tough 3</ability> when <ability value=2764>Stone Barrage</ability> is not on CD.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 2637,
              "apCost": 3,
              "name": "Grant: Stoneskin Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2638>Drink: Stoneskin Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 934,
      "name": "Cyclops Stormcaller",
      "description": "\"I have a following; Cyclops who are fed up with the Voil. I will teach them what I know and give them what I can. I can only hope that this is the beginning of a new empire.\" - Zeventrech the Last",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 75,
      "hash": "dj9AJ8Jf1Ag3AG2Bj9Cj9Dj9Eeeeemekwmuqhiig",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3090,
          "apCost": 0,
          "name": "Catalyst: Electricity",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Electricity damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "breaker_electricity"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2339,
              "apCost": 4,
              "name": "Imbue: Stun",
              "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 9,
              "iconName": "amped"
            },
            {
              "default": false,
              "id": 2401,
              "apCost": 4,
              "name": "Lightning Skewer",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2329,
              "apCost": 0,
              "name": "Revere: Zeventrech",
              "shortDescription": "While this champion is in play, Zeventrech the Last costs 10% less nora to deploy. While Zeventrech the Last is in play, this champion gains <ability value=1131>Ally: Savage Tundra</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            },
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1523,
      "name": "Cyclops Symbiot",
      "description": "Greater than the sum of their parts, a Cyclops Symbiot is a dangerous new addition to the forces of the Shattered Peaks.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 57,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct",
        "Cyclops"
      ],
      "noraCost": 87,
      "hash": "ej9Cj9BG2BF0Be9AG2Aj9Cj9Deegevzvferwiyrf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2678,
          "apCost": 3,
          "name": "Binding Chains",
          "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "disable"
        },
        {
          "id": 3038,
          "apCost": 0,
          "name": "Cyclopean Menace",
          "shortDescription": "The first time each turn a friendly Cyclops or Construct is deployed from the runedock, this champion gains 2 AP and enemy champions within 2 spaces takes 4 Sonic damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "cyclopean_menace"
        },
        {
          "id": 3031,
          "apCost": 0,
          "name": "Imposing Aura",
          "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "imposing_aura"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 125,
              "apCost": 0,
              "name": "Damage Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaphysical"
            },
            {
              "default": true,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1976,
              "apCost": 3,
              "name": "Wail of Grief",
              "shortDescription": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2759,
              "apCost": 0,
              "name": "Guarded: Cyclops",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Cyclops within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": false,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 756,
      "name": "Cyclops Wardrummer",
      "description": "The Wardrummers bring a special beat to battle, one that inspires alacrity in its allies. With such a massive drum, the sound can often be deafening. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 65,
      "hash": "dj9Ej9Dg3AG2Ae9Aj9Fj9Gj9Hrhigtqojpjeggkg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 623,
          "apCost": 0,
          "name": "Knockback",
          "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "knockback"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1688,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 2 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            },
            {
              "default": false,
              "id": 1978,
              "apCost": 0,
              "name": "Vitalize",
              "shortDescription": "Other real friendly champions within 5 spaces with 5 base SPD or less get +1 SPD while this unit is in play. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 668,
              "apCost": 2,
              "name": "Battle Drum",
              "shortDescription": "All friendly champions from the same faction as this one gain <condition value=benediction>Benediction</condition> for 1 turn and recover 1 AP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "drum"
            }
          ]
        }
      ]
    },
    {
      "id": 1495,
      "name": "Cyclops Warsmith",
      "description": "Due to the skill and knowledge required for the trade, Warsmiths are almost always elder Cyclops.  Few young Cyclops have recovered enough memories to perform the task well enough.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 57,
      "hash": "ej9AJ8JE8DF0Be9Af1Aj9Ej9Fepuvztsjipshyo",
      "artist": "Anthony Lopes",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 947,
          "apCost": 0,
          "name": "Craft",
          "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 5,
          "iconName": "forge"
        },
        {
          "id": 3392,
          "apCost": 0,
          "name": "Peaks Armaments",
          "shortDescription": "When a friendly champion with Race: Cyclops, Race: Voil, Race: G'hern or Race: Moga becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 3148,
          "apCost": 0,
          "name": "Provision: Utility",
          "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plunder"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1517,
              "apCost": 0,
              "name": "Train: Damage",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains +2 DMG. This ability costs 3 nora and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 2484,
              "apCost": 3,
              "name": "Build 'Em Tough",
              "shortDescription": "Target Construct within 2 spaces gains a rank of <ability value=1900>Tough</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "build_mine"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2981,
              "apCost": 0,
              "name": "Clone Relic",
              "shortDescription": "Deploy to an adjacent space a copy of the last relic deployed by an opposing player while this unit was in play. This ability shares a cooldown with Clone Equipment.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "duplicate_equip"
            },
            {
              "default": false,
              "id": 2982,
              "apCost": 0,
              "name": "Clone Equipment",
              "shortDescription": "Target champion within 6 spaces is equipped with a copy of the last equipment played by an opposing player while this unit was in play.  This shares a cooldown with Clone Relic.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "duplicate_equip"
            },
            {
              "default": true,
              "id": 625,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrinegood"
            }
          ]
        }
      ]
    },
    {
      "id": 1126,
      "name": "Cyclops Warwizard",
      "description": "The effortless command some Cyclops have over magic is truly terrifying. It is not hard to see that they once ruled, when this world was wilder. ",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 5,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8HE8De9Ae9AF0Aj9Ej9Feeiyvxtqufigkn",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2515,
          "apCost": 3,
          "name": "Cast: Alacrity",
          "shortDescription": "Area Effect 3, Range 4: Friendly champions gain 4 AP and lose 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "killing_stroke"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            },
            {
              "default": false,
              "id": 2216,
              "apCost": 0,
              "name": "Hunter: Mage",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "wizard_foe"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 161,
      "name": "Cyclops Youth",
      "description": "I don't care how old they are, they're big enough to fight! - Eehiist, Voil Queen",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 66,
      "hash": "dj9Bj9Af1Be9AE8Dj9Ej9Fj9Gemsszojgpnuqfeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1208,
          "apCost": 0,
          "name": "Debilitate",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "debuff"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        }
      ]
    },
    {
      "id": 1501,
      "name": "Daggerpede",
      "description": "Originally named Dagdapede for its discoverer, the creature's appearance has led to the more commonly heard \"Daggerpede.\"  The name is also appropriate due to its penchant for shiny objects.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 69,
      "hash": "ej9AJ8Jf1BF0Be9Af1Aj9Aj9Bevsojwmsuheigpf",
      "artist": "Alex Konstad",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 1259,
          "apCost": 0,
          "name": "Split",
          "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "duplicate"
        },
        {
          "id": 2973,
          "apCost": 0,
          "name": "Surge: Equipped",
          "shortDescription": "This unit gets +1 DMG for every equipped champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "surge_equipped"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": false,
              "id": 2998,
              "apCost": 0,
              "name": "Lay Trap: Acid",
              "shortDescription": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapthorn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            },
            {
              "default": true,
              "id": 3097,
              "apCost": 2,
              "name": "Toss Equipment",
              "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 42,
              "apCost": 0,
              "name": "Immunity: Acid",
              "shortDescription": "Acid damage that would be dealt to this unit is prevented. This unit may not become <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 515,
      "name": "Dark Apprentice",
      "description": "Your lessons fill my skull with precious death. My body thirsts for it! - Tachrim, Dark Apprentice",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 65,
      "hash": "dJ8JJ8IF0Be9Ae9BJ8GJ8HJ8Iwiwirfpnegepuvf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1310,
          "apCost": 3,
          "name": "Lich Apprentice",
          "shortDescription": "This unit loses 10 max HP and Lich friendly champions gain an additional +5 HP.\r\n\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "drain"
        },
        {
          "id": 1984,
          "apCost": 2,
          "name": "Worship: Lich",
          "shortDescription": "This champion loses 6 HP and gains <mechanic value=immobile>Immobile</mechanic> for 2 turns, and friendly Liches gain <ability value=117>Regeneration 3</ability> until this champion moves.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1308,
              "apCost": 0,
              "name": "Leverage: Lich",
              "shortDescription": "When this unit is deployed from the runedock, the next Lich that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1216,
              "apCost": 0,
              "name": "Equalize",
              "shortDescription": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 782,
      "name": "Dark Apprentice",
      "description": "Your lessons fill my skull with precious death. My body thirsts for it! - Tachrim, Dark Apprentice",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 65,
      "hash": "dj9Gj9Fe9AG2Be9Aj9Fj9Gj9Hmpyiirjnjlgtzig",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Nora Surge",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 43,
          "apCost": 0,
          "name": "Immunity: Disease",
          "shortDescription": "Disease damage that would be dealt to this unit is prevented. This unit may not become <condition value=diseased>Diseased</condition>.\r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_disease"
        },
        {
          "id": 1308,
          "apCost": 0,
          "name": "Leverage: Lich",
          "shortDescription": "When this unit is deployed from the runedock, the next Lich that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "cost"
        },
        {
          "id": 1310,
          "apCost": 3,
          "name": "Lich Apprentice",
          "shortDescription": "This unit loses 10 max HP and Lich friendly champions gain an additional +5 HP.\r\n\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "drain"
        },
        {
          "id": 105,
          "apCost": 0,
          "name": "Scorn",
          "shortDescription": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1308,
              "apCost": 0,
              "name": "Leverage: Lich",
              "shortDescription": "When this unit is deployed from the runedock, the next Lich that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1216,
              "apCost": 0,
              "name": "Equalize",
              "shortDescription": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 21,
      "name": "Dark Enchantress",
      "description": "The unwary soldier who catches sight of the Dark Enchantress quickly loses focus on his task.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch"
      ],
      "races": [
        "Undead",
        "Vampyre"
      ],
      "noraCost": 69,
      "hash": "cj9Ej9Dj9CG2BG2Bj9Cj9Dj9Eeeeeemsxqsowvoj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3397,
          "apCost": 0,
          "name": "Vampiric Thirst",
          "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 425,
              "apCost": 4,
              "name": "Possession",
              "shortDescription": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns, gains 2 AP and gains <ability value=1408>Chasm Walker</ability> for 4 turns. This unit gains <ability value=2474>Font Ignorance</ability> for 3 turns and becomes <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 2197,
              "apCost": 3,
              "name": "Blood Magic",
              "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1754,
              "apCost": 0,
              "name": "Hidden: Dead Magic Zone",
              "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            }
          ]
        }
      ]
    },
    {
      "id": 1503,
      "name": "Dark Familiar",
      "description": "\"Fetid flesh from rotten tomb be born again from darkness' womb to wrack, wreck, maim and wound.\" - Malefixia Xarlia",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 53,
      "hash": "ej9AJ8JG2BF0Be9Af1Aj9Cj9Detjgneknwkgepqf",
      "artist": "Thomas Babbey",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3022,
          "apCost": 5,
          "name": "Elsari Dusk",
          "shortDescription": "This champion becomes Stealthed and permanently gains +10 MAX HP, +5 DMG, +3 SPD, Stealth and Elusive. This ability begins on cooldown and is removed after use.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 25,
          "iconName": "familiar"
        },
        {
          "id": 1480,
          "apCost": 0,
          "name": "Veiled Flight",
          "shortDescription": "This unit gains <condition value=flying>Flying</condition> when <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "flight_veiled"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            },
            {
              "default": false,
              "id": 1396,
              "apCost": 0,
              "name": "Fading Light",
              "shortDescription": "When this champion recovers a nora globe, it becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2701,
              "apCost": 0,
              "name": "Shadestrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrain_dmz"
            },
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            }
          ]
        }
      ]
    },
    {
      "id": 184,
      "name": "Dark Knight",
      "description": "Ah' thought ah' killed you already! - Jornan Lighthammer, Defender of the High-Hammer Pass",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight",
        "Wizard"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 78,
      "hash": "dj9Dj9CG2Be9Af1AJ8Jj9Aj9Biiwohymnjiepleg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 694,
          "apCost": 0,
          "name": "Lich-born",
          "shortDescription": "This unit cannot be the target of spells.  When this unit is destroyed, it reanimates as a Lich Knight champion, loses Lich-born, gains +1 DEF, +4 DMG, <ability value=1>Flight</ability>, <ability value=105>Scorn</ability>, <ability value=99>Life Siphon</ability>, <ability value=36>Immunity: Magical</ability>, and gains <ability value=544>Attack: Magical</ability> as its basic attack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 35,
          "iconName": "ondeath"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1547,
      "name": "Dark Knight",
      "description": "Ah' thought ah' killed you already! - Jornan Lighthammer, Defender of the High-Hammer Pass",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Wizard"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 78,
      "hash": "ej9Fj9Ee9Bf1Ae9AE8DJ8GJ8Hohilexqzkgvhpn",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 694,
          "apCost": 0,
          "name": "Lich-born",
          "shortDescription": "This unit cannot be the target of spells.  When this unit is destroyed, it reanimates as a Lich Knight champion, loses Lich-born, gains +1 DEF, +4 DMG, <ability value=1>Flight</ability>, <ability value=105>Scorn</ability>, <ability value=99>Life Siphon</ability>, <ability value=36>Immunity: Magical</ability>, and gains <ability value=544>Attack: Magical</ability> as its basic attack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 35,
          "iconName": "ondeath"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 271,
      "name": "Dark Messenger",
      "description": "'Shrouded in mystery? What are you, some kind of minstrel? Just tell me if you killed it. - Javk, Jakei Ice-climber",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Spirit"
      ],
      "noraCost": 66,
      "hash": "dj9Gj9Fe9AF0AF0BJ8IJ8Jj9Ahvsmhymemsqqqzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2701,
          "apCost": 0,
          "name": "Shadestrike",
          "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrain_dmz"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": true,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1754,
              "apCost": 0,
              "name": "Hidden: Dead Magic Zone",
              "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 549,
      "name": "Dark Seductress",
      "description": "There is elegance in death, a beauty in disease and rotting flesh. - Caetian, Dark Seductress",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human",
        "Vampyre"
      ],
      "noraCost": 72,
      "hash": "dJ8HJ8Ge9Bf1BF0AJ8HJ8IJ8Jeeirlnnljlpljwf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 1754,
          "apCost": 0,
          "name": "Hidden: Dead Magic Zone",
          "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 3397,
              "apCost": 0,
              "name": "Vampiric Thirst",
              "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            }
          ]
        }
      ]
    },
    {
      "id": 510,
      "name": "Darkmarsh Concealer",
      "description": "The Darkmarsh know shadows. The umbra raised them from tads. - Cecaelia, Muse of Forglar",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 69,
      "hash": "dj9Dj9CG2Bf1AF0BJ8IJ8Jj9Anjtjgrshersosfg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 982,
          "apCost": 3,
          "name": "Cloak",
          "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 6 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 511,
      "name": "Darkmarsh Defiler",
      "description": "We are bestowing our gift of Forglar, but their bodies will not accept it. - Kaalnaim, Darkmarsh Defiler",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 68,
      "hash": "dj9Dj9CG2Bf1Af1AJ8Jj9Aj9Bkyipwzoqzmsohgg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2575,
          "apCost": 0,
          "name": "Defiling Aura",
          "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defile_corpse"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 3334,
              "apCost": 0,
              "name": "Sabotage: Poison",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            },
            {
              "default": true,
              "id": 145,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapoison"
            },
            {
              "default": false,
              "id": 1346,
              "apCost": 3,
              "name": "Poison Charge",
              "shortDescription": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_poison"
            }
          ]
        }
      ]
    },
    {
      "id": 1276,
      "name": "Darkmarsh Enforcer",
      "description": "The Darkmarsh continue to gain traction against the continued incursions into Swamp politics by the Circadians. Gekaal has been particularly accommodating, and several vital areas are now under the security of the Darkmarsh.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 67,
      "hash": "ej9Cj9Bf1Be9Be9AG2Aj9Aj9Bmeepqwtftjwfkpf",
      "artist": "Christian Fell",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2678,
          "apCost": 3,
          "name": "Binding Chains",
          "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "disable"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": true,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1275,
      "name": "Darkmarsh Fury",
      "description": "\"Darkmarsh propaganda? Look with your eyes, do you not see the burning villages? This is our plight while the Circadians have their gaze fixed firmly northward, chasing ghosts with the Fae and the Jakei.\" ~ Roenik, Darkmarsh Fury",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 70,
      "hash": "ej9Cj9Bf1Ae9Be9AG2AJ8Jj9Aeeilgnykumuhgpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1255,
          "apCost": 0,
          "name": "Inhibiting Touch",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "inhibit"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1392,
      "name": "Darkmarsh Instigator",
      "description": "It only takes one act to start a war.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 64,
      "hash": "ej9Dj9Cf1AF0Ae9AG2BJ8Jj9Aemnhrojnpjnempf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 9,
          "apCost": 0,
          "name": "Battlemaster",
          "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "aurapositive"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 3146,
              "apCost": 0,
              "name": "Aquatic Armaments",
              "shortDescription": "When a friendly champion with Aquatic, Semi-Aquatic, Race: Salaman, or Race: Boghopper becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1440,
              "apCost": 0,
              "name": "Confuse Attacker",
              "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "confuse"
            },
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1248,
      "name": "Darkmarsh Outlaw",
      "description": "The Darkmarsh's ranks have swelled in recent months, due to their anti-Circadian stance, as more Boghopper become critical of Gekaal's acceptance of the Circadians' aid.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 77,
      "hash": "eJ8JJ8Ig3Ae9Be9AF0Bj9Dj9Eeeeeeipllgexkpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2643,
          "apCost": 0,
          "name": "Brand of the Outlaw",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit gains <condition value=cursed>Cursed</condition>, <ability value=2260>Pariah</ability> and <ability value=2008>Liability</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "brand_of_the_outlaw"
        },
        {
          "id": 2251,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "combat_awareness"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 1274,
      "name": "Darkmarsh Shadow",
      "description": "\"The Shadows are in place, Gekaal. We can strike at a moment's notice.\" ~ Kan, Darkmarsh Outlaw",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk",
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 70,
      "hash": "ej9Cj9BF0Be9Be9AG2AJ8IJ8Jiwxvztuvowfkyo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2371,
          "apCost": 4,
          "name": "Flash Bomb",
          "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "flash_bomb"
        },
        {
          "id": 2686,
          "apCost": 0,
          "name": "Logistics: Flanking",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1354,
              "apCost": 0,
              "name": "Sneak",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2357,
              "apCost": 0,
              "name": "Shadowstrike",
              "shortDescription": "This champion becomes stealthed after making a basic attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        }
      ]
    },
    {
      "id": 1716,
      "name": "Darkmarsh Siphon",
      "description": "Xenophobia escalated in some members of the Darkmarsh to the point of paranoia; their heightened mental state rivals that of the Firk.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 77,
      "hash": "ej9Dj9CF0Af1AG2AG2BJ8HJ8Ioyzofkpwmlyxvqf",
      "artist": "Alex Brock",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3154,
          "apCost": 0,
          "name": "Enervating Touch",
          "shortDescription": "When this champion engages an enemy champion on its turn, that champion loses up to 2 AP and this champion gains AP equal to the amount lost. This ability can only trigger twice per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "touch_enervating"
        },
        {
          "id": 3220,
          "apCost": 0,
          "name": "Mind Siphon",
          "shortDescription": "When this champion is attacked by a basic attack, it gains the upgraded abilities of the attacking champion for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "mindsiphon"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 509,
      "name": "Darkmarsh Snatcher",
      "description": "Show no mercy and no remorse. Take from them, or they will take from you. - Creed of the Darkmarsh Snatchers",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 67,
      "hash": "dj9Dj9CG2Bf1AF0AJ8HJ8IJ8Jeerlpumyrjlrheg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1353,
          "apCost": 2,
          "name": "Snatch",
          "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "antiequip"
        },
        {
          "id": 2799,
          "apCost": 0,
          "name": "Still Life",
          "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            },
            {
              "default": true,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            },
            {
              "default": false,
              "id": 580,
              "apCost": 1,
              "name": "Assassinate",
              "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 10,
              "iconName": "stab"
            }
          ]
        }
      ]
    },
    {
      "id": 847,
      "name": "Darkmarsh Sorcerer",
      "description": "\"It is not enough to read a spell from a book. You must become the spell! Write them on your skin, let them soak into your Nora. This is what it means to be a sorcerer in my army.\" - Lemsu of Darkmarsh",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 73,
      "hash": "dj9Cj9BG2AG2BF0BJ8IJ8Jj9Aonhtfeitxqjgvfg",
      "artist": "Daniel Rudnicki ",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1399,
          "apCost": 1,
          "name": "Hex",
          "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "lossoflife"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 1786,
              "apCost": 3,
              "name": "Ritual of Destruction",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_damage"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1540,
      "name": "Darkmarsh Witch",
      "description": "\"Swamp witch?! You gobble nora like a mindless slag, come to my home, and call me witch? I am older than witches, and I am older than you. Now, drink this and remember your place.\" - Busha Bushae to Kartch, Finlord",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 78,
      "hash": "ej9Ej9Df1AF0Be9Ag3AJ8Jj9Aeeephygkusjetqf",
      "artist": "Darcie Banfield",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2954,
          "apCost": 0,
          "name": "Soul Trapper",
          "shortDescription": "This unit has +1 DMG for each charge it has.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "soulsift"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2167,
              "apCost": 0,
              "name": "Attack Charged",
              "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            },
            {
              "default": false,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 2172,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_death"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2117,
              "apCost": 5,
              "name": "Metamorphosis",
              "shortDescription": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "transform"
            }
          ]
        }
      ]
    },
    {
      "id": 747,
      "name": "Darkmarsh Zealot",
      "description": "Lemsu has taught them to fight. They are lost in their hatred, giving no thought to peace or balance. They only wish to exterminate. This is troubling. - Malalain of Forglar",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 67,
      "hash": "dj9Dj9CG2BG2Ae9BJ8GJ8HJ8Iukeiwvmwzkjneeg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1220,
          "apCost": 0,
          "name": "Final Word",
          "shortDescription": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "ondeath"
        },
        {
          "id": 2008,
          "apCost": 0,
          "name": "Liability",
          "shortDescription": "Friendly champions within 5 spaces of this champion have -1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "dampen"
        },
        {
          "id": 861,
          "apCost": 0,
          "name": "Tormented",
          "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 348,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 27,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets +2 DMG, and gains 1 additional rank of <ability value=15>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1000,
      "name": "Darkwing Swarm",
      "description": "Kenter tore at the air in a panic, eyes blinded by the heat of their blasts. He grabbed hold of one and razor-pin fangs tore into his hand. As he screamed and stumbled the tiny dragons descended on their prey.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 74,
      "hash": "ej9Gj9Ff1AE8De9Ae9AJ8Jj9Aerqqfemjnukwvo",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 1955,
          "apCost": 0,
          "name": "Numerous",
          "shortDescription": "This champion takes double damage from area of effect spells and half damage from ranged attacks. It counts as 3 champions for purposes of Bulwark and Surge abilities. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "swarm_of_moga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1822,
      "name": "Dawnmist",
      "description": "\"They're beautiful. I had heard of the Dawnmists from the older shamans, but seeing one for myself was unbelievable. Ah, I'm glad I was chosen to be a shaman.\" -- Jakei Adept, talking to friends in the evening",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 61,
      "hash": "eJ8HJ8Gf1AG2BG2Ae9BJ8Jj9Aeemwkyirqojrjpf",
      "artist": "Caio Monteiro",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 137,
          "apCost": 0,
          "name": "Frost Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novafrost"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1121,
              "apCost": 0,
              "name": "Wind Aura",
              "shortDescription": "Champions within 5 spaces of this champion are <condition value=grounded>Grounded</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 2796,
              "apCost": 0,
              "name": "Snowbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsnow"
            }
          ]
        }
      ]
    },
    {
      "id": 1735,
      "name": "De'lim",
      "description": "To accept revolution, one must first face hardship. I welcome the damage to the forest: it cauterizes a flawed past, so that we may see the way towards a brilliant future.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 89,
      "hash": "ej9Gj9Fg3Af1BG2Ae9Aj9Dj9Eeiyrwkyxoqztxtf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2840,
          "apCost": 0,
          "name": "Devotee of De'lim",
          "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "devotee_delim"
        },
        {
          "id": 885,
          "apCost": 3,
          "name": "Flame Siphon",
          "shortDescription": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "fire"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 3228,
          "apCost": 5,
          "name": "Mass Teleport",
          "shortDescription": "This champion is relocated to target space within 5 spaces. Friendly champions within 2 spaces are also relocated (distributed within the AE).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 3007,
              "apCost": 0,
              "name": "Purging Flames",
              "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dispel"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2900,
              "apCost": 0,
              "name": "Initiate: Devotee to De'lim",
              "shortDescription": "Target friendly champion within 3 spaces is Consumed By Fire (This champion is Shielded, Immobile, and Pacified. At the beginning of your turn, this champion takes 10 Fire Damage) and at the start of its next turn, it also gains <ability value=2840>Devotee of De'lim</ability> and <ability value=55>Resistance: Fire 2</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 3227,
              "apCost": 0,
              "name": "Power of Devotion",
              "shortDescription": "This champion has +2 MAX HP for each real friendly Plant or Elf, and an additional +1 DMG if the champion has <ability value=2840>Devotee of De'lim</ability> or <ability value=2820>Sacrifice of De'lim</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "powerofdevotion"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 364,
      "name": "Dead Fairy",
      "description": "Not all fairies are annoying; some are dead. But then, those can also be annoying. - Caldir, Elven youth",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Fairy",
        "Undead",
        "Zombie"
      ],
      "noraCost": 74,
      "hash": "dj9Dj9CG2BF0Ag3Aj9Dj9Ej9Fwfkjtshykuhnwkg",
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            }
          ]
        }
      ]
    },
    {
      "id": 1325,
      "name": "Deadly Tracker",
      "description": "You will see me again; then you die ~ Code of the Trackers",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer",
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 71,
      "hash": "eJ8HJ8Gf1AF0Ae9Ae9BJ8Jj9Aeevshrjlussjln",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 12,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "detection"
        },
        {
          "id": 2797,
          "apCost": 0,
          "name": "Logistics: Range",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +2 MAX RNG permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 167,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 466,
      "name": "Deadwood Strider",
      "description": "And now the Treefolk are forced to march with Serkan. They hold nothing sacred! - Alfina Lighthander",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Plant",
        "Treefolk",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "dj9Gj9Fe9Af1Ag3Aj9Dj9Ej9Fygyztxiwfmpymjg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "K'thir Forest"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1146,
          "apCost": 1,
          "name": "Disease Breath",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "diseaseaoe"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 2678,
              "apCost": 3,
              "name": "Binding Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 253,
              "apCost": 0,
              "name": "Damage Shield: Disease",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Disease damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_disease"
            },
            {
              "default": false,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": true,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            }
          ]
        }
      ]
    },
    {
      "id": 267,
      "name": "Death Guard",
      "description": "It is said that the very suits of armor of Serkan's death guard screams of misery, betraying their presence. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead"
      ],
      "noraCost": 50,
      "hash": "dj9Gj9Fe9AF0AG2Bj9Cj9Dj9Eeevojlpnevhnnhg",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 877,
          "apCost": 0,
          "name": "Bodyguard",
          "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "block"
        },
        {
          "id": 105,
          "apCost": 0,
          "name": "Scorn",
          "shortDescription": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 203,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 5 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "deathnovadisease"
            },
            {
              "default": true,
              "id": 204,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 8 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "deathnovadisease"
            },
            {
              "default": false,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            }
          ]
        }
      ]
    },
    {
      "id": 534,
      "name": "Death Harvester",
      "description": "I see possibilities here, amongst all these dead. Our enemies only see sorrow and loss. - Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Undead"
      ],
      "noraCost": 58,
      "hash": "dj9Fj9EE8Df1Bf1Bj9Aj9Bj9Ceeeiyietojgkrfg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1426,
          "apCost": 0,
          "name": "Death Harvest",
          "shortDescription": "When a friendly non-Illusion, non-Summoned champion is destroyed, you gain up to 12% of its nora cost, to a maximum of 7. This does not stack",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 13,
          "iconName": "ondeath"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1427,
          "apCost": 0,
          "name": "Scavenger",
          "shortDescription": "This champion can only attack champions and cannot attack champions that are at full health.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "devour"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 894,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 2 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            },
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": true,
              "id": 107,
              "apCost": 0,
              "name": "Immortality",
              "shortDescription": "When this unit is destroyed, its cooldown is set to 0. When this unit is deployed, your Shrine or Avatar loses 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ondeath"
            }
          ]
        }
      ]
    },
    {
      "id": 909,
      "name": "Death Lily",
      "description": "\"There is no flower like the Maljaran Death Lily. To gaze upon it is to be embraced by death itself - a most magnificent feeling.\" - Botany notes of Timothy the Vile",
      "maxRng": 4,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 6,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Plant"
      ],
      "noraCost": 71,
      "hash": "dJ8IJ8HF0Ag3AF0AJ8HJ8IJ8Jepuzklgnetshexf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 17,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 3, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "multiattack"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        },
        {
          "id": 2619,
          "apCost": 0,
          "name": "Zeal: Speed",
          "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "channel_speed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1094,
              "apCost": 0,
              "name": "Poison Eater",
              "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_poison"
            },
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            },
            {
              "default": true,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 3328,
              "apCost": 0,
              "name": "Hunter: Poisoned",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "poison"
            }
          ]
        }
      ]
    },
    {
      "id": 551,
      "name": "Deathcaster",
      "description": "The Deathcasters of Elsarin embrace death, using pain as a weapon. Few accept their self-destructive creed.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 76,
      "hash": "dJ8HJ8Ge9Bf1Bf1AJ8Jj9Aj9Bwqohytzirzilexf",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 550,
          "apCost": 0,
          "name": "Attack: Red Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "electric"
        },
        {
          "id": 189,
          "apCost": 0,
          "name": "Death Nova: Electricity",
          "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovaelec"
        },
        {
          "id": 1450,
          "apCost": 4,
          "name": "Death Pact",
          "shortDescription": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "bloodbond"
        },
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": true,
              "id": 1856,
              "apCost": 1,
              "name": "Thrash",
              "shortDescription": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1196,
              "apCost": 0,
              "name": "Body Jumper",
              "shortDescription": "When this unit is destroyed, the closest opposing champion is <condition value=possessed>Possessed</condition> and becomes <condition value=immobile>Immobile</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "possess"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 488,
              "apCost": 0,
              "name": "Soulsift",
              "shortDescription": "When this unit is destroyed, you gain nora equal to 20% of this units nora cost.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "soulsift"
            }
          ]
        }
      ]
    },
    {
      "id": 23,
      "name": "Decayed Mercenary",
      "description": "He makes a good soldier even in death. Fighting is something you never forget. - Lukis, Dark Adept",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 8,
      "hitPoints": 37,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 50,
      "hash": "cj9Bj9AJ8Jf1AG2BJ8Jj9Aj9Bqohnjnetzzvowzi",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 1258,
          "apCost": 0,
          "name": "Splintering",
          "shortDescription": "After this champion deals Physical damage to a champion on a close-combat attack, this champion loses 4 HP and gains +2 DMG and a Bone Spur is created in an adjacent space. When a champion with Race: Skeleton captures a Bone Spur, they gain +1 DMG for 1 turn and +2 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defpenalties"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 25,
      "name": "Deep Elf Assassin",
      "description": "The undisputed queen of the kill.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 80,
      "hash": "cJ8JJ8IJ8HF0Af1AJ8HJ8IJ8Joqoqoqzzolexirh",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 327,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at triple DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 20,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2172,
          "apCost": 0,
          "name": "Death Charged",
          "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "charged_death"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 2232,
          "apCost": 0,
          "name": "Nora Thief",
          "shortDescription": "Spend 4 charges.  Your opponent loses up to 15 nora and you gain an equal amount.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "nora_thief"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            }
          ]
        }
      ]
    },
    {
      "id": 293,
      "name": "Deep Elf Fanatic",
      "description": "These elves no longer have any visible trace of their K'Thir ancestry. They have been fully corrupted by the darkness of the Underdepths.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 77,
      "hash": "dJ8IJ8HF0AF0Af1AJ8Jj9Aj9Bpqhyxzgrleeexxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        },
        {
          "id": 861,
          "apCost": 0,
          "name": "Tormented",
          "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 317,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1445,
              "apCost": 0,
              "name": "Counter Attack: Ranged",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 129,
      "name": "Deep Elf Fire Dancer",
      "description": "Keep your eyes on the flames! -Ironfist Sergeant",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 71,
      "hash": "dJ8IJ8HF0Ae9AF0AJ8HJ8IJ8Jepnjphytuonhvvf",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3061,
              "apCost": 3,
              "name": "Solar Flare",
              "shortDescription": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 132,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        }
      ]
    },
    {
      "id": 1357,
      "name": "Deep Elf Infiltrator",
      "description": "Infiltrators are adept in providing intelligence to their allies, preferring to facilitate rather than execute.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 70,
      "hash": "ej9AJ8JG2AF0Ae9Af1Aj9Bj9Cevxklpyoqfigipf",
      "artist": "Michele Chang",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2785,
          "apCost": 0,
          "name": "Call of the Hunter",
          "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 1017,
          "apCost": 1,
          "name": "Knockout",
          "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "stun"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": true,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            },
            {
              "default": false,
              "id": 1189,
              "apCost": 0,
              "name": "Sentry",
              "shortDescription": "This unit's spell presence is increased by 3.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "sentry"
            }
          ]
        }
      ]
    },
    {
      "id": 702,
      "name": "Deep Elf Masochist",
      "description": "The elves of K`thir held compassion for their enemies. The Deep Elves would use this against them.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 71,
      "hash": "dj9AJ8Jf1AG2Ae9BJ8GJ8HJ8Iemwqzmwtzmhvzxf",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1269,
          "apCost": 2,
          "name": "Antagonize",
          "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3151,
              "apCost": 0,
              "name": "Bloodspurt",
              "shortDescription": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 27,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets +2 DMG, and gains 1 additional rank of <ability value=15>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2138,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +8 HP.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "plushealth"
            },
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1856,
              "apCost": 1,
              "name": "Thrash",
              "shortDescription": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 26,
      "name": "Deep Elf Mercenary",
      "description": "Self-sworn enemies and traitors of K'thir, they live for blood.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 66,
      "hash": "cj9Bj9AJ8Jf1Af1AJ8Jj9Aj9Bwmykexitzrqqwxi",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 353,
      "name": "Deep Elf Monk",
      "description": "Focus your mind, be angry, consuming, like fire. Put an arrow to fire, it consumes the arrow. Put an army to fire, and it consumes the army. Now, fire can spread or it can explode. Be fire, my friend.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 73,
      "hash": "dj9Cj9BG2AF0AG2Bj9Cj9Dj9Eeeruqwtqsszowig",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 213,
          "apCost": 0,
          "name": "Block",
          "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "block"
        },
        {
          "id": 338,
          "apCost": 0,
          "name": "Counterstrike",
          "shortDescription": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "counter"
        },
        {
          "id": 217,
          "apCost": 0,
          "name": "Dodge",
          "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 1237,
              "apCost": 0,
              "name": "Impenetrable",
              "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ironwill"
            }
          ]
        }
      ]
    },
    {
      "id": 228,
      "name": "Deep Elf Priestess",
      "description": "Celebrate in the glory of Lord Maxxarek, as he has saved us from the Darkness. - Deep Elf Priestess",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 66,
      "hash": "dJ8JJ8IF0Be9BE8Dj9Ej9Fj9Geeeeerhnjygepyg",
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 766,
          "apCost": 1,
          "name": "Magical Attack",
          "shortDescription": "This unit makes a Magical attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "magic"
        },
        {
          "id": 741,
          "apCost": 2,
          "name": "Relocate: Demon",
          "shortDescription": "Target friendly Demon within 5 spaces is relocated to a space adjacent to this unit.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1927,
      "name": "Deep Elf Renegade",
      "description": "Self-sworn enemies and traitors of K'thir, they live for blood.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 40,
      "hash": "cj9Bj9AJ8Jf1Af1AJ8Jj9Aj9Bwmykexitzrqqwxi",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": false,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 307,
      "name": "Deep Elf Ritualist",
      "description": "Demons are spiritual beings, albeit dark and twisted ones. Rituals are important to the Deep elves, to perform one perfectly is divine, and the slightest flaw brings a painful death to all who witness.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 66,
      "hash": "dj9Fj9EE8DF0Af1AJ8Jj9Aj9Bgygipqouxqqjrzg",
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        },
        {
          "id": 1786,
          "apCost": 3,
          "name": "Ritual of Destruction",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_damage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1919,
              "apCost": 0,
              "name": "Revere: Firemaw",
              "shortDescription": "While this champion is in play, Firemaw costs 10% less nora to deploy. While Firemaw is in play, this champion has <ability value=3088>Flameburst</ability> and <ability value=633>Terraform: Lava</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 3151,
              "apCost": 0,
              "name": "Bloodspurt",
              "shortDescription": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 3333,
              "apCost": 1,
              "name": "Blood Spear",
              "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. If the target is <condition value=bloodied>Bloodied</condition> or has less than 50% HP remaining, this champion vampiric heals for 8.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            },
            {
              "default": false,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 27,
      "name": "Deep Elf Scout",
      "description": "To see and be unseen - Maxim of the Nefari Scout",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 56,
      "hash": "cj9Dj9Cj9BG2Af1Aj9Bj9Cj9Dljrqftqhkllwxii",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        }
      ]
    },
    {
      "id": 294,
      "name": "Deep Elf Summoner",
      "description": "Who are they? -- Lord Maxxarek's shadow bound. They've been granted the power to control some of his lesser demons. - Nefari soldiers",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 73,
      "hash": "dj9Fj9EE8DF0Af1Bj9Aj9Bj9Ceeemjetufthtfeg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 579,
          "apCost": 2,
          "name": "Invigorate",
          "shortDescription": "Target champion within 2 spaces gains 4 AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "buff"
        },
        {
          "id": 903,
          "apCost": 4,
          "name": "Summon: Young Imp",
          "shortDescription": "Summon a Young Imp with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 11,
          "iconName": "sumimp"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 1785,
              "apCost": 3,
              "name": "Rite of Healing",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "fascinate"
            }
          ]
        }
      ]
    },
    {
      "id": 28,
      "name": "Deep Elf Temptress",
      "description": "She'll draw you in, and rip you apart.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 72,
      "hash": "cj9Cj9Bj9Af1Bf1Aj9Aj9Bj9Ceipshgrqouhilei",
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1455,
          "apCost": 0,
          "name": "Expedite",
          "shortDescription": "When this unit successfully attacks, you gain a rune reveal.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "scry"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 859,
      "name": "Deep Leviathan",
      "description": "\"And there are those that lurk deeper than we do, who serve no master. These are the ones a demon must fear.\" - Maxxarek, Prince of Sheoul",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Archdemon",
        "Elemental"
      ],
      "noraCost": 79,
      "hash": "dj9Dj9CG2BG2Bf1Bj9Aj9Bj9Cemwipsuofvvxkjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2164,
          "apCost": 0,
          "name": "Abuse Charged",
          "shortDescription": "When an opposing champion makes an attack against this champion, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_abuse"
        },
        {
          "id": 2168,
          "apCost": 0,
          "name": "Attack Charged",
          "shortDescription": "When this champion makes a basic attack, it gains 3 charges.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "charged_abuse"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2192,
          "apCost": 0,
          "name": "Cataclysm",
          "shortDescription": "Spend 15 charges.  All other champions within 8 spaces take 20 fire damage and this champion loses all remaining charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 20,
          "iconName": "cataclysm"
        },
        {
          "id": 2260,
          "apCost": 0,
          "name": "Pariah",
          "shortDescription": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "possess"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            },
            {
              "default": false,
              "id": 3007,
              "apCost": 0,
              "name": "Purging Flames",
              "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dispel"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 24,
      "name": "Deep Miner",
      "description": "Wars are not won by armies alone. - Rugolth, the Dwarven King",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 8,
      "hitPoints": 34,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 46,
      "hash": "cJ8IJ8HJ8Ge9Be9BJ8GJ8HJ8Iiymukpsxvqlyinh",
      "artist": "Kelly Hamilton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2204,
          "apCost": 2,
          "name": "Build Mine",
          "shortDescription": "A Mine relic with Mine (Friendly small champions adjacent to this relic gain Use Mine (This champion is relocated to a space adjacent to friendly Mine)) is deployed in target adjacent square.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 14,
          "iconName": "build_mine"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3064,
              "apCost": 0,
              "name": "Weighty",
              "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "weighty"
            },
            {
              "default": false,
              "id": 5,
              "apCost": 0,
              "name": "Lumbering",
              "shortDescription": "This champion's AP cost for each movement is increased by 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -18,
              "iconName": "lumbering"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 307,
              "apCost": 0,
              "name": "Nora Miner",
              "shortDescription": "At the beginning of your turn, you gain 3 nora.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 308,
              "apCost": 0,
              "name": "Nora Miner",
              "shortDescription": "At the beginning of your turn, you gain 6 nora.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "noragen"
            }
          ]
        }
      ]
    },
    {
      "id": 517,
      "name": "Deepcave Extractor",
      "description": "Some slags are old, remnants of a forgotten age. If they could still speak, perhaps we could understand their amazing ability to draw nora from the ground, and why it brings them such sorrow.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 6,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 57,
      "hash": "dj9Cj9BG2Ae9Bf1AJ8Jj9Aj9Bzztqziextzxtheg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 308,
          "apCost": 0,
          "name": "Nora Miner",
          "shortDescription": "At the beginning of your turn, you gain 6 nora.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "noragen"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 3134,
          "apCost": 2,
          "name": "Suppression",
          "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2002,
              "apCost": 0,
              "name": "Easy Target",
              "shortDescription": "This unit takes 30% more damage from ranged attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -10,
              "iconName": "easy_target"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1724,
              "apCost": 0,
              "name": "Depression",
              "shortDescription": "Champions within 3 spaces of this unit have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 964,
      "name": "Defiler Knight",
      "description": "The Defiler Knights are Korsien's personal retinue, a group of knights bound to serve him in battle. Defiler Knights can either be a human servant or an undead slave, but both follow Korsien with the same fervor.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Shaman"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 83,
      "hash": "dj9Dj9CG2Bg3Ae9Aj9Fj9Gj9Hmsuxvzvvhtzvfkg",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2335,
          "apCost": 3,
          "name": "Cast: Ghostly Visage",
          "shortDescription": "Target champion within 4 spaces becomes <condition value=incorporeal>Incorporeal</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "ethereal"
        },
        {
          "id": 2575,
          "apCost": 0,
          "name": "Defiling Aura",
          "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defile_corpse"
        },
        {
          "id": 3378,
          "apCost": 0,
          "name": "Knight of Despair",
          "shortDescription": "While General Korsien or Eldrick, Czar of the Void is in play, this champion has <ability value=1850>Frightful Blows</ability> and <ability value=2665>Psychological Warfare</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "revere"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 105,
          "apCost": 0,
          "name": "Scorn",
          "shortDescription": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2570,
              "apCost": 0,
              "name": "Surge: Spirit",
              "shortDescription": "This unit has +1 DMG for each friendly Spirit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_spirit"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": false,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            }
          ]
        }
      ]
    },
    {
      "id": 1748,
      "name": "Defiler of Skulls",
      "description": "\"Collecting skulls is a bit creepy. But color coding them is vastly more disturbing.\"",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Shaman"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 83,
      "hash": "eJ8IJ8HG2Bf1BG2AF0Aj9Cj9Dvferhvfmjruxxqf",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2335,
          "apCost": 3,
          "name": "Cast: Ghostly Visage",
          "shortDescription": "Target champion within 4 spaces becomes <condition value=incorporeal>Incorporeal</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "ethereal"
        },
        {
          "id": 2575,
          "apCost": 0,
          "name": "Defiling Aura",
          "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defile_corpse"
        },
        {
          "id": 3378,
          "apCost": 0,
          "name": "Knight of Despair",
          "shortDescription": "While General Korsien or Eldrick, Czar of the Void is in play, this champion has <ability value=1850>Frightful Blows</ability> and <ability value=2665>Psychological Warfare</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "revere"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 105,
          "apCost": 0,
          "name": "Scorn",
          "shortDescription": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2570,
              "apCost": 0,
              "name": "Surge: Spirit",
              "shortDescription": "This unit has +1 DMG for each friendly Spirit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_spirit"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": false,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            }
          ]
        }
      ]
    },
    {
      "id": 1049,
      "name": "Demolisher",
      "description": "\"An armored Destroyer?! Do they really need it? They're 'Destroyers' for Pox sake!\" - Glideye, Skeezik Herder",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 53,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 71,
      "hash": "ej9AJ8Jf1AE8De9Af1AJ8Jj9Aevxvofevqftuqo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2427,
          "apCost": 0,
          "name": "Break the Line",
          "shortDescription": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2213,
          "apCost": 0,
          "name": "Crazed Charger",
          "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crazed_charger"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 2708,
              "apCost": 1,
              "name": "Gluttony",
              "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "devour"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        }
      ]
    },
    {
      "id": 280,
      "name": "Demolition Team",
      "description": "Ohh...the size of the boom! Shoulda seen the look in their eyes.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 80,
      "hash": "dj9Dj9CG2Be9Bf1AJ8Jj9Aj9Bohnjwthtsjyoqfg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 773,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fireaoe"
        },
        {
          "id": 3119,
          "apCost": 0,
          "name": "Provision: Offense",
          "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "plunder"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2099,
              "apCost": 0,
              "name": "Fire Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "artillery"
            },
            {
              "default": true,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2296,
              "apCost": 0,
              "name": "Summon: Land Mine",
              "shortDescription": "Summon a Land Mine relic with <ability value=601>Shadowspawn</ability> and <ability value=2149>Land Mine</ability> to target adjacent space.  This ability is hidden.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 15,
              "iconName": "landmine"
            },
            {
              "default": true,
              "id": 3147,
              "apCost": 0,
              "name": "Seism",
              "shortDescription": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 14,
              "iconName": "seism"
            }
          ]
        }
      ]
    },
    {
      "id": 409,
      "name": "Demon Lich",
      "description": "Denizens of the Underdepths typically eat their dead - waste not, want not. The liches are exempt from this practice, however, and for good reason.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf",
        "Lich",
        "Undead"
      ],
      "noraCost": 74,
      "hash": "dJ8IJ8HF0AF0Be9BJ8GJ8HJ8Iemnumuohilpwxvf",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1885,
          "apCost": 3,
          "name": "Cleansing Flame",
          "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "cleanse"
        },
        {
          "id": 1120,
          "apCost": 4,
          "name": "Set Ablaze",
          "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "fire"
        },
        {
          "id": 1143,
          "apCost": 0,
          "name": "Swarm: Deep-Elf Skeleton",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Deep-Elf Skeleton with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "swarm_skeleton"
        },
        {
          "id": 1271,
          "apCost": 0,
          "name": "Tempo",
          "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dancesong"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1926,
              "apCost": 0,
              "name": "Inscrutable Form",
              "shortDescription": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "inhibit"
            },
            {
              "default": false,
              "id": 1787,
              "apCost": 3,
              "name": "Rite of Power",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed and friendly champions gain +1 DMG permanently and gain +1 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "final_judgement"
            },
            {
              "default": false,
              "id": 3175,
              "apCost": 0,
              "name": "Eternal Life",
              "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "phylactery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 433,
      "name": "Demon Lich",
      "description": "Denizens of the Underdepths typically eat their dead - waste not, want not. The liches are exempt from this practice, however, and for good reason.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf",
        "Lich",
        "Undead"
      ],
      "noraCost": 74,
      "hash": "dj9Ej9Dg3AF0Be9BJ8GJ8HJ8Ieeevkjthnjnuxzg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1885,
          "apCost": 3,
          "name": "Cleansing Flame",
          "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "cleanse"
        },
        {
          "id": 1120,
          "apCost": 4,
          "name": "Set Ablaze",
          "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "fire"
        },
        {
          "id": 1143,
          "apCost": 0,
          "name": "Swarm: Deep-Elf Skeleton",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Deep-Elf Skeleton with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "swarm_skeleton"
        },
        {
          "id": 1271,
          "apCost": 0,
          "name": "Tempo",
          "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dancesong"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1926,
              "apCost": 0,
              "name": "Inscrutable Form",
              "shortDescription": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "inhibit"
            },
            {
              "default": false,
              "id": 1787,
              "apCost": 3,
              "name": "Rite of Power",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed and friendly champions gain +1 DMG permanently and gain +1 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "final_judgement"
            },
            {
              "default": false,
              "id": 3175,
              "apCost": 0,
              "name": "Eternal Life",
              "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "phylactery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 875,
      "name": "Demonbarb Spider",
      "description": "L'arim pulled away from the hissing creature, only to be caught in sticky silk. He turned to face a spider, massive in size, with barbed legs. He cut free from the web and pulled away. As he ran, he could hear the spider clicking with delight.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 75,
      "hash": "dj9Fj9EE8Dg3Ae9BJ8GJ8HJ8Iygyxvhnumnlekyg",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 1805,
          "apCost": 3,
          "name": "Weave Web",
          "shortDescription": "Area Effect 2, Range 3: Affected area is becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "web"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2091,
              "apCost": 0,
              "name": "Dragging Attack",
              "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        }
      ]
    },
    {
      "id": 1654,
      "name": "Demonic Sandclaw",
      "description": "Some alliances are built on violence and blood, rather than words or politics.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 66,
      "hash": "eJ8JJ8If1BF0BG2AF0Bj9Aj9Beeeeersmuhgyoqf",
      "artist": "Markus Erdt",
      "factions": [
        "Sundered Lands",
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 28,
          "apCost": 0,
          "name": "Blood Frenzy",
          "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 3142,
          "apCost": 0,
          "name": "Empowered: Speed",
          "shortDescription": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "empowered_speed"
        },
        {
          "id": 2619,
          "apCost": 0,
          "name": "Zeal: Speed",
          "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "channel_speed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": true,
              "id": 1100,
              "apCost": 0,
              "name": "Sandstriker",
              "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 1013,
      "name": "Demonologist",
      "description": "\"You!, get out front and draw their fire or I'll flay you where you stand!\" - Skrin, Demonologist",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf",
        "Vampyre"
      ],
      "noraCost": 79,
      "hash": "eJ8HJ8Gf1BE8De9Ae9Bj9Aj9Bemwqssmumuxmjn",
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 2432,
          "apCost": 0,
          "name": "Cast: Dark Pact",
          "shortDescription": "Target a champion you own within 5 spaces. The next time this champion is the target of a spell within 6 turns, that spell is cast upon the closest enemy champion instead. Your shrine or avatar takes 5 damage when triggered. If the champion is not a valid target, the spell fizzles. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 6,
          "noraCost": 10,
          "iconName": "boost"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 1786,
          "apCost": 3,
          "name": "Ritual of Destruction",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_damage"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 485,
              "apCost": 0,
              "name": "Souldrinker",
              "shortDescription": "When this unit destroys a champion, it heals HP equal to half the destroyed champions's nora cost.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "nora_eater"
            },
            {
              "default": false,
              "id": 903,
              "apCost": 4,
              "name": "Summon: Young Imp",
              "shortDescription": "Summon a Young Imp with no upgrades to target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 11,
              "iconName": "sumimp"
            },
            {
              "default": false,
              "id": 1426,
              "apCost": 0,
              "name": "Death Harvest",
              "shortDescription": "When a friendly non-Illusion, non-Summoned champion is destroyed, you gain up to 12% of its nora cost, to a maximum of 7. This does not stack",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 13,
              "iconName": "ondeath"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1143,
              "apCost": 0,
              "name": "Swarm: Deep-Elf Skeleton",
              "shortDescription": "When this champion destroys a champion on a basic attack, a Deep-Elf Skeleton with no upgrades is summoned under your control in the location the destroyed champion occupied.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "swarm_skeleton"
            },
            {
              "default": true,
              "id": 2464,
              "apCost": 2,
              "name": "Blood for Nora",
              "shortDescription": "This unit loses 20 health. The next spell you cast this turn has its Nora cost reduced by 20. This effect does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1050,
      "name": "Demonvein Vampyre",
      "description": "\"Most undead care nothing for blood, these Vampyres however share a common hunger with demonkind. Let us exploit that hunger to it's utmost...\" -Maxxarek, Overlord of Sheoul",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 82,
      "hash": "ej9AJ8Jf1BE8De9Af1Aj9Aj9Bpwxkwiyzzvvouo",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2634,
          "apCost": 0,
          "name": "Brain Eater",
          "shortDescription": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_disease"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 2434,
          "apCost": 0,
          "name": "Leech Vitality",
          "shortDescription": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "overkill"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 3397,
          "apCost": 0,
          "name": "Vampiric Thirst",
          "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 2551,
              "apCost": 2,
              "name": "Bloodseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=bloodied>Bloodied</condition> or less than 50% HP and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 707,
      "name": "Depths Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the cruel depths of Sheoul.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Af1Bj9Aj9Bj9Ceerlufilwxfkneg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1329,
              "apCost": 0,
              "name": "Domain: Lava",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_lava"
            },
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 1673,
      "name": "Depths Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the cruel depths of Sheoul.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Af1Bj9Aj9Bj9Ceerlufilwxfkneg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1329,
              "apCost": 0,
              "name": "Domain: Lava",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_lava"
            },
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 358,
      "name": "Destroyer",
      "description": "One cannot run from the great and hideous Destroyer. It can cover a great distance quickly, and it can consume a mounted Knight whole, flesh, bone, armor, and the horse he rides. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 75,
      "hash": "dj9Dj9CG2BF0AF0AJ8HJ8IJ8Jeemjrjwqwkeevzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 1467,
          "apCost": 4,
          "name": "Seismic Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "leap_massive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1856,
              "apCost": 1,
              "name": "Thrash",
              "shortDescription": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        }
      ]
    },
    {
      "id": 30,
      "name": "Diamondhide Basilisk",
      "description": "Their skin is tough and their temper short.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 71,
      "hash": "cj9Cj9Bj9Af1Bf1Bj9Aj9Bj9Cevxonsousjwvsfi",
      "artist": "Roberto Cirillo",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 295,
          "apCost": 0,
          "name": "Deflect",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2094,
              "apCost": 0,
              "name": "Combo Attack: Stun",
              "shortDescription": "When this champion makes two successful basic attacks that deal damage against the same champion in a single turn, that champion becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 15,
              "iconName": "comboatk_rend"
            },
            {
              "default": true,
              "id": 2334,
              "apCost": 2,
              "name": "Petrifying Gaze",
              "shortDescription": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "petrifying_gaze"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 261,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +7 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 1749,
      "name": "Dirge's Day Marcher",
      "description": "The Moga Lord's Guards celebrate what they call \"Dirge's Day\"... pretty much whenever they want. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 7,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 57,
      "hash": "eJ8IJ8Hg3Af1BG2AF0Aj9Dj9Eeigklgiilpwzgrf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1992,
          "apCost": 0,
          "name": "Dirge's Guard",
          "shortDescription": "While Dirge, Moga Lord is in play, this champion gets +5 HP, +3 DMG and Bodyguard.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "revere"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            },
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        }
      ]
    },
    {
      "id": 273,
      "name": "Dirge, Moga Lord",
      "description": "I thought those little monsters were supposed to be vulnerable without the G'Hern... RETREAT!  - Bribok, Boghopper Bull",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 83,
      "hash": "dj9Cj9BG2Ae9Bg3Aj9Dj9Ej9Fkluqwvqhpqzohig",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 853,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "allybuffs"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            },
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 1857,
      "name": "Dirge, Moga Lord",
      "description": "I thought those little monsters were supposed to be vulnerable without the G'Hern... RETREAT!  - Bribok, Boghopper Bull",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 83,
      "hash": "ej9Bj9Ae9BG2BG2Af1BJ8GJ8Hgkufvvkyohiroqf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 853,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "allybuffs"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            },
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 1363,
      "name": "Dirge, Moga Lord",
      "description": "I thought those little monsters were supposed to be vulnerable without the G'Hern... RETREAT!  - Bribok, Boghopper Bull",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 83,
      "hash": "ej9Bj9AF0AF0Ae9Af1BJ8HJ8Ikjtfpsxmusqsso",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 853,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "allybuffs"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            },
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 568,
      "name": "Disciple of the Chillshard",
      "description": "Through meditation, there is no need for knives. The mind can be far more deadly. - Shardseer Argol",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk",
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 75,
      "hash": "dJ8JJ8IF0Bf1Be9BJ8GJ8HJ8Ioqoqjrwtfkpyowf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 1463,
          "apCost": 0,
          "name": "Iceguard",
          "shortDescription": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "iceguard"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1130,
              "apCost": 0,
              "name": "Ally: Forglar Swamp",
              "shortDescription": "While there are other friendly Forglar Swamp champions in play, this champion gets +7 HP and +2 DMG. Forglar champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fs"
            },
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 137,
      "name": "Disturbed Spirit",
      "description": "Our land has been stripped of its name, as these shades have been stripped of their lives. Their endless screams echo our suffering. Serkan, the Lich King",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 0,
      "hitPoints": 26,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 46,
      "hash": "dJ8IJ8HF0Ae9AG2Bj9Cj9Dj9Eeevkgnnlpyievzg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2067,
          "apCost": 0,
          "name": "Frightful Aura",
          "shortDescription": "All opposing champions within 3 spaces have -2 DMG. All friendly undead champions within 3 spaces have +2 DEF.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "fear"
        },
        {
          "id": 599,
          "apCost": 0,
          "name": "Ghost",
          "shortDescription": "This champion is <condition value=incorporeal>Incorporeal</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "ghost"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 149,
          "apCost": 0,
          "name": "Sonic Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3367,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 1 HP for each AP they have.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3137,
              "apCost": 2,
              "name": "Dread Field",
              "shortDescription": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "dread_field"
            },
            {
              "default": true,
              "id": 1807,
              "apCost": 0,
              "name": "Deafening Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "deafening_aura"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 426,
      "name": "Draco-Lich",
      "description": "Vindrax, many of your children have fallen, but they are not lost. - Xulos",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Dragon",
        "Lich",
        "Undead",
        "Zombie"
      ],
      "noraCost": 83,
      "hash": "dj9AJ8Jf1AF0Bf1Bj9Aj9Bj9Ceeevqlnuhronjeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1702,
          "apCost": 0,
          "name": "Blockade",
          "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "blockade"
        },
        {
          "id": 939,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 3 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "drain"
        },
        {
          "id": 1146,
          "apCost": 1,
          "name": "Disease Breath",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "diseaseaoe"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 98,
              "apCost": 0,
              "name": "Lifedrinker",
              "shortDescription": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 2537,
              "apCost": 0,
              "name": "Revel in Misery",
              "shortDescription": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "forsaken_conduit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2142,
              "apCost": 0,
              "name": "Zombie Apocalypse",
              "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "zombie_apoc"
            },
            {
              "default": true,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        }
      ]
    },
    {
      "id": 931,
      "name": "Dragon Engine",
      "description": "Kulmun Stormbrow thought his invention would usher in a new era of dwarven construct-shaping. However, the Dragon Engine was considered too destructive even as a siege weapon.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 1,
      "damage": 15,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 56,
      "hash": "dj9AJ8Jf1Ag3Af1AJ8Jj9Aj9Bepjwfronhygvsfg",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 1886,
          "apCost": 4,
          "name": "Annihilate",
          "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "novafire"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2293,
          "apCost": 0,
          "name": "Mobilize Engine",
          "shortDescription": "This ability costs 15 nora to use.  This champion's speed is set to 7 for 1 turn, and it gains 9 AP.  This champion loses all AP at the end of this turn.  This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "mobilize_engine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 344,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +6 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            }
          ]
        }
      ]
    },
    {
      "id": 233,
      "name": "Dragon Handler",
      "description": "Chosen for their remarkably rare immunities, the Dragon Handlers are the elite protectors of Valdec's most valuable assets.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 74,
      "hash": "dJ8JJ8IF0Be9Bf1Bj9Aj9Bj9Ceeeeemeggrhepyg",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3330,
          "apCost": 0,
          "name": "Commander: Dragon",
          "shortDescription": "Friendly champions within 5 spaces with Race: Dragon have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "improve_damage"
        },
        {
          "id": 766,
          "apCost": 1,
          "name": "Magical Attack",
          "shortDescription": "This unit makes a Magical attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "magic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2960,
          "apCost": 0,
          "name": "Valdac's Soul",
          "shortDescription": "When this unit dies the nearest friendly <mechanic value=dragonkin>Dragonkin</mechanic> gains <ability value=2959>Valdac's Chosen</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "revere"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 877,
              "apCost": 0,
              "name": "Bodyguard",
              "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1342,
              "apCost": 2,
              "name": "Impart",
              "shortDescription": "Target champion within 3 spaces is healed for 5 HP and gains 1 DMG. This unit loses 8 life and gains -1 DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 3165,
              "apCost": 0,
              "name": "Mason's Spire",
              "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1898,
              "apCost": 0,
              "name": "Blessing of the Fallen",
              "shortDescription": "When this unit is destroyed, friendly champions gain +1 DEF for 4 turns (this does not stack) and heal 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ondeath"
            }
          ]
        }
      ]
    },
    {
      "id": 1537,
      "name": "Dragonbark Protector",
      "description": "\"Camp here, this Dragonbark tree feels different than the others, like its moving under its bark, waiting to emerge. With any luck, we should have a powerful ally by morning\" - Kri, Druid of the Waters",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon",
        "Plant",
        "Treefolk"
      ],
      "noraCost": 63,
      "hash": "ej9Ej9De9BF0Be9Ag3AJ8GJ8Heepjyouszolygpf",
      "artist": "Darcie Banfield",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1190,
          "apCost": 0,
          "name": "Fleet",
          "shortDescription": "When this champion is deployed, it gains 5 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "initiative"
        },
        {
          "id": 2950,
          "apCost": 0,
          "name": "Relic Drop: Tree",
          "shortDescription": "When this champion is deployed, it spends the first 4 turns as an Tree relic with 1 DEF and 20 HP. When this unit is destroyed, it becomes the same Tree relic.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "rapid_growth"
        },
        {
          "id": 1312,
          "apCost": 3,
          "name": "Sweep",
          "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 35,
              "apCost": 0,
              "name": "Immunity: Physical",
              "shortDescription": "Physical damage that would be dealt to this unit is prevented. This unit may not be <condition value=eviscerated popup=false>Eviscerated</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "immunity_physical"
            },
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            },
            {
              "default": true,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            }
          ]
        }
      ]
    },
    {
      "id": 740,
      "name": "Drakewing Swarm",
      "description": "Kenter tore at the air in a panic, eyes blinded by the heat of their blasts. He grabbed hold of one and razor-pin fangs tore into his hand. As he screamed and stumbled the tiny dragons descended on their prey.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2AG2Af1AJ8Jj9Aj9Bnykpyitqfkwkggg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 1955,
          "apCost": 0,
          "name": "Numerous",
          "shortDescription": "This champion takes double damage from area of effect spells and half damage from ranged attacks. It counts as 3 champions for purposes of Bulwark and Surge abilities. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "swarm_of_moga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 680,
      "name": "Drakon",
      "description": "With time and training, Rugolth's young wyrm became a steadfast guardian of the Stronghold.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 14,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 91,
      "hash": "dJ8IJ8HF0AG2AF0BJ8IJ8Jj9Amwzzonhvssfkgyg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2459,
          "apCost": 0,
          "name": "Honorary Sigil",
          "shortDescription": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "griffin_sigil"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2557,
              "apCost": 0,
              "name": "Martyrdom",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 8 HP. If this unit shares a race with the destroyed unit, also gain +1 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "intensify"
            },
            {
              "default": true,
              "id": 1469,
              "apCost": 0,
              "name": "Nexus Aura",
              "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "nexus_aura"
            },
            {
              "default": false,
              "id": 1976,
              "apCost": 3,
              "name": "Wail of Grief",
              "shortDescription": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novasonic"
            }
          ]
        }
      ]
    },
    {
      "id": 31,
      "name": "Draksar Archer",
      "description": "My archers are there to get anything I miss. - Akakios, Draksar Lord",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "cj9AJ8JJ8IF0Bf1BJ8IJ8Jj9Aemwvxqwvxtsxvvh",
      "artist": "Roberto Cirillo",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 736,
      "name": "Draksar Augmenter",
      "description": "The Draksar used magic to enhance themselves; a practice adopted by the Augmenters. Unlike the Spellswords, the Augmenters used magic on the body. To the Augmenters, the body was the only weapon in battle.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute",
        "Wizard"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2AG2Ae9Aj9Fj9Gj9Hneexmplnjyvxiig",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 550,
          "apCost": 0,
          "name": "Attack: Red Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "electric"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2763,
          "apCost": 0,
          "name": "Lightning Amped",
          "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Electricity Aura 3.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amped"
        },
        {
          "id": 2262,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 3142,
              "apCost": 0,
              "name": "Empowered: Speed",
              "shortDescription": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_speed"
            },
            {
              "default": true,
              "id": 3136,
              "apCost": 0,
              "name": "Empowered: Offense",
              "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_offense"
            }
          ]
        }
      ]
    },
    {
      "id": 1837,
      "name": "Draksar Beastlord",
      "description": "As the main Legion force fell back to guard weapons development in the homeland, outskirt territory was turned over to Beastlords, units better equipped to harry the enemy and survive on their own.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Draksar"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8IE8DG2BG2AF0Bj9Ej9Fwiwilnlumjrqsqf",
      "artist": "Grant Griffin",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3029,
          "apCost": 0,
          "name": "Hunter: Crippled",
          "shortDescription": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "hunter_crippled"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 3288,
          "apCost": 0,
          "name": "Sabotage: Armor",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "sabotage_armor"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": true,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": true,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        }
      ]
    },
    {
      "id": 677,
      "name": "Draksar Berserker",
      "description": "Welcome your new brothers, children. They were known as Garu. Now, they are kin. - Avix, Broodqueen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Draksar",
        "Garu"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9BG2Af1Bj9Aj9Bj9Cevxtjitxtmshrzg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 25,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "berserker"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 1063,
              "apCost": 0,
              "name": "Kill Frenzy ",
              "shortDescription": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "furious_attacks"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 495,
      "name": "Draksar Bookburner",
      "description": "Countless texts were destroyed in the Draksar's war against slander. Valdac's history was a casualty.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "dj9Bj9Af1Bf1AF0BJ8IJ8Jj9Aemleekpnhyvxxzg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1392,
          "apCost": 2,
          "name": "Book Burn",
          "shortDescription": "No spells may be cast for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "bookburn"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1885,
              "apCost": 3,
              "name": "Cleansing Flame",
              "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": true,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        }
      ]
    },
    {
      "id": 32,
      "name": "Draksar Broodling",
      "description": "It's a wonder any of them survive to reproduce. -Marus, K'thir Temple Scholar",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 4,
      "hitPoints": 21,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 35,
      "hash": "cJ8IJ8HJ8Ge9BG2AJ8GJ8HJ8Iilrlwzxxzvvfpqh",
      "artist": "Kelly Hamilton",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 1448,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "deathnovalava"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 115,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 252,
      "name": "Draksar Broodling",
      "description": "It's a wonder any of them survive to reproduce. -Marus, K'thir Temple Scholar",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 4,
      "hitPoints": 21,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 35,
      "hash": "dj9Cj9BG2Ae9BF0AJ8HJ8IJ8Jjrlyziemneitjyg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 1448,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "deathnovalava"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 115,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 33,
      "name": "Draksar Broodqueen",
      "description": "The broodqueens guarantee Akakios a limitless supply of broodlings.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 74,
      "hash": "cj9Dj9Cj9BG2Af1Bj9Bj9Cj9Dohykwtszojtsjii",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1053,
          "apCost": 3,
          "name": "Lay Hatchling",
          "shortDescription": "Unit summons a dragon egg relic to target adjacent space. At the end of the next turn, the egg will hatch into a Draksar Broodling.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "sumdragonegg"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": false,
              "id": 1721,
              "apCost": 4,
              "name": "Summon: Dragon",
              "shortDescription": "Summon a Dragon Homunculus on an adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "sumdragon"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1342,
              "apCost": 2,
              "name": "Impart",
              "shortDescription": "Target champion within 3 spaces is healed for 5 HP and gains 1 DMG. This unit loses 8 life and gains -1 DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 236,
      "name": "Draksar Chameleon",
      "description": "You sure this is the spot? -- Yeah, this is it. He must be late.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 65,
      "hash": "dJ8JJ8IF0Be9Bg3Aj9Dj9Ej9Fsmsmlwqoumyowfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 125,
          "apCost": 0,
          "name": "Damage Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novaphysical"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 1099,
              "apCost": 0,
              "name": "Hidden: Sand",
              "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3157,
              "apCost": 0,
              "name": "Sandbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": true,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 1530,
      "name": "Draksar Chameleon",
      "description": "You sure this is the spot? -- Yeah, this is it. He must be late.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 65,
      "hash": "ej9Dj9Cf1AF0Be9AG2BJ8Jj9Aeevowkekllnepqf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 125,
          "apCost": 0,
          "name": "Damage Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novaphysical"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 1099,
              "apCost": 0,
              "name": "Hidden: Sand",
              "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3157,
              "apCost": 0,
              "name": "Sandbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": true,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 235,
      "name": "Draksar Charger",
      "description": "The centaur have finished Changing...it is time to train them to fight. - Skak, Draksar Commander",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Centaur",
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "dJ8JJ8IF0Be9BG2Bj9Cj9Dj9Eeeeeeerqjrqwmeg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2214,
              "apCost": 0,
              "name": "Hunter: Scout",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_archer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3059,
              "apCost": 0,
              "name": "Thunderous Charge",
              "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "thunderous_charge"
            },
            {
              "default": false,
              "id": 2213,
              "apCost": 0,
              "name": "Crazed Charger",
              "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 2746,
              "apCost": 0,
              "name": "Strafing Strike",
              "shortDescription": "When this champion makes a successful basic attack, it gains Leap 3 for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 1839,
      "name": "Draksar Confessor",
      "description": "Some of the Morph are trained in the art of information extraction. Known as Confessors, speaking with one in their official capacity has been known to cause permanent scars.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Draksar",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "eJ8JJ8Ie9BG2BG2AF0BJ8GJ8Hukukuqszvfitfpf",
      "artist": "Josh Corpuz",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2364,
          "apCost": 1,
          "name": "Evolution: Draksar Confessor",
          "shortDescription": "This champion has <ability value=332>Sunder 1</ability>. When this ability is activated, the granted ability cycles to <ability value=1952>Slam</ability>, then to <ability value=3295>Healing Mind</ability>, then back to Sunder 1.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "mutation"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3308,
          "apCost": 5,
          "name": "Invoke: Confessor's Exaction",
          "shortDescription": "Area Effect 4: Enemy champions take 8 Psychic damage, lose 3 AP and are <condition value=confused>Confused</condition> for 3 turns. This effect is automatically triggered the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 8,
          "iconName": "invoke"
        },
        {
          "id": 3006,
          "apCost": 0,
          "name": "Nora Induction",
          "shortDescription": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ichor_utility"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 34,
      "name": "Draksar Constrictor",
      "description": "She curls and whirls around her prey until it can't live another day - Song of the Sundered Maidens",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 73,
      "hash": "cJ8JJ8IJ8HF0AG2AJ8HJ8IJ8Jygygygnjlnwqush",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 316,
      "name": "Draksar Consulate",
      "description": "Tell Rugolth that we will not sit idle while he corrupts the minds of our army. The Skeezick are no longer Ironfist, nor will they ever be again.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 75,
      "hash": "dJ8JJ8IF0BF0Ae9Aj9Fj9Gj9Hmsmsmyzoneklgeg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 2112,
              "apCost": 1,
              "name": "Grant: Draconic Force",
              "shortDescription": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 604,
      "name": "Draksar Doomsayer",
      "description": "The Draksar Empire must never rest. Failure looms over us, even as we prosper. Remember, Old Valdac crumbled because its people took respite. - Vernon, Doomsayer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior",
        "Wizard"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "dj9Bj9Af1Bf1BG2Bj9Cj9Dj9Eeemwqlevxfgpfig",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2113,
          "apCost": 2,
          "name": "Demoralizing Descant",
          "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "dreadsong"
        },
        {
          "id": 1732,
          "apCost": 3,
          "name": "Doom",
          "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 9,
          "iconName": "ondeath"
        },
        {
          "id": 3031,
          "apCost": 0,
          "name": "Imposing Aura",
          "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "imposing_aura"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 181,
      "name": "Draksar Explorer",
      "description": "Hey look! You see that? It's a Drakie! -- Just one though... you think I can get 'em from here? - Dwarven Tower Guards",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 63,
      "hash": "dj9Dj9CG2Be9Ae9Aj9Fj9Gj9Hirjwojnpquqllgg",
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1306,
              "apCost": 0,
              "name": "Mountaineer",
              "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "climb"
            },
            {
              "default": true,
              "id": 3157,
              "apCost": 0,
              "name": "Sandbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": false,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            }
          ]
        }
      ]
    },
    {
      "id": 1698,
      "name": "Draksar Fabricator",
      "description": "The new trade with Sundered Lands has disproportionately benefited those who control the means of production.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 63,
      "hash": "eJ8IJ8Hg3Af1AG2AF0Aj9Dj9Eerzgeinemphyzrf",
      "artist": "Shen Fei",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3390,
          "apCost": 0,
          "name": "Dune Armaments",
          "shortDescription": "When a friendly champion with Race: Draksar, Race: Skeezick or Race: Arthropod becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 2007,
          "apCost": 0,
          "name": "Helpless",
          "shortDescription": "This champion has <ability value=2002>Easy Target</ability> and <ability value=2001>Defenseless</ability> ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -17,
          "iconName": "defpenalties"
        },
        {
          "id": 1510,
          "apCost": 0,
          "name": "Market",
          "shortDescription": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "cost"
        },
        {
          "id": 1246,
          "apCost": 2,
          "name": "Pilfer",
          "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 7,
          "iconName": "antiequip"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3239,
              "apCost": 3,
              "name": "Clone Matter",
              "shortDescription": "Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one).",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 12,
              "iconName": "absorb_relic"
            },
            {
              "default": false,
              "id": 2508,
              "apCost": 0,
              "name": "Boost: Construct",
              "shortDescription": "Friendly champions with Race: Construct have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": true,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3195,
              "apCost": 0,
              "name": "Gift: Draketooth Rifle",
              "shortDescription": "The next champion you deploy from the runedock while this champion is in play is equipped with a Draketooth Rifle.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 25,
              "iconName": "gift"
            }
          ]
        }
      ]
    },
    {
      "id": 1697,
      "name": "Draksar Flashblade",
      "description": "Draksar Flashblades can throw weapons with preternatural accuracy and force, hampering those targets that don't die outright. ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 71,
      "hash": "eJ8IJ8HG2Af1AG2AF0Aj9Bj9Ceitoyonufthvqqf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3194,
          "apCost": 0,
          "name": "Ponderous Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "lumbering"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 3029,
              "apCost": 0,
              "name": "Hunter: Crippled",
              "shortDescription": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "hunter_crippled"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 35,
      "name": "Draksar Footman",
      "description": "It's a shame to be born as a footman, as you will spend most of your life trying not to lose them.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 55,
      "hash": "cJ8IJ8HJ8Ge9Bf1BJ8GJ8HJ8Imwmjyowoqzonjph",
      "artist": "Shayne Bingham",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 287,
              "apCost": 0,
              "name": "Riposte",
              "shortDescription": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +1 DMG.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1051,
      "name": "Draksar Forerunner",
      "description": "\"Listen me, I find 'em.\" - Clud, Forerunner",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 69,
      "hash": "ej9AJ8JG2AE8De9Af1Aj9Bj9Ceituonlrzojiyo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": true,
              "id": 2153,
              "apCost": 0,
              "name": "Combo Attack: Declare Target",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes Declared as Target for 1 turn (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "comboatk_drain"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            }
          ]
        }
      ]
    },
    {
      "id": 136,
      "name": "Draksar Gunner",
      "description": "Rugolth is a fool to think we do not have novelties of our own. Varia, Draksar Broodqueen",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 66,
      "hash": "dJ8IJ8HF0Ae9AG2Aj9Bj9Cj9Drjrsufkjnevvmyg",
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2780,
          "apCost": 2,
          "name": "Aim",
          "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "hunted"
        },
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1486,
          "apCost": 0,
          "name": "Strike",
          "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 2131,
              "apCost": 1,
              "name": "Bash",
              "shortDescription": "This champion makes a Physical melee attack against target champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "stab"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1444,
      "name": "Draksar High Marshal",
      "description": "\"They are all guilty, Vindrax. The only question is guilty of what?\" High Marshal Orwald",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 75,
      "hash": "ej9Gj9Fg3AF0Be9Ae9Aj9Dj9Eeerlpnhrjnnpyrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2642,
          "apCost": 0,
          "name": "Dictate",
          "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "dictate"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": false,
              "id": 2893,
              "apCost": 1,
              "name": "Death Sentence",
              "shortDescription": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=cleansed>Cleansed</mechanic> and it loses 5 HP for each condition removed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "final_judgement"
            },
            {
              "default": true,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            }
          ]
        }
      ]
    },
    {
      "id": 764,
      "name": "Draksar High Priest",
      "description": "The priests of Valdac gave their sermons from the books of the Dragon-Gods, of the Creator and the Destroyer. It was the one shred of their Soft-skin ancestors they could never release.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 74,
      "hash": "dj9Ej9Dg3AG2Ag3Aj9Dj9Ej9Fzkgpqofvzxieknh",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1993,
          "apCost": 0,
          "name": "Disciple of the Scale",
          "shortDescription": "While Vindrax is in play, this champion gains <ability value=1465>Instigate</ability> and <ability value=1786>Ritual of Destruction</ability>.  While Valdac is in play, this champion gains <ability value=371>Heal Mass 2</ability> and <ability value=3107>Ritual of Healing</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "revere"
        },
        {
          "id": 2436,
          "apCost": 2,
          "name": "Mutate",
          "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "mutation"
        },
        {
          "id": 1994,
          "apCost": 2,
          "name": "Sermon",
          "shortDescription": "Friendly champions that share a race with this one get +1 DEF, +2 DMG and +5 HP until this champion next moves. This ability does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2439,
              "apCost": 3,
              "name": "Cast: Blood of the Dragon",
              "shortDescription": "For 6 turns, all friendly <mechanic value=dragonkin>Dragonkin</mechanic> have <ability value=249>Damage Shield: Acid 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 6,
              "noraCost": 4,
              "iconName": "draconic"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1942,
      "name": "Draksar High Priest",
      "description": "The priests of Valdac gave their sermons from the books of the Dragon-Gods, of the Creator and the Destroyer. It was the one shred of their Soft-skin ancestors they could never release.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9Ee9Ae9AG2BE8Dj9Fj9Giinjykjpsmyzoqf",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dire Covenant",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1993,
          "apCost": 0,
          "name": "Disciple of the Scale",
          "shortDescription": "While Vindrax is in play, this champion gains <ability value=1465>Instigate</ability> and <ability value=1786>Ritual of Destruction</ability>.  While Valdac is in play, this champion gains <ability value=371>Heal Mass 2</ability> and <ability value=3107>Ritual of Healing</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "revere"
        },
        {
          "id": 2436,
          "apCost": 2,
          "name": "Mutate",
          "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "mutation"
        },
        {
          "id": 1994,
          "apCost": 2,
          "name": "Sermon",
          "shortDescription": "Friendly champions that share a race with this one get +1 DEF, +2 DMG and +5 HP until this champion next moves. This ability does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2439,
              "apCost": 3,
              "name": "Cast: Blood of the Dragon",
              "shortDescription": "For 6 turns, all friendly <mechanic value=dragonkin>Dragonkin</mechanic> have <ability value=249>Damage Shield: Acid 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 6,
              "noraCost": 4,
              "iconName": "draconic"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1582,
      "name": "Draksar Hunchback",
      "description": "The \"hunchback\" mutation does not look particularly useful on the outside, but does confer upon the Draksar the ability to absorb more kinetic force than normal.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "ej9Dj9CG2Be9BG2AG2Bj9Cj9Dqlnpuqoufvfvqsf",
      "artist": "Alex Konstad",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        },
        {
          "id": 410,
          "apCost": 1,
          "name": "Stun",
          "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "stun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2063,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "rebuke"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            },
            {
              "default": false,
              "id": 1879,
              "apCost": 0,
              "name": "Desert Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsand"
            }
          ]
        }
      ]
    },
    {
      "id": 289,
      "name": "Draksar Hunter",
      "description": "You thought you could get away, eh? - Dralpak, Draksar Hunter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 70,
      "hash": "dj9Fj9EE8DF0Ag3Aj9Dj9Ej9Foqsmwqftmleephg",
      "artist": "Trevor Claxton",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 3197,
              "apCost": 0,
              "name": "Homing Sense",
              "shortDescription": "This unit has <ability value=6>Mobility</ability>. At the beginning of its turns, if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>, this unit is relocated to the closest enemy champion within 5 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "homing_sense"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2644,
              "apCost": 2,
              "name": "Phantom Dash",
              "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1399,
      "name": "Draksar Interrogator",
      "description": "The powerful Mengclan were given the honor of leading the investigation into the disappearance of Vex. Some argued it was because of their political connections; Others argued it was their unique flare for cruel tortures.\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9De9BF0Ae9Ag3AJ8GJ8Hoqonuhtuxxfeepf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 1947,
              "apCost": 0,
              "name": "Entangling Attack",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1513,
              "apCost": 0,
              "name": "Train: Strike",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=1486>Strike</ability>. This ability costs 3 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 0,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1523,
              "apCost": 0,
              "name": "Train: Defense",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains +1 DEF.  This ability costs 2 nora and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "cost"
            },
            {
              "default": true,
              "id": 1526,
              "apCost": 0,
              "name": "Train: Evasive",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains 1 rank of Evasive (This unit takes 20% less damage from ranged attacks). This ability costs 3 nora and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 0,
              "iconName": "cost"
            }
          ]
        }
      ]
    },
    {
      "id": 131,
      "name": "Draksar Knight",
      "description": "Once paragons of virtue, their honor is now as corrupt as their skin. -- Rugolth, King of Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 69,
      "hash": "dJ8IJ8HF0Ae9AF0BJ8IJ8Jj9Arzkyvsjrhgrwiwf",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 607,
          "apCost": 0,
          "name": "Essence Capture",
          "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "noragen"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 1052,
      "name": "Draksar Legionnaire",
      "description": "\"It's been said real warriors carry swords, spears or axes. Then my Legion came, blasting through shields and armor with their Hellfire guns. Now they say, 'Warriors end the lives of their enemies, regardless of their weapon.'\" - Vindrax",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 73,
      "hash": "ej9AJ8JG2BE8De9Af1Aj9Cj9Dofxieexfxigegpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1549,
          "apCost": 0,
          "name": "Enduring Aura",
          "shortDescription": "Damage to friendly champions within 2 spaces is reduced by 1. (this ability and its effects do not stack)",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aurapositive"
        },
        {
          "id": 1987,
          "apCost": 2,
          "name": "Hold the Line",
          "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2271,
              "apCost": 0,
              "name": "Sentinel",
              "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        }
      ]
    },
    {
      "id": 36,
      "name": "Draksar Lord",
      "description": "Akakios and his broodqueens built their legions with one purpose: to take his vengeance on us. - Priest of Valdac",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 82,
      "hash": "cj9AJ8JJ8IF0BG2AJ8IJ8Jj9Aeilwfxxoqllygvh",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1241,
          "apCost": 0,
          "name": "Motivate",
          "shortDescription": "All other friendly champions have +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "allybuffs"
        },
        {
          "id": 2053,
          "apCost": 0,
          "name": "Rallying Cries",
          "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "allybuffs"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 1469,
              "apCost": 0,
              "name": "Nexus Aura",
              "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "nexus_aura"
            },
            {
              "default": true,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 879,
              "apCost": 0,
              "name": "Draconic Force",
              "shortDescription": "This champion gets +2 DMG for each friendly <mechanic value=dragonkin>Dragonkin</mechanic> within 2 spaces.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "draconic"
            },
            {
              "default": true,
              "id": 2969,
              "apCost": 0,
              "name": "Guarded: Draksar",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Draksar within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "bulwark_draksar"
            }
          ]
        }
      ]
    },
    {
      "id": 1286,
      "name": "Draksar Marauder",
      "description": "The Perfection Serum is a fabled formula coveted by the Draksar.  It allegedly stabilizes a creature's mutations, essentially preventing any future spontaneous mutations.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Draksar",
        "Mutant"
      ],
      "noraCost": 73,
      "hash": "ej9Dj9Cf1Be9Be9AG2Bj9Aj9Bvzinjrshneiepqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2167,
          "apCost": 0,
          "name": "Attack Charged",
          "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2696,
          "apCost": 0,
          "name": "Charged Fire Bomb",
          "shortDescription": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "fireaoe"
        },
        {
          "id": 2691,
          "apCost": 0,
          "name": "Mutation: Horror",
          "shortDescription": "Spend 4 charges: This champion gains <ability value=1850>Frightful Blows</ability> instead.  If it already has Frightful Blows, it gains <ability value=1330>Dread</ability> instead and this ability is removed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            }
          ]
        }
      ]
    },
    {
      "id": 887,
      "name": "Draksar Marine",
      "description": "Originating from the Boiled Sea, the Marines rarely make contact with Valdac. Currently, they operate along Maljara's coast, aiding the Draksar and Kanen.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar",
        "Mirefolk"
      ],
      "noraCost": 68,
      "hash": "dj9Gj9Fe9Ag3AF0BJ8IJ8Jj9Akgkrjgiwvmuhrfg",
      "artist": "Trevor Claxton",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 978,
              "apCost": 1,
              "name": "Sapping Strike",
              "shortDescription": "This champion makes a Physical attack for 12 damage against target enemy unit at RNG 2-5. If the target is successfully damaged, it loses all AP. This damage ignores DEF. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stab"
            },
            {
              "default": false,
              "id": 1130,
              "apCost": 0,
              "name": "Ally: Forglar Swamp",
              "shortDescription": "While there are other friendly Forglar Swamp champions in play, this champion gets +7 HP and +2 DMG. Forglar champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 37,
      "name": "Draksar Master",
      "description": "The Draksar Masters stop their troops only long enough to collect souvenirs.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 64,
      "hash": "cj9Ej9Dj9CG2Bf1Bj9Cj9Dj9Eeeeeipllepwqzmj",
      "artist": "Roberto Cirillo",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2893,
              "apCost": 1,
              "name": "Death Sentence",
              "shortDescription": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=cleansed>Cleansed</mechanic> and it loses 5 HP for each condition removed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "final_judgement"
            },
            {
              "default": true,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 1015,
      "name": "Draksar Morph",
      "description": "\"It is their purpose and duty to shape and form all living things; to evolve them into their truest and purest form.\" Avix, Broodqueen",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 76,
      "hash": "eJ8HJ8GF0BE8De9Ae9BJ8IJ8Jeetfgpjyrlumym",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2436,
          "apCost": 2,
          "name": "Mutate",
          "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "mutation"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": true,
              "id": 2340,
              "apCost": 3,
              "name": "Haste",
              "shortDescription": "Target champion within 5 spaces has +4 SPD for 3 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2339,
              "apCost": 4,
              "name": "Imbue: Stun",
              "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 9,
              "iconName": "amped"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2117,
              "apCost": 5,
              "name": "Metamorphosis",
              "shortDescription": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "transform"
            }
          ]
        }
      ]
    },
    {
      "id": 985,
      "name": "Draksar Persecutor",
      "description": "\"We must not cast our lesser children aside. They can fight for the Draksar Lord and should be shown the proper respects due to any other soldier.\" - Avix, Broodqueen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Draksar",
        "Mutant"
      ],
      "noraCost": 70,
      "hash": "ej9Fj9EE8DE8De9AE8Dj9Ej9Foququohkjrwxqo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2368,
          "apCost": 0,
          "name": "Mutation: Tough",
          "shortDescription": "Spend 3 charges: This champion gains a rank of <ability value=1900>Tough</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": true,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            }
          ]
        }
      ]
    },
    {
      "id": 676,
      "name": "Draksar Psion",
      "description": "All will know the joys of our gift. Soon, the world will celebrate our empire! - Varia, Broodqueen",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Draksar",
        "Firk"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9BG2Af1AJ8Jj9Aj9Buxxkjnnuhnexiyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "Sundered Lands"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        },
        {
          "id": 332,
          "apCost": 0,
          "name": "Sunder",
          "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "debuff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2112,
              "apCost": 1,
              "name": "Grant: Draconic Force",
              "shortDescription": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 906,
              "apCost": 0,
              "name": "Amplify: Psychic",
              "shortDescription": "All psychic damage is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_psychic"
            },
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1646,
      "name": "Draksar Pursuer",
      "description": "Stronghold scouts learned to never rest outside of the city, no matter how concealed, no matter how tired.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 66,
      "hash": "eJ8IJ8HG2AF0BG2AF0Aj9Bj9Ceerhiegnleiwoqf",
      "artist": "Markus Erdt",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 12,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "detection"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 1361,
      "name": "Draksar Ravenspeaker",
      "description": "The city of Caillin is filled with ravens, whose haunting gaze doesn't faze its citizens, but can be an unnerving sight to visitors, especially when coupled by the presence of a ravenspeaker.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 79,
      "hash": "ej9Bj9Ae9AF0Ae9Af1Bj9Fj9Gplumshnwtxzzipf",
      "artist": "Christian Fell",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2949,
          "apCost": 0,
          "name": "Attack: Raven",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2411,
          "apCost": 2,
          "name": "Dark Raven Form",
          "shortDescription": "This unit becomes a Dark Raven and gains <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, <ability value=13>Detection 3</ability>, <ability value=1399>Hex 2</ability> and Race: Beast. It's RNG becomes 1-1 and it is <mechanic value=cleansed>Cleansed</mechanic>. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "transform"
        },
        {
          "id": 1208,
          "apCost": 0,
          "name": "Debilitate",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "debuff"
        },
        {
          "id": 2948,
          "apCost": 2,
          "name": "Raven Tongue",
          "shortDescription": "Target summoned champion is destroyed, and a Raven Messenger with 10 HP and RNG 1-3 is summoned in its place, under your control",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "nora_hex"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            },
            {
              "default": true,
              "id": 1037,
              "apCost": 5,
              "name": "Deception",
              "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "planar"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1009,
              "apCost": 0,
              "name": "Tariff",
              "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 2436,
              "apCost": 2,
              "name": "Mutate",
              "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "mutation"
            }
          ]
        }
      ]
    },
    {
      "id": 608,
      "name": "Draksar Rocketeer",
      "description": "The soft-skins had one thing right; to defend your homeland, you do what's needed. If you need a better weapon, you make one. - Faerik, Draksar Rocketeer",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2Af1Be9BJ8GJ8HJ8Ifkjtuzzoumlgpyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1708,
          "apCost": 0,
          "name": "Ammunition",
          "shortDescription": "Once this champion has made at least 6 successful attacks, its range becomes 1.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "gun"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 3292,
          "apCost": 0,
          "name": "Reload",
          "shortDescription": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 412,
      "name": "Draksar Sandstalker",
      "description": "Of course the ground is shifting, fool! It's sand! - Ironfist scouting party, last words",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 76,
      "hash": "dJ8IJ8HF0AF0BF0BJ8IJ8Jj9Aemsosfiiymwqsxf",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 580,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1099,
          "apCost": 0,
          "name": "Hidden: Sand",
          "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 1100,
          "apCost": 0,
          "name": "Sandstriker",
          "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "offenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            },
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 434,
      "name": "Draksar Sandstalker",
      "description": "Of course the ground is shifting, fool! It's sand! - Ironfist scouting party, last words",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 76,
      "hash": "dj9Ej9Dg3AF0BF0AJ8HJ8IJ8Jjrqsjwtuvfepleg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 580,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1099,
          "apCost": 0,
          "name": "Hidden: Sand",
          "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 1100,
          "apCost": 0,
          "name": "Sandstriker",
          "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "offenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            },
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 360,
      "name": "Draksar Shifter",
      "description": "It is no secret that the Draksar covet their draconic blood. With great focus some have even been able to ascend to a true dragon form at will, if only for a while.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 82,
      "hash": "dj9Dj9CG2BF0Af1AJ8Jj9Aj9Bufeepnyzgkwoufg",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 979,
          "apCost": 2,
          "name": "Dragon Form",
          "shortDescription": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gains +2 DMG, <ability value=37>Immunity: Fire,</ability> <ability value=2525>Dragonflight</ability>, and <ability value=2400>Flamethrower</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        },
        {
          "id": 1033,
          "apCost": 2,
          "name": "Pit Dragon Form",
          "shortDescription": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gains +5 MAX HP, +5 DMG, <ability value=46>Resistance: Physical 1</ability>, and <ability value=50>Resistance: Magical 1</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2434,
              "apCost": 0,
              "name": "Leech Vitality",
              "shortDescription": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "overkill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        }
      ]
    },
    {
      "id": 357,
      "name": "Draksar Spellsword",
      "description": "Hatched in pairs and infused with the will of magic, one must slay the other to come of age. Fashioning the bones of the fallen into a magical sword, as brothers they fight until death.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 65,
      "hash": "dj9Dj9CG2BF0Ae9BJ8GJ8HJ8Iuvqjrufrjtzolyg",
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 745,
              "apCost": 0,
              "name": "Magic Eater",
              "shortDescription": "When this unit would take Magic damage, it instead recovers HP equal to half the damage that would have been dealt.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_magic"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 462,
      "name": "Dreadnought",
      "description": "\"Sezinok, Champion of Vindrax, I pray to you! Lend us your strength in this fight!\" - Avix, Brood Queen",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 17,
      "hitPoints": 70,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 107,
      "hash": "dj9Gj9Fe9Af1AF0BJ8IJ8Jj9Awqqowzzkpqzgyzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 746,
          "apCost": 0,
          "name": "Dead Eater",
          "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "nora_eater"
        },
        {
          "id": 16,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "multiattack"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": true,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            },
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            }
          ]
        }
      ]
    },
    {
      "id": 38,
      "name": "Dreadwing",
      "description": "Mosquitos that swat back. - Draksar Footman",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 6,
      "hitPoints": 37,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 65,
      "hash": "cj9Gj9Fj9EE8DF0Bj9Ej9Fj9Geitjrfmsowqllji",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        },
        {
          "id": 88,
          "apCost": 0,
          "name": "Vulnerability: Fire",
          "shortDescription": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3334,
              "apCost": 0,
              "name": "Sabotage: Poison",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": false,
              "id": 2357,
              "apCost": 0,
              "name": "Shadowstrike",
              "shortDescription": "This champion becomes stealthed after making a basic attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 593,
      "name": "Drudge Cyclops",
      "description": "Although the drudges spend their days with menial labor, their frustration fuels a fighting spirit in them. When threatened, anger becomes a flurry of strikes.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 58,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 70,
      "hash": "dj9AJ8Jf1Af1Bf1Bj9Aj9Bj9Ceeiyxvzxohthrfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1734,
          "apCost": 2,
          "name": "Drudgery",
          "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "debuff"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2414,
              "apCost": 1,
              "name": "Throw Boulder",
              "shortDescription": "This champion makes a Physical attack at RNG 2-5. This attack causes <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "rock"
            },
            {
              "default": false,
              "id": 3349,
              "apCost": 0,
              "name": "Peaks Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 39,
      "name": "Drunken Thug",
      "description": "I may be fight, but I still have some drunk in me.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 65,
      "hash": "cj9Cj9Bj9Af1Be9Aj9Aj9Bj9Cevfkeeiwqsqzxxi",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2217,
              "apCost": 0,
              "name": "Hunter: Brawler",
              "shortDescription": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_rogue"
            },
            {
              "default": true,
              "id": 348,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 24,
              "apCost": 0,
              "name": "Berserker",
              "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "berserker"
            }
          ]
        }
      ]
    },
    {
      "id": 1528,
      "name": "Drunken Thug",
      "description": "I may be fight, but I still have some drunk in me.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 65,
      "hash": "ej9Dj9CF0AF0Be9AG2BJ8HJ8Iemetfipnjtufgpf",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2217,
              "apCost": 0,
              "name": "Hunter: Brawler",
              "shortDescription": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_rogue"
            },
            {
              "default": true,
              "id": 348,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 24,
              "apCost": 0,
              "name": "Berserker",
              "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "berserker"
            }
          ]
        }
      ]
    },
    {
      "id": 450,
      "name": "Dryad",
      "description": "The dryad's seemingly placid nature is a guise to hide its cunning and devious intentions.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elf",
        "Plant",
        "Treefolk",
        "Vampyre"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9Bf1AF0BJ8IJ8Jj9Ajiiekpwtjrquowf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3242,
          "apCost": 2,
          "name": "Conduit: HP",
          "shortDescription": "Target enemy champion within 5 spaces loses 6 HP and the closest friendly champion to the target (including this one) vampiric heals for 6 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "conduit_hp"
        },
        {
          "id": 1261,
          "apCost": 0,
          "name": "Surge: Plant",
          "shortDescription": "This unit has +1 DMG for each friendly Plant.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge_plant"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 2820,
              "apCost": 2,
              "name": "Sacrifice of De'lim",
              "shortDescription": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "chan_fuel"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1337,
              "apCost": 0,
              "name": "Gift of Fertility",
              "shortDescription": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 1184,
      "name": "Dugon, Garu Stalwart",
      "description": "\"They ask me how I do it.  I tell them that I fear no enemy as long as my brethren fight alongside me.\" ~ Dugon, Garu Stalwart",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 60,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 88,
      "hash": "ej9Dj9Cf1Be9Ae9AG2Bj9Aj9Bshvqqqqzkjwzmpf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 854,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "allybuffs"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1505,
          "apCost": 1,
          "name": "Throw Shield",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "throw_shield"
        },
        {
          "id": 2604,
          "apCost": 4,
          "name": "Triumphant Roar",
          "shortDescription": "Enemy champions within 4 spaces take 12 Sonic damage and become <condition value=distracted>Distracted</condition> and <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 2295,
              "apCost": 0,
              "name": "Thirst for Battle",
              "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "thirst_for_battle"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            }
          ]
        }
      ]
    },
    {
      "id": 1470,
      "name": "Dugon, Garu Stalwart",
      "description": "\"They ask me how I do it.  I tell them that I fear no enemy as long as my brethren fight alongside me.\" ~ Dugon, Garu Stalwart",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 60,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 88,
      "hash": "eJ8HJ8GG2BF0Be9Ae9Bj9Cj9Deekyzgrjlnhgyo",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 854,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "allybuffs"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1505,
          "apCost": 1,
          "name": "Throw Shield",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "throw_shield"
        },
        {
          "id": 2604,
          "apCost": 4,
          "name": "Triumphant Roar",
          "shortDescription": "Enemy champions within 4 spaces take 12 Sonic damage and become <condition value=distracted>Distracted</condition> and <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 2295,
              "apCost": 0,
              "name": "Thirst for Battle",
              "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "thirst_for_battle"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            }
          ]
        }
      ]
    },
    {
      "id": 1667,
      "name": "Dum, the Moga Netter",
      "description": "No! After you release, you must hold tight! - Voil training Moga",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 58,
      "hash": "ej9Bj9Af1BF0BG2Af1Bj9Aj9Bevsmphvmuolgyrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1947,
              "apCost": 0,
              "name": "Entangling Attack",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        }
      ]
    },
    {
      "id": 461,
      "name": "Dune Walker",
      "description": "The sands will conceal our attack force, your Grace. - Derifos, Dune Walker",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman",
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 70,
      "hash": "dj9Gj9Fe9Af1AF0AJ8HJ8IJ8Jeekgiyvhtszroyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3111,
          "apCost": 1,
          "name": "Burning Sandspout",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged and is occupying Sand or is <condition value=sandblasted>Sandblasted</condition>, the target also becomes <condition value=charred>Charred</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 5 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "sandspout"
        },
        {
          "id": 1879,
          "apCost": 0,
          "name": "Desert Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainsand"
        },
        {
          "id": 1228,
          "apCost": 1,
          "name": "Grant: Trail Sand",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1102>Trail: Sand</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 1229,
          "apCost": 1,
          "name": "Grant: Tunnel Sand",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1150>Tunnel: Sand 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 2822,
          "apCost": 0,
          "name": "Ripples",
          "shortDescription": "When a friendly champion is deployed from the rune dock, this champion's cooldowns are reduced by 1.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1878,
              "apCost": 0,
              "name": "Desert Master",
              "shortDescription": "This champion has +1 DMG and +1 DEF for every 3 champions occupying sand terrain.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            },
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1254,
              "apCost": 0,
              "name": "Sand Veil",
              "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": false,
              "id": 3159,
              "apCost": 0,
              "name": "Spellsurge: Sandstorm",
              "shortDescription": "When this champion is deployed, Sandstorm spells are revealed from your runedock.  Sandstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Sandstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1099,
              "apCost": 0,
              "name": "Hidden: Sand",
              "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1341,
      "name": "Dunes Manticore",
      "description": "There is intense debate as to whether these creatures have always existed or are a more recent manifestation due to the plague.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 68,
      "hash": "eJ8JJ8Ie9AF0Ae9AF0Bj9Fj9Gwiwinhgykpwkwo",
      "artist": "Dan Masso",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3111,
          "apCost": 1,
          "name": "Burning Sandspout",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged and is occupying Sand or is <condition value=sandblasted>Sandblasted</condition>, the target also becomes <condition value=charred>Charred</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 5 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "sandspout"
        },
        {
          "id": 2334,
          "apCost": 2,
          "name": "Petrifying Gaze",
          "shortDescription": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "petrifying_gaze"
        },
        {
          "id": 3159,
          "apCost": 0,
          "name": "Spellsurge: Sandstorm",
          "shortDescription": "When this champion is deployed, Sandstorm spells are revealed from your runedock.  Sandstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Sandstorm spell is played.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1228,
              "apCost": 1,
              "name": "Grant: Trail Sand",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1102>Trail: Sand</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        }
      ]
    },
    {
      "id": 1156,
      "name": "Dusk Creeper",
      "description": "\"The Dusk Creeper is so named for its penchant for popping out when your eyes are still trying to adjust to changing light conditions.\" ~ Gillo's Guide to Poxanthuru",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 5,
      "damage": 10,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 70,
      "hash": "ej9Bj9AE8De9Ae9Af1Bj9Ej9Fkuojyztzxqjiwo",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2478,
          "apCost": 0,
          "name": "Improve Range",
          "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "improve_range"
        },
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        },
        {
          "id": 1849,
          "apCost": 0,
          "name": "Shroud",
          "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "aurapositive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 3142,
              "apCost": 0,
              "name": "Empowered: Speed",
              "shortDescription": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_speed"
            }
          ]
        }
      ]
    },
    {
      "id": 1053,
      "name": "Dusk Druid",
      "description": "They can hide things you wish not seen and reveal that which you wish to see most. - Bliss, Muse of K'thir",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 68,
      "hash": "ej9AJ8Jg3AE8De9Af1Aj9Dj9Eerzofeitjymwkpf",
      "artist": "Paul Guzenko",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1419,
          "apCost": 0,
          "name": "Adaptation",
          "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "adaptation"
        },
        {
          "id": 1376,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "resistance_ranged"
        },
        {
          "id": 2506,
          "apCost": 0,
          "name": "Psychic Ping",
          "shortDescription": "When this unit comes into play, it deals 6 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 6 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "psychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            },
            {
              "default": false,
              "id": 257,
              "apCost": 0,
              "name": "Damage Shield: Psychic",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Psychic damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 1245,
      "name": "Dwarven Alchemist",
      "description": "\"A little of this, a little of that. All things are possible when you start mixing dangerous chemicals together!\" ~ Serak, Dwarven Alchemist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 71,
      "hash": "eJ8JJ8If1Be9Be9AF0Bj9Aj9Bygyggipsumlpuo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 773,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fireaoe"
        },
        {
          "id": 1230,
          "apCost": 1,
          "name": "Grant: Damage Shield: Magical",
          "shortDescription": "Target champion within 5 spaces gains <ability value=225>Damage Shield: Magical 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 1,
          "iconName": "grantability"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 850,
              "apCost": 1,
              "name": "Acid Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "acidaoe"
            },
            {
              "default": false,
              "id": 1998,
              "apCost": 2,
              "name": "Grant: Action Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 12,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 3032,
              "apCost": 0,
              "name": "Quest: Support Ally",
              "shortDescription": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "opportunistic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2637,
              "apCost": 3,
              "name": "Grant: Stoneskin Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2638>Drink: Stoneskin Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 40,
      "name": "Dwarven Axe Guard",
      "description": "Hold fast, boys! Ne'er shall a beastie tread in Ironfist, so long as our axes swing true! -- Tibbs MacQuarrie",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 66,
      "hash": "cj9Bj9AJ8Jf1Ae9AJ8Jj9Aj9Birsouxmuzmjlpuh",
      "artist": "Roberto Cirillo",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 1568,
      "name": "Dwarven Beermaiden",
      "description": "This here is medicinal beer. Use it to treat pain, sadness, anger, boredom, laziness, undeath... Side effects may include nausea,  headache, missed attacks, and loss of ap.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 61,
      "hash": "ej9Bj9Ae9Ae9BG2Af1Bj9Fj9Gxqwinhtumlgvsqf",
      "artist": "Anthony Lopes",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2473,
          "apCost": 1,
          "name": "Carouse",
          "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "carouse"
        },
        {
          "id": 3098,
          "apCost": 0,
          "name": "Equip: St Semmir's Brew",
          "shortDescription": "This champion comes into play equipped with a St Semmir's Brew.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 2713,
          "apCost": 0,
          "name": "On The House",
          "shortDescription": "When a friendly champion within 5 spaces collects a Nora Globe, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special_keg"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": false,
              "id": 323,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 2 AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        }
      ]
    },
    {
      "id": 141,
      "name": "Dwarven Catapult",
      "description": "Stronghold grunts developed greater discipline when troublemakers were volunteered to test the latest weaponry.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 67,
      "hash": "dj9Fj9EE8De9Ae9Aj9Fj9Gj9Hkukpjyxftshpheg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1153,
          "apCost": 0,
          "name": "Dwarf Driven",
          "shortDescription": "This unit has lumbering unless it is adjacent to a Dwarf you control",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "drive"
        },
        {
          "id": 590,
          "apCost": 3,
          "name": "Load Catapult",
          "shortDescription": "Target adjacent, friendly, normal-sized champion gains Catapult until end of turn (this champion is relocated to target space 2-5 spaces away, for 0 AP). When a champion with Catapult is no longer adjacent to this unit, it loses the Catapult ability.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "throw_champ"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1468,
              "apCost": 0,
              "name": "Cooperation",
              "shortDescription": "When this unit is within 5 spaces of a friendly champion, it gains <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "sibling"
            },
            {
              "default": false,
              "id": 728,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 7 Physical Damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "traprock"
            },
            {
              "default": true,
              "id": 819,
              "apCost": 0,
              "name": "Sentry",
              "shortDescription": "This unit's spell presence is increased by 2.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "sentry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 336,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +3 RNG and +1 AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 41,
      "name": "Dwarven Defender",
      "description": "The second line of Rugolth's army, Defenders are called such for protecting the structure of Ironfist most proficiently.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 8,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 66,
      "hash": "cj9Dj9Cj9BG2Ae9Aj9Bj9Cj9Dsqoszvhyrsuolei",
      "artist": "Roberto Cirillo",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 1967,
          "apCost": 0,
          "name": "Relic Guardian",
          "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 877,
              "apCost": 0,
              "name": "Bodyguard",
              "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 355,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +3 DEF for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 354,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +2 DEF for 4 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 1,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1087,
      "name": "Dwarven Engineer",
      "description": "\"Off with ye! Grobles don't just make themselves, ya know.\" - Gribson, Grumpy Dwarf Engineer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 67,
      "hash": "ej9Ej9De9BE8De9Ag3AJ8GJ8Hwileiirfrfkjto",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2508,
          "apCost": 0,
          "name": "Boost: Construct",
          "shortDescription": "Friendly champions with Race: Construct have +5 MAX HP.  This does not stack  with other Boosts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "boost"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 2483,
          "apCost": 4,
          "name": "Summon: Young Piledriver",
          "shortDescription": "Summon a Young Piledriver with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 35,
          "iconName": "summon_groble"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 625,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrinegood"
            },
            {
              "default": true,
              "id": 2484,
              "apCost": 3,
              "name": "Build 'Em Tough",
              "shortDescription": "Target Construct within 2 spaces gains a rank of <ability value=1900>Tough</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "build_mine"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2636,
              "apCost": 3,
              "name": "Rev 'Em Up",
              "shortDescription": "Range 3: Target champion with Race: Construct gains <ability value=2253>Manic</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "build_mine"
            },
            {
              "default": true,
              "id": 2981,
              "apCost": 0,
              "name": "Clone Relic",
              "shortDescription": "Deploy to an adjacent space a copy of the last relic deployed by an opposing player while this unit was in play. This ability shares a cooldown with Clone Equipment.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "duplicate_equip"
            },
            {
              "default": false,
              "id": 1514,
              "apCost": 0,
              "name": "Train: Assault",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=1320>Assault</ability>.  This ability costs 6 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 843,
      "name": "Dwarven Excavator",
      "description": "\"If you work hard, then you'll always do a good job. That's always been my motto. Take these mines; we work hard to build them and they're the best in Poxanthuru.\" - Olgirn Ironpick, Ironfist Mines Foreman",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 62,
      "hash": "dj9Cj9BG2AG2BE8Dj9Ej9Fj9Gerqwqoqsuzmnwig",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2204,
          "apCost": 2,
          "name": "Build Mine",
          "shortDescription": "A Mine relic with Mine (Friendly small champions adjacent to this relic gain Use Mine (This champion is relocated to a space adjacent to friendly Mine)) is deployed in target adjacent square.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 14,
          "iconName": "build_mine"
        },
        {
          "id": 307,
          "apCost": 0,
          "name": "Nora Miner",
          "shortDescription": "At the beginning of your turn, you gain 3 nora.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "noragen"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2088,
              "apCost": 4,
              "name": "Tunnel: Vegetation",
              "shortDescription": "This unit is relocated to target Vegetation space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 7,
              "iconName": "tunnel_vegetation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 596,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 4 HP. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "shrinegood"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        }
      ]
    },
    {
      "id": 170,
      "name": "Dwarven Handler",
      "description": "Masters of the golems in Rugolth's royal guard, the Dwarven handlers are renowned for their ability to motivate even the most unwilling of stones.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 7,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 62,
      "hash": "dj9Bj9Af1Be9Ag3Aj9Dj9Ej9Ftzitfmsxxxowohg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 656,
          "apCost": 2,
          "name": "Drive",
          "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "drive"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 2636,
              "apCost": 3,
              "name": "Rev 'Em Up",
              "shortDescription": "Range 3: Target champion with Race: Construct gains <ability value=2253>Manic</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "build_mine"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": true,
              "id": 2508,
              "apCost": 0,
              "name": "Boost: Construct",
              "shortDescription": "Friendly champions with Race: Construct have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            }
          ]
        }
      ]
    },
    {
      "id": 1305,
      "name": "Dwarven Hooligan",
      "description": "\"Never seen a thing get so mad for being given free beer! It's not my fault you can't catch or hold your liquor!\" - Grus the Hooligan",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9Ef1AF0Ae9AE8DJ8Jj9Aeiplekjilwvvxo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2125,
          "apCost": 0,
          "name": "Attack: Keg",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2473,
          "apCost": 1,
          "name": "Carouse",
          "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "carouse"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 2712,
          "apCost": 4,
          "name": "Keg Toss",
          "shortDescription": "Area Effect 2, Range 5: All units become <condition value=intoxicated>Intoxicated</condition> for 4 turns. Opposing units take Physical damage equal to 80% of this unit's DMG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "special_keg"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            },
            {
              "default": true,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            }
          ]
        }
      ]
    },
    {
      "id": 42,
      "name": "Dwarven King",
      "description": "The Gods choose weak kings. Swords make bad kings. A strong arm, a strong heart, and some strong words - that's what makes our king. - Feofil",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 10,
      "hitPoints": 58,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 92,
      "hash": "cj9Fj9Ej9Dg3Ae9Bj9Dj9Ej9Fsuknwitfkegvzmj",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        },
        {
          "id": 331,
          "apCost": 0,
          "name": "Regal Presence",
          "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "majestic"
        },
        {
          "id": 971,
          "apCost": 0,
          "name": "Surge: Dwarf",
          "shortDescription": "This unit has +1 DMG for each friendly Dwarf.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge_dwarf"
        },
        {
          "id": 263,
          "apCost": 0,
          "name": "Warcry",
          "shortDescription": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 608,
              "apCost": 0,
              "name": "Majestic",
              "shortDescription": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "majestic"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2557,
              "apCost": 0,
              "name": "Martyrdom",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 8 HP. If this unit shares a race with the destroyed unit, also gain +1 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "intensify"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1216,
              "apCost": 0,
              "name": "Equalize",
              "shortDescription": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        }
      ]
    },
    {
      "id": 647,
      "name": "Dwarven Magister",
      "description": "Although the Stronghold isn't known for its magic, the Magisters of Ironfist are considered masters. ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "dj9Gj9Fe9AG2AE8Dj9Ej9Fj9Gerqouknpuojnjgg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2300,
              "apCost": 0,
              "name": "Charged Blast",
              "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
              "activationType": 3,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 562,
      "name": "Dwarven Medic",
      "description": "You need someone to care for the injured; you can't just leave a wounded man to die. I know how to patch up a dwarf. Let me help them. - Gillan, Ironfist's first Medic",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 56,
      "hash": "dJ8IJ8HF0Af1Bf1Bj9Aj9Bj9Ceilnhethyxzkwzg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2639,
          "apCost": 3,
          "name": "Grant: Healing Potion",
          "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 1464,
          "apCost": 1,
          "name": "Immunize",
          "shortDescription": "Target unit within 5 spaces gains <ability value=43>Immunity: Disease</ability> for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "blessed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1140,
              "apCost": 2,
              "name": "Command: Heal",
              "shortDescription": "The next time friendly champions within 3 spaces are healed, the amount is increased by 6.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_heal"
            },
            {
              "default": false,
              "id": 3130,
              "apCost": 0,
              "name": "Karmic Reward",
              "shortDescription": "The first time each turn this champion activates a non-basic attack ability, it is healed for 6 HP.  If that ability targets a friendly champion, this champion also gains 2 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "soul_bond"
            },
            {
              "default": true,
              "id": 2473,
              "apCost": 1,
              "name": "Carouse",
              "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "carouse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 460,
              "apCost": 3,
              "name": "First Aid",
              "shortDescription": "Target adjacent friendly champion gains 5 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 281,
      "name": "Dwarven Mogaslicer",
      "description": "Warning: Dwarves should not operate heavy machinery while intoxicated.- GreatBeard",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Dwarf"
      ],
      "noraCost": 77,
      "hash": "dj9Dj9CG2Be9Bf1Bj9Aj9Bj9Cevkygepuziwmegg",
      "artist": "Trevor Claxton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 1217,
          "apCost": 0,
          "name": "Faultbreak",
          "shortDescription": "When this champion moves by way of its normal movement, enemy champions within 2 spaces lose 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crush"
        },
        {
          "id": 1799,
          "apCost": 0,
          "name": "Trample",
          "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 3059,
              "apCost": 0,
              "name": "Thunderous Charge",
              "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "thunderous_charge"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1037,
      "name": "Dwarven Mortar Crew",
      "description": "\"Was a pretty piece of coin we dwarfs paid the Torts for their gunpowder trade but seeing those damn Draksar blow up from three fields out was well worth it.\" - Dwarven Mortar Private Flyn Rockgut",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 14,
      "hitPoints": 42,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Archer",
        "Warrior"
      ],
      "races": [
        "Construct",
        "Dwarf"
      ],
      "noraCost": 76,
      "hash": "eJ8HJ8GG2BE8De9Ae9Bj9Cj9Derjeggpumjnpqo",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2210,
          "apCost": 4,
          "name": "Artillery Strike",
          "shortDescription": "Area Effect 2, Range 7-9: At the beginning of your next turn, units occupying the affected spaces take Fire damage equal to the damage of this unit when it made the attack. This damage will occur even if this unit is destroyed or removed from play.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 25,
          "iconName": "artillery"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2099,
              "apCost": 0,
              "name": "Fire Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "artillery"
            },
            {
              "default": true,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 427,
      "name": "Dwarven Mountaineer",
      "description": "Heartier than most dwarves, mountaineers seek out tests of endurance. The tallest mountain, the coldest storm, the strongest ale - no challenge is too big.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger",
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 68,
      "hash": "dj9AJ8Jf1AF0BF0BJ8IJ8Jj9Aeemwmjlrjwiplyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1128,
          "apCost": 0,
          "name": "Ally: Ironfist Stronghold",
          "shortDescription": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "allybuff_is"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1006,
              "apCost": 0,
              "name": "Surge: Enemy",
              "shortDescription": "This unit has +1 DMG for each deployed enemy champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "surge_enemy"
            }
          ]
        }
      ]
    },
    {
      "id": 1086,
      "name": "Dwarven Roughneck",
      "description": "Roughnecks have always had a chip on their shoulder. Pity the sap that tries to knock it off.\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9De9AE8De9Ag3Aj9Fj9Gmszztuvkluxtoqf",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        },
        {
          "id": 2431,
          "apCost": 0,
          "name": "Rude Fighter",
          "shortDescription": "When this champion successfully hits a champion with a basic attack, that champion becomes Antagonized.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 727,
      "name": "Dwarven Sergeant",
      "description": "The sergeants of the Ironfist Stronghold are best described as boisterous and austere. Most sergeants have years in combat roles, but will spend their time giving commands on the battlefield.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 66,
      "hash": "dj9Bj9Af1BG2Ae9BJ8GJ8HJ8Iqusmlwonussjlyg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2053,
          "apCost": 0,
          "name": "Rallying Cries",
          "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": true,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": false,
              "id": 971,
              "apCost": 0,
              "name": "Surge: Dwarf",
              "shortDescription": "This unit has +1 DMG for each friendly Dwarf.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dwarf"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            }
          ]
        }
      ]
    },
    {
      "id": 282,
      "name": "Dwarven Sharpshooter",
      "description": "Here, drink this. It'll calm your nerves, help you see things that can't be seen, and shoot things that can't be shot. - Apothecary to Bjorn, Dwarven Sharpshooter",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 74,
      "hash": "dj9Dj9CG2Be9BG2Aj9Bj9Cj9Diwtfkuqlwmlnphg",
      "artist": "Trevor Claxton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2780,
          "apCost": 2,
          "name": "Aim",
          "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "hunted"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1019,
              "apCost": 0,
              "name": "Hidden: Arctic",
              "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 970,
              "apCost": 0,
              "name": "Hidden: Rock",
              "shortDescription": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 978,
      "name": "Dwarven Tinkerer",
      "description": "\"You're telling me she fixed that cursed contraption and then you sent her back into the mines? Bring her back up! Find her some more machines!\" - Feofil, the late King's advisor",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 57,
      "hash": "dj9Ej9Dg3Ag3AF0AJ8HJ8IJ8Jepjrqlwmyzgykgg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2484,
          "apCost": 3,
          "name": "Build 'Em Tough",
          "shortDescription": "Target Construct within 2 spaces gains a rank of <ability value=1900>Tough</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "build_mine"
        },
        {
          "id": 2346,
          "apCost": 0,
          "name": "Charged Barricade",
          "shortDescription": "Spend 2 charges: Summon a Barricade relic to target location within 4 spaces. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "charged_barricade"
        },
        {
          "id": 625,
          "apCost": 3,
          "name": "Mason",
          "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "shrinegood"
        },
        {
          "id": 2359,
          "apCost": 4,
          "name": "Summon: Mechanical Crabs",
          "shortDescription": "Summons a Mechanical Crabs champion with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "summon_mechcrab"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            },
            {
              "default": false,
              "id": 2174,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "charged_death"
            },
            {
              "default": true,
              "id": 2178,
              "apCost": 0,
              "name": "Supercharged",
              "shortDescription": "This unit gains 1 charge at the start of its turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "supercharged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 516,
      "name": "Dwarven Windfury",
      "description": "Let the wind carry our hammers! To victory, brothers! - Dundir, Dwarven Windfury",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "dj9Ej9Dg3Ae9AF0AJ8HJ8IJ8Jepuxfxzvkpqwvzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 3263,
          "apCost": 1,
          "name": "Ranged Stance",
          "shortDescription": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "ranged_stance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1341,
              "apCost": 0,
              "name": "Drunkard",
              "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "intoxicate"
            },
            {
              "default": true,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 2214,
              "apCost": 0,
              "name": "Hunter: Scout",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_archer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 783,
      "name": "Dwarven Windfury",
      "description": "Let the wind carry our hammers! To victory, brothers! - Dundir, Dwarven Windfury",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "dj9Gj9Fe9AG2Be9BJ8GJ8HJ8Ilexohvmhnjwfpyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 3263,
          "apCost": 1,
          "name": "Ranged Stance",
          "shortDescription": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "ranged_stance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1341,
              "apCost": 0,
              "name": "Drunkard",
              "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "intoxicate"
            },
            {
              "default": true,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 2214,
              "apCost": 0,
              "name": "Hunter: Scout",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_archer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 656,
      "name": "Eager Cyclops",
      "description": "Look! Do you see his appetite? He has a hunger for violence. He thirsts for war. Free him, Haadrim. He is ready. - Eehiist, Voil Queen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 60,
      "hash": "dj9Gj9Fe9AG2Ag3Aj9Dj9Ej9Flrjpsmlgegvmwkg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1760,
          "apCost": 0,
          "name": "Impatient",
          "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "impatient"
        },
        {
          "id": 2295,
          "apCost": 0,
          "name": "Thirst for Battle",
          "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "thirst_for_battle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 29,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 27,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets +2 DMG, and gains 1 additional rank of <ability value=15>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 346,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +2 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 348,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 347,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +3 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 506,
      "name": "Earth Elemental",
      "description": "The gods have made their own construct to protect us, and I will gladly accept their help. - King Rugolth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 10,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Construct",
        "Elemental",
        "Troll"
      ],
      "noraCost": 68,
      "hash": "dj9Cj9BG2Af1Ag3Aj9Dj9Ej9Fzowkpneirjtmwkg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 553,
          "apCost": 0,
          "name": "Attack: Boulder",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physicalaoe"
        },
        {
          "id": 1408,
          "apCost": 0,
          "name": "Chasm Walker",
          "shortDescription": "This unit can walk over <mechanic value=chasm>chasm</mechanic> spaces without dying.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainchasm"
        },
        {
          "id": 1328,
          "apCost": 0,
          "name": "Domain: Rock",
          "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_rock"
        },
        {
          "id": 1361,
          "apCost": 0,
          "name": "Trail: Rock",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Rock for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "trail_rock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 755,
              "apCost": 4,
              "name": "Tunnel: Earth",
              "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_earth"
            },
            {
              "default": false,
              "id": 2662,
              "apCost": 0,
              "name": "Surge: Rock",
              "shortDescription": "This unit has +1 DMG for every 2 champions occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            },
            {
              "default": false,
              "id": 2414,
              "apCost": 1,
              "name": "Throw Boulder",
              "shortDescription": "This champion makes a Physical attack at RNG 2-5. This attack causes <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2527,
              "apCost": 0,
              "name": "Rock Defiance",
              "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "troll_defiance"
            },
            {
              "default": false,
              "id": 47,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 2037,
              "apCost": 2,
              "name": "Terraform: Rock",
              "shortDescription": "Target space within 3 spaces, and all spaces adjacent to it, are Rock for 6 turns. Any friendly champion occupying target space gains <ability value=2414>Throw Boulder</ability> for 1 turn.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "terrainrock"
            }
          ]
        }
      ]
    },
    {
      "id": 43,
      "name": "Earth Golem",
      "description": "It is not uncommon for the Earth to grow angry. Let us give thanks that it is on our side. - Rugolth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 13,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Elemental"
      ],
      "noraCost": 61,
      "hash": "cJ8JJ8IJ8HF0Ae9BJ8HJ8IJ8Jkukukukrjiwmlph",
      "artist": "Roberto Cirillo",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 35,
              "apCost": 0,
              "name": "Immunity: Physical",
              "shortDescription": "Physical damage that would be dealt to this unit is prevented. This unit may not be <condition value=eviscerated popup=false>Eviscerated</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "immunity_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2571,
              "apCost": 0,
              "name": "Rock Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Rock for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "trail_rock"
            },
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 124,
              "apCost": 0,
              "name": "Damage Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            }
          ]
        }
      ]
    },
    {
      "id": 213,
      "name": "Earthmover",
      "description": "Let us use the very stones of Ironfist herself against the Draksar.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Elemental"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9Be9BF0AJ8HJ8IJ8Jeevzxferfmuqsuf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 553,
          "apCost": 0,
          "name": "Attack: Boulder",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physicalaoe"
        },
        {
          "id": 742,
          "apCost": 2,
          "name": "Create Chasm",
          "shortDescription": "Target unoccupied space becomes <mechanic value=chasm>Chasm</mechanic> and this champion gains <ability value=803>Boulder Toss</ability>. The Create Chasm ability does not come off cooldown while the champion has the Boulder Toss ability.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 13,
          "iconName": "domain_chasm"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 2527,
              "apCost": 0,
              "name": "Rock Defiance",
              "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "troll_defiance"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 982,
      "name": "Elder Bloodbinder",
      "description": "\"Drink deep children, these frightened fleshbags carry copious amounts of that which we value over all else.\" - Slis, Bloodbinder",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Undead",
        "Vampyre"
      ],
      "noraCost": 76,
      "hash": "dj9Ej9Dg3Ag3AG2Aj9Bj9Cj9Dkjpytxtfrhepqlg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2411,
          "apCost": 2,
          "name": "Dark Raven Form",
          "shortDescription": "This unit becomes a Dark Raven and gains <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, <ability value=13>Detection 3</ability>, <ability value=1399>Hex 2</ability> and Race: Beast. It's RNG becomes 1-1 and it is <mechanic value=cleansed>Cleansed</mechanic>. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "transform"
        },
        {
          "id": 2500,
          "apCost": 0,
          "name": "Elsari Coven",
          "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "elsari"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 3006,
          "apCost": 0,
          "name": "Nora Induction",
          "shortDescription": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ichor_utility"
        },
        {
          "id": 3398,
          "apCost": 0,
          "name": "Sanguine Sorceress",
          "shortDescription": "This champion has <ability value=607>Essence Capture</ability>. While there is a friendly champion with <ability value=3399>Lord of Strigoi</ability> in play, friendly champions with Race: Vampyre within 3 spaces of this champion gain <ability value=3151>Bloodspurt</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "greater_vampirism"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 986,
              "apCost": 0,
              "name": "Dark Healing",
              "shortDescription": "When an enemy champion within 10 spaces is healed by a spell or ability, the amount healed is reduced by 50%. At the end of each turn, friendly champions are healed by the same number of HP, distributed evenly among them to a maximum of 6 HP (rounded down, minimum 1). This effect does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dark_heal"
            },
            {
              "default": true,
              "id": 2388,
              "apCost": 0,
              "name": "Greater Vampirism",
              "shortDescription": "All vampiric healing is increased 50%. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "greater_vampirism"
            },
            {
              "default": false,
              "id": 2537,
              "apCost": 0,
              "name": "Revel in Misery",
              "shortDescription": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "forsaken_conduit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 44,
      "name": "Elder Garu",
      "description": "Godwin has the best of intentions, I know. But he also has a hidden rage that I fear could distract him. - Menalaus",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 14,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 82,
      "hash": "cj9AJ8JJ8IF0Be9AJ8IJ8Jj9Aemnpwztjpllpjrh",
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2450,
              "apCost": 0,
              "name": "Guarded: Garu",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Garu within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        }
      ]
    },
    {
      "id": 1060,
      "name": "Elder Murkwurm",
      "description": "\"They're uncontrollable and cranky and can be counted on to make a fine mess of everything.\" - Glink, Swampguard\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Dragon",
        "Worm"
      ],
      "noraCost": 75,
      "hash": "ej9Bj9Af1BE8De9Af1Bj9Aj9Byigvzxvxtuqjyo",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2270,
          "apCost": 0,
          "name": "Attack: Mouth Lightning",
          "shortDescription": "This unit makes an Electricity attack, from its freakin' mouth, at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2481,
          "apCost": 4,
          "name": "Cast: Hungry Mire",
          "shortDescription": "Area Effect 2, Range 4: For the next 4 turns, all spaces become Dirt and Shallow Water. When a champion without <condition value=flying>Flying</condition> enters one of these spaces, it takes 5 Physical damage and becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "hungry_mire"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 1952,
          "apCost": 0,
          "name": "Slam",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 860,
          "apCost": 0,
          "name": "Trail: Slime",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Slime (Impeding 1 Water) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "trail_slime"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2245,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 2893,
              "apCost": 1,
              "name": "Death Sentence",
              "shortDescription": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=cleansed>Cleansed</mechanic> and it loses 5 HP for each condition removed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "final_judgement"
            }
          ]
        }
      ]
    },
    {
      "id": 1830,
      "name": "Elder Vampyre",
      "description": "Those liches pulled from the sentient undead have a particular allegiance to the armies of the undead, seeing it as their domain twice over.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 0,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 80,
      "hash": "eJ8IJ8HF0AG2BG2AF0AJ8HJ8Irlusqqfgpfmufpf",
      "artist": "Caio Monteiro",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1494,
          "apCost": 0,
          "name": "Escalation",
          "shortDescription": "This champion gains +1 DMG at the beginning of its owner's turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 3306,
          "apCost": 5,
          "name": "Invoke: Lifeleech",
          "shortDescription": "Area Effect 4: Enemy champions lose 8 HP and this champion gains +4 MAX HP for each champion affected. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 8,
          "iconName": "invoke"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2706,
              "apCost": 1,
              "name": "Blood Knowledge",
              "shortDescription": "For each opposing champion within 4 spaces with <condition value=bloodied>Bloodied</condition>, your opponent loses 2 nora and this champion gains 1 AP and +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": true,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3399,
              "apCost": 0,
              "name": "Lord of Strigoi",
              "shortDescription": "This champion has <ability value=977>Bleed</ability>. After this champion uses an ability, friendly champions with Race: Vampyre within 3 spaces of this champion gain +2 Max HP and -1 CD on their abilities. This may only trigger once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "soul_siphon"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        }
      ]
    },
    {
      "id": 1182,
      "name": "Eldrick, Czar of the Void",
      "description": "\"The newly dead are so easily manipulated.\" ~ Eldrick, Czar of the Void",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Spirit",
        "Undead"
      ],
      "noraCost": 88,
      "hash": "ej9Dj9CF0Be9Ae9AG2BJ8IJ8Jsqushvofgnnhepf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 2569,
          "apCost": 0,
          "name": "Restless Souls",
          "shortDescription": "The first time each turn a real enemy champion within 5 spaces is destroyed, a Restless Soul with no upgrades is summoned adjacent to this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "ondeath"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 2570,
              "apCost": 0,
              "name": "Surge: Spirit",
              "shortDescription": "This unit has +1 DMG for each friendly Spirit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_spirit"
            },
            {
              "default": false,
              "id": 3395,
              "apCost": 0,
              "name": "Soul Feast",
              "shortDescription": "This champion deals 30% additional damage to <condition value=soultapped>Soultapped</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1583,
      "name": "Elecroc",
      "description": "Similar to albinism which turns the skin of some crocodiles white, the Elecroc suffers from a mutation that forces them to uncontrollably emit electrical energy.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 8,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9De9Ae9BG2Ag3Aj9Fj9Gsmerjgiluqsjlrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3090,
          "apCost": 0,
          "name": "Catalyst: Electricity",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Electricity damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "breaker_electricity"
        },
        {
          "id": 3089,
          "apCost": 0,
          "name": "Initiator",
          "shortDescription": "This champion deals 4 additional damage to champions with 35 or more HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiator"
        },
        {
          "id": 3011,
          "apCost": 0,
          "name": "Stasis",
          "shortDescription": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "crystallize"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": true,
              "id": 805,
              "apCost": 1,
              "name": "Chain Lightning",
              "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "electric"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2244,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 140,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 306,
      "name": "Electric Eel",
      "description": "Jib! Don't stand so close when you provoke that blasted eel!  - Huiey, Cyclops Youth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 59,
      "hash": "dj9Fj9EE8DF0Ae9BJ8GJ8HJ8Iwiegrusmygkumwf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 805,
          "apCost": 1,
          "name": "Chain Lightning",
          "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "electric"
        },
        {
          "id": 1445,
          "apCost": 0,
          "name": "Counter Attack: Ranged",
          "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "reflexes"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 235,
              "apCost": 0,
              "name": "Damage Shield: Electricity",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Electricity damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "dmgshld_lightning"
            },
            {
              "default": true,
              "id": 236,
              "apCost": 0,
              "name": "Damage Shield: Electricity",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Electricity damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "dmgshld_lightning"
            },
            {
              "default": false,
              "id": 237,
              "apCost": 0,
              "name": "Damage Shield: Electricity",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Electricity damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_lightning"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        }
      ]
    },
    {
      "id": 1575,
      "name": "Elemental Core",
      "description": "Elemental Cores are manifested by the C'ramil itself.  It is unknown how the artifact can produce them without any input.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 85,
      "hash": "ej9Cj9Bf1Ae9BG2AG2AJ8Jj9Aeerzzvhvztsztqf",
      "artist": "Danh Nguyen",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2819,
          "apCost": 0,
          "name": "Catalyst: Frost",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "catalyst_frost"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        },
        {
          "id": 3073,
          "apCost": 0,
          "name": "Tundra Menace",
          "shortDescription": "The first time each turn a friendly Jakei or Elemental is deployed from the runedock, this champion gains 2 AP and enemy champions within 2 spaces takes 4 Frost damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "tundra_menace"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 3129,
              "apCost": 3,
              "name": "Elemental Storm: Frost",
              "shortDescription": "Enemy champions within 3 spaces of at least one friendly Elemental, Shaman or Wizard, including this one, take 5 Frost damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "absolute_zero"
            },
            {
              "default": false,
              "id": 3230,
              "apCost": 3,
              "name": "Freezing Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "grip_icelord"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            },
            {
              "default": true,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 248,
      "name": "Elemental Warstaff",
      "description": "Cydna, they need you at the site of the excavation - it looks like we've found a massive store of ancient elven artifacts. - Dwarven executor, deep in the ruins of Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin",
        "Wizard"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 62,
      "hash": "dJ8HJ8Ge9Be9Bf1Bj9Aj9Bj9Cevfexinhtmuxvxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 767,
          "apCost": 1,
          "name": "Fire Attack",
          "shortDescription": "This unit makes a Fire attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "fire"
        },
        {
          "id": 764,
          "apCost": 1,
          "name": "Frost Attack",
          "shortDescription": "This unit makes a Frost attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "ice"
        },
        {
          "id": 766,
          "apCost": 1,
          "name": "Magical Attack",
          "shortDescription": "This unit makes a Magical attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 38,
              "apCost": 0,
              "name": "Immunity: Frost",
              "shortDescription": "Frost damage that would be dealt to this unit is prevented. This unit may not become Chilled.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_frost"
            },
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 1381,
      "name": "Elite Skirmisher",
      "description": "\"Someone has been giving these savages our weapons.  Trust no one and go tell the Circle.  There is a traitor in our midst.\" Arturo, Hand of the Circle\r\n",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer"
      ],
      "races": [
        "Barbarian",
        "Beast"
      ],
      "noraCost": 72,
      "hash": "ej9Cj9BF0BF0Ae9AG2AJ8IJ8Jgytmllrjwxmjepf",
      "artist": "Mazert Young",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 101,
          "apCost": 1,
          "name": "Barrage",
          "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "arrowaoe"
        },
        {
          "id": 2816,
          "apCost": 0,
          "name": "Equip: Frostcall Quiver",
          "shortDescription": "This unit comes into play equipped with Frostcall Quiver.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        }
      ]
    },
    {
      "id": 1580,
      "name": "Elsari Culler",
      "description": "Elsari Cullers spend their time mastering the art of straddling the edge of the veil, drawing power as creatures are brought back from across it.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Human",
        "Lich"
      ],
      "noraCost": 74,
      "hash": "ej9Dj9Cf1Ae9BG2AG2BJ8Jj9Aemjwvqhvosofxqf",
      "artist": "Alex Brock",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 2958,
          "apCost": 3,
          "name": "Ritual of Power",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "deconstruct"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        },
        {
          "id": 3043,
          "apCost": 0,
          "name": "Vitality: Creation",
          "shortDescription": "The first time each turn a champion comes into play, this champion gains +2 MAX HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "fascinate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2389,
              "apCost": 3,
              "name": "Pain Curse",
              "shortDescription": "Opposing <condition value=cursed>Cursed</condition> champions take 5 magical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "defile_corpse"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 431,
              "apCost": 4,
              "name": "Summon: Skeleton",
              "shortDescription": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "sumskel"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": true,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 418,
      "name": "Elsari Mason",
      "description": "Now risen, some say they do better work dead than when alive.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 61,
      "hash": "dJ8IJ8HF0AF0BG2Aj9Bj9Cj9Duvkeegilwfxiyzg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2981,
          "apCost": 0,
          "name": "Clone Relic",
          "shortDescription": "Deploy to an adjacent space a copy of the last relic deployed by an opposing player while this unit was in play. This ability shares a cooldown with Clone Equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "duplicate_equip"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 1510,
          "apCost": 0,
          "name": "Market",
          "shortDescription": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "cost"
        },
        {
          "id": 2781,
          "apCost": 0,
          "name": "Summon: Bone Trap",
          "shortDescription": "Summon an Bone Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=2776>Bone Trap</ability> to target adjacent space. This ability does not break stealth",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deploy"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 3388,
          "apCost": 0,
          "name": "Unholy Armaments",
          "shortDescription": "When a friendly champion with Race: Lich, Race: Skeleton or Race: Vampire becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3165,
              "apCost": 0,
              "name": "Mason's Spire",
              "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": true,
              "id": 596,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 4 HP. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "shrinegood"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 438,
      "name": "Elsari Mason",
      "description": "Now risen, some say they do better work dead than when alive.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 61,
      "hash": "dj9Ej9Dg3AF0BG2Aj9Bj9Cj9Djrftzkrfvzginjg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2981,
          "apCost": 0,
          "name": "Clone Relic",
          "shortDescription": "Deploy to an adjacent space a copy of the last relic deployed by an opposing player while this unit was in play. This ability shares a cooldown with Clone Equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "duplicate_equip"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 1510,
          "apCost": 0,
          "name": "Market",
          "shortDescription": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "cost"
        },
        {
          "id": 2781,
          "apCost": 0,
          "name": "Summon: Bone Trap",
          "shortDescription": "Summon an Bone Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=2776>Bone Trap</ability> to target adjacent space. This ability does not break stealth",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deploy"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 3388,
          "apCost": 0,
          "name": "Unholy Armaments",
          "shortDescription": "When a friendly champion with Race: Lich, Race: Skeleton or Race: Vampire becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3165,
              "apCost": 0,
              "name": "Mason's Spire",
              "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": true,
              "id": 596,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 4 HP. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "shrinegood"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 613,
      "name": "Elsari Reaper",
      "description": "The Knights of Elsarin gave their lives for their kingdom, regardless of its king. Many of them lost their souls, in service to Serkan.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 0,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 72,
      "hash": "dj9Cj9BG2Af1BG2Aj9Bj9Cj9Dymyohygemetszig",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1791,
          "apCost": 0,
          "name": "Soulstrike",
          "shortDescription": "Whenever this champion successfully hits an opponent with a basic attack, target champion loses life equal to 25% of its max HP. This ability ignores immunities.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "lossoflife"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            },
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            }
          ]
        }
      ]
    },
    {
      "id": 1944,
      "name": "Elsari Reaper",
      "description": "The Knights of Elsarin gave their lives for their kingdom, regardless of its king. Many of them lost their souls, in service to Serkan.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 0,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9Fe9Ae9AG2Be9Aj9Fj9Gmnjyvxxonlygtqf",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1791,
          "apCost": 0,
          "name": "Soulstrike",
          "shortDescription": "Whenever this champion successfully hits an opponent with a basic attack, target champion loses life equal to 25% of its max HP. This ability ignores immunities.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "lossoflife"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            },
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            }
          ]
        }
      ]
    },
    {
      "id": 440,
      "name": "Elsari Siren",
      "description": "The siren's song is made of necromantic symbols, specially tailored to ravage the mind of its listener.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Mirefolk",
        "Undead"
      ],
      "noraCost": 58,
      "hash": "dJ8JJ8IF0Bf1AE8Dj9Ej9Fj9Geeeeeiljgtxmeeg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1196,
          "apCost": 0,
          "name": "Body Jumper",
          "shortDescription": "When this unit is destroyed, the closest opposing champion is <condition value=possessed>Possessed</condition> and becomes <condition value=immobile>Immobile</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "possess"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            },
            {
              "default": true,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1976,
              "apCost": 3,
              "name": "Wail of Grief",
              "shortDescription": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 1724,
              "apCost": 0,
              "name": "Depression",
              "shortDescription": "Champions within 3 spaces of this unit have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        }
      ]
    },
    {
      "id": 667,
      "name": "Elsari Swordmage",
      "description": "When Elsarin fell, the survivors turned to spell slinging thugs. When Serkan offered them a place in his kingdom, they accepted.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior",
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3Af1Bf1AJ8Jj9Aj9Bohyketqzrfmsuhg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 766,
          "apCost": 1,
          "name": "Magical Attack",
          "shortDescription": "This unit makes a Magical attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "magic"
        },
        {
          "id": 711,
          "apCost": 0,
          "name": "Siphoning Aura",
          "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "possess"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3021,
              "apCost": 1,
              "name": "Censure",
              "shortDescription": "This champion makes a <mechanic value=lossoflife>Loss of Life</mechanic> at RNG 2-5.  If that champion is Cursed or occupies Dead Magic Zone, it takes an additional 3 Psychic damage and loses all remaining AP.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 3023,
              "apCost": 0,
              "name": "Surge: Cursed",
              "shortDescription": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_cursed"
            },
            {
              "default": false,
              "id": 1070,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1525,
      "name": "Elsari Tomb Raider",
      "description": "Elsari Tomb Raiders are both respected and reviled, depending on whose tomb they happen to be raiding at the time, and at whose behest. Those who know them well know that at the end of the day, they only truly serve one master: themselves.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Human",
        "Vampyre"
      ],
      "noraCost": 66,
      "hash": "ej9Dj9CE8DF0Be9AG2Bj9Ej9Feeevxtmpsqjwoqf",
      "artist": "Conceptopolis",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2212,
          "apCost": 0,
          "name": "Banditry",
          "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "banditry"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 2003,
          "apCost": 0,
          "name": "Mercenary",
          "shortDescription": "At the beginning of your turns you lose 2 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "cost"
        },
        {
          "id": 3042,
          "apCost": 3,
          "name": "Ransack Relic",
          "shortDescription": "Target relic within three spaces is destroyed, you recover Nora equal to half its Nora cost (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "ransack"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 3388,
              "apCost": 0,
              "name": "Unholy Armaments",
              "shortDescription": "When a friendly champion with Race: Lich, Race: Skeleton or Race: Vampire becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            }
          ]
        }
      ]
    },
    {
      "id": 983,
      "name": "Elsari Votary",
      "description": "In life, the Votary were Serkan's closest followers. When he was first slain, the Votary swore their undeath to the coven, in exchange for the power to find his murderer.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "dj9Ej9Dg3Ag3AG2Bj9Cj9Dj9Eeeeeevfirsjrhnh",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2389,
              "apCost": 3,
              "name": "Pain Curse",
              "shortDescription": "Opposing <condition value=cursed>Cursed</condition> champions take 5 magical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "defile_corpse"
            },
            {
              "default": true,
              "id": 3165,
              "apCost": 0,
              "name": "Mason's Spire",
              "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3388,
              "apCost": 0,
              "name": "Unholy Armaments",
              "shortDescription": "When a friendly champion with Race: Lich, Race: Skeleton or Race: Vampire becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 2701,
              "apCost": 0,
              "name": "Shadestrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrain_dmz"
            },
            {
              "default": false,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            }
          ]
        }
      ]
    },
    {
      "id": 514,
      "name": "Elven Ancestor",
      "description": "I have seen this world, J`orea. And now, dear sister, I will share my journey. - L`usara, Ancestor",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elf",
        "Jakei"
      ],
      "noraCost": 74,
      "hash": "dj9Dj9CG2Bf1Ag3Aj9Dj9Ej9Fhthersuxoluhklg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest",
        "Savage Tundra"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 45,
      "name": "Elven Archer",
      "description": "The centaur shoot with raw skill and force unparalleled, but the Elves augment their aim through their studies of the wind.",
      "maxRng": 7,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 71,
      "hash": "cj9Gj9Fj9EE8De9Aj9Ej9Fj9Gerlyrfilwkymhgi",
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 100,
          "apCost": 1,
          "name": "Barrage",
          "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
          "activationType": 1,
          "level": 1,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "arrowaoe"
        },
        {
          "id": 1316,
          "apCost": 0,
          "name": "Vulnerable",
          "shortDescription": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 894,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 2 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 1803,
              "apCost": 0,
              "name": "Volley Leader",
              "shortDescription": "Other friendly Archers within 5 spaces gain a rank of <ability value=1088>Rain of Arrows</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dictate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 299,
      "name": "Elven Artisan ",
      "description": "I whipped these up real quick...they don't just look pretty...these are functional replicas of those weapons you left me. - Gareth, Elven Artisan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Bard",
        "Tinkerer"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 64,
      "hash": "dj9Ej9Dg3Ae9Bf1AJ8Jj9Aj9Begtjekphgpwmygg",
      "artist": "Minn Hyuk Yum",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 947,
          "apCost": 0,
          "name": "Craft",
          "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 5,
          "iconName": "forge"
        },
        {
          "id": 3223,
          "apCost": 2,
          "name": "Enchant: Magic",
          "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "enchant_magic"
        },
        {
          "id": 307,
          "apCost": 0,
          "name": "Nora Miner",
          "shortDescription": "At the beginning of your turn, you gain 3 nora.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "noragen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3391,
              "apCost": 0,
              "name": "Verdant Armaments",
              "shortDescription": "When a friendly champion with Race: Elf, Race: Fairy or Race: Centaur becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 337,
      "name": "Elven Bard",
      "description": "She sings the very spirit of the forest. - Menalaus, K'thir Priest",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 65,
      "hash": "dj9Bj9Af1BF0Ae9Aj9Fj9Gj9Hufevhgeevxklygg",
      "artist": "Eric Williams",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 976,
          "apCost": 4,
          "name": "Battle Hymn",
          "shortDescription": "All friendly champions get <condition value=reverie>Reverie</condition> for 1 turn and recovers 2 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "dancesong"
        },
        {
          "id": 2113,
          "apCost": 2,
          "name": "Demoralizing Descant",
          "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "dreadsong"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 415,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 414,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Adjacent enemy champions become <condition value=charmed>Charmed 3</condition> All affected champions are disengaged from each other.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "charm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 46,
      "name": "Elven Blademaster",
      "description": "They have mastered the art so well that the blades move as gracefully as the Elves themselves.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 56,
      "hash": "bj9Hj9Gj9Fe9Aj9Fj9Gj9Hj9Ierqfkyojplygpwo",
      "artist": "Roberto Cirillo",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1486,
          "apCost": 0,
          "name": "Strike",
          "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 2076,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 20% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 1486,
      "name": "Elven Bureaucrat",
      "description": "\"Please sign here and here. Also, initial there. Your seal goes here. No, no, don't put the seal away, we have quite a few more of these to do before you go.\" -S'g, Elven Bureaucrat",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 69,
      "hash": "eJ8JJ8Ie9AF0Be9AF0Bj9Fj9Geeeeeilroyvhyo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1443,
          "apCost": 0,
          "name": "Council: Spells",
          "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "special"
        },
        {
          "id": 1399,
          "apCost": 1,
          "name": "Hex",
          "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "lossoflife"
        },
        {
          "id": 1391,
          "apCost": 0,
          "name": "Ignorance",
          "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ignorance"
        },
        {
          "id": 3261,
          "apCost": 2,
          "name": "Mind Lock",
          "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "mind_lock"
        },
        {
          "id": 3134,
          "apCost": 2,
          "name": "Suppression",
          "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        }
      ]
    },
    {
      "id": 1804,
      "name": "Elven Curator",
      "description": "Even after De'lim's disappearance, some individuals within K'thir maintained an interest in his beliefs - sometimes academic, sometimes personal.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 64,
      "hash": "ej9Ej9Df1BG2AG2Ag3Aj9Aj9Bsmevxtfxqjnnytf",
      "artist": "Rogier van de Beek",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3282,
          "apCost": 0,
          "name": "Gift: Magical Training",
          "shortDescription": "The next champion you deploy from the runedock while this champion is in play has <ability value=961>Reckless Blast 2</ability> and <ability value=1873>Magic Blast</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "gift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2633,
              "apCost": 0,
              "name": "Amplify: Magic",
              "shortDescription": "Magic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_magic"
            },
            {
              "default": true,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 745,
              "apCost": 0,
              "name": "Magic Eater",
              "shortDescription": "When this unit would take Magic damage, it instead recovers HP equal to half the damage that would have been dealt.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_magic"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 766,
              "apCost": 1,
              "name": "Magical Attack",
              "shortDescription": "This unit makes a Magical attack at range 2-4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "magic"
            }
          ]
        }
      ]
    },
    {
      "id": 296,
      "name": "Elven Druid",
      "description": "We chased the elf-spy for hours, until we lost his tracks in a pack of wolves. - Nefari Scout",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast",
        "Elf"
      ],
      "noraCost": 73,
      "hash": "dj9Ej9Dg3Ae9Be9BJ8GJ8HJ8Ioqjnuxmwvhphpyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 858,
          "apCost": 2,
          "name": "Bear Form",
          "shortDescription": "This champion gets Race: Beast, <ability value=1869>Hibernate</ability>, <ability value=261>Enrage 3</ability>, is <mechanic value=cleansed>Cleansed</mechanic>, and has RNG 1, -5 DMG, +1 DEF, and +25 MAX HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "transform"
        },
        {
          "id": 852,
          "apCost": 2,
          "name": "Eagle Form",
          "shortDescription": "This unit becomes an Eagle with Race: Beast, RNG 1-1, <ability value=1>Flight</ability>, <ability value=6>Mobility</ability>, and <ability value=13>Detection 3</ability>. It gains +1 SPD and is <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        },
        {
          "id": 856,
          "apCost": 2,
          "name": "Wolf Form",
          "shortDescription": "This champion gets Race: Beast and gains <ability value=600>Arctic</ability> and <ability value=163>Rend</ability>. It is <mechanic value=cleansed>Cleansed</mechanic> and has RNG 1, +5 DMG, +5 MAX HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1189,
              "apCost": 0,
              "name": "Sentry",
              "shortDescription": "This unit's spell presence is increased by 3.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "sentry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 851,
              "apCost": 2,
              "name": "Octopus Form",
              "shortDescription": "This unit becomes an Octopus with race Beast, <ability value=114>Aquatic</ability>, <ability value=324>Constriction</ability>, and <ability value=40>Immunity: Poison</ability>. It gains +6 HP and is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "transform"
            }
          ]
        }
      ]
    },
    {
      "id": 218,
      "name": "Elven Fury",
      "description": "Sallisa, take your furies to the east, we have reports of a new Nefari breach in the surface that must be sealed. - Darius, member of the Eternal Circle",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9Be9Bg3Aj9Dj9Ej9Fkpnsuvfkjwmleeg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1320,
          "apCost": 0,
          "name": "Assault",
          "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 1534,
          "apCost": 0,
          "name": "Spell Resistance",
          "shortDescription": "This unit takes 50% less damage from spells.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 2632,
              "apCost": 0,
              "name": "Bold",
              "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "channel_defense"
            },
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1941,
      "name": "Elven Fury",
      "description": "Sallisa, take your furies to the east, we have reports of a new Nefari breach in the surface that must be sealed. - Darius, member of the Eternal Circle",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9EG2Ae9AG2BE8Dj9Bj9Ceevxtftuvxxitqf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1320,
          "apCost": 0,
          "name": "Assault",
          "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 1534,
          "apCost": 0,
          "name": "Spell Resistance",
          "shortDescription": "This unit takes 50% less damage from spells.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 2632,
              "apCost": 0,
              "name": "Bold",
              "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "channel_defense"
            },
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 114,
      "name": "Elven Illusionist",
      "description": "Godwin's visage is as fearsome as his roar. - Menelaus, Priest of K'thir",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 66,
      "hash": "dJ8HJ8Ge9Be9Af1AJ8Jj9Aj9Bkgknlerowtzmjwf",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1429,
          "apCost": 1,
          "name": "Absorb Illusion",
          "shortDescription": "The nearest <condition value=illusion>Illusion</condition> within 5 spaces is destroyed and this unit heals 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 1,
          "iconName": "heal"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1895,
          "apCost": 0,
          "name": "Illusion of Lies",
          "shortDescription": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "planar"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 642,
              "apCost": 0,
              "name": "Illusion: Archer",
              "shortDescription": "Create a Elven Archer Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 2,
              "iconName": "illusion_archer"
            },
            {
              "default": false,
              "id": 644,
              "apCost": 0,
              "name": "Illusion: Garu",
              "shortDescription": "Create a Elder Garu Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 2,
              "iconName": "illusion_garu"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 641,
              "apCost": 0,
              "name": "Illusion: Elf",
              "shortDescription": "Create a Elven BladeMaster <condition value=illusion>Illusion</condition> in the nearest deployment zone. The illusion will appear upgraded at random.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 2,
              "iconName": "illusion_elf"
            },
            {
              "default": true,
              "id": 643,
              "apCost": 0,
              "name": "Illusion: Mage",
              "shortDescription": "Create a Elven Mage Illusion in the nearest deployment zone. The illusion will appear upgraded at random.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 2,
              "iconName": "illusion_mage"
            }
          ]
        }
      ]
    },
    {
      "id": 47,
      "name": "Elven Mage",
      "description": "Fear most those that appear to have no weapons. - Serkan, the Lich King",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 75,
      "hash": "cj9Hj9Gj9Fe9Ae9Aj9Fj9Gj9Huoftmukjtxkrukj",
      "artist": "Roberto Cirillo",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1764,
          "apCost": 0,
          "name": "Magic Acolyte",
          "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "acolyte_magic"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            }
          ]
        }
      ]
    },
    {
      "id": 256,
      "name": "Elven Mage",
      "description": "Fear most those that appear to have no weapons. - Serkan, the Lich King",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 75,
      "hash": "dj9Cj9BG2Ae9BF0BJ8IJ8Jj9Auxqshrfieekgtzg",
      "artist": "Layne Johnson",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1764,
          "apCost": 0,
          "name": "Magic Acolyte",
          "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "acolyte_magic"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            }
          ]
        }
      ]
    },
    {
      "id": 765,
      "name": "Elven Page",
      "description": "They are reluctant, Darius. They began their morning, ready to learn. Now, they've been told to take arms against the Nefari. From the fundamentals of Nora to maces and combat tactics. I would hope they are all reluctant to fight. - Menalaus of K`thir",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8DG2BE8Dj9Ej9Fj9Geeerhituvoleegg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 304,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "divine"
        },
        {
          "id": 1343,
          "apCost": 0,
          "name": "Mystic Push",
          "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "auranegative"
        },
        {
          "id": 1995,
          "apCost": 0,
          "name": "Page of K'thiras",
          "shortDescription": "While Menalaus or Bowmage are in play, this champion has <ability value=399>Force Barrier 2</ability> and <ability value=897>Mindwipe Aura 2</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "revere"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3061,
              "apCost": 3,
              "name": "Solar Flare",
              "shortDescription": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 399,
      "name": "Elven Prodigy",
      "description": "Young prodigies train blindfolded to avoid the distractions that sight brings.",
      "maxRng": 8,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 59,
      "hash": "dJ8HJ8Ge9BF0Bf1Bj9Aj9Bj9Ceevofmletzxigyg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1141,
          "apCost": 0,
          "name": "Blindfire",
          "shortDescription": "When an enemy champion within this units range makes a successful ranged attack against a champion, this champion makes a Physical ranged combat attack against that champion for free.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "blindfire"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1088,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "arrowaoe"
            },
            {
              "default": true,
              "id": 1089,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 1090,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "arrowaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 435,
      "name": "Elven Prodigy",
      "description": "Young prodigies train blindfolded to avoid the distractions that sight brings.",
      "maxRng": 8,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 59,
      "hash": "dj9Ej9Dg3AF0BF0BJ8IJ8Jj9Aeeevsmsofkjnwfg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1141,
          "apCost": 0,
          "name": "Blindfire",
          "shortDescription": "When an enemy champion within this units range makes a successful ranged attack against a champion, this champion makes a Physical ranged combat attack against that champion for free.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "blindfire"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1088,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "arrowaoe"
            },
            {
              "default": true,
              "id": 1089,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 1090,
              "apCost": 1,
              "name": "Rain of Arrows",
              "shortDescription": "Area Effect 2, Range 5: Affected units in the affected area take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "arrowaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1054,
      "name": "Elven Shade",
      "description": "\"Ash is right, we've been sitting around, trying to avoid a war that's already upon us. Get yours, from another if need be, before someone else does.\" - Na'nn, Elven Shade\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 70,
      "hash": "ej9Bj9AE8DE8De9Af1Bj9Ej9Fmsoszxquowzkuo",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2251,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "combat_awareness"
        },
        {
          "id": 1354,
          "apCost": 0,
          "name": "Sneak",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            }
          ]
        }
      ]
    },
    {
      "id": 874,
      "name": "Elven Sky Marshal",
      "description": "\"Flight magic? You told him he had flight magic? That's absurd! He'll fall like a rock with those little cloth wings! You've killed that poor elf!\" - Cassius Bronzebeak, co-creator of the Elven Sky Marshal",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 65,
      "hash": "dj9Fj9EE8Dg3Ae9Aj9Fj9Gj9Hqoqonhnssolgthg",
      "artist": "Simon Dominic",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1979,
          "apCost": 0,
          "name": "Running Start",
          "shortDescription": "Whenever this champion moves 2 or more spaces, it gains <ability value=1>Flight</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "flight"
        },
        {
          "id": 1316,
          "apCost": 0,
          "name": "Vulnerable",
          "shortDescription": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 395,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-2 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +2 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 394,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1 space in a straight line through non-Impeding terrain and makes a close-combat attack at +1 DMG.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 1,
              "iconName": "charge"
            }
          ]
        }
      ]
    },
    {
      "id": 335,
      "name": "Elven Strategist",
      "description": "If ten times their number, surround them. If double, divide them. When equal engage, but when less, be capable of withdraw. Make no mistakes and you simply work to conquer an already defeated foe.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1AF0Ag3Aj9Dj9Ej9Fpnymjipsxfpwohg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 9,
          "apCost": 0,
          "name": "Battlemaster",
          "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "aurapositive"
        },
        {
          "id": 2297,
          "apCost": 1,
          "name": "Grant: Evasive",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 657,
          "apCost": 2,
          "name": "Relocate: Ally",
          "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1322,
      "name": "Elven Taskmaster",
      "description": "Shortly after D'elim's return to the Circle, he integrated his taskmasters into the K'Thras Territorial Army.  The few who openly opposed his decision tended to have unfortunate accidents.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 66,
      "hash": "eJ8HJ8Ge9BF0Ae9Ae9BJ8GJ8Heerqqukpwonsxm",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 163,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rend"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2619,
              "apCost": 0,
              "name": "Zeal: Speed",
              "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "channel_speed"
            },
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            }
          ]
        }
      ]
    },
    {
      "id": 1709,
      "name": "Elven Tender",
      "description": "Sometimes even nature needs nurture.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 62,
      "hash": "ej9Cj9BF0Af1AG2AG2AJ8HJ8Iinlrwkpyonpwqqf",
      "artist": "Danh Nguyen",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 1230,
          "apCost": 1,
          "name": "Grant: Damage Shield: Magical",
          "shortDescription": "Target champion within 5 spaces gains <ability value=225>Damage Shield: Magical 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 1,
          "iconName": "grantability"
        },
        {
          "id": 2637,
          "apCost": 3,
          "name": "Grant: Stoneskin Potion",
          "shortDescription": "Target champion within 3 spaces gains <ability value=2638>Drink: Stoneskin Potion</ability> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "grantability"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            },
            {
              "default": true,
              "id": 1785,
              "apCost": 3,
              "name": "Rite of Healing",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "fascinate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            }
          ]
        }
      ]
    },
    {
      "id": 557,
      "name": "Elven Treecaller",
      "description": "The elves became the wardens of K`thir, learning to protect and nurture their home.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elf",
        "Plant",
        "Treefolk"
      ],
      "noraCost": 69,
      "hash": "dJ8IJ8HF0Af1Be9Aj9Fj9Gj9Huszonnnygexxkeg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 1487,
          "apCost": 4,
          "name": "Summon: Young Sapling",
          "shortDescription": "Summon a Young Sapling with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumtree"
        },
        {
          "id": 1488,
          "apCost": 3,
          "name": "Tree Form",
          "shortDescription": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Gnarlwood Tree and gains gets +2 DEF, +4 DMG, +10 HP, <ability value=1085>Boost: Plant</ability> and <ability value=1083>Plant Regeneration</ability>",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1087,
              "apCost": 2,
              "name": "Take Root",
              "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            },
            {
              "default": false,
              "id": 1522,
              "apCost": 0,
              "name": "Train: Mobility",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=6>Mobility</ability>.  This ability costs 4 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cost"
            }
          ]
        }
      ]
    },
    {
      "id": 1489,
      "name": "Elven Vindicator",
      "description": "As Monks, Vindicators are often underestimated by their enemies. As a result, few are prepared for the skill and ferocity with which a Vindicator strikes. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "eJ8JJ8IF0BF0Be9AF0BJ8IJ8Jeeeepjirjeiwqo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2486,
          "apCost": 3,
          "name": "Blind",
          "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "blind"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        }
      ]
    },
    {
      "id": 491,
      "name": "Ember Wasp",
      "description": "The sting of an Ember Wasp is said to set the skin of its victim ablaze.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 69,
      "hash": "dj9AJ8Jf1Af1Ag3Aj9Dj9Ej9Fevzkuzgerofgyig",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2260,
          "apCost": 0,
          "name": "Pariah",
          "shortDescription": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "possess"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 379,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 6 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 989,
              "apCost": 0,
              "name": "Fire Volatility",
              "shortDescription": "When this unit takes fire damage, it releases a flame pulse equal to that damage, to a maximum of 12 damage, to every unit within 2 spaces. This damage ignores DEF. This unit can not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        }
      ]
    },
    {
      "id": 1313,
      "name": "Emerald Wing",
      "description": "Emerald Wings are trained to navigate through storms and even to summon them at their whim.  Griffins who show an affinity to the elements tend to be smaller and frailer than others of their ilk.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9FF0AF0Ae9Ae9AJ8HJ8Iyvkwkerlyiyzto",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2734,
          "apCost": 0,
          "name": "Emerald Sigil",
          "shortDescription": "This champion gains <ability value=2353>Grant: Teleport</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "griffin_sigil"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 805,
              "apCost": 1,
              "name": "Chain Lightning",
              "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "electric"
            }
          ]
        }
      ]
    },
    {
      "id": 1247,
      "name": "Enforcer of the Circle",
      "description": "\"You know as well as I that there is no time for moral and ethical concerns.  The Enforcers are effective and that is all that matters.\" - De'lim",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 82,
      "hash": "eJ8JJ8IG2Be9Be9AF0Bj9Cj9Dgygymwqjwitfgpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2632,
          "apCost": 0,
          "name": "Bold",
          "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "channel_defense"
        },
        {
          "id": 2642,
          "apCost": 0,
          "name": "Dictate",
          "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "dictate"
        },
        {
          "id": 36,
          "apCost": 0,
          "name": "Immunity: Magical",
          "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "immunity_magic"
        },
        {
          "id": 1312,
          "apCost": 3,
          "name": "Sweep",
          "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1566,
              "apCost": 0,
              "name": "Balance",
              "shortDescription": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "soul_bond"
            },
            {
              "default": false,
              "id": 2820,
              "apCost": 2,
              "name": "Sacrifice of De'lim",
              "shortDescription": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "chan_fuel"
            },
            {
              "default": false,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 300,
      "name": "Enraged Grizzly",
      "description": "The nefari camps near the south caves seem to have dissappeared. -- Disappeared? Camps don't just disappear. - K'thir Wardens",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 62,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 67,
      "hash": "dj9Ej9Dg3Ae9Bf1Bj9Aj9Bj9Ceeerwzkjwoqonhg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 260,
          "apCost": 0,
          "name": "Enrage",
          "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 3,
          "apCost": 0,
          "name": "Fearless",
          "shortDescription": "This unit can not become <condition value=frightened>Frightened</condition>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 963,
      "name": "Enraged Sentry",
      "description": "\"KawwwwwwwwAAARRRRARRGH!\" -- \"Oh no! Drakies are- Wait, what are you doing? Rummy, NOOOOOO!\" \r\n- This Rune honors those who survived T-Day 2011 and commemorates those who didn't. (11/24/2011) - ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 69,
      "hash": "dj9Dj9CG2Be9BG2Bj9Cj9Dj9Eeeiyrwqluhpsfig",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Maljaran War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1441,
          "apCost": 0,
          "name": "Confuse Enemy",
          "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "confuse"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2459,
          "apCost": 0,
          "name": "Honorary Sigil",
          "shortDescription": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "griffin_sigil"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": true,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        }
      ]
    },
    {
      "id": 1326,
      "name": "Epochal Sage",
      "description": "\"You may be an outsider, but I am not too proud to admit we need your help.  The internal political situation is... precarious.\" - Bliss the Muse, to the Epochal Elders' Counsel",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Monk"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8Gf1BF0Ae9Ae9Bj9Aj9Berluxqwoufvxon",
      "artist": "Nadia Enis",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1566,
          "apCost": 0,
          "name": "Balance",
          "shortDescription": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "soul_bond"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 2748,
          "apCost": 3,
          "name": "Time Bend",
          "shortDescription": "This champion is removed from play. At the end of 2 turns, it is returned to play in the location where it was removed from play. If that location is occupied, the redeployment effect is delayed for 1 turn (this process repeats until the unit is successfully redeployed). This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "confuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            }
          ]
        }
      ]
    },
    {
      "id": 615,
      "name": "Essence Devourer",
      "description": "The devourer doesn't eat the flesh of its prey; it feeds upon the essence that makes the flesh. Its immense hunger forces it to consume its allies.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 15,
      "hitPoints": 64,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Troll",
        "Undead"
      ],
      "noraCost": 53,
      "hash": "dj9Cj9BG2Af1Bg3Aj9Dj9Ej9Fiiipusxxzossfkg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 474,
          "apCost": 1,
          "name": "Blood Rage",
          "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "rend"
        },
        {
          "id": 1726,
          "apCost": 0,
          "name": "Devour Life",
          "shortDescription": "At the end of every other one of your turns, the champion with the lowest amount of health which is owned by this champion's owner is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -35,
          "iconName": "devour"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2434,
              "apCost": 0,
              "name": "Leech Vitality",
              "shortDescription": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "overkill"
            },
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 299,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 1,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 346,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +2 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 348,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 347,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +3 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 652,
      "name": "Eternal Lich",
      "description": "Some unlife is not so easily extinguished. A wandering soul can be tenacious. - Xulos of Elsarin",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 80,
      "hash": "dj9Gj9Fe9AG2Af1AJ8Jj9Aj9Bjwfgigplukpnufg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 939,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 3 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "drain"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 1774,
          "apCost": 0,
          "name": "Phylactery Bound",
          "shortDescription": "When this unit is deployed from the runedock, a Phylactery relic is summoned in the closest friendly deployment zone.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "phylactery"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 890,
              "apCost": 0,
              "name": "Grace of the Dead",
              "shortDescription": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2389,
              "apCost": 3,
              "name": "Pain Curse",
              "shortDescription": "Opposing <condition value=cursed>Cursed</condition> champions take 5 magical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "defile_corpse"
            },
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 2480,
              "apCost": 3,
              "name": "Desecrate Earth",
              "shortDescription": "Area Effect 2, Range 5: Affected spaces becomes Desecrated Ground until the end of your next turn. (Desecrated Ground - At beginning of your turns and upon casting, champions without Race: Undead or Race: Spirit in this area lose 6 HP).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "desecrate_earth"
            }
          ]
        }
      ]
    },
    {
      "id": 334,
      "name": "Ethereal Priestess",
      "description": "While most of their kin focus on material, the logical and the physical, there are Dwarves that worship the magic of inexistence. It is said that a priestess of the Ethereal can simply will away the defenses of those around her.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 71,
      "hash": "dj9AJ8Jf1AF0AG2Aj9Bj9Cj9Dpnjilpfkytxipfg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 2563,
          "apCost": 3,
          "name": "Flourish",
          "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 1001,
          "apCost": 2,
          "name": "Soften",
          "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2340,
              "apCost": 3,
              "name": "Haste",
              "shortDescription": "Target champion within 5 spaces has +4 SPD for 3 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            }
          ]
        }
      ]
    },
    {
      "id": 653,
      "name": "Ethereal Soldier",
      "description": "Now adays, it's easy to sneak up on some poor ol' sod and give him a sword in the spine. Yeah, this whole unlife thing isn't so bad. - Kirgile, Ethereal Soldier",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 13,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 64,
      "hash": "dj9Gj9Fe9AG2Af1Bj9Aj9Bj9Cemsxohiwxklnjgg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1737,
          "apCost": 0,
          "name": "Ethereal",
          "shortDescription": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "ethereal"
        },
        {
          "id": 161,
          "apCost": 0,
          "name": "Psychic Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novapsychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1245,
              "apCost": 0,
              "name": "Phase Cleansing",
              "shortDescription": "When this champion becomes <condition value=incorporeal popup=false>Incorporeal</condition>, it is <mechanic value=cleansed>Cleansed</mechanic>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 3013,
              "apCost": 0,
              "name": "Soultap Feedback",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "soultap_feedback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2480,
              "apCost": 3,
              "name": "Desecrate Earth",
              "shortDescription": "Area Effect 2, Range 5: Affected spaces becomes Desecrated Ground until the end of your next turn. (Desecrated Ground - At beginning of your turns and upon casting, champions without Race: Undead or Race: Spirit in this area lose 6 HP).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "desecrate_earth"
            }
          ]
        }
      ]
    },
    {
      "id": 384,
      "name": "Euan Ironfist",
      "description": "Euan's legendary stubbornness and family connections to the royal houses gained him his rank and power",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 89,
      "hash": "dj9AJ8Jf1AF0Be9Aj9Fj9Gj9Humnevvoqfgkjtfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 811,
          "apCost": 1,
          "name": "Euan's Hammer",
          "shortDescription": "This champion makes a Magical attack at RNG 2-5. If successfully damaged, the target is knocked back 2 spaces and is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "magic"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 971,
              "apCost": 0,
              "name": "Surge: Dwarf",
              "shortDescription": "This unit has +1 DMG for each friendly Dwarf.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dwarf"
            },
            {
              "default": false,
              "id": 1957,
              "apCost": 0,
              "name": "Surge: Paladin",
              "shortDescription": "This champion gains +1 DMG for each other friendly Paladin.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            },
            {
              "default": false,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": true,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 526,
      "name": "Euan Ironfist",
      "description": "Euan's legendary stubbornness and family connections to the royal houses gained him his rank and power",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 89,
      "hash": "dj9AJ8Jf1Af1AG2Aj9Bj9Cj9Devhnuvknukwfxfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 811,
          "apCost": 1,
          "name": "Euan's Hammer",
          "shortDescription": "This champion makes a Magical attack at RNG 2-5. If successfully damaged, the target is knocked back 2 spaces and is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "magic"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 971,
              "apCost": 0,
              "name": "Surge: Dwarf",
              "shortDescription": "This unit has +1 DMG for each friendly Dwarf.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dwarf"
            },
            {
              "default": false,
              "id": 1957,
              "apCost": 0,
              "name": "Surge: Paladin",
              "shortDescription": "This champion gains +1 DMG for each other friendly Paladin.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            },
            {
              "default": false,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": true,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 1364,
      "name": "Euan Ironfist",
      "description": "Euan's legendary stubbornness and family connections to the royal houses gained him his rank and power",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 89,
      "hash": "ej9Bj9AF0BF0Ae9Af1BJ8IJ8Jgkusqoshytonwo",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 811,
          "apCost": 1,
          "name": "Euan's Hammer",
          "shortDescription": "This champion makes a Magical attack at RNG 2-5. If successfully damaged, the target is knocked back 2 spaces and is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "magic"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        },
        {
          "id": 2806,
          "apCost": 0,
          "name": "Winter Cheer",
          "shortDescription": "This unit is filled with Winter Cheer!",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "domain_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 971,
              "apCost": 0,
              "name": "Surge: Dwarf",
              "shortDescription": "This unit has +1 DMG for each friendly Dwarf.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dwarf"
            },
            {
              "default": false,
              "id": 1957,
              "apCost": 0,
              "name": "Surge: Paladin",
              "shortDescription": "This champion gains +1 DMG for each other friendly Paladin.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            },
            {
              "default": false,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": true,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 7,
      "name": "Executioner",
      "description": "Unrelenting, unmerciful, unstoppable. Once marked, death is the only escape.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead"
      ],
      "noraCost": 72,
      "hash": "cj9Dj9Cj9BG2AG2Bj9Bj9Cj9Dwzoumsxqwfplekj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 714,
      "name": "Executioner",
      "description": "Unrelenting, unmerciful, unstoppable. Once marked, death is the only escape.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1Af1BG2Bj9Cj9Dj9Eeeevxxmhpyofrhg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 394,
      "name": "Exorcist",
      "description": "Out ye Demon filth!",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Priest"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "dJ8HJ8Ge9BF0Be9BJ8GJ8HJ8Iemwqhgnumegvquf",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 1483,
          "apCost": 3,
          "name": "Solidify",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=solid>Solid</condition> for 3 turns. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 2,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            },
            {
              "default": true,
              "id": 1885,
              "apCost": 3,
              "name": "Cleansing Flame",
              "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1938,
      "name": "Exorcist",
      "description": "Out ye Demon filth!",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9EF0Be9AG2BE8DJ8IJ8Jkuosjnlgkumjgpf",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 1483,
          "apCost": 3,
          "name": "Solidify",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=solid>Solid</condition> for 3 turns. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 2,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            },
            {
              "default": true,
              "id": 1885,
              "apCost": 3,
              "name": "Cleansing Flame",
              "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1327,
      "name": "Experimental Warspirit",
      "description": "\"Insanity, you say?  Your path would lead us to certain defeat and death.  Step aside, Bliss, if you don't have the stomach to do what must be done to save K'Thras\" - D'elim, Apex of the Circle",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Elf",
        "Spirit",
        "Undead"
      ],
      "noraCost": 82,
      "hash": "eJ8HJ8GG2AF0Ae9Ae9Bj9Bj9Ceeiyzmsohilpso",
      "artist": "Michele Chang",
      "factions": [
        "Forsaken Wastes",
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3003,
          "apCost": 0,
          "name": "Dispelling Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "dispelling_blows"
        },
        {
          "id": 2745,
          "apCost": 0,
          "name": "Distichous: KF/FW",
          "shortDescription": "When a KF champion is deployed from the runedock, this champion gains <ability value=1237>Impenetrable</ability> for 4 turns. When an FW champion is deployed from the runedock, this champion gains <ability value=1850>Frightful Blows</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "distichous"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 2281,
          "apCost": 0,
          "name": "Soul Channeling",
          "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dot_soultap"
        },
        {
          "id": 1791,
          "apCost": 0,
          "name": "Soulstrike",
          "shortDescription": "Whenever this champion successfully hits an opponent with a basic attack, target champion loses life equal to 25% of its max HP. This ability ignores immunities.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "lossoflife"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1618,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "terrain_dmz"
            },
            {
              "default": false,
              "id": 3247,
              "apCost": 3,
              "name": "Rift Nova",
              "shortDescription": "Area Effect 2, Range 5: Enemy champions occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> or Dread Field in the area lose 6 HP and lose 1 SPD for 2 turns for each friendly spirit within the AoE (to a maximum of -3).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "stormreader"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2537,
              "apCost": 0,
              "name": "Revel in Misery",
              "shortDescription": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "forsaken_conduit"
            },
            {
              "default": false,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": true,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        }
      ]
    },
    {
      "id": 1352,
      "name": "Eye of Serkan",
      "description": "\"While they cower in fear of the plagues, we shall embrace the situation and turn their distraction into our advantage.\" ~ Serkan",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Je9BF0Ae9Af1AJ8GJ8Hqwmythegerwkln",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 2594,
          "apCost": 0,
          "name": "Soul Vitality",
          "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2526,
              "apCost": 0,
              "name": "Necrosis",
              "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 1666,
      "name": "Eyoir, Rattle Slag",
      "description": "\"Their single minded determination to hunt down their target implies that they have a mind in the first place, which is clearly a ridiculous notion.\" - Calis, Lonx Beastmaster",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 70,
      "hash": "ej9Bj9Af1AF0BG2Af1BJ8Jj9Aeemwfrqhgvfetqf",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 201,
          "apCost": 0,
          "name": "Death Nova: Acid",
          "shortDescription": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovaacid"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            },
            {
              "default": false,
              "id": 3016,
              "apCost": 0,
              "name": "Life Siphon: Scoured",
              "shortDescription": "When this champion successfully damages a champion with <condition value=scoured>Scoured</condition> with a basic attack, it vampiric heals HP equal to half the damage dealt (rounded down).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "siphon_scoured"
            },
            {
              "default": true,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 850,
              "apCost": 1,
              "name": "Acid Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "acidaoe"
            },
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 2620,
              "apCost": 4,
              "name": "Corrosive Grenade",
              "shortDescription": "Area Effect 2, Range 5: Affected units take 8 Acid Damage and becomes <condition value=sundered>Sundered</condition> for 3 turns.  This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "acidaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1487,
      "name": "Fae Advocate",
      "description": "\"I can get you there... but there is a price.  You will one day find yourself transported to the Conclave without warning and I have no control over what the request may be. Do you still wish to go?\" - Saon, Fae Advocate",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 0,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 51,
      "hash": "eJ8JJ8Ie9BF0Be9AF0BJ8GJ8Heeeeepyoumuojn",
      "artist": "Darcie Banfield",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3010,
          "apCost": 4,
          "name": "Bubble",
          "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "bubble"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2587,
          "apCost": 0,
          "name": "Nightfall",
          "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 2799,
          "apCost": 0,
          "name": "Still Life",
          "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1488,
      "name": "Fae Bloomwalker",
      "description": "In these barren lands / Where once naught had dwell / Came along a dream / In her steps did bloom / Petals of life and plume",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 66,
      "hash": "eJ8JJ8IF0AF0Be9AF0BJ8HJ8Ieeeeevknhtjgnn",
      "artist": "Asa Enochs",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 3009,
          "apCost": 2,
          "name": "Summon: Dreamblossom",
          "shortDescription": "Summon a Dreamblossom relic with <ability value=2978>Dreamblossom</ability> and <ability value=3028>Demolish</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2134,
              "apCost": 0,
              "name": "Abash",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intoxicate"
            },
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 3391,
              "apCost": 0,
              "name": "Verdant Armaments",
              "shortDescription": "When a friendly champion with Race: Elf, Race: Fairy or Race: Centaur becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 1710,
      "name": "Fae Dreamer",
      "description": "Gifted telepathically, the Dreamers utilize a dream-like state to communicate with others of their kind. It was a Dreamer whom the imprisoned Amareth first reached.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 7,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 50,
      "hash": "ej9Cj9BF0Bf1AG2AG2AJ8IJ8Jiwmhvxkwquzzvqf",
      "artist": "Danh Nguyen",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 3214,
          "apCost": 0,
          "name": "Gift: Future Sight",
          "shortDescription": "The next champion you deploy from the runedock while this champion is in play gains <ability value=13>Detection 3</ability> and a <condition value=buffered>Buffer</condition> of +10 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "gift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2063,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "rebuke"
            },
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2102,
              "apCost": 0,
              "name": "Dreameater",
              "shortDescription": "At the beginning of each turn, if this champion is <condition value=stealthed>Stealthed</condition>, opposing champions within 5 spaces take 4 Psychic damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dreameater"
            },
            {
              "default": true,
              "id": 2381,
              "apCost": 0,
              "name": "Dreamstate",
              "shortDescription": "Friendly champions (including this one) that come into play within 3 spaces of this unit have Shielded, Spellswallower, Favor and Council: Spells for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "mindslice"
            }
          ]
        }
      ]
    },
    {
      "id": 1024,
      "name": "Fae Enchantress",
      "description": "\"Fae usually prefer to be the calm before the storm.\" - Godwin, Elder Garu",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Bard",
        "Wizard"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 82,
      "hash": "eJ8JJ8IF0BE8De9AF0BJ8IJ8Jygygnpyvxvxojn",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 3223,
          "apCost": 2,
          "name": "Enchant: Magic",
          "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "enchant_magic"
        },
        {
          "id": 2426,
          "apCost": 3,
          "name": "Fairy Dust",
          "shortDescription": "Target champion within 4 spaces gains <ability value=2266>Wandering</ability> for 2 Turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "fairydust"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 87,
          "apCost": 0,
          "name": "Vulnerability: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "vuln_magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": true,
              "id": 2117,
              "apCost": 5,
              "name": "Metamorphosis",
              "shortDescription": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "transform"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2456,
              "apCost": 3,
              "name": "Summon: Prismatic Crystals",
              "shortDescription": "Summon a Prismatic Crystals relic with <ability value=531>Prismatic Crystals</ability> to target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deploy"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1236,
      "name": "Fae Oracle",
      "description": "\"The flowers speak of Amareth's return, though I know not how such a thing could come to pass.  I myself was present when she faded.\" ~ Dahlia, Fae Oracle",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 80,
      "hash": "eJ8IJ8HG2Ae9Be9AF0Aj9Bj9Ceigkyrzosoqouo",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 3010,
          "apCost": 4,
          "name": "Bubble",
          "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "bubble"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 372,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 2115,
          "apCost": 3,
          "name": "Soothing Serenade",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2456,
              "apCost": 3,
              "name": "Summon: Prismatic Crystals",
              "shortDescription": "Summon a Prismatic Crystals relic with <ability value=531>Prismatic Crystals</ability> to target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deploy"
            },
            {
              "default": true,
              "id": 3009,
              "apCost": 2,
              "name": "Summon: Dreamblossom",
              "shortDescription": "Summon a Dreamblossom relic with <ability value=2978>Dreamblossom</ability> and <ability value=3028>Demolish</ability> to target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deploy"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 400,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "forcebarrier"
            },
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        }
      ]
    },
    {
      "id": 1324,
      "name": "Faeguard Nullbeast",
      "description": "Although not commonly seen, the Faeguard Nullbeasts, also known as the Faeing Mantises, are never far from their Fairy masters.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0BF0Ae9Ae9BJ8IJ8Jeevvxirwtzxthn",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1199,
          "apCost": 0,
          "name": "Calcify",
          "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novaphysical"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 1962,
          "apCost": 0,
          "name": "Weaken Spells",
          "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dark_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 241,
              "apCost": 0,
              "name": "Damage Shield: Poison",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Poison damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_poison"
            },
            {
              "default": true,
              "id": 2747,
              "apCost": 0,
              "name": "Bulwark: Fairy",
              "shortDescription": "For each friendly Fairy, this unit gains +2 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "bulwark_fairy"
            }
          ]
        }
      ]
    },
    {
      "id": 856,
      "name": "Fairy Trickster",
      "description": "\"Day 14, Night. I came across a trickster while I was stalking a Timberjaw. I had to part with a bit of Nora to keep her from exposing me. These little pests are nothing but a nuisance.\" - Vahkosh, Headhunter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue",
        "Wizard"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 71,
      "hash": "dj9Dj9CG2BG2BF0AJ8HJ8IJ8Jeemexztzituftfg",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2187,
          "apCost": 0,
          "name": "Counterspell Mastery",
          "shortDescription": "When an opponent casts a spell, if this unit has at least 6 charges, this champion loses all charges and the spell fails.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "counterspell_mastery"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        },
        {
          "id": 2540,
          "apCost": 0,
          "name": "Trickster",
          "shortDescription": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 297,
      "name": "Falconer",
      "description": "Before the war we used to raise these birds for sport...but now; well now lets just say the rules are the same, but the sport is different. - K'laus, the Falconer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 62,
      "hash": "dj9Ej9Dg3Ae9BF0AJ8HJ8IJ8Juxtohiiggtmuzzg",
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 106,
          "apCost": 0,
          "name": "Camouflage",
          "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Vegetation, that damage is reduced by 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "camo"
        },
        {
          "id": 887,
          "apCost": 1,
          "name": "Hawk Attack",
          "shortDescription": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "hawk_attack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1458,
              "apCost": 0,
              "name": "Forest Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 12,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 11,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 3 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 3 spaces are revealed.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "detection"
            }
          ]
        }
      ]
    },
    {
      "id": 239,
      "name": "Fallen Draksar",
      "description": "Though the Fallen Elsarin have ceased their raids into Old Valdec, there still remain testaments to the days of active conflict between the two nations.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar",
        "Undead"
      ],
      "noraCost": 55,
      "hash": "dj9AJ8Jf1Ae9Be9BJ8GJ8HJ8Iemnlgyowmhtfiwf",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes",
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        },
        {
          "id": 721,
          "apCost": 2,
          "name": "Shatter",
          "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "antiequip"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 115,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2214,
              "apCost": 0,
              "name": "Hunter: Scout",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_archer"
            },
            {
              "default": false,
              "id": 1142,
              "apCost": 0,
              "name": "Hunter: Hero",
              "shortDescription": "When this unit would deal damage with any attack to a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater that damage is increased by 2. When this unit would receive damage from any attack by a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "hunter_hero"
            },
            {
              "default": false,
              "id": 2216,
              "apCost": 0,
              "name": "Hunter: Mage",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "wizard_foe"
            }
          ]
        }
      ]
    },
    {
      "id": 48,
      "name": "Fallen Hero",
      "description": "Those who have fallen from the light of Ironfist may always find refuge in the darkness of the Wastes.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Barbarian",
        "Human"
      ],
      "noraCost": 59,
      "hash": "cj9AJ8JJ8IF0BG2BJ8IJ8Jj9Aeevxkjyiieeemwi",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 213,
          "apCost": 0,
          "name": "Block",
          "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "block"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2216,
              "apCost": 0,
              "name": "Hunter: Mage",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "wizard_foe"
            },
            {
              "default": false,
              "id": 1505,
              "apCost": 1,
              "name": "Throw Shield",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "throw_shield"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 287,
              "apCost": 0,
              "name": "Riposte",
              "shortDescription": "When a champion makes an unsuccessful close-combat attack against this unit, this unit makes a close-combat attack against that unit at +1 DMG.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counter"
            },
            {
              "default": true,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        }
      ]
    },
    {
      "id": 1711,
      "name": "Fanatical Devotee",
      "description": "\"If there was any question as to the perversity of De'lim's methods, these fanatics purge all doubt.\" ~ Menalaus",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 71,
      "hash": "ej9Cj9Bf1Af1AG2AG2AJ8Jj9Aeeiymyvkphyierf",
      "artist": "Paul Guzenko",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2840,
          "apCost": 0,
          "name": "Devotee of De'lim",
          "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "devotee_delim"
        },
        {
          "id": 1760,
          "apCost": 0,
          "name": "Impatient",
          "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "impatient"
        },
        {
          "id": 3215,
          "apCost": 0,
          "name": "New Growth",
          "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Young Sapling without upgrades is summoned adjacent to this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "newgrowth"
        },
        {
          "id": 2820,
          "apCost": 2,
          "name": "Sacrifice of De'lim",
          "shortDescription": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "chan_fuel"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1605,
      "name": "Farcrags Sandkip",
      "description": "Sandkips often burrow deep beneath the dunes to reach the warmer depths. They are able to collect and store a tremendous amount of heat for both offensive and defensive uses.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8IF0AF0AG2AF0BJ8HJ8Iqoqouzxkpykjwo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3111,
          "apCost": 1,
          "name": "Burning Sandspout",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged and is occupying Sand or is <condition value=sandblasted>Sandblasted</condition>, the target also becomes <condition value=charred>Charred</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 5 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "sandspout"
        },
        {
          "id": 1101,
          "apCost": 4,
          "name": "Sand Spray",
          "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "sand"
        },
        {
          "id": 3110,
          "apCost": 2,
          "name": "Sirocco",
          "shortDescription": "Area Effect 5: Friendly champions occupying Sand have <ability value=2076>Reflexes 1</ability> and <ability value=1376>Evasive 1</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "sirocco"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            },
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3157,
              "apCost": 0,
              "name": "Sandbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": true,
              "id": 1228,
              "apCost": 1,
              "name": "Grant: Trail Sand",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1102>Trail: Sand</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1102,
              "apCost": 0,
              "name": "Trail: Sand",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 1647,
      "name": "Farcrags Tardigrade",
      "description": "The changed in the Sundered Lands always pride themselves on their tenacity and durability, but still pay respect to those things which outclass them, both in tenure and in toughness.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 7,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 67,
      "hash": "eJ8IJ8HG2BF0BG2AF0Aj9Cj9Deiyofvvfmegvsqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2352,
          "apCost": 0,
          "name": "Defensive Turtle",
          "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "turtle"
        },
        {
          "id": 3157,
          "apCost": 0,
          "name": "Sandbreach",
          "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "terrainsand"
        },
        {
          "id": 2649,
          "apCost": 0,
          "name": "Void Shield",
          "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tetra_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 1100,
              "apCost": 0,
              "name": "Sandstriker",
              "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1254,
              "apCost": 0,
              "name": "Sand Veil",
              "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 152,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": false,
              "id": 249,
              "apCost": 0,
              "name": "Damage Shield: Acid",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Acid damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 459,
      "name": "Faultbreaker",
      "description": "The Ironfist Faultbreaker is used as a shock trooper, using its heft to create chaos for the enemy forces.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 16,
      "hitPoints": 70,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 112,
      "hash": "dJ8HJ8Ge9Bf1Af1Bj9Aj9Bj9Cerhigevztuowkyg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 1217,
          "apCost": 0,
          "name": "Faultbreak",
          "shortDescription": "When this champion moves by way of its normal movement, enemy champions within 2 spaces lose 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crush"
        },
        {
          "id": 3186,
          "apCost": 0,
          "name": "Fractured Lands",
          "shortDescription": "When an enemy champion within 5 spaces makes a basic attack, it loses 2 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "trail_rock"
        },
        {
          "id": 868,
          "apCost": 0,
          "name": "Rock Eater",
          "shortDescription": "When this unit takes Physical damage, it instead recovers HP equal to half the damage that would have been dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_rock"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2527,
              "apCost": 0,
              "name": "Rock Defiance",
              "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "troll_defiance"
            },
            {
              "default": false,
              "id": 2571,
              "apCost": 0,
              "name": "Rock Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Rock for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "trail_rock"
            },
            {
              "default": true,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            }
          ]
        }
      ]
    },
    {
      "id": 1930,
      "name": "Faust the Draksar Lord",
      "description": "\"Akakios may have archers to cover his mistakes, my footmen will leave no one alive.\" - Faust, Draksar Lord",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 82,
      "hash": "cj9AJ8JJ8IF0BG2AJ8IJ8Jj9Aeilwfxxoqllygvh",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1241,
          "apCost": 0,
          "name": "Motivate",
          "shortDescription": "All other friendly champions have +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "allybuffs"
        },
        {
          "id": 2053,
          "apCost": 0,
          "name": "Rallying Cries",
          "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "allybuffs"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 3369,
          "apCost": 0,
          "name": "Taunt: Legions",
          "shortDescription": "Taunt your enemies with the phrase \"To battle, my LEGIONS!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 1469,
              "apCost": 0,
              "name": "Nexus Aura",
              "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "nexus_aura"
            },
            {
              "default": true,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 879,
              "apCost": 0,
              "name": "Draconic Force",
              "shortDescription": "This champion gets +2 DMG for each friendly <mechanic value=dragonkin>Dragonkin</mechanic> within 2 spaces.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "draconic"
            },
            {
              "default": true,
              "id": 2969,
              "apCost": 0,
              "name": "Guarded: Draksar",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Draksar within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "bulwark_draksar"
            }
          ]
        }
      ]
    },
    {
      "id": 467,
      "name": "Favored Nomad",
      "description": "Known as the Children of Fortune, the nomads of Ironfist are said to bring prosperity to those around them.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9Bf1AG2Bj9Cj9Dj9Eeemjievzgrwoheg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 1455,
          "apCost": 0,
          "name": "Expedite",
          "shortDescription": "When this unit successfully attacks, you gain a rune reveal.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "scry"
        },
        {
          "id": 1218,
          "apCost": 0,
          "name": "Favor",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 49,
      "name": "Fentek Servant",
      "description": "The swamp protects.  The swamp serves.  The Old Ones protect.  The Old Ones serve. - Jokal, Boghopper Shaman",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 66,
      "hash": "cJ8JJ8IJ8HF0AF0AJ8HJ8IJ8Jeeeeeepusjiirqh",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        },
        {
          "id": 2132,
          "apCost": 0,
          "name": "Water Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainwater"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 244,
      "name": "Ferpent",
      "description": "Jakei hunters consider catching the elusive Ferpent to be a good omen.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Beast",
        "Ferren"
      ],
      "noraCost": 68,
      "hash": "dj9AJ8Jf1Ae9BG2Bj9Cj9Dj9Eeeeiplwxtqfxvfg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3160,
              "apCost": 0,
              "name": "Ferren Focus",
              "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ferren_focus"
            },
            {
              "default": true,
              "id": 752,
              "apCost": 4,
              "name": "Tunnel: Snow",
              "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_snow"
            },
            {
              "default": false,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            }
          ]
        }
      ]
    },
    {
      "id": 1135,
      "name": "Ferren Brawler",
      "description": "Young Ferren with a distaste for meditation join the Brawlers, a loosely organized group of monks who believe action, namely the taking and giving of blows, guides one to inner peace.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 67,
      "hash": "eJ8IJ8Hg3Ae9Ae9AF0Aj9Dj9Eemnlumhrwvvzzo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1444,
          "apCost": 0,
          "name": "Counter Attack: Melee",
          "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "counter"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2217,
          "apCost": 0,
          "name": "Hunter: Brawler",
          "shortDescription": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "foe_rogue"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": true,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": true,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 1633,
      "name": "Ferren Cloudwisp",
      "description": "\"I glimpse and carry with me the power of those who walk between worlds.\"",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 71,
      "hash": "eJ8HJ8Ge9AF0BG2Ae9Bj9Fj9Geerhnjnygnlufpf",
      "artist": "Rogier van de Beek",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2944,
          "apCost": 0,
          "name": "Portal Walker",
          "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1175,
      "name": "Ferren Dancer",
      "description": "Though not as martial as the way the Masters employ the art, the Ferren Dancer's use of the agility and grace of the Ferren is no less effective.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 73,
      "hash": "ej9Cj9BG2Be9Ae9AG2Aj9Cj9Doygitjevsuqzrqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2563,
          "apCost": 3,
          "name": "Flourish",
          "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 3062,
          "apCost": 3,
          "name": "Shatter Summoned",
          "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1237,
              "apCost": 0,
              "name": "Impenetrable",
              "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ironwill"
            },
            {
              "default": true,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1136,
      "name": "Ferren Master",
      "description": "The Ferren are fascinating creatures. Feral at one glance, organized and civilized at another. - Diary of L`ilae, Jakei Climber",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 71,
      "hash": "eJ8JJ8IE8De9Ae9AF0Bj9Ej9Fiwiwiwfkyiwvon",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1385,
              "apCost": 0,
              "name": "Freezing Aura",
              "shortDescription": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 2817,
              "apCost": 0,
              "name": "Freezing Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=frozen>Frozen</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "discipline_freezing"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 2944,
              "apCost": 0,
              "name": "Portal Walker",
              "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": true,
              "id": 3265,
              "apCost": 0,
              "name": "Portal Watcher",
              "shortDescription": "When a friendly champion relocates (including this one), this champion gains +1 DMG and a rank of <ability value=15>Multiattack</ability> for 1 turn. This can stack up to 3 times.",
              "activationType": 3,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deploy_chrgd"
            }
          ]
        }
      ]
    },
    {
      "id": 1137,
      "name": "Ferren Ninja",
      "description": "\"A blade under your breastplate. A touch of steel to the neck. A severed artery here. A torn ligament there. You are much more fragile than you think.\" - Overheard by the lone survivor of a Skeezick scouting party",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 79,
      "hash": "eJ8JJ8Ie9Ae9Ae9AF0Bj9Fj9Goqoqjetoytzoso",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2371,
          "apCost": 4,
          "name": "Flash Bomb",
          "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "flash_bomb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 1134,
      "name": "Ferren Pouncer",
      "description": "\"Move like the wind. Dance like the stars. Flow like the river. Strike like the chill of winter.\" - Ferren Master to his pupil",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 71,
      "hash": "eJ8IJ8HG2Be9Ae9AF0Aj9Cj9Drzofpuqqoyojwo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2941,
          "apCost": 0,
          "name": "Sundering Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_sundering"
        },
        {
          "id": 1264,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": true,
              "id": 3265,
              "apCost": 0,
              "name": "Portal Watcher",
              "shortDescription": "When a friendly champion relocates (including this one), this champion gains +1 DMG and a rank of <ability value=15>Multiattack</ability> for 1 turn. This can stack up to 3 times.",
              "activationType": 3,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 2944,
              "apCost": 0,
              "name": "Portal Walker",
              "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            }
          ]
        }
      ]
    },
    {
      "id": 1823,
      "name": "Ferren Runner",
      "description": "Ferren Runners specialize in moving goods and civilians through dangerous areas.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 61,
      "hash": "eJ8HJ8Gf1BG2BG2Ae9Bj9Aj9Bevsuhegrsuxqoqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 657,
          "apCost": 2,
          "name": "Relocate: Ally",
          "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "relocate"
        },
        {
          "id": 2799,
          "apCost": 0,
          "name": "Still Life",
          "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1225,
              "apCost": 0,
              "name": "Bastion of Mobility",
              "shortDescription": "Friendly champions within 8 spaces have <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 2773,
              "apCost": 0,
              "name": "Quest: Runner",
              "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 3010,
              "apCost": 4,
              "name": "Bubble",
              "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "bubble"
            }
          ]
        }
      ]
    },
    {
      "id": 1511,
      "name": "Ferren Snowspinner",
      "description": "Ferren Snowspinners are shamans of remarkable power, drawing power from even the harshest of environments to invigorate and replenish themselves and their allies.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 74,
      "hash": "ej9Bj9Af1BF0Be9Af1Bj9Aj9Berqwtzrlegigkpf",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 2221,
          "apCost": 0,
          "name": "Orb of Frostfall",
          "shortDescription": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
          "activationType": 1,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "trail_snow"
        },
        {
          "id": 2667,
          "apCost": 2,
          "name": "Snow Shroud",
          "shortDescription": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "domain_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 3032,
              "apCost": 0,
              "name": "Quest: Support Ally",
              "shortDescription": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1947,
      "name": "Ferren Snowspinner",
      "description": "Ferren Snowspinners are shamans of remarkable power, drawing power from even the harshest of environments to invigorate and replenish themselves and their allies.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 74,
      "hash": "ej9Gj9FF0Be9AG2Be9AJ8IJ8Jqoyofplwtmyilpf",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 2221,
          "apCost": 0,
          "name": "Orb of Frostfall",
          "shortDescription": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
          "activationType": 1,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "trail_snow"
        },
        {
          "id": 2667,
          "apCost": 2,
          "name": "Snow Shroud",
          "shortDescription": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "domain_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 3032,
              "apCost": 0,
              "name": "Quest: Support Ally",
              "shortDescription": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1424,
      "name": "Ferren Wanderer",
      "description": "\"Yes, Vallassa. Our arts are similar to what you have discovered. Your suspicion of a common origin may well be correct.\" - Whar-Pede, Ferren Wanderer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Monk"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 76,
      "hash": "ej9Fj9EF0BF0Be9AE8DJ8IJ8Jeexxvhyruftxvo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": true,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1484,
      "name": "Ferren Windwalker",
      "description": "\"For a warrior to actually catch a Ferren Windwalker is one thing. To kill one is quite another.\" - Neiwin Tal, Ferren Master",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8Hg3AF0Be9AF0Aj9Dj9Eeerzkpyzigrwkpf",
      "artist": "Asa Enochs",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 1871,
          "apCost": 0,
          "name": "Zephyr Shield",
          "shortDescription": "When this champion moves 4 spaces in a single turn, the next successful attack in 4 turns against it misses.  This effect stacks up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "zephyr_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 2773,
              "apCost": 0,
              "name": "Quest: Runner",
              "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 823,
      "name": "Feshcaller Mika",
      "description": "\"No, Sciean, I need you here. Our little Mika will go. We'll send her to Maljara with flutes, a change of clothing, and some of her 'adoring fans.' We'll see what the Leoss think of fesh.\" - Eehiist, Voil Queen.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1AG2BE8Dj9Ej9Fj9Geerhvsfrwxxxzgg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 371,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "healmass"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        },
        {
          "id": 2115,
          "apCost": 3,
          "name": "Soothing Serenade",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        },
        {
          "id": 2133,
          "apCost": 5,
          "name": "Summon: Crested Fesh",
          "shortDescription": "Summon a Crested Fesh with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 20,
          "iconName": "sumfesh"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2063,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "rebuke"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 139,
      "name": "Festering Corpse",
      "description": "Cutting down a man you've killed before is nothing. Squarin' off with a mate of yours who was killed in the last battle? That's torture. - Tibbs MacQuarrie, Stronghold Sergeant",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 31,
      "hash": "dJ8JJ8IF0Be9AE8Dj9Ej9Fj9Geeeeemnhrshilyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 156,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novadisease"
            },
            {
              "default": false,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": false,
              "id": 253,
              "apCost": 0,
              "name": "Damage Shield: Disease",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Disease damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_disease"
            }
          ]
        }
      ]
    },
    {
      "id": 1809,
      "name": "Festival Mika",
      "description": "After her successes in Maljara, Mika was forever a centerpiece of the wild Peaks celebrations. To the Voil, it never mattered if the Fesh got out of hand.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Bard"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9FF0AG2BG2Ae9AJ8HJ8Inymsuzgroqqhtqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 371,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "healmass"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        },
        {
          "id": 2115,
          "apCost": 3,
          "name": "Soothing Serenade",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        },
        {
          "id": 2133,
          "apCost": 5,
          "name": "Summon: Crested Fesh",
          "shortDescription": "Summon a Crested Fesh with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 20,
          "iconName": "sumfesh"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2063,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "rebuke"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 767,
      "name": "Finlord's Neophyte",
      "description": "Kartch believed that his best soldiers should also learn the essence of Nora. Along with their training, they studied healing magics under Gekaal, the High One. They were known as the Finlord's Neophytes.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 73,
      "hash": "dj9Fj9EE8DG2Be9BJ8GJ8HJ8Iukyrukgevmwohyg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 368,
          "apCost": 3,
          "name": "Heal Champion",
          "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "heal"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1990,
          "apCost": 0,
          "name": "Neophyte",
          "shortDescription": "While Kartch is in play, this champion gains +5 MAX HP and +1 SPD.  While Gekaal is in play, this champion has <ability value=372>Heal Mass 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "revere"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1076,
              "apCost": 3,
              "name": "Heal Self",
              "shortDescription": "This unit recovers 12 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 1140,
              "apCost": 2,
              "name": "Command: Heal",
              "shortDescription": "The next time friendly champions within 3 spaces are healed, the amount is increased by 6.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_heal"
            },
            {
              "default": true,
              "id": 840,
              "apCost": 3,
              "name": "Nora Shield",
              "shortDescription": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "nora_barrier"
            }
          ]
        }
      ]
    },
    {
      "id": 1661,
      "name": "Fiora, Favored Nomad",
      "description": "Known as the Children of Fortune, the nomads of Ironfist are said to bring prosperity to those around them.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "ej9Bj9AE8DF0BG2Af1Bj9Ej9Feephyzxtsjwvsqf",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 1455,
          "apCost": 0,
          "name": "Expedite",
          "shortDescription": "When this unit successfully attacks, you gain a rune reveal.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "scry"
        },
        {
          "id": 1218,
          "apCost": 0,
          "name": "Favor",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 127,
      "name": "Fire Elemental",
      "description": "Your K'Thir forefathers have forgotten that all life begins in fire. - Maxxarek of Sheoul",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 71,
      "hash": "dJ8IJ8HF0Ae9Ae9BJ8GJ8HJ8Irhitzkekgipqouf",
      "artist": "Michael Dutton",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        },
        {
          "id": 89,
          "apCost": 0,
          "name": "Vulnerability: Frost",
          "shortDescription": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3193,
              "apCost": 3,
              "name": "Flame Prison",
              "shortDescription": "Spaces adjacent to target champion within 5 spaces becomes Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "trail_firewall"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            }
          ]
        }
      ]
    },
    {
      "id": 490,
      "name": "Fire Giant",
      "description": "The wrathful giants of Lower Sheoul agreed to join Grimlic in his crusade against the over-world.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1Af1AG2Bj9Cj9Dj9Eeeemepuqqlgemhg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 623,
          "apCost": 0,
          "name": "Knockback",
          "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 480,
          "apCost": 0,
          "name": "Lavawalker",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1329,
              "apCost": 0,
              "name": "Domain: Lava",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_lava"
            },
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        }
      ]
    },
    {
      "id": 1589,
      "name": "Fire Phoenix",
      "description": "Born in the depths of a Maljaran volcano, these creatures were recruited by the demons of the Underdepths to incinerate their enemies.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 6,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 80,
      "hash": "ej9Fj9EE8DF0AG2AE8Dj9Ej9Fkuxqszvqsqwfmpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3074,
          "apCost": 0,
          "name": "Rebirth",
          "shortDescription": "When this champion is destroyed, it drops no nora globe and is redeployed in the closest friendly deployment zone without this ability, but gains 5 AP and permanently gains +4 DMG and +25 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 35,
          "iconName": "revive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": true,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            },
            {
              "default": false,
              "id": 767,
              "apCost": 1,
              "name": "Fire Attack",
              "shortDescription": "This unit makes a Fire attack at range 2-4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 347,
      "name": "Fire Salaman",
      "description": "Fire Salaman came into being after a nora well was destroyed by a Voil Bomber. Salaman shaman found they were not burned, but the fire in their bellies would still not die.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 70,
      "hash": "dj9Cj9BG2AF0Ae9Aj9Fj9Gj9Hxolusowvvmuolgg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 207,
      "name": "Firebomber",
      "description": "Gaktch, calm down...what happened at the village?-Bats! Fire breathing Bats!",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Moga",
        "Voil"
      ],
      "noraCost": 71,
      "hash": "dj9Gj9Fe9Ae9BG2Aj9Bj9Cj9Dsjeeegeipjnnufg",
      "artist": "Trevor Claxton",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 773,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fireaoe"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 679,
              "apCost": 0,
              "name": "G'hernbound",
              "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "ghernbound"
            },
            {
              "default": false,
              "id": 3158,
              "apCost": 0,
              "name": "Reckless",
              "shortDescription": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "reckless"
            },
            {
              "default": false,
              "id": 967,
              "apCost": 0,
              "name": "Voil Bound",
              "shortDescription": "At the beginning of your enemy's turns, there are no other friendly Voil in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1436,
              "apCost": 0,
              "name": "Leverage: Beast",
              "shortDescription": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": true,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 686,
      "name": "Firemaw",
      "description": "As Gerron Lighthander was consumed by the fires of Sheoul, his body went through a terrible metamorphosis. From the change came Firemaw, a behemoth made of an immortal wrath.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 7,
      "damage": 14,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 92,
      "hash": "dJ8IJ8HF0AG2Af1Bj9Aj9Bj9Cevfvhnyroljeeeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1855,
          "apCost": 0,
          "name": "Fiery Death",
          "shortDescription": "When this champion is destroyed, all champions in play suffer 10 fire damage and a Heart of Fire relic is deployed.  If the Heart of Fire is not destroyed after 2 rounds, it hatches, redeploying Firemaw.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "fiery_death"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 37,
          "apCost": 0,
          "name": "Immunity: Fire",
          "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "immunity_fire"
        },
        {
          "id": 2552,
          "apCost": 0,
          "name": "Lava Born",
          "shortDescription": "When this champion is not occupying lava, its RNG becomes 1-1 and it gains <ability value=1209>Defiant</ability> and +2 DEF.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "domain_lava"
        },
        {
          "id": 1118,
          "apCost": 2,
          "name": "Lava-Fall",
          "shortDescription": "Spaces within 2 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1329,
              "apCost": 0,
              "name": "Domain: Lava",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_lava"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1448,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "deathnovalava"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1886,
              "apCost": 4,
              "name": "Annihilate",
              "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 407,
      "name": "Firestarter",
      "description": "Born in fire, they sap the will to fight from those around them with a dark magic still not understood.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0AF0BE8Dj9Ej9Fj9Geeitjnpuzknwoyg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1329,
          "apCost": 0,
          "name": "Domain: Lava",
          "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_lava"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 1119,
          "apCost": 2,
          "name": "Lava-Fall",
          "shortDescription": "Spaces within 4 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "terrainlava"
        },
        {
          "id": 1852,
          "apCost": 4,
          "name": "Tunnel: Lava",
          "shortDescription": "This unit is relocated to target Lava space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_lava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            },
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            },
            {
              "default": false,
              "id": 1448,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "deathnovalava"
            },
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1492,
      "name": "Firk Behemoth",
      "description": "The Behemoths do not employ psychic attacks themselves, preferring brute force, but they do seem to have an appetite for the suffering of others.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 80,
      "hash": "eJ8JJ8IG2AF0Be9AF0Bj9Bj9Ceeeeeexfpjnhgpf",
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 456,
          "apCost": 2,
          "name": "Fear",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "fear"
        },
        {
          "id": 2784,
          "apCost": 0,
          "name": "Hunter: Soultapped",
          "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_soultap"
        },
        {
          "id": 3013,
          "apCost": 0,
          "name": "Soultap Feedback",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "soultap_feedback"
        },
        {
          "id": 3012,
          "apCost": 0,
          "name": "Vigor: Psychic",
          "shortDescription": "The first time each turn a champion within 3 spaces takes Psychic damage from a source other than this champion, this champion gains 2 AP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "vigor_psychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2704,
              "apCost": 0,
              "name": "Crushing Blow",
              "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 472,
      "name": "Firk Botanist",
      "description": "Firk botanists rarely fight offensively, using their psychic and botanical powers to defend the swamp's flora.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0Af1Ae9BJ8GJ8HJ8Ivowfpqzgytxkevf",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2309,
          "apCost": 0,
          "name": "Hallucinogenic",
          "shortDescription": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hallucinogenic"
        },
        {
          "id": 2338,
          "apCost": 0,
          "name": "Psychic Magnetism",
          "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2990,
              "apCost": 0,
              "name": "Psychic Anguish",
              "shortDescription": "Enemy champions within 5 spaces of this unit who take Psychic damage become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "psychic_anguish"
            },
            {
              "default": false,
              "id": 906,
              "apCost": 0,
              "name": "Amplify: Psychic",
              "shortDescription": "All psychic damage is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_psychic"
            },
            {
              "default": true,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            },
            {
              "default": true,
              "id": 2343,
              "apCost": 3,
              "name": "Paralyze",
              "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "sentry"
            },
            {
              "default": false,
              "id": 1469,
              "apCost": 0,
              "name": "Nexus Aura",
              "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "nexus_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 315,
      "name": "Firk Diplomat",
      "description": "Beware negotiations with the speechless Firk. They will know your words before they reach your lips. - Voil Queen to her Messenger",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 72,
      "hash": "dJ8JJ8IF0BF0AE8Dj9Ej9Fj9Geeeeevxtxievszg",
      "artist": "Gabriel Garza",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 897,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "mind_control"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1455,
              "apCost": 0,
              "name": "Expedite",
              "shortDescription": "When this unit successfully attacks, you gain a rune reveal.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "scry"
            },
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            },
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            }
          ]
        }
      ]
    },
    {
      "id": 1491,
      "name": "Firk Executor",
      "description": "Executors are not known to jump to conclusions, but when the decision is made to strike, they do so decisively and with the full support of their brethren.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8If1BF0Be9AF0Bj9Aj9Beeeeeiiyouklyo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 3014,
          "apCost": 0,
          "name": "Mind Meld",
          "shortDescription": "This champion has +1 DMG for each friendly real champion with <ability value=547>Attack: Psychic</ability> or that shares a race with this one.  Those champions gain 25% of the DMG bonus if they do not have Mind Meld.  This effect is rounded down and does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "mind_meld"
        },
        {
          "id": 3056,
          "apCost": 0,
          "name": "Overkill: Healing",
          "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overkill"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2239,
              "apCost": 0,
              "name": "Corruption",
              "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "ondeath"
            },
            {
              "default": true,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 524,
      "name": "Firk Infiltrator",
      "description": "The Infiltrators adapted quickly to the Dark Marsh, developing special skills to help with surveillance.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 71,
      "hash": "dj9Ej9Dg3Af1AG2Aj9Bj9Cj9Doqqhgnsshvsosjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 1790,
              "apCost": 4,
              "name": "Shadow Shift",
              "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "shadow_shift"
            },
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2540,
              "apCost": 0,
              "name": "Trickster",
              "shortDescription": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "nemesis_x"
            },
            {
              "default": false,
              "id": 906,
              "apCost": 0,
              "name": "Amplify: Psychic",
              "shortDescription": "All psychic damage is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_psychic"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        }
      ]
    },
    {
      "id": 1331,
      "name": "Firk Mastermind",
      "description": "\"We lead with logic, not ego, and we shall aid the Swamp with patience, not bravado.\" ~ Mastermind Sha'Lon",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 75,
      "hash": "eJ8IJ8He9AF0Ae9AF0Aj9Fj9Gvsqluzgrhnyoso",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2794,
          "apCost": 0,
          "name": "Mastermind",
          "shortDescription": "At the end of its turn, this champion has +1 SPD and <ability value=2479>Improve Speed</ability> for 3 turns if you have 35 or less nora.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge"
        },
        {
          "id": 3376,
          "apCost": 0,
          "name": "Noetic Mind",
          "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "mind_lock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1912,
              "apCost": 0,
              "name": "Resonance",
              "shortDescription": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            }
          ]
        }
      ]
    },
    {
      "id": 646,
      "name": "Firk Mimic",
      "description": "Through telepathy, Firks can develop an intense, empathetic bond with any creature instantly. This gift is often an involuntary one, making it problematic.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk",
        "Rogue"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 67,
      "hash": "dj9Fj9EE8DG2Ag3Aj9Dj9Ej9Fsmepuvxmhiipljg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2217,
          "apCost": 0,
          "name": "Hunter: Brawler",
          "shortDescription": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "foe_rogue"
        },
        {
          "id": 1765,
          "apCost": 0,
          "name": "Mimic Damage",
          "shortDescription": "This unit's DMG is equal to the base DMG of the champion with the highest base DMG in play. This does not include Avatars. If there are no other champions in play, this unit's DMG is 0.\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 16,
          "iconName": "mimic_defense"
        },
        {
          "id": 1816,
          "apCost": 0,
          "name": "Mimic Defense",
          "shortDescription": "This unit's DEF is equal to the base DEF of the champion with the highest base DEF in play. This does not include Avatars.  If there are no other champions in play this unit's DEF is 0. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mimic_defense"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1470,
              "apCost": 0,
              "name": "Nohkan Do",
              "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 645,
      "name": "Firk Mind Shredder",
      "description": "The Mind Shredders act as conduits for psychic energy. When they are threatened, they defend themselves by discharging their excess power.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 71,
      "hash": "dj9Fj9EE8DG2AG2Bj9Cj9Dj9Eeeeeitftjinjwig",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 3376,
          "apCost": 0,
          "name": "Noetic Mind",
          "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "mind_lock"
        },
        {
          "id": 3169,
          "apCost": 1,
          "name": "Psychic Compulsion",
          "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "psychic_compulsion"
        },
        {
          "id": 2506,
          "apCost": 0,
          "name": "Psychic Ping",
          "shortDescription": "When this unit comes into play, it deals 6 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 6 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "psychic"
        },
        {
          "id": 3013,
          "apCost": 0,
          "name": "Soultap Feedback",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "soultap_feedback"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 3220,
              "apCost": 0,
              "name": "Mind Siphon",
              "shortDescription": "When this champion is attacked by a basic attack, it gains the upgraded abilities of the attacking champion for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "mindsiphon"
            }
          ]
        }
      ]
    },
    {
      "id": 119,
      "name": "Firk Mindbreaker",
      "description": "Our histories say nothing of the Firk. They are anomalous, and thus of value to me. Serkan, the Lich King",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9Be9AG2Bj9Cj9Dj9Eeevfiegygtmjnyg",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1017,
          "apCost": 1,
          "name": "Knockout",
          "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "stun"
        },
        {
          "id": 1354,
          "apCost": 0,
          "name": "Sneak",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 906,
              "apCost": 0,
              "name": "Amplify: Psychic",
              "shortDescription": "All psychic damage is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_psychic"
            },
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            }
          ]
        }
      ]
    },
    {
      "id": 1522,
      "name": "Firk Mindcaller",
      "description": "The saying goes, that one should never turn their back on a Firk. If only it were as easy to hide one's thoughts as well.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 73,
      "hash": "ej9Cj9BG2AF0Be9AG2Aj9Bj9Ceeevzzmjtjggtqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            },
            {
              "default": true,
              "id": 1778,
              "apCost": 0,
              "name": "Sabotage: Psychic",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 1554,
      "name": "Firk Mindcaller",
      "description": "\"A time will come when strength reveals itself from the darkness.\" Cyrix Shadowreader",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9Eg3Af1Ae9AE8Dj9Dj9Eeruhrjnlgtzmwqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "The Ronin",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            },
            {
              "default": true,
              "id": 1778,
              "apCost": 0,
              "name": "Sabotage: Psychic",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 688,
      "name": "Firk Mindweaver",
      "description": "We weave a tapestry of consciousness, a web to entangle our enemies. - Eliramos, Firk Mindweaver",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 74,
      "hash": "dJ8IJ8HF0AG2AG2Bj9Cj9Dj9Eeeigytfvoyklygg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1429,
          "apCost": 1,
          "name": "Absorb Illusion",
          "shortDescription": "The nearest <condition value=illusion>Illusion</condition> within 5 spaces is destroyed and this unit heals 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 1,
          "iconName": "heal"
        },
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 2687,
          "apCost": 3,
          "name": "Confuse",
          "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "confuse"
        },
        {
          "id": 1895,
          "apCost": 0,
          "name": "Illusion of Lies",
          "shortDescription": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "planar"
        },
        {
          "id": 3376,
          "apCost": 0,
          "name": "Noetic Mind",
          "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "mind_lock"
        },
        {
          "id": 1779,
          "apCost": 0,
          "name": "Psychic Ping",
          "shortDescription": "When this unit comes into play, it deals 4 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 4 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "psychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            },
            {
              "default": true,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 906,
              "apCost": 0,
              "name": "Amplify: Psychic",
              "shortDescription": "All psychic damage is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_psychic"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 1490,
      "name": "Firk Paraform",
      "description": "The Paraform's inclinations to dabble in various aspects of magic they observe have left them with an eclectic mix of abilities - to both contain and then to extract knowledge from their captives.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk",
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8If1AF0Be9AF0BJ8Jj9Aeeeeeegrqlpquo",
      "artist": "Anthony Lopes",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 295,
          "apCost": 0,
          "name": "Deflect",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2818,
              "apCost": 0,
              "name": "Forbidden Discipline",
              "shortDescription": "The next basic attack this champion makes causes the target to become <condition value=frightened>Frightened</condition> for 2 turns. If the target was <condition value=frozen>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "discipline_forbidden"
            },
            {
              "default": true,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": true,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        }
      ]
    },
    {
      "id": 644,
      "name": "Firk Prophet",
      "description": "The Firk prophets are revered for their premonitions, since precognition is rare.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8DG2AG2Aj9Bj9Cj9Dygkwiinuqwkgkgg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2353,
          "apCost": 1,
          "name": "Grant: Teleport",
          "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "grantability"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 1776,
          "apCost": 0,
          "name": "Premonition",
          "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1917,
              "apCost": 0,
              "name": "Revere: Hydraxor",
              "shortDescription": "While this champion is in play, Hydraxor costs 10% less nora to deploy. While Hydraxor is in play, this champion gains <ability value=1325>Domain: Water</ability> and any damage this champion deals counts toward Hydraxor's <ability value=1892>Quest: Damage</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1566,
              "apCost": 0,
              "name": "Balance",
              "shortDescription": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "soul_bond"
            },
            {
              "default": true,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 769,
      "name": "Firk Prophet",
      "description": "The Firk prophets are revered for their premonitions, since precognition is rare.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8DG2BF0BJ8IJ8Jj9Awiegemhevkpneeg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broodcall",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2353,
          "apCost": 1,
          "name": "Grant: Teleport",
          "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "grantability"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 1776,
          "apCost": 0,
          "name": "Premonition",
          "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1917,
              "apCost": 0,
              "name": "Revere: Hydraxor",
              "shortDescription": "While this champion is in play, Hydraxor costs 10% less nora to deploy. While Hydraxor is in play, this champion gains <ability value=1325>Domain: Water</ability> and any damage this champion deals counts toward Hydraxor's <ability value=1892>Quest: Damage</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1566,
              "apCost": 0,
              "name": "Balance",
              "shortDescription": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "soul_bond"
            },
            {
              "default": true,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 402,
      "name": "Firk Psy-sentry",
      "description": "If you think he's seen you, he probably has.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9BF0BG2Aj9Bj9Cj9Demjyxxzxilrlpyg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 12,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "detection"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 2271,
          "apCost": 0,
          "name": "Sentinel",
          "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3356,
              "apCost": 0,
              "name": "Pacifying Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is Pacified for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 88,
              "apCost": 0,
              "name": "Vulnerability: Fire",
              "shortDescription": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "vuln_fire"
            },
            {
              "default": false,
              "id": 1316,
              "apCost": 0,
              "name": "Vulnerable",
              "shortDescription": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -3,
              "iconName": "vuln_physical"
            },
            {
              "default": true,
              "id": 2001,
              "apCost": 0,
              "name": "Defenseless",
              "shortDescription": "This unit takes 30% more damage from melee attacks. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -5,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 748,
      "name": "Firk Savant",
      "description": "It was believed the Firk thought themselves above the use of spellcraft. The misconception was dispelled when a group of Firk were found studying in K`thiras, along with several spellbooks and arcane tomes. ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 79,
      "hash": "dj9Dj9CG2BG2AF0AJ8HJ8IJ8Jeevonjykljrjpfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2300,
          "apCost": 0,
          "name": "Charged Blast",
          "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2175,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "charged_spell"
        },
        {
          "id": 3011,
          "apCost": 0,
          "name": "Stasis",
          "shortDescription": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "crystallize"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        }
      ]
    },
    {
      "id": 50,
      "name": "Firk Sensorate",
      "description": "The Firk are unwavering defenders of the waters and sense when the balance of the Swamp is threatened.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 82,
      "hash": "cj9Fj9Ej9Dg3AF0Aj9Dj9Ej9Feevxzvxmjgpjnnj",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1502,
          "apCost": 0,
          "name": "Bravery",
          "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "buff"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            },
            {
              "default": true,
              "id": 3067,
              "apCost": 0,
              "name": "Psychic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "psychicaoe"
            },
            {
              "default": false,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": true,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": false,
              "id": 2193,
              "apCost": 0,
              "name": "Psychic Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 1513,
      "name": "Firk Soulthief",
      "description": "Some reclusive Firk have begun studying under Darkmarsh Shamans; learning dark magics and even developing the ability to drain the life force of their foes.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 77,
      "hash": "ej9Bj9AG2BF0Be9Af1Bj9Cj9Demlrqqhtzouftqf",
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 594,
          "apCost": 0,
          "name": "Energy Thief",
          "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 3379,
          "apCost": 0,
          "name": "Magic Ward",
          "shortDescription": "This champion cannot be the target of friendly spells.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "spell_resistance"
        },
        {
          "id": 2991,
          "apCost": 4,
          "name": "Soulwrack",
          "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "soulwrack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": true,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 3100,
              "apCost": 0,
              "name": "Catalyst: Psychic",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_psychic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 161,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapsychic"
            },
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 345,
      "name": "Firk Spellblaster",
      "description": "Spellblasters seem to know the result of a spell before its cast, and have learned to exploit this. Masters of the mind and magic, the Spellblasters are truly a force to behold.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 66,
      "hash": "dj9Bj9Af1BF0Ag3Aj9Dj9Ej9Fjgextjgphrsjyig",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 36,
          "apCost": 0,
          "name": "Immunity: Magical",
          "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "immunity_magic"
        },
        {
          "id": 962,
          "apCost": 1,
          "name": "Reckless Blast",
          "shortDescription": "This unit makes a Magical attack at RNG 2-5 at 12 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "magicaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2216,
              "apCost": 0,
              "name": "Hunter: Mage",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "wizard_foe"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 225,
              "apCost": 0,
              "name": "Damage Shield: Magical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Magical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1493,
      "name": "Firk Thornflinger",
      "description": "The Thornflinger's weapons are living creatures taken from deep in the Forglar Swamp. These plants have a unique defense mechanism of shooting thorns containing powerful neurotoxins when threatened.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8IG2BF0Be9AF0Bj9Cj9Deeeepqosfxzzkpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1441,
          "apCost": 0,
          "name": "Confuse Enemy",
          "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "confuse"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2154,
              "apCost": 0,
              "name": "Combo Attack: Burn",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=charred>Charred</condition> for 5 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            }
          ]
        }
      ]
    },
    {
      "id": 1599,
      "name": "Firk Voidmage",
      "description": "While the dark arts are not unknown in the Swamp, the Firk Voidmage's practices seem to draw from a different, but equally terrifying, power.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 84,
      "hash": "eJ8HJ8GG2BF0AG2Ae9Bj9Cj9Deigvxvvqlevsmpf",
      "artist": "Markus Erdt",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        },
        {
          "id": 3102,
          "apCost": 4,
          "name": "Spatial Dysplasia",
          "shortDescription": "Area Effect 2, Range 5: Enemy champions are pulled 1 space towards the center tile and take 4 Psychic damage for every enemy champion within the affected area (this ignores DEF).",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "spatial_dysplasia"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1611,
      "name": "First Watcher Senshu",
      "description": "Frostfall Dragons are revered by those who live in the Tundra, who believe them to be guardian spirits manifesting in the mortal realm to watch over them.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 75,
      "hash": "ej9AJ8Je9BF0AG2Af1AJ8GJ8Hyknufilgkrwiwo",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3105,
          "apCost": 4,
          "name": "Absolute Zero",
          "shortDescription": "Opposing champions within 2 spaces take 12 Frost damage, opposing champions within 4 spaces take 10 Frost damage, and opposing champions within 6 spaces take 8 Frost damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "absolute_zero"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2796,
          "apCost": 0,
          "name": "Snowbreach",
          "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainsnow"
        },
        {
          "id": 752,
          "apCost": 4,
          "name": "Tunnel: Snow",
          "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 604,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2606,
              "apCost": 4,
              "name": "Arctic Bolt",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "iceaoe"
            },
            {
              "default": true,
              "id": 1296,
              "apCost": 1,
              "name": "Avalanche",
              "shortDescription": "Area Effect 2, Range 5: Affected champions without <ability value=600>Arctic</ability> take 12 Frost damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Deep Snow (Impeding 1).",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 12,
              "iconName": "iceaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 390,
              "apCost": 1,
              "name": "Frost Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            }
          ]
        }
      ]
    },
    {
      "id": 1380,
      "name": "Fist of Bastion",
      "description": "The Fists are the elite warrior corp of Bastion's army. Legend has it that they are beaten as newborns in order to toughen them. This is not true; the beatings don't begin until their third winter.\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian",
        "Beast"
      ],
      "noraCost": 77,
      "hash": "ej9Cj9BF0AF0Ae9AG2AJ8HJ8Igtqhvfplnjwmwo",
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2883,
          "apCost": 3,
          "name": "Ride Down",
          "shortDescription": "Target a champion with 15 or less HP within 3 spaces. This champion moves in a straight line through non-Impeding terrain and destroys that champion. This ability is on the attack chain.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "decapitate"
        },
        {
          "id": 2873,
          "apCost": 0,
          "name": "Warchief: Stone Clan",
          "shortDescription": "This unit has <ability value=3379>Magic Ward</ability>. At the end of your turn, this unit gains a rank of <ability value=1900>Tough</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "stone_clan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 1556,
      "name": "Flagellum of Chains",
      "description": "\"Cruel? We are not cruel. We simply ensure efficiency and devotion.\" ~ Algor, Flagellum of Chains",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 84,
      "hash": "ej9Gj9Fe9Af1Ae9Ae9Aj9Fj9Gmhroshkuzigknpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 3039,
          "apCost": 4,
          "name": "Take Prisoner",
          "shortDescription": "Target enemy champion within 3 spaces with 10 or less current HP is Possessed. That champion has <ability value=2005>Careless</ability> and <ability value=877>Bodyguard</ability> while Possessed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "take_prisoner"
        },
        {
          "id": 3035,
          "apCost": 0,
          "name": "Terminus",
          "shortDescription": "When a champion within 8 spaces loses AP, this champion gains AP equal to the amount lost, to a maximum of 4 AP per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "terminus"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1700,
              "apCost": 0,
              "name": "Surge: Draksar",
              "shortDescription": "This unit has +1 DMG for each friendly Draksar.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_draksar"
            }
          ]
        }
      ]
    },
    {
      "id": 310,
      "name": "Flame Dragoleech",
      "description": "The mines are just not producing like they should. Those blasted dragons are leeching the nora from us! - High Mason reporting to the General.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 63,
      "hash": "dJ8IJ8HF0AF0Af1Bj9Aj9Bj9Cemekevzxkpjgkyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            },
            {
              "default": false,
              "id": 885,
              "apCost": 3,
              "name": "Flame Siphon",
              "shortDescription": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 923,
      "name": "Flame Skitter",
      "description": "The Flame Skitters were believed to be descendants of the Magma Bunnies. These claims have been refuted by the all-knowing Bunny Lord.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 7,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 70,
      "hash": "dJ8JJ8IF0Bg3AG2Aj9Bj9Cj9Dukukusjrlwxojgg",
      "artist": "Darcie Banfield",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2007,
          "apCost": 0,
          "name": "Helpless",
          "shortDescription": "This champion has <ability value=2002>Easy Target</ability> and <ability value=2001>Defenseless</ability> ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -17,
          "iconName": "defpenalties"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2357,
          "apCost": 0,
          "name": "Shadowstrike",
          "shortDescription": "This champion becomes stealthed after making a basic attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1737,
      "name": "Flamebreath Ballista",
      "description": "\"Set 'er down, set 'er down. This battle is only just warming up!\" -- Dwarven Tinker-Seargent",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Archer"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 75,
      "hash": "eJ8HJ8Ge9Af1BG2Ae9Bj9Fj9Gemwqzmetzxvqjpf",
      "artist": "Grant Griffin",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3229,
          "apCost": 2,
          "name": "Ballista Assault Mode",
          "shortDescription": "Until this champion moves, when an enemy unit within this unit's range is the target of a friendly basic attack from another unit, this unit makes a basic Fire attack against the same target for 2 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "ballista_mode"
        },
        {
          "id": 1818,
          "apCost": 0,
          "name": "Defensive Strike",
          "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2095,
              "apCost": 0,
              "name": "Combo Attack: Slam",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion is knocked back 2 spaces.\r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "comboatk_slam"
            }
          ]
        }
      ]
    },
    {
      "id": 1386,
      "name": "Flamemage of the Circle",
      "description": "De'lim, Apex of the Circle, formerly the Outcast, has brought his arts to a new generation of K'Thras mages.  Those with the greatest talents are inducted into the ranks of the flamemages.\r\n",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 71,
      "hash": "ej9Cj9Bg3AF0Ae9AG2Aj9Dj9Eeeiymyvkphyierf",
      "artist": "Conceptopolis",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1885,
          "apCost": 3,
          "name": "Cleansing Flame",
          "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "cleanse"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1255,
          "apCost": 0,
          "name": "Inhibiting Touch",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "inhibit"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 2820,
              "apCost": 2,
              "name": "Sacrifice of De'lim",
              "shortDescription": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "chan_fuel"
            },
            {
              "default": true,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 772,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 408,
      "name": "Flameweb Spider",
      "description": "We hate spiders and we hate demons. This is a spider demon. You figure out the rest. - Genley, Dwarven Sargeant",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 60,
      "hash": "dJ8IJ8HF0AF0Be9Aj9Fj9Gj9Hjgpjytqhyzvkyzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 480,
          "apCost": 0,
          "name": "Lavawalker",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1404,
              "apCost": 0,
              "name": "Fire Feed",
              "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "eater_fire"
            },
            {
              "default": true,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 132,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafire"
            }
          ]
        }
      ]
    },
    {
      "id": 1532,
      "name": "Flameweb Spider",
      "description": "We hate spiders and we hate demons. This is a spider demon. You figure out the rest. - Genley, Dwarven Sargeant",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 60,
      "hash": "ej9Dj9CG2AF0Be9AG2Bj9Bj9Ceeigyxmnpuziyrf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 480,
          "apCost": 0,
          "name": "Lavawalker",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1404,
              "apCost": 0,
              "name": "Fire Feed",
              "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "eater_fire"
            },
            {
              "default": true,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 132,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafire"
            }
          ]
        }
      ]
    },
    {
      "id": 1035,
      "name": "Fleshblight Zombie",
      "description": "\"Pocghs Norrgha ich barancghed.\" - Nill, Zombie",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 67,
      "hash": "eJ8JJ8Ie9BE8De9AF0BJ8GJ8Hmsmsmpyouowmym",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 2253,
          "apCost": 0,
          "name": "Manic",
          "shortDescription": "At the end of its turn, if this champion has a MIN RNG of 1, it moves 2 spaces toward the closest enemy champion, and makes an attack against that champion if possible.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "manic"
        },
        {
          "id": 2107,
          "apCost": 0,
          "name": "Reconstitute",
          "shortDescription": "At the beginning of your turns, this champion is healed to full HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 156,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novadisease"
            },
            {
              "default": true,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": false,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 2142,
              "apCost": 0,
              "name": "Zombie Apocalypse",
              "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "zombie_apoc"
            }
          ]
        }
      ]
    },
    {
      "id": 1531,
      "name": "Fleshblight Zombie",
      "description": "\"Pocghs Norrgha ich barancghed.\" - Nill, Zombie",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 67,
      "hash": "ej9Dj9Cf1BF0Be9AG2Bj9Aj9Berzgruxqsszgtqf",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 2253,
          "apCost": 0,
          "name": "Manic",
          "shortDescription": "At the end of its turn, if this champion has a MIN RNG of 1, it moves 2 spaces toward the closest enemy champion, and makes an attack against that champion if possible.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "manic"
        },
        {
          "id": 2107,
          "apCost": 0,
          "name": "Reconstitute",
          "shortDescription": "At the beginning of your turns, this champion is healed to full HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 156,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novadisease"
            },
            {
              "default": true,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": false,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 2142,
              "apCost": 0,
              "name": "Zombie Apocalypse",
              "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "zombie_apoc"
            }
          ]
        }
      ]
    },
    {
      "id": 1227,
      "name": "Fleshweaver Witch",
      "description": "Stitch and weave, two by two; arms and feet and soulless eyes.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9Ff1Be9Be9Ae9Aj9Aj9Bpnnythkjgtqqhpf",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 695,
          "apCost": 0,
          "name": "Curse",
          "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "debuff"
        },
        {
          "id": 43,
          "apCost": 0,
          "name": "Immunity: Disease",
          "shortDescription": "Disease damage that would be dealt to this unit is prevented. This unit may not become <condition value=diseased>Diseased</condition>.\r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_disease"
        },
        {
          "id": 2586,
          "apCost": 4,
          "name": "Summon: Festering Corpse",
          "shortDescription": "Summon a Festering Corpse with no upgrades and 75% HP to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 15,
          "iconName": "sum_festering_corpse"
        },
        {
          "id": 2591,
          "apCost": 4,
          "name": "Zombie Herder",
          "shortDescription": "Friendly Zombies within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> and lose Lethargic, Weighty, and Lumbering for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "desert_hearder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 2189,
              "apCost": 0,
              "name": "Charged Heal",
              "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 606,
              "apCost": 2,
              "name": "Fester",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=inhibited>Inhibited</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "inhibit"
            },
            {
              "default": true,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 1786,
              "apCost": 3,
              "name": "Ritual of Destruction",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 1430,
      "name": "Flowing Ember",
      "description": "One look might set your soul aflame, one touch will leave your body in ashes.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 7,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Elf"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9FE8DF0Be9Ae9Aj9Ej9Fepjnetziroumhpf",
      "artist": "Mazert Young",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2536,
          "apCost": 0,
          "name": "Bestow",
          "shortDescription": "When this champion is destroyed, the closest friendly champion gains this unit's first upgrade ability. If that champion shares a race with this one, it gains the second upgrade ability as well.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 1611,
          "apCost": 0,
          "name": "Searing Aura ",
          "shortDescription": "When an opposing champion moves within 1 space of this champion or when this champion moves within 1 space of an opposing champion, the opposing champion suffers 2 Fire damage. At the end of your turn all opposing champions within 1 space suffer 3 Fire damage. Damage given by this ability ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "novafire"
        },
        {
          "id": 2853,
          "apCost": 0,
          "name": "Trail: Fire Wall",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "trail_firewall"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            },
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3061,
              "apCost": 3,
              "name": "Solar Flare",
              "shortDescription": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1885,
              "apCost": 3,
              "name": "Cleansing Flame",
              "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 301,
      "name": "Fly Catcher",
      "description": "Stay clear of the tide pools, lest you plan to rest beneath the waves. There are beasts of the swamp that lurk unseen.  - Voil Scout",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 65,
      "hash": "dj9Ej9Dg3Ae9BG2Aj9Bj9Cj9Dwvfvsfrwfkytzig",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3356,
          "apCost": 0,
          "name": "Pacifying Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is Pacified for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "charm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2352,
              "apCost": 0,
              "name": "Defensive Turtle",
              "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "turtle"
            },
            {
              "default": true,
              "id": 1485,
              "apCost": 2,
              "name": "Splash",
              "shortDescription": "Spaces within 3 spaces of this champion are Water (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "tsunami"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 855,
              "apCost": 0,
              "name": "Hidden: Water",
              "shortDescription": "At the end of your turn, if this champion occupies Water, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 216,
      "name": "Forest Dragon",
      "description": "The most benign of the ancient dragons, these creatures are often mistaken as great leafless trees.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Dragon",
        "Plant"
      ],
      "noraCost": 72,
      "hash": "dJ8HJ8Ge9Be9BG2Aj9Bj9Cj9Dgkrzkpumnpyxiyg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 1084,
          "apCost": 0,
          "name": "Plant Regeneration",
          "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1920,
              "apCost": 0,
              "name": "Revere: Thirion",
              "shortDescription": "While this champion is in play, Thirion costs 10% less nora to deploy. While Thirion is in play, this champion gains +2 RNG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 789,
              "apCost": 3,
              "name": "Healing Breath",
              "shortDescription": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 18 HP divided by the number of targets (rounded down to a max of 8 HP per target).",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 341,
      "name": "Forest Giant",
      "description": "The elves are the last remaining race that can speak to the natural creatures of the old world. These simple giants have the strength to stop an army, so long as they are told which army to stop!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 15,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Plant"
      ],
      "noraCost": 75,
      "hash": "dj9Bj9Af1BF0Af1AJ8Jj9Aj9Buszgkwzoumjwzzg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3058,
          "apCost": 1,
          "name": "Chuck: Wood",
          "shortDescription": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "chuck_wood"
        },
        {
          "id": 3031,
          "apCost": 0,
          "name": "Imposing Aura",
          "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "imposing_aura"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 700,
      "name": "Forest Lerper",
      "description": "There are some lerpers that never grow wings. It is said that jealousy of their flying brethren fuels a foul disposition.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 79,
      "hash": "dj9AJ8Jf1AG2AE8Dj9Ej9Fj9Geeiyirumlrjevfg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1509,
          "apCost": 0,
          "name": "Blitz",
          "shortDescription": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 223,
      "name": "Forglar Jellyfish",
      "description": "Avoid the marshes to the south - the water itself is poisonous. - Boghopper Shaman",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 55,
      "hash": "dJ8IJ8HF0Ae9BF0BJ8IJ8Jj9Amnuvfvqhnplnlwf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 114,
          "apCost": 0,
          "name": "Aquatic",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "aquatic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1406,
          "apCost": 4,
          "name": "Dive",
          "shortDescription": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space within 6 spaces.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_dive"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 670,
          "apCost": 3,
          "name": "Replicate",
          "shortDescription": "Create a replica of this champion on target adjacent space. This unit loses half of its current HP (rounded down) and the replica has that amount of HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "swarm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 40,
              "apCost": 0,
              "name": "Immunity: Poison",
              "shortDescription": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_poison"
            },
            {
              "default": false,
              "id": 43,
              "apCost": 0,
              "name": "Immunity: Disease",
              "shortDescription": "Disease damage that would be dealt to this unit is prevented. This unit may not become <condition value=diseased>Diseased</condition>.\r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_disease"
            },
            {
              "default": false,
              "id": 39,
              "apCost": 0,
              "name": "Immunity: Electricity",
              "shortDescription": "Electricity damage that would be dealt to this unit is prevented. This unit may not become <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_electric"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            }
          ]
        }
      ]
    },
    {
      "id": 711,
      "name": "Forsaken Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to his eternal kingdom of Elsarin.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Ae9BJ8GJ8HJ8Ievxkeeplythtsxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            }
          ]
        }
      ]
    },
    {
      "id": 1674,
      "name": "Forsaken Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to his eternal kingdom of Elsarin.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Ae9BJ8GJ8HJ8Ievxkeeplythtsxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            }
          ]
        }
      ]
    },
    {
      "id": 552,
      "name": "Forsaken Follower",
      "description": "Few humans joined Serkan willingly. Those that did were rewarded with power.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9Bf1Bf1Bj9Aj9Bj9Ceipyirjytqfpnyg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 550,
          "apCost": 0,
          "name": "Attack: Red Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "electric"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            },
            {
              "default": false,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 431,
              "apCost": 4,
              "name": "Summon: Skeleton",
              "shortDescription": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "sumskel"
            }
          ]
        }
      ]
    },
    {
      "id": 1782,
      "name": "Fracturing Boulder",
      "description": "On beats the air like heart, and hand, and drum, and rhythm lets it beat for us.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FG2BG2AG2Ae9Aj9Cj9Dofiigrwtjlwousf",
      "artist": "Danh Nguyen",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 3263,
          "apCost": 1,
          "name": "Ranged Stance",
          "shortDescription": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "ranged_stance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 135,
      "name": "Freeze Bug",
      "description": "Some refute that this small but potent threat ever existed.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 4,
      "damage": 17,
      "hitPoints": 18,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 38,
      "hash": "dj9Gj9Fe9Ae9Ag3Aj9Dj9Ej9Fheiyvxxiieegphg",
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 233,
              "apCost": 0,
              "name": "Damage Shield: Frost",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Frost damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 2819,
              "apCost": 0,
              "name": "Catalyst: Frost",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 232,
              "apCost": 0,
              "name": "Damage Shield: Frost",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Frost damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "dmgshld_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 183,
              "apCost": 0,
              "name": "Death Nova: Frost",
              "shortDescription": "When this unit is destroyed, it deals 5 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "deathnovafrost"
            },
            {
              "default": false,
              "id": 184,
              "apCost": 0,
              "name": "Death Nova: Frost",
              "shortDescription": "When this unit is destroyed, it deals 8 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "deathnovafrost"
            },
            {
              "default": true,
              "id": 185,
              "apCost": 0,
              "name": "Death Nova: Frost",
              "shortDescription": "When this unit is destroyed, it deals 11 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafrost"
            }
          ]
        }
      ]
    },
    {
      "id": 1063,
      "name": "Freeze Bug Keeper",
      "description": "\"They generally keep to themselves, preferring the hum and peace of the freezebugs to the politics and bustle of J'thir.\" - Hi'yum, Jakei Elder",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 73,
      "hash": "ej9Bj9Ag3AE8De9Af1Bj9Dj9Eeiljgkpjyziwoqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2453,
          "apCost": 1,
          "name": "Chuck: Young Freeze Bug",
          "shortDescription": "This champion makes a Physical attack at RNG 2-5. A Young Freeze Bug with no upgrades is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 15,
          "iconName": "summon_freezbug"
        },
        {
          "id": 2687,
          "apCost": 3,
          "name": "Confuse",
          "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "confuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 346,
      "name": "Frenzied Pirahnid",
      "description": "Pirahnid warriors fast for weeks before going to war. By the time they reach  the battlefield, hunger turns to primal frenzy as they tear their opponents apart.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 77,
      "hash": "dj9Cj9BG2AF0AE8Dj9Ej9Fj9Gerlyzitzojemwfg",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 1015,
          "apCost": 0,
          "name": "Surge: Aquatic",
          "shortDescription": "This unit has +1 DMG for each friendly <ability value=114>Aquatic</ability> or <ability value=859>Semi Aquatic</ability>.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge_aquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 29,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 51,
      "name": "Froblic Bull",
      "description": "The Froblic Bulls are most revered for their incredible teeth, which are used to bite through anything.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 67,
      "hash": "cj9Ej9Dj9CG2BF0Aj9Cj9Dj9Eeeeeeinetjyitji",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3101,
          "apCost": 0,
          "name": "Ferocious Bite",
          "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "ancestral_avenger"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 46,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 20% (after DEF, rounded up).",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 102,
      "name": "Frost Giant",
      "description": "The Jakei avoided them not out of fear, but pragmatism. Every step they take causes an avalanche.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 76,
      "hash": "dj9Fj9EE8De9AF0AJ8HJ8IJ8Jeeeetzzgkphpnwf",
      "artist": "Gabriel Garza",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 190,
      "name": "Frost Wolf",
      "description": "J'orea stood at her balcony gazing pensively at the approaching army. The cry of the frost wolf, so low and mournful, lends itself well to the impending plight of my people.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 63,
      "hash": "dj9Ej9Dg3Ae9AE8Dj9Ej9Fj9Geeerzgevhtxkjgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 1436,
              "apCost": 0,
              "name": "Leverage: Beast",
              "shortDescription": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1601,
      "name": "Frostfall Dragon",
      "description": "Frostfall Dragons are revered by those who live in the Tundra, who believe them to be guardian spirits manifesting in the mortal realm.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 75,
      "hash": "eJ8IJ8Hf1AF0AG2AF0AJ8Jj9Aeiyiwkjgpsofepf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3105,
          "apCost": 4,
          "name": "Absolute Zero",
          "shortDescription": "Opposing champions within 2 spaces take 12 Frost damage, opposing champions within 4 spaces take 10 Frost damage, and opposing champions within 6 spaces take 8 Frost damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "absolute_zero"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2796,
          "apCost": 0,
          "name": "Snowbreach",
          "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainsnow"
        },
        {
          "id": 752,
          "apCost": 4,
          "name": "Tunnel: Snow",
          "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 604,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2606,
              "apCost": 4,
              "name": "Arctic Bolt",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "iceaoe"
            },
            {
              "default": true,
              "id": 1296,
              "apCost": 1,
              "name": "Avalanche",
              "shortDescription": "Area Effect 2, Range 5: Affected champions without <ability value=600>Arctic</ability> take 12 Frost damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Deep Snow (Impeding 1).",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 12,
              "iconName": "iceaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 390,
              "apCost": 1,
              "name": "Frost Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            }
          ]
        }
      ]
    },
    {
      "id": 1845,
      "name": "Frostfall Furbull",
      "description": "\"Some Furbulls turn out alright -- they're territorial, and flay everything that enters their space, but that's about it. A few Furbulls, though...\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 65,
      "hash": "ej9AJ8JE8DG2BG2Af1Aj9Ej9Fyruvqhpnphgtxqf",
      "artist": "Danh Nguyen",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            }
          ]
        }
      ]
    },
    {
      "id": 1319,
      "name": "Frostfall Hydra",
      "description": "Hailing from the Frostfall Steppes, these Hydras are adapted to dealing with the region's treacherous sinkholes and hunting within its glacial caverns.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 88,
      "hash": "ej9Gj9Fg3AF0Ae9Ae9Aj9Dj9Eevfvhpwmshrowqf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 2741,
          "apCost": 0,
          "name": "Spontaneous Regeneration",
          "shortDescription": "For every 20 damage this champion takes in a single turn, it is healed for 9 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "regen"
        },
        {
          "id": 752,
          "apCost": 4,
          "name": "Tunnel: Snow",
          "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 2810,
              "apCost": 0,
              "name": "Spellsurge: Snowstorm",
              "shortDescription": "When this champion is deployed, Snowstorm spells are revealed from your runedock.  Snowstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Snowstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2697,
              "apCost": 0,
              "name": "Territorial",
              "shortDescription": "When an opposing non-Illusion champion is deployed within 8 spaces, this champion gains <ability value=15>Multiattack 1</ability>, <ability value=259>Enrage 1</ability>, +4 DMG, +1 DEF and +1 SPD for 4 turns. This can trigger up to 2 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "pack_leader"
            }
          ]
        }
      ]
    },
    {
      "id": 1317,
      "name": "Frostfall Icewisp",
      "description": "The sudden and rapid receding of the glaciers around the Frostfall Steppes has caused a mass migration of many species away from the area, many of which have rarely been observed, such as the Icewisp.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental",
        "Plant"
      ],
      "noraCost": 60,
      "hash": "ej9Gj9FG2AF0Ae9Ae9Aj9Bj9Cerqfeiyoukronpf",
      "artist": "Paul Guzenko",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2606,
          "apCost": 4,
          "name": "Arctic Bolt",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "iceaoe"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2799,
          "apCost": 0,
          "name": "Still Life",
          "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1386,
              "apCost": 3,
              "name": "Cold Snap",
              "shortDescription": "Champions within 5 spaces become <condition value=chilled>Chilled</condition> 3.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "repulsion"
            },
            {
              "default": true,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1236,
              "apCost": 0,
              "name": "Ice Veil",
              "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into ice terrain for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainice"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 1316,
      "name": "Frostfall Tardigrade",
      "description": "Tardigrades have a tremendous ability to adapt to whatever environment they find themselves in, but seem partial to the Frostfall region of the Tundra.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 7,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 62,
      "hash": "ej9Gj9Ff1BF0Ae9Ae9Aj9Aj9Bjekwvfxzxzkpjpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2352,
          "apCost": 0,
          "name": "Defensive Turtle",
          "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1385,
              "apCost": 0,
              "name": "Freezing Aura",
              "shortDescription": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novafrost"
            },
            {
              "default": true,
              "id": 2796,
              "apCost": 0,
              "name": "Snowbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 1166,
      "name": "Frostfall Vanguard",
      "description": "They say her heart only beats once per year.  And when it does it causes an avalanche.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God",
        "Warrior"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 80,
      "hash": "ej9Bj9Ag3Ae9Ae9Af1Bj9Dj9Eemsxfvqjwoyxqqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2561,
          "apCost": 0,
          "name": "Frost Overload",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=chilled>Chilled</condition> 3. If that champion is already Chilled, it is equipped with a Frost Amulet. Equipment generated by this ability costs 0 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dot_chill"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2796,
          "apCost": 0,
          "name": "Snowbreach",
          "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainsnow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        }
      ]
    },
    {
      "id": 1113,
      "name": "Frostvein Witch",
      "description": "\"Do you know that as water freezes, it expands? Did you know that blood is made of primarily water?\" - Grizen, Frostvein Witch \r\n",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FG2Be9Ae9Ae9Aj9Cj9Djtmhtqftoyolnpf",
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1463,
          "apCost": 0,
          "name": "Iceguard",
          "shortDescription": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "iceguard"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 1279,
          "apCost": 0,
          "name": "Weary",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "debuff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": true,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2606,
              "apCost": 4,
              "name": "Arctic Bolt",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "iceaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1019,
      "name": "Frostwing Glaive",
      "description": "\"The Frostwing's are an inspiration to all feathered Tundran's. They dive heedlessly into battle with naught more than their glaive, their wings, and their heart.\" - Shardseer K'aeyun",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 83,
      "hash": "eJ8HJ8GG2AE8De9Ae9Bj9Bj9Ceevoqhtjetoymn",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2466,
          "apCost": 1,
          "name": "Arcblade: Frost",
          "shortDescription": "This champion makes a Frost attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "glaivebounce"
        },
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3266,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "combat_awareness"
        },
        {
          "id": 1378,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "resistance_ranged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": true,
              "id": 3294,
              "apCost": 0,
              "name": "Warlord",
              "shortDescription": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "warlord"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 1572,
      "name": "Frostwing Hunter",
      "description": "Dark clouds, bringing sleet and ice / \r\nHarsh winds, biting at your heels /\r\nFrostwings, ruling the skies",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 72,
      "hash": "ej9Bj9AG2Be9BG2Af1Bj9Cj9Dyirwvqwvxqjigrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 3196,
          "apCost": 0,
          "name": "Updraft",
          "shortDescription": "When this champion is deployed from the runedock, friendly champions gain <condition value=flying>Flying</condition> for 4 turns. If it shares a race with this champion or already has <condition value=flying>Flying</condition>, it also gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "tailwind"
        },
        {
          "id": 1479,
          "apCost": 0,
          "name": "Vigorous Cry",
          "shortDescription": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        }
      ]
    },
    {
      "id": 1791,
      "name": "Frostwing Slayer",
      "description": "Each of the slayers depends upon a dedicated aid to weave their wings for them, allowing the frostwings to dedicate all of their energies to combat.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 74,
      "hash": "eJ8IJ8He9AG2AG2AF0Aj9Fj9Gvfmhrzgpqhyrqqf",
      "artist": "Grant Griffin",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1986,
          "apCost": 0,
          "name": "Honor Guard",
          "shortDescription": "While Juya White-Eyes or Jakei Frost Queen is in play, this champion has <ability value=15>Multiattack 1</ability> and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "revere"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 3271,
          "apCost": 1,
          "name": "Slayer's Spear",
          "shortDescription": "This champion makes a Physical attack at range 2-5. If this attack is successful, the enemy champion becomes <condition value=tagged>Tagged</condition><ability value=3277>.</ability>",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "spear"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3145,
              "apCost": 0,
              "name": "Empowered: Defense",
              "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "fragile_defense"
            },
            {
              "default": false,
              "id": 3142,
              "apCost": 0,
              "name": "Empowered: Speed",
              "shortDescription": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_speed"
            }
          ]
        }
      ]
    },
    {
      "id": 111,
      "name": "Frostwing Windrider",
      "description": "Shoot them in the face. -- Juya White-eyes, Frostwing Chieftain",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 65,
      "hash": "dj9Fj9EE8De9AG2Bj9Cj9Dj9Eeeeevshgkegerfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 978,
          "apCost": 1,
          "name": "Sapping Strike",
          "shortDescription": "This champion makes a Physical attack for 12 damage against target enemy unit at RNG 2-5. If the target is successfully damaged, it loses all AP. This damage ignores DEF. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "stab"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1440,
              "apCost": 0,
              "name": "Confuse Attacker",
              "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 2488,
              "apCost": 0,
              "name": "Boon of the Wind",
              "shortDescription": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "martyr"
            }
          ]
        }
      ]
    },
    {
      "id": 570,
      "name": "Furbull",
      "description": "Along with their soft fur coats, the Furbulls are known for having violent temperaments.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 58,
      "hash": "dJ8JJ8IF0Bf1BF0BJ8IJ8Jj9Asmsmnwfevhvklyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1463,
          "apCost": 0,
          "name": "Iceguard",
          "shortDescription": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "iceguard"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 838,
      "name": "Furbull Mother",
      "description": "As Furbulls age they slow down and become less aggressive, focusing their efforts on breeding. Most Furbull Mothers have 3 kittens in each litter. Furbull Mothers only bear their children in the warmer southlands of the Tundra near the Boreal Cliffs.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 79,
      "hash": "dj9Bj9Af1BG2Bf1AJ8Jj9Aj9Bgkgekrzxtssfxfg",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2536,
          "apCost": 0,
          "name": "Bestow",
          "shortDescription": "When this champion is destroyed, the closest friendly champion gains this unit's first upgrade ability. If that champion shares a race with this one, it gains the second upgrade ability as well.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 2218,
          "apCost": 4,
          "name": "Summon: Furbull Litter",
          "shortDescription": "Summon 2 Baby Furbulls without upgrades to adjacent spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 6,
          "noraCost": 50,
          "iconName": "sum_furbulbaby"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1747,
              "apCost": 1,
              "name": "Grant: Frost Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1571,
      "name": "Fury of the Storm",
      "description": "\"We are the clap of thunder, the heat of lightning, the wrath of wind. We are the ancient ones, and to dare come before us is to declare you are truly in dire need.\" - Wichal, Fury of the Storm to Kolar, Barbarian Bolt",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 76,
      "hash": "ej9Bj9Af1Be9BG2Af1Bj9Aj9Bfeexmemwmnwztqf",
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        },
        {
          "id": 1952,
          "apCost": 0,
          "name": "Slam",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 3069,
          "apCost": 4,
          "name": "Storm Field",
          "shortDescription": "Area Effect 2, Range 5: Affected spaces becomes Storm Field (5 Electricity damage per square upon entry) for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "terrainstorm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2247,
              "apCost": 0,
              "name": "Static Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=shocked>Shocked</condition> for 2 turns\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_static"
            },
            {
              "default": false,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            },
            {
              "default": false,
              "id": 2872,
              "apCost": 0,
              "name": "Warchief: Storm Clan",
              "shortDescription": "This unit has <ability value=3158>Reckless</ability>. At the end of its turn, this unit gains one rank of <ability value=2289>Lightning Storm</ability>. When this unit is destroyed and there are no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "storm_clan"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2344,
              "apCost": 0,
              "name": "Paralytic Strike",
              "shortDescription": "This champion does double damage to <condition value=paralyzed>Paralyzed</condition> champions.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "jolt"
            },
            {
              "default": true,
              "id": 2244,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 149,
      "name": "G'hern Birthmother",
      "description": "Moga mothers typically die during childbirth leaving their pups to be fostered by the tribal midwife.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0Be9AG2Bj9Cj9Dj9Eeeeeeemetszxieg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2920,
          "apCost": 0,
          "name": "Guarded: Moga",
          "shortDescription": "The first time each turn this unit is successfully attacked, friendly Moga within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "guarded"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 660,
          "apCost": 3,
          "name": "Summon: Moga",
          "shortDescription": "Summon a Moga Pup on target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "summoga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": false,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1337,
              "apCost": 0,
              "name": "Gift of Fertility",
              "shortDescription": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 1249,
      "name": "G'hern General",
      "description": "\"Moga are good for many things, like carrying my lunch. It's a good thing too, cause otherwise, what would I eat?  What?  Eat the Moga? That's disgusting!\" ~ Utok, G'hern General",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 84,
      "hash": "ej9AJ8JE8De9Be9Af1Aj9Ej9Fuvmjtjeemuvmuo",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2632,
          "apCost": 0,
          "name": "Bold",
          "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "channel_defense"
        },
        {
          "id": 2645,
          "apCost": 4,
          "name": "Designate Flagbearer",
          "shortDescription": "Until target friendly champion within 3 spaces moves, it has <ability value=677>Overseer: Moga 2</ability>, <ability value=2479>Improve Speed</ability> and <ability value=1382>Prestige</ability>. Friendly champions within 5 spaces of it have <ability value=1377>Evasive 2</ability>. This affects a maximum of 1 target at a time.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "independent"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": true,
              "id": 2920,
              "apCost": 0,
              "name": "Guarded: Moga",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Moga within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            }
          ]
        }
      ]
    },
    {
      "id": 278,
      "name": "G'hern Isangoma",
      "description": "Where do you suppose these savages learned how to do that? -- The Nora does not choose, it merely gives. Boghopper Sage to Boghopper Apprentice",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 75,
      "hash": "dj9Dj9CG2Be9BF0BJ8IJ8Jj9Agtowfeevojrufeg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 2339,
          "apCost": 4,
          "name": "Imbue: Stun",
          "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 9,
          "iconName": "amped"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            },
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 1590,
      "name": "G'hern Juggler",
      "description": "\"I tell you, the little 'uns love this, especially when I give 'em the fireworks to play with.\" ~ G'hern Juggler",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 71,
      "hash": "ej9Fj9Ef1AF0AG2AE8DJ8Jj9Aerqsjpszmeeknpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 1707,
          "apCost": 0,
          "name": "Ammunition",
          "shortDescription": "Once this champion has made at least 4 successful attacks, its range becomes 1.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "gun"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 3292,
          "apCost": 0,
          "name": "Reload",
          "shortDescription": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 144,
      "name": "G'hern Overlord",
      "description": "Scouts report there's a powerful G'hern atop that ridge overlooking the shallows. Tulgsh, take your hunters and eliminate him. - Gekkit, Boghopper Shaman",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 69,
      "hash": "dJ8JJ8IF0Be9AF0AJ8HJ8IJ8Jeeeeeegyvqljgvf",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 376,
          "apCost": 0,
          "name": "Exertion",
          "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "crazed_charger"
        },
        {
          "id": 2660,
          "apCost": 3,
          "name": "Grappling Hook",
          "shortDescription": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "pull"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 1248,
              "apCost": 3,
              "name": "Pull",
              "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": true,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            },
            {
              "default": false,
              "id": 657,
              "apCost": 2,
              "name": "Relocate: Ally",
              "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 146,
      "name": "G'hern Punisher",
      "description": "You mean to tell me, one G'hern is responsible for all this devastation? -- Um... yes sir. - Gash, Boghopper Fin Lord to a Messenger",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 75,
      "hash": "dJ8JJ8IF0Be9Af1AJ8Jj9Aj9Bgygygggvfmygyxf",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 2704,
          "apCost": 0,
          "name": "Crushing Blow",
          "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "shrink"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1643,
      "name": "G'hern Pyro",
      "description": "To a Pyro's mind, every Moga is a match stick.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 74,
      "hash": "eJ8IJ8HF0BF0BG2AF0AJ8IJ8Jeemyvmlplphgyo",
      "artist": "Grant Griffin",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1404,
          "apCost": 0,
          "name": "Fire Feed",
          "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "eater_fire"
        },
        {
          "id": 3082,
          "apCost": 3,
          "name": "Flame Surge",
          "shortDescription": "This champion gains 3 AP and Pacified for 1 turn. For each space moved, enemy champions within 2 spaces take 3 Fire damage (this damage ignores DEF). This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "charge_flame"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 228,
              "apCost": 0,
              "name": "Damage Shield: Fire",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Fire damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "dmgshld_fire"
            },
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            },
            {
              "default": false,
              "id": 1446,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 5 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovalava"
            },
            {
              "default": true,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 758,
      "name": "G'hern Rager",
      "description": "In many G`hern, there is an anger fed by years of oppression and servitude. Often, the rage is suppressed. In some, it is used as inspiration. These few are known as the Ragers.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 77,
      "hash": "dj9Ej9Dg3AG2AF0AJ8HJ8IJ8Jpumnnumukrohygg",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 25,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "berserker"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 3147,
          "apCost": 0,
          "name": "Seism",
          "shortDescription": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "seism"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 29,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1059,
      "name": "G'hern Razorback",
      "description": "\"They choose to ignore magic out of sheer stubbornness that rivals the peaks they dwell beside.\" - Kiinliv, Voil Sorcerer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 77,
      "hash": "ej9Bj9Af1AE8De9Af1BJ8Jj9Aerzkjetsjrwouo",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2626,
              "apCost": 0,
              "name": "Scrapper",
              "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "scrapper"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1010,
      "name": "G'hern Soothsayer",
      "description": "\"The G'hern have started to dabble in the dark arts. Soon they may very well be able to overthrow their oppressors.\" - General Korsien ",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 74,
      "hash": "ej9Gj9Fg3AE8De9Ae9Aj9Dj9Eeiphgtztumhipqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 1776,
          "apCost": 0,
          "name": "Premonition",
          "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": true,
              "id": 715,
              "apCost": 0,
              "name": "Surge: Moga",
              "shortDescription": "This unit has +1 DMG for each friendly Moga.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_moga"
            },
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        }
      ]
    },
    {
      "id": 147,
      "name": "G'hern Sustainer",
      "description": "Those too weak for battle should give their strength to those who are not. - Eehiist, Voil Queen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 69,
      "hash": "dJ8JJ8IF0Be9Af1Bj9Aj9Bj9Ceeeeerlplljilyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 847,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +4 MAX HP for 6 turns. This does not stack.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "allybuffs"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 726,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1978,
              "apCost": 0,
              "name": "Vitalize",
              "shortDescription": "Other real friendly champions within 5 spaces with 5 base SPD or less get +1 SPD while this unit is in play. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 460,
              "apCost": 3,
              "name": "First Aid",
              "shortDescription": "Target adjacent friendly champion gains 5 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1342,
              "apCost": 2,
              "name": "Impart",
              "shortDescription": "Target champion within 3 spaces is healed for 5 HP and gains 1 DMG. This unit loses 8 life and gains -1 DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 145,
      "name": "G'hern Taskmaster",
      "description": "Make them work harder; I don't care what it takes. - Voil Warden",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 76,
      "hash": "dJ8JJ8IF0Be9AF0BJ8IJ8Jj9Aqoqolusxiyzgpwf",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 1717,
          "apCost": 3,
          "name": "Command: Charge",
          "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "command_charge"
        },
        {
          "id": 656,
          "apCost": 2,
          "name": "Drive",
          "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "drive"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": true,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 1225,
              "apCost": 0,
              "name": "Bastion of Mobility",
              "shortDescription": "Friendly champions within 8 spaces have <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 204,
      "name": "G'hern Thrower",
      "description": "Fallback! They've found a way over our defenses! - Gash, Boghopper Finlord at the Siege of the Shallows",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 71,
      "hash": "dj9Gj9Fe9Ae9BF0BJ8IJ8Jj9Aknjwvxfmwtxvmyg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 817,
          "apCost": 3,
          "name": "Throw Champion",
          "shortDescription": "Target adjacent friendly champion gains Catapult (This unit leaps to target location within 5 spaces).",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 15,
          "iconName": "throw_champ"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3097,
              "apCost": 2,
              "name": "Toss Equipment",
              "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 1306,
              "apCost": 0,
              "name": "Mountaineer",
              "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "climb"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 150,
      "name": "G'hern Traitor",
      "description": "Stop! Don't hurt him ... I don't know why he's here, but I don't think he's with them.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 74,
      "hash": "dJ8JJ8IF0Be9Ag3Aj9Dj9Ej9Foqoqjemytsonsfg",
      "artist": "Gabriel Garza",
      "factions": [
        "Forglar Swamp",
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 343,
          "apCost": 1,
          "name": "Power Attack",
          "shortDescription": "This unit makes an attack with +4 DMG.",
          "activationType": 1,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hammer"
        },
        {
          "id": 2438,
          "apCost": 3,
          "name": "Ravish",
          "shortDescription": "Target real champion you own is destroyed. Closest friendly champion to the target champion gains 35% of the destroyed champion's current HP and DMG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "overkill"
        },
        {
          "id": 751,
          "apCost": 3,
          "name": "Spike Nova",
          "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novaspike"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 800,
              "apCost": 0,
              "name": "Hunter: Forglar Swamp",
              "shortDescription": "When this unit would deal damage to a Forglar Swamp champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a Forglar Swamp  champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_fs"
            },
            {
              "default": true,
              "id": 666,
              "apCost": 0,
              "name": "Hunter: Shattered Peaks",
              "shortDescription": "When this unit would deal damage with any attack to a Shattered Peaks champion, that damage is increased by 2. When this unit would receive damage from any attack by a Shattered Peaks champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_sp"
            }
          ]
        }
      ]
    },
    {
      "id": 148,
      "name": "G'hern Tyrant",
      "description": "The most vicious of the Voil Queen's brutes, the 'tyrants' are deployed where mercy and restraint are needed least.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 85,
      "hash": "dJ8JJ8IF0Be9AG2Aj9Bj9Cj9Dmsmshknhyzxouzg",
      "artist": "Gabriel Garza",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1237,
          "apCost": 0,
          "name": "Impenetrable",
          "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ironwill"
        },
        {
          "id": 678,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 7 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "overseermoga"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        },
        {
          "id": 715,
          "apCost": 0,
          "name": "Surge: Moga",
          "shortDescription": "This unit has +1 DMG for each friendly Moga.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge_moga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 53,
      "name": "Gahlroon",
      "description": "Sheoul commanders must often reprimand Gahlroon troops for snacking on their allies after battle.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 16,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 75,
      "hash": "cj9AJ8JJ8IF0Bf1AJ8IJ8Jj9Aerlusjwfieevouh",
      "artist": "Dan Kopycienski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3056,
          "apCost": 0,
          "name": "Overkill: Healing",
          "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overkill"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2708,
              "apCost": 1,
              "name": "Gluttony",
              "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "devour"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            }
          ]
        }
      ]
    },
    {
      "id": 1358,
      "name": "Gahlroonling",
      "description": "\"Stop you fool!  That's what it wants you to do!\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 0,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 80,
      "hash": "ej9AJ8JG2BF0Ae9Af1Aj9Cj9Dxknhkpygrjgempf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2791,
          "apCost": 0,
          "name": "Born in Blood",
          "shortDescription": "When this champion is destroyed, no nora globe is dropped and champions within 4 spaces are <condition value=bloodied>Bloodied</condition> and a Gahlroon with <condition value=impervious>Impervious</condition> for 2 turns is spawned in its place.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 80,
          "iconName": "borninblood"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 2824,
              "apCost": 0,
              "name": "Incoherent Babbling",
              "shortDescription": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "rover_babbling"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            }
          ]
        }
      ]
    },
    {
      "id": 1519,
      "name": "Gallows Warden",
      "description": "You may beg all you please. You will find me to be without pity, or mercy. Eventually you will feel the sting of my blade at your neck. In those final moments, you will know the terror you have visited upon my people.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 77,
      "hash": "ej9Cj9BF0BF0Be9AG2AJ8IJ8Jeepytzouhythgpf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2986,
          "apCost": 0,
          "name": "Fearsome Hunter",
          "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "fear"
        },
        {
          "id": 3031,
          "apCost": 0,
          "name": "Imposing Aura",
          "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "imposing_aura"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        }
      ]
    },
    {
      "id": 888,
      "name": "Garin the Sharpfang",
      "description": "Garin left his pack at a young age; he was the brightest mongrel and was considered a threat to Crones. He fled from Maljara and spent his life as a mercenary for the Draksar.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue",
        "Warrior"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 72,
      "hash": "dj9Gj9Fe9Ag3Af1AJ8Jj9Aj9Bqzmyowieevqhggg",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2003,
          "apCost": 0,
          "name": "Mercenary",
          "shortDescription": "At the beginning of your turns you lose 2 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "cost"
        },
        {
          "id": 2250,
          "apCost": 3,
          "name": "Scythe Whirl",
          "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "scythe_wirlwind"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1433,
              "apCost": 0,
              "name": "Bounty Hunter",
              "shortDescription": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hunter_bounty"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            },
            {
              "default": false,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 698,
      "name": "Garu Chosen",
      "description": "\"They were not just chosen by the Eternal Council. They were chosen by Dalnis himself, to protect K`thir.\" - Menalaus",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute",
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 74,
      "hash": "dJ8JJ8IF0BG2AG2Bj9Cj9Dj9Eeeeeeerhempsmhg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1237,
          "apCost": 0,
          "name": "Impenetrable",
          "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ironwill"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1070,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 2633,
              "apCost": 0,
              "name": "Amplify: Magic",
              "shortDescription": "Magic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1920,
              "apCost": 0,
              "name": "Revere: Thirion",
              "shortDescription": "While this champion is in play, Thirion costs 10% less nora to deploy. While Thirion is in play, this champion gains +2 RNG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 298,
      "name": "Garu Cub",
      "description": "Although young, it's not our place to deny the willing their chance at defending our homeland. - Garu advisor",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 61,
      "hash": "dj9Ej9Dg3Ae9BF0BJ8IJ8Jj9Asmnsmhexmevoneg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2450,
          "apCost": 0,
          "name": "Guarded: Garu",
          "shortDescription": "The first time each turn this unit is successfully attacked, friendly Garu within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "guarded"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 2968,
          "apCost": 0,
          "name": "Leverage: Garu",
          "shortDescription": "When this unit is deployed from the runedock, the next Garu with a nora cost of 80 or more that you deploy from the runedock costs 10 less nora for 3 turns. This effect does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 894,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 2 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            },
            {
              "default": true,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1023,
      "name": "Garu Den Mother",
      "description": "\"Leave her be. If we touch that cub you'll bring her and that whole Garu tribe down upon us.\" - Brid'na, Caverunner",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 76,
      "hash": "eJ8IJ8HF0AE8De9AF0AJ8HJ8Ivsuosouqfeemym",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2418,
          "apCost": 0,
          "name": "Pet: Garu Cub",
          "shortDescription": "When this champion is deployed, a Garu Cub with no upgrades is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 35,
          "iconName": "pet"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1869,
              "apCost": 1,
              "name": "Hibernate",
              "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "hibernate"
            },
            {
              "default": false,
              "id": 725,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 555,
      "name": "Garu Hunter",
      "description": "My hunters gather food. They don't fight in an army. But, they will defend our home. - Godwin, Garu Elder",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 67,
      "hash": "dJ8HJ8Ge9Bf1Bg3Aj9Dj9Ej9Ftjwxmnukyggyvfg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1437,
          "apCost": 0,
          "name": "Camaraderie ",
          "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "cost"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            }
          ]
        }
      ]
    },
    {
      "id": 54,
      "name": "Garu Hurler",
      "description": "The peaceful tradition of hurling rocks to clear the earth has become a crucial battle tactic amongst Garu.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 72,
      "hash": "bj9AJ8JJ8IF0BJ8IJ8Jj9Aj9Bjggiiieknlyxojl",
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 659,
          "apCost": 0,
          "name": "Attack: Rock",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rock"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": true,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1039,
      "name": "Garu Kodiak",
      "description": "Godwin was raised around these proud warriors. He retained their ferocity, their prowess, and their temper.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 13,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 82,
      "hash": "eJ8JJ8If1BE8De9AF0Bj9Aj9Bwiwiiiwmeemuqo",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        },
        {
          "id": 1374,
          "apCost": 0,
          "name": "Resolute",
          "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ironwill"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 263,
              "apCost": 0,
              "name": "Warcry",
              "shortDescription": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1892,
              "apCost": 0,
              "name": "Quest: Damage",
              "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 2704,
              "apCost": 0,
              "name": "Crushing Blow",
              "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "shrink"
            }
          ]
        }
      ]
    },
    {
      "id": 1120,
      "name": "Garu Medium",
      "description": "\"From dirt to sky, in sunlit groves, we walk and carry the burdens of old\" ~ Song of the Ancestors",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 5,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 83,
      "hash": "eJ8HJ8GF0Be9Ae9Ae9BJ8IJ8Jeemsmumjrqohem",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1452,
          "apCost": 3,
          "name": "Dispel",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "dispel"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 2294,
          "apCost": 0,
          "name": "Spirit Projection",
          "shortDescription": "When this champion is deployed and at the start of its turns, if there is no Manifestation of this unit in play, a <ability value=2304>Manifestation</ability> of this unit without upgrades is summoned within 3 spaces of this champion. This ability triggers only if the champion is a Garu Medium or Spirit of the Mountain.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "spirit_proj"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2536,
              "apCost": 0,
              "name": "Bestow",
              "shortDescription": "When this champion is destroyed, the closest friendly champion gains this unit's first upgrade ability. If that champion shares a race with this one, it gains the second upgrade ability as well.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1349,
              "apCost": 2,
              "name": "Relieve",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and all effects removed are applied to this unit.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "cleanse"
            },
            {
              "default": true,
              "id": 1483,
              "apCost": 3,
              "name": "Solidify",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=solid>Solid</condition> for 3 turns. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 2,
              "iconName": "ethereal"
            }
          ]
        }
      ]
    },
    {
      "id": 725,
      "name": "Garu Primitive",
      "description": "Some Garu praise their animal ancestors. They believe the bond between their wilder brethren is much stronger than that of the civil kin. These few raise their clubs to protect bear and Garu alike.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Garu"
      ],
      "noraCost": 71,
      "hash": "dj9Bj9Af1BG2AE8Dj9Ej9Fj9Gerqwmymsjyvhigg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1950,
          "apCost": 0,
          "name": "Bear Kinship",
          "shortDescription": "If a friendly Enraged Grizzly is in play, this champion gets +2 DMG and 2 additional ranks of <ability value=259>Enrage</ability>. If no other friendly Garu, this unit has -1 SPD.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "buff"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1290,
          "apCost": 0,
          "name": "Warmonger",
          "shortDescription": "When a friendly real champion is destroyed, this champion gains -1 DEF and +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1252,
              "apCost": 0,
              "name": "Readiness",
              "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 344,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +6 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hammer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            }
          ]
        }
      ]
    },
    {
      "id": 112,
      "name": "Garu Shaman",
      "description": "We are the calm brook. They are the crushing whitewater. Not all nature is peaceful. Afina Lighthander, K'thir Ranger",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 5,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 68,
      "hash": "dJ8HJ8Ge9Be9AF0BJ8IJ8Jj9Ajyoyolyojietxvf",
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 305,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 12 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "divine"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 366,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 4 HP. May target self.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 914,
      "name": "Garu Warguard",
      "description": "The Warguard steadfastly patrol the region the forest home of the Garu.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0Ag3AG2Bj9Cj9Dj9Eeeemwvkroyzgkgg",
      "artist": "Slawomir Maniak",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3,
          "apCost": 0,
          "name": "Fearless",
          "shortDescription": "This unit can not become <condition value=frightened>Frightened</condition>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "buff"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 2078,
          "apCost": 0,
          "name": "Reflexes",
          "shortDescription": "This unit takes 50% less damage (after DEF) from melee attacks.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "reflexes"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": false,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            },
            {
              "default": true,
              "id": 2690,
              "apCost": 4,
              "name": "Glorious Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            }
          ]
        }
      ]
    },
    {
      "id": 1560,
      "name": "Garu Whisperer",
      "description": "In Garu folklore, ancestral spirits reside in the forest all around. Garu Whisperers are said to have the capacity to speak with these spirits and even enlist their aid.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 82,
      "hash": "eJ8JJ8IG2Be9BG2AF0Bj9Cj9Dwiwitzinplpwtqf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1873,
          "apCost": 0,
          "name": "Magic Blast",
          "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "magicaoe"
        },
        {
          "id": 95,
          "apCost": 0,
          "name": "Vulnerability: Psychic",
          "shortDescription": "When this unit takes Psychic damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_psychic"
        },
        {
          "id": 3060,
          "apCost": 0,
          "name": "Wisp Whisperer",
          "shortDescription": "For every 25 damage dealt by this champion, an Ancient Wisp is summoned to an adjacent space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "wisp_whisperer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3043,
              "apCost": 0,
              "name": "Vitality: Creation",
              "shortDescription": "The first time each turn a champion comes into play, this champion gains +2 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fascinate"
            },
            {
              "default": true,
              "id": 1432,
              "apCost": 1,
              "name": "Blast",
              "shortDescription": "This champion makes a Magic attack against every enemy champion within its range.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 745,
              "apCost": 0,
              "name": "Magic Eater",
              "shortDescription": "When this unit would take Magic damage, it instead recovers HP equal to half the damage that would have been dealt.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_magic"
            },
            {
              "default": true,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            }
          ]
        }
      ]
    },
    {
      "id": 623,
      "name": "Gekaal, High One",
      "description": "We have achieved peace with all of Forglar. With this understanding, between the swamp and ourselves, we can ascend beyond our need for Nora. We can become it. - Gekaal, Forglar High One",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 94,
      "hash": "dj9Dj9CG2Bf1BG2Aj9Bj9Cj9Dvzzkllljwqohnjg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1767,
          "apCost": 0,
          "name": "Nora Incarnate",
          "shortDescription": "Any champion damaged by this champion's basic attack becomes <condition value=charred>Charred</condition> for 3 turns, <condition value=chilled>Chilled</condition> 3, <condition value=poisoned>Poisoned</condition> for 3 turns, <condition value=shocked>Shocked</condition> for 3 turns and <condition value=scoured>Scoured</condition> 3.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "special"
        },
        {
          "id": 1769,
          "apCost": 0,
          "name": "One With Nora",
          "shortDescription": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "defenseenhance"
        },
        {
          "id": 3011,
          "apCost": 0,
          "name": "Stasis",
          "shortDescription": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "crystallize"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 400,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "forcebarrier"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 1340,
              "apCost": 0,
              "name": "Intensify",
              "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "intensify"
            }
          ]
        }
      ]
    },
    {
      "id": 1850,
      "name": "Gekaal, High One",
      "description": "We have achieved peace with all of Forglar. With this understanding, between the swamp and ourselves, we can ascend beyond our need for Nora. We can become it. - Gekaal, Forglar High One",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 94,
      "hash": "ej9AJ8Jf1BG2BG2Af1Aj9Aj9Bethgiwkgplnhgrf",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1767,
          "apCost": 0,
          "name": "Nora Incarnate",
          "shortDescription": "Any champion damaged by this champion's basic attack becomes <condition value=charred>Charred</condition> for 3 turns, <condition value=chilled>Chilled</condition> 3, <condition value=poisoned>Poisoned</condition> for 3 turns, <condition value=shocked>Shocked</condition> for 3 turns and <condition value=scoured>Scoured</condition> 3.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "special"
        },
        {
          "id": 1769,
          "apCost": 0,
          "name": "One With Nora",
          "shortDescription": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "defenseenhance"
        },
        {
          "id": 3011,
          "apCost": 0,
          "name": "Stasis",
          "shortDescription": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "crystallize"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 400,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "forcebarrier"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 1340,
              "apCost": 0,
              "name": "Intensify",
              "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "intensify"
            }
          ]
        }
      ]
    },
    {
      "id": 822,
      "name": "General Korsien",
      "description": "Serkan sent his trusted general to Maljara to forge alliances with the enigmatic Stitched. General Korsien is old Elsarin's sole survivor. What lies beneath his armor, living flesh or rotting bone, remains a mystery. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 90,
      "hash": "dJ8JJ8IF0BG2Bg3Aj9Dj9Ej9Fukukwtsqfruvfig",
      "artist": "Michele Chang",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2110,
          "apCost": 0,
          "name": "Dark Rider",
          "shortDescription": "When this unit is destroyed, no nora globe is dropped and a normal sized General Korsien with <ability value=2315>Oblivion Shield</ability> and <ability value=805>Chain Lightning</ability> is spawned in the location this unit occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 40,
          "iconName": "rider"
        },
        {
          "id": 2986,
          "apCost": 0,
          "name": "Fearsome Hunter",
          "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "fear"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3143,
              "apCost": 0,
              "name": "Lead the Charge",
              "shortDescription": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "lead_the_charge"
            },
            {
              "default": false,
              "id": 2068,
              "apCost": 0,
              "name": "Frightful Aura",
              "shortDescription": "All opposing champions within 4 spaces have -2 DMG. All friendly Undead champions within 4 spaces have +2 DEF.",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 853,
              "apCost": 0,
              "name": "Battle Harden",
              "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 3294,
              "apCost": 0,
              "name": "Warlord",
              "shortDescription": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "warlord"
            }
          ]
        }
      ]
    },
    {
      "id": 1689,
      "name": "Genesis Lich",
      "description": "Some seek power, others fortune.  For the Genesis, there is but a single pursuit worthy of true dedication: immortality.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9Df1BF0BG2Ag3Aj9Aj9Beeexoqjlufpwqsf",
      "artist": "Alex Brock",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 607,
          "apCost": 0,
          "name": "Essence Capture",
          "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "noragen"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 3181,
          "apCost": 1,
          "name": "Spirit Harvest",
          "shortDescription": "This champion makes a Loss of Life attack against target champion at RNG 2-5. If this destroys the champion, a Phylactery relic is summoned in the closest friendly deployment zone. ",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "phylactery"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 501,
      "name": "Ghost Stalker",
      "description": "With the help of the forest spirits, these druids can project themselves through the Nora.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf",
        "Spirit"
      ],
      "noraCost": 68,
      "hash": "dj9Cj9BG2Af1Ae9BJ8GJ8HJ8Ipluziwtmuosolyg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1429,
          "apCost": 1,
          "name": "Absorb Illusion",
          "shortDescription": "The nearest <condition value=illusion>Illusion</condition> within 5 spaces is destroyed and this unit heals 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 1,
          "iconName": "heal"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 3033,
          "apCost": 0,
          "name": "Mirrorblade",
          "shortDescription": "When this champion makes a successful basic attack, two illusion copies of itself are summoned randomly within 4 spaces of the target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "swarm"
        },
        {
          "id": 1316,
          "apCost": 0,
          "name": "Vulnerable",
          "shortDescription": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1396,
              "apCost": 0,
              "name": "Fading Light",
              "shortDescription": "When this champion recovers a nora globe, it becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": true,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            }
          ]
        }
      ]
    },
    {
      "id": 238,
      "name": "Ghoul",
      "description": "It's ironic that such well preserved specimens suffer from the fact that their muscles hinder movement more than help. - Xulos, Apprentice to Serkan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elf",
        "Undead",
        "Vampyre",
        "Zombie"
      ],
      "noraCost": 59,
      "hash": "dj9AJ8Jf1Ae9Be9Aj9Fj9Gj9Hjgpuztmnuhklleg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 205,
          "apCost": 0,
          "name": "Death Nova: Disease",
          "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovadisease"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3397,
              "apCost": 0,
              "name": "Vampiric Thirst",
              "shortDescription": "This champion has <ability value=99>Life Siphon</ability>. When a friendly champion with Race: Vampyre within 3 spaces vampiric heals, this champion loses 5 HP, gains 1 AP and gains +1 DMG for 1 turn. This ability can trigger up to 2 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2142,
              "apCost": 0,
              "name": "Zombie Apocalypse",
              "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "zombie_apoc"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 3151,
              "apCost": 0,
              "name": "Bloodspurt",
              "shortDescription": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2634,
              "apCost": 0,
              "name": "Brain Eater",
              "shortDescription": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_disease"
            }
          ]
        }
      ]
    },
    {
      "id": 211,
      "name": "Ghoulhunter",
      "description": "This place reeks of death...but I sense none of Serkan's forces here. - Scheusu, Ghoul Hunter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman",
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 65,
      "hash": "dJ8HJ8Ge9Be9Be9Aj9Fj9Gj9Hiepqfgytzvvziyg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3155,
          "apCost": 3,
          "name": "Declare Vengeance",
          "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "declare_vengeance"
        },
        {
          "id": 163,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rend"
        },
        {
          "id": 1483,
          "apCost": 3,
          "name": "Solidify",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=solid>Solid</condition> for 3 turns. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 2,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 317,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 2216,
              "apCost": 0,
              "name": "Hunter: Mage",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "wizard_foe"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        }
      ]
    },
    {
      "id": 343,
      "name": "Giant Crustacean",
      "description": "The shell of an adult crustacean is stronger than stone and harder than steel. Its foe cannot hope to defeat one with physical might alone.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 69,
      "hash": "dj9Bj9Af1BF0AG2Aj9Bj9Cj9Dpjtzxtzztfkjygg",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1199,
          "apCost": 0,
          "name": "Calcify",
          "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novaphysical"
        },
        {
          "id": 2369,
          "apCost": 0,
          "name": "Clamp",
          "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "clamp"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            },
            {
              "default": false,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            }
          ]
        }
      ]
    },
    {
      "id": 475,
      "name": "Glacial Titan",
      "description": "The tundra has chosen to fight beside the Jakei, aiding with its own breed of soldier.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 16,
      "hitPoints": 68,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 113,
      "hash": "dJ8IJ8HF0Af1Af1AJ8Jj9Aj9Beinpqsftsszkjyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 604,
          "apCost": 1,
          "name": "Frost Cone ",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "iceaoe"
        },
        {
          "id": 2804,
          "apCost": 0,
          "name": "Orb of Frostfall",
          "shortDescription": "Champions within 8 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
          "activationType": 1,
          "level": 2,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "trail_snow"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2742,
              "apCost": 0,
              "name": "Savage Conduit",
              "shortDescription": "When an opposing champion with Chilled, Frozen or <condition value=awestruck popup=false>Awestruck</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "savage_conduit"
            },
            {
              "default": false,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            },
            {
              "default": false,
              "id": 776,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_chill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            },
            {
              "default": true,
              "id": 898,
              "apCost": 0,
              "name": "Ice Eater",
              "shortDescription": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 108,
      "name": "Glacier Rhino",
      "description": "Rugolth's beard! There's something you don't see everyday... -- Mikkels Longhollow, Ironfist Expeditionary Force",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 61,
      "hash": "dj9Fj9EE8De9Af1Bj9Aj9Bj9Ceeeigyohvsxztzg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 617,
          "apCost": 0,
          "name": "Gore",
          "shortDescription": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gore"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 303,
      "name": "Glowing Slider ",
      "description": "Even the smallest creatures of the forest can aid the call of the wounded. - Elven Medic",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 0,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 64,
      "hash": "dj9Ej9Dg3Ae9Bg3Aj9Dj9Ej9Fgegieevquzxtfkg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 3251,
          "apCost": 0,
          "name": "Portal Blast",
          "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 860,
          "apCost": 0,
          "name": "Trail: Slime",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Slime (Impeding 1 Water) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "trail_slime"
        },
        {
          "id": 726,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            },
            {
              "default": false,
              "id": 427,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poison_cloud"
            },
            {
              "default": true,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        }
      ]
    },
    {
      "id": 538,
      "name": "Gluttonous Overseer",
      "description": "Boghopper meat is a delicacy, best enjoyed in moderation. The Overseers have been known to overlook this.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 15,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "G'hern"
      ],
      "noraCost": 64,
      "hash": "dj9Gj9Fe9Af1Be9Aj9Fj9Gj9Hftxfersshpqsqhg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 2333,
          "apCost": 1,
          "name": "Chuck: Moga",
          "shortDescription": "This champion makes a ranged Physical attack at RNG 2-5. A summoned Moga Axeman with no upgrades is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "summoga"
        },
        {
          "id": 1726,
          "apCost": 0,
          "name": "Devour Life",
          "shortDescription": "At the end of every other one of your turns, the champion with the lowest amount of health which is owned by this champion's owner is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -35,
          "iconName": "devour"
        },
        {
          "id": 2708,
          "apCost": 1,
          "name": "Gluttony",
          "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "devour"
        },
        {
          "id": 678,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 7 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "overseermoga"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            }
          ]
        }
      ]
    },
    {
      "id": 1617,
      "name": "Gnarlwood Borderguard",
      "description": "\"I need not know from whence you came, demons, just be assured that you shall find no purchase here.\" ~ Gnarlwood Borderguard to the Nefari Raiders",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9Dg3AF0AG2Ag3Aj9Dj9Eeeeigphyinpyitf",
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 3145,
          "apCost": 0,
          "name": "Empowered: Defense",
          "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "fragile_defense"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        }
      ]
    },
    {
      "id": 397,
      "name": "Gnarlwood Grappler",
      "description": "Any who enter with malicious intentions are torn apart by the trees themselves.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 62,
      "hash": "dJ8HJ8Ge9BF0BF0BJ8IJ8Jj9Aemeplumsuknjlwf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 317,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            },
            {
              "default": true,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 1458,
              "apCost": 0,
              "name": "Forest Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terraingrass"
            }
          ]
        }
      ]
    },
    {
      "id": 221,
      "name": "Gnarlwood Launcher",
      "description": "We have always sworn to protect the Forest! Now, I ask the Forest itself to join me in arms! - Godwin, Elder Garu",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 74,
      "hash": "dJ8IJ8HF0Ae9Be9BJ8GJ8HJ8Imjrfggpjwqwzruf",
      "artist": "Gabriel Garza",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 553,
          "apCost": 0,
          "name": "Attack: Boulder",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physicalaoe"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        },
        {
          "id": 817,
          "apCost": 3,
          "name": "Throw Champion",
          "shortDescription": "Target adjacent friendly champion gains Catapult (This unit leaps to target location within 5 spaces).",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 15,
          "iconName": "throw_champ"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            },
            {
              "default": true,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 769,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 217,
      "name": "Gnarlwood Lifegiver",
      "description": "\"And so the trees were born on the borders of the Forest, so that all that enter and all that leave could be renewed.\" - Trails of K'thir, pg. 76",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 5,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9Be9BG2Bj9Cj9Dj9Eeeigtuknlyofrzg",
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2857,
          "apCost": 0,
          "name": "Courage",
          "shortDescription": "This unit has +2 DMG and +1 DEF for every 8 HP it is missing. This stacks up to 3 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "aurapositive"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 3032,
          "apCost": 0,
          "name": "Quest: Support Ally",
          "shortDescription": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "opportunistic"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1342,
              "apCost": 2,
              "name": "Impart",
              "shortDescription": "Target champion within 3 spaces is healed for 5 HP and gains 1 DMG. This unit loses 8 life and gains -1 DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1481,
              "apCost": 2,
              "name": "Shield Allies",
              "shortDescription": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            }
          ]
        }
      ]
    },
    {
      "id": 1096,
      "name": "Gnarlwood Oakthumper",
      "description": "\"Mind those splinters.\" - Sisslevest, Snakedancer Extraordinaire",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 85,
      "hash": "ej9Fj9Ee9Ae9Ae9AE8Dj9Fj9Gymshyirjtuvqwo",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 1122,
          "apCost": 0,
          "name": "Plant Regeneration",
          "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "plantregen"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1261,
              "apCost": 0,
              "name": "Surge: Plant",
              "shortDescription": "This unit has +1 DMG for each friendly Plant.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_plant"
            },
            {
              "default": false,
              "id": 1006,
              "apCost": 0,
              "name": "Surge: Enemy",
              "shortDescription": "This unit has +1 DMG for each deployed enemy champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "surge_enemy"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 396,
      "name": "Gnarlwood Patriarch",
      "description": "Now it is time we protect each other. - Sapaleh the Ancient",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 67,
      "hash": "dJ8HJ8Ge9BF0BF0AJ8HJ8IJ8Jeeekrjtosmsoyvf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1849,
          "apCost": 0,
          "name": "Shroud",
          "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "aurapositive"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1083,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=115>Regeneration 1</ability>.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            },
            {
              "default": true,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": false,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1095,
      "name": "Gnarlwood Tanglefoot",
      "description": "\"Get away, get awaagghk!\" - Nudbum, Moga Hooligan",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 6,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 66,
      "hash": "ej9Fj9EE8De9Ae9AE8Dj9Ej9Fgytofphrzrwvso",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1947,
          "apCost": 0,
          "name": "Entangling Attack",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "disable"
        },
        {
          "id": 16,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "multiattack"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            },
            {
              "default": true,
              "id": 1306,
              "apCost": 0,
              "name": "Mountaineer",
              "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "climb"
            }
          ]
        }
      ]
    },
    {
      "id": 1097,
      "name": "Gnarlwood Willowind",
      "description": "Willowinds are one of K'thir's oldest treasures. Their sap is an ambrosia they give willingly to any who want it. It will heal a wound and if need be...the mind. \r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 7,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9Ee9Be9Ae9AE8DJ8GJ8Hsqqhvofrfmpyin",
      "artist": "Mike Pedro",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 2801,
          "apCost": 0,
          "name": "Logistics: Heal Champion",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2426,
              "apCost": 3,
              "name": "Fairy Dust",
              "shortDescription": "Target champion within 4 spaces gains <ability value=2266>Wandering</ability> for 2 Turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fairydust"
            },
            {
              "default": false,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 692,
              "apCost": 0,
              "name": "Nature's Balance",
              "shortDescription": "Amplifications and Vulnerabilities are negated.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 15,
              "iconName": "soul_bond"
            },
            {
              "default": true,
              "id": 2501,
              "apCost": 3,
              "name": "Cast: Light as a Feather",
              "shortDescription": "Area Effect 1, Range 4: Affected champions gain <ability value=1>Flight</ability> and <ability value=6>Mobility</ability> for 6 turns and 1 AP.  If the champions have <ability value=5>Lumbering</ability> or <ability value=3064>Weighty</ability>, or <ability value=2012>Lethargic</ability>, they lose it for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "feather"
            }
          ]
        }
      ]
    },
    {
      "id": 55,
      "name": "Goblin Archer",
      "description": "What the goblin archer lacks in skill, he makes up for in arrows.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 66,
      "hash": "cj9Fj9Ej9Dg3AF0Bj9Dj9Ej9Fmjllgnethiytxoj",
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            }
          ]
        }
      ]
    },
    {
      "id": 1159,
      "name": "Goblin Arsonist",
      "description": "FIRE! BURN BURN BURN! Ooooh, FIRE! OH YEA! It's getting hot in here! BURN BURN BURN! Did you dye your hair red? No, it's just on fire!  HAHAHAH!",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue",
        "Wizard"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 64,
      "hash": "ej9Bj9AF0Ae9Ae9Af1BJ8HJ8Ixxklykggtxkyon",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 181,
          "apCost": 0,
          "name": "Death Nova: Fire",
          "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovafire"
        },
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 56,
      "name": "Goblin Brute",
      "description": "Brutes? They're all brutes. Some are just bigger. Same brains as a chestnut, the lot of them. - Rugolth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 62,
      "hash": "cj9Dj9Cj9BG2AF0Bj9Bj9Cj9Dhklwkuolgnyzohi",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 376,
          "apCost": 0,
          "name": "Exertion",
          "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "crazed_charger"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1651,
      "name": "Goblin Collector",
      "description": "Goblins always look for the one thing they will never find: a treasure worth keeping.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 65,
      "hash": "eJ8JJ8Ie9BF0BG2AF0BJ8GJ8Heeeeepwzgiwkuo",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3239,
          "apCost": 3,
          "name": "Clone Matter",
          "shortDescription": "Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one).",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "absorb_relic"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 3148,
          "apCost": 0,
          "name": "Provision: Utility",
          "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plunder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            },
            {
              "default": true,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            }
          ]
        }
      ]
    },
    {
      "id": 1693,
      "name": "Goblin Cropsick",
      "description": "Some of those born with a gift for magic use it to do good, some to do evil... and some use it to get fat.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 40,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 63,
      "hash": "eJ8IJ8HE8Df1AG2AF0Aj9Ej9Feevkgrfmwoythpf",
      "artist": "Damien Mammoliti",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3191,
          "apCost": 4,
          "name": "Irresponsible Essence Imbibement",
          "shortDescription": "Enemy champions within 5 spaces lose between 5 and 15 HP and this champion gains MAX HP equal to 75% of the amount lost. If this champion has more than 75 HP, it is destroyed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "essence_imbibement"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 177,
              "apCost": 0,
              "name": "Death Nova: Magical",
              "shortDescription": "When this unit is destroyed, it deals 11 Magical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovamagic"
            },
            {
              "default": true,
              "id": 535,
              "apCost": 0,
              "name": "Bile Explosion",
              "shortDescription": "When this unit is destroyed, units within 2 spaces take 10 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "deathnovaacid"
            },
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            },
            {
              "default": true,
              "id": 2708,
              "apCost": 1,
              "name": "Gluttony",
              "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "devour"
            }
          ]
        }
      ]
    },
    {
      "id": 1158,
      "name": "Goblin Dirtbag",
      "description": "My mom gave me this bucket!  Don't make fun of it!",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 67,
      "hash": "ej9Bj9Ae9Be9Ae9Af1BJ8GJ8Hyoqlnhnwkpnjln",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2486,
          "apCost": 3,
          "name": "Blind",
          "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "blind"
        },
        {
          "id": 2575,
          "apCost": 0,
          "name": "Defiling Aura",
          "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defile_corpse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            },
            {
              "default": true,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 1160,
      "name": "Goblin Gloombringer",
      "description": "Now, tell me. Are we having fun yet? Remember what happens if you get this wrong...",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue",
        "Wizard"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 82,
      "hash": "ej9Bj9AF0Be9Ae9Af1BJ8IJ8Jkyruhirwqjpsso",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 966,
          "apCost": 2,
          "name": "Cackle",
          "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "cackle"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 2909,
          "apCost": 2,
          "name": "Terrorize",
          "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2209,
              "apCost": 0,
              "name": "Mirrored",
              "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "mirrored"
            },
            {
              "default": false,
              "id": 2434,
              "apCost": 0,
              "name": "Leech Vitality",
              "shortDescription": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "overkill"
            },
            {
              "default": true,
              "id": 2315,
              "apCost": 0,
              "name": "Oblivion Shield",
              "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "aegis"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1760,
      "name": "Goblin King",
      "description": "\"Bring me his head! And his leg! And his eyes! I'm in a bad mood today.\" -- Tolgra, Goblin King",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 60,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God",
        "Wizard"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 85,
      "hash": "ej9AJ8Jg3Af1BG2Af1Aj9Dj9Eerhrhekeignuqsf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1160,
          "apCost": 0,
          "name": "Boost",
          "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "boost"
        },
        {
          "id": 866,
          "apCost": 2,
          "name": "Drain",
          "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "drain"
        },
        {
          "id": 3246,
          "apCost": 0,
          "name": "Sovereign Bounty",
          "shortDescription": "This champion permanently gains a random non-basic attack ability from the next 3 champions you deploy from the runedock.  This does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "sovereign_bounty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1801,
      "name": "Goblin Rockpack",
      "description": "Goblins are the traditional victims of every kind of demon in the Underdepths. As a defense mechanism, young goblins form into groups, which can be as fiendish and bloodthirsty as their tormenters.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 30,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 79,
      "hash": "ej9Cj9BG2AG2AG2AG2Aj9Bj9Ceemsfpljiroftsf",
      "artist": "Caio Monteiro",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3300,
          "apCost": 0,
          "name": "Goblin Rockpack",
          "shortDescription": "When this champion is deployed from the runedock, 2 Goblin Rockpack champions with no upgrades are summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 40,
          "iconName": "pack_mentality"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        },
        {
          "id": 2707,
          "apCost": 0,
          "name": "Vivify",
          "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3147,
              "apCost": 0,
              "name": "Seism",
              "shortDescription": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 14,
              "iconName": "seism"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1933,
              "apCost": 0,
              "name": "Coordination",
              "shortDescription": "All friendly champions within 2 spaces of this unit gain <ability value=1214>Encouraged</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 1127,
      "name": "Goblin Spellkaiser",
      "description": "The Goblins were never gone, they were merely hiding!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8He9Ae9Ae9AF0Aj9Fj9Gmwqhgepqhituon",
      "artist": "Anthony Lopes",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2687,
          "apCost": 3,
          "name": "Confuse",
          "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "confuse"
        },
        {
          "id": 1443,
          "apCost": 0,
          "name": "Council: Spells",
          "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "special"
        },
        {
          "id": 1769,
          "apCost": 0,
          "name": "One With Nora",
          "shortDescription": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "defenseenhance"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2514,
              "apCost": 3,
              "name": "Cast: Cauterize ",
              "shortDescription": "Target injured champion within 3 spaces takes 10 Fire damage and is <condition value=inhibited>Inhibited</condition> and <condition value=defiled>Defiled</condition>. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            },
            {
              "default": true,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2401,
              "apCost": 4,
              "name": "Lightning Skewer",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1161,
      "name": "Goblin Stickyfingers",
      "description": "Why steal money when you can steal... everything?",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Goblin"
      ],
      "noraCost": 57,
      "hash": "ej9Bj9Af1Ae9Ae9Af1BJ8Jj9Aeiyvzketmuhnwo",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2212,
          "apCost": 0,
          "name": "Banditry",
          "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "banditry"
        },
        {
          "id": 2003,
          "apCost": 0,
          "name": "Mercenary",
          "shortDescription": "At the beginning of your turns you lose 2 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "cost"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2523,
              "apCost": 2,
              "name": "Goblin Thievery",
              "shortDescription": "Gain a random ability that is not a basic attack from target opposing champion within 5 spaces. Friendly Goblins within 5 spaces of this champion also gain that ability. This ability does not break stealth and is removed upon use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "goblin_thievery"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1660,
      "name": "Gold-Enchanted Groble",
      "description": "Some grobles are etched with ancient runes before they are awakened.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Jg3AF0BG2Af1Aj9Dj9Eeemwmhnyonlnlrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2737,
          "apCost": 0,
          "name": "Physical Amped",
          "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Physical Aura 3.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amped_physical"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        },
        {
          "id": 2261,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": false,
              "id": 2190,
              "apCost": 0,
              "name": "Charged Attack",
              "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "charged_attack"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1828,
      "name": "Golden Lamia",
      "description": "\"Hurry, hurry, hurry, dwarf, run until your stubby life wears out.\"",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch"
      ],
      "races": [
        "Mirefolk",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 72,
      "hash": "eJ8IJ8He9AG2BG2AF0Aj9Fj9Gmwzvvzrjeepqsqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 3285,
          "apCost": 0,
          "name": "Sabotage: Lethargy",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DMG and <ability value=2012>Lethargic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "sabotage_lethargy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 3398,
              "apCost": 0,
              "name": "Sanguine Sorceress",
              "shortDescription": "This champion has <ability value=607>Essence Capture</ability>. While there is a friendly champion with <ability value=3399>Lord of Strigoi</ability> in play, friendly champions with Race: Vampyre within 3 spaces of this champion gain <ability value=3151>Bloodspurt</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "greater_vampirism"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 759,
      "name": "Goliath Fesh",
      "description": "You just go in there, yank the short sword out of his teeth, and come back. Why are you looking at me? Get to it! - Aanduur, Voil Overseer and second recorded victim of a Goliath Fesh",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3AG2AF0BJ8IJ8Jj9Aqolphtfketmlnhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 669,
          "apCost": 0,
          "name": "Earthbound",
          "shortDescription": "This champion is <condition value=grounded>Grounded</condition>, cannot gain <condition value=flying popup=false>Flying</condition>, and cannot be relocated.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "lumbering"
        },
        {
          "id": 1980,
          "apCost": 4,
          "name": "Swallow Whole",
          "shortDescription": "Target small non-<ability value=1045>Elite</ability> enemy champion is removed from play and loses 8 HP at the beginning of each turn. While this effect is active, this champion gains <ability value=5>Lumbering</ability>, <ability value=680>Planar Bound</ability> and <ability value=2474>Font Ignorance</ability>. After 2 turns or if this champion leaves play or loses this ability, any champions with HP remaining are deployed in the nearest available space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 20,
          "iconName": "swallow"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 779,
      "name": "Goliath Fesh",
      "description": "You just go in there, yank the short sword out of his teeth, and come back. Why are you looking at me? Get to it! - Voil Overseer to the second recorded victim of a Goliath Fesh",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8DG2Bg3Aj9Dj9Ej9Fiwxkjwfkwipsqjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 669,
          "apCost": 0,
          "name": "Earthbound",
          "shortDescription": "This champion is <condition value=grounded>Grounded</condition>, cannot gain <condition value=flying popup=false>Flying</condition>, and cannot be relocated.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "lumbering"
        },
        {
          "id": 1980,
          "apCost": 4,
          "name": "Swallow Whole",
          "shortDescription": "Target small non-<ability value=1045>Elite</ability> enemy champion is removed from play and loses 8 HP at the beginning of each turn. While this effect is active, this champion gains <ability value=5>Lumbering</ability>, <ability value=680>Planar Bound</ability> and <ability value=2474>Font Ignorance</ability>. After 2 turns or if this champion leaves play or loses this ability, any champions with HP remaining are deployed in the nearest available space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 20,
          "iconName": "swallow"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 497,
      "name": "Gravewatcher",
      "description": "We must tend to the Elsari that slumber in their crypts. It is our duty. - Nelmo, Gravewatcher",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 45,
      "hash": "dj9Bj9Af1Bf1AG2Bj9Cj9Dj9Eeeitxmnpsszmwig",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1333,
          "apCost": 0,
          "name": "Exhume",
          "shortDescription": "Target adjacent champion you own will be reanimated when destroyed. This champion is destroyed when the target of this ability is reanimated and gains an additional 20 turn cooldown. If this champion is destroyed before the target, the target will not be reanimated.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 9,
          "noraCost": 9,
          "iconName": "revive"
        },
        {
          "id": 1335,
          "apCost": 0,
          "name": "Gravetend",
          "shortDescription": "When this unit is deployed, your champion with the highest cooldown is set to 0. When this unit is destroyed, your enemy's champion with the highest cooldown is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "ondeath"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 86,
              "apCost": 0,
              "name": "Vulnerability: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is increased by 25% (after DEF).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "vuln_physical"
            },
            {
              "default": false,
              "id": 2002,
              "apCost": 0,
              "name": "Easy Target",
              "shortDescription": "This unit takes 30% more damage from ranged attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -10,
              "iconName": "easy_target"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 204,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 8 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "deathnovadisease"
            }
          ]
        }
      ]
    },
    {
      "id": 57,
      "name": "Great Eagle",
      "description": "The K'thir's advantage is in the agility and speed of their winged scouts.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 64,
      "hash": "bJ8JJ8IJ8HF0AJ8HJ8IJ8Jj9Aoqoqoqjnygvfvzk",
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3296,
              "apCost": 0,
              "name": "Zeal: Damage",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_damage"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 453,
      "name": "Greater Pitspawn ",
      "description": "The K'thir will know his fury. And they will beg for a mercy they will never receive. - Grimlic",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 17,
      "hitPoints": 72,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 113,
      "hash": "dj9Fj9EE8Df1AG2Aj9Bj9Cj9Dsmneexxxqukjygg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 16,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "multiattack"
        },
        {
          "id": 2611,
          "apCost": 0,
          "name": "Soulharvester",
          "shortDescription": "When this unit destroys an enemy champion, you gain nora equal to 25% of the destroyed champion's nora cost.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "ondeath"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 3013,
              "apCost": 0,
              "name": "Soultap Feedback",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "soultap_feedback"
            },
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 58,
      "name": "Grekin",
      "description": "Grekin's existence was a result of an unsuccessful attempt by Xulos to perform a multiple resurrection.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 74,
      "hash": "cj9Dj9Cj9BG2AG2Aj9Bj9Cj9Dsfiersuvshgpsji",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2213,
          "apCost": 0,
          "name": "Crazed Charger",
          "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crazed_charger"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 3059,
              "apCost": 0,
              "name": "Thunderous Charge",
              "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "thunderous_charge"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 1775,
      "name": "Griffin Fledgling",
      "description": "Griffin fledglings are extremely aggressive and refuse any rider. While maturity ensures they may peaceably bond with a trainer, it does little to stunt their valor.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 69,
      "hash": "ej9Fj9EF0AG2AG2AE8DJ8HJ8Ivqqqzoqukeignpf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3256,
          "apCost": 0,
          "name": "Fledgling Mimicry",
          "shortDescription": "When the next friendly champion with a Sigil ability is deployed from the runedock, this champion gains that Sigil ability and has it triggered.  This champion also gains the upgraded abilities of that champion. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "fledgling_mimicry"
        },
        {
          "id": 2459,
          "apCost": 0,
          "name": "Honorary Sigil",
          "shortDescription": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "griffin_sigil"
        },
        {
          "id": 1979,
          "apCost": 0,
          "name": "Running Start",
          "shortDescription": "Whenever this champion moves 2 or more spaces, it gains <ability value=1>Flight</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "flight"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": true,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            }
          ]
        }
      ]
    },
    {
      "id": 59,
      "name": "Griffin Rider",
      "description": "Let us take to the skies. - Rugolth, the Dwarven King",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Archer",
        "Ranger"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 75,
      "hash": "cj9Gj9Fj9EE8De9Bj9Ej9Fj9Gevofrfrumhvmphi",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2459,
          "apCost": 0,
          "name": "Honorary Sigil",
          "shortDescription": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "griffin_sigil"
        },
        {
          "id": 3196,
          "apCost": 0,
          "name": "Updraft",
          "shortDescription": "When this champion is deployed from the runedock, friendly champions gain <condition value=flying>Flying</condition> for 4 turns. If it shares a race with this champion or already has <condition value=flying>Flying</condition>, it also gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "tailwind"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 101,
              "apCost": 1,
              "name": "Barrage",
              "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1139,
              "apCost": 3,
              "name": "Command: Dodge",
              "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "command_dodge"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 354,
      "name": "Grimlic",
      "description": "Brother, the difference between Angels and Demons is that one is bound to a power you agree with. The creation of the Underdepths is but a stepping stone on my ascension! - Grimlic to Menalaus",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 92,
      "hash": "dj9Cj9BG2AF0Ag3Aj9Dj9Ej9Fpfgvfemwxvxvmjg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        },
        {
          "id": 3375,
          "apCost": 0,
          "name": "Zealot",
          "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 773,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 774,
      "name": "Grimlic",
      "description": "Brother, the difference between Angels and Demons is that one is bound to a power you agree with. The creation of the Underdepths is but a stepping stone on my ascension! - Grimlic to Menalaus",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 92,
      "hash": "dj9Fj9EE8DG2Bf1AJ8Jj9Aj9Bsmhykpqqowthpfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        },
        {
          "id": 3375,
          "apCost": 0,
          "name": "Zealot",
          "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 773,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 1855,
      "name": "Grimlic",
      "description": "Brother, the difference between Angels and Demons is that one is bound to a power you agree with. The creation of the Underdepths is but a stepping stone on my ascension! - Grimlic to Menalaus",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 92,
      "hash": "ej9Bj9Ae9AG2BG2Af1Bj9Fj9Giipnhievfpnjlrf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        },
        {
          "id": 3375,
          "apCost": 0,
          "name": "Zealot",
          "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 773,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 1365,
      "name": "Grimlic",
      "description": "Brother, the difference between Angels and Demons is that one is bound to a power you agree with. The creation of the Underdepths is but a stepping stone on my ascension! - Grimlic to Menalaus",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 92,
      "hash": "ej9Bj9Af1AF0Ae9Af1BJ8Jj9Aemwvowtuqzvkepf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        },
        {
          "id": 2807,
          "apCost": 0,
          "name": "Winter Gloom",
          "shortDescription": "This unit is filled with Winter Gloom!",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "domain_snow"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        },
        {
          "id": 3375,
          "apCost": 0,
          "name": "Zealot",
          "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 773,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 785,
      "name": "Grimlic of K'thir",
      "description": "\"Once, long ago, my brother was a gentle man. His life was devoted to K`thir and its protection. But, perhaps that was his downfall.\" - Menalaus of K`thir",
      "maxRng": 7,
      "minRng": 5,
      "defense": 1,
      "speed": 7,
      "damage": 13,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 94,
      "hash": "dj9AJ8Jf1AF0BF0AJ8HJ8IJ8Jjgkepfipsjtjyxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 2635,
          "apCost": 0,
          "name": "Opposing Viewpoints",
          "shortDescription": "Menalaus and Grimlic of K'thir have opposing viewpoints and refuse to co-operate (they may not be part of the same battlegroup).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "passive"
        },
        {
          "id": 738,
          "apCost": 0,
          "name": "Shielded",
          "shortDescription": "This champion may not be the target of opposing spells",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        },
        {
          "id": 1172,
          "apCost": 0,
          "name": "Taunt (Surrender)",
          "shortDescription": "Taunt your enemies with the phrase \"Surrender now and save yourself the trouble!.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 2599,
              "apCost": 0,
              "name": "Iridescent Projection",
              "shortDescription": "When a friendly champion within 8 spaces makes an attack, a random opposing unit within 8 spaces of this one takes 2 Magical damage.   If the attacking champion is a Fairy or a Wizard, the closest unit to this one takes the damage instead.  This damage ignores DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": true,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 1926,
      "name": "Grimlic of K'thir",
      "description": "\"Once, long ago, my brother was a gentle man. His life was devoted to K`thir and its protection. But, perhaps that was his downfall.\" - Menalaus of K`thir",
      "maxRng": 7,
      "minRng": 5,
      "defense": 1,
      "speed": 7,
      "damage": 13,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 94,
      "hash": "dj9AJ8Jf1AF0BF0AJ8HJ8IJ8Jjgkepfipsjtjyxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 2635,
          "apCost": 0,
          "name": "Opposing Viewpoints",
          "shortDescription": "Menalaus and Grimlic of K'thir have opposing viewpoints and refuse to co-operate (they may not be part of the same battlegroup).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "passive"
        },
        {
          "id": 738,
          "apCost": 0,
          "name": "Shielded",
          "shortDescription": "This champion may not be the target of opposing spells",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 2599,
              "apCost": 0,
              "name": "Iridescent Projection",
              "shortDescription": "When a friendly champion within 8 spaces makes an attack, a random opposing unit within 8 spaces of this one takes 2 Magical damage.   If the attacking champion is a Fairy or a Wizard, the closest unit to this one takes the damage instead.  This damage ignores DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": true,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 1133,
      "name": "Grintmaw Bouncer",
      "description": "The entrance to the Gritmaw Caverns are always guarded. Only the Gritmaw may lay eyes on the hanging stone citadel under the mountains. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 82,
      "hash": "eJ8IJ8HG2Ae9Ae9AF0Aj9Bj9Cevfrowxvkyrqso",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1987,
          "apCost": 2,
          "name": "Hold the Line",
          "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2478,
              "apCost": 0,
              "name": "Improve Range",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_range"
            },
            {
              "default": false,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            },
            {
              "default": false,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            }
          ]
        }
      ]
    },
    {
      "id": 1480,
      "name": "Grintmaw Flamehurler",
      "description": "Flamehurlers power their attacks through by channeling nora into fire.  Their particular process makes the attacks especially potent against those carrying equipment.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 68,
      "hash": "eJ8IJ8Hf1AF0Be9AF0AJ8Jj9Aeevxthnuqzxvqo",
      "artist": "Thomas Babbey",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1961,
          "apCost": 0,
          "name": "Channel: Damage",
          "shortDescription": "This champion has +1 DMG for 2 turns and <ability value=655>Skirmisher</ability> for 2 turns. This ability initially costs 4 nora to activate, with the cost increasing by 1 nora per activation for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "channel_damage"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            }
          ]
        }
      ]
    },
    {
      "id": 1479,
      "name": "Grintmaw Gravitone",
      "description": "Some of the Grintmaw's songs were so highly developed that they could even apply kinetic force onto faraway objects.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 6,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 68,
      "hash": "eJ8IJ8HF0BF0Be9AF0AJ8IJ8Jeevzvshtqfignn",
      "artist": "Maciej Janaszek",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3005,
          "apCost": 0,
          "name": "Kinetic Impulse",
          "shortDescription": "Ranged attacks made by this champion have a bonus of 2 DMG for each space the target is beyond the champion's minimum range (to a maximum of 4 DMG).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "rock"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1759,
              "apCost": 0,
              "name": "Impassioned",
              "shortDescription": "This unit gets +3 DMG and +1 DEF when your shrine or avatar has less than half its HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2037,
              "apCost": 2,
              "name": "Terraform: Rock",
              "shortDescription": "Target space within 3 spaces, and all spaces adjacent to it, are Rock for 6 turns. Any friendly champion occupying target space gains <ability value=2414>Throw Boulder</ability> for 1 turn.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "terrainrock"
            }
          ]
        }
      ]
    },
    {
      "id": 1178,
      "name": "Grintmaw Magnificent",
      "description": "Rock slides tend to occur with great frequency when there are Grintmaw present.  It's as though the earth itself is theirs to command.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 83,
      "hash": "ej9Dj9CE8De9Ae9AG2Bj9Ej9Fsmwtxolrhplwipf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 2209,
          "apCost": 0,
          "name": "Mirrored",
          "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "mirrored"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        },
        {
          "id": 2562,
          "apCost": 4,
          "name": "Rock Slide",
          "shortDescription": "Area Effect 2, Range 5: Champions without <ability value=2527>Rock Defiance</ability> in the affected area take 12 Physical damage and become <condition value=grounded>Grounded</condition> for 3 turns. This damage ignores DEF. Affected spaces become Rock for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1361,
              "apCost": 0,
              "name": "Trail: Rock",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Rock for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_rock"
            },
            {
              "default": true,
              "id": 2571,
              "apCost": 0,
              "name": "Rock Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Rock for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "trail_rock"
            },
            {
              "default": false,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            }
          ]
        }
      ]
    },
    {
      "id": 1132,
      "name": "Grintmaw Rockslinger",
      "description": "\"Aim for the head, Baroth!\"\r\n\"How?! This rock is bigger than that whole Moga!\"",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8Hf1Be9Ae9AF0Aj9Aj9Bmsfeigvhytfxon",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 659,
          "apCost": 0,
          "name": "Attack: Rock",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rock"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2131,
              "apCost": 1,
              "name": "Bash",
              "shortDescription": "This champion makes a Physical melee attack against target champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "stab"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1816,
      "name": "Grintmaw Sealer",
      "description": "To the Grintmaw, containing magic is like lifting rocks. It's all managable... until one gets reckless.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 63,
      "hash": "ej9Gj9Fg3AG2BG2Ae9Aj9Dj9Eemegkluqwqfggtf",
      "artist": "Phu Thieu",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2346,
          "apCost": 0,
          "name": "Charged Barricade",
          "shortDescription": "Spend 2 charges: Summon a Barricade relic to target location within 4 spaces. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "charged_barricade"
        },
        {
          "id": 962,
          "apCost": 1,
          "name": "Reckless Blast",
          "shortDescription": "This unit makes a Magical attack at RNG 2-5 at 12 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 129,
              "apCost": 0,
              "name": "Magical Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novamagic"
            },
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2188,
              "apCost": 0,
              "name": "Recharge",
              "shortDescription": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "recharge"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1130,
      "name": "Grintmaw Shaman",
      "description": "\"He looks harmless enough.\"\r\n\"That's what you said about the Goblins.\"\r\n\"Don't remind me.\"",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 74,
      "hash": "eJ8IJ8HF0Be9Ae9AF0AJ8IJ8Jeitjnepyzmhthn",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 372,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 2345,
          "apCost": 0,
          "name": "Starshine",
          "shortDescription": "The closest friendly champion that moves within 5 spaces gains a rank of <ability value=608>Majestic</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "distract"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2527,
              "apCost": 0,
              "name": "Rock Defiance",
              "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "troll_defiance"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1131,
      "name": "Grintmaw Singer",
      "description": "Grintmaw Singers have the unique ability to create music by causing subtle vibrations in the rock naturally around them. Hyaenids derisively, and perhaps ironically, call them \"rock cacklers.\"",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Troll"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8Hf1Ae9Ae9AF0AJ8Jj9Aeiljlegrziykln",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1336,
              "apCost": 0,
              "name": "Fascinate",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1469,
              "apCost": 0,
              "name": "Nexus Aura",
              "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "nexus_aura"
            },
            {
              "default": true,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 60,
      "name": "Groble",
      "description": "A dwarven construct built from stone and rage.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 55,
      "hash": "cj9Ej9Dj9CG2Be9Aj9Cj9Dj9Eeeeeilgphgkyxii",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 259,
          "apCost": 0,
          "name": "Enrage",
          "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "enrage"
        },
        {
          "id": 37,
          "apCost": 0,
          "name": "Immunity: Fire",
          "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "immunity_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2527,
              "apCost": 0,
              "name": "Rock Defiance",
              "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "troll_defiance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            }
          ]
        }
      ]
    },
    {
      "id": 1061,
      "name": "Groble Dervish",
      "description": " \"Just wind 'em up and let 'em tear off! They dun last long but they pack a wallop.  \" - Ged Granitebrow, Groble Engineer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 67,
      "hash": "ej9Bj9AG2AE8De9Af1Bj9Bj9Cemjiljrlgetfgpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 24,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "berserker"
        },
        {
          "id": 6,
          "apCost": 0,
          "name": "Mobility",
          "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mobility"
        },
        {
          "id": 876,
          "apCost": 0,
          "name": "Short Lived",
          "shortDescription": "This unit is destroyed after 8 turns.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": -15,
          "iconName": "ondeath"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        },
        {
          "id": 1806,
          "apCost": 0,
          "name": "Whirl of Blades",
          "shortDescription": "Whenever this champion engages an opponent it makes a free attack against that opponent. This champion gets -2 DMG for 1 turn whenever it makes this attack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2531,
              "apCost": 0,
              "name": "Bounce",
              "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 189,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaelec"
            },
            {
              "default": false,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 2078,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 50% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 171,
      "name": "Groble Piledriver",
      "description": "We tried it with six arms, but the poor bugger was too heavy! - Dwarven Golem-maker",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 65,
      "hash": "dj9Cj9BG2Ae9AE8Dj9Ej9Fj9Gevsqzxzxquxmneg",
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2095,
              "apCost": 0,
              "name": "Combo Attack: Slam",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion is knocked back 2 spaces.\r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "comboatk_slam"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        }
      ]
    },
    {
      "id": 287,
      "name": "Groble Rock Eater",
      "description": "Feed him some sandstones, a schist, or a nice gniess. Maybe that'll help calm his temper. - Els, Dwarven Handler",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 71,
      "hash": "dj9Dj9CG2Be9Bg3Aj9Dj9Ej9Fsumwvsmyiymerjg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        },
        {
          "id": 868,
          "apCost": 0,
          "name": "Rock Eater",
          "shortDescription": "When this unit takes Physical damage, it instead recovers HP equal to half the damage that would have been dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_rock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 333,
      "name": "Gronk Rider",
      "description": "The Gronk are not that smart -- and they smell terrible. They have no instincts for combat and really don't live long. Why are they in use? They breed like rabbits and move nearly as fast!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 74,
      "hash": "dj9AJ8Jf1AF0Af1Bj9Aj9Bj9Ceemjnsshplwqfeg",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 990,
          "apCost": 0,
          "name": "Gronk Rider",
          "shortDescription": "When this unit is destroyed, no nora globe is dropped and a Dwarven Handler with no upgrades is spawned in the location this unit occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "rider"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1468,
              "apCost": 0,
              "name": "Cooperation",
              "shortDescription": "When this unit is within 5 spaces of a friendly champion, it gains <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "sibling"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1306,
              "apCost": 0,
              "name": "Mountaineer",
              "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "climb"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": true,
              "id": 2576,
              "apCost": 1,
              "name": "Throw Javelin",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "spear"
            }
          ]
        }
      ]
    },
    {
      "id": 61,
      "name": "Grundelwulf",
      "description": "I could have sworn I cut his arm off. - Tyra, K'thir Blademaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 69,
      "hash": "cj9Hj9Gj9Fe9Af1Aj9Fj9Gj9Hkplgvzxojwfvonj",
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1062,
      "name": "Grundelwulf Alpha",
      "description": "Rarely seen. Rarely remembered. They are obsidian shadows, reminding others when they have dug too deep.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 75,
      "hash": "ej9Bj9AG2BE8De9Af1Bj9Cj9Dfrfmlpnsfmjykpf",
      "artist": "Bartek Gawel",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1199,
          "apCost": 0,
          "name": "Calcify",
          "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novaphysical"
        },
        {
          "id": 2986,
          "apCost": 0,
          "name": "Fearsome Hunter",
          "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "fear"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            }
          ]
        }
      ]
    },
    {
      "id": 1686,
      "name": "Guardian of Eretat",
      "description": "The Guardians of Eretat will defend their caves with vigor and tenacity, but they would honestly rather be admiring their hoards.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 76,
      "hash": "ej9Ej9DE8DF0BG2Ag3Aj9Ej9Fepuxinsmphkjlrf",
      "artist": "Markus Erdt",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1967,
          "apCost": 0,
          "name": "Relic Guardian",
          "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 3177,
          "apCost": 3,
          "name": "Summon: Guardian's Treasure",
          "shortDescription": "Summon a Guardian's Treasure relic (0 DEF, 20 HP, <ability value=3179>Guardian's Treasure</ability>, <ability value=1336>Fascinate</ability>, <ability value=608>Majestic 1</ability>) to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": false,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 1207,
      "name": "Guardian of the Circle",
      "description": "Amerath was a Fae Enchantress of great reknown who developed scores of artifacts, the most controversial of which were the Chains of Amareth, which is said to have consumed Amareth herself after prolonged use.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Elf"
      ],
      "noraCost": 73,
      "hash": "ej9Ej9Df1Be9Ae9Ag3Aj9Aj9Bwiekpnlroukyrqf",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2819,
          "apCost": 0,
          "name": "Catalyst: Frost",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "catalyst_frost"
        },
        {
          "id": 390,
          "apCost": 1,
          "name": "Frost Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "dmgshld_frost"
        },
        {
          "id": 60,
          "apCost": 0,
          "name": "Resistance: Frost",
          "shortDescription": "When this unit takes Frost damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "resistance_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2454,
              "apCost": 0,
              "name": "Frost Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=137>Frost Aura 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped"
            },
            {
              "default": true,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 3230,
              "apCost": 3,
              "name": "Freezing Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "grip_icelord"
            }
          ]
        }
      ]
    },
    {
      "id": 1747,
      "name": "Guardian of the Wreath",
      "description": "The Wreath Guardian defends the Tundra with her temporal powers, bending time and space to her will.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "eJ8IJ8HG2Af1BG2AF0Aj9Bj9Cemwvszvfvmhvsqf",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2318,
          "apCost": 0,
          "name": "Deploy Charged",
          "shortDescription": "When a champion is deployed from the runedock, this unit gains 2 charges.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 2340,
          "apCost": 3,
          "name": "Haste",
          "shortDescription": "Target champion within 5 spaces has +4 SPD for 3 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 2342,
          "apCost": 0,
          "name": "Spell Shift",
          "shortDescription": "Spend 8 charges.  All cooldowns on your spells are reduced by 5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 8,
          "iconName": "special"
        },
        {
          "id": 2341,
          "apCost": 3,
          "name": "Stall",
          "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "debuff"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 288,
      "name": "Half Skeezick",
      "description": "Although we have not been able to reverse the transformation completely, our lost brothers may yet return to our side.  - Brodu, Priest of Valdec",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf",
        "Skeezick"
      ],
      "noraCost": 76,
      "hash": "dj9Ej9Dg3Ae9BE8Dj9Ej9Fj9Geeemnyxoqsonnhg",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 853,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "allybuffs"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 971,
              "apCost": 0,
              "name": "Surge: Dwarf",
              "shortDescription": "This unit has +1 DMG for each friendly Dwarf.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dwarf"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 1483,
      "name": "Hammerfall Lonx",
      "description": "Forged by a sect of Jakei artisans, the Lonx’s hammers are not only instruments of death, but also a symbol of the determination of those who live in the Tundra to protect their home.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 82,
      "hash": "eJ8IJ8HG2BF0Be9AF0Aj9Cj9Demsuziwvfklegpf",
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 3008,
          "apCost": 1,
          "name": "Frost Mallet",
          "shortDescription": "This champion makes a Frost attack at RNG 2-5.  If the attack is successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 2 turns.  When this ability is not on CD, this champion's successful basic attacks cause <mechanic value=slowed>Slowed</mechanic> for 2 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "ice"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            },
            {
              "default": true,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            }
          ]
        }
      ]
    },
    {
      "id": 1146,
      "name": "Hanging Slag",
      "description": "\"As we study these lovely creatures, it is clear they care not for the past or the future, life or death, friend or enemy.  Their destiny is pure chaos.\" - Norben, the third prophet of madness ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 58,
      "hash": "ej9AJ8JE8De9Ae9Af1Aj9Ej9Fgytzrftxolwoso",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1047,
          "apCost": 0,
          "name": "Acid Eater",
          "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_acid"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 1259,
          "apCost": 0,
          "name": "Split",
          "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "duplicate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 201,
              "apCost": 0,
              "name": "Death Nova: Acid",
              "shortDescription": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaacid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 152,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 153,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaacid"
            }
          ]
        }
      ]
    },
    {
      "id": 955,
      "name": "Haunting Spirit",
      "description": "DOOoOooOoOoOoM!- Haunting Spirit of DOOM",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 0,
      "hitPoints": 26,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 46,
      "hash": "dJ8IJ8HF0Ae9AG2Bj9Cj9Dj9Eeevkgnnlpyievzg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2067,
          "apCost": 0,
          "name": "Frightful Aura",
          "shortDescription": "All opposing champions within 3 spaces have -2 DMG. All friendly undead champions within 3 spaces have +2 DEF.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "fear"
        },
        {
          "id": 599,
          "apCost": 0,
          "name": "Ghost",
          "shortDescription": "This champion is <condition value=incorporeal>Incorporeal</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "ghost"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 149,
          "apCost": 0,
          "name": "Sonic Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novasonic"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3367,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 1 HP for each AP they have.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3137,
              "apCost": 2,
              "name": "Dread Field",
              "shortDescription": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "dread_field"
            },
            {
              "default": true,
              "id": 1807,
              "apCost": 0,
              "name": "Deafening Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "deafening_aura"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1712,
      "name": "Heart of the Forest",
      "description": "\"After the burning, the forest surged in growth, bringing with it a renewed diversity of life. In this, at least, De'lim was right.\" ~ Anonymous",
      "maxRng": 3,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 10,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 81,
      "hash": "ej9Cj9Bf1Bf1AG2AG2Aj9Aj9Bmeiememextmnjrf",
      "artist": "Maciej Janaszek",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 2271,
          "apCost": 0,
          "name": "Sentinel",
          "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        },
        {
          "id": 3217,
          "apCost": 4,
          "name": "Verdant Force",
          "shortDescription": "Friendly champions (including self) gains <ability value=479>Brushwalker</ability> and <ability value=106>Camouflage</ability> for 3 turns, and spaces within 2 tiles of all friendly champions (including self) become Jungle for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "domain_vegetation"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 3356,
              "apCost": 0,
              "name": "Pacifying Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is Pacified for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "charm"
            }
          ]
        }
      ]
    },
    {
      "id": 1232,
      "name": "Hekatian Arbiter",
      "description": "The Hekatian Order is a sect of the Bok that focuses on arcane arts.  For the Arbiters, it means a merger with their blades so fundamental that one's destruction necessarily leads the other to the same fate.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight",
        "Wizard"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 80,
      "hash": "eJ8HJ8Ge9Ae9Be9Ae9Bj9Fj9Geigtzillnuhymn",
      "artist": "Anthony Lopes",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3266,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "combat_awareness"
        },
        {
          "id": 1445,
          "apCost": 0,
          "name": "Counter Attack: Ranged",
          "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "reflexes"
        },
        {
          "id": 356,
          "apCost": 1,
          "name": "Defensive Stance",
          "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "buff"
        },
        {
          "id": 3380,
          "apCost": 0,
          "name": "Sanguine Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3294,
              "apCost": 0,
              "name": "Warlord",
              "shortDescription": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "warlord"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 2580,
              "apCost": 4,
              "name": "Impaling Strike",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and become <condition value=bloodied>Bloodied</condition> for 4 turns. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "stab"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1241,
      "name": "Hekatian Bloodguard",
      "description": "\"The support of the Hekatian Order does not come free, Grimlic.  Blood is our price.\" - Sorsha, Hekatian Bloodguard",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Wizard"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 84,
      "hash": "eJ8JJ8Ie9Be9Be9AF0BJ8GJ8Hiwiwipyojykygn",
      "artist": "Michele Chang",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2629,
          "apCost": 0,
          "name": "Blood Dispersal",
          "shortDescription": "When this champion successfully damages a <condition value=bloodied>Bloodied</condition> champion with a basic attack, friendly champions within 6 spaces of it are healed for the same amount, divided evenly among damaged champions, to a minimum of 1 and a maximum 6.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "blood_debt"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 2630,
          "apCost": 0,
          "name": "Pet: Bloody Imp",
          "shortDescription": "When this champion is deployed, a Bloody Imp with no upgrades is summoned adjacent to it.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "pet"
        },
        {
          "id": 3380,
          "apCost": 0,
          "name": "Sanguine Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2568,
          "apCost": 0,
          "name": "Vigilance",
          "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "vigilance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2551,
              "apCost": 2,
              "name": "Bloodseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=bloodied>Bloodied</condition> or less than 50% HP and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2706,
              "apCost": 1,
              "name": "Blood Knowledge",
              "shortDescription": "For each opposing champion within 4 spaces with <condition value=bloodied>Bloodied</condition>, your opponent loses 2 nora and this champion gains 1 AP and +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "nora_hex"
            }
          ]
        }
      ]
    },
    {
      "id": 1446,
      "name": "Hekatian Voidraker",
      "description": "Even the other demons of the Hekatian Order tended to avoid the Voidrakers, whose appetite for nothingness exceeded even their thirst for blood.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 88,
      "hash": "eJ8HJ8Ge9AF0Be9Ae9Bj9Fj9Geeitjwoytouqqo",
      "artist": "Mazert Young",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 3003,
          "apCost": 0,
          "name": "Dispelling Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "dispelling_blows"
        },
        {
          "id": 3380,
          "apCost": 0,
          "name": "Sanguine Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2649,
          "apCost": 0,
          "name": "Void Shield",
          "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tetra_shield"
        },
        {
          "id": 2901,
          "apCost": 0,
          "name": "Void Touch",
          "shortDescription": "When this champion successfully hits a champion with a basic attack, the attacked champion loses an ability with the highest nora cost (this does not remove basic attacks).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "touch_void"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 29,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 2629,
              "apCost": 0,
              "name": "Blood Dispersal",
              "shortDescription": "When this champion successfully damages a <condition value=bloodied>Bloodied</condition> champion with a basic attack, friendly champions within 6 spaces of it are healed for the same amount, divided evenly among damaged champions, to a minimum of 1 and a maximum 6.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 518,
      "name": "Hell Tick",
      "description": "The Hell Tick will latch on to its host and feed on its blood. It takes pleasure in inflicting pain.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 63,
      "hash": "dj9Cj9BG2Ae9Bf1Bj9Aj9Bj9Cevxtzoqlukemsfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1404,
          "apCost": 0,
          "name": "Fire Feed",
          "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "eater_fire"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": true,
              "id": 249,
              "apCost": 0,
              "name": "Damage Shield: Acid",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Acid damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 173,
              "apCost": 0,
              "name": "Death Nova: Physical",
              "shortDescription": "When this unit is destroyed, it deals 11 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "deathnovaphysical"
            },
            {
              "default": false,
              "id": 750,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 6 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "novaspike"
            },
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            }
          ]
        }
      ]
    },
    {
      "id": 1588,
      "name": "Heretic Overlord",
      "description": "Once you are under the gaze of the Heretic Overlord, there is no escape.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Knight"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 83,
      "hash": "ej9Ej9Dg3Ae9BG2Ag3Aj9Dj9Eeeemwosfthirftf",
      "artist": "Rogier van de Beek",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3084,
          "apCost": 0,
          "name": "Equip: Heretic Shackle",
          "shortDescription": "When this champion comes into play, the closest enemy champion is equipped with a Heretic Shackle.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2972,
              "apCost": 0,
              "name": "Surge: Demon Elf",
              "shortDescription": "This unit has +1 DMG for every friendly champion with the races Demon and Elf.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_demonelf"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 106,
      "name": "High Mason",
      "description": "What does it say when their craftsmen are more dangerous than their soldiers? -- Varia, Draksar Broodqueen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 62,
      "hash": "dJ8HJ8Ge9Be9AE8Dj9Ej9Fj9Gevxftztxoygirwf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3119,
          "apCost": 0,
          "name": "Provision: Offense",
          "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "plunder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 832,
              "apCost": 0,
              "name": "Forge Hammer",
              "shortDescription": "When this champion makes a successful basic attack, the next Construct, relic or equipment deployed from the runedock costs 2 less nora.  This effect stacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "forge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3393,
              "apCost": 0,
              "name": "Ironfist Armaments",
              "shortDescription": "When a friendly champion with Race: Angel, Race: Barbarian, Race: Dwarf, or Race: Construct becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 2473,
              "apCost": 1,
              "name": "Carouse",
              "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "carouse"
            }
          ]
        }
      ]
    },
    {
      "id": 1014,
      "name": "High Warlock",
      "description": "\"Courage you say?! Courage is a feeble thing, it ebbs and wanes just as a tide. Power however...true power is eternal and unyielding.\" - High Warlock Nevenacer\r\n",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead",
        "Zombie"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AE8De9Ae9BJ8HJ8Ierhrqfrwtxiyvm",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1392,
          "apCost": 2,
          "name": "Book Burn",
          "shortDescription": "No spells may be cast for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "bookburn"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 2438,
          "apCost": 3,
          "name": "Ravish",
          "shortDescription": "Target real champion you own is destroyed. Closest friendly champion to the target champion gains 35% of the destroyed champion's current HP and DMG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "overkill"
        },
        {
          "id": 89,
          "apCost": 0,
          "name": "Vulnerability: Frost",
          "shortDescription": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3285,
              "apCost": 0,
              "name": "Sabotage: Lethargy",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DMG and <ability value=2012>Lethargic</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "sabotage_lethargy"
            },
            {
              "default": true,
              "id": 772,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1787,
              "apCost": 3,
              "name": "Rite of Power",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed and friendly champions gain +1 DMG permanently and gain +1 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "final_judgement"
            }
          ]
        }
      ]
    },
    {
      "id": 222,
      "name": "Hippo Rider",
      "description": "She'll try to buck you off, but just hold on tight - she's tame.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Beast",
        "Boghopper"
      ],
      "noraCost": 72,
      "hash": "dJ8IJ8HF0Ae9BF0AJ8HJ8IJ8Jjgrouhkpquoszvf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1752,
          "apCost": 0,
          "name": "Heavy Charger",
          "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": true,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1252,
              "apCost": 0,
              "name": "Readiness",
              "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 715,
      "name": "Hippo Rider",
      "description": "She'll try to buck you off, but just hold on tight - she's tame.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Knight"
      ],
      "races": [
        "Beast",
        "Boghopper"
      ],
      "noraCost": 72,
      "hash": "dj9Bj9Af1Bf1Be9Aj9Fj9Gj9Hqwvsoljirjemphg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1752,
          "apCost": 0,
          "name": "Heavy Charger",
          "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": true,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1252,
              "apCost": 0,
              "name": "Readiness",
              "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1114,
      "name": "Hoarfrost Dragon",
      "description": "\"So that's what the Hoarfrost were up to. You know, they're rather bright for being...dead.\" - Zimm, Jakei Elder\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dragon",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 75,
      "hash": "ej9Gj9Fg3Ae9Ae9Ae9Aj9Dj9Eemetosjymszkrqf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Forsaken Wastes",
        "Savage Tundra"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1863,
          "apCost": 3,
          "name": "Freeze",
          "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "crystallize"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1385,
              "apCost": 0,
              "name": "Freezing Aura",
              "shortDescription": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novafrost"
            },
            {
              "default": true,
              "id": 603,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2606,
              "apCost": 4,
              "name": "Arctic Bolt",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "iceaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            },
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2819,
              "apCost": 0,
              "name": "Catalyst: Frost",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 1056,
      "name": "Hoarfrost Lich",
      "description": "\"They're usually so far north we never see them. Why are they here now? Serkan's up to something.\" - J'bri, Snowcharger Cavalry",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 71,
      "hash": "ej9Bj9Ae9BE8De9Af1BJ8GJ8Hqsxmsfmnsmhnjn",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 774,
          "apCost": 0,
          "name": "Chill",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_chill"
        },
        {
          "id": 1206,
          "apCost": 0,
          "name": "Cripple",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "debuff"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1131,
              "apCost": 0,
              "name": "Ally: Savage Tundra",
              "shortDescription": "While there are other friendly Savage Tundra champions in play, this champion gets +7 HP and +2 DMG. Savage Tundra champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_st"
            },
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            },
            {
              "default": false,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 1117,
              "apCost": 0,
              "name": "Frostburn",
              "shortDescription": "When a friendly champion takes frost damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=chilled>Chilled</condition>, the Chilled condition is removed as well. This effect does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 1289,
      "name": "Homicidal Thug",
      "description": "She is whacked right out of her skull, Vindrax. She ain't never comin' back! ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Draksar",
        "Mutant"
      ],
      "noraCost": 74,
      "hash": "ej9Dj9Cg3Ae9Be9AG2Bj9Dj9Eerllekwxmlljgrf",
      "artist": "Christian Fell",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2167,
          "apCost": 0,
          "name": "Attack Charged",
          "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        },
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2693,
          "apCost": 0,
          "name": "Mutation: Violence",
          "shortDescription": "Spend 4 charges: This champion gains <ability value=261>Enrage 2</ability>. If it already has Enrage 3, it gains <ability value=2837>Psychotic Break</ability> instead and this ability is removed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2644,
              "apCost": 2,
              "name": "Phantom Dash",
              "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": true,
              "id": 3016,
              "apCost": 0,
              "name": "Life Siphon: Scoured",
              "shortDescription": "When this champion successfully damages a champion with <condition value=scoured>Scoured</condition> with a basic attack, it vampiric heals HP equal to half the damage dealt (rounded down).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "siphon_scoured"
            }
          ]
        }
      ]
    },
    {
      "id": 456,
      "name": "Hook Fiend ",
      "description": "Don't scream! It enjoys the screams. - One captive elf to another.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 75,
      "hash": "dj9Fj9EE8Df1Ag3Aj9Dj9Ej9Fqolyvsoqukrjyig",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 125,
          "apCost": 0,
          "name": "Damage Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novaphysical"
        },
        {
          "id": 2660,
          "apCost": 3,
          "name": "Grappling Hook",
          "shortDescription": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "pull"
        },
        {
          "id": 300,
          "apCost": 0,
          "name": "Horrific Aura",
          "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "fear"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            }
          ]
        }
      ]
    },
    {
      "id": 4,
      "name": "Houndmaster",
      "description": "Their hounds could find a goblin in a trash heap. - Akin, Keeper of the Mines",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 70,
      "hash": "cj9Cj9Bj9Af1Be9Bj9Aj9Bj9Cemnhkpfevhipjyi",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 436,
          "apCost": 4,
          "name": "Summon: Beast",
          "shortDescription": "A Beast champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 10 DMG, 15 HP, Attack - Physical, Detection 3).",
          "activationType": 1,
          "level": 3,
          "cooldown": 4,
          "noraCost": 7,
          "iconName": "sumbeast"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": false,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1514,
              "apCost": 0,
              "name": "Train: Assault",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=1320>Assault</ability>.  This ability costs 6 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        }
      ]
    },
    {
      "id": 907,
      "name": "Hraken the Bloodbow",
      "description": "\"Day 9. So expertly killed, this Kanen Cultist. A crossbow bolt perfectly placed between the eyes, a masterful shot. This is Hraken's work, it has to be. The Bloodbow has returned.\" - Vahkosh, Headhunter",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger",
        "Rogue"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 88,
      "hash": "dJ8IJ8HF0Ag3Ae9Aj9Fj9Gj9Hepsmuqjrlpfkwfg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1441,
          "apCost": 0,
          "name": "Confuse Enemy",
          "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "confuse"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2097,
              "apCost": 0,
              "name": "Combo Attack: Rend",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1833,
      "name": "Hyaenid Ascendant",
      "description": "The Djinn proved to be false gods. When the Hyaenid recognize this, will the Djinn pay for their deception?",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 12,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 80,
      "hash": "eJ8IJ8Hf1BG2BG2AF0Aj9Aj9Bmsonyiemjeitsqf",
      "artist": "Markus Erdt",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1425,
          "apCost": 0,
          "name": "Attack: Sand",
          "shortDescription": "This unit makes an Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "sand"
        },
        {
          "id": 1206,
          "apCost": 0,
          "name": "Cripple",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "debuff"
        },
        {
          "id": 1212,
          "apCost": 0,
          "name": "Dissipate",
          "shortDescription": "Ranged attacks made by this champion have a penalty of -2 DMG for each space the target is beyond the champion's minimum range (to a maximum of -4 DMG).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "arrow"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 3402,
          "apCost": 0,
          "name": "Scavenger Idolatry",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3349,
              "apCost": 0,
              "name": "Peaks Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 3285,
              "apCost": 0,
              "name": "Sabotage: Lethargy",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DMG and <ability value=2012>Lethargic</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "sabotage_lethargy"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3286,
              "apCost": 0,
              "name": "Sabotage: Defile",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play becomes <condition value=diseased>Diseased 3</condition>, <condition value=defiled>Defiled</condition> and <condition value=inhibited>Inhibited</condition> for 8 rounds.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_defile"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 1395,
      "name": "Hyaenid Breaker",
      "description": "No one was too shocked to discover that the Breakers had few close friends.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 69,
      "hash": "ej9Dj9CG2BF0Ae9AG2Bj9Cj9Dgnykegyiggkjerf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3090,
          "apCost": 0,
          "name": "Catalyst: Electricity",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Electricity damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "breaker_electricity"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3409,
              "apCost": 0,
              "name": "Serf to Djinn: Marid",
              "shortDescription": "While a friendly Peaks Marid is in play, it gains <ability value=1909>Storm Acolyte</ability> and <ability value=2539>Lightning Blast</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2655,
              "apCost": 4,
              "name": "Overload",
              "shortDescription": "Relics within 10 spaces take 10 Electricity damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 3401,
              "apCost": 0,
              "name": "Scavenger Instinct",
              "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dogpile"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1220,
      "name": "Hyaenid Bulwark",
      "description": "\"I know not from where the Djinn come, only that they sought us out a few moons past, and that we should ask no questions of them.\" ~ Hyaenid Bulwark during an interrogation by the Queen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9Eg3Ae9Be9AE8Dj9Dj9Eevxoqlrhtxtjpqf",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 3408,
              "apCost": 0,
              "name": "Serf to Djinn: Ifrit",
              "shortDescription": "While a friendly Peaks Ifrit is in play, this champion gains <ability value=732>Fury</ability> and <ability value=380>Flame Nova 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            }
          ]
        }
      ]
    },
    {
      "id": 1591,
      "name": "Hyaenid Dreamcrusher",
      "description": "The deadliest of contradictions is to have such a strong belief in disbelief as to break the illusions of another. Beware such a foe. - Arista, Elven Illusionist, to her apprentice",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9Ef1BF0AG2AE8Dj9Aj9Buqsxftfgerjlrqf",
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3086,
          "apCost": 0,
          "name": "Disbelief",
          "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        },
        {
          "id": 1452,
          "apCost": 3,
          "name": "Dispel",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "dispel"
        },
        {
          "id": 3402,
          "apCost": 0,
          "name": "Scavenger Idolatry",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3409,
              "apCost": 0,
              "name": "Serf to Djinn: Marid",
              "shortDescription": "While a friendly Peaks Marid is in play, it gains <ability value=1909>Storm Acolyte</ability> and <ability value=2539>Lightning Blast</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 2244,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2247,
              "apCost": 0,
              "name": "Static Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=shocked>Shocked</condition> for 2 turns\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_static"
            },
            {
              "default": true,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1443,
      "name": "Hyaenid Executioner",
      "description": "\"Joy-Killers\" was the nickname that the other hyaenid had for their more solitary brethren, but they rarely used it to their face.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 84,
      "hash": "ej9Gj9FG2BF0Be9Ae9Aj9Cj9Dexofpythepwouqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2893,
          "apCost": 1,
          "name": "Death Sentence",
          "shortDescription": "This champion makes an attack against an opposing champion at 50% damage. If the attack is successful, that champion is <mechanic value=cleansed>Cleansed</mechanic> and it loses 5 HP for each condition removed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "final_judgement"
        },
        {
          "id": 684,
          "apCost": 1,
          "name": "Execute",
          "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "execute"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 163,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rend"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 3349,
              "apCost": 0,
              "name": "Peaks Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 3406,
              "apCost": 0,
              "name": "Serf to Djinn: Dao",
              "shortDescription": "While a friendly Peaks Dao is in play, this champion gains <ability value=343>Power Attack 2</ability> and <ability value=3266>Combat Awareness 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            }
          ]
        }
      ]
    },
    {
      "id": 1103,
      "name": "Hyaenid Feshwrangler",
      "description": "Initially, Hyaenids had competitions to see how long they could sit on a Goliath Fesh before being thrown off and possibly eaten. After numerous injuries and fatalities the 'Feshwranglers' adopted these giant worms as their battle mounts.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Beast",
        "Hyaenid",
        "Worm"
      ],
      "noraCost": 70,
      "hash": "ej9Fj9EG2Be9Ae9AE8Dj9Cj9Drolwvsjyrfpljpf",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2708,
          "apCost": 1,
          "name": "Gluttony",
          "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "devour"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": true,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            },
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 3408,
              "apCost": 0,
              "name": "Serf to Djinn: Ifrit",
              "shortDescription": "While a friendly Peaks Ifrit is in play, this champion gains <ability value=732>Fury</ability> and <ability value=380>Flame Nova 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            }
          ]
        }
      ]
    },
    {
      "id": 1594,
      "name": "Hyaenid Flamefist",
      "description": "\"Call upon your inner fire, and claim this land for your own.\" ~ Peaks Ifrit",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9Eg3AF0AG2AE8Dj9Dj9Eeiplnshgnsxtjrf",
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3088,
          "apCost": 1,
          "name": "Flameburst",
          "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "fireaoe"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 410,
          "apCost": 1,
          "name": "Stun",
          "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "stun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 3408,
              "apCost": 0,
              "name": "Serf to Djinn: Ifrit",
              "shortDescription": "While a friendly Peaks Ifrit is in play, this champion gains <ability value=732>Fury</ability> and <ability value=380>Flame Nova 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            },
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1104,
      "name": "Hyaenid Headshrinker",
      "description": "\"I don't understand their chattering and cackling, but their rituals and superstitions are proving useful.\" - The Exile\r\n",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9Eg3Ae9Ae9AE8Dj9Dj9Eeiyrwmegyrjinpf",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        },
        {
          "id": 3402,
          "apCost": 0,
          "name": "Scavenger Idolatry",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 2504,
          "apCost": 3,
          "name": "Shrink",
          "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "shrink"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2239,
              "apCost": 0,
              "name": "Corruption",
              "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 3409,
              "apCost": 0,
              "name": "Serf to Djinn: Marid",
              "shortDescription": "While a friendly Peaks Marid is in play, it gains <ability value=1909>Storm Acolyte</ability> and <ability value=2539>Lightning Blast</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1645,
      "name": "Hyaenid Houngan",
      "description": "The Hyaenid made perfect subjects for the Djinn: superstitious, single-minded, and hungry. But even so, there were some who resisted.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest",
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8Hf1BF0BG2AF0Aj9Aj9Bevkgvheevouxkpf",
      "artist": "Amber Jones",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1966,
          "apCost": 0,
          "name": "Rotting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "disease"
        },
        {
          "id": 3402,
          "apCost": 0,
          "name": "Scavenger Idolatry",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 3138,
          "apCost": 0,
          "name": "Twisted Essence",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "twisted_essence"
        },
        {
          "id": 1273,
          "apCost": 0,
          "name": "Untamed",
          "shortDescription": "This champion may not become <condition value=pacified>Pacified</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3360,
              "apCost": 0,
              "name": "Spellsurge: Elemental Vortex",
              "shortDescription": "When this champion is deployed, Elemental Vortex spells are revealed from your runedock. Elemental Vortex spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Elemental Vortex spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2634,
              "apCost": 0,
              "name": "Brain Eater",
              "shortDescription": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_disease"
            },
            {
              "default": true,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1618,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "terrain_dmz"
            }
          ]
        }
      ]
    },
    {
      "id": 868,
      "name": "Hyaenid Instigator",
      "description": "The Hyaenid learned much from the Exile. They learned to hunt in groups, acting together to take down larger prey. Soon after, the Hyaenid would thrive on larger game.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3AG2Bf1AJ8Jj9Aj9Bthekexqllwtuhig",
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 3313,
          "apCost": 0,
          "name": "Swarm: Hyaenid Instigator",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Hyaenid Instigator with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            }
          ]
        }
      ]
    },
    {
      "id": 1105,
      "name": "Hyaenid Mundunugu",
      "description": "It's well known that Hyaenids aren't very fond of water. You'll smell a Mundunugu long before you see one.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FE8De9Ae9Ae9Aj9Ej9Fiwmeitusmjtqwo",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 746,
          "apCost": 0,
          "name": "Dead Eater",
          "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "nora_eater"
        },
        {
          "id": 2339,
          "apCost": 4,
          "name": "Imbue: Stun",
          "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 9,
          "iconName": "amped"
        },
        {
          "id": 2117,
          "apCost": 5,
          "name": "Metamorphosis",
          "shortDescription": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2227,
              "apCost": 0,
              "name": "Choking Stench",
              "shortDescription": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "choking_stench"
            },
            {
              "default": false,
              "id": 1844,
              "apCost": 0,
              "name": "Wicked Aura",
              "shortDescription": "Whenever an enemy champion within 4 spaces would gain AP, they get 1 less than normal.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "auranegative"
            },
            {
              "default": true,
              "id": 3367,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 1 HP for each AP they have.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "punishing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            }
          ]
        }
      ]
    },
    {
      "id": 1106,
      "name": "Hyaenid Pack Leader",
      "description": "\"See dat big 'nid wit da sparkly war club? 'Afore a big throwdown dose clubs is charged up by da Mundunugu's wit some mumbo-jumbo. Puts da power of lightnin' in 'em.\" - Phinnred, IEF",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9Fe9Ae9Ae9Ae9Aj9Fj9Gwzzzgpsoqjlnepf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1723,
          "apCost": 3,
          "name": "Declare Target",
          "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "declare_hunted"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 1363,
          "apCost": 0,
          "name": "Unleash",
          "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "unleashed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3406,
              "apCost": 0,
              "name": "Serf to Djinn: Dao",
              "shortDescription": "While a friendly Peaks Dao is in play, this champion gains <ability value=343>Power Attack 2</ability> and <ability value=3266>Combat Awareness 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 329,
      "name": "Hyaenid Spearman",
      "description": "Hyaenid are usually seen after large battles, making use of the dead for food and Nora. With the ongoing battles in the Shattered Peaks, they have begun to grow in number and strength.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 65,
      "hash": "dj9AJ8Jf1AF0Ae9Aj9Fj9Gj9Hpuzxmjyzmhvkpfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 1206,
          "apCost": 0,
          "name": "Cripple",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "debuff"
        },
        {
          "id": 163,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rend"
        },
        {
          "id": 3402,
          "apCost": 0,
          "name": "Scavenger Idolatry",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            },
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 3407,
              "apCost": 0,
              "name": "Serf to Djinn: Dew",
              "shortDescription": "While a friendly Peaks Dew is in play, this champion gains <ability value=1075>Heal Self 2</ability> and <ability value=1952>Slam</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 1918,
              "apCost": 0,
              "name": "Revere: The Exile",
              "shortDescription": "While this champion is in play, The Exile costs 10% less nora to deploy. While The Exile is in play, this champion has the Deep Wounds Ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            }
          ]
        }
      ]
    },
    {
      "id": 1219,
      "name": "Hyaenid Spiritspeaker",
      "description": "Despite their appearance, the Spiritspeakers are strangely calm, roused only by the presence of the Djinn and serving as a conduit for magical energies.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 77,
      "hash": "ej9Fj9EG2Be9Be9AE8Dj9Cj9Dumjpnwolluqllpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2666,
          "apCost": 0,
          "name": "Guiding Spirit",
          "shortDescription": "When this unit is destroyed, you gain 5% of its nora cost for each real friendly champion that shares a race with it, to a maximum of 20%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "guiding_spirit"
        },
        {
          "id": 1072,
          "apCost": 1,
          "name": "Magical Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "magicaoe"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            },
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": true,
              "id": 3407,
              "apCost": 0,
              "name": "Serf to Djinn: Dew",
              "shortDescription": "While a friendly Peaks Dew is in play, this champion gains <ability value=1075>Heal Self 2</ability> and <ability value=1952>Slam</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            }
          ]
        }
      ]
    },
    {
      "id": 1238,
      "name": "Hyaenid Stalker",
      "description": "He was always a careful hunter. But life among the dangers of the Peaks has a way of turning mere hunters into efficient and ruthless butchers.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 80,
      "hash": "eJ8IJ8Hg3Ae9Be9AF0Aj9Dj9Eerhiygnuzxmygpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 746,
          "apCost": 0,
          "name": "Dead Eater",
          "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "nora_eater"
        },
        {
          "id": 3401,
          "apCost": 0,
          "name": "Scavenger Instinct",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=966>Cackle</ability>. If you have 6 champions with Race: Hyaenid or Race: Djinn in play, the range of Cackle is increased by 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3406,
              "apCost": 0,
              "name": "Serf to Djinn: Dao",
              "shortDescription": "While a friendly Peaks Dao is in play, this champion gains <ability value=343>Power Attack 2</ability> and <ability value=3266>Combat Awareness 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 2584,
              "apCost": 0,
              "name": "Surge: Hyaenid",
              "shortDescription": "This unit has +1 DMG for each friendly Hyaenid.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_hyaenid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 2463,
              "apCost": 0,
              "name": "Quest: Kill Enemy",
              "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 1707,
      "name": "Hyaenid Stormreader",
      "description": "The Hyaenid connection to lightning is spiritual, built upon their instincts and mystic connection to the Djinn.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 67,
      "hash": "ej9Bj9Ae9Bf1AG2Af1BJ8GJ8Hklegnuxkgnnwipf",
      "artist": "Caio Monteiro",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2343,
          "apCost": 3,
          "name": "Paralyze",
          "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "sentry"
        },
        {
          "id": 3210,
          "apCost": 0,
          "name": "Stormreader",
          "shortDescription": "The first time each turn an enemy champion within 5 spaces takes Electricity damage, this champion deals 6 Electricity damage to that champion (ignores DEF). The same champion cannot be damaged by multiple copies of this ability in the same turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 30,
          "iconName": "stormreader"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 189,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaelec"
            },
            {
              "default": false,
              "id": 237,
              "apCost": 0,
              "name": "Damage Shield: Electricity",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Electricity damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_lightning"
            },
            {
              "default": true,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 695,
      "name": "Hyaenid Witchdoctor",
      "description": "Without an ordered language, the Hyaenids use raucous howls to evoke magical power.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard",
        "Witch"
      ],
      "races": [
        "Hyaenid"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0BG2Af1AJ8Jj9Aj9Bygygymushnumyzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1255,
          "apCost": 0,
          "name": "Inhibiting Touch",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "inhibit"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        },
        {
          "id": 3402,
          "apCost": 0,
          "name": "Scavenger Idolatry",
          "shortDescription": "This champion has <ability value=2502>Dogpile</ability>. If you have 4 or more champions with Race: Hyaenid or Race: Djinn in play, this champion gains <ability value=2652>Opportunistic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dogpile"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1918,
              "apCost": 0,
              "name": "Revere: The Exile",
              "shortDescription": "While this champion is in play, The Exile costs 10% less nora to deploy. While The Exile is in play, this champion has the Deep Wounds Ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2479,
              "apCost": 0,
              "name": "Improve Speed",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_speed"
            },
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2478,
              "apCost": 0,
              "name": "Improve Range",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_range"
            }
          ]
        }
      ]
    },
    {
      "id": 685,
      "name": "Hydraxor",
      "description": "Lemsu spoke of another defender, who slumbered within the deepest depths of the marsh; a wrathful serpent, an ancient protector of Forglar.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 91,
      "hash": "dJ8IJ8HF0AG2Af1AJ8Jj9Aj9Bpwthilevzkyrqzg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 1892,
          "apCost": 0,
          "name": "Quest: Damage",
          "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "opportunistic"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 2741,
          "apCost": 0,
          "name": "Spontaneous Regeneration",
          "shortDescription": "For every 20 damage this champion takes in a single turn, it is healed for 9 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "regen"
        },
        {
          "id": 2132,
          "apCost": 0,
          "name": "Water Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainwater"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 2679,
              "apCost": 4,
              "name": "Water Vortex",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1856,
              "apCost": 1,
              "name": "Thrash",
              "shortDescription": "This champion loses HP equal to 50% of its current damage.  All enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 8,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            }
          ]
        }
      ]
    },
    {
      "id": 1001,
      "name": "Hypnofrog",
      "description": "Side effects of Hypnofrog poison are as follows: hallucinations, poetry, thoughtful discussions, staring, drooling, ideas that sound awesome at the time, nausea, indigestion.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "ej9Gj9Ff1BE8De9Ae9Aj9Aj9Bekuhplgtqhgrzo",
      "artist": "Bartek Gawel",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 2309,
          "apCost": 0,
          "name": "Hallucinogenic",
          "shortDescription": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hallucinogenic"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 897,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "mind_control"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            },
            {
              "default": true,
              "id": 427,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1346,
              "apCost": 3,
              "name": "Poison Charge",
              "shortDescription": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_poison"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1022,
      "name": "Ice Caster",
      "description": "\"A few more touches, here, there....and done!\" - Mi'tiko, Ice Caster",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 69,
      "hash": "eJ8IJ8HE8DE8De9AF0Aj9Ej9Feeroqqhgphykjn",
      "artist": "Paul Guzenko",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1298,
          "apCost": 1,
          "name": "Make Ice",
          "shortDescription": "An Ice Block is summoned to an adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "special"
        },
        {
          "id": 2384,
          "apCost": 0,
          "name": "Propagate: Ice Block",
          "shortDescription": "When this unit takes 5 or more damage, an Ice Block relic with 10 HP is summoned 6 spaces away from this champion (if there are no empty spaces, it will be summoned farther away). This can trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_snow"
        },
        {
          "id": 1253,
          "apCost": 2,
          "name": "Ruin",
          "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "terraingrass"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 624,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 8 HP. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "shrinegood"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            },
            {
              "default": false,
              "id": 1295,
              "apCost": 0,
              "name": "Trail: Ice",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ice for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_ice"
            }
          ]
        }
      ]
    },
    {
      "id": 104,
      "name": "Ice Dragon",
      "description": "If there was some force that could unite all these blasted dragons, no realm would be safe... Rugolth, King of Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 73,
      "hash": "dj9Fj9EE8De9AF0BJ8IJ8Jj9Asmjginjtsolpwxf",
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2606,
          "apCost": 4,
          "name": "Arctic Bolt",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "iceaoe"
        },
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            },
            {
              "default": false,
              "id": 603,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "iceaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 136,
              "apCost": 0,
              "name": "Frost Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 260,
      "name": "Ice Golem",
      "description": "Aged shardmasters often would submit their entire being into the ice to imbue it with life.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct",
        "Elemental"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9BF0AF0BJ8IJ8Jj9Auqwzmyxqjykuhvf",
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 898,
          "apCost": 0,
          "name": "Ice Eater",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_frost"
        },
        {
          "id": 2373,
          "apCost": 0,
          "name": "Nora Gem",
          "shortDescription": "This unit is a Nora Gem. It gains the Luminescence abilities of friendly Nora Gem within 5 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "nora_gem"
        },
        {
          "id": 50,
          "apCost": 0,
          "name": "Resistance: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is reduced by 20% (after DEF, rounded up).",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "resistance_magic"
        },
        {
          "id": 46,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 20% (after DEF, rounded up).",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "resistance_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 2384,
              "apCost": 0,
              "name": "Propagate: Ice Block",
              "shortDescription": "When this unit takes 5 or more damage, an Ice Block relic with 10 HP is summoned 6 spaces away from this champion (if there are no empty spaces, it will be summoned farther away). This can trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 263,
      "name": "Ice Wurm",
      "description": "Don't step on the snow you fool, they'll hear you. I don't think they realize we're on their side. - IEF Dwarves",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9BF0Ae9Aj9Fj9Gj9Hgpwowojemlgtmyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2697,
          "apCost": 0,
          "name": "Territorial",
          "shortDescription": "When an opposing non-Illusion champion is deployed within 8 spaces, this champion gains <ability value=15>Multiattack 1</ability>, <ability value=259>Enrage 1</ability>, +4 DMG, +1 DEF and +1 SPD for 4 turns. This can trigger up to 2 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "pack_leader"
        },
        {
          "id": 752,
          "apCost": 4,
          "name": "Tunnel: Snow",
          "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 2810,
              "apCost": 0,
              "name": "Spellsurge: Snowstorm",
              "shortDescription": "When this champion is deployed, Snowstorm spells are revealed from your runedock.  Snowstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Snowstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1019,
              "apCost": 0,
              "name": "Hidden: Arctic",
              "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 372,
      "name": "Icecliff Patrol",
      "description": "I have sent the Icecliff Patrol to the east. Nothing will escape their watchful eyes. J'orea, Frost Queen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3AF0AG2Aj9Bj9Cj9Dftqjwironhpyiig",
      "artist": "Gabriel Garza",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 978,
          "apCost": 1,
          "name": "Sapping Strike",
          "shortDescription": "This champion makes a Physical attack for 12 damage against target enemy unit at RNG 2-5. If the target is successfully damaged, it loses all AP. This damage ignores DEF. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "stab"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            },
            {
              "default": false,
              "id": 2796,
              "apCost": 0,
              "name": "Snowbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 1445,
              "apCost": 0,
              "name": "Counter Attack: Ranged",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 1493,
              "apCost": 0,
              "name": "Pathfinding",
              "shortDescription": "All friendly champions that share a race with this one have <ability value=1306>Mountaineer</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "climb"
            }
          ]
        }
      ]
    },
    {
      "id": 1825,
      "name": "Icefang",
      "description": "Icefang make avalanches, and through them chase prey down moutain sides. Every traveler caught in an avalanche dreads to see a great Icefang emerging from the charging snow. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 81,
      "hash": "eJ8HJ8GG2BG2BG2Ae9Bj9Cj9Deietxkgrufpsxqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 3305,
          "apCost": 5,
          "name": "Invoke: Icefang Rumble",
          "shortDescription": "Area Effect 4: Enemy champions take 10 Sonic Damage and become <condition value=frozen>Frozen</condition> for 3 turns. Affected spaces become Deep Snow (Impeding 2) for 3 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 8,
          "iconName": "invoke"
        },
        {
          "id": 3263,
          "apCost": 1,
          "name": "Ranged Stance",
          "shortDescription": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "ranged_stance"
        },
        {
          "id": 1147,
          "apCost": 3,
          "name": "Sonic Roar",
          "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "novasonic"
        },
        {
          "id": 752,
          "apCost": 4,
          "name": "Tunnel: Snow",
          "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": true,
              "id": 2669,
              "apCost": 0,
              "name": "Snowstrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2668,
              "apCost": 0,
              "name": "Surge: Tundra",
              "shortDescription": "This unit has +1 DMG for every 2 champions occupying Ice or Snow.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_tundra"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3331,
              "apCost": 0,
              "name": "Tundra Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fangandfur"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 669,
      "name": "Icesnap",
      "description": "When J`orea was young, she was given a magical guardian. This guardian was charged with protecting the future Frost Queen, and her kingdom, from harm.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon",
        "Elemental"
      ],
      "noraCost": 92,
      "hash": "dj9Ej9Dg3Af1Bg3Aj9Dj9Ej9Fmjpnszrlgkpqfmh",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1550,
          "apCost": 0,
          "name": "Enduring Aura",
          "shortDescription": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "aurapositive"
        },
        {
          "id": 1863,
          "apCost": 3,
          "name": "Freeze",
          "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "crystallize"
        },
        {
          "id": 604,
          "apCost": 1,
          "name": "Frost Cone ",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "iceaoe"
        },
        {
          "id": 38,
          "apCost": 0,
          "name": "Immunity: Frost",
          "shortDescription": "Frost damage that would be dealt to this unit is prevented. This unit may not become Chilled.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "immunity_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            },
            {
              "default": false,
              "id": 2606,
              "apCost": 4,
              "name": "Arctic Bolt",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "iceaoe"
            },
            {
              "default": true,
              "id": 2819,
              "apCost": 0,
              "name": "Catalyst: Frost",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 390,
              "apCost": 1,
              "name": "Frost Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            }
          ]
        }
      ]
    },
    {
      "id": 123,
      "name": "Imp",
      "description": "Their laughter is as aggravating as their sting. Well... a bit less deadly. Xuvali, Deep Elf Temptress",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 61,
      "hash": "dJ8IJ8HF0Ae9AE8Dj9Ej9Fj9Gevfiiiiitztszxf",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 703,
      "name": "Imp Alchemist",
      "description": "Imp Alchemists concoct powerful potions, keeping the means of making them among their ilk. They keep their secret, in the hopes that the Bok will find use for them.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 65,
      "hash": "dj9AJ8Jf1AG2AF0AJ8HJ8IJ8Jpuxolnytfinhnyg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1998,
          "apCost": 2,
          "name": "Grant: Action Potion",
          "shortDescription": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "grantability"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1919,
              "apCost": 0,
              "name": "Revere: Firemaw",
              "shortDescription": "While this champion is in play, Firemaw costs 10% less nora to deploy. While Firemaw is in play, this champion has <ability value=3088>Flameburst</ability> and <ability value=633>Terraform: Lava</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1183,
      "name": "Imp Deceiver",
      "description": "\"They're plotting against you.  They are your enemies.  But you can show them.  You can show them all!\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 74,
      "hash": "ej9Dj9Cf1Ae9Ae9AG2BJ8Jj9Aeitohvsszgneipf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 2288,
          "apCost": 0,
          "name": "Designate Scapegoat",
          "shortDescription": "Target friendly champion becomes the target of the next opposing spell. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 5,
          "iconName": "punishing_aura"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 2573,
          "apCost": 4,
          "name": "Voices in Their Head",
          "shortDescription": "Target opposing champion within 3 spaces becomes <condition value=possessed>Possessed</condition>, recovers 4 AP and gains <ability value=2005>Careless</ability> and <ability value=2253>Manic</ability> for 1 turn, and gains <ability value=1408>Chasm Walker</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 20,
          "iconName": "possess"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": true,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        }
      ]
    },
    {
      "id": 763,
      "name": "Imp Familiar",
      "description": "Many Deep-Elves use imps for menial tasks. However, Grimlic found a better use for the creature. By binding one to a wizard, an imp could help its master channel Nora.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Imp"
      ],
      "noraCost": 63,
      "hash": "dj9Ej9Dg3AG2AG2Bj9Cj9Dj9Eeeeemnlluqfxtmh",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1988,
          "apCost": 0,
          "name": "Familiar",
          "shortDescription": "While Grimlic or Demonologist is in play, when a friendly Wizard or Imp uses an activated ability that is not a basic attack, that ability has its cooldown reduced by 1 to a minimum of 1. This ability does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "revere"
        },
        {
          "id": 1218,
          "apCost": 0,
          "name": "Favor",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "nora"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 670,
          "apCost": 3,
          "name": "Replicate",
          "shortDescription": "Create a replica of this champion on target adjacent space. This unit loses half of its current HP (rounded down) and the replica has that amount of HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "swarm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3193,
              "apCost": 3,
              "name": "Flame Prison",
              "shortDescription": "Spaces adjacent to target champion within 5 spaces becomes Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "trail_firewall"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1160,
              "apCost": 0,
              "name": "Boost",
              "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 768,
      "name": "Imp Jester",
      "description": "The imp's laughter was shrill and sharp, much louder than the wailing of its victim. In the Underdepths, pranks take on a far more sinister tone.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 69,
      "hash": "dj9Dj9CG2Bf1BE8Dj9Ej9Fj9Gevkuqjwfgnetxig",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1996,
          "apCost": 1,
          "name": "Chuck: Spider",
          "shortDescription": "This champion makes a ranged Physical attack at RNG 2-5. A Spiderling is with no upgrades is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "sumspider"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": true,
              "id": 197,
              "apCost": 0,
              "name": "Death Nova: Sonic",
              "shortDescription": "When this unit is destroyed, it deals 11 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            }
          ]
        }
      ]
    },
    {
      "id": 1751,
      "name": "Imp Philanthropist",
      "description": "\"What? Me? Up to no good? Surely you jest. Look at this hat. Does this look like a hat someone who is up to no good would wear?\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 65,
      "hash": "eJ8JJ8Ie9Af1BG2AF0Bj9Fj9Gkukusuvouvmusqf",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1998,
          "apCost": 2,
          "name": "Grant: Action Potion",
          "shortDescription": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "grantability"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1919,
              "apCost": 0,
              "name": "Revere: Firemaw",
              "shortDescription": "While this champion is in play, Firemaw costs 10% less nora to deploy. While Firemaw is in play, this champion has <ability value=3088>Flameburst</ability> and <ability value=633>Terraform: Lava</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1117,
      "name": "Imp Strangler",
      "description": "\"kackk, gehk itch goff...\" - final words of Grint, Garu Kodiak \r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Imp"
      ],
      "noraCost": 67,
      "hash": "eJ8HJ8Ge9Be9Ae9Ae9BJ8GJ8Heevkgyirqlgitm",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1238,
          "apCost": 0,
          "name": "Intimidating",
          "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "dictate"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            },
            {
              "default": false,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        }
      ]
    },
    {
      "id": 1842,
      "name": "Imp Thunderclops",
      "description": "The Imp sense of humor is dogged and abrasive. Their audience, or victims, feel often disgust, frustration, and fear; it's the imps who are left laughing.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 63,
      "hash": "eJ8JJ8If1AG2BG2AF0BJ8Jj9Aeeeeempnytxvsqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 3289,
          "apCost": 0,
          "name": "Static Shock",
          "shortDescription": "When an enemy champion within 5 spaces loses AP, it takes 2 Electricity damage per AP lost, to a maximum of 10.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "static_shock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 1115,
      "name": "Imp Trickster",
      "description": "\"They're like cockroaches, yes, but even cockroaches have their use...\" - Siz, Bok Mistress",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 70,
      "hash": "eJ8HJ8GE8De9Ae9Ae9Bj9Ej9Feeempwmyoyzohn",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 2540,
          "apCost": 0,
          "name": "Trickster",
          "shortDescription": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1037,
              "apCost": 5,
              "name": "Deception",
              "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "planar"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3033,
              "apCost": 0,
              "name": "Mirrorblade",
              "shortDescription": "When this champion makes a successful basic attack, two illusion copies of itself are summoned randomly within 4 spaces of the target.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm"
            },
            {
              "default": true,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1116,
      "name": "Imp Vixen",
      "description": "\"I'd wager they have no soul, that's why they try to consume everyone else's.\" - Ash the Bandit\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Demon",
        "Imp",
        "Vampyre"
      ],
      "noraCost": 82,
      "hash": "eJ8HJ8Ge9Ae9Ae9Ae9Bj9Fj9Gevfiwmjevxxfkn",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 416,
          "apCost": 2,
          "name": "Charm",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "charm"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        },
        {
          "id": 1371,
          "apCost": 0,
          "name": "Soul Siphon",
          "shortDescription": "When a real champion is destroyed this unit gains 5 MAX HP (to a maximum of 100) and +1 DMG permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "soul_siphon"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2634,
              "apCost": 0,
              "name": "Brain Eater",
              "shortDescription": "When this champion destroys a champion with a different owner, it gains one of its upgraded abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_disease"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 2708,
              "apCost": 1,
              "name": "Gluttony",
              "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "devour"
            }
          ]
        }
      ]
    },
    {
      "id": 350,
      "name": "Incinerator",
      "description": "The demonic fire of the Incinerators burns until nothing remains.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 71,
      "hash": "dj9Cj9BG2AF0AF0BJ8IJ8Jj9Amhephpjrsjrzxzg",
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1883,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_burn"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 997,
              "apCost": 1,
              "name": "Melt",
              "shortDescription": "All snow, ice or water terrain with 6 spaces become dirt for 6 turns. <ability value=600>Arctic</ability>, <ability value=2>Amphibious</ability> and <ability value=114>Aquatic</ability> units within 6 spaces take 7 damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "melt"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 366,
      "name": "Infected Zombie",
      "description": " As the healer is respected for keeping life among the living, the dead respect that which can grant undeath.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 65,
      "hash": "dj9Ej9Dg3AF0Ae9Aj9Fj9Gj9Hhgpjphgtzgrfiig",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 205,
          "apCost": 0,
          "name": "Death Nova: Disease",
          "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovadisease"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": true,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            },
            {
              "default": false,
              "id": 927,
              "apCost": 0,
              "name": "Amplify: Disease",
              "shortDescription": "Disease damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 3361,
              "apCost": 0,
              "name": "Spellsurge: Festering Wounds",
              "shortDescription": "When this champion is deployed, Festering Wounds spells are revealed from your runedock. Festering Wounds spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Festering Wounds spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1524,
      "name": "Infestor",
      "description": "While the Infestor resembles a pupae state of some creature, it is actually fully grown.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 0,
      "hitPoints": 25,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Mutant"
      ],
      "noraCost": 30,
      "hash": "ej9Cj9Bg3AF0Be9AG2Aj9Dj9Eeeemsxqwirfkgrf",
      "artist": "Paul Guzenko",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2898,
          "apCost": 5,
          "name": "Air Drop",
          "shortDescription": "Target a square up to 10 spaces away in an opponent's controlled font zone. At the start of your next turn, this champion is relocated to that square.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 15,
          "iconName": "air_drop"
        },
        {
          "id": 2474,
          "apCost": 0,
          "name": "Font Ignorance",
          "shortDescription": "This unit cannot contest or capture fonts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "font_ignorance"
        },
        {
          "id": 2003,
          "apCost": 0,
          "name": "Mercenary",
          "shortDescription": "At the beginning of your turns you lose 2 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "cost"
        },
        {
          "id": 3080,
          "apCost": 0,
          "name": "Sleeper Agent",
          "shortDescription": "At the end of the turn after being deployed, this champion is permanently Possessed by your opponent.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "sleeper_agent"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 698,
              "apCost": 0,
              "name": "Nora Pearls",
              "shortDescription": "When a player successfully casts a spell, the enemy gains Nora equal to 50% of that spells Nora cost. This does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 696,
              "apCost": 0,
              "name": "Wooden Scales",
              "shortDescription": "When a player successfully casts a spell, each of that player's champions gets -1 DEF and the opponent's champions gets +1 DEF for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "soul_bond"
            },
            {
              "default": true,
              "id": 703,
              "apCost": 0,
              "name": "Tainted Statue",
              "shortDescription": "Spells cost 35% more nora to cast.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "noragen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            }
          ]
        }
      ]
    },
    {
      "id": 1111,
      "name": "Inkblight Witch",
      "description": "\"Ah the screams, the wailing, the panic induced by losing ones eyes while charging headfirst into battle.\" - Brin, Inkblight Witch\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 78,
      "hash": "ej9Gj9Ff1Be9Ae9Ae9Aj9Aj9Buxqfrjtolnwqfpf",
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2486,
          "apCost": 3,
          "name": "Blind",
          "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "blind"
        },
        {
          "id": 1619,
          "apCost": 0,
          "name": "Desecrated Zone",
          "shortDescription": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "terrain_dmz"
        },
        {
          "id": 2500,
          "apCost": 0,
          "name": "Elsari Coven",
          "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "elsari"
        },
        {
          "id": 2315,
          "apCost": 0,
          "name": "Oblivion Shield",
          "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "aegis"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2537,
              "apCost": 0,
              "name": "Revel in Misery",
              "shortDescription": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "forsaken_conduit"
            },
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        }
      ]
    },
    {
      "id": 892,
      "name": "Inquisitor Isran ",
      "description": "As Grand Inquisitor, Isran Hahndor led the Ironfist Inquisition to victory on Poxanthuru. She successfully defended the Stronghold from Wrath invasion countless times. She would give up this title to search for her brother in Maljara.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 70,
      "hash": "dj9Gj9Fe9Ag3Ag3Aj9Dj9Ej9Fuhrfrwonyvfvklg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Maljaran War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        },
        {
          "id": 95,
          "apCost": 0,
          "name": "Vulnerability: Psychic",
          "shortDescription": "When this unit takes Psychic damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_psychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1305,
              "apCost": 4,
              "name": "Consecration",
              "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "consecrate_earth"
            },
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            }
          ]
        }
      ]
    },
    {
      "id": 832,
      "name": "Inquisitor Magnus",
      "description": "Magnus Hahndor was a mighty paladin and a proven leader serving Sarnghaver and then the Inquisition. It was his journey to Maljara that would be his greatest test.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian",
        "Human"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1AG2Bg3Aj9Dj9Ej9Fjlpszrofipwoqjg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1305,
          "apCost": 4,
          "name": "Consecration",
          "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "consecrate_earth"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3089,
              "apCost": 0,
              "name": "Initiator",
              "shortDescription": "This champion deals 4 additional damage to champions with 35 or more HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiator"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            }
          ]
        }
      ]
    },
    {
      "id": 1466,
      "name": "Inquisitor Magnus",
      "description": "Magnus Hahndor was a mighty paladin and a proven leader serving Sarnghaver and then the Inquisition. It was his journey to Maljara that would be his greatest test.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian",
        "Human"
      ],
      "noraCost": 77,
      "hash": "eJ8HJ8GF0BF0Be9Ae9BJ8IJ8Jeeplgnuhthrojn",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1305,
          "apCost": 4,
          "name": "Consecration",
          "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "consecrate_earth"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3089,
              "apCost": 0,
              "name": "Initiator",
              "shortDescription": "This champion deals 4 additional damage to champions with 35 or more HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiator"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            }
          ]
        }
      ]
    },
    {
      "id": 62,
      "name": "Interrogator",
      "description": "We used to joke about her interrogation techniques, until we discovered they all involve knives. - Jakoth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 70,
      "hash": "cj9Bj9AJ8Jf1Ae9BJ8Jj9Aj9Bgkuhvmluzilrwvh",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2875,
              "apCost": 0,
              "name": "Warchief: Blood Clan",
              "shortDescription": "This unit is <ability value=3>Fearless</ability>. At the end of your turn, this unit gains 1 rank of <ability value=163>Rend</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_clan"
            },
            {
              "default": true,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": true,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 1199,
      "name": "Ironfist Agent",
      "description": "I don't necessarily condone their actions, but I can't help but admit it's effective - Gedden, Ironfist Paladin",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 64,
      "hash": "ej9Dj9CG2Be9Ae9AG2Bj9Cj9Dlnymhytmleeevqf",
      "artist": "Anthony Lopes",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3362,
          "apCost": 0,
          "name": "Spellsurge: Suppress",
          "shortDescription": "When this champion is deployed, Suppress spells are revealed from your runedock. Suppress spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Suppress spell is played.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            },
            {
              "default": true,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 1017,
              "apCost": 1,
              "name": "Knockout",
              "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 503,
      "name": "Ironfist Brawler",
      "description": "The head has a lot of important stuff in it. It's also an easy target for a fist. - Mierko, Brawler",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "dj9Cj9BG2Af1Af1Bj9Aj9Bj9Ceruqowilpqjnjgg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2094,
          "apCost": 0,
          "name": "Combo Attack: Stun",
          "shortDescription": "When this champion makes two successful basic attacks that deal damage against the same champion in a single turn, that champion becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "comboatk_rend"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 210,
      "name": "Ironfist Collector",
      "description": "It all looks like junk, I know; but someday it'll be worth something. - Dehnt, Antique Collector ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 63,
      "hash": "dJ8HJ8Ge9Be9BE8Dj9Ej9Fj9Geileithrlusxvxf",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1246,
          "apCost": 2,
          "name": "Pilfer",
          "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 7,
          "iconName": "antiequip"
        },
        {
          "id": 1354,
          "apCost": 0,
          "name": "Sneak",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": true,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        }
      ]
    },
    {
      "id": 706,
      "name": "Ironfist Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the stoic stronghold of the Ironfists.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1AF0AJ8HJ8IJ8Jeepwvhgyvqzxfxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2562,
              "apCost": 4,
              "name": "Rock Slide",
              "shortDescription": "Area Effect 2, Range 5: Champions without <ability value=2527>Rock Defiance</ability> in the affected area take 12 Physical damage and become <condition value=grounded>Grounded</condition> for 3 turns. This damage ignores DEF. Affected spaces become Rock for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            },
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1675,
      "name": "Ironfist Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the stoic stronghold of the Ironfists.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1AF0AJ8HJ8IJ8Jeepwvhgyvqzxfxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2562,
              "apCost": 4,
              "name": "Rock Slide",
              "shortDescription": "Area Effect 2, Range 5: Champions without <ability value=2527>Rock Defiance</ability> in the affected area take 12 Physical damage and become <condition value=grounded>Grounded</condition> for 3 turns. This damage ignores DEF. Affected spaces become Rock for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            },
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 327,
      "name": "Ironfist Glider",
      "description": "It's the best assignment in the King's army! The only catch is the landing part. - Test Pilot 7",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct",
        "Dwarf"
      ],
      "noraCost": 67,
      "hash": "dj9AJ8Jf1AF0AG2Bj9Cj9Dj9Eeeerluonshnyzgg",
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 553,
          "apCost": 0,
          "name": "Attack: Boulder",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physicalaoe"
        },
        {
          "id": 1303,
          "apCost": 0,
          "name": "Gain Control",
          "shortDescription": "The effects of <ability value=874>Reckless Flight</ability> and <ability value=2266>Wandering</ability> are negated until the end of this turn. This ability costs 6 Nora upon activation.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "gale"
        },
        {
          "id": 874,
          "apCost": 0,
          "name": "Reckless Flight",
          "shortDescription": "At the beginning of your turn, this unit moves 2 spaces randomly, usually towards your enemy's Shrine or Avatar. This unit cannot spend AP on movement. This unit has mobility.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "wandering_new"
        },
        {
          "id": 770,
          "apCost": 1,
          "name": "Stone Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            }
          ]
        }
      ]
    },
    {
      "id": 730,
      "name": "Ironfist Inquisitor",
      "description": "For a long time, the Interrogators were considered the subordinates of the Ironfist Paladins. This changed, when King Rugolth appointed Isran Hahndor as the Grand Inquisitor of Ironfist. In turn, she would promote several more into the Inquisition.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 70,
      "hash": "dj9Bj9Af1BG2Af1AJ8Jj9Aj9Bwzketshegvhitfg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        },
        {
          "id": 95,
          "apCost": 0,
          "name": "Vulnerability: Psychic",
          "shortDescription": "When this unit takes Psychic damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_psychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1305,
              "apCost": 4,
              "name": "Consecration",
              "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "consecrate_earth"
            },
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            }
          ]
        }
      ]
    },
    {
      "id": 778,
      "name": "Ironfist Inquisitor",
      "description": "For a long time, the Interrogators were considered the subordinates of the Ironfist Paladins. This changed, when King Rugolth appointed Isran Hahndor as the Grand Inquisitor of Ironfist. In turn, she would promote several more into the Inquisition.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 70,
      "hash": "dj9Gj9Fe9AG2BE8Dj9Ej9Fj9Gevxtfgiggkrlnhg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 605,
          "apCost": 3,
          "name": "Righteous Shield",
          "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "aegis"
        },
        {
          "id": 95,
          "apCost": 0,
          "name": "Vulnerability: Psychic",
          "shortDescription": "When this unit takes Psychic damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_psychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1305,
              "apCost": 4,
              "name": "Consecration",
              "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "consecrate_earth"
            },
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            }
          ]
        }
      ]
    },
    {
      "id": 318,
      "name": "Ironfist Minister",
      "description": "\"Sure, I'll go negotiate a peace treaty with the Draksar scum... I'll ask 'em what piece he'd like me to smash off first\" - Bobek, Minister-in-training",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0BF0AF0AJ8HJ8IJ8Jeeeeepnnjerlnwf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 668,
          "apCost": 2,
          "name": "Battle Drum",
          "shortDescription": "All friendly champions from the same faction as this one gain <condition value=benediction>Benediction</condition> for 1 turn and recover 1 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "drum"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            },
            {
              "default": false,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 662,
      "name": "Ironfist Minister",
      "description": "\"Sure, I'll go negotiate a peace treaty with the Draksar scum... I'll ask 'em what piece he'd like me to smash off first\" - Bobek, Minister-in-training",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0BF0AF0AJ8HJ8IJ8Jeeeeepnnjerlnwf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 668,
          "apCost": 2,
          "name": "Battle Drum",
          "shortDescription": "All friendly champions from the same faction as this one gain <condition value=benediction>Benediction</condition> for 1 turn and recover 1 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "drum"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            },
            {
              "default": false,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 110,
      "name": "Ironfist Paladin",
      "description": "May our ancestors bless our hammers and our hearts, and strengthen us against the darkness, for we stand firm as the barricade to protect the infirm and helpless. First Creed of the Holy Order of Ironfist, Canto I",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9Be9Ae9BJ8GJ8HJ8Ifkneevkrjpushtf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 620,
          "apCost": 4,
          "name": "Lay Hands",
          "shortDescription": "Target champion within 2 spaces (including this champion) heals HP equal to its max HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2753,
              "apCost": 2,
              "name": "Noble Sacrifice",
              "shortDescription": "This champion loses 8 HP and target other friendly champion that shares a race with this one within 3 spaces gains <ability value=1932>Loyalty</ability> for 8 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1305,
              "apCost": 4,
              "name": "Consecration",
              "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "consecrate_earth"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 605,
              "apCost": 3,
              "name": "Righteous Shield",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "aegis"
            }
          ]
        }
      ]
    },
    {
      "id": 1817,
      "name": "Ironfist Standardbearer",
      "description": "\"To me! To me, brothers! Hold fast -- Ironfist shall not fall, not now, not ever, not while we stand together!\" -- Rally of the Standardbearers",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 65,
      "hash": "eJ8HJ8GE8DG2BG2Ae9Bj9Ej9Feephytfpnshnjpf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 579,
          "apCost": 2,
          "name": "Invigorate",
          "shortDescription": "Target champion within 2 spaces gains 4 AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": true,
              "id": 2576,
              "apCost": 1,
              "name": "Throw Javelin",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "spear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3318,
              "apCost": 0,
              "name": "Rally",
              "shortDescription": "Champions (including this one) that come into play under your control within 3 spaces of this unit gain <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 2308,
              "apCost": 0,
              "name": "Rally",
              "shortDescription": "Champions (including this one) that come into play under your control within 3 spaces of this unit gain <condition value=impervious>Impervious</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 630,
      "name": "Ironfist Warsaint",
      "description": "By the gods, I'll smash 'em dead! Doesn't matter where they come from or what they are, no one dares harm Ironfist! No one! - Hieron, War Saint",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 70,
      "hash": "dj9Ej9Dg3Af1BF0BJ8IJ8Jj9Amsqzzrjetqsmjgg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1320,
          "apCost": 0,
          "name": "Assault",
          "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "assault"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1735,
          "apCost": 2,
          "name": "Duel",
          "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 4,
          "iconName": "reflexes"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3297,
              "apCost": 0,
              "name": "Zeal: Defense",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DEF for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_defense"
            },
            {
              "default": false,
              "id": 1076,
              "apCost": 3,
              "name": "Heal Self",
              "shortDescription": "This unit recovers 12 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 969,
              "apCost": 0,
              "name": "Shrine Defender",
              "shortDescription": "While this unit is within your 8 spaces of its shrine, this unit gets +2 DMG and +2 SPD and your Shrine has +8 HP. When your Shrine is Transfigured, this unit has <ability value=1759>Impassioned</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 1932,
              "apCost": 0,
              "name": "Loyalty",
              "shortDescription": "This champion gains +2 DMG and +5 HP as long as all friendly units that you own share a faction with it.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "loyalty"
            }
          ]
        }
      ]
    },
    {
      "id": 1255,
      "name": "Ivory Wing",
      "description": "The Ivory Wing is the priestly branch of the Wings of Al'mara, and one of the original 4 wings of the order.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Jf1Ae9Be9Af1AJ8Jj9Aemsqquofpqsquo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 304,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "divine"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2714,
          "apCost": 0,
          "name": "Ivory Sigil",
          "shortDescription": "This champion gains <ability value=2671>Illuminate</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "griffin_sigil"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 1383,
      "name": "Jakei Adherent",
      "description": "A Learner who shows promise may be instructed deeper in the re-discovered secret Disciplines.  Most who are chosen are unable to master the instruction.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 66,
      "hash": "ej9Cj9Bf1BF0Ae9AG2Aj9Aj9Biethrlusjnwfmpf",
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2839,
          "apCost": 0,
          "name": "Crippling Discipline",
          "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_distracting"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 3230,
              "apCost": 3,
              "name": "Freezing Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "grip_icelord"
            }
          ]
        }
      ]
    },
    {
      "id": 370,
      "name": "Jakei Bruiser",
      "description": "Some warriors of the Jakei chose to train themselves as the feral beasts of the Tundra do. Such training renders them stout to elements and wise in the ways of survival.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 62,
      "hash": "dj9Ej9Dg3AF0Af1AJ8Jj9Aj9Bhrukempwzxonhgg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1252,
          "apCost": 0,
          "name": "Readiness",
          "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 348,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 2217,
              "apCost": 0,
              "name": "Hunter: Brawler",
              "shortDescription": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_rogue"
            },
            {
              "default": false,
              "id": 395,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-2 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +2 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "charge"
            }
          ]
        }
      ]
    },
    {
      "id": 670,
      "name": "Jakei Climber",
      "description": "Into the heart I go, to find a soul, a center. Something within the ice to warm this chill. - The Diary of L`ilae, Jakei Climber",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 63,
      "hash": "dj9Fj9EE8DG2AE8Dj9Ej9Fj9Geeeiyzgvvzthvfg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 721,
          "apCost": 2,
          "name": "Shatter",
          "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "antiequip"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            },
            {
              "default": true,
              "id": 3070,
              "apCost": 0,
              "name": "Savage Armaments",
              "shortDescription": "When a friendly champion with Race: Yeti, Race: Lonx, or Race: Jakei becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 752,
              "apCost": 4,
              "name": "Tunnel: Snow",
              "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1306,
              "apCost": 0,
              "name": "Mountaineer",
              "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "climb"
            },
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 477,
      "name": "Jakei Disciple",
      "description": "Sharpen your mind. Ice will not be the only weapon you wield in battle. - K'ento, Jakei Disciple ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 72,
      "hash": "dJ8IJ8HF0Af1AG2Aj9Bj9Cj9Dvkwouvheknyzgeg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 2651,
          "apCost": 2,
          "name": "Silent Contemplation",
          "shortDescription": "Until this champion moves, it has +4 MAX RNG, <ability value=680>Planar Bound</ability>, and <ability value=2271>Sentinel</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            },
            {
              "default": true,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            },
            {
              "default": false,
              "id": 3356,
              "apCost": 0,
              "name": "Pacifying Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is Pacified for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "charm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            },
            {
              "default": false,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 1912,
              "apCost": 0,
              "name": "Resonance",
              "shortDescription": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            }
          ]
        }
      ]
    },
    {
      "id": 188,
      "name": "Jakei Elder",
      "description": "The legends of the Jakei hold that the elder Jakaris was responsible for the transformation of the forest to the tundra around the time of The Separation.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 73,
      "hash": "dj9Dj9CG2Be9AG2Bj9Cj9Dj9Eeevkgevxkpumwig",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 774,
          "apCost": 0,
          "name": "Chill",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_chill"
        },
        {
          "id": 2669,
          "apCost": 0,
          "name": "Snowstrike",
          "shortDescription": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "iceaoe"
        },
        {
          "id": 1295,
          "apCost": 0,
          "name": "Trail: Ice",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ice for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "trail_ice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2667,
              "apCost": 2,
              "name": "Snow Shroud",
              "shortDescription": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 2668,
              "apCost": 0,
              "name": "Surge: Tundra",
              "shortDescription": "This unit has +1 DMG for every 2 champions occupying Ice or Snow.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_tundra"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 1463,
              "apCost": 0,
              "name": "Iceguard",
              "shortDescription": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        }
      ]
    },
    {
      "id": 1482,
      "name": "Jakei Elementalist",
      "description": "For the Jakei, the only element that truly matters is that which binds its victims in a frigid hold.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "eJ8IJ8HG2AF0Be9AF0Aj9Bj9Ceeitxfgympnjyo",
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2606,
          "apCost": 4,
          "name": "Arctic Bolt",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "iceaoe"
        },
        {
          "id": 384,
          "apCost": 3,
          "name": "Frost Nova",
          "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novafrost"
        },
        {
          "id": 2188,
          "apCost": 0,
          "name": "Recharge",
          "shortDescription": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "recharge"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1747,
              "apCost": 1,
              "name": "Grant: Frost Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3129,
              "apCost": 3,
              "name": "Elemental Storm: Frost",
              "shortDescription": "Enemy champions within 3 spaces of at least one friendly Elemental, Shaman or Wizard, including this one, take 5 Frost damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "absolute_zero"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 422,
      "name": "Jakei Extinguisher",
      "description": "So cold is their touch even fire shivers before them.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 74,
      "hash": "dJ8JJ8IF0BF0Be9Aj9Fj9Gj9Heeeepuzmytfileg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 232,
          "apCost": 0,
          "name": "Damage Shield: Frost",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Frost damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "dmgshld_frost"
        },
        {
          "id": 1114,
          "apCost": 0,
          "name": "Extinguish",
          "shortDescription": "When a friendly champion takes Fire damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=charred>Charred</condition>, the Charred condition is removed as well. This effect does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 898,
              "apCost": 0,
              "name": "Ice Eater",
              "shortDescription": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 137,
              "apCost": 0,
              "name": "Frost Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            }
          ]
        }
      ]
    },
    {
      "id": 436,
      "name": "Jakei Extinguisher",
      "description": "So cold is their touch even fire shivers before them.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 74,
      "hash": "dj9Ej9Dg3AF0Bf1AJ8Jj9Aj9Bjgvkepqqwkgplgg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 232,
          "apCost": 0,
          "name": "Damage Shield: Frost",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Frost damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "dmgshld_frost"
        },
        {
          "id": 1114,
          "apCost": 0,
          "name": "Extinguish",
          "shortDescription": "When a friendly champion takes Fire damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=charred>Charred</condition>, the Charred condition is removed as well. This effect does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 898,
              "apCost": 0,
              "name": "Ice Eater",
              "shortDescription": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 137,
              "apCost": 0,
              "name": "Frost Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            }
          ]
        }
      ]
    },
    {
      "id": 117,
      "name": "Jakei Frost Queen",
      "description": "We have earned our place here. We have become like ice: implacable, unmovable, and above all, endless. -- J'orea, Queen of the Jakei ",
      "maxRng": 7,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 82,
      "hash": "dj9Gj9Fe9Ae9Ae9Aj9Fj9Gj9Hkrhvoqsuzzgpqfg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 1465,
          "apCost": 0,
          "name": "Instigate",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1081,
              "apCost": 0,
              "name": "Enlightened",
              "shortDescription": "When this champion is healed, the amount is increased by 6.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            }
          ]
        }
      ]
    },
    {
      "id": 245,
      "name": "Jakei Frostbow",
      "description": "Not all soldiers are meant to be shardmasters. To wield the frostbow is not dishonorable. - J'orea, Jakei Queen",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "dj9AJ8Jf1Ae9Bg3Aj9Dj9Ej9Fuknyoluzzmjtjgg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 101,
          "apCost": 1,
          "name": "Barrage",
          "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "arrowaoe"
        },
        {
          "id": 3120,
          "apCost": 0,
          "name": "Provision: Speed",
          "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "plunder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 616,
              "apCost": 0,
              "name": "Arctic Camouflage",
              "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Snow or Ice, that damage by is reduced by 2.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "camo"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1574,
      "name": "Jakei Frostseer",
      "description": "\"Ice forms slow in nature, but I see a hasty frost in your future.\" ~ Jakei Frostseer",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 69,
      "hash": "ej9Cj9Be9Be9BG2AG2AJ8GJ8Hoqsmpygerhvxfpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1455,
          "apCost": 0,
          "name": "Expedite",
          "shortDescription": "When this unit successfully attacks, you gain a rune reveal.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "scry"
        },
        {
          "id": 2669,
          "apCost": 0,
          "name": "Snowstrike",
          "shortDescription": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "iceaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            },
            {
              "default": true,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2347,
              "apCost": 0,
              "name": "Prophetic Balance",
              "shortDescription": "Whenever an opposing champion gains AP outside of normal AP generation, this champion gains an equal amount of AP.  Any AP gained this way which would be lost due to the AP cap is gained by the closest friendly champion instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "prophetic_balance"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 1262,
      "name": "Jakei Heretic",
      "description": "The Jakei prohibition against entering the Broken Shard tunnels is not necessarily shared by all Jakei. A number of Jakei joined Vallassa's expedition despite an explicit order from the Shardsheers against it.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "ej9Bj9Ae9Be9Be9Af1BJ8GJ8Hkljljinjytufmn",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1142,
          "apCost": 0,
          "name": "Hunter: Hero",
          "shortDescription": "When this unit would deal damage with any attack to a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater that damage is increased by 2. When this unit would receive damage from any attack by a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "hunter_hero"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 113,
      "name": "Jakei Icefisher",
      "description": "As we circled each other, I found myself facing a twin, equal in style and ferocity.  Afina Lighthander, K'Thir Ranger",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk",
        "Ranger"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 68,
      "hash": "dj9Fj9EE8De9Ag3Aj9Dj9Ej9Fmszvxosxzmnufgg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 649,
          "apCost": 3,
          "name": "Icebreaker",
          "shortDescription": "Snow and Ice spaces adjacent to this champion are Water (Impeding 1) for the next 4 turns. Champions occupying spaces modified this way become <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "dispel"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1743,
              "apCost": 1,
              "name": "Frigid Lance",
              "shortDescription": "This champion makes a Frost attack at RNG 2-5.  If the target is occupying Ice, Snow or is <condition value=frozen>Frozen</condition> and is successfully damaged, the target also becomes <condition value=chilled>Chilled</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ice"
            },
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": true,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 775,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_chill"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 1747,
              "apCost": 1,
              "name": "Grant: Frost Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 731,
      "name": "Jakei Maiden",
      "description": "I remember her, resting in the forest. She offered me a flower from her hair, but I declined it. I can still feel the warmth she shaped in me. - Diary of L`ilae, Jakei Climber",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 62,
      "hash": "dj9Bj9Af1BG2Af1Bj9Aj9Bj9Cemsosfmumuxiigg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 1959,
          "apCost": 0,
          "name": "Cleansing Aura",
          "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "aurapositive"
        },
        {
          "id": 31,
          "apCost": 0,
          "name": "Defender",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "defenseenhance"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 1560,
              "apCost": 0,
              "name": "Growth",
              "shortDescription": "Friendly champions within 2 spaces are healed for 3 HP at the beginning of your turns.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": true,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            }
          ]
        }
      ]
    },
    {
      "id": 837,
      "name": "Jakei Owl Raider",
      "description": "Several Wingmasters were tired of Juya's harsh leadership. They broke away and formed small militias along the Tundra, known as Owl Raiders. These groups fight for J'thir, but do not take orders from the Frostqueen.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 47,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 76,
      "hash": "dj9Bj9Af1BG2BF0BJ8IJ8Jj9Aheeetmjnjruhneg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 2167,
          "apCost": 0,
          "name": "Attack Charged",
          "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 2228,
          "apCost": 0,
          "name": "Charged Frost Cone",
          "shortDescription": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> 2. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "iceaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1509,
              "apCost": 0,
              "name": "Blitz",
              "shortDescription": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1763,
              "apCost": 1,
              "name": "Lift",
              "shortDescription": "Target champion gains flying, no longer engages opposing units, and cannot spend AP on movement for 2 rounds.  Whenever this champion moves, target champion moves to where this champion was.  This champion's movement costs 3 AP while target champion is Lifted.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "feather"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            }
          ]
        }
      ]
    },
    {
      "id": 1632,
      "name": "Jakei Pilgrim",
      "description": "Although a pilgrimage into the empty tundra is a prerequisite for military service, many Jakei opt out of the risky and grueling ordeal.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 66,
      "hash": "eJ8HJ8GE8DF0BG2Ae9Bj9Ej9Feepuhekyvkrwxo",
      "artist": "Rogier van de Beek",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3086,
          "apCost": 0,
          "name": "Disbelief",
          "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        },
        {
          "id": 3150,
          "apCost": 0,
          "name": "Gift: Pilgrim's Offering",
          "shortDescription": "The next champion you deploy from the runedock while this champion is in play has <ability value=867>Blessed</ability> and 2 ranks of <ability value=116>Regeneration</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "gift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1470,
              "apCost": 0,
              "name": "Nohkan Do",
              "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dodge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1212,
              "apCost": 0,
              "name": "Dissipate",
              "shortDescription": "Ranged attacks made by this champion have a penalty of -2 DMG for each space the target is beyond the champion's minimum range (to a maximum of -4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "arrow"
            },
            {
              "default": false,
              "id": 3064,
              "apCost": 0,
              "name": "Weighty",
              "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "weighty"
            }
          ]
        }
      ]
    },
    {
      "id": 641,
      "name": "Jakei Shadowstriker",
      "description": "The Penumbra clan of J`thir believes in a special power over shadow. The source of this power is unknown, but its members use it with incredible skill.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk",
        "Rogue"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 70,
      "hash": "dj9Fj9EE8DG2AF0AJ8HJ8IJ8Jeeepfpsuftsjnyg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1441,
          "apCost": 0,
          "name": "Confuse Enemy",
          "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "confuse"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2818,
              "apCost": 0,
              "name": "Forbidden Discipline",
              "shortDescription": "The next basic attack this champion makes causes the target to become <condition value=frightened>Frightened</condition> for 2 turns. If the target was <condition value=frozen>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "discipline_forbidden"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 259,
      "name": "Jakei Shaman",
      "description": "The preparations for the summoning are in place...tell the minister to have the shamans begin their meditations. - Golem Summoning Ceremony",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 72,
      "hash": "dJ8HJ8Ge9BF0Af1AJ8Jj9Aj9Bgthtzoqqzrsqqwf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 368,
          "apCost": 3,
          "name": "Heal Champion",
          "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1923,
              "apCost": 0,
              "name": "Revere: Icesnap",
              "shortDescription": "While this champion is in play, Icesnap costs 10% less nora to deploy. While Icesnap is in play, whenever a champion takes frost damage this champion generates 1 nora (This does not include damage from <condition value=chilled>Chilled</condition>).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 115,
      "name": "Jakei Shardmaster",
      "description": "They are still K'thir in that their world is their weapon. -- Godwin, Elder Garu",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior",
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 69,
      "hash": "dj9Gj9Fe9Ae9AE8Dj9Ej9Fj9Gemsfvkufroyvfeg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 652,
          "apCost": 0,
          "name": "Attack: Ice Shard",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "ice"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            },
            {
              "default": false,
              "id": 1295,
              "apCost": 0,
              "name": "Trail: Ice",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Ice for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_ice"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 246,
      "name": "Jakei Snowcharger",
      "description": "How I long for the days before the war, when I would tend the land atop my charger and the dead stayed beneath the snow. - Sorjaay, Jakei Farmer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 74,
      "hash": "dj9Bj9Af1Be9BE8Dj9Ej9Fj9Gerztmuvmsxfpjeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 778,
          "apCost": 2,
          "name": "Snow-Fall",
          "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainsnow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 887,
              "apCost": 1,
              "name": "Hawk Attack",
              "shortDescription": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "hawk_attack"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": true,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 671,
      "name": "Jakei Snowhisper",
      "description": "Within the Penumbra Clan, a few have taken vows of silence. This has made them into assassins.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 70,
      "hash": "dj9Fj9EE8DG2Ae9Aj9Fj9Gj9Hukuzmlpuhekjlgg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1454,
          "apCost": 0,
          "name": "Escape",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        },
        {
          "id": 1017,
          "apCost": 1,
          "name": "Knockout",
          "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "stun"
        },
        {
          "id": 1867,
          "apCost": 1,
          "name": "Mark",
          "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "declare_hunted"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            },
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 1019,
              "apCost": 0,
              "name": "Hidden: Arctic",
              "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 900,
      "name": "Jakei Soulpainter",
      "description": "\"To paint with the soul, you must understand its nature. With this force, you will make the world your canvas. Every thought will be a brushstroke. \" - J'almar, Soulpainter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9Bg3AF0BJ8IJ8Jj9Akpyggtuxkegvfxf",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1419,
          "apCost": 0,
          "name": "Adaptation",
          "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "adaptation"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2687,
          "apCost": 3,
          "name": "Confuse",
          "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "confuse"
        },
        {
          "id": 897,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "mind_control"
        },
        {
          "id": 1264,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 608,
              "apCost": 0,
              "name": "Majestic",
              "shortDescription": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "majestic"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            }
          ]
        }
      ]
    },
    {
      "id": 974,
      "name": "Jakei Starseer",
      "description": "\"The evening sky holds our fate. With this gift, we can read the stars. And they have much to teach to us.\" R'isha, Jakei Starseer",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 72,
      "hash": "dj9Dj9CG2Bg3Ag3Aj9Dj9Ej9Fwzxqlrzvxqwtjnh",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1776,
          "apCost": 0,
          "name": "Premonition",
          "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 3062,
          "apCost": 3,
          "name": "Shatter Summoned",
          "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        },
        {
          "id": 2345,
          "apCost": 0,
          "name": "Starshine",
          "shortDescription": "The closest friendly champion that moves within 5 spaces gains a rank of <ability value=608>Majestic</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "distract"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2347,
              "apCost": 0,
              "name": "Prophetic Balance",
              "shortDescription": "Whenever an opposing champion gains AP outside of normal AP generation, this champion gains an equal amount of AP.  Any AP gained this way which would be lost due to the AP cap is gained by the closest friendly champion instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "prophetic_balance"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            },
            {
              "default": false,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 569,
      "name": "Jakei Warfoot",
      "description": "From examining the Lonx, the Jakei adopted a new form of martial arts. They called it Nohkan-Do.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 77,
      "hash": "dJ8JJ8IF0Bf1BF0AJ8HJ8IJ8Jeeeepuojytofxxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 338,
          "apCost": 0,
          "name": "Counterstrike",
          "shortDescription": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "counter"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 1544,
      "name": "Jakei Warfoot",
      "description": "From examining the Lonx, the Jakei adopted a new form of martial arts. They called it Nohkan-Do.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 77,
      "hash": "ej9Ej9Dg3AF0Be9Ag3Aj9Dj9Eeeeevhnyvmlwqsf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 338,
          "apCost": 0,
          "name": "Counterstrike",
          "shortDescription": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "counter"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 124,
      "name": "Jakei Wingmaster",
      "description": "What the Wingmasters lack in subtlety they recoup in sheer speed.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 74,
      "hash": "dj9Gj9Fe9Ae9AF0BJ8IJ8Jj9Anevknwvvkuheiyg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1271,
          "apCost": 0,
          "name": "Tempo",
          "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dancesong"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1445,
              "apCost": 0,
              "name": "Counter Attack: Ranged",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 105,
      "name": "Jakei Wolfrider",
      "description": "Jakei cavalry were well-feared amongst the Lonx, since the steeds were as dangerous as their riders.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 69,
      "hash": "dj9Fj9EE8De9Af1AJ8Jj9Aj9Bkukgrhinwfxtjyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 163,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rend"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            }
          ]
        }
      ]
    },
    {
      "id": 793,
      "name": "Jangar Arcanis",
      "description": "\"I expected a savage, scrawling glyphs on stone. Instead, the Arcanis showed the skill of an elder Magister. He weaved the Nora with such grace and his conjurings were nearly perfect!\" - Igarm, Magister of Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9BG2BE8Dj9Ej9Fj9Gerzthiegrohvvzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 604,
          "apCost": 1,
          "name": "Frost Cone ",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "iceaoe"
        },
        {
          "id": 760,
          "apCost": 3,
          "name": "Magic Nova",
          "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novamagic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1876,
              "apCost": 1,
              "name": "Grant: Elemental Immunity",
              "shortDescription": "Target champion within 5 spaces gains <ability value=37>Immunity: Fire</ability>, <ability value=38>Immunity: Frost</ability> and <ability value=39>Immunity: Electricity</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        }
      ]
    },
    {
      "id": 973,
      "name": "Jangar Architect",
      "description": "\"We had only speculated about arcane construction until the dwarves brought their Grobles to Maljara. We applied our knowledge to theirs and the rest we learned from practice.\" - Eckir, Jangar Architect",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9Fe9BE8De9Ae9AJ8GJ8Hmwmjpsuqlwitjn",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2346,
          "apCost": 0,
          "name": "Charged Barricade",
          "shortDescription": "Spend 2 charges: Summon a Barricade relic to target location within 4 spaces. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "charged_barricade"
        },
        {
          "id": 1253,
          "apCost": 2,
          "name": "Ruin",
          "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "terraingrass"
        },
        {
          "id": 2175,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "charged_spell"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 624,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 8 HP. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "shrinegood"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 3165,
              "apCost": 0,
              "name": "Mason's Spire",
              "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            }
          ]
        }
      ]
    },
    {
      "id": 917,
      "name": "Jek the Silver General",
      "description": "\"The Voil wage war in our skies. But, they don't know an Ospryan's anger. They will never reach K'thir. We will take back our sky.\" - Jek, Ospryan Silver General ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight",
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 85,
      "hash": "dJ8JJ8IF0Bg3Ae9Aj9Fj9Gj9Hiwiwiwxxmyxqjgg",
      "artist": "Slawomir Maniak",
      "factions": [
        "K'thir Forest",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        }
      ]
    },
    {
      "id": 1142,
      "name": "Jellebrium Darkweaver",
      "description": "Shadows... may... return... ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 72,
      "hash": "eJ8JJ8If1Be9Ae9AF0Bj9Aj9Bmsmshthextmsso",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        },
        {
          "id": 1418,
          "apCost": 0,
          "name": "Sands of Time",
          "shortDescription": "When a real opposing unit within 6 spaces  is destroyed by an attack, an opposing revealed rune has its cooldown increased by 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2529,
              "apCost": 0,
              "name": "Jellebrium Mind",
              "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jellebrium_mind"
            },
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 1179,
      "name": "Jellebrium Extispicer",
      "description": "Life... death... paradox...",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 76,
      "hash": "ej9Dj9Ce9Ae9Ae9AG2Bj9Fj9Goqqqquvzkeiwmpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 1269,
          "apCost": 2,
          "name": "Antagonize",
          "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 2990,
          "apCost": 0,
          "name": "Psychic Anguish",
          "shortDescription": "Enemy champions within 5 spaces of this unit who take Psychic damage become <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "psychic_anguish"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2529,
              "apCost": 0,
              "name": "Jellebrium Mind",
              "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jellebrium_mind"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            }
          ]
        }
      ]
    },
    {
      "id": 1143,
      "name": "Jellebrium Lightbringer",
      "description": "Burning... light... horizon...",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8IG2Ae9Ae9AF0Bj9Bj9Ceeeeeruhykplwo",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2582,
          "apCost": 0,
          "name": "Impairing Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 608,
          "apCost": 0,
          "name": "Majestic",
          "shortDescription": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "majestic"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 2529,
              "apCost": 0,
              "name": "Jellebrium Mind",
              "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jellebrium_mind"
            }
          ]
        }
      ]
    },
    {
      "id": 1563,
      "name": "Jellebrium Mediator",
      "description": "Mind... doors... open...",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 65,
      "hash": "ej9AJ8Je9Be9BG2Af1AJ8GJ8Hwqzmufmuzmykuo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2529,
          "apCost": 0,
          "name": "Jellebrium Mind",
          "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "jellebrium_mind"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1811,
      "name": "Jellebrium Mender",
      "description": "Attune... shroud... restore...",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FF0BG2BG2Ae9AJ8IJ8Jwxqouoqsowolyrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 2529,
          "apCost": 0,
          "name": "Jellebrium Mind",
          "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "jellebrium_mind"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            }
          ]
        }
      ]
    },
    {
      "id": 1145,
      "name": "Jellebrium Mindbender",
      "description": "Belong... elsewhere... depart...",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 80,
      "hash": "eJ8JJ8Ig3Ae9Ae9AF0Bj9Dj9Eeeeeevszilexipf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 161,
          "apCost": 0,
          "name": "Psychic Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novapsychic"
        },
        {
          "id": 2338,
          "apCost": 0,
          "name": "Psychic Magnetism",
          "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2529,
              "apCost": 0,
              "name": "Jellebrium Mind",
              "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jellebrium_mind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 2991,
              "apCost": 4,
              "name": "Soulwrack",
              "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "soulwrack"
            },
            {
              "default": false,
              "id": 3100,
              "apCost": 0,
              "name": "Catalyst: Psychic",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 1815,
      "name": "Jellebrium Nexus",
      "description": "Bond... adapt... grow...",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9FG2BG2BG2Ae9Aj9Cj9Dzonlnjluvsosxtf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 3302,
          "apCost": 5,
          "name": "Invoke: Veil of the Mind",
          "shortDescription": "Area Effect 4: Friendly champions (including this one) are Cleansed and have the CD on their non-basic attack abilities reduced by 2 and enemy champions are Dispelled and have the CD on their non-basic attack abilities increased by 2. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 6,
          "iconName": "invoke"
        },
        {
          "id": 1769,
          "apCost": 0,
          "name": "One With Nora",
          "shortDescription": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "defenseenhance"
        },
        {
          "id": 1779,
          "apCost": 0,
          "name": "Psychic Ping",
          "shortDescription": "When this unit comes into play, it deals 4 Psychic damage to nearest opposing champion within 5 spaces. At the beginning of each turn afterwards, this champion deals 4 Psychic damage to the enemy champion with greatest HP within 5 spaces. ",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "psychic"
        },
        {
          "id": 2341,
          "apCost": 3,
          "name": "Stall",
          "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "debuff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 2529,
              "apCost": 0,
              "name": "Jellebrium Mind",
              "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jellebrium_mind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1781,
      "name": "Jellebrium Overmind",
      "description": "Thoughts... dreams... denied...",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 78,
      "hash": "ej9Gj9Ff1AG2AG2Ae9AJ8Jj9Aemnyvhnpqzoqfrf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1160,
          "apCost": 0,
          "name": "Boost",
          "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "boost"
        },
        {
          "id": 3261,
          "apCost": 2,
          "name": "Mind Lock",
          "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "mind_lock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2529,
              "apCost": 0,
              "name": "Jellebrium Mind",
              "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jellebrium_mind"
            },
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2117,
              "apCost": 5,
              "name": "Metamorphosis",
              "shortDescription": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "transform"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        }
      ]
    },
    {
      "id": 1144,
      "name": "Jellebrium Skycaller",
      "description": "Morning... star... descends...",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jellebrium"
      ],
      "noraCost": 75,
      "hash": "eJ8JJ8IG2Be9Ae9AF0Bj9Cj9Dsmsmwosfiwfgepf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1368,
          "apCost": 0,
          "name": "Deflect: Electric",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Electric damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect_electric"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2245,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 805,
              "apCost": 1,
              "name": "Chain Lightning",
              "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "electric"
            },
            {
              "default": true,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            },
            {
              "default": false,
              "id": 2529,
              "apCost": 0,
              "name": "Jellebrium Mind",
              "shortDescription": "When this unit is deployed, a revealed rune in the opposing rune dock has +2 CD for each friendly unit with Jellebrium Mind, including this one. At the beginning of its turns, for every 5 runes your opponent has on cooldown, this unit is healed for 2 and gains a rank of <ability value=406>Teleport</ability> for 1 turn (if it is a champion).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jellebrium_mind"
            },
            {
              "default": true,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 826,
      "name": "Judge Torien",
      "description": "To the Draksar, a Judge is one who exacts the divine judgment of the Dragon Gods. It is Torien's duty to enforce Valdaci law, as well as the tenets of Valdac and Vindrax, in Maljara.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 75,
      "hash": "dj9AJ8Jf1AG2BF0AJ8HJ8IJ8Jjrfkrqwfipsuqzg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2003,
          "apCost": 0,
          "name": "Mercenary",
          "shortDescription": "At the beginning of your turns you lose 2 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "cost"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2116,
              "apCost": 3,
              "name": "Judgement",
              "shortDescription": "Champions within 3 spaces of this champion are <mechanic value=cleansed>Cleansed</mechanic>.  For each condition removed this way, the affected champion loses 10 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "divine"
            },
            {
              "default": true,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1818,
              "apCost": 0,
              "name": "Defensive Strike",
              "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 633,
      "name": "Juya White-Eyes",
      "description": "No one will take J`thir! Not Voil, or demon, or undead wretch! And no one will harm the Frost Queen! Not with her Wingmasters in the sky! To victory! - Juya White-Eyes",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 93,
      "hash": "dj9Ej9Dg3Af1BG2Aj9Bj9Cj9Dsofrjpsjpsjtxkg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1702,
          "apCost": 0,
          "name": "Blockade",
          "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "blockade"
        },
        {
          "id": 1723,
          "apCost": 3,
          "name": "Declare Target",
          "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "declare_hunted"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 364,
          "apCost": 1,
          "name": "Piercing Shot",
          "shortDescription": "This champion makes a ranged attack at +9 DMG and +1 AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 9,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": true,
              "id": 1139,
              "apCost": 3,
              "name": "Command: Dodge",
              "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "command_dodge"
            },
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        }
      ]
    },
    {
      "id": 772,
      "name": "Juya White-Eyes",
      "description": "No one will take J`thir! Not Voil, or demon, or undead wretch! And no one will harm the Frost Queen! Not with her Wingmasters in the sky! To victory! - Juya White-Eyes",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 93,
      "hash": "dj9Dj9CG2Bf1Bf1Bj9Aj9Bj9Ceilnegextjgtxig",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1702,
          "apCost": 0,
          "name": "Blockade",
          "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "blockade"
        },
        {
          "id": 1723,
          "apCost": 3,
          "name": "Declare Target",
          "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "declare_hunted"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 364,
          "apCost": 1,
          "name": "Piercing Shot",
          "shortDescription": "This champion makes a ranged attack at +9 DMG and +1 AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 9,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": true,
              "id": 1139,
              "apCost": 3,
              "name": "Command: Dodge",
              "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "command_dodge"
            },
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        }
      ]
    },
    {
      "id": 1851,
      "name": "Juya White-Eyes",
      "description": "No one will take J`thir! Not Voil, or demon, or undead wretch! And no one will harm the Frost Queen! Not with her Wingmasters in the sky! To victory! - Juya White-Eyes",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 93,
      "hash": "ej9AJ8JG2AG2BG2Af1Aj9Bj9Cemnwfxkeklymlrf",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1702,
          "apCost": 0,
          "name": "Blockade",
          "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "blockade"
        },
        {
          "id": 1723,
          "apCost": 3,
          "name": "Declare Target",
          "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "declare_hunted"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 364,
          "apCost": 1,
          "name": "Piercing Shot",
          "shortDescription": "This champion makes a ranged attack at +9 DMG and +1 AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 9,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": true,
              "id": 1139,
              "apCost": 3,
              "name": "Command: Dodge",
              "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "command_dodge"
            },
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        }
      ]
    },
    {
      "id": 1102,
      "name": "Jyx the Shadesworn",
      "description": "\"He no longer wields that blade. It wields him.\" - Kartch, Boghopper Finlord\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 13,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue",
        "Warrior"
      ],
      "races": [
        "Demon",
        "Salaman"
      ],
      "noraCost": 84,
      "hash": "ej9Fj9EG2Ae9Ae9AE8Dj9Bj9Cemnuvfkpushpfpf",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "Underdepths"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 3119,
          "apCost": 0,
          "name": "Provision: Offense",
          "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "plunder"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            },
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2463,
              "apCost": 0,
              "name": "Quest: Kill Enemy",
              "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 485,
              "apCost": 0,
              "name": "Souldrinker",
              "shortDescription": "When this unit destroys a champion, it heals HP equal to half the destroyed champions's nora cost.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "nora_eater"
            }
          ]
        }
      ]
    },
    {
      "id": 1253,
      "name": "K'ento, First Disciple",
      "description": "K'ento, meaning \"The First,\" refers not to age, but to rank, and speaks to the fact that for the Penumbra Clan, life is a journey for which there are no masters, only disciples.\r\n\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 76,
      "hash": "ej9AJ8JF0Be9Be9Af1AJ8IJ8Juhykrsftuhkwqo",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2939,
          "apCost": 0,
          "name": "Chilling Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_chilling"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2651,
          "apCost": 2,
          "name": "Silent Contemplation",
          "shortDescription": "Until this champion moves, it has +4 MAX RNG, <ability value=680>Planar Bound</ability>, and <ability value=2271>Sentinel</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1479,
              "apCost": 0,
              "name": "Vigorous Cry",
              "shortDescription": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 1472,
      "name": "K'ento, First Disciple",
      "description": "K'ento, meaning \"First Discipline\" refers to the idea that life is a journey for which there are no masters, only disciples. There is  only one First Discipline at any time, and Penumbra who attain the rank of First Discipline take on the name of K'ento.\r",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 76,
      "hash": "eJ8IJ8HE8DF0Be9AF0Aj9Ej9Feeekpwkyowfrqo",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2939,
          "apCost": 0,
          "name": "Chilling Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_chilling"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2651,
          "apCost": 2,
          "name": "Silent Contemplation",
          "shortDescription": "Until this champion moves, it has +4 MAX RNG, <ability value=680>Planar Bound</ability>, and <ability value=2271>Sentinel</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1479,
              "apCost": 0,
              "name": "Vigorous Cry",
              "shortDescription": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 227,
      "name": "K'lzik",
      "description": "Lady K'lzik...is...is that you? -- Who speaks?  There is no K'lzik.  I am not K'lzik.  I am the destroyer.  I am not Nefari. I am greater than Nefari. You shall die?  Yes. Now! - K'lzik's return to the Nefari caverns",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 13,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Demon",
        "Elf"
      ],
      "noraCost": 90,
      "hash": "dJ8IJ8HF0Ae9Bg3Aj9Dj9Ej9Fsssofvxqqqsmneg",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 724,
          "apCost": 0,
          "name": "Propagate: Spiderling",
          "shortDescription": "When this unit takes 5 or more damage, a Spiderling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away). This triggers up to 3 times per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "propagate_spiderling"
        },
        {
          "id": 3271,
          "apCost": 1,
          "name": "Slayer's Spear",
          "shortDescription": "This champion makes a Physical attack at range 2-5. If this attack is successful, the enemy champion becomes <condition value=tagged>Tagged</condition><ability value=3277>.</ability>",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "spear"
        },
        {
          "id": 783,
          "apCost": 0,
          "name": "Surge: Arthropod",
          "shortDescription": "This unit has +1 DMG for each friendly Arthropod.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge_spider"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 988,
              "apCost": 2,
              "name": "Envenom",
              "shortDescription": "Target opposing champion within 5 spaces becomes <condition value=poisoned>Poisoned</condition> for 1 turn and loses 4 AP at the start of their next turn.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1859,
              "apCost": 0,
              "name": "Death Spawn: Spiderling",
              "shortDescription": "When this champion is destroyed, 2 Spiderling champions are summoned in the spaces it formerly occupied.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "deathspawn_spiderling"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        }
      ]
    },
    {
      "id": 708,
      "name": "K'thir Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the gentle forests of K`thir.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dJ8JJ8IF0BF0BF0BJ8IJ8Jj9Aeeeeeipquxfeexf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            }
          ]
        }
      ]
    },
    {
      "id": 1676,
      "name": "K'thir Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the gentle forests of K`thir.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dJ8JJ8IF0BF0BF0BJ8IJ8Jj9Aeeeeeipquxfeexf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            }
          ]
        }
      ]
    },
    {
      "id": 853,
      "name": "K'thun the Ancient",
      "description": "\"K'thun is renown for his endless wisdom, his wandering mind and mindless wandering.\" - Sipn, Elven Bard",
      "maxRng": 4,
      "minRng": 1,
      "defense": 2,
      "speed": 4,
      "damage": 8,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 76,
      "hash": "dj9Dj9CG2BG2BE8Dj9Ej9Fj9Gerluxtoshytxkjg",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2237,
          "apCost": 0,
          "name": "Biogenesis",
          "shortDescription": "When this champion is deployed and at the end of its every third turn, a Young Sapling is summoned to an adjacent space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "sumtree"
        },
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 1303,
          "apCost": 0,
          "name": "Gain Control",
          "shortDescription": "The effects of <ability value=874>Reckless Flight</ability> and <ability value=2266>Wandering</ability> are negated until the end of this turn. This ability costs 6 Nora upon activation.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "gale"
        },
        {
          "id": 2255,
          "apCost": 4,
          "name": "Gift of Ironwood",
          "shortDescription": "This unit loses 10 HP and target Sapling within 3 spaces is removed from play and a Gnarlwood Grappler with no upgrades is summoned in the same location the Sapling occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 5,
          "noraCost": 35,
          "iconName": "gif_of_ironwood"
        },
        {
          "id": 2266,
          "apCost": 0,
          "name": "Wandering",
          "shortDescription": "At the end of your opponent's turns, this unit moves 2 spaces randomly towards your enemies Shrine or Avatar. This unit cannot spend AP on movement.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -30,
          "iconName": "wandering_new"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 841,
              "apCost": 3,
              "name": "Nora Shield",
              "shortDescription": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 8,
              "iconName": "nora_barrier"
            },
            {
              "default": false,
              "id": 1337,
              "apCost": 0,
              "name": "Gift of Fertility",
              "shortDescription": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 798,
      "name": "Kanen Alpha",
      "description": "Most Alphas are older Kanen, who have survived a lifetime of brutality. From this, they are made into the perfect mixture of strength and cunning, the perfect leader of a Kanen pack.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9BG2Bf1AJ8Jj9Aj9Bshknphykuxxolyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1444,
          "apCost": 0,
          "name": "Counter Attack: Melee",
          "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "counter"
        },
        {
          "id": 2146,
          "apCost": 0,
          "name": "Pack Leader",
          "shortDescription": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        },
        {
          "id": 1363,
          "apCost": 0,
          "name": "Unleash",
          "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "unleashed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 796,
      "name": "Kanen Animus",
      "description": "The Animus embraces the killer in the Kanen blood. Where most Kanen kill to survive, the Animus does it simply for the thrill of taking life. The lifespan of an Animus is half as long as most Kanen.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 59,
      "hash": "dJ8HJ8Ge9BG2BF0AJ8HJ8IJ8Jeemygrhiwknjpwf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 24,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "berserker"
        },
        {
          "id": 3101,
          "apCost": 0,
          "name": "Ferocious Bite",
          "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "ancestral_avenger"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 1063,
              "apCost": 0,
              "name": "Kill Frenzy ",
              "shortDescription": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "furious_attacks"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 800,
      "name": "Kanen Crone",
      "description": "\"They are savages, Kailyn. Look, there. One has smashed another across the head with a rock, for no better reason than to exert strength. This is a Crone's work. Keep them this way and they will follow.\" - Kiergana, Crone of Kain Taris",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 80,
      "hash": "dJ8HJ8Ge9BG2BG2Aj9Bj9Cj9Duqowfroytxzkjeg",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 1072,
          "apCost": 1,
          "name": "Magical Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "magicaoe"
        },
        {
          "id": 737,
          "apCost": 0,
          "name": "Spellswallower",
          "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "spellswallow"
        },
        {
          "id": 3138,
          "apCost": 0,
          "name": "Twisted Essence",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "twisted_essence"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1787,
              "apCost": 3,
              "name": "Rite of Power",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed and friendly champions gain +1 DMG permanently and gain +1 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "final_judgement"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            }
          ]
        }
      ]
    },
    {
      "id": 799,
      "name": "Kanen Cultist",
      "description": "\"Lead them to the brink of madness, but don't lose them there. We guide them to do the will of Kain Taris, not to lose them in hopeless mania. Find this balance and you will be a powerful cultist.\" - Kiergana, Crone of Kain Taris",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9BG2Bf1Bj9Aj9Bj9Cemjnlwiwthiwvzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2288,
          "apCost": 0,
          "name": "Designate Scapegoat",
          "shortDescription": "Target friendly champion becomes the target of the next opposing spell. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 5,
          "iconName": "punishing_aura"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1912,
              "apCost": 0,
              "name": "Resonance",
              "shortDescription": "At the beginning of each of its turns, this champion gains DMG for 1 turn equal to the amount of nora your opponent generated through spells, relics and abilities in the last 2 turns.  This DMG is only applied for nora generated while this champion is in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            }
          ]
        }
      ]
    },
    {
      "id": 940,
      "name": "Kanen Darkrunner",
      "description": "The sound of movement startled Remmi. He turned and peered into the jungle, raising his torch to see. The light caught the snarling maw of the brush.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute",
        "Rogue"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 61,
      "hash": "dj9Bj9Af1Bg3Ae9BJ8GJ8HJ8Ikggkwoymwkwoszg",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1454,
          "apCost": 0,
          "name": "Escape",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            },
            {
              "default": true,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": true,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 801,
      "name": "Kanen Howler",
      "description": "\"'Twas a lone Kanen, sitting on a rock. When Quiverhook missed his shot, the mutt threw its head back and gave a yell. That's when its mates showed up, all fifty of them.\" - Ensign Balvur Strongarm, Canoneer on the Leviathan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 63,
      "hash": "dJ8HJ8Ge9BG2BG2Bj9Cj9Dj9Eeerluklpwkjytfg",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 2087,
          "apCost": 0,
          "name": "Swarm: Kanen Mongrel",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Kanen Mongrel champion is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": false,
              "id": 245,
              "apCost": 0,
              "name": "Damage Shield: Sonic",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Sonic damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_sonic"
            },
            {
              "default": true,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 197,
              "apCost": 0,
              "name": "Death Nova: Sonic",
              "shortDescription": "When this unit is destroyed, it deals 11 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovasonic"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 802,
      "name": "Kanen Lasher",
      "description": "\"We can direct this carnage into a focused power. Give the Kanen weapons and train them in the art of formal combat. You would have an unflinching force, worthy of a noble kingdom. We can help them.\" - Iseria, Draksar Consulate",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 61,
      "hash": "dJ8HJ8Ge9BG2Bg3Aj9Dj9Ej9Fmheetuqukuzthgg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 795,
      "name": "Kanen Mongrel",
      "description": "Mongrels make up the majority of the Kanen population, also acting as the mangy foot soldiers of the Kanen army. In battle, Mongrels follow the Alpha's lead.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 56,
      "hash": "dJ8HJ8Ge9BG2Be9BJ8GJ8HJ8Iyitztxqqwmjlgvf",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 941,
      "name": "Kanen Pillager",
      "description": "The Kanen learned much from the legions of Valdac. The Draksar gave them weapons and taught them to fight. The Skeezick taught them the art of the siege.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 58,
      "hash": "dj9Bj9Af1Bg3AF0AJ8HJ8IJ8Jeeevxxfgkjlggeg",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 1393,
          "apCost": 0,
          "name": "Pillage",
          "shortDescription": "When this champion enters an enemy font deployment zone, you gain 6 nora. This can trigger once per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "noragen"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": true,
              "id": 132,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 767,
              "apCost": 1,
              "name": "Fire Attack",
              "shortDescription": "This unit makes a Fire attack at range 2-4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "fire"
            },
            {
              "default": true,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": false,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            }
          ]
        }
      ]
    },
    {
      "id": 933,
      "name": "Kanen Scavenger",
      "description": "\"Let them chew on bones and rotten meat. If they turn away from us, they turn away from Kain Taris. They will gnaw at our refuse.\" - Kiergana, Stitched Crone",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 60,
      "hash": "dj9AJ8Jf1Ag3AG2Aj9Bj9Cj9Depfvqjtsmnuxthg",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 746,
          "apCost": 0,
          "name": "Dead Eater",
          "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "nora_eater"
        },
        {
          "id": 1457,
          "apCost": 0,
          "name": "Forage",
          "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "forage"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            },
            {
              "default": false,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        }
      ]
    },
    {
      "id": 928,
      "name": "Kanen Slipped",
      "description": "When a Kanen has reached a certain age, it slips into a terrible, unending frenzy. A slipped Kanen has twice the strength of an Alpha and none of its restraint. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 13,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 79,
      "hash": "dj9AJ8Jf1Ag3Ae9BJ8GJ8HJ8Ieevxxvheeggykyg",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2146,
          "apCost": 0,
          "name": "Pack Leader",
          "shortDescription": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1363,
          "apCost": 0,
          "name": "Unleash",
          "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "unleashed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 3056,
              "apCost": 0,
              "name": "Overkill: Healing",
              "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "overkill"
            },
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 797,
      "name": "Kanen Tracker",
      "description": "\"They have Trackers with them. Do you see the smaller prints and the claw markings there? They're looking for something. Probably, for us.\" - Teneroh, Chirai Outrunner",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 8,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 64,
      "hash": "dJ8HJ8Ge9BG2BF0BJ8IJ8Jj9Aetuqhykwvszkyxf",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2998,
              "apCost": 0,
              "name": "Lay Trap: Acid",
              "shortDescription": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapthorn"
            },
            {
              "default": false,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            },
            {
              "default": true,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 970,
              "apCost": 0,
              "name": "Hidden: Rock",
              "shortDescription": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1099,
              "apCost": 0,
              "name": "Hidden: Sand",
              "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 942,
      "name": "Kanen Whirlwind",
      "description": "\"These Kanen were different. They were coordinated, highly trained. They were wild, but the wildness was perfectly honed. Our defending party didn't stand a chance.\" - Hemnir Redbeard, IEF",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 64,
      "hash": "dj9Bj9Af1Bg3AF0BJ8IJ8Jj9Aiiilymhnyinyrfg",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1504,
          "apCost": 0,
          "name": "Brutality",
          "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "surge"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 1938,
          "apCost": 0,
          "name": "Pack Mentality",
          "shortDescription": "The first time this champion uses the Fuel Rage ability each turn, the ability's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 176,
      "name": "Kartch, Finlord",
      "description": "Kartch raised his arms feebly as the dragon's mouth swooped to surround him, when suddenly it roared out in pain, a Finlord's spear protruding from both sides of its neck.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 91,
      "hash": "dj9Cj9BG2Ae9Af1Bj9Aj9Bj9Ceiymhtsmhpymneg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1892,
          "apCost": 0,
          "name": "Quest: Damage",
          "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "opportunistic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1818,
              "apCost": 0,
              "name": "Defensive Strike",
              "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 771,
      "name": "Kartch, Finlord",
      "description": "Kartch raised his arms feebly as the dragon's mouth swooped to surround him, when suddenly it roared out in pain, a Finlord's spear protruding from both sides of its neck.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 91,
      "hash": "dj9Dj9CG2Bf1BF0BJ8IJ8Jj9Axfvfvoqzitsmwfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1892,
          "apCost": 0,
          "name": "Quest: Damage",
          "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "opportunistic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1818,
              "apCost": 0,
              "name": "Defensive Strike",
              "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1372,
      "name": "Kartch, Finlord",
      "description": "Kartch raised his arms feebly as the dragon's mouth swooped to surround him, when suddenly it roared out in pain, a Finlord's spear protruding from both sides of its neck.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 91,
      "hash": "ej9Bj9AG2AF0Ae9Af1Bj9Bj9Cerzkyxirjnufmpf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 2856,
          "apCost": 0,
          "name": "Presidential",
          "shortDescription": "This is a presidential unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "majestic"
        },
        {
          "id": 1892,
          "apCost": 0,
          "name": "Quest: Damage",
          "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "opportunistic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1818,
              "apCost": 0,
              "name": "Defensive Strike",
              "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1658,
      "name": "Katchi, Salaman Soldier",
      "description": "Katchi, the Swamp is most happy to have your blades by its side. - Gekaal, Forglar High One",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 70,
      "hash": "ej9AJ8JG2AF0BG2Af1Aj9Bj9Ceevmsxipnpygyrf",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 2644,
              "apCost": 2,
              "name": "Phantom Dash",
              "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1267,
      "name": "Keeper of Memories",
      "description": "Memories of the race are kept and passed on by Keepers - Yetis who show the unique capacity to connect telepathically with others of their kind.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 84,
      "hash": "ej9Bj9AG2Ae9Be9Af1Bj9Bj9Ceitjtssxxkufkpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2318,
          "apCost": 0,
          "name": "Deploy Charged",
          "shortDescription": "When a champion is deployed from the runedock, this unit gains 2 charges.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 2454,
          "apCost": 0,
          "name": "Frost Amped",
          "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=137>Frost Aura 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amped"
        },
        {
          "id": 2670,
          "apCost": 0,
          "name": "Unleash Memories",
          "shortDescription": "Spend all charges. You gain 2 nora for each charge lost this way (up to 40).",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2623,
              "apCost": 0,
              "name": "Anthomancy",
              "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "scry"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 2172,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_death"
            }
          ]
        }
      ]
    },
    {
      "id": 1538,
      "name": "Khong Monk",
      "description": "\"What kind of attack was that? Watch me do it, and see how silly you look flailing about\" - Uncle Khong",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Monk"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9DF0AF0Be9Ag3AJ8HJ8Ieeeinhnluvhykpf",
      "artist": "Anthony Lopes",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 2956,
          "apCost": 0,
          "name": "Mocking Blow",
          "shortDescription": "When a champion makes an unsuccessful basic attack against this unit, this unit attacks the attacker with that ability",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "soul_bond"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 920,
      "name": "Kiergana",
      "description": "\"They have chosen me to be their Matriarch. I am queen of two thrones and master of two armies. Now I shall never be usurped.\" - Kiergana, Stitched Crone",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Kanen",
        "Stitched"
      ],
      "noraCost": 88,
      "hash": "dJ8JJ8IF0Bg3AF0BJ8IJ8Jj9Agygygkytmhyiwzg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2300,
          "apCost": 0,
          "name": "Charged Blast",
          "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2173,
          "apCost": 0,
          "name": "Death Charged",
          "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "charged_death"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 1276,
          "apCost": 0,
          "name": "Vengeful",
          "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2105,
              "apCost": 3,
              "name": "Reconstruct: Magician",
              "shortDescription": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Magician is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 12,
              "iconName": "reconstruct"
            },
            {
              "default": false,
              "id": 485,
              "apCost": 0,
              "name": "Souldrinker",
              "shortDescription": "When this unit destroys a champion, it heals HP equal to half the destroyed champions's nora cost.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "nora_eater"
            },
            {
              "default": false,
              "id": 1009,
              "apCost": 0,
              "name": "Tariff",
              "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "cost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2103,
              "apCost": 0,
              "name": "Deconstruct",
              "shortDescription": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "merge"
            },
            {
              "default": false,
              "id": 2146,
              "apCost": 0,
              "name": "Pack Leader",
              "shortDescription": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "pack_leader"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        }
      ]
    },
    {
      "id": 1818,
      "name": "Kingmaker",
      "description": "The Ironfist Stronghold remains a monarchy. In order to function in a protracted war, however, it was ultimately necessary for the King to make certain concessions of power...",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 63,
      "hash": "eJ8HJ8Ge9AG2BG2Ae9Bj9Fj9Gevfepqsowmjnnpf",
      "artist": "Rogier van de Beek",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2157,
          "apCost": 0,
          "name": "Annex",
          "shortDescription": "While this unit is in play, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "special"
        },
        {
          "id": 3283,
          "apCost": 0,
          "name": "Gift: Kingmaker",
          "shortDescription": "The next champion you deploy from the runedock while this champion is in play has <ability value=608>Majestic 1</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "gift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 3010,
              "apCost": 4,
              "name": "Bubble",
              "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "bubble"
            },
            {
              "default": false,
              "id": 657,
              "apCost": 2,
              "name": "Relocate: Ally",
              "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 990,
      "name": "Klub the Devourer",
      "description": "\"He only wants to destroy, to devour entire armies in his bloodlust. There is no saving Cyclops like him.\" - Zeventrech the Last",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 89,
      "hash": "ej9Fj9Ef1AE8De9AE8DJ8Jj9Aevxxfpqhnwtfro",
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        },
        {
          "id": 2393,
          "apCost": 0,
          "name": "Tactician",
          "shortDescription": "Friendly champions within 3 spaces have +1 MAX RNG if they have a MIN RNG of 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "tactician"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2759,
              "apCost": 0,
              "name": "Guarded: Cyclops",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Cyclops within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 1864,
      "name": "Klub the Devourer",
      "description": "\"He only wants to destroy, to devour entire armies in his bloodlust. There is no saving Cyclops like him.\" - Zeventrech the Last",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 89,
      "hash": "ej9Cj9BE8DG2BG2AG2Aj9Ej9Fukjwxkrwkpshkrf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        },
        {
          "id": 2393,
          "apCost": 0,
          "name": "Tactician",
          "shortDescription": "Friendly champions within 3 spaces have +1 MAX RNG if they have a MIN RNG of 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "tactician"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2759,
              "apCost": 0,
              "name": "Guarded: Cyclops",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Cyclops within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 1163,
      "name": "Korona, Bok Huntress",
      "description": "\"Run and hide, elf! The chase only feeds my thirst.\" ~ Korona, Bok Huntress",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 83,
      "hash": "ej9Bj9Af1Be9Ae9Af1Bj9Aj9Bykuqhyojpljiepf",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 3357,
          "apCost": 0,
          "name": "Obsidian Flight",
          "shortDescription": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3293,
              "apCost": 0,
              "name": "Bind: Spells",
              "shortDescription": "When this champion destroys an enemy champion, enemy spells cost 5 nora more to play while this champion is in play. This ability triggers up to 3 times.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "bind_spells"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 2463,
              "apCost": 0,
              "name": "Quest: Kill Enemy",
              "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 1469,
      "name": "Korona, Bok Huntress",
      "description": "\"Run and hide, elf! The chase only feeds my thirst.\" ~ Korona, Bok Huntress",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 83,
      "hash": "eJ8HJ8GG2AF0Be9Ae9Bj9Bj9Ceeemhvkpwmymuo",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 3357,
          "apCost": 0,
          "name": "Obsidian Flight",
          "shortDescription": "This unit is <condition value=flying>Flying</condition> and has <ability value=1603>Reflection 2</ability> and <ability value=2004>Faithless</ability>. When within 3 spaces of a champion with Sanguine Flight, it also gains <ability value=2942>Masochist</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3293,
              "apCost": 0,
              "name": "Bind: Spells",
              "shortDescription": "When this champion destroys an enemy champion, enemy spells cost 5 nora more to play while this champion is in play. This ability triggers up to 3 times.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "bind_spells"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 2463,
              "apCost": 0,
              "name": "Quest: Kill Enemy",
              "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 64,
      "name": "Krikkinwing",
      "description": "You don't so much choose to escape a krikkinwing as you choose how painfully it's going to kill you.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 74,
      "hash": "cj9Fj9Ej9Dg3Af1Bj9Dj9Ej9Fgtmjnsmlemuquqj",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 40,
          "apCost": 0,
          "name": "Immunity: Poison",
          "shortDescription": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_poison"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        },
        {
          "id": 730,
          "apCost": 1,
          "name": "Poison Sting",
          "shortDescription": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 144,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novapoison"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 193,
              "apCost": 0,
              "name": "Death Nova: Poison",
              "shortDescription": "When this unit is destroyed, it deals 11 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovapoison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            },
            {
              "default": false,
              "id": 427,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1937,
      "name": "Krikkinwing",
      "description": "You don't so much choose to escape a krikkinwing as you choose how painfully it's going to kill you.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 76,
      "hash": "ej9Fj9EF0Ae9AG2BE8DJ8HJ8Ikljipusjemnlyo",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 730,
          "apCost": 1,
          "name": "Poison Sting",
          "shortDescription": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 144,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novapoison"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 193,
              "apCost": 0,
              "name": "Death Nova: Poison",
              "shortDescription": "When this unit is destroyed, it deals 11 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovapoison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            },
            {
              "default": false,
              "id": 427,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1239,
      "name": "Krikkinwing Alpha",
      "description": "The Krikkinwing Alpha appears to be a recently mutated form of the Krikkinwing, retaining some traits while discarding others.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod",
        "Mutant"
      ],
      "noraCost": 83,
      "hash": "eJ8JJ8IE8De9Be9AF0Bj9Ej9Foqoqzvhigknsqo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 40,
          "apCost": 0,
          "name": "Immunity: Poison",
          "shortDescription": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_poison"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2627,
          "apCost": 0,
          "name": "Shimmering Wings",
          "shortDescription": "For 2 turns, this champion loses Tough, gains <ability value=2582>Impairing Feedback</ability>, <ability value=6>Mobility</ability>, <ability value=427>Poison Cloud 2</ability> and its RNG becomes 3-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "shimmering_wings"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 3334,
              "apCost": 0,
              "name": "Sabotage: Poison",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 3159,
              "apCost": 0,
              "name": "Spellsurge: Sandstorm",
              "shortDescription": "When this champion is deployed, Sandstorm spells are revealed from your runedock.  Sandstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Sandstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 2688,
              "apCost": 4,
              "name": "Screech",
              "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "sonicaoe"
            },
            {
              "default": true,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 594,
      "name": "Lance Admiral Sceian",
      "description": "No one questions me, because I've never given them a reason to doubt. Would you ever question a soldier who built a kingdom? - Sceian, Lance Admiral",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 13,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 87,
      "hash": "dj9AJ8Jf1Af1BG2Aj9Bj9Cj9Duohpyxxosfkeggg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 101,
          "apCost": 1,
          "name": "Barrage",
          "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "arrowaoe"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1763,
          "apCost": 1,
          "name": "Lift",
          "shortDescription": "Target champion gains flying, no longer engages opposing units, and cannot spend AP on movement for 2 rounds.  Whenever this champion moves, target champion moves to where this champion was.  This champion's movement costs 3 AP while target champion is Lifted.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "feather"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 317,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 263,
              "apCost": 0,
              "name": "Warcry",
              "shortDescription": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1892,
              "apCost": 0,
              "name": "Quest: Damage",
              "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 854,
              "apCost": 0,
              "name": "Battle Harden",
              "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 776,
      "name": "Lance Admiral Sceian",
      "description": "No one questions me, because I've never given them a reason to doubt. Would you ever question a soldier who built a kingdom? - Sceian, Lance Admiral",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 13,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 87,
      "hash": "dj9Fj9EE8DG2BG2Aj9Bj9Cj9Dqojtuxtsfxvfphg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 101,
          "apCost": 1,
          "name": "Barrage",
          "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "arrowaoe"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1763,
          "apCost": 1,
          "name": "Lift",
          "shortDescription": "Target champion gains flying, no longer engages opposing units, and cannot spend AP on movement for 2 rounds.  Whenever this champion moves, target champion moves to where this champion was.  This champion's movement costs 3 AP while target champion is Lifted.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "feather"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 317,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DEF and +4 DMG.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 263,
              "apCost": 0,
              "name": "Warcry",
              "shortDescription": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1892,
              "apCost": 0,
              "name": "Quest: Damage",
              "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 854,
              "apCost": 0,
              "name": "Battle Harden",
              "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 29,
      "name": "Lavaflow Devourer",
      "description": "I just naturally fear anything that can eat fire. - Akit, Keeper of the Mines",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 64,
      "hash": "cj9Gj9Fj9EE8Df1Aj9Ej9Fj9Gemwmsfvfetolukj",
      "artist": "Dan Kopycienski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 846,
          "apCost": 1,
          "name": "Entangle",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "net"
        },
        {
          "id": 1404,
          "apCost": 0,
          "name": "Fire Feed",
          "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "eater_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1447,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deathnovalava"
            },
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 924,
      "name": "Lavaspout",
      "description": "She stood back as a stream of lava burst from the mountainside. Shocked, she watched it turn and advanced towards her unsuspecting rangers.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 0,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 42,
      "hash": "dJ8JJ8IF0Bg3AG2Bj9Cj9Dj9Eeeeeeeeigkuquhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1448,
          "apCost": 0,
          "name": "Death Nova: Lava",
          "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "deathnovalava"
        },
        {
          "id": 37,
          "apCost": 0,
          "name": "Immunity: Fire",
          "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "immunity_fire"
        },
        {
          "id": 1119,
          "apCost": 2,
          "name": "Lava-Fall",
          "shortDescription": "Spaces within 4 spaces of this champion are Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "terrainlava"
        },
        {
          "id": 2283,
          "apCost": 0,
          "name": "Rapid Growth",
          "shortDescription": "Summon a copy of this champion with no upgrades on target space within 5 spaces. This ability costs 20 nora to activate and begins on CD.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 50,
          "iconName": "rapid_growth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2032,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +4 HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plushealth"
            },
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 757,
              "apCost": 0,
              "name": "Immobile",
              "shortDescription": "This unit cannot move or be relocated.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -30,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1784,
      "name": "Leaf on the Wind",
      "description": "\"Injury, you see, comes from our unwillingness to be moved. We insistent on being the movers. But accept movement in all forms, and you will be unharmed.\" ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 65,
      "hash": "eJ8HJ8GE8DG2AG2Ae9Bj9Ej9Feeekukrlevkphpf",
      "artist": "Grant Griffin",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            },
            {
              "default": false,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        }
      ]
    },
    {
      "id": 1734,
      "name": "Len the Weird Uncle",
      "description": "The end is nigh! We must repent and bow down  to our Sporegill lords before its too late! ~ Len the Weird Uncle",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 64,
      "hash": "ej9Gj9FG2Bf1BG2Ae9Aj9Cj9Dzrzgvzmsuzilrsf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1724,
          "apCost": 0,
          "name": "Depression",
          "shortDescription": "Champions within 3 spaces of this unit have -2 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "debuff"
        },
        {
          "id": 1734,
          "apCost": 2,
          "name": "Drudgery",
          "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "debuff"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 161,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapsychic"
            },
            {
              "default": true,
              "id": 160,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novapsychic"
            },
            {
              "default": false,
              "id": 159,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 2 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "novapsychic"
            }
          ]
        }
      ]
    },
    {
      "id": 835,
      "name": "Leoss Border Patrol",
      "description": "\"Day 11. The Border Patrol has agreed to help with the Kanen resting along our outer-most perimeter. We will approach by night, to take them while they sleep. They have promised me the Alpha.\" - Vahkosh, Headhunter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 74,
      "hash": "dj9Bj9Af1BG2Be9BJ8GJ8HJ8Inymwqhiyvouxoyg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3058,
          "apCost": 1,
          "name": "Chuck: Wood",
          "shortDescription": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "chuck_wood"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 2299,
          "apCost": 0,
          "name": "Soul of Ailur",
          "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "warriorspride"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            }
          ]
        }
      ]
    },
    {
      "id": 794,
      "name": "Leoss Druid",
      "description": "The Druids navigate through the densest parts of Maljaran jungle, using its hostile nature to their advantage.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9BG2Be9Aj9Fj9Gj9Hszrhvmytqfxmjeg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2297,
          "apCost": 1,
          "name": "Grant: Evasive",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 368,
          "apCost": 3,
          "name": "Heal Champion",
          "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "heal"
        },
        {
          "id": 2082,
          "apCost": 0,
          "name": "Jungle Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Jungle (Impeding Vegetation) for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "ferociousgrowth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 2083,
              "apCost": 0,
              "name": "Trailblaze",
              "shortDescription": "All friendly champions have Brushwalker (This champion ignores movement restrictions and movement penalties imposed by Vegetation.).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "climb"
            },
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            },
            {
              "default": true,
              "id": 3415,
              "apCost": 0,
              "name": "Jungle Kingdom",
              "shortDescription": "Friendly champions with Race: Leoss within 3 spaces gain <ability value=2088>Tunnel: Vegetation</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "tunnel_vegetation"
            }
          ]
        }
      ]
    },
    {
      "id": 786,
      "name": "Leoss Guardian",
      "description": "Although the Guardians hold the lowest rank in the Leoss Army, they are not novices in battle. Once a Guardian is deemed worthy, the Leoss is allowed into one of the elite warrior societies.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 65,
      "hash": "dj9Gj9Fe9AG2BF0AJ8HJ8IJ8Jjgpwmjyzmnsszzg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3266,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "combat_awareness"
        },
        {
          "id": 410,
          "apCost": 1,
          "name": "Stun",
          "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "stun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 1321,
      "name": "Leoss Magnate",
      "description": "\"There are those who argue that we should stay on our island and mind our own business, but security through isolation makes for a fool's blanket.\" ~ Leoss Magnate",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Monk"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 75,
      "hash": "eJ8HJ8Ge9AF0Ae9Ae9Bj9Fj9Gerhigemsfrouon",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 372,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 2743,
          "apCost": 2,
          "name": "Magnate's Blessing",
          "shortDescription": "Target champion within 4 spaces gains <ability value=608>Majestic 1</ability> for 4 turns. It also gains +1 DMG for 4 turns for every 25 HP on opposing champions within 3 spaces of it, rounded down. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "majestic"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 2479,
              "apCost": 0,
              "name": "Improve Speed",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_speed"
            }
          ]
        }
      ]
    },
    {
      "id": 792,
      "name": "Leoss Monk",
      "description": "The Monks of Ailur believe in defending life through peace. As the Kanen threat advanced on Ailur, the Monks were forced to change their philosophy: strike only to defend and never to kill.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 70,
      "hash": "dj9Gj9Fe9AG2Bg3Aj9Dj9Ej9Femykggyvonyrfkg",
      "artist": "Joachim Barrum",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 579,
          "apCost": 2,
          "name": "Invigorate",
          "shortDescription": "Target champion within 2 spaces gains 4 AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "buff"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 605,
              "apCost": 3,
              "name": "Righteous Shield",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 399,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 2: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "forcebarrier"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": false,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            }
          ]
        }
      ]
    },
    {
      "id": 1550,
      "name": "Lesser Shadowrake",
      "description": "\"You can hide from me, but can you hide from every shadow?\" - B'onja, Shadowrake",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 8,
      "hitPoints": 12,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 44,
      "hash": "ej9Fj9Ef1Af1Ae9AE8DJ8Jj9Aevkllwtjyowqfpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 3002,
          "apCost": 0,
          "name": "Hunter: Quick",
          "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunter_quick"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 65,
      "name": "Lich King",
      "description": "Death has done little to humble the man who was Serkan.  In death he holds his power to be absolute. - Rugolth",
      "maxRng": 8,
      "minRng": 6,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 95,
      "hash": "cj9Fj9Ej9Dg3AG2Bj9Dj9Ej9Fwinhtxtzxqqossj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 107,
          "apCost": 0,
          "name": "Immortality",
          "shortDescription": "When this unit is destroyed, its cooldown is set to 0. When this unit is deployed, your Shrine or Avatar loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 2315,
          "apCost": 0,
          "name": "Oblivion Shield",
          "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "aegis"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            }
          ]
        }
      ]
    },
    {
      "id": 1934,
      "name": "Lich King",
      "description": "Death has done little to humble the man who was Serkan.  In death he holds his power to be absolute. - Rugolth",
      "maxRng": 8,
      "minRng": 6,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 95,
      "hash": "ej9Gj9FE8De9AG2Be9Aj9Ej9Fqoqwzgrwquxzoqf",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 107,
          "apCost": 0,
          "name": "Immortality",
          "shortDescription": "When this unit is destroyed, its cooldown is set to 0. When this unit is deployed, your Shrine or Avatar loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 2315,
          "apCost": 0,
          "name": "Oblivion Shield",
          "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "aegis"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            }
          ]
        }
      ]
    },
    {
      "id": 761,
      "name": "Lich's Servitor",
      "description": "With Xulos's true intention revealed, Serkan found he could trust only a few in Elsarin. He began taking several humans into his tutelage, in the hopes of finding a new, loyal apprentice.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 78,
      "hash": "dj9Ej9Dg3AG2Af1Bj9Aj9Bj9Ceeerzvvonjpjpjg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1985,
          "apCost": 0,
          "name": "Aspiring Servant",
          "shortDescription": "While Serkan, Lich Master or Czar of the Void is in play, this champion has <ability value=694>Lich-born</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 30,
          "iconName": "revere"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2786,
          "apCost": 0,
          "name": "Spell Aegis",
          "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dark_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 890,
              "apCost": 0,
              "name": "Grace of the Dead",
              "shortDescription": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "healmass"
            },
            {
              "default": true,
              "id": 725,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 3181,
              "apCost": 1,
              "name": "Spirit Harvest",
              "shortDescription": "This champion makes a Loss of Life attack against target champion at RNG 2-5. If this destroys the champion, a Phylactery relic is summoned in the closest friendly deployment zone. ",
              "activationType": 3,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "phylactery"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 1402,
      "name": "Lichling",
      "description": "Xulos was pleased to take the Lichlings out of their ceremonial duty and put them into the field. They proved to be capable saboteurs.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Lich",
        "Spirit",
        "Undead"
      ],
      "noraCost": 53,
      "hash": "ej9Ej9Df1AF0Ae9Ag3AJ8Jj9Aeeeirjgvxzxzrqf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1308,
          "apCost": 0,
          "name": "Leverage: Lich",
          "shortDescription": "When this unit is deployed from the runedock, the next Lich that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 617,
              "apCost": 0,
              "name": "Gore",
              "shortDescription": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "gore"
            },
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        }
      ]
    },
    {
      "id": 1208,
      "name": "Light of the Circle",
      "description": "Menalaus was initially relunctant to release the Chains from Amareth's Sanctum, but after the complete destruction of an Elven village at the hands of the Hyaenid and their new Djinn allies, Outcast De'lim convinced the Throne to force Menalaus' hand.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elemental",
        "Elf"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9DG2Ae9Ae9Ag3Aj9Bj9Ceeemsuvklpwzvqf",
      "artist": "Christian Fell",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 1209,
      "name": "Light of the Circle",
      "description": "Menalaus was initially relunctant to release the Chains from Amareth's Sanctum, but after the complete destruction of an Elven village at the hands of the Hyaenid and their new Djinn allies, Outcast De'lim convinced the Throne to force Menalaus' hand.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elemental",
        "Elf"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9DG2Be9Ae9Ag3Aj9Cj9Diwzztsxxkexferf",
      "artist": "H. D. Mujica \"Andralexis\"",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 1210,
      "name": "Light of the Circle",
      "description": "Menalaus was initially relunctant to release the Chains from Amareth's Sanctum, but after the complete destruction of an Elven village at the hands of the Hyaenid and their new Djinn allies, Outcast De'lim convinced the Throne to force Menalaus' hand.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elemental",
        "Elf"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9Dg3Ae9Ae9Ag3Aj9Dj9Eeeeipyzrwknjirf",
      "artist": "Lillian \"Amberthyst\" Harter",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 257,
      "name": "Lightning Elemental",
      "description": "I've heard their whispers, Haadrim. A demon made of storms. I fear they are true. - Eehiist, Voil Queen",
      "maxRng": 4,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 82,
      "hash": "dj9Gj9Fe9Af1AG2Aj9Bj9Cj9Derhgvhithnjplgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1388,
          "apCost": 0,
          "name": "Bolt",
          "shortDescription": "When this champion successfully attacks an enemy champion, it is relocated to the nearest space to that target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "bolt"
        },
        {
          "id": 1368,
          "apCost": 0,
          "name": "Deflect: Electric",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Electric damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect_electric"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 6,
          "apCost": 0,
          "name": "Mobility",
          "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mobility"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 2245,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jolt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            },
            {
              "default": false,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 1331,
              "apCost": 0,
              "name": "Electricity Eater",
              "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_electric"
            }
          ]
        }
      ]
    },
    {
      "id": 545,
      "name": "Locust",
      "description": "We can use these insects, your Grace. Imagine what they could do to the Elf-Lands! - Faliep, Draksar Council",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 76,
      "hash": "dj9Gj9Fe9Af1Bg3Aj9Dj9Ej9Fsxquhruoqushrjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 3314,
          "apCost": 0,
          "name": "Swarm: Locust",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Locust with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1500,
              "apCost": 4,
              "name": "Locust Cloud",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 8 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Mini-locust Swarm (Opposing champions within the affected area have -2 DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "locust_swarm"
            },
            {
              "default": false,
              "id": 1,
              "apCost": 0,
              "name": "Flight",
              "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "flight"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1100,
              "apCost": 0,
              "name": "Sandstriker",
              "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            }
          ]
        }
      ]
    },
    {
      "id": 1065,
      "name": "Lodestone Armory",
      "description": "The magnetic polarity of lodestones can be released allowing allies to grab whatever weapon they need. They're utilized as walking armories.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 60,
      "hash": "ej9Cj9Be9AE8De9AG2Aj9Fj9Gyxiwfxxzkrjygpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1891,
          "apCost": 0,
          "name": "Magnetic Pulse",
          "shortDescription": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "auranegative"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 93,
          "apCost": 0,
          "name": "Vulnerability: Acid",
          "shortDescription": "When this unit takes Acid damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_acid"
        },
        {
          "id": 2475,
          "apCost": 3,
          "name": "Weapon Forger",
          "shortDescription": "Target champion within 5 spaces becomes equipped with either Heavy Crossbow, Axeman's Fate or Sunder Axe. This unit loses 5 HP. Equipment generated by this ability has a nora cost of 0.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 25,
          "iconName": "forge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            },
            {
              "default": false,
              "id": 3165,
              "apCost": 0,
              "name": "Mason's Spire",
              "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3290,
              "apCost": 0,
              "name": "Salvage Equipment",
              "shortDescription": "When an equipment or equipped champion is destroyed, this champion heals for 5 HP and gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "reclaim_materials"
            },
            {
              "default": false,
              "id": 1510,
              "apCost": 0,
              "name": "Market",
              "shortDescription": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1717,
      "name": "Lodestone Builder",
      "description": "The Falgar project first saw huge Lodestone constructs hauling large amounts of materials towards the border villages of the Stronghold. For many in the outlying villages, it was the first time they had seen such machines and abundance.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 69,
      "hash": "ej9Dj9CF0Bf1AG2AG2BJ8IJ8Jgthtfkletohgerf",
      "artist": "Shen Fei",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3225,
          "apCost": 3,
          "name": "Barricade Barrier",
          "shortDescription": "Range 3: Summon a Barricade relic in target unoccupied space and all adjacent unoccupied spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "charged_barricade"
        },
        {
          "id": 2346,
          "apCost": 0,
          "name": "Charged Barricade",
          "shortDescription": "Spend 2 charges: Summon a Barricade relic to target location within 4 spaces. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "charged_barricade"
        },
        {
          "id": 3140,
          "apCost": 3,
          "name": "Detonate Relic",
          "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 5,
          "iconName": "reclaim_materials"
        },
        {
          "id": 1493,
          "apCost": 0,
          "name": "Pathfinding",
          "shortDescription": "All friendly champions that share a race with this one have <ability value=1306>Mountaineer</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "climb"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 625,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrinegood"
            },
            {
              "default": false,
              "id": 2484,
              "apCost": 3,
              "name": "Build 'Em Tough",
              "shortDescription": "Target Construct within 2 spaces gains a rank of <ability value=1900>Tough</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "build_mine"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2993,
              "apCost": 0,
              "name": "Reclaim Materials",
              "shortDescription": "When a real friendly Construct is destroyed, you gain 3 nora. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reclaim_materials"
            },
            {
              "default": true,
              "id": 3221,
              "apCost": 3,
              "name": "Absorb Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed and this champion heals for 10 HP.  If the relic was friendly, this champion also gains +5 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "absorb_relic"
            }
          ]
        }
      ]
    },
    {
      "id": 455,
      "name": "Lodestone Construct",
      "description": "Constructed from highly magnetic rock, the Lodestone Construct attracts the metal in most weaponry.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 11,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 68,
      "hash": "dJ8HJ8Ge9Bf1Af1AJ8Jj9Aj9Bykeerzosfpluxxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1194,
          "apCost": 0,
          "name": "Equipment Boon",
          "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "buff"
        },
        {
          "id": 2717,
          "apCost": 3,
          "name": "Gravity Well",
          "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "gravitywell"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 2064,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 8 spaces gains AP through spells and abilities, it takes 4 electricity damage per AP gained.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "rebuke"
            },
            {
              "default": true,
              "id": 1891,
              "apCost": 0,
              "name": "Magnetic Pulse",
              "shortDescription": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 1683,
      "name": "Lodestone Megalith",
      "description": "Not to be outdone by the Silverclan engineers, lodestone engineers have begun experimenting with flight and channeling energy between devices.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 82,
      "hash": "ej9Dj9CF0BF0BG2AG2BJ8IJ8Jeemjrosjignexqf",
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3182,
          "apCost": 1,
          "name": "Guardian's Light",
          "shortDescription": "Target friendly champion within 5 spaces gains Magic Beam for 1 turn. If the target is a Megalith Guardian, this champion gains 1 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "guardians_light"
        },
        {
          "id": 745,
          "apCost": 0,
          "name": "Magic Eater",
          "shortDescription": "When this unit would take Magic damage, it instead recovers HP equal to half the damage that would have been dealt.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_magic"
        },
        {
          "id": 3168,
          "apCost": 0,
          "name": "Megalith Guardians",
          "shortDescription": "When this champion is deployed from the runedock, 2 Megalith Guardians are summoned in adjacent squares. At the beginning of each turn, for each Megalith Guardian within 5 spaces, this champion has +1 DMG, +1 MAX RNG and +1 DEF. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 30,
          "iconName": "megalith_guardian"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2271,
              "apCost": 0,
              "name": "Sentinel",
              "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1066,
      "name": "Long Knife Adept",
      "description": "The cut is all that matters. One clean quick slice that empties the container of its life essence. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 77,
      "hash": "ej9Cj9Be9BE8De9AG2AJ8GJ8Hqolnjwfemjwzmn",
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2251,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "combat_awareness"
        },
        {
          "id": 684,
          "apCost": 1,
          "name": "Execute",
          "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "execute"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2476,
              "apCost": 0,
              "name": "Warguard",
              "shortDescription": "When this unit takes damage from an attack or spell, that damage is reduced to 2.  After this effect occurs 5 times, this unit is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 2357,
              "apCost": 0,
              "name": "Shadowstrike",
              "shortDescription": "This champion becomes stealthed after making a basic attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2469,
              "apCost": 0,
              "name": "Elusive",
              "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "elusive"
            }
          ]
        }
      ]
    },
    {
      "id": 638,
      "name": "Lonx Adept",
      "description": "We have spoken to their shamans. If what they have taught us is true, I believe we can bring their magic to our home. - Zecar, Lonx Adept",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 73,
      "hash": "dj9Fj9EE8DG2Ae9BJ8GJ8HJ8Iqoykumwkjllyzxf",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1419,
          "apCost": 0,
          "name": "Adaptation",
          "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "adaptation"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2606,
          "apCost": 4,
          "name": "Arctic Bolt",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become <condition value=chilled>Chilled</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "iceaoe"
        },
        {
          "id": 1751,
          "apCost": 1,
          "name": "Grant: Frost Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 2353,
          "apCost": 1,
          "name": "Grant: Teleport",
          "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "grantability"
        },
        {
          "id": 3062,
          "apCost": 3,
          "name": "Shatter Summoned",
          "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            },
            {
              "default": false,
              "id": 2221,
              "apCost": 0,
              "name": "Orb of Frostfall",
              "shortDescription": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "trail_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 130,
      "name": "Lonx Ambusher",
      "description": "The Lonx are solitary creatures, elusive to the eyes of most and skilled hunters. If you feel as tho you are being watched, its already too late.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 75,
      "hash": "dj9Gj9Fe9Ae9AG2Aj9Bj9Cj9Dxoszmukekphnpfg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1019,
              "apCost": 0,
              "name": "Hidden: Arctic",
              "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 369,
      "name": "Lonx Beast Tamer",
      "description": "The beasts of the Tundra that choose to be tamed by Lonx gain many things from them, such as the warmth of a fire, and care for their wounds.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3AF0AF0BJ8IJ8Jj9Awiiipjwithpnsfg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 656,
          "apCost": 2,
          "name": "Drive",
          "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "drive"
        },
        {
          "id": 579,
          "apCost": 2,
          "name": "Invigorate",
          "shortDescription": "Target champion within 2 spaces gains 4 AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 725,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1523,
              "apCost": 0,
              "name": "Train: Defense",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains +1 DEF.  This ability costs 2 nora and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1008,
              "apCost": 4,
              "name": "Tame Beast",
              "shortDescription": "Target enemy Beast champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 2 turns. This unit is <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2667,
              "apCost": 2,
              "name": "Snow Shroud",
              "shortDescription": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 1266,
      "name": "Lonx Bounty Hunter",
      "description": "Not all Lonx have joined forces with the Jakei for the betterment of the Tundra. Some do it for pay.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 63,
      "hash": "ej9Bj9Af1Be9Be9Af1Bj9Aj9Bzmlllyirlyxigpf",
      "artist": "Christian Fell",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1433,
          "apCost": 0,
          "name": "Bounty Hunter",
          "shortDescription": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "hunter_bounty"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 2003,
          "apCost": 0,
          "name": "Mercenary",
          "shortDescription": "At the beginning of your turns you lose 2 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "cost"
        },
        {
          "id": 343,
          "apCost": 1,
          "name": "Power Attack",
          "shortDescription": "This unit makes an attack with +4 DMG.",
          "activationType": 1,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hammer"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": true,
              "id": 2669,
              "apCost": 0,
              "name": "Snowstrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1063,
              "apCost": 0,
              "name": "Kill Frenzy ",
              "shortDescription": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "furious_attacks"
            }
          ]
        }
      ]
    },
    {
      "id": 1318,
      "name": "Lonx Channeler",
      "description": "Lonx who come close to death are changed in irrevocable ways.  Many recuse themselves from others and shun all interaction, while others embrace their connection to the spirit world and use it on the field of battle.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 76,
      "hash": "ej9Gj9FG2BF0Ae9Ae9Aj9Cj9Duhgnjwolwzmnsqf",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2193,
          "apCost": 0,
          "name": "Psychic Amped",
          "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amped_psychic"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        },
        {
          "id": 2261,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 2800,
              "apCost": 0,
              "name": "Logistics: Life Siphon",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=99>Life Siphon</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1067,
      "name": "Lonx Chieftain",
      "description": "All the mistakes are there, waiting to be made.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 75,
      "hash": "ej9Cj9BF0AE8De9AG2AJ8HJ8Imwohieiipnytqo",
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 657,
          "apCost": 2,
          "name": "Relocate: Ally",
          "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": true,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 1514,
              "apCost": 0,
              "name": "Train: Assault",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=1320>Assault</ability>.  This ability costs 6 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 643,
      "name": "Lonx Defender",
      "description": "They've never seen a Lonx protect his home from invasion. They don't know savagery. - Laerik the Fierce",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8DG2Af1Bj9Aj9Bj9Ceeevojgeruvhvfg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1939,
      "name": "Lonx Defender",
      "description": "They've never seen a Lonx protect his home from invasion. They don't know savagery. - Laerik the Fierce",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9Ef1Ae9AG2BE8DJ8Jj9Aeeipqqzkpquhkpf",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broodcall",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1573,
      "name": "Lonx Facilitator",
      "description": "There are fighters, and there are those who provide support to them. Uncommonly, there are those who seek to do a bit of both.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 63,
      "hash": "ej9Cj9BE8De9BG2AG2Aj9Ej9Fsmhipwvzthnusqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3070,
          "apCost": 0,
          "name": "Savage Armaments",
          "shortDescription": "When a friendly champion with Race: Yeti, Race: Lonx, or Race: Jakei becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 2576,
          "apCost": 1,
          "name": "Throw Javelin",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "spear"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1783,
      "name": "Lonx Howler",
      "description": "Originally a method of emergency contact across long distances, the Howlers became engaged in direct combat as the Lonx fell under greater stress.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 65,
      "hash": "ej9Gj9Fg3AG2AG2Ae9Aj9Dj9Eevowfklusfexztf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 3263,
          "apCost": 1,
          "name": "Ranged Stance",
          "shortDescription": "Until this ability is activated again, this champion has -1 SPD and +3 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "ranged_stance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 3136,
              "apCost": 0,
              "name": "Empowered: Offense",
              "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_offense"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1126,
              "apCost": 0,
              "name": "Ally: Shattered Peaks",
              "shortDescription": "While there are other friendly Shattered Peaks champions in play, this champion gets +7 HP and +2 DMG. Shattered Peaks champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_sp"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 836,
      "name": "Lonx Hunt Leader",
      "description": "With the death of Gnark, the hunters had no leader. Many would rise to take his place, but only a few would prove worthy.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 75,
      "hash": "dj9Bj9Af1BG2BF0AJ8HJ8IJ8Jeeilumjtusonyzg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 867,
          "apCost": 0,
          "name": "Blessed",
          "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 2479,
              "apCost": 0,
              "name": "Improve Speed",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_speed"
            },
            {
              "default": false,
              "id": 1479,
              "apCost": 0,
              "name": "Vigorous Cry",
              "shortDescription": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 1139,
              "apCost": 3,
              "name": "Command: Dodge",
              "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "command_dodge"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            }
          ]
        }
      ]
    },
    {
      "id": 128,
      "name": "Lonx Hunter",
      "description": "Lunacy. Do you ask the dragon if the lizard is its kin? No link exists between my people and the savage Lonx. Godwin, Elder Garu",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 73,
      "hash": "dj9Gj9Fe9Ae9Af1Bj9Aj9Bj9Cerhemlnyxievfeg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1804,
          "apCost": 0,
          "name": "Hunter: Fighter",
          "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "foe_warrior"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 640,
      "name": "Lonx Hurler",
      "description": "Though seemingly primitive, the Lonx have turned the act of hurling stones into a martial art. Many hurlers have mastered form, making simple stones into deadly weapons.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 62,
      "hash": "dj9Fj9EE8DG2AF0BJ8IJ8Jj9Amsusoqhgiepuxzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 659,
          "apCost": 0,
          "name": "Attack: Rock",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rock"
        },
        {
          "id": 1137,
          "apCost": 1,
          "name": "Impact Strike",
          "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 3292,
          "apCost": 0,
          "name": "Reload",
          "shortDescription": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1706,
              "apCost": 0,
              "name": "Ammunition",
              "shortDescription": "Once this champion has made at least 2 successful attacks, its range becomes 1.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "gun"
            },
            {
              "default": false,
              "id": 1707,
              "apCost": 0,
              "name": "Ammunition",
              "shortDescription": "Once this champion has made at least 4 successful attacks, its range becomes 1.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "gun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            }
          ]
        }
      ]
    },
    {
      "id": 1738,
      "name": "Lonx Icelord",
      "description": "Where the Jakei turned towards the mystical and the arcane for their magic, the Lonx looked instead to the natural world for their power.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman",
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 80,
      "hash": "eJ8HJ8Ge9Bf1BG2Ae9BJ8GJ8Heemyzmukuzgnpn",
      "artist": "Caio Monteiro",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2819,
          "apCost": 0,
          "name": "Catalyst: Frost",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "catalyst_frost"
        },
        {
          "id": 673,
          "apCost": 3,
          "name": "Crystallize",
          "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "crystallize"
        },
        {
          "id": 1863,
          "apCost": 3,
          "name": "Freeze",
          "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "crystallize"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": true,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1320,
      "name": "Lonx Luminary",
      "description": "Though some claim the Lonx are savage beasts, few have survived against them to bear witness to the Luminary.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 69,
      "hash": "eJ8HJ8GE8DF0Ae9Ae9Bj9Ej9Feeekljwkrqzgkn",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1452,
          "apCost": 3,
          "name": "Dispel",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "dispel"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1527,
      "name": "Lonx Marauder",
      "description": "Marauders will lie in wait even in the most inhospitable of places if the situation calls for it.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9Ce9BF0Be9AG2BJ8GJ8Heerhrqzmnlrhyo",
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3029,
          "apCost": 0,
          "name": "Hunter: Crippled",
          "shortDescription": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "hunter_crippled"
        },
        {
          "id": 332,
          "apCost": 0,
          "name": "Sunder",
          "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "debuff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            }
          ]
        }
      ]
    },
    {
      "id": 1485,
      "name": "Lonx Missionary",
      "description": "\"Why would the Gods have spared us in the Separation, only to have us fall at the hand of the undead hoardes? Know that soon our tribulation shall end, and we shall be stronger for having endured it.\" - Rowan Broon, Lonx Missionary ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8IE8DF0Be9AF0Bj9Ej9Feeeepumepqsmuo",
      "artist": "Thomas Babbey",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 372,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 1994,
          "apCost": 2,
          "name": "Sermon",
          "shortDescription": "Friendly champions that share a race with this one get +1 DEF, +2 DMG and +5 HP until this champion next moves. This ability does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 323,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 2 AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 513,
      "name": "Lonx Recruiter",
      "description": "Queen J`orea knows nothing. If we are to fight, then everyone must fight together! - Vernek, Lonx Recruiter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 77,
      "hash": "dj9Dj9CG2Bf1AG2Aj9Bj9Cj9Dxinjlnsjwvsziig",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 1320,
          "apCost": 0,
          "name": "Assault",
          "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 1345,
          "apCost": 0,
          "name": "Recruit Snowcat",
          "shortDescription": "When this champion enters play a Snowcat is summoned in each of your deployment zones.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "sumsnowcat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 189,
      "name": "Lonx Shredder",
      "description": "J'orea, you worry too much ... my Lonx warriors KNOW who their enemies are -- they would never turn against our forces. -Cyren, Lonx Cheiftan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 64,
      "hash": "dj9Dj9CG2Be9Ag3Aj9Dj9Ej9Fpnnnwtqzggrsmjg",
      "artist": "Trevor Claxton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 164,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_rend"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 479,
      "name": "Lonx Snowguard",
      "description": "Our finest guardians need no armor. A quick hand can block any blade or arrow. - Gnark, Lonx warrior",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 61,
      "hash": "dJ8IJ8HF0Af1Ag3Aj9Dj9Ej9Fvfkpsjlnekukegg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1239,
          "apCost": 0,
          "name": "Lonx Guardian",
          "shortDescription": "Friendly Lonx champions that are adjacent to this champion may not be the target of ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dodge"
        },
        {
          "id": 1252,
          "apCost": 0,
          "name": "Readiness",
          "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 251,
      "name": "Lonx Striker",
      "description": "We will strike as the Jakei do, with weapons made from the tundra. - Bekier, Lonx Striker",
      "maxRng": 4,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 69,
      "hash": "dJ8JJ8IF0Bf1Bf1AJ8Jj9Aj9Bkukuvsziwfrsuzg",
      "artist": "Anthony Lopes",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 1824,
      "name": "Lonx Wanderer",
      "description": "Compared to the Jakei, pilgrimage is different for the Lonx. Lonx wandering lacks a deeply physical element, but is more spiritual.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger",
        "Shaman"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 76,
      "hash": "eJ8HJ8GG2AG2BG2Ae9Bj9Bj9Ceerzvztjirzrsqf",
      "artist": "Phu Thieu",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1081,
              "apCost": 0,
              "name": "Enlightened",
              "shortDescription": "When this champion is healed, the amount is increased by 6.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 361,
      "name": "Lost Queen",
      "description": "Her mind still rules Valdac, sire. But, her body wanders about the wastes without direction. - Xulos",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 60,
      "hash": "dj9Dj9CG2BF0Af1Bj9Aj9Bj9Cemekwvmpsosojgg",
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2678,
          "apCost": 3,
          "name": "Binding Chains",
          "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "disable"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 1220,
          "apCost": 0,
          "name": "Final Word",
          "shortDescription": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "ondeath"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1250,
              "apCost": 1,
              "name": "Ravenous Torrent",
              "shortDescription": "This champion takes 5 HP Disease damage and makes a ranged-combat, Disease attack at DMG 10 and RNG 5. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            }
          ]
        }
      ]
    },
    {
      "id": 863,
      "name": "Lower Beast of Sheoul",
      "description": "Along the River Votaev are beasts with no name. They are referred to as the Lower Beasts. These demons protect the river from invaders, striking terror in those that threaten Votaev.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 73,
      "hash": "dj9Ej9Dg3AG2BE8Dj9Ej9Fj9Geeeileirukemukg",
      "artist": "Bartek Gawel",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2193,
          "apCost": 0,
          "name": "Psychic Amped",
          "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amped_psychic"
        },
        {
          "id": 2177,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 3 charges.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "charged_spell"
        },
        {
          "id": 2261,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1656,
      "name": "M'tan, Garu Shaman",
      "description": "We are the calm brook. They are the crushing whitewater. Not all nature is peaceful. Afina Lighthander, K'thir Ranger",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 5,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 68,
      "hash": "ej9AJ8Jf1AF0BG2Af1AJ8Jj9Aeeiegrjemwoyoqf",
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 305,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 12 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "divine"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 366,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 4 HP. May target self.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 1612,
      "name": "Maeck the Unshakeable",
      "description": "The best ales are made in the mountainous region of Semmir.  Various noble families have cultivated their art for years here, and have developed fierce but cordial rivalries between them.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 81,
      "hash": "ej9AJ8JF0AF0AG2Af1AJ8HJ8Ifrhyowiwfirfepf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 3103,
          "apCost": 0,
          "name": "Drunken Revel",
          "shortDescription": "When a friendly champion becomes <condition value=intoxicated>Intoxicated</condition>, this champion gains 1 AP and +2 DMG for 2 turns. This effect stacks up to 3 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "carouse"
        },
        {
          "id": 3104,
          "apCost": 2,
          "name": "Dwarven Noble",
          "shortDescription": "This champion gains +2 DEF and Majestic 2 for 4 turns. The CD of this ability is reduced by 1 whenever a friendly Dwarf or Drunkard within 5 spaces is attacked (not including itself).",
          "activationType": 0,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "drunken_noble"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3098,
              "apCost": 0,
              "name": "Equip: St Semmir's Brew",
              "shortDescription": "This champion comes into play equipped with a St Semmir's Brew.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2712,
              "apCost": 4,
              "name": "Keg Toss",
              "shortDescription": "Area Effect 2, Range 5: All units become <condition value=intoxicated>Intoxicated</condition> for 4 turns. Opposing units take Physical damage equal to 80% of this unit's DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "special_keg"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1932,
              "apCost": 0,
              "name": "Loyalty",
              "shortDescription": "This champion gains +2 DMG and +5 HP as long as all friendly units that you own share a faction with it.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "loyalty"
            },
            {
              "default": true,
              "id": 2473,
              "apCost": 1,
              "name": "Carouse",
              "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "carouse"
            },
            {
              "default": false,
              "id": 2713,
              "apCost": 0,
              "name": "On The House",
              "shortDescription": "When a friendly champion within 5 spaces collects a Nora Globe, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special_keg"
            }
          ]
        }
      ]
    },
    {
      "id": 650,
      "name": "Mage of Lament",
      "description": "What's the bloody point of it all? Reading and writing, studies and experimentations, and for what? It's all worthless in the end... - K`arim, Lamenting Mage",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 64,
      "hash": "dj9Gj9Fe9AG2AF0AJ8HJ8IJ8Jpuvklgithpuzvzg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1724,
          "apCost": 0,
          "name": "Depression",
          "shortDescription": "Champions within 3 spaces of this unit have -2 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "debuff"
        },
        {
          "id": 1734,
          "apCost": 2,
          "name": "Drudgery",
          "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "debuff"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 161,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapsychic"
            },
            {
              "default": true,
              "id": 160,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novapsychic"
            },
            {
              "default": false,
              "id": 159,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 2 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "novapsychic"
            }
          ]
        }
      ]
    },
    {
      "id": 179,
      "name": "Magma Bunny",
      "description": "It's just a flesh burn! - Anonymous",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 61,
      "hash": "dj9Cj9BG2Ae9Ag3Aj9Dj9Ej9Ffrllrquohkeiyig",
      "artist": "Kelly Hamilton",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            },
            {
              "default": false,
              "id": 1329,
              "apCost": 0,
              "name": "Domain: Lava",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Lava.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_lava"
            },
            {
              "default": true,
              "id": 1404,
              "apCost": 0,
              "name": "Fire Feed",
              "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "eater_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1259,
              "apCost": 0,
              "name": "Split",
              "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "duplicate"
            },
            {
              "default": false,
              "id": 670,
              "apCost": 3,
              "name": "Replicate",
              "shortDescription": "Create a replica of this champion on target adjacent space. This unit loses half of its current HP (rounded down) and the replica has that amount of HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "swarm"
            }
          ]
        }
      ]
    },
    {
      "id": 489,
      "name": "Magma Elemental",
      "description": "A fiery berserker emerged from the flames of Sheoul. Its anger would be an inspiration to the Deep-Elves.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3Af1Ae9BJ8GJ8HJ8Ikuxofxmluvmpfeg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        },
        {
          "id": 3085,
          "apCost": 0,
          "name": "Sabotage: Fire",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sabotage_acid"
        },
        {
          "id": 633,
          "apCost": 2,
          "name": "Terraform: Lava",
          "shortDescription": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        },
        {
          "id": 89,
          "apCost": 0,
          "name": "Vulnerability: Frost",
          "shortDescription": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1404,
              "apCost": 0,
              "name": "Fire Feed",
              "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "eater_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3061,
              "apCost": 3,
              "name": "Solar Flare",
              "shortDescription": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1581,
      "name": "Magnepede",
      "description": "Magnepedes vary in appearance a great deal, largely due to how long they have lived and what manner of materials they have managed to attract with their magnetic field.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 68,
      "hash": "ej9Dj9Cf1Be9BG2AG2Bj9Aj9Bnwonleknhyojgrf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 1891,
          "apCost": 0,
          "name": "Magnetic Pulse",
          "shortDescription": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "auranegative"
        },
        {
          "id": 1259,
          "apCost": 0,
          "name": "Split",
          "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "duplicate"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            },
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            },
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 689,
      "name": "Magnetic Anuran",
      "description": "Although much smaller than their cousins, the Shock Toads, the Magnetic Anurans are no less deadly.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 62,
      "hash": "dJ8IJ8HF0AG2Ag3Aj9Dj9Ej9Fxtfxmjrsmhginhg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1495,
              "apCost": 3,
              "name": "Fry",
              "shortDescription": "If this champion occupies water when activating this ability, all enemy champions in water within 5 spaces take 8 Electricity damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novaelectric"
            },
            {
              "default": true,
              "id": 2245,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1891,
              "apCost": 0,
              "name": "Magnetic Pulse",
              "shortDescription": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 904,
      "name": "Magnetic Rover",
      "description": "Pewterblade didn't have the heart to say their construct was a disaster; it had no arms, no legs, and no head. Their disaster, the Magnetic Rover, would become the main transport through the Ironfist mountains.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 55,
      "hash": "dJ8HJ8Ge9Bg3AG2Bj9Cj9Dj9Eeeemjepfgpluxfg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1225,
          "apCost": 0,
          "name": "Bastion of Mobility",
          "shortDescription": "Friendly champions within 8 spaces have <ability value=6>Mobility</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mobility"
        },
        {
          "id": 805,
          "apCost": 1,
          "name": "Chain Lightning",
          "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "electric"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 139,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 2 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "novaelectric"
            },
            {
              "default": true,
              "id": 140,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaelectric"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2275,
              "apCost": 0,
              "name": "Planar Hold",
              "shortDescription": "All champions within 8 spaces, including this one, have <ability value=680>Planar Bound</ability> and <ability value=669>Earthbound</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "magnetic_hold"
            },
            {
              "default": true,
              "id": 657,
              "apCost": 2,
              "name": "Relocate: Ally",
              "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1891,
              "apCost": 0,
              "name": "Magnetic Pulse",
              "shortDescription": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 881,
      "name": "Magnus the Fallen",
      "description": "\"That's not Magnus, not anymore. That monster is not the Inquisitor who served the Stronghold. Magnus Hahndor died in Maljara and that thing took his place.\" - Zedin of the Sarnghaver\r\n\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian",
        "Human",
        "Undead"
      ],
      "noraCost": 83,
      "hash": "dj9Fj9EE8Dg3AG2Bj9Cj9Dj9Eeeeeemexqziljig",
      "artist": "Slawomir Maniak",
      "factions": [
        "Forsaken Wastes",
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2239,
          "apCost": 0,
          "name": "Corruption",
          "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 872,
          "apCost": 1,
          "name": "Hammer Throw",
          "shortDescription": "Make a magical attack with a range of 3-6, at +4 DMG against target enemy unit.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "hammer"
        },
        {
          "id": 300,
          "apCost": 0,
          "name": "Horrific Aura",
          "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "fear"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2344,
              "apCost": 0,
              "name": "Paralytic Strike",
              "shortDescription": "This champion does double damage to <condition value=paralyzed>Paralyzed</condition> champions.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3234,
              "apCost": 2,
              "name": "Truthseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=branded>Branded</condition> or <ability value=2004>Faithless</ability> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate_lightning"
            },
            {
              "default": false,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1450,
              "apCost": 4,
              "name": "Death Pact",
              "shortDescription": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "bloodbond"
            }
          ]
        }
      ]
    },
    {
      "id": 664,
      "name": "Mairdreth of the Rot",
      "description": "She is the mother of decay. She was feared in Serkan's time, when Elsarin was mortal. But, those were different times, when no one could truly appreciate the beauty of rot. - Caetian, Dark Seductress",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Dragon",
        "Undead",
        "Zombie"
      ],
      "noraCost": 92,
      "hash": "dj9Ej9Dg3Af1Be9Aj9Fj9Gj9Hzmpshirlginwxkg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1618,
          "apCost": 0,
          "name": "Desecrated Zone",
          "shortDescription": "Area Effect 2: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "terrain_dmz"
        },
        {
          "id": 1146,
          "apCost": 1,
          "name": "Disease Breath",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "diseaseaoe"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1846,
          "apCost": 0,
          "name": "Foul Strike",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, all opposing champions within 3 spaces of the target are <condition value=diseased>Diseased</condition> and <condition value=inhibited>Inhibited</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "diseaseaoe"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": false,
              "id": 2537,
              "apCost": 0,
              "name": "Revel in Misery",
              "shortDescription": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "forsaken_conduit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        }
      ]
    },
    {
      "id": 1502,
      "name": "Maleficia",
      "description": "\"They're believed to be far beyond the limits of good and evil. Power is now their only morality.\" - Inquisitor Isran",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 62,
      "hash": "ej9AJ8JG2AF0Be9Af1Aj9Bj9Ceeroyxonuqwfkpf",
      "artist": "Kirill Chepizhko",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1728,
          "apCost": 0,
          "name": "Divert",
          "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deflect"
        },
        {
          "id": 3107,
          "apCost": 3,
          "name": "Ritual of Healing",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_healing"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": false,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            },
            {
              "default": false,
              "id": 890,
              "apCost": 0,
              "name": "Grace of the Dead",
              "shortDescription": "When this unit dies, all friendly champions are healed for 6 HP. At the start of your next turn, all friendly champions are healed for 3 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "healmass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 3021,
              "apCost": 1,
              "name": "Censure",
              "shortDescription": "This champion makes a <mechanic value=lossoflife>Loss of Life</mechanic> at RNG 2-5.  If that champion is Cursed or occupies Dead Magic Zone, it takes an additional 3 Psychic damage and loses all remaining AP.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 224,
      "name": "Mandrake",
      "description": "Long past the swifwillow trees you will find the den of the Mandrake- there, young shaman, you will learn the true limit of your abilities. - Gekkit, Boghopper Shaman",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Plant"
      ],
      "noraCost": 64,
      "hash": "dJ8IJ8HF0Ae9Bf1AJ8Jj9Aj9Bjierqhrfiipluxf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2678,
          "apCost": 3,
          "name": "Binding Chains",
          "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "disable"
        },
        {
          "id": 456,
          "apCost": 2,
          "name": "Fear",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "fear"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 427,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 1807,
              "apCost": 0,
              "name": "Deafening Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "deafening_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            }
          ]
        }
      ]
    },
    {
      "id": 883,
      "name": "Mangleshell",
      "description": "\"Law? Ye be talkin to the wrong Tortun. I nary believe in laws of Admiralty. Aye, best be handin' me that purse lad 'lest I decide to end ye here.\" - Dread Pirate Mangleshell, captain of the Rotmaw",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 81,
      "hash": "dj9Gj9Fe9Ag3AE8Dj9Ej9Fj9Geeiymyztohekrhg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1433,
          "apCost": 0,
          "name": "Bounty Hunter",
          "shortDescription": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "hunter_bounty"
        },
        {
          "id": 2254,
          "apCost": 0,
          "name": "Pirate's Treasure",
          "shortDescription": "Whenever a friendly Tortun attacks, this unit gains a charge. When this unit is destroyed, an \"X\" appears on a space within 6 spaces. When a friendly champion moves into that space, it gains Recover Treasure (You gain 4 nora for every charge that was on Mangleshell when it was destroyed). ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "pirates_treasure"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 1936,
      "name": "Mangleshell",
      "description": "\"Law? Ye be talkin to the wrong Tortun. I nary believe in laws of Admiralty. Aye, best be handin' me that purse lad 'lest I decide to end ye here.\" - Dread Pirate Mangleshell, captain of the Rotmaw",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 82,
      "hash": "ej9Fj9Ee9Be9AG2BE8DJ8GJ8Hygkygvkrhpyouo",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1433,
          "apCost": 0,
          "name": "Bounty Hunter",
          "shortDescription": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "hunter_bounty"
        },
        {
          "id": 2254,
          "apCost": 0,
          "name": "Pirate's Treasure",
          "shortDescription": "Whenever a friendly Tortun attacks, this unit gains a charge. When this unit is destroyed, an \"X\" appears on a space within 6 spaces. When a friendly champion moves into that space, it gains Recover Treasure (You gain 4 nora for every charge that was on Mangleshell when it was destroyed). ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "pirates_treasure"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 1222,
      "name": "Mantid Tracker",
      "description": "\"Between the port city of Caillin and the Fetid Marsh lies vegetation hosting an incredible marvel of creatures.  The Mantid Tracker's size betrays its agility as it leaps soundlessly through the jungle.\" - Gillo's Guide to Poxanthuru",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9Fe9Ae9Be9Ae9Aj9Fj9Gjpsmuhkemjemhpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        },
        {
          "id": 2357,
          "apCost": 0,
          "name": "Shadowstrike",
          "shortDescription": "This champion becomes stealthed after making a basic attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": true,
              "id": 167,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2574,
              "apCost": 0,
              "name": "Preparation",
              "shortDescription": "At the end of each of its turns, if this unit did not attack, it has +1 DMG and +1 MAX RNG.  This effect stacks up to 4 times and is reset at the end of turn when this unit makes an attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1705,
              "apCost": 0,
              "name": "Ambush",
              "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 1608,
      "name": "Marouk of the Dunes",
      "description": "Sandkips often burrow deep beneath the dunes to reach the warmer depths. They are able to collect and store a tremendous amount of heat for both offensive and defensive uses.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8Ig3AF0AG2AF0Bj9Dj9Eeeeeevfekgeeerf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3111,
          "apCost": 1,
          "name": "Burning Sandspout",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged and is occupying Sand or is <condition value=sandblasted>Sandblasted</condition>, the target also becomes <condition value=charred>Charred</condition> for 3 turns and <condition value=inhibited>Inhibited</condition> for 5 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "sandspout"
        },
        {
          "id": 1101,
          "apCost": 4,
          "name": "Sand Spray",
          "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "sand"
        },
        {
          "id": 3110,
          "apCost": 2,
          "name": "Sirocco",
          "shortDescription": "Area Effect 5: Friendly champions occupying Sand have <ability value=2076>Reflexes 1</ability> and <ability value=1376>Evasive 1</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "sirocco"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            },
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3157,
              "apCost": 0,
              "name": "Sandbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": true,
              "id": 1228,
              "apCost": 1,
              "name": "Grant: Trail Sand",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1102>Trail: Sand</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1102,
              "apCost": 0,
              "name": "Trail: Sand",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 470,
      "name": "Marsh Gargantua",
      "description": "I will not let these atrocities continue in our swamp! I will join you, Kartch! - Moog, Marsh Gargantua",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 16,
      "hitPoints": 65,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental",
        "Plant"
      ],
      "noraCost": 108,
      "hash": "dJ8IJ8HF0Af1AE8Dj9Ej9Fj9Gemjirhkymusqszg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1248,
          "apCost": 3,
          "name": "Pull",
          "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "pull"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2624,
              "apCost": 0,
              "name": "Marsh Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aquatic"
            },
            {
              "default": true,
              "id": 2481,
              "apCost": 4,
              "name": "Cast: Hungry Mire",
              "shortDescription": "Area Effect 2, Range 4: For the next 4 turns, all spaces become Dirt and Shallow Water. When a champion without <condition value=flying>Flying</condition> enters one of these spaces, it takes 5 Physical damage and becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "hungry_mire"
            },
            {
              "default": false,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 1261,
              "apCost": 0,
              "name": "Surge: Plant",
              "shortDescription": "This unit has +1 DMG for each friendly Plant.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_plant"
            }
          ]
        }
      ]
    },
    {
      "id": 403,
      "name": "Marsh Raptor",
      "description": "Highly developed ambush hunters, a single raptor can take down prey many times its size.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "None"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 69,
      "hash": "dJ8HJ8Ge9BF0BG2Bj9Cj9Dj9Eeeeitjrowmuszzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 580,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 855,
          "apCost": 0,
          "name": "Hidden: Water",
          "shortDescription": "At the end of your turn, if this champion occupies Water, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 342,
      "name": "Marsh Troll",
      "description": "As their numbers dwindle, they join the fight to save their swamp and their kind.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Troll"
      ],
      "noraCost": 68,
      "hash": "dj9Bj9Af1BF0Af1Bj9Aj9Bj9Ceilnwvmhkepnneg",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp",
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2527,
              "apCost": 0,
              "name": "Rock Defiance",
              "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "troll_defiance"
            },
            {
              "default": true,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 2678,
              "apCost": 3,
              "name": "Binding Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            }
          ]
        }
      ]
    },
    {
      "id": 1021,
      "name": "Marsh Warden",
      "description": "\"Wardens tend to engage once a kill is certain. If you see them coming at you it's too late.\" Jin'den, Nefari Scout",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 78,
      "hash": "eJ8HJ8Gg3AE8De9Ae9Bj9Dj9Eeemsjytfvmuhto",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2371,
          "apCost": 4,
          "name": "Flash Bomb",
          "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "flash_bomb"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1129,
              "apCost": 0,
              "name": "Ally: K'thir Forest",
              "shortDescription": "While there are other friendly K'thir Forest champions in play, this champion gets +7 HP and +2 DMG. K'thir champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_kf"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 565,
      "name": "Massive Anuran",
      "description": "They're Swamp-shakers. It isn't bad when they go up, but it is when they come down. - Lugil, Boghopper Youth",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "None"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dJ8IJ8HF0Af1Bg3Aj9Dj9Ej9Fwxiipuofiinjigg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1467,
          "apCost": 4,
          "name": "Seismic Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "leap_massive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 241,
              "apCost": 0,
              "name": "Damage Shield: Poison",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Poison damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_poison"
            },
            {
              "default": false,
              "id": 3334,
              "apCost": 0,
              "name": "Sabotage: Poison",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 167,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 1094,
              "apCost": 0,
              "name": "Poison Eater",
              "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_poison"
            },
            {
              "default": false,
              "id": 3328,
              "apCost": 0,
              "name": "Hunter: Poisoned",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "poison"
            }
          ]
        }
      ]
    },
    {
      "id": 505,
      "name": "Master Axeman",
      "description": "Only a few are capable of cleaving foes, while using an axe, with such grace and ferocity. - Rugolth of Ironfist to Steofil the Axeraiser",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 64,
      "hash": "dj9Cj9BG2Af1AG2Bj9Cj9Dj9Eeemsjyiinpwxkjg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        },
        {
          "id": 1358,
          "apCost": 2,
          "name": "Summon Axe",
          "shortDescription": "Axeman's Fate equipment is removed from the nearest champion equipped with it and is then equipped to this unit. If this unit is already equipped, the currently equipped equipment is destroyed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "whirl"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            }
          ]
        }
      ]
    },
    {
      "id": 607,
      "name": "Master Trapsmith",
      "description": "Sure, I can make you a trap that can take a leg clean off. But, might I recommend something else? The best traps make them doubt they were ever caught. - Kibur, Trapsmith",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue",
        "Tinkerer"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 59,
      "hash": "dj9Cj9BG2Af1Be9Aj9Fj9Gj9Hexfgtjtuxvvvzig",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1746,
          "apCost": 1,
          "name": "Grant: Lay Trap: Fire",
          "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 2998,
          "apCost": 0,
          "name": "Lay Trap: Acid",
          "shortDescription": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "trapthorn"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 11,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 3 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 3 spaces are revealed.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 12,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1747,
              "apCost": 1,
              "name": "Grant: Frost Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1749,
              "apCost": 1,
              "name": "Grant: Lay Trap: Boulder",
              "shortDescription": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 109,
      "name": "Mastodon",
      "description": "The herds were hidden as best as possible, since frost giants thought of the mastodon like dwarves think of their cattle.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 56,
      "hash": "dj9Fj9EE8De9AG2Aj9Bj9Cj9Dgytosjwirqjnheg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 617,
          "apCost": 0,
          "name": "Gore",
          "shortDescription": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gore"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            }
          ]
        }
      ]
    },
    {
      "id": 878,
      "name": "Matriarch Sarinda",
      "description": "\"She is the Matriarch. Don't you understand...of course you don't, you haven't seen what I've seen...You will never understand. She has created worlds.\" - Ramblings of Magnus Hahndor",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 58,
      "hash": "dj9Fj9EE8Dg3Af1AJ8Jj9Aj9Bqoqojthtzgpytfg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2183,
          "apCost": 0,
          "name": "Death Toll",
          "shortDescription": "When this champion comes into play, the closest real champion you own is destroyed.  Otherwise, this champion is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -30,
          "iconName": "death_toll"
        },
        {
          "id": 2103,
          "apCost": 0,
          "name": "Deconstruct",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "merge"
        },
        {
          "id": 2184,
          "apCost": 0,
          "name": "Eradicate",
          "shortDescription": "Spend all charges. Target champion within 5 spaces loses 2 HP for each charge spent this way (up to 20 HP).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "eradicate"
        },
        {
          "id": 2362,
          "apCost": 2,
          "name": "Reclaim Remains",
          "shortDescription": "Target adjacent Stitched Remains is destroyed.  This champion gains 12 charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "reconstruct"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1426,
              "apCost": 0,
              "name": "Death Harvest",
              "shortDescription": "When a friendly non-Illusion, non-Summoned champion is destroyed, you gain up to 12% of its nora cost, to a maximum of 7. This does not stack",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 13,
              "iconName": "ondeath"
            },
            {
              "default": true,
              "id": 1009,
              "apCost": 0,
              "name": "Tariff",
              "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 2104,
              "apCost": 3,
              "name": "Reconstruct: Blackguard",
              "shortDescription": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Blackguard is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 12,
              "iconName": "reconstruct"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 3067,
              "apCost": 0,
              "name": "Psychic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "psychicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 738,
      "name": "Mauler",
      "description": "Although they share similarities with the Destroyer, the Maulers are actually closer kin to the Dragoleech. They have a close tie to Nora, although the nature of this bond is unknown.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "dj9Cj9BG2AG2AF0AJ8HJ8IJ8Jpjyxmphpsusoheg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 607,
          "apCost": 0,
          "name": "Essence Capture",
          "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "noragen"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        },
        {
          "id": 1963,
          "apCost": 0,
          "name": "Reduce Magic",
          "shortDescription": "All magical damage is reduced by 20% (after DEF). This effect does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dark_aura"
        },
        {
          "id": 1256,
          "apCost": 0,
          "name": "Sibling",
          "shortDescription": "When this champion is deployed, champions with the same name are revealed in your runedock. When you have a champion in play with the same name as this one, this champion gains +1 DEF, +1 SPD and +5 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "sibling"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 992,
      "name": "Maxxarek",
      "description": "There are many demons lurking in Sheoul, but none as powerful as Maxxarek. All who serve the Underdepths kneel before his throne.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 20,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Archdemon",
        "Demon"
      ],
      "noraCost": 98,
      "hash": "ej9Fj9EG2AE8De9AE8Dj9Bj9Ceitsqftukpnpyo",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 3099,
          "apCost": 0,
          "name": "Maxxarek's Servant",
          "shortDescription": "When this champion is deployed, the closest friendly champion gains <ability value=741>Relocate: Demon</ability>. Friendly Archdemons besides Maxxarek gain <ability value=2536>Bestow</ability> and <ability value=2753>Noble Sacrifice</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "relocate"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 2398,
          "apCost": 0,
          "name": "Sacrificial Power",
          "shortDescription": "This champion has <ability value=2399>Dark Summons</ability> and <ability value=820>Portal</ability>. When a real opposing champion is destroyed this champion's cooldowns are reduced by 10. Sheoul Disciples cost 10 less nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "sacrificial_power"
        },
        {
          "id": 2233,
          "apCost": 0,
          "name": "Stationary",
          "shortDescription": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3007,
              "apCost": 0,
              "name": "Purging Flames",
              "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dispel"
            },
            {
              "default": true,
              "id": 771,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1863,
      "name": "Maxxarek",
      "description": "There are many demons lurking in Sheoul, but none as powerful as Maxxarek. All who serve the Underdepths kneel before his throne.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 20,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Archdemon",
        "Demon"
      ],
      "noraCost": 98,
      "hash": "ej9Bj9Ag3AG2BG2Af1Bj9Dj9Eemsjpllpsxzrftf",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 3099,
          "apCost": 0,
          "name": "Maxxarek's Servant",
          "shortDescription": "When this champion is deployed, the closest friendly champion gains <ability value=741>Relocate: Demon</ability>. Friendly Archdemons besides Maxxarek gain <ability value=2536>Bestow</ability> and <ability value=2753>Noble Sacrifice</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "relocate"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 2398,
          "apCost": 0,
          "name": "Sacrificial Power",
          "shortDescription": "This champion has <ability value=2399>Dark Summons</ability> and <ability value=820>Portal</ability>. When a real opposing champion is destroyed this champion's cooldowns are reduced by 10. Sheoul Disciples cost 10 less nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "sacrificial_power"
        },
        {
          "id": 2233,
          "apCost": 0,
          "name": "Stationary",
          "shortDescription": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3007,
              "apCost": 0,
              "name": "Purging Flames",
              "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dispel"
            },
            {
              "default": true,
              "id": 771,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 996,
      "name": "Mechanical Crabs",
      "description": "\"Loose the crabs!\" - Miskle, Dwarven Tinkerer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 7,
      "hitPoints": 15,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 34,
      "hash": "ej9Gj9Fe9AE8De9Ae9Aj9Fj9Gonlrowzxtjroyo",
      "artist": "Alex Fang",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2474,
          "apCost": 0,
          "name": "Font Ignorance",
          "shortDescription": "This unit cannot contest or capture fonts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "font_ignorance"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 1596,
      "name": "Mechanized Band",
      "description": "After one hundred accusations for noise contamination, seventy-two cases of dwarven deafness, thirteen complaints for general annoyance, and one trampled child, Dimgal still insisted his invention would improve the lives of all.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Construct",
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9Fg3AF0AG2Ae9Aj9Dj9Eemjwiitmyzvfpsf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 3087,
          "apCost": 3,
          "name": "Sonic Surge",
          "shortDescription": "This champion gains 3 AP and Pacified for 1 turn.  For each space moved, enemy champions within 2 spaces take 3 Sonic damage (this damage ignores DEF).  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "charge_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 149,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1336,
              "apCost": 0,
              "name": "Fascinate",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            }
          ]
        }
      ]
    },
    {
      "id": 219,
      "name": "Menalaus",
      "description": "To fight rashly is to place the very essence of your being at the mercy of your body. To fight wisely is to arm your strength with your mind. - Menalaus, High Mage",
      "maxRng": 7,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 99,
      "hash": "dJ8IJ8HF0Ae9BE8Dj9Ej9Fj9Geigtqzzmhnymhyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 36,
          "apCost": 0,
          "name": "Immunity: Magical",
          "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "immunity_magic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 738,
          "apCost": 0,
          "name": "Shielded",
          "shortDescription": "This champion may not be the target of opposing spells",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 773,
      "name": "Menalaus",
      "description": "To fight rashly is to place the very essence of your being at the mercy of your body. To fight wisely is to arm your strength with your mind. - Menalaus, High Mage",
      "maxRng": 7,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 99,
      "hash": "dj9Dj9CG2Bf1BG2Bj9Cj9Dj9Eeevonjtjpuquzkg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 36,
          "apCost": 0,
          "name": "Immunity: Magical",
          "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "immunity_magic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 738,
          "apCost": 0,
          "name": "Shielded",
          "shortDescription": "This champion may not be the target of opposing spells",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 1373,
      "name": "Menalaus",
      "description": "To fight rashly is to place the very essence of your being at the mercy of your body. To fight wisely is to arm your strength with your mind. - Menalaus, High Mage",
      "maxRng": 7,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 99,
      "hash": "ej9Bj9AG2BF0Ae9Af1Bj9Cj9Detufevonjtmerqf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2607,
          "apCost": 1,
          "name": "Grant: Magical Aura",
          "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 36,
          "apCost": 0,
          "name": "Immunity: Magical",
          "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "immunity_magic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 738,
          "apCost": 0,
          "name": "Shielded",
          "shortDescription": "This champion may not be the target of opposing spells",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        },
        {
          "id": 2806,
          "apCost": 0,
          "name": "Winter Cheer",
          "shortDescription": "This unit is filled with Winter Cheer!",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "domain_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 1315,
      "name": "Metallic Slag",
      "description": "\"I have never studied a more fascinating creature. My every waking thought has been consumed by images of it from the moment I laid eyes on it.\" ~ Observation Notes on the Metallic Slag",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Construct",
        "Slag"
      ],
      "noraCost": 75,
      "hash": "ej9Gj9Ff1AF0Ae9Ae9AJ8Jj9Aemjwxxievfmsfpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Shattered Peaks"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2735,
          "apCost": 0,
          "name": "Distichous: IS/SP",
          "shortDescription": "When an IS champion is deployed from the runedock, this champion gains <ability value=1006>Surge: Enemy</ability> for 4 turns. When an SP champion is deployed from the runedock, this champion gains <ability value=1199>Calcify</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "distichous"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2309,
              "apCost": 0,
              "name": "Hallucinogenic",
              "shortDescription": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hallucinogenic"
            },
            {
              "default": false,
              "id": 832,
              "apCost": 0,
              "name": "Forge Hammer",
              "shortDescription": "When this champion makes a successful basic attack, the next Construct, relic or equipment deployed from the runedock costs 2 less nora.  This effect stacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "forge"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            },
            {
              "default": true,
              "id": 2549,
              "apCost": 0,
              "name": "Oozing",
              "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ooze_tap"
            }
          ]
        }
      ]
    },
    {
      "id": 1757,
      "name": "Midnight Whisper",
      "description": "While many imps prefer to cackle, some whisper, just loud enough to heard, but too quiet to be understood. The silence is excruciating.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8JF0Af1BG2Af1AJ8HJ8Iwqqwirwfklnwkpf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 2357,
          "apCost": 0,
          "name": "Shadowstrike",
          "shortDescription": "This champion becomes stealthed after making a basic attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 425,
              "apCost": 4,
              "name": "Possession",
              "shortDescription": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns, gains 2 AP and gains <ability value=1408>Chasm Walker</ability> for 4 turns. This unit gains <ability value=2474>Font Ignorance</ability> for 3 turns and becomes <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "possess"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1790,
              "apCost": 4,
              "name": "Shadow Shift",
              "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "shadow_shift"
            },
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 1404,
      "name": "Mindflayer Queen",
      "description": "Mindflayer Queens are rarely alone. They carry Mindflayer larvae in their throats, and usually have an adolescent Mindflayer along their spine. \r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Undead"
      ],
      "noraCost": 65,
      "hash": "ej9Ej9DG2AF0Ae9Ag3Aj9Bj9Ceeevvsjlpqhierf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2835,
          "apCost": 0,
          "name": "Equip: Mindflayer",
          "shortDescription": "This champion comes into play equipped with a Mindflayer. \r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2834,
          "apCost": 0,
          "name": "Mindflayer Jumper",
          "shortDescription": "When this champion is destroyed, if it is equipped with a Mindflayer, the closest friendly unequipped champion is equipped with a Mindflayer. This will only jump from the original champion one time.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3220,
              "apCost": 0,
              "name": "Mind Siphon",
              "shortDescription": "When this champion is attacked by a basic attack, it gains the upgraded abilities of the attacking champion for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "mindsiphon"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 730,
              "apCost": 1,
              "name": "Poison Sting",
              "shortDescription": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1155,
      "name": "Mindthief Creeper",
      "description": "These creatures came into being by consuming the flesh of the slain dead. Eventually, some were even able to use the abilities of the corpses it had gorged itself on. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 66,
      "hash": "ej9AJ8Jg3Ae9Ae9Af1Aj9Dj9Eeiyirhrllpuxmpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        },
        {
          "id": 2343,
          "apCost": 3,
          "name": "Paralyze",
          "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "sentry"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        },
        {
          "id": 2540,
          "apCost": 0,
          "name": "Trickster",
          "shortDescription": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            },
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 908,
      "name": "Mindwarp Frog",
      "description": "When surprised, the Mindwarp Frog excretes poisons from its skin. Although it is non-lethal, this poison is highly hallucinogenic. A single dose of the Mindwarp's poison can last for hours.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dJ8IJ8HF0Ag3Ae9BJ8GJ8HJ8Ievonevxxthierwf",
      "artist": "Bartek Gawel",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 2309,
          "apCost": 0,
          "name": "Hallucinogenic",
          "shortDescription": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hallucinogenic"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 897,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "mind_control"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            },
            {
              "default": true,
              "id": 427,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 3: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1346,
              "apCost": 3,
              "name": "Poison Charge",
              "shortDescription": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_poison"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1301,
      "name": "Minotaur Battlemage",
      "description": "\"We embrace magic and consider it a precious resource. We utilize it in an efficient manner that builds on our strength, and not frivolous pursuits like summoning magic pies.\" ~ Radwin, Minotaur Battlemage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute",
        "Wizard"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 81,
      "hash": "ej9Fj9Ee9AF0Ae9AE8Dj9Fj9Gklyrukeegronepf",
      "artist": "Christian Fell",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 295,
          "apCost": 0,
          "name": "Deflect",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect"
        },
        {
          "id": 2705,
          "apCost": 2,
          "name": "Empower",
          "shortDescription": "This champion gains <ability value=129>Magical Aura 3</ability>, <ability value=117>Regeneration 3</ability> and <ability value=1899>Scale Armor</ability> for 6 turns. The duration of this effect is decreased by 1 whenever this champion is successfully attacked.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "divine"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 766,
          "apCost": 1,
          "name": "Magical Attack",
          "shortDescription": "This unit makes a Magical attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "magic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 608,
              "apCost": 0,
              "name": "Majestic",
              "shortDescription": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "majestic"
            }
          ]
        }
      ]
    },
    {
      "id": 1299,
      "name": "Minotaur Culler",
      "description": "During the Separation, the labyrinths that the Minotaurs called home were flooded with lava. This forced the Minotaur to relocate, losing access to their network of Dimension Doors.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 70,
      "hash": "ej9Ej9Dg3Ae9Be9Ag3Aj9Dj9Eeeevkevmwzmnlrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        },
        {
          "id": 1486,
          "apCost": 0,
          "name": "Strike",
          "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2091,
              "apCost": 0,
              "name": "Dragging Attack",
              "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 2797,
              "apCost": 0,
              "name": "Logistics: Range",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +2 MAX RNG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        }
      ]
    },
    {
      "id": 1300,
      "name": "Minotaur Flamecrusher",
      "description": "The hammers wielded by the Flamecrushers are laced with the same magic that powers the Dimension Doors, allowing the Minotaurs to use the hammer as both a melee weapon and a fiery projectile.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9EE8DF0Ae9AE8Dj9Ej9Fmsqjrqhinpwqwo",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2400,
          "apCost": 4,
          "name": "Flamethrower",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "fireaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3389,
              "apCost": 0,
              "name": "Infernal Armaments",
              "shortDescription": "When a friendly champion with Race: Minotaur, Race: Demon Elf or Race: Archdemon becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1354,
      "name": "Minotaur Fury",
      "description": "You were sent to stop me? Absurd!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 62,
      "hash": "ej9AJ8JF0BF0Ae9Af1AJ8IJ8Jmwvkpfgipsztso",
      "artist": "Anthony Lopes",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1302,
      "name": "Minotaur Gladiator",
      "description": "Brawling is the cultural past-time of the Minotaurs, and the skills learned in the Pit are directly translatable to the field of combat.  Gladiators, in particular, carry with them a love for the thrill of combat.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 80,
      "hash": "ej9Fj9Ee9BF0Ae9AE8DJ8GJ8Hqwmjyiwvsusqln",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1444,
          "apCost": 0,
          "name": "Counter Attack: Melee",
          "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "counter"
        },
        {
          "id": 2660,
          "apCost": 3,
          "name": "Grappling Hook",
          "shortDescription": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "pull"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            },
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1407,
      "name": "Minotaur Insurgent",
      "description": "\"The insurgents that exist within the minotaurs are well known for their brute  strength.  Alas, it seems no one ever wants to be around them.\" -Menalaus",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 69,
      "hash": "ej9Fj9EE8DF0Be9AE8Dj9Ej9Feephyrhphpwoyo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2213,
          "apCost": 0,
          "name": "Crazed Charger",
          "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crazed_charger"
        },
        {
          "id": 2008,
          "apCost": 0,
          "name": "Liability",
          "shortDescription": "Friendly champions within 5 spaces of this champion have -1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "dampen"
        },
        {
          "id": 1312,
          "apCost": 3,
          "name": "Sweep",
          "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            },
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        }
      ]
    },
    {
      "id": 1696,
      "name": "Minotaur Mageknight",
      "description": "The Minotaurs have always favored enchantment and enhancement ahead of raw magic; they would never forgo a head-to-head fight. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight",
        "Wizard"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 79,
      "hash": "eJ8IJ8HF0Bf1AG2AF0AJ8IJ8Jevonevzrlwfeepf",
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 380,
          "apCost": 3,
          "name": "Flame Nova",
          "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novafire"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": true,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1216,
              "apCost": 0,
              "name": "Equalize",
              "shortDescription": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1536,
      "name": "Minotaur Portalwalker",
      "description": "Many Minotaur roam the underdepths, they actually rule from Cretios. The citadel was hidden away back during the great war between the Cyclops and Minotaur. Masters of dimensional magic, some Minotaur actually gain power when walking between planes. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9De9AF0Be9Ag3Aj9Fj9Geeevoyzkpsuzxqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 820,
          "apCost": 4,
          "name": "Portal",
          "shortDescription": "This unit may teleport to any deployment zone its controller controls.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "relocate"
        },
        {
          "id": 2944,
          "apCost": 0,
          "name": "Portal Walker",
          "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 771,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            }
          ]
        }
      ]
    },
    {
      "id": 1695,
      "name": "Minotaur Render",
      "description": "\"That eggshell armor won't save you -- strike to kill, or you have already lost!\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Knight"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 72,
      "hash": "eJ8IJ8HF0Af1AG2AF0AJ8HJ8Imjirzrowofrhvo",
      "artist": "Grant Griffin",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2704,
          "apCost": 0,
          "name": "Crushing Blow",
          "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "shrink"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 3192,
          "apCost": 0,
          "name": "Render",
          "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "render"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 1298,
      "name": "Minotaur Sentry",
      "description": "\"Don't be so surprised at our rebuilding, Maxxarek. We lost much during the Separation, but we do not suffer from the bureaucracy of the Bok.\" ~ Prince Malandur",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 69,
      "hash": "ej9Ej9DG2Be9Be9Ag3Aj9Cj9Dofmnnhgtxqojgrf",
      "artist": "Christian Fell",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2709,
          "apCost": 3,
          "name": "Summon: Dimension Door",
          "shortDescription": "Summon a Dimension Door relic with <ability value=2698>Dimension Door</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "deploy"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1189,
              "apCost": 0,
              "name": "Sentry",
              "shortDescription": "This unit's spell presence is increased by 3.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "sentry"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            },
            {
              "default": true,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1518,
      "name": "Minotaur Stoker",
      "description": "\"The furnaces won't stoke themselves. Lord Randgal won't be pleased if the fires grow dim.\"",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 69,
      "hash": "ej9Cj9BF0AF0Be9AG2AJ8HJ8Ieerhegrfmwvkyo",
      "artist": "Maciej Janaszek",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 767,
          "apCost": 1,
          "name": "Fire Attack",
          "shortDescription": "This unit makes a Fire attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "fire"
        },
        {
          "id": 3007,
          "apCost": 0,
          "name": "Purging Flames",
          "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dispel"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 771,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        }
      ]
    },
    {
      "id": 1687,
      "name": "Minotaur Thunderaxe",
      "description": "Minotaurs are no strangers to magic, but most prefer a more direct application of its effects.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 79,
      "hash": "ej9Ej9De9AF0BG2Ag3Aj9Fj9Geeemnjwigkpsqsf",
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3178,
          "apCost": 0,
          "name": "Equip: Thunderaxe",
          "shortDescription": "This champion comes into play equipped with a Thunderaxe. (Equipped champion has <ability value=1739>Paralytic Feedback</ability> and <ability value=3172>Chuck: Thunderaxe</ability>. If the champion is Race: Minotaur, it also gains <ability value=3251>Portal Blast</ability>)",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            }
          ]
        }
      ]
    },
    {
      "id": 749,
      "name": "Mirefolk Stalker",
      "description": "The Nefari had taken control of a village in Forglar, inhabited by the Mirefolk. However, they were forced to retreat when their captives began fighting back.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 62,
      "hash": "dj9Dj9CG2BG2AF0BJ8IJ8Jj9Akyxxolnumwtjegg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 114,
          "apCost": 0,
          "name": "Aquatic",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "aquatic"
        },
        {
          "id": 580,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 855,
          "apCost": 0,
          "name": "Hidden: Water",
          "shortDescription": "At the end of your turn, if this champion occupies Water, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            },
            {
              "default": false,
              "id": 1407,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space within 7 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "tunnel_dive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 66,
      "name": "Mirevixen",
      "description": "In Forglar, they are revered as the incarnation of water's gift of beauty to the world.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 72,
      "hash": "cj9Dj9Cj9BG2AF0Aj9Bj9Cj9Demegpumpyoqhggi",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 3235,
          "apCost": 2,
          "name": "Beckoning Guile",
          "shortDescription": "Target a space within 5 spaces. Enemy champions without <ability value=4>Iron Will</ability> within 5 spaces of the target move one space towards it.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "pull_guile"
        },
        {
          "id": 304,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "divine"
        },
        {
          "id": 2563,
          "apCost": 3,
          "name": "Flourish",
          "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 1594,
          "apCost": 0,
          "name": "Water Walker",
          "shortDescription": "This champion has <ability value=1044>Trail: Water</ability> and <ability value=2>Amphibious</ability>. At the end of each turn, all spaces within 2 spaces of this champion becomes Shallow Water for 2 turns.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "terrainwater"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 460,
              "apCost": 3,
              "name": "First Aid",
              "shortDescription": "Target adjacent friendly champion gains 5 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1462,
              "apCost": 2,
              "name": "Hydrate",
              "shortDescription": "Friendly champions within 2 spaces gain 2 AP and the spaces they are standing in turn to Water for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "terrainwater"
            },
            {
              "default": false,
              "id": 2679,
              "apCost": 4,
              "name": "Water Vortex",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 883,
              "apCost": 1,
              "name": "Tidal Wave",
              "shortDescription": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "tsunami"
            }
          ]
        }
      ]
    },
    {
      "id": 1330,
      "name": "Misshapen Boghopper",
      "description": "\"They are lost to you, Finlord!  Those touched by corruption cannot be cured, but they can certainly be used.\" ~ Timothy the Vile",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 72,
      "hash": "eJ8IJ8HE8DF0Ae9AF0Aj9Ej9Feemwkpuojyvvon",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 1441,
          "apCost": 0,
          "name": "Confuse Enemy",
          "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "confuse"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            }
          ]
        }
      ]
    },
    {
      "id": 1779,
      "name": "Mocking Toad",
      "description": "Never make eye contact.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 8,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 61,
      "hash": "ej9Gj9FF0AG2AG2Ae9AJ8HJ8Iquszolnjtsxirqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            },
            {
              "default": true,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            }
          ]
        }
      ]
    },
    {
      "id": 154,
      "name": "Moga Assault Team",
      "description": "They don't mean to fight like that do they? - Agilch, Boghopper Ranger, last words",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 73,
      "hash": "dj9AJ8Jf1Ae9AF0AJ8HJ8IJ8Jepuqssoljlemnwf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 706,
          "apCost": 1,
          "name": "Disperse",
          "shortDescription": "This champion becomes three small units: the Moga Axeman, the Moga Shieldman and the Moga Crossbowman.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "tactician"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1362,
              "apCost": 1,
              "name": "Throw Axe",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 757,
      "name": "Moga Aviator",
      "description": "To a Moga, flight is no small feat. Through history, Moga aviation has been purely Voil-based. With advances in technology, they broke free from this dependence. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 57,
      "hash": "dj9Ej9Dg3AG2Ae9BJ8GJ8HJ8Iwirwqjtsmwkgneg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 659,
          "apCost": 0,
          "name": "Attack: Rock",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rock"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 2478,
          "apCost": 0,
          "name": "Improve Range",
          "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "improve_range"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 630,
              "apCost": 1,
              "name": "Grant: Flight",
              "shortDescription": "Target champion within 5 spaces gains <condition value=flying>Flying</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "flight"
            },
            {
              "default": false,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2100,
              "apCost": 3,
              "name": "Gale",
              "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "gale"
            },
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 1394,
      "name": "Moga Babbler",
      "description": "\"I used to have a pair of red socks but they were always hungry don't you hate that I think you're right I missed them more than you or I will ever hear them singing I used to have a pair...\" Ernest, Moga Babbler's last words.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 46,
      "hash": "ej9Dj9CG2AF0Ae9AG2Bj9Bj9Cerlggyojigigvqf",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 2824,
          "apCost": 0,
          "name": "Incoherent Babbling",
          "shortDescription": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "rover_babbling"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3072,
              "apCost": 3,
              "name": "Elusive Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "dashing_dodge"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2690,
              "apCost": 4,
              "name": "Glorious Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1440,
              "apCost": 0,
              "name": "Confuse Attacker",
              "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 979,
      "name": "Moga Boom Vendor",
      "description": "Interesting fact - Boomsticks, better known as mining explosives, are one of the three main exports of Moga tribes. The other two are dried meats of dubious origin and weird rocks.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 47,
      "hash": "dj9Ej9Dg3Ag3AF0BJ8IJ8Jj9Aygytoytxtzvkwig",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 3392,
          "apCost": 0,
          "name": "Peaks Armaments",
          "shortDescription": "When a friendly champion with Race: Cyclops, Race: Voil, Race: G'hern or Race: Moga becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 2370,
          "apCost": 0,
          "name": "Train: Death Nova: Magical",
          "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=176>Death Nova: Magical 2</ability>. This ability costs 4 nora.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1510,
              "apCost": 0,
              "name": "Market",
              "shortDescription": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            }
          ]
        }
      ]
    },
    {
      "id": 275,
      "name": "Moga Cannon",
      "description": "Aim for the beastie...the little'n is just gonna hide! - Gui Atch'li, Dwarven General",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Moga"
      ],
      "noraCost": 70,
      "hash": "dj9Dj9CG2Be9Be9Aj9Fj9Gj9Houqohitfpumpqhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2099,
          "apCost": 0,
          "name": "Fire Blast",
          "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "artillery"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 837,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +2 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        }
      ]
    },
    {
      "id": 1397,
      "name": "Moga Chef",
      "description": "\"Dis here is gonna be da best soup evvahs had!\"\r\n\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 34,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 46,
      "hash": "ej9Ej9DE8DF0Ae9Ag3Aj9Ej9Fsmhrzmhrowtuqqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1145,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "diseaseaoe"
            },
            {
              "default": true,
              "id": 1146,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "diseaseaoe"
            },
            {
              "default": false,
              "id": 1144,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "diseaseaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 370,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 3 HP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "healmass"
            },
            {
              "default": true,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 388,
      "name": "Moga Creeper",
      "description": "The Ghern see the usefulness of a Moga that can hide in plain sight!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 54,
      "hash": "dj9Gj9Fe9AF0BG2Bj9Cj9Dj9Eeeerhevzxtmpshg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1017,
              "apCost": 1,
              "name": "Knockout",
              "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            }
          ]
        }
      ]
    },
    {
      "id": 1029,
      "name": "Moga Hooligan",
      "description": "\"The name hooligan is a badge of honor amongst the %&@!*@# dirtballs.\" - General Korsien report excerpt ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 50,
      "hash": "eJ8IJ8Hf1BE8De9AF0Aj9Aj9Bilwfmpljllnemn",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 205,
      "name": "Moga Hunters",
      "description": "We're dead...we're dead...we're dead. -- Silence! We're not dead yet! - Netted Boghopper Scouts",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Moga"
      ],
      "noraCost": 73,
      "hash": "dj9Gj9Fe9Ae9Bf1AJ8Jj9Aj9Byzkeekwtqzxiwzg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 846,
          "apCost": 1,
          "name": "Entangle",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "net"
        },
        {
          "id": 1804,
          "apCost": 0,
          "name": "Hunter: Fighter",
          "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "foe_warrior"
        },
        {
          "id": 815,
          "apCost": 0,
          "name": "Moga Riders",
          "shortDescription": "When this unit is destroyed, no nora globe is dropped and a Moga Trapper and a Moga Netter are with no upgrades are spawned in its place at 1/3 of their maximum health.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "rider"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 679,
              "apCost": 0,
              "name": "G'hernbound",
              "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "ghernbound"
            },
            {
              "default": true,
              "id": 88,
              "apCost": 0,
              "name": "Vulnerability: Fire",
              "shortDescription": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "vuln_fire"
            },
            {
              "default": false,
              "id": 2008,
              "apCost": 0,
              "name": "Liability",
              "shortDescription": "Friendly champions within 5 spaces of this champion have -1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "dampen"
            }
          ]
        }
      ]
    },
    {
      "id": 1705,
      "name": "Moga Inferno",
      "description": "Moga have a lopsided sense of risk versus reward.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 52,
      "hash": "ej9Bj9AE8Df1AG2Af1Bj9Ej9Fiwzoqhgvfphvvqf",
      "artist": "Grant Griffin",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3088,
          "apCost": 1,
          "name": "Flameburst",
          "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "fireaoe"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 229,
              "apCost": 0,
              "name": "Damage Shield: Fire",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 132,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            }
          ]
        }
      ]
    },
    {
      "id": 766,
      "name": "Moga Lord's Guard",
      "description": "Because of his reputation as the leader of the free Moga tribes, Dirge needs bodyguards. His guard consists of heavily-armored Moga, each carrying a large shield. They are quick, able to react to possible threats in an instant.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 7,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 57,
      "hash": "dj9Fj9EE8DG2Be9Aj9Fj9Gj9Hsmhinuzinjwiphg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1992,
          "apCost": 0,
          "name": "Dirge's Guard",
          "shortDescription": "While Dirge, Moga Lord is in play, this champion gets +5 HP, +3 DMG and Bodyguard.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "revere"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            },
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        }
      ]
    },
    {
      "id": 206,
      "name": "Moga Netter",
      "description": "No! After you release, you must hold tight! - Voil training Moga",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 58,
      "hash": "dj9Gj9Fe9Ae9Bf1Bj9Aj9Bj9Cemjwfkjymemukeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1947,
              "apCost": 0,
              "name": "Entangling Attack",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        }
      ]
    },
    {
      "id": 1038,
      "name": "Moga Razor",
      "description": "\"Someone's raided the armory! Wait is that - wha?! is that dirtball wearing armor?!\" General Korsien ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 72,
      "hash": "eJ8JJ8If1AE8De9AF0BJ8Jj9Aeeeeeieigpygnn",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2468,
          "apCost": 0,
          "name": "Buckethead's Revenge",
          "shortDescription": "When this champions health reaches 0 it is removed from play and a fearsome Buckethead spawns to rip someone's face off!",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 30,
          "iconName": "buckethead"
        },
        {
          "id": 220,
          "apCost": 0,
          "name": "Damage Shield: Physical",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Physical damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "dmgshld_physical"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2005,
              "apCost": 0,
              "name": "Careless",
              "shortDescription": "This unit loses all AP at the end of its turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 679,
              "apCost": 0,
              "name": "G'hernbound",
              "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "ghernbound"
            },
            {
              "default": false,
              "id": 1760,
              "apCost": 0,
              "name": "Impatient",
              "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "impatient"
            }
          ]
        }
      ]
    },
    {
      "id": 535,
      "name": "Moga Recruiter",
      "description": "In larger tribes, it is difficult to gather every Moga to one spot. The recruiters remedied this problem.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 69,
      "hash": "dj9Cj9BG2Ae9BG2Aj9Bj9Cj9Dqhtmnevvojtjggg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 1498,
          "apCost": 0,
          "name": "Swarm: Moga",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Moga Scout with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "swarm_moga"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 976,
              "apCost": 4,
              "name": "Battle Hymn",
              "shortDescription": "All friendly champions get <condition value=reverie>Reverie</condition> for 1 turn and recovers 2 AP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 12,
              "iconName": "dancesong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 696,
      "name": "Moga Sapper",
      "description": "The only problem was getting the ordinance on their backs. They took care of the rest. - Laaroon, Voil Captain",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 33,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 38,
      "hash": "dJ8JJ8IF0BG2Af1Bj9Aj9Bj9Ceeeeemnyxzvzmeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1105,
          "apCost": 0,
          "name": "Death Nova: Sand",
          "shortDescription": "When this champion is destroyed, all champions within 2 spaces become <condition value=blinded>Blinded</condition> for 2 turns, and all spaces within 2 spaces become Sand for 6 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovasand"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 989,
              "apCost": 0,
              "name": "Fire Volatility",
              "shortDescription": "When this unit takes fire damage, it releases a flame pulse equal to that damage, to a maximum of 12 damage, to every unit within 2 spaces. This damage ignores DEF. This unit can not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": true,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1111,
              "apCost": 1,
              "name": "Shrine Exertion",
              "shortDescription": "Your Shrine or Avatar loses 10 HP, and this champion recovers 3 AP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "shrinebad"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 151,
      "name": "Moga Scout",
      "description": "Eehiist won't be pleased ... but we simply can't hear them over the swamp noise. What if we sent the Moga? --Voil Scouts in Forglar",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 42,
      "hash": "dj9AJ8Jf1Ae9AE8Dj9Ej9Fj9Geevonjyzigpwtzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 893,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 1 space.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "mobility"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 1189,
              "apCost": 0,
              "name": "Sentry",
              "shortDescription": "This unit's spell presence is increased by 3.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "sentry"
            }
          ]
        }
      ]
    },
    {
      "id": 156,
      "name": "Moga Slinger",
      "description": "Spin. Aim. Release... Not at me you fool! - Voil training a Moga",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 56,
      "hash": "dj9AJ8Jf1Ae9Af1AJ8Jj9Aj9Bephtjlpjyvsqjyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 659,
          "apCost": 0,
          "name": "Attack: Rock",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rock"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": true,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            }
          ]
        }
      ]
    },
    {
      "id": 487,
      "name": "Moga Spark ",
      "description": "A few Moga had learned a new trick. The G`hern would soon regret their disciplinary actions.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 32,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 53,
      "hash": "dj9Ej9Dg3Af1Ae9Aj9Fj9Gj9Hmsxirwvouhvqsjg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 805,
          "apCost": 1,
          "name": "Chain Lightning",
          "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "electric"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 1355,
          "apCost": 3,
          "name": "Spark Charge",
          "shortDescription": "Until end of turn, all Electricity damage is increased by 2. This unit loses 6 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "amp_lightning"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 140,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaelectric"
            },
            {
              "default": true,
              "id": 188,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 8 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "deathnovaelec"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2244,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "jolt"
            },
            {
              "default": true,
              "id": 237,
              "apCost": 0,
              "name": "Damage Shield: Electricity",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Electricity damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_lightning"
            }
          ]
        }
      ]
    },
    {
      "id": 378,
      "name": "Moga Spellsnare",
      "description": "Some Moga gained an affinity for magic. This affinity would often lead to a violent end.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 46,
      "hash": "dj9Ej9Dg3Af1AE8Dj9Ej9Fj9Geeevxoqqsojygig",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            },
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1041,
      "name": "Moga Team 6",
      "description": "A few of the Moga Assault Teams that work well together (meaning they don't get killed or kill each other) become part of the elite Team 6. No one knows where the name came from since moga are incapable of counting past the number 2.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FF0AE8De9Ae9AJ8HJ8Itzrqhykukgvmnn",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 706,
          "apCost": 1,
          "name": "Disperse",
          "shortDescription": "This champion becomes three small units: the Moga Axeman, the Moga Shieldman and the Moga Crossbowman.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "tactician"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2710,
              "apCost": 0,
              "name": "Stat Bonus: Range",
              "shortDescription": "This champion gains +1 MAX RNG.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusrange"
            },
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            },
            {
              "default": false,
              "id": 1698,
              "apCost": 0,
              "name": "Widowmaker",
              "shortDescription": "This unit makes an attack for 0 AP against any adjacent opposing champion with 30% or less of its HP remaining.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "stab"
            }
          ]
        }
      ]
    },
    {
      "id": 153,
      "name": "Moga Trailblazer",
      "description": "Don't worry, we're safe.  We'll see Voil a long way off from up here. -Hern, Elven Ranger, last words",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 46,
      "hash": "dj9AJ8Jf1Ae9Ae9BJ8GJ8HJ8Ierzthiwtxkjpfvf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 970,
          "apCost": 0,
          "name": "Hidden: Rock",
          "shortDescription": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 791,
          "apCost": 0,
          "name": "Hidden: Vegetation",
          "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 203,
      "name": "Moga Trapper",
      "description": "Those don't look like Frog traps. -Cyrar, Elven Ranger",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 44,
      "hash": "dj9Gj9Fe9Ae9BF0AJ8HJ8IJ8Juxfmersmexkpyxf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            },
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            },
            {
              "default": true,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            }
          ]
        }
      ]
    },
    {
      "id": 155,
      "name": "Moga Trigger",
      "description": "When dawn first broke over the shallows, Galgish was surprised to find all his traps triggered yet empty.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 49,
      "hash": "dj9AJ8Jf1Ae9AF0BJ8IJ8Jj9Aeruhrftsjthnwxf",
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 1403,
          "apCost": 1,
          "name": "Latch On",
          "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "disable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            },
            {
              "default": false,
              "id": 1446,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 5 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovalava"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 534,
              "apCost": 0,
              "name": "Bile Explosion",
              "shortDescription": "When this unit is destroyed, units within 2 spaces take 5 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "deathnovaacid"
            }
          ]
        }
      ]
    },
    {
      "id": 152,
      "name": "Moga Zealot",
      "description": "I swear there was one, but he moved so fast.  It was as if the air was a flurry of knives. - Gulch, Boghopper Bull",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 37,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 52,
      "hash": "dj9AJ8Jf1Ae9Ae9Aj9Fj9Gj9Hepfrqhvxfiwmheg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 667,
          "apCost": 0,
          "name": "Surge: G'hern",
          "shortDescription": "This unit has +1 DMG for every friendly G'hern.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "surge_ghern"
        },
        {
          "id": 3375,
          "apCost": 0,
          "name": "Zealot",
          "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        }
      ]
    },
    {
      "id": 447,
      "name": "Mogahern Destroyer ",
      "description": "With an attentive Moga sitting on its shoulders, a G'hern becomes much more effective in combat.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "G'hern",
        "Moga"
      ],
      "noraCost": 70,
      "hash": "dj9Fj9EE8Df1Ae9BJ8GJ8HJ8Iiwztsqjwfilwtxf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 677,
          "apCost": 0,
          "name": "Overseer: Moga",
          "shortDescription": "Friendly units within 6 spaces are not penalized by <ability value=679>G'hernbound</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "overseermoga"
        },
        {
          "id": 332,
          "apCost": 0,
          "name": "Sunder",
          "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "debuff"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 3029,
              "apCost": 0,
              "name": "Hunter: Crippled",
              "shortDescription": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "hunter_crippled"
            },
            {
              "default": true,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 3136,
              "apCost": 0,
              "name": "Empowered: Offense",
              "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_offense"
            },
            {
              "default": false,
              "id": 3089,
              "apCost": 0,
              "name": "Initiator",
              "shortDescription": "This champion deals 4 additional damage to champions with 35 or more HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiator"
            }
          ]
        }
      ]
    },
    {
      "id": 1545,
      "name": "Moog, Marsh Gargantua",
      "description": "I will not let these atrocities continue in our swamp! I will join you, Kartch! - Moog, Marsh Gargantua",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 16,
      "hitPoints": 65,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental",
        "Plant"
      ],
      "noraCost": 108,
      "hash": "ej9Fj9EE8Df1Ae9AE8Dj9Ej9Fsmneirhvxowmepf",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1248,
          "apCost": 3,
          "name": "Pull",
          "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "pull"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2624,
              "apCost": 0,
              "name": "Marsh Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aquatic"
            },
            {
              "default": true,
              "id": 2481,
              "apCost": 4,
              "name": "Cast: Hungry Mire",
              "shortDescription": "Area Effect 2, Range 4: For the next 4 turns, all spaces become Dirt and Shallow Water. When a champion without <condition value=flying>Flying</condition> enters one of these spaces, it takes 5 Physical damage and becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "hungry_mire"
            },
            {
              "default": false,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 1261,
              "apCost": 0,
              "name": "Surge: Plant",
              "shortDescription": "This unit has +1 DMG for each friendly Plant.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_plant"
            }
          ]
        }
      ]
    },
    {
      "id": 1270,
      "name": "Moonlit Fae",
      "description": "Even in the darkness of night, nature finds a way to illuminate and reveal that which is hidden.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 70,
      "hash": "ej9Cj9BE8De9Be9AG2Aj9Ej9Fiwtuztqqlgtzgpf",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 16,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": true,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 993,
      "name": "Moragen the Lost",
      "description": "Moragen was the cruelest of Serkan's deeds. Once the greatest bard in Elsarin, her songs and poetry were unmatched. But, her music no longer holds the sun. It tears the very soul to pieces.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Bard",
        "Witch"
      ],
      "races": [
        "Human",
        "Undead",
        "Zombie"
      ],
      "noraCost": 82,
      "hash": "ej9Fj9EG2BE8De9AE8Dj9Cj9Doqohgpfpwmnlgpf",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 976,
          "apCost": 4,
          "name": "Battle Hymn",
          "shortDescription": "All friendly champions get <condition value=reverie>Reverie</condition> for 1 turn and recovers 2 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "dancesong"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2396,
          "apCost": 0,
          "name": "Siren's Song",
          "shortDescription": "Whenever an enemy champion without <ability value=4 popup=false>Iron Will</ability> that is within 5 spaces of this unit moves away from this unit, the enemy is pulled one space directly toward this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "soothserenade"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            },
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 2134,
              "apCost": 0,
              "name": "Abash",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intoxicate"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            }
          ]
        }
      ]
    },
    {
      "id": 1854,
      "name": "Moragen the Lost",
      "description": "Moragen was the cruelest of Serkan's deeds. Once the greatest bard in Elsarin, her songs and poetry were unmatched. But, her music no longer holds the sun. It tears the very soul to pieces.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Bard",
        "Witch"
      ],
      "races": [
        "Human",
        "Undead",
        "Zombie"
      ],
      "noraCost": 82,
      "hash": "ej9Bj9AE8DG2BG2Af1Bj9Ej9Fuknpnsuhkjgygrf",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 976,
          "apCost": 4,
          "name": "Battle Hymn",
          "shortDescription": "All friendly champions get <condition value=reverie>Reverie</condition> for 1 turn and recovers 2 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "dancesong"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2396,
          "apCost": 0,
          "name": "Siren's Song",
          "shortDescription": "Whenever an enemy champion without <ability value=4 popup=false>Iron Will</ability> that is within 5 spaces of this unit moves away from this unit, the enemy is pulled one space directly toward this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "soothserenade"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            },
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 2134,
              "apCost": 0,
              "name": "Abash",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intoxicate"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            }
          ]
        }
      ]
    },
    {
      "id": 840,
      "name": "Mosharn the Barricade",
      "description": "With 192 Kanen slain, including five Alphas, Mosharn is the undisputed leader of the Walls of Ailur. He received his nickname 'the Barricade' after defeating an entire pack of Kanen on his own: 29 plus their Alpha. Mosharn is Ailur's greatest warrior.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 88,
      "hash": "dj9Bj9Af1BG2BG2Aj9Bj9Cj9Dzztosmlpsonlyig",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 1702,
          "apCost": 0,
          "name": "Blockade",
          "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "blockade"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 2075,
          "apCost": 0,
          "name": "Pride of Ailur",
          "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "warriorspride"
        },
        {
          "id": 2271,
          "apCost": 0,
          "name": "Sentinel",
          "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1788,
      "name": "Mother of Frond",
      "description": "Old, slow, and weak, but never quite forgotten, neither her nor her children.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Plant"
      ],
      "noraCost": 75,
      "hash": "eJ8HJ8GF0AG2AG2Ae9BJ8HJ8Iemwmerowfpfevo",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 791,
          "apCost": 0,
          "name": "Hidden: Vegetation",
          "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 3268,
          "apCost": 0,
          "name": "Mother of Frond",
          "shortDescription": "When this champion is deployed from the runedock, Ambling Fronds in your deck are revealed and cost 5 nora less to play (this does not stack). This champion has <ability value=2471>Protective</ability> if there is at least one friendly Ambling Frond in play.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "motheroffrond"
        },
        {
          "id": 726,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2134,
              "apCost": 0,
              "name": "Abash",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intoxicate"
            },
            {
              "default": true,
              "id": 3216,
              "apCost": 0,
              "name": "Spellsurge: Spontaneous Growth",
              "shortDescription": "When this champion is deployed, Spontaneous Growth spells are revealed from your runedock.  Spontaneous Growth spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Spontaneous Growth spell is played.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2623,
              "apCost": 0,
              "name": "Anthomancy",
              "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "scry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1342,
              "apCost": 2,
              "name": "Impart",
              "shortDescription": "Target champion within 3 spaces is healed for 5 HP and gains 1 DMG. This unit loses 8 life and gains -1 DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            }
          ]
        }
      ]
    },
    {
      "id": 1627,
      "name": "Motion Sensor",
      "description": "Master Thoribald spent his entire life producing, ad nausem, one contraption. It was not until after his death that his madness would find vindication.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 0,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 39,
      "hash": "ej9Gj9Fe9BF0BG2Ae9AJ8GJ8Heekwqwoqhnwkgpf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 3124,
          "apCost": 0,
          "name": "Motion Sensor",
          "shortDescription": "When an enemy champion moves within 5 spaces, this champion permanently gains +8 SPD and this ability is removed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "motion_sensor"
        },
        {
          "id": 1276,
          "apCost": 0,
          "name": "Vengeful",
          "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 970,
              "apCost": 0,
              "name": "Hidden: Rock",
              "shortDescription": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3145,
              "apCost": 0,
              "name": "Empowered: Defense",
              "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "fragile_defense"
            },
            {
              "default": false,
              "id": 3136,
              "apCost": 0,
              "name": "Empowered: Offense",
              "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_offense"
            }
          ]
        }
      ]
    },
    {
      "id": 191,
      "name": "Mountain Garu",
      "description": "General Godwin, your cousin says he'll send reinforcements as soon as he's done fighting in the east. - Bennon, Garu Messenger",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 65,
      "hash": "dj9Cj9BG2Ae9Ae9BJ8GJ8HJ8Inpuzxinwtxxvsxf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3058,
          "apCost": 1,
          "name": "Chuck: Wood",
          "shortDescription": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "chuck_wood"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        },
        {
          "id": 2083,
          "apCost": 0,
          "name": "Trailblaze",
          "shortDescription": "All friendly champions have Brushwalker (This champion ignores movement restrictions and movement penalties imposed by Vegetation.).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 24,
              "apCost": 0,
              "name": "Berserker",
              "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "berserker"
            },
            {
              "default": false,
              "id": 25,
              "apCost": 0,
              "name": "Berserker",
              "shortDescription": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "berserker"
            }
          ]
        }
      ]
    },
    {
      "id": 169,
      "name": "Mountain Lion",
      "description": "There I was, sleeping like a cub, when suddenly I heard a terrible growl... - Godwin's cousin Dugon recounting the tale of how he lost his arm",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 71,
      "hash": "dj9Bj9Af1Be9AG2Bj9Cj9Dj9Eeemjepfpuzmyzgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2470,
          "apCost": 1,
          "name": "Howling Attack",
          "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "horrific_howl"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1063,
              "apCost": 0,
              "name": "Kill Frenzy ",
              "shortDescription": "When this champion destroys a champion with an attack, its attack costs are reset and it gains 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "furious_attacks"
            },
            {
              "default": false,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 284,
      "name": "Mountain Sentry",
      "description": "Kawwwwwww! -- Oh no! Drakies are coming! To arms!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dj9Dj9CG2Be9BG2Bj9Cj9Dj9Eeeiyrwqluhpsfig",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2459,
          "apCost": 0,
          "name": "Honorary Sigil",
          "shortDescription": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "griffin_sigil"
        },
        {
          "id": 2799,
          "apCost": 0,
          "name": "Still Life",
          "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": false,
              "id": 1763,
              "apCost": 1,
              "name": "Lift",
              "shortDescription": "Target champion gains flying, no longer engages opposing units, and cannot spend AP on movement for 2 rounds.  Whenever this champion moves, target champion moves to where this champion was.  This champion's movement costs 3 AP while target champion is Lifted.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "feather"
            },
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2773,
              "apCost": 0,
              "name": "Quest: Runner",
              "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1641,
      "name": "Mountain Slag",
      "description": "Mineral exposure in their mountain caves provides Mountain Slags with its jaggy exterior.  Without these scales, their skin would be as smooth as a baby slag's.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 68,
      "hash": "eJ8JJ8Ie9BG2AG2AF0BJ8GJ8Hqoqoqfiiggrwzo",
      "artist": "Caio Monteiro",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 2528,
          "apCost": 0,
          "name": "Ooze Tap",
          "shortDescription": "When a non-flying opposing champion within 5 spaces enters Ooze, it takes 2 Acid damage and friendly Slags occupying Ooze within 5 spaces of this unit each heal 2 HP. The damage effect of this ability does not stack and each friendly Slag can only be healed to a maximum of 6 HP from the champion entering Ooze.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 2361,
          "apCost": 0,
          "name": "Repulsion",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly away from this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "repulsion"
        },
        {
          "id": 3134,
          "apCost": 2,
          "name": "Suppression",
          "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 1121,
          "apCost": 0,
          "name": "Wind Aura",
          "shortDescription": "Champions within 5 spaces of this champion are <condition value=grounded>Grounded</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "gale"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 153,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaacid"
            },
            {
              "default": true,
              "id": 2030,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +2 DEF.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plusdefense"
            },
            {
              "default": false,
              "id": 3145,
              "apCost": 0,
              "name": "Empowered: Defense",
              "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "fragile_defense"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2545,
              "apCost": 0,
              "name": "Guarded: Slag",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Slag within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": true,
              "id": 2620,
              "apCost": 4,
              "name": "Corrosive Grenade",
              "shortDescription": "Area Effect 2, Range 5: Affected units take 8 Acid Damage and becomes <condition value=sundered>Sundered</condition> for 3 turns.  This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "acidaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1379,
      "name": "Mounted Hawkmaster",
      "description": "\"Curse these bird lovers! We will not be stopped by such peasants!\" Arturo, Hand to the Circle\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Barbarian",
        "Beast"
      ],
      "noraCost": 72,
      "hash": "ej9Cj9Be9BF0Ae9AG2AJ8GJ8Hsmwkuxferztqso",
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 887,
          "apCost": 1,
          "name": "Hawk Attack",
          "shortDescription": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "hawk_attack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            },
            {
              "default": true,
              "id": 3403,
              "apCost": 0,
              "name": "Warchief: Beast Clan",
              "shortDescription": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "beast_clan"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        }
      ]
    },
    {
      "id": 1423,
      "name": "Mounted Kinsman",
      "description": "Cast out, hated, hunted, and scorned, the twin brothers Allita and Oswald rose to power by gathering together the forgotten outcasts of other tribes.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian",
        "Beast"
      ],
      "noraCost": 83,
      "hash": "ej9Fj9EF0AF0Be9AE8DJ8HJ8Ieilwohgtxiegro",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 16,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "multiattack"
        },
        {
          "id": 862,
          "apCost": 0,
          "name": "Team",
          "shortDescription": "When this unit dies, no nora globe is dropped and it re-spawns in the same space, but gets -2 DMG, loses Multiattack and Team.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "marauder"
        },
        {
          "id": 3403,
          "apCost": 0,
          "name": "Warchief: Beast Clan",
          "shortDescription": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "beast_clan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1468,
              "apCost": 0,
              "name": "Cooperation",
              "shortDescription": "When this unit is within 5 spaces of a friendly champion, it gains <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "sibling"
            },
            {
              "default": false,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 2427,
              "apCost": 0,
              "name": "Break the Line",
              "shortDescription": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            }
          ]
        }
      ]
    },
    {
      "id": 359,
      "name": "Mounted Sauropod",
      "description": "An ancient story tells of many Sauropod dying to save a single Skeezick.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Skeezick"
      ],
      "noraCost": 73,
      "hash": "dj9Dj9CG2BF0AF0BJ8IJ8Jj9Aqqqsuxxqsmssjeg",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 1010,
          "apCost": 0,
          "name": "Skeezick Rider",
          "shortDescription": "When this unit is destroyed, no drop globe is dropped, a Skeezick Trapper with no upgrades is spawned in the location this unit occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "rider"
        },
        {
          "id": 2576,
          "apCost": 1,
          "name": "Throw Javelin",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "spear"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1126,
              "apCost": 0,
              "name": "Ally: Shattered Peaks",
              "shortDescription": "While there are other friendly Shattered Peaks champions in play, this champion gets +7 HP and +2 DMG. Shattered Peaks champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_sp"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 2126,
              "apCost": 0,
              "name": "Pin Down",
              "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 67,
      "name": "Muck Dragon",
      "description": "They are the result of Nature's anger towards those who ruin her.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 74,
      "hash": "cj9Bj9AJ8Jf1AF0AJ8Jj9Aj9Beevxxxkuzzmyiwi",
      "artist": "Shayne Bingham",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1093,
          "apCost": 1,
          "name": "Poison Cone",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "poisonaoe"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            },
            {
              "default": false,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            }
          ]
        }
      ]
    },
    {
      "id": 848,
      "name": "Mucker",
      "description": "\"Mucker\" is a term referring to any mass of swamp vegetation that is carnivorous. Boghoppers believe that muckers are the incarnation of the Swamp's anger.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Plant"
      ],
      "noraCost": 71,
      "hash": "dj9Cj9BG2AG2Bf1AJ8Jj9Aj9Bkgipyrfkuheilgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2107,
          "apCost": 0,
          "name": "Reconstitute",
          "shortDescription": "At the beginning of your turns, this champion is healed to full HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            },
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": false,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 43,
              "apCost": 0,
              "name": "Immunity: Disease",
              "shortDescription": "Disease damage that would be dealt to this unit is prevented. This unit may not become <condition value=diseased>Diseased</condition>.\r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_disease"
            },
            {
              "default": true,
              "id": 39,
              "apCost": 0,
              "name": "Immunity: Electricity",
              "shortDescription": "Electricity damage that would be dealt to this unit is prevented. This unit may not become <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_electric"
            },
            {
              "default": false,
              "id": 44,
              "apCost": 0,
              "name": "Immunity: Psychic",
              "shortDescription": "Psychic damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "immunity_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 314,
      "name": "Mud Elemental",
      "description": "It seems the G'Hern have devised a way to bring our own bog traps against us. - Boghoppper Scout",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Elemental"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0AF0Ag3Aj9Dj9Ej9Ftoqhykeitollrfg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 945,
          "apCost": 0,
          "name": "Mudsling",
          "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "disable"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2361,
              "apCost": 0,
              "name": "Repulsion",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly away from this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "repulsion"
            },
            {
              "default": true,
              "id": 2678,
              "apCost": 3,
              "name": "Binding Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 701,
      "name": "Murk Demon",
      "description": "From the veil of smoke came a slender shape. As they approached, it withdrew into the murk.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 66,
      "hash": "dj9AJ8Jf1AG2Ae9Aj9Fj9Gj9Hpjwofmhieevfkgg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1737,
          "apCost": 0,
          "name": "Ethereal",
          "shortDescription": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "ethereal"
        },
        {
          "id": 1851,
          "apCost": 0,
          "name": "Murk",
          "shortDescription": "<condition value=stealthed>Stealthed</condition> champions within 8 spaces, including this one, do not lose stealth when damaged.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 16,
          "iconName": "domain_shadows"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1790,
              "apCost": 4,
              "name": "Shadow Shift",
              "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "shadow_shift"
            },
            {
              "default": true,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": true,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1290,
      "name": "Mutant Doctor",
      "description": "\"The mutation rate increases with each passing day.  It is imperative we find that serum, Gharzard, if you want your people to survive.\" ~ Wu, Mutant Doctor",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Human",
        "Mutant"
      ],
      "noraCost": 73,
      "hash": "ej9Ej9DE8De9Be9Ag3Aj9Ej9Fkjegggigtqluoqf",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 2695,
          "apCost": 0,
          "name": "Harvest Organs",
          "shortDescription": "When this champion recovers a nora globe, it gains 3 charges and +4 MAX HP permanently.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "killing_stroke"
        },
        {
          "id": 2436,
          "apCost": 2,
          "name": "Mutate",
          "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "mutation"
        },
        {
          "id": 2188,
          "apCost": 0,
          "name": "Recharge",
          "shortDescription": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "recharge"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": true,
              "id": 1748,
              "apCost": 1,
              "name": "Grant: Poison Cloud Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=446>Lay Trap: Poison Cloud</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1287,
      "name": "Mutant Yeti",
      "description": "\"This power, which is revealed in the incomprehensible gift of mutation, has given me meaning far beyond the servitude of the Jakei could provide, Vallassa, and freed me from the oppression of the Keepers.\" - Farlrec, first of the Untouchables",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mutant",
        "Yeti"
      ],
      "noraCost": 64,
      "hash": "ej9Dj9CG2Ae9Be9AG2Bj9Bj9Ceiphkyrfxonetqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra",
        "Sundered Lands"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 2368,
          "apCost": 0,
          "name": "Mutation: Tough",
          "shortDescription": "Spend 3 charges: This champion gains a rank of <ability value=1900>Tough</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 2454,
              "apCost": 0,
              "name": "Frost Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=137>Frost Aura 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped"
            },
            {
              "default": false,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2178,
              "apCost": 0,
              "name": "Supercharged",
              "shortDescription": "This unit gains 1 charge at the start of its turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "supercharged"
            },
            {
              "default": false,
              "id": 2262,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "charged_abuse"
            },
            {
              "default": true,
              "id": 2261,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1838,
      "name": "Mutated Drake",
      "description": "Though a few Draksar finish the Change as complete dragons, its myriad effects in other species are less clear, and less final.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dragon",
        "Mutant"
      ],
      "noraCost": 78,
      "hash": "eJ8JJ8Ie9AG2BG2AF0Bj9Fj9Gqoqolyroqwkuxqf",
      "artist": "Josh Corpuz",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 658,
          "apCost": 1,
          "name": "Evolution: Mutated Drake",
          "shortDescription": "This champion has <ability value=2493>Scour 3</ability>. When this ability is activated, the granted ability cycles to <ability value=2533>Acid Acolyte</ability>, then to <ability value=2994>Vigor: Acid</ability>, then back to Scour 3.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "mutation"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 2632,
              "apCost": 0,
              "name": "Bold",
              "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "channel_defense"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            },
            {
              "default": true,
              "id": 732,
              "apCost": 0,
              "name": "Fury",
              "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 665,
      "name": "Mute Stalker",
      "description": "They were thieves and murderers, the scourge of Elsarin's streets. Now, they serve the king. - Tachrim, Dark Apprentice",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Elf",
        "Undead",
        "Zombie"
      ],
      "noraCost": 68,
      "hash": "dj9Ej9Dg3Af1Be9BJ8GJ8HJ8Iqouhvqfpfklljeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2574,
          "apCost": 0,
          "name": "Preparation",
          "shortDescription": "At the end of each of its turns, if this unit did not attack, it has +1 DMG and +1 MAX RNG.  This effect stacks up to 4 times and is reset at the end of turn when this unit makes an attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "surge"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1251,
      "name": "Mysian Lamia",
      "description": "\"Well, look at what we have here. A teeny tiny Tortun. Not so confident now, are we?\"\r\nMerin, Mysian Lamia",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard",
        "Witch"
      ],
      "races": [
        "Mirefolk",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 82,
      "hash": "ej9AJ8Je9Be9Be9Af1AJ8GJ8Hgtowxmuhnnwojn",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2397,
          "apCost": 0,
          "name": "Pawn",
          "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pawn"
        },
        {
          "id": 2271,
          "apCost": 0,
          "name": "Sentinel",
          "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2648,
          "apCost": 2,
          "name": "Shrinking Scion",
          "shortDescription": "Until this champion moves, it has +4 DMG, +1 MAX RNG, and <ability value=2503>Shrinking Gaze</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "shrink"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2389,
              "apCost": 3,
              "name": "Pain Curse",
              "shortDescription": "Opposing <condition value=cursed>Cursed</condition> champions take 5 magical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "defile_corpse"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 3398,
              "apCost": 0,
              "name": "Sanguine Sorceress",
              "shortDescription": "This champion has <ability value=607>Essence Capture</ability>. While there is a friendly champion with <ability value=3399>Lord of Strigoi</ability> in play, friendly champions with Race: Vampyre within 3 spaces of this champion gain <ability value=3151>Bloodspurt</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "greater_vampirism"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 3220,
              "apCost": 0,
              "name": "Mind Siphon",
              "shortDescription": "When this champion is attacked by a basic attack, it gains the upgraded abilities of the attacking champion for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "mindsiphon"
            }
          ]
        }
      ]
    },
    {
      "id": 1350,
      "name": "Mysian Necromancer",
      "description": "The Mysians primarily live on a penisula jutting into Lake Quietus covered in a thick fog.  It is believed that the region hosts entrances to various underwater caverns with linkages that lead all the way to the Emerald Lake.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Mirefolk",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8JE8DF0Ae9Af1Aj9Ej9Fmsfpwolgkgtjwo",
      "artist": "Dan Masso",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 3398,
          "apCost": 0,
          "name": "Sanguine Sorceress",
          "shortDescription": "This champion has <ability value=607>Essence Capture</ability>. While there is a friendly champion with <ability value=3399>Lord of Strigoi</ability> in play, friendly champions with Race: Vampyre within 3 spaces of this champion gain <ability value=3151>Bloodspurt</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "greater_vampirism"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 2701,
              "apCost": 0,
              "name": "Shadestrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrain_dmz"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": true,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            },
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        }
      ]
    },
    {
      "id": 1595,
      "name": "Mysterious Hooded Elf",
      "description": "From within the ranks of the Nefari Resurrection, a hooded figure stepped forward. He raised his hand, and with merely a glance in the direction of the forest, the enemy sprang to life, advancing forward and putting every ancient tree to the torch.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9FG2BF0AG2Ae9Aj9Cj9Dpjitxfepjykwkrf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 760,
          "apCost": 3,
          "name": "Magic Nova",
          "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novamagic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": true,
              "id": 1124,
              "apCost": 0,
              "name": "Ally: Underdepths",
              "shortDescription": "While there are other friendly Underdepths champions in play, this champion gets +7 HP and +2 DMG. Underdepths champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_ud"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 982,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            }
          ]
        }
      ]
    },
    {
      "id": 1223,
      "name": "Myx Adamant",
      "description": "It is speculated that the Matriarchs have the ability to manipulate the growth patterns of the pupae to a greater extent than seemingly possible.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Myx"
      ],
      "noraCost": 74,
      "hash": "ej9Gj9Fe9Be9Be9Ae9AJ8GJ8Hinjnsmuxqlymnn",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2490,
          "apCost": 0,
          "name": "Brood Bond",
          "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "broodbond"
        },
        {
          "id": 1199,
          "apCost": 0,
          "name": "Calcify",
          "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novaphysical"
        },
        {
          "id": 2369,
          "apCost": 0,
          "name": "Clamp",
          "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "clamp"
        },
        {
          "id": 1604,
          "apCost": 0,
          "name": "Reflection",
          "shortDescription": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "damageshield"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": true,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1836,
      "name": "Myx Bombardier",
      "description": "\"Rile them up! We want those Myx nice and spitty for the enemy.\" -- Draksar Myx herder",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Myx"
      ],
      "noraCost": 71,
      "hash": "eJ8IJ8Hg3AG2BG2AF0Aj9Dj9Eemnuzzvqhpjgkrf",
      "artist": "Caio Monteiro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3296,
              "apCost": 0,
              "name": "Zeal: Damage",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_damage"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 1401,
              "apCost": 0,
              "name": "Acidic Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_acid"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 1109,
      "name": "Myx Broodlord",
      "description": "Broodlords aren't picky eaters - anyone will do. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 83,
      "hash": "ej9Gj9FF0Be9Ae9Ae9AJ8IJ8Jietjrumpuvxzto",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 1467,
          "apCost": 4,
          "name": "Seismic Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "leap_massive"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2497,
              "apCost": 0,
              "name": "Amplify: Acid",
              "shortDescription": "Acid damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_acid"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2490,
              "apCost": 0,
              "name": "Brood Bond",
              "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "broodbond"
            },
            {
              "default": false,
              "id": 249,
              "apCost": 0,
              "name": "Damage Shield: Acid",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Acid damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_acid"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        }
      ]
    },
    {
      "id": 1515,
      "name": "Myx Coordinator",
      "description": "Coordinators are prized by the Myx for their fully developed wings, allowing them to achieve flight.  This makes them ideal as facilitators and gives them the unique role of ensuring the smooth operation of their local hive.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 63,
      "hash": "ej9Cj9BE8DF0Be9AG2Aj9Ej9Feepjwfkevoyxkpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3017,
          "apCost": 0,
          "name": "Autophobia",
          "shortDescription": "At the beginning of its turn, this champion has -4 SPD for 1 turn unless at least one friendly champion sharing a race came into play from the runedock while this champion was in play during the last 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "autophobia"
        },
        {
          "id": 2490,
          "apCost": 0,
          "name": "Brood Bond",
          "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "broodbond"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 657,
          "apCost": 2,
          "name": "Relocate: Ally",
          "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2499,
              "apCost": 5,
              "name": "Lay Myx Pupae",
              "shortDescription": "Summon a <ability value=2494>Myx Pupae</ability> relic to target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "hatch_myx_pupae"
            },
            {
              "default": false,
              "id": 2996,
              "apCost": 0,
              "name": "Lay Trap: Acid",
              "shortDescription": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 2 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "trapthorn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": false,
              "id": 1933,
              "apCost": 0,
              "name": "Coordination",
              "shortDescription": "All friendly champions within 2 spaces of this unit gain <ability value=1214>Encouraged</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 1110,
      "name": "Myx Drone",
      "description": "\"Myx Drones, just what we need...Cedd, go tell the capn' our situation just became awful.\" - Elven Ranger Griss",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 56,
      "hash": "ej9Gj9Ff1Ae9Ae9Ae9AJ8Jj9Aeigklrshipsuxo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1326,
          "apCost": 0,
          "name": "Domain: Sand",
          "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_sand"
        },
        {
          "id": 1254,
          "apCost": 0,
          "name": "Sand Veil",
          "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "terrainsand"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 395,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-2 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +2 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 394,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1 space in a straight line through non-Impeding terrain and makes a close-combat attack at +1 DMG.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 1,
              "iconName": "charge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            },
            {
              "default": true,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            }
          ]
        }
      ]
    },
    {
      "id": 1699,
      "name": "Myx Hurricane",
      "description": "The Hurricanes make up for most Myx's lack of wings with careful wind shaping. A swarm of Myx carried off into the sky is a wonderous, and absolutely terrifying, sight.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 67,
      "hash": "eJ8JJ8Ie9Af1AG2AF0Bj9Fj9Gsmsmwtxoljnuqqf",
      "artist": "Grant Griffin",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3196,
          "apCost": 0,
          "name": "Updraft",
          "shortDescription": "When this champion is deployed from the runedock, friendly champions gain <condition value=flying>Flying</condition> for 4 turns. If it shares a race with this champion or already has <condition value=flying>Flying</condition>, it also gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "tailwind"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 100,
              "apCost": 1,
              "name": "Barrage",
              "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 1,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 167,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            }
          ]
        }
      ]
    },
    {
      "id": 1797,
      "name": "Myx Incubator",
      "description": "Myx naturally mature at great speed. A hive which houses an incubator, however, can move through generations in days.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Myx"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8Ie9AG2AG2AF0Bj9Fj9Gygygpwtohkluvqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1710,
          "apCost": 0,
          "name": "Augment Creation",
          "shortDescription": "Friendly champions coming into play gain +2 DMG permanently.  This effect does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "surge"
        },
        {
          "id": 2490,
          "apCost": 0,
          "name": "Brood Bond",
          "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "broodbond"
        },
        {
          "id": 2113,
          "apCost": 2,
          "name": "Demoralizing Descant",
          "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "dreadsong"
        },
        {
          "id": 3276,
          "apCost": 5,
          "name": "Incubate: Young Myx Slasher",
          "shortDescription": "Target friendly Myx Pupae within 3 spaces is destroyed and a young Young Myx Slasher is summoned in its place.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "incubate_slasher"
        },
        {
          "id": 3275,
          "apCost": 5,
          "name": "Incubate: Young Myx Spitter",
          "shortDescription": "Target friendly Myx Pupae within 3 spaces is destroyed and a Young Myx Spitter is summoned in its place.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "incubate_spitter"
        },
        {
          "id": 2499,
          "apCost": 5,
          "name": "Lay Myx Pupae",
          "shortDescription": "Summon a <ability value=2494>Myx Pupae</ability> relic to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "hatch_myx_pupae"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1228,
              "apCost": 1,
              "name": "Grant: Trail Sand",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1102>Trail: Sand</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1108,
      "name": "Myx Matriarch",
      "description": "Wily and elusive, Matriarchs are rarely seen. They burrow into soft dunes near Hiistine, creating miles of underground tunnels to hatch their brood. Their beautiful chirping song soothes agitated Broodlords or coaxes stubborn pupae into hatching.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 74,
      "hash": "ej9Gj9FF0Ae9Ae9Ae9AJ8HJ8Ivqhkpymyohpjpn",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2490,
          "apCost": 0,
          "name": "Brood Bond",
          "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "broodbond"
        },
        {
          "id": 1879,
          "apCost": 0,
          "name": "Desert Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainsand"
        },
        {
          "id": 1229,
          "apCost": 1,
          "name": "Grant: Tunnel Sand",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1150>Tunnel: Sand 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 2499,
          "apCost": 5,
          "name": "Lay Myx Pupae",
          "shortDescription": "Summon a <ability value=2494>Myx Pupae</ability> relic to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "hatch_myx_pupae"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1101,
              "apCost": 4,
              "name": "Sand Spray",
              "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "sand"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 2479,
              "apCost": 0,
              "name": "Improve Speed",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 SPD. This ability does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_speed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            },
            {
              "default": true,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            },
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 1499,
      "name": "Myx Mindwarp",
      "description": "\"Subjects describe a darkness, but don't find it to be scary. Rather, they describe it as a comforting warmth.\" ~ Excerpt from the Doctor's Notes",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 73,
      "hash": "ej9AJ8JF0BF0Be9Af1AJ8IJ8Jepsjnnhtjgrquo",
      "artist": "Alex Konstad",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2490,
          "apCost": 0,
          "name": "Brood Bond",
          "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "broodbond"
        },
        {
          "id": 2309,
          "apCost": 0,
          "name": "Hallucinogenic",
          "shortDescription": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hallucinogenic"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 3220,
          "apCost": 0,
          "name": "Mind Siphon",
          "shortDescription": "When this champion is attacked by a basic attack, it gains the upgraded abilities of the attacking champion for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "mindsiphon"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2998,
              "apCost": 0,
              "name": "Lay Trap: Acid",
              "shortDescription": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapthorn"
            },
            {
              "default": false,
              "id": 153,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 3016,
              "apCost": 0,
              "name": "Life Siphon: Scoured",
              "shortDescription": "When this champion successfully damages a champion with <condition value=scoured>Scoured</condition> with a basic attack, it vampiric heals HP equal to half the damage dealt (rounded down).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "siphon_scoured"
            },
            {
              "default": false,
              "id": 3154,
              "apCost": 0,
              "name": "Enervating Touch",
              "shortDescription": "When this champion engages an enemy champion on its turn, that champion loses up to 2 AP and this champion gains AP equal to the amount lost. This ability can only trigger twice per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "touch_enervating"
            }
          ]
        }
      ]
    },
    {
      "id": 1107,
      "name": "Myx Sandlion",
      "description": "\"Get that damn bug before it burrows or we're in serious trouble!\" - Inquisitor Tord\r\n",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9Fe9Be9Ae9Ae9AJ8GJ8Hkgkwfpjtzrqqln",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 2491,
          "apCost": 0,
          "name": "Scour",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
          "activationType": 1,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "scour"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1907,
              "apCost": 0,
              "name": "Desert Camouflage",
              "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Sand, that damage by is reduced by 2.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "camo"
            },
            {
              "default": false,
              "id": 2490,
              "apCost": 0,
              "name": "Brood Bond",
              "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "broodbond"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 1728,
      "name": "Myx Sandsnipe",
      "description": "Due to the variety of Myx, the anatomy and capabilities of many Myx are not well known.  For awhile, the Sandsnipes were thought to prefer melee combat!\r\n",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Myx"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9Fe9Bf1BG2Ae9AJ8GJ8Hmwvshillexohkpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 2491,
          "apCost": 0,
          "name": "Scour",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
          "activationType": 1,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "scour"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1907,
              "apCost": 0,
              "name": "Desert Camouflage",
              "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Sand, that damage by is reduced by 2.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "camo"
            },
            {
              "default": false,
              "id": 2490,
              "apCost": 0,
              "name": "Brood Bond",
              "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "broodbond"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 1181,
      "name": "Myx Slasher",
      "description": "The Myx Slasher is a patient hunter, sitting still for days at a time. Once it pounces, however, it cares not who notices its destruction.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 12,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Myx"
      ],
      "noraCost": 62,
      "hash": "ej9Dj9CF0Ae9Ae9AG2BJ8HJ8Ijykepsmhigykwo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2490,
          "apCost": 0,
          "name": "Brood Bond",
          "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "broodbond"
        },
        {
          "id": 1099,
          "apCost": 0,
          "name": "Hidden: Sand",
          "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 2572,
          "apCost": 0,
          "name": "Spur",
          "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "spur"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 2690,
              "apCost": 4,
              "name": "Glorious Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1221,
      "name": "Myx Spitter",
      "description": "While Spitters are generally considered by the Arthromancers to be Sandsnipes that hatched prematurely, it'd be a mistake to take them lightly.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Myx"
      ],
      "noraCost": 69,
      "hash": "ej9Gj9FE8De9Be9Ae9Aj9Ej9Fofephthpnsfpyo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2486,
          "apCost": 3,
          "name": "Blind",
          "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "blind"
        },
        {
          "id": 2490,
          "apCost": 0,
          "name": "Brood Bond",
          "shortDescription": "Friendly Myx Pupae hatch 1 turn faster (to a minimum of 2 turns) while this unit is in play. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "broodbond"
        },
        {
          "id": 1212,
          "apCost": 0,
          "name": "Dissipate",
          "shortDescription": "Ranged attacks made by this champion have a penalty of -2 DMG for each space the target is beyond the champion's minimum range (to a maximum of -4 DMG).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "arrow"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            },
            {
              "default": false,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 1754,
      "name": "Naria Flamewillow",
      "description": "What does it mean to protect nature, when nature itself is so unnaturally cruel?",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Plant",
        "Treefolk",
        "Vampyre"
      ],
      "noraCost": 70,
      "hash": "eJ8JJ8If1Af1BG2AF0BJ8Jj9Aeeeeeinszirwoqf",
      "artist": "Rogier van de Beek",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3244,
          "apCost": 1,
          "name": "Conduit: Damage",
          "shortDescription": "Target enemy champion within 5 spaces has -2 DMG and the closest friendly champion to the target (including this one) has +2 DMG until targets change or the target is destroyed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "conduit_damage"
        },
        {
          "id": 3242,
          "apCost": 2,
          "name": "Conduit: HP",
          "shortDescription": "Target enemy champion within 5 spaces loses 6 HP and the closest friendly champion to the target (including this one) vampiric heals for 6 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "conduit_hp"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            },
            {
              "default": true,
              "id": 1011,
              "apCost": 0,
              "name": "Torch",
              "shortDescription": "When an enemy champion is healed, the source of the healing loses HP equal to 25% of the total amount healed. If that source is a spell, all champions affected take the damage. This effect does not stack.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "cataclysm"
            },
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1759,
      "name": "Naria Mindtap",
      "description": "\"And then I felt a haze fall over me, a comfortable haze... when I recovered, there I was, back at camp. And my arm was missing.\" -- Elvish border patrol",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk",
        "Vampyre"
      ],
      "noraCost": 74,
      "hash": "ej9AJ8JG2Bf1BG2Af1Aj9Cj9Dowzxoftosusolrf",
      "artist": "Caio Monteiro",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3245,
          "apCost": 0,
          "name": "Conduit: Speed",
          "shortDescription": "Target enemy champion within 5 spaces has -1 SPD and the closest friendly champion to the target (including this one) has +1 SPD until targets change or the target is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "conduit_speed"
        },
        {
          "id": 3261,
          "apCost": 2,
          "name": "Mind Lock",
          "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "mind_lock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            },
            {
              "default": false,
              "id": 2629,
              "apCost": 0,
              "name": "Blood Dispersal",
              "shortDescription": "When this champion successfully damages a <condition value=bloodied>Bloodied</condition> champion with a basic attack, friendly champions within 6 spaces of it are healed for the same amount, divided evenly among damaged champions, to a minimum of 1 and a maximum 6.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        }
      ]
    },
    {
      "id": 1755,
      "name": "Naria Queen",
      "description": "Royalty and primacy are one and the same to those for whom survival is everything.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 2,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk",
        "Vampyre"
      ],
      "noraCost": 86,
      "hash": "eJ8JJ8IG2Af1BG2AF0Bj9Bj9Ceeeeevzxojeexqf",
      "artist": "Rogier van de Beek",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3243,
          "apCost": 0,
          "name": "Conduit Mastery",
          "shortDescription": "When a friendly champion is affected by a friendly Conduit ability, this champion also gains the same effect. If the effect is a buff, it lasts for 6 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit_mastery"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1241,
          "apCost": 0,
          "name": "Motivate",
          "shortDescription": "All other friendly champions have +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "allybuffs"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            },
            {
              "default": true,
              "id": 2629,
              "apCost": 0,
              "name": "Blood Dispersal",
              "shortDescription": "When this champion successfully damages a <condition value=bloodied>Bloodied</condition> champion with a basic attack, friendly champions within 6 spaces of it are healed for the same amount, divided evenly among damaged champions, to a minimum of 1 and a maximum 6.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 3156,
              "apCost": 3,
              "name": "Drain Vitality",
              "shortDescription": "For 6 turns, target champion has -5 DMG and -2 SPD and the closest 3 friendly champions gain +2 DMG and +1 SPD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "drain"
            }
          ]
        }
      ]
    },
    {
      "id": 1758,
      "name": "Naria Ragevine",
      "description": "The Naria have a great passion for nature and life, so long as it's their own.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Plant",
        "Treefolk",
        "Vampyre"
      ],
      "noraCost": 70,
      "hash": "ej9AJ8JG2Af1BG2Af1Aj9Bj9Ceigrwmuvmnnjgrf",
      "artist": "Caio Monteiro",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 3244,
          "apCost": 1,
          "name": "Conduit: Damage",
          "shortDescription": "Target enemy champion within 5 spaces has -2 DMG and the closest friendly champion to the target (including this one) has +2 DMG until targets change or the target is destroyed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "conduit_damage"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": true,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            },
            {
              "default": false,
              "id": 732,
              "apCost": 0,
              "name": "Fury",
              "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3332,
              "apCost": 1,
              "name": "Vine Whip",
              "shortDescription": "This champion makes a Physical attack at RNG 2-5. If the target is occupying Vegetation, <condition value=ensnared>Ensnared</condition> or <condition value=rooted>Rooted</condition> and is successfully damaged, the target also becomes <condition value=burred>Burred</condition> for 3 turns and <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "drive"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1752,
      "name": "Naria Seedling",
      "description": "The Seared Forest has been scarred and torn for so long that it has finally given birth to its own original inhabitants, who want to live at any price.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 7,
      "hitPoints": 37,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Plant",
        "Treefolk",
        "Vampyre"
      ],
      "noraCost": 54,
      "hash": "eJ8JJ8Ie9Bf1BG2AF0BJ8GJ8Hmsmsmpuonheexo",
      "artist": "Rogier van de Beek",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 3241,
          "apCost": 0,
          "name": "Conduit Watcher",
          "shortDescription": "The first time each a turn a friendly champion activates a Conduit: X ability, this champion gains +2 MAX HP permanently and 1 AP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "conduit_watcher"
        },
        {
          "id": 12,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 4 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 4 spaces are revealed.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "detection"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3332,
              "apCost": 1,
              "name": "Vine Whip",
              "shortDescription": "This champion makes a Physical attack at RNG 2-5. If the target is occupying Vegetation, <condition value=ensnared>Ensnared</condition> or <condition value=rooted>Rooted</condition> and is successfully damaged, the target also becomes <condition value=burred>Burred</condition> for 3 turns and <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "drive"
            },
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1084,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plantregen"
            },
            {
              "default": true,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1793,
      "name": "Naria Strangler",
      "description": "Lust needs no language -- neither does violence, or pain. Though wordless, the Naria speak in the ways of the forest, stone, and fire.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Plant",
        "Treefolk",
        "Vampyre"
      ],
      "noraCost": 78,
      "hash": "eJ8IJ8HF0AG2AG2AF0AJ8HJ8Iiljlexiepfvxzo",
      "artist": "Markus Erdt",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 3273,
          "apCost": 2,
          "name": "Conduit: Upgrade",
          "shortDescription": "Target enemy champion within 5 spaces loses its highest cost upgrade ability and the closest friendly champion gains that ability until targets change. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "conduit_upgrade"
        },
        {
          "id": 2942,
          "apCost": 0,
          "name": "Masochist",
          "shortDescription": "Whenever this champion is successfully attacked, it regenerates 2 health ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "drive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3363,
              "apCost": 0,
              "name": "Bloodlust",
              "shortDescription": "This champion deals 30% additional damage to Bloodied champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2626,
              "apCost": 0,
              "name": "Scrapper",
              "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "scrapper"
            },
            {
              "default": true,
              "id": 1947,
              "apCost": 0,
              "name": "Entangling Attack",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            },
            {
              "default": true,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 68,
      "name": "Necromancer",
      "description": "Raising the dead is a most attractive quality. - Xulos, Apprentice to Serkan",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 70,
      "hash": "cJ8IJ8HJ8Ge9BG2BJ8GJ8HJ8Ievxouoyknsftuqh",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 550,
          "apCost": 0,
          "name": "Attack: Red Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "electric"
        },
        {
          "id": 431,
          "apCost": 4,
          "name": "Summon: Skeleton",
          "shortDescription": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "sumskel"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3023,
              "apCost": 0,
              "name": "Surge: Cursed",
              "shortDescription": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_cursed"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            }
          ]
        }
      ]
    },
    {
      "id": 69,
      "name": "Necrotaur",
      "description": "The only thing more frightening than a living dragon is a dead one.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dragon",
        "Undead",
        "Zombie"
      ],
      "noraCost": 75,
      "hash": "cj9Gj9Fj9EE8DG2Bj9Ej9Fj9Geeitsfemsjgkymj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1146,
          "apCost": 1,
          "name": "Disease Breath",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "diseaseaoe"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1924,
              "apCost": 0,
              "name": "Revere: Mairdreth of the Rot",
              "shortDescription": "While this champion is in play, Mairdreth of the Rot costs 10% less nora to deploy. If Mairdreth of the Rot is in play, this champion gains <ability value=973>Afflict 2</ability> and <ability value=2537>Revel in Misery</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            },
            {
              "default": false,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 2537,
              "apCost": 0,
              "name": "Revel in Misery",
              "shortDescription": "When an opposing champion with <condition value=cursed>Cursed</condition>, Hexed or <condition value=diseased>Diseased</condition> is damaged by an attack, this champion heals for 25% of the damage dealt (to a minimum of 3).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "forsaken_conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 15,
      "name": "Nectar Fairy",
      "description": "Sometimes, the most dangerous enemies can be those that are ignored.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 61,
      "hash": "bJ8IJ8HJ8Ge9BJ8GJ8HJ8IJ8Jjnhykjplgrfiluk",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 592,
          "apCost": 3,
          "name": "Cleanse",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "cleanse"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 367,
          "apCost": 3,
          "name": "Heal Champion",
          "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2134,
              "apCost": 0,
              "name": "Abash",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intoxicate"
            },
            {
              "default": false,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            },
            {
              "default": true,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 1118,
      "name": "Needleclaw Imp",
      "description": "\"Steer clear of those bastards. Their claws cut through bone as if it were butter.\" - Dwarven Seargent Slateslab\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Imp"
      ],
      "noraCost": 76,
      "hash": "eJ8HJ8GF0Ae9Ae9Ae9BJ8HJ8Ieilnetzxiirsxm",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1433,
          "apCost": 0,
          "name": "Bounty Hunter",
          "shortDescription": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "hunter_bounty"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        }
      ]
    },
    {
      "id": 1587,
      "name": "Nefari Beastcaller",
      "description": "The Nefari have taken to keeping young Grundelwulf as pets. Grown Grundelwulf will have none of it, though.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 68,
      "hash": "ej9Ej9DG2Ae9BG2Ag3Aj9Bj9Ceeekrzonegyvqsf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3083,
          "apCost": 0,
          "name": "Pet: Grundelwulf Pup",
          "shortDescription": "When this champion is deployed, a Grundelwulf Pup with no upgrades is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "pet"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1070,
      "name": "Nefari Caverunner",
      "description": "\"This way quickly, they won't expect this.\" - Rikachi, Caverunner",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 72,
      "hash": "ej9Cj9Bf1BE8De9AG2Aj9Aj9Bufrhnwqwqzvfgpf",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 772,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "fireaoe"
        },
        {
          "id": 2371,
          "apCost": 4,
          "name": "Flash Bomb",
          "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "flash_bomb"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            },
            {
              "default": false,
              "id": 3389,
              "apCost": 0,
              "name": "Infernal Armaments",
              "shortDescription": "When a friendly champion with Race: Minotaur, Race: Demon Elf or Race: Archdemon becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 125,
      "name": "Nefari Dragon",
      "description": "Where do we fly in the depths of the world, you ask? Wouldn't you like to know? Dour Lin, Deep Elf Explorer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Dragon"
      ],
      "noraCost": 72,
      "hash": "dJ8IJ8HF0Ae9Ae9Aj9Fj9Gj9Hekwmsquososxmyg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 910,
          "apCost": 0,
          "name": "Amplify: Fire",
          "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amp_fire"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            }
          ]
        }
      ]
    },
    {
      "id": 540,
      "name": "Nefari Fireslinger",
      "description": "Burn them! Leave no one alive. They will serve us better as ash. - M`ortyr, Fireslinger",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 80,
      "hash": "dj9Gj9Fe9Af1BF0AJ8HJ8IJ8Jumetjepnyrwkrzg",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1494,
          "apCost": 0,
          "name": "Escalation",
          "shortDescription": "This champion gains +1 DMG at the beginning of its owner's turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge"
        },
        {
          "id": 773,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fireaoe"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            },
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        }
      ]
    },
    {
      "id": 1071,
      "name": "Nefari Griefbearer",
      "description": "\"How can you know pain... Yes all of them! I see where they hide and scheme, plot and chatter! Demand pain, or you are unworthy of life. They will be mine!\" - Griefbearer mutterings",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 68,
      "hash": "ej9Cj9BG2AE8De9AG2Aj9Bj9Ceerlnlgtfxqzkpf",
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1452,
          "apCost": 3,
          "name": "Dispel",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "dispel"
        },
        {
          "id": 1349,
          "apCost": 2,
          "name": "Relieve",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and all effects removed are applied to this unit.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "cleanse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": true,
              "id": 1469,
              "apCost": 0,
              "name": "Nexus Aura",
              "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "nexus_aura"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 752,
      "name": "Nefari Griefsinger",
      "description": "The Griefbearers believe that they are meant to bear the suffering of their exile from K'thir. The Griefsingers intone this suffering, to share this pain with whoever happens to hear it.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 62,
      "hash": "dj9Dj9CG2BG2AG2Aj9Bj9Cj9Dsuqlljeiwmjlrjg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2260,
          "apCost": 0,
          "name": "Pariah",
          "shortDescription": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "possess"
        },
        {
          "id": 3189,
          "apCost": 1,
          "name": "Sonicburst",
          "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "sonicaoe"
        },
        {
          "id": 97,
          "apCost": 0,
          "name": "Soulburst",
          "shortDescription": "When this unit is destroyed, it deals 20 Magical damage to each champion within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "deathnovamagic"
        },
        {
          "id": 1534,
          "apCost": 0,
          "name": "Spell Resistance",
          "shortDescription": "This unit takes 50% less damage from spells.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "spell_resistance"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        },
        {
          "id": 1976,
          "apCost": 3,
          "name": "Wail of Grief",
          "shortDescription": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 149,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            },
            {
              "default": true,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 2824,
              "apCost": 0,
              "name": "Incoherent Babbling",
              "shortDescription": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "rover_babbling"
            }
          ]
        }
      ]
    },
    {
      "id": 352,
      "name": "Nefari Guardian",
      "description": "Underdepths of land so scarred; Through the halls of Demon Kings; Lay in wait Nefari Guard; To protect yet darker things.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 8,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 62,
      "hash": "dj9Cj9BG2AF0AG2Aj9Bj9Cj9Dhiphruxqzitmlgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 877,
          "apCost": 0,
          "name": "Bodyguard",
          "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "block"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2678,
              "apCost": 3,
              "name": "Binding Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        }
      ]
    },
    {
      "id": 1653,
      "name": "Nefari Informant",
      "description": "\"It's been more than fifty years, but the Circle shall pay for abandoning us. Their grove will bleed fire and flicker with blood.\" ~ Midari, Nefari Informant",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 63,
      "hash": "eJ8JJ8IF0BF0BG2AF0BJ8IJ8Jeeeepuhroufegpf",
      "artist": "Rogier van de Beek",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3155,
          "apCost": 3,
          "name": "Declare Vengeance",
          "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "declare_vengeance"
        },
        {
          "id": 1354,
          "apCost": 0,
          "name": "Sneak",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "stealth"
        },
        {
          "id": 1263,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3097,
              "apCost": 2,
              "name": "Toss Equipment",
              "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 321,
      "name": "Nefari Messenger",
      "description": "Sometimes it takes more than mere words to get our message across...",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 75,
      "hash": "dJ8JJ8IF0BF0Af1Bj9Aj9Bj9Ceeeeeitsxxfvszg",
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 3358,
          "apCost": 0,
          "name": "Scolding Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target becomes <condition value=scolded>Scolded</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "attack_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1237,
              "apCost": 0,
              "name": "Impenetrable",
              "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 22,
      "name": "Nefari Reaper",
      "description": "To a reaper, every foe is a stalk of grain.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 64,
      "hash": "cj9Ej9Dj9CG2Bf1Aj9Cj9Dj9Eeeeevftqjnpnplj",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 2250,
              "apCost": 3,
              "name": "Scythe Whirl",
              "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "scythe_wirlwind"
            }
          ]
        }
      ]
    },
    {
      "id": 1509,
      "name": "Nefari Schemer",
      "description": "\"Bring the fool before me. I will show him the meaning of Nefari justice.\"",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 75,
      "hash": "ej9Bj9AF0BF0Be9Af1BJ8IJ8Jeekruqhvfmnlyo",
      "artist": "Alex Konstad",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3086,
          "apCost": 0,
          "name": "Disbelief",
          "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1248,
              "apCost": 3,
              "name": "Pull",
              "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "pull"
            },
            {
              "default": true,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": false,
              "id": 3039,
              "apCost": 4,
              "name": "Take Prisoner",
              "shortDescription": "Target enemy champion within 3 spaces with 10 or less current HP is Possessed. That champion has <ability value=2005>Careless</ability> and <ability value=877>Bodyguard</ability> while Possessed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "take_prisoner"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 1585,
      "name": "Nefari Shockbow",
      "description": "The Nefari have more at their disposal than most realize, including artisans who craft elementally charged arrows.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9DF0Be9BG2Ag3AJ8IJ8Jofigkjytmnnyxqf",
      "artist": "Markus Erdt",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 2126,
          "apCost": 0,
          "name": "Pin Down",
          "shortDescription": "This unit makes an attack at RNG 2-5 at 50% DMG. If the target is successfully damaged, it becomes <condition value=rooted>Rooted</condition> for 2 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "pindown"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 309,
      "name": "Nefari Siphon",
      "description": "Of course the flames have Nora... -- Then why do you need sacrifice? -- The flames need encouragement to give their bounty. - Priestess Nefarra",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 69,
      "hash": "dj9Fj9EE8DF0AF0AJ8HJ8IJ8Jeeephvxzxqsuvxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 886,
          "apCost": 3,
          "name": "Flame Siphon",
          "shortDescription": "Target friendly champion within 6 spaces takes 10 Fire damage, you gain 150% of the damage taken in Nora.  May target self.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "fire"
        },
        {
          "id": 89,
          "apCost": 0,
          "name": "Vulnerability: Frost",
          "shortDescription": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3007,
              "apCost": 0,
              "name": "Purging Flames",
              "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dispel"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 3193,
              "apCost": 3,
              "name": "Flame Prison",
              "shortDescription": "Spaces adjacent to target champion within 5 spaces becomes Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "trail_firewall"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": true,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 349,
      "name": "Nefari Soul Torch ",
      "description": "Some Elves were affected differently in Grimlic's ascending ritual. Several young priestesses took in so much demon fire that their burning souls can be witnessed by the naked eye. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 73,
      "hash": "dj9Cj9BG2AF0AF0AJ8HJ8IJ8Jpukusojwxztonyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        },
        {
          "id": 1012,
          "apCost": 0,
          "name": "Torch",
          "shortDescription": "When an enemy champion is healed, the source of the healing loses HP equal to 50% of the total amount healed. If that source is a spell, all champions affected take the damage. This effect does not stack.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "cataclysm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1404,
              "apCost": 0,
              "name": "Fire Feed",
              "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "eater_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 377,
      "name": "Nefari Soul Torch ",
      "description": "Some Elves were affected differently in Grimlic's ascending ritual. Several young priestesses took in so much demon fire that their burning souls can be witnessed by the naked eye. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 73,
      "hash": "dj9Gj9Fe9AF0BF0BJ8IJ8Jj9Aeigyoytszrjluzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 388,
          "apCost": 1,
          "name": "Flame Armor",
          "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "immunity_fire"
        },
        {
          "id": 1012,
          "apCost": 0,
          "name": "Torch",
          "shortDescription": "When an enemy champion is healed, the source of the healing loses HP equal to 50% of the total amount healed. If that source is a spell, all champions affected take the damage. This effect does not stack.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "cataclysm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1404,
              "apCost": 0,
              "name": "Fire Feed",
              "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "eater_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 182,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 14 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deathnovafire"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 886,
      "name": "Negation Mage",
      "description": "Negation Mages are commonly used on battlefields, but seldom receive aid from their allies. They use the energy released at death to deprive the enemy of their nora.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 72,
      "hash": "dj9Gj9Fe9Ag3AF0AJ8HJ8IJ8Jepjnnlrjrlplgeg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2187,
          "apCost": 0,
          "name": "Counterspell Mastery",
          "shortDescription": "When an opponent casts a spell, if this unit has at least 6 charges, this champion loses all charges and the spell fails.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "counterspell_mastery"
        },
        {
          "id": 2172,
          "apCost": 0,
          "name": "Death Charged",
          "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "charged_death"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 2954,
          "apCost": 0,
          "name": "Soul Trapper",
          "shortDescription": "This unit has +1 DMG for each charge it has.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "soulsift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        }
      ]
    },
    {
      "id": 969,
      "name": "Neuromancer",
      "description": "Neuromancers have honed their psychic abilities to a fine edge. Where an adept attacks the mind, a Neuromancer can focus on individual nerve endings. These attacks are subtle, but they often deal greater damage to a victim's mind.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Boghopper",
        "Firk"
      ],
      "noraCost": 72,
      "hash": "dj9Dj9CG2Bg3Af1Bj9Aj9Bj9Ceerqjnsjtfrzojg",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2338,
          "apCost": 0,
          "name": "Psychic Magnetism",
          "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull"
        },
        {
          "id": 1778,
          "apCost": 0,
          "name": "Sabotage: Psychic",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sabotage_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 2193,
              "apCost": 0,
              "name": "Psychic Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped_psychic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3067,
              "apCost": 0,
              "name": "Psychic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "psychicaoe"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            }
          ]
        }
      ]
    },
    {
      "id": 1229,
      "name": "Nightfall Spider",
      "description": "\"Should you encounter the Nightfall, only A'lmara's light can save you. \" ~ Valhari, Favored Nomad",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9FG2Be9Be9Ae9Aj9Cj9Donuvztjpsoympqf",
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2486,
          "apCost": 3,
          "name": "Blind",
          "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "blind"
        },
        {
          "id": 2587,
          "apCost": 0,
          "name": "Nightfall",
          "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": true,
              "id": 1805,
              "apCost": 3,
              "name": "Weave Web",
              "shortDescription": "Area Effect 2, Range 3: Affected area is becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "web"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 230,
      "name": "Nightmare",
      "description": "Elder Ceyle, we've tracked the source of the rivers of flame to a pair of enormous demons who melt the very ground beneath their feet. - Elven scout ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon",
        "Elf"
      ],
      "noraCost": 74,
      "hash": "dJ8JJ8IF0Be9Be9BJ8GJ8HJ8Iqoqouvzonhyzxvf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 804,
          "apCost": 0,
          "name": "Trail: Lava",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Shallow Lava (4 Fire damage on entry and at the beginning of each of the occupying champion's turns) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "trail_lava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 2400,
              "apCost": 4,
              "name": "Flamethrower",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 326,
      "name": "Nightwatch",
      "description": "The nightwatch was actually formed by the clergy of Valdac. Scorned by our brethren, we abandoned helm and shield for the way of the Shadow. - Dromos, Master of the Watch",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest",
        "Rogue"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 69,
      "hash": "dj9AJ8Jf1AF0AF0AJ8HJ8IJ8Jpjgiiykgpyosuxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        },
        {
          "id": 2357,
          "apCost": 0,
          "name": "Shadowstrike",
          "shortDescription": "This champion becomes stealthed after making a basic attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": false,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1017,
              "apCost": 1,
              "name": "Knockout",
              "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "stun"
            }
          ]
        }
      ]
    },
    {
      "id": 1382,
      "name": "Nohkan Apprentice",
      "description": "\"She may not have been exposed to our methods until recently, but she is effective.\" Elder Vallassa\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 66,
      "hash": "ej9Cj9Bf1AF0Ae9AG2AJ8Jj9Aeeruvohtjymhipf",
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2940,
          "apCost": 0,
          "name": "Alluring Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=charmed>Charmed</condition> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_alluring"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2454,
              "apCost": 0,
              "name": "Frost Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=137>Frost Aura 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped"
            },
            {
              "default": true,
              "id": 2466,
              "apCost": 1,
              "name": "Arcblade: Frost",
              "shortDescription": "This champion makes a Frost attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "glaivebounce"
            },
            {
              "default": false,
              "id": 1385,
              "apCost": 0,
              "name": "Freezing Aura",
              "shortDescription": "Enemy champions within 3 spaces are <condition value=frozen>Frozen</condition>.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novafrost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2262,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "charged_abuse"
            },
            {
              "default": true,
              "id": 137,
              "apCost": 0,
              "name": "Frost Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Frost damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            }
          ]
        }
      ]
    },
    {
      "id": 1384,
      "name": "Nohkan Grandmaster",
      "description": "There are very few known Grandmasters of Nohkan Do.  Some walk the Tundra travel alone,  seeking wisdom.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 80,
      "hash": "ej9Cj9BG2AF0Ae9AG2Aj9Bj9Ceemnlwfgknufrqf",
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2939,
          "apCost": 0,
          "name": "Chilling Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_chilling"
        },
        {
          "id": 338,
          "apCost": 0,
          "name": "Counterstrike",
          "shortDescription": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "counter"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        }
      ]
    },
    {
      "id": 1535,
      "name": "Nohkan Grandmaster",
      "description": "There are very few known Grandmasters of Nohkan Do.  Some walk the Tundra travel alone,  seeking wisdom.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 80,
      "hash": "ej9Ej9DE8DF0Be9Ag3Aj9Ej9Fepjgvsfgigevsqf",
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2939,
          "apCost": 0,
          "name": "Chilling Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "discipline_chilling"
        },
        {
          "id": 338,
          "apCost": 0,
          "name": "Counterstrike",
          "shortDescription": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "counter"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        }
      ]
    },
    {
      "id": 1440,
      "name": "Nohkan Guide",
      "description": "\"You, my guides, will be the instrument via which we will tell all Jakei about their heritage.  For the Kas way of Nohkan is their birthright, stolen long ago.\" Elder Vallassa",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Monk"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9Ff1AF0Be9Ae9AJ8Jj9Aeevqhpnyrwvqhpf",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2896,
          "apCost": 5,
          "name": "Find Pupil",
          "shortDescription": "This champion moves 3 spaces at random, then gains <ability value=2911>Reveal: Kas Pupil</ability> (Spawn a Kas Pupil on target adjacent square) for 1 turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "find_pupil"
        },
        {
          "id": 2817,
          "apCost": 0,
          "name": "Freezing Discipline",
          "shortDescription": "The next basic attack this champion makes causes <condition value=frozen>Frozen</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "discipline_freezing"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1933,
              "apCost": 0,
              "name": "Coordination",
              "shortDescription": "All friendly champions within 2 spaces of this unit gain <ability value=1214>Encouraged</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1517,
              "apCost": 0,
              "name": "Train: Damage",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains +2 DMG. This ability costs 3 nora and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "cost"
            },
            {
              "default": true,
              "id": 2897,
              "apCost": 0,
              "name": "Train: Nohkan Do",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=1470>Nohkan Do</ability>. This ability costs 6 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1522,
              "apCost": 0,
              "name": "Train: Mobility",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=6>Mobility</ability>.  This ability costs 4 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cost"
            }
          ]
        }
      ]
    },
    {
      "id": 133,
      "name": "Nora Beast",
      "description": "Despite their immense utility, some Jakei sympathize with what they call the Nora Beast's 'curse' to the point of defending their lives",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 0,
      "hitPoints": 40,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 50,
      "hash": "dj9Gj9Fe9Ae9AG2Bj9Cj9Dj9Eeemjnyzmlevhegg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 598,
          "apCost": 2,
          "name": "Power Store",
          "shortDescription": "This champion loses 10 HP and its owner gains 15 Nora.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 45,
          "iconName": "noragen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 616,
              "apCost": 0,
              "name": "Arctic Camouflage",
              "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Snow or Ice, that damage by is reduced by 2.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "camo"
            },
            {
              "default": false,
              "id": 2464,
              "apCost": 2,
              "name": "Blood for Nora",
              "shortDescription": "This unit loses 20 health. The next spell you cast this turn has its Nora cost reduced by 20. This effect does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "nora_hex"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1054,
              "apCost": 0,
              "name": "Healing Deficiency",
              "shortDescription": "Healing received by this unit is reduced by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 999,
      "name": "Norafire Elemental",
      "description": "'Deeper and deeper what do you find? A creature of Nora, that will not be mined.' - Song of the Norafires, famous in the Ironfist Mines",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9FF0BE8De9Ae9AJ8IJ8Jyinlggknhnwfro",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1367,
          "apCost": 0,
          "name": "Deflect: Fire",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Fire damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect_fire"
        },
        {
          "id": 538,
          "apCost": 0,
          "name": "Fire Eater",
          "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_fire"
        },
        {
          "id": 3085,
          "apCost": 0,
          "name": "Sabotage: Fire",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sabotage_acid"
        },
        {
          "id": 633,
          "apCost": 2,
          "name": "Terraform: Lava",
          "shortDescription": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        },
        {
          "id": 89,
          "apCost": 0,
          "name": "Vulnerability: Frost",
          "shortDescription": "When this unit takes Frost damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_frost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 1404,
              "apCost": 0,
              "name": "Fire Feed",
              "shortDescription": "At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "eater_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3061,
              "apCost": 3,
              "name": "Solar Flare",
              "shortDescription": "Enemy champions within 3 spaces take 8 Fire damage and are knocked back 2 spaces.  Champions successfully damaged become <condition value=illuminated>Illuminated</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        }
      ]
    },
    {
      "id": 1570,
      "name": "Northern Cross Avenger",
      "description": "Deployed on only the most vital of campaigns, Northern Cross Avengers are unmatched warriors that prepare through prayer and meditation to enter the very battlefield in which they will give their lives.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 8,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 76,
      "hash": "ej9Bj9AF0Be9BG2Af1BJ8IJ8Jsuqoqfinuklykpf",
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        },
        {
          "id": 3011,
          "apCost": 0,
          "name": "Stasis",
          "shortDescription": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "crystallize"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1277,
              "apCost": 0,
              "name": "Vindictive",
              "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1314,
      "name": "Northern Cross Cardinal",
      "description": "There is no greater virtue than taking upon yourself the burden of morality. ~ Northern Cross Cardinal",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Paladin",
        "Priest"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9FF0BF0Ae9Ae9AJ8IJ8Jusjgrfpuzoyvxo",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2808,
          "apCost": 0,
          "name": "Mark of Al'Mara",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is Branded (When a Paladin, Shaman or Priest makes a basic attack against this champion, the target takes 2 additional fire damage (ignores DEF). This does not stack) for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            },
            {
              "default": false,
              "id": 1994,
              "apCost": 2,
              "name": "Sermon",
              "shortDescription": "Friendly champions that share a race with this one get +1 DEF, +2 DMG and +5 HP until this champion next moves. This ability does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1305,
              "apCost": 4,
              "name": "Consecration",
              "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "consecrate_earth"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 1311,
      "name": "Northern Cross Fanatic",
      "description": "The Northern Cross does not discriminate against race; any who will join in the fight against the supernatural and the unholy are welcome.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute",
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 68,
      "hash": "ej9Gj9Fe9AF0Ae9Ae9Aj9Fj9Grfkumwzrjitmjpf",
      "artist": "Andrew Hou",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2276,
          "apCost": 0,
          "name": "Inquisition",
          "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "inquisition"
        },
        {
          "id": 3158,
          "apCost": 0,
          "name": "Reckless",
          "shortDescription": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "reckless"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2690,
              "apCost": 4,
              "name": "Glorious Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "leap"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            },
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": true,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1310,
      "name": "Northern Cross Militia",
      "description": "The so-called Northern Cross Militia is nothing more than the Order's recruitment program in action.  Its ranks have swelled to levels never seen before the Plagues began.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 62,
      "hash": "ej9Gj9FE8DF0Ae9Ae9Aj9Ej9Fukrzgtqlpfmnepf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1550,
          "apCost": 0,
          "name": "Enduring Aura",
          "shortDescription": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "aurapositive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1081,
              "apCost": 0,
              "name": "Enlightened",
              "shortDescription": "When this champion is healed, the amount is increased by 6.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2473,
              "apCost": 1,
              "name": "Carouse",
              "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "carouse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 877,
              "apCost": 0,
              "name": "Bodyguard",
              "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 1312,
      "name": "Northern Cross Priestess",
      "description": "The Priestesses arrived first, offering help and support, but soon the villagers realized that their arrival was simply a precursor to the more radical approaches of the Northern Cross.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Paladin",
        "Priest"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9Fe9BF0Ae9Ae9AJ8GJ8Hgtheiiieigkjpn",
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2733,
          "apCost": 3,
          "name": "Call: Celestial Spear",
          "shortDescription": "Summon a Celestial Spear to target space within 3 spaces.  This ability is removed after use.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "deploy"
        },
        {
          "id": 1967,
          "apCost": 0,
          "name": "Relic Guardian",
          "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3295,
              "apCost": 0,
              "name": "Healing Mind",
              "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "healing_wind"
            },
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1885,
              "apCost": 3,
              "name": "Cleansing Flame",
              "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2808,
              "apCost": 0,
              "name": "Mark of Al'Mara",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is Branded (When a Paladin, Shaman or Priest makes a basic attack against this champion, the target takes 2 additional fire damage (ignores DEF). This does not stack) for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        }
      ]
    },
    {
      "id": 1819,
      "name": "Northern Cross Purger",
      "description": "\"The leaders of Ironfist focus on mundane matters while planar spirits ravage the land. Do they not ask themselves what the Arroyo will do after they have fed on the Djinn?\" ~ Markoth the Purger",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin",
        "Priest"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 73,
      "hash": "eJ8HJ8Ge9BG2BG2Ae9BJ8GJ8Heevvshgpfkeeto",
      "artist": "Jordy Knoop",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1706,
          "apCost": 0,
          "name": "Ammunition",
          "shortDescription": "Once this champion has made at least 2 successful attacks, its range becomes 1.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "gun"
        },
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 229,
          "apCost": 0,
          "name": "Damage Shield: Fire",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dmgshld_fire"
        },
        {
          "id": 2808,
          "apCost": 0,
          "name": "Mark of Al'Mara",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is Branded (When a Paladin, Shaman or Priest makes a basic attack against this champion, the target takes 2 additional fire damage (ignores DEF). This does not stack) for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 3292,
          "apCost": 0,
          "name": "Reload",
          "shortDescription": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1277,
              "apCost": 0,
              "name": "Vindictive",
              "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 2325,
              "apCost": 1,
              "name": "Ricochet Shot",
              "shortDescription": "This champion makes a physical attack against target champion. If successful, the nearest other opposing champion within 4 spaces of the target takes 1 physical damage and if that champion takes damage is <condition value=stunned>Stunned</condition> for 2 turns. This damage ignores Defense.",
              "activationType": 3,
              "level": 0,
              "cooldown": 2,
              "noraCost": 10,
              "iconName": "cannon_barrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 905,
      "name": "Northern Cross Templar",
      "description": "Considered an extreme order of the Ironfist Inquisition, the Northern Cross Templars are the sole defenders against \"the Unnaturals.\" ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9Bg3Ag3Aj9Dj9Ej9Fufrqlyzonexqlgg",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1735,
          "apCost": 2,
          "name": "Duel",
          "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 4,
          "iconName": "reflexes"
        },
        {
          "id": 2276,
          "apCost": 0,
          "name": "Inquisition",
          "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "inquisition"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 70,
      "name": "Nymph",
      "description": "I don't care if she is the girl of your dreams; we have a battle to win. - Zran, Deep Elf Captain",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Elf",
        "Fairy"
      ],
      "noraCost": 69,
      "hash": "bj9Cj9Bj9Af1Bj9Aj9Bj9Cj9Dphpyzxfxoqowowm",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2115,
          "apCost": 3,
          "name": "Soothing Serenade",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "soothserenade"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3219,
              "apCost": 0,
              "name": "Force Projection",
              "shortDescription": "When this champion makes a basic attack, the farthest adjacent accessible space from this champion to the target becomes Inaccessible for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forcebarrier"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3356,
              "apCost": 0,
              "name": "Pacifying Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is Pacified for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "charm"
            },
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1931,
      "name": "Nyxia, Vile Priestess",
      "description": "Celebrate in the glory of Lord Maxxarek, as he has saved us from the Darkness. - Deep Elf Priestess",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 67,
      "hash": "dJ8JJ8IF0Be9BE8Dj9Ej9Fj9Geeeeerhnjygepyg",
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 766,
          "apCost": 1,
          "name": "Magical Attack",
          "shortDescription": "This unit makes a Magical attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "magic"
        },
        {
          "id": 741,
          "apCost": 2,
          "name": "Relocate: Demon",
          "shortDescription": "Target friendly Demon within 5 spaces is relocated to a space adjacent to this unit.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 3370,
          "apCost": 0,
          "name": "Taunt: Maxxarek",
          "shortDescription": "Taunt your enemies with the phrase \"Here comes Maxxarek!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1,
      "name": "Oaken Defender",
      "description": "Who ever said trees can't defend themselves?",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 4,
      "damage": 10,
      "hitPoints": 64,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 53,
      "hash": "cJ8JJ8IJ8HF0Ae9AJ8HJ8IJ8Jqoqoqofpwinpfph",
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 969,
              "apCost": 0,
              "name": "Shrine Defender",
              "shortDescription": "While this unit is within your 8 spaces of its shrine, this unit gets +2 DMG and +2 SPD and your Shrine has +8 HP. When your Shrine is Transfigured, this unit has <ability value=1759>Impassioned</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "tgtdefensive"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            }
          ]
        }
      ]
    },
    {
      "id": 1044,
      "name": "Obsidian Venger",
      "description": "\"Pompous paladins prancing about in their shiny armors. Let them see what the touch of undeath can do for their power.\" - Serkan the Lich King ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Undead"
      ],
      "noraCost": 80,
      "hash": "ej9AJ8JE8DE8De9Af1Aj9Ej9Fofetowmuqzxqqo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2480,
          "apCost": 3,
          "name": "Desecrate Earth",
          "shortDescription": "Area Effect 2, Range 5: Affected spaces becomes Desecrated Ground until the end of your next turn. (Desecrated Ground - At beginning of your turns and upon casting, champions without Race: Undead or Race: Spirit in this area lose 6 HP).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "desecrate_earth"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 2315,
          "apCost": 0,
          "name": "Oblivion Shield",
          "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "aegis"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 3222,
              "apCost": 0,
              "name": "Quest: Crusade",
              "shortDescription": "The first time this champion moves within 3 spaces of an enemy avatar, shrine or font, it is healed for 25 HP and permanently gains +1 DEF, +2 DMG and <ability value=2276>Inquisition</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3234,
              "apCost": 2,
              "name": "Truthseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=branded>Branded</condition> or <ability value=2004>Faithless</ability> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate_lightning"
            },
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            }
          ]
        }
      ]
    },
    {
      "id": 1258,
      "name": "Obsidian Wing",
      "description": "The Obsidian Wing is the iconic symbol for what the Wings of Al'mara provides to the Stronghold forces: power, prestige and presence.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 80,
      "hash": "ej9AJ8JG2Be9Be9Af1Aj9Cj9Duxqhierumjgekpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 684,
          "apCost": 1,
          "name": "Execute",
          "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "execute"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2660,
          "apCost": 3,
          "name": "Grappling Hook",
          "shortDescription": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "pull"
        },
        {
          "id": 2658,
          "apCost": 0,
          "name": "Obsidian Sigil",
          "shortDescription": "This champion gains <ability value=1320>Assault</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "griffin_sigil"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2678,
              "apCost": 3,
              "name": "Binding Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 1922,
              "apCost": 0,
              "name": "Revere: Drakon",
              "shortDescription": "While this champion is in play, Drakon costs 10% less nora to deploy. While Drakon is in play this unit has the <ability value=1899>Scale Armor</ability> ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            }
          ]
        }
      ]
    },
    {
      "id": 915,
      "name": "Occuli Slag",
      "description": "Believed to be a Pre-Separation native to the Thirion forests, the Occuli Slag reappeared in parts of the Maljaran jungle. The slags are known to congregate around areas where Nora is plentiful.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 69,
      "hash": "dJ8IJ8HF0Ag3Ag3Aj9Dj9Ej9Fekwkgiyxtzohvhg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest",
        "Shattered Peaks"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 307,
          "apCost": 0,
          "name": "Nora Miner",
          "shortDescription": "At the beginning of your turn, you gain 3 nora.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "noragen"
        },
        {
          "id": 1316,
          "apCost": 0,
          "name": "Vulnerable",
          "shortDescription": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 3067,
              "apCost": 0,
              "name": "Psychic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "psychicaoe"
            },
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1671,
      "name": "Omalaa the Undertortoise",
      "description": "Ancient texts speak of this goliath and its expertise with a \"heacy crosboew.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 8,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 77,
      "hash": "ej9Cj9BE8DF0BG2AG2Aj9Ej9Feepuzzmyxkwxxqf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3162,
          "apCost": 1,
          "name": "heacy crosboew",
          "shortDescription": "This champion makes a Physical attack at 12 DMG and RNG 2-5 (this ignores DEF).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "arrow"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": true,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 1569,
      "name": "Onyx Wing",
      "description": "Some Griffins are born with one wing or otherwise incapable of flight - a telltale sign of this affliction are the blackened feathers. This deficiency has led to these griffins developing enhanced mental abilities.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 69,
      "hash": "ej9Bj9Ae9Be9BG2Af1BJ8GJ8Hollgetosussfxo",
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2459,
          "apCost": 0,
          "name": "Honorary Sigil",
          "shortDescription": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "griffin_sigil"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 3067,
          "apCost": 0,
          "name": "Psychic Blast",
          "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "psychicaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": true,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 101,
              "apCost": 1,
              "name": "Barrage",
              "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "arrowaoe"
            },
            {
              "default": false,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2193,
              "apCost": 0,
              "name": "Psychic Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 1149,
      "name": "Oozeking Slag",
      "description": "\"The Oozeking considers itself to be the center of slag culture, often heard mumbling 'slag slag slag slag' to itself.   For a slag, this is considered true poetry. Their spirit is pure chaos.\" - Sisken, the first prophet of madness",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 83,
      "hash": "ej9AJ8JF0Ae9Ae9Af1AJ8HJ8Ixmpqojyknpfkln",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1047,
          "apCost": 0,
          "name": "Acid Eater",
          "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_acid"
        },
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1238,
          "apCost": 0,
          "name": "Intimidating",
          "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "dictate"
        },
        {
          "id": 2528,
          "apCost": 0,
          "name": "Ooze Tap",
          "shortDescription": "When a non-flying opposing champion within 5 spaces enters Ooze, it takes 2 Acid damage and friendly Slags occupying Ooze within 5 spaces of this unit each heal 2 HP. The damage effect of this ability does not stack and each friendly Slag can only be healed to a maximum of 6 HP from the champion entering Ooze.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 2338,
          "apCost": 0,
          "name": "Psychic Magnetism",
          "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2545,
              "apCost": 0,
              "name": "Guarded: Slag",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Slag within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2620,
              "apCost": 4,
              "name": "Corrosive Grenade",
              "shortDescription": "Area Effect 2, Range 5: Affected units take 8 Acid Damage and becomes <condition value=sundered>Sundered</condition> for 3 turns.  This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "acidaoe"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            },
            {
              "default": false,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            },
            {
              "default": true,
              "id": 850,
              "apCost": 1,
              "name": "Acid Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "acidaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 163,
      "name": "Oozing Slag",
      "description": "\"As they started splitting, the valley filled with the sound of \"SLAG SLAG SLAG SLAG SLAG SLAG\".   If I were a soft skin, I probably would've turned and ran.   Fortunately I'm not.\"  - Bij, Serpentor Ardent",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 66,
      "hash": "dj9Bj9Af1Be9Ae9BJ8GJ8HJ8Insmpwxfrowirlwf",
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1047,
          "apCost": 0,
          "name": "Acid Eater",
          "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_acid"
        },
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 1259,
          "apCost": 0,
          "name": "Split",
          "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "duplicate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2777,
              "apCost": 4,
              "name": "Tunnel: Ooze",
              "shortDescription": "This unit is relocated to target Ooze space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_ooze"
            },
            {
              "default": false,
              "id": 249,
              "apCost": 0,
              "name": "Damage Shield: Acid",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Acid damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2528,
              "apCost": 0,
              "name": "Ooze Tap",
              "shortDescription": "When a non-flying opposing champion within 5 spaces enters Ooze, it takes 2 Acid damage and friendly Slags occupying Ooze within 5 spaces of this unit each heal 2 HP. The damage effect of this ability does not stack and each friendly Slag can only be healed to a maximum of 6 HP from the champion entering Ooze.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ooze_tap"
            },
            {
              "default": true,
              "id": 3382,
              "apCost": 0,
              "name": "Hidden: Ooze",
              "shortDescription": "At the end of your turn, if this unit occupies Ooze, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 854,
      "name": "Ospryan Valkyrie",
      "description": "Ospryans were believed extinct after the Separation. They reemerged in the denser areas of K'thir. Valkyries are skilled hunters, using nets and ear piercing cries to hunt or incapacitate prey.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 73,
      "hash": "dj9Dj9CG2BG2Be9Aj9Fj9Gj9Hgpnjgepjithrwkg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1947,
          "apCost": 0,
          "name": "Entangling Attack",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "disable"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            }
          ]
        }
      ]
    },
    {
      "id": 1743,
      "name": "Outcast De'lim",
      "description": "To accept revolution, one must first face hardship. I welcome the damage to the forest: it cauterizes a flawed past, so that we may see the way towards a brilliant future.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger",
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 89,
      "hash": "eJ8IJ8He9Bf1BG2AF0AJ8GJ8Heigpluhpumwito",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3237,
          "apCost": 5,
          "name": "De'lim's Mass Teleport",
          "shortDescription": "This champion is relocated to target space within 5 spaces. Friendly champions within 2 spaces are also relocated (distributed randomly within the AE).",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "relocate"
        },
        {
          "id": 2840,
          "apCost": 0,
          "name": "Devotee of De'lim",
          "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "devotee_delim"
        },
        {
          "id": 885,
          "apCost": 3,
          "name": "Flame Siphon",
          "shortDescription": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "fire"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 3007,
              "apCost": 0,
              "name": "Purging Flames",
              "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dispel"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2900,
              "apCost": 0,
              "name": "Initiate: Devotee to De'lim",
              "shortDescription": "Target friendly champion within 3 spaces is Consumed By Fire (This champion is Shielded, Immobile, and Pacified. At the beginning of your turn, this champion takes 10 Fire Damage) and at the start of its next turn, it also gains <ability value=2840>Devotee of De'lim</ability> and <ability value=55>Resistance: Fire 2</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 3227,
              "apCost": 0,
              "name": "Power of Devotion",
              "shortDescription": "This champion has +2 MAX HP for each real friendly Plant or Elf, and an additional +1 DMG if the champion has <ability value=2840>Devotee of De'lim</ability> or <ability value=2820>Sacrifice of De'lim</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "powerofdevotion"
            },
            {
              "default": false,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 699,
      "name": "Outcast of the Flame",
      "description": "To burn K`thir is to cleanse it. But, the Eternal Circle will never understand. - D`elim, Outcast",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "dJ8JJ8IF0BG2Ag3Aj9Dj9Ej9Fqoqouxofexkuxig",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 885,
          "apCost": 3,
          "name": "Flame Siphon",
          "shortDescription": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3193,
              "apCost": 3,
              "name": "Flame Prison",
              "shortDescription": "Spaces adjacent to target champion within 5 spaces becomes Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "trail_firewall"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 657,
      "name": "Overcharged Golem",
      "description": "We sent experimental golems to aid the battalion in the Peaks. Last we heard, they were bracing for a storm. We haven't received word from them in over a month, sir. - Feofil, King Rugolth's Advisor",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 62,
      "hash": "dJ8HJ8Ge9BG2Ag3Aj9Dj9Ej9Feinnerhegnevzgg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1331,
          "apCost": 0,
          "name": "Electricity Eater",
          "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_electric"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2344,
              "apCost": 0,
              "name": "Paralytic Strike",
              "shortDescription": "This champion does double damage to <condition value=paralyzed>Paralyzed</condition> champions.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1355,
              "apCost": 3,
              "name": "Spark Charge",
              "shortDescription": "Until end of turn, all Electricity damage is increased by 2. This unit loses 6 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_lightning"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 189,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaelec"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 391,
      "name": "Paladin Commander",
      "description": "Through me their trainer says dodge, their king says block, and their church says pray. - Gedden, Ironfist Paladin",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9BF0Be9Aj9Fj9Gj9Heeinsxqlwxonpyg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 1987,
          "apCost": 2,
          "name": "Hold the Line",
          "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2753,
              "apCost": 2,
              "name": "Noble Sacrifice",
              "shortDescription": "This champion loses 8 HP and target other friendly champion that shares a race with this one within 3 spaces gains <ability value=1932>Loyalty</ability> for 8 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": false,
              "id": 1140,
              "apCost": 2,
              "name": "Command: Heal",
              "shortDescription": "The next time friendly champions within 3 spaces are healed, the amount is increased by 6.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_heal"
            },
            {
              "default": false,
              "id": 1139,
              "apCost": 3,
              "name": "Command: Dodge",
              "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "command_dodge"
            },
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            }
          ]
        }
      ]
    },
    {
      "id": 437,
      "name": "Paladin Commander",
      "description": "Through me their trainer says dodge, their king says block, and their church says pray. - Gedden, Ironfist Paladin",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 74,
      "hash": "dj9Ej9Dg3AF0Bf1Bj9Aj9Bj9Ceeeegykuxmuvxig",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 1987,
          "apCost": 2,
          "name": "Hold the Line",
          "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2753,
              "apCost": 2,
              "name": "Noble Sacrifice",
              "shortDescription": "This champion loses 8 HP and target other friendly champion that shares a race with this one within 3 spaces gains <ability value=1932>Loyalty</ability> for 8 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": false,
              "id": 1140,
              "apCost": 2,
              "name": "Command: Heal",
              "shortDescription": "The next time friendly champions within 3 spaces are healed, the amount is increased by 6.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_heal"
            },
            {
              "default": false,
              "id": 1139,
              "apCost": 3,
              "name": "Command: Dodge",
              "shortDescription": "Friendly champions within 3 spaces gain <condition value=dodging>Dodging</condition> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "command_dodge"
            },
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            }
          ]
        }
      ]
    },
    {
      "id": 791,
      "name": "Pantier Headhunter",
      "description": "\"Day 4. The Alpha paused, sniffed for his pack, continued down through brush. I met him at a curve in the path. My cut was clean; little mess, little noise, no struggle. I took another trophy today.\" - Vahkosh, Headhunter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 81,
      "hash": "dj9Gj9Fe9AG2BG2Bj9Cj9Dj9Eeevfvvxfkjgepjg",
      "artist": "Joachim Barrum",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 327,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at triple DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 20,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            },
            {
              "default": true,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            },
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        }
      ]
    },
    {
      "id": 944,
      "name": "Pantier Lurker",
      "description": "\"Day 1, new hunt. Came across a Lurker and a Stitched. The mess he made of it; rips and tears, nothing clean. They are not like us. They are devils.\" - Vahkosh, Pantier Headhunter",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 67,
      "hash": "dj9Bj9Af1Bg3Af1Bj9Aj9Bj9Ceevofinexqqfrhg",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 970,
              "apCost": 0,
              "name": "Hidden: Rock",
              "shortDescription": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            }
          ]
        }
      ]
    },
    {
      "id": 906,
      "name": "Paragon of Ailur",
      "description": "\"To extinguish a life is to ignore everything our kingdom was built on. Ailur is a nation of peace. We, as its protectors, must always remember this.\" - Paragon Roshan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 66,
      "hash": "dJ8IJ8HF0Ag3AE8Dj9Ej9Fj9Geemjegnsfpsoleg",
      "artist": "Alex Fang",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1437,
          "apCost": 0,
          "name": "Camaraderie ",
          "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "cost"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1470,
              "apCost": 0,
              "name": "Nohkan Do",
              "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 2941,
              "apCost": 0,
              "name": "Sundering Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=sundered>Sundered</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_sundering"
            },
            {
              "default": false,
              "id": 2839,
              "apCost": 0,
              "name": "Crippling Discipline",
              "shortDescription": "The next basic attack this champion makes gains <ability value=2093>Ponderous</ability> for 2 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_distracting"
            }
          ]
        }
      ]
    },
    {
      "id": 168,
      "name": "Parasitic Fesh",
      "description": "Hey Jann, you notice anything strange about Daerne lately? Jann? Jann? - Cyrar, Elven Ranger, last words",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 6,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 68,
      "hash": "dj9Bj9Af1Be9AG2Aj9Bj9Cj9Dpluziiwigpwipfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 672,
          "apCost": 0,
          "name": "Infest",
          "shortDescription": "Make an attack against target champion within 2 spaces. If successful, the attack does no damage, Parasitic Fesh is removed from play, and the targeted champion becomes Infested (at the beginning of each turn, it loses 8 HP. If it is destroyed this way, a Parasitic Fesh spawns at half HP in that champion's space, under your control. This condition can not be cleansed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 20,
          "iconName": "disease"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 1283,
      "name": "Peaks Dao",
      "description": "\"We are not here to take over, good Queen, only to provide... assistance. We may not be of your realm, but we have great interest in your people's continued success in this plane.\" ~ Shariak, Peaks Dao",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Monk"
      ],
      "races": [
        "Djinn",
        "Elemental"
      ],
      "noraCost": 81,
      "hash": "ej9Dj9CF0Ae9Be9AG2BJ8HJ8Iouxqlwfxxziiyo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3094,
              "apCost": 1,
              "name": "Gift of the Djinn: Dao",
              "shortDescription": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=2078>Reflexes 3</ability> until this ability is used again.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1396,
      "name": "Peaks Dew",
      "description": "\"We are the voice of the mountain stream, the breakers of rock and bone. Your service means nothing to us; we drown your enemies for reasons of our own.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Djinn",
        "Elemental"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9Cg3AF0Ae9AG2Bj9Dj9Eevojpjpluxxmjrf",
      "artist": "Conceptopolis",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3010,
          "apCost": 4,
          "name": "Bubble",
          "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "bubble"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1462,
          "apCost": 2,
          "name": "Hydrate",
          "shortDescription": "Friendly champions within 2 spaces gain 2 AP and the spaces they are standing in turn to Water for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "terrainwater"
        },
        {
          "id": 726,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        },
        {
          "id": 2679,
          "apCost": 4,
          "name": "Water Vortex",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Physical damage and are knocked back 1 space. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3032,
              "apCost": 0,
              "name": "Quest: Support Ally",
              "shortDescription": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 1248,
              "apCost": 3,
              "name": "Pull",
              "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "pull"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1876,
              "apCost": 1,
              "name": "Grant: Elemental Immunity",
              "shortDescription": "Target champion within 5 spaces gains <ability value=37>Immunity: Fire</ability>, <ability value=38>Immunity: Frost</ability> and <ability value=39>Immunity: Electricity</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3095,
              "apCost": 1,
              "name": "Gift of the Djinn: Dew",
              "shortDescription": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=117>Regeneration 3</ability> until this ability is used again.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 712,
      "name": "Peaks Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the dwellers of the Shattered Peaks.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Af1AJ8Jj9Aj9Beetuszolpwxtzzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3349,
              "apCost": 0,
              "name": "Peaks Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1677,
      "name": "Peaks Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the dwellers of the Shattered Peaks.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Af1AJ8Jj9Aj9Beetuszolpwxtzzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3349,
              "apCost": 0,
              "name": "Peaks Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1218,
      "name": "Peaks Ifrit",
      "description": "\"A deal is a deal, right?  Serve us well and we shall guarantee your victory.\" ~ The Djinn reassuring the Hyaenid during a heated battle",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Djinn",
        "Elemental"
      ],
      "noraCost": 76,
      "hash": "ej9Fj9EG2Ae9Be9AE8Dj9Bj9Cerhvzgykjwxohpf",
      "artist": "Paul Guzenko",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1883,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_burn"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 37,
          "apCost": 0,
          "name": "Immunity: Fire",
          "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "immunity_fire"
        },
        {
          "id": 3158,
          "apCost": 0,
          "name": "Reckless",
          "shortDescription": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "reckless"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 261,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +7 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2584,
              "apCost": 0,
              "name": "Surge: Hyaenid",
              "shortDescription": "This unit has +1 DMG for each friendly Hyaenid.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_hyaenid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3092,
              "apCost": 1,
              "name": "Gift of the Djinn: Ifrit",
              "shortDescription": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=25>Berserker 3</ability> until this ability is used again.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1217,
      "name": "Peaks Marid",
      "description": "\"These Djinn are powerful, but the Queen will not be pleased.  These Hyaenids have been hiding much from us.\" ~ Klub the Devourer",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Djinn",
        "Elemental"
      ],
      "noraCost": 70,
      "hash": "ej9Fj9Ef1Be9Be9AE8Dj9Aj9Bjwmeexknygrszo",
      "artist": "Paul Guzenko",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 630,
              "apCost": 1,
              "name": "Grant: Flight",
              "shortDescription": "Target champion within 5 spaces gains <condition value=flying>Flying</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "flight"
            },
            {
              "default": false,
              "id": 3093,
              "apCost": 1,
              "name": "Gift of the Djinn: Marid",
              "shortDescription": "Target champion with Race: Elemental or Hyaenid within 5 spaces gains <ability value=518>Leap 3</ability> until this ability is used again.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1387,
      "name": "Perfected Runner",
      "description": "D'elim, Apex of the Circle, took the fastest rangers of K'Thras and \"encouraged\" them to undergo the painful transformation into runners.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Elemental",
        "Elf"
      ],
      "noraCost": 72,
      "hash": "ej9Dj9CE8DF0Ae9AG2Bj9Ej9Fqoygirljwxkwmpf",
      "artist": "Nate Abell",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2213,
          "apCost": 0,
          "name": "Crazed Charger",
          "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crazed_charger"
        },
        {
          "id": 3088,
          "apCost": 1,
          "name": "Flameburst",
          "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "fireaoe"
        },
        {
          "id": 1760,
          "apCost": 0,
          "name": "Impatient",
          "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "impatient"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2773,
              "apCost": 0,
              "name": "Quest: Runner",
              "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1226,
      "name": "Phantasmal Creeper",
      "description": "On the shores of Quietus live creatures that rankle the minds of even the most grounded mortals. It is said that here was where these creatures first emerged.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 65,
      "hash": "ej9Gj9Ff1Ae9Be9Ae9AJ8Jj9Aevsfrjygeketzo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 1737,
          "apCost": 0,
          "name": "Ethereal",
          "shortDescription": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "ethereal"
        },
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        },
        {
          "id": 820,
          "apCost": 4,
          "name": "Portal",
          "shortDescription": "This unit may teleport to any deployment zone its controller controls.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            },
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 128,
              "apCost": 0,
              "name": "Magical Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novamagic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": true,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 860,
      "name": "Phase Spider",
      "description": "One moment it was there, the next it wasn't. L'arsim held his torch out to the darkness, hoping to catch the creature in its light. Nothing appeared.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 72,
      "hash": "dj9Dj9CG2BG2BG2Aj9Bj9Cj9Dqqhnlgthvhepwkg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2214,
          "apCost": 0,
          "name": "Hunter: Scout",
          "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "foe_archer"
        },
        {
          "id": 129,
          "apCost": 0,
          "name": "Magical Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Magical damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novamagic"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            },
            {
              "default": true,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 180,
      "name": "Pincushion",
      "description": "What are you doing! The demon's gonna kill you for shooting his pet! -- Target practice! Don't worry, it likes it. - Nefari Scout to a Bok Archer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 67,
      "hash": "dj9Dj9CG2Be9AE8Dj9Ej9Fj9Gevfiwitsohykwfg",
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2029,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +1 DEF.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plusdefense"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 125,
              "apCost": 0,
              "name": "Damage Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaphysical"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            }
          ]
        }
      ]
    },
    {
      "id": 344,
      "name": "Pirahnid",
      "description": "As masterful swimmers, their existence is key in the great aquatic battles of the swamp.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 69,
      "hash": "dj9Bj9Af1BF0AG2Bj9Cj9Dj9Eeevonnjeiwthnhg",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 17,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 3, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 14,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            },
            {
              "default": false,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            }
          ]
        }
      ]
    },
    {
      "id": 1214,
      "name": "Pirahnid Bloodfiend",
      "description": "\"Bring the next Pirahnid, the Vault is ready for its next offering.\" - Marx, Circadian Templar",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9EF0Ae9Be9AE8DJ8HJ8Iyzietoymnpjnnn",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 2077,
          "apCost": 0,
          "name": "Reflexes",
          "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "reflexes"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 261,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +7 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 24,
              "apCost": 0,
              "name": "Berserker",
              "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "berserker"
            }
          ]
        }
      ]
    },
    {
      "id": 1216,
      "name": "Pirahnid Tempest",
      "description": "Gekaal looked on as the Tempest trained against the captive Kanen.  The rites the Circadian had performed gave the Pirahnid far greater potential than he had anticipated.  Perhaps he could tolerate the Circadian intrusion for awhile longer.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 84,
      "hash": "ej9Fj9Ef1Ae9Be9AE8DJ8Jj9Aemsxmeeiepuxvo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 2245,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "jolt"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 189,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaelec"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            },
            {
              "default": false,
              "id": 1877,
              "apCost": 0,
              "name": "Static Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this champion, it takes 2 points of Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            }
          ]
        }
      ]
    },
    {
      "id": 564,
      "name": "Pirahnid Warrior",
      "description": "The Pirahnids are more than feral savages. With guidance, they can be deadly and precise. - Kartch, Finlord",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 74,
      "hash": "dJ8IJ8HF0Af1BG2Bj9Cj9Dj9Eeevonszxonnnufg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1504,
          "apCost": 0,
          "name": "Brutality",
          "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "surge"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 178,
      "name": "Pit Dragon",
      "description": "ARCHERS! Concentrate your attacks on that demon! If it reaches the gates all is lost - Dallinae, Captain of the Guards at Moontower Glade, K'thir",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 18,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Dragon"
      ],
      "noraCost": 71,
      "hash": "dj9Cj9BG2Ae9AG2Bj9Cj9Dj9Eeevxxvhyxvfgnhg",
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 50,
          "apCost": 0,
          "name": "Resistance: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is reduced by 20% (after DEF, rounded up).",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "resistance_magic"
        },
        {
          "id": 46,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 20% (after DEF, rounded up).",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "resistance_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1273,
              "apCost": 0,
              "name": "Untamed",
              "shortDescription": "This champion may not become <condition value=pacified>Pacified</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            }
          ]
        }
      ]
    },
    {
      "id": 157,
      "name": "Pit Wolf",
      "description": "Unlike their lowland kin, the wolves of the peaks hunt alone, often stalking their prey for days.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 65,
      "hash": "dj9AJ8Jf1Ae9Af1Bj9Aj9Bj9Ceeiggigeiwqwtzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1484,
              "apCost": 0,
              "name": "Solitary",
              "shortDescription": "This unit has +3 DMG, +2 DEF, and +5 MAX HP when there are no friendly champions within 6 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1439,
      "name": "Pitfighter",
      "description": "The Sarnghavian rebels' morale improved dramatically when the pitfighters joined their cause. Most assumed the athletes wouldn't give up their highly-paid lives as bloodsport entertainers to Ironfist nobles, but most did.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 76,
      "hash": "ej9Gj9FF0BF0Be9Ae9AJ8IJ8Jepqfgtqwqwztzo",
      "artist": "Mazert Young",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2369,
          "apCost": 0,
          "name": "Clamp",
          "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "clamp"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        },
        {
          "id": 2895,
          "apCost": 1,
          "name": "Submission Hold",
          "shortDescription": "This champion makes a melee attack against opposing <condition value=stationary>Stationary</condition> champion. If successful, the target takes 50% damage and becomes <condition value=pacified>Pacified</condition> for 2 turns..",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 0,
          "iconName": "submission_hold"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2875,
              "apCost": 0,
              "name": "Warchief: Blood Clan",
              "shortDescription": "This unit is <ability value=3>Fearless</ability>. At the end of your turn, this unit gains 1 rank of <ability value=163>Rend</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_clan"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 632,
      "name": "Plains Savage",
      "description": "We are glad to have them as allies. With their fervor in battle, I wouldn't want them against us. - Zedin, Elder Barbarian",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian",
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dj9Ej9Dg3Af1Bf1Bj9Aj9Bj9Ceeemlwkjykygkjg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1393,
          "apCost": 0,
          "name": "Pillage",
          "shortDescription": "When this champion enters an enemy font deployment zone, you gain 6 nora. This can trigger once per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "noragen"
        },
        {
          "id": 3403,
          "apCost": 0,
          "name": "Warchief: Beast Clan",
          "shortDescription": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "beast_clan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2576,
              "apCost": 1,
              "name": "Throw Javelin",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "spear"
            },
            {
              "default": false,
              "id": 2213,
              "apCost": 0,
              "name": "Crazed Charger",
              "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "crazed_charger"
            }
          ]
        }
      ]
    },
    {
      "id": 1259,
      "name": "Platinum Wing",
      "description": "The Platinum Wing is the most obscure branch of the Wings of Al'mara, providing a mix of support and burst power.  Philosophically, the Platinums view themselves as the guards of the order and the last line of defense should its halls be breached.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 74,
      "hash": "ej9AJ8Jg3Ae9Be9Af1Aj9Dj9Eevxxileemhgyoqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2659,
          "apCost": 0,
          "name": "Platinum Sigil",
          "shortDescription": "This champion gains +1 RNG and <ability value=2478>Improve Range</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "griffin_sigil"
        },
        {
          "id": 1523,
          "apCost": 0,
          "name": "Train: Defense",
          "shortDescription": "Target friendly champion within 5 spaces permanently gains +1 DEF.  This ability costs 2 nora and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            }
          ]
        }
      ]
    },
    {
      "id": 508,
      "name": "Poison Elemental",
      "description": "The children of the Dark Marsh received a new protector. It would soon defend the entire swamp.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental",
        "Plant"
      ],
      "noraCost": 75,
      "hash": "dj9Dj9CG2Bf1Ae9Aj9Fj9Gj9Hkgplggrsmuvfiig",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1366,
          "apCost": 0,
          "name": "Deflect: Poison",
          "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Poison damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "deflect_poison"
        },
        {
          "id": 167,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_poison"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        },
        {
          "id": 93,
          "apCost": 0,
          "name": "Vulnerability: Acid",
          "shortDescription": "When this unit takes Acid damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 428,
              "apCost": 3,
              "name": "Poison Cloud",
              "shortDescription": "Area Effect 2, Range 4: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poison_cloud"
            },
            {
              "default": true,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            },
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1748,
              "apCost": 1,
              "name": "Grant: Poison Cloud Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=446>Lay Trap: Poison Cloud</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1346,
              "apCost": 3,
              "name": "Poison Charge",
              "shortDescription": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_poison"
            },
            {
              "default": true,
              "id": 446,
              "apCost": 0,
              "name": "Lay Trap: Poison Cloud",
              "shortDescription": "Lay a Poison Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, all spaces within a range of 2 are covered in a <mechanic value=poison_cloud>poison cloud</mechanic> until end of the next turn.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trappoison"
            }
          ]
        }
      ]
    },
    {
      "id": 1813,
      "name": "Poison Oak",
      "description": "Sentient trees are rarer in the Swamp, and often keep to themselves.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9Ff1BG2BG2Ae9Aj9Aj9Berjljpuxigyxmsf",
      "artist": "Blake Henriksen",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 3291,
          "apCost": 3,
          "name": "Elemental Storm: Poison",
          "shortDescription": "Enemy champions within 3 spaces of at least one friendly Plant, Shaman or champion with Attack: Poison, including this one, take 5 Poison damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "novapoison"
        },
        {
          "id": 3328,
          "apCost": 0,
          "name": "Hunter: Poisoned",
          "shortDescription": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "poison"
        },
        {
          "id": 40,
          "apCost": 0,
          "name": "Immunity: Poison",
          "shortDescription": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 169,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            },
            {
              "default": false,
              "id": 1093,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "poisonaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 261,
      "name": "Polar Ant",
      "description": "A single polar ant is no big threat, until it finds a meal. The ants will alert their kin about ready sources of food, and a swarm can devour an army.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 8,
      "hitPoints": 33,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9BF0AF0AJ8HJ8IJ8Jeemsusmpwxievvf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3315,
          "apCost": 0,
          "name": "Swarm: Polar Ant",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Polar Ant with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 755,
              "apCost": 4,
              "name": "Tunnel: Earth",
              "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_earth"
            },
            {
              "default": true,
              "id": 752,
              "apCost": 4,
              "name": "Tunnel: Snow",
              "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        }
      ]
    },
    {
      "id": 1429,
      "name": "Polluted Martyr",
      "description": "\"My information does not come free, Vindrax.  Fortunately for you, we do not place the same value on a corpse.\" Xulos, Undead Sage\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dragon",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "ej9Fj9Eg3AF0Be9AE8Dj9Dj9Eeevkykwklnpluqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 876,
          "apCost": 0,
          "name": "Short Lived",
          "shortDescription": "This unit is destroyed after 8 turns.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": -15,
          "iconName": "ondeath"
        },
        {
          "id": 489,
          "apCost": 0,
          "name": "Soulsift",
          "shortDescription": "When this unit is destroyed, you gain nora equal to 40% of this units nora cost.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soulsift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1247,
              "apCost": 0,
              "name": "Propagate: Carrionling",
              "shortDescription": "When this unit takes 5 or more damage, a Death Carrionling with no upgrades is summoned 5 spaces away from this champion (if there are no empty spaces, it will be summoned farther away).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "propagate_carrionling"
            },
            {
              "default": true,
              "id": 534,
              "apCost": 0,
              "name": "Bile Explosion",
              "shortDescription": "When this unit is destroyed, units within 2 spaces take 5 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "deathnovaacid"
            },
            {
              "default": false,
              "id": 2227,
              "apCost": 0,
              "name": "Choking Stench",
              "shortDescription": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "choking_stench"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2575,
              "apCost": 0,
              "name": "Defiling Aura",
              "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "defile_corpse"
            },
            {
              "default": false,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": true,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        }
      ]
    },
    {
      "id": 1628,
      "name": "Pontiff of Al'mara",
      "description": "The Church of Al'mara depends upon a strict hierarchy of immutable faith; a judgement questioned is no judgement at all. ",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FF0AF0BG2Ae9AJ8HJ8Ieipytonhpfvklpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3125,
          "apCost": 1,
          "name": "Verdict of Al'mara",
          "shortDescription": "This champion makes a Magical attack at RNG 2-5.  If the attack is successful and the target is Branded, the target also becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "verdict_of_almara"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 3142,
              "apCost": 0,
              "name": "Empowered: Speed",
              "shortDescription": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_speed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2276,
              "apCost": 0,
              "name": "Inquisition",
              "shortDescription": "When this champion is deployed and at the end of your turns, the closest opposing champion within 5 spaces becomes <ability value=2004>Faithless</ability> and <condition value=branded>Branded</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "inquisition"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 96,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of Forglar comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 584,
          "apCost": 0,
          "name": "Attack: Forglar Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 97,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Forsaken Wastes comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 589,
          "apCost": 0,
          "name": "Attack: Forsaken Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 98,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of Ironfist Mountain comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 588,
          "apCost": 0,
          "name": "Attack: Ironfist Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 99,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of K'Thir Forest comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 587,
          "apCost": 0,
          "name": "Attack: K'thir Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 100,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Sundered Lands comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 586,
          "apCost": 0,
          "name": "Attack: Sundered Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 101,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Underdepths comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 585,
          "apCost": 0,
          "name": "Attack: Underdepths Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1952,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of Forglar comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8HJ8GG2Be9AG2Be9Bj9Cj9Deemegkpllwtqjpf",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 584,
          "apCost": 0,
          "name": "Attack: Forglar Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1953,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Forsaken Wastes comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8HJ8Gg3Ae9AG2Be9Bj9Dj9Eeeerqfkpnhpnnpf",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 589,
          "apCost": 0,
          "name": "Attack: Forsaken Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1954,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of Ironfist Mountain comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8IJ8HE8De9AG2BF0Aj9Ej9Feeemwigpyrhvxo",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 588,
          "apCost": 0,
          "name": "Attack: Ironfist Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1955,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of K'Thir Forest comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8IJ8He9Ae9AG2BF0Aj9Fj9Gevsmepwqoqwtfpf",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 587,
          "apCost": 0,
          "name": "Attack: K'thir Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1956,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Sundered Lands comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8IJ8He9Be9AG2BF0AJ8GJ8Heevxtoyzmnuvmn",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 586,
          "apCost": 0,
          "name": "Attack: Sundered Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1959,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Underdepths comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8IJ8Hf1Ae9AG2BF0AJ8Jj9Aeemsfitsuzgexo",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 585,
          "apCost": 0,
          "name": "Attack: Underdepths Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 140,
      "name": "Pox Harbinger",
      "description": "Fate is a fickle mistress with dark wings and a wicked bow.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 646,
          "apCost": 0,
          "name": "Attack: Savage Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1958,
      "name": "Pox Harbinger",
      "description": "Fate is a fickle mistress with dark wings and a wicked bow.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8IJ8HF0Be9AG2BF0AJ8IJ8Jeemnhrfxmljito",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 646,
          "apCost": 0,
          "name": "Attack: Savage Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 253,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Peaks comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "cj9Ej9Dj9CG2Bg3Aj9Cj9Dj9Eeeeemwkrluvzipj",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 816,
          "apCost": 0,
          "name": "Attack: Shattered Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1957,
      "name": "Pox Harbinger",
      "description": "They say that the spirit of the Peaks comes to those that prepare for the future, while remembering the mistakes of the past.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Angel"
      ],
      "noraCost": 88,
      "hash": "eJ8IJ8HF0Ae9AG2BF0AJ8HJ8Ieitfgtmjnwvoqo",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2623,
          "apCost": 0,
          "name": "Anthomancy",
          "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "scry"
        },
        {
          "id": 816,
          "apCost": 0,
          "name": "Attack: Shattered Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 1534,
              "apCost": 0,
              "name": "Spell Resistance",
              "shortDescription": "This unit takes 50% less damage from spells.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1449,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1450,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1451,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1452,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1453,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1454,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1455,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1456,
      "name": "Pox Renovator",
      "description": "\"Was it a giant owl? A crazy monster owl? An owl lord that can stop time and command the wind!?\" \"No, just an owl... But it had a BIG GUN!\"",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GF0AF0Be9Ae9BJ8HJ8Ieevxosfetjyxfm",
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2918,
          "apCost": 0,
          "name": "Renovate",
          "shortDescription": "This champion deals 1 additional damage to champions for each starting ability above 2 on that champion.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "soul_bond"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": true,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1690,
      "name": "Poxtoberfest Maiden",
      "description": "Poxtoberfest: Special Ale, Beermaidens, and Drunken Revelry.  What more can you ask for?",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Bard"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 61,
      "hash": "ej9Fj9EF0Bf1AG2AE8DJ8IJ8Jusmhnhgeexqjnpf",
      "artist": "Anthony Lopes",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2473,
          "apCost": 1,
          "name": "Carouse",
          "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "carouse"
        },
        {
          "id": 3098,
          "apCost": 0,
          "name": "Equip: St Semmir's Brew",
          "shortDescription": "This champion comes into play equipped with a St Semmir's Brew.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 2713,
          "apCost": 0,
          "name": "On The House",
          "shortDescription": "When a friendly champion within 5 spaces collects a Nora Globe, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special_keg"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": false,
              "id": 323,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 2 AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        }
      ]
    },
    {
      "id": 674,
      "name": "Priest of Fury",
      "description": "They believed in the Fury, that it would cleanse the sickness from Valdac's veins. The only way to truly cure their city of the Soft-skins was with anger. - Book of Valdac",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9BG2AF0AJ8HJ8IJ8Jeevkjevkevzvmwf",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 771,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "fireaoe"
        },
        {
          "id": 1926,
          "apCost": 0,
          "name": "Inscrutable Form",
          "shortDescription": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "inhibit"
        },
        {
          "id": 3007,
          "apCost": 0,
          "name": "Purging Flames",
          "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dispel"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2556,
              "apCost": 0,
              "name": "Vitality: Nora",
              "shortDescription": "The first time each turn that nora is generated via spells, relics and abilities, this champion gains +2 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2112,
              "apCost": 1,
              "name": "Grant: Draconic Force",
              "shortDescription": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1921,
              "apCost": 0,
              "name": "Revere: Akakios",
              "shortDescription": "While this champion is in play, Akakios costs 10% less nora to deploy. While Akakios is in play, whenever a champion takes fire damage this champion generates 1 nora (This does not include damage from <condition value=charred>Charred</condition>).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        }
      ]
    },
    {
      "id": 770,
      "name": "Priest of Fury",
      "description": "They believed in the Flame, that it would cleanse the sickness from Valdac's veins. - Book of Valdac",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 73,
      "hash": "dj9Fj9EE8DG2BF0AJ8HJ8IJ8Jeepukygtmjyxqzg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broodcall",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 771,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "fireaoe"
        },
        {
          "id": 1926,
          "apCost": 0,
          "name": "Inscrutable Form",
          "shortDescription": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "inhibit"
        },
        {
          "id": 3007,
          "apCost": 0,
          "name": "Purging Flames",
          "shortDescription": "When a champion within 5 spaces takes Fire damage, it is <mechanic value=dispelled>Dispelled</mechanic> if it is an enemy champion.  If the champion is friendly, it is <mechanic value=cleansed>Cleansed</mechanic> instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dispel"
        },
        {
          "id": 115,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2556,
              "apCost": 0,
              "name": "Vitality: Nora",
              "shortDescription": "The first time each turn that nora is generated via spells, relics and abilities, this champion gains +2 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2112,
              "apCost": 1,
              "name": "Grant: Draconic Force",
              "shortDescription": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1921,
              "apCost": 0,
              "name": "Revere: Akakios",
              "shortDescription": "While this champion is in play, Akakios costs 10% less nora to deploy. While Akakios is in play, whenever a champion takes fire damage this champion generates 1 nora (This does not include damage from <condition value=charred>Charred</condition>).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        }
      ]
    },
    {
      "id": 71,
      "name": "Priest of Valdac",
      "description": "The priests remember when Valdac was one entity. They will preach it, and they will fight for it.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 71,
      "hash": "cj9Hj9Gj9Fe9Ae9Bj9Fj9Gj9Hmjgvzknerljyilj",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 305,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 12 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "divine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1305,
              "apCost": 4,
              "name": "Consecration",
              "shortDescription": "Area Effect 2, Range 5: Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  Affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "consecrate_earth"
            },
            {
              "default": false,
              "id": 605,
              "apCost": 3,
              "name": "Righteous Shield",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "aegis"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1741,
      "name": "Primordial Enigma",
      "description": "\"It is a shame to hurt a thing so bright and strange.\" -- \"And an even greater shame that it can't be hurt!\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 73,
      "hash": "eJ8HJ8Gf1Af1BG2Ae9BJ8Jj9Aeeiluowvsfmwfpf",
      "artist": "Danh Nguyen",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 141,
          "apCost": 0,
          "name": "Electricity Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novaelectric"
        },
        {
          "id": 3233,
          "apCost": 0,
          "name": "Enigma Shield",
          "shortDescription": "This champion is immune to damage from champion abilities (including basic attacks) if the source is not within 4 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "enigma_shield"
        },
        {
          "id": 3006,
          "apCost": 0,
          "name": "Nora Induction",
          "shortDescription": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ichor_utility"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1331,
              "apCost": 0,
              "name": "Electricity Eater",
              "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_electric"
            },
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 2556,
              "apCost": 0,
              "name": "Vitality: Nora",
              "shortDescription": "The first time each turn that nora is generated via spells, relics and abilities, this champion gains +2 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "noragen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2361,
              "apCost": 0,
              "name": "Repulsion",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly away from this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "repulsion"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 827,
      "name": "Prince Malandur",
      "description": "Prince Malandur hails from the Randgal bloodline; the royal family of ThunderHoofs. Malandur would go to Maljara on behalf of Lord Maxxarek. With this, he would bring pride to the Randgals and a secure hold for Sheoul.\r\n\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight",
        "Warrior"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 86,
      "hash": "dj9AJ8Jf1AG2BF0BJ8IJ8Jj9Aeiymuohyrzileeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2392,
          "apCost": 0,
          "name": "Battle Leader",
          "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "divine"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 870,
          "apCost": 1,
          "name": "Hammer Throw",
          "shortDescription": "Make a magical attack with a range of 3-6, at +2 DMG against target enemy unit.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "hammer"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2557,
              "apCost": 0,
              "name": "Martyrdom",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 8 HP. If this unit shares a race with the destroyed unit, also gain +1 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "intensify"
            },
            {
              "default": false,
              "id": 3143,
              "apCost": 0,
              "name": "Lead the Charge",
              "shortDescription": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "lead_the_charge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 608,
              "apCost": 0,
              "name": "Majestic",
              "shortDescription": "Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "majestic"
            },
            {
              "default": false,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            }
          ]
        }
      ]
    },
    {
      "id": 1360,
      "name": "Princess Ctharia",
      "description": "The true power behind the Circadians, the Caecaelia, though few in number, control the upper echelons of Circadian society.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God",
        "Priest"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 94,
      "hash": "ej9Bj9AE8DF0Ae9Af1Bj9Ej9Fgyonwiymufvfepf",
      "artist": "Michele Chang",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2881,
          "apCost": 0,
          "name": "Mirefolk Fealty",
          "shortDescription": "When this champion is deployed, friendly champions gain <ability value=1783>Subsume</ability> for 4 turns.  If the affected champion is a Mirefolk, it also gains <ability value=399>Force Barrier 2</ability> for 4 turns.\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 2593,
          "apCost": 0,
          "name": "Mirefolk Resurgence",
          "shortDescription": "When this unit is deployed, friendly champions gain 1 AP. If the affected champion is a Mirefolk, it also gains +2 DMG for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 331,
          "apCost": 0,
          "name": "Regal Presence",
          "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "majestic"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 605,
              "apCost": 3,
              "name": "Righteous Shield",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2132,
              "apCost": 0,
              "name": "Water Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainwater"
            },
            {
              "default": false,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            },
            {
              "default": true,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            }
          ]
        }
      ]
    },
    {
      "id": 1474,
      "name": "Princess Ctharia",
      "description": "The true power behind the Circadians, the Caecaelia, though few in number, control the upper echelons of Circadian society.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God",
        "Priest"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 94,
      "hash": "eJ8IJ8He9BF0Be9AF0AJ8GJ8Heerzmytziwzxfm",
      "artist": "Michele Chang",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2881,
          "apCost": 0,
          "name": "Mirefolk Fealty",
          "shortDescription": "When this champion is deployed, friendly champions gain <ability value=1783>Subsume</ability> for 4 turns.  If the affected champion is a Mirefolk, it also gains <ability value=399>Force Barrier 2</ability> for 4 turns.\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 2593,
          "apCost": 0,
          "name": "Mirefolk Resurgence",
          "shortDescription": "When this unit is deployed, friendly champions gain 1 AP. If the affected champion is a Mirefolk, it also gains +2 DMG for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 331,
          "apCost": 0,
          "name": "Regal Presence",
          "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "majestic"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 605,
              "apCost": 3,
              "name": "Righteous Shield",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=impervious>Impervious</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2132,
              "apCost": 0,
              "name": "Water Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainwater"
            },
            {
              "default": false,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            },
            {
              "default": true,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            }
          ]
        }
      ]
    },
    {
      "id": 1428,
      "name": "Prismatic Skywing",
      "description": "Valdac's latest experiments show he has the soul of an artist.  A sadistic, homicidal artist, but an artist nonetheless.\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 84,
      "hash": "ej9Fj9EG2BF0Be9AE8Dj9Cj9Deiexvhyiwftmpqf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 2649,
          "apCost": 0,
          "name": "Void Shield",
          "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tetra_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 1777,
      "name": "Prismatic Wing",
      "description": "Originally formed to combat the increasing threat of the Shattered Peaks, Prismatic Wings lead far reaching expeditions for the Wings of Al'Mara.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 10,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 84,
      "hash": "ej9Fj9Ef1AG2AG2AE8DJ8Jj9Aeiggigvosjilwqf",
      "artist": "Grant Griffin",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 4,
          "apCost": 0,
          "name": "Iron Will",
          "shortDescription": "This champion cannot be <condition value=charmed>Charmed</condition>, <condition value=possessed>Possessed</condition> or <condition value=distracted>Distracted</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "iron_will"
        },
        {
          "id": 3258,
          "apCost": 0,
          "name": "Prismatic Sigil",
          "shortDescription": "This champion gains <ability value=764>Frost Attack</ability>, <ability value=767>Fire Attack</ability> and <ability value=766>Magical Attack</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "griffin_sigil"
        },
        {
          "id": 1006,
          "apCost": 0,
          "name": "Surge: Enemy",
          "shortDescription": "This unit has +1 DMG for each deployed enemy champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "surge_enemy"
        },
        {
          "id": 1264,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2209,
              "apCost": 0,
              "name": "Mirrored",
              "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "mirrored"
            },
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 3362,
              "apCost": 0,
              "name": "Spellsurge: Suppress",
              "shortDescription": "When this champion is deployed, Suppress spells are revealed from your runedock. Suppress spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a friendly Suppress spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 1333,
      "name": "Privateer Captain",
      "description": "I only take payment up front and all contracts have an expiration clause.  And if you ask me to say 'Arr' I'll show you what it means to 'walk the plank.'",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 70,
      "hash": "eJ8IJ8HF0AF0Ae9AF0AJ8HJ8Iitxmexvftuhthn",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 623,
          "apCost": 0,
          "name": "Knockback",
          "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 2152,
          "apCost": 0,
          "name": "Tortun's Trade",
          "shortDescription": "This ability costs 4 nora to activate.  Target Tortun within 5 spaces gains 2 AP.  Each Tortun may be the target of one Tortun's Trade ability per turn.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 0,
          "iconName": "plunder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 839,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +6 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 10,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2296,
              "apCost": 0,
              "name": "Summon: Land Mine",
              "shortDescription": "Summon a Land Mine relic with <ability value=601>Shadowspawn</ability> and <ability value=2149>Land Mine</ability> to target adjacent space.  This ability is hidden.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 15,
              "iconName": "landmine"
            },
            {
              "default": false,
              "id": 2755,
              "apCost": 3,
              "name": "Summon: Artillery Marker",
              "shortDescription": "Summon an Artillery Marker relic with <ability value=2151>Artillery Marker</ability> to target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 20,
              "iconName": "deploy"
            }
          ]
        }
      ]
    },
    {
      "id": 573,
      "name": "Puppet Master",
      "description": "The creature used a Nefari slave to speak. As we approached, the elf attacked. - Thomroy, Priest of Ironfist",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 76,
      "hash": "dj9Gj9Fe9Af1Bf1Bj9Aj9Bj9Cerqfvhnwmnyofgg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1343,
          "apCost": 0,
          "name": "Mystic Push",
          "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "auranegative"
        },
        {
          "id": 2397,
          "apCost": 0,
          "name": "Pawn",
          "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pawn"
        },
        {
          "id": 1527,
          "apCost": 4,
          "name": "Puppet Master",
          "shortDescription": "Target enemy champion within 3 spaces is <condition value=possessed>Possessed</condition>, <condition value=pacified>Pacified</condition> and  gains <ability value=2474>Font Ignorance</ability> for 3 turns and gains this unit's remaining AP. This unit loses all AP and also gains Font Ignorance for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 7,
          "iconName": "disable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1009,
              "apCost": 0,
              "name": "Tariff",
              "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1248,
              "apCost": 3,
              "name": "Pull",
              "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "pull"
            },
            {
              "default": true,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 1630,
      "name": "Pureblood Plainswalker",
      "description": "\"These young fighters have grown up in war, with victory as the only aim. They do not understand the heart of combat.\"",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Archer",
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "ej9Gj9Ff1AF0BG2Ae9AJ8Jj9Aeemuxtfvsuhnuqf",
      "artist": "Grant Griffin",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3149,
          "apCost": 0,
          "name": "Reallocate: Speed",
          "shortDescription": "This champion has +1 SPD and the next champion you deploy from the runedock permanently has -1 SPD.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "reallocate_speed"
        },
        {
          "id": 3127,
          "apCost": 0,
          "name": "True Nature",
          "shortDescription": "When this champion makes a basic attack, the other champion is Dispelled and becomes <condition name=confused>Confused</condition> for the attack.  Damage Shields and abilities that generate a condition for its effect (such as Confuse Attacker) will still trigger.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "true_nature"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2099,
              "apCost": 0,
              "name": "Fire Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "artillery"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1542,
      "name": "Purple Dragon",
      "description": "A purple dragon with a purple top, majestic in its natural habitat.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9DG2AF0Be9Ag3Aj9Bj9Ceeeplgplrfklgrf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 221,
          "apCost": 0,
          "name": "Damage Shield: Physical",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dmgshld_physical"
        },
        {
          "id": 751,
          "apCost": 3,
          "name": "Spike Nova",
          "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novaspike"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": true,
              "id": 2334,
              "apCost": 2,
              "name": "Petrifying Gaze",
              "shortDescription": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "petrifying_gaze"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 1664,
      "name": "Putrid Bile Zombie",
      "description": "Even the filth is disgusted.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 0,
      "hitPoints": 35,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 44,
      "hash": "ej9Bj9AF0AF0BG2Af1BJ8HJ8Ieilemherofexkpf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 562,
          "apCost": 3,
          "name": "Self Destruct",
          "shortDescription": "This unit destroys itself. This ability can only be activated by the unit's owner.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "sacrifice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1111,
              "apCost": 1,
              "name": "Shrine Exertion",
              "shortDescription": "Your Shrine or Avatar loses 10 HP, and this champion recovers 3 AP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "shrinebad"
            },
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 536,
              "apCost": 0,
              "name": "Bile Explosion",
              "shortDescription": "When this unit is destroyed, units within 2 spaces take 15 Acid damage (ignores DEF), are <condition value=blinded>Blinded</condition> for 2 turns and become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 15,
              "iconName": "deathnovaacid"
            }
          ]
        }
      ]
    },
    {
      "id": 1157,
      "name": "Putrid Creeper",
      "description": "\"Curious... this... thing reminds me of someone... special.\" ~ Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 11,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 79,
      "hash": "ej9Bj9Ae9Ae9Ae9Af1Bj9Fj9Gqwojtztfvkufepf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 3133,
          "apCost": 0,
          "name": "Creeping Harvest",
          "shortDescription": "When this champion captures a nora globe, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> increases by 1.  This ability is removed after 3 triggers.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "creep"
        },
        {
          "id": 2695,
          "apCost": 0,
          "name": "Harvest Organs",
          "shortDescription": "When this champion recovers a nora globe, it gains 3 charges and +4 MAX HP permanently.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "killing_stroke"
        },
        {
          "id": 2368,
          "apCost": 0,
          "name": "Mutation: Tough",
          "shortDescription": "Spend 3 charges: This champion gains a rank of <ability value=1900>Tough</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 2553,
          "apCost": 0,
          "name": "Worm Lord",
          "shortDescription": "This champion has <ability value=2526>Necrosis</ability>.  When a real enemy champion is destroyed by a champion with Race: Worm or Necrosis within 5 spaces, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "creep_master"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2438,
              "apCost": 3,
              "name": "Ravish",
              "shortDescription": "Target real champion you own is destroyed. Closest friendly champion to the target champion gains 35% of the destroyed champion's current HP and DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "overkill"
            },
            {
              "default": true,
              "id": 153,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            },
            {
              "default": true,
              "id": 249,
              "apCost": 0,
              "name": "Damage Shield: Acid",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Acid damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_acid"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            }
          ]
        }
      ]
    },
    {
      "id": 1349,
      "name": "Pyro the Patient",
      "description": "\"It's all very well being known for his patience, but frankly he just sits around until something gets in the way of his rifle. If I paid him at all it would be too much.\" ~ Xulos, when asked about Pyro the Patient",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Archer"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "eJ8JJ8Ig3AF0Ae9AF0Bj9Dj9Eeeeeerluoyzxmpf",
      "artist": "Christian Fell",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2574,
          "apCost": 0,
          "name": "Preparation",
          "shortDescription": "At the end of each of its turns, if this unit did not attack, it has +1 DMG and +1 MAX RNG.  This effect stacks up to 4 times and is reset at the end of turn when this unit makes an attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "surge"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 1166,
          "apCost": 0,
          "name": "Taunt: Pyro",
          "shortDescription": "Taunt your enemies.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 563,
      "name": "Quagmirrian",
      "description": "We are the Old Ones. We protect Forglar and serve its kin. - Quagmirrian Pytal",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 72,
      "hash": "dJ8IJ8HF0Af1BG2Aj9Bj9Cj9Dwvmyonhtuvzvkeg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1866,
          "apCost": 0,
          "name": "Gift of Scrying",
          "shortDescription": "You have an additional rune reveal each of your turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "scry"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 2132,
          "apCost": 0,
          "name": "Water Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainwater"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1917,
              "apCost": 0,
              "name": "Revere: Hydraxor",
              "shortDescription": "While this champion is in play, Hydraxor costs 10% less nora to deploy. While Hydraxor is in play, this champion gains <ability value=1325>Domain: Water</ability> and any damage this champion deals counts toward Hydraxor's <ability value=1892>Quest: Damage</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            }
          ]
        }
      ]
    },
    {
      "id": 821,
      "name": "Queen Anaru",
      "description": "\"I will go for K'thir, Menalaus. My lerpers and I will aid those in Gharivol. Do not think on it another moment. I make my way to Seljichan tomorrow.\" - Anaru, the Lerper Queen",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Elf"
      ],
      "noraCost": 88,
      "hash": "dJ8JJ8IF0BG2BG2Bj9Cj9Dj9Eeeeeeevsqlgrqhg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2429,
          "apCost": 0,
          "name": "Flanking",
          "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "flank"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2135,
          "apCost": 0,
          "name": "Pet: Tamed Lerper",
          "shortDescription": "When this champion is deployed, a Tamed Lerper without upgrades is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "pet"
        },
        {
          "id": 2077,
          "apCost": 0,
          "name": "Reflexes",
          "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "reflexes"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2196,
              "apCost": 0,
              "name": "Nora Barrier",
              "shortDescription": "When this champion is deployed, it is <condition value=norashielded>Nora Shielded</condition> for 8 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "nora_barrier"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1216,
              "apCost": 0,
              "name": "Equalize",
              "shortDescription": "If your enemy controls more champions than you, receive a 15% nora refund when this champion comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 1753,
      "name": "Quillbeast Pango",
      "description": "\"Don't look at it, don't spook it, and especially don't touch it. Just get your heads down and keep moving.\" -- Deep Elf scouting party",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 69,
      "hash": "eJ8JJ8IF0Bf1BG2AF0BJ8IJ8Jygygnpwvkjrwkpf",
      "artist": "Anthony Lopes",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 101,
          "apCost": 1,
          "name": "Barrage",
          "shortDescription": "This champion makes its basic ranged attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "arrowaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2352,
              "apCost": 0,
              "name": "Defensive Turtle",
              "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "turtle"
            },
            {
              "default": false,
              "id": 647,
              "apCost": 3,
              "name": "Turtle",
              "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "turtle"
            },
            {
              "default": false,
              "id": 1604,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "damageshield"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 1929,
      "name": "Raava, Sage of Braz",
      "description": "It wasn't until Raava saw her late friend in the elf's eyes that she realized the Epochal elves could not ignore Bliss' request. The Sage of Braz would aid them.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Monk"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 72,
      "hash": "ej9AJ8Jf1Bg3AG2Af1Aj9Aj9Bkpytoqlnwzvhirf",
      "artist": "Phu Thieu",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1566,
          "apCost": 0,
          "name": "Balance",
          "shortDescription": "When this unit comes into play, enemy champions take 3 Physical damage and friendly champions are healed for 2 HP.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "soul_bond"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        },
        {
          "id": 3368,
          "apCost": 0,
          "name": "Taunt: Raava",
          "shortDescription": "Taunt your enemies with the phrase \"Time is wasted on you!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        },
        {
          "id": 2748,
          "apCost": 3,
          "name": "Time Bend",
          "shortDescription": "This champion is removed from play. At the end of 2 turns, it is returned to play in the location where it was removed from play. If that location is occupied, the redeployment effect is delayed for 1 turn (this process repeats until the unit is successfully redeployed). This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "confuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 1776,
              "apCost": 0,
              "name": "Premonition",
              "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1338,
              "apCost": 0,
              "name": "Grand Entrance",
              "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "majestic"
            }
          ]
        }
      ]
    },
    {
      "id": 1212,
      "name": "Rage of the Circle",
      "description": "\"This is exactly why I was against this!\" ~ Menalaus upon learning the fate of the Rage that fall in battle",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elemental",
        "Elf"
      ],
      "noraCost": 73,
      "hash": "ej9Fj9Ee9Ae9Be9AE8Dj9Fj9Grwvmljlgyigpyo",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 189,
          "apCost": 0,
          "name": "Death Nova: Electricity",
          "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovaelec"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        },
        {
          "id": 964,
          "apCost": 4,
          "name": "Reckless Teleport",
          "shortDescription": "Range 7: This champion is relocated to a random location within 2 spaces of target space.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 2763,
              "apCost": 0,
              "name": "Lightning Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Electricity Aura 3.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            }
          ]
        }
      ]
    },
    {
      "id": 72,
      "name": "Ranger",
      "description": "He moves with the spirit of the wind behind him.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 74,
      "hash": "bj9Ej9Dj9CG2Bj9Cj9Dj9Ej9Fvqllpusoferhnpn",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 218,
          "apCost": 0,
          "name": "Dodge",
          "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 9,
          "iconName": "dodge"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 521,
      "name": "Ranger Elite",
      "description": "We must defend K`thir from the front lines. The Eternal Circle has no say in this. - S`etra, Elite Ranger",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 78,
      "hash": "dj9Ej9Dg3Af1Af1Bj9Aj9Bj9Ceeeitxvzmllygig",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 336,
      "name": "Rascal Fairy",
      "description": "As sure as the trees make shade and the birds sing at dawn, the Rascal Fairies make mischief to all that surround them. Only now, they do so in defense of K'thir, much to the relief of the forest.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 37,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer",
        "Rogue"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 71,
      "hash": "dj9Bj9Af1BF0AE8Dj9Ej9Fj9Gevkuvzkruknnneg",
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 1017,
          "apCost": 1,
          "name": "Knockout",
          "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "stun"
        },
        {
          "id": 2540,
          "apCost": 0,
          "name": "Trickster",
          "shortDescription": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 1147,
      "name": "Rattle Slag",
      "description": "\"Their single minded determination to hunt down their target implies that they have a mind in the first place, which is clearly a ridiculous notion.\" - Calis, Lonx Beastmaster",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 70,
      "hash": "ej9AJ8Je9Ae9Ae9Af1Aj9Fj9Gymjpsxvssmsjwo",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 201,
          "apCost": 0,
          "name": "Death Nova: Acid",
          "shortDescription": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "deathnovaacid"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            },
            {
              "default": false,
              "id": 3016,
              "apCost": 0,
              "name": "Life Siphon: Scoured",
              "shortDescription": "When this champion successfully damages a champion with <condition value=scoured>Scoured</condition> with a basic attack, it vampiric heals HP equal to half the damage dealt (rounded down).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "siphon_scoured"
            },
            {
              "default": true,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 850,
              "apCost": 1,
              "name": "Acid Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "acidaoe"
            },
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 2620,
              "apCost": 4,
              "name": "Corrosive Grenade",
              "shortDescription": "Area Effect 2, Range 5: Affected units take 8 Acid Damage and becomes <condition value=sundered>Sundered</condition> for 3 turns.  This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "acidaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 183,
      "name": "Ravager",
      "description": "If we use the tunnels we should be able to make it outside before the Drakies miss us and send their dogs. - Dwarven prisoners planning an escape",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 73,
      "hash": "dj9Dj9CG2Be9AF0AJ8HJ8IJ8Jeeigtukjgkumnyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 684,
          "apCost": 1,
          "name": "Execute",
          "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "execute"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 666,
      "name": "Ravenwraith",
      "description": "In some accounts of Elsarin's fall, there were tales of wraiths that came to devour the souls of the deceased.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 78,
      "hash": "dj9Ej9Dg3Af1BF0AJ8HJ8IJ8Jumnwmnhnnnsjtfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 711,
          "apCost": 0,
          "name": "Siphoning Aura",
          "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "possess"
        },
        {
          "id": 1783,
          "apCost": 0,
          "name": "Subsume",
          "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 98,
              "apCost": 0,
              "name": "Lifedrinker",
              "shortDescription": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 3023,
              "apCost": 0,
              "name": "Surge: Cursed",
              "shortDescription": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_cursed"
            },
            {
              "default": true,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            }
          ]
        }
      ]
    },
    {
      "id": 73,
      "name": "Razorfin Slider",
      "description": "Avoid the deeper swamp when you ride your toads. There are monstrous beasts who would feast upon young hoppers like you. - Flean",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 8,
      "damage": 13,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 62,
      "hash": "cJ8IJ8HJ8Ge9BF0BJ8GJ8HJ8Ivxxzgpussjyitoh",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 114,
          "apCost": 0,
          "name": "Aquatic",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "aquatic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1405,
          "apCost": 4,
          "name": "Dive",
          "shortDescription": "This unit is relocated to target water space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_dive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1044,
              "apCost": 0,
              "name": "Trail: Water",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Water (Impeding 1) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_water"
            },
            {
              "default": true,
              "id": 2625,
              "apCost": 0,
              "name": "Water Veil",
              "shortDescription": "When this champion comes into play, spaces within 10 spaces turns into Shallow Water terrain for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainwater"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 328,
      "name": "Reckless Spellhack",
      "description": "The G'hern could not make use of any of the things they found after their raid on an Elven mage tower. However, some Moga could get the Elven wands to react if they shook them long enough.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 0,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Moga"
      ],
      "noraCost": 49,
      "hash": "dj9AJ8Jf1AF0AE8Dj9Ej9Fj9Geerztmpnjruqfeg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 679,
          "apCost": 0,
          "name": "G'hernbound",
          "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ghernbound"
        },
        {
          "id": 962,
          "apCost": 1,
          "name": "Reckless Blast",
          "shortDescription": "This unit makes a Magical attack at RNG 2-5 at 12 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 964,
          "apCost": 4,
          "name": "Reckless Teleport",
          "shortDescription": "Range 7: This champion is relocated to a random location within 2 spaces of target space.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "relocate"
        },
        {
          "id": 1962,
          "apCost": 0,
          "name": "Weaken Spells",
          "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dark_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 760,
              "apCost": 3,
              "name": "Magic Nova",
              "shortDescription": "This unit deals 9 Magic damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged have -1 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novamagic"
            }
          ]
        }
      ]
    },
    {
      "id": 1746,
      "name": "Red Minister",
      "description": "For those in the Minister ranks of the Stronghold, the \"Red\" mark signifies a negotiator of the highest order.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8Hf1Bf1BG2AF0Aj9Aj9Bitxvxieipuzvoqf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 668,
          "apCost": 2,
          "name": "Battle Drum",
          "shortDescription": "All friendly champions from the same faction as this one gain <condition value=benediction>Benediction</condition> for 1 turn and recover 1 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "drum"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            },
            {
              "default": false,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 1669,
      "name": "Red Temple Guard",
      "description": "Akakios argued the importance of protecting the temples of Valdac from invaders. He would need warriors, warriors who spent years in service, warriors who knew what it was to protect.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 8,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Knight"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 66,
      "hash": "ej9Bj9AG2BF0BG2Af1Bj9Cj9Deiegygyxkrlplrf",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 877,
          "apCost": 0,
          "name": "Bodyguard",
          "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "block"
        },
        {
          "id": 31,
          "apCost": 0,
          "name": "Defender",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "defenseenhance"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2032,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +4 HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plushealth"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        }
      ]
    },
    {
      "id": 1694,
      "name": "Red-tipped Raptor",
      "description": "The flaming manes of the Red-tipped Raptor makes a striking contrast to the raptor's sleek exterior.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 77,
      "hash": "eJ8IJ8He9Af1AG2AF0Aj9Fj9Grqjwkygerousmpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3082,
          "apCost": 3,
          "name": "Flame Surge",
          "shortDescription": "This champion gains 3 AP and Pacified for 1 turn. For each space moved, enemy champions within 2 spaces take 3 Fire damage (this damage ignores DEF). This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "charge_flame"
        },
        {
          "id": 480,
          "apCost": 0,
          "name": "Lavawalker",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainlava"
        },
        {
          "id": 3085,
          "apCost": 0,
          "name": "Sabotage: Fire",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sabotage_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": true,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1256,
              "apCost": 0,
              "name": "Sibling",
              "shortDescription": "When this champion is deployed, champions with the same name are revealed in your runedock. When you have a champion in play with the same name as this one, this champion gains +1 DEF, +1 SPD and +5 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "sibling"
            },
            {
              "default": false,
              "id": 29,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 454,
      "name": "Redcap Twins ",
      "description": "Known to most as the Sisters of Blood, these twins are deadly when fighting in tandem.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue",
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 68,
      "hash": "dj9Fj9EE8Df1AG2Bj9Cj9Dj9Eeeeemegpyoshnhg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 2595,
          "apCost": 0,
          "name": "Hunter: Bloodied",
          "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "blood_debt"
        },
        {
          "id": 1256,
          "apCost": 0,
          "name": "Sibling",
          "shortDescription": "When this champion is deployed, champions with the same name are revealed in your runedock. When you have a champion in play with the same name as this one, this champion gains +1 DEF, +1 SPD and +5 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "sibling"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3141,
              "apCost": 3,
              "name": "Blood Convergence",
              "shortDescription": "Target enemy champion within 5 spaces loses 4 HP per Blood Ball within 3 spaces of it. Those Blood Balls are consumed and this champion vampiric heals for 50% of the HP lost to a maximum of 20 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "bloodball"
            },
            {
              "default": false,
              "id": 2197,
              "apCost": 3,
              "name": "Blood Magic",
              "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3151,
              "apCost": 0,
              "name": "Bloodspurt",
              "shortDescription": "When this unit is successfully attacked with a basic attack, the target is Bloodied (This unit cannot stealthed) for 6 turns and a blood ball worth 5 DMG is created in an adjacent space to the attacker.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 1251,
              "apCost": 0,
              "name": "Raze",
              "shortDescription": "When this champion comes into play, your opponents shrine takes 5 damage. Transfigured Avatars take 15",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "shrinebad"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 899,
      "name": "Redfist",
      "description": "\"You must burn like fire! Strike with force and fury! Anger is a weapon, not a hindrance. One swift strike won't require another.\" - Tranh, Redfist Monk",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9Bg3AF0AJ8HJ8IJ8Jeeerziphruxtsxf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 213,
          "apCost": 0,
          "name": "Block",
          "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "block"
        },
        {
          "id": 2279,
          "apCost": 0,
          "name": "Charged Flame Fist",
          "shortDescription": "Spend 4 Charges. This unit makes a Fire attack at +2 DMG at its range against target unit.",
          "activationType": 3,
          "level": 0,
          "cooldown": 1,
          "noraCost": 8,
          "iconName": "chrg_flame_fist"
        },
        {
          "id": 2282,
          "apCost": 0,
          "name": "Ki Strike",
          "shortDescription": "This champion's next basic attack this turn has +DMG equal to the number of charges it currently has and the champion loses a third of its charges (rounded down).",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "ki_strike"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2167,
              "apCost": 0,
              "name": "Attack Charged",
              "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            },
            {
              "default": false,
              "id": 2178,
              "apCost": 0,
              "name": "Supercharged",
              "shortDescription": "This unit gains 1 charge at the start of its turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "supercharged"
            },
            {
              "default": true,
              "id": 2261,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 2818,
              "apCost": 0,
              "name": "Forbidden Discipline",
              "shortDescription": "The next basic attack this champion makes causes the target to become <condition value=frightened>Frightened</condition> for 2 turns. If the target was <condition value=frozen>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "discipline_forbidden"
            }
          ]
        }
      ]
    },
    {
      "id": 1732,
      "name": "Redtide Neuromancer",
      "description": "It is said that when the Neuromancer assaults the soul of an enemy, the next tide runs red.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Boghopper",
        "Firk"
      ],
      "noraCost": 72,
      "hash": "ej9Gj9Ff1Bf1BG2Ae9Aj9Aj9Betmsqqowmpjthrf",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2338,
          "apCost": 0,
          "name": "Psychic Magnetism",
          "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull"
        },
        {
          "id": 1778,
          "apCost": 0,
          "name": "Sabotage: Psychic",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sabotage_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 2193,
              "apCost": 0,
              "name": "Psychic Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and <ability value=161>Psychic Aura 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped_psychic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3067,
              "apCost": 0,
              "name": "Psychic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "psychicaoe"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            }
          ]
        }
      ]
    },
    {
      "id": 1703,
      "name": "Reflecting Creeper",
      "description": "Stare at them, and you will always find yourself staring back.  This is one staring contest you won't win.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 70,
      "hash": "ej9AJ8JG2Bf1AG2Af1Aj9Cj9Duzxtqqzvhnpljrf",
      "artist": "Caio Monteiro",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2209,
          "apCost": 0,
          "name": "Mirrored",
          "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "mirrored"
        },
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3013,
              "apCost": 0,
              "name": "Soultap Feedback",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "soultap_feedback"
            },
            {
              "default": true,
              "id": 2032,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +4 HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plushealth"
            },
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2824,
              "apCost": 0,
              "name": "Incoherent Babbling",
              "shortDescription": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "rover_babbling"
            }
          ]
        }
      ]
    },
    {
      "id": 74,
      "name": "Renegade",
      "description": "He follows no gods, no laws, no code but his own.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 60,
      "hash": "cj9Ej9Dj9CG2Be9Bj9Cj9Dj9Eeeeeruvkyirfkji",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1719,
          "apCost": 0,
          "name": "Conqueror",
          "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 654,
      "name": "Resilient Skeezick ",
      "description": "The rebellion had died in them, replaced, in some, by an unbending fealty to Valdac.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 71,
      "hash": "dj9Gj9Fe9AG2AG2Aj9Bj9Cj9Drhyiextfrwvquhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1783,
          "apCost": 0,
          "name": "Subsume",
          "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            }
          ]
        }
      ]
    },
    {
      "id": 1629,
      "name": "Reticulated Splinehawk",
      "description": "\"They wanted a bird, they got a bird. Don't those turtles know a bird when they see one?\" -- Tarren, Tinker's Apprentice",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 66,
      "hash": "ej9Gj9FF0BF0BG2Ae9AJ8IJ8Jepssztfmwojlpqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3126,
          "apCost": 0,
          "name": "Gift: Spare Wings",
          "shortDescription": "The next champion you deploy from the runedock while this champion is in play has +1 SPD and <ability value=1>Flight</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "gift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": true,
              "id": 3089,
              "apCost": 0,
              "name": "Initiator",
              "shortDescription": "This champion deals 4 additional damage to champions with 35 or more HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiator"
            },
            {
              "default": false,
              "id": 1509,
              "apCost": 0,
              "name": "Blitz",
              "shortDescription": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3142,
              "apCost": 0,
              "name": "Empowered: Speed",
              "shortDescription": "This champion has +1 SPD and Mobility. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_speed"
            },
            {
              "default": true,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 742,
      "name": "Revenant",
      "description": "The Revenants are spirits, summoned to fulfill a command given to them by their summoners. Once they've completed their appointed task, they are freed from their bond. Unlife for a Revenant is often short.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 28,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Skeleton",
        "Spirit",
        "Undead"
      ],
      "noraCost": 35,
      "hash": "dj9Cj9BG2AG2AG2Aj9Bj9Cj9Dpnuklrhvxztuhig",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 875,
          "apCost": 0,
          "name": "Short Lived",
          "shortDescription": "This unit is destroyed after 6 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": -20,
          "iconName": "ondeath"
        },
        {
          "id": 3013,
          "apCost": 0,
          "name": "Soultap Feedback",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "soultap_feedback"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": true,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 1328,
      "name": "Revolting Fentek",
      "description": "For whatever reason, the Fentek were particularly susceptible to the influences of the Plague.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 61,
      "hash": "eJ8HJ8GG2BF0Ae9Ae9Bj9Cj9Demeiplwmlgiiwo",
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3145,
          "apCost": 0,
          "name": "Empowered: Defense",
          "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "fragile_defense"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1094,
              "apCost": 0,
              "name": "Poison Eater",
              "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_poison"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1346,
              "apCost": 3,
              "name": "Poison Charge",
              "shortDescription": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            },
            {
              "default": true,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            }
          ]
        }
      ]
    },
    {
      "id": 544,
      "name": "Rip Demon",
      "description": "A gift for you, noble Akakios, of our union. A warrior made of ash and scale. - Siralis, Nefari Messenger",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Draksar"
      ],
      "noraCost": 66,
      "hash": "dj9Gj9Fe9Af1BG2Bj9Cj9Dj9Eeemwzmlerouvfig",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands",
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1444,
          "apCost": 0,
          "name": "Counter Attack: Melee",
          "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "counter"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1603,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 3 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 229,
              "apCost": 0,
              "name": "Damage Shield: Fire",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_fire"
            },
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 380,
              "apCost": 3,
              "name": "Flame Nova",
              "shortDescription": "This unit deals 9 Fire damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=inhibited>Inhibited</condition> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 541,
      "name": "Rip Demon Alpha",
      "description": "Behold! The union of Sheoul and Valdac, of ash and scale, of demon and Draksar. - Lord Maxxarek",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Draksar"
      ],
      "noraCost": 76,
      "hash": "dj9Gj9Fe9Af1BF0BJ8IJ8Jj9Atzzziekygpsxfeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands",
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1504,
          "apCost": 0,
          "name": "Brutality",
          "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "surge"
        },
        {
          "id": 1445,
          "apCost": 0,
          "name": "Counter Attack: Ranged",
          "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG of 2 or more.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "reflexes"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1603,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 3 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "damageshield"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 1112,
      "name": "Rip Witch",
      "description": "\"Flesh is such a feeble thing. Just the smallest amount of pressure in the correct spot at the correct time, and a body will empty itself of all that it would normally hold dear.\" - Jezevel, Rip Witch\r\n",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human",
        "Vampyre"
      ],
      "noraCost": 75,
      "hash": "ej9Gj9FG2Ae9Ae9Ae9Aj9Bj9Cevkgnlegrqonjpf",
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3398,
          "apCost": 0,
          "name": "Sanguine Sorceress",
          "shortDescription": "This champion has <ability value=607>Essence Capture</ability>. While there is a friendly champion with <ability value=3399>Lord of Strigoi</ability> in play, friendly champions with Race: Vampyre within 3 spaces of this champion gain <ability value=3151>Bloodspurt</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "greater_vampirism"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 2642,
              "apCost": 0,
              "name": "Dictate",
              "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "dictate"
            },
            {
              "default": false,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 1073,
      "name": "Risen Grenadier",
      "description": "When Maljaria was discovered, the Buckleshell pirates rejected the protectorate treaties and sailed away. Years later, some have returned, victims of a new necromancy, unknown even to Xulos. They seem to have have free will, but cannot speak. ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Archer"
      ],
      "races": [
        "Tortun",
        "Undead",
        "Zombie"
      ],
      "noraCost": 72,
      "hash": "ej9Cj9Bg3AE8De9AG2Aj9Dj9Eeevoshnpquowtqf",
      "artist": "Alex Fang",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 2945,
          "apCost": 4,
          "name": "Summon: Long Fuse Bomb",
          "shortDescription": "Summon a Long Fuse Bomb relic with <ability value=2946>Long Fuse Bomb</ability>, <ability value=1056>Impregnable</ability> and <ability value=2260>Pariah</ability> to target space within 4 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "cannon_barrage"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 2152,
          "apCost": 0,
          "name": "Tortun's Trade",
          "shortDescription": "This ability costs 4 nora to activate.  Target Tortun within 5 spaces gains 2 AP.  Each Tortun may be the target of one Tortun's Trade ability per turn.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 0,
          "iconName": "plunder"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": true,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3286,
              "apCost": 0,
              "name": "Sabotage: Defile",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play becomes <condition value=diseased>Diseased 3</condition>, <condition value=defiled>Defiled</condition> and <condition value=inhibited>Inhibited</condition> for 8 rounds.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_defile"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        }
      ]
    },
    {
      "id": 871,
      "name": "Risen Moga",
      "description": "\"KHashinkshink ere arrgh chooo?\" - Chiba, Risen Moga searching for his master.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Moga",
        "Undead",
        "Zombie"
      ],
      "noraCost": 60,
      "hash": "dj9Ej9Dg3AG2BG2Bj9Cj9Dj9Eeeeeigtuhrsjymh",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2470,
          "apCost": 1,
          "name": "Howling Attack",
          "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "horrific_howl"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 205,
              "apCost": 0,
              "name": "Death Nova: Disease",
              "shortDescription": "When this unit is destroyed, it deals 11 Disease damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovadisease"
            },
            {
              "default": false,
              "id": 1126,
              "apCost": 0,
              "name": "Ally: Shattered Peaks",
              "shortDescription": "While there are other friendly Shattered Peaks champions in play, this champion gets +7 HP and +2 DMG. Shattered Peaks champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_sp"
            },
            {
              "default": true,
              "id": 253,
              "apCost": 0,
              "name": "Damage Shield: Disease",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Disease damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_disease"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1144,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 50% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "diseaseaoe"
            },
            {
              "default": false,
              "id": 1145,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "diseaseaoe"
            },
            {
              "default": true,
              "id": 1146,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "diseaseaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 186,
      "name": "Risen Yeti",
      "description": "It's a pity that undeath makes the hair fall out. Still he's no less fearsome. - Xulos, Apprentice to Serkan",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Yeti",
        "Zombie"
      ],
      "noraCost": 67,
      "hash": "dj9Dj9CG2Be9Af1Bj9Aj9Bj9Ceipqljrzkyzkwfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes",
        "Savage Tundra"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1847,
              "apCost": 0,
              "name": "Hunter: Diseased",
              "shortDescription": "When this unit would deal damage to a <condition value=diseased>Diseased</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=diseased>Diseased</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2067,
              "apCost": 0,
              "name": "Frightful Aura",
              "shortDescription": "All opposing champions within 3 spaces have -2 DMG. All friendly undead champions within 3 spaces have +2 DEF.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 943,
      "name": "Ritual Crone",
      "description": "\"The rituals are all we have left. There is no kingdom, no promised land waiting for us. Turn away from Kiergana. Turn to Kain Taris.\" - Crone Reiayko",
      "maxRng": 6,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 74,
      "hash": "dj9Bj9Af1Bg3Af1AJ8Jj9Aj9Bmszzxquvkphyggg",
      "artist": "Michele Chang",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2161,
          "apCost": 0,
          "name": "Charged",
          "shortDescription": "When this unit comes into play, it gains 5 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "heal_charged"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2300,
          "apCost": 0,
          "name": "Charged Blast",
          "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2958,
          "apCost": 3,
          "name": "Ritual of Power",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "deconstruct"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2178,
              "apCost": 0,
              "name": "Supercharged",
              "shortDescription": "This unit gains 1 charge at the start of its turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "supercharged"
            },
            {
              "default": false,
              "id": 2175,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "charged_spell"
            },
            {
              "default": true,
              "id": 2740,
              "apCost": 0,
              "name": "Race Charged",
              "shortDescription": "At the beginning of its turn, this unit gains 1 charge for every two friendly champion within 6 spaces that shares a race with it, to a maximum of 3 charges.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "charged_race"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 2389,
              "apCost": 3,
              "name": "Pain Curse",
              "shortDescription": "Opposing <condition value=cursed>Cursed</condition> champions take 5 magical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "defile_corpse"
            },
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 932,
      "name": "Ritual Cultist",
      "description": "\"Rituals are important. Without them, we are no more than a pack of roaming animals. When we have Kain Taris, we have a legion.\" - Cultist Reiayko",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 69,
      "hash": "dj9AJ8Jf1Ag3Af1Bj9Aj9Bj9Ceeerlykroyruhgg",
      "artist": "Michele Chang",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 2178,
          "apCost": 0,
          "name": "Supercharged",
          "shortDescription": "This unit gains 1 charge at the start of its turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "supercharged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1786,
              "apCost": 3,
              "name": "Ritual of Destruction",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_damage"
            },
            {
              "default": false,
              "id": 1785,
              "apCost": 3,
              "name": "Rite of Healing",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "fascinate"
            },
            {
              "default": true,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            }
          ]
        }
      ]
    },
    {
      "id": 331,
      "name": "Rock Guardian",
      "description": "There is a special bond between dwarves and stone. Some even have the ability to create the great stone golems. Few have the power to bind themselves to with rock, and become an avatar of the earth.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 74,
      "hash": "dj9AJ8Jf1AF0AF0BJ8IJ8Jj9Aeipyvhgkyvhvhyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1702,
          "apCost": 0,
          "name": "Blockade",
          "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "blockade"
        },
        {
          "id": 968,
          "apCost": 2,
          "name": "Golem Form",
          "shortDescription": "This unit is <mechanic value=cleansed>Cleansed</mechanic> and gets 15 MAX HP, +1 DEF, <ability value=48>Resistance: Physical 3</ability>, and <ability value=5>Lumbering</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        },
        {
          "id": 969,
          "apCost": 0,
          "name": "Shrine Defender",
          "shortDescription": "While this unit is within your 8 spaces of its shrine, this unit gets +2 DMG and +2 SPD and your Shrine has +8 HP. When your Shrine is Transfigured, this unit has <ability value=1759>Impassioned</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "tgtdefensive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3145,
              "apCost": 0,
              "name": "Empowered: Defense",
              "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "fragile_defense"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2531,
              "apCost": 0,
              "name": "Bounce",
              "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            }
          ]
        }
      ]
    },
    {
      "id": 1834,
      "name": "Rockcharger Warbeast",
      "description": "The Voil Empire, in a push to gather ever larger armies, enslaved every creature they could find. Some, like the moga and cyclops, chafed at the reins. Others, like the warbeasts, embraced their position.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 88,
      "hash": "eJ8IJ8HG2AG2BG2AF0Aj9Bj9Cevfmhyoukufvxqf",
      "artist": "Danh Nguyen",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 3307,
          "apCost": 5,
          "name": "Invoke: Warbeast Roar",
          "shortDescription": "Area Effect 4: Friendly champions (including this one) gain +3 DMG for 2 turns and enemy champions take 8 Sonic damage and become <condition value=frightened>Frightened</condition> for 2 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 10,
          "iconName": "invoke"
        },
        {
          "id": 869,
          "apCost": 3,
          "name": "Tremor",
          "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2688,
              "apCost": 4,
              "name": "Screech",
              "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "sonicaoe"
            },
            {
              "default": true,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 3186,
              "apCost": 0,
              "name": "Fractured Lands",
              "shortDescription": "When an enemy champion within 5 spaces makes a basic attack, it loses 2 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "trail_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2632,
              "apCost": 0,
              "name": "Bold",
              "shortDescription": "This champion has +1 DEF for 2 turns for each space it moves, to a maximum of +5 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "channel_defense"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 1260,
      "name": "Rockforger",
      "description": "Its obsessive compulsion to create tiny versions of itself has fascinated observers for years.  Most don't watch long enough to see it consume its own creations, however.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 11,
      "hitPoints": 56,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental",
        "Troll"
      ],
      "noraCost": 79,
      "hash": "ej9Bj9AE8De9Be9Af1Bj9Ej9Fiwowxfvhklphyo",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1720,
          "apCost": 1,
          "name": "Consume",
          "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 2661,
          "apCost": 0,
          "name": "Geogenesis",
          "shortDescription": "At end of this champion's first turn and every three thereafter, a Rockling with no upgrades is summoned to an adjacent space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "sum_rockling"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        },
        {
          "id": 2571,
          "apCost": 0,
          "name": "Rock Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Rock for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "trail_rock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            },
            {
              "default": false,
              "id": 1978,
              "apCost": 0,
              "name": "Vitalize",
              "shortDescription": "Other real friendly champions within 5 spaces with 5 base SPD or less get +1 SPD while this unit is in play. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2662,
              "apCost": 0,
              "name": "Surge: Rock",
              "shortDescription": "This unit has +1 DMG for every 2 champions occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            }
          ]
        }
      ]
    },
    {
      "id": 1308,
      "name": "Rockling",
      "description": "An elemental in the image of the Rockforger",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 5,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 39,
      "hash": "ej9Bj9Ae9Ae9Be9Af1Bj9Fj9Gfggvsqqouqlegpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2527,
          "apCost": 0,
          "name": "Rock Defiance",
          "shortDescription": "When this unit is successfully attacked, this unit and friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "troll_defiance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 970,
              "apCost": 0,
              "name": "Hidden: Rock",
              "shortDescription": "At the end of your turn, if this champion occupies Rock, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1361,
              "apCost": 0,
              "name": "Trail: Rock",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Rock for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1328,
              "apCost": 0,
              "name": "Domain: Rock",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Rock.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_rock"
            },
            {
              "default": true,
              "id": 2034,
              "apCost": 0,
              "name": "Stat Bonus: Damage",
              "shortDescription": "This champion has +1 DMG.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plusdamage"
            }
          ]
        }
      ]
    },
    {
      "id": 425,
      "name": "Rolling Shrieker",
      "description": "There are foul things that live in the sand. The Shriekers can glide through the sand and their screams engulf the mind in terror. - Elven Survivor",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dj9AJ8Jf1AF0BG2Aj9Bj9Cj9Djgilpssmwolgtfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 3157,
          "apCost": 0,
          "name": "Sandbreach",
          "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "terrainsand"
        },
        {
          "id": 1147,
          "apCost": 3,
          "name": "Sonic Roar",
          "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 196,
              "apCost": 0,
              "name": "Death Nova: Sonic",
              "shortDescription": "When this unit is destroyed, it deals 8 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "deathnovasonic"
            },
            {
              "default": true,
              "id": 1907,
              "apCost": 0,
              "name": "Desert Camouflage",
              "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Sand, that damage by is reduced by 2.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "camo"
            },
            {
              "default": false,
              "id": 245,
              "apCost": 0,
              "name": "Damage Shield: Sonic",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Sonic damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_sonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2352,
              "apCost": 0,
              "name": "Defensive Turtle",
              "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "turtle"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 1148,
              "apCost": 4,
              "name": "Tunnel: Sand",
              "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 1154,
      "name": "Rotmaw Creeper",
      "description": "\"Some mistake the corrosive effects of the Rotmaw Creeper's attacks for having acidic properties, when in reality it's just really bad breath.\" ~ Gillo's Guide to Poxanthuru",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 64,
      "hash": "ej9AJ8JG2Be9Ae9Af1Aj9Cj9Drouhgpjnhigeipf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1008,
      "name": "Royal Condor Fury",
      "description": "Multiple conditions must be met for a Fury to don the Royal Colors. 25 Kills, 10 years of service, and a pristine service record are needed before even being considered for the honor of wearing the Royal Colors. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Knight"
      ],
      "races": [
        "Beast",
        "Elf"
      ],
      "noraCost": 79,
      "hash": "eJ8HJ8Ge9BE8De9Ae9BJ8GJ8Heemhyoshyvzosm",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heritage",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3143,
          "apCost": 0,
          "name": "Lead the Charge",
          "shortDescription": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "lead_the_charge"
        },
        {
          "id": 2008,
          "apCost": 0,
          "name": "Liability",
          "shortDescription": "Friendly champions within 5 spaces of this champion have -1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "dampen"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2213,
              "apCost": 0,
              "name": "Crazed Charger",
              "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "crazed_charger"
            },
            {
              "default": true,
              "id": 3059,
              "apCost": 0,
              "name": "Thunderous Charge",
              "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "thunderous_charge"
            }
          ]
        }
      ]
    },
    {
      "id": 968,
      "name": "Royal Geomancer",
      "description": "Geomancy is a form of magic practiced only by Dwarves and Barbarians, and the Royal Geomancers are the masters. To a Royal Geomancer, the act of changing the earth is trivial; and the ability to rend it is just as easy.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 78,
      "hash": "dj9Dj9CG2Bg3Af1AJ8Jj9Aj9Bmsqqqfrssqjnyig",
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2275,
          "apCost": 0,
          "name": "Planar Hold",
          "shortDescription": "All champions within 8 spaces, including this one, have <ability value=680>Planar Bound</ability> and <ability value=669>Earthbound</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "magnetic_hold"
        },
        {
          "id": 2336,
          "apCost": 4,
          "name": "Shockwave",
          "shortDescription": "All opposing champions within 3 spaces of this unit take 10 physical damage.  All opposing champions hit by this ability then release a shockwave dealing 5 physical damage to all opposing champions within 5 spaces. This damage ignores defense.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "physicalaoe"
        },
        {
          "id": 1270,
          "apCost": 1,
          "name": "Tectonic Pulse",
          "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "physicalaoe"
        },
        {
          "id": 633,
          "apCost": 2,
          "name": "Terraform: Lava",
          "shortDescription": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        },
        {
          "id": 869,
          "apCost": 3,
          "name": "Tremor",
          "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            },
            {
              "default": false,
              "id": 37,
              "apCost": 0,
              "name": "Immunity: Fire",
              "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 2637,
              "apCost": 3,
              "name": "Grant: Stoneskin Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2638>Drink: Stoneskin Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1652,
      "name": "Ruby Crawler",
      "description": "On rare occasions, a Ruby Catalyst will absorb so much energy that it will start moving, imbued with an endless thirst for the heat the living.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Elemental"
      ],
      "noraCost": 72,
      "hash": "eJ8JJ8IF0AF0BG2AF0BJ8HJ8Ieeeeemwtsjigyo",
      "artist": "Grant Griffin",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1908,
          "apCost": 0,
          "name": "Fire Acolyte",
          "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "acolyte_fire"
        },
        {
          "id": 132,
          "apCost": 0,
          "name": "Fire Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novafire"
        },
        {
          "id": 1609,
          "apCost": 0,
          "name": "Reflection",
          "shortDescription": "Champions attacking this champion from range take 7 damage of the Attacker's damage type.",
          "activationType": 2,
          "level": 6,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "damageshield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            },
            {
              "default": true,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 443,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Fire Damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "trapfire"
            },
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 2853,
              "apCost": 0,
              "name": "Trail: Fire Wall",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_firewall"
            }
          ]
        }
      ]
    },
    {
      "id": 1744,
      "name": "Rudolph the Chosen",
      "description": "Some are content with simply being one of the Chosen, others like to dress the part.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Brute",
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 74,
      "hash": "eJ8IJ8HF0Bf1BG2AF0AJ8IJ8Jerqzkjrsmhexfpf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 867,
          "apCost": 0,
          "name": "Blessed",
          "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1070,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 2633,
              "apCost": 0,
              "name": "Amplify: Magic",
              "shortDescription": "Magic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1920,
              "apCost": 0,
              "name": "Revere: Thirion",
              "shortDescription": "While this champion is in play, Thirion costs 10% less nora to deploy. While Thirion is in play, this champion gains +2 RNG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1089,
      "name": "Rugolth's Revenge",
      "description": "\"In Honor of our late King Rugolth, we dedicate this weapon to his steadfastness, courage, and honor.\" - Inscription on each Revenge Construct",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 14,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Dwarf"
      ],
      "noraCost": 85,
      "hash": "ej9Ej9DF0BE8De9Ag3AJ8IJ8Jqzkrwmjgyipygpf",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        },
        {
          "id": 2487,
          "apCost": 0,
          "name": "Stunning",
          "shortDescription": "The first time this champion is successfully attacked each turn, the attacking champion becomes <condition value=stunned>Stunned</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 17,
          "iconName": "stunning"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 110,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 10,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 9,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 2704,
              "apCost": 0,
              "name": "Crushing Blow",
              "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "shrink"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 1339,
      "name": "Rupture Alpha",
      "description": "Ruptures are the latest incarnations of the Alphas, handcrafted by the Spark Crones who infused them with the power of storms they have mastered.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 83,
      "hash": "eJ8IJ8Hg3AF0Ae9AF0Aj9Dj9Eevxfgvsxfeexipf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 853,
          "apCost": 0,
          "name": "Battle Harden",
          "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +6 MAX HP and +1 DMG for 8 turns. This does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "allybuffs"
        },
        {
          "id": 2146,
          "apCost": 0,
          "name": "Pack Leader",
          "shortDescription": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 2487,
          "apCost": 0,
          "name": "Stunning",
          "shortDescription": "The first time this champion is successfully attacked each turn, the attacking champion becomes <condition value=stunned>Stunned</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 17,
          "iconName": "stunning"
        },
        {
          "id": 1363,
          "apCost": 0,
          "name": "Unleash",
          "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "unleashed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": true,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": false,
              "id": 2763,
              "apCost": 0,
              "name": "Lightning Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Electricity Aura 3.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2262,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "charged_abuse"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 308,
      "name": "Rust Demon",
      "description": "In the days before the Separation, the dwarves would often tell tales of their great iron mines 'souring', or turning to rust. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8DF0AF0BJ8IJ8Jj9Aqouzkgipwzmyiyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 2492,
          "apCost": 0,
          "name": "Scour",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "scour"
        },
        {
          "id": 721,
          "apCost": 2,
          "name": "Shatter",
          "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "antiequip"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 201,
              "apCost": 0,
              "name": "Death Nova: Acid",
              "shortDescription": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaacid"
            }
          ]
        }
      ]
    },
    {
      "id": 1551,
      "name": "Rusty Firecase",
      "description": "Rusty Firecases are made from recovered Firecase parts, a great example of the type of survival techniques one must have if they are to survive in the Peaks.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 0,
      "hitPoints": 24,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 43,
      "hash": "ej9Fj9Ef1Bf1Ae9AE8Dj9Aj9Bxklwtszmyitojpf",
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "The Ronin",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 132,
          "apCost": 0,
          "name": "Fire Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novafire"
        },
        {
          "id": 37,
          "apCost": 0,
          "name": "Immunity: Fire",
          "shortDescription": "Fire damage that would be dealt to this unit is prevented. This unit may not become <condition value=charred popup=false>Charred</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "immunity_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 647,
              "apCost": 3,
              "name": "Turtle",
              "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "turtle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 228,
              "apCost": 0,
              "name": "Damage Shield: Fire",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Fire damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "dmgshld_fire"
            },
            {
              "default": true,
              "id": 1447,
              "apCost": 0,
              "name": "Death Nova: Lava",
              "shortDescription": "When this unit is destroyed, it deals 8 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. Affected spaces become Lava for 4 turns. This damage ignores DEF.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deathnovalava"
            }
          ]
        }
      ]
    },
    {
      "id": 1389,
      "name": "Ruthless Enforcer",
      "description": "The Enforcers have become the most feared of all K'Thras soldiers.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute",
        "Warrior"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9Ce9BF0Ae9AG2BJ8GJ8Hwzkjnwxqqztjwo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2840,
          "apCost": 0,
          "name": "Devotee of De'lim",
          "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "devotee_delim"
        },
        {
          "id": 2821,
          "apCost": 0,
          "name": "Enforcement Action",
          "shortDescription": "When this champion makes a successful basic attack against an enemy champion, friendly champions with Devotee to D'elim gain +2 DMG for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "aurapositive"
        },
        {
          "id": 3227,
          "apCost": 0,
          "name": "Power of Devotion",
          "shortDescription": "This champion has +2 MAX HP for each real friendly Plant or Elf, and an additional +1 DMG if the champion has <ability value=2840>Devotee of De'lim</ability> or <ability value=2820>Sacrifice of De'lim</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "powerofdevotion"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2644,
              "apCost": 2,
              "name": "Phantom Dash",
              "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1288,
      "name": "Ruthless Netmaster",
      "description": "Spontaneous mutations have recently begun to affect even those not normally subject to them, such as the Skeezick.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Mutant",
        "Skeezick"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9CG2Be9Be9AG2Bj9Cj9Dinnwfevkuqhgyrf",
      "artist": "Christian Fell",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        },
        {
          "id": 2173,
          "apCost": 0,
          "name": "Death Charged",
          "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "charged_death"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2692,
          "apCost": 0,
          "name": "Mutation: Gore",
          "shortDescription": "Spend 4 charges: This champion gains <ability value=2035>Stat Bonus: Damage 2</ability>. If it already has Stat Bonus: Damage 2, it gains <ability value=164>Rend 2</ability> instead.  If it already has <ability value=163>Rend</ability>, it gains <ability value=2190>Charged Attack</ability> instead and this ability is removed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2800,
              "apCost": 0,
              "name": "Logistics: Life Siphon",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=99>Life Siphon</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1309,
      "name": "Ryv the Ruthless",
      "description": "\"That Ferren and his floozie, they're gonna die!\" - Ryv the Ruthless",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Mutant",
        "Skeezick"
      ],
      "noraCost": 75,
      "hash": "ej9Fj9Eg3AF0Ae9AE8Dj9Dj9Eemwmjljiphgkrqf",
      "artist": "Christian Fell",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broken Shard",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        },
        {
          "id": 2173,
          "apCost": 0,
          "name": "Death Charged",
          "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "charged_death"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2692,
          "apCost": 0,
          "name": "Mutation: Gore",
          "shortDescription": "Spend 4 charges: This champion gains <ability value=2035>Stat Bonus: Damage 2</ability>. If it already has Stat Bonus: Damage 2, it gains <ability value=164>Rend 2</ability> instead.  If it already has <ability value=163>Rend</ability>, it gains <ability value=2190>Charged Attack</ability> instead and this ability is removed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 1165,
          "apCost": 0,
          "name": "Taunt: Ryv",
          "shortDescription": "Taunt your enemies.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2800,
              "apCost": 0,
              "name": "Logistics: Life Siphon",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=99>Life Siphon</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1799,
      "name": "Salaam the Fell Rabbit",
      "description": "\"I don't get it. Is this some kind of joke?\" -- Boghopper scout, last words",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 84,
      "hash": "ej9Cj9BF0AG2AG2AG2AJ8HJ8Iqjnyxtxzkyowvqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1440,
          "apCost": 0,
          "name": "Confuse Attacker",
          "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "confuse"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 3299,
          "apCost": 0,
          "name": "Pet: Shadowbunny",
          "shortDescription": "When this champion is deployed, a Shadowbunny with <ability value=3298>Soul Transfer</ability> and no upgrades is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "pet"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 3012,
              "apCost": 0,
              "name": "Vigor: Psychic",
              "shortDescription": "The first time each turn a champion within 3 spaces takes Psychic damage from a source other than this champion, this champion gains 2 AP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "vigor_psychic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2690,
              "apCost": 4,
              "name": "Glorious Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            }
          ]
        }
      ]
    },
    {
      "id": 1625,
      "name": "Salaman Appraiser",
      "description": "The Draksar expected to pull in vast sums of wealth from their trade pact with the Swamp. Their first encounter with a Salaman inspector proved otherwise.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 70,
      "hash": "ej9Gj9FE8DF0BG2Ae9Aj9Ej9Fepuvxmnhrfxitqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3121,
          "apCost": 0,
          "name": "Salaman Ingenuity: Damage",
          "shortDescription": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) gain +2 DMG for 4 turns.  This stacks up to 3 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "salamaningenuity"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 1510,
              "apCost": 0,
              "name": "Market",
              "shortDescription": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            }
          ]
        }
      ]
    },
    {
      "id": 1442,
      "name": "Salaman Commando",
      "description": "\"There's only one place for a real Salaman, and that's deep behind enemy lines,\" Borja Mohn, Salaman Commando.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FG2AF0Be9Ae9Aj9Bj9Ceeiekrwilgtoqqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1253,
          "apCost": 2,
          "name": "Ruin",
          "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "terraingrass"
        },
        {
          "id": 2540,
          "apCost": 0,
          "name": "Trickster",
          "shortDescription": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2660,
              "apCost": 3,
              "name": "Grappling Hook",
              "shortDescription": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1017,
              "apCost": 1,
              "name": "Knockout",
              "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1074,
      "name": "Salaman Daredevil",
      "description": "\"Bein' round water most t'ere lives Salamans tend ta steer well clear of 'letric, but Daredevils be choosin' ta brandish it as weapon whilst flying in a kite made of sticks. They be madder than me Tortfather after he'd gone kissin' fish.\" - Mangelshell",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 79,
      "hash": "ej9Dj9CE8DE8De9AG2Bj9Ej9Fiwvzinlllwmwfpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 2401,
          "apCost": 4,
          "name": "Lightning Skewer",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "electricaoe"
        },
        {
          "id": 1979,
          "apCost": 0,
          "name": "Running Start",
          "shortDescription": "Whenever this champion moves 2 or more spaces, it gains <ability value=1>Flight</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1509,
              "apCost": 0,
              "name": "Blitz",
              "shortDescription": "This champion gets +1 DMG for 2 turns for each space it moves, to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2290,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 805,
              "apCost": 1,
              "name": "Chain Lightning",
              "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "electric"
            },
            {
              "default": true,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 625,
      "name": "Salaman Dervish",
      "description": "The dervishes are skilled fighters. But, they were never taught discipline or focus in combat. I wouldn't have it any other way. - Katchi, Salaman Soldier",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 75,
      "hash": "dj9Dj9CG2Bf1Bg3Aj9Dj9Ej9Flegnpsqwqhpqqlg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1194,
          "apCost": 0,
          "name": "Equipment Boon",
          "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "buff"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 440,
              "apCost": 0,
              "name": "Whirlwind Attack",
              "shortDescription": "This champion makes a close-combat attack against target champion. Then, each other adjacent champion takes damage equal to this champion's DMG, of the same type as this champion's basic attack.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 1624,
      "name": "Salaman Elite",
      "description": "To become a member of the Elites, a Salaman must have a natural talent with unusual technology. Their war plan hinges upon an aptitude for innovation.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 77,
      "hash": "ej9Fj9EG2BF0BG2AE8Dj9Cj9Derfkevmhiymshrf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 3123,
          "apCost": 1,
          "name": "Arcblade: Electricity",
          "shortDescription": "This champion makes an Electricity attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "glaive_electric"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3119,
          "apCost": 0,
          "name": "Provision: Offense",
          "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "plunder"
        },
        {
          "id": 1264,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 189,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaelec"
            }
          ]
        }
      ]
    },
    {
      "id": 750,
      "name": "Salaman Hunter",
      "description": "Salaman Hunters train in secluded locations throughout the Marsh Tongue where they hone their deadly aim. Salaman weapons are nora-bound to their owner and will not work for anyone except their intended wielder.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 67,
      "hash": "dj9Dj9CG2BG2Af1AJ8Jj9Aj9Bwvmeipfgvonnphg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1971,
          "apCost": 3,
          "name": "Hunter's Blind",
          "shortDescription": "Until this unit moves, it gets +3 DMG, its range becomes 4-8, and it will becomed <condition value=stealthed>Stealthed</condition> at the end of your turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "camo"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 362,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +3 DMG and +1 AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 364,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +9 DMG and +1 AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 9,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1433,
              "apCost": 0,
              "name": "Bounty Hunter",
              "shortDescription": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hunter_bounty"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 1814,
      "name": "Salaman Investigator",
      "description": "\"This wreckage is unnatural. I would think deep-water storms were churning the waters, except...\" - Salaman Investigator",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 69,
      "hash": "ej9Gj9FG2AG2BG2Ae9Aj9Bj9Cevknpyxvfinjrsf",
      "artist": "Blake Henriksen",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3290,
          "apCost": 0,
          "name": "Salvage Equipment",
          "shortDescription": "When an equipment or equipped champion is destroyed, this champion heals for 5 HP and gains 2 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "reclaim_materials"
        },
        {
          "id": 1962,
          "apCost": 0,
          "name": "Weaken Spells",
          "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dark_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            },
            {
              "default": true,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 692,
      "name": "Salaman Negamage",
      "description": "The Salaman of Forglar dared to use the Old World instruments, to ward off aggressive magics.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 67,
      "hash": "dJ8JJ8IF0BG2Ae9BJ8GJ8HJ8Iiwiwmlluolnnsxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 737,
          "apCost": 0,
          "name": "Spellswallower",
          "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "spellswallow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1891,
              "apCost": 0,
              "name": "Magnetic Pulse",
              "shortDescription": "Area Effect 5: Equipped enemy champions have -2 DMG and <ability value=2005>Careless</ability>.  Equipped friendly champions have +2 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "auranegative"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            }
          ]
        }
      ]
    },
    {
      "id": 1277,
      "name": "Salaman Ninja",
      "description": "Salamans are highly adaptable, capable of thriving in many environments.  This adaptability extends to combat situations as well, as the Ninja has been known to mimic its opponents with precision.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Monk",
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 71,
      "hash": "ej9Cj9BG2Ae9Be9AG2Aj9Bj9Ceevftsuzxqlepqf",
      "artist": "Christian Fell",
      "factions": [
        "Forglar Swamp",
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2371,
          "apCost": 4,
          "name": "Flash Bomb",
          "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "flash_bomb"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        },
        {
          "id": 3024,
          "apCost": 2,
          "name": "Teleport: Equipped",
          "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "relocate_equipped"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3128,
              "apCost": 0,
              "name": "Portal Dancer",
              "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 2944,
              "apCost": 0,
              "name": "Portal Walker",
              "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": true,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1391,
      "name": "Salaman Picket",
      "description": "Most salamans have an affinity to the wilderness, but the Picket particularly suited to scouting.  For that reason, the Circadians specifically requested a contigent of them to be on the frontlines in the search for Gekaal.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 57,
      "hash": "ej9Dj9CF0BF0Ae9AG2BJ8IJ8Jqwvkljnjtjtfipf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1393,
          "apCost": 0,
          "name": "Pillage",
          "shortDescription": "When this champion enters an enemy font deployment zone, you gain 6 nora. This can trigger once per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "noragen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            },
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            }
          ]
        }
      ]
    },
    {
      "id": 1736,
      "name": "Salaman Privateer",
      "description": "Pirates immediately began to prey on merchants between the Salaman and the Draksar. In no time at all, the trade routes became a veritable free-for-all of pirates, privateers, and bounty hunters.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 74,
      "hash": "eJ8HJ8GE8Df1BG2Ae9Bj9Ej9Feepnpwiirzmsfpf",
      "artist": "Grant Griffin",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 2466,
          "apCost": 1,
          "name": "Arcblade: Frost",
          "shortDescription": "This champion makes a Frost attack at 12 DMG against target champion within 4 spaces. If successful, the nearest enemy champion within 4 spaces takes 9 damage then the next closest champion takes 6 damage. This damage ignores DEF.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "glaivebounce"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 3226,
          "apCost": 0,
          "name": "Salaman Ingenuity: Evasive",
          "shortDescription": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) gain a rank of <ability value=1376>Evasive</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "salamaningenuity"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2111,
              "apCost": 1,
              "name": "Pistol Shot",
              "shortDescription": "This unit makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "gun"
            },
            {
              "default": true,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": true,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        }
      ]
    },
    {
      "id": 849,
      "name": "Salaman Rook",
      "description": "\"He wasn't going to use all of it. Besides, there were others that needed it more. Not all Salaman get to live in Seljichan. Some of us have to survive with what's around us.\" - Jiilakai, Salaman Rook",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 73,
      "hash": "dj9Cj9BG2AG2Bf1Bj9Aj9Bj9Cemsoyiwklwonwig",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 2167,
          "apCost": 0,
          "name": "Attack Charged",
          "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2232,
          "apCost": 0,
          "name": "Nora Thief",
          "shortDescription": "Spend 4 charges.  Your opponent loses up to 15 nora and you gain an equal amount.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "nora_thief"
        },
        {
          "id": 2357,
          "apCost": 0,
          "name": "Shadowstrike",
          "shortDescription": "This champion becomes stealthed after making a basic attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 855,
              "apCost": 0,
              "name": "Hidden: Water",
              "shortDescription": "At the end of your turn, if this champion occupies Water, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 225,
      "name": "Salaman Sentry",
      "description": "Voil!! Voil are here! - Chinscathi, Salaman Sentry announcing the start of the Siege of the Shallows",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 66,
      "hash": "dJ8IJ8HF0Ae9Bf1Bj9Aj9Bj9Cevkyzmuoufemhyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1246,
          "apCost": 2,
          "name": "Pilfer",
          "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 7,
          "iconName": "antiequip"
        },
        {
          "id": 1390,
          "apCost": 2,
          "name": "Relocate: Relic",
          "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "relocate_relic"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1343,
              "apCost": 0,
              "name": "Mystic Push",
              "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "auranegative"
            },
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            },
            {
              "default": true,
              "id": 3146,
              "apCost": 0,
              "name": "Aquatic Armaments",
              "shortDescription": "When a friendly champion with Aquatic, Semi-Aquatic, Race: Salaman, or Race: Boghopper becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            }
          ]
        }
      ]
    },
    {
      "id": 226,
      "name": "Salaman Soldier",
      "description": "Katchi, the Swamp is most happy to have your blades by its side. - Gekaal, Forglar High One",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 70,
      "hash": "dJ8IJ8HF0Ae9BG2Aj9Bj9Cj9Dsuhgpukyxmwqqzg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 2644,
              "apCost": 2,
              "name": "Phantom Dash",
              "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1393,
      "name": "Salaman Trapper",
      "description": "He moves quickly and quietly.  You don't know he's been there until the trap has gone off.   And to make matters worse, you don't want to come between this fella and his knife.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Salaman"
      ],
      "noraCost": 69,
      "hash": "ej9Dj9Cf1BF0Ae9AG2Bj9Aj9Bxvqjytumpwqfrqf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3122,
          "apCost": 0,
          "name": "Salaman Ingenuity: Cooldowns",
          "shortDescription": "When a friendly equipment or relic is deployed from the runedock within 5 spaces of this unit, friendly Salaman within 5 spaces (including this one) have their abilities on CD have their CD reduced by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "salamaningenuity"
        },
        {
          "id": 2882,
          "apCost": 0,
          "name": "Summon: Flash Bang",
          "shortDescription": "Summon a Flash Bang relic with <ability value=601>Shadowspawn</ability> and <ability value=2844>Flash Bang</ability> to target adjacent space. This ability does not break stealth",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            },
            {
              "default": false,
              "id": 1749,
              "apCost": 1,
              "name": "Grant: Lay Trap: Boulder",
              "shortDescription": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1440,
              "apCost": 0,
              "name": "Confuse Attacker",
              "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 493,
      "name": "Sand Elemental",
      "description": "There is power in the sand. Akakios will see this soon enough. - Derifos, Dune Walker",
      "maxRng": 4,
      "minRng": 2,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 73,
      "hash": "dj9Bj9Af1Bf1Ae9Aj9Fj9Gj9Hkyitmyohevvmlgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1425,
          "apCost": 0,
          "name": "Attack: Sand",
          "shortDescription": "This unit makes an Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "sand"
        },
        {
          "id": 1907,
          "apCost": 0,
          "name": "Desert Camouflage",
          "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Sand, that damage by is reduced by 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "camo"
        },
        {
          "id": 1326,
          "apCost": 0,
          "name": "Domain: Sand",
          "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_sand"
        },
        {
          "id": 1148,
          "apCost": 4,
          "name": "Tunnel: Sand",
          "shortDescription": "This unit is relocated to target Sand space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_sand"
        },
        {
          "id": 88,
          "apCost": 0,
          "name": "Vulnerability: Fire",
          "shortDescription": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "vuln_fire"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1370,
              "apCost": 0,
              "name": "Deflect: Sand",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Physical damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_sand"
            },
            {
              "default": false,
              "id": 1101,
              "apCost": 4,
              "name": "Sand Spray",
              "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "sand"
            },
            {
              "default": false,
              "id": 35,
              "apCost": 0,
              "name": "Immunity: Physical",
              "shortDescription": "Physical damage that would be dealt to this unit is prevented. This unit may not be <condition value=eviscerated popup=false>Eviscerated</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "immunity_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1879,
              "apCost": 0,
              "name": "Desert Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsand"
            },
            {
              "default": false,
              "id": 3157,
              "apCost": 0,
              "name": "Sandbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": false,
              "id": 1105,
              "apCost": 0,
              "name": "Death Nova: Sand",
              "shortDescription": "When this champion is destroyed, all champions within 2 spaces become <condition value=blinded>Blinded</condition> for 2 turns, and all spaces within 2 spaces become Sand for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovasand"
            }
          ]
        }
      ]
    },
    {
      "id": 548,
      "name": "Sand Scorpion",
      "description": "The deserts of Valdac held many dangers for the Dunewalkers. But, some dangers could be domesticated.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 66,
      "hash": "dJ8HJ8Ge9Bf1Be9BJ8GJ8HJ8Izvvkyzohgtsqwvf",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1907,
          "apCost": 0,
          "name": "Desert Camouflage",
          "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Sand, that damage by is reduced by 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "camo"
        },
        {
          "id": 1099,
          "apCost": 0,
          "name": "Hidden: Sand",
          "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 1870,
          "apCost": 0,
          "name": "Startle",
          "shortDescription": "This unit becomes <condition value=enraged3>Enraged 3</condition> for 2 turns whenever it loses <condition value=stealthed>Stealthed</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": true,
              "id": 988,
              "apCost": 2,
              "name": "Envenom",
              "shortDescription": "Target opposing champion within 5 spaces becomes <condition value=poisoned>Poisoned</condition> for 1 turn and loses 4 AP at the start of their next turn.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": true,
              "id": 3157,
              "apCost": 0,
              "name": "Sandbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Sand for 3 turns. Enemy champions within those spaces become <condition value=sandblasted>Sandblasted</condition> for 3 turns. This triggers once per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            }
          ]
        }
      ]
    },
    {
      "id": 413,
      "name": "Sand Spitter",
      "description": "Sand Spitters can move where others cannot, their Sand Spray encumbers their victims while they close in for the kill",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod",
        "Beast"
      ],
      "noraCost": 75,
      "hash": "dJ8IJ8HF0AF0Bf1AJ8Jj9Aj9Buxkjiwqhpwosfxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1101,
          "apCost": 4,
          "name": "Sand Spray",
          "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "sand"
        },
        {
          "id": 1254,
          "apCost": 0,
          "name": "Sand Veil",
          "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "terrainsand"
        },
        {
          "id": 3110,
          "apCost": 2,
          "name": "Sirocco",
          "shortDescription": "Area Effect 5: Friendly champions occupying Sand have <ability value=2076>Reflexes 1</ability> and <ability value=1376>Evasive 1</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "sirocco"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": true,
              "id": 2091,
              "apCost": 0,
              "name": "Dragging Attack",
              "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 519,
      "name": "Sandhunter",
      "description": "The Sandhunters are said to be spirits made from sand. The Dunewalkers revere them as spiritual animals.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Spirit"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2Ae9BG2Bj9Cj9Dj9Eeeiljlnukjekrhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1099,
          "apCost": 0,
          "name": "Hidden: Sand",
          "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 1101,
          "apCost": 4,
          "name": "Sand Spray",
          "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "sand"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3110,
              "apCost": 2,
              "name": "Sirocco",
              "shortDescription": "Area Effect 5: Friendly champions occupying Sand have <ability value=2076>Reflexes 1</ability> and <ability value=1376>Evasive 1</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "sirocco"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1254,
              "apCost": 0,
              "name": "Sand Veil",
              "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": false,
              "id": 1102,
              "apCost": 0,
              "name": "Trail: Sand",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_sand"
            },
            {
              "default": true,
              "id": 1879,
              "apCost": 0,
              "name": "Desert Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsand"
            }
          ]
        }
      ]
    },
    {
      "id": 929,
      "name": "Sandstalker Dustdevil",
      "description": "Where the soldiers of Valdac focus on military tactics and rank-and-file combat, the Dunewalkers focus on fluid and more adaptive styles. The Dustdevils are the prime example of this practice.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 75,
      "hash": "dj9AJ8Jf1Ag3AF0AJ8HJ8IJ8Jepjgytuolwxmuzg",
      "artist": "Charles Chen",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1326,
          "apCost": 0,
          "name": "Domain: Sand",
          "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_sand"
        },
        {
          "id": 3011,
          "apCost": 0,
          "name": "Stasis",
          "shortDescription": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "crystallize"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        },
        {
          "id": 1806,
          "apCost": 0,
          "name": "Whirl of Blades",
          "shortDescription": "Whenever this champion engages an opponent it makes a free attack against that opponent. This champion gets -2 DMG for 1 turn whenever it makes this attack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "whirl"
        },
        {
          "id": 1871,
          "apCost": 0,
          "name": "Zephyr Shield",
          "shortDescription": "When this champion moves 4 spaces in a single turn, the next successful attack in 4 turns against it misses.  This effect stacks up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "zephyr_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1102,
              "apCost": 0,
              "name": "Trail: Sand",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "trail_sand"
            },
            {
              "default": false,
              "id": 1189,
              "apCost": 0,
              "name": "Sentry",
              "shortDescription": "This unit's spell presence is increased by 3.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "sentry"
            },
            {
              "default": true,
              "id": 3110,
              "apCost": 2,
              "name": "Sirocco",
              "shortDescription": "Area Effect 5: Friendly champions occupying Sand have <ability value=2076>Reflexes 1</ability> and <ability value=1376>Evasive 1</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "sirocco"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2822,
              "apCost": 0,
              "name": "Ripples",
              "shortDescription": "When a friendly champion is deployed from the rune dock, this champion's cooldowns are reduced by 1.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 678,
      "name": "Sandstalker Lord",
      "description": "You have a legion, Akakios, made from sand. I have given you these warriors and all I ask in return is this: that you accept the power, my power, of the sands of Valdac. - Derifos, Dunewalker",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 80,
      "hash": "dJ8HJ8Ge9BG2AG2Aj9Bj9Cj9Dkpsxknwiwosqfeg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1879,
          "apCost": 0,
          "name": "Desert Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainsand"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1100,
          "apCost": 0,
          "name": "Sandstriker",
          "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "offenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3159,
              "apCost": 0,
              "name": "Spellsurge: Sandstorm",
              "shortDescription": "When this champion is deployed, Sandstorm spells are revealed from your runedock.  Sandstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Sandstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1254,
              "apCost": 0,
              "name": "Sand Veil",
              "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into sand terrain for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainsand"
            },
            {
              "default": true,
              "id": 1878,
              "apCost": 0,
              "name": "Desert Master",
              "shortDescription": "This champion has +1 DMG and +1 DEF for every 3 champions occupying sand terrain.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "domain_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 398,
      "name": "Sapling",
      "description": "\"I’ve given them a great deal of thought, as I am sure our elders did when we were saplings. They are young and mischievous, but will eventually take root\" - Ghor Bouquet, K'thir Treant",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 8,
      "hitPoints": 24,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 36,
      "hash": "dJ8HJ8Ge9BF0Bf1AJ8Jj9Aj9Beerwkjegpfphtxf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 106,
          "apCost": 0,
          "name": "Camouflage",
          "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Vegetation, that damage is reduced by 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "camo"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": true,
              "id": 2674,
              "apCost": 0,
              "name": "Nature's Connections",
              "shortDescription": "When a friendly champion within 5 spaces makes a successful basic attack, this unit heals for 2 HP.  If the attacking champion is a Plant, Ranger or Shaman, it also heals for 2 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "forage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1087,
              "apCost": 2,
              "name": "Take Root",
              "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plantregen"
            },
            {
              "default": true,
              "id": 1083,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=115>Regeneration 1</ability>.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plantregen"
            }
          ]
        }
      ]
    },
    {
      "id": 959,
      "name": "Sarinda",
      "description": "\"All I ask is your loyalty. Help me to the throne, Zeventrech, and I will make you my finest subject.\" - Sarinda",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human"
      ],
      "noraCost": 98,
      "hash": "dj9Cj9BG2Ag3AG2Aj9Bj9Cj9Duqlwtfknwxtzrjg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 986,
          "apCost": 0,
          "name": "Dark Healing",
          "shortDescription": "When an enemy champion within 10 spaces is healed by a spell or ability, the amount healed is reduced by 50%. At the end of each turn, friendly champions are healed by the same number of HP, distributed evenly among them to a maximum of 6 HP (rounded down, minimum 1). This effect does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "dark_heal"
        },
        {
          "id": 3086,
          "apCost": 0,
          "name": "Disbelief",
          "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        },
        {
          "id": 3400,
          "apCost": 0,
          "name": "Queen of the Night",
          "shortDescription": "This champion has <ability value=2397>Pawn</ability>. Friendly champions with Class: Witch within 5 spaces gain <ability value=2832>Domain: Dead Magic Zone</ability>. If a champion with Lord of Strigoi is in play, this champion gains Race: Vampyre and <ability value=3363>Bloodlust</ability> permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "forsaken_conduit"
        },
        {
          "id": 2611,
          "apCost": 0,
          "name": "Soulharvester",
          "shortDescription": "When this unit destroys an enemy champion, you gain nora equal to 25% of the destroyed champion's nora cost.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "ondeath"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2629,
              "apCost": 0,
              "name": "Blood Dispersal",
              "shortDescription": "When this champion successfully damages a <condition value=bloodied>Bloodied</condition> champion with a basic attack, friendly champions within 6 spaces of it are healed for the same amount, divided evenly among damaged champions, to a minimum of 1 and a maximum 6.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": false,
              "id": 3023,
              "apCost": 0,
              "name": "Surge: Cursed",
              "shortDescription": "This unit has +1 DMG for each champion that is <condition value=cursed>Cursed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_cursed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 98,
              "apCost": 0,
              "name": "Lifedrinker",
              "shortDescription": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 1431,
      "name": "Sarnghavian Centaur",
      "description": "\"They are worse than enemies - They are traitors, and are even less deserving of our mercy than an insect! I don't care what Bliss says!\" D'elim, Apex of the Circle",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute",
        "Knight",
        "Warrior"
      ],
      "races": [
        "Barbarian",
        "Centaur"
      ],
      "noraCost": 75,
      "hash": "ej9Gj9Fe9AF0Be9Ae9Aj9Fj9Gerzgepshginllpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Ironfist Stronghold",
        "K'thir Forest"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 3198,
          "apCost": 0,
          "name": "Fellowship",
          "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "solo_cleanse"
        },
        {
          "id": 1238,
          "apCost": 0,
          "name": "Intimidating",
          "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "dictate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": true,
              "id": 1735,
              "apCost": 2,
              "name": "Duel",
              "shortDescription": "Target an opposing champion within 2 spaces.  For 8 turns, this champion is Dueling the targeted opposing champion.  While Dueling, this champion cannot attack any champion other than the targeted champion and deals 50% more damage (after DEF) to the targeted champion and only takes 75% damage (after DEF) from the targeted champion.  This effect ends if the target is destroyed or removed from play.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 4,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1820,
      "name": "Sarnghavian Gladiator",
      "description": "\"The Sarnghavian will fear nothing, neither beast nor spirit nor machine.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 81,
      "hash": "eJ8HJ8GF0AG2BG2Ae9BJ8HJ8Ieilruowquklwxo",
      "artist": "Phu Thieu",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        },
        {
          "id": 3304,
          "apCost": 5,
          "name": "Invoke: Sarnghavian Rage",
          "shortDescription": "Area Effect 4: Enemy champions take 10 Physical damage and this champion gains 1 AP and +1 DMG for 2 turns for each enemy champion affected. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 8,
          "iconName": "invoke"
        },
        {
          "id": 1362,
          "apCost": 1,
          "name": "Throw Axe",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5.  If successful, the target has -1 DEF for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "whirl"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 3136,
              "apCost": 0,
              "name": "Empowered: Offense",
              "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_offense"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1378,
      "name": "Sarnghavian Herder",
      "description": "The K'Thras occupation of Sarnghaver has enflamed the passions of the normally peaceful herdsmen.\r\n",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 72,
      "hash": "ej9Cj9Be9AF0Ae9AG2Aj9Fj9Guowzoqlrziiympf",
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 1860,
          "apCost": 2,
          "name": "Grant: Rage Potion",
          "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 323,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 2 AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2348,
              "apCost": 4,
              "name": "Beast Herder",
              "shortDescription": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "desert_hearder"
            },
            {
              "default": true,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": false,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 276,
      "name": "Savage Boar",
      "description": "To bore is impossible, when being chased by a boar. -- Cut the word play wizard and keep running. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Moga"
      ],
      "noraCost": 69,
      "hash": "dj9Dj9CG2Be9Be9BJ8GJ8HJ8Iohtufeekwqsuhyg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 617,
          "apCost": 0,
          "name": "Gore",
          "shortDescription": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gore"
        },
        {
          "id": 1233,
          "apCost": 0,
          "name": "Hostile",
          "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 88,
              "apCost": 0,
              "name": "Vulnerability: Fire",
              "shortDescription": "When this unit takes Fire damage, that damage is increased by 25% (after DEF).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "vuln_fire"
            },
            {
              "default": false,
              "id": 3158,
              "apCost": 0,
              "name": "Reckless",
              "shortDescription": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -4,
              "iconName": "reckless"
            },
            {
              "default": true,
              "id": 679,
              "apCost": 0,
              "name": "G'hernbound",
              "shortDescription": "This unit has -3 DMG, -1 SPD unless it is within range of a unit with <ability value=676>Overseer: Moga</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "ghernbound"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 1436,
              "apCost": 0,
              "name": "Leverage: Beast",
              "shortDescription": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 709,
      "name": "Savage Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the mighty halls of J`thir.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dJ8JJ8IF0BF0Bf1Bj9Aj9Bj9Ceeeeeemjrherwzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2221,
              "apCost": 0,
              "name": "Orb of Frostfall",
              "shortDescription": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "trail_snow"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 1678,
      "name": "Savage Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the mighty halls of J`thir.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dJ8JJ8IF0BF0Bf1Bj9Aj9Bj9Ceeeeeemjrherwzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2221,
              "apCost": 0,
              "name": "Orb of Frostfall",
              "shortDescription": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "trail_snow"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 561,
      "name": "Savage Shieldman",
      "description": "Training under the Ironfist Guard gave the Barbarians new defensive tactics in combat.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 64,
      "hash": "dJ8IJ8HF0Af1Bf1AJ8Jj9Aj9Bjpqwxoqjwonymyg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 213,
          "apCost": 0,
          "name": "Block",
          "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "block"
        },
        {
          "id": 355,
          "apCost": 1,
          "name": "Defensive Stance",
          "shortDescription": "This champion has -2 DMG and +3 DEF for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1505,
              "apCost": 1,
              "name": "Throw Shield",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "throw_shield"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1481,
              "apCost": 2,
              "name": "Shield Allies",
              "shortDescription": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 681,
      "name": "Savage Wolf",
      "description": "Some dogs you don't try to tame, and that's one of `em. I recommend we go, before he sees us. - Feofil, Advisor to King Rugolth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 67,
      "hash": "dJ8IJ8HF0AG2AE8Dj9Ej9Fj9Geiljlrwkjrheeeg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2937,
          "apCost": 0,
          "name": "Barbarian Bound",
          "shortDescription": "At the beginning of your enemy's turns, if there are no other friendly Barbarians in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "savage"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        }
      ]
    },
    {
      "id": 1257,
      "name": "Scarlet Wing",
      "description": "A newest wing of the order, the Scarlets are designed to provide ranged fire support for its operations and had been available for some time, but the decline in the Griffin population prevented their full deployment until now.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 5,
      "damage": 10,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Beast",
        "Dwarf"
      ],
      "noraCost": 65,
      "hash": "ej9AJ8JG2Ae9Be9Af1Aj9Bj9Cerhgthnplpqhgpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2657,
          "apCost": 0,
          "name": "Scarlet Sigil",
          "shortDescription": "This champion gains +1 DMG and <ability value=543>Attack: Fire</ability> for 5 turns when a friendly unit with a Sigil ability is deployed from the runedock.\r\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "griffin_sigil"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1727,
      "name": "Scarletter",
      "description": "Some of these strange beasts have a habit of leaving notes in a strange, unknown language on the bodies of the prey they mutilate. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 60,
      "hash": "ej9Gj9Fe9Af1BG2Ae9Aj9Fj9Gowirwiephemphrf",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 2435,
          "apCost": 0,
          "name": "Bloodtracker",
          "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rend"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 1802,
      "name": "Scavenger Pack",
      "description": "\"Those mongrels just feed, and feed, and feed, on carrion, on their own -- we make no judgement on nature, but their savage hunger is unnatural.\" -- Boghopper Commander",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 30,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 83,
      "hash": "ej9Cj9Bg3AG2AG2AG2Aj9Dj9Eeeiplrqofxtzitf",
      "artist": "Grant Griffin",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1387,
          "apCost": 0,
          "name": "Assimilate",
          "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "assimilate"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 746,
          "apCost": 0,
          "name": "Dead Eater",
          "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "nora_eater"
        },
        {
          "id": 1875,
          "apCost": 0,
          "name": "Deep Wounds",
          "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "rend"
        },
        {
          "id": 664,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_rabid"
        },
        {
          "id": 1427,
          "apCost": 0,
          "name": "Scavenger",
          "shortDescription": "This champion can only attack champions and cannot attack champions that are at full health.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "devour"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            },
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3301,
              "apCost": 0,
              "name": "Scavenger Pack",
              "shortDescription": "When this champion is deployed from the runedock, 2 Scavenger Pack champions with no upgrades are summoned adjacent to it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 40,
              "iconName": "pack_mentality"
            }
          ]
        }
      ]
    },
    {
      "id": 351,
      "name": "Scorched Dwarf",
      "description": "The Ironfist Dwarves had no idea the collapsed mines were a result of demon raids. If they knew their kin had been enslaved, they would have attempted a rescue. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 4,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer",
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 46,
      "hash": "dj9Cj9BG2AF0Af1AJ8Jj9Aj9Bxirqzrlrlwfrleg",
      "artist": "Eric Williams",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 947,
          "apCost": 0,
          "name": "Craft",
          "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 5,
          "iconName": "forge"
        },
        {
          "id": 308,
          "apCost": 0,
          "name": "Nora Miner",
          "shortDescription": "At the beginning of your turn, you gain 6 nora.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "noragen"
        },
        {
          "id": 721,
          "apCost": 2,
          "name": "Shatter",
          "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "antiequip"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 899,
              "apCost": 0,
              "name": "Demon Elf Bound",
              "shortDescription": "At the beginning of your enemy's turns, if there are no other friendly Demon Elves in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 86,
              "apCost": 0,
              "name": "Vulnerability: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is increased by 25% (after DEF).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "vuln_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1128,
              "apCost": 0,
              "name": "Ally: Ironfist Stronghold",
              "shortDescription": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_is"
            },
            {
              "default": true,
              "id": 624,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 8 HP. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "shrinegood"
            }
          ]
        }
      ]
    },
    {
      "id": 52,
      "name": "Scorpic",
      "description": "The horrors that blight the surface would pale to those that lurk in the Underdepths.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 71,
      "hash": "cj9Cj9Bj9Af1BF0Bj9Aj9Bj9Cerhvxqumjipszzi",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 163,
          "apCost": 0,
          "name": "Rend",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rend"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 1127,
              "apCost": 0,
              "name": "Ally: Sundered Lands",
              "shortDescription": "While there are other friendly Sundered Lands champions in play, this champion gets +7 HP and +2 DMG. Sundered Lands champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_sl"
            },
            {
              "default": true,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": true,
              "id": 1604,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 4 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "damageshield"
            }
          ]
        }
      ]
    },
    {
      "id": 379,
      "name": "Screaming Imp",
      "description": "The horror of these creatures' screams are only surpassed by their collective smell. The screaming imps only serve their renegade master, and they do it blindly. ",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Bard",
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1Af1AE8Dj9Ej9Fj9Geemnyohykgekneg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks",
        "Underdepths"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 1147,
          "apCost": 3,
          "name": "Sonic Roar",
          "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            },
            {
              "default": false,
              "id": 149,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2688,
              "apCost": 4,
              "name": "Screech",
              "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "sonicaoe"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 3087,
              "apCost": 3,
              "name": "Sonic Surge",
              "shortDescription": "This champion gains 3 AP and Pacified for 1 turn.  For each space moved, enemy champions within 2 spaces take 3 Sonic damage (this damage ignores DEF).  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 12,
              "iconName": "charge_sonic"
            }
          ]
        }
      ]
    },
    {
      "id": 302,
      "name": "Screaming Leviathan",
      "description": "One of our balloon snipers was swallowed by a flying... I think it was a whale?  - Skeezick Baiter ",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 66,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3Ae9BG2Bj9Cj9Dj9Eeeeemephplegpjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1405,
          "apCost": 4,
          "name": "Dive",
          "shortDescription": "This unit is relocated to target water space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_dive"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2688,
          "apCost": 4,
          "name": "Screech",
          "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "sonicaoe"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2138,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +8 HP.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "plushealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            },
            {
              "default": false,
              "id": 2029,
              "apCost": 0,
              "name": "Stat Bonus: Defense",
              "shortDescription": "This champion gains +1 DEF.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plusdefense"
            },
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 75,
      "name": "Scythbill",
      "description": "Prized for their colorful beaks, nimble scythbill are rarely captured due to their incredible speed.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 7,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 63,
      "hash": "cj9Gj9Fj9EE8DG2Aj9Ej9Fj9Gevfrsfrzgnjlplj",
      "artist": "Kelly Hamilton",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 516,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 1,
              "iconName": "leap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 115,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 1295,
      "name": "Seeker of Blood",
      "description": "Some thirst for knowledge while others thirst for blood, but sometimes, they are one and the same.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Demon",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 75,
      "hash": "ej9Ej9Df1Ae9Be9Ag3AJ8Jj9Aeeexfrhkekpyoqf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3416,
          "apCost": 0,
          "name": "Blood Collection",
          "shortDescription": "Whenever this champion collects a blood ball, it gains one charge. This champion automatically recovers blood balls within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "bloodball"
        },
        {
          "id": 2160,
          "apCost": 0,
          "name": "Charged",
          "shortDescription": "When this unit comes into play, it gains 3 charges.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "heal_charged"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2229,
          "apCost": 0,
          "name": "Charged Magic Bomb",
          "shortDescription": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "magicaoe"
        },
        {
          "id": 2786,
          "apCost": 0,
          "name": "Spell Aegis",
          "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dark_aura"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 2197,
              "apCost": 3,
              "name": "Blood Magic",
              "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2706,
              "apCost": 1,
              "name": "Blood Knowledge",
              "shortDescription": "For each opposing champion within 4 spaces with <condition value=bloodied>Bloodied</condition>, your opponent loses 2 nora and this champion gains 1 AP and +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1441,
      "name": "Seeker of the Source",
      "description": "Only a few elves had the ability to locate Source crystals, and of those, even fewer were willing to undergo the requisite ritual blinding.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 5,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 73,
      "hash": "ej9Gj9Ff1BF0Be9Ae9Aj9Aj9Berhtxzousjeplpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2899,
          "apCost": 2,
          "name": "Find Source Crystal",
          "shortDescription": "This champion moves 3 spaces at random, then gets <ability value=2912>Reveal: Source Crystal</ability> for 1 turn.  Source Crystal relics have: This relic has <ability value=538>Fire Eater</ability>, <ability value=1118>Lava-fall 1</ability>, and <ability value=2900>Initiate: Devotee to De'lim</ability>. If you have 3 or more Source crystals, they have Lava-Fall 2 instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "source_crystal"
        },
        {
          "id": 480,
          "apCost": 0,
          "name": "Lavawalker",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by Lava. Fire damage that would be dealt to this champion by Lava is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "terrainlava"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2652,
          "apCost": 0,
          "name": "Opportunistic",
          "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "opportunistic"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3221,
              "apCost": 3,
              "name": "Absorb Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed and this champion heals for 10 HP.  If the relic was friendly, this champion also gains +5 MAX HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "absorb_relic"
            },
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            }
          ]
        }
      ]
    },
    {
      "id": 1609,
      "name": "Seeker Zuo",
      "description": "Voil Stalkers particularly enjoy prey who have gone to ground, utilizing their pet companion to ferret out their quarry.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 82,
      "hash": "ej9AJ8JE8DF0AG2Af1Aj9Ej9Fkumlwofxzrlumpf",
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 3109,
          "apCost": 0,
          "name": "Pet: Swiftwing",
          "shortDescription": "When this champion is deployed, a Level 1 Swiftwing is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "pet"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 3294,
          "apCost": 0,
          "name": "Warlord",
          "shortDescription": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "warlord"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3072,
              "apCost": 3,
              "name": "Elusive Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "dashing_dodge"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1600,
      "name": "Semmiran Noble",
      "description": "The best ales are made in the mountainous region of Semmir.  Various noble families have cultivated their art for years here, and have developed fierce but cordial rivalries between them.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 81,
      "hash": "eJ8IJ8HF0AF0AG2AF0AJ8HJ8Irhiyxkusofmnso",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 3103,
          "apCost": 0,
          "name": "Drunken Revel",
          "shortDescription": "When a friendly champion becomes <condition value=intoxicated>Intoxicated</condition>, this champion gains 1 AP and +2 DMG for 2 turns. This effect stacks up to 3 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "carouse"
        },
        {
          "id": 3104,
          "apCost": 2,
          "name": "Dwarven Noble",
          "shortDescription": "This champion gains +2 DEF and Majestic 2 for 4 turns. The CD of this ability is reduced by 1 whenever a friendly Dwarf or Drunkard within 5 spaces is attacked (not including itself).",
          "activationType": 0,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "drunken_noble"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3098,
              "apCost": 0,
              "name": "Equip: St Semmir's Brew",
              "shortDescription": "This champion comes into play equipped with a St Semmir's Brew.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2712,
              "apCost": 4,
              "name": "Keg Toss",
              "shortDescription": "Area Effect 2, Range 5: All units become <condition value=intoxicated>Intoxicated</condition> for 4 turns. Opposing units take Physical damage equal to 80% of this unit's DMG.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "special_keg"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1932,
              "apCost": 0,
              "name": "Loyalty",
              "shortDescription": "This champion gains +2 DMG and +5 HP as long as all friendly units that you own share a faction with it.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "loyalty"
            },
            {
              "default": true,
              "id": 2473,
              "apCost": 1,
              "name": "Carouse",
              "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "carouse"
            },
            {
              "default": false,
              "id": 2713,
              "apCost": 0,
              "name": "On The House",
              "shortDescription": "When a friendly champion within 5 spaces collects a Nora Globe, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special_keg"
            }
          ]
        }
      ]
    },
    {
      "id": 945,
      "name": "Sentinel of Ailur",
      "description": "The Sentinels guard Ailur's deepest sanctuaries, acting as a last line of defense against invasion. To awaken a Sentinel, one must invoke the name of the first King of Ailur: Kimuron.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 14,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 53,
      "hash": "dj9Bj9Af1Bg3AG2Aj9Bj9Cj9Doytzzgnnnusmhig",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2358,
          "apCost": 0,
          "name": "Animate",
          "shortDescription": "This champion loses <mechanic value=immobile>Immobile</mechanic> and Passive and gains <ability value=545>Attack: Physical</ability> for 3 turns.  This ability costs 10 nora.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "mobilize_engine"
        },
        {
          "id": 757,
          "apCost": 0,
          "name": "Immobile",
          "shortDescription": "This unit cannot move or be relocated.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -30,
          "iconName": "debuff"
        },
        {
          "id": 680,
          "apCost": 0,
          "name": "Planar Bound",
          "shortDescription": "This unit is immune to relocate and remove from play effects.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "planar"
        },
        {
          "id": 3217,
          "apCost": 4,
          "name": "Verdant Force",
          "shortDescription": "Friendly champions (including self) gains <ability value=479>Brushwalker</ability> and <ability value=106>Camouflage</ability> for 3 turns, and spaces within 2 tiles of all friendly champions (including self) become Jungle for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "domain_vegetation"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 2082,
              "apCost": 0,
              "name": "Jungle Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Jungle (Impeding Vegetation) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ferociousgrowth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1221,
              "apCost": 0,
              "name": "Font Blessing",
              "shortDescription": "While this champion is within 5 spaces of a font deployment zone you control, it gets +1 DEF, +5 DMG, and +10 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2075,
              "apCost": 0,
              "name": "Pride of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "warriorspride"
            },
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            }
          ]
        }
      ]
    },
    {
      "id": 550,
      "name": "Serkan, Lich Master",
      "description": "Your kingdoms will fall and your people will die. You can never escape me for I have become the fate of all things. - Serkan, the true Lich King",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 93,
      "hash": "dJ8HJ8Ge9Bf1BF0BJ8IJ8Jj9Apfmpjlluvztjrwf",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2642,
          "apCost": 0,
          "name": "Dictate",
          "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "dictate"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 604,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 3181,
              "apCost": 1,
              "name": "Spirit Harvest",
              "shortDescription": "This champion makes a Loss of Life attack against target champion at RNG 2-5. If this destroys the champion, a Phylactery relic is summoned in the closest friendly deployment zone. ",
              "activationType": 3,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "phylactery"
            },
            {
              "default": false,
              "id": 940,
              "apCost": 0,
              "name": "Dark Favor",
              "shortDescription": "When this unit is deployed, enemy champions lose 6 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drain"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1818,
              "apCost": 0,
              "name": "Defensive Strike",
              "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 775,
      "name": "Serkan, Lich Master",
      "description": "Your kingdoms will fall and your people will die. You can never escape me for I have become the fate of all things. - Serkan, the true Lich King",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 93,
      "hash": "dj9Fj9EE8DG2Bf1Bj9Aj9Bj9Ceeemekjlukneegg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2642,
          "apCost": 0,
          "name": "Dictate",
          "shortDescription": "Target friendly non-Illusion champion within 3 spaces loses 5 HP and this champion permanently gains +1 DMG and 2 AP.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "dictate"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 604,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 3181,
              "apCost": 1,
              "name": "Spirit Harvest",
              "shortDescription": "This champion makes a Loss of Life attack against target champion at RNG 2-5. If this destroys the champion, a Phylactery relic is summoned in the closest friendly deployment zone. ",
              "activationType": 3,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "phylactery"
            },
            {
              "default": false,
              "id": 940,
              "apCost": 0,
              "name": "Dark Favor",
              "shortDescription": "When this unit is deployed, enemy champions lose 6 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drain"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1818,
              "apCost": 0,
              "name": "Defensive Strike",
              "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 1498,
      "name": "Serpentfly",
      "description": "Like many of the Sundered Lands' inhabitants, the origin of the Serpentfly is not well understood; it simply appears to be a bizarre mix of a serpent and a wasp.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Mutant"
      ],
      "noraCost": 74,
      "hash": "ej9AJ8JF0AF0Be9Af1AJ8HJ8Ieilnymyiwmevqo",
      "artist": "Conceptopolis",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 3003,
          "apCost": 0,
          "name": "Dispelling Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "dispelling_blows"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2644,
              "apCost": 2,
              "name": "Phantom Dash",
              "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": true,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": false,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            }
          ]
        }
      ]
    },
    {
      "id": 1250,
      "name": "Serpentor Ardent",
      "description": "Though few in number, the Serpentor sect of the Draksar are well respected amongst their ranks for their tenacity and instantly recognizable for their distinctive black scales and snake-like appearance.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 83,
      "hash": "ej9AJ8Je9Ae9Be9Af1Aj9Fj9Grwinjlphvhyiyo",
      "artist": "Bartek Gawel",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        },
        {
          "id": 2619,
          "apCost": 0,
          "name": "Zeal: Speed",
          "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "channel_speed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 3029,
              "apCost": 0,
              "name": "Hunter: Crippled",
              "shortDescription": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "hunter_crippled"
            },
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        }
      ]
    },
    {
      "id": 1342,
      "name": "Serpentor Paradigm",
      "description": "The material used to make the Paradigm's weapons are a closely guarded secret of the Serpentor. The blades resonate with magical energy that its wielder can convert to burning fire.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8Ie9BF0Ae9AF0BJ8GJ8Hgygygpyzohethn",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 767,
          "apCost": 1,
          "name": "Fire Attack",
          "shortDescription": "This unit makes a Fire attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "fire"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            },
            {
              "default": true,
              "id": 1883,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 457,
      "name": "Servile Brute",
      "description": "Originally slaves to the Deep Elves, the Servile have proven useful in combat with their incredible power.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 52,
      "hash": "dj9Gj9Fe9Af1AE8Dj9Ej9Fj9Geiyzgrwmevoqwfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 24,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "berserker"
        },
        {
          "id": 899,
          "apCost": 0,
          "name": "Demon Elf Bound",
          "shortDescription": "At the beginning of your enemy's turns, if there are no other friendly Demon Elves in play, this unit is <condition value=possessed>Possessed</condition> by your enemy until end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "possess"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2972,
              "apCost": 0,
              "name": "Surge: Demon Elf",
              "shortDescription": "This unit has +1 DMG for every friendly champion with the races Demon and Elf.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_demonelf"
            },
            {
              "default": true,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 420,
      "name": "Shadestalker",
      "description": "Cursed, they stalk the living, stealing the will of all around them.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 65,
      "hash": "dJ8IJ8HF0AF0Bg3Aj9Dj9Ej9Fuknwvvhvxmekwfg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 594,
          "apCost": 0,
          "name": "Energy Thief",
          "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 1737,
          "apCost": 0,
          "name": "Ethereal",
          "shortDescription": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "ethereal"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1220,
              "apCost": 0,
              "name": "Final Word",
              "shortDescription": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            }
          ]
        }
      ]
    },
    {
      "id": 1294,
      "name": "Shadestriker",
      "description": "Shadestrikers are Liches whose rebirth were incomplete.  Now, their magic is tainted with the veil's influence.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Spirit",
        "Undead"
      ],
      "noraCost": 73,
      "hash": "ej9Ej9DF0Be9Be9Ag3AJ8IJ8Jkjpuzrsjeepykpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 2701,
          "apCost": 0,
          "name": "Shadestrike",
          "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrain_dmz"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3247,
              "apCost": 3,
              "name": "Rift Nova",
              "shortDescription": "Area Effect 2, Range 5: Enemy champions occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> or Dread Field in the area lose 6 HP and lose 1 SPD for 2 turns for each friendly spirit within the AoE (to a maximum of -3).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "stormreader"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 1754,
              "apCost": 0,
              "name": "Hidden: Dead Magic Zone",
              "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        }
      ]
    },
    {
      "id": 542,
      "name": "Shadow Hunter",
      "description": "The shadows watched, as we entered Sheoul. Occasionally, one would sneer. - Thomroy, Priest of Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 73,
      "hash": "dj9Gj9Fe9Af1Bf1AJ8Jj9Aj9Bqjytquhegeerqfg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2489,
          "apCost": 0,
          "name": "Mischief",
          "shortDescription": "Target opposing champion within 5 spaces loses 1 AP. Friendly Imps within 5 spaces of the target each gain AP equal to the amount lost. Using this ability does not cause the unit to lose <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "nemesis_x"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": false,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 373,
      "name": "Shadow Master",
      "description": "Any fool can hide themselves. As a master of the shadow, however, I can shift others out of sight, by clouding the minds of those that would see. - Elrac, Master of Shadows",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 66,
      "hash": "dj9Cj9BG2AF0Af1Bj9Aj9Bj9Cemwzvknllegnwfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1867,
          "apCost": 1,
          "name": "Mark",
          "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "declare_hunted"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1354,
              "apCost": 0,
              "name": "Sneak",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": false,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1555,
      "name": "Shadow Master",
      "description": "Never trust a squid. - Barthanos, Master of Shadows",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 66,
      "hash": "ej9Gj9FE8Df1Ae9Ae9Aj9Ej9Fkuxxztmetxfkjpf",
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1867,
          "apCost": 1,
          "name": "Mark",
          "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "declare_hunted"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1354,
              "apCost": 0,
              "name": "Sneak",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": false,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1508,
      "name": "Shadowrake",
      "description": "\"You think this is pain? If only I could give back to you the pain which our entire race has suffered, suffered because of your betrayal.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 8,
      "damage": 11,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 81,
      "hash": "ej9Bj9AF0AF0Be9Af1BJ8HJ8Iemnykljpufipuo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 3002,
          "apCost": 0,
          "name": "Hunter: Quick",
          "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunter_quick"
        },
        {
          "id": 2397,
          "apCost": 0,
          "name": "Pawn",
          "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pawn"
        },
        {
          "id": 3001,
          "apCost": 0,
          "name": "Shadowdancer",
          "shortDescription": "When this champion makes a successful basic attack, a Lesser Shadowrake is summoned to a space adjacent to the target.  This effect can only occur once per turn and only if no copy created by this champion is in play. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "shadowdancer"
        },
        {
          "id": 3011,
          "apCost": 0,
          "name": "Stasis",
          "shortDescription": "When this champion comes into play, it is <mechanic value=pacified>Pacified</mechanic> and <mechanic value=immobile>Immobile</mechanic> for 3 turns.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "crystallize"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            },
            {
              "default": false,
              "id": 3024,
              "apCost": 2,
              "name": "Teleport: Equipped",
              "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "relocate_equipped"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 880,
      "name": "Shadowshank",
      "description": "The Shadowshank is a folktale, a myth passed around Poxanthuru. The story goes that those who show disrespect towards the dead will be visited by a stranger wearing a skull. The Shadowshank strikes from the shadows, then disappears without a trace.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 12,
      "hitPoints": 33,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8Dg3AG2Aj9Bj9Cj9Diwirlpyrqzkethg",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 2200,
          "apCost": 0,
          "name": "Killing Stroke",
          "shortDescription": "When this champion successfully deals damage on a basic attack to a non-Avatar, non-Boss, non-Elite champion with a different owner, this champion is Sacrificed and the other champion is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "killing_stroke"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1754,
              "apCost": 0,
              "name": "Hidden: Dead Magic Zone",
              "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1017,
              "apCost": 1,
              "name": "Knockout",
              "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1304,
      "name": "Shallaxy the Courier",
      "description": "Shallaxy has always been trusted to deliver secrets between those who would betray their gods and kings. As of late, the only message is \"Paladins despair -- the Ganelon are coming\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Bard"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 79,
      "hash": "ej9Fj9EF0BF0Ae9AE8DJ8IJ8Jmwkymuhvmeeeto",
      "artist": "Christian Fell",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 896,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 2 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "mind_control"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 2711,
          "apCost": 0,
          "name": "Summon: Rock Trap",
          "shortDescription": "Summon a Rock Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=1029>Rock Trap</ability> to target adjacent space. This ability does not break stealth",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        }
      ]
    },
    {
      "id": 1473,
      "name": "Shallaxy the Courier",
      "description": "Shallaxy has always been trusted to deliver secrets between those who would betray their gods and kings. As of late, the only message is \"Paladins despair -- the Ganelon are coming\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 79,
      "hash": "eJ8IJ8He9AF0Be9AF0Aj9Fj9Gerqoqzmshpqluo",
      "artist": "Christian Fell",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 896,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 2 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "mind_control"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 2711,
          "apCost": 0,
          "name": "Summon: Rock Trap",
          "shortDescription": "Summon a Rock Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=1029>Rock Trap</ability> to target adjacent space. This ability does not break stealth",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        }
      ]
    },
    {
      "id": 902,
      "name": "Shardseer Argol",
      "description": "Argol was the first appointed Shardseer to master two major forces at once: the frost shard and his innate psychic powers. He was also the first Shardseer with no Elven lineage.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 7,
      "damage": 13,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Monk",
        "Wizard"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 92,
      "hash": "dJ8HJ8Ge9Bg3Af1Bj9Aj9Bj9Ceerhnnsuszvoyzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 604,
          "apCost": 1,
          "name": "Frost Cone ",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "iceaoe"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 1881,
          "apCost": 4,
          "name": "Telekinetic Thrust",
          "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "knockback"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            },
            {
              "default": false,
              "id": 2939,
              "apCost": 0,
              "name": "Chilling Discipline",
              "shortDescription": "The next basic attack this champion makes causes <condition value=chilled>Chilled</condition> for 4 turns. If the target was <condition value=frozen popup=false>Frozen</condition>, all friendly Monks gain 1 damage for 6 turns",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "discipline_chilling"
            },
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3376,
              "apCost": 0,
              "name": "Noetic Mind",
              "shortDescription": "This champion has <ability value=3261>Mind Lock</ability>. When another friendly champion within 5 spaces uses Mind Lock, this champion also gains the ability affected by Mind Lock for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 2338,
              "apCost": 0,
              "name": "Psychic Magnetism",
              "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pull"
            }
          ]
        }
      ]
    },
    {
      "id": 824,
      "name": "Shardseer K'aeyun",
      "description": "K'aeyun was instrumental in establishing relations with the Lonx. However, she gave up a life in the Arctic Delegation to become the first Shardseer. When she was asked to go to Maljara as an ambassador, she accepted.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 83,
      "hash": "dj9AJ8Jf1AG2Be9Aj9Fj9Gj9Huxkroytuszkephg",
      "artist": "Michele Chang",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 652,
          "apCost": 0,
          "name": "Attack: Ice Shard",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "ice"
        },
        {
          "id": 1744,
          "apCost": 0,
          "name": "Frost Acolyte",
          "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "catalyst_frost"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2221,
              "apCost": 0,
              "name": "Orb of Frostfall",
              "shortDescription": "Champions within 5 spaces have <ability value=831>Trail: Snow</ability>.  If the affected champion is friendly, it also gains <ability value=600>Arctic</ability>",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "trail_snow"
            },
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 2542,
              "apCost": 0,
              "name": "Savage Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=frozen>Frozen</condition>, <condition value=chilled>Chilled</condition> or <condition value=awestruck popup=false>Awestruck</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "iceguard"
            }
          ]
        }
      ]
    },
    {
      "id": 76,
      "name": "Sheoul Demon",
      "description": "Most leaders inspire loyalty, the Sheoul Demons do well inspiring chaos. - Broodqueen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 58,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God",
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 84,
      "hash": "cj9Fj9Ej9Dg3Af1Aj9Dj9Ej9Fuowvkeiegklgkpj",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1320,
          "apCost": 0,
          "name": "Assault",
          "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 607,
          "apCost": 0,
          "name": "Essence Capture",
          "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "noragen"
        },
        {
          "id": 301,
          "apCost": 0,
          "name": "Horrific Aura",
          "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fear"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3056,
              "apCost": 0,
              "name": "Overkill: Healing",
              "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "overkill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 936,
              "apCost": 0,
              "name": "Surge: Demon",
              "shortDescription": "This unit has +1 DMG for every friendly Demon.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_demon"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 1949,
      "name": "Sheoul Demon",
      "description": "Most leaders inspire loyalty, the Sheoul Demons do well inspiring chaos. - Broodqueen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 58,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God",
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 84,
      "hash": "ej9Gj9Ff1Be9AG2Be9Aj9Aj9Bgtqqwvxzkpsjtqf",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1320,
          "apCost": 0,
          "name": "Assault",
          "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 607,
          "apCost": 0,
          "name": "Essence Capture",
          "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "noragen"
        },
        {
          "id": 301,
          "apCost": 0,
          "name": "Horrific Aura",
          "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fear"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3056,
              "apCost": 0,
              "name": "Overkill: Healing",
              "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "overkill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 936,
              "apCost": 0,
              "name": "Surge: Demon",
              "shortDescription": "This unit has +1 DMG for every friendly Demon.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_demon"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 1356,
      "name": "Sheoul Disciple",
      "description": "The Disciples hold considerable power amongst the ranks of the Sheoul and are considered an extension of Maxxerek, who will sometimes inhabit the bodies of the Disciples to perform certain functions.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue",
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 75,
      "hash": "ej9AJ8Jf1BF0Ae9Af1Aj9Aj9Bgkjnssjiwftjepf",
      "artist": "Michele Chang",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3213,
          "apCost": 1,
          "name": "Electric Attack",
          "shortDescription": "This unit makes an Electric attack at range 2-4.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "electric"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3090,
              "apCost": 0,
              "name": "Catalyst: Electricity",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Electricity damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "breaker_electricity"
            },
            {
              "default": true,
              "id": 2551,
              "apCost": 2,
              "name": "Bloodseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=bloodied>Bloodied</condition> or less than 50% HP and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 866,
      "name": "Sheoul Magus",
      "description": "\"We must encourage this talent, Erimalion. Imagine, power over blood! The Magus could be our finest warrior.\" - Maxxarek, Prince of Sheoul",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Vampyre"
      ],
      "noraCost": 75,
      "hash": "dj9Ej9Dg3AG2BF0AJ8HJ8IJ8Jjgkepfrfgvkeggg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2706,
          "apCost": 1,
          "name": "Blood Knowledge",
          "shortDescription": "For each opposing champion within 4 spaces with <condition value=bloodied>Bloodied</condition>, your opponent loses 2 nora and this champion gains 1 AP and +1 DMG for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "nora_hex"
        },
        {
          "id": 2197,
          "apCost": 3,
          "name": "Blood Magic",
          "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "novablood"
        },
        {
          "id": 2595,
          "apCost": 0,
          "name": "Hunter: Bloodied",
          "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "blood_debt"
        },
        {
          "id": 2188,
          "apCost": 0,
          "name": "Recharge",
          "shortDescription": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "recharge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2176,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "charged_spell"
            },
            {
              "default": true,
              "id": 3416,
              "apCost": 0,
              "name": "Blood Collection",
              "shortDescription": "Whenever this champion collects a blood ball, it gains one charge. This champion automatically recovers blood balls within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "bloodball"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2833,
              "apCost": 2,
              "name": "Teleport: Blood Ball",
              "shortDescription": "This champion relocates to a Blood Ball within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 2464,
              "apCost": 2,
              "name": "Blood for Nora",
              "shortDescription": "This unit loses 20 health. The next spell you cast this turn has its Nora cost reduced by 20. This effect does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 2551,
              "apCost": 2,
              "name": "Bloodseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=bloodied>Bloodied</condition> or less than 50% HP and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            }
          ]
        }
      ]
    },
    {
      "id": 1517,
      "name": "Sheoul Monstrosity",
      "description": "Sheoul Monstrosity are as much beast as they are demon, created by the Nefari to lead raids on villages and outlaying farms.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon",
        "Mutant"
      ],
      "noraCost": 73,
      "hash": "ej9Cj9Be9BF0Be9AG2AJ8GJ8Heeexxxfeeilnuo",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": true,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            }
          ]
        }
      ]
    },
    {
      "id": 474,
      "name": "Shock Pomfret",
      "description": "It is a sign of dark times, in the Forglar Swamps, when a fish can fly and produce electricity.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 67,
      "hash": "dJ8IJ8HF0Af1AF0BJ8IJ8Jj9Avxfkyipuhvqhvxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 114,
          "apCost": 0,
          "name": "Aquatic",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "aquatic"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 1388,
          "apCost": 0,
          "name": "Bolt",
          "shortDescription": "When this champion successfully attacks an enemy champion, it is relocated to the nearest space to that target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "bolt"
        },
        {
          "id": 1405,
          "apCost": 4,
          "name": "Dive",
          "shortDescription": "This unit is relocated to target water space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_dive"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2245,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jolt"
            },
            {
              "default": true,
              "id": 140,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 237,
              "apCost": 0,
              "name": "Damage Shield: Electricity",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Electricity damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_lightning"
            },
            {
              "default": true,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 566,
      "name": "Shock Toad",
      "description": "The Shock Toads are considered a scourge in Forglar. Their innate defenses wreak havoc on the local wildlife.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 77,
      "hash": "dJ8JJ8IF0Bf1BE8Dj9Ej9Fj9Geeeeemepuzvhieg",
      "artist": "Darcie Banfield",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2270,
          "apCost": 0,
          "name": "Attack: Mouth Lightning",
          "shortDescription": "This unit makes an Electricity attack, from its freakin' mouth, at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        },
        {
          "id": 1739,
          "apCost": 0,
          "name": "Paralytic Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "conduit"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            },
            {
              "default": false,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1495,
              "apCost": 3,
              "name": "Fry",
              "shortDescription": "If this champion occupies water when activating this ability, all enemy champions in water within 5 spaces take 8 Electricity damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 2401,
              "apCost": 4,
              "name": "Lightning Skewer",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "electricaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 390,
      "name": "Siege Engine",
      "description": "Built for a long range siege, they remain too inaccurate to strike a moving target.",
      "maxRng": 7,
      "minRng": 5,
      "defense": 0,
      "speed": 5,
      "damage": 11,
      "hitPoints": 40,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 53,
      "hash": "dJ8HJ8Ge9BF0BE8Dj9Ej9Fj9Geeiyiigggkwigyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1153,
          "apCost": 0,
          "name": "Dwarf Driven",
          "shortDescription": "This unit has lumbering unless it is adjacent to a Dwarf you control",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -12,
          "iconName": "drive"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1251,
              "apCost": 0,
              "name": "Raze",
              "shortDescription": "When this champion comes into play, your opponents shrine takes 5 damage. Transfigured Avatars take 15",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "shrinebad"
            },
            {
              "default": true,
              "id": 2284,
              "apCost": 0,
              "name": "Overkill: Raze",
              "shortDescription": "Whenever this champion would destroy another champion with a basic attack, any damage over the current health of the target is dealt to that unit's owner's shrine, to a maximum of 5.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "overkill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2099,
              "apCost": 0,
              "name": "Fire Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "artillery"
            }
          ]
        }
      ]
    },
    {
      "id": 655,
      "name": "Siege Monger",
      "description": "Send in the Siege Mongers. Give them a little time, and they'll do away with those pesky defenses. - Trevia, Nefari Reaper",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 74,
      "hash": "dj9Gj9Fe9AG2AG2Bj9Cj9Dj9Eeerzxfrqolyxkjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1810,
          "apCost": 0,
          "name": "Siege Lord",
          "shortDescription": "No relics can be played from the runedock within 12 spaces of this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2427,
              "apCost": 0,
              "name": "Break the Line",
              "shortDescription": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 1752,
              "apCost": 0,
              "name": "Heavy Charger",
              "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3147,
              "apCost": 0,
              "name": "Seism",
              "shortDescription": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 14,
              "iconName": "seism"
            }
          ]
        }
      ]
    },
    {
      "id": 1234,
      "name": "Silverclan Cavalier",
      "description": "The Silverclan Cavalier were developed to give injured Dwarven Warriors one last chance at glory.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Dwarf"
      ],
      "noraCost": 73,
      "hash": "eJ8IJ8Hf1Ae9Be9AF0AJ8Jj9Aevonnuxzonjgnn",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2577,
          "apCost": 0,
          "name": "Complex Machine",
          "shortDescription": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "complex_machine"
        },
        {
          "id": 2213,
          "apCost": 0,
          "name": "Crazed Charger",
          "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crazed_charger"
        },
        {
          "id": 6,
          "apCost": 0,
          "name": "Mobility",
          "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mobility"
        },
        {
          "id": 3059,
          "apCost": 0,
          "name": "Thunderous Charge",
          "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "thunderous_charge"
        },
        {
          "id": 90,
          "apCost": 0,
          "name": "Vulnerability: Electricity",
          "shortDescription": "When this unit takes Electricity damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_electric"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 2111,
              "apCost": 1,
              "name": "Pistol Shot",
              "shortDescription": "This unit makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "gun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1217,
              "apCost": 0,
              "name": "Faultbreak",
              "shortDescription": "When this champion moves by way of its normal movement, enemy champions within 2 spaces lose 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2343,
              "apCost": 3,
              "name": "Paralyze",
              "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "sentry"
            }
          ]
        }
      ]
    },
    {
      "id": 1200,
      "name": "Silverclan Hoplite",
      "description": "The Silverclan engineers rise to prominence was, not coincidentally, tied to their discovery of being able to power their constructs with the rare Tilium Emerald.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 73,
      "hash": "ej9Dj9Cg3Ae9Ae9AG2Bj9Dj9Eemjnplgnevvferf",
      "artist": "\"Faxtar\"",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2577,
          "apCost": 0,
          "name": "Complex Machine",
          "shortDescription": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "complex_machine"
        },
        {
          "id": 1550,
          "apCost": 0,
          "name": "Enduring Aura",
          "shortDescription": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "aurapositive"
        },
        {
          "id": 2576,
          "apCost": 1,
          "name": "Throw Javelin",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "spear"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 1202,
      "name": "Silverclan Protector",
      "description": "The Silverclan Protector X-150 Series features a 3-gauge Tilium Engine and a tri-focal lens capable of emitting a beam of magical energy that sustains its intensity even over extreme distances.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 80,
      "hash": "ej9Ej9De9Ae9Ae9Ag3Aj9Fj9Gkuonhkwkrzruqqf",
      "artist": "Anthony Lopes",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2577,
          "apCost": 0,
          "name": "Complex Machine",
          "shortDescription": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "complex_machine"
        },
        {
          "id": 1873,
          "apCost": 0,
          "name": "Magic Blast",
          "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "magicaoe"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        }
      ]
    },
    {
      "id": 1481,
      "name": "Silverclan Purger",
      "description": "The Purger's Source Emerald pulsates a dark blue to purple every so often.  The Engineers adamantly swear it a benign side effect of the propellant used to generate flames, but others suspect it's some kind of remnant from Ba'lah's influence.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 72,
      "hash": "eJ8IJ8Hf1BF0Be9AF0Aj9Aj9Beruvqwietuzouo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2577,
          "apCost": 0,
          "name": "Complex Machine",
          "shortDescription": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "complex_machine"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 3002,
          "apCost": 0,
          "name": "Hunter: Quick",
          "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunter_quick"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": true,
              "id": 133,
              "apCost": 0,
              "name": "Fire Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Fire damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 1201,
      "name": "Silverclan Tinkerer",
      "description": "The Silverclan are recognized to be some of the finest engineers of the Stronghold.  Much to their dismay, they have far greater notoriety for not being able to hold their ale.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 63,
      "hash": "ej9Ej9DE8De9Ae9Ag3Aj9Ej9Fygyrjwkrzketmpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 579,
          "apCost": 2,
          "name": "Invigorate",
          "shortDescription": "Target champion within 2 spaces gains 4 AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "buff"
        },
        {
          "id": 721,
          "apCost": 2,
          "name": "Shatter",
          "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "antiequip"
        },
        {
          "id": 2578,
          "apCost": 3,
          "name": "Superior Tinkering",
          "shortDescription": "Target construct within 2 spaces gains +1 DMG and +10 MAX HP.  This effect does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "build_mine"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 596,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 4 HP. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "shrinegood"
            },
            {
              "default": false,
              "id": 624,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 8 HP. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "shrinegood"
            },
            {
              "default": false,
              "id": 625,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrinegood"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1082,
      "name": "Sixul the Worldender",
      "description": "One of nine Dire Lords; Argol's brother Sixul underwent grueling physical changes under the Immortal Trial of Conflagration. Since 'Embracing the Cinder' his control over the element of fire has become legendary. Even trees cower in his wake.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 58,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Priest"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 88,
      "hash": "dj9Gj9Fe9Ae9Be9BJ8GJ8HJ8Iwkwzzvqhekgnpwf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1885,
          "apCost": 3,
          "name": "Cleansing Flame",
          "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "cleanse"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 1271,
          "apCost": 0,
          "name": "Tempo",
          "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dancesong"
        },
        {
          "id": 633,
          "apCost": 2,
          "name": "Terraform: Lava",
          "shortDescription": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1886,
              "apCost": 4,
              "name": "Annihilate",
              "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 3012,
              "apCost": 0,
              "name": "Vigor: Psychic",
              "shortDescription": "The first time each turn a champion within 3 spaces takes Psychic damage from a source other than this champion, this champion gains 2 AP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "vigor_psychic"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 885,
              "apCost": 3,
              "name": "Flame Siphon",
              "shortDescription": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fire"
            },
            {
              "default": true,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1467,
      "name": "Sixul the Worldender",
      "description": "One of nine Dire Lords; Argol's brother Sixul underwent grueling physical changes under the Immortal Trial of Conflagration. Since 'Embracing the Cinder' his control over the element of fire has become legendary. Even trees cower in his wake.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 58,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Firk"
      ],
      "noraCost": 88,
      "hash": "eJ8HJ8Gf1AF0Be9Ae9BJ8Jj9Aeeerfmwtzvsfmn",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1885,
          "apCost": 3,
          "name": "Cleansing Flame",
          "shortDescription": "Target champion within 4 spaces takes 10 Fire damage and is Cleansed and Dispelled.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "cleanse"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 1271,
          "apCost": 0,
          "name": "Tempo",
          "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dancesong"
        },
        {
          "id": 633,
          "apCost": 2,
          "name": "Terraform: Lava",
          "shortDescription": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1886,
              "apCost": 4,
              "name": "Annihilate",
              "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 3012,
              "apCost": 0,
              "name": "Vigor: Psychic",
              "shortDescription": "The first time each turn a champion within 3 spaces takes Psychic damage from a source other than this champion, this champion gains 2 AP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "vigor_psychic"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 885,
              "apCost": 3,
              "name": "Flame Siphon",
              "shortDescription": "Target friendly champion within 5 spaces takes 10 Fire damage, you gain 100% of the damage taken in Nora.  May target self.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fire"
            },
            {
              "default": true,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 272,
      "name": "Skeezick Alchemist",
      "description": "Keep them away from our main forces...not all of us have as strong resilience to their accidents - Raxar, Skeezick General",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Mutant",
        "Skeezick"
      ],
      "noraCost": 78,
      "hash": "dj9Gj9Fe9AF0AF0AJ8HJ8IJ8Jpjwzgtmsjwiigyg",
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1998,
              "apCost": 2,
              "name": "Grant: Action Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 12,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2436,
              "apCost": 2,
              "name": "Mutate",
              "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "mutation"
            },
            {
              "default": false,
              "id": 773,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 739,
      "name": "Skeezick Arthromancer",
      "description": "In Valdac, the Skeezick are often given the odd jobs. The Arthromancers were tasked with gathering insects for the Broodlings. Over time, they developed a bond with their harvest.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 70,
      "hash": "dj9Cj9BG2AG2AF0BJ8IJ8Jj9Awitxfgekjlykrfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1323,
          "apCost": 2,
          "name": "Contaminate",
          "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "dot_poison"
        },
        {
          "id": 3390,
          "apCost": 0,
          "name": "Dune Armaments",
          "shortDescription": "When a friendly champion with Race: Draksar, Race: Skeezick or Race: Arthropod becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 1500,
          "apCost": 4,
          "name": "Locust Cloud",
          "shortDescription": "Area Effect 2, Range 5: Affected champions take 8 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Mini-locust Swarm (Opposing champions within the affected area have -2 DEF).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "locust_swarm"
        },
        {
          "id": 1964,
          "apCost": 3,
          "name": "Summon: Hive",
          "shortDescription": "Summon a Hive relic with <ability value=2017>Hive</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "plant_hive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1879,
              "apCost": 0,
              "name": "Desert Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsand"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1229,
              "apCost": 1,
              "name": "Grant: Tunnel Sand",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1150>Tunnel: Sand 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1793,
              "apCost": 0,
              "name": "Spider Frenzy",
              "shortDescription": "Other friendly champions with Race: Arthropod within 8 spaces have <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sumspider"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 77,
      "name": "Skeezick Baiter",
      "description": "Despite their name, the Baiters do not actually enjoy baiting as much as what happens to the baited.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 65,
      "hash": "cj9Gj9Fj9EE8Df1Bj9Ej9Fj9Gerzosfipqqllgkj",
      "artist": "Roberto Cirillo",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1441,
          "apCost": 0,
          "name": "Confuse Enemy",
          "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "confuse"
        },
        {
          "id": 2998,
          "apCost": 0,
          "name": "Lay Trap: Acid",
          "shortDescription": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "trapthorn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2660,
              "apCost": 3,
              "name": "Grappling Hook",
              "shortDescription": "This champion is relocated to target space within 2-5 spaces.  If that space is occupied by a champion, both champions are relocated up to 2 spaces towards each other. This ability may not be used on impassable or inaccessible spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "pull"
            },
            {
              "default": false,
              "id": 1099,
              "apCost": 0,
              "name": "Hidden: Sand",
              "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            }
          ]
        }
      ]
    },
    {
      "id": 1344,
      "name": "Skeezick Blackguard",
      "description": "Blackguards are rare amongst the Skeezick, as most simply do not have the discipline to endure the training required to achieve the status. Those who do earn considerable status amongst the Skeezick.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 84,
      "hash": "eJ8JJ8IF0BF0Ae9AF0BJ8IJ8Jukukuqsshtxzon",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2772,
          "apCost": 0,
          "name": "Blackguard Training",
          "shortDescription": "For every 25 damage this champion deals, a Blackguard Banner Relic with <ability value=2771>Blackguard Banner</ability> is deployed in an adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1967,
          "apCost": 0,
          "name": "Relic Guardian",
          "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1723,
              "apCost": 3,
              "name": "Declare Target",
              "shortDescription": "Target opposing champion within 5 spaces becomes  Declared as Target (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn) for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "declare_hunted"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": true,
              "id": 331,
              "apCost": 0,
              "name": "Regal Presence",
              "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "majestic"
            }
          ]
        }
      ]
    },
    {
      "id": 1036,
      "name": "Skeezick Bolter",
      "description": "Skeezik Bolter regiments are trained to be skirmish hit and run specialists. They often flank enemy positions and retreat before an enemy has time to react. Pursuers often find themselves choking to death on poison trap left behind. ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Archer"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8IF0AE8De9AF0BJ8HJ8Iygygpfrzxvhygn",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 555,
          "apCost": 0,
          "name": "Attack: Arrow",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arrow"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        },
        {
          "id": 2686,
          "apCost": 0,
          "name": "Logistics: Flanking",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 446,
              "apCost": 0,
              "name": "Lay Trap: Poison Cloud",
              "shortDescription": "Lay a Poison Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, all spaces within a range of 2 are covered in a <mechanic value=poison_cloud>poison cloud</mechanic> until end of the next turn.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trappoison"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            }
          ]
        }
      ]
    },
    {
      "id": 268,
      "name": "Skeezick Boneblade",
      "description": "The dead are the dead...it matters not what you were before, you'll make a fine addition to Serkan's Army. - Chi'lus, Necromancer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 65,
      "hash": "dj9Gj9Fe9AF0AG2Aj9Bj9Cj9Dofmeroumuztoygg",
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1258,
          "apCost": 0,
          "name": "Splintering",
          "shortDescription": "After this champion deals Physical damage to a champion on a close-combat attack, this champion loses 4 HP and gains +2 DMG and a Bone Spur is created in an adjacent space. When a champion with Race: Skeleton captures a Bone Spur, they gain +1 DMG for 1 turn and +2 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defpenalties"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2619,
              "apCost": 0,
              "name": "Zeal: Speed",
              "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "channel_speed"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1127,
              "apCost": 0,
              "name": "Ally: Sundered Lands",
              "shortDescription": "While there are other friendly Sundered Lands champions in play, this champion gets +7 HP and +2 DMG. Sundered Lands champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_sl"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        }
      ]
    },
    {
      "id": 237,
      "name": "Skeezick Cannoneer",
      "description": "Those skeezick not fortunate enough to avoid service in the Draksar military often find themselves in the least desirable of roles.",
      "maxRng": 7,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1Ae9BE8Dj9Ej9Fj9Geeitfkjitmhtxzg",
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 792,
          "apCost": 0,
          "name": "Attack: Cannon",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "artillery"
        },
        {
          "id": 363,
          "apCost": 1,
          "name": "Piercing Shot",
          "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "defpenalties"
        },
        {
          "id": 1152,
          "apCost": 0,
          "name": "Recoil",
          "shortDescription": "When this champion makes a basic attack, it is knocked back 1 space in the direction opposite its target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "knockback"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2099,
              "apCost": 0,
              "name": "Fire Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "artillery"
            },
            {
              "default": false,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1668,
      "name": "Skeezick Cutthroat",
      "description": "I will show them grief and agony. I will have their greatest warriors wake only to defeat, and the cold kiss of this dagger as their world fades a final time. - Stukmoco, Skeezick Scoundrel",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 74,
      "hash": "ej9Bj9AG2AF0BG2Af1Bj9Bj9Ceerzzxohrfgkgrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 580,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            },
            {
              "default": true,
              "id": 2078,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 50% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            }
          ]
        }
      ]
    },
    {
      "id": 286,
      "name": "Skeezick Dragonslayer",
      "description": "Dragons, like any other beast, are easy to kill once you know their weakness... - Dragonslayer Training Tip #12",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 64,
      "hash": "dj9Gj9Fe9AF0AE8Dj9Ej9Fj9Gevkpnykjlgtsofg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 684,
          "apCost": 1,
          "name": "Execute",
          "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "execute"
        },
        {
          "id": 606,
          "apCost": 2,
          "name": "Fester",
          "shortDescription": "Target champion within 5 spaces becomes <condition value=inhibited>Inhibited</condition> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "inhibit"
        },
        {
          "id": 1200,
          "apCost": 0,
          "name": "Hunter: Flying",
          "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "gale"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            },
            {
              "default": false,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            }
          ]
        }
      ]
    },
    {
      "id": 182,
      "name": "Skeezick Drummer",
      "description": "Morale is down sir... the dwarven catapults have our troops nearly at a rout.  -- Send in the drums. - Excerpt from a Draksar Battle Meeting",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 4,
      "damage": 9,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 58,
      "hash": "dj9Dj9CG2Be9Ae9BJ8GJ8HJ8Ijpwkpjyzmnleexf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 668,
          "apCost": 2,
          "name": "Battle Drum",
          "shortDescription": "All friendly champions from the same faction as this one gain <condition value=benediction>Benediction</condition> for 1 turn and recover 1 AP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "drum"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1807,
              "apCost": 0,
              "name": "Deafening Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "deafening_aura"
            }
          ]
        }
      ]
    },
    {
      "id": 134,
      "name": "Skeezick Filcher",
      "description": "Well, mine's longer, and I'll show - hey, where's my sword?",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 60,
      "hash": "dJ8IJ8HF0Ae9Af1Bj9Aj9Bj9Ceipqzzofiruszxf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 594,
          "apCost": 0,
          "name": "Energy Thief",
          "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 1017,
          "apCost": 1,
          "name": "Knockout",
          "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "stun"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 981,
              "apCost": 3,
              "name": "Cloak",
              "shortDescription": "Friendly champions within 2 spaces become <condition value=stealthed>Stealthed</condition> for 2 turns.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 283,
      "name": "Skeezick General",
      "description": "Now that we've breached into the brood pits...it's time to finish what we have started...sappers bring the oil... - Raxar, Skeezick General",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 10,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 84,
      "hash": "dJ8IJ8HF0AF0AF0AJ8HJ8IJ8Jpuvszitmlephgvf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        },
        {
          "id": 930,
          "apCost": 0,
          "name": "Surge: Skeezick",
          "shortDescription": "This unit has +1 DMG for each friendly Skeezick.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge_skeezick"
        },
        {
          "id": 263,
          "apCost": 0,
          "name": "Warcry",
          "shortDescription": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            }
          ]
        }
      ]
    },
    {
      "id": 1340,
      "name": "Skeezick Grunt",
      "description": "Those less talented Skeezick whose eyesight are too poor for Sniper or Cannoneer duty are relegated to the role of Grunt.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 60,
      "hash": "eJ8JJ8IE8DF0Ae9AF0Bj9Ej9Fukukuvkgknepso",
      "artist": "Dan Masso",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2429,
          "apCost": 0,
          "name": "Flanking",
          "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "flank"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        },
        {
          "id": 2768,
          "apCost": 0,
          "name": "Sole Purpose",
          "shortDescription": "When this champion makes a basic attack, it loses 3 Charges. For each charge it lacks, it loses 4 HP instead.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "ondeath"
        },
        {
          "id": 2261,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2178,
              "apCost": 0,
              "name": "Supercharged",
              "shortDescription": "This unit gains 1 charge at the start of its turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "supercharged"
            },
            {
              "default": false,
              "id": 2167,
              "apCost": 0,
              "name": "Attack Charged",
              "shortDescription": "When this champion makes a basic attack, it gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            },
            {
              "default": false,
              "id": 2165,
              "apCost": 0,
              "name": "Abuse Charged",
              "shortDescription": "When an opposing champion makes an attack against this champion, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_abuse"
            }
          ]
        }
      ]
    },
    {
      "id": 984,
      "name": "Skeezick Herder",
      "description": "The Skeezick to survive exile became accustomed to the arid Dunes of Valdac. When the rebellion ended and their crimes were absolved, their survival skills were put to use in service of the city.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3Ag3Ag3Aj9Dj9Ej9Fgnlrlnytsfpyvoh",
      "artist": "Bartek Gawel",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2348,
          "apCost": 4,
          "name": "Beast Herder",
          "shortDescription": "Friendly Beasts within 5 spaces gain 3 AP and <ability value=396>Charge 3</ability> for 1 turn.  If the champion already has Charge, it gains <ability value=2092>Crushing Charge</ability> instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "desert_hearder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": true,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1879,
              "apCost": 0,
              "name": "Desert Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsand"
            },
            {
              "default": false,
              "id": 1229,
              "apCost": 1,
              "name": "Grant: Tunnel Sand",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1150>Tunnel: Sand 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        }
      ]
    },
    {
      "id": 1224,
      "name": "Skeezick Machinist",
      "description": "\"You are going to have to define 'working'...\" ~ Tok, Skeezick Machinist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FF0Ae9Be9Ae9AJ8HJ8Iwitfxzohthigro",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        },
        {
          "id": 2590,
          "apCost": 3,
          "name": "Summon: Gatling Gun",
          "shortDescription": "Summon a Gatling Gun relic with <ability value=2602>Misfire</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            },
            {
              "default": false,
              "id": 625,
              "apCost": 3,
              "name": "Mason",
              "shortDescription": "Target friendly Relic, Shrine or champion with Race: Construct within 5 spaces heals 12 HP. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrinegood"
            },
            {
              "default": true,
              "id": 772,
              "apCost": 1,
              "name": "Fire Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            },
            {
              "default": true,
              "id": 3390,
              "apCost": 0,
              "name": "Dune Armaments",
              "shortDescription": "When a friendly champion with Race: Draksar, Race: Skeezick or Race: Arthropod becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            }
          ]
        }
      ]
    },
    {
      "id": 78,
      "name": "Skeezick Netter",
      "description": "Akakios most liked the netters for their ability to catch small things: like elves and goblins.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 64,
      "hash": "cj9Hj9Gj9Fe9AG2Aj9Fj9Gj9Hqfplegigevzmlpj",
      "artist": "Kelly Hamilton",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1947,
              "apCost": 0,
              "name": "Entangling Attack",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1200,
              "apCost": 0,
              "name": "Hunter: Flying",
              "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            }
          ]
        }
      ]
    },
    {
      "id": 285,
      "name": "Skeezick Rioter",
      "description": "We're going to raid the forward walls tonight while the sappers blow up the grain reserves. It will be a glorious night for our people. - Raxar, Skeezick General",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 73,
      "hash": "dj9Gj9Fe9AF0Ae9Aj9Fj9Gj9Hrojytqjpfvsqzgg",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 659,
          "apCost": 0,
          "name": "Attack: Rock",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "rock"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        },
        {
          "id": 3316,
          "apCost": 0,
          "name": "Swarm: Skeezick Rioter",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Skeezick Rioter with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1880,
              "apCost": 0,
              "name": "Violent",
              "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            }
          ]
        }
      ]
    },
    {
      "id": 1343,
      "name": "Skeezick Ripper",
      "description": "Skeezicks were never known for being \"stable\" but the Rippers seem to be affected by something otherwordly.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8IF0AF0Ae9AF0BJ8HJ8Iukukgggkwojlln",
      "artist": "Conceptopolis",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        },
        {
          "id": 2608,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 2773,
              "apCost": 0,
              "name": "Quest: Runner",
              "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 547,
      "name": "Skeezick Ruffian",
      "description": "I like the sound of dwarf bone, when it snaps in two. Elf bones aren't the same. - Hegim, Skeezick Ruffian",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 65,
      "hash": "dJ8HJ8Ge9Bf1Be9Aj9Fj9Gj9Hwzxkjrjetziyxzg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1454,
          "apCost": 0,
          "name": "Escape",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 342,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +2 DMG.",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 344,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +6 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hammer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 115,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 2 HP.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 356,
      "name": "Skeezick Scoundrel",
      "description": "I will show them grief and agony. I will have their greatest warriors wake only to defeat, and the cold kiss of this dagger as their world fades a final time. - Stukmoco, Skeezick Scoundrel",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 74,
      "hash": "dj9Dj9CG2BF0Ae9Aj9Fj9Gj9Huxxfvherouhtuhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 580,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            },
            {
              "default": true,
              "id": 2078,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 50% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            }
          ]
        }
      ]
    },
    {
      "id": 279,
      "name": "Skeezick Sniper ",
      "description": "TEN CLAWS MOVING WEST BY SOUTH, FROM THE BLOOD WELL. - Skeezick Sniper on reconnaissance duty  ",
      "maxRng": 7,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 66,
      "hash": "dj9Gj9Fe9AF0Ae9BJ8GJ8HJ8Inusqlgiwqojetxf",
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 1303,
          "apCost": 0,
          "name": "Gain Control",
          "shortDescription": "The effects of <ability value=874>Reckless Flight</ability> and <ability value=2266>Wandering</ability> are negated until the end of this turn. This ability costs 6 Nora upon activation.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "gale"
        },
        {
          "id": 874,
          "apCost": 0,
          "name": "Reckless Flight",
          "shortDescription": "At the beginning of your turn, this unit moves 2 spaces randomly, usually towards your enemy's Shrine or Avatar. This unit cannot spend AP on movement. This unit has mobility.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "wandering_new"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1137,
              "apCost": 1,
              "name": "Impact Strike",
              "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1818,
              "apCost": 0,
              "name": "Defensive Strike",
              "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1433,
              "apCost": 0,
              "name": "Bounty Hunter",
              "shortDescription": "This unit gains the Hunter ability that matches the faction of the first champion it successfully attacks with a basic attack, after the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hunter_bounty"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 411,
      "name": "Skeezick Torch",
      "description": "Controlling fire is a feat worthy of respect in Draconic society.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 72,
      "hash": "dJ8IJ8HF0AF0BF0AJ8HJ8IJ8Jumyxiigigkpsjwf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1883,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_burn"
        },
        {
          "id": 2400,
          "apCost": 4,
          "name": "Flamethrower",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "fireaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 997,
              "apCost": 1,
              "name": "Melt",
              "shortDescription": "All snow, ice or water terrain with 6 spaces become dirt for 6 turns. <ability value=600>Arctic</ability>, <ability value=2>Amphibious</ability> and <ability value=114>Aquatic</ability> units within 6 spaces take 7 damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "melt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 717,
      "name": "Skeezick Torch",
      "description": "Controlling fire is a feat worthy of respect in Draconic society.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 72,
      "hash": "dj9Bj9Af1Bf1Be9BJ8GJ8HJ8Itqzxfpuztxqshyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1883,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_burn"
        },
        {
          "id": 2400,
          "apCost": 4,
          "name": "Flamethrower",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Fire damage and are <condition value=enflamed>Enflamed</condition> 2. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "fireaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 997,
              "apCost": 1,
              "name": "Melt",
              "shortDescription": "All snow, ice or water terrain with 6 spaces become dirt for 6 turns. <ability value=600>Arctic</ability>, <ability value=2>Amphibious</ability> and <ability value=114>Aquatic</ability> units within 6 spaces take 7 damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "melt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 79,
      "name": "Skeezick Trapper",
      "description": "To track a trapper one must avoid being entrapped themselves. - K'thir Ranger Sayer",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 64,
      "hash": "cj9Hj9Gj9Fe9Af1Bj9Fj9Gj9Hyknjnpfkgkegyoj",
      "artist": "Roberto Cirillo",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 452,
          "apCost": 0,
          "name": "Lay Trap: Frost",
          "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "trapfrost"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            },
            {
              "default": true,
              "id": 443,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Fire Damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "trapfire"
            },
            {
              "default": false,
              "id": 442,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 3 Fire Damage.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "trapfire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 728,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 7 Physical Damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "traprock"
            },
            {
              "default": false,
              "id": 727,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Physical Damage.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "traprock"
            },
            {
              "default": false,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            }
          ]
        }
      ]
    },
    {
      "id": 1648,
      "name": "Skeezick Trigger",
      "description": "Though the civil war ended, the Skeezick learned many things from it -- a war fought with torches, pitchforks, and cunning.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 65,
      "hash": "eJ8IJ8Hg3AF0BG2AF0Aj9Dj9Eeevxtjrwoqowxqf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1882,
          "apCost": 0,
          "name": "Burn",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_burn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2655,
              "apCost": 4,
              "name": "Overload",
              "shortDescription": "Relics within 10 spaces take 10 Electricity damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2091,
              "apCost": 0,
              "name": "Dragging Attack",
              "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "pull"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 1749,
              "apCost": 1,
              "name": "Grant: Lay Trap: Boulder",
              "shortDescription": "Target champion within 5 spaces gains <ability value=729>Lay Trap: Boulder 3 </ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1650,
      "name": "Skeezick Vanguard",
      "description": "Most troops want a few ranks between them and the enemy. The Vanguard wants only an open path and the rush of wind.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8Ie9AF0BG2AF0Bj9Fj9Geeeeerzoytouoqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3143,
          "apCost": 0,
          "name": "Lead the Charge",
          "shortDescription": "When this champion is deployed from the runedock, the next 2 champions you deploy from the runedock while this champion is in play gain a rank of <ability value=113>Initiative</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "lead_the_charge"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1523,
          "apCost": 0,
          "name": "Train: Defense",
          "shortDescription": "Target friendly champion within 5 spaces permanently gains +1 DEF.  This ability costs 2 nora and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 1237,
              "apCost": 0,
              "name": "Impenetrable",
              "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ironwill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 494,
      "name": "Skeezick Warguard",
      "description": "They had ardor in their hearts. Their skin became armor for their righteous souls. - Lord Akakios",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 61,
      "hash": "dj9Bj9Af1Bf1AF0AJ8HJ8IJ8Jeevxkwtqhexmnyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 217,
          "apCost": 0,
          "name": "Dodge",
          "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "dodge"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        },
        {
          "id": 2476,
          "apCost": 0,
          "name": "Warguard",
          "shortDescription": "When this unit takes damage from an attack or spell, that damage is reduced to 2.  After this effect occurs 5 times, this unit is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "aegis"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 546,
      "name": "Skeezick Warmage",
      "description": "When the Skeezick learned to channel Nora, the result was often sporadic and oddly effective.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9Bf1BE8Dj9Ej9Fj9Gevfvhtfrwxzonyg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2229,
          "apCost": 0,
          "name": "Charged Magic Bomb",
          "shortDescription": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "magicaoe"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 738,
              "apCost": 0,
              "name": "Shielded",
              "shortDescription": "This champion may not be the target of opposing spells",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spell_resistance"
            }
          ]
        }
      ]
    },
    {
      "id": 1771,
      "name": "Skeezick Whorl",
      "description": "The magic of the skeezick is just as ordered, in its own way, as that of the dwarves, although the results may appear otherwise.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 73,
      "hash": "ej9Ej9Dg3Af1BG2Ag3Aj9Dj9Eeeerzrsoshpyruf",
      "artist": "Caio Monteiro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 1255,
          "apCost": 0,
          "name": "Inhibiting Touch",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "inhibit"
        },
        {
          "id": 1780,
          "apCost": 1,
          "name": "Radiant Blow",
          "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "radiant_blow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1876,
              "apCost": 1,
              "name": "Grant: Elemental Immunity",
              "shortDescription": "Target champion within 5 spaces gains <ability value=37>Immunity: Fire</ability>, <ability value=38>Immunity: Frost</ability> and <ability value=39>Immunity: Electricity</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 930,
      "name": "Skeezick Wrecker",
      "description": "\"The problem with the Tortuns is you let them keep their guns! Destroy his weapon and the enemy will flee.\" - Raxar, General of the Skeezick Armies",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1Ag3AF0BJ8IJ8Jj9Aeevklpljyzieieg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2094,
          "apCost": 0,
          "name": "Combo Attack: Stun",
          "shortDescription": "When this champion makes two successful basic attacks that deal damage against the same champion in a single turn, that champion becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "comboatk_rend"
        },
        {
          "id": 2285,
          "apCost": 0,
          "name": "Sword Breaker",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "wrecker"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1076,
      "name": "Skeezick Wylder",
      "description": "You can find them near the Dunes of Valdac, that is, if they wish to be found. ",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue",
        "Shaman"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9Ce9BE8De9AG2BJ8GJ8Hkymnwtshyvxqqo",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2300,
          "apCost": 0,
          "name": "Charged Blast",
          "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2339,
          "apCost": 4,
          "name": "Imbue: Stun",
          "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 9,
          "iconName": "amped"
        },
        {
          "id": 2177,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 3 charges.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "charged_spell"
        },
        {
          "id": 737,
          "apCost": 0,
          "name": "Spellswallower",
          "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "spellswallow"
        },
        {
          "id": 86,
          "apCost": 0,
          "name": "Vulnerability: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": true,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1099,
              "apCost": 0,
              "name": "Hidden: Sand",
              "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            }
          ]
        }
      ]
    },
    {
      "id": 269,
      "name": "Skeletal Berserker",
      "description": "My, how the newly risen dead love to rumble... - Xulos, Apprentice to Serkan",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 12,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 34,
      "hash": "dj9Gj9Fe9AF0Af1Bj9Aj9Bj9Ceilrukexxxvsofg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 23,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +2 DMG and <ability value=2005>Careless</ability>",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "berserker"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 105,
          "apCost": 0,
          "name": "Scorn",
          "shortDescription": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "shrinebad"
        },
        {
          "id": 875,
          "apCost": 0,
          "name": "Short Lived",
          "shortDescription": "This unit is destroyed after 6 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": -20,
          "iconName": "ondeath"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 394,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1 space in a straight line through non-Impeding terrain and makes a close-combat attack at +1 DMG.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 1,
              "iconName": "charge"
            },
            {
              "default": true,
              "id": 347,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +3 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 27,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets +2 DMG, and gains 1 additional rank of <ability value=15>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 2217,
              "apCost": 0,
              "name": "Hunter: Brawler",
              "shortDescription": "When this unit would deal damage to a champion with Class: Monk, Brute, or Rogue with any Attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Monk, Brute, or Rogue, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_rogue"
            }
          ]
        }
      ]
    },
    {
      "id": 1704,
      "name": "Skeletal Excavator",
      "description": "As the Ironfist line drew back to fortify their homeland, Xulos ordered raids on now-exposed tombsites: monuments opened to reveal fresh stock for new offensives and artifacts to experiment with.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 7,
      "hitPoints": 60,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 75,
      "hash": "ej9AJ8Jg3Af1AG2Af1Aj9Dj9Eevkuvqwowvxqosf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3147,
          "apCost": 0,
          "name": "Seism",
          "shortDescription": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "seism"
        },
        {
          "id": 3203,
          "apCost": 0,
          "name": "Slothful",
          "shortDescription": "After using an activated ability (including basic attacks), this champion becomes <ability value=757>Immobile</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "slothful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            },
            {
              "default": false,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            },
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            }
          ]
        }
      ]
    },
    {
      "id": 1297,
      "name": "Skeletal Lerper",
      "description": "\"Stay hidden, my pet, and report what you find directly to me. Stay especially hidden from Serkan's henchmen.\" Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Skeleton",
        "Spirit",
        "Undead"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9DG2Ae9Be9Ag3Aj9Bj9Ceeegiiekneegyrf",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2703,
          "apCost": 0,
          "name": "Haunting Visions",
          "shortDescription": "At the beginning of its turn, this champion gains 2 AP and +3 DMG and +1 DEF for 2 turns if opponent has 25 or less nora. This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "possess"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        },
        {
          "id": 95,
          "apCost": 0,
          "name": "Vulnerability: Psychic",
          "shortDescription": "When this unit takes Psychic damage, that damage is increased by 25% (after DEF).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "vuln_psychic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": false,
              "id": 3013,
              "apCost": 0,
              "name": "Soultap Feedback",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "soultap_feedback"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 363,
      "name": "Skeletal Raider",
      "description": "In their final days of fighting, their Queen vowed victory or an honorable burial with their warhorse. In death, they get both.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 73,
      "hash": "dj9Dj9CG2BF0AG2Bj9Cj9Dj9Eeerqftmwiwkykjg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1000,
          "apCost": 0,
          "name": "Skeletal Rider",
          "shortDescription": "When this unit is destroyed, no nora globe is dropped and a Decayed Mercenary with no upgrades is spawned in the location this unit occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "rider"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        }
      ]
    },
    {
      "id": 439,
      "name": "Skeletal Raider",
      "description": "In their final days of fighting, their Queen vowed victory or an honorable burial with their warhorse. In death, they get both.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 73,
      "hash": "dj9Ej9Dg3AF0Bg3Aj9Dj9Ej9Fjgklwztonhirqlg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1000,
          "apCost": 0,
          "name": "Skeletal Rider",
          "shortDescription": "When this unit is destroyed, no nora globe is dropped and a Decayed Mercenary with no upgrades is spawned in the location this unit occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "rider"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        }
      ]
    },
    {
      "id": 1347,
      "name": "Skeletal Reaper",
      "description": "The singular focus of the Skeletal Reaper is both its greatest strength and its greatest weakness.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 65,
      "hash": "eJ8JJ8IG2AF0Ae9AF0Bj9Bj9Ceeeeeipnsjgiepf",
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2250,
          "apCost": 3,
          "name": "Scythe Whirl",
          "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "scythe_wirlwind"
        },
        {
          "id": 711,
          "apCost": 0,
          "name": "Siphoning Aura",
          "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "possess"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": false,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1348,
      "name": "Skeletal Rifleman",
      "description": "When to take their shot comes naturally. The dead know nothing if not patience.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "eJ8JJ8IG2BF0Ae9AF0Bj9Cj9Dqoqoyipnnpleipf",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2574,
          "apCost": 0,
          "name": "Preparation",
          "shortDescription": "At the end of each of its turns, if this unit did not attack, it has +1 DMG and +1 MAX RNG.  This effect stacks up to 4 times and is reset at the end of turn when this unit makes an attack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "surge"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": true,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 290,
      "name": "Skithmaw Hunter",
      "description": "While the Skithmaw have no eyes, they are not blind. They can see through sound itself from echos of their clicks and yalups, meaning they hear what cannot be seen.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 64,
      "hash": "dj9Fj9EE8DF0AG2Bj9Cj9Dj9Eeeeerlgkruxfegg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1376,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "resistance_ranged"
        },
        {
          "id": 517,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": false,
              "id": 201,
              "apCost": 0,
              "name": "Death Nova: Acid",
              "shortDescription": "When this unit is destroyed, it deals 11 Acid damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaacid"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1345,
      "name": "Skybreak Dragon",
      "description": "Jakei creation stories often feature the idea that it is the ice that tames the flames of a young planet and makes it habitable, and both are necessary for life.  The Skybreak Dragon is often cited as nature's affirmation of that idea.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon",
        "Elemental"
      ],
      "noraCost": 81,
      "hash": "eJ8JJ8If1AF0Ae9AF0BJ8Jj9Aeeeeevfpyxxtso",
      "artist": "Nadia Enis",
      "factions": [
        "Savage Tundra",
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2770,
          "apCost": 0,
          "name": "Distichous: ST/SL",
          "shortDescription": "When an ST champion is deployed from the runedock, this champion gains <ability value=1744>Frost Acolyte</ability> and <ability value=135>Frost Aura 1</ability> for 4 turns.  When an SL champion is deployed from the runedock, this champion gains <ability value=1908>Fire Acolyte</ability> and <ability value=131>Fire Aura 1</ability> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "distichous"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 2786,
          "apCost": 0,
          "name": "Spell Aegis",
          "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dark_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 390,
              "apCost": 1,
              "name": "Frost Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=233>Damage Shield: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dmgshld_frost"
            },
            {
              "default": false,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": true,
              "id": 3196,
              "apCost": 0,
              "name": "Updraft",
              "shortDescription": "When this champion is deployed from the runedock, friendly champions gain <condition value=flying>Flying</condition> for 4 turns. If it shares a race with this champion or already has <condition value=flying>Flying</condition>, it also gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "tailwind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1296,
              "apCost": 1,
              "name": "Avalanche",
              "shortDescription": "Area Effect 2, Range 5: Affected champions without <ability value=600>Arctic</ability> take 12 Frost damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Deep Snow (Impeding 1).",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 12,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2600,
              "apCost": 0,
              "name": "Elemental Zephyr",
              "shortDescription": "Friendly Elementals within 5 spaces have <ability value=6>Mobility</ability> and +1 SPD. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 1499,
              "apCost": 4,
              "name": "Lava Storm",
              "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 12,
              "iconName": "fireaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1271,
      "name": "Skyshear Pegasus",
      "description": "Sometimes, I have to imagine Nature itself would be surprised at the things it has wrought.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Plant"
      ],
      "noraCost": 75,
      "hash": "ej9Cj9Be9Ae9Be9AG2Aj9Fj9Goykytsxfmljykpf",
      "artist": "Christian Fell",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 1769,
          "apCost": 0,
          "name": "One With Nora",
          "shortDescription": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "defenseenhance"
        },
        {
          "id": 1776,
          "apCost": 0,
          "name": "Premonition",
          "shortDescription": "When this unit is deployed, champions you own have <ability value=1237>Impenetrable</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 1979,
          "apCost": 0,
          "name": "Running Start",
          "shortDescription": "Whenever this champion moves 2 or more spaces, it gains <ability value=1>Flight</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": true,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3196,
              "apCost": 0,
              "name": "Updraft",
              "shortDescription": "When this champion is deployed from the runedock, friendly champions gain <condition value=flying>Flying</condition> for 4 turns. If it shares a race with this champion or already has <condition value=flying>Flying</condition>, it also gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "tailwind"
            },
            {
              "default": false,
              "id": 766,
              "apCost": 1,
              "name": "Magical Attack",
              "shortDescription": "This unit makes a Magical attack at range 2-4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "magic"
            }
          ]
        }
      ]
    },
    {
      "id": 1151,
      "name": "Skywing Acidcraw",
      "description": "\"Armor? You won't be needing that...\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 66,
      "hash": "ej9AJ8Jf1Ae9Ae9Af1AJ8Jj9Aeruhemjnevssso",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2491,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 3 turns",
              "activationType": 1,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scour"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        }
      ]
    },
    {
      "id": 1150,
      "name": "Skywing Agitator",
      "description": "The dull glow of fire that the Agitators introduce is both a show of force and a signal calling fellow Skywing into battle.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 70,
      "hash": "ej9AJ8JF0Be9Ae9Af1AJ8IJ8Jgpfkukeietszon",
      "artist": "Bartek Gawel",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1989,
              "apCost": 3,
              "name": "Flame Charge",
              "shortDescription": "Until end of turn, all Fire damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_fire"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1124,
      "name": "Skywing Eminent",
      "description": "The Eminents of the Skywing Volarium have a penchant for sweeping in near the end of a battle and killing off disarrayed forces.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 74,
      "hash": "eJ8HJ8GG2Be9Ae9Ae9Bj9Cj9Deipuqwkrlplnso",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2521,
          "apCost": 0,
          "name": "Attack: Toe Lightning",
          "shortDescription": "This unit makes an Electricity attack, from its dainty toes, at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2797,
              "apCost": 0,
              "name": "Logistics: Range",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +2 MAX RNG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1368,
              "apCost": 0,
              "name": "Deflect: Electric",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Electric damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_electric"
            }
          ]
        }
      ]
    },
    {
      "id": 1153,
      "name": "Skywing Imperator",
      "description": "The Imperators are the artillery of the Skywing forces; they rain down acid and lightning onto the battlefield without prejudice.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 80,
      "hash": "ej9AJ8JG2Ae9Ae9Af1Aj9Bj9Cemnygvxqhexiepf",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 805,
          "apCost": 1,
          "name": "Chain Lightning",
          "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "electric"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1879,
              "apCost": 0,
              "name": "Desert Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsand"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 1101,
              "apCost": 4,
              "name": "Sand Spray",
              "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "sand"
            },
            {
              "default": false,
              "id": 2688,
              "apCost": 4,
              "name": "Screech",
              "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "sonicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 889,
      "name": "Skywing Patrol",
      "description": "The Skywing Patrol was the first in what would become the elite special forces of Akakios' army: the Skywing Volarium.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon",
        "Draksar"
      ],
      "noraCost": 76,
      "hash": "dj9Gj9Fe9Ag3Af1Bj9Aj9Bj9Ceevowfvvxzgkrhg",
      "artist": "Andrew Hou",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 2259,
          "apCost": 2,
          "name": "Drop Beacon",
          "shortDescription": "A Skywing Beacon with Beacon (Starting on your next turn, spaces adjacent to this relic are deployment zones for the controller of this relic) is deployed in target adjacent square.  This ability is removed after use.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1152,
      "name": "Skywing Rumbler",
      "description": "This is one storm you can't run from.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 64,
      "hash": "ej9AJ8Jf1Be9Ae9Af1Aj9Aj9Bmlllnlemyxfmwo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 876,
          "apCost": 0,
          "name": "Short Lived",
          "shortDescription": "This unit is destroyed after 8 turns.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": -15,
          "iconName": "ondeath"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 2539,
              "apCost": 0,
              "name": "Lightning Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 1388,
              "apCost": 0,
              "name": "Bolt",
              "shortDescription": "When this champion successfully attacks an enemy champion, it is relocated to the nearest space to that target.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "bolt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 139,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 2 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "novaelectric"
            },
            {
              "default": true,
              "id": 140,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaelectric"
            }
          ]
        }
      ]
    },
    {
      "id": 1835,
      "name": "Skywing Screecher",
      "description": "Screechers use their odd anatomy to compensate for small size.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 69,
      "hash": "eJ8IJ8HG2BG2BG2AF0Aj9Cj9Drzgtjwmufinygrf",
      "artist": "Caio Monteiro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": true,
              "id": 148,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            }
          ]
        }
      ]
    },
    {
      "id": 1700,
      "name": "Skywing Sonicbolt",
      "description": "\"Send my Skywings; let them roll accross their land, moving like lightning, roaring like thunder, and leaving only ashes and ruin in their wake\" - Vindrax, God of Destruction",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 87,
      "hash": "eJ8JJ8IF0Af1AG2AF0BJ8HJ8Ioqoqjwvfvqheepf",
      "artist": "Alex Brock",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 1391,
          "apCost": 0,
          "name": "Ignorance",
          "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ignorance"
        },
        {
          "id": 2688,
          "apCost": 4,
          "name": "Screech",
          "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "sonicaoe"
        },
        {
          "id": 3087,
          "apCost": 3,
          "name": "Sonic Surge",
          "shortDescription": "This champion gains 3 AP and Pacified for 1 turn.  For each space moved, enemy champions within 2 spaces take 3 Sonic damage (this damage ignores DEF).  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "charge_sonic"
        },
        {
          "id": 3189,
          "apCost": 1,
          "name": "Sonicburst",
          "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "sonicaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2315,
              "apCost": 0,
              "name": "Oblivion Shield",
              "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 2469,
              "apCost": 0,
              "name": "Elusive",
              "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "elusive"
            },
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            },
            {
              "default": false,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1180,
      "name": "Slag Overmind",
      "description": "The machinations of the slags functions with or without the presence of an Overmind, but the Overminds evolved to impose efficiency and order to the otherwise chaotic and unpredictable behavior of the slags.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 78,
      "hash": "ej9Dj9Ce9Be9Ae9AG2BJ8GJ8Hoytmemuzvhvoso",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2297,
          "apCost": 1,
          "name": "Grant: Evasive",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 1895,
          "apCost": 0,
          "name": "Illusion of Lies",
          "shortDescription": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "planar"
        },
        {
          "id": 3261,
          "apCost": 2,
          "name": "Mind Lock",
          "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "mind_lock"
        },
        {
          "id": 897,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "mind_control"
        },
        {
          "id": 3319,
          "apCost": 0,
          "name": "Spell Breach",
          "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "counterspell_mastery"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 657,
              "apCost": 2,
              "name": "Relocate: Ally",
              "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1401,
              "apCost": 0,
              "name": "Acidic Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 673,
      "name": "Sleeping Yeti",
      "description": "Some say the cruelest lesson learned in the Savage Tundra is this: tread lightly near sleeping yetis.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 72,
      "hash": "dJ8HJ8Ge9BG2Ae9BJ8GJ8HJ8Iyojgknpwoqoyzvf",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 456,
          "apCost": 2,
          "name": "Fear",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "fear"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1870,
          "apCost": 0,
          "name": "Startle",
          "shortDescription": "This unit becomes <condition value=enraged3>Enraged 3</condition> for 2 turns whenever it loses <condition value=stealthed>Stealthed</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 988,
      "name": "Slick and Buzz",
      "description": "Whenever a Salaman is in mortal peril or the city of Seljichan is in danger, only one daring duo will do: Slick and Buzz! Together, these two paragons protect and serve their home city from the forces of evil!",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Salaman"
      ],
      "noraCost": 86,
      "hash": "ej9Fj9EF0AE8De9AE8DJ8HJ8Iwvfiyvvfexoukn",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1998,
          "apCost": 2,
          "name": "Grant: Action Potion",
          "shortDescription": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "grantability"
        },
        {
          "id": 1860,
          "apCost": 2,
          "name": "Grant: Rage Potion",
          "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2117,
          "apCost": 5,
          "name": "Metamorphosis",
          "shortDescription": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 850,
              "apCost": 1,
              "name": "Acid Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "acidaoe"
            },
            {
              "default": false,
              "id": 169,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        }
      ]
    },
    {
      "id": 1858,
      "name": "Slick and Buzz",
      "description": "Whenever a Salaman is in mortal peril or the city of Seljichan is in danger, only one daring duo will do: Slick and Buzz! Together, these two paragons protect and serve their home city from the forces of evil!",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod",
        "Salaman"
      ],
      "noraCost": 86,
      "hash": "ej9Bj9AF0BG2BG2Af1BJ8IJ8Juoquoyvkgpjyxqf",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1998,
          "apCost": 2,
          "name": "Grant: Action Potion",
          "shortDescription": "Target champion within 3 spaces gains <ability value=1999>Drink Action Potion</ability> for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "grantability"
        },
        {
          "id": 1860,
          "apCost": 2,
          "name": "Grant: Rage Potion",
          "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "grantability"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 2117,
          "apCost": 5,
          "name": "Metamorphosis",
          "shortDescription": "Target champion within 3 spaces is <mechanic value=cleansed>Cleansed</mechanic> and becomes a Snail with 5 SPD, 7 DMG, 1 RNG, 1 DEF, loses all of its base and upgraded abilities, and gains <ability value=545>Attack: Physical</ability> for 4 turns. If the target is a large champion, it becomes a Giant Toad instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 850,
              "apCost": 1,
              "name": "Acid Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "acidaoe"
            },
            {
              "default": false,
              "id": 169,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 2371,
              "apCost": 4,
              "name": "Flash Bomb",
              "shortDescription": "All enemy champions within 2 spaces are <condition value=blinded>Blinded</condition> for 2 turns and this champion becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "flash_bomb"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        }
      ]
    },
    {
      "id": 80,
      "name": "Slipworm",
      "description": "The sporadic movements of the Slipworm distract long enough to drain unwary travelers of everything but their marvel.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 8,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 69,
      "hash": "cJ8JJ8IJ8HF0AF0BJ8HJ8IJ8Jukukukuxfkrfxqh",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 140,
          "apCost": 0,
          "name": "Electricity Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "novaelectric"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 2076,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 20% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "reflexes"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 1331,
              "apCost": 0,
              "name": "Electricity Eater",
              "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_electric"
            },
            {
              "default": true,
              "id": 189,
              "apCost": 0,
              "name": "Death Nova: Electricity",
              "shortDescription": "When this unit is destroyed, it deals 11 Electricity damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovaelec"
            }
          ]
        }
      ]
    },
    {
      "id": 1742,
      "name": "Slitherine",
      "description": "Those who live after facing the Slitherine are plagued with recurring nightmares, but all would rather choose that than meet the Slitherine again.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 74,
      "hash": "eJ8HJ8Gf1Bf1BG2Ae9Bj9Aj9Bemsfkwiljtmukpf",
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3235,
          "apCost": 2,
          "name": "Beckoning Guile",
          "shortDescription": "Target a space within 5 spaces. Enemy champions without <ability value=4>Iron Will</ability> within 5 spaces of the target move one space towards it.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "pull_guile"
        },
        {
          "id": 2783,
          "apCost": 0,
          "name": "Horrifying Delusion",
          "shortDescription": "If the opposing player has 25 or less nora at the beginning of this unit's turn, it gains <ability value=1850>Frightful Blows</ability> and <ability value=99>Life Siphon</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "possess"
        },
        {
          "id": 1018,
          "apCost": 2,
          "name": "Tangle",
          "shortDescription": "Disengagement from this unit will remove all remaining AP from champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "disable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 966,
              "apCost": 2,
              "name": "Cackle",
              "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "cackle"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 81,
      "name": "Sludge Wurm",
      "description": "These giant creatures are unmoved by fear, and unafraid to bite back.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 53,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon",
        "Worm"
      ],
      "noraCost": 71,
      "hash": "cj9Hj9Gj9Fe9AF0Bj9Fj9Gj9Hsukeinusmlgpfmj",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2227,
          "apCost": 0,
          "name": "Choking Stench",
          "shortDescription": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "choking_stench"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        },
        {
          "id": 860,
          "apCost": 0,
          "name": "Trail: Slime",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Slime (Impeding 1 Water) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "trail_slime"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2481,
              "apCost": 4,
              "name": "Cast: Hungry Mire",
              "shortDescription": "Area Effect 2, Range 4: For the next 4 turns, all spaces become Dirt and Shallow Water. When a champion without <condition value=flying>Flying</condition> enters one of these spaces, it takes 5 Physical damage and becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "hungry_mire"
            },
            {
              "default": true,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            },
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1748,
              "apCost": 1,
              "name": "Grant: Poison Cloud Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=446>Lay Trap: Poison Cloud</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 339,
      "name": "Snake Charmer ",
      "description": "This wood is home to a thousand kin of snake. Bare no arms here, or I will call upon the forest fangs! - Jahne, Serpentine Druid",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 64,
      "hash": "dj9Bj9Af1BF0AF0AJ8HJ8IJ8Jeeiyzvzvfxiegyg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 416,
          "apCost": 2,
          "name": "Charm",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "charm"
        },
        {
          "id": 1004,
          "apCost": 4,
          "name": "Summon: Serpent",
          "shortDescription": "Randomly summon a Poison Serpent with 0 DEF, 6 SPD, 9 DMG, HP of 15, RNG 1 and <ability value=168>Poison 2</ability> or a Constrictor Serpent with 0 DEF, 5 SPD, 7 DMG, HP of 25, RNG 1 and <ability value=324>Constriction</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "sumsnake"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 366,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 4 HP. May target self.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": true,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 1121,
      "name": "Snaptooth Ancient",
      "description": "\"You'd better have a good reason for waking me up, lil' snapper, or I'll make you eat your tail.\"",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 76,
      "hash": "eJ8HJ8Gf1Ae9Ae9Ae9BJ8Jj9Aeemwmegrjnsshn",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 3355,
          "apCost": 0,
          "name": "Murkwater Solemnity",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=1857>Soultap</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1125,
              "apCost": 0,
              "name": "Ally: Forsaken Waste",
              "shortDescription": "While there are other friendly Forsaken Wastes champions in play, this champion gets +7 HP and +2 DMG. Forsaken champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fw"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 1332,
      "name": "Snaptooth Chilan",
      "description": "\"Our magic is ancient, Berkchani. Older  and more capable than you think.\" ~ Kahn Ajua, Master Chilan",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 76,
      "hash": "eJ8IJ8He9BF0Ae9AF0AJ8GJ8Hevxxqllyroqhem",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 1728,
          "apCost": 0,
          "name": "Divert",
          "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deflect"
        },
        {
          "id": 3355,
          "apCost": 0,
          "name": "Murkwater Solemnity",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=1857>Soultap</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 3006,
          "apCost": 0,
          "name": "Nora Induction",
          "shortDescription": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ichor_utility"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 3137,
              "apCost": 2,
              "name": "Dread Field",
              "shortDescription": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "dread_field"
            },
            {
              "default": false,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1786,
              "apCost": 3,
              "name": "Ritual of Destruction",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_damage"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 1101,
      "name": "Snaptooth Crawmangler",
      "description": "\"I've seen them Serkan, they linger between both worlds, never really alive nor truly dead. The Murkwater in which they dwell seems to be the source of their power and it is ... quite potent\" - Xulos, Undead Sage\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9Ef1Be9Ae9AE8Dj9Aj9Bmluvvzmnymjtxo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2582,
          "apCost": 0,
          "name": "Impairing Feedback",
          "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 2517,
          "apCost": 0,
          "name": "Murkwater Frenzy",
          "shortDescription": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 1125,
              "apCost": 0,
              "name": "Ally: Forsaken Waste",
              "shortDescription": "While there are other friendly Forsaken Wastes champions in play, this champion gets +7 HP and +2 DMG. Forsaken champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fw"
            },
            {
              "default": true,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        }
      ]
    },
    {
      "id": 1100,
      "name": "Snaptooth Deadeye",
      "description": "\"Thing came out of the Murkwater like lightnin' and snatched that whelp 'afore it could turn ta see what the noise was.\" - Harrin, Barbarian Conscript\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9Ef1Ae9Ae9AE8DJ8Jj9Aerumuvvhthtzto",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2517,
          "apCost": 0,
          "name": "Murkwater Frenzy",
          "shortDescription": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 1800,
          "apCost": 4,
          "name": "Tunnel Trap",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> and moves directly to target space within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "traprock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2097,
              "apCost": 0,
              "name": "Combo Attack: Rend",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_rend"
            },
            {
              "default": true,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": false,
              "id": 1867,
              "apCost": 1,
              "name": "Mark",
              "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "declare_hunted"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            }
          ]
        }
      ]
    },
    {
      "id": 1098,
      "name": "Snaptooth Dusk Shaman",
      "description": "\"We know little about Murkwater magic or the way they use nora. They don't talk much.\" - Rissa, Tadpool Guardian \r\n",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 78,
      "hash": "ej9Fj9EF0Ae9Ae9AE8DJ8HJ8Ixmhgkrljitxqln",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1208,
          "apCost": 0,
          "name": "Debilitate",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "debuff"
        },
        {
          "id": 3355,
          "apCost": 0,
          "name": "Murkwater Solemnity",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=1857>Soultap</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        },
        {
          "id": 1279,
          "apCost": 0,
          "name": "Weary",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "debuff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1237,
              "apCost": 0,
              "name": "Impenetrable",
              "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ironwill"
            },
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1715,
      "name": "Snaptooth Frenzy",
      "description": "The Snaptooth are some of the most tempermental swamp denizens. An \"aggressive Snaptooth,\" then, is something special. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 81,
      "hash": "ej9Dj9Ce9Bf1AG2AG2BJ8GJ8Hszvvkusxinjtqqf",
      "artist": "Grant Griffin",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2253,
          "apCost": 0,
          "name": "Manic",
          "shortDescription": "At the end of its turn, if this champion has a MIN RNG of 1, it moves 2 spaces toward the closest enemy champion, and makes an attack against that champion if possible.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "manic"
        },
        {
          "id": 2517,
          "apCost": 0,
          "name": "Murkwater Frenzy",
          "shortDescription": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 1564,
      "name": "Snaptooth Hunter",
      "description": "\"Stop bleeding on me!\" ~ Last words of a Moga Scouting party",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 71,
      "hash": "ej9AJ8Jf1Ae9BG2Af1AJ8Jj9Aeiyxvxxvkepykpf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 2517,
          "apCost": 0,
          "name": "Murkwater Frenzy",
          "shortDescription": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 2324,
          "apCost": 4,
          "name": "Pounce",
          "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "pounce"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": true,
              "id": 2785,
              "apCost": 0,
              "name": "Call of the Hunter",
              "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1099,
      "name": "Snaptooth Murkwater",
      "description": "\"Murkwater is a place beyond Darkmarsh that we boghop do not tread. The Snaptooth, while our allies, do not tolerate anything that is not food in their homewater.\" - Kartch, Boghopper Finlord\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 65,
      "hash": "ej9Fj9EF0Be9Ae9AE8DJ8IJ8Jgpferwtjrzrjpn",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2517,
          "apCost": 0,
          "name": "Murkwater Frenzy",
          "shortDescription": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 2754,
          "apCost": 0,
          "name": "Spellsurge: Murkwater Weakness",
          "shortDescription": "When this champion is deployed, Murkwater Weakness spells are revealed from your runedock.  Murkwater Weakness spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Murkwater Weakness spell is played.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 19,
      "name": "Snaptooth Rider",
      "description": "Beauty can control any beast. The Snaptooth Riders are living proof of this.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Human",
        "Snaptooth"
      ],
      "noraCost": 75,
      "hash": "cJ8IJ8HJ8Ge9BF0AJ8GJ8HJ8Iemsxietjinsqonh",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2517,
          "apCost": 0,
          "name": "Murkwater Frenzy",
          "shortDescription": "This unit gains <ability value=2>Amphibious</ability> and <ability value=3013>Soultap Feedback</ability>. While 4 friendly champions with Race: Snaptooth are in play, this champion gains <ability value=1504>Brutality</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": true,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1745,
      "name": "Snaptooth Vermillion",
      "description": "\"You might see me from a mile away, but I am still gonna catch ya!\"",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Snaptooth"
      ],
      "noraCost": 76,
      "hash": "eJ8IJ8Hf1Af1BG2AF0AJ8Jj9Aerlpufmuxtjwkpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 3355,
          "apCost": 0,
          "name": "Murkwater Solemnity",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=1857>Soultap</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "murkwater_frenzy"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 663,
          "apCost": 0,
          "name": "Rabid",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_rabid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 1125,
              "apCost": 0,
              "name": "Ally: Forsaken Waste",
              "shortDescription": "While there are other friendly Forsaken Wastes champions in play, this champion gets +7 HP and +2 DMG. Forsaken champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fw"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 839,
      "name": "Snare Fairy",
      "description": "\"The Elves were not the only race capable of surviving the cold of the Tundra after the Separation.\" - Ladri, Tundra Fairy",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 67,
      "hash": "dj9Bj9Af1BG2Bf1Bj9Aj9Bj9Ceitolgymshignhg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest",
        "Savage Tundra"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 774,
          "apCost": 0,
          "name": "Chill",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dot_chill"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2669,
              "apCost": 0,
              "name": "Snowstrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 1747,
              "apCost": 1,
              "name": "Grant: Frost Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 1463,
              "apCost": 0,
              "name": "Iceguard",
              "shortDescription": "The next time this unit is damaged, this unit becomes <condition value=crystallized>Crystallized</condition> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "iceguard"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1094,
      "name": "Snogvie the Antbear",
      "description": "\"What did the didgeridoo? He done did it saxy.\" - Snogvie the Antbear\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Bard"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 94,
      "hash": "ej9Ej9Dg3AE8De9Ag3Aj9Dj9Eeeeruxiwxqofgrf",
      "artist": "Mike Pedro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Wild Alliance",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1807,
          "apCost": 0,
          "name": "Deafening Aura",
          "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "deafening_aura"
        },
        {
          "id": 2505,
          "apCost": 0,
          "name": "Snogvie's Greeting",
          "shortDescription": "When this champion comes into play, all enemy champions take 5 sonic damage and become <condition value=distracted>Distracted</condition> for 2 turns. This damage ignores defense. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "greeting_sonic"
        },
        {
          "id": 149,
          "apCost": 0,
          "name": "Sonic Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 1336,
              "apCost": 0,
              "name": "Fascinate",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2352,
              "apCost": 0,
              "name": "Defensive Turtle",
              "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "turtle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": true,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        }
      ]
    },
    {
      "id": 1468,
      "name": "Snogvie the Antbear",
      "description": "\"What did the didgeridoo? He done did it.\" - Snogvie the Antbear\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Bard"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 94,
      "hash": "eJ8HJ8Gf1BF0Be9Ae9Bj9Aj9Beeigrqluxigtqo",
      "artist": "Mike Pedro",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1807,
          "apCost": 0,
          "name": "Deafening Aura",
          "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "deafening_aura"
        },
        {
          "id": 2505,
          "apCost": 0,
          "name": "Snogvie's Greeting",
          "shortDescription": "When this champion comes into play, all enemy champions take 5 sonic damage and become <condition value=distracted>Distracted</condition> for 2 turns. This damage ignores defense. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "greeting_sonic"
        },
        {
          "id": 149,
          "apCost": 0,
          "name": "Sonic Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 1336,
              "apCost": 0,
              "name": "Fascinate",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2352,
              "apCost": 0,
              "name": "Defensive Turtle",
              "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "turtle"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": true,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        }
      ]
    },
    {
      "id": 242,
      "name": "Snow Lerper",
      "description": "After the Separation, it was not just elves, but indeed all creatures of the Forest that had lost their home.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 65,
      "hash": "dj9AJ8Jf1Ae9Bf1Bj9Aj9Bj9Ceevsjyxqwfitxzg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1474,
          "apCost": 0,
          "name": "Omnivore",
          "shortDescription": "When this unit deals damage to a Beast or Plant champion, it heals HP equal to half the damage dealt and gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "devour"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            },
            {
              "default": true,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": false,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        }
      ]
    },
    {
      "id": 423,
      "name": "Snow Prowler",
      "description": "The only trace she leaves behind is a deep red spot in the snow where the final kill took place.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 13,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 85,
      "hash": "dJ8JJ8IF0BF0Be9BJ8GJ8HJ8Ieeeeeiyrjitziwf",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 327,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at triple DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 20,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 2260,
          "apCost": 0,
          "name": "Pariah",
          "shortDescription": "This champion cannot be the target of friendly spells and abilities from other friendly units.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "possess"
        },
        {
          "id": 325,
          "apCost": 2,
          "name": "Stealth",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": true,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1019,
              "apCost": 0,
              "name": "Hidden: Arctic",
              "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            },
            {
              "default": false,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            },
            {
              "default": true,
              "id": 895,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            }
          ]
        }
      ]
    },
    {
      "id": 243,
      "name": "Snow Rhea",
      "description": "Kwark! - Snow Rhea mating call",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 70,
      "hash": "dj9AJ8Jf1Ae9BG2Aj9Bj9Cj9Duvkggnnjexmjleg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 3266,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "combat_awareness"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 517,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 3 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 3,
              "iconName": "leap"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 516,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 2 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 1,
              "iconName": "leap"
            }
          ]
        }
      ]
    },
    {
      "id": 1004,
      "name": "Snowcharger Cavalry",
      "description": "Snowcharger horns are usually removed when the bulls get to mating age. If they remain on the Charger they become as deadly as pikes, capable of impaling man or beast without hardly slowing the Charger.  ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 53,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 80,
      "hash": "ej9Gj9FG2BE8De9Ae9Aj9Cj9Dzzzonnwxkneklpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 1290,
          "apCost": 0,
          "name": "Warmonger",
          "shortDescription": "When a friendly real champion is destroyed, this champion gains -1 DEF and +1 DMG.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": true,
              "id": 1493,
              "apCost": 0,
              "name": "Pathfinding",
              "shortDescription": "All friendly champions that share a race with this one have <ability value=1306>Mountaineer</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "climb"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        }
      ]
    },
    {
      "id": 834,
      "name": "Snowman",
      "description": "\"We weren't entirely sure what it was, until it was nearly ten paces ahead of us. The thing was throwing snowballs at us. It had the laugh of an imp and the ugliest smile I've ever seen.\" - Corman Hightabard, IEF Scout",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 66,
      "hash": "dj9Bj9Af1BG2Be9Aj9Fj9Gj9Hgtzrshtmwipnyig",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 184,
          "apCost": 0,
          "name": "Death Nova: Frost",
          "shortDescription": "When this unit is destroyed, it deals 8 Frost damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "deathnovafrost"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 898,
          "apCost": 0,
          "name": "Ice Eater",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>. At the beginning of your turn, if this unit occupies Snow or Ice, it heals 2 HP. When this unit would take Frost damage, it instead heals HP equal to half the damage that would have been dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "eater_frost"
        },
        {
          "id": 1482,
          "apCost": 0,
          "name": "Snowball",
          "shortDescription": "This unit makes a Frost attack at range 2-4 for 8 DMG. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "ice"
        },
        {
          "id": 1259,
          "apCost": 0,
          "name": "Split",
          "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "duplicate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2796,
              "apCost": 0,
              "name": "Snowbreach",
              "shortDescription": "When this unit is damaged, spaces within 2 spaces becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 752,
              "apCost": 4,
              "name": "Tunnel: Snow",
              "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_snow"
            },
            {
              "default": false,
              "id": 831,
              "apCost": 0,
              "name": "Trail: Snow",
              "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Snow (Impeding 1) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "trail_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1236,
              "apCost": 0,
              "name": "Ice Veil",
              "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into ice terrain for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "terrainice"
            }
          ]
        }
      ]
    },
    {
      "id": 554,
      "name": "Solitary Garu",
      "description": "There is a journey one must make to find serenity. Allies would only be a hindrance. - Railo, Garu",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9Bf1BG2Bj9Cj9Dj9Eeevkuvzolwzkleg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 1076,
          "apCost": 3,
          "name": "Heal Self",
          "shortDescription": "This unit recovers 12 HP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "heal"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        },
        {
          "id": 1484,
          "apCost": 0,
          "name": "Solitary",
          "shortDescription": "This unit has +3 DMG, +2 DEF, and +5 MAX HP when there are no friendly champions within 6 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1866,
              "apCost": 0,
              "name": "Gift of Scrying",
              "shortDescription": "You have an additional rune reveal each of your turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "scry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 1869,
              "apCost": 1,
              "name": "Hibernate",
              "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "hibernate"
            },
            {
              "default": false,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1616,
      "name": "Solstice Marksman",
      "description": "The Solstice Marksmen's arrows are specially crafted to draw heat from its target as a source for its magical flames.  This process leaves a lingering cold in the victim.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 5,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 67,
      "hash": "ej9Ej9DG2BF0AG2Ag3Aj9Cj9Dqowkjgytuqsoytf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2816,
          "apCost": 0,
          "name": "Equip: Frostcall Quiver",
          "shortDescription": "This unit comes into play equipped with Frostcall Quiver.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 894,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 2 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 597,
      "name": "Sonic Elemental",
      "description": "The power of its shriek was awesome. Those who didn't cover their ears immediately were deafened or worse. I saw an archer fall to his knees, blood dribbling from his ears. - Thomroy, Priest of Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 72,
      "hash": "dj9Bj9Af1Bf1BE8Dj9Ej9Fj9Gemjwztxmhpnjegg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 244,
          "apCost": 0,
          "name": "Damage Shield: Sonic",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Sonic damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "dmgshld_sonic"
        },
        {
          "id": 1807,
          "apCost": 0,
          "name": "Deafening Aura",
          "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "deafening_aura"
        },
        {
          "id": 41,
          "apCost": 0,
          "name": "Immunity: Sonic",
          "shortDescription": "Sonic damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_sonic"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 149,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novasonic"
            },
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            }
          ]
        }
      ]
    },
    {
      "id": 419,
      "name": "Soul Collector",
      "description": "From the nora they are spawned and to nora they return, and in the end all shall be mine.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Lich",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 64,
      "hash": "dJ8IJ8HF0AF0BG2Bj9Cj9Dj9Eeeeipqufpnusmeg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1112,
          "apCost": 0,
          "name": "Soul Collection",
          "shortDescription": "When this champion moves within 5 spaces of a nora globe, or a nora globe drops from a champion within 5 spaces of this champion, this champion automatically recovers it.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "nora_eater"
        },
        {
          "id": 2594,
          "apCost": 0,
          "name": "Soul Vitality",
          "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 2232,
              "apCost": 0,
              "name": "Nora Thief",
              "shortDescription": "Spend 4 charges.  Your opponent loses up to 15 nora and you gain an equal amount.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "nora_thief"
            },
            {
              "default": false,
              "id": 1619,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "terrain_dmz"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2575,
              "apCost": 0,
              "name": "Defiling Aura",
              "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "defile_corpse"
            },
            {
              "default": false,
              "id": 2172,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 1754,
              "apCost": 0,
              "name": "Hidden: Dead Magic Zone",
              "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 240,
      "name": "Soul Siren",
      "description": "O the Siren sings you from your ship/She sings you from your home/And if you heed the Siren's call/She'll surely eat your soul - Old Sailor Song",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "dj9AJ8Jf1Ae9BF0BJ8IJ8Jj9Aemsfigyzruhgexf",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1976,
              "apCost": 3,
              "name": "Wail of Grief",
              "shortDescription": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2688,
              "apCost": 4,
              "name": "Screech",
              "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 2717,
              "apCost": 3,
              "name": "Gravity Well",
              "shortDescription": "Champions within 4 spaces are relocated 2 spaces closer to this one.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "gravitywell"
            },
            {
              "default": false,
              "id": 1248,
              "apCost": 3,
              "name": "Pull",
              "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "pull"
            }
          ]
        }
      ]
    },
    {
      "id": 704,
      "name": "Soulbleeder",
      "description": "Beyond them echoed the cries of lost souls, as they were devoured by the demon. The explorers would go no further.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 69,
      "hash": "dj9AJ8Jf1AG2AF0BJ8IJ8Jj9Aemephnyrjyirwzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1760,
          "apCost": 0,
          "name": "Impatient",
          "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "impatient"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1371,
          "apCost": 0,
          "name": "Soul Siphon",
          "shortDescription": "When a real champion is destroyed this unit gains 5 MAX HP (to a maximum of 100) and +1 DMG permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "soul_siphon"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3013,
              "apCost": 0,
              "name": "Soultap Feedback",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "soultap_feedback"
            },
            {
              "default": false,
              "id": 50,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 20% (after DEF, rounded up).",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_magic"
            },
            {
              "default": false,
              "id": 2035,
              "apCost": 0,
              "name": "Stat Bonus: Damage",
              "shortDescription": "This champion has +2 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plusdamage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 861,
              "apCost": 0,
              "name": "Tormented",
              "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            }
          ]
        }
      ]
    },
    {
      "id": 1231,
      "name": "Soulcrawler",
      "description": "\"Spiders are nothing new for the Underdepths, but the latest ones to emerge  seem to be have been touched by something with its own agenda. I fear that we might be responsible.\" ~ Menalus' Personal Journal",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Arthropod",
        "Demon"
      ],
      "noraCost": 73,
      "hash": "eJ8HJ8GE8De9Be9Ae9Bj9Ej9Feeplnegrquzkjn",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 607,
          "apCost": 0,
          "name": "Essence Capture",
          "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "noragen"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 2594,
          "apCost": 0,
          "name": "Soul Vitality",
          "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": true,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            },
            {
              "default": false,
              "id": 3100,
              "apCost": 0,
              "name": "Catalyst: Psychic",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_psychic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1778,
              "apCost": 0,
              "name": "Sabotage: Psychic",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 3067,
              "apCost": 0,
              "name": "Psychic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Psychic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "psychicaoe"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            }
          ]
        }
      ]
    },
    {
      "id": 1303,
      "name": "Soulthirster",
      "description": "An abomination amongst abominations, their seemingly insatiable hunger revolts even the most gluttonous of the Underdepths. Any band containing a Soulthirster or a Soulbleeder is \"blessed\" by the constant sound of feeding.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Mutant"
      ],
      "noraCost": 80,
      "hash": "ej9Fj9EF0AF0Ae9AE8DJ8HJ8Izrjygkpqsmsjpn",
      "artist": "Christian Fell",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 300,
          "apCost": 0,
          "name": "Horrific Aura",
          "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "fear"
        },
        {
          "id": 1371,
          "apCost": 0,
          "name": "Soul Siphon",
          "shortDescription": "When a real champion is destroyed this unit gains 5 MAX HP (to a maximum of 100) and +1 DMG permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "soul_siphon"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            },
            {
              "default": true,
              "id": 2708,
              "apCost": 1,
              "name": "Gluttony",
              "shortDescription": "This champion gains 1 AP and +1 DMG for 1 turn for every 25 HP on opposing champions within 3 spaces, rounded down.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "devour"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2434,
              "apCost": 0,
              "name": "Leech Vitality",
              "shortDescription": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "overkill"
            },
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 885,
      "name": "Spark Crone",
      "description": "\"We must thank the Voil for these lessons. These new magics will serve us well. I will remember their kindness when I sit on the throne of Ailur.\" - Kiergana, Crone",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 72,
      "hash": "dj9Gj9Fe9Ag3Ae9BJ8GJ8HJ8Iyoufphevzmytszg",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2244,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "jolt"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2248,
              "apCost": 0,
              "name": "Spark Curse",
              "shortDescription": "Units that become <condition value=shocked popup=false>Shocked</condition> also becomes <condition value=cursed>Cursed</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "spark_curse"
            },
            {
              "default": false,
              "id": 3153,
              "apCost": 0,
              "name": "Empowered: Range",
              "shortDescription": "This champion has +2 MIN RNG and +2 MAX RNG. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_range"
            },
            {
              "default": false,
              "id": 3296,
              "apCost": 0,
              "name": "Zeal: Damage",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            },
            {
              "default": false,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            }
          ]
        }
      ]
    },
    {
      "id": 1017,
      "name": "Spawnpool Guardian",
      "description": "\"They guard the tads with love and install them with the link between the swamp and our innate duty to protect it and all that dwell within it. Without them the boghoppers would perish. Guardians are the unspoken heroes of our kind.\" Gekkal, High One",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 65,
      "hash": "ej9Dj9CG2BE8De9AG2Bj9Cj9Dnnnyiwqoyowxtqf",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 2417,
          "apCost": 4,
          "name": "Summon: Boghopper Tad",
          "shortDescription": "Summon a Boghopper Tad with no upgrades to a target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "summon_tad"
        },
        {
          "id": 2472,
          "apCost": 4,
          "name": "Swamp Teachings",
          "shortDescription": "This unit loses 10 HP and target Boghopper Tad within 3 spaces is removed from play and a Boghopper Pupil with no upgrades is summoned in the same location the Boghopper Tad occupied. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "semiaquatic"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2919,
              "apCost": 0,
              "name": "Guarded: Boghopper",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Boghopper within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": true,
              "id": 877,
              "apCost": 0,
              "name": "Bodyguard",
              "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 1462,
              "apCost": 2,
              "name": "Hydrate",
              "shortDescription": "Friendly champions within 2 spaces gain 2 AP and the spaces they are standing in turn to Water for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "terrainwater"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1494,
      "name": "Speckled Fesh",
      "description": "\"We are proud to announce a great new product today.  The Speckled Fesh is the perfect pet for your cave or overhang. It is also a great side to any meal! Get your's TODAY at Stack's EYEPorium where what you see is what you will probably get!\"",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 30,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Worm"
      ],
      "noraCost": 59,
      "hash": "eJ8JJ8Ig3AF0Be9AF0Bj9Dj9Eeeeeeeigruzxoqf",
      "artist": "Paul Guzenko",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 812,
          "apCost": 0,
          "name": "Devourable",
          "shortDescription": "Adjacent champions may sacrifice this unit and heal equal to its current health.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "devour"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 1237,
          "apCost": 0,
          "name": "Impenetrable",
          "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ironwill"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 2556,
              "apCost": 0,
              "name": "Vitality: Nora",
              "shortDescription": "The first time each turn that nora is generated via spells, relics and abilities, this champion gains +2 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "noragen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": true,
              "id": 307,
              "apCost": 0,
              "name": "Nora Miner",
              "shortDescription": "At the beginning of your turn, you gain 3 nora.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "noragen"
            }
          ]
        }
      ]
    },
    {
      "id": 322,
      "name": "Spectral Emissary",
      "description": "Never make a deal with the dead.  - Gedden, Ironfist Paladin",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior",
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Spirit",
        "Undead"
      ],
      "noraCost": 75,
      "hash": "dJ8JJ8IF0BF0AG2Aj9Bj9Cj9Doqoqfmsjpymjgeg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 2250,
              "apCost": 3,
              "name": "Scythe Whirl",
              "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "scythe_wirlwind"
            },
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 2397,
              "apCost": 0,
              "name": "Pawn",
              "shortDescription": "The first time this champion would be damaged by an attack each round, the closest friendly champion takes damage instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "pawn"
            },
            {
              "default": false,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 1272,
      "name": "Spikewood Abomination",
      "description": "He looks very scary, but he's actually very shy.  So don't hurt him, okay? ~ Charme, Elven Child, Age 6",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Plant"
      ],
      "noraCost": 80,
      "hash": "ej9Cj9Be9Be9Be9AG2AJ8GJ8Hkussqwfeitftqo",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2675,
          "apCost": 0,
          "name": "Equip: Seed of Potential",
          "shortDescription": "When this champion is deployed, it is equipped with a Seed of Potential.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "comboatk_devastate"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        },
        {
          "id": 861,
          "apCost": 0,
          "name": "Tormented",
          "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2277,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 2 HP for each AP they have.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "punishing_aura"
            },
            {
              "default": false,
              "id": 1947,
              "apCost": 0,
              "name": "Entangling Attack",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 1088,
      "name": "Spirit of Endurance",
      "description": "Light preserves those that persevere.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Angel",
        "Spirit"
      ],
      "noraCost": 69,
      "hash": "ej9Ej9DF0AE8De9Ag3AJ8HJ8Iqoyxqshthytfxo",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1552,
          "apCost": 0,
          "name": "Enduring Aura",
          "shortDescription": "Damage to friendly champions within 3 spaces is reduced by 3. (this ability and its effects do not stack)",
          "activationType": 0,
          "level": 5,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "aurapositive"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2128,
          "apCost": 0,
          "name": "Merciful",
          "shortDescription": "If a champion would be destroyed by this champion, it's HP is set to 1 instead.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "merciful"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 1208,
              "apCost": 0,
              "name": "Debilitate",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Debilitated, it becomes <condition value=debilitated>Debilitated</condition> for 6 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 630,
              "apCost": 1,
              "name": "Grant: Flight",
              "shortDescription": "Target champion within 5 spaces gains <condition value=flying>Flying</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "flight"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        }
      ]
    },
    {
      "id": 936,
      "name": "Spirit of the Mountain",
      "description": "\"There are many spirits in K'thir. There are the wisps and the ancestors, the fae and the gnarlwood. And there are some who loom beyond the forest. They are our protectors, too.\" - Menalaus, Priest of K'thir",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God",
        "Shaman"
      ],
      "races": [
        "Beast",
        "Spirit"
      ],
      "noraCost": 80,
      "hash": "dj9Bj9Af1Bg3AE8Dj9Ej9Fj9Geeiyinnhpuofrhg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest",
        "Shattered Peaks"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 370,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 3 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "healmass"
        },
        {
          "id": 1572,
          "apCost": 4,
          "name": "Nature's Blessing",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 9 HP and gains 1 DEF for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 6,
          "noraCost": 10,
          "iconName": "cleanse"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 2294,
          "apCost": 0,
          "name": "Spirit Projection",
          "shortDescription": "When this champion is deployed and at the start of its turns, if there is no Manifestation of this unit in play, a <ability value=2304>Manifestation</ability> of this unit without upgrades is summoned within 3 spaces of this champion. This ability triggers only if the champion is a Garu Medium or Spirit of the Mountain.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "spirit_proj"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1916,
              "apCost": 0,
              "name": "Nora Link",
              "shortDescription": "Whenever a player's spell, relic, or ability generates nora, the other player gains an equal amount.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1065,
              "apCost": 0,
              "name": "Boost: Beast ",
              "shortDescription": "Friendly champions with Race: Beast have +5 MAX HP.  This does not stack  with other Boosts.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "boost"
            },
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        }
      ]
    },
    {
      "id": 295,
      "name": "Spirit Singer",
      "description": "Where am I? What happened? -- Do not worry brave warrior. The forest has willed you to live again. - Trella, Elven Spirit Singer",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Bard",
        "Priest"
      ],
      "races": [
        "Angel",
        "Elf"
      ],
      "noraCost": 76,
      "hash": "dj9Ej9Dg3Ae9Be9Aj9Fj9Gj9Hplwvzvkwqfevzig",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2851,
          "apCost": 1,
          "name": "Grant: Mobility",
          "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 1750,
          "apCost": 1,
          "name": "Grant: Tempo",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 841,
          "apCost": 3,
          "name": "Nora Shield",
          "shortDescription": "Target friendly champion within 3 spaces becomes <condition value=norashielded>Nora Shielded</condition> for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 8,
          "iconName": "nora_barrier"
        },
        {
          "id": 842,
          "apCost": 0,
          "name": "Resurrect",
          "shortDescription": "For 4 turns, the cooldown of the next champion you own that dies is set to 0.",
          "activationType": 1,
          "level": 1,
          "cooldown": 5,
          "noraCost": 2,
          "iconName": "revive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2760,
              "apCost": 0,
              "name": "Logistics: Force Barrier",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 2801,
              "apCost": 0,
              "name": "Logistics: Heal Champion",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=368>Heal Champion 3</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            }
          ]
        }
      ]
    },
    {
      "id": 338,
      "name": "Sporegill",
      "description": "It's a tradition for young elves to carry handfuls of sporegills as they play in the forest as protection.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Plant"
      ],
      "noraCost": 46,
      "hash": "dj9Bj9Af1BF0Ae9BJ8GJ8HJ8Ihevolpqqqolwtxf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 1190,
          "apCost": 0,
          "name": "Fleet",
          "shortDescription": "When this champion is deployed, it gains 5 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "initiative"
        },
        {
          "id": 40,
          "apCost": 0,
          "name": "Immunity: Poison",
          "shortDescription": "Poison damage that would be dealt to this unit is prevented. This unit may not become <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_poison"
        },
        {
          "id": 426,
          "apCost": 3,
          "name": "Poison Cloud",
          "shortDescription": "Area Effect 2, Range 2: Affected space become <mechanic value=poison_cloud>Poison Cloud</mechanic> for 2 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "poison_cloud"
        },
        {
          "id": 1003,
          "apCost": 0,
          "name": "Relic Drop: Spore",
          "shortDescription": "When this champion is deployed from the runedock, it spends the first 4 turns as a Mushroom relic with 1 DEF and 20 HP.  When this unit is destroyed, it becomes the same mushroom relic without this ability.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "spore"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 241,
              "apCost": 0,
              "name": "Damage Shield: Poison",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Poison damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_poison"
            },
            {
              "default": false,
              "id": 3328,
              "apCost": 0,
              "name": "Hunter: Poisoned",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 730,
              "apCost": 1,
              "name": "Poison Sting",
              "shortDescription": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "poison"
            },
            {
              "default": false,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 907,
              "apCost": 0,
              "name": "Amplify: Poison",
              "shortDescription": "Poison damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_poison"
            }
          ]
        }
      ]
    },
    {
      "id": 1543,
      "name": "Spring Dragon",
      "description": "The most benign of the ancient dragons, these creatures are often mistaken as great leafless trees.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Dragon",
        "Plant"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9DG2BF0Be9Ag3Aj9Cj9Depjlygrletqqlrf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 1084,
          "apCost": 0,
          "name": "Plant Regeneration",
          "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=116>Regeneration 2</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 1920,
              "apCost": 0,
              "name": "Revere: Thirion",
              "shortDescription": "While this champion is in play, Thirion costs 10% less nora to deploy. While Thirion is in play, this champion gains +2 RNG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 789,
              "apCost": 3,
              "name": "Healing Breath",
              "shortDescription": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 18 HP divided by the number of targets (rounded down to a max of 8 HP per target).",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 82,
      "name": "Sprite",
      "description": "They give the sun its glow and the trees their charm. - Godwin, Elder Garu",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 67,
      "hash": "bj9Dj9Cj9BG2Aj9Bj9Cj9Dj9Eerqwvzgplyrjwin",
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2760,
          "apCost": 0,
          "name": "Logistics: Force Barrier",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=400>Force Barrier 3</ability> permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 2540,
          "apCost": 0,
          "name": "Trickster",
          "shortDescription": "When this unit activates an ability that is not a basic attack, it becomes <condition value=stealthed>Stealthed</condition> for 6 turns and gains <ability value=1790>Shadow Shift</ability> for 1 turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "nemesis_x"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": true,
              "id": 1323,
              "apCost": 2,
              "name": "Contaminate",
              "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "dot_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            },
            {
              "default": true,
              "id": 2426,
              "apCost": 3,
              "name": "Fairy Dust",
              "shortDescription": "Target champion within 4 spaces gains <ability value=2266>Wandering</ability> for 2 Turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fairydust"
            }
          ]
        }
      ]
    },
    {
      "id": 464,
      "name": "Stalwart Defender",
      "description": "By the gates of Ironfist, we will not lose this font! - Toldim Broadshield, Defender of Ironfist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 64,
      "hash": "dJ8HJ8Ge9Bf1AG2Aj9Bj9Cj9Dnnextfrsftzgtzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1221,
          "apCost": 0,
          "name": "Font Blessing",
          "shortDescription": "While this champion is within 5 spaces of a font deployment zone you control, it gets +1 DEF, +5 DMG, and +10 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "buff"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 969,
              "apCost": 0,
              "name": "Shrine Defender",
              "shortDescription": "While this unit is within your 8 spaces of its shrine, this unit gets +2 DMG and +2 SPD and your Shrine has +8 HP. When your Shrine is Transfigured, this unit has <ability value=1759>Impassioned</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "tgtdefensive"
            },
            {
              "default": false,
              "id": 1932,
              "apCost": 0,
              "name": "Loyalty",
              "shortDescription": "This champion gains +2 DMG and +5 HP as long as all friendly units that you own share a faction with it.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "loyalty"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1703,
              "apCost": 0,
              "name": "Aid Defense",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, friendly champions with the same race as this one have +1 DEF for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 872,
              "apCost": 1,
              "name": "Hammer Throw",
              "shortDescription": "Make a magical attack with a range of 3-6, at +4 DMG against target enemy unit.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "hammer"
            },
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1273,
      "name": "Starlight Sylph",
      "description": "Starlight Sylphs represent the ultimate manifestation of co-operation among the Fae in their desire to defend the forest.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 71,
      "hash": "ej9Cj9BF0Ae9Be9AG2AJ8HJ8Iinphrfmsosxouo",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1214,
          "apCost": 0,
          "name": "Encouraged",
          "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 2672,
          "apCost": 1,
          "name": "Starlight",
          "shortDescription": "This champion makes a Magical attack at RNG 2-5.  If the target is successfully damaged, it also takes an additional 2 damage for each champion with Race: Fairy or <ability value=544>Attack: Magical</ability> within 5 spaces of this champion (the additional damage ignores DEF).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "magic"
        },
        {
          "id": 1316,
          "apCost": 0,
          "name": "Vulnerable",
          "shortDescription": "When this unit makes an attack, it gets -1 DEF for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "vuln_physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3211,
              "apCost": 0,
              "name": "Portent",
              "shortDescription": "This unit gains a Buffer of 10 HP. Every other round at the start of this units turns, its Buffer is reset to 10 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "portent"
            },
            {
              "default": true,
              "id": 1881,
              "apCost": 4,
              "name": "Telekinetic Thrust",
              "shortDescription": "Target opposing champion within 4 spaces takes 6 physical damage and is knocked back 3 spaces (this damage ignores DEF).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2345,
              "apCost": 0,
              "name": "Starshine",
              "shortDescription": "The closest friendly champion that moves within 5 spaces gains a rank of <ability value=608>Majestic</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            }
          ]
        }
      ]
    },
    {
      "id": 234,
      "name": "Steelspine Bearcat",
      "description": "By the grace of the Holy! What sort of foul abomination is that? - Orrum, Dwarven Priest",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 65,
      "hash": "dJ8JJ8IF0Be9BG2Aj9Bj9Cj9Dygygrleitosmyzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2352,
          "apCost": 0,
          "name": "Defensive Turtle",
          "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "turtle"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1603,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 3 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            },
            {
              "default": true,
              "id": 173,
              "apCost": 0,
              "name": "Death Nova: Physical",
              "shortDescription": "When this unit is destroyed, it deals 11 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "deathnovaphysical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 751,
              "apCost": 3,
              "name": "Spike Nova",
              "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novaspike"
            }
          ]
        }
      ]
    },
    {
      "id": 1682,
      "name": "Stillwater Mutant",
      "description": "The Firk had thought themselves immune to the plague which had previously ravaged Forglar, assuming that their mental abilities had protected their bodies. In truth, they had only delayed its effects.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Firk",
        "Mutant"
      ],
      "noraCost": 74,
      "hash": "ej9Dj9CF0AF0BG2AG2BJ8HJ8Ieigkpwouqzrwtqf",
      "artist": "Alex Brock",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3100,
          "apCost": 0,
          "name": "Catalyst: Psychic",
          "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "catalyst_psychic"
        },
        {
          "id": 3118,
          "apCost": 0,
          "name": "Psychic Agony",
          "shortDescription": "The first time this champion falls below 50% HP, enemy champions take 5 Psychic damage. If the champion is <condition value=soultapped>Soultapped</condition>, it becomes <condition value=ensnared>Ensnared</condition> and <condition value=confused>Confused</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "psychic_agony"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 1778,
              "apCost": 0,
              "name": "Sabotage: Psychic",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 209,
              "apCost": 0,
              "name": "Death Nova: Psychic",
              "shortDescription": "When this unit is destroyed, it deals 11 Psychic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovapsychic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": true,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 3012,
              "apCost": 0,
              "name": "Vigor: Psychic",
              "shortDescription": "The first time each turn a champion within 3 spaces takes Psychic damage from a source other than this champion, this champion gains 2 AP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "vigor_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 949,
      "name": "Stitched Anathema",
      "description": "\"It seems the forces that bind the Anathema are different. Instead of pulling objects together, this Stitched repulses materials away. I see no reason how it keeps a shape.\" - Tachrim",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 75,
      "hash": "dj9Cj9BG2Ag3Ae9Aj9Fj9Gj9Hilwoufruziwfrjg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2103,
          "apCost": 0,
          "name": "Deconstruct",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "merge"
        },
        {
          "id": 2105,
          "apCost": 3,
          "name": "Reconstruct: Magician",
          "shortDescription": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Magician is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "reconstruct"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2344,
              "apCost": 0,
              "name": "Paralytic Strike",
              "shortDescription": "This champion does double damage to <condition value=paralyzed>Paralyzed</condition> champions.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "jolt"
            },
            {
              "default": true,
              "id": 1452,
              "apCost": 3,
              "name": "Dispel",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=dispelled>Dispelled</mechanic>. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "dispel"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2129,
              "apCost": 1,
              "name": "Grant: Electricity Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=141>Electricity Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 2361,
              "apCost": 0,
              "name": "Repulsion",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly away from this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "repulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 817,
      "name": "Stitched Blackguard",
      "description": "\"There were hundreds of them. Soldiers, made from corpse and steel, the remnants of our dead. How could we face their Blackguard? I was staring into the faces of my kin!\" - Ferahni, Leoss Guardian",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 67,
      "hash": "dJ8JJ8IF0BG2BF0BJ8IJ8Jj9Akukuxosowoqqszg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 775,
          "apCost": 0,
          "name": "Chill",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_chill"
        },
        {
          "id": 2108,
          "apCost": 3,
          "name": "Meld: Stitched Merged",
          "shortDescription": "The Stitched Hexer, Blackguard and Dreameater combine into a Stitched Merged with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "meld"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 3072,
              "apCost": 3,
              "name": "Elusive Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "dashing_dodge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 524,
              "apCost": 1,
              "name": "Hinder Movement",
              "shortDescription": "This unit makes an attack at RNG 2-5. If successful, the target becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pindown"
            },
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 947,
      "name": "Stitched Concealer",
      "description": "D'alno peered out into the campground. A thick, black fog had settled outside. He listened for his comrades, for their whispered voices. All D'alno heard was a strange chittering, like the sound of muffled laughter.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 69,
      "hash": "dj9Bj9Af1Bg3Ag3Aj9Dj9Ej9Fwqonpwqoyvhpjlg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1867,
          "apCost": 1,
          "name": "Mark",
          "shortDescription": "This ability does not destealth, and is only usable while stealthed.  Target champion within 3 spaces suffers 2 additional damage from all attacks made by friendly units this turn.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "declare_hunted"
        },
        {
          "id": 1790,
          "apCost": 4,
          "name": "Shadow Shift",
          "shortDescription": "This unit is relocated to target space within 5 spaces, and loses <condition value=rooted>Rooted</condition>.  This ability does not break stealth and is only usable while <condition value=stealthed>Stealthed</condition>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "shadow_shift"
        },
        {
          "id": 1354,
          "apCost": 0,
          "name": "Sneak",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> at the end of your turn if you have runes in your rune dock that are still concealed and there are no enemy champions within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "stealth"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2143,
              "apCost": 0,
              "name": "Occlude",
              "shortDescription": "This unit loses 3 HP and 3 random runes in your runedock are concealed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 1352,
              "apCost": 0,
              "name": "Conceal",
              "shortDescription": "Each player has 2 runes concealed.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 2,
              "iconName": "shroud"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1795,
              "apCost": 0,
              "name": "Surge: Shadows",
              "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_shadow"
            },
            {
              "default": true,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            }
          ]
        }
      ]
    },
    {
      "id": 815,
      "name": "Stitched Dreameater",
      "description": "\"No one dares to sleep. I've only seen it in my dreams, but some say it lurks in the jungles beyond our camp. The captain says we're just being cubs, but I think there is a Dreameater!\" - Hashon, Leoss Guardian",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 70,
      "hash": "dJ8JJ8IF0BG2Be9BJ8GJ8HJ8Iygygpfvvxmlyvxf",
      "artist": "Cristian Giraldes",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2102,
          "apCost": 0,
          "name": "Dreameater",
          "shortDescription": "At the beginning of each turn, if this champion is <condition value=stealthed>Stealthed</condition>, opposing champions within 5 spaces take 4 Psychic damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "dreameater"
        },
        {
          "id": 2108,
          "apCost": 3,
          "name": "Meld: Stitched Merged",
          "shortDescription": "The Stitched Hexer, Blackguard and Dreameater combine into a Stitched Merged with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "meld"
        },
        {
          "id": 3062,
          "apCost": 3,
          "name": "Shatter Summoned",
          "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "shattered_dreams"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 325,
              "apCost": 2,
              "name": "Stealth",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 2357,
              "apCost": 0,
              "name": "Shadowstrike",
              "shortDescription": "This champion becomes stealthed after making a basic attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            }
          ]
        }
      ]
    },
    {
      "id": 813,
      "name": "Stitched First",
      "description": "\"We believe these are the first of the Stitched. They are made from older materials, some dating to pre-Separation times. Some carry human heads on their shoulders, which resemble the original Elsari.\" - Tachrim, Apprentice to Xulos",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 83,
      "hash": "dJ8JJ8IF0BG2BE8Dj9Ej9Fj9Geeeeevofepsuqfg",
      "artist": "Eric Belisle",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3410,
          "apCost": 0,
          "name": "Master Reconstructor",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>, <ability value=2104>Reconstruct: Blackguard</ability>, <ability value=2106>Reconstruct: Dreameater</ability> and <ability value=2105>Reconstruct: Magician</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stitched"
        },
        {
          "id": 2107,
          "apCost": 0,
          "name": "Reconstitute",
          "shortDescription": "At the beginning of your turns, this champion is healed to full HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "heal"
        },
        {
          "id": 1390,
          "apCost": 2,
          "name": "Relocate: Relic",
          "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "relocate_relic"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2315,
              "apCost": 0,
              "name": "Oblivion Shield",
              "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 3100,
              "apCost": 0,
              "name": "Catalyst: Psychic",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_psychic"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            }
          ]
        }
      ]
    },
    {
      "id": 831,
      "name": "Stitched First",
      "description": "\"We believe these are the first of the Stitched. They are made from older materials, some dating to pre-Separation times. Some carry human heads on their shoulders, which resemble the original Elsari.\" - Tachrim, Apprentice to Xulos",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 83,
      "hash": "dj9AJ8Jf1AG2BG2Bj9Cj9Dj9Eeeerqssjnhigeig",
      "artist": "Eric Belisle",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3410,
          "apCost": 0,
          "name": "Master Reconstructor",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>, <ability value=2104>Reconstruct: Blackguard</ability>, <ability value=2106>Reconstruct: Dreameater</ability> and <ability value=2105>Reconstruct: Magician</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "stitched"
        },
        {
          "id": 2107,
          "apCost": 0,
          "name": "Reconstitute",
          "shortDescription": "At the beginning of your turns, this champion is healed to full HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "heal"
        },
        {
          "id": 1390,
          "apCost": 2,
          "name": "Relocate: Relic",
          "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "relocate_relic"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2315,
              "apCost": 0,
              "name": "Oblivion Shield",
              "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 3100,
              "apCost": 0,
              "name": "Catalyst: Psychic",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Psychic damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_psychic"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            }
          ]
        }
      ]
    },
    {
      "id": 812,
      "name": "Stitched Hexer",
      "description": "To perform a hex, one must invoke the magic needed through a verbal ritual. However, some Stitched invoke the same power through their astral language. How they do this, invoking hexes through projecting symbols, is a mystery.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0AG2Bg3Aj9Dj9Ej9Fyoyrjtukpfvhrhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 1399,
          "apCost": 1,
          "name": "Hex",
          "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "lossoflife"
        },
        {
          "id": 2108,
          "apCost": 3,
          "name": "Meld: Stitched Merged",
          "shortDescription": "The Stitched Hexer, Blackguard and Dreameater combine into a Stitched Merged with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "meld"
        },
        {
          "id": 2104,
          "apCost": 3,
          "name": "Reconstruct: Blackguard",
          "shortDescription": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Blackguard is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "reconstruct"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1739,
              "apCost": 0,
              "name": "Paralytic Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack from RNG 4 or greater, the attacking champion becomes <condition value=paralyzed>Paralyzed</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "conduit"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            }
          ]
        }
      ]
    },
    {
      "id": 865,
      "name": "Stitched Librarian",
      "description": "\"The pile of books started floating in the air and glaring at us. Then, it struck poor Stonebrow with a gust. It nearly carried him away! We had to retreat from a pile of books!\" - Orrin Bronzebelly, of the IMEF",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 70,
      "hash": "dj9Ej9Dg3AG2Be9BJ8GJ8HJ8Igyoqlymwtmjyrfg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2191,
          "apCost": 0,
          "name": "Nora Hex",
          "shortDescription": "Shrine nora generation for opposing players is reduced by 1 for every 3 charges on this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "nora_hex"
        },
        {
          "id": 2177,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 3 charges.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "charged_spell"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 820,
              "apCost": 4,
              "name": "Portal",
              "shortDescription": "This unit may teleport to any deployment zone its controller controls.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 819,
      "name": "Stitched Magearm",
      "description": "\"I thought it impossible. To wield a mage's staff takes practice, yet the merged ones had conjured the power of ten, at once. The blast obliterated a large stone. I could feel the raw power in my bones. Magnificent!\" - Tachrim, apprentice to Xulos",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 47,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 74,
      "hash": "dJ8JJ8IF0BG2Bf1Bj9Aj9Bj9Ceeeeeigpsjtuqfg",
      "artist": "Eric Belisle",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2103,
          "apCost": 0,
          "name": "Deconstruct",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "merge"
        },
        {
          "id": 2579,
          "apCost": 4,
          "name": "Magic Beam",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "magicaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            },
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 816,
      "name": "Stitched Magician",
      "description": "The Stitched feed off of magical power; they crave it more than anything else. Oftentimes, a Stitched will collect trinkets imbued with magic and sew them into its skin.",
      "maxRng": 7,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 66,
      "hash": "dJ8JJ8IF0BG2BF0AJ8HJ8IJ8Jeeeepjwvmhthiyg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2109,
          "apCost": 3,
          "name": "Meld: Stitched Magearm",
          "shortDescription": "The Stitched Mesmer, Magician and Shaman combine into a Stitched Magearm with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "meld"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 925,
      "name": "Stitched Mangler",
      "description": "\"We're all callin' it the Mangler. Just about ripped the whole landin' party to pieces. It has an arm for every kind of murder. And here we were hopin' the Stitched was out of ideas.\" - Algus Shovelsnout, Infantrytort on the Gygurnaut",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 66,
      "hash": "dJ8JJ8IF0Bg3Ag3Aj9Dj9Ej9Fygygyowfgkjwkjg",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2198,
          "apCost": 3,
          "name": "Decapitating Blow",
          "shortDescription": "Target adjacent champion with less than 25% max HP is destroyed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 12,
          "iconName": "decapitate"
        },
        {
          "id": 1874,
          "apCost": 1,
          "name": "Shred Defense",
          "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "defpenalties"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            },
            {
              "default": false,
              "id": 219,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 2 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "dmgshld_physical"
            },
            {
              "default": false,
              "id": 220,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 4 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "dmgshld_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 818,
      "name": "Stitched Merged",
      "description": "\"I watched, captivated, as the three Stitched merged to form a behemoth. It was a new entity, physically large and brutish. The genius of these creations! They are truly perfect machines!\" - Tachrim, apprentice to Xulos",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 14,
      "hitPoints": 72,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 84,
      "hash": "dJ8JJ8IF0BG2Bf1AJ8Jj9Aj9Bqoqofgphpuxfgeg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1317,
          "apCost": 0,
          "name": "Absorb",
          "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "eater_arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2737,
          "apCost": 0,
          "name": "Physical Amped",
          "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Physical Aura 3.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amped_physical"
        },
        {
          "id": 2362,
          "apCost": 2,
          "name": "Reclaim Remains",
          "shortDescription": "Target adjacent Stitched Remains is destroyed.  This champion gains 12 charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "reconstruct"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 1273,
              "apCost": 0,
              "name": "Untamed",
              "shortDescription": "This champion may not become <condition value=pacified>Pacified</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        }
      ]
    },
    {
      "id": 814,
      "name": "Stitched Mesmer",
      "description": "\"When I first saw the abomination, I was revolted. But, I soon found myself drawn to its beautiful shapes. I was prepared to follow it into the jungle, when two Rangers restrained me.\" - K'asara, Elven Mage",
      "maxRng": 2,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 69,
      "hash": "dJ8JJ8IF0BG2Be9Aj9Fj9Gj9Hqoqofexzxkgtfgg",
      "artist": "Simon Dominic",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2103,
          "apCost": 0,
          "name": "Deconstruct",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "merge"
        },
        {
          "id": 1336,
          "apCost": 0,
          "name": "Fascinate",
          "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "illuminate"
        },
        {
          "id": 2343,
          "apCost": 3,
          "name": "Paralyze",
          "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "sentry"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 425,
              "apCost": 4,
              "name": "Possession",
              "shortDescription": "Target enemy champion within 2 spaces is <condition value=possessed>Possessed</condition> by you for 3 turns, gains 2 AP and gains <ability value=1408>Chasm Walker</ability> for 4 turns. This unit gains <ability value=2474>Font Ignorance</ability> for 3 turns and becomes <condition value=paralyzed>Paralyzed</condition> while this effect is active.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "possess"
            },
            {
              "default": false,
              "id": 594,
              "apCost": 0,
              "name": "Energy Thief",
              "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": false,
              "id": 3367,
              "apCost": 0,
              "name": "Punishing Aura",
              "shortDescription": "At the end of this unit's turn, opposing champions within 5 spaces lose 1 HP for each AP they have.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "punishing_aura"
            },
            {
              "default": true,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            }
          ]
        }
      ]
    },
    {
      "id": 922,
      "name": "Stitched Mirrorskin",
      "description": "The Jangar paused, believing his spell had obliterated the stitched. Instead, he saw his fireball was returning. The Mirrorskin was unfazed.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 6,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 68,
      "hash": "dJ8JJ8IF0Bg3Af1Bj9Aj9Bj9Ceeeeeevfmpsqufg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2209,
          "apCost": 0,
          "name": "Mirrored",
          "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "mirrored"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 1366,
              "apCost": 0,
              "name": "Deflect: Poison",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Poison damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_poison"
            },
            {
              "default": false,
              "id": 1367,
              "apCost": 0,
              "name": "Deflect: Fire",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Fire damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2214,
              "apCost": 0,
              "name": "Hunter: Scout",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_archer"
            },
            {
              "default": false,
              "id": 2216,
              "apCost": 0,
              "name": "Hunter: Mage",
              "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "wizard_foe"
            },
            {
              "default": true,
              "id": 2933,
              "apCost": 0,
              "name": "Hunter: Cleric",
              "shortDescription": "When this unit would deal damage to a champion with Class: Priest or Shaman with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Priest or Shaman, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "foe_ranger"
            }
          ]
        }
      ]
    },
    {
      "id": 946,
      "name": "Stitched Monolith",
      "description": "\"We are the ancestors, we serve the faded ones. We are Elsarin, Ailur, Thir, Valdac, all nations. We are Stitched.\" - Stitched Monolith, roughly translated from Old Elsari",
      "maxRng": 5,
      "minRng": 2,
      "defense": 3,
      "speed": 6,
      "damage": 0,
      "hitPoints": 75,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 75,
      "hash": "dj9Bj9Af1Bg3AG2Bj9Cj9Dj9Eeeeitjwqqlpwtjg",
      "artist": "Alex Fang",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 2271,
          "apCost": 0,
          "name": "Sentinel",
          "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 690,
              "apCost": 0,
              "name": "Guard Tower",
              "shortDescription": "At the start of your turns, enemy champions within 4 spaces take 2 Physical damage and are knocked back 1 space (does not affect Stealthed champions).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaphysical"
            },
            {
              "default": false,
              "id": 1933,
              "apCost": 0,
              "name": "Coordination",
              "shortDescription": "All friendly champions within 2 spaces of this unit gain <ability value=1214>Encouraged</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 3165,
              "apCost": 0,
              "name": "Mason's Spire",
              "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            }
          ]
        }
      ]
    },
    {
      "id": 948,
      "name": "Stitched Seamstress",
      "description": "\"These Stitched are frail. They last no more than a few days before they fall apart. The mortals have priests to tend to their wounded. Make me a priest for my army.\" - Matriarch Kiergana",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 66,
      "hash": "dj9Cj9BG2Ag3AE8Dj9Ej9Fj9Geemeggyiitoneig",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 2362,
          "apCost": 2,
          "name": "Reclaim Remains",
          "shortDescription": "Target adjacent Stitched Remains is destroyed.  This champion gains 12 charges.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 2,
          "iconName": "reconstruct"
        },
        {
          "id": 2311,
          "apCost": 3,
          "name": "Reconstruct: Mangler",
          "shortDescription": " Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Mangler is spawned in the location the relic occupied. This ability shares a CD with other Reconstruct abilities.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "reconstruct"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 2174,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 2172,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_death"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2696,
              "apCost": 0,
              "name": "Charged Fire Bomb",
              "shortDescription": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            },
            {
              "default": true,
              "id": 2228,
              "apCost": 0,
              "name": "Charged Frost Cone",
              "shortDescription": "Spend 6 Charges.  Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> 2. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2243,
              "apCost": 0,
              "name": "Charged Disease Breath",
              "shortDescription": "Spend 6 Charges. Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. \r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "diseaseaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 820,
      "name": "Stitched Shaman",
      "description": "\"I am not insane; the others can speak in my defense! It was drinking the spirits from the air! And it's thirst was never-ending. Do you see? These are the nightmares that await us in Maljara.\" - Tasro Osmei of the Ironfist Inquisition",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 72,
      "hash": "dJ8JJ8IF0BG2BG2Aj9Bj9Cj9Diwiwkrsqqlgrfgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2103,
          "apCost": 0,
          "name": "Deconstruct",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "merge"
        },
        {
          "id": 2109,
          "apCost": 3,
          "name": "Meld: Stitched Magearm",
          "shortDescription": "The Stitched Mesmer, Magician and Shaman combine into a Stitched Magearm with full HP. To use this ability, you must have each of those units together in a formation that makes up the base of a large unit, with one empty space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 0,
          "iconName": "meld"
        },
        {
          "id": 2106,
          "apCost": 3,
          "name": "Reconstruct: Dreameater",
          "shortDescription": "Target Stitched Remains relic within 3 spaces is destroyed and a Stitched Dreameater is spawned in the location the relic occupied.  This ability shares a CD with other Reconstruct abilities.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "reconstruct"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 725,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 1349,
              "apCost": 2,
              "name": "Relieve",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and all effects removed are applied to this unit.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "cleanse"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1579,
      "name": "Stitched Skeleform",
      "description": "While at a glance, this creature resembles a common zombie or skeleton, upon closer inspection one realizes that it is made up of rotting parts and skeletal pieces of numerous creatures.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Skeleton",
        "Stitched",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "ej9Dj9Ce9Ae9BG2AG2Bj9Fj9Gllevmwvmlpsfgrf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2837,
              "apCost": 0,
              "name": "Psychotic Break",
              "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "psychotic_break"
            },
            {
              "default": false,
              "id": 16,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 2, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1277,
              "apCost": 0,
              "name": "Vindictive",
              "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 3076,
              "apCost": 1,
              "name": "Sustain: Berserker",
              "shortDescription": "Target champion within 7 spaces gains <ability value=24>Berserker 2</ability> until this ability is used again.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1640,
      "name": "Stitched Suppressor",
      "description": "Leoss raids on Stitched territory not only never failed, they never happened.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 55,
      "hash": "eJ8HJ8Gg3AF0BG2Ae9Bj9Dj9Eeeerqsheeklrsqf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 3165,
          "apCost": 0,
          "name": "Mason's Spire",
          "shortDescription": "Friendly relics within 5 spaces have +10 MAX HP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "defenseenhance"
        },
        {
          "id": 3318,
          "apCost": 0,
          "name": "Rally",
          "shortDescription": "Champions (including this one) that come into play under your control within 3 spaces of this unit gain <condition value=impervious>Impervious</condition> for 2 turns.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "allybuffs"
        },
        {
          "id": 1390,
          "apCost": 2,
          "name": "Relocate: Relic",
          "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "relocate_relic"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1931,
              "apCost": 0,
              "name": "Enveloping Mist",
              "shortDescription": "Opposing units within 5 spaces of this unit have their range reduced down to their minimum range for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "poison_cloud"
            },
            {
              "default": false,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 3134,
              "apCost": 2,
              "name": "Suppression",
              "shortDescription": "Target enemy champion within 5 spaces has <ability value=3064>Weighty</ability> and <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1353,
      "name": "Stitched Tyrant",
      "description": "The Stitched had not been seen outside of the ferns of Maljara after the death of the  Matriarch.  Most assumed the leaderless Stitched were no longer a threat.  They were wrong.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 12,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 81,
      "hash": "ej9AJ8JF0AF0Ae9Af1AJ8HJ8Izrfvvsjiegtzon",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        },
        {
          "id": 2788,
          "apCost": 1,
          "name": "Stitched Reconstitution",
          "shortDescription": "Destroy target Stitched Remains within 3 spaces. This champion gains 3 AP, is healed for 8 HP and gains a Stitchling Rider (to a maximum of 4).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "reconstitute"
        },
        {
          "id": 2787,
          "apCost": 0,
          "name": "Stitched Symbiosis",
          "shortDescription": "This champion comes into play with 2 Stitchling Riders.  At the beginning of your turn, this unit heals 3 HP as long as it has at least 1 Stitched Rider on it.  When this champion is successfully attacked by a basic attack, it loses a stack of Stitchling Riders and a Symbiotic Stitchling with no upgrades is summoned adjacent to the attacking champion.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": true,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2427,
              "apCost": 0,
              "name": "Break the Line",
              "shortDescription": "When this champion charges, all opposing champions within 3 spaces of his end position are knocked back 3 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        }
      ]
    },
    {
      "id": 921,
      "name": "Stitched Warlock",
      "description": "\"The Warlock is much like the Shaman, drawing on latent energies to power its magicks. However, where the Shaman draws on spiritual powers, the Warlock draws on life. Brilliant!\" - Tachrim, Apprentice to Xulos",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0Bg3Af1AJ8Jj9Aj9Biwiwiwkrwfevkeg",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2300,
          "apCost": 0,
          "name": "Charged Blast",
          "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2103,
          "apCost": 0,
          "name": "Deconstruct",
          "shortDescription": "This champion has <ability value=2101>Stitched</ability>. When this unit destroys an opposing champion, that unit does not drop a nora globe and a Stitched Remains relic is spawned in the location that champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "merge"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            }
          ]
        }
      ]
    },
    {
      "id": 918,
      "name": "Stitchling",
      "description": "Stitchlings are thrown together and animated with very little magic. Their purpose is to annoy and distract the opposition.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 8,
      "hitPoints": 30,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Stitched"
      ],
      "noraCost": 42,
      "hash": "dJ8JJ8IF0Bg3Ae9BJ8GJ8HJ8Ismsmsukwknjnyxf",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        },
        {
          "id": 2101,
          "apCost": 0,
          "name": "Stitched",
          "shortDescription": "When this champion is destroyed, a Stitched Remains relic is summoned to the closest available space.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "stitched"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 663,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 3 turns.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": true,
              "id": 2824,
              "apCost": 0,
              "name": "Incoherent Babbling",
              "shortDescription": "Champions within 3 spaces are <condition value=distracted>Distracted</condition>. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "rover_babbling"
            },
            {
              "default": false,
              "id": 945,
              "apCost": 0,
              "name": "Mudsling",
              "shortDescription": "Target unit within 5 spaces takes 50% DMG and gains <ability value=5>Lumbering</ability> and cannot <ability value=516>Leap</ability>, <ability value=2324>Pounce</ability> or <ability value=406>Teleport</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "disable"
            }
          ]
        }
      ]
    },
    {
      "id": 103,
      "name": "Stone Colossus",
      "description": "Bigger is not always better. Biggest, however... that's a different story...",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9Be9AF0AJ8HJ8IJ8Jeeilepssjykgpuf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2704,
          "apCost": 0,
          "name": "Crushing Blow",
          "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "shrink"
        },
        {
          "id": 376,
          "apCost": 0,
          "name": "Exertion",
          "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "crazed_charger"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": true,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": false,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 212,
      "name": "Stone Dragon",
      "description": "The ancient texts speak of creatures such as these-but they were believed to have died off years ago, during the Separation.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 0,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct",
        "Dragon"
      ],
      "noraCost": 74,
      "hash": "dJ8HJ8Ge9Be9Be9BJ8GJ8HJ8Ieexxmjllrlpfkuf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        },
        {
          "id": 2334,
          "apCost": 2,
          "name": "Petrifying Gaze",
          "shortDescription": "This champion makes an Psychic attack against target opposing champion at Range 1-3. If damaged, the target becomes <condition value=petrified>Petrified</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "petrifying_gaze"
        },
        {
          "id": 2235,
          "apCost": 0,
          "name": "Strength of Body",
          "shortDescription": "This champion's has +DMG equal to its HP divided by 5 (rounded down).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "buff"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 35,
              "apCost": 0,
              "name": "Immunity: Physical",
              "shortDescription": "Physical damage that would be dealt to this unit is prevented. This unit may not be <condition value=eviscerated popup=false>Eviscerated</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "immunity_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 2562,
              "apCost": 4,
              "name": "Rock Slide",
              "shortDescription": "Area Effect 2, Range 5: Champions without <ability value=2527>Rock Defiance</ability> in the affected area take 12 Physical damage and become <condition value=grounded>Grounded</condition> for 3 turns. This damage ignores DEF. Affected spaces become Rock for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 726,
      "name": "Stoneskin Dwarf",
      "description": "You'll need a lot more than good steel to get through this hide. You'll need Nora or a prayer. - Illamor Stoneskin",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute",
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 70,
      "hash": "dj9Bj9Af1BG2Ae9Aj9Fj9Gj9Hwvmsquzkjtjnuhg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1341,
          "apCost": 0,
          "name": "Drunkard",
          "shortDescription": "When this unit comes into play, it becomes <condition value=intoxicated>Intoxicated</condition> for 6 turns. While this unit is <condition value=intoxicated popup=false>Intoxicated</condition>, it has +1 DEF, <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "intoxicate"
        },
        {
          "id": 260,
          "apCost": 0,
          "name": "Enrage",
          "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 868,
              "apCost": 0,
              "name": "Rock Eater",
              "shortDescription": "When this unit takes Physical damage, it instead recovers HP equal to half the damage that would have been dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_rock"
            },
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2704,
              "apCost": 0,
              "name": "Crushing Blow",
              "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 1831,
      "name": "Stormbunny",
      "description": "The Shattered Peaks are not conducive to survival, but being conductive certainly helps.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Elemental"
      ],
      "noraCost": 68,
      "hash": "eJ8IJ8HF0BG2BG2AF0AJ8IJ8Jeitzvfxvmuxtjpf",
      "artist": "Danh Nguyen",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 3006,
          "apCost": 0,
          "name": "Nora Induction",
          "shortDescription": "Whenever this champion makes a successful attack against a champion, the target's controller gains 2 nora.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "ichor_utility"
        },
        {
          "id": 3128,
          "apCost": 0,
          "name": "Portal Dancer",
          "shortDescription": "When this champion is successfully relocated, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 3296,
          "apCost": 0,
          "name": "Zeal: Damage",
          "shortDescription": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "channel_damage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2177,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 3 charges.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_spell"
            },
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2245,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "jolt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2401,
              "apCost": 4,
              "name": "Lightning Skewer",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "electricaoe"
            },
            {
              "default": true,
              "id": 1388,
              "apCost": 0,
              "name": "Bolt",
              "shortDescription": "When this champion successfully attacks an enemy champion, it is relocated to the nearest space to that target.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "bolt"
            },
            {
              "default": false,
              "id": 2763,
              "apCost": 0,
              "name": "Lightning Amped",
              "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Electricity Aura 3.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amped"
            }
          ]
        }
      ]
    },
    {
      "id": 1090,
      "name": "Strig Battle Ward",
      "description": "\"Having to aid Jakei and those brainless Cats rankles us to no end. However, we have no choice in the matter as the war has arrrived quite literally on our doorstep.\" - Rhinticent the 143rd.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 75,
      "hash": "ej9Ej9Df1AE8De9Ag3AJ8Jj9Aeeekekjllyvxkpf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2488,
          "apCost": 0,
          "name": "Boon of the Wind",
          "shortDescription": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "martyr"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": true,
              "id": 1551,
              "apCost": 0,
              "name": "Enduring Aura",
              "shortDescription": "Damage to friendly champions within 3 spaces is reduced by 2. (this ability and its effects do not stack)",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1092,
      "name": "Strig Legwhip",
      "description": "\"Names are an essence of our power. They indicate our line, the power of the family. There is much strength in Strig names.\" - Oram the 444th\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9DG2AE8De9Ag3Aj9Bj9Ceeetfkpjietxtqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1091,
      "name": "Strig Magebane",
      "description": "\"It is not a question of who we hate. It is a question of who we hate the least.\" -Khaldemorance the 709th.\r\n",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 71,
      "hash": "ej9Ej9Df1BE8De9Ag3Aj9Aj9Bgytzgkplyipwoqf",
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 550,
          "apCost": 0,
          "name": "Attack: Red Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "electric"
        },
        {
          "id": 2488,
          "apCost": 0,
          "name": "Boon of the Wind",
          "shortDescription": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "martyr"
        },
        {
          "id": 2216,
          "apCost": 0,
          "name": "Hunter: Mage",
          "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Wizard or Witch, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Wizard or Witch, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "wizard_foe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 1070,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "magicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1123,
      "name": "Strig Warlock",
      "description": "The Strig have no qualms about using dark arts. For them it's merely being practical.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 80,
      "hash": "eJ8HJ8GG2Ae9Ae9Ae9Bj9Bj9Ceerztqlluxfvon",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2488,
          "apCost": 0,
          "name": "Boon of the Wind",
          "shortDescription": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "martyr"
        },
        {
          "id": 939,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 3 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "drain"
        },
        {
          "id": 2519,
          "apCost": 0,
          "name": "Swarm: Tundra Beast",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Tundra Beast champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "swarm_arcticbeast"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1125,
              "apCost": 0,
              "name": "Ally: Forsaken Waste",
              "shortDescription": "While there are other friendly Forsaken Wastes champions in play, this champion gets +7 HP and +2 DMG. Forsaken champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_fw"
            },
            {
              "default": true,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 1392,
              "apCost": 2,
              "name": "Book Burn",
              "shortDescription": "No spells may be cast for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "bookburn"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2343,
              "apCost": 3,
              "name": "Paralyze",
              "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "sentry"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 1720,
              "apCost": 1,
              "name": "Consume",
              "shortDescription": "Sacrifice target owned adjacent champion and this champion is healed for the amount equal to the destroyed champion's current HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "devour"
            }
          ]
        }
      ]
    },
    {
      "id": 1093,
      "name": "Strig Windrider",
      "description": "\"The time for diplomacy has passed. Consider yourselves food.\" - Sintessniko the 429th\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9DG2BE8De9Ag3Aj9Cj9Dyrqqzirftolyxqf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2488,
          "apCost": 0,
          "name": "Boon of the Wind",
          "shortDescription": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "martyr"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 2422,
          "apCost": 0,
          "name": "Tailwind",
          "shortDescription": "On every fourth space that this champion moves in this turn, friendly champions within 8 spaces of this unit with <condition value=flying>Flying</condition> and which do not have Tailwind gain 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "tailwind"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3224,
              "apCost": 0,
              "name": "Commander: Flying",
              "shortDescription": "Friendly champions within 5 spaces with Flying have +2 DMG. This ability does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 2100,
              "apCost": 3,
              "name": "Gale",
              "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "gale"
            },
            {
              "default": true,
              "id": 1225,
              "apCost": 0,
              "name": "Bastion of Mobility",
              "shortDescription": "Friendly champions within 8 spaces have <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 231,
      "name": "Succubus",
      "description": "Remember your place, Nefari scum. Though Lord Maxxarek has given you wings, you are not Bok! - Notk, Bok Guardian ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Demon",
        "Elf"
      ],
      "noraCost": 72,
      "hash": "dJ8JJ8IF0Be9BF0AJ8HJ8IJ8Jeeeepuvhevzvkwf",
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 161,
              "apCost": 0,
              "name": "Psychic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Psychic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapsychic"
            },
            {
              "default": false,
              "id": 977,
              "apCost": 0,
              "name": "Bleed",
              "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_debt"
            }
          ]
        }
      ]
    },
    {
      "id": 1269,
      "name": "Sun Blossom",
      "description": "\"Even I was not aware of the fantastical creatures that live inside the Conclave\" ~ Menalaus upon observing the Sun Blossom for the first time",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 36,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Fairy"
      ],
      "noraCost": 67,
      "hash": "ej9Bj9Ag3Ae9Be9Af1Bj9Dj9Eerzofkrjtztztqf",
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2134,
          "apCost": 0,
          "name": "Abash",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "intoxicate"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2486,
          "apCost": 3,
          "name": "Blind",
          "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "blind"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            }
          ]
        }
      ]
    },
    {
      "id": 1291,
      "name": "Sunder Hellion",
      "description": "Sunder Hellions are reknowned for being reclusive even for a Dragon, though they think of themselves as nothing less than gods and ruthlessly defend their territory when disturbed.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dragon",
        "Mutant"
      ],
      "noraCost": 80,
      "hash": "ej9Ej9De9Ae9Be9Ag3Aj9Fj9Giwzxqwxkyilwtqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        },
        {
          "id": 2697,
          "apCost": 0,
          "name": "Territorial",
          "shortDescription": "When an opposing non-Illusion champion is deployed within 8 spaces, this champion gains <ability value=15>Multiattack 1</ability>, <ability value=259>Enrage 1</ability>, +4 DMG, +1 DEF and +1 SPD for 4 turns. This can trigger up to 2 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "pack_leader"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 591,
              "apCost": 1,
              "name": "Flamestrike",
              "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "fire"
            },
            {
              "default": false,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            }
          ]
        }
      ]
    },
    {
      "id": 710,
      "name": "Sundered Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the glorious kingdom of Valdac.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1AF0BJ8IJ8Jj9Aevkuzkpyrwiipyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            }
          ]
        }
      ]
    },
    {
      "id": 1679,
      "name": "Sundered Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the glorious kingdom of Valdac.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1AF0BJ8IJ8Jj9Aevkuzkpyrwiipyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 330,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            }
          ]
        }
      ]
    },
    {
      "id": 1584,
      "name": "Sundered Phoenix",
      "description": "Brightly colored against the stark landscape of the Sundered Lands, the Sundered Phoenix is a glorious sight to behold.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 7,
      "hitPoints": 20,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 82,
      "hash": "ej9Ej9De9Be9BG2Ag3AJ8GJ8Hiwtosuxklymsoqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1401,
          "apCost": 0,
          "name": "Acidic Greeting",
          "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "greeting_acid"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 942,
          "apCost": 0,
          "name": "Eternal",
          "shortDescription": "This unit cannot be Sacrificed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "bloodless"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 3074,
          "apCost": 0,
          "name": "Rebirth",
          "shortDescription": "When this champion is destroyed, it drops no nora globe and is redeployed in the closest friendly deployment zone without this ability, but gains 5 AP and permanently gains +4 DMG and +25 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 35,
          "iconName": "revive"
        },
        {
          "id": 3287,
          "apCost": 0,
          "name": "Sabotage: Acid",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sabotage_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            },
            {
              "default": true,
              "id": 2620,
              "apCost": 4,
              "name": "Corrosive Grenade",
              "shortDescription": "Area Effect 2, Range 5: Affected units take 8 Acid Damage and becomes <condition value=sundered>Sundered</condition> for 3 turns.  This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "acidaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            },
            {
              "default": false,
              "id": 153,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 2497,
              "apCost": 0,
              "name": "Amplify: Acid",
              "shortDescription": "Acid damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 458,
      "name": "Sunderpede",
      "description": "The Sunderpede regenerates at a remarkable rate, allowing it to split itself into two sentient creatures. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 69,
      "hash": "dj9Gj9Fe9Af1Ae9Aj9Fj9Gj9Hyklexqwkgrjrlgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2732,
          "apCost": 0,
          "name": "Ichor: Regeneration",
          "shortDescription": "This champion gains a rank of Regeneration for each champion within 6 spaces with an Ichor ability.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "ichor_utility"
        },
        {
          "id": 1259,
          "apCost": 0,
          "name": "Split",
          "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "duplicate"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            },
            {
              "default": false,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            },
            {
              "default": true,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": true,
              "id": 2944,
              "apCost": 0,
              "name": "Portal Walker",
              "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 1549,
      "name": "Sunderpede",
      "description": "The Sunderpede regenerates at a remarkable rate, allowing it to split itself into two sentient creatures. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 71,
      "hash": "ej9Fj9EF0Bf1Ae9AE8DJ8IJ8Jshpwirsmhgnuxo",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 1054,
          "apCost": 0,
          "name": "Healing Deficiency",
          "shortDescription": "Healing received by this unit is reduced by 50%.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "inhibit"
        },
        {
          "id": 2492,
          "apCost": 0,
          "name": "Scour",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "scour"
        },
        {
          "id": 1259,
          "apCost": 0,
          "name": "Split",
          "shortDescription": "When this unit is successfully damaged from a basic combat attack (takes more than 0 damage), it splits in two and both copies' hp are halved.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "duplicate"
        },
        {
          "id": 755,
          "apCost": 4,
          "name": "Tunnel: Earth",
          "shortDescription": "This unit is relocated to target Dirt or Rock space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_earth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            },
            {
              "default": false,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            },
            {
              "default": true,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": true,
              "id": 2944,
              "apCost": 0,
              "name": "Portal Walker",
              "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            }
          ]
        }
      ]
    },
    {
      "id": 1805,
      "name": "Sunglade Dryad",
      "description": "The Nefari's fires burnt large scars in the forest, but in most places the blackened earth did not last, and vibrant life returned to these newly sunlit glades.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9DG2AG2AG2Ag3Aj9Bj9Ceeevhkuouvzzitf",
      "artist": "Caio Monteiro",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3244,
          "apCost": 1,
          "name": "Conduit: Damage",
          "shortDescription": "Target enemy champion within 5 spaces has -2 DMG and the closest friendly champion to the target (including this one) has +2 DMG until targets change or the target is destroyed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "conduit_damage"
        },
        {
          "id": 368,
          "apCost": 3,
          "name": "Heal Champion",
          "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "heal"
        },
        {
          "id": 1487,
          "apCost": 4,
          "name": "Summon: Young Sapling",
          "shortDescription": "Summon a Young Sapling with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumtree"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1114,
              "apCost": 0,
              "name": "Extinguish",
              "shortDescription": "When a friendly champion takes Fire damage, it is healed for up to 4 HP (or the amount of damage taken) at the end of that turn. If the champion is affected by <condition value=charred>Charred</condition>, the Charred condition is removed as well. This effect does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_fire"
            },
            {
              "default": true,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2820,
              "apCost": 2,
              "name": "Sacrifice of De'lim",
              "shortDescription": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "chan_fuel"
            }
          ]
        }
      ]
    },
    {
      "id": 1662,
      "name": "Sunset Ferpent",
      "description": "Jakei hunters consider catching the elusive Ferpent to be a good omen.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Monk"
      ],
      "races": [
        "Beast",
        "Ferren"
      ],
      "noraCost": 62,
      "hash": "ej9Bj9Ae9AF0BG2Af1Bj9Fj9Gevfrshvvkuqzxqf",
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 3160,
          "apCost": 0,
          "name": "Ferren Focus",
          "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ferren_focus"
        },
        {
          "id": 752,
          "apCost": 4,
          "name": "Tunnel: Snow",
          "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "tunnel_snow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 774,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_chill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3160,
              "apCost": 0,
              "name": "Ferren Focus",
              "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ferren_focus"
            },
            {
              "default": true,
              "id": 752,
              "apCost": 4,
              "name": "Tunnel: Snow",
              "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_snow"
            },
            {
              "default": false,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            }
          ]
        }
      ]
    },
    {
      "id": 713,
      "name": "Swamp Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the tranquil swamps of Forglar.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Ae9Aj9Fj9Gj9Heexiilegtfvhygg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1178,
          "apCost": 0,
          "name": "Taunt: Doom",
          "shortDescription": "Taunt your enemies with the phrase \"DOOOOOOM!\"",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2227,
              "apCost": 0,
              "name": "Choking Stench",
              "shortDescription": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "choking_stench"
            }
          ]
        }
      ]
    },
    {
      "id": 1680,
      "name": "Swamp Doombringer",
      "description": "Serkan crafted his own Harbingers, each carrying a prophecy of apocalypse. This voice will travel far to deliver its message to the tranquil swamps of Forglar.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Beast",
        "Mutant"
      ],
      "noraCost": 77,
      "hash": "dj9AJ8Jf1Af1Ae9Aj9Fj9Gj9Heexiilegtfvhygg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3163,
          "apCost": 0,
          "name": "Adaptive",
          "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2531,
          "apCost": 0,
          "name": "Bounce",
          "shortDescription": "For 8 turns, the next time target opposing champion within 8 spaces engages one of your champions, it is knocked back 4 spaces. This effect is hidden until triggered and does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "knockback"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3350,
              "apCost": 0,
              "name": "Swamp Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=poisoned>Poisoned</condition>, <condition value=soultapped>Soultapped</condition> or <condition value=blinded>Blinded</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1732,
              "apCost": 3,
              "name": "Doom",
              "shortDescription": "Target champion without <ability value=875>Short Lived</ability> within 2 spaces gains <ability value=876>Short Lived 2</ability>.  This effect cannot be <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 9,
              "iconName": "ondeath"
            },
            {
              "default": false,
              "id": 2227,
              "apCost": 0,
              "name": "Choking Stench",
              "shortDescription": "Spaces within 2 spaces of this unit are <mechanic value=poison_cloud>Poison Cloud</mechanic>.  This Poison Cloud does not deal damage on deploy.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "choking_stench"
            }
          ]
        }
      ]
    },
    {
      "id": 63,
      "name": "Swamp Octopus",
      "description": "Every good swamp has its giant Octopus. - Forglar shaman",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 57,
      "hash": "cj9Hj9Gj9Fe9AF0Aj9Fj9Gj9Heeiyrwqwowiirlj",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 114,
          "apCost": 0,
          "name": "Aquatic",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "aquatic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1403,
              "apCost": 1,
              "name": "Latch On",
              "shortDescription": "For the next 3 turns this unit stays adjacent to target champion while it moves. Target unit gains <ability value=5>Lumbering</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "disable"
            },
            {
              "default": true,
              "id": 1947,
              "apCost": 0,
              "name": "Entangling Attack",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "disable"
            },
            {
              "default": false,
              "id": 324,
              "apCost": 0,
              "name": "Constriction",
              "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "constriction"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 1075,
              "apCost": 3,
              "name": "Heal Self",
              "shortDescription": "This unit recovers 8 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 1237,
      "name": "Swamp Thing",
      "description": "No one is sure what exactly this creature is, but one thing is for certain: It isn't happy and it sure isn't singing.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mirefolk",
        "Mutant"
      ],
      "noraCost": 82,
      "hash": "eJ8IJ8HG2Be9Be9AF0Aj9Cj9Dmnpyzxzkluvhyo",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2434,
          "apCost": 0,
          "name": "Leech Vitality",
          "shortDescription": "When this champion damages an opposing champion, it permanently gains MAX HP equal to 50% of the damage dealt (to a maximum of 5).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "overkill"
        },
        {
          "id": 2624,
          "apCost": 0,
          "name": "Marsh Awakening",
          "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying water.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "aquatic"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 883,
          "apCost": 1,
          "name": "Tidal Wave",
          "shortDescription": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "tsunami"
        },
        {
          "id": 1044,
          "apCost": 0,
          "name": "Trail: Water",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Water (Impeding 1) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "trail_water"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 1567,
      "name": "Swamp Wisp",
      "description": "Swamp Wisps appear mostly around the boggy areas of the swamp. Typically dormant, they have become more agitated as incursions into the Swamp land by outsiders have increased.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Spirit"
      ],
      "noraCost": 75,
      "hash": "ej9Bj9AE8De9BG2Af1Bj9Ej9Fsmpnssonwvhtoqf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1377,
          "apCost": 0,
          "name": "Evasive",
          "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_ranged"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1094,
          "apCost": 0,
          "name": "Poison Eater",
          "shortDescription": "When this unit would take Poison damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=poisoned popup=false>Poisoned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_poison"
        },
        {
          "id": 3334,
          "apCost": 0,
          "name": "Sabotage: Poison",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sabotage_acid"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 145,
              "apCost": 0,
              "name": "Poison Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Poison damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novapoison"
            },
            {
              "default": true,
              "id": 446,
              "apCost": 0,
              "name": "Lay Trap: Poison Cloud",
              "shortDescription": "Lay a Poison Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, all spaces within a range of 2 are covered in a <mechanic value=poison_cloud>poison cloud</mechanic> until end of the next turn.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trappoison"
            },
            {
              "default": false,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1092,
              "apCost": 1,
              "name": "Poison Cone",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Poison damage equal to 65% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=poisoned>Poisoned</condition> for 2 turns. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            },
            {
              "default": true,
              "id": 730,
              "apCost": 1,
              "name": "Poison Sting",
              "shortDescription": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "poison"
            },
            {
              "default": false,
              "id": 3066,
              "apCost": 1,
              "name": "Poisonburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Poison damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "poisonaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 116,
      "name": "Swamp Wurm",
      "description": "Drylanders forget that we don't live IN the swamp. We live WITH the swamp. And our neighbors are often ill-tempered. -- Gekaal, Forglar High One",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon",
        "Worm"
      ],
      "noraCost": 66,
      "hash": "dJ8HJ8Ge9Be9Af1Bj9Aj9Bj9Ceitjwqzitqhirwf",
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 241,
          "apCost": 0,
          "name": "Damage Shield: Poison",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Poison damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dmgshld_poison"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": true,
              "id": 193,
              "apCost": 0,
              "name": "Death Nova: Poison",
              "shortDescription": "When this unit is destroyed, it deals 11 Poison damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovapoison"
            },
            {
              "default": false,
              "id": 1346,
              "apCost": 3,
              "name": "Poison Charge",
              "shortDescription": "Until end of turn, all Poison damage is increased by 2. This unit loses 5 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "amp_poison"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2741,
              "apCost": 0,
              "name": "Spontaneous Regeneration",
              "shortDescription": "For every 20 damage this champion takes in a single turn, it is healed for 9 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 14,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 1006,
      "name": "Swampguard Crusher",
      "description": "Boghoppers cannot trust the Crusher mounts they ride to not attack them. They must constantly be aware of the Crushers target lest they be attacked themselves.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Arthropod",
        "Boghopper"
      ],
      "noraCost": 81,
      "hash": "eJ8HJ8GE8DE8De9Ae9Bj9Ej9Feepnsssjnhetfm",
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 3,
          "apCost": 0,
          "name": "Fearless",
          "shortDescription": "This unit can not become <condition value=frightened>Frightened</condition>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "buff"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2463,
          "apCost": 0,
          "name": "Quest: Kill Enemy",
          "shortDescription": "When this champion destroys an enemy champion, it loses this ability, is healed for 20 HP and permanently gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 655,
          "apCost": 0,
          "name": "Skirmisher",
          "shortDescription": "This unit can only attack champions and transfigured Avatars.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -2,
          "iconName": "hunter"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 6,
              "apCost": 0,
              "name": "Mobility",
              "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 1789,
      "name": "Swift Current",
      "description": "We are disciples of the river, ever flowing, tireless and unstoppable.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Monk"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 77,
      "hash": "eJ8HJ8Gf1AG2AG2Ae9BJ8Jj9Aeevfeieirjluhpf",
      "artist": "Grant Griffin",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 3072,
          "apCost": 3,
          "name": "Elusive Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "dashing_dodge"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 3270,
          "apCost": 0,
          "name": "Swift Current",
          "shortDescription": "When this champion makes a successful basic attack, friendly champions within 5 spaces gains Mobility for 1 turn and moves 1 space towards the target if able. If the affected champion shares a race or class with this one, it also gains 1 AP. This effect can trigger only once per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull_guile"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1747,
              "apCost": 1,
              "name": "Grant: Frost Trap",
              "shortDescription": "Target champion within 5 spaces gains <ability value=452>Lay Trap: Frost 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2091,
              "apCost": 0,
              "name": "Dragging Attack",
              "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "pull"
            },
            {
              "default": true,
              "id": 3296,
              "apCost": 0,
              "name": "Zeal: Damage",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_damage"
            },
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 1401,
      "name": "Tainted Vinecreeper",
      "description": "Tainted treefolk have no real allegiance. They simply grow in the sundered lands, and feed on meat. ",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Mutant",
        "Plant",
        "Treefolk"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9DF0BF0Ae9Ag3AJ8IJ8Jsmhketmwfxoympf",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1099,
          "apCost": 0,
          "name": "Hidden: Sand",
          "shortDescription": "At the end of your turn, if this champion occupies Sand, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1100,
              "apCost": 0,
              "name": "Sandstriker",
              "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1326,
              "apCost": 0,
              "name": "Domain: Sand",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Sand.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_sand"
            },
            {
              "default": false,
              "id": 3296,
              "apCost": 0,
              "name": "Zeal: Damage",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_damage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 2091,
              "apCost": 0,
              "name": "Dragging Attack",
              "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "pull"
            }
          ]
        }
      ]
    },
    {
      "id": 291,
      "name": "Talgar Ironfist",
      "description": "I thought the last of the Ironfists died out in the days of the Catastrophe.  -- The strongest of  us survived. - King Rugolth to Talgar upon revealing his noble lineage  ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 13,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin",
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 90,
      "hash": "dJ8IJ8HF0AF0AF0BJ8IJ8Jj9Aiyirlyxtszgepwf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 870,
          "apCost": 1,
          "name": "Hammer Throw",
          "shortDescription": "Make a magical attack with a range of 3-6, at +2 DMG against target enemy unit.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "hammer"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 1860,
      "name": "Talgar Ironfist",
      "description": "I thought the last of the Ironfists died out in the days of the Catastrophe.  -- The strongest of  us survived. - King Rugolth to Talgar upon revealing his noble lineage  ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 13,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin",
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 90,
      "hash": "ej9Bj9Af1BG2BG2Af1Bj9Aj9Bwmekwmsonplnlrf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 870,
          "apCost": 1,
          "name": "Hammer Throw",
          "shortDescription": "Make a magical attack with a range of 3-6, at +2 DMG against target enemy unit.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "hammer"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2572,
              "apCost": 0,
              "name": "Spur",
              "shortDescription": "This champion has +1 DMG and +1 SPD for each opposing champion within 4 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "spur"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 737,
      "name": "Temple Guard",
      "description": "Akakios argued the importance of protecting the temples of Valdac from invaders. He would need warriors, warriors who spent years in service, warriors who knew what it was to protect.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 8,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 66,
      "hash": "dj9Cj9BG2AG2Ae9BJ8GJ8HJ8Iqjtolgkrukevszg",
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 877,
          "apCost": 0,
          "name": "Bodyguard",
          "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "block"
        },
        {
          "id": 31,
          "apCost": 0,
          "name": "Defender",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "defenseenhance"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2032,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +4 HP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plushealth"
            },
            {
              "default": false,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        }
      ]
    },
    {
      "id": 1706,
      "name": "Terraced Slag",
      "description": "Not all slags are scary.  Some are kept as pets.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 7,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Plant",
        "Slag"
      ],
      "noraCost": 70,
      "hash": "ej9Bj9Ae9Af1AG2Af1Bj9Fj9Gfxiwvsxkjykeerf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 2309,
          "apCost": 0,
          "name": "Hallucinogenic",
          "shortDescription": "When this unit is successfully attacked by a basic attack, the attacking champion gains <ability value=2266>Wandering</ability> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hallucinogenic"
        },
        {
          "id": 2528,
          "apCost": 0,
          "name": "Ooze Tap",
          "shortDescription": "When a non-flying opposing champion within 5 spaces enters Ooze, it takes 2 Acid damage and friendly Slags occupying Ooze within 5 spaces of this unit each heal 2 HP. The damage effect of this ability does not stack and each friendly Slag can only be healed to a maximum of 6 HP from the champion entering Ooze.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        },
        {
          "id": 2549,
          "apCost": 0,
          "name": "Oozing",
          "shortDescription": "This unit has <ability value=2549>Trail: Ooze</ability>. When this unit is damaged, spaces within 3 spaces becomes Ooze for 3 turns and opposing units within 3 spaces become <condition value=scoured>Scoured</condition> and <condition value=grounded>Grounded</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "ooze_tap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2777,
              "apCost": 4,
              "name": "Tunnel: Ooze",
              "shortDescription": "This unit is relocated to target Ooze space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_ooze"
            },
            {
              "default": false,
              "id": 1047,
              "apCost": 0,
              "name": "Acid Eater",
              "shortDescription": "When this unit takes Acid damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=scoured>Scoured</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_acid"
            },
            {
              "default": true,
              "id": 3287,
              "apCost": 0,
              "name": "Sabotage: Acid",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Acid damage and gains <ability value=93>Vulnerability: Acid</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1076,
              "apCost": 3,
              "name": "Heal Self",
              "shortDescription": "This unit recovers 12 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "heal"
            },
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 107,
      "name": "Terraformer",
      "description": "Gardens in the desert? Not a problem. Gardens in solid ice? A challenge, perhaps. -- Feofil, Assistant to the King",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9Be9Ae9Aj9Fj9Gj9Hkphrjtqlpjnjexf",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1499,
          "apCost": 4,
          "name": "Lava Storm",
          "shortDescription": "Area Effect 2, Range 5: Affected champions take 12 Fire damage. This damage ignores DEF. For the next 2 turns, spaces within the affected area are Shallow Lava (4 Fire damage on entry and when occupied).",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 12,
          "iconName": "fireaoe"
        },
        {
          "id": 689,
          "apCost": 0,
          "name": "Lockdown",
          "shortDescription": "All units within 5 spaces have <ability value=669>Earthbound</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "debuff"
        },
        {
          "id": 633,
          "apCost": 2,
          "name": "Terraform: Lava",
          "shortDescription": "This champion has <ability value=480>Lavawalker</ability>. Target space within 3 spaces is Lava (Impeding 1, 8 Fire damage on entry and when occupied) for 6 turns.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainlava"
        },
        {
          "id": 2036,
          "apCost": 2,
          "name": "Terraform: Rock",
          "shortDescription": "Target space within 3 spaces, and all spaces adjacent to it, are Rock for 6 turns. Any friendly champion occupying target space gains <ability value=2414>Throw Boulder</ability> for 1 turn.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "terrainrock"
        },
        {
          "id": 869,
          "apCost": 3,
          "name": "Tremor",
          "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "physicalaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1270,
              "apCost": 1,
              "name": "Tectonic Pulse",
              "shortDescription": "This champion makes an attack against target champion within 2-5 spaces, in a straight line, at DMG 15. When this attack is made, the intervening spaces between this champion and the target become <mechanic value=unstableground>Unstable Ground</mechanic> until the end of your enemy's turn. When this attack deals 1 or more damage to the target, that champion is knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2764,
              "apCost": 4,
              "name": "Stone Barrage",
              "shortDescription": "3 random opposing champions within 5 spaces take 9 physical damage (reduced by 3 per trigger against the same champion). This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": true,
              "id": 2637,
              "apCost": 3,
              "name": "Grant: Stoneskin Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2638>Drink: Stoneskin Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 684,
      "name": "The Exile",
      "description": "Bladen Windfury made a deal with the Voil Queen: the bodies of his enemies for his allegiance.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 14,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 93,
      "hash": "dJ8IJ8HF0AG2AF0AJ8HJ8IJ8Jpjnpwkluohrhtxf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1875,
          "apCost": 0,
          "name": "Deep Wounds",
          "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "rend"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 732,
              "apCost": 0,
              "name": "Fury",
              "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1330,
              "apCost": 0,
              "name": "Dread",
              "shortDescription": "Enemy champions within 8 spaces of this champion have -2 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1146,
              "apCost": 1,
              "name": "Disease Breath",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Disease damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=diseased>Diseased</condition> for 2 turns. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "diseaseaoe"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 1607,
      "name": "The Sanguine",
      "description": "Despite the name, Bloodgoyles are not constructs of any kind, instead, they are pure demonic energy driven by the lust for blood.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Demon",
        "Imp"
      ],
      "noraCost": 76,
      "hash": "eJ8JJ8IG2BF0AG2AF0Bj9Cj9Dygyggkepjrjyvqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 977,
          "apCost": 0,
          "name": "Bleed",
          "shortDescription": "When this unit damages a champion with a basic attack, the target is <condition value=bloodied>Bloodied</condition> for 6 turns and a blood ball is created in an adjacent space. Archdemons, Demons and Vampyres that capture the blood ball vampiric heal equal to 50% of the damage. Other champions take the same amount in disease damage. Only one blood ball per enemy can be active.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "blood_debt"
        },
        {
          "id": 3112,
          "apCost": 0,
          "name": "Blood Casting",
          "shortDescription": "When this champion is deployed, all real enemy champions in play have a Blood Ball worth 5 HP created adjacent to them.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "bloodball"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 2833,
          "apCost": 2,
          "name": "Teleport: Blood Ball",
          "shortDescription": "This champion relocates to a Blood Ball within 6 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1378,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 50% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "resistance_ranged"
            },
            {
              "default": true,
              "id": 2626,
              "apCost": 0,
              "name": "Scrapper",
              "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "scrapper"
            },
            {
              "default": false,
              "id": 3072,
              "apCost": 3,
              "name": "Elusive Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "dashing_dodge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 2595,
              "apCost": 0,
              "name": "Hunter: Bloodied",
              "shortDescription": "When this unit would deal damage with any Attack to a <condition value=bloodied>Bloodied</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=bloodied>Bloodied</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "blood_debt"
            },
            {
              "default": false,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1785,
      "name": "The Silent Master",
      "description": "Like water or wind or will, an action announces while a sound but suggests.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Monk"
      ],
      "races": [
        "Ferren"
      ],
      "noraCost": 84,
      "hash": "eJ8HJ8Ge9AG2AG2Ae9Bj9Fj9Gerzkuowfmheplpf",
      "artist": "Daniel Kamarudin",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 3351,
          "apCost": 0,
          "name": "Fen Teachings",
          "shortDescription": "This unit has <ability value=2>Amphibious</ability> and <ability value=600>Arctic</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "amphib"
        },
        {
          "id": 3264,
          "apCost": 0,
          "name": "Fury of a Thousand Strikes",
          "shortDescription": "The first time each turn this champion makes a successful basic attack, other friendly champions within 5 spaces that share a race or class with this champion have their CDs reduced by 1 and their attack chain is reset.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "fury_1k_strikes"
        },
        {
          "id": 3265,
          "apCost": 0,
          "name": "Portal Watcher",
          "shortDescription": "When a friendly champion relocates (including this one), this champion gains +1 DMG and a rank of <ability value=15>Multiattack</ability> for 1 turn. This can stack up to 3 times.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 2626,
          "apCost": 0,
          "name": "Scrapper",
          "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "scrapper"
        },
        {
          "id": 1264,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3160,
              "apCost": 0,
              "name": "Ferren Focus",
              "shortDescription": "This champion has <ability value=600>Arctic</ability>.  When this champion makes a successful basic attack against a champion, the following debuffs are applied to the target in order: <condition value=frozen>Frozen</condition> for 1 turn, <condition value=slowed>Slowed</condition> for 2 turns, <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ferren_focus"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            },
            {
              "default": true,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            },
            {
              "default": false,
              "id": 2095,
              "apCost": 0,
              "name": "Combo Attack: Slam",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion is knocked back 2 spaces.\r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "comboatk_slam"
            }
          ]
        }
      ]
    },
    {
      "id": 1812,
      "name": "Thicket Crawler",
      "description": "Most creatures in the Swamp embody the ethos of its more sentient inhabitants: don't mess with them, they don't mess with you.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Beast",
        "Plant"
      ],
      "noraCost": 68,
      "hash": "ej9Gj9Ff1AG2BG2Ae9AJ8Jj9Aeigegeigplyrhrf",
      "artist": "Caio Monteiro",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 3288,
          "apCost": 0,
          "name": "Sabotage: Armor",
          "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "sabotage_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3334,
              "apCost": 0,
              "name": "Sabotage: Poison",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Poison damage and gains <ability value=91>Vulnerability: Poison</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 3136,
              "apCost": 0,
              "name": "Empowered: Offense",
              "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_offense"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1142,
              "apCost": 0,
              "name": "Hunter: Hero",
              "shortDescription": "When this unit would deal damage with any attack to a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater that damage is increased by 2. When this unit would receive damage from any attack by a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "hunter_hero"
            },
            {
              "default": false,
              "id": 3328,
              "apCost": 0,
              "name": "Hunter: Poisoned",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=poisoned>Poisoned</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=poisoned>Poisoned</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities. This does not stack with other Hunter: X abilities.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "poison"
            },
            {
              "default": true,
              "id": 3029,
              "apCost": 0,
              "name": "Hunter: Crippled",
              "shortDescription": "When this unit would deal damage to a champion with less than 0 DEF with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with less than 0 DEF, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "hunter_crippled"
            }
          ]
        }
      ]
    },
    {
      "id": 687,
      "name": "Thirion",
      "description": "The trees moved and swayed. From the foliage came an ancient creature; its purpose benevolent and its power endless.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 13,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Dragon",
        "Plant"
      ],
      "noraCost": 89,
      "hash": "dJ8IJ8HF0AG2AG2Aj9Bj9Cj9Dxkymjggnjgerofg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1702,
          "apCost": 0,
          "name": "Blockade",
          "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "blockade"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1458,
          "apCost": 0,
          "name": "Forest Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Vegetation for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terraingrass"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 1122,
          "apCost": 0,
          "name": "Plant Regeneration",
          "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2579,
              "apCost": 4,
              "name": "Magic Beam",
              "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Magic damage (ignores DEF) and has its DEF set to 0 for 1 turn if its DEF is greater than 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 1072,
              "apCost": 1,
              "name": "Magical Bomb",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 789,
              "apCost": 3,
              "name": "Healing Breath",
              "shortDescription": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 18 HP divided by the number of targets (rounded down to a max of 8 HP per target).",
              "activationType": 1,
              "level": 1,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "healmass"
            }
          ]
        }
      ]
    },
    {
      "id": 1072,
      "name": "Throatrend Lonx",
      "description": "\"I've seen them wade recklessly into a pack of Kanen and not falter until the last few are drowning in their own blood. These Lonx, they are our kin.\" - Mosharn the Barricade",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 82,
      "hash": "ej9Cj9BG2BE8De9AG2Aj9Cj9Dkygrlegtqhvxoqf",
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 25,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +2 SPD, +4 DMG, and <ability value=2005>Careless</ability>",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "berserker"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 1389,
          "apCost": 0,
          "name": "Perseverance",
          "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tgtdefensive"
        },
        {
          "id": 2619,
          "apCost": 0,
          "name": "Zeal: Speed",
          "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "channel_speed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 3056,
              "apCost": 0,
              "name": "Overkill: Healing",
              "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "overkill"
            }
          ]
        }
      ]
    },
    {
      "id": 1593,
      "name": "Thunder Elemental",
      "description": "Rolling, crashing, down the cliff it came, thundering ever louder towards the invading force, landing with a shock wave that shook ears and swallowed hope.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 83,
      "hash": "ej9Fj9EG2BF0AG2AE8Dj9Cj9Djiwojwfepwipfrf",
      "artist": "Danh Nguyen",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 3087,
          "apCost": 3,
          "name": "Sonic Surge",
          "shortDescription": "This champion gains 3 AP and Pacified for 1 turn.  For each space moved, enemy champions within 2 spaces take 3 Sonic damage (this damage ignores DEF).  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "charge_sonic"
        },
        {
          "id": 3059,
          "apCost": 0,
          "name": "Thunderous Charge",
          "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "thunderous_charge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 149,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 10,
      "name": "ThunderHoof",
      "description": "They shake the ground as they approach, to let their enemies know of the death that awaits them.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Minotaur"
      ],
      "noraCost": 70,
      "hash": "cj9Ej9Dj9CG2BF0Bj9Cj9Dj9Eeeeemsfvoljlgkj",
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1453,
          "apCost": 0,
          "name": "Encroached",
          "shortDescription": "This champion gets +2 DMG and +1 SPD for each font your opponent controls. It also gets +2 DEF if your opponent controls more fonts than you.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "buff"
        },
        {
          "id": 617,
          "apCost": 0,
          "name": "Gore",
          "shortDescription": "When this champion makes a close-combat or Charge attack that deals Physical damage to a champion, that champion becomes <condition value=gored>Gored</condition>. This can stack up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gore"
        },
        {
          "id": 3059,
          "apCost": 0,
          "name": "Thunderous Charge",
          "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "thunderous_charge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": true,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2213,
              "apCost": 0,
              "name": "Crazed Charger",
              "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "crazed_charger"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            }
          ]
        }
      ]
    },
    {
      "id": 305,
      "name": "Tide Master",
      "description": "Call forth the waters of the swamp Gorglik. Let them fight in our element. - Kartch, Boghopper Finlord",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 78,
      "hash": "dj9Fj9EE8DF0Ae9Aj9Fj9Gj9Hgygekuvziginpfg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 883,
          "apCost": 1,
          "name": "Tidal Wave",
          "shortDescription": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "tsunami"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": true,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 948,
              "apCost": 0,
              "name": "Surge: Boghopper",
              "shortDescription": "This unit has +1 DMG for each friendly Boghopper.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_boghopper"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2132,
              "apCost": 0,
              "name": "Water Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainwater"
            }
          ]
        }
      ]
    },
    {
      "id": 1945,
      "name": "Tide Master",
      "description": "Call forth the waters of the swamp Gorglik. Let them fight in our element. - Kartch, Boghopper Finlord",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 78,
      "hash": "ej9Gj9Fe9Be9AG2Be9AJ8GJ8Hwirjigvosxfkyo",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 883,
          "apCost": 1,
          "name": "Tidal Wave",
          "shortDescription": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "tsunami"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2786,
              "apCost": 0,
              "name": "Spell Aegis",
              "shortDescription": "When an opposing spell is successfully cast, opposing spells cost 5 additional nora for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            },
            {
              "default": true,
              "id": 867,
              "apCost": 0,
              "name": "Blessed",
              "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 948,
              "apCost": 0,
              "name": "Surge: Boghopper",
              "shortDescription": "This unit has +1 DMG for each friendly Boghopper.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_boghopper"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2132,
              "apCost": 0,
              "name": "Water Front",
              "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrainwater"
            }
          ]
        }
      ]
    },
    {
      "id": 873,
      "name": "Timberjaw Alpha",
      "description": "Timberjaws are unruly and savage. They mindlessly charge through the jungle; searching for something, anything, to kill.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 70,
      "hash": "dj9Fj9EE8Dg3AE8Dj9Ej9Fj9Geeeemnluvzzxigg",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1306,
          "apCost": 0,
          "name": "Mountaineer",
          "shortDescription": "This champion ignores movement restrictions and movement penalties imposed by terrain elevation and ignores terrain restrictions while moving.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "climb"
        },
        {
          "id": 2146,
          "apCost": 0,
          "name": "Pack Leader",
          "shortDescription": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        },
        {
          "id": 1363,
          "apCost": 0,
          "name": "Unleash",
          "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "unleashed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3056,
              "apCost": 0,
              "name": "Overkill: Healing",
              "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "overkill"
            },
            {
              "default": true,
              "id": 1874,
              "apCost": 1,
              "name": "Shred Defense",
              "shortDescription": "Target champion within 2 spaces has its DEF set to 0 for 2 turns and takes Physical damage equal to the amount of DEF lost. It also gains <ability value=5>Lumbering</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            }
          ]
        }
      ]
    },
    {
      "id": 910,
      "name": "Timothy the Vile",
      "description": "\"Necromancy is merely a discipline of magic, nothing more. I practice the 'dark arts' to further our understanding. Also, I like having servants that don't talk much.\" - Timothy the Vile",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 78,
      "hash": "dJ8IJ8HF0Ag3AF0BJ8IJ8Jj9Aevxtftuxipqonyg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 2935,
          "apCost": 4,
          "name": "Summon: Boghopper Zombie",
          "shortDescription": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 4 spaces. Spooky!",
          "activationType": 1,
          "level": 3,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumskel"
        },
        {
          "id": 3372,
          "apCost": 0,
          "name": "Swarm: Boghopper Zombie",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Level 1 Boghopper Zombie champion without upgrades and with <ability value=518>Leap 3</ability> and <ability value=1403>Latch On</ability> is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2958,
              "apCost": 3,
              "name": "Ritual of Power",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "deconstruct"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 958,
      "name": "Timothy the Vile",
      "description": "\"Necromancy is merely a discipline of magic, nothing more. I practice the 'dark arts' to further our understanding. Also, I like having servants that don't talk much.\" - Timothy the Vile",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Witch",
        "Wizard"
      ],
      "races": [
        "Boghopper"
      ],
      "noraCost": 78,
      "hash": "dj9Dj9CG2Bg3AE8Dj9Ej9Fj9Geemjexkythpyojg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 2935,
          "apCost": 4,
          "name": "Summon: Boghopper Zombie",
          "shortDescription": "Summon a Boghopper Zombie with <ability value=518>Leap 3</ability> and <ability value=877>Bodyguard</ability> to target, within 4 spaces. Spooky!",
          "activationType": 1,
          "level": 3,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumskel"
        },
        {
          "id": 3372,
          "apCost": 0,
          "name": "Swarm: Boghopper Zombie",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Level 1 Boghopper Zombie champion without upgrades and with <ability value=518>Leap 3</ability> and <ability value=1403>Latch On</ability> is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "swarm_kanen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2958,
              "apCost": 3,
              "name": "Ritual of Power",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. Friendly champions get +2 DMG for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "deconstruct"
            },
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 3107,
              "apCost": 3,
              "name": "Ritual of Healing",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2594,
              "apCost": 0,
              "name": "Soul Vitality",
              "shortDescription": "When a non-illusion champion is destroyed, this champion gains 1 AP.  If the champion was real, this champion gains 2 AP instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 522,
      "name": "Tireless Harvester",
      "description": "The Harvesters bring us comfort, and in return we give Nora. This is a fair trade. - Sapaleh the Ancient",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 4,
      "damage": 7,
      "hitPoints": 41,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 49,
      "hash": "dj9Bj9Af1BF0Be9Aj9Fj9Gj9Heerukpufmlplggg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1339,
          "apCost": 3,
          "name": "Harvest",
          "shortDescription": "Friendly Plant champions lose 1 AP and 2 HP each. You gain 3 nora for each Plant effected.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "charm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 307,
              "apCost": 0,
              "name": "Nora Miner",
              "shortDescription": "At the beginning of your turn, you gain 3 nora.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "noragen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2426,
              "apCost": 3,
              "name": "Fairy Dust",
              "shortDescription": "Target champion within 4 spaces gains <ability value=2266>Wandering</ability> for 2 Turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fairydust"
            },
            {
              "default": true,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        }
      ]
    },
    {
      "id": 1614,
      "name": "Tog and Kaiya",
      "description": "Mounted bowmen aren't a new thing, but it takes a certain agility to master the art with a Corgi mount whose cadence when running provides a certain challenge.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Fairy"
      ],
      "noraCost": 74,
      "hash": "ej9AJ8Jf1AF0AG2Af1AJ8Jj9Aerqonufmlyoympf",
      "artist": "Darcie Banfield",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1319,
          "apCost": 1,
          "name": "Arrowshot",
          "shortDescription": "This unit makes a Physical attack at Range 3-6.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 3101,
          "apCost": 0,
          "name": "Ferocious Bite",
          "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "ancestral_avenger"
        },
        {
          "id": 2690,
          "apCost": 4,
          "name": "Glorious Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. Opposing champions within 2 spaces of the target space are <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "leap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 335,
              "apCost": 1,
              "name": "Farshot",
              "shortDescription": "This champion makes a ranged attack at +2 RNG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "arrow"
            },
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2097,
              "apCost": 0,
              "name": "Combo Attack: Rend",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 367,
      "name": "Toll-Taker",
      "description": "The Toll-taker stands where the dead have veered; A sordid god, with a short foul beard; His eyes like a hollow furnace on fire; Opulent chains bind his obscene attire. - Songs of the Dead, Canta 4 ",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Priest"
      ],
      "races": [
        "Lich",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 76,
      "hash": "dj9Ej9Dg3AF0Ae9BJ8GJ8HJ8Iukggpqfegtoytzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 2239,
          "apCost": 0,
          "name": "Corruption",
          "shortDescription": "This unit loses 5 HP.  For 1 turn, this unit loses its basic attacks and gains <ability value=1943>Attack: Loss of Life</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 3,
          "iconName": "ondeath"
        },
        {
          "id": 105,
          "apCost": 0,
          "name": "Scorn",
          "shortDescription": "When this unit is deployed, its owner's Shrine or Avatar loses 8 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "shrinebad"
        },
        {
          "id": 1009,
          "apCost": 0,
          "name": "Tariff",
          "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "cost"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 2191,
              "apCost": 0,
              "name": "Nora Hex",
              "shortDescription": "Shrine nora generation for opposing players is reduced by 1 for every 3 charges on this champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": true,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            },
            {
              "default": false,
              "id": 3137,
              "apCost": 2,
              "name": "Dread Field",
              "shortDescription": "Area Effect 2, Range 5: For 4 turns, the area becomes Dread Field (Champions have -5 DMG).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "dread_field"
            }
          ]
        }
      ]
    },
    {
      "id": 265,
      "name": "Tomb Lord",
      "description": "Although the dead rise to battle for us, their decaying bones are brittle. We must augment our troops with the souls of our enemies.   - Serkan",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 75,
      "hash": "dJ8IJ8HF0AF0Ae9Aj9Fj9Gj9Hpwkrhkrjwououzg",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 863,
          "apCost": 0,
          "name": "Boost: Skeleton",
          "shortDescription": "Friendly champions with Race: Skeleton have +5 MAX HP. This does not stack  with other Boosts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "boost"
        },
        {
          "id": 925,
          "apCost": 0,
          "name": "Surge: Skeleton",
          "shortDescription": "This unit has +1 DMG for each friendly Skeleton.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge_skeleton"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": true,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 656,
              "apCost": 2,
              "name": "Drive",
              "shortDescription": "Target champion within 5 spaces loses 2 HP (HP loss cannot be prevented) and gains Driven (This champion gets +2 DMG and +1 SPD) and recovers 1 AP. This ability can not be used on a champion who already has this effect.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "drive"
            },
            {
              "default": true,
              "id": 432,
              "apCost": 4,
              "name": "Summon: Skeleton",
              "shortDescription": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 7 SPD, 1 RNG, 9 DMG, 15 HP, <ability value=545>Attack: Physical</ability>).",
              "activationType": 1,
              "level": 3,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "sumskel"
            }
          ]
        }
      ]
    },
    {
      "id": 1638,
      "name": "Tomb Sentinel",
      "description": "Tachrim, like Xulos, sought to surpass his master and began experimenting with constructs. Unlike those created by the artisans of the Stronghold, Tacrim's golems are powered by the energy harvested from souls and spirits.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Construct",
        "Undead"
      ],
      "noraCost": 50,
      "hash": "eJ8HJ8Gf1BF0BG2Ae9Bj9Aj9Beerlnsjevsxxfpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1190,
          "apCost": 0,
          "name": "Fleet",
          "shortDescription": "When this champion is deployed, it gains 5 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "initiative"
        },
        {
          "id": 3132,
          "apCost": 0,
          "name": "Relic Drop: Tomb",
          "shortDescription": "When this champion is deployed from the runedock, it spends the first 4 turns as a Tomb relic with 1 DEF and 20 HP.  When this unit is destroyed, it becomes the same Tomb relic.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "tombdrop"
        },
        {
          "id": 3013,
          "apCost": 0,
          "name": "Soultap Feedback",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "soultap_feedback"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3145,
              "apCost": 0,
              "name": "Empowered: Defense",
              "shortDescription": "This champion has +3 DEF. This ability is removed after this champion has been the target of 3 successful basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "fragile_defense"
            },
            {
              "default": false,
              "id": 356,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +4 DEF for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 365,
      "name": "Tormented Priest",
      "description": "Little equals the torment of a priest, risen undead to a time when their religion has long been forgotten. Their souls long since departed, their never-ending pain now echoes throughout the Waste.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Priest"
      ],
      "races": [
        "Lich",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 76,
      "hash": "dj9Ej9Dg3AF0AE8Dj9Ej9Fj9Geeeiyvvhyrfrshg",
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 986,
          "apCost": 0,
          "name": "Dark Healing",
          "shortDescription": "When an enemy champion within 10 spaces is healed by a spell or ability, the amount healed is reduced by 50%. At the end of each turn, friendly champions are healed by the same number of HP, distributed evenly among them to a maximum of 6 HP (rounded down, minimum 1). This effect does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "dark_heal"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 431,
              "apCost": 4,
              "name": "Summon: Skeleton",
              "shortDescription": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "sumskel"
            },
            {
              "default": false,
              "id": 2596,
              "apCost": 0,
              "name": "Forsaken Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=diseased>Diseased</condition>, <condition value=cursed>Cursed</condition> or <condition value=hexed>Hexed</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_forsaken"
            },
            {
              "default": true,
              "id": 3286,
              "apCost": 0,
              "name": "Sabotage: Defile",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play becomes <condition value=diseased>Diseased 3</condition>, <condition value=defiled>Defiled</condition> and <condition value=inhibited>Inhibited</condition> for 8 rounds.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_defile"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            },
            {
              "default": false,
              "id": 1774,
              "apCost": 0,
              "name": "Phylactery Bound",
              "shortDescription": "When this unit is deployed from the runedock, a Phylactery relic is summoned in the closest friendly deployment zone.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 15,
              "iconName": "phylactery"
            }
          ]
        }
      ]
    },
    {
      "id": 850,
      "name": "Tortalleon Gunbattery",
      "description": "\"Bring the little 'un to shore, Mr. Greenclaw. We'll show those Drakkies who has the biggest guns.\" - Captain Tremir Craghide of the Gygurnaut",
      "maxRng": 6,
      "minRng": 5,
      "defense": 2,
      "speed": 5,
      "damage": 14,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 77,
      "hash": "dj9Cj9BG2AG2BG2Aj9Bj9Cj9Dgpqfpljrlytxmjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2210,
          "apCost": 4,
          "name": "Artillery Strike",
          "shortDescription": "Area Effect 2, Range 7-9: At the beginning of your next turn, units occupying the affected spaces take Fire damage equal to the damage of this unit when it made the attack. This damage will occur even if this unit is destroyed or removed from play.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 25,
          "iconName": "artillery"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 1818,
          "apCost": 0,
          "name": "Defensive Strike",
          "shortDescription": "For 4 turns, the first time a visible opposing champion moves into this champion's range, this champion makes a free basic attack against that champion. If this champion has no basic attack, it makes a Physical non-basic attack instead. This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 2002,
          "apCost": 0,
          "name": "Easy Target",
          "shortDescription": "This unit takes 30% more damage from ranged attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "easy_target"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 2099,
              "apCost": 0,
              "name": "Fire Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "artillery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 3288,
              "apCost": 0,
              "name": "Sabotage: Armor",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play has -2 DEF and <ability value=2008>Liability</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "sabotage_armor"
            }
          ]
        }
      ]
    },
    {
      "id": 806,
      "name": "Tortalleon Pygmy",
      "description": "The smaller Tortalleons, those too small to sail on, become the Tortun's heavy infantry. The Pygmies are taught to strike with their foreclaws, while standing on their hindlegs and balancing on their tail.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 60,
      "hash": "dJ8IJ8HF0AG2BF0AJ8HJ8IJ8Juxqufkuqjnssxxf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        }
      ]
    },
    {
      "id": 1533,
      "name": "Tortalleon Pygmy",
      "description": "The smaller Tortalleons, those too small to sail on, become the Tortun's heavy infantry. The Pygmies are taught to strike with their foreclaws, while standing on their hindlegs and balancing on their tail.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 60,
      "hash": "ej9Dj9CG2BF0Be9AG2Bj9Cj9Demnuziegpsolgrf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 455,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 2 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": false,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            }
          ]
        }
      ]
    },
    {
      "id": 950,
      "name": "Tortalleon Transport",
      "description": "Not all tortalleons are fitted for war: some serve as transport vessels. The average transport can carry 100 tortuns, along with a crew of 10, to any point on Maljara within a day. Some can even travel between continents, but with a lighter load.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 4,
      "damage": 0,
      "hitPoints": 65,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 53,
      "hash": "dj9Cj9BG2Ag3Ae9BJ8GJ8HJ8Ishtzonyxvfmheeg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 2352,
          "apCost": 0,
          "name": "Defensive Turtle",
          "shortDescription": "The first time this champion's HP falls below 50% of its max HP, it becomes <condition value=turtled>Turtled</condition> for 1 turn, then this ability is removed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "turtle"
        },
        {
          "id": 2474,
          "apCost": 0,
          "name": "Font Ignorance",
          "shortDescription": "This unit cannot contest or capture fonts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "font_ignorance"
        },
        {
          "id": 2007,
          "apCost": 0,
          "name": "Helpless",
          "shortDescription": "This champion has <ability value=2002>Easy Target</ability> and <ability value=2001>Defenseless</ability> ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -17,
          "iconName": "defpenalties"
        },
        {
          "id": 3228,
          "apCost": 5,
          "name": "Mass Teleport",
          "shortDescription": "This champion is relocated to target space within 5 spaces. Friendly champions within 2 spaces are also relocated (distributed within the AE).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 12,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2053,
              "apCost": 0,
              "name": "Rallying Cries",
              "shortDescription": "All friendly champions within 3 spaces gain 1 AP at the beginning of your turn.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 1405,
              "apCost": 4,
              "name": "Dive",
              "shortDescription": "This unit is relocated to target water space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_dive"
            },
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1440,
              "apCost": 0,
              "name": "Confuse Attacker",
              "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 1550,
              "apCost": 0,
              "name": "Enduring Aura",
              "shortDescription": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 894,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 2 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            }
          ]
        }
      ]
    },
    {
      "id": 951,
      "name": "Tortun Battle Mystic",
      "description": "\"Their Battle Mystics could divine the arrows and will them to stop. One had explained it to me simply: they carried Eriluun's favor in their hearts and could shield themselves with its power.\" - H'aliel, Priest of K'thir",
      "maxRng": 4,
      "minRng": 2,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2Ag3AF0AJ8HJ8IJ8Jepuoufrlpsszofg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2469,
          "apCost": 0,
          "name": "Elusive",
          "shortDescription": "All ranged attacks against this champion miss if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "elusive"
        },
        {
          "id": 1343,
          "apCost": 0,
          "name": "Mystic Push",
          "shortDescription": "Spell presence of friendly champions is increased by one and champions your enemy controls have their spell presence decreased by one.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "auranegative"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 400,
              "apCost": 3,
              "name": "Force Barrier",
              "shortDescription": "Range 3: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "forcebarrier"
            },
            {
              "default": true,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            }
          ]
        }
      ]
    },
    {
      "id": 1240,
      "name": "Tortun Bokor",
      "description": "\"These Elsari practices are very similar to your forbidden arts.  Go to them and learn all you can.  I sense there is profit to be made.\" Dread Pirate Mangleshell to Bokor Marcus.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Witch"
      ],
      "races": [
        "Tortun",
        "Undead"
      ],
      "noraCost": 75,
      "hash": "eJ8JJ8Ie9Ae9Be9AF0Bj9Fj9Gsmsmwfxiggymuo",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2628,
          "apCost": 0,
          "name": "Cursed Treasure",
          "shortDescription": "When a nora globe within 8 spaces is recovered, opposing champions within 3 spaces of the nora globe becomes <condition value=cursed>Cursed</condition> for 5 turns.  If the champion was already Cursed, it also takes 5 Disease damage.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "cursed_treasure"
        },
        {
          "id": 1850,
          "apCost": 0,
          "name": "Frightful Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "fear_blows"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            },
            {
              "default": false,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            },
            {
              "default": false,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            }
          ]
        }
      ]
    },
    {
      "id": 805,
      "name": "Tortun Broadside",
      "description": "\"We thought he'd gone kissin' fish, taking the cannons right off the deck and heftin' them ashore. Then, he laid waste to a pack o' Kanen, just like that; a cannon under each arm! Now, the blasted lunatic is a hero!\" - Tale of First Mate Greenclaw",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0AG2Be9BJ8GJ8HJ8Iitfgyzmyzvxqowf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 792,
          "apCost": 0,
          "name": "Attack: Cannon",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "artillery"
        },
        {
          "id": 2212,
          "apCost": 0,
          "name": "Banditry",
          "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "banditry"
        },
        {
          "id": 332,
          "apCost": 0,
          "name": "Sunder",
          "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "debuff"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2095,
              "apCost": 0,
              "name": "Combo Attack: Slam",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion is knocked back 2 spaces.\r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "comboatk_slam"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        }
      ]
    },
    {
      "id": 808,
      "name": "Tortun Captain",
      "description": "\"I'll ask ye kindly; would ye please step off my ship? No? Then, perhaps me Flintlockes be doin' the talkin' henceforth.\" - Captain Bregin Longeye of the Leviathan to a pack of boarding Kanen",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 13,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 80,
      "hash": "dJ8IJ8HF0AG2Bf1AJ8Jj9Aj9Buhvoqhplggnjtzg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2251,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "combat_awareness"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1492,
          "apCost": 0,
          "name": "Ready",
          "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "buff"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 2152,
          "apCost": 0,
          "name": "Tortun's Trade",
          "shortDescription": "This ability costs 4 nora to activate.  Target Tortun within 5 spaces gains 2 AP.  Each Tortun may be the target of one Tortun's Trade ability per turn.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 0,
          "iconName": "plunder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3096,
              "apCost": 0,
              "name": "Cull",
              "shortDescription": "This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            }
          ]
        }
      ]
    },
    {
      "id": 807,
      "name": "Tortun Corsair",
      "description": "Every Captain and Admiral, in the Tortun Navy, starts as a Corsair. Corsairs are the most adept fighters, with expertise in swordsmanship and in marksmanship. Bravado comes naturally to the Corsairs.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 71,
      "hash": "dJ8IJ8HF0AG2BF0BJ8IJ8Jj9Ailnwvqolygvxkyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2111,
          "apCost": 1,
          "name": "Pistol Shot",
          "shortDescription": "This unit makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "gun"
        },
        {
          "id": 1009,
          "apCost": 0,
          "name": "Tariff",
          "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "cost"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 2152,
          "apCost": 0,
          "name": "Tortun's Trade",
          "shortDescription": "This ability costs 4 nora to activate.  Target Tortun within 5 spaces gains 2 AP.  Each Tortun may be the target of one Tortun's Trade ability per turn.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 0,
          "iconName": "plunder"
        },
        {
          "id": 3097,
          "apCost": 2,
          "name": "Toss Equipment",
          "shortDescription": "This champion's equipment is destroyed and target unequipped champion within 5 spaces is then equipped with that equipment.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "comboatk_devastate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2172,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": true,
              "id": 2190,
              "apCost": 0,
              "name": "Charged Attack",
              "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "charged_attack"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 810,
      "name": "Tortun Favored",
      "description": "The Favored are priests who have dedicated their lives garnering the favor of the sea goddess, Eriluun. With her love, the Favored are given a special bond to the sea. With a Favored on deck, even the Soshinharg is no challenge.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Priest"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0AG2BG2Aj9Bj9Cj9Dyvowzvfgtofmsfg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 304,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "divine"
        },
        {
          "id": 2671,
          "apCost": 0,
          "name": "Illuminate",
          "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "illuminate"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 883,
              "apCost": 1,
              "name": "Tidal Wave",
              "shortDescription": "Area Effect 2, Range 5: Affected Non-Aquatic, non-Semi-aquatic, and non-Amphibious champions take 12 Physical damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Shallow Water.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "tsunami"
            },
            {
              "default": true,
              "id": 372,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 9 HP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 913,
      "name": "Tortun Fishkisser",
      "description": "Fishkissers are the few infantrytorts deemed too crazy to fight with other forces. Admiral Redjaw utilizes Fishkissers in his famed offensive strategy; the Fishkisser Blitz.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 80,
      "hash": "dJ8IJ8HF0Ag3AG2Aj9Bj9Cj9Dekekuofvhvfiwfg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 751,
          "apCost": 3,
          "name": "Spike Nova",
          "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novaspike"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1609,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 7 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 6,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2837,
              "apCost": 0,
              "name": "Psychotic Break",
              "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "psychotic_break"
            }
          ]
        }
      ]
    },
    {
      "id": 858,
      "name": "Tortun Galesinger",
      "description": "Galesingers have the rare ability of calling to the wind with song. They can summon gales, which drive the Tortalleons onward. A Galesinger can amass huge fortunes, which can create rivalries with the Captains.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 2,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Bard",
        "Priest"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 70,
      "hash": "dj9Dj9CG2BG2Bf1AJ8Jj9Aj9Bgtzvxkwmjplnuhg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 2152,
          "apCost": 0,
          "name": "Tortun's Trade",
          "shortDescription": "This ability costs 4 nora to activate.  Target Tortun within 5 spaces gains 2 AP.  Each Tortun may be the target of one Tortun's Trade ability per turn.  This ability begins on CD.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 0,
          "iconName": "plunder"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2115,
              "apCost": 3,
              "name": "Soothing Serenade",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "soothserenade"
            },
            {
              "default": false,
              "id": 1382,
              "apCost": 0,
              "name": "Prestige",
              "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "iron_will"
            },
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2113,
              "apCost": 2,
              "name": "Demoralizing Descant",
              "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "dreadsong"
            },
            {
              "default": true,
              "id": 2100,
              "apCost": 3,
              "name": "Gale",
              "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "gale"
            },
            {
              "default": false,
              "id": 976,
              "apCost": 4,
              "name": "Battle Hymn",
              "shortDescription": "All friendly champions get <condition value=reverie>Reverie</condition> for 1 turn and recovers 2 AP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 12,
              "iconName": "dancesong"
            }
          ]
        }
      ]
    },
    {
      "id": 811,
      "name": "Tortun Grenadier",
      "description": "\"When it landed, the Kanen stared like they'd never seen a grenade before. It's just a shame I didn't get to see their faces when it went off.\" - Chief Munitions Officer Elddin Longtale",
      "maxRng": 4,
      "minRng": 2,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 69,
      "hash": "dJ8IJ8HF0AG2BG2Bj9Cj9Dj9Eeerumuhtonhiggg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 773,
          "apCost": 1,
          "name": "Fire Bomb",
          "shortDescription": "Area Effect 2, Range 5:  Affected units take Fire damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fireaoe"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 181,
              "apCost": 0,
              "name": "Death Nova: Fire",
              "shortDescription": "When this unit is destroyed, it deals 11 Fire damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovafire"
            },
            {
              "default": false,
              "id": 3085,
              "apCost": 0,
              "name": "Sabotage: Fire",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Fire damage and gains <ability value=88>Vulnerability: Fire</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            },
            {
              "default": false,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            }
          ]
        }
      ]
    },
    {
      "id": 803,
      "name": "Tortun Groundpounder",
      "description": "With Gharivol threatened by Stitched and Kanen, the once-ridiculed Groundpounder is now the staple of the Tortun land forces. Groundpounders carry massive warhammers into battle, breaking the earth with each strike.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 13,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0AG2BE8Dj9Ej9Fj9Gerlusmsosfmuheg",
      "artist": "Simon Dominic",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": true,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": true,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 911,
      "name": "Tortun Gunslinger",
      "description": "Myths have it that a gunslinger could hit a gold coin in midair, during a maelstrom. Although the gunslingers are skilled marksmen, the myth was proven false; a tortun would never fire at a perfectly good piece of gold.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 76,
      "hash": "dJ8IJ8HF0Ag3Af1AJ8Jj9Aj9Bepyvxzzxkyxxxzg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1707,
          "apCost": 0,
          "name": "Ammunition",
          "shortDescription": "Once this champion has made at least 4 successful attacks, its range becomes 1.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "gun"
        },
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 3292,
          "apCost": 0,
          "name": "Reload",
          "shortDescription": "When this champion collects a Nora globe, the counter on its <ability value=1706>Ammunition</ability> ability is reset.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 2325,
          "apCost": 1,
          "name": "Ricochet Shot",
          "shortDescription": "This champion makes a physical attack against target champion. If successful, the nearest other opposing champion within 4 spaces of the target takes 1 physical damage and if that champion takes damage is <condition value=stunned>Stunned</condition> for 2 turns. This damage ignores Defense.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "cannon_barrage"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 363,
              "apCost": 1,
              "name": "Piercing Shot",
              "shortDescription": "This champion makes a ranged attack at +6 DMG and +1 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1620,
      "name": "Tortun Hawker",
      "description": "A hawk makes for a rare and useful pet on the high seas. Dwarven replicas never quite match the real thing.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 68,
      "hash": "ej9Fj9EF0AF0BG2AE8DJ8HJ8Ierzgexfpygilgpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1387,
          "apCost": 0,
          "name": "Assimilate",
          "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "assimilate"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 887,
          "apCost": 1,
          "name": "Hawk Attack",
          "shortDescription": "This unit makes a Physical attack at Range 3-6. If attack is successful, the target is <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "hawk_attack"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        }
      ]
    },
    {
      "id": 953,
      "name": "Tortun Inventor",
      "description": "The Positron Lightning Projection Array does as its inventor describes: one points it at something and blows the target to bloody smithereens. The Tortun Navy restricts the use of PLPAs near bodies of water",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 71,
      "hash": "dj9Cj9BG2Ag3Af1AJ8Jj9Aj9Bilgpyzmemeigphg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2245,
          "apCost": 0,
          "name": "Jolt",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 4 turns.\r\n",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "jolt"
        },
        {
          "id": 2401,
          "apCost": 4,
          "name": "Lightning Skewer",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "electricaoe"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2343,
              "apCost": 3,
              "name": "Paralyze",
              "shortDescription": "Target champion within 3 spaces becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "sentry"
            },
            {
              "default": false,
              "id": 3081,
              "apCost": 0,
              "name": "Sabotage: Electricity",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Electricity damage and gains <ability value=90>Vulnerability: Electricity</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            }
          ]
        }
      ]
    },
    {
      "id": 912,
      "name": "Tortun Minelayer",
      "description": "\"We left a few presents for the slobberyaps. Also, you should mind yer step in the Wilds.\" - Aimen Redeye, Tortun Minelayer",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 68,
      "hash": "dJ8IJ8HF0Ag3Af1Bj9Aj9Bj9Ceerqjinnpjtoleg",
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2296,
          "apCost": 0,
          "name": "Summon: Land Mine",
          "shortDescription": "Summon a Land Mine relic with <ability value=601>Shadowspawn</ability> and <ability value=2149>Land Mine</ability> to target adjacent space.  This ability is hidden.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "landmine"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 837,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +2 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 839,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +6 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 10,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 838,
              "apCost": 1,
              "name": "Explosive Attack",
              "shortDescription": "This unit makes a Fire attack at range at +4 DMG.   If successfully damaged, the target is knocked back 1 space. ",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "knockback"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 444,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 9 Fire Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfire"
            },
            {
              "default": true,
              "id": 1746,
              "apCost": 1,
              "name": "Grant: Lay Trap: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=444>Lay Trap: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 729,
              "apCost": 0,
              "name": "Lay Trap: Boulder",
              "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 10 Physical Damage.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "traprock"
            }
          ]
        }
      ]
    },
    {
      "id": 809,
      "name": "Tortun Mortar",
      "description": "\"The way I saw it, the cannon wasn't that heavy and we needed the firepower. It worked the same, just needed to prop it up when aimin' at a distance. Mobile artillery, some called it; others, lunacy.\" - First Mate Kulagin Greenclaw of the Gygurnaut",
      "maxRng": 7,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Archer"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 70,
      "hash": "dJ8IJ8HF0AG2Bf1Bj9Aj9Bj9Cemwiiwieevouheg",
      "artist": "Anthony Lopes",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2099,
          "apCost": 0,
          "name": "Fire Blast",
          "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Fire damage.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "artillery"
        },
        {
          "id": 1137,
          "apCost": 1,
          "name": "Impact Strike",
          "shortDescription": "Target of this attack takes damage and is knocked back 1 space. Enemy units without flying within 3 spaces of this unit are knocked back 1 space, and take half of the damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 3194,
              "apCost": 0,
              "name": "Ponderous Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target gains <ability value=2093>Ponderous</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "lumbering"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3203,
              "apCost": 0,
              "name": "Slothful",
              "shortDescription": "After using an activated ability (including basic attacks), this champion becomes <ability value=757>Immobile</ability> for 1 turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "slothful"
            },
            {
              "default": false,
              "id": 2012,
              "apCost": 0,
              "name": "Lethargic",
              "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -6,
              "iconName": "lumbering"
            }
          ]
        }
      ]
    },
    {
      "id": 916,
      "name": "Tortun Portalmage",
      "description": "\"The Favored have caught on faster than I thought. I was prepared to spend a season on teleportation, but they're already able to make portals. I'm always surprised how versed these Tortuns are in the advanced magicks.\" - H'aliel, Priest of K'thir",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 0,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Priest",
        "Wizard"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 70,
      "hash": "dJ8JJ8IF0Bg3AE8Dj9Ej9Fj9Geeeeeeilruqqufg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 1443,
          "apCost": 0,
          "name": "Council: Spells",
          "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "special"
        },
        {
          "id": 2303,
          "apCost": 0,
          "name": "Deploy Charged",
          "shortDescription": "When a champion is deployed from the runedock, this unit gains a charge.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 2353,
          "apCost": 1,
          "name": "Grant: Teleport",
          "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "grantability"
        },
        {
          "id": 2188,
          "apCost": 0,
          "name": "Recharge",
          "shortDescription": "Spend 5 Charges. Current cooldowns of this champion's other abilities are reduced by 3.",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 4,
          "iconName": "recharge"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2563,
              "apCost": 3,
              "name": "Flourish",
              "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 3010,
              "apCost": 4,
              "name": "Bubble",
              "shortDescription": "Target friendly champion within 4 spaces without a Buffer gains a <condition value=buffered>Buffer</condition> of 10 HP. Using this ability does not desealth this champion.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "bubble"
            },
            {
              "default": false,
              "id": 657,
              "apCost": 2,
              "name": "Relocate: Ally",
              "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 952,
      "name": "Tortun Repeater",
      "description": "\"Don't worry 'bout the Drakkies, mate. Those are 'eavy Repeaters coverin' our shells. Nothin'll get through them.\" - Corbin Grayshell, Infantrytort on the Gygurnaut",
      "maxRng": 5,
      "minRng": 3,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 78,
      "hash": "dj9Cj9BG2Ag3AF0BJ8IJ8Jj9Agtqqfxmhpwqzzgg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 954,
          "apCost": 0,
          "name": "Attack: Gun",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "gun"
        },
        {
          "id": 1348,
          "apCost": 0,
          "name": "Punish",
          "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "punish"
        },
        {
          "id": 2271,
          "apCost": 0,
          "name": "Sentinel",
          "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": false,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 2285,
              "apCost": 0,
              "name": "Sword Breaker",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, any equipment on that champion is destroyed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "wrecker"
            }
          ]
        }
      ]
    },
    {
      "id": 804,
      "name": "Tortun Slamhammer",
      "description": "Slamhammers are considered the elite Groundpounders, wielding two steel mallets instead of the warhammer. Where a 'Pounder deals in heavy strikes, the Slammer delivers an onslaught of lighter attacks.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 73,
      "hash": "dJ8IJ8HF0AG2Be9Aj9Fj9Gj9Hjinuzilukeepsfg",
      "artist": "Cristian Giraldes",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2094,
          "apCost": 0,
          "name": "Combo Attack: Stun",
          "shortDescription": "When this champion makes two successful basic attacks that deal damage against the same champion in a single turn, that champion becomes <condition value=stunned>Stunned</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "comboatk_rend"
        },
        {
          "id": 109,
          "apCost": 1,
          "name": "Pummel",
          "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "hammer"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1277,
              "apCost": 0,
              "name": "Vindictive",
              "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1170,
      "name": "Totem of the Fallen",
      "description": "\"That is their god?  It explains an awful lot, actually.\" ~ Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Mutant",
        "Skeezick"
      ],
      "noraCost": 77,
      "hash": "ej9Cj9BF0Ae9Ae9AG2AJ8HJ8Ikgphnekyofxqso",
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 1750,
          "apCost": 1,
          "name": "Grant: Tempo",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 371,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "healmass"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 609,
          "apCost": 0,
          "name": "Majestic",
          "shortDescription": "Opposing champions within 2 spaces of this unit are <condition value=awestruck>Awestruck</condition>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "majestic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2560,
              "apCost": 0,
              "name": "Guarded: Skeezick",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Skeezick within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2436,
              "apCost": 2,
              "name": "Mutate",
              "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "mutation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2554,
              "apCost": 0,
              "name": "Skeezick Rapture",
              "shortDescription": "Friendly Skeezick within 6 spaces have <ability value=539>Attack: Acid</ability> and <ability value=2491>Scour rank 1</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 1401,
              "apCost": 0,
              "name": "Acidic Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_acid"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        }
      ]
    },
    {
      "id": 1750,
      "name": "Totem of the Hat",
      "description": "\"Now they even decorate the thing? And here I thought I was twisted.\" - Xulos, Undead Sage",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God"
      ],
      "races": [
        "Mutant",
        "Skeezick"
      ],
      "noraCost": 78,
      "hash": "eJ8JJ8IE8Df1BG2AF0Bj9Ej9Fygygnwofepnsoqf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 1750,
          "apCost": 1,
          "name": "Grant: Tempo",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 2,
          "iconName": "grantability"
        },
        {
          "id": 371,
          "apCost": 3,
          "name": "Heal Mass",
          "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "healmass"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 609,
          "apCost": 0,
          "name": "Majestic",
          "shortDescription": "Opposing champions within 2 spaces of this unit are <condition value=awestruck>Awestruck</condition>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "majestic"
        },
        {
          "id": 2554,
          "apCost": 0,
          "name": "Skeezick Rapture",
          "shortDescription": "Friendly Skeezick within 6 spaces have <ability value=539>Attack: Acid</ability> and <ability value=2491>Scour rank 1</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2560,
              "apCost": 0,
              "name": "Guarded: Skeezick",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Skeezick within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2436,
              "apCost": 2,
              "name": "Mutate",
              "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "mutation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2554,
              "apCost": 0,
              "name": "Skeezick Rapture",
              "shortDescription": "Friendly Skeezick within 6 spaces have <ability value=539>Attack: Acid</ability> and <ability value=2491>Scour rank 1</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 1401,
              "apCost": 0,
              "name": "Acidic Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_acid"
            },
            {
              "default": true,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        }
      ]
    },
    {
      "id": 258,
      "name": "Tracker Gnark",
      "description": "Don't worry...I won't need help. Once my pets catch the scent of blood you'll realize why no one fights with Gnark and wins. - Tracker Gnark addressing the Frost Queen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 81,
      "hash": "dJ8IJ8HF0AF0Ae9BJ8GJ8HJ8Iilemjyzipyinuvf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 846,
          "apCost": 1,
          "name": "Entangle",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "net"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 924,
          "apCost": 0,
          "name": "Swarm: Snowcat",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Snowcat champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "swarm_cat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2626,
              "apCost": 0,
              "name": "Scrapper",
              "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "scrapper"
            },
            {
              "default": false,
              "id": 2153,
              "apCost": 0,
              "name": "Combo Attack: Declare Target",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes Declared as Target for 1 turn (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "comboatk_drain"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            },
            {
              "default": true,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 1371,
      "name": "Tracker Gnark",
      "description": "Don't worry...I won't need help. Once my pets catch the scent of blood you'll realize why no one fights with Gnark and wins. - Tracker Gnark addressing the Frost Queen",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Lonx"
      ],
      "noraCost": 81,
      "hash": "ej9Bj9Af1BF0Ae9Af1Bj9Aj9Bzoygpyxzipqhipf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 846,
          "apCost": 1,
          "name": "Entangle",
          "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "net"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 924,
          "apCost": 0,
          "name": "Swarm: Snowcat",
          "shortDescription": "When this champion destroys a champion on a basic attack, a Snowcat champion with no upgrades is summoned under your control in the location the destroyed champion occupied.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "swarm_cat"
        },
        {
          "id": 2855,
          "apCost": 0,
          "name": "Warm and Fuzzy",
          "shortDescription": "This unit is warm and fuzzy.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "furring"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2626,
              "apCost": 0,
              "name": "Scrapper",
              "shortDescription": "When this champion makes a successful basic attack, it gains <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "scrapper"
            },
            {
              "default": false,
              "id": 2153,
              "apCost": 0,
              "name": "Combo Attack: Declare Target",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes Declared as Target for 1 turn (This champion has been declared as a target. Enemy champions that attack it gain 3 AP on the first successful attack per turn).",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "comboatk_drain"
            },
            {
              "default": true,
              "id": 1901,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            },
            {
              "default": true,
              "id": 316,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "whirl"
            }
          ]
        }
      ]
    },
    {
      "id": 600,
      "name": "Trap Spider",
      "description": "The spiders of Sheoul are cunning. They often create intricate tunnels in the rock floors. With these in place, they can easily capture their prey, regardless of where it waits.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 74,
      "hash": "dj9Bj9Af1Bf1BF0AJ8HJ8IJ8Jeerlnlpytqufrzg",
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 728,
          "apCost": 0,
          "name": "Lay Trap: Boulder",
          "shortDescription": "Lay a Boulder Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 7 Physical Damage.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "traprock"
        },
        {
          "id": 1800,
          "apCost": 4,
          "name": "Tunnel Trap",
          "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> and moves directly to target space within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "traprock"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2492,
              "apCost": 0,
              "name": "Scour",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=scoured>Scoured</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "scour"
            },
            {
              "default": true,
              "id": 168,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_poison"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 443,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Fire Damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "trapfire"
            },
            {
              "default": false,
              "id": 2997,
              "apCost": 0,
              "name": "Lay Trap: Acid",
              "shortDescription": "Lay an Acid Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 4 Acid Damage and becomes <condition value=scoured>Scoured</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "trapthorn"
            }
          ]
        }
      ]
    },
    {
      "id": 1626,
      "name": "Treasure Hunter",
      "description": "\"No, sir! This isn't garbage. You never know what you are going to find!\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Tinkerer"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 61,
      "hash": "ej9Gj9Fe9AF0BG2Ae9Aj9Fj9Gevxftssowfvmyrf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2212,
          "apCost": 0,
          "name": "Banditry",
          "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "banditry"
        },
        {
          "id": 3024,
          "apCost": 2,
          "name": "Teleport: Equipped",
          "shortDescription": "This champion is relocated to target equipped champion within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "relocate_equipped"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1253,
              "apCost": 2,
              "name": "Ruin",
              "shortDescription": "Target relic within 3 spaces is destroyed. If the relic was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Shatter).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "terraingrass"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3140,
              "apCost": 3,
              "name": "Detonate Relic",
              "shortDescription": "Target relic within 3 spaces is destroyed.  Other champions within 2 spaces of the relic take 12 Fire damage (ignores DEF).  If the target is a friendly relic, the CD of this ability is set to 2.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 5,
              "iconName": "reclaim_materials"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 443,
      "name": "Tree Spider",
      "description": "These trees hold more than leaves. We have many more allies in this fight! - Godwin, Elder Garu",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 5,
      "damage": 9,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 70,
      "hash": "dJ8HJ8Ge9Bf1Ae9BJ8GJ8HJ8Izgknpqonuxxituf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1232,
          "apCost": 0,
          "name": "Habitation",
          "shortDescription": "This champion gets +1 DEF, +1 DMG and +1 SPD for each font you control.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "buff"
        },
        {
          "id": 1200,
          "apCost": 0,
          "name": "Hunter: Flying",
          "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "gale"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1698,
              "apCost": 0,
              "name": "Widowmaker",
              "shortDescription": "This unit makes an attack for 0 AP against any adjacent opposing champion with 30% or less of its HP remaining.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "stab"
            },
            {
              "default": false,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 730,
              "apCost": 1,
              "name": "Poison Sting",
              "shortDescription": "This champion makes a Poison attack at Range 2-5.  If the target is successfully damaged, it becomes<condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "poison"
            },
            {
              "default": true,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            },
            {
              "default": false,
              "id": 3332,
              "apCost": 1,
              "name": "Vine Whip",
              "shortDescription": "This champion makes a Physical attack at RNG 2-5. If the target is occupying Vegetation, <condition value=ensnared>Ensnared</condition> or <condition value=rooted>Rooted</condition> and is successfully damaged, the target also becomes <condition value=burred>Burred</condition> for 3 turns and <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "drive"
            }
          ]
        }
      ]
    },
    {
      "id": 846,
      "name": "Tremir Craghide",
      "description": "\"There's two things you need to know about the Captain Craghide. First, never get on his bad side, he's got the temper of a leviathan. Second, never make a bet with him, he always wins.\" - First Mate Kulagin Greenclaw of the Gygurnaut",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 14,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 84,
      "hash": "dj9Cj9BG2AG2BF0AJ8HJ8IJ8Jumwtfvmygthileg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2231,
          "apCost": 0,
          "name": "Cannon Barrage",
          "shortDescription": "Spend 6 charges. Area Effect 2, Range 5: For each friendly real Tortun (up to 5), a random space is targeted by an AE1 Cannon Ball effect.  Units affected by the Cannon Ball effect take 10 Physical damage (this damage ignores DEF).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "cannon_barrage"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 2262,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3089,
              "apCost": 0,
              "name": "Initiator",
              "shortDescription": "This champion deals 4 additional damage to champions with 35 or more HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiator"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 893,
      "name": "Tremir Craghide",
      "description": "\"There's two things you need to know about the Captain Craghide. First, never get on his bad side. He's got the temper of a leviathan. Second, never make a bet with him. He always wins.\" - First Mate Kulagin Greenclaw of the Gygurnaut",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 14,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Tortun"
      ],
      "noraCost": 84,
      "hash": "dJ8HJ8Ge9Bg3Ae9Aj9Fj9Gj9Hqoygrukeerjgneg",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2231,
          "apCost": 0,
          "name": "Cannon Barrage",
          "shortDescription": "Spend 6 charges. Area Effect 2, Range 5: For each friendly real Tortun (up to 5), a random space is targeted by an AE1 Cannon Ball effect.  Units affected by the Cannon Ball effect take 10 Physical damage (this damage ignores DEF).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "cannon_barrage"
        },
        {
          "id": 2190,
          "apCost": 0,
          "name": "Charged Attack",
          "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "charged_attack"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        },
        {
          "id": 2929,
          "apCost": 0,
          "name": "Tortun Shell",
          "shortDescription": "This champion has <ability value=2093>Ponderous</ability>, <ability value=2>Amphibious</ability>, <ability value=647>Turtle</ability> and <ability value=3161>Stability</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "turtle"
        },
        {
          "id": 2262,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1241,
              "apCost": 0,
              "name": "Motivate",
              "shortDescription": "All other friendly champions have +1 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3089,
              "apCost": 0,
              "name": "Initiator",
              "shortDescription": "This champion deals 4 additional damage to champions with 35 or more HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiator"
            },
            {
              "default": false,
              "id": 2652,
              "apCost": 0,
              "name": "Opportunistic",
              "shortDescription": "At the end of your opponent's turn, if this champion was not successfully attacked that turn, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "opportunistic"
            },
            {
              "default": true,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 1719,
      "name": "Truthseeker",
      "description": "Some seek flame, others glory, but some journey for one thing: the truth.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 75,
      "hash": "ej9Dj9CG2Af1AG2AG2Bj9Bj9Ceigpnexiluzgtsf",
      "artist": "Grant Griffin",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 867,
          "apCost": 0,
          "name": "Blessed",
          "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 3222,
          "apCost": 0,
          "name": "Quest: Crusade",
          "shortDescription": "The first time this champion moves within 3 spaces of an enemy avatar, shrine or font, it is healed for 25 HP and permanently gains +1 DEF, +2 DMG and <ability value=2276>Inquisition</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "opportunistic"
        },
        {
          "id": 3234,
          "apCost": 2,
          "name": "Truthseeker",
          "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=branded>Branded</condition> or <ability value=2004>Faithless</ability> and gains +2 SPD for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate_lightning"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2619,
              "apCost": 0,
              "name": "Zeal: Speed",
              "shortDescription": "When this champion makes a successful basic attack, it gains +1 SPD for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "channel_speed"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            },
            {
              "default": true,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            }
          ]
        }
      ]
    },
    {
      "id": 1659,
      "name": "Tsaz, Circadian Templar",
      "description": "The Circadians have long set themselves apart from the rest of the Swamp, preferring to stay within the confines of the Emerald Lake.  So their recent insistence at being included has been viewed with great suspicion by others who call Forglar home.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Mirefolk"
      ],
      "noraCost": 71,
      "hash": "ej9AJ8JG2BF0BG2Af1Aj9Cj9Degvosfigtfmjgrf",
      "artist": "Paul Guzenko",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2593,
          "apCost": 0,
          "name": "Mirefolk Resurgence",
          "shortDescription": "When this unit is deployed, friendly champions gain 1 AP. If the affected champion is a Mirefolk, it also gains +2 DMG for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "mirefolk_revival"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 2063,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "rebuke"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 355,
              "apCost": 1,
              "name": "Defensive Stance",
              "shortDescription": "This champion has -2 DMG and +3 DEF for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 83,
      "name": "Tundra Barbarian",
      "description": "The Barbs are as good as family. They love their home as we do and are willing to fight for it. - Rugolth",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 13,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 67,
      "hash": "cj9Dj9Cj9BG2Ae9Bj9Bj9Cj9Dwoumuvkuvqhkufi",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2092,
          "apCost": 3,
          "name": "Crushing Charge",
          "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "crush"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": true,
              "id": 2819,
              "apCost": 0,
              "name": "Catalyst: Frost",
              "shortDescription": "When this unit is successfully attacked by a basic attack, all opposing champions within 3 spaces take 4 Frost damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 775,
              "apCost": 0,
              "name": "Chill",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=chilled>Chilled</condition> for 4 turns.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_chill"
            },
            {
              "default": true,
              "id": 1131,
              "apCost": 0,
              "name": "Ally: Savage Tundra",
              "shortDescription": "While there are other friendly Savage Tundra champions in play, this champion gets +7 HP and +2 DMG. Savage Tundra champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_st"
            }
          ]
        }
      ]
    },
    {
      "id": 1246,
      "name": "Tundra Whisper",
      "description": "The spirit of the Tundra heeds the call of those who have cared and protected it.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental",
        "Spirit"
      ],
      "noraCost": 72,
      "hash": "eJ8JJ8IG2Ae9Be9AF0Bj9Bj9Ceeeeemhvvkwkyo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1737,
          "apCost": 0,
          "name": "Ethereal",
          "shortDescription": "This champion begins play <condition value=incorporeal>Incorporeal</condition> for 2 turns and becomes Incorporeal for 2 turns at the start of each of your other turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "ethereal"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 2641,
          "apCost": 3,
          "name": "Three Wishes",
          "shortDescription": "Target champion within 3 spaces gains both of this units selected upgrade abilities. This ability is removed after 3 uses.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "fascinate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1,
              "apCost": 0,
              "name": "Flight",
              "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "flight"
            },
            {
              "default": false,
              "id": 2329,
              "apCost": 0,
              "name": "Revere: Zeventrech",
              "shortDescription": "While this champion is in play, Zeventrech the Last costs 10% less nora to deploy. While Zeventrech the Last is in play, this champion gains <ability value=1131>Ally: Savage Tundra</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": true,
              "id": 1271,
              "apCost": 0,
              "name": "Tempo",
              "shortDescription": "When a spell is successfully cast, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dancesong"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 120,
      "name": "Tundra Yeti",
      "description": "Something tells me 'diplomacy' isn't one of their words... do they have words? Ceyana, Deep Elf Mercenary",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 70,
      "hash": "dj9Gj9Fe9Ae9Ae9BJ8GJ8HJ8Ijwzmsoyonhevmwf",
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2704,
          "apCost": 0,
          "name": "Crushing Blow",
          "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "shrink"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": true,
              "id": 1900,
              "apCost": 0,
              "name": "Tough",
              "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 344,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +6 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hammer"
            },
            {
              "default": true,
              "id": 1374,
              "apCost": 0,
              "name": "Resolute",
              "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            }
          ]
        }
      ]
    },
    {
      "id": 507,
      "name": "Turret Team",
      "description": "The Turret Team was meant for Stronghold defense, but intense training gave them mobility for the battlefield.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Dwarf"
      ],
      "noraCost": 68,
      "hash": "dj9Dj9CG2Bf1AE8Dj9Ej9Fj9Gemjineevqhirshg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1528,
          "apCost": 1,
          "name": "Fire Turret",
          "shortDescription": "This unit makes a Fire attack at RNG 2-7.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "fire"
        },
        {
          "id": 1529,
          "apCost": 1,
          "name": "Frost Turret",
          "shortDescription": "This unit makes a Frost attack at RNG 2-7.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "ice"
        },
        {
          "id": 565,
          "apCost": 0,
          "name": "Siege",
          "shortDescription": "This champion deals double damage against relics.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "shrinebad"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 689,
              "apCost": 0,
              "name": "Lockdown",
              "shortDescription": "All units within 5 spaces have <ability value=669>Earthbound</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1237,
              "apCost": 0,
              "name": "Impenetrable",
              "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ironwill"
            },
            {
              "default": true,
              "id": 3199,
              "apCost": 0,
              "name": "Raider",
              "shortDescription": "You gain 4 nora when an enemy relic is destroyed.  If the relic was Summoned, you gain 2 nora instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "raider"
            }
          ]
        }
      ]
    },
    {
      "id": 523,
      "name": "Turtle Rider",
      "description": "The boghoppers had tamed the elder tortoises of Forglar. It took many months to learn to ride them.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Beast",
        "Boghopper"
      ],
      "noraCost": 75,
      "hash": "dj9Ej9Dg3Af1Af1AJ8Jj9Aj9Bmsxkerqjtsuqqhg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1410,
          "apCost": 0,
          "name": "Boghopper Rider",
          "shortDescription": "When this unit is destroyed, no nora globe is dropped and a Boghopper with no upgrades is spawned in the location this unit occupied.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "rider"
        },
        {
          "id": 2576,
          "apCost": 1,
          "name": "Throw Javelin",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "spear"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        },
        {
          "id": 3064,
          "apCost": 0,
          "name": "Weighty",
          "shortDescription": "When this champion has moved 3 spaces via normal movement, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "weighty"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1325,
              "apCost": 0,
              "name": "Domain: Water",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Water.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_water"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 114,
              "apCost": 0,
              "name": "Aquatic",
              "shortDescription": "This unit has <ability value=2>Amphibious</ability>. While occupying Water, this champion gets +1 SPD and has <ability value=6>Mobility</ability>. When moving to a location that is not at least half water, there is an additional 1 AP cost unless it is <condition value=flying>Flying</condition>. At the beginning of your turn, if this champion is not occupying Water, it loses 5 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": -10,
              "iconName": "aquatic"
            },
            {
              "default": true,
              "id": 2,
              "apCost": 0,
              "name": "Amphibious",
              "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "amphib"
            },
            {
              "default": false,
              "id": 859,
              "apCost": 0,
              "name": "Semi Aquatic",
              "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "semiaquatic"
            }
          ]
        }
      ]
    },
    {
      "id": 997,
      "name": "Tusk",
      "description": "\"Tusk and I have an understanding; I scratch his back, and he runs everything over.\" - Azaren",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 4,
      "damage": 8,
      "hitPoints": 40,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 56,
      "hash": "ej9Dj9Cg3AE8De9AG2Bj9Dj9Eeigpfmnytjiyxqf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2213,
          "apCost": 0,
          "name": "Crazed Charger",
          "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crazed_charger"
        },
        {
          "id": 6,
          "apCost": 0,
          "name": "Mobility",
          "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mobility"
        },
        {
          "id": 46,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 20% (after DEF, rounded up).",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "resistance_physical"
        },
        {
          "id": 1799,
          "apCost": 0,
          "name": "Trample",
          "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            },
            {
              "default": true,
              "id": 51,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "resistance_magic"
            },
            {
              "default": false,
              "id": 50,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 20% (after DEF, rounded up).",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 82,
              "apCost": 0,
              "name": "Resistance: Psychic",
              "shortDescription": "When this unit takes Psychic damage, that damage is reduced by 20% (after DEF, rounded up).",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "resistance_psychic"
            },
            {
              "default": true,
              "id": 83,
              "apCost": 0,
              "name": "Resistance: Psychic",
              "shortDescription": "When this unit takes Psychic damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "resistance_psychic"
            },
            {
              "default": false,
              "id": 84,
              "apCost": 0,
              "name": "Resistance: Psychic",
              "shortDescription": "When this unit takes Psychic damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "resistance_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 1874,
      "name": "Tusk the White",
      "description": "\"Tusk and I have an understanding; I scratch his back, and he runs everything over.\" - Azaren",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 4,
      "damage": 8,
      "hitPoints": 40,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 56,
      "hash": "ej9Dj9Ce9AG2BG2AG2Bj9Fj9Gkuvhpyoymwvzvsf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 2213,
          "apCost": 0,
          "name": "Crazed Charger",
          "shortDescription": "When this champion activates <ability value=394>Charge</ability>, it's CD is set to 0.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "crazed_charger"
        },
        {
          "id": 6,
          "apCost": 0,
          "name": "Mobility",
          "shortDescription": "This champion may disengage the turn it becomes <condition value=engaged>Engaged</condition>, and disengages for 0 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "mobility"
        },
        {
          "id": 46,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 20% (after DEF, rounded up).",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "resistance_physical"
        },
        {
          "id": 1799,
          "apCost": 0,
          "name": "Trample",
          "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "crush"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 52,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "resistance_magic"
            },
            {
              "default": true,
              "id": 51,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "resistance_magic"
            },
            {
              "default": false,
              "id": 50,
              "apCost": 0,
              "name": "Resistance: Magical",
              "shortDescription": "When this unit takes Magical damage, that damage is reduced by 20% (after DEF, rounded up).",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 82,
              "apCost": 0,
              "name": "Resistance: Psychic",
              "shortDescription": "When this unit takes Psychic damage, that damage is reduced by 20% (after DEF, rounded up).",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 0,
              "iconName": "resistance_psychic"
            },
            {
              "default": true,
              "id": 83,
              "apCost": 0,
              "name": "Resistance: Psychic",
              "shortDescription": "When this unit takes Psychic damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 1,
              "iconName": "resistance_psychic"
            },
            {
              "default": false,
              "id": 84,
              "apCost": 0,
              "name": "Resistance: Psychic",
              "shortDescription": "When this unit takes Psychic damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "resistance_psychic"
            }
          ]
        }
      ]
    },
    {
      "id": 1639,
      "name": "Twilight Creeper",
      "description": "Serkan resented the Creepers for their cost in bodies and resources, but Xulos considered it a small price to pay for continued research.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Worm"
      ],
      "noraCost": 69,
      "hash": "eJ8HJ8GG2BF0BG2Ae9Bj9Cj9Deexvxowmnnusoqf",
      "artist": "Rogier van de Beek",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 2526,
          "apCost": 0,
          "name": "Necrosis",
          "shortDescription": "When this champion is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> expands by 1.  When a champion without Race: Worm or Necrosis is deployed from the runedock, your shrine's <mechanic value=deployment_zone>Deployment Zone</mechanic> decreases by 1 (this does not stack).",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            },
            {
              "default": false,
              "id": 1760,
              "apCost": 0,
              "name": "Impatient",
              "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "impatient"
            },
            {
              "default": true,
              "id": 563,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2678,
              "apCost": 3,
              "name": "Binding Chains",
              "shortDescription": "Enemy champions within 3 spaces take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "disable"
            }
          ]
        }
      ]
    },
    {
      "id": 1425,
      "name": "Twisted Fireoak",
      "description": "Cursed long ago by Grimlic, it prefers to burn in peace.\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9Ef1AF0Be9AE8DJ8Jj9Aeemwtqojrhvszo",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 3371,
          "apCost": 0,
          "name": "Fireoak Snare",
          "shortDescription": "At the end of its turn, enemy champions within 2 spaces take 4 Fire damage and are <condition value=inhibited>Inhibited</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "frostvine_snare"
        },
        {
          "id": 1120,
          "apCost": 4,
          "name": "Set Ablaze",
          "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "fire"
        },
        {
          "id": 2233,
          "apCost": 0,
          "name": "Stationary",
          "shortDescription": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "lumbering"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 407,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 6 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 10,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 408,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 7 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 14,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1852,
              "apCost": 4,
              "name": "Tunnel: Lava",
              "shortDescription": "This unit is relocated to target Lava space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_lava"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2710,
              "apCost": 0,
              "name": "Stat Bonus: Range",
              "shortDescription": "This champion gains +1 MAX RNG.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusrange"
            },
            {
              "default": false,
              "id": 3348,
              "apCost": 0,
              "name": "Underdepths Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charred>Charred</condition>, <condition value=bloodied>Bloodied</condition> or <condition value=frightened>Frightened</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": false,
              "id": 538,
              "apCost": 0,
              "name": "Fire Eater",
              "shortDescription": "This champion moves unimpeded over Lava. When this champion would take Fire damage, it instead heals HP equal to half the damage that would have been dealt. This champion may not become <condition value=charred popup=false>Charred</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1725,
      "name": "Twisted Frostvine",
      "description": "The pressure from the Nefari offensive forced some life further north. Nature, as always, manages to adapt and endure.",
      "maxRng": 4,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Plant",
        "Treefolk"
      ],
      "noraCost": 79,
      "hash": "ej9Ej9Df1Bf1AG2Ag3Aj9Aj9Bqolpyrwievoftsf",
      "artist": "Caio Monteiro",
      "factions": [
        "K'thir Forest",
        "Savage Tundra"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 3207,
          "apCost": 0,
          "name": "Frostvine Snare",
          "shortDescription": "At the end of its turn, enemy champions within 2 spaces take 4 Frost damage and are <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "frostvine_snare"
        },
        {
          "id": 2233,
          "apCost": 0,
          "name": "Stationary",
          "shortDescription": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "lumbering"
        },
        {
          "id": 1087,
          "apCost": 2,
          "name": "Take Root",
          "shortDescription": "This champion loses Take Root and gains Uproot, <ability value=655>Skirmisher</ability>, <mechanic value=immobile>Immobile</mechanic>, <ability value=106>Camouflage</ability>, and <ability value=15>Multiattack 1</ability>. It also gains +2 DMG, +2 DEF, +5 MAX HP, and +1 MAX RNG.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plantregen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": true,
              "id": 384,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 9 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 452,
              "apCost": 0,
              "name": "Lay Trap: Frost",
              "shortDescription": "Lay a Frost Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Frost Damage and becomes <mechanic value=slowed>Slowed</mechanic> for 4 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "trapfrost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 752,
              "apCost": 4,
              "name": "Tunnel: Snow",
              "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_snow"
            },
            {
              "default": true,
              "id": 408,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 7 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 14,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 407,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 6 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 10,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1649,
      "name": "Two-Headed Kanen",
      "description": "\"That counts twice.\" -- Mosharn the Barricade",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 55,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Kanen"
      ],
      "noraCost": 79,
      "hash": "eJ8JJ8IE8DF0BG2AF0Bj9Ej9Feeeepjrlrukukpf",
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1504,
          "apCost": 0,
          "name": "Brutality",
          "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "surge"
        },
        {
          "id": 2785,
          "apCost": 0,
          "name": "Call of the Hunter",
          "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 2146,
          "apCost": 0,
          "name": "Pack Leader",
          "shortDescription": "The first time this champion makes a basic attack against a champion each turn, other champions with <ability value=1938>Pack Mentality</ability> within melee range of the target make a free Physical attack against the same target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "pack_leader"
        },
        {
          "id": 1363,
          "apCost": 0,
          "name": "Unleash",
          "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "unleashed"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 2097,
              "apCost": 0,
              "name": "Combo Attack: Rend",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, that champion becomes <condition value=eviscerated>Eviscerated</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2098,
              "apCost": 0,
              "name": "Combo Attack: Drain",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, this unit heals an amount equal to the damage done on the second attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "comboatk_drain"
            },
            {
              "default": true,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        }
      ]
    },
    {
      "id": 1445,
      "name": "Umbral Wulf",
      "description": "In ages past, there lived  a mage that would \"banish\" foes using magic that was not completely understood. These creatures have begun to emerge in this age, and are now able to walk between planes of existence. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Spirit",
        "Undead"
      ],
      "noraCost": 75,
      "hash": "eJ8HJ8GE8DF0Be9Ae9Bj9Ej9Feepjinpytmyxmn",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 1245,
          "apCost": 0,
          "name": "Phase Cleansing",
          "shortDescription": "When this champion becomes <condition value=incorporeal popup=false>Incorporeal</condition>, it is <mechanic value=cleansed>Cleansed</mechanic>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "blessed"
        },
        {
          "id": 2909,
          "apCost": 2,
          "name": "Terrorize",
          "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "ignore_invite"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            },
            {
              "default": true,
              "id": 2570,
              "apCost": 0,
              "name": "Surge: Spirit",
              "shortDescription": "This unit has +1 DMG for each friendly Spirit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_spirit"
            },
            {
              "default": false,
              "id": 2991,
              "apCost": 4,
              "name": "Soulwrack",
              "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "soulwrack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": true,
              "id": 1783,
              "apCost": 0,
              "name": "Subsume",
              "shortDescription": "When this unit is the target of an opponent's spell or abilities (excluding basic attacks), it is healed for 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "blessed"
            }
          ]
        }
      ]
    },
    {
      "id": 1578,
      "name": "Undead Crone",
      "description": "The Undead Crone is recognized by the distinctive screech that seems to echo hollowly no matter where she is when awoken.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Kanen",
        "Undead"
      ],
      "noraCost": 69,
      "hash": "ej9Dj9CE8De9BG2AG2Bj9Ej9Fwiirqzmuzkgvxqf",
      "artist": "Alex Brock",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 594,
          "apCost": 0,
          "name": "Energy Thief",
          "shortDescription": "When a non-illusion champion moves within 2 spaces of this champion, that champion loses 1 AP and this champion gains 1 AP. At the beginning of your turn, each champion within 2 spaces loses 1 AP, and then this champion gains 1 AP for each AP lost this way.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": true,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1619,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "terrain_dmz"
            },
            {
              "default": false,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        }
      ]
    },
    {
      "id": 876,
      "name": "Undead Magister",
      "description": "\"The corpse was dressed in a Magister's robe and it stood no taller than I. Priestess Yorin tried to cast a spell on it, but the corpse resisted. It advanced on us, silently.\" - Thomroy, Priest of Ironfist",
      "maxRng": 4,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Dwarf",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 73,
      "hash": "dj9Fj9EE8Dg3AF0AJ8HJ8IJ8Jeeeeplpssuhpuzg",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2187,
          "apCost": 0,
          "name": "Counterspell Mastery",
          "shortDescription": "When an opponent casts a spell, if this unit has at least 6 charges, this champion loses all charges and the spell fails.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "counterspell_mastery"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 2353,
          "apCost": 1,
          "name": "Grant: Teleport",
          "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "grantability"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 2176,
              "apCost": 0,
              "name": "Spell Charged",
              "shortDescription": "When a spell is played, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "charged_spell"
            },
            {
              "default": true,
              "id": 2172,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "charged_death"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 543,
      "name": "Undertortoise",
      "description": "Ancient texts speak of this goliath and its expertise with a \"heacy crosboew.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 5,
      "damage": 8,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 72,
      "hash": "dj9Gj9Fe9Af1BG2Aj9Bj9Cj9Dwmphnpyxmhpqqhg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1242,
          "apCost": 0,
          "name": "Pace",
          "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "initiative"
        },
        {
          "id": 647,
          "apCost": 3,
          "name": "Turtle",
          "shortDescription": "This unit becomes <condition value=impervious>Impervious</condition>, <condition value=immobile>Immobile</condition> and <condition value=pacified>Pacified</condition> and has an AP cap of 0 for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "turtle"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 1899,
              "apCost": 0,
              "name": "Scale Armor",
              "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "scale_armor"
            },
            {
              "default": true,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 1409,
      "name": "Unhinged Bok",
      "description": "Some did not handle Grimlic's depature well\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Archdemon"
      ],
      "noraCost": 77,
      "hash": "ej9Fj9Ee9BF0Be9AE8DJ8GJ8Heevvoftxonumnn",
      "artist": "Mazert Young",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 474,
          "apCost": 1,
          "name": "Blood Rage",
          "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "rend"
        },
        {
          "id": 3031,
          "apCost": 0,
          "name": "Imposing Aura",
          "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "imposing_aura"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        },
        {
          "id": 3158,
          "apCost": 0,
          "name": "Reckless",
          "shortDescription": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "reckless"
        },
        {
          "id": 3380,
          "apCost": 0,
          "name": "Sanguine Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has <ability value=3379>Magic Ward</ability> and <ability value=977>Bleed</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 2435,
              "apCost": 0,
              "name": "Bloodtracker",
              "shortDescription": "When this unit is deployed, the nearest opposing champion becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=bloodied>Bloodied</condition>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        }
      ]
    },
    {
      "id": 877,
      "name": "Utterdark Fadewisp",
      "description": "\"Oh, the things that lurk in the Utterdark. If only you could see them, Xulos. If only you could know the horrors I conjure from that place!\" - Serkan, Lich King",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Spirit",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "dj9Fj9EE8Dg3AF0BJ8IJ8Jj9Akukpqjgympqhieg",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 1206,
          "apCost": 0,
          "name": "Cripple",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "debuff"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1966,
              "apCost": 0,
              "name": "Rotting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=decaying>Decaying</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "disease"
            },
            {
              "default": false,
              "id": 167,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 3 turns.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1504,
      "name": "Utterdark Leviathan",
      "description": "\"One cannot reason with death, only pray it is swift when it comes.\" - Jakei Disciple",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dragon",
        "Spirit",
        "Undead"
      ],
      "noraCost": 75,
      "hash": "ej9AJ8Jg3AF0Be9Af1Aj9Dj9Eeevklrwkplwztqf",
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 51,
          "apCost": 0,
          "name": "Resistance: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is reduced by 35% (after DEF, rounded up).",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "resistance_magic"
        },
        {
          "id": 3013,
          "apCost": 0,
          "name": "Soultap Feedback",
          "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "soultap_feedback"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            },
            {
              "default": true,
              "id": 2991,
              "apCost": 4,
              "name": "Soulwrack",
              "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "soulwrack"
            },
            {
              "default": false,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 745,
      "name": "Utterdark Planeshift",
      "description": "It clutched his arm, spattering black mess into his face as it hissed. The creature began to slither back into the tear it came from, pulling the Garu along. Before R`ontun could nock his arrow, both had vanished.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 71,
      "hash": "dj9Dj9CG2BG2AE8Dj9Ej9Fj9Geiljtosmssxvfig",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 324,
          "apCost": 0,
          "name": "Constriction",
          "shortDescription": "This champion makes a melee attack against target opposing champion.  If successful, the target takes 50% damage and becomes Constricted 3 (This Champion may not move, activate special abilities, or attack units other than this one, and takes 5 Physical damage at the beginning of each turn).",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "constriction"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 1376,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 20% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "resistance_ranged"
            },
            {
              "default": false,
              "id": 3013,
              "apCost": 0,
              "name": "Soultap Feedback",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "soultap_feedback"
            }
          ]
        }
      ]
    },
    {
      "id": 1636,
      "name": "Utterdark Shadecaster",
      "description": "Well-trained members of the Inquisition didn't jump at shadows. They would pay dearly for their discipline. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 70,
      "hash": "eJ8HJ8GF0BF0BG2Ae9BJ8IJ8Jeepfxknetxtjto",
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 3152,
          "apCost": 0,
          "name": "Portal Siphon",
          "shortDescription": "When this champion is successfully relocated, enemy champions within 2 spaces lose 2 HP and this champion vampiric heals for an equal amount.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3265,
              "apCost": 0,
              "name": "Portal Watcher",
              "shortDescription": "When a friendly champion relocates (including this one), this champion gains +1 DMG and a rank of <ability value=15>Multiattack</ability> for 1 turn. This can stack up to 3 times.",
              "activationType": 3,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 820,
              "apCost": 4,
              "name": "Portal",
              "shortDescription": "This unit may teleport to any deployment zone its controller controls.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 3251,
              "apCost": 0,
              "name": "Portal Blast",
              "shortDescription": "When this champion is successfully relocated, adjacent champions are knocked back 2 spaces.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2281,
              "apCost": 0,
              "name": "Soul Channeling",
              "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_soultap"
            },
            {
              "default": true,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 919,
      "name": "Utterdark Soulrender",
      "description": "The Utterdark has many servants; some that draw one into the void and some that keep them there. The Soulrenders draw in the poor souls too foolish to run away.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 71,
      "hash": "dJ8JJ8IF0Bg3AF0AJ8HJ8IJ8Jeeeeeepfrllumyg",
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 2281,
          "apCost": 0,
          "name": "Soul Channeling",
          "shortDescription": "At the beginning of its turns, this champion is healed for 2 HP for every champion in play with Soultapped. At the end of its turns, opposing champions within 2 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3036,
              "apCost": 0,
              "name": "Dark Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 3 champions (not including self) occupying a Dead Magic Zone.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "desecrate_earth"
            },
            {
              "default": false,
              "id": 2991,
              "apCost": 4,
              "name": "Soulwrack",
              "shortDescription": "This champion makes a Loss of Life attack at RNG 2-5. This attack deals bonus damage equal to the number of champions with <condition value=soultapped>Soultapped</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "soulwrack"
            },
            {
              "default": true,
              "id": 3026,
              "apCost": 2,
              "name": "Soulseeker",
              "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=soultapped>Soultapped</condition> or <condition value=cursed>Cursed</condition> and gains +2 SPD for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "relocate_lightning"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            }
          ]
        }
      ]
    },
    {
      "id": 611,
      "name": "Utterdark Spectre",
      "description": "The spectres of the Utterdark are in service to Serkan. They will follow their Dark Bringer to any end.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 72,
      "hash": "dj9Cj9BG2Af1Bf1AJ8Jj9Aj9Bpumpyvmwmnsmygg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1761,
          "apCost": 0,
          "name": "Insubstantiate",
          "shortDescription": "At the end of your turn, all <condition value=incorporeal>Incorporeal</condition> champions within 8 spaces become <condition value=stealthed>Stealthed</condition> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "stealth"
        },
        {
          "id": 326,
          "apCost": 0,
          "name": "Phase Shift",
          "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ethereal"
        },
        {
          "id": 1795,
          "apCost": 0,
          "name": "Surge: Shadows",
          "shortDescription": "This champion gets +1 DMG for all stealthed champions you or your opponent controls.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "surge_shadow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1244,
              "apCost": 0,
              "name": "Cleave",
              "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2250,
              "apCost": 3,
              "name": "Scythe Whirl",
              "shortDescription": "This unit gains <ability value=1378>Evasive 3</ability> for 2 turns and all opposing units within 3 spaces takes Physical damage equal to this unit's DMG.  Units successfully damaged become <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "scythe_wirlwind"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1731,
              "apCost": 0,
              "name": "Domain: Shadows",
              "shortDescription": "At the beginning of each turn, this unit has +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> for 1 turn if it is <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_shadows"
            },
            {
              "default": false,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            }
          ]
        }
      ]
    },
    {
      "id": 743,
      "name": "Utterdark Voidhowler",
      "description": "The Voidhowlers call out to the Utterdark, to foretell the arrival of a creature from its depths. This howl reaches beyond the physical plane, into other worlds. It is said that those, close to death, succumb to its sound.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Skeleton",
        "Undead"
      ],
      "noraCost": 70,
      "hash": "dj9Cj9BG2AG2AG2Bj9Cj9Dj9Eeeipyztxinukukg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1968,
          "apCost": 0,
          "name": "Void Howl",
          "shortDescription": "When this champion dies, it deals 12 Sonic Damage to all champions within 3 spaces. This damage ignores DEF. If an opposing non-Illusion, non-Summoned champion is destroyed by this ability, a Voidhowler is spawned under your control.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "sonicaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 149,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1807,
              "apCost": 0,
              "name": "Deafening Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "deafening_aura"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 520,
      "name": "Utterdark Wraith",
      "description": "Boeunir entered the catacomb, relieved to flee his captors. He reclined against a column, catching his breath. As he opened his eyes, he froze, fear rushing through his body, his desperate cry for help drowned out as the darkness engulfed him.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 64,
      "hash": "dj9Bj9Af1Bf1Af1Bj9Aj9Bj9Cevonjymnwxilwfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2375,
          "apCost": 0,
          "name": "Draining Luminescence",
          "shortDescription": "When this unit is deployed and at the start of its turns, the controller of each opposing champion within 4 spaces loses 3 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "draining_luminesence"
        },
        {
          "id": 1754,
          "apCost": 0,
          "name": "Hidden: Dead Magic Zone",
          "shortDescription": "At the end of your turn, if this champion occupies a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 3249,
          "apCost": 0,
          "name": "Rift Bound",
          "shortDescription": "At the end of its turns, if this unit does not occupy Dead Magic Zone, it loses 2 MAX HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "rift_bound"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": true,
              "id": 1017,
              "apCost": 1,
              "name": "Knockout",
              "shortDescription": "This champion makes an attack at RNG 1-2.  If successful, the target becomes <condition value=paralyzed>Paralyzed</condition> 2. This champion must be <condition value=stealthed>Stealthed</condition> and does not destealth the champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1844,
              "apCost": 0,
              "name": "Wicked Aura",
              "shortDescription": "Whenever an enemy champion within 4 spaces would gain AP, they get 1 less than normal.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "auranegative"
            },
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1608,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 6 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "damageshield"
            }
          ]
        }
      ]
    },
    {
      "id": 605,
      "name": "Valdac",
      "description": "I am creation and my brother, Vindrax, is destruction. We are in conflict, yet we both know the importance of the other. As long as there is life and death, our struggle will continue. - Valdac, Avatar of Creation",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God",
        "Priest"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 85,
      "hash": "dj9Bj9Af1Bf1Bg3Aj9Dj9Ej9Fpluhrqwofiyxqjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 790,
          "apCost": 3,
          "name": "Healing Breath",
          "shortDescription": "Area Effect 2, Range 3: Other champions are <mechanic value=cleansed>Cleansed</mechanic> and healed 25 HP divided by the number of targets (rounded down to a max of 12 HP per target).",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 14,
          "iconName": "healmass"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        },
        {
          "id": 1721,
          "apCost": 4,
          "name": "Summon: Dragon",
          "shortDescription": "Summon a Dragon Homunculus on an adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumdragon"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2436,
              "apCost": 2,
              "name": "Mutate",
              "shortDescription": "Target friendly champion within 3 spaces gets +5 MAX HP, +2 DMG or +1 SPD. Target opposing champion gets -5 MAX HP, -2 DMG or -1 SPD. These effects can not be cleansed or dispelled. If target champion has a Mutation ability it also gains 4 charges.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "mutation"
            },
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2347,
              "apCost": 0,
              "name": "Prophetic Balance",
              "shortDescription": "Whenever an opposing champion gains AP outside of normal AP generation, this champion gains an equal amount of AP.  Any AP gained this way which would be lost due to the AP cap is gained by the closest friendly champion instead.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "prophetic_balance"
            },
            {
              "default": true,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 2623,
              "apCost": 0,
              "name": "Anthomancy",
              "shortDescription": "When this champion is deployed, 6 non-champion runes in your runedock are revealed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "scry"
            }
          ]
        }
      ]
    },
    {
      "id": 1776,
      "name": "Valdaci Bolter",
      "description": "When the Falgar excavations first uncovered the Valdaci city, the workers were stunned: how could the Draksar have seemingly infiltrated Ironfist territory, and seized Ironfist magic?",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct",
        "Draksar"
      ],
      "noraCost": 71,
      "hash": "ej9Fj9EF0BG2AG2AE8DJ8IJ8Jietfgrjiwtzirqf",
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1967,
          "apCost": 0,
          "name": "Relic Guardian",
          "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 3257,
          "apCost": 2,
          "name": "Valdaci Sacrifice: Crossbow",
          "shortDescription": "This champion loses 5 HP and a Valdaci Crossbow relic with 15 HP and <ability value=2602>Misfire</ability> is summoned to target adjacent unoccupied tile. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 5,
          "iconName": "valdacisac_xbow"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        }
      ]
    },
    {
      "id": 1773,
      "name": "Valdaci Guardian",
      "description": "Many Draksar welcomed the Valdaci, viewing them as ancestors to the might and unity of the Empire. Changed individuals could now be seen as both revolutionaries and part of a legacy.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight"
      ],
      "races": [
        "Construct",
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "ej9Fj9Ee9AG2AG2AE8Dj9Fj9Gwzrqhvqqushkerf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 42,
          "apCost": 0,
          "name": "Immunity: Acid",
          "shortDescription": "Acid damage that would be dealt to this unit is prevented. This unit may not become <condition value=scoured>Scoured</condition>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_acid"
        },
        {
          "id": 1344,
          "apCost": 0,
          "name": "Provision: Defense",
          "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "plunder"
        },
        {
          "id": 3260,
          "apCost": 2,
          "name": "Valdaci Sacrifice: Emerald",
          "shortDescription": "This champion loses 5 HP and a Valdaci Emerald relic with 15 HP and <ability value=153>Acidic Aura 3</ability> is summoned to target adjacent unoccupied tile. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 5,
          "iconName": "valdacisac_emerald"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2577,
              "apCost": 0,
              "name": "Complex Machine",
              "shortDescription": "When this champion is within 5 spaces of a friendly champion with Class: Tinkerer, it gains +1 SPD and <ability value=116>Regeneration 2</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "complex_machine"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3238,
              "apCost": 3,
              "name": "Extinguish Matter",
              "shortDescription": "Target relic or equipment on target champion within 3 spaces is destroyed and the closest enemy champion within 5 spaces to the target takes 10 Magical damage and becomes <condition value=cursed>Cursed 5</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "reclaim_materials"
            },
            {
              "default": true,
              "id": 153,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaacid"
            },
            {
              "default": false,
              "id": 3139,
              "apCost": 0,
              "name": "Sundered Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=sundered>Sundered</condition>, <condition value=scoured>Scoured</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_sundered"
            }
          ]
        }
      ]
    },
    {
      "id": 1770,
      "name": "Valdaci Needlewing",
      "description": "Like all Valdaci creatures, the Needlewing is part-construct, part-flesh, built to protect and last within their synthetic city below the earth.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Construct"
      ],
      "noraCost": 70,
      "hash": "ej9Ej9DG2Bf1BG2Ag3Aj9Cj9Dyrqwipwvzojlluf",
      "artist": "Grant Griffin",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 1606,
          "apCost": 0,
          "name": "Reflection",
          "shortDescription": "Champions attacking this champion from range take 5 damage of the Attacker's damage type.",
          "activationType": 2,
          "level": 4,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "damageshield"
        },
        {
          "id": 3259,
          "apCost": 2,
          "name": "Valdaci Sacrifice: Burr",
          "shortDescription": "This champion loses 5 HP and target enemy champion within 5 spaces is equipped with Valdaci Burr (Equipped champion is <condition value=Burred>Burred</condition>).",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 2,
          "iconName": "valdacisac_burr"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2300,
              "apCost": 0,
              "name": "Charged Blast",
              "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
              "activationType": 3,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 894,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 2 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2261,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 1979,
              "apCost": 0,
              "name": "Running Start",
              "shortDescription": "Whenever this champion moves 2 or more spaces, it gains <ability value=1>Flight</ability> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "flight"
            }
          ]
        }
      ]
    },
    {
      "id": 1774,
      "name": "Valdaci Sentry",
      "description": "King Feofil immediately cast the Valdaci as a symbol of all the mistakes of Old Valdac -- these things, then or now, had no place in a good and ordered society.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Construct",
        "Skeezick"
      ],
      "noraCost": 64,
      "hash": "ej9Fj9Ee9BG2AG2AE8DJ8GJ8Hkgkneegpnjygipf",
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 3255,
          "apCost": 2,
          "name": "Valdaci Sacrifice: Tracker",
          "shortDescription": "This champion loses 5 HP and the closest friendly equippable champion within 5 spaces is equipped with Valdaci Tracker (Equipped champion has <ability value=13>Detection 3</ability> and <ability value=2671>Illuminate</ability>).",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 2,
          "iconName": "valdacisac_tracker"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2974,
              "apCost": 0,
              "name": "Hunter: Equipped",
              "shortDescription": "When this unit would deal damage to an equipped champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by an equipped champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_equipped"
            },
            {
              "default": false,
              "id": 2576,
              "apCost": 1,
              "name": "Throw Javelin",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "spear"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 878,
              "apCost": 0,
              "name": "Skeezick Alliance",
              "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "skeezickalliance"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            }
          ]
        }
      ]
    },
    {
      "id": 1790,
      "name": "Valdaci Shieldwarden",
      "description": "\"If nothing else, the Valdaci stand testament to the possibility of reconcilliation with the Empire! We should not throw them aside. Is peace not what we want?\" -- Brom the Heretic",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Construct",
        "Draksar"
      ],
      "noraCost": 72,
      "hash": "eJ8HJ8GG2BG2AG2Ae9Bj9Cj9Demjtxqfvssqsuqf",
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 316,
          "apCost": 0,
          "name": "Melee Specialist",
          "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +1 DEF and +3 DMG.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "whirl"
        },
        {
          "id": 116,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "regen"
        },
        {
          "id": 51,
          "apCost": 0,
          "name": "Resistance: Magical",
          "shortDescription": "When this unit takes Magical damage, that damage is reduced by 35% (after DEF, rounded up).",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "resistance_magic"
        },
        {
          "id": 1505,
          "apCost": 1,
          "name": "Throw Shield",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "throw_shield"
        },
        {
          "id": 3269,
          "apCost": 2,
          "name": "Valdaci Sacrifice: Shield",
          "shortDescription": "This champion loses 5 HP and target friendly champion within 5 spaces is equipped with Valdaci Shield (Equipped champion has <ability value=3266>Combat Awareness 1</ability>).",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 2,
          "iconName": "valdacisac_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 597,
              "apCost": 0,
              "name": "Unstoppable",
              "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "unstoppable"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 1772,
      "name": "Valdaci Sweeper",
      "description": "\"Allies? We cannot be allies with these things, creators and spawn of the very magic which poisoned our land, who fought against the Change!\" -- Lennox, Draksar High Priest",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Construct"
      ],
      "noraCost": 64,
      "hash": "ej9Fj9EE8DG2AG2AE8Dj9Ej9Fiwmeeekeeiygvqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 518,
          "apCost": 3,
          "name": "Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "leap"
        },
        {
          "id": 1312,
          "apCost": 3,
          "name": "Sweep",
          "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "whirl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 443,
              "apCost": 0,
              "name": "Lay Trap: Fire",
              "shortDescription": "Lay a Fire Trap on target adjacent space. For 8 turns, the next time an enemy champion enters that space, it takes 6 Fire Damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "trapfire"
            },
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": true,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 2993,
              "apCost": 0,
              "name": "Reclaim Materials",
              "shortDescription": "When a real friendly Construct is destroyed, you gain 3 nora. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reclaim_materials"
            },
            {
              "default": false,
              "id": 895,
              "apCost": 1,
              "name": "Retreat",
              "shortDescription": "This champion can disengage for free and move 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "mobility"
            }
          ]
        }
      ]
    },
    {
      "id": 1306,
      "name": "Vallassa the Elder",
      "description": "\"I am certain I will be branded a heretic for what I am about to do, but I have no choice.\" ~ Vallassa the Elder's personal journal",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Jakei"
      ],
      "noraCost": 71,
      "hash": "ej9Fj9Ef1BF0Ae9AE8Dj9Aj9Bgkekjwinyvzrfpf",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broken Shard",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1142,
          "apCost": 0,
          "name": "Hunter: Hero",
          "shortDescription": "When this unit would deal damage with any attack to a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater that damage is increased by 2. When this unit would receive damage from any attack by a champion with <ability value=802>Hero</ability>, <ability value=2265>Split Hero</ability> or with a nora cost of 80 or greater, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "hunter_hero"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        },
        {
          "id": 1162,
          "apCost": 0,
          "name": "Taunt: Vallassa",
          "shortDescription": "Taunt your enemies.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 0,
          "iconName": "reckless_fury"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": true,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 84,
      "name": "Vampyre",
      "description": "The taste of blood, while an acquired taste, soon exceeds the baser pleasures of life.  - Brennon, Vampyre",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Undead",
        "Vampyre"
      ],
      "noraCost": 79,
      "hash": "cJ8JJ8IJ8HF0AG2BJ8HJ8IJ8Jsmsmsmsmuojneth",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1037,
          "apCost": 5,
          "name": "Deception",
          "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 6,
          "iconName": "planar"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 3399,
          "apCost": 0,
          "name": "Lord of Strigoi",
          "shortDescription": "This champion has <ability value=977>Bleed</ability>. After this champion uses an ability, friendly champions with Race: Vampyre within 3 spaces of this champion gain +2 Max HP and -1 CD on their abilities. This may only trigger once per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "soul_siphon"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            },
            {
              "default": false,
              "id": 3141,
              "apCost": 3,
              "name": "Blood Convergence",
              "shortDescription": "Target enemy champion within 5 spaces loses 4 HP per Blood Ball within 3 spaces of it. Those Blood Balls are consumed and this champion vampiric heals for 50% of the HP lost to a maximum of 20 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "bloodball"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1895,
              "apCost": 0,
              "name": "Illusion of Lies",
              "shortDescription": "When a friendly champion is deployed from the runedock, an illusion copy of that champion is spawned in the nearest deployment zone.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "planar"
            },
            {
              "default": false,
              "id": 2251,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is prevented. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "combat_awareness"
            },
            {
              "default": true,
              "id": 2295,
              "apCost": 0,
              "name": "Thirst for Battle",
              "shortDescription": "At the end of its turn, this unit permanently gains +2 DMG and +1 DEF if it is engaged.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "thirst_for_battle"
            }
          ]
        }
      ]
    },
    {
      "id": 202,
      "name": "Vampyre Bat",
      "description": "You mean to tell me that you didn't recapture the canyon because of bats? These better be some big bats. - Eddent, Mountain Garu Captain",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 18,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Beast",
        "Voil"
      ],
      "noraCost": 38,
      "hash": "dj9AJ8Jf1Ae9AG2Aj9Bj9Cj9Degkexkwiggykgeg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1454,
              "apCost": 0,
              "name": "Escape",
              "shortDescription": "This unit becomes <condition value=stealthed>Stealthed</condition> for 3 turns at the end of any turn it was successfully damaged.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 1441,
              "apCost": 0,
              "name": "Confuse Enemy",
              "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "confuse"
            },
            {
              "default": true,
              "id": 1387,
              "apCost": 0,
              "name": "Assimilate",
              "shortDescription": "When this champion recovers a nora globe, it is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "assimilate"
            }
          ]
        }
      ]
    },
    {
      "id": 463,
      "name": "Varu Dragon",
      "description": "The merge was painful, your Grace, but the power we've gained is a worthy reward. - Zezidrid, Varu Dragon",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 76,
      "hash": "dj9Gj9Fe9Af1Af1AJ8Jj9Aj9Bytukymwtououmeg",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1425,
          "apCost": 0,
          "name": "Attack: Sand",
          "shortDescription": "This unit makes an Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "sand"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1370,
              "apCost": 0,
              "name": "Deflect: Sand",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Physical damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_sand"
            },
            {
              "default": false,
              "id": 1101,
              "apCost": 4,
              "name": "Sand Spray",
              "shortDescription": "Area Effect 2, Range 5: Enemy units take 10 Physical damage. This damage ignores DEF.  Units successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 4 turns. Spaces within the affected area become Sand for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "sand"
            },
            {
              "default": false,
              "id": 2688,
              "apCost": 4,
              "name": "Screech",
              "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "sonicaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 1100,
              "apCost": 0,
              "name": "Sandstriker",
              "shortDescription": "While this champion occupies Sand terrain, it has +5 DMG.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            }
          ]
        }
      ]
    },
    {
      "id": 85,
      "name": "Varu Howler",
      "description": "The screech of a Howler is usually the last thing you'll hear.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 64,
      "hash": "cj9Bj9AJ8Jf1Af1BJ8Jj9Aj9Bufeegnhtzmsxiyi",
      "artist": "Roberto Cirillo",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2470,
          "apCost": 1,
          "name": "Howling Attack",
          "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "horrific_howl"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 148,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 4 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            }
          ]
        }
      ]
    },
    {
      "id": 1141,
      "name": "Vashal Cavalier",
      "description": "They answer to a higher power, making them capable of incredible feats.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 54,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight",
        "Paladin"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 81,
      "hash": "eJ8JJ8If1Ae9Ae9AF0BJ8Jj9Aeeeeemekuzrzon",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 867,
          "apCost": 0,
          "name": "Blessed",
          "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 870,
          "apCost": 1,
          "name": "Hammer Throw",
          "shortDescription": "Make a magical attack with a range of 3-6, at +2 DMG against target enemy unit.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "hammer"
        },
        {
          "id": 47,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 35% (after DEF, rounded up).",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "resistance_physical"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1128,
              "apCost": 0,
              "name": "Ally: Ironfist Stronghold",
              "shortDescription": "While there are other friendly Ironfist Stronghold champions in play, this champion gets +7 HP and +2 DMG. Ironfist champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_is"
            },
            {
              "default": true,
              "id": 1550,
              "apCost": 0,
              "name": "Enduring Aura",
              "shortDescription": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 2530,
              "apCost": 2,
              "name": "Seal of the Vashal",
              "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "seal_of_the_vashal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1892,
              "apCost": 0,
              "name": "Quest: Damage",
              "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 263,
              "apCost": 0,
              "name": "Warcry",
              "shortDescription": "When this unit makes a successful basic attack, friendly champions within 3 spaces that share a race with this champion recover 2 AP and get +2 DMG until end of turn.  This triggers once per turn and units can be affected once per turn.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "allybuffs"
            },
            {
              "default": true,
              "id": 1277,
              "apCost": 0,
              "name": "Vindictive",
              "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 724,
      "name": "Vashal Druid",
      "description": "Although the elves thought it a wasted endeavor, Menalaus tutored the Vashal in the ways of nature. Many went on to study spellcrafting with the priests of K`thir. The Quillbacks were joined by Druids.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 75,
      "hash": "dj9AJ8Jf1AG2Ag3Aj9Dj9Ej9Fpheiitsmlwqlljg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 1160,
          "apCost": 0,
          "name": "Boost",
          "shortDescription": "Friendly champions that share a race or class with this one have +5 MAX HP.  This does not stack with other Boosts.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "boost"
        },
        {
          "id": 1561,
          "apCost": 0,
          "name": "Growth",
          "shortDescription": "Friendly champions within 3 spaces are healed for 3 HP at the beginning of your turns.",
          "activationType": 0,
          "level": 4,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "plantregen"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            },
            {
              "default": false,
              "id": 1571,
              "apCost": 4,
              "name": "Nature's Blessing",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and is healed for 7 HP",
              "activationType": 1,
              "level": 1,
              "cooldown": 6,
              "noraCost": 8,
              "iconName": "cleanse"
            },
            {
              "default": true,
              "id": 592,
              "apCost": 3,
              "name": "Cleanse",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2530,
              "apCost": 2,
              "name": "Seal of the Vashal",
              "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "seal_of_the_vashal"
            },
            {
              "default": false,
              "id": 1483,
              "apCost": 3,
              "name": "Solidify",
              "shortDescription": "Target champion within 5 spaces becomes <condition value=solid>Solid</condition> for 3 turns. May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 2,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 1557,
      "name": "Vashal Enchanter",
      "description": "Vashal Enchanters mostly stay in the backlines, focusing on enhancing the abilities of their allies, but at the tavern, they are always the loudest when proclaiming their own heroics.",
      "maxRng": 6,
      "minRng": 4,
      "defense": 0,
      "speed": 5,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8Ie9Be9BG2AF0BJ8GJ8Hsmsmsoyoukrqqo",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1338,
          "apCost": 0,
          "name": "Grand Entrance",
          "shortDescription": "When this unit is deployed, the closest enemy champion is <condition value=awestruck>Awestruck</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "majestic"
        },
        {
          "id": 2339,
          "apCost": 4,
          "name": "Imbue: Stun",
          "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 9,
          "iconName": "amped"
        },
        {
          "id": 2530,
          "apCost": 2,
          "name": "Seal of the Vashal",
          "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "seal_of_the_vashal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3347,
              "apCost": 0,
              "name": "Forest Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=charmed>Charmed</condition>, <condition value=illuminated>Illuminated</condition> or <condition value=pacified>Pacified</condition> it gains 1 AP and has +2 DMG for the attack. This champion does not trigger removal of Illuminated with its basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1138,
      "name": "Vashal Eremite",
      "description": "Some Vashal choose a solitary lifestyle, but the bond of the Vashal ensures they always answer the call of war.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Monk"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 73,
      "hash": "eJ8JJ8Ie9Be9Ae9AF0BJ8GJ8Hkukukpyzztqhem",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3072,
          "apCost": 3,
          "name": "Elusive Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "dashing_dodge"
        },
        {
          "id": 1804,
          "apCost": 0,
          "name": "Hunter: Fighter",
          "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "foe_warrior"
        },
        {
          "id": 1470,
          "apCost": 0,
          "name": "Nohkan Do",
          "shortDescription": "Attacks against this unit miss for 2 AP. This effect can trigger once per turn and does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dodge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 344,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +6 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 338,
              "apCost": 0,
              "name": "Counterstrike",
              "shortDescription": "When a champion makes an unsuccessful attack against this unit, this unit makes an attack against that unit at +1 DMG.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "counter"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 684,
              "apCost": 1,
              "name": "Execute",
              "shortDescription": "For 1 turn, the next basic attack made by this unit deals 50% more damage if the target is a champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "execute"
            },
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 2530,
              "apCost": 2,
              "name": "Seal of the Vashal",
              "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "seal_of_the_vashal"
            }
          ]
        }
      ]
    },
    {
      "id": 1844,
      "name": "Vashal Interceptor",
      "description": "\"Our informats said the closest enemy squadron was over a days march away, so who the Pox are these?\" -- Nefari Commander",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 77,
      "hash": "eJ8JJ8IG2AG2BG2AF0Bj9Bj9Ceeeeerjpukufgrf",
      "artist": "Damien Mammoliti",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 2091,
          "apCost": 0,
          "name": "Dragging Attack",
          "shortDescription": "When this champion successfully damages a small champion with a basic attack, that champion is relocated one space toward this unit.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "pull"
        },
        {
          "id": 3303,
          "apCost": 5,
          "name": "Invoke: Intercedence",
          "shortDescription": "Area Effect 4: Friendly champions (including this one) are Cleansed and gain 1 stack of Wind Shield for 4 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 8,
          "iconName": "invoke"
        },
        {
          "id": 3296,
          "apCost": 0,
          "name": "Zeal: Damage",
          "shortDescription": "When this champion makes a successful basic attack, it gains +2 DMG for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "channel_damage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 3155,
              "apCost": 3,
              "name": "Declare Vengeance",
              "shortDescription": "Target enemy champion within 5 spaces becomes Marked for Vengeance (When this champion is successfully attacked with a basic attack, it loses 3 HP.  If this champion is destroyed, the attacking champion gains +3 DMG for 6 turns.) until targets change.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "declare_vengeance"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1717,
              "apCost": 3,
              "name": "Command: Charge",
              "shortDescription": "All friendly champions within 3 spaces gain <ability value=396>Charge 3</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "command_charge"
            },
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": true,
              "id": 2530,
              "apCost": 2,
              "name": "Seal of the Vashal",
              "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "seal_of_the_vashal"
            }
          ]
        }
      ]
    },
    {
      "id": 1521,
      "name": "Vashal Mirrorblade",
      "description": "A Vashal Mirrorblade is a dangerous foe. It is said that she is already wiping your blood from her blade by the time you figure out which version is the true enemy.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 72,
      "hash": "ej9Cj9Bf1BF0Be9AG2Aj9Aj9Beemwtxvkwqwfpqf",
      "artist": "Darcie Banfield",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 3034,
          "apCost": 2,
          "name": "Mirror Swap",
          "shortDescription": "This champion is relocated in place of the closest friendly illusion of itself within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "swarm"
        },
        {
          "id": 3033,
          "apCost": 0,
          "name": "Mirrorblade",
          "shortDescription": "When this champion makes a successful basic attack, two illusion copies of itself are summoned randomly within 4 spaces of the target.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "swarm"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 169,
              "apCost": 0,
              "name": "Poison",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 5 turns.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_poison"
            },
            {
              "default": true,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 1419,
              "apCost": 0,
              "name": "Adaptation",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability, this unit gains that ability for 4 turns. Basic Attacks and abilities that change a champion's form are not gained.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "adaptation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2530,
              "apCost": 2,
              "name": "Seal of the Vashal",
              "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "seal_of_the_vashal"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 340,
      "name": "Vashal Quillback",
      "description": "Though small in stature, the Quillback is a cunning warrior. Its tactics are known to bring confusion.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 8,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 66,
      "hash": "dj9Bj9Af1BF0AF0BJ8IJ8Jj9Azzxmpjtouvolpyg",
      "artist": "Layne Johnson",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 221,
          "apCost": 0,
          "name": "Damage Shield: Physical",
          "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "dmgshld_physical"
        },
        {
          "id": 2530,
          "apCost": 2,
          "name": "Seal of the Vashal",
          "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "seal_of_the_vashal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 214,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses. This effect is hidden until triggered. This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "block"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 218,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is Paralyzed or Stunned.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 9,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 1139,
      "name": "Vashal Quillquip",
      "description": "Tell me where, and I shall go.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 70,
      "hash": "eJ8JJ8IF0Ae9Ae9AF0BJ8HJ8Iiwiwmuvfieithn",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 546,
          "apCost": 0,
          "name": "Attack: Poison",
          "shortDescription": "This unit makes a Poison attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_poison"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 601,
              "apCost": 0,
              "name": "Shadowspawn",
              "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "shadowspawn"
            },
            {
              "default": false,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1140,
      "name": "Vashal Ranger",
      "description": "The Vashal protects what the Forest provides. ~ Vashal Creed",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 78,
      "hash": "eJ8JJ8IF0Be9Ae9AF0BJ8IJ8Jiwiwiipuzgilln",
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2785,
          "apCost": 0,
          "name": "Call of the Hunter",
          "shortDescription": "This champion gains <ability value=657>Relocate: Ally</ability> for 2 turns.  This ability can only be used if this unit is adjacent to an opposing champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 2214,
          "apCost": 0,
          "name": "Hunter: Scout",
          "shortDescription": "When this unit would deal damage with any attack to a champion with Class: Ranger, Archer or Bard, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Ranger, Archer or Bard, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "foe_archer"
        },
        {
          "id": 2544,
          "apCost": 0,
          "name": "Pet: Wolf",
          "shortDescription": "When this champion is deployed, a Wolf with no upgrades is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 15,
          "iconName": "pet"
        },
        {
          "id": 2530,
          "apCost": 2,
          "name": "Seal of the Vashal",
          "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "seal_of_the_vashal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1514,
              "apCost": 0,
              "name": "Train: Assault",
              "shortDescription": "Target friendly champion within 5 spaces permanently gains <ability value=1320>Assault</ability>.  This ability costs 6 nora.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            }
          ]
        }
      ]
    },
    {
      "id": 1167,
      "name": "Vashal Vicar",
      "description": "\"When we sustain life, we are given life.\" ~ Vashal Creed",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 76,
      "hash": "ej9Cj9BE8De9Ae9AG2Aj9Ej9Fkukpfeilrzgeepf",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2001,
          "apCost": 0,
          "name": "Defenseless",
          "shortDescription": "This unit takes 30% more damage from melee attacks. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "defpenalties"
        },
        {
          "id": 2409,
          "apCost": 0,
          "name": "Empathy",
          "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "martyr"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        },
        {
          "id": 1340,
          "apCost": 0,
          "name": "Intensify",
          "shortDescription": "After 10 turns, this ability is removed and this unit is <mechanic value=cleansed>Cleansed</mechanic>, is healed for 15 HP and gains +10 MAX HP, +1 RNG and +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "intensify"
        },
        {
          "id": 2530,
          "apCost": 2,
          "name": "Seal of the Vashal",
          "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "seal_of_the_vashal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1959,
              "apCost": 0,
              "name": "Cleansing Aura",
              "shortDescription": "Friendly champions within 3 spaces (including this one) are <mechanic value=cleansed>Cleansed</mechanic> at the start of your turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 2220,
              "apCost": 0,
              "name": "Amplify: Healing",
              "shortDescription": "All healing is increased by 50%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "amp_healing"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2753,
              "apCost": 2,
              "name": "Noble Sacrifice",
              "shortDescription": "This champion loses 8 HP and target other friendly champion that shares a race with this one within 3 spaces gains <ability value=1932>Loyalty</ability> for 8 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        }
      ]
    },
    {
      "id": 1558,
      "name": "Vashal Woodchuck",
      "description": "Find out exactly how much wood a woodchuck would chuck if a woodchuck could chuck wood by enlisting a woodchucking woodchuck.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Vashal"
      ],
      "noraCost": 74,
      "hash": "eJ8JJ8IF0Ae9BG2AF0BJ8HJ8Igygyoqzxmsmluo",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3058,
          "apCost": 1,
          "name": "Chuck: Wood",
          "shortDescription": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "chuck_wood"
        },
        {
          "id": 2082,
          "apCost": 0,
          "name": "Jungle Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion become Jungle (Impeding Vegetation) for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "ferociousgrowth"
        },
        {
          "id": 2083,
          "apCost": 0,
          "name": "Trailblaze",
          "shortDescription": "All friendly champions have Brushwalker (This champion ignores movement restrictions and movement penalties imposed by Vegetation.).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "climb"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            },
            {
              "default": false,
              "id": 1261,
              "apCost": 0,
              "name": "Surge: Plant",
              "shortDescription": "This unit has +1 DMG for each friendly Plant.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_plant"
            },
            {
              "default": true,
              "id": 2088,
              "apCost": 4,
              "name": "Tunnel: Vegetation",
              "shortDescription": "This unit is relocated to target Vegetation space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 7,
              "iconName": "tunnel_vegetation"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        }
      ]
    },
    {
      "id": 1122,
      "name": "Veilwalker",
      "description": "It is said that those who walk the veil never return fully.  None ever speak of what they see beyond, however.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman",
        "Witch"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "eJ8HJ8Gf1Be9Ae9Ae9Bj9Aj9Bevszmsxzowiiln",
      "artist": "Anthony Lopes",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Wild Alliance",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1009,
          "apCost": 0,
          "name": "Tariff",
          "shortDescription": "When a real enemy champion is destroyed, that champion's controller loses 8 nora. If that player has less than 8 nora in their nora bank, their Shrine or Avatar loses 5 HP instead.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "cost"
        },
        {
          "id": 1280,
          "apCost": 0,
          "name": "Wisdom",
          "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "diplomat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": true,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 973,
              "apCost": 3,
              "name": "Afflict",
              "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "lossoflife"
            }
          ]
        }
      ]
    },
    {
      "id": 890,
      "name": "Vengeant Templar",
      "description": "Vengeant Templar are trained from the ranks of Barbarians through the combined efforts of the Inquisitors and Dwarven Commanders. The Inquisitors teach tactics while the dwarves teach the use of shield and sword. \r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Paladin"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 74,
      "hash": "dj9Gj9Fe9Ag3AG2Aj9Bj9Cj9Ditsjirhneklrhig",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2166,
          "apCost": 0,
          "name": "Attack Charged",
          "shortDescription": "When this champion makes a basic attack, it gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_abuse"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 3119,
          "apCost": 0,
          "name": "Provision: Offense",
          "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "plunder"
        },
        {
          "id": 1880,
          "apCost": 0,
          "name": "Violent",
          "shortDescription": "This champion has <ability value=732>Fury</ability> if a friendly champion that shares a race or class with it is within 2 spaces.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "aggressive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 213,
              "apCost": 0,
              "name": "Block",
              "shortDescription": "Next time target champion within 10 spaces makes a close-combat attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>. (You may target this unit to Block the next close-combat attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": true,
              "id": 3212,
              "apCost": 0,
              "name": "Ironfist Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=stunned>Stunned</condition>, <condition value=branded>Branded</condition> or <condition value=fatigued>Fatigued</condition>, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1505,
              "apCost": 1,
              "name": "Throw Shield",
              "shortDescription": "This champion makes a Physical attack at range 2-5.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "throw_shield"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 536,
      "name": "Vengeful Cyclops",
      "description": "If you're looking to kill a tribe of Cyclops, don't leave a single one alive. - Wyann, Ironfist Scout",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 69,
      "hash": "dj9Fj9EE8Df1Bg3Aj9Dj9Ej9Fgyitjtsonjymhig",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        },
        {
          "id": 1276,
          "apCost": 0,
          "name": "Vengeful",
          "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 29,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1277,
              "apCost": 0,
              "name": "Vindictive",
              "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 716,
      "name": "Vengeful Cyclops",
      "description": "If you're looking to kill a tribe of Cyclops, don't leave a single one alive. - Wyann, Ironfist Scout",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 5,
      "damage": 10,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Brute"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 69,
      "hash": "dj9Cj9BG2Af1BF0AJ8HJ8IJ8Jjgegtjygiwitzzg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2837,
          "apCost": 0,
          "name": "Psychotic Break",
          "shortDescription": "When a unit is destroyed by an attack, this champion gains <ability value=2253>Manic</ability> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "psychotic_break"
        },
        {
          "id": 1276,
          "apCost": 0,
          "name": "Vengeful",
          "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 29,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 1277,
              "apCost": 0,
              "name": "Vindictive",
              "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1379,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 1 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 444,
      "name": "Veteran Barbarian",
      "description": "A true warrior is forged in battle and in time. - Zedin, Barbarian Elder",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 14,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 72,
      "hash": "dJ8HJ8Ge9Bf1Ag3Aj9Dj9Ej9Flljluklpuvherfg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2093,
          "apCost": 0,
          "name": "Ponderous",
          "shortDescription": "This champion's AP cost for attacks and attack abilities with an AP cost of 1 or higher is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -8,
          "iconName": "lumbering"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        },
        {
          "id": 2873,
          "apCost": 0,
          "name": "Warchief: Stone Clan",
          "shortDescription": "This unit has <ability value=3379>Magic Ward</ability>. At the end of your turn, this unit gains a rank of <ability value=1900>Tough</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "stone_clan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1492,
              "apCost": 0,
              "name": "Ready",
              "shortDescription": "At the end of its turns, this champion gains 1 AP if it did not activate an ability that turn.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1431,
              "apCost": 0,
              "name": "Barbaric Assault",
              "shortDescription": "This unit gains <ability value=1348>Punish</ability> and <ability value=1242>Pace</ability> when another friendly Barbarian is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3079,
              "apCost": 0,
              "name": "Sapping Armor",
              "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "sapping_armor"
            },
            {
              "default": true,
              "id": 2704,
              "apCost": 0,
              "name": "Crushing Blow",
              "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 1892,
              "apCost": 0,
              "name": "Quest: Damage",
              "shortDescription": "Whenever this champion has dealt 25 damage, it permanently gains +2 DMG and a rank of <ability value=15>Multiattack</ability>. When this champion has dealt 50 damage it permanently gains another +2 DMG and another rank of Multiattack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "opportunistic"
            }
          ]
        }
      ]
    },
    {
      "id": 991,
      "name": "Vex",
      "description": "There is a pantheon devoted to the Dragon Gods, though much of its lore was lost in the bookburnings. One such Dragon God was Vex, mother of Vindrax and Valdac.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God",
        "Priest"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 88,
      "hash": "ej9Fj9Ef1BE8De9AE8Dj9Aj9Bpwfpqfpnytxvvo",
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 2318,
          "apCost": 0,
          "name": "Deploy Charged",
          "shortDescription": "When a champion is deployed from the runedock, this unit gains 2 charges.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 2394,
          "apCost": 0,
          "name": "Divine Wellspring",
          "shortDescription": "While this champion has at least 10 charges, friendly champions within 5 spaces cannot fall below 1 HP via <ability value=1389>Perseverance</ability>.  When this effect prevents the champion's HP from falling below 1, that champion gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of that turn and this champion loses all charges.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "divine_wellspring"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2112,
              "apCost": 1,
              "name": "Grant: Draconic Force",
              "shortDescription": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1337,
              "apCost": 0,
              "name": "Gift of Fertility",
              "shortDescription": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1721,
              "apCost": 4,
              "name": "Summon: Dragon",
              "shortDescription": "Summon a Dragon Homunculus on an adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "sumdragon"
            },
            {
              "default": false,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 1886,
              "apCost": 4,
              "name": "Annihilate",
              "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "novafire"
            }
          ]
        }
      ]
    },
    {
      "id": 1865,
      "name": "Vex",
      "description": "There is a pantheon devoted to the Dragon Gods, though much of its lore was lost in the bookburnings. One such Dragon God was Vex, mother of Vindrax and Valdac.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 13,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God",
        "Priest"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 89,
      "hash": "ej9Cj9Be9AG2BG2AG2Aj9Fj9Gwvmwkygklnwqqsf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2189,
          "apCost": 0,
          "name": "Charged Heal",
          "shortDescription": "Spend 3 Charges.  Target friendly champion within 5 spaces heals 12 HP.  May target self.\r\n",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "heal"
        },
        {
          "id": 2318,
          "apCost": 0,
          "name": "Deploy Charged",
          "shortDescription": "When a champion is deployed from the runedock, this unit gains 2 charges.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 2394,
          "apCost": 0,
          "name": "Divine Wellspring",
          "shortDescription": "While this champion has at least 10 charges, friendly champions within 5 spaces cannot fall below 1 HP via <ability value=1389>Perseverance</ability>.  When this effect prevents the champion's HP from falling below 1, that champion gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of that turn and this champion loses all charges.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "divine_wellspring"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2112,
              "apCost": 1,
              "name": "Grant: Draconic Force",
              "shortDescription": "Target champion within 5 spaces gains <ability value=879>Draconic Force</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 726,
              "apCost": 2,
              "name": "Transfer Life",
              "shortDescription": "This unit loses 6 HP, and target champion within 5 spaces heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1337,
              "apCost": 0,
              "name": "Gift of Fertility",
              "shortDescription": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1721,
              "apCost": 4,
              "name": "Summon: Dragon",
              "shortDescription": "Summon a Dragon Homunculus on an adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "sumdragon"
            },
            {
              "default": false,
              "id": 295,
              "apCost": 0,
              "name": "Deflect",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected to the nearest enemy within 8 spaces.  This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": true,
              "id": 1886,
              "apCost": 4,
              "name": "Annihilate",
              "shortDescription": "Opposing champions within 2 spaces take 12 Fire damage, opposing champions within 4 spaces take 10 Fire damage, and opposing champions within 6 spaces take 8 Fire damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "novafire"
            }
          ]
        }
      ]
    },
    {
      "id": 1400,
      "name": "Vexian Neodrak",
      "description": "The neodraks have become nearly uncontrollable in the absence of the calming influence of Vex.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 68,
      "hash": "ej9Ej9DF0AF0Ae9Ag3AJ8HJ8Ismjgiplyrqqzipf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 539,
          "apCost": 0,
          "name": "Attack: Acid",
          "shortDescription": "This unit makes an Acid attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_acid"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 861,
          "apCost": 0,
          "name": "Tormented",
          "shortDescription": "This unit receives a damage boost when injured. If at 80% of max HP, it gains +1 DMG. At 60% it gains +2 DMG, at 40% it gains +3 DMG and at 20% it gains +4 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 2533,
              "apCost": 0,
              "name": "Acid Acolyte",
              "shortDescription": "Whenever a champion takes Acid damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=scoured>Scoured</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_acid"
            },
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": false,
              "id": 153,
              "apCost": 0,
              "name": "Acidic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Acid damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaacid"
            }
          ]
        }
      ]
    },
    {
      "id": 460,
      "name": "Vindictive Skeezick",
      "description": "If they kill one of us, I say we kill eight of them! It's only fair! - Wegin, Skeezick",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Skeezick"
      ],
      "noraCost": 70,
      "hash": "dj9Gj9Fe9Af1Ae9BJ8GJ8HJ8Iqsmufvohtuojexf",
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2986,
          "apCost": 0,
          "name": "Fearsome Hunter",
          "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "fear"
        },
        {
          "id": 878,
          "apCost": 0,
          "name": "Skeezick Alliance",
          "shortDescription": "While 3 or more friendly Skeezick are in play, this unit gains +2 DMG. If there are 5 or more friendly Skeezick are in play, this unit also gains +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "skeezickalliance"
        },
        {
          "id": 1277,
          "apCost": 0,
          "name": "Vindictive",
          "shortDescription": "When a champion you own that shares a race with this champion is on cooldown, this champion gains <ability value=17>Multiattack 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 260,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +5 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 2961,
              "apCost": 0,
              "name": "Skeezick Rebel",
              "shortDescription": "When a real friendly champion is destroyed, this unit is healed for 6 HP. If that unit was a Skeezick, this unit also gains +2 Max HP and <ability value=259>Enrage 1</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intensify"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        }
      ]
    },
    {
      "id": 232,
      "name": "Vindrax",
      "description": "M'lord...is it- Vindrax, yes...the Avatar of the God of Destruction has revealed himself to us. Our victory is secured! - Akakios, Draksar Broodmaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Demi-God",
        "Warrior"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 94,
      "hash": "dJ8JJ8IF0Be9Bf1AJ8Jj9Aj9Bukukjwxknufvfxf",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 1401,
          "apCost": 0,
          "name": "Acidic Greeting",
          "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "greeting_acid"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 854,
              "apCost": 0,
              "name": "Battle Harden",
              "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 1700,
              "apCost": 0,
              "name": "Surge: Draksar",
              "shortDescription": "This unit has +1 DMG for each friendly Draksar.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_draksar"
            }
          ]
        }
      ]
    },
    {
      "id": 777,
      "name": "Vindrax",
      "description": "M'lord...is it- Vindrax, yes...the Avatar of the God of Destruction has revealed himself to us. Our victory is secured! - Akakios, Draksar Broodmaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God",
        "Warrior"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 94,
      "hash": "dj9Fj9EE8DG2BG2Bj9Cj9Dj9Eeeeerqfkygvkeig",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 1401,
          "apCost": 0,
          "name": "Acidic Greeting",
          "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "greeting_acid"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 854,
              "apCost": 0,
              "name": "Battle Harden",
              "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 1700,
              "apCost": 0,
              "name": "Surge: Draksar",
              "shortDescription": "This unit has +1 DMG for each friendly Draksar.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_draksar"
            }
          ]
        }
      ]
    },
    {
      "id": 1856,
      "name": "Vindrax",
      "description": "M'lord...is it- Vindrax, yes...the Avatar of the God of Destruction has revealed himself to us. Our victory is secured! - Akakios, Draksar Broodmaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God",
        "Warrior"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 94,
      "hash": "ej9Bj9AF0AG2BG2Af1BJ8HJ8Ilnljllrsuvousqf",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 1401,
          "apCost": 0,
          "name": "Acidic Greeting",
          "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "greeting_acid"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 854,
              "apCost": 0,
              "name": "Battle Harden",
              "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 1700,
              "apCost": 0,
              "name": "Surge: Draksar",
              "shortDescription": "This unit has +1 DMG for each friendly Draksar.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_draksar"
            }
          ]
        }
      ]
    },
    {
      "id": 1374,
      "name": "Vindrax",
      "description": "M'lord...is it- Vindrax, yes...the Avatar of the God of Destruction has revealed himself to us. Our victory is secured! - Akakios, Draksar Broodmaster",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Demi-God",
        "Warrior"
      ],
      "races": [
        "Dragon"
      ],
      "noraCost": 94,
      "hash": "ej9Bj9Ag3AF0Ae9Af1Bj9Dj9Eevkgevsjronevqf",
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 850,
          "apCost": 1,
          "name": "Acid Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Acid damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=scoured>Scoured</condition> for 2 turns",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "acidaoe"
        },
        {
          "id": 1401,
          "apCost": 0,
          "name": "Acidic Greeting",
          "shortDescription": "When this champion comes into play, all enemy champions become <condition value=scoured>Scoured</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "greeting_acid"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2525,
          "apCost": 0,
          "name": "Dragonflight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition>. The next Dragon you deploy from the runedock gains 2 AP. When this effect triggers, this champion gains <ability value=1395>Hunter: Walker</ability> for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "skyreign"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 117,
          "apCost": 0,
          "name": "Regeneration",
          "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "regen"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 854,
              "apCost": 0,
              "name": "Battle Harden",
              "shortDescription": "When this unit is deployed, friendly champions that share a faction with this champion gain +8 MAX HP and +1 DMG for 8 turns. This does not stack.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            },
            {
              "default": true,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 1700,
              "apCost": 0,
              "name": "Surge: Draksar",
              "shortDescription": "This unit has +1 DMG for each friendly Draksar.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_draksar"
            }
          ]
        }
      ]
    },
    {
      "id": 1252,
      "name": "Void Spider",
      "description": "The Void Spider is so named not just for its appearance, but also for its adaptability and ability to survive exposure to virtually any environment.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 81,
      "hash": "ej9AJ8JF0Ae9Be9Af1AJ8HJ8Iyzvhrzrjiwmhnn",
      "artist": "Anthony Lopes",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Endless Wonder",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 2338,
          "apCost": 0,
          "name": "Psychic Magnetism",
          "shortDescription": "If this champion is successfully attacked with a ranged attack the attacking champion is relocated 2 spaces closer to this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "pull"
        },
        {
          "id": 2649,
          "apCost": 0,
          "name": "Void Shield",
          "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tetra_shield"
        },
        {
          "id": 2650,
          "apCost": 2,
          "name": "Void Strike",
          "shortDescription": "This champion's next basic attack this turn has +1 DMG for every 20 nora in your nora bank and deals <mechanic value=lossoflife>Loss of Life</mechanic> instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "chaos_incarnate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2990,
              "apCost": 0,
              "name": "Psychic Anguish",
              "shortDescription": "Enemy champions within 5 spaces of this unit who take Psychic damage become <condition value=soultapped>Soultapped</condition> for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "psychic_anguish"
            },
            {
              "default": false,
              "id": 2909,
              "apCost": 2,
              "name": "Terrorize",
              "shortDescription": "Target enemy champion within 4 spaces becomes <condition value=frightened>Frightened</condition> for 3 turns. If that champion becomes Frightened, it is relocated 4 spaces away.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 1857,
              "apCost": 0,
              "name": "Soultap",
              "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_soultap"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1778,
              "apCost": 0,
              "name": "Sabotage: Psychic",
              "shortDescription": "The next enemy champion deployed from the runedock while this champion is in play takes 6 Psychic damage and gains <ability value=95>Vulnerability: Psychic</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "sabotage_acid"
            },
            {
              "default": true,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            },
            {
              "default": false,
              "id": 2141,
              "apCost": 0,
              "name": "Creep and Crawl",
              "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "creep_and_crawl"
            }
          ]
        }
      ]
    },
    {
      "id": 208,
      "name": "Voil Bomber",
      "description": "Soldiers disperse! Shaman ready yourselves - the Voil are back for more. - Gash, Boghopper Finlord at the Siege of the Shallows",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 71,
      "hash": "dj9Gj9Fe9Ae9BG2Bj9Cj9Dj9Eeerllrjyiyzkjgg",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 553,
          "apCost": 0,
          "name": "Attack: Boulder",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physicalaoe"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3153,
              "apCost": 0,
              "name": "Empowered: Range",
              "shortDescription": "This champion has +2 MIN RNG and +2 MAX RNG. This ability is removed after 3 basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "empowered_range"
            },
            {
              "default": true,
              "id": 2780,
              "apCost": 2,
              "name": "Aim",
              "shortDescription": "At the start of its next turn, this champion has +1 RNG, +3 DMG and <ability value=1775>Precision</ability> for 1 turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 770,
              "apCost": 1,
              "name": "Stone Bomb",
              "shortDescription": "Area Effect 2, Range 5:  Affected units take Physical damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged are knocked back 1 space.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2390,
              "apCost": 0,
              "name": "Hit and Run",
              "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "hit_and_run"
            },
            {
              "default": false,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": false,
              "id": 2414,
              "apCost": 1,
              "name": "Throw Boulder",
              "shortDescription": "This champion makes a Physical attack at RNG 2-5. This attack causes <condition value=awestruck>Awestruck</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "rock"
            }
          ]
        }
      ]
    },
    {
      "id": 1285,
      "name": "Voil Conqueror",
      "description": "\"We have let these land lay lawless for too long. Send the Conquerors and consolidate them before the Hyaenids and their babysitters gain a foothold.\" ~ Queen Eehiist",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 80,
      "hash": "ej9Dj9Cf1Ae9Be9AG2BJ8Jj9Aevfvmsoquhnekpf",
      "artist": "Christian Fell",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1719,
          "apCost": 0,
          "name": "Conqueror",
          "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1775,
          "apCost": 0,
          "name": "Precision",
          "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3349,
              "apCost": 0,
              "name": "Peaks Exploit",
              "shortDescription": "When this champion makes a successful basic attack against a target with <condition value=shocked>Shocked</condition>, <condition value=distracted>Distracted</condition> or <condition value=shrunken>Shrunken</condition> it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "exploit_ironfist"
            },
            {
              "default": true,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 3031,
              "apCost": 0,
              "name": "Imposing Aura",
              "shortDescription": "Enemy champions within 3 spaces have -2 DMG and <ability value=2005>Careless</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "imposing_aura"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            }
          ]
        }
      ]
    },
    {
      "id": 320,
      "name": "Voil Courier",
      "description": "It's a long journey to the swamp Jarkahl, you should take some morsels with you. Let the Frogs know that they have four moons until we come to reclaim the outer banks.  ",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 73,
      "hash": "dJ8JJ8IF0BF0Af1AJ8Jj9Aj9Bmsmsmpsuvfipjyg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 1965,
          "apCost": 0,
          "name": "Distracting Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "distract"
        },
        {
          "id": 2892,
          "apCost": 0,
          "name": "Feint",
          "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "feint"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            },
            {
              "default": false,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": true,
              "id": 1734,
              "apCost": 2,
              "name": "Drudgery",
              "shortDescription": "All champions lose all of their AP. This ability begins on cooldown.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            }
          ]
        }
      ]
    },
    {
      "id": 980,
      "name": "Voil Dive Bomber",
      "description": "Each Dive Bomber is given a bladed helm and a plated shirt to cover their arms and chest. These pieces are only meant to protect the Voil during a dive, to make sure the collision is most effective.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 76,
      "hash": "dj9Ej9Dg3Ag3Af1AJ8Jj9Aj9Bwtfkeerfiilwmjg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 563,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "initiative"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3059,
              "apCost": 0,
              "name": "Thunderous Charge",
              "shortDescription": "When this champion makes a successful Charge attack, the target and enemy champions within 2 spaces of the target become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "thunderous_charge"
            },
            {
              "default": true,
              "id": 1214,
              "apCost": 0,
              "name": "Encouraged",
              "shortDescription": "When a friendly champion succesfully attacks, this champion gains +1 DMG for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "buff"
            },
            {
              "default": false,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 277,
      "name": "Voil Frenzy",
      "description": "Daksen, what is the status of the eastern wall? -- Dead sir...a vicious strike by the voil, sir. I think the battle is lost. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 65,
      "hash": "dj9Dj9CG2Be9BF0AJ8HJ8IJ8Jeevshpfxzvxirzg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 29,
          "apCost": 0,
          "name": "Blood Frenzy",
          "shortDescription": "While this champion has less than half of its max HP remaining, it gets -2 DEF, +6 DMG, and gains 3 additional ranks of <ability value=17>Multiattack</ability> (to a max of 3 ranks).",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "offenseenhance"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 348,
              "apCost": 0,
              "name": "Berserk Attack",
              "shortDescription": "This unit makes a close-combat attack at +4 DMG and becomes Berserked (This unit gets -2 DEF) for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 1760,
              "apCost": 0,
              "name": "Impatient",
              "shortDescription": "This unit loses 5 HP at the end of your turn if it did not successfully attack.  Every time a friendly champion within 3 spaces successfully attacks, this unit gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": -8,
              "iconName": "impatient"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            },
            {
              "default": false,
              "id": 99,
              "apCost": 0,
              "name": "Life Siphon",
              "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            }
          ]
        }
      ]
    },
    {
      "id": 1539,
      "name": "Voil Glarewing",
      "description": "Being totally blind, Voil are not affected by light at all. Unlike its Nocturnal kin, the Glarewing is completely diurnal. Its skin can actually reflect sunlight and blind its attackers. ",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 73,
      "hash": "ej9Ej9DF0BF0Be9Ag3AJ8IJ8Jepuxfvfmhvoyoqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 2345,
          "apCost": 0,
          "name": "Starshine",
          "shortDescription": "The closest friendly champion that moves within 5 spaces gains a rank of <ability value=608>Majestic</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "distract"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": true,
              "id": 2671,
              "apCost": 0,
              "name": "Illuminate",
              "shortDescription": "When this champion successfully damages a unit with a basic attack, that unit is <condition value=illuminated>Illuminated</condition> for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 2486,
              "apCost": 3,
              "name": "Blind",
              "shortDescription": "Target champion within 4 spaces is <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "blind"
            }
          ]
        }
      ]
    },
    {
      "id": 1280,
      "name": "Voil Guard",
      "description": "The internal structures of the Voil are not widely known to outsiders, though it is clear that the guards in and around the Queen's roost are substantial.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Knight"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 69,
      "hash": "ej9Dj9CE8De9Be9AG2Bj9Ej9Fgyxmpqlyzilwkpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1550,
          "apCost": 0,
          "name": "Enduring Aura",
          "shortDescription": "Damage to friendly champions within 2 spaces is reduced by 2. (this ability and its effects do not stack)",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "aurapositive"
        },
        {
          "id": 3148,
          "apCost": 0,
          "name": "Provision: Utility",
          "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "plunder"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 877,
              "apCost": 0,
              "name": "Bodyguard",
              "shortDescription": "Target champion within 5 spaces is Bodyguarded (While this unit is within 5 spaces of the Bodyguarding unit, all damage dealt to this champion is prevented and is dealt to the Bodyguarding unit instead) for 6 turns. If this unit attacks, this effect is removed. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "block"
            },
            {
              "default": false,
              "id": 1967,
              "apCost": 0,
              "name": "Relic Guardian",
              "shortDescription": "This champion gains +4 DMG and +2 DEF when it is within 3 spaces of a friendly relic.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 657,
              "apCost": 2,
              "name": "Relocate: Ally",
              "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 3297,
              "apCost": 0,
              "name": "Zeal: Defense",
              "shortDescription": "When this champion makes a successful basic attack, it gains +2 DEF for 5 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "channel_defense"
            },
            {
              "default": true,
              "id": 3392,
              "apCost": 0,
              "name": "Peaks Armaments",
              "shortDescription": "When a friendly champion with Race: Cyclops, Race: Voil, Race: G'hern or Race: Moga becomes equipped, it gains 1 AP and +1 DEF for 4 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            }
          ]
        }
      ]
    },
    {
      "id": 935,
      "name": "Voil Imperialist",
      "description": "Amongst Eehiist's grand army, there have been several who disagree with the Voil Queen. When Ruubgaal returned, this group of Voil emerged from the darkness. They wore the armor of the old Voil King.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 74,
      "hash": "dj9AJ8Jf1Ag3Ag3Aj9Dj9Ej9Fepfgtojtfigrukg",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 1382,
          "apCost": 0,
          "name": "Prestige",
          "shortDescription": "All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "iron_will"
        },
        {
          "id": 1899,
          "apCost": 0,
          "name": "Scale Armor",
          "shortDescription": "This champion takes 25% less damage (after DEF) from attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "scale_armor"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 3044,
              "apCost": 0,
              "name": "Bulwark",
              "shortDescription": "When this champion is deployed from the runedock, it permanently gains +2 MAX HP for each friendly champion that shares a race or class with it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 1080,
      "name": "Voil Infernal",
      "description": "Ruubgaal's gift has warped them completely. It's become sport to them, as they float the balance between life and death so deftly they rarely hear the screams of those they take from and the sighs of relief from those that receive. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Priest"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 74,
      "hash": "ej9Dj9Cf1BE8De9AG2Bj9Aj9Bqlnuxonuhnnykpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 939,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 3 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "drain"
        },
        {
          "id": 303,
          "apCost": 0,
          "name": "Divine Favor",
          "shortDescription": "When this unit is deployed, friendly champions heal 4 HP.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "divine"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 725,
          "apCost": 2,
          "name": "Transfer Life",
          "shortDescription": "This unit loses 9 HP, and target champion within 5 spaces heals 12 HP.",
          "activationType": 1,
          "level": 1,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "heal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 98,
              "apCost": 0,
              "name": "Lifedrinker",
              "shortDescription": "When this unit destroys an opposing champion, it vampiric heals HP equal to half the destroyed champion's max HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "ondeath"
            },
            {
              "default": true,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1399,
              "apCost": 1,
              "name": "Hex",
              "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "lossoflife"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1349,
              "apCost": 2,
              "name": "Relieve",
              "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and all effects removed are applied to this unit.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 1284,
      "name": "Voil Jester",
      "description": "Voil Jesters look and act ridiculous, but are actually highly skilled in the arts of observation and deception.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 72,
      "hash": "ej9Dj9CF0Be9Be9AG2BJ8IJ8Jgtuojpnhnwfggpf",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 966,
          "apCost": 2,
          "name": "Cackle",
          "shortDescription": "Opposing champions within 2 spaces become <condition value=awestruck>Awestruck</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "cackle"
        },
        {
          "id": 2687,
          "apCost": 3,
          "name": "Confuse",
          "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "confuse"
        },
        {
          "id": 2563,
          "apCost": 3,
          "name": "Flourish",
          "shortDescription": "Opposing champions within 4 spaces are <condition value=charmed>Charmed</condition> and <condition value=distracted>Distracted</condition> for 4 turns. ",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "auranegative"
        },
        {
          "id": 149,
          "apCost": 0,
          "name": "Sonic Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novasonic"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2685,
              "apCost": 0,
              "name": "Restraining Aura",
              "shortDescription": "When an enemy champion within 5 spaces activates an ability (excluding basic attacks), that ability has +3 cooldown.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            },
            {
              "default": false,
              "id": 1037,
              "apCost": 5,
              "name": "Deception",
              "shortDescription": "This unit is relocated to target space within 5 spaces, 2 <condition value=illusion>Illusion</condition> copies of this champion are randomly spawned adjacent to target location.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "planar"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1728,
              "apCost": 0,
              "name": "Divert",
              "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "deflect"
            },
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": true,
              "id": 1370,
              "apCost": 0,
              "name": "Deflect: Sand",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Physical damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_sand"
            }
          ]
        }
      ]
    },
    {
      "id": 879,
      "name": "Voil King Ruubgaal",
      "description": "While living, Ruubgaal was the greatest king the Voil had ever known. With Serkan's necromancy now fueling his body his power has grown ten fold...and he has not forgotten Eehiist's betrayal.",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead",
        "Voil"
      ],
      "noraCost": 92,
      "hash": "dj9Fj9EE8Dg3Af1Bj9Aj9Bj9Ceeeerllrwvfxigg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2270,
          "apCost": 0,
          "name": "Attack: Mouth Lightning",
          "shortDescription": "This unit makes an Electricity attack, from its freakin' mouth, at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2238,
          "apCost": 0,
          "name": "Black Tempest",
          "shortDescription": "At the beginning of each of this unit's turns, a random opposing champion within 8 spaces takes 6 Electricity damage (this damage ignores DEF).  For every 5 champions in play, this ability triggers again but can only affect a unit once per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 18,
          "iconName": "black_tempest"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 1276,
              "apCost": 0,
              "name": "Vengeful",
              "shortDescription": "This unit gains +1 DMG every time a real friendly champion which shares a race with this champion is destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2185,
              "apCost": 0,
              "name": "Stunning Wail",
              "shortDescription": "Spend 8 Charges. Opposing champions within 6 spaces become <condition value=stunned>Stunned</condition> for 2 turns and this champion loses all remaining charges.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "stunning"
            },
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 1774,
              "apCost": 0,
              "name": "Phylactery Bound",
              "shortDescription": "When this unit is deployed from the runedock, a Phylactery relic is summoned in the closest friendly deployment zone.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 15,
              "iconName": "phylactery"
            }
          ]
        }
      ]
    },
    {
      "id": 167,
      "name": "Voil Lancer",
      "description": "With sound alone a Voil selects its target, its lance never missing its intended victim.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 73,
      "hash": "dj9Bj9Af1Be9Af1Bj9Aj9Bj9Cerhnnsmwvhvqfeg",
      "artist": "Gabriel Garza",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 3197,
          "apCost": 0,
          "name": "Homing Sense",
          "shortDescription": "This unit has <ability value=6>Mobility</ability>. At the beginning of its turns, if it is not <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>, this unit is relocated to the closest enemy champion within 5 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "homing_sense"
        },
        {
          "id": 3265,
          "apCost": 0,
          "name": "Portal Watcher",
          "shortDescription": "When a friendly champion relocates (including this one), this champion gains +1 DMG and a rank of <ability value=15>Multiattack</ability> for 1 turn. This can stack up to 3 times.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "deploy_chrgd"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 1263,
          "apCost": 2,
          "name": "Swap",
          "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2077,
              "apCost": 0,
              "name": "Reflexes",
              "shortDescription": "This unit takes 35% less damage (after DEF) from melee attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "reflexes"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1775,
              "apCost": 0,
              "name": "Precision",
              "shortDescription": "This champion's attacks cannot miss and ignores the effects of Evasive and Reflexes.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": true,
              "id": 3266,
              "apCost": 0,
              "name": "Combat Awareness",
              "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "combat_awareness"
            }
          ]
        }
      ]
    },
    {
      "id": 386,
      "name": "Voil Lifestealer",
      "description": "Some Voil developed the ability to consume flesh for much more than sustenance!",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 63,
      "hash": "dj9Gj9Fe9AF0Bf1Bj9Aj9Bj9Ceemnnjwxmuhrsfg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path to Conquest",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 99,
          "apCost": 0,
          "name": "Life Siphon",
          "shortDescription": "When this unit attacks and deals damage to a champion, it vampiric heals HP equal to half the damage dealt.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1457,
              "apCost": 0,
              "name": "Forage",
              "shortDescription": "This unit gains 2 AP when it captures a nora globe.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "forage"
            },
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1206,
              "apCost": 0,
              "name": "Cripple",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have Crippled, it becomes <condition value=crippled>Crippled</condition> for 10 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "debuff"
            },
            {
              "default": false,
              "id": 1255,
              "apCost": 0,
              "name": "Inhibiting Touch",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=Inhibited>Inhibited</condition> for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "inhibit"
            }
          ]
        }
      ]
    },
    {
      "id": 1282,
      "name": "Voil Nighthawk",
      "description": "The Queen not only openly admits to their existence, but celebrate these anarchists for their ability to carry out any task.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 68,
      "hash": "ej9Dj9Ce9Be9Be9AG2BJ8GJ8Hszzkjgvvsqumuo",
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 2799,
          "apCost": 0,
          "name": "Still Life",
          "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "stealth"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1353,
              "apCost": 2,
              "name": "Snatch",
              "shortDescription": "Equipment within 3 spaces is destroyed. You gain 2 AP per equipment destroyed this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2686,
              "apCost": 0,
              "name": "Logistics: Flanking",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains <ability value=2429>Flanking</ability> permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 2212,
              "apCost": 0,
              "name": "Banditry",
              "shortDescription": "Whenever this champion successfully damages a champion with any attack, that champion's controller loses up to 2 nora and you gain nora equal to the amount lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "banditry"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 448,
      "name": "Voil Progenitor ",
      "description": "These titans are said to be the Shattered Peaks themselves, aiding their Voil allies in battle.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 7,
      "damage": 15,
      "hitPoints": 70,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 110,
      "hash": "dj9Fj9EE8Df1AF0AJ8HJ8IJ8Jeeeersuxoshegyg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Nora Surge",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2704,
          "apCost": 0,
          "name": "Crushing Blow",
          "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "shrink"
        },
        {
          "id": 48,
          "apCost": 0,
          "name": "Resistance: Physical",
          "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "resistance_physical"
        },
        {
          "id": 1272,
          "apCost": 0,
          "name": "Titan",
          "shortDescription": "This unit has <ability value=3>Fearless</ability>, <ability value=680>Planar Bound</ability>, <ability value=814 popup=false>Unequippable</ability>, <ability value=4>Iron Will</ability>, <ability value=597>Unstoppable</ability>, <ability value=942>Eternal</ability>, <ability value=1201>Clear</ability> and <ability value=3379>Magic Ward</ability>. If this champion is deployed when you have less than 3 real champions in play, it is destroyed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "titan"
        },
        {
          "id": 1799,
          "apCost": 0,
          "name": "Trample",
          "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "crush"
        },
        {
          "id": 1928,
          "apCost": 0,
          "name": "Voil Caverns",
          "shortDescription": "The first time each turn a real enemy champion within 5 spaces is destroyed, a Young Bat with no upgrades is summoned adjacent to this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 11,
          "iconName": "sumbat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3375,
              "apCost": 0,
              "name": "Zealot",
              "shortDescription": "This unit gains +1 DMG for every other friendly real champion to a maximum of 5.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1036,
              "apCost": 0,
              "name": "Surge: Voil",
              "shortDescription": "This unit has +1 DMG for every friendly Voil",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_voil"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 2562,
              "apCost": 4,
              "name": "Rock Slide",
              "shortDescription": "Area Effect 2, Range 5: Champions without <ability value=2527>Rock Defiance</ability> in the affected area take 12 Physical damage and become <condition value=grounded>Grounded</condition> for 3 turns. This damage ignores DEF. Affected spaces become Rock for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "physicalaoe"
            },
            {
              "default": false,
              "id": 1864,
              "apCost": 0,
              "name": "Slowing Armor",
              "shortDescription": "When this champion is successfully attacked by any attack, the attacking champion becomes <mechanic value=slowed>Slowed</mechanic> for 3 turns.\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "conduit"
            }
          ]
        }
      ]
    },
    {
      "id": 165,
      "name": "Voil Queen",
      "description": "Boastful, young, and cruel, the Voil Queen Eehiist bore all the traits of doomed leadership. Yet somehow, she continued to win battles.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 74,
      "hash": "dj9Bj9Af1Be9AF0BJ8IJ8Jj9Axqoufiyolrhvhyg",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 331,
          "apCost": 0,
          "name": "Regal Presence",
          "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "majestic"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 686,
          "apCost": 4,
          "name": "Summon: Young Bat",
          "shortDescription": "A Young Bat with no upgrades is summoned on to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumbat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 1337,
              "apCost": 0,
              "name": "Gift of Fertility",
              "shortDescription": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 1529,
      "name": "Voil Queen",
      "description": "Boastful, young, and cruel, the Voil Queen Eehiist bore all the traits of doomed leadership. Yet somehow, she continued to win battles.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 74,
      "hash": "ej9Dj9CF0BF0Be9AG2BJ8IJ8Jeevfmymletmekpf",
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 331,
          "apCost": 0,
          "name": "Regal Presence",
          "shortDescription": "Friendly champions within 3 spaces that share a race with this champion have <ability value=1932>Loyalty</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "majestic"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 686,
          "apCost": 4,
          "name": "Summon: Young Bat",
          "shortDescription": "A Young Bat with no upgrades is summoned on to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumbat"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2471,
              "apCost": 0,
              "name": "Protective",
              "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "protective"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": false,
              "id": 2953,
              "apCost": 0,
              "name": "Blinding",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=blinded>Blinded</condition> for 2 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blind"
            },
            {
              "default": true,
              "id": 1337,
              "apCost": 0,
              "name": "Gift of Fertility",
              "shortDescription": "Abilities that create units that are on your champions have their cooldowns decreased by 1 (to a minimum of 1). This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "surge"
            }
          ]
        }
      ]
    },
    {
      "id": 166,
      "name": "Voil Screecher",
      "description": "You're gonna have to speak up. The poor lad's ears are shot from the damned shriekers. -Boghopper Rangers",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 73,
      "hash": "dj9Bj9Af1Be9Af1AJ8Jj9Aj9Biekggymuqsjgrzg",
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2688,
          "apCost": 4,
          "name": "Screech",
          "shortDescription": "Opposing champions within 2 spaces take 12 Sonic damage, opposing champions within 4 spaces take 10 Sonic damage, and opposing champions within 6 spaces take 8 Sonic damage. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "sonicaoe"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 2268,
              "apCost": 0,
              "name": "Sonic Eater",
              "shortDescription": "When this unit takes Sonic damage, it instead recovers HP equal to half the damage that would have been dealt.  This unit cannot be Distracted.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_sonic"
            },
            {
              "default": true,
              "id": 2931,
              "apCost": 0,
              "name": "Amplify: Sonic",
              "shortDescription": "Sonic damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_sonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 245,
              "apCost": 0,
              "name": "Damage Shield: Sonic",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Sonic damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_sonic"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 197,
              "apCost": 0,
              "name": "Death Nova: Sonic",
              "shortDescription": "When this unit is destroyed, it deals 11 Sonic damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "deathnovasonic"
            }
          ]
        }
      ]
    },
    {
      "id": 1281,
      "name": "Voil Skyhowler",
      "description": "\"My Queen, we have finished training the new Skyhowlers, who should prove to be quite useful for defending our squadrons against ranged assaults.\" ~ Report from a  Voil Sky Captain",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 71,
      "hash": "ej9Dj9Ce9Ae9Be9AG2Bj9Fj9Gljrhvolekpqwoqf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 2297,
          "apCost": 1,
          "name": "Grant: Evasive",
          "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3189,
              "apCost": 1,
              "name": "Sonicburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Sonic damage. If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=distracted>Distracted</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "sonicaoe"
            },
            {
              "default": true,
              "id": 2100,
              "apCost": 3,
              "name": "Gale",
              "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "gale"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 2127,
              "apCost": 1,
              "name": "Grant: Sonic Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=149>Sonic Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 755,
      "name": "Voil Skythrash",
      "description": "Skythrash gain their title through brute force; an actual tally is made of their victories. A Voil with more than a thousand kills is a Skythrash. There is no ceremony for achieving such a feat, only the title.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 65,
      "hash": "dj9Ej9Dg3AG2AE8Dj9Ej9Fj9Geeemwilymlnjpjg",
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1395,
          "apCost": 0,
          "name": "Hunter: Walker",
          "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "predator_angel"
        },
        {
          "id": 2008,
          "apCost": 0,
          "name": "Liability",
          "shortDescription": "Friendly champions within 5 spaces of this champion have -1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "dampen"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            }
          ]
        }
      ]
    },
    {
      "id": 325,
      "name": "Voil Sorcerer",
      "description": "Voil that show an aptitude for bestial magic are separated from the others at birth. They believe bestial magic is channeled through discipline and rage, two things no Voil lacks.",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 75,
      "hash": "dJ8JJ8IF0BF0Ag3Aj9Dj9Ej9Fwiwinsuzvfmpfgg",
      "artist": "Kelly Hamilton",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1072,
          "apCost": 1,
          "name": "Magical Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "magicaoe"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2300,
              "apCost": 0,
              "name": "Charged Blast",
              "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
              "activationType": 3,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 962,
              "apCost": 1,
              "name": "Reckless Blast",
              "shortDescription": "This unit makes a Magical attack at RNG 2-5 at 12 DMG and the closest friendly champion to the damaged champion takes 4 magic damage as well. This damage ignores DEF.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "magicaoe"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2261,
              "apCost": 0,
              "name": "Violence Charged",
              "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "charged_abuse"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            }
          ]
        }
      ]
    },
    {
      "id": 1604,
      "name": "Voil Stalker",
      "description": "Voil Stalkers particularly enjoy prey who have gone to ground, utilizing their pet companion to ferret out their quarry.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 82,
      "hash": "eJ8JJ8Ie9BF0AG2AF0BJ8GJ8Hwiwiwzmjnjinso",
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 3109,
          "apCost": 0,
          "name": "Pet: Swiftwing",
          "shortDescription": "When this champion is deployed, a Level 1 Swiftwing is summoned adjacent to it.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "pet"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 3294,
          "apCost": 0,
          "name": "Warlord",
          "shortDescription": "When a friendly champion within 5 spaces that shares a race or class with this one makes a successful targeted attack, this champion gains +1 MAX RNG and +1 DMG for 1 turn. This ability can trigger up to 3 times per turn.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "warlord"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3072,
              "apCost": 3,
              "name": "Elusive Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 9,
              "iconName": "dashing_dodge"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 693,
      "name": "Voil Stormflyer",
      "description": "The Voil grew accustomed to the intermittent lightning storms, learning to turn them against their enemies.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 69,
      "hash": "dJ8JJ8IF0BG2AF0AJ8HJ8IJ8Jeeeeephphygrfxf",
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 805,
          "apCost": 1,
          "name": "Chain Lightning",
          "shortDescription": "This champion makes an attack at Range 2-4 against a champion for 13 Electricity damage, then each enemy unit within 2 spaces of the target takes 10 Electricity damage, then each enemy unit within 2 spaces of those units take 7 Electricity damage. This damage ignores DEF. A single unit may not take more than one instance of damage from this effect.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "electric"
        },
        {
          "id": 1344,
          "apCost": 0,
          "name": "Provision: Defense",
          "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "plunder"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1606,
              "apCost": 0,
              "name": "Reflection",
              "shortDescription": "Champions attacking this champion from range take 5 damage of the Attacker's damage type.",
              "activationType": 2,
              "level": 4,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "damageshield"
            },
            {
              "default": false,
              "id": 2247,
              "apCost": 0,
              "name": "Static Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=shocked>Shocked</condition> for 2 turns\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_static"
            },
            {
              "default": true,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 141,
              "apCost": 0,
              "name": "Electricity Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": false,
              "id": 1877,
              "apCost": 0,
              "name": "Static Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this champion, it takes 2 points of Electricity damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaelectric"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1708,
      "name": "Voil Stormspear",
      "description": "As the Voil obsession with electricity grew, so did their bravery in going to its source.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 53,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Knight"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 87,
      "hash": "ej9Bj9AF0Af1AG2Af1BJ8HJ8Iqjlwxtsxkjrwmpf",
      "artist": "Alex Brock",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 141,
          "apCost": 0,
          "name": "Electricity Aura",
          "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Electricity damage to each champion within 2 spaces. This damage ignores DEF.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "novaelectric"
        },
        {
          "id": 113,
          "apCost": 0,
          "name": "Initiative",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "initiative"
        },
        {
          "id": 2401,
          "apCost": 4,
          "name": "Lightning Skewer",
          "shortDescription": "All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this unit take 12 Electricity damage and are <condition value=paralyzed>Paralyzed</condition> 1. This damage ignores DEF.",
          "activationType": 3,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "electricaoe"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        },
        {
          "id": 3200,
          "apCost": 2,
          "name": "Stormseeker",
          "shortDescription": "This champion is relocated adjacent to target champion within 5 spaces with <condition value=shocked>Shocked</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=distracted>Distracted</condition> and gains +2 SPD for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "relocate_lightning"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1368,
              "apCost": 0,
              "name": "Deflect: Electric",
              "shortDescription": "Next time this unit takes damage from an attack made by target champion within 8 spaces, that damage is redirected as Electric damage to the nearest enemy within 8 spaces. This effect is hidden until triggered. (You may target this unit to Deflect the damage from the next attack by any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 10,
              "iconName": "deflect_electric"
            },
            {
              "default": true,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            },
            {
              "default": false,
              "id": 2555,
              "apCost": 0,
              "name": "Electric Overload",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns. If that champion is already Shocked, it is equipped with a Lightning Rod. Equipment generated by this ability costs 0 nora.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "jolt"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1331,
              "apCost": 0,
              "name": "Electricity Eater",
              "shortDescription": "When this unit would take Electric damage, it instead recovers HP equal to half the damage that would have been dealt. This unit cannot be <condition value=shocked popup=false>Shocked</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_electric"
            },
            {
              "default": true,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 1909,
              "apCost": 0,
              "name": "Storm Acolyte",
              "shortDescription": "Whenever a champion takes Electricity damage, this champion heals 2 HP.  This triggers up to 3 times per turn and does not include damage from <condition value=shocked popup=false>Shocked</condition>.\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_storm"
            }
          ]
        }
      ]
    },
    {
      "id": 209,
      "name": "Voil Transporter",
      "description": "You dropped him from too high. Fly lower you fool! - Sceian, Voil Lance Admiral",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 69,
      "hash": "dj9Gj9Fe9Ae9Bg3Aj9Dj9Ej9Fwvxtjrowtmhkuhg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2100,
          "apCost": 3,
          "name": "Gale",
          "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "gale"
        },
        {
          "id": 657,
          "apCost": 2,
          "name": "Relocate: Ally",
          "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "relocate"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 820,
              "apCost": 4,
              "name": "Portal",
              "shortDescription": "This unit may teleport to any deployment zone its controller controls.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1750,
              "apCost": 1,
              "name": "Grant: Tempo",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1271>Tempo</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 3148,
              "apCost": 0,
              "name": "Provision: Utility",
              "shortDescription": "While this champion is equipped, it gains <ability value=3062>Shatter Summoned</ability>, <ability value=1306>Mountaineer</ability> and <ability value=13>Detection 3</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 537,
      "name": "Voil Windstriker",
      "description": "The sky is ours! Kill the invaders! For Queen Eehiist! - Aariis, Voil Windstriker",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Voil"
      ],
      "noraCost": 75,
      "hash": "dj9Gj9Fe9Af1BE8Dj9Ej9Fj9Gemjinnszmsxofgg",
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1200,
          "apCost": 0,
          "name": "Hunter: Flying",
          "shortDescription": "When this unit would deal damage to a <condition value=flying popup=false>Flying</condition> champion with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=flying popup=false>Flying</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "gale"
        },
        {
          "id": 2644,
          "apCost": 2,
          "name": "Phantom Dash",
          "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate"
        },
        {
          "id": 1939,
          "apCost": 0,
          "name": "Sonic Flight",
          "shortDescription": "This champion has <condition value=flying>Flying</condition>, <ability value=92>Vulnerability: Sonic</ability> and <ability value=1376>Evasive 1</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "flight_sonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1036,
              "apCost": 0,
              "name": "Surge: Voil",
              "shortDescription": "This unit has +1 DMG for every friendly Voil",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_voil"
            },
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 1502,
              "apCost": 0,
              "name": "Bravery",
              "shortDescription": "This unit gains <ability value=1006>Surge: Enemy</ability> and <ability value=4>Iron Will</ability> when a champion that shares a race with it is within 3 spaces. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 332,
              "apCost": 0,
              "name": "Sunder",
              "shortDescription": "When this champion makes a successful basic attack against a champion, the target becomes <condition value=sundered>Sundered</condition> for 3 turns. ",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            }
          ]
        }
      ]
    },
    {
      "id": 1148,
      "name": "Voltaic Slag",
      "description": "\"There is no rhyme or reason to their attacks, if you observe them long enough you'll see them shock enemies, friends, and moga with equal abandon. Their weapon is pure chaos.\" - Lien, the second prophet of madness",
      "maxRng": 6,
      "minRng": 5,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Slag"
      ],
      "noraCost": 74,
      "hash": "ej9AJ8Je9Be9Ae9Af1AJ8GJ8Hsqqufrojwkwthn",
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 2298,
          "apCost": 1,
          "name": "Grant: Reflexes",
          "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 3,
          "iconName": "grantability"
        },
        {
          "id": 2312,
          "apCost": 0,
          "name": "Impair Vision",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "observe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2478,
              "apCost": 0,
              "name": "Improve Range",
              "shortDescription": "Units within 5 spaces of this champion that share a race or class with this champion have +1 MAX RNG. This ability does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "improve_range"
            },
            {
              "default": false,
              "id": 2555,
              "apCost": 0,
              "name": "Electric Overload",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns. If that champion is already Shocked, it is equipped with a Lightning Rod. Equipment generated by this ability costs 0 nora.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "jolt"
            },
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 1279,
              "apCost": 0,
              "name": "Weary",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion does not have <condition value=wearied>Wearied</condition>, it becomes <condition value=wearied>Wearied</condition> for 6 turns. ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 2244,
              "apCost": 0,
              "name": "Jolt",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=shocked>Shocked</condition> for 3 turns.\r\n",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "jolt"
            }
          ]
        }
      ]
    },
    {
      "id": 86,
      "name": "Voodoo Shamfie",
      "description": "How they harness the tremendous powers that lay in the Swamps is unknown to me. But they do it well. - Feofil",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute",
        "Shaman"
      ],
      "races": [
        "Barbarian",
        "Beast"
      ],
      "noraCost": 80,
      "hash": "cj9AJ8JJ8IF0BF0BJ8IJ8Jj9Aevxtoyvmplluhth",
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2,
          "apCost": 0,
          "name": "Amphibious",
          "shortDescription": "This champion ignores restrictions and penalties imposed by Water. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 1,
          "iconName": "amphib"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 1371,
          "apCost": 0,
          "name": "Soul Siphon",
          "shortDescription": "When a real champion is destroyed this unit gains 5 MAX HP (to a maximum of 100) and +1 DMG permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 20,
          "iconName": "soul_siphon"
        },
        {
          "id": 2132,
          "apCost": 0,
          "name": "Water Front",
          "shortDescription": "At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "terrainwater"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3063,
              "apCost": 0,
              "name": "Kill Sense",
              "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 3192,
              "apCost": 0,
              "name": "Render",
              "shortDescription": "When this effect comes into play and at the beginning of each turn, this champion has +DMG equal to the highest DEF value on enemy champions for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "render"
            },
            {
              "default": true,
              "id": 607,
              "apCost": 0,
              "name": "Essence Capture",
              "shortDescription": "When this champion deals damage to a champion on a basic attack, you gain nora equal to 30% of the damage dealt.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "noragen"
            }
          ]
        }
      ]
    },
    {
      "id": 751,
      "name": "Vothsair Ireguard",
      "description": "Under Grimlic's control, the Ireguards protect his Vothsair Spires. They roam through the peaks of Mt. Belkairon, releasing their endless anger on any who cross their paths.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 13,
      "hitPoints": 58,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 90,
      "hash": "dj9Dj9CG2BG2Af1Bj9Aj9Bj9Cevfvvxxtmpyvfig",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1504,
          "apCost": 0,
          "name": "Brutality",
          "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "surge"
        },
        {
          "id": 1244,
          "apCost": 0,
          "name": "Cleave",
          "shortDescription": "After this champion makes an basic attack, it then makes an attack against each other adjacent champion as well.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "multiattack"
        },
        {
          "id": 2004,
          "apCost": 0,
          "name": "Faithless",
          "shortDescription": "This unit has no spell presence.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -3,
          "iconName": "dead_magic_zone"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1489,
              "apCost": 0,
              "name": "Unspeakable",
              "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "ignore_invite"
            },
            {
              "default": true,
              "id": 1486,
              "apCost": 0,
              "name": "Strike",
              "shortDescription": "This champion's attacks ignore DEF if the target's DEF is greater than 0.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "defpenalties"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            }
          ]
        }
      ]
    },
    {
      "id": 1829,
      "name": "Vothsair Monstrosity",
      "description": "\"You may perform your... experiments, servant of Serkan. But remember that I shall collect the payment at a time of my choosing.\" ~ Maxxarek to Xulos",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Demon",
        "Undead",
        "Zombie"
      ],
      "noraCost": 82,
      "hash": "eJ8IJ8He9BG2BG2AF0AJ8GJ8Hemnhtziilymwxo",
      "artist": "Jordy Knoop",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3293,
          "apCost": 0,
          "name": "Bind: Spells",
          "shortDescription": "When this champion destroys an enemy champion, enemy spells cost 5 nora more to play while this champion is in play. This ability triggers up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "bind_spells"
        },
        {
          "id": 2575,
          "apCost": 0,
          "name": "Defiling Aura",
          "shortDescription": "Opposing champions within 3 spaces are <condition value=defiled>Defiled</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "defile_corpse"
        },
        {
          "id": 456,
          "apCost": 2,
          "name": "Fear",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "fear"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2142,
              "apCost": 0,
              "name": "Zombie Apocalypse",
              "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "zombie_apoc"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 3056,
              "apCost": 0,
              "name": "Overkill: Healing",
              "shortDescription": "When this unit would destroy a unit with a basic attack, it is healed for the amount of damage given beyond the current health of the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "overkill"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 157,
              "apCost": 0,
              "name": "Disease Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novadisease"
            },
            {
              "default": false,
              "id": 474,
              "apCost": 1,
              "name": "Blood Rage",
              "shortDescription": "This unit makes a melee attack and loses 8 HP. This ability's AP cost cannot be modified.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "rend"
            },
            {
              "default": false,
              "id": 410,
              "apCost": 1,
              "name": "Stun",
              "shortDescription": "This champion makes an attack at 8 DMG.  If successful, the target becomes <condition value=stunned>Stunned</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "stun"
            }
          ]
        }
      ]
    },
    {
      "id": 1843,
      "name": "Vothsair Overlord",
      "description": "\"We lost the forward post, sir.\" - \"How? Explain yourselves.\" - \"A Vothsair, sir. A big one.\" - \"Oh... I'm glad at least one of you made it out alive.\"",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 55,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 86,
      "hash": "eJ8JJ8If1BG2BG2AF0Bj9Aj9Bsmsmnnuhkpfxxqf",
      "artist": "Grant Griffin",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2704,
          "apCost": 0,
          "name": "Crushing Blow",
          "shortDescription": "When this champion makes a successful basic attack, that champion becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "shrink"
        },
        {
          "id": 3309,
          "apCost": 5,
          "name": "Invoke: Vothsair Crush",
          "shortDescription": "Area Effect 4: Enemy champions take 10 Physical damage and are <condition value=scolded>Scolded</condition> for 2 turns. This effect is automatically triggered with cooldown the first time this champion falls below 50% MAX HP (this triggers even if the ability is already on cooldown and will place the ability on full cooldown).",
          "activationType": 1,
          "level": 0,
          "cooldown": 8,
          "noraCost": 8,
          "iconName": "invoke"
        },
        {
          "id": 4,
          "apCost": 0,
          "name": "Iron Will",
          "shortDescription": "This champion cannot be <condition value=charmed>Charmed</condition>, <condition value=possessed>Possessed</condition> or <condition value=distracted>Distracted</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "iron_will"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1781,
              "apCost": 0,
              "name": "Restrict",
              "shortDescription": "All champions within 6 spaces of this unit are unequippable.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "unequipable"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 1908,
              "apCost": 0,
              "name": "Fire Acolyte",
              "shortDescription": "Whenever a champion takes Fire damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=charred>Charred</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1613,
              "apCost": 0,
              "name": "Searing Aura",
              "shortDescription": "When an opposing champion moves within 2 spaces of this champion or when this champion moves within 2 spaces of an opposing champion, the opposing champion suffers 3 Fire damage. At the end of your turn all opposing champions within 2 spaces suffer 4 Fire damage. Damage given by this ability ignores DEF.",
              "activationType": 2,
              "level": 5,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "novafire"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            },
            {
              "default": true,
              "id": 910,
              "apCost": 0,
              "name": "Amplify: Fire",
              "shortDescription": "Fire damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_fire"
            }
          ]
        }
      ]
    },
    {
      "id": 1030,
      "name": "Vothsair Reaver",
      "description": "Reavers protect the inner chambers of the Vothsair Spires. Even the Bok steer clear of Reavers for their relentless rage is near impossible to contain. ",
      "maxRng": 2,
      "minRng": 1,
      "defense": 3,
      "speed": 6,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "LEGENDARY",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 82,
      "hash": "eJ8IJ8HG2AE8De9AF0Aj9Bj9Cemexzgvfxmssqo",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1987,
          "apCost": 2,
          "name": "Hold the Line",
          "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "defenseenhance"
        },
        {
          "id": 1505,
          "apCost": 1,
          "name": "Throw Shield",
          "shortDescription": "This champion makes a Physical attack at range 2-5.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "throw_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 28,
              "apCost": 0,
              "name": "Blood Frenzy",
              "shortDescription": "While this champion has less than half of its max HP remaining, it gets -1 DEF, +4 DMG, and gains 2 additional ranks of <ability value=16>Multiattack</ability> (to a max of 3 ranks).",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            },
            {
              "default": false,
              "id": 1481,
              "apCost": 2,
              "name": "Shield Allies",
              "shortDescription": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 5,
              "iconName": "aurapositive"
            },
            {
              "default": false,
              "id": 1221,
              "apCost": 0,
              "name": "Font Blessing",
              "shortDescription": "While this champion is within 5 spaces of a font deployment zone you control, it gets +1 DEF, +5 DMG, and +10 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 8,
              "apCost": 0,
              "name": "Battlemaster",
              "shortDescription": "Friendly champions within 3 spaces get +2 DMG and +1 DEF.  This effect does not stack.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2271,
              "apCost": 0,
              "name": "Sentinel",
              "shortDescription": "Whenever an enemy champion within this unit's range successfully attacks another friendly unit, this unit makes a free basic attack against the attacking champion.  ",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 1506,
      "name": "Vothsair Vanguard",
      "description": "The Vanguard are the first to battle, and often the first to fall, but they do so willingly, for only the weak fear death.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Demon"
      ],
      "noraCost": 82,
      "hash": "ej9Bj9Ae9AF0Be9Af1Bj9Fj9Gerlyrukjrhrzkpf",
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 685,
          "apCost": 0,
          "name": "Arrow Eater",
          "shortDescription": "When this unit would take damage from a targeted ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "eater_arrow"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 3025,
          "apCost": 0,
          "name": "Vanguard",
          "shortDescription": "When this champion is within 5 spaces of a friendly champion with <ability value=685>Arrow Eater</ability> or <ability value=2469>Elusive</ability>, this unit gains <ability value=116>Regeneration 2</ability> and +1 SPD.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "vanguard"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1380,
              "apCost": 0,
              "name": "Blood Bond",
              "shortDescription": "When a friendly champion within 5 spaces that has one or more of the same races as this champion is attacked, this unit gains 2 AP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "bloodbond"
            },
            {
              "default": true,
              "id": 1799,
              "apCost": 0,
              "name": "Trample",
              "shortDescription": "Whenever this champion moves by way of its normal movement, all opposing champions within 2 spaces take 2 damage. \r\n",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "crush"
            },
            {
              "default": false,
              "id": 125,
              "apCost": 0,
              "name": "Damage Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Physical damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novaphysical"
            }
          ]
        }
      ]
    },
    {
      "id": 1403,
      "name": "Wailing Banshee",
      "description": "A banshee's wail is at once tragic, horrifying and deadly.\r\n",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Witch"
      ],
      "races": [
        "Spirit",
        "Undead",
        "Vampyre"
      ],
      "noraCost": 72,
      "hash": "ej9Ej9Df1BF0Ae9Ag3Aj9Aj9Bkuszmuzipwvfvqf",
      "artist": "Conceptopolis",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1807,
          "apCost": 0,
          "name": "Deafening Aura",
          "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "deafening_aura"
        },
        {
          "id": 1248,
          "apCost": 3,
          "name": "Pull",
          "shortDescription": "Target enemy champion within 5 spaces is relocated 3 spaces closer to an unoccupied non-damaging, non-chasm space. This ability shares a cooldown with Drop Harpoon.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "pull"
        },
        {
          "id": 1976,
          "apCost": 3,
          "name": "Wail of Grief",
          "shortDescription": "Enemy champions within 3 spaces take 8 Sonic damage and lose all AP. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novasonic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2197,
              "apCost": 3,
              "name": "Blood Magic",
              "shortDescription": "Enemy champions within 3 spaces lose 8 HP and are <condition value=bloodied>Bloodied</condition> for 8 turns.  If an affected champion is already Bloodied, this champion vampiric heals 8 HP.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "novablood"
            },
            {
              "default": true,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1619,
              "apCost": 0,
              "name": "Desecrated Zone",
              "shortDescription": "Area Effect 3: Affected spaces are <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "terrain_dmz"
            },
            {
              "default": true,
              "id": 1274,
              "apCost": 0,
              "name": "Vaporize",
              "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 1391,
              "apCost": 0,
              "name": "Ignorance",
              "shortDescription": "Enemy Wizards, Shamans and Priests within 5 spaces of this unit may not activate abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "ignorance"
            }
          ]
        }
      ]
    },
    {
      "id": 1081,
      "name": "Wailing Yeti",
      "description": "\"You hear that, that howling?  No that's just the wi -  That's not wind, we're in Yeti country. On your guard.\" - Vedk, Draksar Scout\r\n",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Bard"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 74,
      "hash": "ej9Dj9CG2AE8De9AG2Bj9Bj9Cemwitzvsjiyxoqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heritage",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1324,
          "apCost": 0,
          "name": "Domain: Arctic",
          "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "domain_snow"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 149,
              "apCost": 0,
              "name": "Sonic Aura",
              "shortDescription": "At the beginning of your opponent's turns, this unit deals 6 Sonic damage to each champion within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 299,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 1,
              "cooldown": 5,
              "noraCost": 6,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": false,
              "id": 1807,
              "apCost": 0,
              "name": "Deafening Aura",
              "shortDescription": "Whenever an enemy champion moves within 2 spaces of this unit, it takes 3 Sonic damage and is <condition value=distracted>Distracted</condition> for 2 turns.  This damage ignores DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "deafening_aura"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            }
          ]
        }
      ]
    },
    {
      "id": 788,
      "name": "Wall of Ailur",
      "description": "The Walls of Ailur are the most distinguished of all the warrior societies. A Wall is a massive, heavily-armored warrior, capable of devastating an entire army of Kanen.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 81,
      "hash": "dj9Gj9Fe9AG2Bf1AJ8Jj9Aj9Bxmjpwowtmpfkygg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 648,
          "apCost": 0,
          "name": "Attack: Spear",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "spear"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 1389,
          "apCost": 0,
          "name": "Perseverance",
          "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "tgtdefensive"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 2710,
              "apCost": 0,
              "name": "Stat Bonus: Range",
              "shortDescription": "This champion gains +1 MAX RNG.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusrange"
            }
          ]
        }
      ]
    },
    {
      "id": 830,
      "name": "Wall of Ailur",
      "description": "The Walls of Ailur are the most distinguished of all the warrior societies. A Wall is a massive, heavily-armored warrior, capable of devastating an entire army of Kanen.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 56,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 80,
      "hash": "dj9AJ8Jf1AG2BG2Aj9Bj9Cj9Djwftmhgrosjyohg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3041,
          "apCost": 0,
          "name": "Hunter: Meek",
          "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "hunter_meek"
        },
        {
          "id": 3079,
          "apCost": 0,
          "name": "Sapping Armor",
          "shortDescription": "When this champion is successfully attacked by a basic attack, the attacking champion loses 3 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sapping_armor"
        },
        {
          "id": 1481,
          "apCost": 2,
          "name": "Shield Allies",
          "shortDescription": "For 2 turns, friendly normal-sized champions and relics that are within 2 spaces of this unit gain <ability value=1378>Evasive 3</ability>.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "aurapositive"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1242,
              "apCost": 0,
              "name": "Pace",
              "shortDescription": "When this champion is successfully attacked by a basic attack, it gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "initiative"
            },
            {
              "default": true,
              "id": 2299,
              "apCost": 0,
              "name": "Soul of Ailur",
              "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2075>Pride of Ailur</ability> gains 1 AP and gains +2 DMG for 6 turns (to a max of +4 DMG).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "warriorspride"
            },
            {
              "default": false,
              "id": 1269,
              "apCost": 2,
              "name": "Antagonize",
              "shortDescription": "Target champion within 2 spaces can only target and attack this champion for 4 turns. A champion can only be antagonized by one champion at a time.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enrage"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1987,
              "apCost": 2,
              "name": "Hold the Line",
              "shortDescription": "This champion gains +2 DEF, +1 MAX RNG, <ability value=680>Planar Bound</ability>, <ability value=597>Unstoppable</ability>, <ability value=4>Iron Will</ability> and <ability value=1818>Defensive Strike</ability> until it moves. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 2710,
              "apCost": 0,
              "name": "Stat Bonus: Range",
              "shortDescription": "This champion gains +1 MAX RNG.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusrange"
            }
          ]
        }
      ]
    },
    {
      "id": 553,
      "name": "Wandering Zombie",
      "description": "I'm not sure I see the usefulness in a detachable head. Perhaps, it's my inexperience. - Apprentice Tachrim",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 62,
      "hash": "dJ8HJ8Ge9Bf1BG2Aj9Bj9Cj9Dxowxojinygkwxzg",
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1491,
          "apCost": 0,
          "name": "Brainless",
          "shortDescription": "When this unit is destroyed, it drops no nora globe and is re-spawned with the Headless ability at the location where it died.  The brainless unit is <ability value=814>Unequippable</ability>",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "headless"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 47,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 746,
              "apCost": 0,
              "name": "Dead Eater",
              "shortDescription": "When this unit recovers a nora globe, it recovers an additional 6 nora.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "nora_eater"
            },
            {
              "default": true,
              "id": 664,
              "apCost": 0,
              "name": "Rabid",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=diseased>Diseased</condition> for 4 turns.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "dot_rabid"
            }
          ]
        }
      ]
    },
    {
      "id": 683,
      "name": "War-Enchanted Groble",
      "description": "Some grobles are etched with ancient runes before they are awakened.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 72,
      "hash": "dJ8IJ8HF0AG2Ae9BJ8GJ8HJ8Imssuvhyzknphkwf",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2737,
          "apCost": 0,
          "name": "Physical Amped",
          "shortDescription": "This champion loses a charge at the end of its turn. While this champion has at least 8 charges, it has +1 SPD, +2 DMG, +2 DEF and Physical Aura 3.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "amped_physical"
        },
        {
          "id": 1476,
          "apCost": 0,
          "name": "Resilient",
          "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        },
        {
          "id": 2261,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3163,
              "apCost": 0,
              "name": "Adaptive",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, it gains +1 DMG. If the spell costs 35 nora or more, it also gains +3 MAX HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1913,
              "apCost": 0,
              "name": "Backlash",
              "shortDescription": "Whenever a unit generates nora through an ability, it loses HP equal to the amount gained. If the nora was generated via a spell, the owner's shrine loses HP equal to half the amount gained. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_hex"
            },
            {
              "default": false,
              "id": 3003,
              "apCost": 0,
              "name": "Dispelling Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <mechanic value=dispelled>Dispelled</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "dispelling_blows"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 36,
              "apCost": 0,
              "name": "Immunity: Magical",
              "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "immunity_magic"
            },
            {
              "default": false,
              "id": 2190,
              "apCost": 0,
              "name": "Charged Attack",
              "shortDescription": "Spend 3 Charges: This champion makes an attack at its RNG. This is a free attack (costs 0 AP and is not on the attack chain).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "charged_attack"
            },
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 618,
      "name": "Warcaller Fiorn",
      "description": "I come with news from your Elder, Godwin. The Deep-elves are in K`thir! Now is the time to fight for our homeland! Ready your weapons, clansman, we go to war! - Fiorn, Warcaller",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Bard",
        "Knight"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 82,
      "hash": "dj9Dj9CG2Bf1Be9BJ8GJ8HJ8Ipshtjekpqhytxzg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1752,
          "apCost": 0,
          "name": "Heavy Charger",
          "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "crush"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1756,
          "apCost": 2,
          "name": "Horn of K'thir",
          "shortDescription": "All friendly champions get +1 DEF and have +4 DMG on melee attacks for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "horn_kithir"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            },
            {
              "default": true,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 1853,
      "name": "Warcaller Fiorn",
      "description": "I come with news from your Elder, Godwin. The Deep-elves are in K`thir! Now is the time to fight for our homeland! Ready your weapons, clansman, we go to war! - Fiorn, Warcaller",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 60,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Bard",
        "Knight"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 82,
      "hash": "ej9AJ8Jg3AG2BG2Af1Aj9Dj9Eeiymyxigyvofvsf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1752,
          "apCost": 0,
          "name": "Heavy Charger",
          "shortDescription": "This champion deals 50% more damage when using <ability value=394>Charge</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "crush"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        },
        {
          "id": 1756,
          "apCost": 2,
          "name": "Horn of K'thir",
          "shortDescription": "All friendly champions get +1 DEF and have +4 DMG on melee attacks for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "horn_kithir"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1444,
              "apCost": 0,
              "name": "Counter Attack: Melee",
              "shortDescription": "This unit makes a free attack against any champion that successfully attacks it with an attack at RNG 1.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "counter"
            },
            {
              "default": false,
              "id": 2568,
              "apCost": 0,
              "name": "Vigilance",
              "shortDescription": "This champion has +1 DMG for each engaged friendly champion within 5 spaces, including itself.  At the end of its turn, it gains a rank of <ability value=1900>Tough</ability> for 2 turns for each engaged friendly champion within 5 spaces, including this one.  It also gains +1 SPD if that champion shares a race or class with it, not including itself.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "vigilance"
            },
            {
              "default": true,
              "id": 1320,
              "apCost": 0,
              "name": "Assault",
              "shortDescription": "This unit makes an attack at no AP cost against any unit that attempts to disengage from it. Spells and abilities that relocate other units do not trigger this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "assault"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1138,
              "apCost": 3,
              "name": "Command: Block",
              "shortDescription": "Friendly champions within 3 spaces become <condition value=blocking>Blocking</condition>.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 4,
              "iconName": "command_block"
            },
            {
              "default": false,
              "id": 1209,
              "apCost": 0,
              "name": "Defiant",
              "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "eater_rock"
            },
            {
              "default": true,
              "id": 2392,
              "apCost": 0,
              "name": "Battle Leader",
              "shortDescription": "When this champion destroys an opposing champion, friendly champions permanently gain +1 DMG. If those champions also share a race or class with this champion, they also are healed for 3 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "divine"
            }
          ]
        }
      ]
    },
    {
      "id": 954,
      "name": "Ward of Ailur",
      "description": "The Wards do not belong to a formal warrior caste, but are trained with the same intensity. Wards protect Ailur from behind its walls, using their knowledge of the city to their advantage.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Leoss"
      ],
      "noraCost": 74,
      "hash": "dj9Cj9BG2Ag3Af1Bj9Aj9Bj9Ceeruvztjyrqofig",
      "artist": "Anthony Lopes",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2559,
          "apCost": 0,
          "name": "Commander",
          "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "improve_damage"
        },
        {
          "id": 2075,
          "apCost": 0,
          "name": "Pride of Ailur",
          "shortDescription": "This champion has <ability value=479>Brushwalker</ability>. When this champion attacks another champion with an attack that costs at least 1 AP, the closest valid friendly champion within 8 spaces with <ability value=2299>Soul of Ailur</ability> gains 1 AP and gains +1 DEF for 6 turns (to a max of +2 DEF).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "warriorspride"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3041,
              "apCost": 0,
              "name": "Hunter: Meek",
              "shortDescription": "When this unit would deal damage to a champion with nora cost 72 or less, that damage is increased by 2. When this unit would receive damage from a champion with nora cost 72 or less, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "hunter_meek"
            },
            {
              "default": false,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 1344,
              "apCost": 0,
              "name": "Provision: Defense",
              "shortDescription": "While this champion is equipped, it gains a rank of <ability value=213>Block</ability>, <ability value=597>Unstoppable</ability> and +1 DEF.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 2031,
              "apCost": 0,
              "name": "Stat Bonus: Speed",
              "shortDescription": "This champion gains +1 SPD.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "plusspeed"
            }
          ]
        }
      ]
    },
    {
      "id": 1619,
      "name": "Warden of the Path",
      "description": "De'lim was able to convince the Circle to allow him to install portal devices throughout the Forest, as a way to facilitate movement and security. Those devices would ultimately be used by the Nefari during their invasion.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 69,
      "hash": "ej9Fj9Ee9AF0BG2AE8Dj9Fj9Gemjwirljytzitqf",
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1441,
          "apCost": 0,
          "name": "Confuse Enemy",
          "shortDescription": "The next time this champion successfully makes an attack against an enemy unit, this champion is relocated 3 spaces directly away from the target.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "confuse"
        },
        {
          "id": 3136,
          "apCost": 0,
          "name": "Empowered: Offense",
          "shortDescription": "This champion has +3 DMG and <ability value=1775>Precision</ability>. This ability is removed after 3 basic attacks.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "empowered_offense"
        },
        {
          "id": 3117,
          "apCost": 3,
          "name": "Summon: Path of De'lim",
          "shortDescription": "Summon a Path of De'lim relic with <ability value=3115>Path of De'lim</ability> to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 7,
          "iconName": "deploy"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            },
            {
              "default": true,
              "id": 1882,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_burn"
            },
            {
              "default": false,
              "id": 3120,
              "apCost": 0,
              "name": "Provision: Speed",
              "shortDescription": "While this champion is equipped, it gains +1 SPD and <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "plunder"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2646,
              "apCost": 0,
              "name": "Heart Strike",
              "shortDescription": "When this champion makes a successful basic attack against a champion with 50% or less HP, it gains 1 AP and has +2 DMG for the attack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "killing_stroke"
            },
            {
              "default": false,
              "id": 2840,
              "apCost": 0,
              "name": "Devotee of De'lim",
              "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "devotee_delim"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 87,
      "name": "Warogg",
      "description": "As if being eaten by a Gahlroon wasn't enough to worry about! Now this?  - Deep Elf Scout",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 8,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast",
        "Demon"
      ],
      "noraCost": 57,
      "hash": "cj9Bj9AJ8Jf1AF0BJ8Jj9Aj9Bytxqzmjtzvojpwi",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 751,
          "apCost": 3,
          "name": "Spike Nova",
          "shortDescription": "This unit deals 9 Physical damage to each unit within 2 spaces. This damage ignores DEF. Champions successfully damaged become <condition value=burred>Burred</condition> for 4 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "novaspike"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 163,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 3 turns",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 221,
              "apCost": 0,
              "name": "Damage Shield: Physical",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Physical damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_physical"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 315,
              "apCost": 0,
              "name": "Melee Specialist",
              "shortDescription": "While this champion is within 3 spaces of at least 2 enemy champions it gets +2 DMG.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 172,
              "apCost": 0,
              "name": "Death Nova: Physical",
              "shortDescription": "When this unit is destroyed, it deals 8 Physical damage to each champion and Relic within 2 spaces, and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.",
              "activationType": 2,
              "level": 2,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "deathnovaphysical"
            },
            {
              "default": true,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            }
          ]
        }
      ]
    },
    {
      "id": 851,
      "name": "Wavecrusher",
      "description": "Wavecrushers are extremely hard to control. Only the most Favored of Eriluun's followers can calm the behemoth's rage. However, no matter how favored the follower, the hold is only temporary.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 13,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 59,
      "hash": "dj9Cj9BG2AG2BG2Bj9Cj9Dj9Eeerzkpytqwtoykg",
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1407,
          "apCost": 4,
          "name": "Dive",
          "shortDescription": "This ability may be activated only if this unit occupies water. This unit is relocated to target water space within 7 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "tunnel_dive"
        },
        {
          "id": 859,
          "apCost": 0,
          "name": "Semi Aquatic",
          "shortDescription": "This unit is <ability value=2>Amphibious</ability>.  This unit has +1 SPD when within 3 spaces of water. At the beginning of your turns, if it is not within 3 spaces of water it has -1 SPD and loses 3 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "semiaquatic"
        },
        {
          "id": 876,
          "apCost": 0,
          "name": "Short Lived",
          "shortDescription": "This unit is destroyed after 8 turns.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": -15,
          "iconName": "ondeath"
        },
        {
          "id": 2233,
          "apCost": 0,
          "name": "Stationary",
          "shortDescription": "This unit may not spend AP on normal movement. Relocation effects are not affected.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -10,
          "iconName": "lumbering"
        },
        {
          "id": 1044,
          "apCost": 0,
          "name": "Trail: Water",
          "shortDescription": "At the beginning of each turn and whenever this champion moves, the spaces this unit occupies becomes Water (Impeding 1) for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "trail_water"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 869,
              "apCost": 3,
              "name": "Tremor",
              "shortDescription": "Opposing champions without <condition value=flying popup=false>Flying</condition> within 3 spaces of this unit are knocked back 1 space, gain <ability value=5>Lumbering</ability> for 2 turns and take 6 Physical damage. Enemy relics in the affected area take 6 Physical damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "physicalaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2582,
              "apCost": 0,
              "name": "Impairing Feedback",
              "shortDescription": "When this champion is successfully attacked by a basic attack, if the attacking champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            }
          ]
        }
      ]
    },
    {
      "id": 215,
      "name": "Weaponsmith",
      "description": "You've come to the right place...now what exactly are you trying to kill? - Wern, Dwarven Weaponsmith",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Dwarf"
      ],
      "noraCost": 67,
      "hash": "dJ8HJ8Ge9Be9Bf1AJ8Jj9Aj9Binuqsufemhvzmwf",
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2473,
          "apCost": 1,
          "name": "Carouse",
          "shortDescription": "Target adjacent champion is equipped with a Pale Brew. If this champion is equipped with a Brew equipment, the target is equipped with that Brew instead. Brew replaces the Pale Brew. Equipment generated by this ability costs 0 nora.",
          "activationType": 0,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "carouse"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 947,
              "apCost": 0,
              "name": "Craft",
              "shortDescription": "Equipment runes of the same faction as this unit have their cooldown reduced to 0.",
              "activationType": 1,
              "level": 0,
              "cooldown": 8,
              "noraCost": 5,
              "iconName": "forge"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            },
            {
              "default": true,
              "id": 3393,
              "apCost": 0,
              "name": "Ironfist Armaments",
              "shortDescription": "When a friendly champion with Race: Angel, Race: Barbarian, Race: Dwarf, or Race: Construct becomes equipped, it gains 1 AP and +2 DMG for 2 turns. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": true,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            }
          ]
        }
      ]
    },
    {
      "id": 603,
      "name": "Weaver",
      "description": "Within Sheoul, there are places where the walls are covered in webbing. Occasionally, deep inside the tightly weaved mass, a muffled cry can be heard.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Arthropod"
      ],
      "noraCost": 67,
      "hash": "dj9Bj9Af1Bf1BG2Aj9Bj9Cj9Dzgtoyxitfxzkphg",
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 2141,
          "apCost": 0,
          "name": "Creep and Crawl",
          "shortDescription": "While 4 or more friendly champions with the race Arthropod are in play, this unit gains <ability value=1306>Mountaineer</ability> and an additional rank of <ability value=15>Multiattack</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "creep_and_crawl"
        },
        {
          "id": 1792,
          "apCost": 2,
          "name": "Relocate: Arthropod",
          "shortDescription": "Target friendly Arthropod within 5 spaces is relocated to a space adjacent to this unit.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "relocate_arthropod"
        },
        {
          "id": 1793,
          "apCost": 0,
          "name": "Spider Frenzy",
          "shortDescription": "Other friendly champions with Race: Arthropod within 8 spaces have <ability value=6>Mobility</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "sumspider"
        },
        {
          "id": 1805,
          "apCost": 3,
          "name": "Weave Web",
          "shortDescription": "Area Effect 2, Range 3: Affected area is becomes <mechanic value=web_terrain>Web Terrain</mechanic> for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "web"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 846,
              "apCost": 1,
              "name": "Entangle",
              "shortDescription": "This unit makes a Physical attack at RNG 2-5 against target champion. If successful, that unit becomes <condition value=grounded>Grounded</condition> for 2 turns, <condition value=ensnared>Ensnared</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "net"
            },
            {
              "default": false,
              "id": 1858,
              "apCost": 3,
              "name": "Summon: Spiderling",
              "shortDescription": "Summon a Spiderling champion with no upgrades to target adjacent space.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "sumspider"
            },
            {
              "default": false,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2298,
              "apCost": 1,
              "name": "Grant: Reflexes",
              "shortDescription": "Target champion within 5 spaces gains <ability value=2077>Reflexes 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 13,
              "apCost": 0,
              "name": "Detection",
              "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "detection"
            },
            {
              "default": false,
              "id": 2297,
              "apCost": 1,
              "name": "Grant: Evasive",
              "shortDescription": "Target champion within 5 spaces gains <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 1688,
      "name": "Whirling Quarry",
      "description": "\"I've been through the storms of the dunes, but this was another thing entirely.\" -- Report from the Draksar Consulate in Scinzar",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 81,
      "hash": "ej9Ej9DF0BF0BG2Ag3AJ8IJ8Jepjgpfpwtxthgrf",
      "artist": "Danh Nguyen",
      "factions": [
        "Shattered Peaks"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1952,
          "apCost": 0,
          "name": "Slam",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "knockback"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        },
        {
          "id": 3174,
          "apCost": 0,
          "name": "Whirling Stones",
          "shortDescription": "At the end of this unit's turns and when it is the target of a basic attack, the closest enemy champion within 3 spaces takes 5 Physical damage and is knocked back 1 space.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "whirling_stones"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3147,
              "apCost": 0,
              "name": "Seism",
              "shortDescription": "When this champion is deployed, the closest enemy relic takes 20 Physical damage.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 14,
              "iconName": "seism"
            },
            {
              "default": false,
              "id": 3087,
              "apCost": 3,
              "name": "Sonic Surge",
              "shortDescription": "This champion gains 3 AP and Pacified for 1 turn.  For each space moved, enemy champions within 2 spaces take 3 Sonic damage (this damage ignores DEF).  This ability begins on CD.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 12,
              "iconName": "charge_sonic"
            },
            {
              "default": false,
              "id": 2711,
              "apCost": 0,
              "name": "Summon: Rock Trap",
              "shortDescription": "Summon a Rock Trap relic with <ability value=601>Shadowspawn</ability> and <ability value=1029>Rock Trap</ability> to target adjacent space. This ability does not break stealth",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 15,
              "iconName": "deploy"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2337,
              "apCost": 4,
              "name": "Blessing of Stone",
              "shortDescription": "For 4 turns, all friendly champions gain 2 ranks of <ability value=47>Resistance: Physical</ability>. Friendly champions that are occupying rock terrain also gain <ability value=1242>Pace</ability> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": false,
              "id": 1317,
              "apCost": 0,
              "name": "Absorb",
              "shortDescription": "If this unit is successfully attacked at RNG 2 or greater, it gains <ability value=685>Arrow Eater</ability> for 1 turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "eater_arrow"
            },
            {
              "default": false,
              "id": 1849,
              "apCost": 0,
              "name": "Shroud",
              "shortDescription": "Other friendly champions within 3 spaces gain <ability value=1377>Evasive 2</ability>  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "aurapositive"
            }
          ]
        }
      ]
    },
    {
      "id": 1405,
      "name": "Whisperghast",
      "description": "\"There is so much more to this utterdark than Serkan ever knew!\" Xulos\r\n",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Spirit",
        "Undead"
      ],
      "noraCost": 73,
      "hash": "ej9Ej9DG2BF0Ae9Ag3Aj9Cj9Dukwxirlpnhemjrf",
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2854,
          "apCost": 2,
          "name": "Relocate: DMZ",
          "shortDescription": "Target friendly champion, within 5 spaces, who is standing on <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is relocated next to this unit.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "special"
        },
        {
          "id": 1857,
          "apCost": 0,
          "name": "Soultap",
          "shortDescription": "Any time this champion damages another with a basic attack, the target becomes <condition value=soultapped>Soultapped</condition> for 6 turns",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "dot_soultap"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2832,
              "apCost": 0,
              "name": "Domain: Dead Magic Zone",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying a <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic>. \r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "dead_magic_zone"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": false,
              "id": 1390,
              "apCost": 2,
              "name": "Relocate: Relic",
              "shortDescription": "Target friendly relic within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "relocate_relic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2701,
              "apCost": 0,
              "name": "Shadestrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 2 spaces of the target becomes a Dead Magic Zone for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "terrain_dmz"
            },
            {
              "default": false,
              "id": 866,
              "apCost": 2,
              "name": "Drain",
              "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 4,
              "iconName": "drain"
            },
            {
              "default": false,
              "id": 2784,
              "apCost": 0,
              "name": "Hunter: Soultapped",
              "shortDescription": "When this unit would deal damage with any attack to a <condition value=soultapped>Soultapped</condition> champion, that damage is increased by 2. When this unit would receive damage from any attack by a <condition value=soultapped>Soultapped</condition> champion, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dot_soultap"
            }
          ]
        }
      ]
    },
    {
      "id": 1635,
      "name": "Whitestar",
      "description": "Whitestars are rare, enormous snowflakes that have somehow achieved sentient thought; born on wind and a whim.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elemental"
      ],
      "noraCost": 74,
      "hash": "eJ8HJ8GF0AF0BG2Ae9BJ8HJ8Ieemsxzkrfiipqo",
      "artist": "Rogier van de Beek",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 2209,
          "apCost": 0,
          "name": "Mirrored",
          "shortDescription": "When this champion would take non-Physical damage from an attack, that damage is reduced by 50% (rounded down), and the attacking champion takes an equal amount of damage of the same type.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "mirrored"
        },
        {
          "id": 778,
          "apCost": 2,
          "name": "Snow-Fall",
          "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 4,
          "iconName": "terrainsnow"
        },
        {
          "id": 814,
          "apCost": 0,
          "name": "Unequippable",
          "shortDescription": "This champion may not be equipped.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -5,
          "iconName": "unequipable"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1744,
              "apCost": 0,
              "name": "Frost Acolyte",
              "shortDescription": "Whenever a champion takes Frost damage, this champion heals 2 HP. This triggers up to 3 times per turn and does not include damage from <condition value=chilled>Chilled</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "catalyst_frost"
            },
            {
              "default": false,
              "id": 2963,
              "apCost": 0,
              "name": "Surge: Elemental",
              "shortDescription": "This unit gets +1 DMG for every friendly Elemental",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_rock"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 3105,
              "apCost": 4,
              "name": "Absolute Zero",
              "shortDescription": "Opposing champions within 2 spaces take 12 Frost damage, opposing champions within 4 spaces take 10 Frost damage, and opposing champions within 6 spaces take 8 Frost damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "absolute_zero"
            },
            {
              "default": false,
              "id": 3129,
              "apCost": 3,
              "name": "Elemental Storm: Frost",
              "shortDescription": "Enemy champions within 3 spaces of at least one friendly Elemental, Shaman or Wizard, including this one, take 5 Frost damage (ignores DEF) and lose up to 1 AP. This champion gains 1 AP per AP lost this way.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "absolute_zero"
            },
            {
              "default": false,
              "id": 3331,
              "apCost": 0,
              "name": "Tundra Awakening",
              "shortDescription": "This champion has +1 DMG, +1 DEF and +1 SPD for every 2 opposing champions occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fangandfur"
            }
          ]
        }
      ]
    },
    {
      "id": 682,
      "name": "Whitestone Gargoyle",
      "description": "King Rugolth had statues erected throughout the Stronghold, to remind his subjects of Old Valdac. These statues could be animated, to act as guardians.",
      "maxRng": 4,
      "minRng": 2,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Brute",
        "Warrior"
      ],
      "races": [
        "Construct"
      ],
      "noraCost": 75,
      "hash": "dJ8IJ8HF0AG2Ae9Aj9Fj9Gj9Hpyigiwmwipytofg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 548,
          "apCost": 0,
          "name": "Attack: Sonic",
          "shortDescription": "This unit makes a Sonic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_sonic"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 1926,
          "apCost": 0,
          "name": "Inscrutable Form",
          "shortDescription": "This champion cannot be cloned or copied. No other champions can take the form of this champion.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "inhibit"
        },
        {
          "id": 2012,
          "apCost": 0,
          "name": "Lethargic",
          "shortDescription": "At the beginning of every 6 turns, this champion is in play, it gains <ability value=5>Lumbering</ability> for 1 turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -6,
          "iconName": "lumbering"
        },
        {
          "id": 1903,
          "apCost": 3,
          "name": "Statue Form",
          "shortDescription": "This champion becomes <ability value=757>Immobile</ability> and <ability value=669>Earthbound</ability> It gains <ability value=35>Immunity: Physical</ability>, <ability value=117>Regeneration 3</ability>, +3 DEF, -5 DMG and its range is set to 1.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 5,
          "iconName": "transform"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1252,
              "apCost": 0,
              "name": "Readiness",
              "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1147,
              "apCost": 3,
              "name": "Sonic Roar",
              "shortDescription": "Champions within 2 spaces take 4 Sonic damage.  Champions successfully damaged champions become <condition value=awestruck>Awestruck</condition> for 2 turns. Relics within 2 spaces take 8 Sonic damage. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "novasonic"
            },
            {
              "default": false,
              "id": 1922,
              "apCost": 0,
              "name": "Revere: Drakon",
              "shortDescription": "While this champion is in play, Drakon costs 10% less nora to deploy. While Drakon is in play this unit has the <ability value=1899>Scale Armor</ability> ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1702,
              "apCost": 0,
              "name": "Blockade",
              "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "blockade"
            },
            {
              "default": false,
              "id": 1898,
              "apCost": 0,
              "name": "Blessing of the Fallen",
              "shortDescription": "When this unit is destroyed, friendly champions gain +1 DEF for 4 turns (this does not stack) and heal 10 HP.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ondeath"
            },
            {
              "default": true,
              "id": 1199,
              "apCost": 0,
              "name": "Calcify",
              "shortDescription": "When this champion is successfully attacked, it gains +2 DEF until the end of the turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "novaphysical"
            }
          ]
        }
      ]
    },
    {
      "id": 679,
      "name": "Wild Chieftain",
      "description": "You want me to apologize for the chieftain's actions? He's not a deranged brute; he is a respected warrior! You should be the one apologizing! - Zedin, Barbarian Elder",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 11,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 73,
      "hash": "dJ8HJ8Ge9BG2AG2Bj9Cj9Dj9Eeeiljpherfggpfg",
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2535,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "reinforcement"
        },
        {
          "id": 1479,
          "apCost": 0,
          "name": "Vigorous Cry",
          "shortDescription": "Whenever this unit makes a successful attack against a champion with a basic attack, friendly champions within 5 spaces gain 1 AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "allybuffs"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2875,
              "apCost": 0,
              "name": "Warchief: Blood Clan",
              "shortDescription": "This unit is <ability value=3>Fearless</ability>. At the end of your turn, this unit gains 1 rank of <ability value=163>Rend</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "blood_clan"
            },
            {
              "default": false,
              "id": 1348,
              "apCost": 0,
              "name": "Punish",
              "shortDescription": "When this unit deals damage to a champion with a basic attack, that champion loses all AP and loses HP equal to the AP lost.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "punish"
            },
            {
              "default": false,
              "id": 3403,
              "apCost": 0,
              "name": "Warchief: Beast Clan",
              "shortDescription": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "beast_clan"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1431,
              "apCost": 0,
              "name": "Barbaric Assault",
              "shortDescription": "This unit gains <ability value=1348>Punish</ability> and <ability value=1242>Pace</ability> when another friendly Barbarian is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": true,
              "id": 3374,
              "apCost": 0,
              "name": "Logistics: Damage",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +3 DMG permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            }
          ]
        }
      ]
    },
    {
      "id": 88,
      "name": "Wild Elf",
      "description": "If we are not kin in Nature, we are kin in purpose. Fight with me, brothers, for the glory of K'thir! - Godwin",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Barbarian",
        "Elf"
      ],
      "noraCost": 67,
      "hash": "bj9Gj9Fj9EE8Dj9Ej9Fj9Gj9Hmykukplgilepson",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 15,
          "apCost": 0,
          "name": "Multiattack",
          "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "multiattack"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2766,
              "apCost": 0,
              "name": "Logistics: Speed",
              "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            },
            {
              "default": true,
              "id": 3403,
              "apCost": 0,
              "name": "Warchief: Beast Clan",
              "shortDescription": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "beast_clan"
            }
          ]
        }
      ]
    },
    {
      "id": 728,
      "name": "Wild Griffin",
      "description": "Griffins are considered the highest form of predator amongst the animals of the Ironfist Mountains. It takes immense strength to tame a wild Griffin, along with a little patience.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 77,
      "hash": "dj9Bj9Af1BG2AF0AJ8HJ8IJ8Jeemwqwmljgruvzg",
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2465,
          "apCost": 0,
          "name": "Declare Hunted",
          "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "hunted"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2459,
          "apCost": 0,
          "name": "Honorary Sigil",
          "shortDescription": "This counts as a Sigil ability.  When this unit is deployed, other Sigil abilities will trigger.",
          "activationType": 1,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "griffin_sigil"
        },
        {
          "id": 2608,
          "apCost": 0,
          "name": "Reinforcement",
          "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "reinforcement"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2098,
              "apCost": 0,
              "name": "Combo Attack: Drain",
              "shortDescription": "When this champion makes two successful basic attacks against the same champion in a single turn, this unit heals an amount equal to the damage done on the second attack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "comboatk_drain"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1395,
              "apCost": 0,
              "name": "Hunter: Walker",
              "shortDescription": "When this unit would deal damage with any attack to a champion without <condition value=flying popup=false>Flying</condition>, that damage is increased by 2. When this unit would receive damage from any attack by a champion without <condition value=flying popup=false>Flying</condition>, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "predator_angel"
            },
            {
              "default": false,
              "id": 2644,
              "apCost": 2,
              "name": "Phantom Dash",
              "shortDescription": "For 1 turn, the next time a friendly champion makes a successful basic attack against target champion within 6 spaces, this champion is relocated to the closest available space to that champion.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            }
          ]
        }
      ]
    },
    {
      "id": 558,
      "name": "Wilderkin",
      "description": "I do not condone their ferocity, even if we are allies. - Darius, High Chancellor, speaking of Wilderkin",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 7,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Barbarian",
        "Beast",
        "Elf"
      ],
      "noraCost": 75,
      "hash": "dJ8IJ8HF0Af1Be9BJ8GJ8HJ8Irqjnsmnerfithvf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1374,
          "apCost": 0,
          "name": "Resolute",
          "shortDescription": "For 2 turns, all damage from attacks at RNG 1 against this unit is prevented.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "ironwill"
        },
        {
          "id": 1901,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 2 less than normal. ",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "defenseenhance"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1233,
              "apCost": 0,
              "name": "Hostile",
              "shortDescription": "This unit sacrifices 5 HP to gain +5 DMG until the end of turn.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 1875,
              "apCost": 0,
              "name": "Deep Wounds",
              "shortDescription": "Whenever this champion successfully damages an enemy champion with any attack, that champion becomes Wounded (This champion takes 35% additional damage from basic attacks made by champions with Deep Wounds.  This stacks up to 3 times) for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "rend"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 164,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 4 turns",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "dot_rend"
            },
            {
              "default": true,
              "id": 3101,
              "apCost": 0,
              "name": "Ferocious Bite",
              "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "ancestral_avenger"
            },
            {
              "default": false,
              "id": 3403,
              "apCost": 0,
              "name": "Warchief: Beast Clan",
              "shortDescription": "This unit has <ability value=1306>Mountaineer</ability>. At the end of your turn, this unit gains a rank of <ability value=394>Charge</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "beast_clan"
            }
          ]
        }
      ]
    },
    {
      "id": 722,
      "name": "Wilderkin Snakedancer",
      "description": "I was shocked he even survived the encounter. Not a single bruise on him. He's got quite a lot of skill with that whip. - Mardin, Garu Hurler",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard",
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 74,
      "hash": "dj9AJ8Jf1AG2AG2Aj9Bj9Cj9Dphgrhepqqwvzkgg",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2932,
          "apCost": 0,
          "name": "Attack: Whip",
          "shortDescription": "This unit makes a Physical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_whip"
        },
        {
          "id": 1947,
          "apCost": 0,
          "name": "Entangling Attack",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "disable"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 1436,
              "apCost": 0,
              "name": "Leverage: Beast",
              "shortDescription": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        }
      ]
    },
    {
      "id": 994,
      "name": "Wilderkin Snakedancer",
      "description": "\"It wasn't his whip that hurt. It was his biting criticism of my attire. I spent hours picking this out! How dare he!\" - Brennon, Vampyre",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 47,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Bard",
        "Ranger"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 74,
      "hash": "ej9Fj9Eg3AE8De9AE8Dj9Dj9Eerzthnnegkwilpf",
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1947,
          "apCost": 0,
          "name": "Entangling Attack",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "disable"
        },
        {
          "id": 168,
          "apCost": 0,
          "name": "Poison",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=poisoned>Poisoned</condition> for 4 turns.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "dot_poison"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 217,
              "apCost": 0,
              "name": "Dodge",
              "shortDescription": "Next time target champion within 10 spaces makes a ranged attack against this unit, that attack automatically misses.  This effect is hidden until triggered.  This effect does not trigger if this unit is <condition value=paralyzed>Paralyzed</condition> or <condition value=stunned>Stunned</condition>.  (You may target this unit to Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "dodge"
            },
            {
              "default": false,
              "id": 2509,
              "apCost": 0,
              "name": "Commander: Beast",
              "shortDescription": "Friendly champions within 5 spaces with Race: Beast have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            },
            {
              "default": false,
              "id": 1377,
              "apCost": 0,
              "name": "Evasive",
              "shortDescription": "This unit takes 35% less damage (after DEF) from ranged attacks.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_ranged"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 1436,
              "apCost": 0,
              "name": "Leverage: Beast",
              "shortDescription": "When this unit is deployed from the runedock, the next Beast that costs 80 or more nora that you deploy from the runedock costs 10 less nora. This effect lasts for a maximum of 3 turns and does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 3002,
              "apCost": 0,
              "name": "Hunter: Quick",
              "shortDescription": "When this unit would deal damage with any attack to a champion with SPD 7 or more, that damage is increased by 2. When this unit would receive damage from any attack by a champion with SPD 7 or more, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunter_quick"
            }
          ]
        }
      ]
    },
    {
      "id": 697,
      "name": "Wind Sprinter",
      "description": "The wind picked up and, before the Deep-elf could make sense of it, E`ulin was gone.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 9,
      "hitPoints": 34,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 71,
      "hash": "dJ8JJ8IF0BG2AG2Aj9Bj9Cj9Dsmsmwqfpuxmuxfg",
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 974,
          "apCost": 0,
          "name": "Arrow Throw",
          "shortDescription": "When a champion makes an unsuccessful ranged attack against this unit, this unit makes a ranged attack against that unit at +1 DMG.",
          "activationType": 2,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "dodge"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1871,
          "apCost": 0,
          "name": "Zephyr Shield",
          "shortDescription": "When this champion moves 4 spaces in a single turn, the next successful attack in 4 turns against it misses.  This effect stacks up to 3 times.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "zephyr_shield"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 1327,
              "apCost": 0,
              "name": "Domain: Vegetation",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Vegetation.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_vegetation"
            },
            {
              "default": false,
              "id": 820,
              "apCost": 4,
              "name": "Portal",
              "shortDescription": "This unit may teleport to any deployment zone its controller controls.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 396,
              "apCost": 0,
              "name": "Charge",
              "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "charge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2100,
              "apCost": 3,
              "name": "Gale",
              "shortDescription": "Area Effect 2, Range 5: Affected champions are knocked back 2 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "gale"
            },
            {
              "default": false,
              "id": 2995,
              "apCost": 0,
              "name": "Dashing Dodge",
              "shortDescription": "Next time target champion within 11 spaces makes a ranged attack against this unit, that attack automatically misses and this champion is relocated to the closest available space to target champion. This effect is hidden until triggered. This effect does not trigger if this unit is Paralyzed or Stunned. (You may target this unit to Artful Dodge the next ranged attack from any champion.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 10,
              "iconName": "dashing_dodge"
            }
          ]
        }
      ]
    },
    {
      "id": 89,
      "name": "Winged Lerper",
      "description": "The myth goes that if the lerpers had slightly stronger wings, they would fly back to their home on the moon.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 64,
      "hash": "cJ8IJ8HJ8Ge9Be9AJ8GJ8HJ8Imnhrlerolufkymh",
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 13,
          "apCost": 0,
          "name": "Detection",
          "shortDescription": "Enemy units within 5 spaces lose <condition value=stealthed>Stealthed</condition> and enemy traps within 5 spaces are revealed.",
          "activationType": 0,
          "level": 3,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "detection"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 2390,
          "apCost": 0,
          "name": "Hit and Run",
          "shortDescription": "When this champion makes a basic attack, it gains <ability value=6>Mobility</ability> for 1 turn and 1 AP whenever it moves for 1 turn. This effect may trigger up to 3 times per turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "hit_and_run"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2799,
              "apCost": 0,
              "name": "Still Life",
              "shortDescription": "At the beginning of your opponent's turns, if this champion did not move during your last turn, it becomes <condition value=stealthed>Stealthed</condition> for 5 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "stealth"
            },
            {
              "default": true,
              "id": 2587,
              "apCost": 0,
              "name": "Nightfall",
              "shortDescription": "When this champion is deployed or destroyed, the closest unstealthed friendly champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            },
            {
              "default": false,
              "id": 791,
              "apCost": 0,
              "name": "Hidden: Vegetation",
              "shortDescription": "At the end of your turn, if this champion occupies Vegetation, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2429,
              "apCost": 0,
              "name": "Flanking",
              "shortDescription": "Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "flank"
            },
            {
              "default": true,
              "id": 165,
              "apCost": 0,
              "name": "Rend",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that champion is <condition value=eviscerated>Eviscerated</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dot_rend"
            }
          ]
        }
      ]
    },
    {
      "id": 1724,
      "name": "Wingmaster Cleric",
      "description": "\"We need clerics, everywhere. How quickly can you teach them to fly?\" -- Juya",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 44,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Priest"
      ],
      "races": [
        "Beast",
        "Jakei"
      ],
      "noraCost": 74,
      "hash": "ej9Ej9Df1Af1AG2Ag3AJ8Jj9Aeeemegrhvsmsosf",
      "artist": "Maciej Janaszek",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 592,
          "apCost": 3,
          "name": "Cleanse",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "cleanse"
        },
        {
          "id": 3295,
          "apCost": 0,
          "name": "Healing Mind",
          "shortDescription": "When this champion makes a successful basic attack, the closest friendly damaged champion (not including this one) within 5 spaces of this champion is healed for 5.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "healing_wind"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2409,
              "apCost": 0,
              "name": "Empathy",
              "shortDescription": "Friendly champions within 5 spaces have an additional rank of Regeneration.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "martyr"
            },
            {
              "default": false,
              "id": 630,
              "apCost": 1,
              "name": "Grant: Flight",
              "shortDescription": "Target champion within 5 spaces gains <condition value=flying>Flying</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "flight"
            },
            {
              "default": false,
              "id": 2851,
              "apCost": 1,
              "name": "Grant: Mobility",
              "shortDescription": "Target champion within 5 spaces gains <ability value=6>Mobility</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 304,
              "apCost": 0,
              "name": "Divine Favor",
              "shortDescription": "When this unit is deployed, friendly champions heal 8 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 11,
              "iconName": "divine"
            },
            {
              "default": false,
              "id": 579,
              "apCost": 2,
              "name": "Invigorate",
              "shortDescription": "Target champion within 2 spaces gains 4 AP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "buff"
            }
          ]
        }
      ]
    },
    {
      "id": 556,
      "name": "Wisp",
      "description": "Folklore tells of wisps as vessels. They hold the souls of fallen elves and can carry them into the afterlife.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Fairy",
        "Spirit"
      ],
      "noraCost": 76,
      "hash": "dJ8IJ8HF0Af1BE8Dj9Ej9Fj9Gevkuzxfgvhykwzg",
      "artist": "Darcie Banfield",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2966,
          "apCost": 0,
          "name": "Fairy Flight",
          "shortDescription": "This unit has <condition value=flying>Flying</condition> while it has at least 15 HP. When this unit has less than 15 HP, it gains <ability value=2001>Defenseless</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "flight_fairy"
        },
        {
          "id": 1072,
          "apCost": 1,
          "name": "Magical Bomb",
          "shortDescription": "Area Effect 2, Range 5: Affected units take Magic damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged have their DEF set to 0 until the end of turn if their DEF is greater than 0.",
          "activationType": 1,
          "level": 3,
          "cooldown": 3,
          "noraCost": 10,
          "iconName": "magicaoe"
        },
        {
          "id": 1469,
          "apCost": 0,
          "name": "Nexus Aura",
          "shortDescription": "For 2 turns, any damage from spells or attacks done to a champion within 2 spaces is split and shared equally with all champions in that range.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "nexus_aura"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 326,
              "apCost": 0,
              "name": "Phase Shift",
              "shortDescription": "This unit becomes <condition value=incorporeal>Incorporeal</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "ethereal"
            },
            {
              "default": false,
              "id": 1764,
              "apCost": 0,
              "name": "Magic Acolyte",
              "shortDescription": "Whenever a champion takes Magic damage, this champion heals 2 HP.  This triggers up to 3 times per turn.\r\n\r\n",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "acolyte_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1336,
              "apCost": 0,
              "name": "Fascinate",
              "shortDescription": "At the beginning of your turn, any enemy champion without <ability value=4 popup=false>Iron Will</ability> within 5 spaces of this unit is moved 2 spaces directly towards this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "illuminate"
            },
            {
              "default": false,
              "id": 488,
              "apCost": 0,
              "name": "Soulsift",
              "shortDescription": "When this unit is destroyed, you gain nora equal to 20% of this units nora cost.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "soulsift"
            },
            {
              "default": true,
              "id": 1052,
              "apCost": 0,
              "name": "Purified",
              "shortDescription": "At the beginning of your turn, this unit is <mechanic value=cleansed>Cleansed</mechanic>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cleanse"
            }
          ]
        }
      ]
    },
    {
      "id": 976,
      "name": "Wizard of the Ways",
      "description": "\"The Way is as old as the forest and it has many masters. They wander through the forest, finding lost travelers and sending them home. I can teach you this, if you are willing to learn.\" - Menalaus",
      "maxRng": 6,
      "minRng": 5,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 75,
      "hash": "dj9Ej9Dg3Ag3Ae9Aj9Fj9Gj9Hwtqfvkgekljrqlg",
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2300,
          "apCost": 0,
          "name": "Charged Blast",
          "shortDescription": "Spend 5 Charges.  This champion makes a Magic attack against each opposing champion within its range.",
          "activationType": 3,
          "level": 0,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "magicaoe"
        },
        {
          "id": 2176,
          "apCost": 0,
          "name": "Spell Charged",
          "shortDescription": "When a spell is played, this unit gains 2 charges.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "charged_spell"
        },
        {
          "id": 406,
          "apCost": 4,
          "name": "Teleport",
          "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
          "activationType": 1,
          "level": 1,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "relocate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 657,
              "apCost": 2,
              "name": "Relocate: Ally",
              "shortDescription": "Target friendly champion within 5 spaces is relocated to the nearest available space adjacent to this unit. This ability cannot target <ability value=680>Planar Bound</ability> or <mechanic value=immobile>Immobile</mechanic> units.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 2341,
              "apCost": 3,
              "name": "Stall",
              "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 8,
              "iconName": "debuff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 2944,
              "apCost": 0,
              "name": "Portal Walker",
              "shortDescription": "When this champion is successfully relocated, it has +2 DMG until its next attack or for 6 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "deploy_chrgd"
            },
            {
              "default": false,
              "id": 1263,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 4 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 262,
      "name": "Wizened Wren",
      "description": "Beasts are not without their own form of wisdom. While the Wizened Wren is not a magical creature, it seems to have an understanding of magic that would rival most scholars. ",
      "maxRng": 5,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 67,
      "hash": "dJ8HJ8Ge9BF0Ae9BJ8GJ8HJ8Ietmuvsmeeilnnuf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2922,
          "apCost": 0,
          "name": "Arctic Flight",
          "shortDescription": "This unit has <ability value=600>Arctic</ability>, <condition value=flying>Flying</condition> and 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "shimmering_wings"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2488,
          "apCost": 0,
          "name": "Boon of the Wind",
          "shortDescription": "When this champion enters play the nearest friendly champion with <condition value=flying popup=false>Flying</condition> gains +1 DMG and an additional rank of <ability value=1376>Evasive</ability>.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "martyr"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1873,
              "apCost": 0,
              "name": "Magic Blast",
              "shortDescription": "When this unit makes a basic attack, all opposing champions within 2 spaces of the target take 50% Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "magicaoe"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            },
            {
              "default": true,
              "id": 3062,
              "apCost": 3,
              "name": "Shatter Summoned",
              "shortDescription": "Area Effect 3, Range 5: Enemy illusions and summoned units take 15 Psychic damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            },
            {
              "default": true,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 745,
              "apCost": 0,
              "name": "Magic Eater",
              "shortDescription": "When this unit would take Magic damage, it instead recovers HP equal to half the damage that would have been dealt.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "eater_magic"
            }
          ]
        }
      ]
    },
    {
      "id": 651,
      "name": "Wolf Pack",
      "description": "There was an understanding between the wolves and their home. They could take their food from the forest, but they would protect it when the need arose.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 35,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Beast"
      ],
      "noraCost": 82,
      "hash": "dj9Gj9Fe9AG2AF0BJ8IJ8Jj9Aqlnpqfrqsolrjeg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3101,
          "apCost": 0,
          "name": "Ferocious Bite",
          "shortDescription": "When this champion makes a successful basic attack, that champion has -3 DMG for 2 turns. This does not stack. If the target is <condition value=distracted>Distracted</condition> or <condition value=illuminated>Illuminated</condition>, that champion also gains 2 stacks of <condition value=sundered>Sundered</condition> for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "ancestral_avenger"
        },
        {
          "id": 3063,
          "apCost": 0,
          "name": "Kill Sense",
          "shortDescription": "Enemy champions within 5 spaces with 50% or less HP are <condition value=slowed>Slowed</condition>.  This champion gains +1 SPD and +2 DMG for every enemy champion within 5 spaces with 4 SPD or less.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "killing_stroke"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2773,
              "apCost": 0,
              "name": "Quest: Runner",
              "shortDescription": "For every 10 spaces this champion moves, it permanently gains +1 DMG and +3 MAX HP. This ability is removed after 4 triggers.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "opportunistic"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            },
            {
              "default": false,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1798,
              "apCost": 0,
              "name": "Wolf Pack",
              "shortDescription": "When this champion is deployed from the runedock, 2 Timber Wolves champions with no upgrades are summoned adjacent to it.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 40,
              "iconName": "pack_mentality"
            }
          ]
        }
      ]
    },
    {
      "id": 499,
      "name": "Wood Elemental",
      "description": "It can be trusted, Darius. That is not my concern. Its anger troubles me. - Menalaus of K`thir",
      "maxRng": 1,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 11,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Elemental",
        "Plant",
        "Treefolk"
      ],
      "noraCost": 75,
      "hash": "dj9Cj9BG2Af1AE8Dj9Ej9Fj9Gemekepnemuhnjgg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 3058,
          "apCost": 1,
          "name": "Chuck: Wood",
          "shortDescription": "This champion makes a Physical attack RNG 2-5.  A summoned Woodchucked Wood relic (15 HP with <ability value=2082>Jungle Front</ability>) is summoned adjacent to the target if it is successfully damaged.",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "chuck_wood"
        },
        {
          "id": 2083,
          "apCost": 0,
          "name": "Trailblaze",
          "shortDescription": "All friendly champions have Brushwalker (This champion ignores movement restrictions and movement penalties imposed by Vegetation.).",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "climb"
        },
        {
          "id": 1384,
          "apCost": 0,
          "name": "Transplant",
          "shortDescription": "When this champion would be destroyed and has at least 10 MAX HP, the nearest friendly plant champion is destroyed and this champion respawns on that location with -10 MAX HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "sumtree"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2369,
              "apCost": 0,
              "name": "Clamp",
              "shortDescription": "When this champion makes a successful melee attack against a champion, that champion gains <condition value=stationary>Stationary</condition> while engaged to this champion.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "clamp"
            },
            {
              "default": true,
              "id": 1122,
              "apCost": 0,
              "name": "Plant Regeneration",
              "shortDescription": "While occupying Grass, Vegetation, Dirt, or Water, this champion has <ability value=117>Regeneration 3</ability>.",
              "activationType": 0,
              "level": 3,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "plantregen"
            },
            {
              "default": false,
              "id": 3332,
              "apCost": 1,
              "name": "Vine Whip",
              "shortDescription": "This champion makes a Physical attack at RNG 2-5. If the target is occupying Vegetation, <condition value=ensnared>Ensnared</condition> or <condition value=rooted>Rooted</condition> and is successfully damaged, the target also becomes <condition value=burred>Burred</condition> for 3 turns and <condition value=eviscerated>Eviscerated</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "drive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 109,
              "apCost": 1,
              "name": "Pummel",
              "shortDescription": "This champion makes its basic melee attack against target opposing champion. If successful, this unit makes an additional basic attack for free against the same target.  This attack costs +1 AP compared to a normal basic attack.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 7,
              "iconName": "hammer"
            },
            {
              "default": false,
              "id": 1261,
              "apCost": 0,
              "name": "Surge: Plant",
              "shortDescription": "This unit has +1 DMG for each friendly Plant.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "surge_plant"
            },
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            }
          ]
        }
      ]
    },
    {
      "id": 317,
      "name": "Woodland Diplomat",
      "description": "I will give them a chance to negotiate a withdrawal from our forest, but the opportunity for a peaceful conclusion is waning. - Ambassador Gorney",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Garu"
      ],
      "noraCost": 71,
      "hash": "dJ8JJ8IF0BF0Ae9BJ8GJ8HJ8Ikukuxonpwiwofvf",
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 867,
          "apCost": 0,
          "name": "Blessed",
          "shortDescription": "At the beginning of your turn, if this unit was damaged the previous turn, it heals 5 HP.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "blessed"
        },
        {
          "id": 944,
          "apCost": 0,
          "name": "Diplomat",
          "shortDescription": "When this champion comes into play, the nearest enemy champion and the friendly real champion closest to it become <condition value=pacified>Pacified</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "diplomat"
        },
        {
          "id": 1869,
          "apCost": 1,
          "name": "Hibernate",
          "shortDescription": "This champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns. At the start of next turn, it gains <ability value=117>Regeneration 3</ability>, <ability value=757>Immobile</ability> and <condition value=pacified>Pacified</condition> for 3 turns or until it is destealthed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 4,
          "iconName": "hibernate"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1280,
              "apCost": 0,
              "name": "Wisdom",
              "shortDescription": "When this champion comes into play 2 spell runes are revealed and spell cooldowns are reduced by 2.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "diplomat"
            },
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            },
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1443,
              "apCost": 0,
              "name": "Council: Spells",
              "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "special"
            },
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            }
          ]
        }
      ]
    },
    {
      "id": 500,
      "name": "Woodland Jester",
      "description": "Disarm the enemy with charm. A joke can weaken an opponent's resolve. - Gaffilgorn, Woodland Jester",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 43,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Bard"
      ],
      "races": [
        "Beast",
        "Vashal"
      ],
      "noraCost": 69,
      "hash": "dj9Cj9BG2Af1Ae9Aj9Fj9Gj9Hsuhkeeggpsusuhg",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1443,
          "apCost": 0,
          "name": "Council: Spells",
          "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "special"
        },
        {
          "id": 2113,
          "apCost": 2,
          "name": "Demoralizing Descant",
          "shortDescription": "Target champion within 5 spaces becomes Demoralized 4 (This champion has -2 DMG).  This effect stacks.  ",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 5,
          "iconName": "dreadsong"
        },
        {
          "id": 3072,
          "apCost": 3,
          "name": "Elusive Leap",
          "shortDescription": "This champion is relocated to target space within 4 spaces and the next basic attack against this champion within 6 turns misses.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 9,
          "iconName": "dashing_dodge"
        },
        {
          "id": 895,
          "apCost": 1,
          "name": "Retreat",
          "shortDescription": "This champion can disengage for free and move 3 spaces.",
          "activationType": 1,
          "level": 3,
          "cooldown": 1,
          "noraCost": 6,
          "iconName": "mobility"
        },
        {
          "id": 2341,
          "apCost": 3,
          "name": "Stall",
          "shortDescription": "Target champion within 5 spaces has -4 SPD for 3 turns. This does not stack.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 8,
          "iconName": "debuff"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2530,
              "apCost": 2,
              "name": "Seal of the Vashal",
              "shortDescription": "Target friendly Vashal or Beast within 5 spaces is <condition value=norashielded>Nora Shielded</condition> and heals for 3 for each unit with Seal of the Vashal (to a maximum of 12). Target champion gains Unsealed (This unit can not be the target of Seal of the Vashal) for 6 turns. This ability is removed after use.",
              "activationType": 1,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "seal_of_the_vashal"
            },
            {
              "default": false,
              "id": 3319,
              "apCost": 0,
              "name": "Spell Breach",
              "shortDescription": "Friendly champions within 5 spaces (including this one), gain +1 SPD for 2 turns when an enemy spell is successfully cast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "counterspell_mastery"
            },
            {
              "default": false,
              "id": 3261,
              "apCost": 2,
              "name": "Mind Lock",
              "shortDescription": "Target enemy champion within 5 spaces has a random activated ability (excluding basic attacks) gain +2 CD. This champion gains a copy that ability for 5 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "mind_lock"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            },
            {
              "default": false,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        }
      ]
    },
    {
      "id": 1388,
      "name": "Woodland Marshal",
      "description": "Do you not understand? It is natural for forests to burn. This makes room for new life and enriches the soil, so that which grows next is even stronger. This is our way.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 76,
      "hash": "ej9Dj9Ce9AF0Ae9AG2Bj9Fj9Ghytufiygkexxqqf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2840,
          "apCost": 0,
          "name": "Devotee of De'lim",
          "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "devotee_delim"
        },
        {
          "id": 367,
          "apCost": 3,
          "name": "Heal Champion",
          "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1785,
          "apCost": 3,
          "name": "Rite of Healing",
          "shortDescription": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fascinate"
        },
        {
          "id": 2820,
          "apCost": 2,
          "name": "Sacrifice of De'lim",
          "shortDescription": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "chan_fuel"
        },
        {
          "id": 1487,
          "apCost": 4,
          "name": "Summon: Young Sapling",
          "shortDescription": "Summon a Young Sapling with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumtree"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 1124,
              "apCost": 0,
              "name": "Ally: Underdepths",
              "shortDescription": "While there are other friendly Underdepths champions in play, this champion gets +7 HP and +2 DMG. Underdepths champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_ud"
            },
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            }
          ]
        }
      ]
    },
    {
      "id": 1534,
      "name": "Woodland Marshal",
      "description": "Do you not understand? It is natural for forests to burn. This makes room for new life and enriches the soil, so that which grows next is even stronger. This is our way.",
      "maxRng": 3,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 7,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Elf"
      ],
      "noraCost": 76,
      "hash": "ej9Dj9Cg3AF0Be9AG2Bj9Dj9Eeerheiiwfmnplrf",
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "runeSet": "Bonds of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2840,
          "apCost": 0,
          "name": "Devotee of De'lim",
          "shortDescription": "When a real Plant or Treefolk unit is destroyed, this unit gains 3 MAX HP and is healed for 6 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "devotee_delim"
        },
        {
          "id": 367,
          "apCost": 3,
          "name": "Heal Champion",
          "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 6,
          "iconName": "heal"
        },
        {
          "id": 1785,
          "apCost": 3,
          "name": "Rite of Healing",
          "shortDescription": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fascinate"
        },
        {
          "id": 2820,
          "apCost": 2,
          "name": "Sacrifice of De'lim",
          "shortDescription": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own within 5 spaces and friendly units with <ability value=2840>Devotee of De'lim</ability> gain +2 DMG.  If the champion has a nora cost of 30 or more, 25% of the sacrificed champion's nora cost is refunded.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "chan_fuel"
        },
        {
          "id": 1487,
          "apCost": 4,
          "name": "Summon: Young Sapling",
          "shortDescription": "Summon a Young Sapling with no upgrades to target adjacent space.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "sumtree"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2639,
              "apCost": 3,
              "name": "Grant: Healing Potion",
              "shortDescription": "Target champion within 3 spaces gains <ability value=2640>Drink Healing Potion</ability> for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1120,
              "apCost": 4,
              "name": "Set Ablaze",
              "shortDescription": "Target champion within 2 spaces takes 4 Fire damage and is Consumed By Fire (This champion is <condition value=shielded>Shielded</condition>, <mechanic value=immobile>Immobile</mechanic> and <mechanic value=pacified>Pacified</mechanic>. At the beginning of your turn, this champion takes 8 Fire Damage) for 2 turns.  Friendly units take an additional 4 Fire damage.  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "fire"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 388,
              "apCost": 1,
              "name": "Flame Armor",
              "shortDescription": "This unit gets +3 DEF and gains <ability value=229>Damage Shield: Fire 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "immunity_fire"
            },
            {
              "default": false,
              "id": 1124,
              "apCost": 0,
              "name": "Ally: Underdepths",
              "shortDescription": "While there are other friendly Underdepths champions in play, this champion gets +7 HP and +2 DMG. Underdepths champions gain 1 AP when this unit comes into play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuff_ud"
            },
            {
              "default": false,
              "id": 2033,
              "apCost": 0,
              "name": "Stat Bonus: Health",
              "shortDescription": "This champion has +6 HP.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plushealth"
            }
          ]
        }
      ]
    },
    {
      "id": 663,
      "name": "Wretched Witch",
      "description": "The townsfolk fell ill with her arrival. As she left, the last few were on their deathbeds. We don't know where she went and don't care to find her again. - Journal of Jonah Veipell",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Witch"
      ],
      "races": [
        "Human",
        "Undead"
      ],
      "noraCost": 71,
      "hash": "dJ8HJ8Ge9BG2AE8Dj9Ej9Fj9Geipusoqlusqhrzg",
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Broodcall",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 1323,
          "apCost": 2,
          "name": "Contaminate",
          "shortDescription": "Target champion within 3 spaces gains the <ability value=167>Poison 1</ability> ability for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "dot_poison"
        },
        {
          "id": 1399,
          "apCost": 1,
          "name": "Hex",
          "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "lossoflife"
        },
        {
          "id": 43,
          "apCost": 0,
          "name": "Immunity: Disease",
          "shortDescription": "Disease damage that would be dealt to this unit is prevented. This unit may not become <condition value=diseased>Diseased</condition>.\r\n",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "immunity_disease"
        },
        {
          "id": 897,
          "apCost": 3,
          "name": "Mindwipe Aura",
          "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 4,
          "noraCost": 8,
          "iconName": "mind_control"
        },
        {
          "id": 1845,
          "apCost": 0,
          "name": "Wicked Aura",
          "shortDescription": "Whenever an enemy champion within 5 spaces would gain AP, they get 1 less than normal.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "auranegative"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1924,
              "apCost": 0,
              "name": "Revere: Mairdreth of the Rot",
              "shortDescription": "While this champion is in play, Mairdreth of the Rot costs 10% less nora to deploy. If Mairdreth of the Rot is in play, this champion gains <ability value=973>Afflict 2</ability> and <ability value=2537>Revel in Misery</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "revere"
            },
            {
              "default": false,
              "id": 695,
              "apCost": 0,
              "name": "Curse",
              "shortDescription": "This unit makes an 8 dmg attack at range 1-5. If successful, the target becomes <condition value=cursed>Cursed</condition> for 4 turns. If the target was already Cursed, then this attack deals an additional 5 damage.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "debuff"
            },
            {
              "default": true,
              "id": 416,
              "apCost": 2,
              "name": "Charm",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=charmed>Charmed</condition> for 3 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "charm"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3377,
              "apCost": 0,
              "name": "Corrupting Aura",
              "shortDescription": "The closest enemy unit within 6 spaces without <ability value=94>Vulnerability: Disease</ability> gains Vulnerability: Disease.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "vuln_disease"
            },
            {
              "default": true,
              "id": 937,
              "apCost": 0,
              "name": "Nora Leech",
              "shortDescription": "When your enemy would gain Nora through an ability, spell or relic, they gain 75% of that amount, and you gain 25% of that amount. When you would gain Nora through an ability, spell or relic you instead gain only 75% of that amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "nora_thief"
            },
            {
              "default": false,
              "id": 2500,
              "apCost": 0,
              "name": "Elsari Coven",
              "shortDescription": "Whenever an opposing champion is deployed into or enters a friendly Dead Magic Zone, it becomes <condition value=cursed>Cursed</condition> for 2 turns plus 1 additional turn for each friendly Witch (to a maximum of 8).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "elsari"
            }
          ]
        }
      ]
    },
    {
      "id": 606,
      "name": "Wyrmpriest",
      "description": "Their tomes are wrong! This is not punishment; we do not suffer an ancient affliction! It is a gift, given to us by the Dragon gods. - Wyrmpriest Lorinal",
      "maxRng": 4,
      "minRng": 2,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 45,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Draksar"
      ],
      "noraCost": 70,
      "hash": "dj9Cj9BG2Af1BE8Dj9Ej9Fj9Gevxoqhvqwojnnhg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 973,
          "apCost": 3,
          "name": "Afflict",
          "shortDescription": "For 6 turns, target champion within 5 spaces loses 8 HP every time this unit is damaged by an attack from an opposing champion.",
          "activationType": 1,
          "level": 2,
          "cooldown": 5,
          "noraCost": 6,
          "iconName": "lossoflife"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 3138,
          "apCost": 0,
          "name": "Twisted Essence",
          "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "twisted_essence"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1465,
              "apCost": 0,
              "name": "Instigate",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this one gain <ability value=259>Enrage 1</ability>. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3076,
              "apCost": 1,
              "name": "Sustain: Berserker",
              "shortDescription": "Target champion within 7 spaces gains <ability value=24>Berserker 2</ability> until this ability is used again.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 1860,
              "apCost": 2,
              "name": "Grant: Rage Potion",
              "shortDescription": "Target champion within 3 spaces gains Drink Rage Potion (This champion gains +3 DMG for 1 turn) for 6 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3086,
              "apCost": 0,
              "name": "Disbelief",
              "shortDescription": "When this champion is deployed, enemy illusions and summoned units takes 10 Magic damage.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "shattered_dreams"
            },
            {
              "default": true,
              "id": 1786,
              "apCost": 3,
              "name": "Ritual of Destruction",
              "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 3,
              "iconName": "ondeath_damage"
            },
            {
              "default": false,
              "id": 1785,
              "apCost": 3,
              "name": "Rite of Healing",
              "shortDescription": "Target real champion you own within 5 spaces is destroyed. All friendly champions are healed for 8 HP and gain <ability value=117>Regeneration 3</ability> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 2,
              "iconName": "fascinate"
            }
          ]
        }
      ]
    },
    {
      "id": 1808,
      "name": "Xulos the Glorious",
      "description": "“The dead will die. Elsarin will crumble. Serkan will fall. I will fall. How touching; but, a true lover of death must wish for death in everything, even oneself.” -- Xulos, Undead Sage",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 92,
      "hash": "ej9Fj9EG2BG2BG2AE8Dj9Cj9Dzgerhtqsfiigrsf",
      "artist": "Caio Monteiro",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3322,
          "apCost": 4,
          "name": "Coercive Pact ",
          "shortDescription": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "bloodbond"
        },
        {
          "id": 941,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 9 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "drain"
        },
        {
          "id": 3321,
          "apCost": 2,
          "name": "Glorious Drain",
          "shortDescription": "Target friendly champion you own loses 12 HP. This unit vampiric heals 12 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "drain"
        },
        {
          "id": 892,
          "apCost": 0,
          "name": "Grace of the Dead",
          "shortDescription": "When this unit dies, all friendly champions are healed for 12 HP. At the start of your next turn, all friendly champions are healed for 6 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 1220,
              "apCost": 0,
              "name": "Final Word",
              "shortDescription": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "ondeath"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 266,
      "name": "Xulos, Undead Sage",
      "description": "\"Let us gift death upon the denizens of this land so that we may grant its Nora to lord Serkan.\" ~ Xulos, Apprentice to Serkan",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 92,
      "hash": "dj9Gj9Fe9AF0Ag3Aj9Dj9Ej9Fqqqoumephtjpyig",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Drums of War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 941,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 9 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "drain"
        },
        {
          "id": 1450,
          "apCost": 4,
          "name": "Death Pact",
          "shortDescription": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "bloodbond"
        },
        {
          "id": 866,
          "apCost": 2,
          "name": "Drain",
          "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "drain"
        },
        {
          "id": 892,
          "apCost": 0,
          "name": "Grace of the Dead",
          "shortDescription": "When this unit dies, all friendly champions are healed for 12 HP. At the start of your next turn, all friendly champions are healed for 6 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 1220,
              "apCost": 0,
              "name": "Final Word",
              "shortDescription": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "ondeath"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 1862,
      "name": "Xulos, Undead Sage",
      "description": "\"Let us gift death upon the denizens of this land so that we may grant its Nora to lord Serkan.\" ~ Xulos, Apprentice to Serkan",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 92,
      "hash": "ej9Bj9AG2BG2BG2Af1Bj9Cj9Dhiwqhgeggtqhvsf",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Drums of War",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 941,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 9 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "drain"
        },
        {
          "id": 1450,
          "apCost": 4,
          "name": "Death Pact",
          "shortDescription": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "bloodbond"
        },
        {
          "id": 866,
          "apCost": 2,
          "name": "Drain",
          "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "drain"
        },
        {
          "id": 892,
          "apCost": 0,
          "name": "Grace of the Dead",
          "shortDescription": "When this unit dies, all friendly champions are healed for 12 HP. At the start of your next turn, all friendly champions are healed for 6 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 1220,
              "apCost": 0,
              "name": "Final Word",
              "shortDescription": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "ondeath"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 1375,
      "name": "Xulos, Undead Sage",
      "description": "\"Let us gift death upon the denizens of this land so that we may grant its Nora to lord Serkan.\" ~ Xulos, Apprentice to Serkan",
      "maxRng": 5,
      "minRng": 3,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Skeleton",
        "Undead"
      ],
      "noraCost": 92,
      "hash": "ej9Cj9BE8DF0Ae9AG2Aj9Ej9Fgygexmyvfklyipf",
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Plague of Ba'lah",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 941,
          "apCost": 0,
          "name": "Dark Favor",
          "shortDescription": "When this unit is deployed, enemy champions lose 9 HP.",
          "activationType": 2,
          "level": 3,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "drain"
        },
        {
          "id": 1450,
          "apCost": 4,
          "name": "Death Pact",
          "shortDescription": "Target champion within 5 spaces loses 50% of its current HP. This unit loses HP by the same amount.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 6,
          "iconName": "bloodbond"
        },
        {
          "id": 866,
          "apCost": 2,
          "name": "Drain",
          "shortDescription": "Target owned champion within 5 spaces loses 12 HP. This unit vampiric heals 12 HP.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 4,
          "iconName": "drain"
        },
        {
          "id": 892,
          "apCost": 0,
          "name": "Grace of the Dead",
          "shortDescription": "When this unit dies, all friendly champions are healed for 12 HP. At the start of your next turn, all friendly champions are healed for 6 HP.",
          "activationType": 2,
          "level": 2,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "healmass"
        },
        {
          "id": 802,
          "apCost": 0,
          "name": "Hero",
          "shortDescription": "This unit can not be Reanimated. This unit has <ability value=4>Iron Will</ability>. If this unit is in play while in a split-faction battlegroup, it is destroyed. ",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 3135,
              "apCost": 0,
              "name": "Gravebind",
              "shortDescription": "The first time each turn an opposing real champion within 5 spaces is destroyed, a Grave Warrior without upgrades is summoned adjacent to this unit.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "swarm_skeleton"
            },
            {
              "default": false,
              "id": 897,
              "apCost": 3,
              "name": "Mindwipe Aura",
              "shortDescription": "All opposing champions within 3 spaces of this unit becomes <condition value=pacified>Pacified</condition> for 2 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "mind_control"
            },
            {
              "default": false,
              "id": 1220,
              "apCost": 0,
              "name": "Final Word",
              "shortDescription": "When this unit is destroyed by a champion, the champion that destroyed it is also destroyed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "ondeath"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 711,
              "apCost": 0,
              "name": "Siphoning Aura",
              "shortDescription": "At the beginning of your opponent's turn, all champions within 2 spaces lose 3 HP, and this champion is healed by an equal amount.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "possess"
            },
            {
              "default": true,
              "id": 3138,
              "apCost": 0,
              "name": "Twisted Essence",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=twisted>Twisted</condition> for 3 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "twisted_essence"
            },
            {
              "default": false,
              "id": 737,
              "apCost": 0,
              "name": "Spellswallower",
              "shortDescription": "When your enemy successfully casts a spell, this unit permanently gains +1 DMG. For every third spell cast, this unit also permanently gains +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "spellswallow"
            }
          ]
        }
      ]
    },
    {
      "id": 732,
      "name": "Yeti Ambusher",
      "description": "Those who wander into Yeti territory are often never seen again. Some are entangled within intricate traps, while others are found frozen beneath heavy-woven nets. Their attackers are never found; no trace evident even in the heavy snow.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 76,
      "hash": "dj9Bj9Af1BG2AG2Aj9Bj9Cj9Doftzkrjrwiiluhg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 1705,
          "apCost": 0,
          "name": "Ambush",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, if an opposing champion moves adjacent to this champion, this champion makes a free attack against that opponent that ignores DEF if it is greater than 0 and causes <condition value=ensnared>Ensnared</condition> 2.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "assault"
        },
        {
          "id": 554,
          "apCost": 0,
          "name": "Attack: Net",
          "shortDescription": "This unit makes a Physical attack at its Range. If successful, target becomes <condition value=grounded>Grounded</condition> for 2 turns. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "net"
        },
        {
          "id": 1019,
          "apCost": 0,
          "name": "Hidden: Arctic",
          "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "stealth"
        },
        {
          "id": 2766,
          "apCost": 0,
          "name": "Logistics: Speed",
          "shortDescription": "The first time there are 4 or more real champions in play that share a race or class with this champion, this champion gains +1 SPD permanently.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "special"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 580,
              "apCost": 1,
              "name": "Assassinate",
              "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
              "activationType": 1,
              "level": 1,
              "cooldown": 2,
              "noraCost": 10,
              "iconName": "stab"
            },
            {
              "default": false,
              "id": 456,
              "apCost": 2,
              "name": "Fear",
              "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 7,
              "iconName": "fear"
            },
            {
              "default": true,
              "id": 1960,
              "apCost": 0,
              "name": "Summon: Snow Trap",
              "shortDescription": "Summon a Snow Trap relic with <ability value=600>Arctic</ability>, <ability value=601>Shadowspawn</ability> and <ability value=1025>Arctic Trap</ability> to target adjacent space. This ability does not break stealth",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "trapfrost"
            }
          ]
        }
      ]
    },
    {
      "id": 1520,
      "name": "Yeti Ancient",
      "description": "Though few in number, the beasts of the Tundra are viscious, and will protect their domain with a savage fury.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "RARE",
      "classes": [
        "Brute"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 71,
      "hash": "ej9Cj9Bf1AF0Be9AG2AJ8Jj9Aeeeinplgvofgkpf",
      "artist": "Anthony Lopes",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "The Ronin",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2985,
          "apCost": 0,
          "name": "Escalating Rage",
          "shortDescription": "At the beginning of its turn, this champion gains +2 DMG.  Every 4th trigger, it also gains full AP.  At the end of that turn, all DMG bonuses from this ability are removed.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "escalating_rage"
        },
        {
          "id": 2986,
          "apCost": 0,
          "name": "Fearsome Hunter",
          "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "fear"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1467,
              "apCost": 4,
              "name": "Seismic Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. Non-flying enemy champions within 2 spaces of the target takes 8 Physical damage (this damage ignores DEF), are knocked back 1 space and become <condition value=slowed>Slowed</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "leap_massive"
            },
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": false,
              "id": 1804,
              "apCost": 0,
              "name": "Hunter: Fighter",
              "shortDescription": "When this unit would deal damage to a champion with Class: Warrior, Knight or Paladin with any attack, that damage is increased by 2. When this unit would receive damage from any attack by a champion with Class: Warrior, Knight or Paladin, that damage is decreased by 2. This does not stack with other Hunter: X abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "foe_warrior"
            },
            {
              "default": true,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            }
          ]
        }
      ]
    },
    {
      "id": 1264,
      "name": "Yeti Apostate",
      "description": "\"These yeti traitors abandoned their post during a time of war. They will be caught and an example will be made.\" Shardeer Kae'yun",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 66,
      "hash": "ej9Bj9AF0Be9Be9Af1BJ8IJ8Jirhtmlgpuzoquo",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 2470,
          "apCost": 1,
          "name": "Howling Attack",
          "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "horrific_howl"
        },
        {
          "id": 2471,
          "apCost": 0,
          "name": "Protective",
          "shortDescription": "When another friendly champion that shares a race or class with this one is attacked with a basic attack, this champion gains +2 DMG for 2 turns. This stacks up to 2 times.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "protective"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2608,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 2 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "reinforcement"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 113,
              "apCost": 0,
              "name": "Initiative",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each opposing champion in play, to a maximum of 6. This ability does not trigger if champion has Reinforcement.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "initiative"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 986,
      "name": "Yeti Avalancher",
      "description": "The furious scream shook the peaceful dawn to life. Meodi felt the ground shudder beneath her, as a sheet of snow tumbled down the mountainside in the distance. \"Avalancher\", she thought, \"terrible beasts.\"",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 51,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 80,
      "hash": "ej9Fj9Ee9AE8De9AE8Dj9Fj9Gjyoyohymplnsuo",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1296,
          "apCost": 1,
          "name": "Avalanche",
          "shortDescription": "Area Effect 2, Range 5: Affected champions without <ability value=600>Arctic</ability> take 12 Frost damage.  This damage ignores DEF.  For 3 turns, spaces within the affected area are Deep Snow (Impeding 1).",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 12,
          "iconName": "iceaoe"
        },
        {
          "id": 1494,
          "apCost": 0,
          "name": "Escalation",
          "shortDescription": "This champion gains +1 DMG at the beginning of its owner's turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "surge"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            },
            {
              "default": true,
              "id": 300,
              "apCost": 0,
              "name": "Horrific Aura",
              "shortDescription": "For 2 turns, when a champion attacks this unit, that champion becomes <condition value=frightened>Frightened</condition> for 2 turns and the attack misses. This effect is hidden until triggered.",
              "activationType": 1,
              "level": 2,
              "cooldown": 4,
              "noraCost": 8,
              "iconName": "fear"
            },
            {
              "default": false,
              "id": 2470,
              "apCost": 1,
              "name": "Howling Attack",
              "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "horrific_howl"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 752,
              "apCost": 4,
              "name": "Tunnel: Snow",
              "shortDescription": "This unit is relocated to target Snow or Ice space within 6 spaces.",
              "activationType": 1,
              "level": 0,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "tunnel_snow"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 371,
      "name": "Yeti Berserker",
      "description": "They become so savage they lose the ability to even speak. ",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Brute"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 71,
      "hash": "dj9Ej9Dg3AF0Af1Bj9Aj9Bj9Ceeevoyvolnhrshg",
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 24,
          "apCost": 0,
          "name": "Berserker",
          "shortDescription": "This champion gets +1 SPD, +3 DMG, and <ability value=2005>Careless</ability>.",
          "activationType": 0,
          "level": 2,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "berserker"
        },
        {
          "id": 2470,
          "apCost": 1,
          "name": "Howling Attack",
          "shortDescription": "This champion makes a Sonic attack at +2 DMG against target enemy champion within 4 spaces. If successfully damaged, the target becomes <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "horrific_howl"
        },
        {
          "id": 1236,
          "apCost": 0,
          "name": "Ice Veil",
          "shortDescription": "When this champion comes into play all terrain within 10 spaces turns into ice terrain for 3 turns.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "terrainice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 15,
              "apCost": 0,
              "name": "Multiattack",
              "shortDescription": "This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "multiattack"
            },
            {
              "default": false,
              "id": 1389,
              "apCost": 0,
              "name": "Perseverance",
              "shortDescription": "Whenever this champion's health falls below 1, it loses Perseverance and it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains <condition value=impervious>Impervious</condition>, <ability value=1237>Impenetrable</ability>, and <ability value=738>Shielded</ability> until the end of turn.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tgtdefensive"
            },
            {
              "default": true,
              "id": 1504,
              "apCost": 0,
              "name": "Brutality",
              "shortDescription": "This unit gains <ability value=16>Multiattack 2</ability> when a champion that shares a race with it is within 3 spaces.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "surge"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 2535,
              "apCost": 0,
              "name": "Reinforcement",
              "shortDescription": "When this champion is deployed, it gains 1 AP for each friendly unit that shares a race or class with it, to a maximum of 6.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "reinforcement"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 525,
      "name": "Yeti Conqueror",
      "description": "These Yeti knew where to strike and when. They even claimed the outpost! - Miran, Lonx Hunter",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 6,
      "damage": 12,
      "hitPoints": 48,
      "size": "2x2",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 72,
      "hash": "dj9Ej9Dg3Af1AG2Bj9Cj9Dj9Eeeeevfrowowiilg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1719,
          "apCost": 0,
          "name": "Conqueror",
          "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 456,
          "apCost": 2,
          "name": "Fear",
          "shortDescription": "Enemy champions within 3 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "fear"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1363,
              "apCost": 0,
              "name": "Unleash",
              "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "unleashed"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 116,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 4 HP.",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "regen"
            },
            {
              "default": false,
              "id": 47,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 35% (after DEF, rounded up).",
              "activationType": 2,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 1252,
              "apCost": 0,
              "name": "Readiness",
              "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 567,
      "name": "Yeti Cub",
      "description": "Yetis learn the art of war at a young age, through competition. In trying times, they can be apt combatants.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 9,
      "hitPoints": 39,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 59,
      "hash": "dJ8JJ8IF0Bf1Be9Aj9Fj9Gj9Hkukuvmyiyzrztfg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1482,
          "apCost": 0,
          "name": "Snowball",
          "shortDescription": "This unit makes a Frost attack at range 2-4 for 8 DMG. This damage ignores DEF.",
          "activationType": 1,
          "level": 0,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "ice"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1225,
              "apCost": 0,
              "name": "Bastion of Mobility",
              "shortDescription": "Friendly champions within 8 spaces have <ability value=6>Mobility</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "mobility"
            },
            {
              "default": false,
              "id": 2925,
              "apCost": 0,
              "name": "Guarded: Yeti",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Yeti within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            },
            {
              "default": true,
              "id": 1437,
              "apCost": 0,
              "name": "Camaraderie ",
              "shortDescription": "Champions that share a race or class with this champion cost 3 less Nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "cost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 616,
              "apCost": 0,
              "name": "Arctic Camouflage",
              "shortDescription": "When this unit is damaged by a ranged attack while it is occupying Snow or Ice, that damage by is reduced by 2.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "camo"
            },
            {
              "default": true,
              "id": 1440,
              "apCost": 0,
              "name": "Confuse Attacker",
              "shortDescription": "The next time this unit is successfully attacked (and damaged), it is relocated 3 spaces directly away from the source of the attack.\r\n",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 2,
              "iconName": "confuse"
            }
          ]
        }
      ]
    },
    {
      "id": 1263,
      "name": "Yeti Curate",
      "description": "Their peaceful exterior belies an interior that is volatile.  Never forget these are Yetis, first and foremost, no matter how civilized they may act.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 7,
      "hitPoints": 38,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Priest"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 64,
      "hash": "ej9Bj9AF0Ae9Be9Af1BJ8HJ8Iqfeitzojtjyvqo",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3032,
          "apCost": 0,
          "name": "Quest: Support Ally",
          "shortDescription": "When this champion targets a friendly champion with an ability, this champion permanently gains a rank of <ability value=115>Regeneration</ability>.  On the fourth trigger, this ability is removed and this champion also permanently gains <ability value=372>Heal Mass 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 12,
          "iconName": "opportunistic"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 368,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 12 HP. May target self.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "heal"
            },
            {
              "default": true,
              "id": 367,
              "apCost": 3,
              "name": "Heal Champion",
              "shortDescription": "Target friendly champion within 5 spaces heals 8 HP. May target self.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "heal"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2667,
              "apCost": 2,
              "name": "Snow Shroud",
              "shortDescription": "Target champion within 5 spaces occupying Ice or Snow has <ability value=2077>Reflexes 2</ability> and <ability value=1377>Evasive 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        }
      ]
    },
    {
      "id": 642,
      "name": "Yeti Druid",
      "description": "Through experimentation, the Yetis found ways of manipulating magic beyond simple spells. With this knowledge, some Shamans became versed in bestial magic.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 8,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 73,
      "hash": "dj9Fj9EE8DG2Af1AJ8Jj9Aj9Bukumllymyrwmleg",
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 592,
          "apCost": 3,
          "name": "Cleanse",
          "shortDescription": "Target champion within 5 spaces is <mechanic value=cleansed>Cleansed</mechanic> and then is healed for 5 HP. May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 5,
          "iconName": "cleanse"
        },
        {
          "id": 1728,
          "apCost": 0,
          "name": "Divert",
          "shortDescription": "For 4 turns, the next time target friendly champion takes damage from an attack, that damage is redirected to the nearest opponent within 8 spaces.  This effect is hidden until triggered.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 10,
          "iconName": "deflect"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1237,
              "apCost": 0,
              "name": "Impenetrable",
              "shortDescription": "This champion can not be the target of abilities your enemy controls, including non-basic attacks.  This does not include basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "ironwill"
            },
            {
              "default": false,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 2312,
              "apCost": 0,
              "name": "Impair Vision",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, if that champion's MAX RNG is greater than its MIN RNG, it is Impaired (This champion's maximum range is lowered by 1. This effect stacks) for 4 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "observe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            }
          ]
        }
      ]
    },
    {
      "id": 733,
      "name": "Yeti Icelord",
      "description": "Yeti tribes formed around the mountains near J`thir, comprised of an Icelord and his followers. The Icelord is their greatest warrior, charged with guiding his tribe.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Warrior"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 81,
      "hash": "dj9Bj9Af1BG2AG2Bj9Cj9Dj9Eeerzklrfgpjrjig",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 396,
          "apCost": 0,
          "name": "Charge",
          "shortDescription": "This champion moves 1-3 spaces in a straight line through non-Impeding terrain and makes a close-combat attack at +3 DMG.",
          "activationType": 1,
          "level": 3,
          "cooldown": 2,
          "noraCost": 5,
          "iconName": "charge"
        },
        {
          "id": 1850,
          "apCost": 0,
          "name": "Frightful Blows",
          "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "fear_blows"
        },
        {
          "id": 1900,
          "apCost": 0,
          "name": "Tough",
          "shortDescription": "Any time this unit would take damage, it takes 1 less than normal. ",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "defenseenhance"
        },
        {
          "id": 1489,
          "apCost": 0,
          "name": "Unspeakable",
          "shortDescription": "When this unit is deployed, all enemy units become <condition value=frightened>Frightened</condition> until the end of next turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "ignore_invite"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": false,
              "id": 1194,
              "apCost": 0,
              "name": "Equipment Boon",
              "shortDescription": "This champion gains +2 max HP and +1 DMG for each friendly equipment in play.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "buff"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 778,
              "apCost": 2,
              "name": "Snow-Fall",
              "shortDescription": "Area Effect 4: Affected spaces become Snow (Impeding 1) for 4 turns.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "terrainsnow"
            },
            {
              "default": true,
              "id": 1363,
              "apCost": 0,
              "name": "Unleash",
              "shortDescription": "Friendly champions within 3 spaces gain <ability value=1364>Fuel Rage</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "unleashed"
            },
            {
              "default": false,
              "id": 1476,
              "apCost": 0,
              "name": "Resilient",
              "shortDescription": "If this champion was to take less than 4 damage, that damage is prevented.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "defenseenhance"
            }
          ]
        }
      ]
    },
    {
      "id": 1730,
      "name": "Yeti Magister",
      "description": "Yetis live close to nature, so its no surprise their mages often combine the powers of nature with that of the arcane.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 71,
      "hash": "ej9Gj9FF0Bf1BG2Ae9AJ8IJ8Jyirqwfkpssmluqf",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1432,
          "apCost": 1,
          "name": "Blast",
          "shortDescription": "This champion makes a Magic attack against every enemy champion within its range.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "magicaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2669,
              "apCost": 0,
              "name": "Snowstrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2810,
              "apCost": 0,
              "name": "Spellsurge: Snowstorm",
              "shortDescription": "When this champion is deployed, Snowstorm spells are revealed from your runedock.  Snowstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Snowstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 1685,
      "name": "Yeti Painter",
      "description": "\"The paintings he paints tell not of the past, nor are they tales of fantasies.  Rather, they seek out their subjects and compel them to act.\"",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 76,
      "hash": "ej9Dj9CG2AF0BG2AG2Bj9Bj9Ceerllrjphyzxqsf",
      "artist": "Rogier van de Beek",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Path of De'lim",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 547,
          "apCost": 0,
          "name": "Attack: Psychic",
          "shortDescription": "This unit makes a Psychic attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_psychic"
        },
        {
          "id": 3169,
          "apCost": 1,
          "name": "Psychic Compulsion",
          "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "psychic_compulsion"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2134,
              "apCost": 0,
              "name": "Abash",
              "shortDescription": "When this champion is attacked, the attacking champion becomes <condition value=charmed>Charmed</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "intoxicate"
            },
            {
              "default": false,
              "id": 2345,
              "apCost": 0,
              "name": "Starshine",
              "shortDescription": "The closest friendly champion that moves within 5 spaces gains a rank of <ability value=608>Majestic</ability>.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "distract"
            },
            {
              "default": true,
              "id": 1965,
              "apCost": 0,
              "name": "Distracting Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=distracted>Distracted</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "distract"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1001,
              "apCost": 2,
              "name": "Soften",
              "shortDescription": "Area Effect 3, Range 5: Affected opposing champions have -3 DEF for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "defpenalties"
            },
            {
              "default": true,
              "id": 1710,
              "apCost": 0,
              "name": "Augment Creation",
              "shortDescription": "Friendly champions coming into play gain +2 DMG permanently.  This effect does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "surge"
            },
            {
              "default": false,
              "id": 2559,
              "apCost": 0,
              "name": "Commander",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "improve_damage"
            }
          ]
        }
      ]
    },
    {
      "id": 368,
      "name": "Yeti Scout",
      "description": "The Yeti are truly creatures of the Savage Tundra. They never need to seek warmth, and can go for long periods of time without moving. A Yeti can only be seen in the snow if it wishes to be seen.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 10,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 56,
      "hash": "dj9Ej9Dg3AF0AF0AJ8HJ8IJ8Jpjrfipnnyxirheg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3070,
              "apCost": 0,
              "name": "Savage Armaments",
              "shortDescription": "When a friendly champion with Race: Yeti, Race: Lonx, or Race: Jakei becomes equipped, it gains 1 AP and +1 DMG for 4 turns. This does not stack.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "comboatk_devastate"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            },
            {
              "default": true,
              "id": 1019,
              "apCost": 0,
              "name": "Hidden: Arctic",
              "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": false,
              "id": 1252,
              "apCost": 0,
              "name": "Readiness",
              "shortDescription": "This champion has a bonus to DEF equal to half of this unit's AP (rounded down).",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 721,
              "apCost": 2,
              "name": "Shatter",
              "shortDescription": "Destroy equipment on target champion within 3 spaces. If the equipment was friendly, this champion also gains +2 SPD and +3 DMG for 5 turns (this does not stack with Ruin).",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "antiequip"
            }
          ]
        }
      ]
    },
    {
      "id": 478,
      "name": "Yeti Shaman",
      "description": "With a natural affinity for Nora, the Yeti have received the ability to conjure magic.",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 46,
      "size": "1x1",
      "rarity": "COMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 72,
      "hash": "dJ8IJ8HF0Af1AG2Bj9Cj9Dj9Eeemwzrwzoyrqqfg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 2339,
          "apCost": 4,
          "name": "Imbue: Stun",
          "shortDescription": "Target champion within 5 spaces becomes Imbued(For 5 turns, their next basic attack has a damage type of Magical and deals +2 damage. Champions damaged by this attack become <condition value=stunned>Stunned</condition> for 2 turns).  May target self.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 9,
          "iconName": "amped"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2353,
              "apCost": 1,
              "name": "Grant: Teleport",
              "shortDescription": "Target champion within 5 spaces gains <ability value=407>Teleport 2</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 5,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            },
            {
              "default": true,
              "id": 1264,
              "apCost": 2,
              "name": "Swap",
              "shortDescription": "Exchange places with target friendly champion of the same size within 1 to 5 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "relocate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 371,
              "apCost": 3,
              "name": "Heal Mass",
              "shortDescription": "Friendly champions, including this one, within 3 spaces heal 6 HP.",
              "activationType": 1,
              "level": 2,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "healmass"
            },
            {
              "default": false,
              "id": 1863,
              "apCost": 3,
              "name": "Freeze",
              "shortDescription": "Target opposing champion within 2 spaces is <condition value=crystallized>Crystallized</condition> for 2 turns and <condition value=frozen>Frozen</condition> 4.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 6,
              "iconName": "crystallize"
            },
            {
              "default": true,
              "id": 2607,
              "apCost": 1,
              "name": "Grant: Magical Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            }
          ]
        }
      ]
    },
    {
      "id": 734,
      "name": "Yeti Sorcerer",
      "description": "The Yetis practiced their magical techniques in secret. With help from the Jakei, they began to master the magical elements.",
      "maxRng": 5,
      "minRng": 4,
      "defense": 0,
      "speed": 6,
      "damage": 10,
      "hitPoints": 42,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 71,
      "hash": "dj9Bj9Af1BG2Ag3Aj9Dj9Ej9Fknsjyzgvsfegvkg",
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 544,
          "apCost": 0,
          "name": "Attack: Magical",
          "shortDescription": "This unit makes a Magical attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_magic"
        },
        {
          "id": 1432,
          "apCost": 1,
          "name": "Blast",
          "shortDescription": "This champion makes a Magic attack against every enemy champion within its range.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "magicaoe"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 2669,
              "apCost": 0,
              "name": "Snowstrike",
              "shortDescription": "When this champion makes a successful basic attack, spaces within 1 space of the target becomes Deep Snow (Impeding 2) for 3 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2810,
              "apCost": 0,
              "name": "Spellsurge: Snowstorm",
              "shortDescription": "When this champion is deployed, Snowstorm spells are revealed from your runedock.  Snowstorm spells costs 10 nora less (this does not stack) and this champion is healed for 8 HP when a Snowstorm spell is played.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "special"
            },
            {
              "default": false,
              "id": 3223,
              "apCost": 2,
              "name": "Enchant: Magic",
              "shortDescription": "Target relic or equipped champion within 5 spaces gains <ability value=129>Magical Aura 3</ability> and <ability value=225>Damage Shield: Magical 3</ability> for 6 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "enchant_magic"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 1751,
              "apCost": 1,
              "name": "Grant: Frost Aura",
              "shortDescription": "Target champion within 5 spaces gains <ability value=137>Frost Aura 3</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "grantability"
            },
            {
              "default": false,
              "id": 1780,
              "apCost": 1,
              "name": "Radiant Blow",
              "shortDescription": "This champion makes a Fire attack at +2 DMG.  All opposing champions within 2 spaces of the target become <condition value=blinded>Blinded</condition> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "radiant_blow"
            },
            {
              "default": false,
              "id": 3119,
              "apCost": 0,
              "name": "Provision: Offense",
              "shortDescription": "While this champion is equipped, it gains +1 DMG and a rank of <ability value=15>Multiattack</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "plunder"
            }
          ]
        }
      ]
    },
    {
      "id": 735,
      "name": "Yeti Spirit",
      "description": "Their shamans had learned to contact the deceased. Soon after the first seance, Yeti Spirits began appearing all across the world. These apparitions roamed, instilling a cold in any who neared.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 0,
      "hitPoints": 40,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Spirit",
        "Yeti"
      ],
      "noraCost": 67,
      "hash": "dj9Cj9BG2AG2AE8Dj9Ej9Fj9Geitsfvhgkjlnshg",
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Dire Covenant",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 399,
          "apCost": 3,
          "name": "Force Barrier",
          "shortDescription": "Range 2: Unoccupied spaces within 2 spaces of target unoccupied space become Inaccessible for 2 turns.",
          "activationType": 1,
          "level": 2,
          "cooldown": 3,
          "noraCost": 8,
          "iconName": "forcebarrier"
        },
        {
          "id": 3230,
          "apCost": 3,
          "name": "Freezing Chains",
          "shortDescription": "Enemy champions within 3 spaces take 8 Frost damage and become <condition value=frozen>Frozen</condition> for 2 turns (this damage ignores DEF).  This ability's CD is reduced by 1 whenever this champion is successfully attacked.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "grip_icelord"
        },
        {
          "id": 1274,
          "apCost": 0,
          "name": "Vaporize",
          "shortDescription": "When this champion is successfully attacked it becomes <condition value=incorporeal>Incorporeal</condition> for the remainder of the turn.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "ethereal"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 673,
              "apCost": 3,
              "name": "Crystallize",
              "shortDescription": "Target friendly champion that is within 2 spaces becomes Crystallized until the beginning of your next turn. (Crystallized - This champion is <condition value=shielded>Shielded</condition>, <condition value=impervious>Impervious</condition>, and may not move, attack, or activate special abilities. At the beginning of your turn, this champion heals 4 HP).  May target self.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 5,
              "iconName": "crystallize"
            },
            {
              "default": false,
              "id": 383,
              "apCost": 3,
              "name": "Frost Nova",
              "shortDescription": "This unit deals 6 Frost damage to each unit within 2 spaces. This damage ignores DEF. Champions damaged by Frost Nova become <mechanic value=slowed>Slowed</mechanic> 4.",
              "activationType": 1,
              "level": 2,
              "cooldown": 3,
              "noraCost": 4,
              "iconName": "novafrost"
            },
            {
              "default": false,
              "id": 3071,
              "apCost": 0,
              "name": "Frost Greeting",
              "shortDescription": "When this champion comes into play, all enemy champions become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "greeting_frost"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": true,
              "id": 31,
              "apCost": 0,
              "name": "Defender",
              "shortDescription": "Friendly champions within 5 spaces that share a race or class with this champion has +2 DEF. This ability does not stack with other Defenders.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 7,
              "iconName": "defenseenhance"
            },
            {
              "default": false,
              "id": 1962,
              "apCost": 0,
              "name": "Weaken Spells",
              "shortDescription": "Friendly champions within 5 spaces take 5 less damage from spells.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "dark_aura"
            },
            {
              "default": false,
              "id": 909,
              "apCost": 0,
              "name": "Amplify: Frost",
              "shortDescription": "Frost damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "amp_frost"
            }
          ]
        }
      ]
    },
    {
      "id": 1265,
      "name": "Yeti Tracker",
      "description": "\"The Trackers have been invaluable during this dangerous journey. These tunnels are filled with traps and other surprises.\" ~ Vallassa the Elder's personal journal",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Rogue"
      ],
      "races": [
        "Yeti"
      ],
      "noraCost": 71,
      "hash": "ej9Bj9Af1Ae9Be9Af1BJ8Jj9Aevxkuqluowolyo",
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Broken Shard",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 580,
          "apCost": 1,
          "name": "Assassinate",
          "shortDescription": "While <condition value=stealthed>Stealthed</condition>, this champion makes an attack against target champion at double DMG. This attack ignores DEF and does not miss.",
          "activationType": 1,
          "level": 1,
          "cooldown": 2,
          "noraCost": 10,
          "iconName": "stab"
        },
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 601,
          "apCost": 0,
          "name": "Shadowspawn",
          "shortDescription": "This unit comes into play <condition value=stealthed>Stealthed</condition>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "shadowspawn"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 2973,
              "apCost": 0,
              "name": "Surge: Equipped",
              "shortDescription": "This unit gets +1 DMG for every equipped champion.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "surge_equipped"
            },
            {
              "default": false,
              "id": 1019,
              "apCost": 0,
              "name": "Hidden: Arctic",
              "shortDescription": "At the end of your turn, if this champion occupies Ice or Snow, it becomes <condition value=stealthed>Stealthed</condition>. Otherwise, it loses Stealthed.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "stealth"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1960,
              "apCost": 0,
              "name": "Summon: Snow Trap",
              "shortDescription": "Summon a Snow Trap relic with <ability value=600>Arctic</ability>, <ability value=601>Shadowspawn</ability> and <ability value=1025>Arctic Trap</ability> to target adjacent space. This ability does not break stealth",
              "activationType": 1,
              "level": 0,
              "cooldown": 5,
              "noraCost": 10,
              "iconName": "trapfrost"
            },
            {
              "default": false,
              "id": 1246,
              "apCost": 2,
              "name": "Pilfer",
              "shortDescription": "Equipment on target champion within 2 spaces is destroyed. If this champion is unequipped, that equipment is then equipped on this champion if possible.",
              "activationType": 1,
              "level": 0,
              "cooldown": 4,
              "noraCost": 7,
              "iconName": "antiequip"
            },
            {
              "default": true,
              "id": 1850,
              "apCost": 0,
              "name": "Frightful Blows",
              "shortDescription": "When this champion successfully attacks a champion with a basic attack, the target is <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "fear_blows"
            }
          ]
        }
      ]
    },
    {
      "id": 1722,
      "name": "Yetihound",
      "description": "Named as much for its ferocity as any ties of blood.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "UNCOMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Mutant",
        "Yeti"
      ],
      "noraCost": 68,
      "hash": "ej9Ej9DF0Af1AG2Ag3AJ8HJ8Ikuosjilwoyvzzrf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Savage Tundra"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 2026,
          "apCost": 2,
          "name": "Abominable",
          "shortDescription": "This unit has <ability value=600>Arctic</ability> and deals +1 DMG to Scented champions for each real friendly Yeti. When this ability is activated, the closest enemy champion within 6 spaces becomes Scented for 2 turns and loses <condition value=stealthed>Stealthed</condition>. If the enemy champion is <condition value=frightened>Frightened</condition>, it becomes Scented for 4 turns instead.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 2,
          "iconName": "fangandfur"
        },
        {
          "id": 540,
          "apCost": 0,
          "name": "Attack: Frost",
          "shortDescription": "This unit makes a Frost attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_frost"
        },
        {
          "id": 3266,
          "apCost": 0,
          "name": "Combat Awareness",
          "shortDescription": "Damage from spells and abilities that do not target this champion is reduced by 50%. This does not include terrain effects, conditions, or equipment on this champion.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "combat_awareness"
        },
        {
          "id": 2691,
          "apCost": 0,
          "name": "Mutation: Horror",
          "shortDescription": "Spend 4 charges: This champion gains <ability value=1850>Frightful Blows</ability> instead.  If it already has Frightful Blows, it gains <ability value=1330>Dread</ability> instead and this ability is removed.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 0,
          "iconName": "mutation"
        },
        {
          "id": 2261,
          "apCost": 0,
          "name": "Violence Charged",
          "shortDescription": "When an opposing champion makes a basic attack, this unit gains 1 charge.",
          "activationType": 0,
          "level": 1,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "charged_abuse"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2324,
              "apCost": 4,
              "name": "Pounce",
              "shortDescription": "This champion is relocated to an empty space adjacent to target enemy unit within 5 spaces and deals Physical damage at +2 DMG against the target.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 6,
              "iconName": "pounce"
            },
            {
              "default": true,
              "id": 518,
              "apCost": 3,
              "name": "Leap",
              "shortDescription": "This champion is relocated to target space within 4 spaces. If this champion is engaged, this ability costs 1 additional AP.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 5,
              "iconName": "leap"
            },
            {
              "default": false,
              "id": 2092,
              "apCost": 3,
              "name": "Crushing Charge",
              "shortDescription": "This unit moves 1-5 spaces in a straight-line to target unoccupied space. All champions in the path of this movement are knocked back 2 spaces to a random side and become <condition value=slowed>Slowed 2</condition>. If a champion remains in the path, this champion stops moving.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "crush"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 2665,
              "apCost": 0,
              "name": "Psychological Warfare",
              "shortDescription": "This champion deals 4 additional damage and gives <condition name=confused>Confused</condition> for 4 turns to <condition value=frightened popup=false>Frightened</condition> champions on basic attacks.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "aggressive"
            },
            {
              "default": true,
              "id": 2465,
              "apCost": 0,
              "name": "Declare Hunted",
              "shortDescription": "When this unit is deployed from the runedock, the closest opposing champion becomes <condition value=tagged>Tagged</condition><ability value=3277> </ability> and permanently gains <ability value=2467>Hunted</ability>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hunted"
            },
            {
              "default": false,
              "id": 1324,
              "apCost": 0,
              "name": "Domain: Arctic",
              "shortDescription": "This unit gains +2 DMG, +1 DEF, and <ability value=6>Mobility</ability> while occupying Snow or Ice.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "domain_snow"
            }
          ]
        }
      ]
    },
    {
      "id": 1610,
      "name": "Yobanchi the Eternal ",
      "description": "Bone Circle Archmages embody the ethos of the order, who understand and embrace the fact that the cycle of death and undeath is eternal.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 6,
      "damage": 0,
      "hitPoints": 49,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Wizard"
      ],
      "races": [
        "Lich",
        "Undead"
      ],
      "noraCost": 74,
      "hash": "ej9AJ8Je9AF0AG2Af1Aj9Fj9Gmpfmlwfiymyvqqf",
      "artist": "Alex Konstad",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Coalitions",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 3106,
          "apCost": 5,
          "name": "Bone Prison",
          "shortDescription": "3 Grave Warriors are summoned in the spaces closest to target enemy champion within 5 spaces.",
          "activationType": 1,
          "level": 0,
          "cooldown": 5,
          "noraCost": 15,
          "iconName": "bone_prison"
        },
        {
          "id": 1443,
          "apCost": 0,
          "name": "Council: Spells",
          "shortDescription": "When an opposing player successfully casts a spell, you gain 5 nora.  This does not stack.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 8,
          "iconName": "special"
        },
        {
          "id": 3175,
          "apCost": 0,
          "name": "Eternal Life",
          "shortDescription": "This unit has <ability value=942>Eternal</ability>. If a Phylactery is in play when this unit dies, your Shrine or Avatar loses 5 HP and the nearest Phylactery relic is destroyed and this unit is reanimated in its place.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "phylactery"
        },
        {
          "id": 1399,
          "apCost": 1,
          "name": "Hex",
          "shortDescription": "This champion makes a Loss of Life attack for 6 life against target champion within 5 spaces. When a champion loses 1 or more life from this attack, it becomes Hexed 3 (This unit's DMG is reduced by 60%). This effect does not stack.",
          "activationType": 1,
          "level": 2,
          "cooldown": 2,
          "noraCost": 7,
          "iconName": "lossoflife"
        },
        {
          "id": 1786,
          "apCost": 3,
          "name": "Ritual of Destruction",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest enemy champion within 5 spaces takes 10 acid damage.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_damage"
        },
        {
          "id": 3107,
          "apCost": 3,
          "name": "Ritual of Healing",
          "shortDescription": "Target summoned champion within 5 spaces is destroyed. The closest friendly champion within 5 spaces and this champion heals for 8 HP.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 3,
          "iconName": "ondeath_healing"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1769,
              "apCost": 0,
              "name": "One With Nora",
              "shortDescription": "After this champion is damaged by a basic attack, it gains immunity to the attacker's damage type for 4 turns. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "defenseenhance"
            },
            {
              "default": true,
              "id": 2315,
              "apCost": 0,
              "name": "Oblivion Shield",
              "shortDescription": "Damage from the first successful attack made against this champion each turn is prevented.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 12,
              "iconName": "aegis"
            },
            {
              "default": false,
              "id": 2184,
              "apCost": 0,
              "name": "Eradicate",
              "shortDescription": "Spend all charges. Target champion within 5 spaces loses 2 HP for each charge spent this way (up to 20 HP).",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 12,
              "iconName": "eradicate"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 3169,
              "apCost": 1,
              "name": "Psychic Compulsion",
              "shortDescription": "Target enemy champion within 5 spaces becomes Compelled (This champion may only target the closest enemy champion to it with activated abilities, including basic attacks) for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "psychic_compulsion"
            },
            {
              "default": false,
              "id": 2173,
              "apCost": 0,
              "name": "Death Charged",
              "shortDescription": "When a real champion is destroyed, this unit gains 2 charges.",
              "activationType": 0,
              "level": 2,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "charged_death"
            },
            {
              "default": true,
              "id": 431,
              "apCost": 4,
              "name": "Summon: Skeleton",
              "shortDescription": "An Undead Skeleton Warrior champion is summoned to target adjacent space, under your control (0 DEF, 6 SPD, 1 RNG, 7 DMG, 12 HP, <ability value=545>Attack: Physical</ability>).",
              "activationType": 1,
              "level": 2,
              "cooldown": 5,
              "noraCost": 7,
              "iconName": "sumskel"
            }
          ]
        }
      ]
    },
    {
      "id": 825,
      "name": "Zedin of Sarnghaver",
      "description": "\"I will accompany Magnus to Maljara. We know the fear of facing oblivion in the eyes of the Draksar, as the Leoss face it in the Kanen. I have led lions into battle before.\" - Zedin of the Sarnghaver",
      "maxRng": 2,
      "minRng": 1,
      "defense": 1,
      "speed": 6,
      "damage": 12,
      "hitPoints": 50,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Knight"
      ],
      "races": [
        "Barbarian"
      ],
      "noraCost": 76,
      "hash": "dj9AJ8Jf1AG2Be9BJ8GJ8HJ8Ieiljygpwojrlgyg",
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1719,
          "apCost": 0,
          "name": "Conqueror",
          "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 5,
          "iconName": "offenseenhance"
        },
        {
          "id": 2155,
          "apCost": 3,
          "name": "Secure Fonts",
          "shortDescription": "For 3 turns, fonts you currently control cannot be contested. This ability comes into play on cooldown.",
          "activationType": 1,
          "level": 0,
          "cooldown": 4,
          "noraCost": 5,
          "iconName": "bound_nora"
        },
        {
          "id": 2873,
          "apCost": 0,
          "name": "Warchief: Stone Clan",
          "shortDescription": "This unit has <ability value=3379>Magic Ward</ability>. At the end of your turn, this unit gains a rank of <ability value=1900>Tough</ability>. When this unit is destroyed and there is no other champion with this ability, the closest friendly champion with Race: Barbarian gains this ability.\n",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 10,
          "iconName": "stone_clan"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 3198,
              "apCost": 0,
              "name": "Fellowship",
              "shortDescription": "When a friendly champion is deployed from the runedock, this champion is healed for 4 HP. If the deployed champion shares a race or class with this champion, this champion is healed for 6 HP instead.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "solo_cleanse"
            },
            {
              "default": false,
              "id": 2063,
              "apCost": 0,
              "name": "Rebuke",
              "shortDescription": "Whenever an opposing champion within 7 spaces gains AP through spells and abilities, it takes 3 electricity damage per AP gained.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "rebuke"
            },
            {
              "default": true,
              "id": 2986,
              "apCost": 0,
              "name": "Fearsome Hunter",
              "shortDescription": "When this champion destroys an enemy champion, enemy champions within 5 spaces become <condition value=frightened>Frightened</condition> for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "fear"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 48,
              "apCost": 0,
              "name": "Resistance: Physical",
              "shortDescription": "When this unit takes Physical damage, that damage is reduced by 50% (after DEF, rounded up).",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "resistance_physical"
            },
            {
              "default": true,
              "id": 1312,
              "apCost": 3,
              "name": "Sweep",
              "shortDescription": "All champions within 2 spaces take 8 Physical damage and are knocked back 2 spaces. This damage ignores DEF.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "whirl"
            },
            {
              "default": false,
              "id": 1238,
              "apCost": 0,
              "name": "Intimidating",
              "shortDescription": "This champion may not be the target of close-combat attacks, except those made by champions who have <ability value=3 popup=false>Fearless</ability> or <ability value=4 popup=false>Iron Will</ability>",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "dictate"
            }
          ]
        }
      ]
    },
    {
      "id": 867,
      "name": "Zeventrech the Last",
      "description": "\"I came to see this shattered kingdom, and despair. I have a story to tell, of lands once united. Sit, and listen.\" - Zeventrech, sole survivor of the Cyclops Empire",
      "maxRng": 7,
      "minRng": 5,
      "defense": 1,
      "speed": 7,
      "damage": 16,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 114,
      "hash": "dj9Ej9Dg3AG2BF0BJ8IJ8Jj9Aukggkwxqlwfkrhg",
      "artist": "Slawomir Maniak",
      "factions": [
        "Savage Tundra",
        "Shattered Peaks"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2199,
          "apCost": 0,
          "name": "Aegis",
          "shortDescription": "If another friendly Shattered Peaks champion is in play this champion has <ability value=68>Resistance: Poison 3</ability>, <ability value=80>Resistance: Disease 3</ability> and <ability value=49>Resistance: Physical 3</ability>.  If another friendly Savage Tundra champion is in play this champion has <ability value=84>Resistance: Psychic 3</ability>, <ability value=72>Resistance: Sonic 3</ability>, <ability value=76>Resistance: Acid 3</ability> and <ability value=64>Resistance: Electricity 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "aegis"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 36,
          "apCost": 0,
          "name": "Immunity: Magical",
          "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "immunity_magic"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1568,
              "apCost": 0,
              "name": "Balance",
              "shortDescription": "When this unit comes into play, enemy champions take 4 Physical damage and friendly champions are healed for 3 HP.",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "soul_bond"
            },
            {
              "default": true,
              "id": 604,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 407,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 6 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 10,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 1702,
              "apCost": 0,
              "name": "Blockade",
              "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "blockade"
            }
          ]
        }
      ]
    },
    {
      "id": 1951,
      "name": "Zeventrech the Last",
      "description": "\"I came to see this shattered kingdom, and despair. I have a story to tell, of lands once united. Sit, and listen.\" - Zeventrech, sole survivor of the Cyclops Empire",
      "maxRng": 7,
      "minRng": 5,
      "defense": 1,
      "speed": 7,
      "damage": 16,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "LIMITED",
      "classes": [
        "Shaman",
        "Wizard"
      ],
      "races": [
        "Cyclops"
      ],
      "noraCost": 114,
      "hash": "ej9Gj9FG2Be9AG2Be9Aj9Cj9Dykrllpjetukphrf",
      "artist": "Slawomir Maniak",
      "factions": [
        "Savage Tundra",
        "Shattered Peaks"
      ],
      "runeSet": "Heroes of Maljara",
      "forSale": false,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 2199,
          "apCost": 0,
          "name": "Aegis",
          "shortDescription": "If another friendly Shattered Peaks champion is in play this champion has <ability value=68>Resistance: Poison 3</ability>, <ability value=80>Resistance: Disease 3</ability> and <ability value=49>Resistance: Physical 3</ability>.  If another friendly Savage Tundra champion is in play this champion has <ability value=84>Resistance: Psychic 3</ability>, <ability value=72>Resistance: Sonic 3</ability>, <ability value=76>Resistance: Acid 3</ability> and <ability value=64>Resistance: Electricity 3</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 25,
          "iconName": "aegis"
        },
        {
          "id": 600,
          "apCost": 0,
          "name": "Arctic",
          "shortDescription": "This unit cannot be <condition value=chilled>Chilled</condition>.  If this unit is a champion, it has <ability value=640>Icewalker</ability> and gains +1 DMG while occupying Snow or Ice.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "arctic"
        },
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 36,
          "apCost": 0,
          "name": "Immunity: Magical",
          "shortDescription": "Magical damage that would be dealt to this unit is prevented.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 7,
          "iconName": "immunity_magic"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1568,
              "apCost": 0,
              "name": "Balance",
              "shortDescription": "When this unit comes into play, enemy champions take 4 Physical damage and friendly champions are healed for 3 HP.",
              "activationType": 0,
              "level": 4,
              "cooldown": 0,
              "noraCost": 10,
              "iconName": "soul_bond"
            },
            {
              "default": true,
              "id": 604,
              "apCost": 1,
              "name": "Frost Cone ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Frost damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "iceaoe"
            },
            {
              "default": false,
              "id": 2291,
              "apCost": 4,
              "name": "Lightning Storm ",
              "shortDescription": "Area Effect 2, Range 5: Affected units take Electricity damage equal to 80% of this unit's DMG. This damage ignores DEF. Champions successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.\r\n",
              "activationType": 1,
              "level": 3,
              "cooldown": 3,
              "noraCost": 10,
              "iconName": "electricaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 406,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 5 spaces.",
              "activationType": 1,
              "level": 1,
              "cooldown": 1,
              "noraCost": 6,
              "iconName": "relocate"
            },
            {
              "default": false,
              "id": 407,
              "apCost": 4,
              "name": "Teleport",
              "shortDescription": "This champion loses <condition value=rooted>Rooted</condition> and is relocated to target space within 6 spaces.",
              "activationType": 1,
              "level": 2,
              "cooldown": 1,
              "noraCost": 10,
              "iconName": "relocate"
            },
            {
              "default": true,
              "id": 1702,
              "apCost": 0,
              "name": "Blockade",
              "shortDescription": "Enemy champions within 8 spaces cannot gain AP via spells and abilities.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "blockade"
            }
          ]
        }
      ]
    },
    {
      "id": 926,
      "name": "Zoalt, Sky Serpent",
      "description": "Zoalt was believed to be the incarnation of the Leoss' God of Fury. Myths say that a sacrifice to Zoalt brought luck to the whole of Ailur for several years. The reason Zoalt has returned is a mystery.\r\n",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "EXOTIC",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 83,
      "hash": "dj9AJ8Jf1Ag3Ae9Aj9Fj9Gj9Hepuvxojllyvzthg",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            },
            {
              "default": true,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        }
      ]
    },
    {
      "id": 957,
      "name": "Zoalt, Sky Serpent",
      "description": "Zoalt was believed to be the incarnation of the Leoss' God of Fury. Myths say that a sacrifice to Zoalt brought luck to the whole of Ailur for several years. The reason Zoalt has returned is a mystery.",
      "maxRng": 2,
      "minRng": 1,
      "defense": 2,
      "speed": 7,
      "damage": 12,
      "hitPoints": 52,
      "size": "1x1",
      "rarity": "LIMITED",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Beast",
        "Dragon"
      ],
      "noraCost": 83,
      "hash": "dj9Cj9BG2Ag3Ag3Aj9Dj9Ej9Fymljnllyginpumh",
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks",
        "Underdepths"
      ],
      "runeSet": "Maljaran War",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 1,
      "startingAbilities": [
        {
          "id": 542,
          "apCost": 0,
          "name": "Attack: Electricity",
          "shortDescription": "This unit makes a Electricity attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_electricity"
        },
        {
          "id": 591,
          "apCost": 1,
          "name": "Flamestrike",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. If the target is successfully damaged, it also becomes <condition value=charred>Charred</condition> for 3 turns.",
          "activationType": 1,
          "level": 0,
          "cooldown": 3,
          "noraCost": 7,
          "iconName": "fire"
        },
        {
          "id": 1,
          "apCost": 0,
          "name": "Flight",
          "shortDescription": "This champion is <condition value=flying>Flying</condition> and has 2 ranks of <ability value=819>Sentry</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 6,
          "iconName": "flight"
        },
        {
          "id": 732,
          "apCost": 0,
          "name": "Fury",
          "shortDescription": "When this unit makes a successful basic attack, it permanently gains +1 DMG.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "enrage"
        },
        {
          "id": 2265,
          "apCost": 0,
          "name": "Split Hero",
          "shortDescription": "If this unit is in play with a full-faction battlegroup, it is destroyed. This unit cannot be Reanimated. This unit has <ability value=4>Iron Will</ability>. You may only have one Split Hero champions in your battlegroup. This unit counts as a <ability value=802>Hero</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 0,
          "iconName": "split_requirement_hero"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 781,
              "apCost": 0,
              "name": "Surge: Dragon",
              "shortDescription": "This unit has +1 DMG for each friendly Dragon.",
              "activationType": 0,
              "level": 1,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_dragon"
            },
            {
              "default": false,
              "id": 1020,
              "apCost": 0,
              "name": "Surge: Beast",
              "shortDescription": "This unit has +1 DMG for every friendly Beast.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "surge_beast"
            },
            {
              "default": true,
              "id": 1719,
              "apCost": 0,
              "name": "Conqueror",
              "shortDescription": "While this champion is in a neutral or enemy font zone, it gains +3 DMG and +1 DEF.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 5,
              "iconName": "offenseenhance"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 117,
              "apCost": 0,
              "name": "Regeneration",
              "shortDescription": "At the beginning of your turn, this unit heals 6 HP.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "regen"
            },
            {
              "default": true,
              "id": 2649,
              "apCost": 0,
              "name": "Void Shield",
              "shortDescription": "When this champion takes 4 or more damage, it gains a rank of Resistance to that damage type.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "tetra_shield"
            },
            {
              "default": false,
              "id": 2385,
              "apCost": 0,
              "name": "Guarded: Beast",
              "shortDescription": "The first time each turn this unit is successfully attacked, friendly Beasts within 5 spaces gain 2 AP and +2 DMG for 2 turns.",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "guarded"
            }
          ]
        }
      ]
    },
    {
      "id": 362,
      "name": "Zombie Behemoth",
      "description": "During unlife, these behemoths can expend their entire life-force in combat. When this happens, they return to a somber state until their vitality returns.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 0,
      "speed": 5,
      "damage": 12,
      "hitPoints": 54,
      "size": "2x2",
      "rarity": "COMMON",
      "classes": [
        "Brute"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 58,
      "hash": "dj9Dj9CG2BF0AG2Aj9Bj9Cj9Dgrjgkrjlwigruhg",
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 545,
          "apCost": 0,
          "name": "Attack: Physical",
          "shortDescription": "This unit makes a Physical attack at its range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "physical"
        },
        {
          "id": 1209,
          "apCost": 0,
          "name": "Defiant",
          "shortDescription": "When this champion is successfully attacked it gains <ability value=868>Rock Eater</ability> for 2 turns.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "eater_rock"
        },
        {
          "id": 5,
          "apCost": 0,
          "name": "Lumbering",
          "shortDescription": "This champion's AP cost for each movement is increased by 1.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -18,
          "iconName": "lumbering"
        },
        {
          "id": 817,
          "apCost": 3,
          "name": "Throw Champion",
          "shortDescription": "Target adjacent friendly champion gains Catapult (This unit leaps to target location within 5 spaces).",
          "activationType": 1,
          "level": 0,
          "cooldown": 1,
          "noraCost": 15,
          "iconName": "throw_champ"
        },
        {
          "id": 597,
          "apCost": 0,
          "name": "Unstoppable",
          "shortDescription": "This champion cannot be <condition value=stunned>Stunned</condition>, <condition value=ensnared>Ensnared</condition>, <condition value=paralyzed>Paralyzed</condition> or <condition value=rooted>Rooted</condition>, and is immune to Knockback. This unit is also immune to any effects that cause the loss of AP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 3,
          "iconName": "unstoppable"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": true,
              "id": 623,
              "apCost": 0,
              "name": "Knockback",
              "shortDescription": "This unit makes an attack against a champion. If the attack is successful, the attacked unit takes 50% damage, and is knocked back 3 spaces.",
              "activationType": 1,
              "level": 3,
              "cooldown": 1,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 1952,
              "apCost": 0,
              "name": "Slam",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, the target is knocked back 2 spaces. ",
              "activationType": 2,
              "level": 0,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "knockback"
            },
            {
              "default": false,
              "id": 343,
              "apCost": 1,
              "name": "Power Attack",
              "shortDescription": "This unit makes an attack with +4 DMG.",
              "activationType": 1,
              "level": 2,
              "cooldown": 0,
              "noraCost": 4,
              "iconName": "hammer"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 259,
              "apCost": 0,
              "name": "Enrage",
              "shortDescription": "When this unit is successfully attacked, it gets +3 DMG for 2 turns. This effect does not stack.",
              "activationType": 2,
              "level": 1,
              "cooldown": 0,
              "noraCost": 2,
              "iconName": "enrage"
            },
            {
              "default": false,
              "id": 4,
              "apCost": 0,
              "name": "Iron Will",
              "shortDescription": "This champion cannot be <condition value=charmed>Charmed</condition>, <condition value=possessed>Possessed</condition> or <condition value=distracted>Distracted</condition>.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "iron_will"
            },
            {
              "default": true,
              "id": 376,
              "apCost": 0,
              "name": "Exertion",
              "shortDescription": "This champion loses 8 HP and gains 3 AP.  This ability begins on CD.",
              "activationType": 1,
              "level": 3,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "crazed_charger"
            }
          ]
        }
      ]
    },
    {
      "id": 1702,
      "name": "Zombie Headchucker",
      "description": "After Aurthur fell in battle, Isidor thought he would never see his friend again. He was right -- almost.",
      "maxRng": 1,
      "minRng": 1,
      "defense": 1,
      "speed": 7,
      "damage": 11,
      "hitPoints": 48,
      "size": "1x1",
      "rarity": "RARE",
      "classes": [
        "Ranger"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 71,
      "hash": "ej9AJ8JG2Af1AG2Af1Aj9Bj9Cerzojrohyztherf",
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 543,
          "apCost": 0,
          "name": "Attack: Fire",
          "shortDescription": "This unit makes a Fire attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_fire"
        },
        {
          "id": 3206,
          "apCost": 1,
          "name": "Chuck: Flaming Skull",
          "shortDescription": "This champion makes a Fire attack at RNG 2-5. A summoned Flaming Skull relic with 0 DEF, 15 HP, <ability value=3205>Flaming Skull</ability> is summoned adjacent to the target if it is successfully damaged.\r\n",
          "activationType": 3,
          "level": 0,
          "cooldown": 4,
          "noraCost": 10,
          "iconName": "chuck_flamingskull"
        },
        {
          "id": 3158,
          "apCost": 0,
          "name": "Reckless",
          "shortDescription": "When this champion spends 4 or more AP on attacks and abilities in a single turn, it loses 4 HP.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": -4,
          "iconName": "reckless"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 1884,
              "apCost": 0,
              "name": "Burn",
              "shortDescription": "When this champion successfully damages a champion with a basic attack, that unit becomes <condition value=charred>Charred</condition> for 5 turns",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 9,
              "iconName": "dot_burn"
            },
            {
              "default": true,
              "id": 2707,
              "apCost": 0,
              "name": "Vivify",
              "shortDescription": "When a friendly champion within 3 spaces that shares a race with this champion makes a successful attack, this champion gains 1 AP.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "allybuffs"
            },
            {
              "default": false,
              "id": 3088,
              "apCost": 1,
              "name": "Flameburst",
              "shortDescription": "This champion makes an attack at RNG 1-3 for 10 Fire damage.  If successfully damaged, the target is knocked back 3 spaces, then the target and enemy champions within 2 spaces of the final destination become <condition value=charred>Charred</condition> for 3 turns.",
              "activationType": 3,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "fireaoe"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 229,
              "apCost": 0,
              "name": "Damage Shield: Fire",
              "shortDescription": "When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Fire damage. This damage ignores DEF.",
              "activationType": 2,
              "level": 3,
              "cooldown": 0,
              "noraCost": 3,
              "iconName": "dmgshld_fire"
            },
            {
              "default": false,
              "id": 2355,
              "apCost": 1,
              "name": "Grant: Death Nova: Fire",
              "shortDescription": "Target champion within 5 spaces gains <ability value=181>Death Nova: Fire 2</ability> and <ability value=562>Self Destruct</ability> for 2 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "grantability"
            },
            {
              "default": true,
              "id": 2892,
              "apCost": 0,
              "name": "Feint",
              "shortDescription": "This Champion makes a 0 damage attack against target champion within 5 spaces. This attack is not part of the attack chain. If this attack is successful, the attacked champion gains 1 stack of <condition value=sundered>Sundered</condition> for 1 turn. ",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 3,
              "iconName": "feint"
            }
          ]
        }
      ]
    },
    {
      "id": 1792,
      "name": "Zombie Rotwrapper",
      "description": "\"There is nothing more natural than the production of children.\" -- Xulos, Undead Sage",
      "maxRng": 4,
      "minRng": 3,
      "defense": 0,
      "speed": 6,
      "damage": 9,
      "hitPoints": 44,
      "size": "1x1",
      "rarity": "LEGENDARY",
      "classes": [
        "Shaman"
      ],
      "races": [
        "Undead",
        "Zombie"
      ],
      "noraCost": 78,
      "hash": "eJ8IJ8He9BG2AG2AF0AJ8GJ8Hevklpwtmphgevo",
      "artist": "Caio Monteiro",
      "factions": [
        "Forsaken Wastes"
      ],
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "tradeable": true,
      "allowRanked": true,
      "deckLimit": 2,
      "startingAbilities": [
        {
          "id": 541,
          "apCost": 0,
          "name": "Attack: Disease",
          "shortDescription": "This unit makes a Disease attack at its Range. This is a basic attack.",
          "activationType": 3,
          "level": 0,
          "cooldown": 0,
          "noraCost": 2,
          "iconName": "attack_disease"
        },
        {
          "id": 3272,
          "apCost": 0,
          "name": "Corpse Restoration",
          "shortDescription": "The first time each turn a friendly real champion within 5 spaces is destroyed, a Shambling Zombie without upgrades is summoned adjacent to this unit.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 14,
          "iconName": "defile_corpse"
        },
        {
          "id": 986,
          "apCost": 0,
          "name": "Dark Healing",
          "shortDescription": "When an enemy champion within 10 spaces is healed by a spell or ability, the amount healed is reduced by 50%. At the end of each turn, friendly champions are healed by the same number of HP, distributed evenly among them to a maximum of 6 HP (rounded down, minimum 1). This effect does not stack.",
          "activationType": 2,
          "level": 0,
          "cooldown": 0,
          "noraCost": 9,
          "iconName": "dark_heal"
        },
        {
          "id": 2142,
          "apCost": 0,
          "name": "Zombie Apocalypse",
          "shortDescription": "This champion has <ability value=1211>Disease Eater</ability> and <ability value=1054>Healing Deficiency</ability>.  While you control at least 5 Zombies, this unit gains <ability value=2147>Swarm: Festering Corpse</ability>.",
          "activationType": 0,
          "level": 0,
          "cooldown": 0,
          "noraCost": 4,
          "iconName": "zombie_apoc"
        }
      ],
      "abilitySets": [
        {
          "abilities": [
            {
              "default": false,
              "id": 2504,
              "apCost": 3,
              "name": "Shrink",
              "shortDescription": "Target champion within 5 squares becomes <condition value=shrunken>Shrunken</condition> for 3 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "shrink"
            },
            {
              "default": false,
              "id": 1198,
              "apCost": 3,
              "name": "Cocoon",
              "shortDescription": "Target champion within 2 spaces becomes <condition value=cocooned>Cocooned</condition>. (After 3 turns, this champion loses Cocooned and gains +1 DEF, +1 SPD and +2 DMG. If this champion has Race: Arthropod, it loses Cocooned in 2 turns instead. This effect does not stack.)",
              "activationType": 1,
              "level": 0,
              "cooldown": 3,
              "noraCost": 8,
              "iconName": "web"
            },
            {
              "default": true,
              "id": 1218,
              "apCost": 0,
              "name": "Favor",
              "shortDescription": "When you successfully cast a spell that shares a faction with this unit, you gain 5 nora. This does not stack.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora"
            }
          ]
        },
        {
          "abilities": [
            {
              "default": false,
              "id": 1112,
              "apCost": 0,
              "name": "Soul Collection",
              "shortDescription": "When this champion moves within 5 spaces of a nora globe, or a nora globe drops from a champion within 5 spaces of this champion, this champion automatically recovers it.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 8,
              "iconName": "nora_eater"
            },
            {
              "default": true,
              "id": 2687,
              "apCost": 3,
              "name": "Confuse",
              "shortDescription": "Target champion within 5 spaces is <condition name=confused>Confused</condition> for 4 turns.",
              "activationType": 1,
              "level": 0,
              "cooldown": 2,
              "noraCost": 6,
              "iconName": "confuse"
            },
            {
              "default": false,
              "id": 927,
              "apCost": 0,
              "name": "Amplify: Disease",
              "shortDescription": "Disease damage dealt to champions and relics is increased by 10%.",
              "activationType": 0,
              "level": 0,
              "cooldown": 0,
              "noraCost": 6,
              "iconName": "amp_disease"
            }
          ]
        }
      ]
    }
  ],
  spells= [
    {
      "id": 150,
      "name": "Absorb Magic",
      "description": "The next time an enemy spell targets an enemy unit, the spell is redirected to the closest friendly champion. This effect is hidden until triggered.",
      "flavorText": "\"Let them have a taste of their own magic!\" - Xulos, Apprentice to Serken",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1Be9Ae9BF0Bj9Aj9Biwiwqjlnwthpuo",
      "deckLimit": 2
    },
    {
      "id": 401,
      "name": "Acid Storm",
      "description": "Area Effect 3: Units take 10 Acid damage and become <condition value=scoured>Scoured</condition> for 2 turns.",
      "flavorText": "\"Wait a moment. Give it a little time to work its way down under their leaves and bark. Cutting treefolk down is far easier if they're already rotting on the inside.\" - Kedrell, Blackscale Centurion ",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9AF0Ae9BG2Bj9Fj9Gqwtmnllnwonytqf",
      "deckLimit": 2
    },
    {
      "id": 300,
      "name": "Acidic Gale",
      "description": "Target champion takes Acid damage equal to 50% of the nora in its controller's nora bank.",
      "flavorText": "\"The Tortuns' greed is despicable, but it could prove useful. We can use their hunger for Nora against them, your Grace.\" -  Skubbin, Skeezick Alchemist",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0Ae9Be9BG2BJ8HJ8Iuqohievsqwohepf",
      "deckLimit": 2
    },
    {
      "id": 146,
      "name": "Acrid Smoke",
      "description": "Area Effect 2: Units take 8 Physical damage. Non-Demon Champions become <condition value=blinded>Blinded</condition> for 2 turns.",
      "flavorText": "\"The true foe when fighting fire is not the fire, but rather the acrid smoke that blinds and kills!\" - Matrim, Elven Druid",
      "noraCost": 35,
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9Be9Ae9BF0BJ8GJ8Hsmsmsuxvsohygn",
      "deckLimit": 2
    },
    {
      "id": 327,
      "name": "Alacrity",
      "description": "Area Effect 3: Friendly champions gain 4 AP and lose 8 HP.",
      "flavorText": "The Alpha was upon them in an instant. Before their captain could give the order to retreat, two had already succumbed to their wounds. ",
      "noraCost": 45,
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9BF0Ae9Be9AJ8GJ8Hqwzzkggirowfro",
      "deckLimit": 2
    },
    {
      "id": 71,
      "name": "Ambush",
      "description": "The next time an enemy unit engages target friendly Draksar during your opponent's turn, a Draksar Footman is summoned adjacent to it with upgrades.",
      "flavorText": "\"Ever get the feeling you were being... watched?\"",
      "noraCost": 50,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 10,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2AE8De9Bf1Bj9Bj9Ceilwftmjtmleipf",
      "deckLimit": 2
    },
    {
      "id": 138,
      "name": "Amplify Healing",
      "description": "For 4 turns, when a champion would be healed the amount is increased by 50%.",
      "flavorText": "It is said that there exist a spell of great power that is even stronger then the healing of a Priest from Valdac.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0Be9Ae9BF0AJ8IJ8Jerzkpqhpfgepjn",
      "deckLimit": 2
    },
    {
      "id": 402,
      "name": "Anathema",
      "description": "Area Effect 3: Champions take 12 Disease damage and become <condition value=defiled>Defiled</condition> and <condition value=decaying>Decaying</condition> for 2 turns.",
      "flavorText": "\"-Then his skin split instead of healin'. He was makin' an awful noise and it smelled like meat gone bad. He passed out and he's been like that for a week now. I can't tell if he's still alive.\" - Brid, Dwarven Sharpshooter",
      "noraCost": 45,
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9BF0Ae9BG2BJ8GJ8Hyoqqljpfkevhyo",
      "deckLimit": 2
    },
    {
      "id": 210,
      "name": "Ancestral Anger",
      "description": "Target champion gains <ability value=25>Berserker 3</ability> and has MAX RNG of 1 for 6 turns. If target champion is a Garu, it also gains <ability value=260>Enrage 2</ability>.",
      "flavorText": "\"There is something inherit in Elf and Garu alike. It goes by many names, but it is the same in everyone. It is anger. It is our greatest tool.\" - Ellorn, Mountain Garu",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Dg3Ae9Ae9Bg3Aj9Dj9Eeeerlplpjthnlrf",
      "deckLimit": 2
    },
    {
      "id": 207,
      "name": "Ancestral Focus",
      "description": "Target champion gains <ability value=1769>One With Nora</ability> for 6 turns. If this champion is destroyed while this effect is active, you gain 20 nora.",
      "flavorText": "\"I have learned many things during my travels across the world. Of these, I will teach you to focus. Through this, you will gain a new mastery over Nora.\" - L`usara, Elven Ancestor",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1Be9Ae9Bg3Aj9Aj9Bygpjgrwztjwztqf",
      "deckLimit": 2
    },
    {
      "id": 459,
      "name": "Ancient Implications",
      "description": "Target champion gains <ability value=1913>Backlash</ability>, <ability value=116>Regeneration 2</ability> and <ability value=1052>Purified</ability> for 6 turns. If this champion is destroyed while this effect is active, you gain 20 Nora.",
      "flavorText": "Yetis have an enigmatic history and culture that is largely not communicated to casual observers due their gruff exterior appearance and demeanor.  Tattoos like these, crafted by Yeti artisans, carry with them not only visual interest, but significant mystical properties as well.",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2AF0Be9BF0Aj9Bj9Ceerzgnyoqouhepf",
      "deckLimit": 2
    },
    {
      "id": 301,
      "name": "Ancient's Protection",
      "description": "For 6 turns, the first spell cast by your opponent fails. When this effect triggers, your shrine or avatar loses 15 HP. This effect is hidden until triggered.",
      "flavorText": "Even as a god, Zarimahl was compelled to protect Serkan's armies. The old king would place himself in harm's way to protect his subjects; the price for his power.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0Be9Be9BG2BJ8IJ8Jqwvkljnjtjtfipf",
      "deckLimit": 2
    },
    {
      "id": 224,
      "name": "Animosity",
      "description": "Target champion loses 7 HP, the nearest enemy relic loses 7 HP and each of your opponents lose 7 nora.",
      "flavorText": "\"You will not escape us, Gerron Lighthander. Your kin will suffer the wrath of Sheoul!\" - Lord Maxxarek of the Underdepths",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Ae9Be9Be9AJ8HJ8Iyvkwkerlyiyzto",
      "deckLimit": 2
    },
    {
      "id": 276,
      "name": "Antimagic Field",
      "description": "For 4 turns, all spell damage is prevented.\n",
      "flavorText": "Counter-magic is nothing new to the Draksar, although its practice was relatively crude until recently. After strenuous study, the Spellswords found a way to protect an entire army with one super-charged, counter-spell field.",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 4,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0Ae9Be9Bf1BJ8HJ8Ikjtfpsxmusqsso",
      "deckLimit": 2
    },
    {
      "id": 522,
      "name": "Arcane Enervation",
      "description": "Enemy champions within 5 spaces of target friendly small champion take 10 Magic damage. If the target is a Witch, affected champions also become <condition value=cursed>Cursed</condition> for 5 turns.",
      "flavorText": "\"Few know the power that Darkness holds as many fools find their end in its blackened folds.\" - Miriam, Inkblight Witch",
      "noraCost": 45,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CE8DF0Be9BG2Bj9Ej9Feeemwzzzgerwqqf",
      "deckLimit": 2
    },
    {
      "id": 296,
      "name": "Arcane Maelstrom",
      "description": "9 undeployed runes in your runedock are concealed. Target champion takes Electricity damage equal to the total number of concealed runes in your runedock.",
      "flavorText": "\"A red churning mass had formed in the sky, cutting the night with fiery bolts. The Arcanis waved me inside his home. He told me that the maelstrom would pass. I asked about its nature, but he wouldn't reply.\" - L'usara",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2Be9Be9BG2Aj9Cj9Dwzgnnuxzxzggvqf",
      "deckLimit": 2
    },
    {
      "id": 385,
      "name": "Arctic Gift",
      "description": "The next 4 friendly champions deployed or summoned have <ability value=600>Arctic</ability>, <ability value=1236>Ice Veil</ability> and <ability value=1324>Domain: Arctic</ability>.",
      "flavorText": "They begin and end with ice, it has become their welcome home. ",
      "noraCost": 20,
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1BF0Ae9Bf1Bj9Aj9Bohpwfkyrjymhkpf",
      "deckLimit": 2
    },
    {
      "id": 63,
      "name": "Arctic Wail",
      "description": "Area Effect 5: Relics in target area take 15 Frost damage. Enemy champions lose 1 AP and become <condition value=frozen>Frozen</condition> for 2 turns.",
      "flavorText": "\"When last I heard such a wail, it was the cry of my beloved king as he fell into the chasm. Terror and madness in chorus. Beautiful, in a way.\" - Varia, Draksar Broodqueen",
      "noraCost": 30,
      "artist": "Gabriel Garza",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AE8DE8De9Bf1Bj9Ej9Fiwzztzzzxfxiwo",
      "deckLimit": 2
    },
    {
      "id": 290,
      "name": "Arise",
      "description": "Area Effect 2: Relics with <ability value=2144>Stitched Remains</ability> are destroyed and a Stitched Blackguard, Stitched Magician or a Stitched Dreameater is spawned in the locations the relics occupied. ",
      "flavorText": "\"Their remains began to shake. Before I knew it, the pieces were gone and the Stitched was reassembled. How do you fight something that puts itself back together?\" - Kashara, Leoss Guardian",
      "noraCost": 60,
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 12,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0Be9Be9BG2AJ8IJ8Jgytmllrjwxmjepf",
      "deckLimit": 2
    },
    {
      "id": 227,
      "name": "Arthropod Frenzy",
      "description": "Friendly champions with Race: Arthropod gain <ability value=2324>Pounce</ability>, <ability value=518>Leap 3</ability> and <ability value=894>Retreat 2</ability> for 1 turn.",
      "flavorText": "\"My children are warriors! They can fight as hard, and with as much conviction, as any of your Nefari. My army is limited only by the size of its warriors. Your army is limited by numbers.\" - K`lzik, Matron of Lower Sheoul\r\n",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Be9Be9Be9Aj9Aj9Bjekwvfxzxzkpjpf",
      "deckLimit": 2
    },
    {
      "id": 83,
      "name": "Avalanche",
      "description": "Area Effect 3: Units take 10 Physical damage. Champions successfully damaged become <condition value=grounded>Grounded</condition> for 2 turns and are knockbacked 1 space.",
      "flavorText": "\"This isn't hard! Move those rocks THERE to that pile THERE!\" - Yiikae, Voil Screecher",
      "noraCost": 45,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1AE8De9BG2AJ8Jj9Aeeiyzvhpuhthepf",
      "deckLimit": 2
    },
    {
      "id": 397,
      "name": "Avenging Flame",
      "description": "When target friendly champion is destroyed, the nearest enemy champion becomes Consumed By Fire (This champion is Shielded, Immobile and Pacified. At the beginning of your turn, this champion takes 10 Fire Damage) for 2 turns.",
      "flavorText": "Fire is all consuming and exact in it's vengeance. ",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2BF0Ae9BG2Aj9Cj9Dyoyvkyigkrfiyrf",
      "deckLimit": 2
    },
    {
      "id": 250,
      "name": "Awaken Brood",
      "description": "All Egg relics in play hatch immediately.",
      "flavorText": "Eraila admired her clutch, as it came to life. The eggs jostled about and their shells slowly cracked. From one, a broodling eye emerged. As she met its wild stare, her heart was filled with pride.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2Be9Be9BF0Aj9Cj9Diyrwofmeipfgepf",
      "deckLimit": 2
    },
    {
      "id": 1,
      "name": "Backfire",
      "description": "For 6 turns, the next enemy spell cast fails (Nora is still used, and the spell still cools down).  This effect is hidden until triggered.",
      "flavorText": "\"What's the worst that could happen?\" - Celea, Elven Mage Apprentice",
      "noraCost": 40,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9BE8De9Be9BJ8GJ8Heeipjnsqqsxitm",
      "deckLimit": 2
    },
    {
      "id": 410,
      "name": "Backfire Boon",
      "description": "For 6 turns, the next enemy spell cast fails (Nora is still used, and the spell still cools down). This effect is hidden until triggered. When this effect triggers, friendly champions are healed for 15 HP.\r\n",
      "flavorText": "\"Whatever they were up to, it didn't work. Let's keep going.\" - Griblic, Boghopper Elite",
      "noraCost": 55,
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 11,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DE8DF0Ae9Bg3Aj9Ej9Fwiwthpsztfiwtqf",
      "deckLimit": 2
    },
    {
      "id": 74,
      "name": "Bad Blood",
      "description": "Target champion takes 15 Magical damage. Champions that share a race with target champion within 5 spaces also take 8 Magical damage.",
      "flavorText": "\"Burn the swamp!\" - Eehiist, Voil Queen",
      "noraCost": 45,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8DE8De9BG2Aj9Ej9Fiwipnpfmlluzzo",
      "deckLimit": 2
    },
    {
      "id": 535,
      "name": "Bait and Switch",
      "description": "Target friendly champion swaps places with the closest friendly champion of the same size in 6 spaces.  The champion with the higher AP loses AP so it has the same AP as the other, and the other gains AP equal to the amount lost.",
      "flavorText": "\"Look, they won't be able to tell us apart after we do this. I am telling you, it's foolproof.\"",
      "noraCost": 30,
      "artist": "Paul Guzenko",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0Af1AG2Ae9BJ8HJ8Ievxxqwtmuzolro",
      "deckLimit": 2
    },
    {
      "id": 460,
      "name": "Balancing Act",
      "description": "Target champion gains <ability value=3128>Portal Dancer</ability>, <ability value=1440>Confuse Attacker</ability> and +1 SPD for 6 turns.  If it has Class: Archer, it also gains <ability value=1264>Swap 3</ability>.",
      "flavorText": "Elven children grow up amongst the streams and rapids running through the forest, and become adept at tranversing them when the need arises.",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2BF0Be9BF0Aj9Cj9Deipqsosszrzzipf",
      "deckLimit": 2
    },
    {
      "id": 302,
      "name": "Balancing Force",
      "description": "For 6 turns, the next time an opposing player targets a champion with a spell from the runedock, the closest valid champion controlled by a different player is targeted by a copy of the same spell as though it was cast by you. This effect does not stack and is hidden until triggered.",
      "flavorText": "\"These 'hoppers have a few tricks up their sleeves. This counterspellin' mess, for instance. We could put this to use against the Kanen, don't ye think?\" ? Deblin Redjaw, Admiralty to Gharivol",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1Ae9Be9BG2BJ8Jj9Aemnhrojnpjnempf",
      "deckLimit": 2
    },
    {
      "id": 493,
      "name": "Bane Beam",
      "description": "Area Effect 2: Champions take 12 Electricity damage. If they are <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>, they lose those conditions and take an additional 6 Electricity damage.",
      "flavorText": "Al'Mara is patient with both her followers and non-believers alike. To incur her wrath, one must commit an unspeakable crime.",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "LIMITED",
      "cooldown": 8,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0AG2BG2AG2BJ8HJ8Izirfrsshvoyzgrf",
      "deckLimit": 2
    },
    {
      "id": 344,
      "name": "Bane Blast",
      "description": "Area Effect 2: Champions take 12 Electricity damage. If they are <condition value=stunned>Stunned</condition> or <condition value=paralyzed>Paralyzed</condition>, they lose those conditions and take an additional 6 Electricity damage.",
      "flavorText": "Al'Mara is patient with both her followers and non-believers alike. To incur her wrath, one must commit an unspeakable crime.",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gg3AF0Ae9Be9Bj9Dj9Eeevfmuqshgyxfpf",
      "deckLimit": 2
    },
    {
      "id": 431,
      "name": "Bane Shift",
      "description": "For 6 turns, this champion is <mechanic value=cleansed>Cleansed</mechanic> at the start of each turn. For every condition removed this way, a random enemy champion within 5 spaces loses 5 HP. This effect is hidden until triggered.",
      "flavorText": "\"Goblins are idiots, they harm themselves and everyone around them in every conceivable way and it ends up being hilarious to them regardless of the outcome.\" - Anonymous",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9AF0Be9Be9Aj9Fj9Gevkykphtqwolnpf",
      "deckLimit": 2
    },
    {
      "id": 59,
      "name": "Banish",
      "description": "Target enemy champion without <ability value=680>Planar Bound</ability> loses all AP and is relocated to the furthest available space in the closest deployment zone its owner controls and gains <ability value=2260>Pariah</ability>, <condition value=confused>Confused</condition> and <condition value=distracted>Distracted</condition> for 4 turns. The closest friendly real champion gains <ability value=2474>Font Ignorance</ability> for 3 turns.",
      "flavorText": "\"Don't think of this as 'goodbye'. Think of it as an introduction to true suffering.\" Xuvali, Deep Elf Temptress",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1BE8De9Bf1Aj9Aj9Bjiiwxofgvmumwo",
      "deckLimit": 2
    },
    {
      "id": 259,
      "name": "Barricade",
      "description": "Area Effect 2: Barricade relics with 1 DEF, 15 HP and <ability value=3028>Demolish</ability> are summoned to the edge of the affected area.",
      "flavorText": "Rinmar turned to witness a terrible sight: a massive brick wall, where his troops once marched behind him. It was then, he realized, the assault on the Stronghold would fail.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2Ae9Be9BF0Bj9Bj9Ceeeeeipnsjgiepf",
      "deckLimit": 2
    },
    {
      "id": 172,
      "name": "Battle Fatigue",
      "description": "For 4 turns, after a champion successfully attacks, it loses all AP.",
      "flavorText": "\"The resolve of our soldiers is astounding. They fight even when they cannot stand!\" - Akakios, Draksar Lord",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2Be9Ae9Bf1Bj9Cj9Dpygpykwmyzvzoqf",
      "deckLimit": 2
    },
    {
      "id": 228,
      "name": "Befoul",
      "description": "Enemy champions become <condition value=defiled>Defiled</condition> for 6 turns.",
      "flavorText": "\"Your people are not safe, Rugolth. Do you think stone can thwart me? Ha! You are foolish, dwarf. Your stronghold will crumble, and your subjects will decay. You cannot escape my grasp!\" - Maxxarek of Sheoul\r\n",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Ae9Be9Be9Aj9Bj9Cerqfeiyoukronpf",
      "deckLimit": 2
    },
    {
      "id": 236,
      "name": "Black Ops",
      "description": "Target friendly unit becomes <condition value=stealthed>Stealthed</condition> and gains <ability value=13>Detection 3</ability>.",
      "flavorText": "Serkan has many eyes, in many different places. With these eyes, Serkan can see everything. The eyes see, but cannot be seen. They are always watching.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1Ae9Be9Be9BJ8Jj9Aeevshrjlussjln",
      "deckLimit": 2
    },
    {
      "id": 316,
      "name": "Blaspheme",
      "description": "Target champion loses all AP and gains 1 stack of Demoralized (This champion has -2 DMG) per friendly Draksar in play (up to 4) for 5 turns.",
      "flavorText": "To the Draksar, words held power. With words alone, one could bring a foe to its knees. Words could dissolve a kingdom and raise a new one in its place.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9AF0Ae9BE8Dj9Fj9Gsxtxxolgyvzmhpf",
      "deckLimit": 2
    },
    {
      "id": 491,
      "name": "Blast Doors",
      "description": "Destroy all Dimension Door relics. Non-Minotaur champions within 3 spaces of a Dimension Door take 12 Magical damage and are knocked back 2 spaces.",
      "flavorText": "\"Quick!  Maxxarek has discovered our portal, get through the door before it's destroyed!\" - Minotaur Sentry",
      "noraCost": 35,
      "artist": "Nate Abell",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ag3AF0Be9Bf1Bj9Dj9Eeevsufexzoljerf",
      "deckLimit": 2
    },
    {
      "id": 339,
      "name": "Blessing of Al'Mara",
      "description": "Target champion gains <ability value=1>Flight</ability>; if target champion has Class: Paladin or Priest, it also gains <ability value=1395>Hunter: Walker</ability> and Race: Angel.",
      "flavorText": "Remnir was flying. He didn't remember how or why, but he made the best of it anyway. As he passed a mountain, he saw an angel standing at its peak. She smiled and waved to him.",
      "noraCost": 20,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 4,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0BF0Ae9Be9BJ8IJ8Jeemememwkruojn",
      "deckLimit": 2
    },
    {
      "id": 142,
      "name": "Blessing of the River",
      "description": "Target unit gains <ability value=2>Amphibious</ability> and <ability value=883>Tidal Wave</ability> for 8 turns. If target unit already has Amphibious/Semi-Aquatic/Aquatic, it gains <ability value=867>Blessed</ability>.",
      "flavorText": "\"In the river is power, if we can somehow harness that power it could increase our strength!\" - Tide Master of Forglar",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2Be9Ae9BF0Aj9Cj9Dvkgemwkjwzrhyo",
      "deckLimit": 2
    },
    {
      "id": 152,
      "name": "Blight the Holy",
      "description": "Target Protectorate champion takes 20 Disease damage and becomes <condition value=Inhibited>Inhibited</condition>.\r\n",
      "flavorText": "\"They are no match for our power!  The Undead will reign the land of the holy!!\"",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2Be9Ae9BF0Bj9Cj9Dwiwinlnnsmpfgpf",
      "deckLimit": 2
    },
    {
      "id": 289,
      "name": "Blinding Flash",
      "description": "Target champion becomes <condition value=blinded>Blinded</condition> and <condition value=slowed>Slowed</condition> for 4 turns.",
      "flavorText": "It lasted only a moment; a light so brilliant and fierce. Kanen scampered about the jungle, covering their eyes and whimpering. Their prey had escaped and they were too bewildered to give chase.",
      "noraCost": 35,
      "artist": "Slawomir Maniak",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "EXOTIC",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9Be9Be9Bg3AJ8GJ8Hoqonuhtuxxfeepf",
      "deckLimit": 2
    },
    {
      "id": 65,
      "name": "Blinding Reflection",
      "description": "Target non-Illusion, non-Hero friendly champion loses all conditions and is removed from play. It then re-enters play along with 3 Illusion champions that appear to be identical copies of this champion. When this champion leaves play, the Illusions are destroyed.",
      "flavorText": "\"He said there were twenty of them. Well, twenty combatants don't leave one set of tracks.\" - Ceyana, Deep Elf Mercenary",
      "noraCost": 30,
      "artist": "Gabriel Garza",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "EXOTIC",
      "cooldown": 6,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9BE8De9Bf1BJ8GJ8Hklexzohexmhiln",
      "deckLimit": 2
    },
    {
      "id": 287,
      "name": "Blink",
      "description": "Target champion is removed from play. At the end of 2 turns, the champion is returned to play in the location where it was removed from play. If that location is occupied, that unit loses 5 hp and the redeployment effect is delayed for 1 turn (this process repeats until the unit is successfully redeployed).",
      "flavorText": "\"Day 2. The Alpha has seen my steps along the trail. I've spent time hiding in the brush. He has been pacing the perimeter the whole time, but I see him losing interest. He'll give up soon.\" - Vahkosh, Headhunter",
      "noraCost": 55,
      "artist": "Simon Dominic",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 11,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "ej9Cj9BF0Ae9Be9BG2AJ8HJ8Igtqhvfplnjwmwo",
      "deckLimit": 2
    },
    {
      "id": 2,
      "name": "Blister",
      "description": "Champions without Race: Dragon, Skeezick or Draksar take 8 Physical damage.",
      "flavorText": "\"The soft skinned of Ironfist shall suffer for their damnation of the survivors of Old Valdac.\" - Akakios, Draksar Lord  ",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0BE8De9BF0BJ8IJ8Joqoqosumpyxkln",
      "deckLimit": 2
    },
    {
      "id": 278,
      "name": "Blizzard",
      "description": "Area Effect 4: Affected area becomes Ice for the next 8 turns. For 4 turns, at the end of your opponent's turns, champions without <ability value=600>Arctic</ability> in the area become <condition value=chilled>Chilled 2</condition> and <condition value=frozen>Frozen 2</condition>.",
      "flavorText": "\"The chill bites at my core. We've been searching along the Boreal Cliffs for cartography, jotting notes about the terrain and its various features. I can't fight this cold, like they do. I think it's killing me.\" - Diary of L`ilae, Ice Climber",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1Ae9Be9Bf1BJ8Jj9Aemwvowtuqzvkepf",
      "deckLimit": 2
    },
    {
      "id": 471,
      "name": "Blizzard Cloak",
      "description": "For 6 turns, the next 3 attacks against target champion misses. This effect is hidden until triggered. If the target champion occupies Snow or Ice, this spell refunds 10 nora.",
      "flavorText": "Now the frost winds call / A brief moment of clarity / Of promises and omens / Amidst the lingering chill\r\n",
      "noraCost": 40,
      "artist": "Anthony Lopes",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3AF0Be9BF0Bj9Dj9Eeeeeeerhnllyrqf",
      "deckLimit": 2
    },
    {
      "id": 223,
      "name": "Blood Exchange",
      "description": "Target friendly champion's current hit points are swapped with the current hit points of the closest non-avatar friendly champion.",
      "flavorText": "\"The Deep Elves share a link through blood. It sustains their elven bodies and feeds their demon hearts.\" - Betrella, Bok Guardian",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "ej9Gj9Fe9Ae9Be9Be9Aj9Fj9Grfkumwzrjitmjpf",
      "deckLimit": 2
    },
    {
      "id": 120,
      "name": "Blood for Mortar",
      "description": "Target real owned champion loses 10 HP. Enemy champions within 3 spaces lose 8 life and become <condition value=bloodied>Bloodied</condition> and your shrine and relics heal for the amount of HP lost on enemy champions, split evenly.",
      "flavorText": "\"They say the shrines in the Underdepths are built with the blood and bones of their fallen warriors.\" \r\n",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Ae9Ae9Be9AJ8Jj9Aerherfphkpwtzo",
      "deckLimit": 2
    },
    {
      "id": 231,
      "name": "Blood of the Dragon",
      "description": "For 6 turns, all friendly champions with Race: Dragon, Skeezick or Draksar have <ability value=249>Damage Shield: Acid 3</ability>.\n",
      "flavorText": "\"Courage burns in their hearts. Their very blood is set ablaze at the call to war. They know they must fight for their country, and they are grateful to serve.\" - Akakios, Draksar Lord",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8De9Be9Be9Bj9Ej9Feeekljwkrqzgkn",
      "deckLimit": 2
    },
    {
      "id": 219,
      "name": "Blood of the Swamp",
      "description": "For 6 turns, whenever target friendly champion takes damage, other friendly champions heal an amount equal to half the damage taken.  This effect is hidden until triggered.",
      "flavorText": "Few could explain what happened when Gebsir fell. His blood began to seep into the skin of his comrades. As it did, their wounds began to close. It was a miracle from Forglar.",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Ae9Be9BE8Dj9Bj9Cevxxigpftzrojpf",
      "deckLimit": 2
    },
    {
      "id": 3,
      "name": "Bog Trap",
      "description": "Area Effect 2: For 5 turns, when a champion without <condition value=flying>Flying</condition> or <ability value=2>Amphibious</ability> enters an affected space, it loses all AP. Affected spaces also becomes Water (Impeding 1) for 5 turns.",
      "flavorText": "\"In the swamps of Forglar, even the land itself will try to consume you.\" - Finn Wynsithe, K'thir Ranger",
      "noraCost": 35,
      "artist": "Shayne Bingham",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EE8DE8De9BE8Dj9Ej9Fukgvknygeipuso",
      "deckLimit": 2
    },
    {
      "id": 461,
      "name": "Boghopper Bravado",
      "description": "Area Effect 2: Friendly champions gain +2 DMG, <ability value=3>Fearless</ability> and <ability value=4>Iron Will</ability> for 6 turns.  If the champion is a Boghopper, it also gains <ability value=1238>Intimidating</ability> for 2 turns.",
      "flavorText": "\"Say what you will about their slimy skin, these hoppers mean business.\" ~ Voil Courier",
      "noraCost": 35,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hg3AF0Be9BF0Aj9Dj9Eeevkpsfvqwqwmpf",
      "deckLimit": 2
    },
    {
      "id": 4,
      "name": "Boil",
      "description": "Area Effect 3: Champions without <condition value=flying>Flying</condition> occupying Water within the affected area take 16 Physical damage. Champions with <ability value=114>Aquatic</ability> or <ability value=859>Semi Aquatic</ability> take an additional 8 damage.",
      "flavorText": "Being downstream, Dibbos' first thought when he felt the water around his legs warm was to his comrades upstream, until he saw their corpses float past him.",
      "noraCost": 45,
      "artist": "Shayne Bingham",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1AE8De9BF0BJ8Jj9Aeeeeerlegtjyon",
      "deckLimit": 2
    },
    {
      "id": 422,
      "name": "Bond of Vashal",
      "description": "Area Effect 3: For 6 turns, friendly champions gain a rank of <ability value=1900>Tough</ability> and a rank of <ability value=115>Regeneration</ability> for each Vashal in the affected area.",
      "flavorText": "A lone Vashal is one thing, but an organized pack on the warpath is another.\r\n",
      "noraCost": 35,
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9BF0Be9BE8DJ8GJ8Heemeiphnuhgipn",
      "deckLimit": 2
    },
    {
      "id": 482,
      "name": "Boreal Twilight",
      "description": "For 12 turns, when a friendly champion is destroyed, your champions within 6 spaces of that unit gain 1 AP.",
      "flavorText": "Jakei believe death is not the end, rather a journey all must take.  When Jakei die, they live on in their people, and in the tundra itself.",
      "noraCost": 25,
      "artist": "Asa Enochs",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AE8DF0Be9Bf1Bj9Ej9Feeexzmwvqftzipf",
      "deckLimit": 2
    },
    {
      "id": 378,
      "name": "Boulder Throw",
      "description": "Target champion takes 15 Physical damage and becomes <condition value=distracted>Distracted</condition> and <condition value=awestruck>Awestruck</condition> for 2 turns.",
      "flavorText": "\"That Moga wasn't even close to our troops! What in Sheoul are they doing? Are they planning to kill their army first?\" - Orman Rockblade, IEF",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AE8DF0Ae9Bf1Bj9Ej9Fqouhyvxqsqjegpf",
      "deckLimit": 2
    },
    {
      "id": 538,
      "name": "Boundless Enthusiasm",
      "description": "Target champion with Race: Goblin or Race: Imp gains <ability value=1269>Antagonize</ability>, <ability value=3296>Zeal: Damage</ability> and <ability value=2707>Vivify</ability> for 6 turns.",
      "flavorText": "\"I will punch him! Then I will punch him again! And I will kick him in the floor!\" Goblin children playing",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9Bf1BG2Af1AJ8GJ8Hinwvfrfkllrwfpf",
      "deckLimit": 2
    },
    {
      "id": 5,
      "name": "Brambles",
      "description": "Area Effect 2: Champions become <condition value=ensnared>Ensnared</condition> for 2 turns and take 8 Physical damage.",
      "flavorText": "\"If it has thorns, don't touch it.\" - Lesson 31, Draksar Footman Handbook",
      "noraCost": 35,
      "artist": "Gabriel Garza",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9AE8De9Be9Aj9Fj9Gjllpnhvoyrzmepf",
      "deckLimit": 2
    },
    {
      "id": 364,
      "name": "Brand of Brutality",
      "description": "Starting next turn, this champion deals and takes twice as much damage from melee attacks made by or against non-Summoned champions.",
      "flavorText": "Those who serve the Temple of Brutality, who share the blessings of Erimalion, are given the Brand of Brutality. The mark is said to imbue one with terrible anger.",
      "noraCost": 40,
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3AF0Ae9BF0Bj9Dj9Eeeeeevonnshyoqf",
      "deckLimit": 2
    },
    {
      "id": 321,
      "name": "Breath of Ash",
      "description": "Area Effect 4: Affected spaces become Ash (Champions occupying this space gain Evasive 3) for 8 turns.",
      "flavorText": "Occasionally, the Breath of Sheoul can carry into the Seared Forest. When this happens, only demons can bear the thick, ash-filled winds that blow through the trees.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1BF0Ae9BE8Dj9Aj9Bqlrftzzirjpqhpf",
      "deckLimit": 2
    },
    {
      "id": 244,
      "name": "Breath of L'usara",
      "description": "Area Effect 5: For 6 turns, affected area becomes Ice. Friendly champions gain <ability value=1324>Domain: Arctic</ability>",
      "flavorText": "With L`usara's help, the treacherous terrain of the Shattered Peaks was quickly overcome. As they traveled, the Peaks were dotted with patches of ice and snow.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0Ae9Be9BF0AJ8HJ8Iitxmexvftuhthn",
      "deckLimit": 2
    },
    {
      "id": 104,
      "name": "Broodguard",
      "description": "All egg relics gain +1 DEF, +15 MAX HP, and <ability value=37>Immunity: Fire</ability>.",
      "flavorText": "Broodmothers affix the molted scales of warriors to the fragile shells of their eggs to better protect them from those who would do them harm.",
      "noraCost": 25,
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1BE8De9Bg3Aj9Aj9Bqolpwouvxtxxqqf",
      "deckLimit": 2
    },
    {
      "id": 388,
      "name": "Bubble of Protection",
      "description": "Target champion gains a <condition value=buffered>Buffer</condition> of 35 HP. This overrides any existing Buffer on the champion.",
      "flavorText": "Arrows were whirling toward him. He muttered words that were harsh and swift but precise. The arrows fell to the marsh floor as though they were toothpicks.\r\n\r\n",
      "noraCost": 45,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ag3AF0Ae9Bf1Bj9Dj9Eemexmnwfvzmhyrf",
      "deckLimit": 2
    },
    {
      "id": 187,
      "name": "Bullseye",
      "description": "For 1 turn, each friendly champion with Class: Archer and a range greater than 3 gains <ability value=655>Skirmisher</ability> does 50% more damage on its next basic attack.",
      "flavorText": "\"Your fears are unfounded, M'alta. My students do not miss their targets. I would put my life on it.\" - L'ilim, Elvish Archer",
      "noraCost": 35,
      "artist": "Anthony Lopes",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LEGENDARY",
      "cooldown": 7,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1AE8De9BE8DJ8Jj9Aemwqzxfkrumyto",
      "deckLimit": 2
    },
    {
      "id": 284,
      "name": "Bullseye",
      "description": "For 1 turn, each ranged friendly champion gains <ability value=655>Skirmisher</ability> does 50% more damage on its next basic attack.",
      "flavorText": "\"Your fears are unfounded, M'alta. My students do not miss their targets. I would put my life on it.\" - L'ilim, Elvish Archer",
      "noraCost": 35,
      "artist": "Anthony Lopes",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LIMITED",
      "cooldown": 7,
      "runeSet": "Nora Surge",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8De9Be9BG2Aj9Ej9Fgygexmyvfklyipf",
      "deckLimit": 2
    },
    {
      "id": 469,
      "name": "Burning Crusade",
      "description": "Target champion gains <ability value=388>Flame Armor</ability>, <ability value=133>Fire Aura 3</ability> and <ability value=2738>Brand</ability>.  If the target is a Paladin, you are refunded 10 nora.",
      "flavorText": "\"Every hovel in every village will be subject to a thorough search.  No one, not even those with connections to the Inquisition nor the Royal Family are exempt.  All resources are hereby released for mobilization.  The source of these distrubances must be found and eradicated!\" ~ Excerpt from classified communications of the Northern Cross\r\n",
      "noraCost": 35,
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2AF0Be9BF0Bj9Bj9Ceeeeeeiroufgipf",
      "deckLimit": 2
    },
    {
      "id": 488,
      "name": "Burning Sands",
      "description": "Area Effect 3: Champions take 10 Physical damage.  If an affected champion is on Sand, it also becomes <condition value=charred>Charred 3</condition> and <condition value=sandblasted>Sandblasted</condition> for 5 turns.\r\n",
      "flavorText": "Even the elements seem to be against us...",
      "noraCost": 40,
      "artist": "Paul Guzenko",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1BF0Be9Bf1Bj9Aj9Bevfrsszilljgnpf",
      "deckLimit": 2
    },
    {
      "id": 322,
      "name": "Burnout",
      "description": "Sacrifice target champion you own, champions within 2 spaces take 14 Fire damage, become <condition value=charred>Charred 3</condition> and are knocked back 2 spaces.",
      "flavorText": "\"The Nefari blew up, like a Thir-splitter, and nearly took out our landing party. I don't know what kinda trick that was, but I'd hate to see it again.\" - Hugo Stormshell, Infantrytort on the Leviathan",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2AF0Ae9BE8Dj9Bj9Cemwquxfgpyonlpf",
      "deckLimit": 2
    },
    {
      "id": 6,
      "name": "Butterfly Wings",
      "description": "Target champion gains <condition value=flying>Flying</condition> and <ability value=6>Mobility</ability>.",
      "flavorText": "\"Few things in this world are as graceful as the wings of a butterfly, nor as temporal.\" - Menalaus, Elven Priest",
      "noraCost": 20,
      "artist": "Dan Kopycienski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0AE8De9Be9AJ8HJ8Iwmnljnpqsxiipn",
      "deckLimit": 2
    },
    {
      "id": 208,
      "name": "Call of the Tundra",
      "description": "A Yeti Conqueror with upgrades is summoned to the closest available unoccupied location to target space. This champion comes into play with 5 AP and <ability value=655>Skirmisher</ability>. At the end of your opponent's turn, the champion is removed from play.  This spell refunds 3 nora for each friendly Yeti, to a maximum of 15.",
      "flavorText": "With all of his strength, Y`inlo called out to the tundra. He thought his hail had gone unanswered, until he saw it charging towards him. The tundra's response was large, woolly, and furious.",
      "noraCost": 50,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 10,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2Ae9Ae9Bg3Aj9Bj9Ceeeipqfxmyvfxqf",
      "deckLimit": 2
    },
    {
      "id": 140,
      "name": "Call Serpent",
      "description": "Summons an egg relic that will hatch in 2 turns into either a Poison Serpent with 0 DEF, 6 SPD, 9 DMG, HP of 15, RNG 1 and <ability value=169>Poison 3</ability> or a Constrictor Serpent with 0 DEF, 5 SPD, 7 DMG, HP of 25, RNG 1 and <ability value=324>Constriction</ability>.",
      "flavorText": "Always watch the grass... they say that serpents slither amongst it.",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1Be9Ae9BF0Aj9Aj9Bipyirowiinpuqo",
      "deckLimit": 2
    },
    {
      "id": 230,
      "name": "Call to War",
      "description": "3 Draksar Footman champions with no upgrades are summoned in the nearest deployment zone.",
      "flavorText": "\"We will serve Lord Akakios when he needs us. It doesn't matter the situation; if a Draksar hears the call to war, he will answer.\" - Telir, Draksar",
      "noraCost": 80,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 16,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3Ae9Be9Be9Aj9Dj9Eevfvhpwmshrowqf",
      "deckLimit": 2
    },
    {
      "id": 403,
      "name": "Calming Tailwinds",
      "description": "Area Effect 4: Friendly champions with <condition value=flying>Flying</condition> gain 4 AP and become <condition value=pacified>Pacified</condition> for 2 turns.",
      "flavorText": "\"Wind is the element we are born into. We are its master and its slave.\" - Losintusniako the 67th",
      "noraCost": 25,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0AF0Ae9BG2BJ8HJ8Ixxfvhnusuoyggpf",
      "deckLimit": 2
    },
    {
      "id": 365,
      "name": "Cancel Magic",
      "description": "For 6 turns, the next spell your opponent casts costing equal or more nora than this spell fails (Nora is still used, and the spell still cools down). This effect is hidden until triggered.",
      "flavorText": "\"You must study the caster's movements. There is a moment when the energy is properly channeled, but the spell is not fully invoked. This is your moment of opportunity. This is when you strike.\" - Yumerin, Spellsword Commander",
      "noraCost": 40,
      "artist": "Alex Fang",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JE8DF0Ae9Bf1Aj9Ej9Fiwvowzkygiwiyo",
      "deckLimit": 2
    },
    {
      "id": 7,
      "name": "Carnivorous Vines",
      "description": "Target champion becomes <condition value=rooted>Rooted</condition> for 3 turns and takes 4 Physical damage.",
      "flavorText": "Take care when traveling in K'thir - the plants are not picky eaters.",
      "noraCost": 30,
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9BE8De9Be9AJ8GJ8Hinpfemnsmnjpln",
      "deckLimit": 2
    },
    {
      "id": 8,
      "name": "Cauterize",
      "description": "Target injured champion takes 10 Fire damage and is <condition value=inhibited>Inhibited</condition> and <condition value=defiled>Defiled</condition>.",
      "flavorText": "\"Let this remind you of my ability to hold a grudge.\" - Gibir, Demon of the Underdepths",
      "noraCost": 30,
      "artist": "Dan Kopycienski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hg3AE8De9BF0Aj9Dj9Eerzxtzkyrhnyzo",
      "deckLimit": 2
    },
    {
      "id": 64,
      "name": "Chain Lightning",
      "description": "Target champion takes 15 Electricity damage. Then each enemy unit within 2 spaces take 10 Electricity damage, then each enemy unit within 2 spaces of those units take 5 Electricity damage (units are not hit more than once each).",
      "flavorText": "\"When told that lightning never strikes twice, it's said that Serkan's mages took it as a challenge.\"",
      "noraCost": 40,
      "artist": "Michael Dutton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9AE8De9Bf1Bj9Fj9Gfxztssztosmeepf",
      "deckLimit": 2
    },
    {
      "id": 257,
      "name": "Chains of Corruption",
      "description": "Area Effect 3: Enemy champions lose 5 HP and become <condition value=ensnared>Ensnared</condition> for 2 turns. If a friendly Human is in the affected area, those champions lose 8 HP and become <condition value=ensnared>Ensnared</condition> for 4 turns instead.",
      "flavorText": "\"Let him thrash about, let him scream and howl until his throat gives out. With those chains around his wrists, he is powerless.\" - Kelzin, Elsari Sorceress",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1Ae9Be9BF0BJ8Jj9Aeeeeevfpyxxtso",
      "deckLimit": 2
    },
    {
      "id": 251,
      "name": "Channeled Violence",
      "description": "Area Effect 3: Friendly champions gain <ability value=260>Enrage 2</ability> and <ability value=2164>Abuse Charged 2</ability> for 4 turns.  If the champion is a Draksar, it also gains <ability value=15>Multiattack 1</ability> for 4 turns.",
      "flavorText": "\"The fury of the Draksar is shared between all of Valdac's kin. Maybe it is zealotry, or maybe it's kinship.\" - Raxar, Skeezick General",
      "noraCost": 45,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hg3Ae9Be9BF0Aj9Dj9Eevxfgvsxfeexipf",
      "deckLimit": 2
    },
    {
      "id": 9,
      "name": "Clairvoyance",
      "description": "Target friendly champion gains <ability value=13>Detection 3</ability> for 8 turns. If it has class Priest or Ranger, it gains <ability value=2671>Illuminate</ability> as well.",
      "flavorText": "During the celebration of summer, it is said that Menalaus gave to Godwin the greatest gift he could confer: the gift of foresight.",
      "noraCost": 25,
      "artist": "Shayne Bingham",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1AE8De9Be9AJ8Jj9Aevfiljwkwzkuxo",
      "deckLimit": 2
    },
    {
      "id": 110,
      "name": "Clairvoyance",
      "description": "Target friendly champion gains <ability value=13>Detection 3</ability> for 8 turns. If it has class Priest or Ranger, it gains <ability value=2671>Illuminate</ability> as well.",
      "flavorText": "During the celebration of summer, it is said that Menalaus gave to Godwin the greatest gift he could conjure: the gift of foresight.",
      "noraCost": 25,
      "artist": "Gabriel Garza",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LIMITED",
      "cooldown": 5,
      "runeSet": "Pox Nora Release Set",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1Ae9Ae9BE8DJ8Jj9Aevszzrsuzvqwvo",
      "deckLimit": 2
    },
    {
      "id": 424,
      "name": "Cleansing Mist",
      "description": "Area Effect 4: At the end of your opponent's next turn, friendly champions are <mechanic value=cleansed>Cleansed</mechanic> of negative conditions and healed for 8 HP.  This effect is hidden until triggered.\r\n",
      "flavorText": "\"Hey, I didn't know there was a waterfall here!\" - Toby the Tad",
      "noraCost": 25,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0BF0Be9BE8DJ8IJ8Jeeiepfgvzmuvxo",
      "deckLimit": 2
    },
    {
      "id": 68,
      "name": "Cleansing Storm",
      "description": "All champions are <mechanic value=cleansed>Cleansed</mechanic> of negative conditions. Friendly champions are healed for 5 HP.",
      "flavorText": "\"Let the heavens wash it all away, and carry all the sin and anger of the land down to the eternal seas.\" Rain Prayer of Old Valdac",
      "noraCost": 40,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0BE8De9Bf1BJ8IJ8Jirfekygkuxirso",
      "deckLimit": 2
    },
    {
      "id": 235,
      "name": "Combined Arms",
      "description": "Friendly warriors gain <ability value=218>Dodge 2</ability>. Friendly Archers gain <ability value=214>Block 2</ability>. Friendly Rangers gain <ability value=2652>Opportunistic</ability> and <ability value=3266>Combat Awareness 1</ability>.",
      "flavorText": "Through cooperation, K`thir Forest grows and thrives. Through camaraderie, its protectors guard it from harm.",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0Be9Be9Be9BJ8IJ8Jeevvxirwtzxthn",
      "deckLimit": 2
    },
    {
      "id": 176,
      "name": "Combined Effort",
      "description": "Friendly champions lose all AP and you gain nora equal to 25 plus the AP lost by non-Illusion, non-Summoned champions.",
      "flavorText": "\"With the help of another, any feat is possible.\" - Menalaus, K'thir priest ",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9Be9Ae9BG2AJ8GJ8Hoqjwqhykygytqo",
      "deckLimit": 2
    },
    {
      "id": 544,
      "name": "Conclave Concordance",
      "description": "A Sun Blossom with upgrades is summoned to the closest available unoccupied location to target space. This champion comes into play with 5 AP and <ability value=655>Skirmisher</ability>. At the end of your opponent's turn, the champion is removed from play.  This spell refunds 3 nora for each friendly Fairy, to a maximum of 15.",
      "flavorText": "\"The Fae have continued to use the instability in the nora's roots. This writer remains too skeptical of the ultimate repercusions to suggest similar action.\" ~ Official report to the Circle",
      "noraCost": 45,
      "artist": "Blake Henriksen",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0BG2AG2AF0BJ8IJ8Jmsmsmytxtzxvmpf",
      "deckLimit": 2
    },
    {
      "id": 79,
      "name": "Confusion",
      "description": "Enemy spells may not be cast next turn.",
      "flavorText": "\"Move the wizards back!  The damn frogs are blocking our magic.\" - Bok Legionaire",
      "noraCost": 25,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0AE8De9BG2BJ8HJ8Ioyiwkjythrqjwo",
      "deckLimit": 2
    },
    {
      "id": 153,
      "name": "Conjure Ice Block",
      "description": "An Ice Block relic is summoned on target space, under your control (0 DEF, 20 HP). When this relic has been in play for 8 turns, it is destroyed, and the space it occupied becomes Shallow Water (non-Impeding) for the next 3 turns.",
      "flavorText": "Automatic ice-makers are a common feature of the frozen tundra.",
      "noraCost": 25,
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3Ae9Ae9BF0Bj9Dj9Eeeeeemjepjwxkpf",
      "deckLimit": 2
    },
    {
      "id": 112,
      "name": "Consecrate the Earth",
      "description": "Area Effect 3:  Friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space.  For 4 turns, affected spaces become <mechanic value=hallowed_ground>Hallowed Ground</mechanic>. For each friendly champion with Class: Paladin or Class: Priest in play, this spell is refunded 3 nora to a maximum of 15.\n",
      "flavorText": "\"Is there any way you can amplify the effects of that spell...it'd be nice not to worry about the dead any longer.\" - Rugolth, Dwarven King",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Ae9Ae9BE8Dj9Bj9Ceiyirlyzxztohpf",
      "deckLimit": 2
    },
    {
      "id": 134,
      "name": "Consume Resources",
      "description": "Nora Fonts controlled by players become uncontrolled.  You gain 5 nora for each font affected this way. For 4 turns, nora fonts may not be captured.",
      "flavorText": "\"I care not to relate the events following Meepo's nighttime gorging; only that for the rest of the trip, our diet consisted of xander root, slag berry, and strips of what could only be translated as 'Meepo jerky.'\" - Etchen, the Chronicler",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HE8De9Ae9BF0Aj9Ej9Feerqsfrqlnlymn",
      "deckLimit": 2
    },
    {
      "id": 298,
      "name": "Converging Portals",
      "description": "Area Effect 2: Champions in the affected area are all relocated to the same randomly selected nora font.",
      "flavorText": "With help from K'thiras, the Ironfist Magisters were able to develop their own techniques for teleportation. Soon, they could move several through separate portals and transport them to the same area with relative accuracy.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9Ae9Be9BG2Bj9Fj9Ghytufiygkexxqqf",
      "deckLimit": 2
    },
    {
      "id": 233,
      "name": "Corpse Collection",
      "description": "Friendly Zombie and Skeleton champions gain <ability value=1387>Assimilate</ability>, <ability value=1396>Fading Light</ability>, and <ability value=1457>Forage</ability> for 1 turn.",
      "flavorText": "\"Collect your Elsari brothers and sisters when they have fallen. Serkan has taught us that there is use in a corpse. We can take what is necessary from our fallen compatriots. You must remember this.\" - Xulos of Elsarin\r\n",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9Be9Be9Be9BJ8GJ8Heerqqukpwonsxm",
      "deckLimit": 2
    },
    {
      "id": 10,
      "name": "Corrode",
      "description": "Area Effect 3: Non-Forglar Swamp equipment in the affected area is destroyed.",
      "flavorText": "\"It is well known that all things must come to an end. We simply speed up the process.\" - Gekaal, Boghopper Shaman",
      "noraCost": 30,
      "artist": "Shayne Bingham",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0BE8De9Be9BJ8IJ8Jeerjwofxoshgem",
      "deckLimit": 2
    },
    {
      "id": 192,
      "name": "Coward's Reach",
      "description": "Target champion's MIN RNG and MAX RNG are set to 1 for 6 turns.",
      "flavorText": "\"They are afraid of us, Grimlic. They may stand and draw their weapons, but I know it's there. Terror grips their hearts. Exploit this fear, and they will wither.\" - Maxxarek, Overlord of Sheoul",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CE8De9Ae9BG2Bj9Ej9Fwinymnpwilgvkpf",
      "deckLimit": 2
    },
    {
      "id": 111,
      "name": "Crack the Earth",
      "description": "Area Effect 2: Affected spaces become impassable for 4 turns. This spell can not be cast onto terrain that is occupied by units.",
      "flavorText": "\"Do not walk where the ground looks turned. These beasts have tricked us before.\" - Faselam, Boghopper Finlord ",
      "noraCost": 25,
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1Be9Ae9BE8Dj9Aj9Btjnpusmsjlnszo",
      "deckLimit": 2
    },
    {
      "id": 449,
      "name": "Crescendo",
      "description": "Target enemy champion takes 9 Sonic damage.  The next closest enemy champion within 3 spaces takes 12 Sonic damage, and the next closest enemy champion within 3 spaces of the second champion takes 15 Sonic damage and gains Immunity - Sonic.  Each champion may only be affected once by each instance of this spell.",
      "flavorText": "Originally developed by the Cyclops of the Old Kingdom as a weapon against the Voil, the Wailing Chimes were thought destroyed after the Voil came to power.",
      "noraCost": 35,
      "artist": "Christian Fell",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8DF0Be9Be9Bj9Ej9Feeepqlwvxiiton",
      "deckLimit": 2
    },
    {
      "id": 199,
      "name": "Crowded Forces",
      "description": "Enemy champions within 4 spaces take 2 Magical damage for each real champion they have in play (maximum 14 damage).",
      "flavorText": "\"They are careless to leave so many of their forces so close together. A single arrow is all it takes. Panic would provide the rest.\" - L`ilim, Elven Archer",
      "noraCost": 45,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2Be9Ae9BG2Bj9Cj9Dhpnlyxkwtoygyrf",
      "deckLimit": 2
    },
    {
      "id": 214,
      "name": "Crush",
      "description": "For 6 turns, the next time an enemy equipment is played, that equipment is destroyed and all enemy champions within 3 spaces takes 6 Physical damage.  This effect is hidden until triggered. ",
      "flavorText": "Almir awoke in a daze. He was surprised to find bits of his mace lodged in his armor and in the Elven priestess that had died beside him. As his senses returned, he could hear a Moga cackle.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Be9Be9Be9AJ8IJ8Jusjgrfpuzoyvxo",
      "deckLimit": 2
    },
    {
      "id": 445,
      "name": "Crystal Reflection",
      "description": "For 4 turns, friendly champions with Race: Elemental gain <ability value=1603>Reflection 2</ability>. If the champion has <ability value=2373>Nora Gem</ability> or <ability value=2581>Endless Devotion</ability>, it also gains <ability value=2209>Mirrored</ability> for 4 turns.",
      "flavorText": "\"The Mastodons were enveloped in some kind of light, and our attacks seemed to harm us as much as it harmed them.\" ~ Draksar Scout",
      "noraCost": 40,
      "artist": "Christian Fell",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1BF0Be9Be9Aj9Aj9Bevxfinyrhigpnpf",
      "deckLimit": 2
    },
    {
      "id": 69,
      "name": "Crystallize",
      "description": "Target friendly champion without <ability value=597>Unstoppable</ability> is <condition value=crystallized>Crystallized</condition> for 2 turns. If the target champion has Race: Elemental, it is also healed for 8 HP.",
      "flavorText": "\"People don't leave life-like sculptures amongst the wood they were carved from. Something's wrong here.\" -- Mikkels Longhollow, IEF",
      "noraCost": 30,
      "artist": "Shayne Bingham",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1AE8De9Bf1BJ8Jj9Aevkpjlnljiwmwo",
      "deckLimit": 2
    },
    {
      "id": 539,
      "name": "Cull the Weak",
      "description": "Target champion loses 10 HP.  If this destroys the champion, a Phylactery relic is summoned in the closest friendly deployment zone.",
      "flavorText": "Sometimes, to carry back a message, the undead let a single enemy live. Sometimes, they don't -- that's the message. ",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0Bf1BG2Af1BJ8IJ8Jmjilwzrssukytqf",
      "deckLimit": 2
    },
    {
      "id": 115,
      "name": "Cultivate the Earth",
      "description": "Area Effect 3: For each vegetation space in the affected area, that space becomes dirt and you receive 1 nora. Enemy champions occupying those spaces lose 2 AP and become <condition value=burred>Burred</condition> for 4 turns.",
      "flavorText": "\"You're too young to remember, but in the days before the Catastrophe we used to have five growing seasons.\" - Verlek, Elven Bard",
      "noraCost": 25,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8De9Ae9Be9Aj9Ej9Fgytxxoukwxxoyo",
      "deckLimit": 2
    },
    {
      "id": 360,
      "name": "Cultural Contamination",
      "description": "All friendly units with <ability value=2146>Pack Leader</ability> gain <ability value=677>Overseer: Moga 2</ability> and friendly units with <ability value=677>Overseer: Moga 2</ability> gain <ability value=2146>Pack Leader</ability>. Friendly units with <ability value=679>G'hernbound</ability> gain <ability value=1938>Pack Mentality</ability> and friendly units with <ability value=1938>Pack Mentality</ability> gain <ability value=679>G'hernbound</ability>.",
      "flavorText": "As Moga began filtering into Maljara, many began to leave their overseers behind. They were found amongst Kanen packs, snarling like mongrels and marked with their war paint. ",
      "noraCost": 20,
      "artist": "Slawomir Maniak",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 4,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "eJ8JJ8IF0BF0Ae9BF0BJ8IJ8Jmsmsmegvzrlwqo",
      "deckLimit": 2
    },
    {
      "id": 368,
      "name": "Curse of the Fallen",
      "description": "Target real owned champion gains <ability value=1887>Roar of the Fallen</ability> and is destroyed. If the destroyed champion had Class: Witch or Race: Hyaenid, the closest friendly unit also gains <ability value=1457>Forage</ability> and <ability value=746>Dead Eater</ability>.",
      "flavorText": "\"Old Ruubgaal has many tricks! And you thought I spent my death in sleep. Be sure to thank the Elsari when they come to raise your corpses.\" - Ruubgaal, Rightful King of Hiistzine",
      "noraCost": 30,
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0AF0Ae9Bf1AJ8HJ8Izgyzmpjlpyiwqo",
      "deckLimit": 2
    },
    {
      "id": 128,
      "name": "Dark Pact",
      "description": "Target a champion you own. For 8 turns the next time this champion is the target of a spell, that spell is cast upon the closest enemy champion instead. Your shrine or avatar takes 5 damage when triggered. If the champion is not a valid target, the spell fizzles.  This effect is hidden until triggered.",
      "flavorText": "\"In the Underdepths, deception is a deadly weapon.\"",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0Be9Ae9Be9BJ8IJ8Jeeipllwxfkexfm",
      "deckLimit": 2
    },
    {
      "id": 11,
      "name": "Dark Rising",
      "description": "Area Effect 4: Summon 5 Risen Warriors in random locations. These units have 1 DEF, 3 SPD, 5 DMG, 4 HP, 1 RNG, <ability value=1190>Fleet</ability>, <ability value=655>Skirmisher</ability>, <ability value=653>Unstable</ability>.",
      "flavorText": "\"Let the fallen rise; the end has come for all!\" - Serkan, Lich King",
      "noraCost": 50,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 10,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1AE8De9BF0AJ8Jj9Aevxohpnnpfrjln",
      "deckLimit": 2
    },
    {
      "id": 335,
      "name": "Darkmarsh Warsong",
      "description": "Target champion with max range of 2 or less gains <ability value=1479>Vigorous Cry</ability> for 4 turns.",
      "flavorText": "\"They do not understand. To defeat our enemies, we must act with the same anger and animosity that they do. We must teach our allies the song, if we want their help.\" - Lemsu of the Darkmarsh",
      "noraCost": 30,
      "artist": "Simon Dominic",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8DF0Ae9Be9Bj9Ej9Feeemyklpuxfxmn",
      "deckLimit": 2
    },
    {
      "id": 12,
      "name": "Darkness",
      "description": "Each player's non-deployed Runes (excluding this one) become concealed. Then each player's Rune Dock is shuffled.",
      "flavorText": "K'thir Lore holds that when the Blood Moon rises, darkness shall engulf the lands.",
      "noraCost": 30,
      "artist": "Gabriel Garza",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0BE8De9BF0AJ8IJ8Jevowmsmjtmwthn",
      "deckLimit": 2
    },
    {
      "id": 520,
      "name": "Darkweave",
      "description": "For 6 turns, when enemy champions make a successful attack, they become <mechanic value=cursed>Cursed</mechanic> for 3 turns and spaces within 2 spaces of attacking champion become Dead Magic Zone (Enemy spells may not be cast in this area) for 4 turns. This effect is hidden until triggered.",
      "flavorText": "\"You cannot hope to overcome me.  Watch as even your own actions bolster my forces!\" - Xulos, Undead Sage",
      "noraCost": 20,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2BF0Be9BG2Aj9Cj9Deevhggpjtjekerf",
      "deckLimit": 2
    },
    {
      "id": 394,
      "name": "Dead Zone Voodoo",
      "description": "The next time an opposing champion moves into a Dead Magic Zone you control, it is knocked back 3 spaces, takes 10 magic damage and loses all AP. This effect is hidden until triggered.",
      "flavorText": "\"The Stitched have shown us ways to improve our greatest asset.\" - Serkan",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1AF0Ae9BG2AJ8Jj9Aeevshkgkekjgkpf",
      "deckLimit": 2
    },
    {
      "id": 196,
      "name": "Decay",
      "description": "For 6 turns, when a champion would receive healing, it loses HP equal to 50% of the healing instead.",
      "flavorText": "\"Nothing is more beautiful than the end of life. To watch it flicker and fade, before it is completely extinguished. The K`thir will see its beauty, in due time.\" - Xulos, Undead Sage",
      "noraCost": 35,
      "artist": "Ian Miller",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1Ae9Ae9BG2BJ8Jj9Aerzxowitxkjekpf",
      "deckLimit": 2
    },
    {
      "id": 53,
      "name": "Deep Freeze",
      "description": "Area Effect 3: Units take 10 Frost damage and become <condition value=frozen>Frozen 4</condition>.",
      "flavorText": "\"Jakei Battlegroups are renowned for the speed at which they can cross through the seemingly impassable river lands.\"",
      "noraCost": 40,
      "artist": "Shayne Bingham",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JE8DE8De9Bf1Aj9Ej9Fukrqwonpuzonso",
      "deckLimit": 2
    },
    {
      "id": 185,
      "name": "Defend the Roost",
      "description": "Target friendly Voil champion is relocated within 3 spaces of your Shrine or Avatar. Additionally, 2 Young Bats with 5 AP and no upgrades are summoned by your Shrine or Avatar.",
      "flavorText": "Through instinct, the Voil can immediately return to their home at the first signs of danger.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0Be9Ae9Bf1BJ8IJ8Jszmlytmjwklpuo",
      "deckLimit": 2
    },
    {
      "id": 222,
      "name": "Delay",
      "description": "For 6 turns, the first time an enemy champion enters or moves within target owned font's deployment zone, 3 Shades under your control are spawned adjacent to it. This effect is hidden until triggered.",
      "flavorText": "The wraiths tugged at Relgur's armor. He tried his best to free himself from their clutches, but his efforts were in vain.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8De9Be9Be9Aj9Ej9Fukrzgtqlpfmnepf",
      "deckLimit": 2
    },
    {
      "id": 13,
      "name": "Demolish",
      "description": "Area Effect 2: Relics in target area are destroyed.",
      "flavorText": "\"Things fall apart so much easier up here.\" - Notk, Bok Guardian",
      "noraCost": 25,
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9BE8De9BF0BJ8GJ8Hiwiwievqwvkgem",
      "deckLimit": 2
    },
    {
      "id": 170,
      "name": "Demon Call",
      "description": "All Demon champions are revealed in your rune dock.",
      "flavorText": "\"I call to the fires of Sheoul and all its inhabitants! Arise!\" - Grimlic, Mage of Sheoul",
      "noraCost": 20,
      "artist": "Trevor Claxton",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 4,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1Be9Ae9Bf1Bj9Aj9Bowmlyrwmhgthgpf",
      "deckLimit": 2
    },
    {
      "id": 490,
      "name": "Depths of Despair",
      "description": "Target champion takes 8 Magic damage. That champion takes 2 additional Magic damage each time a friendly copy of this spell is cast. This is not Cleansable.",
      "flavorText": "I have no need to cut you deep. This wound will never heal, the pain will never end. For you, there is no rest. For you, there is no peace. When you finally die, all you will hear is my name. - Curse of the Paper Skull",
      "noraCost": 20,
      "artist": "Nate Abell",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2BF0Be9Bf1Bj9Cj9Deigigvvqwiphvqf",
      "deckLimit": 2
    },
    {
      "id": 198,
      "name": "Desecration",
      "description": "Area Effect 4: Champions take 8 Disease damage and become <condition value=diseased>Diseased</condition> for 2 turns. Relics take 16 Disease damage.",
      "flavorText": "\"I can only assume that they came at night. When we awoke at dawn, our shrine was lying in shambles. Its sides were smeared with bile. It reeked of rotten flesh.\" - Thomroy, Priest of Ironfist",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2Ae9Ae9BG2Bj9Bj9Cemjrjevzrojetqf",
      "deckLimit": 2
    },
    {
      "id": 14,
      "name": "Desperate Heal",
      "description": "Each friendly champion recovers 15 HP, then your Shrine or Avatar loses 5 HP for each unit healed this way.",
      "flavorText": "\"Even if you don't like it, we must trust in the decisions of our king, or all is lost.\" - Feofil, Assistant to Rugolth",
      "noraCost": 40,
      "artist": "Shayne Bingham",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1BE8De9BE8Dj9Aj9Bjiwvkpqwqwxtxo",
      "deckLimit": 2
    },
    {
      "id": 273,
      "name": "Despoil",
      "description": "Area Effect 3: A <mechanic value=dead_magic_zone>Dead Magic Zone</mechanic> is created in the target area for 6 turns. All nora globes that drop within the affected area are automatically collected by the casting player.",
      "flavorText": "Serkan's armies had burnt K`thir, as they advanced towards the center. No matter how hard their druids tried, the wounds could not be closed; the druid spells fell dead as they were cast.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AE8De9Be9Bf1Bj9Ej9Fgyonwiymufvfepf",
      "deckLimit": 2
    },
    {
      "id": 15,
      "name": "Devolve",
      "description": "Target champion has -50% DEF, SPD, and DMG for 4 turns.",
      "flavorText": "\"What Menalaus doesn't realize is that his 'pacifistic magic,' makes it easier to do things my way.\" - Godwin, Elder Garu",
      "noraCost": 30,
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0AE8De9Be9BJ8HJ8Ievxkrzklgnlrwm",
      "deckLimit": 2
    },
    {
      "id": 91,
      "name": "Devour",
      "description": "Sacrifice target real owned champion.  Friendly champions heal for the nora cost of the sacrificed unit, dividedly evenly (rounded up).",
      "flavorText": "\"The savages are eating their own!\" - Elven Scout",
      "noraCost": 25,
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1BE8De9BG2Aj9Aj9Bmeiigrhpllneipf",
      "deckLimit": 2
    },
    {
      "id": 94,
      "name": "Disarm",
      "description": "Target equipment is returned to its owner's Rune Dock with a cooldown of 4.  ",
      "flavorText": "\"Pick up your weapons!\" -- \"Sir, we can't.\" - Draksar Troops",
      "noraCost": 25,
      "artist": "Shayne Bingham",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Be9Ae9BE8DJ8IJ8Jqjwmwfiwqlggro",
      "deckLimit": 2
    },
    {
      "id": 247,
      "name": "Disarray",
      "description": "Enemy champions are knocked back 2 spaces in a random direction.",
      "flavorText": "The treachery of the Shattered Peaks often makes quick work of those who aren't prepared. Many attacking forces have been defeated by its terrain alone.",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1Be9Be9BF0Aj9Aj9Bvkpwvkufgnlrso",
      "deckLimit": 2
    },
    {
      "id": 380,
      "name": "Disintegrate",
      "description": "Target relic is removed from play and replaced with Stitched Remains. This spell cannot be used in campaigns.",
      "flavorText": "The Stitched have many dark and mysterious rituals, many of which go unobserved. The few that have been seen share common ground with the rituals of Elsarin, Pre-Separation era.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9BF0Ae9Bf1BJ8GJ8Hwqwoftqzxqquqo",
      "deckLimit": 2
    },
    {
      "id": 293,
      "name": "Dissidence",
      "description": "For 2 turns, enemy champions may not be deployed from the rune dock in font deployment zones (this does not include Shrine deployment zones).",
      "flavorText": "\"The Kanen are a force of nature, charging recklessly to their deaths. But, a force of nature can't be controlled forever.\" - Gekaal, High One of Forglar",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2Ae9Be9BG2Aj9Bj9Ceemnlwfgknufrqf",
      "deckLimit": 2
    },
    {
      "id": 92,
      "name": "Distract",
      "description": "Area Effect 3: Units become <condition value=distracted>Distracted</condition> for 4 turns.\r\n",
      "flavorText": "\"Look! It's over there!  Quick shoot him!\"  -- \"Sir, that's a rock.\" -- \"I could have sworn I saw one..\" -- Elven Rangers",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Be9Ae9BE8DJ8GJ8Hwvmwkpsosqoukn",
      "deckLimit": 2
    },
    {
      "id": 16,
      "name": "Divine Dispersal",
      "description": "All relics and equipment are returned to its owner's runedock with 0 CD and the owner recovers Nora equal to 50% of the relic or equipment's Nora Cost.",
      "flavorText": "\"The fairest battlefield is always an empty one.\" - Rugolth, King of Ironfist",
      "noraCost": 40,
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "EXOTIC",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3AE8De9Be9Aj9Dj9Eerlgpyxmpqqjrqf",
      "deckLimit": 2
    },
    {
      "id": 377,
      "name": "Divine Reprisal",
      "description": "For 6 turns, whenever target champion is successfully attacked, the attacking champion takes equal damage of the same type. This effect is hidden until triggered.",
      "flavorText": "\"I had Al'Mara on my side. The poxxer didn't stand a chance against the two of us.\" - Garim Steelsword of the Ironfist Inquisition",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jg3AF0Ae9Bf1Aj9Dj9Eeigkgetufkeetqf",
      "deckLimit": 2
    },
    {
      "id": 387,
      "name": "Divinity's Touch",
      "description": "Target champion is removed from play and redeployed at the nearest deployment zone and becomes <condition value=awestruck>Awestruck</condition> for 3 turns.",
      "flavorText": "Even the greatest warriors kneel in the presence of the divine. Those that do not will be knelt.",
      "noraCost": 50,
      "artist": "Andrew Hou",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 10,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2BF0Ae9Bf1Bj9Cj9Dpnnsfkgpqoygtqf",
      "deckLimit": 2
    },
    {
      "id": 17,
      "name": "Domination",
      "description": "Target non-Possessed enemy champion recovers 4 AP and is <condition value=possessed>Possessed</condition> for 1 turn. Target champion also gains <ability value=1408>Chasm Walker</ability> for 2 turns.",
      "flavorText": "\"Once a mind is forced to see that we are the end, it becomes much more willing to aide us.\" - Xulos, Advisor to Serkan",
      "noraCost": 40,
      "artist": "Shayne Bingham",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "EXOTIC",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9AE8De9BF0Aj9Fj9Grqfkllnsszmuon",
      "deckLimit": 2
    },
    {
      "id": 288,
      "name": "Doom",
      "description": "Target champion without Short Lived gains <ability value=875>Short Lived 1</ability>.  This cannot be Cleansed.",
      "flavorText": "The sensation overcame Bahkar as he rushed the Blackguard. It was a dread that weakened him as he moved.  He staggered, his breathing labored.  It was crushing him from within. DOOOOOOOM!",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "EXOTIC",
      "cooldown": 9,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0Ae9Be9Bg3AJ8HJ8Ismjgiplyrqqzipf",
      "deckLimit": 2
    },
    {
      "id": 18,
      "name": "Draconic Benediction",
      "description": "For 1 turn, all friendly units gain +3 DMG, +2 SPD, and +1 DEF.  recover 2 AP and are <condition value=flying>Flying</condition> (this does not stack).  After this spell has been cast, no other spells can be cast this turn.",
      "flavorText": "\"The arrogant soft-skins of Ironfist do not realize that our curse is not without its benefits.\" - Akakios, Draksar Lord",
      "noraCost": 60,
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 12,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1BE8De9BF0Aj9Aj9Brumpnszklnuxon",
      "deckLimit": 2
    },
    {
      "id": 229,
      "name": "Draconic Pulsar",
      "description": "Area Effect 4: Target small champion at center of this spell takes 14 Fire damage and all surrounding units within 4 spaces take 14 Fire damage, decreasing by 2 for each space away from the center.",
      "flavorText": "\"It is a swift and righteous strike! Our enemies will quiver, falling before us in reverence.\" - Medril, Guardian of Valdac",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Be9Be9Be9Aj9Cj9Duhgnjwolwzmnsqf",
      "deckLimit": 2
    },
    {
      "id": 148,
      "name": "Draconic Sacrifice",
      "description": "For the next 2 turns, all damage to target champion with Race: Dragon, Skeezick or Draksar is prevented. At the beginning of your next turn, all prevented damage is dealt to your Shrine or Avatar.  This effect is hidden until triggered.\r\n",
      "flavorText": "The Dragons are masters of their art.  It seems they have harnessed the power of sacrifice.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0Be9Ae9BF0BJ8IJ8Jgygyggiplwmhnn",
      "deckLimit": 2
    },
    {
      "id": 428,
      "name": "Dragonfear",
      "description": "Target champion is <condition value=awestruck>Awestruck</condition> and <condition value=distracted>Distracted</condition> for 6 turns.  For every friendly champion with Race: Dragon, you are refunded 3 nora, to a maximum of 15.",
      "flavorText": "\"Terror is a tactic, look it up.\" - Vindrax",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2BF0Be9BE8Dj9Cj9Derlrhrhpqqhnsqf",
      "deckLimit": 2
    },
    {
      "id": 126,
      "name": "Drain the Earth",
      "description": "Area of Effect 3: Target area becomes Desecrated Ground (At beginning of your turns and upon deploying Non-Undead Champions in this area lose 6 HP) for 6 turns.",
      "flavorText": "\"The ground beneath their feet withers and dies as they advance!\"",
      "noraCost": 30,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8De9Ae9Be9Bj9Ej9Feeeithkepjwkjn",
      "deckLimit": 2
    },
    {
      "id": 531,
      "name": "Drain Vitality",
      "description": "Target champion has -6 DMG and -3 SPD for 6 turns.  Then, the closest 3 friendly champions within 5 spaces gain +2 DMG and +1 SPD for 6 turns.",
      "flavorText": "\"Take what you can, discard the rest.\"",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1BF0AG2Ag3Aj9Aj9Boqsjepsonlpsosf",
      "deckLimit": 2
    },
    {
      "id": 452,
      "name": "Drone Signal",
      "description": "Summon a Myx Broodlord to the closest available unoccupied location to target space. This champion comes into play with 5 AP and <ability value=655>Skirmisher</ability>. At the end of your opponent's turn, the champion is removed from play.  This spell refunds 3 nora for each friendly Myx, to a maximum of 15.",
      "flavorText": "\"Even after years of study, some of the fundamentals of the way Myx communicate continue to elude me.\" ~ Diary of L`ilae, Jakei Climber",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0AF0Be9Be9BJ8HJ8Ieemwmegrjnsshn",
      "deckLimit": 2
    },
    {
      "id": 60,
      "name": "Drought",
      "description": "Area Effect 5: Affected water terrain becomes dirt for 6 turns. Non-Sundered Lands champions within effected spaces take 4 Magic damage and lose all remaining AP. Champions with <ability value=114>Aquatic</ability>, <ability value=859>Semi Aquatic</ability>, or <ability value=2>Amphibious</ability> take 8 Magic damage.",
      "flavorText": "\"The first example of Nature's cruelty.\" -Varia, Draksar Broodqueen",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2AE8De9Bf1Aj9Bj9Cerzknlrlumphepf",
      "deckLimit": 2
    },
    {
      "id": 19,
      "name": "Drown",
      "description": "Destroy target small champion without <condition value=flying>Flying</condition> or <ability value=2>Amphibious</ability> occupying Water. Only one copy of this rune can be included in your battlegroup.",
      "flavorText": "Water giveth, and water taketh away.",
      "noraCost": 85,
      "artist": "Shayne Bingham",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "EXOTIC",
      "cooldown": 17,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9AE8De9BE8Dj9Fj9Grjnepwmuojnpwo",
      "deckLimit": 1
    },
    {
      "id": 20,
      "name": "Earthquake",
      "description": "Area Effect 4: All non-Flying units take 10 Physical damage and champions lose all AP.",
      "flavorText": "\"We thought we were safe once we found cover from their griffons, until the earth opened up and swallowed half of our squad whole.\" - Journal of Szen, Draksar Scout",
      "noraCost": 45,
      "artist": "Shayne Bingham",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0AE8De9BE8DJ8HJ8Iyruonwkyrqqqln",
      "deckLimit": 2
    },
    {
      "id": 412,
      "name": "Electrostaticificationized",
      "description": "Target champion takes 5 Electric damage for each real friendly champion within 5 spaces, to a maximum of 25. If the target is not destroyed by this spell, all champions within 5 spaces of the target take 10 Electric damage.",
      "flavorText": "Sometimes the hardest part of casting a spell is pronouncing it.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9BF0Ae9Bg3AJ8GJ8Hukuoyxfmnjpygpf",
      "deckLimit": 2
    },
    {
      "id": 528,
      "name": "Elemental Vortex",
      "description": "For 6 turns, target champion gains <ability value=132>Fire Aura 2</ability>, <ability value=136>Frost Aura 2</ability>, and <ability value=140>Electricity Aura 2</ability>.",
      "flavorText": "The Djinn taught the Hyaenids not to fear nature, but to access and harness it.",
      "noraCost": 40,
      "artist": "Markus Erdt",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Ae9BG2Ae9Aj9Bj9Ceruxolrzrqfpyrf",
      "deckLimit": 2
    },
    {
      "id": 453,
      "name": "Elsarin Night",
      "description": "Area Effect 4: For 6 turns, affected area becomes Elsarin Night (Friendly champions occupying this space have <ability value=1378>Evasive 3</ability>. If the champion has Race: Zombie, it also gains +1 SPD and +3 DMG.)",
      "flavorText": "\"We are the survivors of Elsarin, the minions and retainer of the mighty Serkan, we know not of discrimination, and welcome all within the dark embrace of Old Elsarin. Let its shroud take you in, and be born again in its dark power. Be you beast, burden, or tired soul, you can find home here in the Wastes.\" ~ Mercer Skye, Necromancer",
      "noraCost": 30,
      "artist": "Christian Fell",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "EXOTIC",
      "cooldown": 6,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0BF0Be9Be9BJ8IJ8Jeeekyxiwxkrjln",
      "deckLimit": 2
    },
    {
      "id": 194,
      "name": "Energy Overload",
      "description": "For the next 6 turns, your opponent's Shrine or Avatar takes damage equal to 10% of their total nora at the end of their turn.",
      "flavorText": "\"Nora is a very volatile substance, your Grace. However, I do believe I've learned how to exploit this trait to our advantage.\" - Higbin, Skeezick Alchemist",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9Be9Ae9BG2BJ8GJ8Huofxonjgvxqluo",
      "deckLimit": 2
    },
    {
      "id": 147,
      "name": "Enslave",
      "description": "You gain control of target enemy champion for 1 turn. That champion recovers full AP, and gains <ability value=757>Immobile</ability> and <ability value=942>Eternal</ability> for 1 turn.",
      "flavorText": "Why use your own men when theirs will do just fine?",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0Ae9Ae9BF0BJ8HJ8Igygytohvmufpjn",
      "deckLimit": 2
    },
    {
      "id": 330,
      "name": "Eriluun's Favor",
      "description": "Area Effect 3: Enemy champions lose 2 AP and friendly Tortuns gain 2 AP.",
      "flavorText": "\"At night, Gharivol is filled with the smell of incense. They burn it at the port, in front of the altar to Eriluun. There is a Favored there, who prays to her through the night.\" - H'aliel, priest of K'thir",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1AF0Ae9Be9AJ8Jj9Aeilrhtxxkrzrhpf",
      "deckLimit": 2
    },
    {
      "id": 98,
      "name": "Erode",
      "description": "Area Effect 3: All relics within the affected spaces are destroyed.",
      "flavorText": "\"No matter how sturdy or strong they are built, all things return to the Swamp. Remember this, young hopper.\" - Gekkit, Boghopper Shaman",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DE8DE8De9Bg3Aj9Ej9Fkuvoqhgyzmssmpf",
      "deckLimit": 2
    },
    {
      "id": 541,
      "name": "Eroding Winds",
      "description": "For 4 turns, at the start of the opponent's turn, enemy units in a shrine or font deployment zone are <condition value=eviscerated>Eviscerated</condition> for 4 turns.  If the unit is a champion, it is also knocked back 3 spaces away from your shrine or avatar.",
      "flavorText": "\"I left the desert to escape sand storms. I didn't expect them in the mountains.\" Skeezick Merchan's Diary entry nº 309",
      "noraCost": 50,
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 10,
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bg3Af1BG2AG2Aj9Dj9Eeevfieeeiwkuftf",
      "deckLimit": 2
    },
    {
      "id": 269,
      "name": "Erupt",
      "description": "Area Effect 5: 5 Relics with <ability value=1027>Lava Trap</ability> spawn randomly within the affected area. These relics are not shadowspawned.",
      "flavorText": "\"There were places, along the trail, that rumbled with anger. Every now and then, the ground would lose its temper, splitting and spewing molten earth into the sky. We lost one man, Icar Windhammer, to such a tantrum. The angry earth had taken him.\" - Thomroy, Priest of Ironfist",
      "noraCost": 50,
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1Be9Be9Bf1Aj9Aj9Bgkjnssjiwftjepf",
      "deckLimit": 2
    },
    {
      "id": 350,
      "name": "Escape Magic",
      "description": "For 6 turns, when target owned champion would be destroyed, that champion becomes stealthed and is relocated to the closest friendly deployment zone and has its HP set to 15. This effect is hidden.",
      "flavorText": "The corpse began to glow. It disappeared before Grondin's eyes. It was a trick, a new Elven spell he had never seen before. He searched the surrounding area, but somehow he knew his mark was long gone.",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0BF0Ae9BF0AJ8IJ8Jeiyiwmuftqlgnn",
      "deckLimit": 2
    },
    {
      "id": 21,
      "name": "Essence Drain",
      "description": "Target champion loses half of its current HP (loss of HP cannot be prevented).",
      "flavorText": "\"You weren't using it anyway.\" - Xulos, Apprentice of Serkan",
      "noraCost": 55,
      "artist": "Shayne Bingham",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 11,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2BE8De9Be9Bj9Cj9Devssfipsshemso",
      "deckLimit": 2
    },
    {
      "id": 58,
      "name": "Evolve",
      "description": "Area Effect 3: Affected Aquatic champions lose Aquatic, and gain +2 SPD, +3 DMG and <ability value=2>Amphibious</ability> for 5 turns.",
      "flavorText": "\"Did that fish just talk?\" - Ceyana, Deep Elf Mercenary",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1AE8De9Bf1AJ8Jj9Aemwvzxquhnlrso",
      "deckLimit": 2
    },
    {
      "id": 174,
      "name": "Execution Order",
      "description": "Area Effect 3: Friendly champions with a MAX RNG of 2 or less gain 2 AP, <ability value=6>Mobility</ability> and <ability value=684>Execute</ability> for 1 turn.",
      "flavorText": "Once the most feared order in Elsarin, this command brings a new zeal to Serkan's forces.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8De9Ae9BG2Aj9Ej9Fsmsuszzgilpygpf",
      "deckLimit": 2
    },
    {
      "id": 320,
      "name": "Exile",
      "description": "Target real owned champion gains <ability value=3080>Sleeper Agent</ability>, <ability value=2266>Wandering</ability> and <ability value=2008>Liability</ability> and the closest friendly champion within 8 spaces gain <ability value=1932>Loyalty</ability> and <ability value=3031>Imposing Aura</ability>.",
      "flavorText": "To the Bok, loyalty is necessary. When someone has shown any measure of disloyalty, they are punished. Treason is punished with banishment, a fate worse than death to the Nefari.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1AF0Ae9BE8DJ8Jj9Aerlufevssxztzo",
      "deckLimit": 2
    },
    {
      "id": 203,
      "name": "Expanded Reach",
      "description": "Friendly Boghoppers gain <ability value=2128>Merciful</ability> for one turn and gain 2 AP. This effect does not stack.",
      "flavorText": "The Boghoppers achieved a momentary peace in Forglar. During this time, the Fin Lord looked out to furthest edge of the swamp. To keep their peace, he knew they would have to go beyond it.",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9Be9Ae9Bg3AJ8GJ8Hiwinpnlgkpsfxo",
      "deckLimit": 2
    },
    {
      "id": 262,
      "name": "Extended Reach",
      "description": "All friendly champions with a minimum range of 1 have their maximum range increased by 1 until the end of turn.",
      "flavorText": "\"I know the weapon won't work. But, look how it's made. I think that one has caught on to something, Roogiid.\" - Haadrim, Military Advisor to Queen Eehiist.",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JE8De9Be9Bf1Aj9Ej9Fmsfpwolgkgtjwo",
      "deckLimit": 2
    },
    {
      "id": 414,
      "name": "Eye for an Eye",
      "description": "Target real friendly champion you own loses 8 HP and the closest opposing champion within 8 spaces loses 8 HP. Both also become <condition value=blinded>Blinded</condition>.",
      "flavorText": "\"There is no greater loss to a mortal than the loss of one's sight. And yet my subjects give theirs up willingly to smite their foes; to hear their wailing and loss.\" - Maxxarek, Lord of Sheoul",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0BF0Ae9Bg3AJ8IJ8Jwiwknygyztszoqf",
      "deckLimit": 2
    },
    {
      "id": 294,
      "name": "Fading Recollection",
      "description": "Target champion permanently loses all base and upgraded abilities that are not basic attacks. Champions with the Boss or Elite abilities are not affected. This cannot be cleansed.",
      "flavorText": "\"When the Stitched were upon us, I froze. I couldn't remember what to do next, as if my ten seasons of training had vanished. The only thing I could recall was a human girl, fading away.\" - I'ora, Elven Fury",
      "noraCost": 50,
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 10,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9Ae9Be9Bg3Aj9Fj9Ggyolemykjnexvqf",
      "deckLimit": 2
    },
    {
      "id": 351,
      "name": "Fairy Dust",
      "description": "Area Effect 3: Champions gain <ability value=2266>Wandering</ability> for 3 Turns. ",
      "flavorText": "\"When mixed with gnarlwood sap, Fairy Dust can help one to relax. However, in a more concentrated form, it can induce a state of total boredom. The subject will wander around, looking for something to do.\" - Excerpt from Elven Herbal Remedies",
      "noraCost": 35,
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1AF0Ae9BF0AJ8Jj9Aeipuknjwkpfvqo",
      "deckLimit": 2
    },
    {
      "id": 361,
      "name": "False Orders",
      "description": "The next time an opponent plays a champion from the runedock, a random champion from the battlegroup with a lower or equal nora cost is played instead. The player still spends nora equal to the cost of the original champion. This effect is hidden until triggered.",
      "flavorText": "Mirrick felt something was amiss, but he wasn't sure. The orders from \"Keeng Rugloth\" told him to stand near the \"towur\" at the \"shattured peeks\" in his \"lioncloth\" and to bring only a \"woking stik.\"",
      "noraCost": 20,
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 4,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1AF0Ae9BF0BJ8Jj9Aeeeeemnuxztquo",
      "deckLimit": 2
    },
    {
      "id": 249,
      "name": "Fan Faire",
      "description": "Target champion gains <ability value=1336>Fascinate</ability>. When this spell is cast, allies within 4 spaces of target champion gain <ability value=1129>Ally: K'thir Forest</ability>.",
      "flavorText": "\"We must take time to admire those that admire us. They are the spirit, which fuels us to fight. Without them, our blades swing in vain.\" - Menalaus, Priest of K`thir",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LIMITED",
      "cooldown": 9,
      "runeSet": "Rise of Serkan",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1AE8De9BG2BJ8Jj9Aevosmjgeileeipf",
      "deckLimit": 2
    },
    {
      "id": 542,
      "name": "Fast Friends",
      "description": "Target friendly champion and the closest friendly champion within 5 spaces gain <ability value=3267>Friends for Life</ability> (This champion has +2 DEF, <ability value=116>Regeneration 2</ability> and <ability value=1214>Encouraged</ability> as long as it within 5 spaces of at least one friendly champion with this ability).",
      "flavorText": "In the Tundra, everything endures, no matter how small -- a bundle of fur, or a budding friendship.",
      "noraCost": 30,
      "artist": "Maciej Janaszek",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1Bf1BG2AG2Bj9Aj9Bqukusxzithtxqsf",
      "deckLimit": 2
    },
    {
      "id": 309,
      "name": "Favor of the Queen",
      "description": "Target friendly champion gains <ability value=867>Blessed</ability> and opposing champions within 2 spaces of target champion become <condition value=awestruck>Awestruck</condition> for 3 turns. If the target is Race: Jakei, it also gains <ability value=1932>Loyalty</ability>.",
      "flavorText": "\"I didn't build J'thir by myself. It was my people who worked to build the walls of this city. They are the life of my kingdom. I owe them my gratitude. It's the least I can do.\" - J'orea, Frostqueen of J'thir",
      "noraCost": 30,
      "artist": "Michele Chang",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1Ae9Be9Bg3AJ8Jj9Aeeeirjgvxzxzrqf",
      "deckLimit": 2
    },
    {
      "id": 57,
      "name": "Feeding Frenzy",
      "description": "Area Effect 3: Feeding frenzy correctly summons 5 Frenzied Pirahnas to random locations.  These units have 3 SPD, 6 DMG, 1 RNG, 4 HP, <ability value=114>Aquatic</ability>, <ability value=655>Skirmisher</ability> and <ability value=814>Unequippable</ability> and come into play with 5 AP.",
      "flavorText": "\"This conflict over Nora is like a school of swamp-chomps fighting over fresh meat. Mindless, fruitless, and purely destructive.\" Gekaal, Forglar High One",
      "noraCost": 50,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 10,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0BE8De9Bf1AJ8IJ8Jusxkwiwxmnlyon",
      "deckLimit": 2
    },
    {
      "id": 317,
      "name": "Ferocity of Kain Taris",
      "description": "Whenever target champion's health falls below 1 it is <mechanic value=cleansed>Cleansed</mechanic>, it's current health is set to 1, and gains Invulnerable, Impenetrable, and <ability value=738>Shielded</ability> for 1 turn. This effect does not stack and is hidden until triggered.",
      "flavorText": "\"When you follow Kain Taris, you carry a fire that will never die. His will can feed you and restore your body!\" - Sermon of Kiergana",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9BF0Ae9BE8DJ8GJ8Hkymsqwzgtzxmnn",
      "deckLimit": 2
    },
    {
      "id": 22,
      "name": "Festering Wounds",
      "description": "Damaged enemy champions become <condition value=diseased>Diseased</condition> and <condition value=inhibited>Inhibited</condition> for 4 turns.",
      "flavorText": "\"The sight of blood is so much more satisfying when accompanied with a twinge of mortified flesh.\" - Xulos, Apprentice to Serkan",
      "noraCost": 45,
      "artist": "Shayne Bingham",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IE8DE8De9BF0Bj9Ej9Foqoqofklnyouon",
      "deckLimit": 2
    },
    {
      "id": 455,
      "name": "Fiery Ambush",
      "description": "At the beginning of next turn, all spaces of the font deployment zone become a Fire Wall (Whenever an enemy champion enters this space, it takes 5 Fire damage and becomes Charred 4) for 1 turn.",
      "flavorText": "\"The only thing better than burning someone is watching them burn themselves.\" ~ Goblin Arsonist",
      "noraCost": 35,
      "artist": "Christian Fell",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1BF0Be9Be9Bj9Aj9Beerhnuhrlnuqso",
      "deckLimit": 2
    },
    {
      "id": 218,
      "name": "Fight in Formation",
      "description": "Area Effect 2: Draksar gain <ability value=1987>Hold the Line</ability> and <ability value=1379>Blood Bond 1</ability> for 6 turns. If they have Hold the Line, they gain <ability value=1481>Shield Allies</ability> instead. While under the effect of Fight In Formation, the cooldown of Hold the Line is reset whenever an enemy champion dies.",
      "flavorText": "The Draksar are taught, from an early age, to fight together. A soldier that strays from his unit is severely punished. No Draksar is exempt from this.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1Be9Be9BE8Dj9Aj9Bgkekjwinyvzrfpf",
      "deckLimit": 2
    },
    {
      "id": 143,
      "name": "Fire Blast",
      "description": "Area Effect 2: Units in the affected area take 11 Fire damage.  Champions successfully damaged become <condition value=charred>Charred</condition> for 2 turns.",
      "flavorText": "\"Fire was meant to burn things, especially elves, it is our greatest ally!\" - Maxxarek of Sheoul",
      "noraCost": 40,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hg3Ae9Ae9BF0Aj9Dj9Eeiyzxxzmwfiygpf",
      "deckLimit": 2
    },
    {
      "id": 393,
      "name": "Fire for Effect",
      "description": "Friendly champions with Class: Archer gain 1 AP and permanently gain <ability value=1883>Burn 2</ability>.",
      "flavorText": "Archers forward! Light up the skies!",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0BF0Ae9BG2AJ8IJ8Jqoluhtxkusxigpf",
      "deckLimit": 2
    },
    {
      "id": 548,
      "name": "Fireblaze",
      "description": "Area Effect 3: Units within the affected area take 14 Fire damage.  Units successfully damaged become <condition value=charred>Charred</condition> for 3 turns. ",
      "flavorText": "\"It would seem that the beasts still can use Valdac magic.\" - Feofil, Assistant to Rugolth",
      "noraCost": 55,
      "artist": "Dan Kopycienski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "LIMITED",
      "cooldown": 11,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9BG2BG2AG2BJ8GJ8Hqwvsheggnygtxqf",
      "deckLimit": 2
    },
    {
      "id": 23,
      "name": "Firestorm",
      "description": "Area Effect 3: Units within the affected area take 14 Fire damage.  Units successfully damaged become <condition value=charred>Charred</condition> for 3 turns. ",
      "flavorText": "\"It would seem that the beasts still can use Valdac magic.\" - Feofil, Assistant to Rugolth",
      "noraCost": 55,
      "artist": "Dan Kopycienski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 11,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9AE8De9BF0Bj9Fj9Gsmsmwtofilroso",
      "deckLimit": 2
    },
    {
      "id": 255,
      "name": "Flash Freeze",
      "description": "Target champion becomes <condition value=crystallized>Crystallized</condition> for 2 turns and if it is an enemy champion, it also becomes <condition value=frozen>Frozen</condition> for 6 turns.",
      "flavorText": "\"We've slowed their advances to a halt. Our shardmasters made quick work of their Fiends. The rest were left at the pass, frozen to death.\" - Juya Whiteeyes",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0Ae9Be9BF0BJ8HJ8Iukukgggkwojlln",
      "deckLimit": 2
    },
    {
      "id": 272,
      "name": "Flood",
      "description": "Area Effect 3: Affected area becomes Shallow Water for 5 turns.  At the end of your turns, all champions without <ability value=2>Amphibious</ability> or <condition value=flying>Flying</condition> are knocked back 2 squares from the center square and take 2 Physical damage and the affected area grows by 1 square. ",
      "flavorText": "\"The Tidemaster uses the water to protect Forglar. He can raise a river into a tidal wave, crushing enemies in its path. He can draw water up from the earth and make it into his weapon. His power is respected for good reason.\" - Gekaal, Forglar High One",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jg3Ae9Be9Bf1Aj9Dj9Eemwquonsouoyrqf",
      "deckLimit": 2
    },
    {
      "id": 303,
      "name": "Focused Nexus",
      "description": "Area Effect 3: Friendly champions with Soul of Ailur in target area gain <ability value=2075>Pride of Ailur</ability> for 4 turns. Friendly champions with Pride of Ailur gain <ability value=2299>Soul of Ailur</ability> for 4 turns.",
      "flavorText": "\"Stand beside me. Know that your pain is mine. The Kanen is a threat on our kingdom, but we can overcome them. Stand with me and the Kanen will fall.\" ? Mosharn the Barricade at the first Siege on Ailur\r\n",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1Be9Be9BG2Bj9Aj9Bxvqjytumpwqfrqf",
      "deckLimit": 2
    },
    {
      "id": 329,
      "name": "Fog of Ancients",
      "description": "Area Effect 3: Affected spaces become Fog Cloud for 5 turns (At the end of your turns, champions in the affected area become <condition value=stealthed>Stealthed</condition> for 6 turns).",
      "flavorText": "Menalaus raised his lantern to the fog. In the distance, he saw a shape moving towards him. He didn't call to it, but took it by the tunic as it stumbled past him. He guided the lost elf back to K'thiras.",
      "noraCost": 25,
      "artist": "Simon Dominic",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0BF0Ae9Be9AJ8IJ8Jmwfvszolrqhtzo",
      "deckLimit": 2
    },
    {
      "id": 180,
      "name": "Font Eruption",
      "description": "Each enemy champion in a font or shrine deployment zone takes 12 magical damage. Enemy relics in that area take 6 magical damage.",
      "flavorText": "\"The Nora helps those that use it for a good cause. With our help, it can harm those that abuse its powers.\" - Malmog, Boghopper Shaman",
      "noraCost": 45,
      "artist": "Helen Zhu",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1Be9Ae9BG2Aj9Aj9Bkpytxoygvmsfkpf",
      "deckLimit": 2
    },
    {
      "id": 463,
      "name": "For the Empire",
      "description": "Area Effect 3: Friendly Voil gain 2 AP and <ability value=1063>Kill Frenzy</ability> for 4 turns.",
      "flavorText": "\"Mission accomplished, send a courier to Klub immediately.  Let them know we shall rendezvous with them at Shale Summit at the scheduled time.\" ~ Lance Admiral Sceian",
      "noraCost": 40,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9AF0Be9BF0Bj9Fj9Geeeeeruvmufgepf",
      "deckLimit": 2
    },
    {
      "id": 220,
      "name": "Forced Evolution",
      "description": "Target champion is fully healed and gains <ability value=114>Aquatic</ability> permanently.",
      "flavorText": "\"The change will not be subtle. It will be a quick and painful warping of the form. But, when it's over, you will be better.\" - Kierkadin, Firk Botanist",
      "noraCost": 55,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "EXOTIC",
      "cooldown": 11,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Be9Be9BE8Dj9Cj9Dxkgigetufmsmnpf",
      "deckLimit": 2
    },
    {
      "id": 473,
      "name": "Forced Reconstruction",
      "description": "Sacrifice target owned real champion. A Misshapen Boghopper with <ability value=942>Eternal</ability> and <ability value=113>Initiative 1</ability> is summoned in its place. The unit is spawned with 1% of its MAX HP for each point of nora the sacrificed champion costs.",
      "flavorText": "\"I wonder what that goo tastes like.\" ~ Boghopper Kreb's last words",
      "noraCost": 35,
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9AF0Be9Bf1Aj9Fj9Gemnllgiwkggeipf",
      "deckLimit": 2
    },
    {
      "id": 318,
      "name": "Forced Transfusion",
      "description": "Target champion gains <ability value=3035>Terminus</ability> for 1 turn and enemy champions within 5 spaces lose 2 AP.",
      "flavorText": "\"The transfusion of power between caster and subject can be dangerous. The caster may lose vital energies during transfer, resulting in the violent death of both parties.\" - excerpt from Life Magicks",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0AF0Ae9BE8DJ8HJ8Izgphnpsxtuhgro",
      "deckLimit": 2
    },
    {
      "id": 50,
      "name": "Fortify",
      "description": "Target Shrine, Relic, or Construct you control gains 25 HP. This effect does not stack.",
      "flavorText": "The engineers in Ironfist have perfected defenses to keep the Draksar filth from their doorstep.",
      "noraCost": 40,
      "artist": "Kelly Hamilton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3AE8De9BF0Bj9Dj9Eeeeeeigkpqsxipf",
      "deckLimit": 2
    },
    {
      "id": 274,
      "name": "Foul Rite",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> all undead you own.  Friendly Humans get +2 DMG and +5 HP for each non illusion unit destroyed this way. Summoned Undead units destroyed give +1 DMG and +2 HP instead.",
      "flavorText": "\"This war is not won with corpses alone! Serkan has mortal beings, sturdy and tenacious. And we would serve him better. We must not remain neglected. We are his mightiest legion, we living servants!\" - Tachrim, Dark Apprentice",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9Ae9Be9Bf1Bj9Fj9Gplumshnwtxzzipf",
      "deckLimit": 2
    },
    {
      "id": 404,
      "name": "Freeze in Place",
      "description": "Area Effect 4: Enemy champions gain <ability value=757>Immobile</ability> for 2 turns.",
      "flavorText": "\"Gahh! Listen me! Clud stuck, can't move, need move can't move-aghh!\" ",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0BF0Ae9BG2BJ8IJ8Jkyrlrowkjpqfkpf",
      "deckLimit": 2
    },
    {
      "id": 131,
      "name": "Freeze the Earth",
      "description": "Area Effect 2: Affected spaces become Ice for 4 turns",
      "flavorText": "\"We must bring the Tundra to our enemies\"",
      "noraCost": 20,
      "artist": "Gabriel Garza",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0Ae9Ae9Be9BJ8HJ8Ieruhvzosshymym",
      "deckLimit": 2
    },
    {
      "id": 442,
      "name": "Frigid Barrier",
      "description": "Enemy units within target font deployment zone take 12 Frost Damage and unoccupied spaces adjacent to the deployment zone become Crystal (This space is inaccessible) for 2 turns.",
      "flavorText": "\"I don't care how you manage it, just delay them a little while longer!\" ~ J'orea the Frost Queen",
      "noraCost": 40,
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0AF0Be9Be9AJ8HJ8Ieigklrshipsuxo",
      "deckLimit": 2
    },
    {
      "id": 54,
      "name": "Frostbite",
      "description": "All enemy units become <condition value=frozen>Frozen</condition> and <condition value=chilled>Chilled</condition> for 3 turns.",
      "flavorText": "\"Think warm thoughts, think warm thoughts, think warm thoughts... join the army, they said....\"",
      "noraCost": 40,
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9AE8De9Bf1Aj9Fj9Grjwklnlnsxkjwo",
      "deckLimit": 2
    },
    {
      "id": 533,
      "name": "Frostfall Heritage",
      "description": "Destroy target relic and summon an Ice Dragon Statue relic with 20 HP, <ability value=3236>Arctic Bolt</ability> and <ability value=2458>Instability</ability>. If the relic was friendly, you are refunded 10 nora.",
      "flavorText": "As Xulos's excavations pushed deeper into the old Frostfall lands, a movement formed within the Jakei to preserve their ancient lands.",
      "noraCost": 40,
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Af1AG2Ae9Aj9Bj9Ceiphpsumwmuxkrf",
      "deckLimit": 2
    },
    {
      "id": 90,
      "name": "Frostguard",
      "description": "Area Effect 3: 3 Snow Trap relics are summoned randomly within the affected area (Proximity Mine - This relic has Shadowspawn. When an enemy unit moves within 2 spaces of the trap, all opposing champions within range take 8 frost damage and become Frozen 3. This damage ignores DEF. All effected spaces become Deep Snow for 3 turns).",
      "flavorText": "\"Your undead minions will fall, as all who tried before you, to the cold, to the tundra, to the Jakei!\" -- J'orea shouting from atop her citadel before the siege of the capital",
      "noraCost": 40,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9AE8De9BG2Aj9Fj9Goyojtojthtxxipf",
      "deckLimit": 2
    },
    {
      "id": 264,
      "name": "Fuel",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> target Treefolk champion you own.  All friendly Devotees of the De'lim get +2 DMG and you recover nora equal to 50% of the Treefolk's cost.",
      "flavorText": "\"Murderers? Ha! A thousand lives will be spared by the sacrifice of a single Gnarlwood. We do what is needed. If we are exiled for it, then so be it!\" - N`elim, Outcast",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9Be9Be9Bf1AJ8GJ8Hqwmythegerwkln",
      "deckLimit": 2
    },
    {
      "id": 165,
      "name": "Gale Force",
      "description": "Area Effect 2: Champions within the affected area take 5 Frost damage and are knocked back 3 spaces if damaged.",
      "flavorText": "\"The wind seems to have...picked up a bit.\" - Drynar, Deep Elf Scout",
      "noraCost": 50,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 10,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1Be9Ae9Bf1Aj9Aj9Btjiruqshkjilyo",
      "deckLimit": 2
    },
    {
      "id": 97,
      "name": "Gathering at Dawn",
      "description": "Area Effect 4: 4 Tiny Insects with <ability value=812>Devourable</ability> are summoned within the affected area.",
      "flavorText": "\"Ring the morning bell...it is time for the young shaman to eat.\" - Flean, Boghopper Sage",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cg3AE8De9BG2Bj9Dj9Eerhrqllnnnleerf",
      "deckLimit": 2
    },
    {
      "id": 125,
      "name": "Ghostly Visage",
      "description": "Target champion gains incorporeal for the next 4 turns.  For every champion with Race: Spirit in play, you are refunded 2 nora, to a maximum of 10.",
      "flavorText": "\"They cannot harm that which they cannot touch.\"",
      "noraCost": 35,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3Ae9Ae9Be9Aj9Dj9Eeitoluxxqwqluqf",
      "deckLimit": 2
    },
    {
      "id": 477,
      "name": "Glimpse into Utterdark",
      "description": "Area Effect 3: Friendly non-Avatar champions with Soul Channeling or Soul Tap gain <ability value=3395>Soul Feast</ability> for 6 turns. If the champion has Dark Awakening or Rift Bound, they gain <ability value=3247>Rift Nova</ability> for 6 turns.",
      "flavorText": "Sometimes, there is no light at the end of the tunnel, only more darkness.",
      "noraCost": 35,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1AF0Be9Bf1AJ8Jj9Aeeigilwquhykepf",
      "deckLimit": 2
    },
    {
      "id": 395,
      "name": "Glimpse of Death",
      "description": "For 10 turns, at the beginning of each turn, target champion has its max HP reduced by 20% (rounded up). If this effect leaves play before the champion is destroyed, you gain 20 nora.",
      "flavorText": "Sometimes death takes a long hard look at you, and you dare not blink.",
      "noraCost": 45,
      "artist": "Alex Fang",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "LIMITED",
      "cooldown": 9,
      "runeSet": "Spirits Beyond",
      "forSale": false,
      "allowRanked": true,
      "tradeable": false,
      "hash": "ej9Cj9Bf1BF0Ae9BG2Aj9Aj9Bgpnsmjpjtofgpqf",
      "deckLimit": 2
    },
    {
      "id": 178,
      "name": "Glorious Charge",
      "description": "Friendly champions gain <ability value=6>Mobility</ability> and <ability value=396>Charge 3</ability> for 1 turn.",
      "flavorText": "\"Few expect to see a dwarf charge a position, let alone an entire detachment. And that's the beauty of it.\" - Feofil, Advisor to King Rugolth",
      "noraCost": 30,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0Be9Ae9BG2AJ8IJ8Jsmeepymjygykyo",
      "deckLimit": 2
    },
    {
      "id": 547,
      "name": "Goblin Bomb",
      "description": "Destroy target Goblin you own. Enemy champions within 5 spaces takes 12 Fire damage.",
      "flavorText": "Goblins are hardly selfless, but they do love a spectacle. ",
      "noraCost": 20,
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 4,
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2BG2AG2AF0Bj9Cj9Dkukussmwfthiirf",
      "deckLimit": 2
    },
    {
      "id": 315,
      "name": "Goresplosion",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> target champion you own.  All champions within 3 squares are Scoured 3, lose all charges, and take 12 physical damage.",
      "flavorText": "\"If a Stitched is alone, you get the Sheoul away from him. They never travel alone, unless they're looking to pop.\" - Rondel Redarm of the IMEF",
      "noraCost": 30,
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EE8DF0Ae9BE8Dj9Ej9Fiwvzkrukgiepyo",
      "deckLimit": 2
    },
    {
      "id": 408,
      "name": "Gravity Flux",
      "description": "All champions within 5 spaces of target champion are relocated 2 spaces closer to it.\r\n",
      "flavorText": "\"C'mere you walkin' trash heaps! I want to show you my new warhammer!\" - Talgar Ironfist",
      "noraCost": 35,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2BF0Ae9BG2Bj9Cj9Dfknjgkpqqusmhrf",
      "deckLimit": 2
    },
    {
      "id": 489,
      "name": "Grim Harvest",
      "description": "Area Effect 3: For each Nora Globe in the affected area (to maximum of 6), you gain 2 Nora and opposing champions take 2 Magical damage.\r\n",
      "flavorText": "\"Those nora globes are filled with dark things, I warn you not to touch them!\" - Northern Cross Soldier",
      "noraCost": 30,
      "artist": "Alex Konstad",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2AF0Be9Bf1Bj9Bj9Ceeruvfeevohgrqf",
      "deckLimit": 2
    },
    {
      "id": 87,
      "name": "Grimlic's Bane",
      "description": "Target champion and each identical champion with the same controller (including illusions) takes 15 Magical damage.",
      "flavorText": "\"As light does die at evenings wake, did Grimlic's shadows fade away.\" - Song of the Shadows",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bg3AE8De9BG2Aj9Dj9Eeemsjpyoheiyvqf",
      "deckLimit": 2
    },
    {
      "id": 24,
      "name": "Grimlic's Mirror",
      "description": "Create a copy of target non-Hero non-Titan friendly champion with cost of 99 nora or less. This copy appears in the closest location in your nearest deployment zone.",
      "flavorText": "Grimlic and his mirror were the perfect couple - they both worshipped Grimlic.",
      "noraCost": 80,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "EXOTIC",
      "cooldown": 16,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9AE8De9Be9Bj9Fj9Geitoykllpuqfkn",
      "deckLimit": 2
    },
    {
      "id": 145,
      "name": "Grimlic's Treachery",
      "description": "All non-demons take 2 Fire damage for each Demon Elf in play. Elves take 4 additional damage. Your Shrine or Avatar takes 5 damage for each champion killed as a result of this spell.",
      "flavorText": "\"It's as if they know how to defeat us!  There is a traitor among us!\" - Elven Ranger",
      "noraCost": 45,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9Ae9Ae9BF0Bj9Fj9Gukukgyvojnumuo",
      "deckLimit": 2
    },
    {
      "id": 417,
      "name": "Grintmaw Hymn",
      "description": "The next 25 damage dealt to friendly champions are prevented. For each friendly champion with Race: Troll, the damage prevented is increased by 3.",
      "flavorText": "The songs of the Grintmaw speak of a time forgotten by most, but for the Grintmaw, they are forever written in stone.",
      "noraCost": 40,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2AF0Ae9Bg3Aj9Bj9Ceeemevoushplgrf",
      "deckLimit": 2
    },
    {
      "id": 337,
      "name": "Groble Bombardment",
      "description": "Area Effect 2:  A Groble with 25% HP is summoned at target location.  If there is a champion on the targeted space, that unit takes 12 physical damage and is knocked back 1 square prior to the deployment of the Groble.  All other champions in the affected area take 8 physical damage. ",
      "flavorText": "\"Have you ever thought about slingin' them? They seem sturdy enough.\" -  Hyron Redtail, credited inventor of the Groble Bombardment",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9BF0Ae9Be9BJ8GJ8Heevfiygeemumym",
      "deckLimit": 2
    },
    {
      "id": 343,
      "name": "Groble Strike Force",
      "description": "Summons a Groble Rock Eater, Groble Piledriver, and a Groble with no upgrades and half HP to the nearest friendly deployment zone.",
      "flavorText": "\"If we're going to keep up with those Kanen, we're going to need more Grobles! More Grobles! More!\" - Limarn, Construct Forger",
      "noraCost": 80,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 16,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2BF0Ae9Be9Bj9Cj9Deitojyouhgkgyo",
      "deckLimit": 2
    },
    {
      "id": 25,
      "name": "Hammer Strike",
      "description": "Target champion takes 10 Physical damage. If the target takes damage, that champion loses all AP and becomes <condition value=stunned>Stunned</condition> for 2 turns.",
      "flavorText": "Despite the awkward balance and shape of their hammers, Dwarves always seem to be able to hit their targets.",
      "noraCost": 45,
      "artist": "Shayne Bingham",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0BE8De9BE8DJ8IJ8Jusmwknjwvsjipn",
      "deckLimit": 2
    },
    {
      "id": 26,
      "name": "Hatching Season",
      "description": "Area Effect 4: 5 Dragon Egg relics with 0 DEF and 1 HP are summoned randomly within the affected area. At the start of your turns, one of these relics is removed from play, and in its place a Dragon Hatchling champion under your control is summoned.",
      "flavorText": "It's a surprise they survive at all.",
      "noraCost": 45,
      "artist": "Kelly Hamilton",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2BE8De9BF0Aj9Cj9Dmsshkrhnnnhiwo",
      "deckLimit": 2
    },
    {
      "id": 61,
      "name": "Haunt",
      "description": "Target relic gains <ability value=757>Immobile</ability> and <ability value=2260>Pariah</ability>. Spaces within 4 spaces of it becomes Dead Magic Zone for 5 turns. When this effect ends, 3x Shades with 0 nora cost and no upgrades are summoned in the affected area, and the relic is destroyed.",
      "flavorText": "\"Ghosts are greedier in death than they ever were in life. Best not to tamper with what they claim.\" Menalaus, Priest of K'thir",
      "noraCost": 30,
      "artist": "Michael Dutton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2BE8De9Bf1Aj9Cj9Duzzgpwvzmnuzipf",
      "deckLimit": 2
    },
    {
      "id": 352,
      "name": "Haunting Grip",
      "description": "Summon a Haunting Spirit with no upgrades and <ability value=876>Short Lived 1</ability> adjacent to target champion.  When this Haunting Spirit is summoned, it gains 3 AP and automatically attempts to use <ability value=1403>Latch On</ability> on the target champion.",
      "flavorText": "K'ulon fled and the apparition followed. No matter where he ran or how hard he sprinted, it was always behind him. Scouts would find K'ulon in a clearing, his face still wracked with fear.",
      "noraCost": 40,
      "artist": "Slawomir Maniak",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1BF0Ae9BF0Aj9Aj9Bmegpygrzzmhpuo",
      "deckLimit": 2
    },
    {
      "id": 411,
      "name": "Havoc's Touch",
      "description": "Target champion has +3 DMG and gains Essence Capture (When this champion deals damage to a champion on an attack, you gain nora equal to 30% of the damage dealt).  If the champion has a MAX RNG of 2 or less, it gains an additional +2 DMG. If the target is Race: Hyaenid, it gains 2 AP. This effect does not stack.",
      "flavorText": "\"Their magic is more than bizarre. I've yet to be able to understand how it works. It's as if they just at whim decide to make the magic do whatever they want regardless of the laws of magic's nature.\" - Smiizkiine, Voil Sorcer",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9AF0Ae9Bg3Aj9Fj9Gqoumleiruszzxqf",
      "deckLimit": 2
    },
    {
      "id": 305,
      "name": "Healing Hand",
      "description": "For 6 turns, the next time this unit's HP would fall to 5 or less, this unit is healed to 50% of its max HP. If the target is Race: Leoss, when the effect activates, all spaces within 5 spaces of the champion become unimpeding jungle for 6 turns. If the target is Race: Leoss and was already on Vegetation when the effect triggers, it also gains <ability value=3295>Healing Mind</ability>. This effect is hidden until triggered.",
      "flavorText": "\"The elf made a full recovery. The Priest's power was unbelievable; even Priestess Megin commented on his skill. Considering their predicament, these Leoss are truly amazing creatures.\" -Shardseer K'aeyun\r\n",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2Be9Be9BG2Bj9Cj9Dgnykegyiggkjerf",
      "deckLimit": 2
    },
    {
      "id": 100,
      "name": "Hellfire",
      "description": "Area of Effect 5: Target champion is dealt 10 Fire damage. All other units within the affected area are dealt 5 Fire damage.  Units successfully damaged become Charred 3.",
      "flavorText": "\"The demons were here. Look, you can see the scorch marks on the melted sand...\" -- \"I found Sen's pack- I don't think we're going to find them alive\" - Elven search party",
      "noraCost": 35,
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9BE8De9Bg3AJ8GJ8Hygymluzouhigvo",
      "deckLimit": 2
    },
    {
      "id": 114,
      "name": "Herbal Antidote",
      "description": "Area Effect 3: Affected champions are Cleansed, heal for 4 and have Immunity: Poison and Immunity: Disease for 4 turns.",
      "flavorText": "\"Here, drink this...\"",
      "noraCost": 40,
      "artist": "Layne Johnson",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3Ae9Ae9BE8Dj9Dj9Eerqftufmexojpqf",
      "deckLimit": 2
    },
    {
      "id": 532,
      "name": "Holy Light",
      "description": "Destroy target relic and all champions within 3 spaces of takes 10 Magical damage. Enemy champions damaged this way become Awestruck for 2 turns. If the relic was friendly, you are refunded 10 nora.",
      "flavorText": "\"Hold those burial sites as long as you can! When we fall back, give them a final consecration.\"",
      "noraCost": 40,
      "artist": "Danh Nguyen",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Bf1AG2Ae9Aj9Aj9Bpjykufkwojnsfrf",
      "deckLimit": 2
    },
    {
      "id": 465,
      "name": "Honest Mistake",
      "description": "Target opposing champion without Iron Will becomes possessed and makes a free basic attack against the closest opposing champion within its range, after making the attack the champion is no longer possessed and becomes <condition value=scolded>Scolded</condition> for 2 turns.",
      "flavorText": "\"It wasn't me.\"",
      "noraCost": 25,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0AF0Be9BF0BJ8HJ8Ieeeeemekuzrzon",
      "deckLimit": 2
    },
    {
      "id": 390,
      "name": "Horrific Mutation",
      "description": "Target champion permanently gains Race: Dragon, <ability value=1>Flight</ability>, <ability value=299>Horrific Aura</ability>, +1 DMG, +1 DEF, and +1 SPD.",
      "flavorText": "\"I will take that wretched husk you call a body and turn it into something wonderous. Hold still.\" Xivvix, Draksar Morph",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9AF0Ae9BG2Aj9Fj9Gmjpwxfxqlymyoqf",
      "deckLimit": 2
    },
    {
      "id": 206,
      "name": "Howling Wind",
      "description": "Target champion takes 10 sonic damage and becomes <condition value=frozen>Frozen 2</condition>. Enemy champions within 2 spaces of the target are knocked back 1 space and also become Frozen 2. If any affected champions are already Frozen, they become <condition value=slowed>Slowed 2</condition> instead.",
      "flavorText": "The winds of the tundra ravage the unprepared with terrible howls and an intolerable chill. They often leave their victims dazed and shivering.",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1Ae9Ae9Bg3AJ8Jj9Aeeevfmwtollyoqf",
      "deckLimit": 2
    },
    {
      "id": 213,
      "name": "Humble",
      "description": "Area of Effect 3: Enemy champions become <condition value=distracted>Distracted</condition> for 4 turns. For each affected enemy with a nora cost less than 80, you are refunded 5 nora (to a maximum of 15).",
      "flavorText": "\"If you hope to survive the tundra, you'd best leave arrogance behind. The tundra makes quick work of fools.\" - J`eani, Jakei Icefisher",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Be9Be9BE8DJ8GJ8Hqwmjyiwvsusqln",
      "deckLimit": 2
    },
    {
      "id": 149,
      "name": "Hungry Dead",
      "description": "Area Effect 2: For the next 4 turns skeletal hands reach from their graves and grab all enemy champions in the area, causing 4 Physical damage, as well as an additional 4 Physical damage each turn. This counts as spell damage. Units affected by the hands become <condition value=ensnared>Ensnared</condition> for 1 turn. \r\n",
      "flavorText": "The truth is, the dead despise the living as much as the living despise the dead. Even when a body is stripped of undeath, they can be called upon to perform the occasional task.",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1Ae9Ae9BF0BJ8Jj9Aeeeeeitjevfvqo",
      "deckLimit": 2
    },
    {
      "id": 27,
      "name": "Hungry Mire",
      "description": "Area Effect 2: For the next 6 turns, all spaces become Dirt and Shallow Water. When a non-Flying champion enters one of these spaces, it takes 5 Physical damage and becomes Ensnared 2.",
      "flavorText": "Forglar mud is renowned for its ability to defend against intruders.",
      "noraCost": 35,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8DE8De9Be9Bj9Ej9Feeegggvvmytohn",
      "deckLimit": 2
    },
    {
      "id": 271,
      "name": "Huntmaster's Charm",
      "description": "When this spell is cast on a Boghopper Huntmaster, a Pygmy Hippo without upgrades is summoned adjacent to the unit. When this spell is cast on a Pygmy Hippo, it gains +1 SPD, +2 DMG and +20 MAX HP. When this spell is cast on any other champion, that unit gains +1 DMG and +5 MAX HP. These effects do not stack.",
      "flavorText": "Wild Pygmy Hippos are dangerous predators, capable of taking down large prey with very little struggle. They are also incredibly agile and are known to strike weak points with great accuracy. It takes a special charm to tame a Pygmy Hippo.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2Be9Be9Bf1Aj9Cj9Dxknhkpygrjgempf",
      "deckLimit": 2
    },
    {
      "id": 234,
      "name": "Hurry",
      "description": "The cooldown on all of your runes are reduced by 2.\n",
      "flavorText": "\"If we ever hope to continue defending our home, we need to rethink our strategies. We need soldiers deployed quickly; each one ready to fight immediately. Otherwise, we are at the mercy of more efficient enemies.\" - S`etra, Elite Ranger",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0Ae9Be9Be9BJ8HJ8Iemsfeetziyohem",
      "deckLimit": 2
    },
    {
      "id": 308,
      "name": "Hypothermia",
      "description": "Enemies units occupying Snow or Ice become <condition value=Frozen>Frozen</condition> for 3 turns and take 3 Frost damage and lose up to 3 AP.",
      "flavorText": "They stood, befuddled, as Drakmaster B began to slide around on the ice. After watching for a time, they learned he was sliding on purpose. He called his movements breakdancing. His companions didn't understand.",
      "noraCost": 25,
      "artist": "Simon Dominic",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0Be9Be9Bg3AJ8IJ8Jsmhketmwfxoympf",
      "deckLimit": 2
    },
    {
      "id": 545,
      "name": "Ice Stars",
      "description": "For 4 turns, enemy champions that make a successful basic attack take 5 Frost damage and becomes <condition value=slowed>Slowed</condition> for 3 turns.",
      "flavorText": "Even those who are familiar with the Tundra have to be wary of these marks.",
      "noraCost": 35,
      "artist": "Phu Thieu",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1AG2AG2AF0BJ8Jj9Aeeeeevoqonjwqqf",
      "deckLimit": 2
    },
    {
      "id": 62,
      "name": "Ice Storm",
      "description": "Area Effect 4: All spaces become Ice for the next 4 turns.  All units become <condition value=grounded>Grounded</condition> for 2 turns and take 10 Frost damage.  Units successfully damaged become <condition value=chilled>Chilled</condition> for 2 turns.",
      "flavorText": "\"There used to be a village here...\" Juya White-eyes, Frostwing Chieftain",
      "noraCost": 50,
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 10,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jg3AE8De9Bf1Aj9Dj9Eevkgemymjrlwmpf",
      "deckLimit": 2
    },
    {
      "id": 246,
      "name": "Identity Crisis",
      "description": "Area Effect 4: For 6 turns, affected units have no race and no class.",
      "flavorText": "E`lmir stared into the mirror's surface, at the image that stared back. He raised his hand to see it reaching toward him in the same way. And yet, the image within the mirror didn't match.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1Ae9Be9BF0AJ8Jj9Aemssqosmetqzon",
      "deckLimit": 2
    },
    {
      "id": 373,
      "name": "Imbue Luminescence",
      "description": "Target champion gains <ability value=2373>Nora Gem</ability>. if target champion already has Nora Gem or <ability value=2581>Endless Devotion</ability>, it gains <ability value=1336>Fascinate</ability> instead.",
      "flavorText": "\"The elf shined the gem with his sleeve and held it to the sky. The stone became a tiny sun, warming his cold hands.\" - Exerpt from elven myth, The Precious Gem",
      "noraCost": 15,
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 3,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1AF0Ae9Bf1AJ8Jj9Aerlphtjrluvmyo",
      "deckLimit": 2
    },
    {
      "id": 28,
      "name": "Impervious",
      "description": "Target champion is <condition value=impervious>Impervious</condition> for 2 turns and gains <ability value=655>Skirmisher</ability> for 3 turns.",
      "flavorText": "In battle, some warriors will become so great that they cannot be touched by words, blades, or magic.  They become legends.",
      "noraCost": 30,
      "artist": "Shayne Bingham",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1BE8De9Be9Aj9Aj9Bpjtqluxmsuoqfpf",
      "deckLimit": 2
    },
    {
      "id": 169,
      "name": "Implant",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> targeted owned champion, and a Crested Fesh unit is summoned in its place with 5 AP.  Other friendly Worms gain 3 AP.",
      "flavorText": "The pain of a Crested Fesh attack is said to be incredibly painful. There are no first hand accounts, due to the Fesh's vicious nature.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1Ae9Ae9Bf1BJ8Jj9Aerqsxqqfxfklyo",
      "deckLimit": 2
    },
    {
      "id": 215,
      "name": "Increase Gravity",
      "description": "All champions become Planarbound and Earthbound for 6 turns.",
      "flavorText": "\"The spell is complete. Let's see those bloody Voil try to fly over us now!\" - Kulman Stonebrow, moments before being seriously injured by an UWH (Unidentified Winged Humanoid).",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Ae9Be9BE8DJ8HJ8Izrjygkpqsmsjpn",
      "deckLimit": 2
    },
    {
      "id": 253,
      "name": "Infuse",
      "description": "For 6 turns, target champion has +1 DMG for every 15 nora in your bank when this spell is cast.  This spell can not be cast on a champion that is already under the effect of Infuse.",
      "flavorText": "\"If you wish to defend the swamps from invaders, then heed my teachings. Nora is the blood of the world. We have created many things with it. Now, you will learn to use it to destroy.\" - Gekaal the High One",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9Ae9Be9BF0Bj9Fj9Gwiwinhgykpwkwo",
      "deckLimit": 2
    },
    {
      "id": 537,
      "name": "Inhibit Power",
      "description": "Area Effect 3: Affected champions are <condition value=distracted>Distracted</condition> and <condition value=confused>Confused</condition>  for 4 turns.",
      "flavorText": "\"Forget De'lim's influence! Do not harm where there is no need.\" -- Menelaus",
      "noraCost": 40,
      "artist": "\"Faxtar\"",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3Af1BG2AF0Bj9Dj9Eeeeeemsftolllrf",
      "deckLimit": 2
    },
    {
      "id": 549,
      "name": "Inspiration",
      "description": "Target champion gains <ability value=1336>Fascinate</ability>. When this spell is cast, allies within 4 spaces of target champion gain <ability value=1129>Ally: K'thir Forest</ability>.",
      "flavorText": "\"We must take time to admire those that admire us. They are the spirit, which fuels us to fight. Without them, our blades swing in vain.\" - Menalaus, Priest of K`thir",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LEGENDARY",
      "cooldown": 9,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1AE8De9BG2BJ8Jj9Aevosmjgeileeipf",
      "deckLimit": 2
    },
    {
      "id": 444,
      "name": "Instill Panic",
      "description": "Target champion has -2 DMG, -1 SPD and <condition value=distracted>Distracted</condition> for 4 turns and is relocated up to 3 squares away from the closest friendly champion.",
      "flavorText": "\"They can run, but sooner or later, they are going to run out of places to go.\" ~ Talgar Ironfist",
      "noraCost": 25,
      "artist": "Christian Fell",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1AF0Be9Be9AJ8Jj9Aeemnnpquvhpqjpf",
      "deckLimit": 2
    },
    {
      "id": 82,
      "name": "Intimidation",
      "description": "For 4 turns, the team or player with the fewest champions loses 1 DEF and 3 DMG on all their champions. This effect does not stack.",
      "flavorText": "\"Our numbers alone guarantee our victory!\" - Sceian, Voil Lance Admiral",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0BE8De9BG2AJ8IJ8Jiwmssqhieknlwo",
      "deckLimit": 2
    },
    {
      "id": 56,
      "name": "Invisibility",
      "description": "Target champion gains <ability value=325>Stealth</ability> and becomes <condition value=stealthed>Stealthed</condition>. If it has Race: Elf, it also gains <ability value=1867>Mark</ability>.",
      "flavorText": "\"Can't hit what you can't see. Smell them out? This place stinks of life, how am I supposed to smell anything?\" - Xeelos, Wasteland Battlescrounger",
      "noraCost": 20,
      "artist": "Howard Lyon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0AE8De9Bf1AJ8HJ8Iyrlnpykeemukln",
      "deckLimit": 2
    },
    {
      "id": 517,
      "name": "Ionization",
      "description": "Area Effect 3: Friendly champions gain <ability value=542>Attack: Electricity</ability> for 5 turns.  If a champion already has Attack: Electricity, that champion gains 2 AP and <ability value=1509>Blitz</ability> for 1 turn instead.",
      "flavorText": "\"B-but I c-can't st-stop s-s-shaking!\" - Moga Recruiter",
      "noraCost": 40,
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1AF0Be9BG2AJ8Jj9Aeeerqhgyvsfgnpf",
      "deckLimit": 2
    },
    {
      "id": 466,
      "name": "Kiss of Vex",
      "description": "Target champion gains <ability value=88>Vulnerability: Fire</ability> and <ability value=93>Vulnerability: Acid</ability> for 6 turns.  If this effect leaves play before the champion is destroyed, you gain 25 nora.",
      "flavorText": "\"I am gravely disappointed. Again you have made me unleash my dogs of war. Someday, I may simply let you learn to fend for yourselves.\" ~ Vex",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0BF0Be9BF0BJ8IJ8Jeeeeepqzvowtso",
      "deckLimit": 2
    },
    {
      "id": 406,
      "name": "Lash Down",
      "description": "Target champion takes 5 physical damage and becomes <condition value=rooted>Rooted</condition> and <condition value=distracted>Distracted</condition> for 2 turns. Friendly Treefolk you control gain 2 AP.",
      "flavorText": "\"Move them to the fields Narcus, this forest has far too many eyes and ears...and roots...\" - Kiergana",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1BF0Ae9BG2Bj9Aj9Bykygpyrojrhgtqf",
      "deckLimit": 2
    },
    {
      "id": 258,
      "name": "Last Stand",
      "description": "Target champion gains <ability value=2004>Faithless</ability>, <ability value=655>Skirmisher</ability>, <ability value=1484>Solitary</ability>, <ability value=1453>Encroached</ability>, Defender of Chaos 2, and +10 MAX HP, and sacrifice all other champions you own.",
      "flavorText": "\"Tell your queen what happened here! Tell her you've lost an entire army to a lone barbarian! Tell her Zedin still breathes!\" - Arvan Masirr, Barbarian Warrior",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "eJ8JJ8If1Be9Be9BF0Bj9Aj9Boqoqftxkrfknwo",
      "deckLimit": 2
    },
    {
      "id": 191,
      "name": "Late to Battle",
      "description": "The next time an opposing champion is deployed it becomes Paralyzed (This champion can not move or use attacks or abilities. This champion has -2 DEF and it loses all AP at the start of each turn. It cannot engage other Champions and loses Paralyzed if it becomes damaged), Impervious (cannot take damage), and <condition value=defiled>Defiled</condition> for 4 turns. This effect is hidden until triggered and cannot be cleansed.",
      "flavorText": "\"Where is L`urin? He should have arrived by now. The Deep-elves will be upon us soon, and we still don't have our orders!\" - K`elim, Elven Ranger",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9Be9Ae9Bf1BJ8GJ8Houzgexkljgrfmn",
      "deckLimit": 2
    },
    {
      "id": 179,
      "name": "Lay Bridge",
      "description": "Area Effect 4: All spaces, including chasms, within the affected area become Rock terrain for 7 turns.",
      "flavorText": "\"Give him a little Nora, and an Ironfist dwarf could build a bridge across a canyon.\" - Rugolth, King of Ironfist ",
      "noraCost": 20,
      "artist": "Trevor Claxton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1Ae9Ae9BG2AJ8Jj9Aeemwmshgpqqhgpf",
      "deckLimit": 2
    },
    {
      "id": 141,
      "name": "Leap to Battle",
      "description": "All champions deployed from the rune dock this turn gain <ability value=563>Initiative 2</ability> and <ability value=2690>Glorious Leap</ability> until end of turn.",
      "flavorText": "\"We are goin' in with the first wave,\" shouted the commander. \"Means more moga for us ta kill...\"",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 4,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2Ae9Ae9BF0Aj9Bj9Cemnpfvqquvmnuo",
      "deckLimit": 2
    },
    {
      "id": 484,
      "name": "Lethologica",
      "description": "Target champion loses all AP.  For 6 turns, it has <ability value=2005>Careless</ability>, <ability value=2824>Incoherent Babbling</ability> and <ability value=2093>Ponderous</ability>.",
      "flavorText": "You go.... uh.... how about.... we.... uh....slags.  DO NOW!",
      "noraCost": 25,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9BF0Be9Bf1BJ8GJ8Heevsfgtjilerso",
      "deckLimit": 2
    },
    {
      "id": 95,
      "name": "Light as a Feather",
      "description": "Area Effect 1: Affected champions gain Flight and Mobility for 6 turns and 1 AP.  If the champions have Lumbering, Weighty or Lethargic, they lose it for 6 turns.",
      "flavorText": "\"How can we ever take the offensive if the treants move so damn slow?\" -- \"What if they didn't?\" - Godwin talking to Menalaus",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2AE8De9BG2Bj9Bj9Ceiggnhgtzvkyrqf",
      "deckLimit": 2
    },
    {
      "id": 189,
      "name": "Lightning Storm",
      "description": "Area Effect 3: All units take 10 Electricity damage.  Units occupying water take 50% more damage.  Units that are successfully damaged become <condition value=shocked>Shocked</condition> for 2 turns.",
      "flavorText": "After the Dawn, the Shattered Peaks were alight with terrible lightning storms. Bolts of incredible size and power would strike the ground, often without warning.",
      "noraCost": 45,
      "artist": "Anthony Lopes",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Be9Ae9Be9Aj9Cj9Drsjevkjlyoumpqf",
      "deckLimit": 2
    },
    {
      "id": 248,
      "name": "Limit",
      "description": "Target champion's controller loses 35 nora.",
      "flavorText": "The Moga were trained to steal Nora from the Nora reserves of any nation. They became incredibly skilled at doing it. Bringing the Nora back was the one complication they never overcame.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2Ae9Be9BF0Aj9Bj9Cerhemleieeplwo",
      "deckLimit": 2
    },
    {
      "id": 392,
      "name": "Living Vines",
      "description": "Area Effect 2: For 2 turns, affected spaces becomes Living Vines (Whenever an opposing champion enters this space, it becomes Ensnared 1 and equipped with Barbed Vine Leash). Equipment generated by this spell costs 0 nora.",
      "flavorText": "\"Even the flora rise against them. The Forest isn't completely helpless you see.\" - K'thun the Ancient ",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0AF0Ae9BG2AJ8HJ8Iqwiphiggkpykyo",
      "deckLimit": 2
    },
    {
      "id": 243,
      "name": "Lockdown",
      "description": "For 4 turns, champions may only gain AP due to natural AP generation.",
      "flavorText": "The Savage Tundra is worthy of its namesake; maneuvering through it without training can be incredibly difficult.",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9Be9Be9BF0AJ8GJ8Hevxxqllyroqhem",
      "deckLimit": 2
    },
    {
      "id": 475,
      "name": "Looking for Work",
      "description": "A Level 3 Moga Zealot, Moga Slinger or Moga Trapper is summoned in the closest available space to target friendly G'hern. If your opponent has 40 or more nora, the champion is spawned instead.",
      "flavorText": "If the Moga had known beforehand the type of work they offered here, he may have chosen to starve instead.",
      "noraCost": 40,
      "artist": "Anthony Lopes",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0AF0Be9Bf1AJ8HJ8Ieruhemjnevssso",
      "deckLimit": 2
    },
    {
      "id": 240,
      "name": "Loot",
      "description": "Target friendly champion gains the nearest valid opposing equipment.\t\t\t\t\r\n",
      "flavorText": "\"When you're traveling through Darkmarsh, its best to keep your hand on your weapon. Then again, a firm grip may not help.\" - Siralis, Nefari Messenger",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gg3Ae9Be9Be9Bj9Dj9Eeerqousmuxoyzo",
      "deckLimit": 2
    },
    {
      "id": 485,
      "name": "Lost Echoes",
      "description": "Target champion takes 8 Sonic damage. That champion takes 2 additional Sonic damage each time a friendly copy of this spell is cast. This is not Cleansable.",
      "flavorText": "The sounds themselves may become torture, if used correctly. -unknown mage",
      "noraCost": 20,
      "artist": "Anthony Lopes",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0AF0Be9Bf1BJ8HJ8Ieiyvzketmuhnwo",
      "deckLimit": 2
    },
    {
      "id": 384,
      "name": "Lost Trails",
      "description": "Target a friendly deployment zone. For 8 turns, the next time an enemy champion enters one of the deployment zone spaces, that champion is relocated to the next closest deployment zone it's controller controls and gains <ability value=2266>Wandering</ability> for 3 turns. This effect is hidden until triggered.",
      "flavorText": "\"Village over that nex-hrmm?! Where we?\" ~ Lost Moga Patrol",
      "noraCost": 25,
      "artist": "Alex Fang",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1AF0Ae9Bf1BJ8Jj9Aeigyggvojwkjgpf",
      "deckLimit": 2
    },
    {
      "id": 279,
      "name": "Macadamize",
      "description": "Area Effect 5: For 6 turns, affected area becomes Rock. Friendly champions gain <ability value=1328>Domain: Rock</ability>.",
      "flavorText": "The Earth Elementals left their mark across the Ironfist mountains. Places once green with growth were left with pocks of slate and gray. Trees became stonework masterpieces, forever entombing their beauty.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1Be9Be9Bf1Bj9Aj9Bzoygpyxzipqhipf",
      "deckLimit": 2
    },
    {
      "id": 162,
      "name": "Maddening Echoes ",
      "description": "Area Effect 2: Champions within the affected area take an amount of Sonic damage based on the number of non-summoned, non illusion champions within the affected area: 1 champion takes 5 damage, 2 champions each take 8 damage, 3 champions each take 12 damage, 4 champions each take 17 damage, 5+ champions each take 23 damage. Champions damaged by this spell gain <ability value=72>Resistance: Sonic 3</ability> for 1 turn.",
      "flavorText": "Screaming only makes things worse...",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9Be9Ae9Bf1AJ8GJ8Hwvmszzkykytojn",
      "deckLimit": 2
    },
    {
      "id": 476,
      "name": "Magnetize",
      "description": "Opposing relics and opposing equipment on champions within 5 spaces of target champion are destroyed and that champion takes 5 Physical damage for each unit destroyed this way.",
      "flavorText": "Grog bobbed and weaved as best as he could, but once the first piece struck, it was all downhill from there.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0BF0Be9Bf1AJ8IJ8Jeetjiympsxqowo",
      "deckLimit": 2
    },
    {
      "id": 190,
      "name": "Magnify Beast",
      "description": "Target Beast champion gains +10 max HP and <ability value=1238>Intimidating</ability>. If it costs 80 or more Nora, it also gains <ability value=1199>Calcify</ability>.",
      "flavorText": "The Moga had gained an affinity for magic, but still lacked a true understanding of its intricacies. Many of their spells ended with unintended consequences.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1Be9Ae9Be9Bj9Aj9Bemjegeinymlemn",
      "deckLimit": 2
    },
    {
      "id": 492,
      "name": "Mandate from Sheoul",
      "description": "Target champion with 2 or less range gains <ability value=2463>Quest: Kill Enemy</ability>, <ability value=1612>Searing Aura 4</ability> and <ability value=1142>Hunter: Hero</ability>.",
      "flavorText": "Find Grimlic. If he has betrayed us, you know what to do. \r\n",
      "noraCost": 40,
      "artist": "Alex Konstad",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8DF0Be9BG2Aj9Ej9Feeepljwiwkyxmpf",
      "deckLimit": 2
    },
    {
      "id": 124,
      "name": "March of the Skeezick",
      "description": "All Skeezick recover 2 AP. For the next 4 turns, all Skeezik have +1 SPD.",
      "flavorText": "\"Chaaaarge!\"  - Skeezick General at the ruins of Old Valdac",
      "noraCost": 45,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Ae9Ae9Be9Aj9Bj9Cemexqhephplnlpf",
      "deckLimit": 2
    },
    {
      "id": 457,
      "name": "Mark of Redemption",
      "description": "Target champion gains +2 DMG, <ability value=1775>Precision</ability> and <ability value=1899>Scale Armor</ability> for 6 turns.  If the unit is destroyed while this effect is active, you gain 20 nora.",
      "flavorText": "\"There are none that are above the need, nor the ability to receive, redemption.\" ~ Inquisitor Isran",
      "noraCost": 35,
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1AF0Be9BF0AJ8Jj9Aeemwzmwkplpsso",
      "deckLimit": 2
    },
    {
      "id": 333,
      "name": "Marsh Fable",
      "description": "An Illusion copy of a random champion in your battlegroup is summoned on target space in a friendly deployment.",
      "flavorText": "To a Boghopper youth, nothing is more important than a good story. Elders share old fables to entertain them and to teach them important lessons.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2BF0Ae9Be9Aj9Cj9Dxtzvsmumuofpuqf",
      "deckLimit": 2
    },
    {
      "id": 80,
      "name": "Marsh Song",
      "description": "For 7 rounds, you gain 8 nora at the end of your turns.",
      "flavorText": "\"Day 3: How do the Archmagi expect me to concentrate in the noise of this miserable swamp!\" - Journal of Kali, Elven Apprentice Mage",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9BE8De9BG2BJ8GJ8Hszvqqfrsfvonso",
      "deckLimit": 2
    },
    {
      "id": 432,
      "name": "Masochism",
      "description": "Target a real champion you own.  For 3 turns, damage to friendly champions is prevented and the target champion loses HP equal to the damage prevented.",
      "flavorText": " \"Agony or Ecstasy?.. I can't really tell the difference.\" - Alba, Deep Elf Masochist",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9BF0Be9Be9AJ8GJ8Heevzmeemevmyto",
      "deckLimit": 2
    },
    {
      "id": 260,
      "name": "Mass Web",
      "description": "For each friendly Arthropod, target champion takes 2 Physical damage and is <condition value=ensnared>Ensnared</condition> for 1 turn.",
      "flavorText": "\"Watch them envelope him. Do you see his fear? Can't you taste his screams? Your Nefari cannot evoke such a delicacy. Now watch, Grimlic. Watch my children feed.\" - K`lzik, Matron of Lower Sheoul",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2Be9Be9BF0Bj9Cj9Dqoqoyipnnpleipf",
      "deckLimit": 2
    },
    {
      "id": 443,
      "name": "Melt Down",
      "description": "Sacrifice target real Construct you own. Friendly Constructs gain +1 DMG and 5 MAX HP permanently and you gain nora equal to 50% of its nora cost.",
      "flavorText": "Even the best builders sometimes start over",
      "noraCost": 25,
      "artist": "Christian Fell",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0BF0Be9Be9AJ8IJ8Jeexouxoykrlrfpf",
      "deckLimit": 2
    },
    {
      "id": 331,
      "name": "Memento",
      "description": "All friendly champions with 3 base DEF gain +1 DEF permanently.  If a champion has 2 or less base DEF, it gains +2 DEF instead. This effect does not stack.",
      "flavorText": "\"I took his armor, so the Stitched wouldn't get it. I knew that it was better I take it than to have it sewed into a Blackguard. It didn't help with the guilt\" - K'oras, Elven Fury",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1BF0Ae9Be9Aj9Aj9Bgyrzojykegiplpf",
      "deckLimit": 2
    },
    {
      "id": 200,
      "name": "Mend",
      "description": "For 6 turns, target champion gains an additional 2 AP per turn and gains two ranks of Regeneration.",
      "flavorText": "\"If you fight for K`thir, the forest will aid you. If you are hungry, it will feed you. If you are tired, it will give you shelter. If you are wounded, K`thir will heal you.\" - Menalaus of K`thir",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cg3Ae9Ae9BG2Bj9Dj9Eeilnekyxqhgigrf",
      "deckLimit": 2
    },
    {
      "id": 280,
      "name": "Mercy",
      "description": "When target enemy champion would be destroyed, it instead respawns in the closest space in its owner's deployment zone with 25% of its MAX HP at end of turn. You receive Nora equal to that unit's nora cost.",
      "flavorText": "\"Priestess Yorin touched the creatures face and then brought her hand to its chest. The monster began to jerk and spring back to life. We retreated before it fully regained its senses. I asked her why she revived the foul demon and she gave no reply.\" - Thomroy, Priest of Ironfist",
      "noraCost": 20,
      "artist": "Michele Chang",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 4,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2Ae9Be9Bf1Bj9Bj9Cerzkyxirjnufmpf",
      "deckLimit": 2
    },
    {
      "id": 319,
      "name": "Metamagic Backlash",
      "description": "Target champion loses all charges and takes 12 Acid damage.  For each charge lost greater than 4, the target takes an additional 4 Acid damage.  For 6 turns, it takes 4 Acid damage for each charge gained.",
      "flavorText": "The Spellswords understood metamagic. They knew how to manipulate these principles and turn them on their enemies.",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0BF0Ae9BE8DJ8IJ8Jinuoymhvhtxxvo",
      "deckLimit": 2
    },
    {
      "id": 407,
      "name": "Might of Ironfist",
      "description": "Target champion loses 10 HP, has +5 DMG and gains a rank of Pummel for 1 turn.\r\n",
      "flavorText": "Freedom is never far from extinction. It must be fought for and defended while teaching our coming generations how to do the same. - Late King Rugolth's personal journal",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2AF0Ae9BG2Bj9Bj9Cevoszvhpwvhiyrf",
      "deckLimit": 2
    },
    {
      "id": 163,
      "name": "Millennial Icequake",
      "description": "Each unit takes 20 Physical damage.",
      "flavorText": "\"After the second quake, I began to question the rarity of this massive, geologic event. When, moments later, the third nearly killed me, I knew the 'millennial' was merely hyperbole.\" - Etchen, the Chronicler",
      "noraCost": 100,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 20,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0Be9Ae9Bf1AJ8IJ8Jqjwvhroqoqhvqo",
      "deckLimit": 2
    },
    {
      "id": 307,
      "name": "Mimic",
      "description": "Target friendly champion gains all upgraded abilities of adjacent non-Avatar/Boss/Elite enemy champion. Basic attacks and abilities that change a champion's form are not gained.",
      "flavorText": "\"Fancy spell-slingin' ye got there. I'm honored ya wanna be more like me.\" - Corporal Ishman Quickclaw of the Ellie P.\r\n",
      "noraCost": 30,
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DE8De9Be9Bg3Aj9Ej9Fsmhrzmhrowtuqqf",
      "deckLimit": 2
    },
    {
      "id": 379,
      "name": "Mindslicer Boomerang",
      "description": "Target real champion you control takes 7 Psychic damage.  Then, the closest real champion you control takes 6 Psychic damage.  This repeats until all real champions you control have been damaged this way, each taking 1 less damage to a minimum of 1.  The opposing champion closest to the last champion takes Psychic damage equal to the damage dealt.  The opposing champion also gains Defenseless if 5 or more champions you control were damaged this way.",
      "flavorText": "\"The mind is vulnerable. There are no shields to protect it, no gates, and no walls to hold it in. You only need to know how to strike, and the mind will crumble.\" - Sarinda",
      "noraCost": 40,
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9AF0Ae9Bf1Bj9Fj9Gufgignhyvzvzkpf",
      "deckLimit": 2
    },
    {
      "id": 29,
      "name": "Mindstorm",
      "description": "Target champion takes 10 Psychic damage, loses all AP and becomes <condition value=shocked>Shocked 3</condition>.",
      "flavorText": "\"Selea and I stood there at the edge of the cavern staring across at a large encampment of Nefari warriors, we had found our quarry, when all of sudden she fell to the floor, screaming and convulsing. I knew it was time to go.\" - Fehra, Wild Elf Scout",
      "noraCost": 35,
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HE8DE8De9BF0Aj9Ej9Feevkerosoyxfkn",
      "deckLimit": 2
    },
    {
      "id": 173,
      "name": "Mine Field",
      "description": "Area Effect 4: 3 Proximity Mine relics are summoned randomly within the affected area (Proximity Mine - This relic has Shadowspawn. When an opposing champion moves within 2 spaces of it, it is destroyed and opposing champions within 2 spaces takes 12 Fire damage).",
      "flavorText": "\"I've lost several warriors along the roads leading to the Sundered Lands. The ground erupts, often without warning. I'm afraid the Draksar have learned new magics.\" - M'alta, Elven Fury",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ag3Ae9Ae9Bf1Bj9Dj9Eeiplrhpnnyoytqf",
      "deckLimit": 2
    },
    {
      "id": 421,
      "name": "Mirror Trap",
      "description": "Target opposing non-Hero champion is cloned and deployed in your nearest Shrine or nora font deployment zone. If the target is destroyed, this clone is also destroyed.",
      "flavorText": "Wait, don't look at it!",
      "noraCost": 50,
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 10,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9AF0Be9BE8Dj9Fj9Gemnhetsjtzoljpf",
      "deckLimit": 2
    },
    {
      "id": 340,
      "name": "Mirrorhold",
      "description": "Target champion becomes <condition value=pacified>Pacified</condition> and 3 Illusion copies of the champion under that player's control are summoned within 3 spaces of the target champion.  The affected champion loses Pacified, if all the Illusions are no longer in play.",
      "flavorText": "\"Your enemy believes he has the upper-hand. In reality, he is helpless. This is the power I can teach you, if you are willing to learn.\" - K'ento, Disciple of Sh'aradezrin",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1AF0Ae9Be9BJ8Jj9Aeemjrfrwfkwfmn",
      "deckLimit": 2
    },
    {
      "id": 367,
      "name": "Misdirection",
      "description": "Target champion becomes <condition value=stealthed>Stealthed</condition> for 6 turns and summons 3 Illusion champions within 3 spaces that appear to be identical copies of this champion. When this champion leaves play, the Illusions are destroyed.",
      "flavorText": "\"This forest plays tricks on those who are not cautious. A fool could get hopelessly lost, with no hope of return.\" - Menalaus",
      "noraCost": 20,
      "artist": "Slawomir Maniak",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9BF0Ae9Bf1AJ8GJ8Hkymjnlukukegnn",
      "deckLimit": 2
    },
    {
      "id": 30,
      "name": "Mobilization",
      "description": "All friendly champions gain 4 AP.",
      "flavorText": "\"Living armies complain about forced marches, dead ones seem not to care.\" Xulos, Apprentice to Serkan",
      "noraCost": 60,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 11,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1AE8De9Be9BJ8Jj9Aeerqjtqjemlrhn",
      "deckLimit": 2
    },
    {
      "id": 93,
      "name": "Moga Decoy",
      "description": "An Moga Slinger Illusion with no upgrades is created in your <mechanic value=deployment_zone>deployment zone</mechanic>.",
      "flavorText": "\"I don't understand...it looked like a Moga\" -- \"There is something strange going on here...\" - Garu camp",
      "noraCost": 20,
      "artist": "Gabriel Garza",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 4,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Ae9Ae9BE8DJ8HJ8Iygetufmjrzgnnn",
      "deckLimit": 2
    },
    {
      "id": 31,
      "name": "Monsoon",
      "description": "Area Effect 3: All champions take 10 Physical damage and become <condition value=grounded>Grounded</condition> for 2 turns. For the next 3 turns, all spaces become Water and are Impeding 1.",
      "flavorText": "\"Those miserable boghoppers bring their blasted swamp wherever they go!\" - Garriegh, Centaur Archer",
      "noraCost": 40,
      "artist": "Shayne Bingham",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9BE8De9BE8DJ8GJ8Hgtmnsxohrljyin",
      "deckLimit": 2
    },
    {
      "id": 409,
      "name": "Murkwater Weakness",
      "description": "Area Effect 2: Champions in the affected area have -2 SPD, and have their DMG and DEF set to 1 for 2 turns.",
      "flavorText": "\"What's wrong with Scad?\"\r\n\"Dunno. Says he dun' feel like fightin'.\"\r\n\"This is not boghopper magic, it's...dirtier.\" - Dredd, Negation Mage\r\n",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cg3AF0Ae9BG2Bj9Dj9Eemsfeigvxqsqlrf",
      "deckLimit": 2
    },
    {
      "id": 252,
      "name": "Murky Depths",
      "description": "All friendly champions gain Hidden: Water for 8 turns.",
      "flavorText": "\"To hide is not cowardice. A hunter hides, waiting for his prey to make a mistake. A warrior must hide to lull his opponent. An enemy, at ease, will expose a weakness.\" - Lemsu of Darkmarsh",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IE8De9Be9BF0Bj9Ej9Fukukuvkgknepso",
      "deckLimit": 2
    },
    {
      "id": 96,
      "name": "Mystic Opposition",
      "description": "For 8 turns, if target champion becomes the target of a spell, the spell backfires. This effect is hidden until triggered.",
      "flavorText": "\"Don't fear the aggressors magic, trust in the power of the Forest.\" - Sred Favage, Elven Mage",
      "noraCost": 25,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2BE8De9BG2Bj9Cj9Dirzmwtsojwqzvqf",
      "deckLimit": 2
    },
    {
      "id": 523,
      "name": "Naturalize",
      "description": "Area Effect 5: Enemy relics, illusions and summoned champions take 15 Magic damage.",
      "flavorText": "All things return to their natural state, usually with time, and sometimes with the aid of magic.",
      "noraCost": 25,
      "artist": "Conceptopolis",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9Ae9BG2Ae9Aj9Fj9Gpuqqqhknphiitqf",
      "deckLimit": 2
    },
    {
      "id": 77,
      "name": "Nature's Wrath",
      "description": "Area Effect 3: All units take 10 Magical damage and all champions damaged this way have their DEF set to 0 for 5 turns.",
      "flavorText": "\"The forest has more than wind and leaves to defend itself, its just reluctant to show it.\" - Menalaus upon slaying a host of undead with a single spell",
      "noraCost": 45,
      "artist": "Layne Johnson",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CE8DE8De9BG2Bj9Ej9Fgyxvqjtoquzvhpf",
      "deckLimit": 2
    },
    {
      "id": 89,
      "name": "Necro Hex",
      "description": "Target real champion gains <ability value=2526>Necrosis</ability>, <ability value=1211>Disease Eater</ability>, and Race: Undead. Your Shrine's <mechanic value=deployment_zone>deployment zone</mechanic> is increased by 1.",
      "flavorText": "\"Xulos you fool!  How is this supposed to help?  He's not under my control!\" - Serkan, angrily shouting",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1BE8De9BG2Bj9Aj9Bvvxquhgigknympf",
      "deckLimit": 2
    },
    {
      "id": 32,
      "name": "Necroweave",
      "description": "For 6 turns, when an undead friendly champion is destroyed, its cooldown is set to 0.",
      "flavorText": "\"Souls are like thread, one simple knot and they can be looped eternally.\" - Xulos, Apprentice to Serkan",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2AE8De9Be9Bj9Bj9Ceemsolrhiruvon",
      "deckLimit": 2
    },
    {
      "id": 334,
      "name": "Nora Artillery",
      "description": "Area Effect 3: You lose all remaining nora.  At the beginning of your next turn, champions occupying the affected spaces take 5 Magic damage and an additional 5 Magic damage for every 10 nora lost  (rounded down).",
      "flavorText": "\"They'll get a big surprise when they see this one comin' at them. Don't worry, 'hopper. I've done this before.\" - Olmin Hardshell, Artillery Specialist on the Leviathan",
      "noraCost": 45,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3AF0Ae9Be9Aj9Dj9Eemnhekwxtosqzrf",
      "deckLimit": 2
    },
    {
      "id": 33,
      "name": "Nora Drain",
      "description": "Target enemy champion, each player loses all Nora.",
      "flavorText": "\"Those who claim ownership of Nora, need to remember that it belongs to the land.\" - Gekaal, Forglar High One",
      "noraCost": 45,
      "artist": "Shayne Bingham",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "ej9Gj9FF0BE8De9Be9AJ8IJ8Jolruojpqsmpyto",
      "deckLimit": 2
    },
    {
      "id": 123,
      "name": "Nora Freeze",
      "description": "For the next 6 turns, while your opponent controls more fonts than you do, their font nora gen is reduced by 50%. This effect does not stack.",
      "flavorText": "\"We need time to regroup. Have the Elder delay the enemies advance.\"",
      "noraCost": 35,
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "EXOTIC",
      "cooldown": 7,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9Be9Ae9Be9BJ8GJ8Heemexqoftqhyvm",
      "deckLimit": 2
    },
    {
      "id": 369,
      "name": "Nora Infusion",
      "description": "For 5 turns, target friendly champion is Nora Shielded. This effect is hidden until triggered.",
      "flavorText": "\"Told you those 'oppers could show us some tricks! This Nora Influction maxmizes our Kanen-kicking capacity by 100 percent.\" - Arnom Ironshell, corsair on the Boulderbeak",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0BF0Ae9Bf1AJ8IJ8Jinuvxouxquvquo",
      "deckLimit": 2
    },
    {
      "id": 347,
      "name": "Nora Seep",
      "description": "At the beginning of each turn for 7 turns, 3 random nora globes valued between 5 and 15 nora are dropped on random squares around nora fonts.",
      "flavorText": "Both rangers paused, watching intently as Nora globes appeared. The globes sprung from the ground and then came to rest with a thud. They stopped their duel, believing that the Nora was a sign from the gods.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9AF0Ae9BF0Aj9Fj9Gmjwmykygnhtmuo",
      "deckLimit": 2
    },
    {
      "id": 518,
      "name": "Nora Storm",
      "description": "Target champion collects all nora globes within 3 spaces and takes Electricity damage equal to twice the nora recovered.",
      "flavorText": "As the Voil continue to develop ways to utilize nora directly, a development that gravely concerned the other factions.",
      "noraCost": 25,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1BF0Be9BG2Aj9Aj9Beeigggkwipjgrqf",
      "deckLimit": 2
    },
    {
      "id": 359,
      "name": "Nora Trap",
      "description": "Target champion is Nora Trapped 4 (When this condition is removed, this champion takes Magic damage equal to 50% of the amount of nonshrine, nonfont nora its owner generated while it was active).  This effect is hidden until triggered.",
      "flavorText": "\"The old hex worked better than I imagined. Their miners were reduced to fits of screaming. Greedy softskins, cowards. They don't bother themselves with metamagicks.\" - Lazero, Draksar Spellsword",
      "noraCost": 25,
      "artist": "Anthony Lopes",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0AF0Ae9BF0BJ8HJ8Imsmsqufvkjnhnn",
      "deckLimit": 2
    },
    {
      "id": 516,
      "name": "Noraweave",
      "description": "For 4 turns, you gain 10 nora for each successful basic attack made by enemy champions.",
      "flavorText": "\"Sometimes, the best course of action is to let the enemy fight himself.\" - Unkown Salaman Hunter",
      "noraCost": 35,
      "artist": "Nate Abell",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0BF0Be9BG2AJ8IJ8Jeeegeggkrolgipf",
      "deckLimit": 2
    },
    {
      "id": 481,
      "name": "Northern Wind Discipline",
      "description": "Champions in a 5 space straight line from target friendly champion take 10 Frost damage and become <condition value=frozen>Frozen</condition> for 3 turns if successfully damaged. If any additional targets are friendly monks, they take no damage and opposing champions in a 5 space straight line from that champion take 5 Frost damage and become Frozen for 3 turns and are relocated 1 space closer if successfully damaged",
      "flavorText": "While powerful as individuals, the Kas posess the powers of tundra when they work together.\r\n",
      "noraCost": 40,
      "artist": "Nate Abell",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jg3AF0Be9Bf1Aj9Dj9Eeemepqzxtxqfvqf",
      "deckLimit": 2
    },
    {
      "id": 426,
      "name": "Nublin's Surprise Pies",
      "description": "Area Effect 3: 5 Meat Pie relics are <condition value=summoned>Summoned</condition> randomly within the affected area with <ability value=812>Devourable</ability> and <ability value=2541>Mystery Meat</ability>",
      "flavorText": "May contain some or none of the following ingredients: Poxyhydrogenated Oil, Fesh Meat Filling, G'hern Wax, Hopper Juice, Gnarlwood Extract, Slider Slime, Enriched Fesh Yeast...",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1BF0Be9BE8Dj9Aj9Bemjwigvzkufpjpf",
      "deckLimit": 2
    },
    {
      "id": 354,
      "name": "Obelus",
      "description": "For 6 turns, whenever this champion activates an ability (including attacks), it loses 14 HP.  This effect is hidden until triggered.",
      "flavorText": "\"These were new magicks; even the elf knew nothin' about them. She said these were older magicks, called them 'Pre-Separation.' This doesn't bode well.\" - Captain's Log of the Leviathan",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2BF0Ae9BF0Aj9Cj9Drqftqjpwqfpfgpf",
      "deckLimit": 2
    },
    {
      "id": 467,
      "name": "Oblivion Hex",
      "description": "Target champion becomes Cursed, Inhibited and <condition value=defiled>Defiled</condition> for 6 turns.  If this effect leaves play before the champion is destroyed, you gain 30 nora.",
      "flavorText": "The disease spread quickly, covering up large portions of his body.  Then suddenly, one day, as quickly as it had appeared, it faded.",
      "noraCost": 30,
      "artist": "Christian Fell",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1AF0Be9BF0BJ8Jj9Aeeeeeevzvfpnwo",
      "deckLimit": 2
    },
    {
      "id": 281,
      "name": "Occlusion",
      "description": "For 4 turns, all non-fairy champions have <ability value=2004>Faithless</ability>.",
      "flavorText": "The murk invaded his thoughts as it covered his study. He closed his eyes and the darkness was gray with its haze. He reached out to begin a spell, but the Dark Apprentice couldn't focus beneath the crushing veil.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2Be9Be9Bf1Bj9Cj9Detufevonjtmerqf",
      "deckLimit": 2
    },
    {
      "id": 297,
      "name": "Onus of Kiergana",
      "description": "Target champion is destroyed. After 12 turns, your shrine and all of your units are destroyed, even if they would otherwise not be destroyed, and you lose the game (this effect cannot be removed).",
      "flavorText": "\"These are our rituals. They are dark, yes, and savage. But, the Kanen have few enemies.\" ? Kiergana, Kanen Crone",
      "noraCost": 50,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "EXOTIC",
      "cooldown": 10,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CE8De9Be9BG2Bj9Ej9Fqoygirljwxkwmpf",
      "deckLimit": 2
    },
    {
      "id": 75,
      "name": "Open the Earth",
      "description": "Area Effect 3: All non-Flying units occupying land spaces take 8 Fire damage and all land spaces become Shallow Lava (non-Impeding, deals 4 Fire damage) for 4 turns.",
      "flavorText": "\"Tell the geomancers that the next time they want to call forth lava into MY stronghold, they ask me first!\" - Rugolth, Dwarven King",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2AE8De9BG2Aj9Bj9Ceevofgyzkwqzmpf",
      "deckLimit": 2
    },
    {
      "id": 447,
      "name": "Overgrowth",
      "description": "Target relic gains <ability value=757>Immobile</ability> and <ability value=2260>Pariah</ability>.  Spaces within 4 spaces of it becomes Vegetation for 5 turns. When this effect ends, 3 Young Saplings without upgrades are summoned in the affected area and the relic is destroyed.",
      "flavorText": "Nature will always reclaim what mortals leave behind",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2BF0Be9Be9Aj9Cj9Deiwigyzmsztqwqf",
      "deckLimit": 2
    },
    {
      "id": 357,
      "name": "Pack Savagery",
      "description": "All units with <ability value=1938>Pack Mentality</ability> or <ability value=2146>Pack Leader</ability> engaged with an opposing champion makes a free Physical melee attack against one of the opposing champions it is engaged to.",
      "flavorText": "\"The Kanen are getting worse. The little restraint they possessed is gone, replaced by a blind, almost desperate rage. This sort of reckless savagery makes them more dangerous.\" - Kimuron, Elder Guardian",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9AF0Ae9BF0Bj9Fj9Gygygtmnllrziyo",
      "deckLimit": 2
    },
    {
      "id": 277,
      "name": "Patience",
      "description": "Target champion becomes Immobile, Shielded, Passive, and Invulnerable for 3 turns. The next closest champion also becomes Immobile, Shielded, Passive, and Invulnerable for 3 turns.",
      "flavorText": "\"The tundra tells you to be slow. You rush and you are bound to lose power, to waste your strength, struggling against it. If you show patience and make each step with purpose, you will survive. Raging against it is the quickest path to death.\" - K`ento, Jakei Disciple",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0Be9Be9Bf1BJ8IJ8Jgkusqoshytonwo",
      "deckLimit": 2
    },
    {
      "id": 389,
      "name": "Peak Tactics",
      "description": "Area Effect 4: For 1 turn friendly champions gain <ability value=2429>Flanking</ability> (Whenever this champion makes a basic attack, it has +5 DMG for that attack if the target is engaged to another champion.) ",
      "flavorText": "\"They're brainless sots, incapable of advanced deployment, flanking or even marching in formation.\" - Boghopper Elite Reed's ill fated charge ",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8DF0Ae9BG2Aj9Ej9Fqoqjgvxoykgykpf",
      "deckLimit": 2
    },
    {
      "id": 483,
      "name": "Petrichor",
      "description": "Area of Effect 3: Friendly champions are healed for 12 HP and gain <ability value=2674>Nature's Connections</ability> for 4 turns.",
      "flavorText": "Even nature seemed to notice Menalaus' absence, raining for 3 straight days.\r\n",
      "noraCost": 30,
      "artist": "Paul Guzenko",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9AF0Be9Bf1Bj9Fj9Gevofrsxzxfrzmpf",
      "deckLimit": 2
    },
    {
      "id": 324,
      "name": "Pilfered Armory",
      "description": "Equipment on target equipped champion is destroyed and a copy of that equipment is equipped onto the closest unequipped champion with a different owner if possible.",
      "flavorText": "\"What do you mean you're out of weapons? Do they still have weapons? Then, take theirs!\" - Kiiraam, Voil Overseer",
      "noraCost": 35,
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3AF0Ae9BE8Dj9Dj9Eeigtuxmeemumuqf",
      "deckLimit": 2
    },
    {
      "id": 526,
      "name": "Pilgrimage",
      "description": "Target champion gains <ability value=2773>Quest: Runner</ability> and <ability value=1457>Forage</ability>.",
      "flavorText": "\"May your footprints on the snow be followed solely by the good willed, and this soil painted solely by your enemies.\" - Inscription at the southernmost area of the Boreal Cliffs",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Be9BG2Ae9AJ8IJ8Jgvsufkwkekgklpf",
      "deckLimit": 2
    },
    {
      "id": 396,
      "name": "Pillars of Flame",
      "description": "Champions in a 5 space straight line from target friendly champion take 10 Fire damage and become <condition value=enflamed>Enflamed 2</condition> if successfully damaged. If any additional targets are friendly Wizards, they take no damage and opposing champions in a 5 space straight line from that champion take 5 Fire damage and become <condition value=charred>Charred 1</condition>.",
      "flavorText": "Gouts of flame hurtled skyward in a blinding flash. As he turned he understood now what had happened, he was trapped in a corral made of flame. ",
      "noraCost": 35,
      "artist": "Bartek Gawel",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2AF0Ae9BG2Aj9Bj9Ceeiyztshkjlgtqf",
      "deckLimit": 2
    },
    {
      "id": 34,
      "name": "Plague",
      "description": "Target champion becomes Plagued and spawns a Festering Corpse under your control upon death. Target champion becomes <condition value=inhibited>Inhibited 5</condition>, <condition value=diseased>Diseased 5</condition> and <condition value=infectious>Infectious 5</condition>.",
      "flavorText": "\"Burn the bodies - bosses orders - says they have some kind of disease.\" - Gort Dunrok, Ironfist Sergeant",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1BE8De9Be9Bj9Aj9Beigklnplgtxiln",
      "deckLimit": 2
    },
    {
      "id": 451,
      "name": "Planar Dissonance",
      "description": "For 6 turns, the first time an enemy champion is relocated on its turn, it loses 10 HP and all AP and gains <ability value=2266>Wandering</ability> for 3 turns. This effect is hidden until triggered.",
      "flavorText": "For a brief moment, he was everywhere but nowhere. The rest of the his party was oblivious, but Misk knew something was very wrong.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9BF0Be9Be9BJ8GJ8Heeerwfxohkegem",
      "deckLimit": 2
    },
    {
      "id": 242,
      "name": "Poisonous Fumes",
      "description": "Area Effect 2: Create a <mechanic value=poison_cloud>Poison Cloud</mechanic> until the end of the next turn in the target area.",
      "flavorText": "\"The invaders will accept our gift, even if their bodies shrivel, even if their lungs burn and blister. I will make sure of it.\" - Kaalnaim, Darkmarsh Defiler",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9Ae9Be9BF0Aj9Fj9Gvsqluzgrhnyoso",
      "deckLimit": 2
    },
    {
      "id": 193,
      "name": "Price of Victory",
      "description": "Your shrine loses 50% of its current HP and friendly champions gain +5 MAX HP and 2 AP.",
      "flavorText": "\"Fight harder! Don't let them come any closer! They will take nothing from us.\" - N`altin, Deep-Elf Captain",
      "noraCost": 45,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9Ae9Ae9BG2Bj9Fj9Guzthtfpuvqlwoqf",
      "deckLimit": 1
    },
    {
      "id": 338,
      "name": "Pride of Sarnghaver",
      "description": "All friendly Barbarians gain <ability value=1320>Assault</ability> and <ability value=1374>Resolute</ability> for 4 turns.",
      "flavorText": "When Zedin finally returned from Maljara, his first action was to rally the barbarians of the Sarnghaver. He wanted to lead his people to Maljara, to destroy the Stitched.",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0AF0Ae9Be9BJ8HJ8Ieipyiexkusfxfm",
      "deckLimit": 2
    },
    {
      "id": 101,
      "name": "Protect the Nest",
      "description": "6 Spiderling eggs are spawned within 4 spaces of your Shrine or Avatar. After a 2 turn delay, at the beginning your opponent's turn, one of these relics is removed from play, and Spiderling champion under your control is summoned in its place .",
      "flavorText": "\"The village is ours...\" -- \"Excellent. Daphos, prepare the egg sacs. Their reinforcements should arrive shortly...and we wouldn't want to disappoint them\" - Maxxarek",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0AE8De9Bg3AJ8HJ8Ikuosxfpfepyzzo",
      "deckLimit": 2
    },
    {
      "id": 328,
      "name": "Protection",
      "description": "The next time target champion would be damaged, it gains the Eater ability matching that damage type for 6 turns (this occurs before damage resolves).  This effect is hidden until triggered.",
      "flavorText": "\"I wanted a place for my students to study and discuss their lessons with each other. That is why I made K'thiras. It is not a training ground for your armies.\" - Menalaus, priest of K'thir",
      "noraCost": 45,
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0AF0Ae9Be9AJ8HJ8Izztfklruqwvxvo",
      "deckLimit": 2
    },
    {
      "id": 241,
      "name": "Psionic Impact",
      "description": "For 1 turn, champions damaged by Psychic attacks are knocked back 1 space and become <condition value=distracted>Distracted</condition> for 2 turns. Friendly champions with race: Firk who do not have <ability value=547>Attack: Psychic</ability> gain <ability value=1818>Defensive Strike</ability> for 1 turn. This effect does not stack.",
      "flavorText": "The blast had thrown the Nefari off of his feet. When he landed, some twenty paces behind, his face wore a look of bewildered fear. He stumbled away from the defending Firk, gasping and clawing past the marsh growth.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HE8De9Be9BF0Aj9Ej9Feemwkpuojyvvon",
      "deckLimit": 2
    },
    {
      "id": 423,
      "name": "Psionic Storm",
      "description": "Area Effect 2: Opposing champions take 6 Psychic damage and gain <condition value=confused>Confused</condition> and <condition value=grounded>Grounded</condition> for 2 turns. The area of effect increases by 1 for each friendly champion with Attack - Psychic in the area of effect, to a maximum of 5.",
      "flavorText": "A psionic storm does little in the ways of physical damage, but for those affected it is a harrowing experience.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0AF0Be9BE8DJ8HJ8Ierumuvvhthtzto",
      "deckLimit": 2
    },
    {
      "id": 181,
      "name": "Psychic Blast",
      "description": "Target champion takes 12 Psychic damage. Enemy champions within 5 spaces of target champion take 2 Psychic damage for each friendly champion with the Attack: Psychic ability.",
      "flavorText": "Psychics can harmonize psychic energies into a singular wave. When released, the result is often fatal.",
      "noraCost": 40,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2Ae9Ae9BG2Aj9Bj9Ceerztzofkrhepqf",
      "deckLimit": 2
    },
    {
      "id": 524,
      "name": "Psychic Conundrum",
      "description": "Target friendly champion loses up to 12 AP and enemy champions within 4 spaces take Psychic damage equal to 150% of the AP lost (rounded up).  Champions successfully damaged this way become <condition value=distracted>Distracted</condition> for 2 turns. Champions who are <condition value=soultapped>Soultapped</condition> also gain <ability value=2266>Wandering</ability> for 2 turns.",
      "flavorText": "The mysteries of the swamp entice not only those who dwell within, but also those without.  Solving them, however, is a path wrought with peril.",
      "noraCost": 35,
      "artist": "Markus Erdt",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9Be9BG2Ae9AJ8GJ8Hshvzzosukyinyo",
      "deckLimit": 2
    },
    {
      "id": 478,
      "name": "Purefire",
      "description": "Target champion is <mechanic value=dispelled>Dispelled</mechanic> and gains <ability value=88>Vulnerability: Fire</ability> for 6 turns",
      "flavorText": "\"Its been too long since our enemies have tasted flame, they have forgotten our power and grown bold in their ignorance. They will know the weight of Onus as we watch them burn.\" - Nefari Fireslinger",
      "noraCost": 35,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1BF0Be9Bf1Aj9Aj9Bemjemwolwvshipf",
      "deckLimit": 2
    },
    {
      "id": 416,
      "name": "Purge",
      "description": "Area Effect 3: All champions in the affected area are <mechanic value=cleansed>Cleansed</mechanic> and <mechanic value=dispelled>Dispelled</mechanic>.\r\n\r\n\r\n",
      "flavorText": "As the blade pierced Cedrim's heart and lung, he heard the sound of his own voice screaming as if from far away. His final thoughts were why his sacred rite hadn't protected him and how the Draksar now running him through had shaken off his stun.",
      "noraCost": 45,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1BF0Ae9Bg3Aj9Aj9Bsmwtsxfmlnuhyrf",
      "deckLimit": 2
    },
    {
      "id": 346,
      "name": "Pygmy Hippo Stampede",
      "description": "Area Effect 3: 3x Pygmy Hippos with 6 DMG, 5 HP, <ability value=2213>Crazed Charger</ability>, <ability value=654>Feeding Frenzy</ability>, <ability value=1932>Loyalty</ability>, <ability value=113>Initiative 1</ability>, <ability value=2>Amphibious</ability> and <ability value=655>Skirmisher</ability> are summoned randomly in the affected area.",
      "flavorText": "At first, the spectacle made the Nefari scout laugh. And then, after being trampled by the advancing hippos, he didn't find it amusing.",
      "noraCost": 55,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 11,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2AF0Ae9BF0Bj9Bj9Ceeeeerlpferhgpf",
      "deckLimit": 2
    },
    {
      "id": 427,
      "name": "Quicken",
      "description": "Target champion is Quickened (The next time this champion makes a basic attack it makes a second basic attack against the same target for 0 AP. This does not stack). If it has Race: Skeezick, you are refunded 5 nora.",
      "flavorText": "What had been a skirmish, a dance of blades and sidestepping moves suddenly became an unrelenting murderous assault. Impossible to disengage and inevitably mortal. ",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2AF0Be9BE8Dj9Bj9Ceevklrshkymnnpf",
      "deckLimit": 2
    },
    {
      "id": 35,
      "name": "Quickening",
      "description": "Friendly champions are Quickened (The next time this champion makes a basic attack it makes a second basic attack against the same target for 0 AP. This does not stack). After this spell has been cast, no other spells can be cast this turn.",
      "flavorText": "In the thick of battle, with the clang of steel against steel, and the cries of fallen soldiers, time takes on a new meaning.",
      "noraCost": 55,
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 11,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2BE8De9BF0Bj9Cj9Dgygyxolnwitfepf",
      "deckLimit": 2
    },
    {
      "id": 456,
      "name": "Rain of Blood",
      "description": "Area Effect 3: Opposing champions within the affected area become <condition value=bloodied>Bloodied</condition> for 4 turns. Friendly champions within the affected area with Race: Vampyre, Bleed or Life Siphon gain 2 AP and gain <ability value=2551>Bloodseeker</ability> for 1 turn.",
      "flavorText": "\"Don't be disturbed, my pet, the rain won't harm you.\" ~ Sorsha, Hekatian Bloodguard",
      "noraCost": 35,
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2AF0Be9Be9Bj9Bj9Ceeeipnsufvxkwo",
      "deckLimit": 2
    },
    {
      "id": 265,
      "name": "Rally the Herd",
      "description": "The next time each Centaur champion you own makes a basic attack this turn, they each make a second attack against the same target for free.",
      "flavorText": "\"Draw your swords and raise your shields. Archers, ready your bows. We take the fight to their front line. They fight centaurs today; and they will never forget.\" - Aririn, Centaur Commander",
      "noraCost": 55,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 11,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0Ae9Be9Bf1AJ8HJ8Izrfvvsjiegtzon",
      "deckLimit": 2
    },
    {
      "id": 188,
      "name": "Rapid Assault",
      "description": "The next champion you deploy from the runedock has <ability value=563>Initiative 2</ability> and <ability value=1216>Equalize</ability>.",
      "flavorText": "\"We can retrieve them from Votaev and bring them here sooner. They won't survive for long without his gift.\" - R`valna, Deep-elf Priestess",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "LEGENDARY",
      "cooldown": 5,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2BE8De9Bf1Bj9Cj9Deinyxvhkrjiympf",
      "deckLimit": 2
    },
    {
      "id": 285,
      "name": "Rapid Assault",
      "description": "The next champion you deploy from the runedock has <ability value=563>Initiative 2</ability> and <ability value=1216>Equalize</ability>.",
      "flavorText": "\"We can retrieve them from Votaev and bring them here sooner. They won't survive for long without his gift.\" - R`valna, Deep-elf Priestess",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "LIMITED",
      "cooldown": 6,
      "runeSet": "Nora Surge",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9Ae9Be9BG2Aj9Fj9Guowzoqlrziiympf",
      "deckLimit": 2
    },
    {
      "id": 212,
      "name": "Razor Ice",
      "description": "Area Effect 3: Friendly champions with a Frost basic attack gain <ability value=545>Attack: Physical</ability>, <ability value=163>Rend 1</ability> and <ability value=2542>Savage Exploit</ability> for 6 turns. If they already have Savage Exploit, they gain <ability value=2646>Heart Strike</ability> instead.",
      "flavorText": "\"Sharpen the Nora, as it flows through you, and it will sharpen any weapon you wield. Take this lesson with you, L`evia, teach it to your Shardmasters.\" - K`ento, Jakei Disciple",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Ae9Be9BE8Dj9Fj9Gklyrukeegronepf",
      "deckLimit": 2
    },
    {
      "id": 36,
      "name": "Reanimate",
      "description": "When target non-Hero non-Eternal champion is destroyed, it respawns with <ability value=942>Eternal</ability> in the closest space in its owner's nearest deployment zone at end of turn. Sacrificed champions are not reanimated. This effect is hidden until triggered. ",
      "flavorText": "The twisted magic of the fallen Elsari enable them to cheat death entirely.",
      "noraCost": 60,
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 12,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0AE8De9BF0AJ8HJ8Imjnpuvoqolnhem",
      "deckLimit": 2
    },
    {
      "id": 245,
      "name": "Rebound",
      "description": "Area Effect 3: All equipment on champions in the area is destroyed. Enemy champions affected by this gain <ability value=2093>Ponderous</ability> for 2 turns.",
      "flavorText": "\"And if you lose your weapon in battle, what will you do? I am trying to teach you to fight without steel! Must I take your dagger away, before you take my teaching to heart?\" - K`ento, Jakei Disciple",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0Be9Be9BF0AJ8IJ8Jemnusoyvmwilln",
      "deckLimit": 2
    },
    {
      "id": 78,
      "name": "Recall",
      "description": "Target real owned champion is removed from play and returned to the runedock. The next spell you cast costs 70% less nora.",
      "flavorText": "\"Don't take his criticisms too hard. The Garu don't understand that even if we use all our tricks, magic still takes time.\"- Elven Battlemages after Battle of Burning Fields",
      "noraCost": 25,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9AE8De9BG2Bj9Fj9Gletqlygnjgvvmpf",
      "deckLimit": 2
    },
    {
      "id": 204,
      "name": "Reckless Command",
      "description": "Your opponent's champions take 1 damage for each rune they currently have on cooldown.",
      "flavorText": "The Voil advised that a direct assault on Forglar would certainly result in tremendous losses. After several failed attempts, the G`hern agreed.",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0Ae9Ae9Bg3AJ8HJ8Ioqwmekyzkpuzgpf",
      "deckLimit": 2
    },
    {
      "id": 362,
      "name": "Reckless Summoning",
      "description": "The next time your opponent attempts to deploy a champion from the rune dock, its nora cost is refunded and goes on cooldown for 4 turns and a Reckless Spellhack under your control with no upgrades is deployed in the closest friendly deployment zone. This effect is hidden until triggered.",
      "flavorText": "\"We were expectin' Cpt. Shellhorn on deck and this little bugger popped up in his place. I tell you, Admiral, the whole bloody island's gone mad!\" - Virgel Ironhide, crewtort of the Ellie P.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1BF0Ae9BF0Bj9Aj9Bukukphnhnnnlyo",
      "deckLimit": 2
    },
    {
      "id": 282,
      "name": "Reclaim",
      "description": "Area Effect 3: This area becomes Vegetation.  At the end of your turns, all enemy champions within the area are <condition value=pacified>Pacified</condition> for its next turn, and the area of this spell's effect decreases by 1. ",
      "flavorText": "\"Now that we have pushed the Draksar out, K`thir will heal. It will take time, but eventually the land will be green and lush. K`thir will be healthy again.\" - Menalaus, Priest of K`thir",
      "noraCost": 50,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 10,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ag3Ae9Be9Bf1Bj9Dj9Eevkgevsjronevqf",
      "deckLimit": 2
    },
    {
      "id": 521,
      "name": "Red Sand",
      "description": "For 4 turns, target champion takes 3 Fire damage for every AP it spends (max 15 damage per turn).",
      "flavorText": "The \"red sand\" that begins as a burning sensation in the lungs. Soon after, the victim is consumed from within by an intense magical flame.",
      "noraCost": 25,
      "artist": "Nate Abell",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bg3AF0Be9BG2Aj9Dj9Eeeeiplrfxkrojrf",
      "deckLimit": 2
    },
    {
      "id": 105,
      "name": "Reflesh",
      "description": "Target champion with Race: Undead is healed for 10 HP and gains <ability value=1342>Impart</ability>. If champion is Race: Skeleton or Race: Zombie, it also gains <ability value=892>Grace of the Dead 2</ability>.",
      "flavorText": "\"I need fresher corpses...preferably unmutilated, if I ever hope to get a spy inside that damned fortress!\" - Xulos, Apprentice to Serkan",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2AE8De9Bg3Aj9Bj9Ceeerjnwojlnyvqf",
      "deckLimit": 2
    },
    {
      "id": 529,
      "name": "Reforge",
      "description": "Target equipped champion has its equipment destroyed and is equipped with a Dragonclaw instead. If the target is a friendly champion, you are refunded 10 nora.",
      "flavorText": "\"In times of war, concepts such as personal property and ownership don't seem particularly applicable.\" ~ Draksar Consulate",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Be9BG2Ae9Aj9Cj9Devzrqoqouqsshrf",
      "deckLimit": 2
    },
    {
      "id": 291,
      "name": "Refute",
      "description": "The next opposing champion rune played fails and is set to a cooldown of 8.  Other copies of the same rune in your opponent's rune dock are revealed and also set to a cooldown of 8. Your opponent is refunded 50% of the failed rune's nora cost.",
      "flavorText": "The collision of the two forces echoed through the jungle. A lone Arcanis watched the spells unravel, one energy tearing through the other. The counterspell was working.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1Ae9Be9BG2AJ8Jj9Aeeruvohtjymhipf",
      "deckLimit": 2
    },
    {
      "id": 177,
      "name": "Regulate",
      "description": "All champions without Race: Fairy have their base stats set to DEF 0, SPD 5, DMG 9 for 4 turns.",
      "flavorText": "\"If they want a fair fight, Godwin, then I will give it to them.\" - Menalaus, High Mage of K'thir",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0Ae9Ae9BG2AJ8HJ8Isqzvoyxqqztouo",
      "deckLimit": 2
    },
    {
      "id": 239,
      "name": "Repair",
      "description": "Target champion with Race: Construct is healed 30 HP.",
      "flavorText": "\"We can bring other magics into our construct creation. Imagine what we could do! With nature, we could make massive repairs on the battlefield!\" - Gregorn, Construct Mage",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Be9Be9Be9Bj9Cj9Demeiplwmlgiiwo",
      "deckLimit": 2
    },
    {
      "id": 314,
      "name": "Repurpose",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> target real champion you own.  The closest friendly champion gains half of the destroyed champion's current HP and DMG.",
      "flavorText": "\"I've seen them in the fields, taking this and that from the fallen. Swords, armor, body parts, doesn't matter; they'll take anything if it's useful.\" - Trumin Rightblade of the IMEF",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Dg3Ae9Be9Bg3Aj9Dj9Eeeemegrhvsmsosf",
      "deckLimit": 2
    },
    {
      "id": 37,
      "name": "Restore Life",
      "description": "Champion rune you own with the highest cooldown is reduced to 0.",
      "flavorText": "In times of great strife, the Ironfist Priests will pray for their fallen warriors to rise to their aid.",
      "noraCost": 40,
      "artist": "Shayne Bingham",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3AE8De9BE8Dj9Dj9Eevkuhiyrqsxinpf",
      "deckLimit": 2
    },
    {
      "id": 107,
      "name": "Retreat",
      "description": "Target unit you own is returned to your Rune dock with a cooldown of 1. You recover nora equal to half of its cost.",
      "flavorText": "\"Our work is finished...we should get back before they realize what we've done.\" - Jakei troops",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Dg3AE8De9Bg3Aj9Dj9Eeeevszgytuziirf",
      "deckLimit": 2
    },
    {
      "id": 38,
      "name": "Retribution",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> target real champion you own. The closest champion with owner different from that of the destroyed champion takes Magical damage equal to half the destroyed units Nora Cost.",
      "flavorText": "\"He'd be more useful dead than alive.\" - Gibir, Sheoul Demon upon learning of the capture of a scout",
      "noraCost": 45,
      "artist": "Gabriel Garza",
      "factions": [
        "Underdepths"
      ],
      "rarity": "EXOTIC",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2AE8De9BF0Bj9Bj9Ceeeeemwkwvhkwo",
      "deckLimit": 2
    },
    {
      "id": 183,
      "name": "Retrieve",
      "description": "Target friendly champion is returned to the closest deployment zone and is healed for 10 HP.",
      "flavorText": "\"It doesn't matter if they are Jakei or Lonx, they are allies of J'thir. I will spare no resource in finding them and returning them to safety.\" - Queen J'orea of the Jakei",
      "noraCost": 25,
      "artist": "Helen Zhu",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bg3Ae9Ae9BG2Aj9Dj9Eeevkluxmwqqfxqf",
      "deckLimit": 2
    },
    {
      "id": 299,
      "name": "Reverberating Blast",
      "description": "Target champion takes 12 Sonic damage. If target champion takes damage, the next closest champion within 3 spaces takes 5 Sonic damage and is <condition value=stunned>Stunned</condition> for 2 turns if it takes damage.",
      "flavorText": "To the younger Jangar, spellcasting became a contest of skill. Apprentices would compete to perform spells based on style and finesse. Some of these, like the reverberating blast, became commonly practiced styles. ",
      "noraCost": 50,
      "artist": "Slawomir Maniak",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 10,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9Be9Be9BG2BJ8GJ8Hwzkjnwxqqztjwo",
      "deckLimit": 2
    },
    {
      "id": 39,
      "name": "Righteous Deflection",
      "description": "For the next 4 turns, whenever target champion would take damage from a ranged attack, that damage is dealt to the attacking unit instead. This effect is hidden until triggered.",
      "flavorText": "\"You shot me! You bloody shot me!\" - \"I aimed at the dwarf, I swear!\"",
      "noraCost": 30,
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2AE8De9BE8Dj9Bj9Cerzofrlygevofpf",
      "deckLimit": 2
    },
    {
      "id": 268,
      "name": "Rip",
      "description": "Area Effect 3:  Enemy relics in the area take 15 Physical damage and enemy champions gain -1 SPD for 2 turns.",
      "flavorText": "Amongst the Voil territories is one area that is restless; it is known as the Fragile Lands. The earth is unstable in this expanse, often quaking and splitting at a moments notice.",
      "noraCost": 25,
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1Ae9Be9Bf1AJ8Jj9Aeipyggtszkrowo",
      "deckLimit": 2
    },
    {
      "id": 462,
      "name": "Rite of Purity",
      "description": "Target champion gains <ability value=1052>Purified</ability> and +1 MAX RNG for 6 turns.  If the unit is destroyed while this effect is active, you gain 30 nora.",
      "flavorText": "Empathy is strength. Those who walk alone cannot hope to accomplish what those who stand together can achieve.",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IE8DF0Be9BF0Bj9Ej9Feeeeepjyiyrjwo",
      "deckLimit": 2
    },
    {
      "id": 430,
      "name": "Ritual of Ashes",
      "description": "For 6 turns, when target friendly champion takes damage from an attack, opposing non-Avatar champions within 5 spaces become <condition value=cursed>Cursed</condition> for 5 turns and take 50% of the damage as Magic damage. This effect does not stack and is hidden until triggered.",
      "flavorText": "\"Ash to ash.\" - Sumjen, Soul Siren",
      "noraCost": 30,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8DF0Be9Be9Aj9Ej9Feephphipymnljpf",
      "deckLimit": 2
    },
    {
      "id": 325,
      "name": "Ritual of Binding",
      "description": "For 6 turns, opposing relics, shrines and avatars may not activate abilities.",
      "flavorText": "\"I know these ancients and I know ways of binding them. The Old Empire had many old magics. They can help us defeat these destroyers.\" - Zeventrech, sole survivor of the Cyclops Empire",
      "noraCost": 30,
      "artist": "Michele Chang",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8DF0Ae9Be9Aj9Ej9Fmsqfkymnjiymhpf",
      "deckLimit": 2
    },
    {
      "id": 470,
      "name": "Rock Torrent",
      "description": "Target a friendly champion occupying Rock. Opposing champions within 5 spaces of target take 10 Physical damage and spaces adjacent to them becomes Unstable Ground for 2 turns.",
      "flavorText": "\"Let the rage of the land consume you fully, then your foes shall know the true extent of her power.\"\r\n~ Geomancer Rivanka",
      "noraCost": 40,
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2BF0Be9BF0Bj9Cj9Deeeeextofxzzmpf",
      "deckLimit": 2
    },
    {
      "id": 342,
      "name": "Runic Seal",
      "description": "Your shrine is protected from 50 damage. This spell does not protect Avatars. This effect does not stack.",
      "flavorText": "\"This is our only home. We must protect it through any means necessary.\" - From the Decree of Protection, mandating the use of Elsari protection runes",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2AF0Ae9Be9Bj9Bj9Ceerqjnhggegnuo",
      "deckLimit": 2
    },
    {
      "id": 211,
      "name": "Sabotage",
      "description": "The next time an opposing relic is deployed within 6 turns, it is destroyed and all enemy champions within 3 spaces of it take 9 Physical damage and are knocked back 2 spaces. This effect is hidden until triggered. This effect does not stack.",
      "flavorText": "\"Don't worry about the Obelisk, M`alta. I think you'll enjoy the modifications I've made to it. I can't say the same of the Deep-elves.\" - K`elim, Elven Ranger",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EE8De9Be9BE8Dj9Ej9Fmsqjrqhinpwqwo",
      "deckLimit": 2
    },
    {
      "id": 40,
      "name": "Sacrifice",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> target real champion you own. You regain Nora equal to 85% of its Nora Cost.",
      "flavorText": "\"Everyone is Nora, even me.\" - Gibir, Sheoul Demon, second-to-last words",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0AE8De9BF0BJ8HJ8Ioqoqjwilyzxthn",
      "deckLimit": 2
    },
    {
      "id": 275,
      "name": "Sandspout",
      "description": "Area of Effect 3: This area becomes sand. At the end of your turns, all enemy champions within the area are <condition value=blinded>Blinded</condition> for 2 turns and all friendly champions become <condition value=stealthed>Stealthed</condition> for 4 turns, and the area of this spell's effect decreases by 1.",
      "flavorText": "\"Expansion. Invasion. These are the words our enemies use. We spread our kingdom into theirs, not because we hope to bury them. We bring immortality! The sand is eternity. We strive for an endless kingdom!\" - Derifos, Dunewalker Lord",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9Be9Be9Bf1BJ8GJ8Hshykeknsqwfxon",
      "deckLimit": 2
    },
    {
      "id": 160,
      "name": "Sandstorm",
      "description": "Area Effect 4: Units within the affected area take 7 Physical damage and champions successfully damaged become <condition value=sandblasted>Sandblasted</condition> for 3 turns. Affected spaces become Sand for 6 turns.",
      "flavorText": "\"The relentless grains had taken the skin from our faces and the edge from our blades. I was amazed they had not also taken our sight.\" - Dalain, Dwarven Fieldscribe",
      "noraCost": 40,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0Ae9Ae9Bf1AJ8HJ8Iygirhvkgpjignn",
      "deckLimit": 2
    },
    {
      "id": 345,
      "name": "Sapping Beam",
      "description": "Target champion loses all AP. For 2 turns, whenever this champion gains AP, it loses an equal amount of AP.",
      "flavorText": "The entire battalion stopped. Moga, G'hern, and even the Cyclops dropped their weapons and sat on the ground. No matter how much the Voil Captain screamed, nobody moved.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HE8DF0Ae9BF0Aj9Ej9Feeigyzxmhnjrqo",
      "deckLimit": 2
    },
    {
      "id": 217,
      "name": "Scapegoat",
      "description": "Target friendly champion is considered to be the target of the next opposing single target or AoE spell casts on a friendly unit.   This effect is hidden until triggered.   If this unit is an invalid target of that spell, this effect will not trigger.",
      "flavorText": "\"I don't know what I did, but I must have made someone mad as pox.\" - Tulbur, The Unluckiest Skeezick",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1Ae9Be9BE8DJ8Jj9Aeiplekjilwvvxo",
      "deckLimit": 2
    },
    {
      "id": 161,
      "name": "Scatter",
      "description": "Target friendly champion gains <ability value=6>Mobility</ability> for 1 turn. Enemy champions within 2 spaces take 5 Physical damage and are knocked back 1 space.\r\n\r\n",
      "flavorText": "Sometimes a guy just needs his space. And sometimes there are frogs in that space.",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 4,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2Ae9Ae9Bf1Aj9Bj9Ceiyvmyknhtmhgpf",
      "deckLimit": 2
    },
    {
      "id": 326,
      "name": "Scold",
      "description": "Target champion becomes <condition value=scolded>Scolded</condition> for 6 turns. If 4 or more friendly champions with Race: Kanen are in play, target champion also loses all AP.",
      "flavorText": "\"He wouldn't listen to me, so I punished him. Now he'll never disobey me again. This is the power of fear.\" - Cultist Reiayko",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9AF0Ae9Be9Aj9Fj9Gkyklwtqhnerllpf",
      "deckLimit": 2
    },
    {
      "id": 119,
      "name": "Scorch the Earth",
      "description": "Area Effect 3: All affected spaces become Shallow Lava (4 Fire damage on entry and when occupied) for 4 turns.",
      "flavorText": "\"Is the work on the fissure vents complete?\" -- \"Yes master...the lava flows are ready.\" - Rexxar before siege of Talus",
      "noraCost": 35,
      "artist": "Kelly Hamilton",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Be9Ae9Be9AJ8IJ8Jgpnnphphknuxvo",
      "deckLimit": 2
    },
    {
      "id": 332,
      "name": "Sea Song",
      "description": "Target unit gains <ability value=1336>Fascinate</ability> and <ability value=1807>Deafening Aura</ability> for the next 8 turns. If the target unit is Mirefolk, it gains <ability value=2563>Flourish</ability> as well.",
      "flavorText": "\"It's the sea, lass. Eriluun is calling to us. That's good fortune to hear her. We'll make it to Gharivol without a hitch.\" - Sebbul Mooneye, captain of the Quickfin",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2AF0Ae9Be9Aj9Bj9Cevfinjwolexoqqf",
      "deckLimit": 1
    },
    {
      "id": 534,
      "name": "Secret Meeting",
      "description": "The closest friendly champion to target friendly champion within 8 spaces becomes <condition value=stealthed>Stealthed</condition> for 4 turns and is relocated to an adjacent space. The relocated champion loses all but 2 AP.",
      "flavorText": "The Aurora did their best to handle the Resurrection, but the spies and threats in the shadows would remain for much longer.",
      "noraCost": 20,
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 4,
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8Df1AG2Ae9Bj9Ej9Feeerlnufigpuzo",
      "deckLimit": 2
    },
    {
      "id": 519,
      "name": "Seismic Disturbance",
      "description": "For 6 turns, when enemy champions make a successful basic attack, spaces within 2 spaces of it becomes Unstable Ground for 3 turns.  This effect is hidden until triggered.",
      "flavorText": "As Zeventrech explored the remains of the Old Empire, the ground would periodically shake. He would later discover that he was setting off long forgotten wards.",
      "noraCost": 25,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "ej9Cj9BG2AF0Be9BG2Aj9Bj9Ceeemsqjilexiwqf",
      "deckLimit": 2
    },
    {
      "id": 221,
      "name": "Serkan's Touch",
      "description": "Target friendly champion gains <ability value=3138>Twisted Essence</ability>, <ability value=1279>Weary</ability> and <ability value=1206>Cripple</ability>.",
      "flavorText": "\"My touch razed a kingdom to the ground, and brought it back up from destruction. I have slain armies, legion innumerable, with my grasp.\" - Serkan, the true Lich King",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3Ae9Be9BE8Dj9Dj9Eemwmjljiphgkrqf",
      "deckLimit": 2
    },
    {
      "id": 292,
      "name": "Setback",
      "description": "Target unit's controller has 15 random undeployed runes in the runedock concealed.",
      "flavorText": "T'anir looked to his comrade, seeing only an obscured and transparent form. He turned to another to ask where he had gone. He was greeted by two eyes, fading into the air.",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1Be9Be9BG2Aj9Aj9Biethrlusjnwfmpf",
      "deckLimit": 2
    },
    {
      "id": 226,
      "name": "Shadow",
      "description": "All non-Avatar, non-Boss champions currently in play become <condition value=stealthed>Stealthed</condition>. They also become <condition value=pacified>Pacified</condition> for 1 turn.",
      "flavorText": "\"Take shelter in shadow. No one will harm you there. Let the darkness soothe you. And when you are ready, emerge with your weapon ready.\" - Elrac, Master of Shadows",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Ae9Be9Be9AJ8Jj9Aemjwxxievfmsfpf",
      "deckLimit": 2
    },
    {
      "id": 41,
      "name": "Shatter",
      "description": "Equipment on targeted champion is destroyed and all champions within 2 spaces become Eviscerated 4. If those champions are equipped, their equipment is also destroyed.",
      "flavorText": "\"That was my favorite shield!\" - Ironfist Dwarf",
      "noraCost": 25,
      "artist": "Shayne Bingham",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9BE8De9BF0AJ8GJ8Herzowtqjlymsxm",
      "deckLimit": 2
    },
    {
      "id": 486,
      "name": "Shattered Fonts",
      "description": "All champions within deployment range of a nora font take 6 Physical damage and champions that are damaged lose 2 AP.\n",
      "flavorText": "\"GET OUTTA HEREEEEEEEEE!\" ",
      "noraCost": 30,
      "artist": "Paul Guzenko",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0BF0Be9Bf1BJ8IJ8Jeemlwziegpukepf",
      "deckLimit": 2
    },
    {
      "id": 99,
      "name": "Shattered Nerves",
      "description": "For 6 turns, target champion loses 2 HP for each AP that it spends to a maximum of 14 per turn (life is lost at end of turns). This effect is hidden until triggered.",
      "flavorText": "\"Their scouts are too effective...Drall, find a way to curse them so we can move about unwatched.\" - Maxxarek",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9AE8De9Bg3Aj9Fj9Giwzknhnshyitqqf",
      "deckLimit": 2
    },
    {
      "id": 413,
      "name": "Sheoul's Fireball",
      "description": "Target champion takes 14 Fire damage and is <condition value=charred>Charred 2</condition>. If this kills the champion, the next closest enemy champion within 4 squares takes 10 Fire damage and is Charred 2 and the next closest enemy champion within 4 squares takes 8 Fire damage and is Charred 2.",
      "flavorText": "\"Fire is a greedy element. A twist of the wrist, a profane word uttered as it's released, and you see? As it incinerates the first target you coax the fire into wanting more, demanding more...\" - Nefari Fireslinger",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0AF0Ae9Bg3AJ8HJ8Iwirwmuvxxqlykpf",
      "deckLimit": 2
    },
    {
      "id": 67,
      "name": "Shield",
      "description": "Area Effect 3: For 4 turns, friendly champions gain <ability value=3266>Combat Awareness 1</ability> and <ability value=1534>Spell Resistance</ability>.",
      "flavorText": "\"Much we can learn from these frozen savages. As they employ ice, so would I use flesh.\" - Serkan, the Lich King",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0AE8De9Bf1BJ8HJ8Iqjpleetfgrzxon",
      "deckLimit": 2
    },
    {
      "id": 122,
      "name": "Skeezick Revolt",
      "description": "A Skeezick Rioter, Trapper and Baiter are summoned within 3 spaces of your Shrine or Avatar. A Draksar Hunter with Hunter: SL and +1 SPD is summoned under your opponent's control within 3 spaces of their Shrine or Avatar.",
      "flavorText": "\"The time of tyranny has ended. We are no longer slaves.\"  - Skeezick General before the uprising",
      "noraCost": 80,
      "artist": "Trevor Claxton",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 16,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Be9Ae9Be9Aj9Aj9Bmhetfxxtuxmphpf",
      "deckLimit": 2
    },
    {
      "id": 425,
      "name": "Slag Slop",
      "description": "Area Effect 2: All spaces within the affected area become Ooze for 6 turns. Opposing champions in the affected area become Poisoned 3, Scoured 3 and Grounded (This champion loses Flying) for 6 turns. The area of effect increases by 1 for each friendly Slag in the area of effect, to a maximum of 5. This spell has a deck limit of 3.",
      "flavorText": "\"Slags gotta be the most disgustin' wretched creatures in the Peaks, next ta moagz that is.\" - Captain Crupz",
      "noraCost": 35,
      "artist": "Christian Fell",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1AF0Be9BE8DJ8Jj9Aeeiggtmhexirfpf",
      "deckLimit": 3
    },
    {
      "id": 348,
      "name": "Slipwater",
      "description": "For 1 turn, whenever an Aquatic or Semi-aquatic unit enters a water space, it gains 1 AP.  This effect can trigger up to 5 times per champion.",
      "flavorText": "At a young age, Boghoppers are already versed in the ebb and flow of the marshlands. It is believed that this knowledge comes naturally to the Boghoppers as a sort of instinct.",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9BF0Ae9BF0AJ8GJ8Hemwqzitjiigygn",
      "deckLimit": 2
    },
    {
      "id": 43,
      "name": "Smite Enemy",
      "description": "Target enemy champion takes 5 Magical damage for each champion with Class: Paladin or Class: Priest within 5 spaces of it, to a max of 25. If the target is killed by this spell, enemy champions within 3 spaces of the champion become <condition value=awestruck>Awestruck</condition>.",
      "flavorText": "\"Serkan's forces were dead once. They can be dead again.\" - Rugolth, King of Ironfist",
      "noraCost": 50,
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 10,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2BE8De9BE8Dj9Cj9Duzxvfmjerjgkjpf",
      "deckLimit": 2
    },
    {
      "id": 356,
      "name": "Smoke Cloud",
      "description": "The next 3 champions you deploy from the runedock are Shadowspawned (This unit comes into play stealthed).",
      "flavorText": "D'elin swung his sword at the cloud of smoke, goading the creature inside to show itself. He saw two eyes appear, then two more, and then another pair. Soon, the cloud was filled with piercing stares and menacing laughter.",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 4,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IE8DF0Ae9BF0Bj9Ej9Fmsmsmsjpuhvmuo",
      "deckLimit": 2
    },
    {
      "id": 468,
      "name": "Smoldering Ashes",
      "description": "Target champion is <condition value=defiled>Defiled</condition> and takes 3 Fire damage at the end of each turn for 6 turns.  If this effect leaves play before the champion is destroyed, you gain 30 nora.",
      "flavorText": "\"Fire burns fast and hard, but long after the rage of the flames have died down, the ashes remain filled with potential energy.  It is from these ashes that we craft our magic.\" ~ Ptoric, Ash Demon",
      "noraCost": 25,
      "artist": "Christian Fell",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1BF0Be9BF0Bj9Aj9Beeeeerzziwqjepf",
      "deckLimit": 2
    },
    {
      "id": 52,
      "name": "Snow Blind",
      "description": "For 8 turns, the next time an opposing spell that targets a single unit is cast, it is instead cast on the closest valid target (from the original). If there is no valid target to redirect to, the spell fizzles.   This effect is hidden until triggered.",
      "flavorText": "\"Shoot you idiot!\"--\"I can't see a thing!\"-- \"Shoot anyway! Just hit something!\"",
      "noraCost": 30,
      "artist": "Shayne Bingham",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9BE8De9Bf1AJ8GJ8Hgtmljwquqjpshn",
      "deckLimit": 2
    },
    {
      "id": 341,
      "name": "Snowball Fight",
      "description": "All champions gain Snowball (This unit makes a Frost attack at range 2-4 for 8 DMG. This damage ignores DEF).",
      "flavorText": "\"It's all fun and games until someone takes amped Frost damage.\" - G'hern Birthmother",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1BF0Ae9Be9Bj9Aj9Bevonshpqqukuqo",
      "deckLimit": 2
    },
    {
      "id": 310,
      "name": "Snowburst",
      "description": "All relics gain <ability value=137>Frost Aura 3</ability> and all spaces within 3 spaces of a relic become Snow (Impeding 1) while that relic is in play.",
      "flavorText": "To the untrained, the Savage Tundra can be cruel. In some parts, a clear sky can turn to a blizzard in a matter of moments. The Jakei know to stay away from these places.",
      "noraCost": 50,
      "artist": "Charles Chen",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 10,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1Be9Be9Bg3Aj9Aj9Bkuszmuzipwvfvqf",
      "deckLimit": 2
    },
    {
      "id": 419,
      "name": "Snowed In",
      "description": "Area Effect 3: At the start of your next turn, enemy units take 8 Frost damage, become Grounded (This unit loses Flying) and Frozen (This unit has -1 DMG, -1 DEF and -1 SPD) for 6 turns, and affected spaces becomes Deep Snow (Impeding 2) for 6 turns. This effect is hidden until triggered.",
      "flavorText": "\"Asistil, before you go you should be wary of their land itself. If the Tundra slips away, so shall you slip into the forbidden caverns.\" - Surah, Nefari Forlorn",
      "noraCost": 30,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Dg3AF0Ae9Bg3Aj9Dj9Eeeeitsxvmsqwqsf",
      "deckLimit": 2
    },
    {
      "id": 108,
      "name": "Snowstorm",
      "description": "Area Effect 4: For the next 6 turns, within the affected spaces, all dirt terrain becomes Snow (Impeding 1), all water terrain becomes ice. All units take 6 Frost damage.",
      "flavorText": "\"Keep your wits about you soldiers...snow is unnatural for this time of year...the Frost ones are near.\" - Draksar Commander",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EE8De9Ae9BE8Dj9Ej9Fqolpyoqhtxtsuo",
      "deckLimit": 2
    },
    {
      "id": 514,
      "name": "Snowtide",
      "description": "For 6 turns, when enemy champions make a successful basic attack, spaces within 2 spaces of it becomes Deep Snow (Impeding 2) for 2 turns.  This effect is hidden until triggered.",
      "flavorText": "\"We have been here for centuries. We will be here for centuries more. The snow is not only our home. It is our protector, and now it is your death.\" - Frost Wing J'kal",
      "noraCost": 25,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9BF0Be9BG2AJ8GJ8Heeeieknnytjlwo",
      "deckLimit": 2
    },
    {
      "id": 429,
      "name": "Snuff",
      "description": "Target champion gains <ability value=2008>Liability</ability>, <ability value=5>Lumbering </ability> and <ability value=2260>Pariah</ability> for 6 turns. This spell refunds 3 nora for each friendly Worm, Skeleton or Zombie, to a maximum of 15.",
      "flavorText": "The weak and feeble should not have to carry the burden of living.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3AF0Be9BE8Dj9Dj9Eeemeknpwosmnwqf",
      "deckLimit": 2
    },
    {
      "id": 118,
      "name": "Soak the Earth",
      "description": "Area Effect 3: All affected spaces become Shallow Water for 5 turns. Friendly units with Amphibious, Semi-Aquatic, or Aquatic within the area gain <ability value=6>Mobility</ability>.",
      "flavorText": "\"There - they went into that cave. Have the Tidemaster drown the mongrels out!\" - Boghopper Scout",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Ae9Ae9Be9AJ8HJ8Ixqwqjtqzkpfgro",
      "deckLimit": 2
    },
    {
      "id": 42,
      "name": "Soul Cage",
      "description": "Target champion becomes <condition value=paralyzed>Paralyzed</condition> for 4 turns and opposing champions within 3 spaces become <condition value=soultapped>Soultapped</condition> for 5 turns. If target champion takes damage, the Paralyzed effect ends.",
      "flavorText": "\"We have no use for your words, as they imply reason. We have no use for reason.\" - Grubdar, Goblin Herder",
      "noraCost": 40,
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1BE8De9BF0Bj9Aj9Bygyggvvqfkerso",
      "deckLimit": 2
    },
    {
      "id": 353,
      "name": "Soul Corruption",
      "description": "Target champion gains Corrupted Soul (At the end of 5 turns, target champion becomes Possessed).  Corrupted Soul cannot be cleansed, but Possessed remains cleansable.",
      "flavorText": "\"When you stand before the Utterdark, you will forget your loyalties. There are no allies in the void, no brothers-in-arms. You will be alone, afraid, hopelessly lost. And when I return you, you will kneel.\" - Serkan, Lich Master",
      "noraCost": 55,
      "artist": "Charles Chen",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 11,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2AF0Ae9BF0Aj9Bj9Cevxouxowkjrjyo",
      "deckLimit": 2
    },
    {
      "id": 261,
      "name": "Soul Feed",
      "description": "Target friendly champion gains <ability value=3013>Soultap Feedback</ability>, <ability value=3026>Soulseeker</ability> and <ability value=1378>Evasive 3</ability> for 6 turns. If target champion dies while this effect is active, you are refunded 20 nora.",
      "flavorText": "The Nefari followed Grimlic into the Underdepths, with the hopes of finding Nora. After years spent in anguish, Grimlic finally gave them their due. He taught them to drink the life from other living things and take their Nora.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3Ae9Be9BF0Bj9Dj9Eeeeeerluoyzxmpf",
      "deckLimit": 2
    },
    {
      "id": 415,
      "name": "Soulbane",
      "description": "Target champion loses 15 HP, if this destroys the champion all opposing champions become Cursed for 2 turns.\r\n",
      "flavorText": "A soul's destruction can cause it to lash out unwittingly against those that would seek to protect it. ",
      "noraCost": 40,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1AF0Ae9Bg3AJ8Jj9Aeeerhgnykroftqf",
      "deckLimit": 2
    },
    {
      "id": 164,
      "name": "Soulfrost",
      "description": "For 6 turns, when target owned champion currently occupying Snow or Ice makes a successful basic attack, you gain 10 nora. This effect does not stack.",
      "flavorText": "\"Perhaps the demon will think twice before it lays into us again,\" said the wolfrider. \"Perhaps,\" replied the shardmaster, \"but probably not.\"",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1Ae9Ae9Bf1AJ8Jj9Aevsmephtqwoquo",
      "deckLimit": 2
    },
    {
      "id": 256,
      "name": "Soulreave",
      "description": "Friendly champions with a basic attack have it replaced with <ability value=1943>Attack: Loss of Life</ability> for 3 turns.",
      "flavorText": "\"Our weapons will wound them, no matter what protections they wear. They will rend their souls.\" - Serkan, Lich Master",
      "noraCost": 40,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0Be9Be9BF0BJ8IJ8Jukukuqsshtxzon",
      "deckLimit": 2
    },
    {
      "id": 543,
      "name": "Southern Wave Discipline",
      "description": "Champions in a 5 space straight line of target champion take 10 Physical damage and are knockbacked 1 if successfully damaged. If any affected champions are friendly monks, they take no damage and opposing champions in a 5 space straight line from that champion take 5 Physical damage and are knockbacked 1 if successfully damaged.",
      "flavorText": "As the monk masters of south and north exchanged ideas, theirs became a process not only of adoption but of adaptation.",
      "noraCost": 40,
      "artist": "Daniel Kamarudin",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1BG2AG2Ae9Aj9Aj9Bphvzmerwkwfvkrf",
      "deckLimit": 2
    },
    {
      "id": 418,
      "name": "Spare Parts",
      "description": "Area Effect 3: Real friendly constructs gain <ability value=2536>Bestow</ability>.",
      "flavorText": "\"Welp, we can't salvage this'n past it's crankdrive casing and nora expulsion unit but I've got a Dervish model those'll fit right into. Give 'em here\"",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2BF0Ae9Bg3Aj9Cj9Dmshrlpymwxvqlrf",
      "deckLimit": 2
    },
    {
      "id": 216,
      "name": "Speed Trap",
      "description": "All enemy champions with 6 SPD or higher have their SPD set to 5 for 5 turns.",
      "flavorText": "Operation: Next Fall was considered the greatest success of Private Firgus Fuzzmaw. It was also his only success.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "EXOTIC",
      "cooldown": 6,
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Be9Be9BE8DJ8IJ8Jmwkymuhvmeeeto",
      "deckLimit": 2
    },
    {
      "id": 73,
      "name": "Spell Trap",
      "description": "Next time an opposing spell is cast, their Shrine or Avatar loses 10 HP.  This effect is hidden until triggered.",
      "flavorText": "\"Valdec lore holds that apprentices were taught humility using spell traps.\"",
      "noraCost": 20,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 4,
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ag3AE8De9Bf1Bj9Dj9Eeruqjplrjnpwqqf",
      "deckLimit": 2
    },
    {
      "id": 113,
      "name": "Spell Ward",
      "description": "All player's spell runes are revealed and the cooldown of each spell rune is increased by 4 turns.",
      "flavorText": "\"Rugolth, I know we all fear the magics that led to the Catastrophe, so our shaman have found a way to delay any arcane spellcasting.\" - Grothbane, Barbarian Commander",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Be9Ae9BE8Dj9Cj9Dkgeegtzmlwmllpf",
      "deckLimit": 2
    },
    {
      "id": 450,
      "name": "Spirit Channeling",
      "description": "Target Hyaenid gains Race: Djinn, <ability value=1>Flight</ability>, <ability value=544>Attack: Magical</ability> and +1 SPD. This champion counts as each type of required champion for Serf To Djinn abilities.",
      "flavorText": "My spirit now flows through you. You are my disciple, my thrall, my instrument of destruction",
      "noraCost": 30,
      "artist": "Christian Fell",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9AF0Be9Be9Bj9Fj9Geerzkuoyrolnso",
      "deckLimit": 2
    },
    {
      "id": 540,
      "name": "Spirits Within",
      "description": "Target champion becomes Soulrifted (At the end of its turns, this champion loses 5 HP. When this effect is removed, 3 Rift Spirits are summoned in adjacent spaces) for 6 turns.",
      "flavorText": "\"The rifts can't open within our own heads, can they? Promise me that doesn't happen... promise me that doesn't happen... promise me...\"",
      "noraCost": 35,
      "artist": "Rogier van de Beek",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9Bf1BG2AG2AJ8GJ8Hqolevvhithitoqf",
      "deckLimit": 2
    },
    {
      "id": 530,
      "name": "Split Personality",
      "description": "For 4 turns, whenever target champion makes a basic attack, the damage is prevented and the attacking champion loses HP equal to that damage. This effect is hidden until triggered. After this effect is triggered, it is removed at the  end of that turn.",
      "flavorText": "\"There are times when I myself don't know what I have done.\" ~ Unknown",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3Ae9BG2Ae9Aj9Dj9Eevsqzilpuouxmsf",
      "deckLimit": 2
    },
    {
      "id": 487,
      "name": "Spontaneous Congregation",
      "description": "For 12 turns, when owner deploys a champion, friendly champions within 6 spaces gain 1 AP.\r\n",
      "flavorText": "Meeting at the watering hole has its perks.\r\n",
      "noraCost": 25,
      "artist": "Nate Abell",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1AF0Be9Bf1BJ8Jj9Aeemetmyiytuhipf",
      "deckLimit": 2
    },
    {
      "id": 116,
      "name": "Spontaneous Growth",
      "description": "Area Effect 2: Champion with Race: Treefolk or Race: Plant gain +5 MAX HP. For the next 4 turns, spaces in area are Vegetation.",
      "flavorText": "\"The forest will grow again, healing the scars of battle.\"",
      "noraCost": 25,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9Ae9Ae9Be9Aj9Fj9Gyilgyzmegnwmhpf",
      "deckLimit": 2
    },
    {
      "id": 376,
      "name": "Spore Pox",
      "description": "Target normal-sized champion becomes an Level 1 Sporegill without Spore Drop for 3 turns.  The unit also becomes Impervious for the duration of this effect.",
      "flavorText": "\"Meememeeemeeemeeee. MEEEMEMEEEEEEEEEE!\" - Garthain, Draksar Lieutenant, victim of the dreaded Mushroom Curse",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2BF0Ae9Bf1Aj9Cj9Dnnshtmphthkepqf",
      "deckLimit": 2
    },
    {
      "id": 513,
      "name": "Stasis Field",
      "description": "Area Effect 3: For 5 turns, at beginning of your turn, opposing champions in the affected area take 8 Magical damage if they are not Paralyzed.  Then, opposing champions become Paralyzed for 2 turns.",
      "flavorText": "The Northern Cross have a history of innovative solutions to common problems.  The Stasis Field was developed by adapting techniques used to herd animals and has proven to be highly effective at controlling hostile movement as well.",
      "noraCost": 35,
      "artist": "Paul Guzenko",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9AF0Be9BG2Aj9Fj9Geeitjroqusqzrqf",
      "deckLimit": 2
    },
    {
      "id": 464,
      "name": "State of Confusion",
      "description": "Target champion becomes <condition value=distracted>Distracted</condition> and <condition value=confused>Confused</condition> for 6 turns.  If this effect leaves play before the champion is destroyed, you gain 25 nora.",
      "flavorText": "\"I always enjoy the look of confusion on their faces when their well laid plans are disrupted.\" ~ Keelir, Voil Jester",
      "noraCost": 30,
      "artist": "Christian Fell",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9BF0Be9BF0BJ8GJ8Heeeeeegnhpukln",
      "deckLimit": 2
    },
    {
      "id": 313,
      "name": "Steal Life",
      "description": "Target champion that has 0 AP or is <condition value=bloodied>Bloodied</condition> loses 12 HP and the closest valid friendly champion heals 12 HP. For each friendly champion with Race: Vampyre in play, you are refunded 2 nora, to a maximum of 10.",
      "flavorText": "All T'irin could see was the image of the fading man. As it approached, he could feel weakness in his body. The image was consuming him slowly, painfully.",
      "noraCost": 40,
      "artist": "Michele Chang",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2Be9Be9Bg3Aj9Cj9Dukwxirlpnhemjrf",
      "deckLimit": 2
    },
    {
      "id": 446,
      "name": "Stellar Horizon",
      "description": "Opposing champions within 5 spaces of target friendly small champion take 10 Magical damage.  If the target is a Wizard, it is healed for 2 for each opposing champion damaged this way.",
      "flavorText": "\"Even a fool can find his way out of the dark, but the wise looks up and finds answers.\" ~ Carlyn, Elven Mage",
      "noraCost": 45,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "EXOTIC",
      "cooldown": 9,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2AF0Be9Be9Aj9Bj9Ceerlwkuoyvhpsqf",
      "deckLimit": 2
    },
    {
      "id": 381,
      "name": "Stitched Possession",
      "description": "Destroy target Stitched champion you own.  The closest opposing champion gains Stitched Possessed (At the beginning of each turn, this champion deals 6 Psychic damage to the friendly champion with greatest HP within 6 spaces) and Depression (All champions within 3 spaces of this unit have -2 DMG).",
      "flavorText": "The strange doll stared back at R'oen with painted eyes on a wooden mask. He heard murmurs behind him. He ignored them at first, but as they drew closer he felt compelled to listen. The voices became clear, familiar, trustworthy. They wanted the best for R'oen and he for them.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0AF0Ae9Bf1BJ8HJ8Ihilnuonpftmpuo",
      "deckLimit": 2
    },
    {
      "id": 263,
      "name": "Stormwrack",
      "description": "Target champion takes 10 Electric damage.  Units successfully damaged become Paralyzed 2 (This champion can not move or use attacks or abilities. This champion has -2 DEF and it loses all AP at the start of each turn. It cannot engage other Champions and loses Paralyzed if it becomes damaged).",
      "flavorText": "The storms over the Shattered Peaks were more severe. Traveling within the Peaks became an even greater hazard. However, with their Elemental's power, the Cyclopes learned to harness the storms.",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9Ae9Be9Bf1Aj9Fj9Gklgkwvkrzzigepf",
      "deckLimit": 2
    },
    {
      "id": 472,
      "name": "Strategic Retreat",
      "description": "Target friendly champion is healed for 15 HP and relocated up to 4 spaces away from the closest enemy champion.",
      "flavorText": "\"The invaders have a strange attachment to not moving.  Their lethargy will be our weapon.\"",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JE8DF0Be9Bf1Aj9Ej9Feepnwojtxkygepf",
      "deckLimit": 2
    },
    {
      "id": 132,
      "name": "Strength in Numbers",
      "description": "Target champion you own and control and each champion that shares a race with it gets +1 HP for each champion affected this way. If there are 4 or more champions affected, they also gain +1 DMG and +1 DEF each. This effect lasts for 5 turns.",
      "flavorText": "Many warriors battling for a cause wreak much more havoc than a lone champion.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "EXOTIC",
      "cooldown": 7,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Be9Ae9Be9Bj9Cj9Derlyvvhephgkuo",
      "deckLimit": 2
    },
    {
      "id": 136,
      "name": "Strength of Stone",
      "description": "For 4 turns, friendly champions gain <ability value=47>Resistance: Physical 2</ability>.",
      "flavorText": "\"Thandar took what should have been a killing blow, standing rigid and defiant as though a column of stone. At that moment, I knew my destiny lay within the earth - indeed, was the earth itself.\" - Reirak, Rock Guardian Initiate",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9Be9Ae9BF0AJ8GJ8Heiyiipyrztzmym",
      "deckLimit": 2
    },
    {
      "id": 137,
      "name": "Strip Armor",
      "description": "Until end of turn, all champions gain <ability value=2001>Defenseless</ability>.",
      "flavorText": "The full implications of wearing metal undergarments hit Urthal like a cold, brisk wind.",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0Ae9Ae9BF0AJ8HJ8Ivoszmlgvqfkygn",
      "deckLimit": 2
    },
    {
      "id": 201,
      "name": "Stronghold",
      "description": "All enemy champions within 5 spaces of friendly Nora Fonts and Shrines take 10 Physical damage.  Units successfully damaged lose 1 AP and are knocked back 1 space.",
      "flavorText": "\"I don't want to lose another outpost, because our defenses couldn't cut it. We need something better, Feofil. Tell them we need something that fights back.\" - King Rugolth of Ironfist",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DE8De9Ae9Bg3Aj9Ej9Foqoqukrjirhtoqf",
      "deckLimit": 2
    },
    {
      "id": 386,
      "name": "Stunning Repercussion",
      "description": "The next time target champion you control is damaged by an attack, the attacking champion becomes <condition value=stunned>Stunned</condition> for 3 turns. This effect is hidden until triggered.",
      "flavorText": "Even a sure thing sometimes isn't. Enemies of the Ironfist often learn this, usually too late.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2AF0Ae9Bf1Bj9Bj9Cevkpwzgkpnygpqf",
      "deckLimit": 2
    },
    {
      "id": 81,
      "name": "Suicidal Attack",
      "description": "Target real champion you own gains +5 DMG, <ability value=1486>Strike</ability> and <ability value=2324>Pounce</ability>. After 4 turns this champion is destroyed.",
      "flavorText": "\"We had 'im outnumbered ten to one. But the little bugger kept on comin' despite it all.\" - Dugon, Mountain Garu Chieftain",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9BE8De9BG2AJ8GJ8Hkusmnnuqjigvon",
      "deckLimit": 2
    },
    {
      "id": 254,
      "name": "Summon Ant",
      "description": "Summon a Polar Ant with <ability value=655>Skirmisher</ability> and full AP to target space.  It is removed from play at the end of your turn.",
      "flavorText": "When threatened, the Polar Ant emits an audible screech to alert its colony. The Lonx learned to mimic the screech, to gain their help in battle.",
      "noraCost": 65,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 13,
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9Be9Be9BF0BJ8GJ8Hgygygpyzohethn",
      "deckLimit": 2
    },
    {
      "id": 144,
      "name": "Summon Borghas ",
      "description": "Summon a Borghas Demon champion under your control on target space (0 DEF, 0 SPD, 0 RNG, 0 DMG, 10 HP, Fire Aura 1, Resistance Fire 2, Fire Volatility, Immobile and Mythical).",
      "flavorText": "\"Though immense while in larval form, adult borghae are no larger than dragon eggs and are often worn by young Nefari as hats.\" - Etchen, the Chronicler",
      "noraCost": 40,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IE8De9Ae9BF0Bj9Ej9Fgygygykuxtjrqo",
      "deckLimit": 2
    },
    {
      "id": 195,
      "name": "Summon Dragon",
      "description": "All <mechanic value=dragonkin>Dragonkin</mechanic> are revealed in your dock. The next dragonkin you deploy this turn will gain 4 AP.",
      "flavorText": "\"I call to you, kin of Vindrax! The Draksar call to you for guidance. Aid us in destroying our enemies!\" - Avix, Draksar Broodqueen",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0Be9Ae9BG2BJ8IJ8Jwvzieeeiiexfgpf",
      "deckLimit": 2
    },
    {
      "id": 270,
      "name": "Summon Trap Spider",
      "description": "Summon a shadowspawned Trap Spider to a target space.",
      "flavorText": "Upper Sheoul is teeming with K`lzik's children. Spiders lay in wait, ready to pounce on any who dare to enter.",
      "noraCost": 80,
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 16,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2Ae9Be9Bf1Aj9Bj9Cevxklpyoqfigipf",
      "deckLimit": 2
    },
    {
      "id": 238,
      "name": "Summoning Ritual",
      "description": "<mechanic value=sacrifice>Sacrifice</mechanic> target Dwarf champion you own. A Stone Colossus (with 7 SPD) is summoned in the nearest available deployment zone location.",
      "flavorText": "\"My father, Feodin, gave his life to protect the Stronghold. His sacrifice was rewarded with immense power, but the price he paid was just as great.\" - Feofil, Advisor to King Rugolth",
      "noraCost": 55,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 11,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Ae9Be9Be9Bj9Bj9Ceeiyzmsohilpso",
      "deckLimit": 2
    },
    {
      "id": 84,
      "name": "Superiority",
      "description": "All champions within 5 spaces of target champion which do not share a race with that champion take 13 Psychic damage. If target champion is Race: Demon, those champions also have -2 DMG for 2 turns.",
      "flavorText": "That night, the forest echoed with the screams of all within, save for the demons, who howled in joy at the sound.",
      "noraCost": 45,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 9,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0BE8De9BG2BJ8IJ8Jgthgtuqhtufgepf",
      "deckLimit": 2
    },
    {
      "id": 237,
      "name": "Suppress",
      "description": "Target champion is Distracted 4 (This unit only activate basic attacks) and Pacified 4 (This champion cannot attack or use abilities to attack, and cannot engage other champions.  This cannot be cleansed).\r\n\t\t\t\t\t\r\n",
      "flavorText": "\"If you don't want them swinging swords at you, you gotta take care of their arms. I prefer to tie them behind the back, so they can't get to any boot knives.\" - Kulman Stonebrow",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1Be9Be9Be9Bj9Aj9Berluxqwoufvxon",
      "deckLimit": 2
    },
    {
      "id": 286,
      "name": "Swap",
      "description": "Target opposing champion swaps location with the nearest valid friendly champion within 8 spaces of the same size. This is a relocation effect when moving the opposing champion.",
      "flavorText": "Both Kanen and Leoss paused. A momentary silence fell over the scene, as a lone Leoss grasped for an explanation. Finding none, he roared and drove his spear into the closest Kanen.",
      "noraCost": 55,
      "artist": "Michele Chang",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "EXOTIC",
      "cooldown": 11,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9Be9Be9BG2AJ8GJ8Hsmwkuxferztqso",
      "deckLimit": 2
    },
    {
      "id": 139,
      "name": "Swiftwind",
      "description": "Area Effect 2: Champions within the affected area gain 1 AP and gain <ability value=597>Unstoppable</ability> for 4 turns.",
      "flavorText": "\"Despite our efforts, the meddlesome fairy could not be contained. Before I knew it, my squad was engaged in an all-out brawl over who, among them, would have the tiny pest's hand in marriage.\" - Gen. Skizm Skragg, War Journal",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1Ae9Ae9BF0AJ8Jj9Aeruqwofxvxfgnn",
      "deckLimit": 2
    },
    {
      "id": 117,
      "name": "Swimming Lessons",
      "description": "For 5 turns, friendly champions have <ability value=2>Amphibious</ability>.",
      "flavorText": "\"If we're gonna take the swamp, you're gonna have to learn to swim...\" - Moga camp instructor",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 4,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9Be9Ae9Be9AJ8GJ8Hsqlegklwvvvmnn",
      "deckLimit": 2
    },
    {
      "id": 103,
      "name": "Taint",
      "description": "Target champion gains Race: Draksar, <ability value=117>Regeneration 3</ability> and <ability value=879>Draconic Force</ability>. If champion already has Race: Draksar, it also gains <ability value=2691>Mutation: Horror</ability> and <ability value=2261>Violence Charged 1</ability>.",
      "flavorText": "\"It is really only the act of Changing that hurts...I think you'll find that your sense of pain is quite different once you're finished\" - Draksar youth to his changing brother",
      "noraCost": 30,
      "artist": "Kelly Hamilton",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1AE8De9Bg3AJ8Jj9Aeeempqqqftuxmpf",
      "deckLimit": 2
    },
    {
      "id": 479,
      "name": "Tales of Valor",
      "description": "Target champion gains <ability value=2857>Courage</ability> (This unit has +2 DMG (up to 6) and +1 DEF (up to 3) for every 8 HP it is missing). If target champion has Race: Barbarian, it also gains 2 AP.",
      "flavorText": "\"And this scar here, well was given this by Vindrax himself!\" - Barbarian under the influence of black label brew.\r\n",
      "noraCost": 30,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2AF0Be9Bf1Aj9Bj9Ceevkjtjrluxfmpf",
      "deckLimit": 2
    },
    {
      "id": 448,
      "name": "Tendrils of the Deep",
      "description": "Area Effect 3: For 5 turns, champions without <ability value=2>Amphibious</ability> moving out of the area of effect take 8 Physical damage and become <condition value=ensnared>Ensnared</condition> for 3 turns. Affected spaces also becomes Water (Impeding 1) for 5 turns.",
      "flavorText": "The Emerald Lake is one of the few areas of Poxanthuru that remains largely unexplored.  Some say the lake is sentient and protects itself against intrusion.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3AF0Be9Be9Aj9Dj9Eeevowfvmuvssfrf",
      "deckLimit": 2
    },
    {
      "id": 102,
      "name": "Thaw",
      "description": "For the next 4 turns, enemy champions that enter play or are summoned take 4 Physical damage and gain <ability value=1102>Trail: Sand</ability> and <ability value=88>Vulnerability: Fire</ability> permanently.",
      "flavorText": "\"It is really quite simple...the Tundra lies far above the Stronghold...if we melt its glaciers, then all of Rugolth's kingdom shall be flooded!\"",
      "noraCost": 35,
      "artist": "Trevor Claxton",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0BE8De9Bg3AJ8IJ8Jkuvmjiytjlgyipf",
      "deckLimit": 2
    },
    {
      "id": 311,
      "name": "The Ailur Concord",
      "description": "All friendly Jakei gain <ability value=1775>Precision</ability>, all friendly Lonx gain <ability value=1783>Subsume</ability> and all friendly Leoss gain <ability value=1327>Domain: Vegetation</ability>.  ",
      "flavorText": "\"Know that you have allies in the Savage Tundra. Although things seem bleak, we will always stand beside you. Your kingdom will not fall.\" - J'orea, Queen of J'thir",
      "noraCost": 25,
      "artist": "Andrew Hou",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bg3Ae9Be9BG2Aj9Dj9Eeeiymyvkphyierf",
      "deckLimit": 2
    },
    {
      "id": 130,
      "name": "Thorn Collection",
      "description": "Area Effect 3: All spaces within the affected become vegetation for 6 turns, Champions and Relics take 12 physical damage and Shrines take 3 damage. The owner of this spell gains nora equal to 25% of the actual damage dealt by this spell at the end of the turn.",
      "flavorText": "\"Spirit of K'thir - I bid you rain thorns upon the intruders, and in doing so, return the power of the forest to its rightful owners.\" - Elven Druid",
      "noraCost": 50,
      "artist": "Gabriel Garza",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LEGENDARY",
      "cooldown": 10,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Ae9Ae9Be9Bj9Bj9Ceevkumhvhnpsqo",
      "deckLimit": 2
    },
    {
      "id": 121,
      "name": "Threads of Ice",
      "description": "For 3 turns, target champion is encased in Ice Threads. While affected by Ice Threads, target champion is Paralyzed (This champion can not move or use attacks or abilities. This champion has -2 DEF and it loses all AP at the start of each turn. It cannot engage other Champions and loses Paralyzed if it becomes damaged) and takes 50% more Frost damage. This effect is removed if this champion takes damage. For each friendly champion with Attack: Frost in play, this spell is refunded 3 nora to a maximum of 15.\n",
      "flavorText": "\"Hey, Glark is looking a little blue....\" - Draksar Scout",
      "noraCost": 40,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 8,
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9Ae9Ae9Be9Bj9Fj9Gemnlpsxzvhexmn",
      "deckLimit": 2
    },
    {
      "id": 106,
      "name": "Throw Bones",
      "description": "Target owned Undead champion is destroyed and Friendly Witch champions gain 2 AP and +2 DMG.",
      "flavorText": "\"Since the Catastrophe, many have abandoned the gods in favor of the old folk magics.\"",
      "noraCost": 35,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 7,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2BE8De9Bg3Aj9Cj9Doqhnwvhvssoferf",
      "deckLimit": 2
    },
    {
      "id": 375,
      "name": "Time Slip",
      "description": "Target friendly champion loses all AP and is disabled (cannot activate any abilities, gain AP, and is stationary) for 2 turns. At the end of target champion's turn, its SPD is set to 20 for 2 turns and gains Skirmisher for 2 turns.",
      "flavorText": "It was as if the Veasal had vanished. As Uzsar turned to his comrades, he saw they had fallen. And the Veasal was charging again.",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "ej9AJ8JG2AF0Ae9Bf1Aj9Bj9Cemwvkgrqzmegkpf",
      "deckLimit": 2
    },
    {
      "id": 44,
      "name": "Tornado",
      "description": "Area Effect 2: All champions become <condition value=grounded>Grounded</condition> for 2 turns and take 12 Physical damage. All relics take 20 Physical damage and all Shrines take 5 Physical damage. (This damage to Shrines cannot be reduced.)",
      "flavorText": "\"Since the Catastrophe, even the winds in Old Valdac are cursed.\" - Menalaus, Elven Priest",
      "noraCost": 45,
      "artist": "Dan Kopycienski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2AE8De9BF0Aj9Bj9Ceitftjgyoqjpso",
      "deckLimit": 2
    },
    {
      "id": 349,
      "name": "Tortun Cannon Barrage",
      "description": "Area Effect 2: For each real friendly Tortun (up to 5), a random space is targeted by an AE1 Cannon Ball effect. Units affected by the Cannon Ball effect take 10 Physical damage (this damage ignores DEF). ",
      "flavorText": "\"The marker's ready! Fire positions! Come on, chaps! Let's give those blokes what they're askin' for!\" - Cpt. Bregin Longeye of the Gygurnaut",
      "noraCost": 45,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0AF0Ae9BF0AJ8HJ8Irzgvsonlwofpjn",
      "deckLimit": 2
    },
    {
      "id": 151,
      "name": "Touch of Death",
      "description": "Target champion gains <ability value=94>Vulnerability: Disease</ability> and loses 3 HP per turn for 6 turns. If this effect ends or is removed before this champion is destroyed, you are refunded 20 nora.",
      "flavorText": "\"Suddenly, Talamae's face took on a deathly pallor - her vitality draining by the second. Fortunately, our only dilemma was deciding how to cleanse her of the insidious ailment.\" - Valinor, Elven Mage",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2Ae9Ae9BF0Bj9Bj9Ceeeeevsmjpsjyo",
      "deckLimit": 2
    },
    {
      "id": 358,
      "name": "Touch of Vindrax",
      "description": "Target friendly champion gains <ability value=99>Life Siphon</ability> and <ability value=1760>Impatient</ability>. If it has a nora cost of less than 80 and does not have Short Lived, it also permanently gains <ability value=875>Short Lived 1</ability>.",
      "flavorText": "The Dragon Gods, Valdac and Vindrax, act as balancing forces. Where Valdac is the creator, Vindrax is the destroyer. It is said that those, touched by the Avatar of Destruction, have the same urge to destroy life.",
      "noraCost": 30,
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9BF0Ae9BF0BJ8GJ8Hqoqoqjeilwxojn",
      "deckLimit": 2
    },
    {
      "id": 405,
      "name": "Treefolk's Blessing",
      "description": "Target champion gains <ability value=48>Resistance: Physical</ability> and <ability value=117>Regeneration 3</ability> for 6 turns. If the target is a Plant, it also gains <ability value=106>Camouflage</ability>  for 6 turns",
      "flavorText": "\"Even the smallest of creatures can sometimes have the greatest impaa-zzzZzzZ zzzZzzz.\" - K'thun the Ancient",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 5,
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1AF0Ae9BG2BJ8Jj9Aeiymufkgiirfpqf",
      "deckLimit": 2
    },
    {
      "id": 86,
      "name": "Tribe War",
      "description": "Two Cyclops Maulers appear within 3 spaces of each player's Shrine or Avatar, under that player's control with Skirmisher.",
      "flavorText": "Even under the Voil's cruel supervision, the rivalries between the cyclops tribes persist.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0AE8De9BG2AJ8HJ8Iinlnhvkwtsqqso",
      "deckLimit": 2
    },
    {
      "id": 45,
      "name": "Truce",
      "description": "Your shrine loses 25 hp and all champions become <condition value=pacified>Pacified</condition> for 3 turns. Any champions that enter play before the effect ends also become Pacified for the remaining duration.",
      "flavorText": "\"Do not be so eager to shed blood as to forget that the reason you were doing so was to end bloodshed.\" - Menalaus, Elven Priest to Godwin, Elder Garu",
      "noraCost": 35,
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2BE8De9Be9Aj9Cj9Dohnsmuzkeegknpf",
      "deckLimit": 2
    },
    {
      "id": 420,
      "name": "Tundra Discipline",
      "description": "Area Effect 3: Friendly champions gain +1 DMG and <ability value=540>Attack: Frost</ability> for 6 turns.  If the champion is a Ferren, it also gains <ability value=2542>Savage Exploit</ability> for 6 turns.",
      "flavorText": "Jakei historians now believe that Nohkan Do may have been inspired by observing the blurred movements and impossibly precise strikes of the Ferren.",
      "noraCost": 30,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EE8DF0Be9BE8Dj9Ej9Feeetztmlwxinepf",
      "deckLimit": 2
    },
    {
      "id": 135,
      "name": "Unbending Force",
      "description": "For 3 turns, this champion cannot fall below 1 HP and has <ability value=655>Skirmisher</ability>. While this effect is in play, this champion can not be healed. If this unit costs less than 80 nora it is destroyed when the effect ends. This effect is hidden until triggered. ",
      "flavorText": "The forces of Ironfist are stubborn and battlehard.  It is said that they can even hold off death until they fulfill their duty.",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9Ae9Ae9BF0Aj9Fj9Gigklpsjgythrqo",
      "deckLimit": 2
    },
    {
      "id": 205,
      "name": "Undertow",
      "description": "Target an unoccupied Water space. The nearest normal-sized enemy champion within 4 spaces is relocated there.",
      "flavorText": "In the Forglar Swamp, an unskilled foot can find peril if it steps too close to the water's edge. A skilled foot can use this peril to its advantage.",
      "noraCost": 50,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "cooldown": 10,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0Be9Ae9Bg3AJ8IJ8Joqolrosuhgkykpf",
      "deckLimit": 2
    },
    {
      "id": 46,
      "name": "Unobstructed View",
      "description": "For 4 turns, all enemy Stealthed champions and relics lose <condition value=stealthed>Stealthed</condition>.",
      "flavorText": "\"How can you hide, when there are no shadows?\" - Andeson, Deep Elf Scout",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8DE8De9Be9Aj9Ej9Foquvsjyigtmpwo",
      "deckLimit": 2
    },
    {
      "id": 133,
      "name": "Unstable Ground",
      "description": "Area Effect 3: For the next 6 turns, when a non-Flying champion enters one of the affected spaces through normal movement, it takes 5 Physical damage.",
      "flavorText": "Sometimes all the research, planning, and training in the world can't make up for an uneven playing field.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gg3Ae9Ae9Be9Bj9Dj9Eeemepuvfkrfexo",
      "deckLimit": 2
    },
    {
      "id": 202,
      "name": "Valiant Sacrifice",
      "description": "Sacrifice a champion you own. The nearest friendly champion is healed for up to half the sacrificed champion's nora cost, and your shrine is healed for 15.",
      "flavorText": "\"Durmil stayed to stand against Serkan's advancing legion. If it wasn't for his sacrifice, we would have suffered terrible loss.\" - Gedden, Paladin of Ironfist",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9Ae9Ae9Bg3Aj9Fj9Gsmjluvszthgvsqf",
      "deckLimit": 2
    },
    {
      "id": 76,
      "name": "Valor",
      "description": "If there are fewer friendly champions than opposing champions, each friendly champion gets +5 DMG, and +2 DEF and +5 HP for 2 turns.",
      "flavorText": "\"Think we can do this?\" -- \"Yah ... we can take `em.\"",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2BE8De9BG2Aj9Cj9Dszmsumjtfthyrqf",
      "deckLimit": 2
    },
    {
      "id": 312,
      "name": "Vampirism",
      "description": "Area Effect 3: Friendly champions in target area with Race: Vampyre gain <ability value=2595>Hunter: Bloodied</ability> and <ability value=2434>Leech Vitality</ability> for 6 turns. Enemy champions in target area become <condition value=bloodied>Bloodied</condition> for 6 turns.",
      "flavorText": "\"For their crimes, they were given a hunger that could not be fulfilled with food. Over time, they learned that this craving was for the very essence of life.\" - excerpt from The Vampyre's Curse",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 8,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2Ae9Be9Bg3Aj9Bj9Ceeevvsjlpqhierf",
      "deckLimit": 2
    },
    {
      "id": 515,
      "name": "Verdant Promise",
      "description": "Target owned champion gains <ability value=2666>Guiding Spirit</ability> and the effects of <ability value=1087>Take Root</ability>.",
      "flavorText": "The forest is as old as it is powerful; it will protect those who dwell within its borders. Nature always keeps its promise.",
      "noraCost": 35,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0AF0Be9BG2AJ8HJ8Ieevxoluxiwfiepf",
      "deckLimit": 2
    },
    {
      "id": 546,
      "name": "Verdict of Derifos",
      "description": "Target champion takes 8 Physical damage becomes <condition value=blinded>Blinded</condition> for 2 turns and spaces within 5 spaces of that champion become Sand for 4 turns. If the champion already occupied Sand, it becomes Blinded and gains <ability value=2266>Wandering</ability> for 2 turns instead.",
      "flavorText": "Derifos is as pitiless as the dunes he calls home. To outsiders, it's cruelty; to his acolytes, it's justice.",
      "noraCost": 35,
      "artist": "Markus Erdt",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1BG2AG2AF0Bj9Aj9Bukukljiiytfxvqf",
      "deckLimit": 2
    },
    {
      "id": 304,
      "name": "Vertical Push",
      "description": "Target champion is removed from play and closest friendly real champion gains <ability value=2474>Font Ignorance</ability> for 3 turns. After 3 turns, this champion is returned to play in a random unoccupied location 1-4 squares from the location where it was launched, has its HP adjusted to before it was removed from play and takes 18 Physical damage. If there are no valid locations, the redeployment effect is delayed for 1 turn. This spell cannot target champions with Flying or Earthbound. If the champion is equipped, the nora cost of the equipment is refunded for the equipment's owner.",
      "flavorText": "\"And you thought we Cultists were defenseless without our hordes? A painful lesson, isn't it? It's a pity you won't survive to learn from this mistake. Goodbye, kitten.\" - Cultist Rieayko\r\n",
      "noraCost": 55,
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 11,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2Ae9Be9BG2Bj9Bj9Cerlggyojigigvqf",
      "deckLimit": 2
    },
    {
      "id": 536,
      "name": "Vex Cor Pram",
      "description": "Target champion loses all DEF for 1 turn. Champions within 3 spaces take Acid damage equal to 3 times the DEF lost, to a maximum of 15 (this includes the target if it is an enemy champion).",
      "flavorText": "Vex's gifts are many, though not all receive them well.",
      "noraCost": 30,
      "artist": "Paul Guzenko",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1Af1AG2Af1BJ8Jj9Aevkgevsjronevqf",
      "deckLimit": 2
    },
    {
      "id": 355,
      "name": "Volcanic Burst",
      "description": "At the beginning of your next turn, all units within 2 spaces of target space takes 15 Fire damage and all affected spaces becomes Shallow Lava for 4 turns. This effect is hidden until triggered.",
      "flavorText": "\"We were told the volcano on Maljara was dormant, that it had been for centuries. As the Furies advanced up the Crown of Kiergana, the ground began to shiver. Before they reached the summit, the peak was ablaze.\" - H'aliel, Priest of K'thir",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hg3AF0Ae9BF0Aj9Dj9Eemwilumllyvxkpf",
      "deckLimit": 2
    },
    {
      "id": 47,
      "name": "Vortex",
      "description": "Target champion without <ability value=680>Planar Bound</ability> loses all AP and is moved to the furthest location in its owner's Shrine deployment zone. If there is no valid location for the unit, it is relocated to the closest available space to the owner's Shrine or Avatar and becomes <condition value=crystallized>Crystallized</condition> for 2 turns. The closest friendly real champion to the target gains <ability value=2474>Font Ignorance</ability> for 3 turns.",
      "flavorText": "\"I may not wish to kill them, but I can certainly remove them from my home.\" - Menalaus, Elven Priest",
      "noraCost": 45,
      "artist": "Dan Kopycienski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "cooldown": 9,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2AE8De9Be9Aj9Bj9Ceipuhggpqufmjpf",
      "deckLimit": 2
    },
    {
      "id": 323,
      "name": "Votaev's Grasp",
      "description": "When target opposing normal-sized champion is destroyed, a copy of it is summoned under your control in the closest friendly deployment zone with <ability value=876>Short Lived 2</ability>, <ability value=563>Initiative 2</ability> and <ability value=1237>Impenetrable</ability>.",
      "flavorText": "When a demon is ready to return from death, the Ferryman pulls it from the river and takes it to the shore. After that, it is up to the demon to find its way back to Upper Sheoul.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2BF0Ae9BE8Dj9Cj9Dnnjnhknhvzxmpqf",
      "deckLimit": 2
    },
    {
      "id": 175,
      "name": "Wake the Dead",
      "description": "For 8 turns, the next time an opposing champion captures a nora globe, 3 Grave Warriors are summoned in the closest available spaces to it. This effect is hidden until triggered.",
      "flavorText": "\"We will no longer allow their putrid growth to overcome our lands. Serkan beckons you. Join him in his crusade against life.\" - Xulos, Advisor to Serkan",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9Ae9Ae9BG2Aj9Fj9Ggthggevsqofxkpf",
      "deckLimit": 2
    },
    {
      "id": 363,
      "name": "Warchief Inauguration",
      "description": "Target champion gains <ability value=2875>Warchief: Blood Clan</ability> and +1 DMG and +5 HP for each Warchief ability it has. <ability value=2875 popup=false>Warchief: Blood Clan</ability> does not stack. If target champion has Race: Barbarian, it also gains <ability value=1379>Blood Bond 1</ability>.",
      "flavorText": "Barbarians believe that anger resides in the blood. To truly lead, one must understand their own blood.",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "cooldown": 6,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2BF0Ae9BF0Bj9Cj9Dkukuofrojthekpf",
      "deckLimit": 2
    },
    {
      "id": 382,
      "name": "Waylay",
      "description": "For 6 turns, if an opposing champion enters a friendly deployment zone, a Skeezick Ruffian with no upgrades is summoned in the closest unoccupied space to the opposing unit within that deployment zone.  This effect is hidden until triggered.",
      "flavorText": "The Skeezicks are Valdac's primary guerrilla fighting force. They put their tactics to use in defending strategic locations, making use of their environment to gain the advantage against attackers.",
      "noraCost": 45,
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "cooldown": 9,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0BF0Ae9Bf1BJ8IJ8Jqsfeiiygegrlyo",
      "deckLimit": 2
    },
    {
      "id": 48,
      "name": "Weaken",
      "description": "For 4 turns, target champion gets -1 DEF, -2 SPD and -10 DMG.",
      "flavorText": "\"He was much too strong for my tastes. I prefer foes that are more easily slain.\" - Xulos, Apprentice to Serkan",
      "noraCost": 30,
      "artist": "Shayne Bingham",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gg3AE8De9Be9Bj9Dj9Eeeipquxvxmsfvo",
      "deckLimit": 2
    },
    {
      "id": 109,
      "name": "Weather Harden",
      "description": "Target champion gains <ability value=600>Arctic</ability>, <ability value=1900>Tough 1</ability> and +5 max HP. This spell cannot target units that already have Arctic.",
      "flavorText": "\"Hayith, I need you to travel far to the north, into the frigid wastes- the Shardmasters shall protect you from the harshness of the cold.\" - J'orea, Jakei Frost Queen",
      "noraCost": 20,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Ae9Ae9BE8Dj9Fj9Gzvhkrftxknyoyo",
      "deckLimit": 2
    },
    {
      "id": 474,
      "name": "Whispers of the Mind",
      "description": "The next time target champion makes a basic attack within 4 turns, that attack misses and the champion loses all AP and becomes Distracted 4. This effect is hidden until triggered.",
      "flavorText": "She watched helplessly as the blade slipped from her grasp, missing its target by a wide margin. In a moment that seemed to last forever, one word repeated in her mind: \"Slag slag slag slag slag...\"",
      "noraCost": 35,
      "artist": "Conceptopolis",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9BF0Be9Bf1AJ8GJ8Heemphpnnnyiyon",
      "deckLimit": 2
    },
    {
      "id": 527,
      "name": "Whispers of the Veil",
      "description": "Target champion without a Buffer gains a Buffer of 5 HP per friendly champion with Race: Spirit (to a maximum of 30 HP).",
      "flavorText": "\"We call upon the spirits who have walked the circle path, join us once again in the mortal realm, for we have need of your protection.\" ",
      "noraCost": 25,
      "artist": "Alex Konstad",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "cooldown": 5,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Ae9BG2Ae9AJ8Jj9Aemerjepsuzklpqf",
      "deckLimit": 2
    },
    {
      "id": 525,
      "name": "Winged Purpose",
      "description": "Area Effect 3: Friendly champions with a Flight or Sigil ability heal for 10 HP and gain <ability value=1900>Tough 1</ability> and <ability value=1476>Resilient</ability> for 4 turns and have their Sigils triggered.",
      "flavorText": "Despite their long absence, the Wings of Al'mara's resurgence has been smooth and met only with enthusiasm within the Stronghold.",
      "noraCost": 35,
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "cooldown": 7,
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Ae9BG2Ae9AJ8HJ8Ikwfrhigneknlgpf",
      "deckLimit": 2
    },
    {
      "id": 458,
      "name": "Wings of Glory",
      "description": "Area Effect 3: Friendly champions with a Flight or Sigil ability gain 2 AP and gain <ability value=1242>Pace</ability> and <ability value=1214>Encouraged</ability> for 4 turns.",
      "flavorText": "The return of the Wings of Al'mara has inspired all the warriors of the Stronghold.",
      "noraCost": 35,
      "artist": "Christian Fell",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1BF0Be9BF0Aj9Aj9Bevshgyowxmymwo",
      "deckLimit": 2
    },
    {
      "id": 267,
      "name": "Wings of Steel",
      "description": "Real voil and bats you currently control lose Flying and get +1 DEF and +10 MAX HP. This does not stack.",
      "flavorText": "\"We preserve Hiistzine, whatever it takes. If they make us fight on the ground, then we fight with wings of steel. If you've lost your sword, you fight with your claws.\" - Sceian, Lance Admiral of the Voil Army",
      "noraCost": 35,
      "artist": "Michele Chang",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 7,
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0Be9Be9Bf1AJ8IJ8Jmwvkpfgipsztso",
      "deckLimit": 2
    },
    {
      "id": 154,
      "name": "Winter's Shroud",
      "description": "For 4 turns, the next time target friendly champion is attacked, the attack misses. When this triggers, 4 illusions of the target are created randomly within 2 spaces of the attacker. This effect is hidden until triggered.",
      "flavorText": "Masters of illusionary magic, the Jakei have spells that can trick you into seeing an army from a single warrior, or trick you into seeing nothing at all. ",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "cooldown": 5,
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JE8De9Ae9Bf1Aj9Ej9Fqolpwzmlpfrluo",
      "deckLimit": 2
    },
    {
      "id": 374,
      "name": "Wish",
      "description": "Target champion gains a copy of the nearest equipment in play. Equipment generated by this spell cost 0 nora.",
      "flavorText": "\"In dark times, it is always good to have a glimmer of hope; to believe in the unbelievable. These little glimmers keep us from despair.\" - K'ento, Jakei Disciple",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "cooldown": 6,
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1BF0Ae9Bf1Aj9Aj9Bqljipuxklyiigpf",
      "deckLimit": 2
    },
    {
      "id": 454,
      "name": "Witching Hour",
      "description": "Area Effect 3: For 6 turns, friendly Witches gain +1 SPD, <ability value=1>Flight</ability> and <ability value=2537>Revel in Misery</ability>.",
      "flavorText": "The Elsari Coven convenes every sixth full moon at a location disclosed to each member via enoptromancy. Each member carries a special mirror granted by the Coven for this specific purpose.",
      "noraCost": 30,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "cooldown": 6,
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1AF0Be9Be9BJ8Jj9Aeeevfpymnyzxon",
      "deckLimit": 2
    },
    {
      "id": 306,
      "name": "Zealotry",
      "description": "Target champion gains 3 AP and <ability value=1433>Bounty Hunter</ability>. If target champion has Race: Kanen, friendly champions that share a race with target champion within 3 spaces gain 1 AP and you are refunded 5 nora.",
      "flavorText": "\"With Kain Taris, we control them all. They would fight and die for this idol. If we name an enemy, they will seek it out and destroy it. But, we must keep it this way if we are to make it to Ailur.\" ? Crone Kiergana\r\n",
      "noraCost": 40,
      "artist": "Cristian Giraldes",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "cooldown": 8,
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cg3Ae9Be9BG2Bj9Dj9Eevojpjpluxxmjrf",
      "deckLimit": 2
    }
  ],
  equips= [
    {
      "id": 9,
      "name": "Acid Fang",
      "description": "Equipped champion has <ability value=3139>Sundered Exploit</ability> and <ability value=2533>Acid Acolyte</ability>.",
      "flavorText": "\"These flowers when combined with a few stalks of Hate Weed and a touch of Ezraen Powder will make for a wonderfully agonizing toxin!\" - Szenz, Draksar Alchemist",
      "noraCost": 20,
      "artist": "Dan Kopycienski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8DE8Df1Be9Aj9Ej9Fsmuqlnhrojlgipf",
      "deckLimit": 2
    },
    {
      "id": 81,
      "name": "Akakios's Blade",
      "description": "Equipped champion gains <ability value=591>Flamestrike</ability>.  If it has Race: Draksar, it also gains <ability value=2707>Vivify</ability>.",
      "flavorText": "The Blade of Lord Akakios is said to be the first blade forged under his rule. Some believe it was pilfered from the ruins of the kingdom he usurped.",
      "noraCost": 25,
      "artist": "Anthony Lopes",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2AE8Df1BG2Aj9Bj9Ceerzohegipqzvqf",
      "deckLimit": 2
    },
    {
      "id": 201,
      "name": "Amareth's Lexicon",
      "description": "Equipped champion gains <ability value=2974>Hunter: Equipped</ability> and <ability value=738>Shielded</ability>. If it has Race: Fairy, it also gains <ability value=295>Deflect</ability>.",
      "flavorText": "Seen only by a few outside of the Conclave, Amareth's Lexicon describes in great detail most of the known artifacts of Poxanthuru.",
      "noraCost": 25,
      "artist": "Kirill Chepizhko",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0Be9Af1BG2BJ8IJ8Jqsxknufvsouxoqf",
      "deckLimit": 2
    },
    {
      "id": 63,
      "name": "Ancient Elsari Helm",
      "description": "Equipped champion loses all AP after activating an ability (including attacks). When equipped champion is destroyed, this equipment is equipped onto the closest valid enemy champion to this equipment's owner.",
      "flavorText": "\"The Elsari knew the art of war, but never practiced it. They crafted armors for battle, and left them to decay. Perhaps, dear Xulos, we can put them to use.\" - Serkan, King of the Wastes\r\n",
      "noraCost": 30,
      "artist": "Trevor Claxton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jg3AE8Df1Bf1Aj9Dj9Eerqsxzxfgnjwvqf",
      "deckLimit": 2
    },
    {
      "id": 1,
      "name": "Aquatic Talisman",
      "description": "At the start of equipped champion's turns, it heals HP equal to 25% of its MAX HP if it is occupying Water.",
      "flavorText": "\"That talisman is brimming with the power of the Forglar.  I should like to add it to my collection.\" - Gibir, Sheoul Demon",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9BE8Df1BE8DJ8GJ8Huxkuhvvsfxkepn",
      "deckLimit": 2
    },
    {
      "id": 95,
      "name": "Arachnablade",
      "description": "When equipped champion makes a successful attack, a Spider Egg under your control is deployed within 2 spaces of it. At the end of this turn, the egg hatches into a Spiderling.",
      "flavorText": "K`lzik's children joined the war effort in Sheoul. The spiders offered the Deep Elves a gift; a blade that would beckon them to fight.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9AE8Df1Bg3Aj9Fj9Goqfplrzgpsowzrf",
      "deckLimit": 2
    },
    {
      "id": 206,
      "name": "Aurora Lance",
      "description": "Equipped champion gains <ability value=1052>Purified</ability> and <ability value=2988>Lightseeker</ability>. If it has Class: Wizard, it also gains <ability value=2987>Aurora Lance</ability>.",
      "flavorText": "Aurite is a special mineral found only in areas that have been devastated by forest fires, and is characterized by its resonant reaction when exposed to light. This material is specifically preferred by the Aurora in crafting weaponry.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Be9BG2AE8DJ8GJ8Hwqoytojitheruo",
      "deckLimit": 2
    },
    {
      "id": 236,
      "name": "Avarice",
      "description": "Equipped champion gains <ability value=2253>Manic</ability>. If it does not have Race: Imp or Goblin, it has -4 DMG and -1 SPD.",
      "flavorText": "In the Underdepths, greed is never for material things. Violence, blood, and passion are the currencies under the earth.",
      "noraCost": 35,
      "artist": "Caio Monteiro",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9AG2BG2AE8Dj9Fj9Gowmhvxzztsqlgrf",
      "deckLimit": 2
    },
    {
      "id": 73,
      "name": "Axeman's Fate",
      "description": "Equipped Master Axeman gains +15 MAX HP and +2 DMG. Other Protectorate champions gain <ability value=116>Regeneration 2</ability>, and Wrath champions lose 3 HP per turn.",
      "flavorText": "\"The Axeman's Fate was not forged. It was born in battle. It has friends and enemies. It is an axeman, wielded by the best of axemen.\" -Rugolth of Ironfist",
      "noraCost": 25,
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ag3AE8Df1Bf1Bj9Dj9Eeipyvmshrhyzzrf",
      "deckLimit": 2
    },
    {
      "id": 30,
      "name": "Bag of Boulders",
      "description": "Equipped champion gains <ability value=2414>Throw Boulder</ability>. If equipped champion has Race: Voil, it also gains <ability value=3097>Toss Equipment</ability> (starts on cooldown).",
      "flavorText": "\"They're lighter than they look...here, watch!\" - Iiaars, Voil youth",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hg3AE8Df1BF0Aj9Dj9Eeiyrjietzgnsmpf",
      "deckLimit": 2
    },
    {
      "id": 182,
      "name": "Bag of Filth",
      "description": "For every 4 spaces equipped champion moves, a <ability value=1026>Plague Trap</ability> is summoned adjacent to it, under the control of the owner of this equipment. This equipment is destroyed after 4 triggers.",
      "flavorText": "Those in Xulos' employ are given special permission to work on their own side projects. Most of these fail in spectacular fashion, but the Bag of Filth managed to make the cut.",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8De9Af1BG2Aj9Ej9Fgygthvhipukuoqf",
      "deckLimit": 2
    },
    {
      "id": 23,
      "name": "Ball and Chain",
      "description": "Equipped champion gains <ability value=669>Earthbound</ability> and <ability value=5>Lumbering</ability>.",
      "flavorText": "\"Pretty bird man no flyid away.\" - Cyclops Youth upon capturing a Frostwing",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8DE8Df1Be9Bj9Ej9Feeetzxmwignpnn",
      "deckLimit": 2
    },
    {
      "id": 49,
      "name": "Barbed Vine Leash",
      "description": "When equipped champion moves through normal movement, it loses 1 HP per space. When equipped champion is relocated, it loses 5 HP. Upon equipping, this equipped champion becomes <condition value=ensnared>Ensnared</condition> for 2 turns. This may only be equipped on enemy champions.  ",
      "flavorText": "\"Stop your whining. It's your own damn fault the elves got you. I could have told you that house was trapped.\" - Miike, Nefari General",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0AE8Df1BF0BJ8HJ8Ismsmjyoufvvvon",
      "deckLimit": 2
    },
    {
      "id": 218,
      "name": "Betrayal",
      "description": "Equipped champion gains <ability value=545>Attack: Physical</ability>. When this champion makes a successful basic attack, it makes a second attack at no cost. This equipment then transfers to a random valid champion with a different controller. If there are no valid targets, this equipment is destroyed.",
      "flavorText": "Like many things in the Peaks, it bites back.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "ej9Ej9DF0BF0AG2Ag3AJ8IJ8Jukjgnhtjpsqferf",
      "deckLimit": 1
    },
    {
      "id": 240,
      "name": "Black Pearl",
      "description": "Equipped champion gains <ability value=406>Teleport 1</ability>. After 6 turns, this equipment is destroyed. When this equipment is destroyed, this champion and all other champions within 3 spaces become <condition value=frightened>Frightened</condition> and gain <condition value=confused>Confused</ability> for 4 turns.",
      "flavorText": "Pearls were pre-Catastrophe tools, used in vision and transportation rituals. They are powerful, but unexpected severance proves traumatizing.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1AG2BG2AE8DJ8Jj9Aeruzieggiwklyrf",
      "deckLimit": 2
    },
    {
      "id": 72,
      "name": "Blacklabel Brew",
      "description": "Equipped champion gains <ability value=1901>Tough 2</ability> and is <condition value=intoxicated>Intoxicated</condition>. If this equipment is destroyed while equipped to a champion with Race: Dwarf, it becomes Enraged 1 for 2 turns.",
      "flavorText": "\"Caution: Drinking Black Label Brew may result in temporary blindness and/or death. Please enjoy responsibly.\" - Warning on Black Label Keg",
      "noraCost": 25,
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2BE8Df1Bf1Bj9Cj9Dxqwfgvfexthyvqf",
      "deckLimit": 2
    },
    {
      "id": 2,
      "name": "Blade of the Snake",
      "description": "Equipped champion that has a MAX RNG of 2 or less gains +5 DMG, <ability value=942>Eternal</ability> and <ability value=1054>Healing Deficiency</ability>. If equipped champion is Race: Archdemon, it also gains <ability value=597>Unstoppable</ability> and <ability value=1887>Roar of the Fallen</ability>. Equipped champion loses 6 HP at the beginning of each of its turns.",
      "flavorText": "\"There is always a way to grow stronger.\" - Notk, Bok Guardian",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EE8DE8Df1BE8Dj9Ej9Fwirumjgigphiepf",
      "deckLimit": 2
    },
    {
      "id": 70,
      "name": "Blight Ring",
      "description": "At the start of each turn, equipped champion loses 3 HP. When equipped champion makes a basic attack, it loses 3 HP.",
      "flavorText": "The Ring of Blights is said to drain the life force of its wearer, be they alive or dead. Another ring was crafted to counteract its power. If the rings were to meet, their powers would clash.",
      "noraCost": 25,
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1BE8Df1Bf1Bj9Aj9Bgirsxqzmsofxmpf",
      "deckLimit": 2
    },
    {
      "id": 60,
      "name": "Blindwing",
      "description": "This champion gains <ability value=874>Reckless Flight</ability> and <ability value=1303>Gain Control</ability>.",
      "flavorText": "When stuck to a living creature, the Blindwing enters a state of euphoria. It flaps its wings frenziedly, often lifting its new host into the sky.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1BE8Df1Bf1Aj9Aj9Bjtqzgtqqftqzipf",
      "deckLimit": 2
    },
    {
      "id": 205,
      "name": "Bloodstained Claws",
      "description": "Equipped champion with 2 or less MAX RNG gains <ability value=3363>Bloodlust</ability> and <ability value=2942>Masochist</ability>.",
      "flavorText": "Bearing the markings of Elven magic used for portents, these claws are anything but.",
      "noraCost": 30,
      "artist": "Darcie Banfield",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2Be9Af1BG2Bj9Cj9Dpwohgvssfitolrf",
      "deckLimit": 2
    },
    {
      "id": 120,
      "name": "Bloodthirsty Blade",
      "description": "This champion gains <ability value=15>Multiattack 1</ability> (This champion's AP cost for making a basic attack is reduced by 1, to a minimum of 2 AP), <ability value=655>Skirmisher</ability> (This unit can only attack champions and transfigured Avatars), <ability value=876>Short-Lived 2</ability> (This unit is Sacrificed after 8 turns), and is <condition value=impervious>Impervious</condition>.",
      "flavorText": "When Vindrax heard of the Kanen in Maljara, he had a weapon forged from his scales. It was said that this blade gave its wielder an endless thirst for blood.",
      "noraCost": 40,
      "artist": "Bartek Gawel",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Be9Af1Be9Aj9Aj9Bwitjyoqqosqlpqf",
      "deckLimit": 2
    },
    {
      "id": 207,
      "name": "Bog Pearl",
      "description": "Equipped champion gains <ability value=1336>Fascinate</ability> and <ability value=2582>Impairing Feedback</ability>.",
      "flavorText": "Sparkling with iridescent light, Bog Pearls are things of unimaginable beauty and worth.",
      "noraCost": 25,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Ae9BG2AE8DJ8HJ8Ihrqofpnluoqoyo",
      "deckLimit": 2
    },
    {
      "id": 230,
      "name": "Boglight Crystal",
      "description": "Equipped champion heals 10 HP and gains <ability value=99>Life Siphon</ability>.  If this equipment is destroyed, this champion loses 10 HP.",
      "flavorText": "The swamps greatest boons are still of the swamp: balanced.",
      "noraCost": 30,
      "artist": "\"Faxtar\"",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9Af1BG2AG2Bj9Fj9Gsjpfvqjnemusqsf",
      "deckLimit": 2
    },
    {
      "id": 210,
      "name": "Bone Circle Staff",
      "description": "Equipped champion gains <ability value=1786>Ritual of Destruction</ability> and <ability value=3043>Vitality: Creation</ability>. When this champion is destroyed, this equipment moves to the next closest unequipped friendly champion.",
      "flavorText": "\"Serkan has imbued us with the power to resurrect our dying art, to use that which came before, which has been passed on, and use it now, until we ourselves are passed on.\" -- MarkXXIV, Skeleton Warlord.",
      "noraCost": 30,
      "artist": "Alex Brock",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Ae9BG2AE8Dj9Bj9Cevojiipwfthkuqf",
      "deckLimit": 2
    },
    {
      "id": 109,
      "name": "Bonesplitter Maul",
      "description": "Equipped champion with Class: Warrior gains <ability value=684>Execute</ability>, <ability value=2986>Fearsome Hunter</ability> and <ability value=376>Exertion 3</ability> (starts on cooldown).",
      "flavorText": "When the King of Ailur died, it was believed that his bones were made of steel. His bones were taken and made into mighty weapons, one of which was the Bonesplitter Maul. When the Draksar arrived in Maljara, they stole the maul from its resting place.",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9Ae9Af1Be9Aj9Fj9Giershymllexipqf",
      "deckLimit": 2
    },
    {
      "id": 141,
      "name": "Bracelet of Mirrors",
      "description": "Equipped champion gains <ability value=295>Deflect</ability>. If equipped champion has Race: Stitched, it also gains <ability value=1037>Deception</ability>.",
      "flavorText": "When Sarinda was finally vanquished, she left many things behind: an army of Stitched, various tomes, enchanted trinkets. One such item was the Bracelet of Mirrors; a bangle that could make one person seem like a hundred.",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2Ae9Af1BF0Aj9Bj9Cevxknsmsshpygpf",
      "deckLimit": 2
    },
    {
      "id": 33,
      "name": "Burning Oak Seed",
      "description": "Equipped champion gains <ability value=543>Attack: Fire</ability>, <ability value=1882>Burn 1</ability>, and <ability value=1255>Inhibiting Touch</ability>.",
      "flavorText": "\"The more dangerous the threat, the faster we find ways to counteract it. It's simply evolution.\" - Menalaus, High Mage",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gg3AE8Df1Be9Bj9Dj9Eeemetfrshnjrhpf",
      "deckLimit": 2
    },
    {
      "id": 235,
      "name": "Centaur Banner",
      "description": "Equipped Race: Centaur champion gains <ability value=1962>Weaken Spells</ability> (Friendly champions within 5 spaces take 5 less damage from spells) and <ability value=3319>Spell Breach</ability>. The next non-champion rune played by your opponent from the runedock costs 10 more nora.",
      "flavorText": "Fierce, swift, and dedicated to the nora, Centaur remain a bit more leery of crafted magic than do Elves of the Circle.",
      "noraCost": 30,
      "artist": "Caio Monteiro",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9BG2BG2Af1AJ8GJ8Hmwvouxxfevosjpf",
      "deckLimit": 2
    },
    {
      "id": 144,
      "name": "Chillshard",
      "description": "Whenever an enemy champion takes psychic damage, they become <condition value=chilled>Chilled</condition> for 3 turns. If the equipped champion has <ability value=547>Attack: Psychic</ability>, it also gains <ability value=3067>Psychic Blast.</ability> If the equipped champion has <ability value=540>Attack: Frost</ability>, it also gains <ability value=1751>Grant: Frost Aura.</ability>",
      "flavorText": "Argol's ascension to Shardseer caused many followed in his example; to try and master two elements at once. Argol crafted the Shards of the Mind to help them achieve this.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IE8De9Af1BF0Bj9Ej9Fukukukgnssfexo",
      "deckLimit": 2
    },
    {
      "id": 145,
      "name": "Cloak of Ice",
      "description": "Equipped champion has <ability value=1864>Slowing Armor</ability> and <ability value=1385>Freezing Aura</ability>.",
      "flavorText": "When Argol was appointed Shardseer, he fashioned a cloak of ice to commemorate the occasion. This cloak became a symbol of the Shardseers; a masterpiece of the highest order, shaped from the ice of the tundra.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9Ae9Af1BF0Bj9Fj9Gwiwirohpnlwxfpf",
      "deckLimit": 2
    },
    {
      "id": 113,
      "name": "Cloak of Long Knives",
      "description": "Equipped champion with Class: Rogue or Ranger has +2 DMG and gains <ability value=1790>Shadow Shift</ability>. If the equipped unit has range 2 or less it gains <ability value=2357>Shadowstrike</ability>.",
      "flavorText": "\"The shadows accepted the young elf. If she could take a blade to her love, then she was little more than a shadow. She was given a cloak, marked with her crest: the Long Knife.\" - Tale of the Long Knife",
      "noraCost": 30,
      "artist": "Simon Dominic",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Be9Af1BE8Dj9Cj9Dfvssmwvklyxkuqf",
      "deckLimit": 2
    },
    {
      "id": 169,
      "name": "Cloak of Skulls",
      "description": "Equipped champion has +2 DEF and gains <ability value=1424>Bone Fracture</ability>.  If it has Race: Skeleton, it gains <ability value=2559>Commander</ability>.",
      "flavorText": "\"Each skull on the cloak is meticulously chosen.  This is the work not of a madman as some claim, but of a genius who understands the beauty of what remains when the weakness of flesh has been fully eradicated.\" ~ Xulos, Undead Sage",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0Ae9Af1Bf1BJ8HJ8Itsojrzxtjtshyo",
      "deckLimit": 2
    },
    {
      "id": 160,
      "name": "Covenant",
      "description": "Equipped champion has +10 MAX HP and gains <ability value=867>Blessed</ability>. If it has Race: Elf, it also has +1 MAX RNG.",
      "flavorText": "A gift from the heart of K'thir herself to those sworn to her service.",
      "noraCost": 30,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1Be9Af1Bf1Aj9Aj9Byzvvfphiwquzkpf",
      "deckLimit": 2
    },
    {
      "id": 227,
      "name": "Cracked Egg",
      "description": "After 6 turns, this equipment is destroyed, the equipped champ takes 10 Poison damage and becomes <condition value=poisoned>Poisoned</condition> for 3 turns. When this triggers or if the champion is destroyed while equipped, a Constrictor Serpent is summoned to the closest available space under the control of this equipment's owner.",
      "flavorText": "\"Leave 'em be, you daft rats! You won't be the ones eating.\" -- G'hern Taskmaster to the camp chef",
      "noraCost": 25,
      "artist": "Rogier van de Beek",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9Af1BG2Af1Aj9Fj9Gjgrjegkwqlyxxqf",
      "deckLimit": 2
    },
    {
      "id": 3,
      "name": "Crown of Corruption",
      "description": "Equipped champion with Race: Vampyre or Race: Lich gains <ability value=1382>Prestige</ability>, <ability value=3169>Psychic Compulsion</ability> and <ability value=2239>Corruption</ability>. If the champion has Race: Lich, it also gains <ability value=2999>Essence Claw</ability>. If the champion does not have Race: Vampyre or Race: Lich, it gains <ability value=2004>Faithless</ability>, <ability value=2583>Limbo</ability> and becomes <condition value=cursed>Cursed</condition> permanently.",
      "flavorText": "Before the Catastrophe the crowns of the Kings of Old Elsarin were said to inspire loyalty in even the most rebellious of subjects.",
      "noraCost": 35,
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9AE8Df1BE8Dj9Fj9Ghrhnpsjgiwmhipf",
      "deckLimit": 2
    },
    {
      "id": 64,
      "name": "Crown of K'thir",
      "description": "Equipped champion gains <ability value=1571>Nature's Blessing 1</ability> and has +1 DMG for each K'thir Forest champion you have on cooldown (to a maximum of 6). If there are 4 or more champions on cooldown, this unit also gets +1 DEF. When equipped champion is destroyed, this equipment is equipped onto the closest valid friendly champion.",
      "flavorText": "\"I commemorate this crown in our honor, brothers and sisters of K'thir. Through our union, we will prosper.\" - Darius, High Chancellor of the Eternal Circle",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AE8DE8Df1Bf1Bj9Ej9Foqfmsjrzrfruhpf",
      "deckLimit": 2
    },
    {
      "id": 134,
      "name": "Crown of Nightbarbs",
      "description": "When a spell is cast the equipped champion loses 6 HP and the closest enemy champion gains 6 HP.",
      "flavorText": "The Night Rose is said to grow vicious thorns, when it is close to magical energy. These Nightbarbs were used in Pre-Separation Elsarin as punishment for committing a crime involving magic.",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HE8De9Af1BF0Aj9Ej9Feeiggvkpuxxito",
      "deckLimit": 2
    },
    {
      "id": 178,
      "name": "Crown of Petals",
      "description": "Equipped champion has <ability value=2093>Ponderous</ability> and becomes <condition value=confused>Confused.</condition>. If the champion is a Fairy, it gains <ability value=1237>Impenetrable</ability> and <ability value=1241>Motivate</ability> instead.",
      "flavorText": "It is often said that the Fae love nature. While true, it seems as though nature loves the Fae more, bestowing upon them gifts it gives to no one else.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1Be9Af1Bf1Bj9Aj9Bqfemeklyrhrzoqf",
      "deckLimit": 2
    },
    {
      "id": 179,
      "name": "Crystal Anima",
      "description": "Equipped champion gains <ability value=1463>Iceguard</ability> and <ability value=2594>Soul Vitality</ability>. If it has Race: Elemental, it also gains <ability value=2378>Soultap Luminescence</ability>.",
      "flavorText": "\"Keeper Borlai seems to believe these crystals are linked to the realm of souls.  He assures me that there is no inherent malevolence to them.\" ~ Vallassa the Elder's personal journal",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2Ae9Af1Bf1Bj9Bj9Cevklyiwiymwztqf",
      "deckLimit": 2
    },
    {
      "id": 19,
      "name": "Crystal Spike",
      "description": "Equipped champion has +3 DMG. If it has MAX RNG 2 or less, it also gains <ability value=776>Chill 3</ability>.",
      "flavorText": "\"For the Shardmasters, they were both a muse and an instigator.\"",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1BE8Df1Be9Aj9Aj9Bofthtjwfxiyknpf",
      "deckLimit": 2
    },
    {
      "id": 27,
      "name": "Cursed Blade",
      "description": "Equipped champion gains <ability value=2008>Liability</ability> and has -50% DEF and DMG (rounded down).",
      "flavorText": "\"Oh... and don't loot their weapons!\" -Draksar field Master addressing troops before battle",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0BE8Df1Be9BJ8IJ8Jeeietmjwfvxfkn",
      "deckLimit": 2
    },
    {
      "id": 24,
      "name": "Cyclops Eye Belt",
      "description": "Equipped champion gains <ability value=1775>Precision</ability> and <ability value=13>Detection 3</ability>. If it has Race: Cyclops, it also gains <ability value=1486>Strike</ability>.",
      "flavorText": "\"Wantahid hitahs hardid can.\" Der-Din, Cyclops Brawler ",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9AE8Df1Be9Bj9Fj9Gemnpfievztojro",
      "deckLimit": 2
    },
    {
      "id": 112,
      "name": "Darius' Favor",
      "description": "Equipped champion with Class: Ranger gains <ability value=1319>Arrowshot</ability> and <ability value=1723>Declare Target</ability>.",
      "flavorText": "After serving many years as an archer of K'thir, Darius joined the Eternal Circle and sent his bow to J'thir. The Jakei kept it safe for many years, until it was needed again.",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Ae9Af1BE8Dj9Bj9Cemwzzonwojwkpqf",
      "deckLimit": 2
    },
    {
      "id": 143,
      "name": "Darkmarsh Blackstaff",
      "description": "Equipped champion gains <ability value=2397>Spellswallower</ability> and <ability value=1857>Pawn</ability>. If it has class Witch, it also gains <ability value=2239>Corruption</ability>.",
      "flavorText": "\"They taunted me when I was a sickly tad. Teased me for playing with dead things. Now they gaze in awe through once living eyes at the marvel their master has become.\" - Timothy the Vile",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hg3Ae9Af1BF0Aj9Dj9Eemwqqzmpukytoqf",
      "deckLimit": 2
    },
    {
      "id": 88,
      "name": "Darkmarsh Helm",
      "description": "Equipped champion with MAX RNG of 2 or less gains <ability value=325>Stealth</ability> and <ability value=580>Assassinate 1</ability>. This equipment can be dropped as a relic with <ability value=1824>Darkmarsh Helm</ability> and <ability value=1827>Wieldable</ability>.",
      "flavorText": "\"The shadows of Darkmarsh hide us from our enemies, following with our swords drawn and ready.\" - Sumar, Darkmarsh Acolyte",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0BE8Df1BG2BJ8IJ8Juxxfinwzmyiwmpf",
      "deckLimit": 2
    },
    {
      "id": 66,
      "name": "Deepwater Helm",
      "description": "Equipped champion gains <ability value=1271>Tempo</ability> and has +1 DMG for each Forglar Swamp champion you have on cooldown (to a maximum of 6). If there are 4 or more champions on cooldown, this unit also gets +1 DEF. When equipped champion is destroyed, this equipment is equipped onto the closest valid friendly champion.",
      "flavorText": "The head of a Deepwater Mangler is considered a symbol of respect in Forglar. The Boghoppers and Salaman revere those that wear it. Even the Firk regard it with a measure of respect.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9BE8Df1Bf1BJ8GJ8Hietzmjgkyohnso",
      "deckLimit": 2
    },
    {
      "id": 52,
      "name": "Demon Shield ",
      "description": "Equipped champion gains <ability value=685>Arrow Eater</ability>. If champion has a max range of 1, it also gains <ability value=3266>Combat Awareness 1</ability>. This may only be equipped on champions with Race: Demon.",
      "flavorText": "\"You want me to run out bare-handed to draw their fire?\" -- \"No... I expect you to run out there with this shield and reveal their positions.\" -Deep Elves during the Siege of Nefara",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3AE8Df1BF0Bj9Dj9Eeeeeemjinuftqqf",
      "deckLimit": 2
    },
    {
      "id": 221,
      "name": "Desert Brew",
      "description": "Equipped champion gains <ability value=1900>Tough 1</ability> and is <condition value=intoxicated>Intoxicated</condition>. If this equipment is destroyed while equipped to a champion with Race: Dwarf, it becomes Enraged 1 for 2 turns.",
      "flavorText": "Celebrate Poxtoberfest with this special limited time Desert Brew!",
      "noraCost": 25,
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "LIMITED",
      "runeSet": "Path of De'lim",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Af1AG2AE8DJ8HJ8Iyrhyzgyrfmpjipf",
      "deckLimit": 2
    },
    {
      "id": 161,
      "name": "Destiny",
      "description": "Equipped champion gains <ability value=364>Piercing Shot 3</ability>. If it has Race: Boghopper, it also gains <ability value=2463>Quest: Kill Enemy</ability>.",
      "flavorText": "A Finlord must prove himself worthy to wield the Harpoon, lest its true power not manifest.",
      "noraCost": 40,
      "artist": "Anthony Lopes",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2Ae9Af1Bf1Aj9Bj9Cemwipnyvfpjyoqf",
      "deckLimit": 2
    },
    {
      "id": 91,
      "name": "Diamond Mace",
      "description": "Equipped champion gains <ability value=344>Power Attack 3</ability> and <ability value=3041>Hunter: Meek</ability>. If equipped on a champion with Race: Voil, it also gains <ability value=2953>Blinding</ability>. If equipped on a champion with Race: G'hern, it gains <ability value=1374>Resolute</ability>.",
      "flavorText": "Precious gems are common place in the Shattered Peaks, but it took time for the Voil and G`hern to learn their uses. They learned to enhance enemy weapons, left behind in battle. The modifications were crude, but effective.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2AE8Df1BG2Bj9Bj9Cemjwiwmwvftferf",
      "deckLimit": 2
    },
    {
      "id": 84,
      "name": "Dragon God's Staff",
      "description": "Equipped champion is <mechanic value=cleansed>Cleansed</mechanic>, gains <ability value=1052>Purified</ability> and takes 2 Fire damage at the start of its turn. This equipment can be dropped as a relic with <ability value=1822>Dragon God's Staff</ability> and <ability value=1827>Wieldable</ability>.",
      "flavorText": "The Draksar believe in a dragon that governs Valdac and Vindrax; this being is the Dragon God. The staff of the Dragon God is said to hold a slight amount of his immense power.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CE8DE8Df1BG2Bj9Ej9Fuklegrjemnlrqqf",
      "deckLimit": 2
    },
    {
      "id": 38,
      "name": "Dragonclaw",
      "description": "Equipped champion gains <ability value=809>Dragonclaw</ability> (This champion makes a Physical attack at RNG 1 at +4 DMG. If the target is successfully damaged, it becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns). If it has Race: Draksar, it also gains <ability value=1312>Sweep</ability>. ",
      "flavorText": "\"Come on you slithering whelps! Kick as hard as you can! You must be able to use your entire body as a weapon!\" - Skak, Draksar Commander",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0BE8Df1BF0AJ8IJ8Jerzgtxtfmhtuon",
      "deckLimit": 2
    },
    {
      "id": 135,
      "name": "Draketooth Rifle",
      "description": "Equipped champion gains <ability value=2316>Draketooth Rifle</ability> (This champion makes a Physical attack at RNG 2-5 for 14 DMG).",
      "flavorText": "The Draketooth Rifle is the only Post-Separation gun in mass production. The munitions casing is held inside the rifle's body; one must disassemble the rifle to reload.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9Ae9Af1BF0Aj9Fj9Gmjieiilnyrzzxo",
      "deckLimit": 2
    },
    {
      "id": 59,
      "name": "Dreadeye Symbiote",
      "description": "Equipped champion gains <ability value=1775>Precision</ability>. If it has MAX RNG 2 or less, it also gains <ability value=169>Poison 3</ability>.",
      "flavorText": "The dreadeye symbiote considers eye-to-eye contact either a territorial challenge, or a desire to mate. Avoid eye-to-eye contact with the dreadeye symbiote.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0BE8Df1Bf1AJ8IJ8Jwzrhvmhrwkrjwo",
      "deckLimit": 2
    },
    {
      "id": 101,
      "name": "Dunewalker's Mantle",
      "description": "Equipped champion gains <ability value=1326>Domain: Sand</ability> and <ability value=3266>Combat Awareness 1</ability>. If equipped champion has max range 2 or less, it also gains <ability value=1370>Deflect: Sand</ability>.",
      "flavorText": "The Dunewalkers endured endless hardship after their exile from Valdac. With each passing day, they grew accustomed to the harsh Dunes. Soon, their environment became their advantage against invaders. With the help of their leader, Derifos, the Dunewalkers prospered in the desert.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2AE8Df1Bg3Aj9Bj9Ceeeiexfmlpljirf",
      "deckLimit": 2
    },
    {
      "id": 25,
      "name": "Earthgod Sigil",
      "description": "Equipped champion gains <ability value=669>Earthbound</ability>, <ability value=480>Lavawalker</ability>, <ability value=5>Lumbering</ability> and <ability value=804>Trail: Lava</ability>.",
      "flavorText": "\"Rugolth, this report says that the excavators have found the remains of the Royal Academy. They say its guarded by some kind of symbol of flame.\" - Feofil assisting with the King's mail",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9BE8Df1Be9BJ8GJ8Heemerhrhggnyzm",
      "deckLimit": 2
    },
    {
      "id": 105,
      "name": "Earthshaker's Bracelet",
      "description": "Equipped Champion gains <ability value=869>Tremor</ability> and <ability value=48>Resistance: Physical 3</ability>. If it has race: Cyclops it also gains <ability value=1270>Tectonic Pulse</ability>.",
      "flavorText": "To better differentiate themselves from the Maulers, the Earthshakers wear large stone bracelets. The stone and rope, used in its making, is strong enough to withstand continuous impacts. ",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Ae9Af1BE8Dj9Fj9Ggnlyoqfkpfrhkpf",
      "deckLimit": 2
    },
    {
      "id": 77,
      "name": "Elite Blade",
      "description": "Equipped champion has +10 MAX HP and +2 DMG. If it has Class: Ranger or Class: Knight, it also gains <ability value=2078>Reflexes 3</ability>.",
      "flavorText": "\"When a blade has seen enough battle, they say it will choose its wielder. Go ahead, lift it up. See if you're worthy!\" - Wern, Dwarven Weaponsmith",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0AE8Df1BG2AJ8HJ8Iouvqwzrjlpfeepf",
      "deckLimit": 2
    },
    {
      "id": 80,
      "name": "Elsari Shackles",
      "description": "Equipped champion has <ability value=3064>Weighty</ability>, <ability value=2005>Careless</ability>, and <ability value=669>Earthbound</ability>.",
      "flavorText": "For the prisoners of Elsarin, there is no hope for a quick escape.",
      "noraCost": 30,
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1BE8Df1BG2Aj9Aj9Byxqoytohnwzxqqf",
      "deckLimit": 2
    },
    {
      "id": 193,
      "name": "Emergency Kit",
      "description": "Equipped champion gains <ability value=316>Melee Specialist 2</ability>, <ability value=13>Detection 3</ability> and +1 SPD.",
      "flavorText": "The Salaman are always prepared.",
      "noraCost": 30,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bg3Ae9Af1BG2Aj9Dj9Eeerqfkpnleknlrf",
      "deckLimit": 2
    },
    {
      "id": 224,
      "name": "Enervating Collar",
      "description": "Equipped champion gains <ability value=1452>Dispel</ability>. If equipped champion has 2 or less MAX RNG, it also gains <ability value=594>Energy Thief</ability>.",
      "flavorText": "Many Jakei tombs had powerful seals. The raid leaders put a collar on the lead Excavator, and let the beast do the rest.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Bf1AG2Ae9Bj9Cj9Devsuxiyipwtsqqf",
      "deckLimit": 2
    },
    {
      "id": 195,
      "name": "Entropic Clasp",
      "description": "Equipped champion has -1 DMG for every 8 HP it currently has.  At the end of its turn, it takes 1 Acid damage with 1 additional damage for every 8 HP it is missing.",
      "flavorText": "The Draksar have only begun to understand the power of the plague and mutations, they are now beginning to wield it into their armor.",
      "noraCost": 25,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9Ae9Af1BG2Bj9Fj9Gusjrllnwtuzxxqf",
      "deckLimit": 2
    },
    {
      "id": 31,
      "name": "Ethereal Hammer",
      "description": "This champion gains <ability value=3113>Ethereal Hammer</ability> and <ability value=544>Attack: Magical</ability>. After 6 turns, this equipment is returned to the runedock and its nora cost is refunded.",
      "flavorText": "\"Your majesty, we have yet to find a way to imbue your weapons with the Nora, but we have found that the enchantments work quite well by themselves.\" - Tarn, Dwarven Alchemist ",
      "noraCost": 20,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2AE8Df1Be9Bj9Bj9Ceevkggkuzkygvo",
      "deckLimit": 2
    },
    {
      "id": 45,
      "name": "Ethereal Mindshank",
      "description": "Equipped champion gets -1 SPD and -3 DMG. After 4 turns, it is returned to its owner's rune dock and its nora cost is refunded.",
      "flavorText": "\"Plant the seed of despair into the mind of their commander, and their defenses will rot from the inside-out.\" - Krelick, Dark Knight",
      "noraCost": 20,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2AE8Df1BF0Bj9Bj9Ceeeeevsjytzxipf",
      "deckLimit": 2
    },
    {
      "id": 146,
      "name": "Everfrost Manacles",
      "description": "Equipped champion is <condition value=frozen>Frozen</condition> and takes 3 Frost damage whenever it is attacked. If equipped champion is friendly, it also gains <ability value=898>Ice Eater</ability>.",
      "flavorText": "\"He will not escape the tundra as long as he wears those manacles. It will follow him wherever he runs.\" - K'ailo, Jakei Shardmaster",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9Be9Af1BF0BJ8GJ8Hgygygtqzmpnymn",
      "deckLimit": 2
    },
    {
      "id": 246,
      "name": "Firebeard Brew",
      "description": "Equipped Champion is <condition value=intoxicated>Intoxicated</condition> and gains <ability value=543>Attack: Fire</ability>. If the equipped champion has Race: Dwarf, it gains <ability value=1882>Burn 1</ability>. If not Race: Dwarf, it is <condition value=inhibited>Inhibited</condition>.",
      "flavorText": "Ach, it burns! (hic)",
      "noraCost": 25,
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2BE8Df1Bf1Bj9Cj9Dxqwfgvfexthyvqf",
      "deckLimit": 2
    },
    {
      "id": 122,
      "name": "Firelight Gem",
      "description": "Equipped champion gains <ability value=4>Iron Will</ability> and <ability value=3061>Solar Flare</ability>. If it is Race: Demon Elf or has Attack: Fire, it also gains <ability value=3193>Flame Prison</ability>.",
      "flavorText": "To Grimlic's inner circle, wearing a Firelight gem demands a measure of respect. Those who have survived Grimlic's trials of fire are given a Firelight gem as their prize.",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Be9Af1Be9Aj9Cj9Dhnwqhgyvvsuoyrf",
      "deckLimit": 2
    },
    {
      "id": 48,
      "name": "Firk Mask",
      "description": "Equipped champion gains <ability value=3100>Catalyst: Psychic</ability> and <ability value=2338>Psychic Magnetism</ability>. If the champion is Race: Firk, it also gains <ability value=3220>Mind Siphon</ability>.",
      "flavorText": "\"If you will be scouting ahead with the Firk, be sure to don this mask as to amplify their power while shielding your own mind from any collateral psychic damage.\" ",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0BE8Df1BF0BJ8IJ8Jsmsmsfethrzoso",
      "deckLimit": 2
    },
    {
      "id": 78,
      "name": "Flag of Unification",
      "description": "Equipped champion gains <ability value=1382>Prestige</ability> and <ability value=3198>Fellowship</ability>. If it is Race: Jakei or Class: Monk, it also gains <ability value=2568>Vigilance</ability>.",
      "flavorText": "L`usara held the flag high and, in the savage storm, the elves of J`thir followed her. Since then, it has been used to bring the Tundra's protectors together.",
      "noraCost": 30,
      "artist": "Darcie Banfield",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0BE8Df1BG2AJ8IJ8Joqwtjgrwzmjyipf",
      "deckLimit": 2
    },
    {
      "id": 104,
      "name": "Flameheart Pauldron",
      "description": "Equipped Size: Small champion with 2 or less MAX RNG gains +2 DMG and <ability value=297>Deflect</ability>. If it has Race: Demon Elf, it also gains <ability value=3198>Fellowship</ability>.",
      "flavorText": "The Flamehearts took up weapons against the first wave of elves, who threatened the mouth of Sheoul. All were lost in the battle. Now, they are immortalized by Nefari soldiers, who burn an inscription of their insignia on their Pauldrons.",
      "noraCost": 30,
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EE8De9Af1BE8Dj9Ej9Fmszvqohkuzzigpf",
      "deckLimit": 2
    },
    {
      "id": 137,
      "name": "Flamethrower Engine",
      "description": "Equipped champion gains <ability value=2400>Flamethrower</ability>. If it has Race: Construct or Class: Tinkerer, it also gains <ability value=885>Flame Siphon 1</ability>.",
      "flavorText": "The first Flamethrower Engine was made in Valdac, during the Pre-Separation era. It saw widespread use during the War of Kinsmen, where it was used as a siege weapon.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0Ae9Af1BF0AJ8HJ8Irztmpjruojrzmn",
      "deckLimit": 2
    },
    {
      "id": 40,
      "name": "Fleshsewn Helm",
      "description": "Equipped champion has <ability value=156>Disease Aura 2</ability>, <ability value=48>Resistance: Physical 3</ability> and <ability value=927>Amplify: Disease</ability>.",
      "flavorText": "\"You've got to try harder if you want to impress me...any one can sew a few scalps together.\" - Xulos to a Necromancer in training ",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1BE8Df1BF0Aj9Aj9Bipqlrfmplwziwo",
      "deckLimit": 2
    },
    {
      "id": 4,
      "name": "Forbidden Fruit",
      "description": "Equipped real friendly champion loses all AP. When this champion successfully deals damage on a basic attack to a non-Avatar champion with an opposing owner, both champions and this equipment are destroyed (the source of the destruction effect is this equipment, not the equipped champion).  This does not trigger if equipped on Eternal champions.",
      "flavorText": "\"To taste the fruit of your desire, you must be willing to give up all else.\" -  Avix, Draksar Brood Queen",
      "noraCost": 45,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0AE8Df1BE8DJ8HJ8Iiwoqqfklyiwvso",
      "deckLimit": 2
    },
    {
      "id": 96,
      "name": "Forest's Embrace",
      "description": "Equipped champion gains <ability value=116>Regeneration 2</ability> and <ability value=1805>Weave Web</ability> and becomes Cocooned (This champion is Pacified, Impervious and Immobile. After 3 turns, this champion loses Cooconed and gains +1 DEF, +1 SPD and +2 DMG. This effect does not stack).",
      "flavorText": "\"Do not fear its embrace, young one. Let the forest hold you. If you allow it, the forest can heal your wounds.\" - Menalaus of K`thir",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9De9BE8Df1Bg3AJ8GJ8Hkukwxvmjlrwthpf",
      "deckLimit": 2
    },
    {
      "id": 5,
      "name": "Forge Hammer",
      "description": "Equipped champion with MAX RNG of 2 or lower gains <ability value=1967>Relic Guardian</ability> and <ability value=832>Forge Hammer</ability>.",
      "flavorText": "\"Would ya believe they're good for smashin' things too?\" - Dar Thunhammer Ironfist Blacksmith",
      "noraCost": 25,
      "artist": "Dan Kopycienski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2AE8Df1BE8Dj9Bj9Ceiyvzvzrlyiinpf",
      "deckLimit": 2
    },
    {
      "id": 21,
      "name": "Frost Amulet",
      "description": "This champion gains <ability value=89>Vulnerability: Frost</ability> and <ability value=3064>Weighty</ability>.",
      "flavorText": "Beauty is not without its benefits.",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2BE8Df1Be9Aj9Cj9Dpufiexoyzkllwqf",
      "deckLimit": 2
    },
    {
      "id": 132,
      "name": "Frostcall Quiver",
      "description": "Equipped champion gains <ability value=540>Attack: Frost</ability>. If it has a MIN RNG of 2 or greater, it also gains <ability value=774>Chill: 1</ability>.",
      "flavorText": "Frostcall Quivers were the first of several Jakei additions to K'thir's armory. When arrows are placed in the quiver, they are imbued with the Shardmasters' magic.",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Be9Af1Be9Bj9Cj9Deitssouqfrhvfpf",
      "deckLimit": 2
    },
    {
      "id": 94,
      "name": "Full Plate Armor",
      "description": "Equipped champion has +4 DEF and <ability value=1476>Resilient</ability>. If it costs less than 80 nora, it gains <ability value=669>Earthbound</ability> and <ability value=5>Lumbering</ability>. If 80 nora or more, it gains <ability value=3064>Weighty</ability> instead.",
      "flavorText": "The Ironfist Armory was once a sparse collection of chipped swords and suspect chainmail. Now, with resources plentiful, it holds the finest armor in the world.",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DE8DE8Df1Bg3Aj9Ej9Fiwtfgrhegymsuqf",
      "deckLimit": 2
    },
    {
      "id": 229,
      "name": "Furry Hat",
      "description": "Equipped champion gains <ability value=764>Frost Attack</ability> and <ability value=3097>Toss Equipment</ability> (starts on cooldown).",
      "flavorText": "\"My dad gave me that hat. It was the only thing I had of his. Still had some of his warmth, too.\"",
      "noraCost": 20,
      "artist": "Maciej Janaszek",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CE8Df1BG2AG2Bj9Ej9Fiwvhtzxxthpjlrf",
      "deckLimit": 2
    },
    {
      "id": 28,
      "name": "G'hern Helm",
      "description": "Equipped champion gains <ability value=677>Overseer: Moga 2</ability> and Race: G'hern and loses <ability value=679>G'hernbound</ability>. If it has Race: Moga, it also gains <ability value=715>Surge: Moga</ability>.",
      "flavorText": "\"A Moga once longed for G'hern power; so he killed one and took it.\" - Boghopper Fable",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1AE8Df1Be9BJ8Jj9Aeeigkrukevhton",
      "deckLimit": 2
    },
    {
      "id": 85,
      "name": "Ghost Pendant",
      "description": "Equipped champion gains <ability value=326>Phase Shift</ability> and <ability value=3013>Soultap Feedback</ability>. This equipment can be dropped as a relic with <ability value=1821>Ghost Pendant</ability> and <ability value=1827>Wieldable</ability>. When Phase Shift is activated, Drop Pendant begins cooldown.",
      "flavorText": "\"A gift for you, dearest Caetian. The gift of shedding this wretched flesh, to become ethereal. A form of absolute beauty.\" - Xulos of Elsarin",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9AE8Df1BG2Bj9Fj9Getqfrqsmepsuvqf",
      "deckLimit": 2
    },
    {
      "id": 128,
      "name": "Goading Mask",
      "description": "Equipped champion has <ability value=1269>Antagonize</ability>. If it has Race: Boghopper,  it also gains <ability value=966>Cackle</ability>.",
      "flavorText": "The Mongrel slipped the mask over his face and was set upon by his pack, the frenzied Kanen swiping and biting at him. When the mask came off, another Mongrel picked it up and placed it on his face. Nine unconscious Kanen later, the remaining pack decided the mask was evil.",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0Be9Af1Be9BJ8IJ8Jeemekusoyklymn",
      "deckLimit": 2
    },
    {
      "id": 215,
      "name": "Gold Sand",
      "description": "Equipped champion has <ability value=117>Regeneration 3</ability> and <ability value=544>Attack: Magical</ability>.  If it has Race: Salaman, the closest enemy champion within 5 spaces becomes <condition value=blinded>Blinded</condition> for 2 turns.",
      "flavorText": "When more canonical supplies were scarce, Salaman home remedies became common-place in Forglar armies.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1BF0AG2AG2Aj9Aj9Bsziegrohetfierf",
      "deckLimit": 2
    },
    {
      "id": 177,
      "name": "Golden Compass",
      "description": "When equipped champion moves closer to an enemy shrine or avatar, it gains +1 DMG for 2 turns.  If it moves away from an enemy shrine or avatar, it gains +1 DEF for 2 turns.",
      "flavorText": "The only wrong direction is to stop.",
      "noraCost": 25,
      "artist": "Conceptopolis",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1Ae9Af1Bf1BJ8Jj9Aeiggnusofpwzkpf",
      "deckLimit": 2
    },
    {
      "id": 22,
      "name": "Granite Bracers",
      "description": "Equipped champion gains <ability value=287>Riposte 1</ability> and <ability value=974>Arrow Throw 1</ability>. The first attack made against this champion each turn misses.",
      "flavorText": "\"You haven't seen these before\"",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3AE8Df1Be9Aj9Dj9Eeitfgyrhrjinerf",
      "deckLimit": 2
    },
    {
      "id": 156,
      "name": "Hammerheart Platemail",
      "description": "Equipped champion gains <ability value=1899>Scale Armor</ability> and +2 DMG. If it has Race: Dwarf, it also gains <ability value=597>Unstoppable</ability>.",
      "flavorText": "\"Sure, it's beat up and dirty, but so am I. Long as the rivets hold and the holes get patched this will be the armor they bury me in.\" - Talgar Ironfist",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9Be9Af1Bf1AJ8GJ8Hqsshpqsshphrqo",
      "deckLimit": 2
    },
    {
      "id": 116,
      "name": "Harmless Bauble",
      "description": "Equipped champion is <condition value=defiled>Defiled</condition>. This champion loses 2 HP at the end of each turn for each unique Cleansable condition that it has.",
      "flavorText": "\"She carved an amulet for me from the tusk of a Nora Beast. It was beautiful. But, when I look on its surface, I see her smile. It reminds me of the distance between us. I keep it in my satchel.\" - Diary of L'ilae, Jakei Climber",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "hash": "ej9Gj9Fe9Be9Af1Be9AJ8GJ8Hgkpwipsjepssuo",
      "deckLimit": 2
    },
    {
      "id": 58,
      "name": "Hate Leech",
      "description": "Equipped champion with a maximum range of 2 gains <ability value=99>Life Siphon</ability> and +1 DMG. At the start of its turn, this champion loses 5 HP.",
      "flavorText": "Give the leech what it wants, and you just might live forever.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1AE8Df1Bf1AJ8Jj9Aevsuzkyrqwxfepf",
      "deckLimit": 2
    },
    {
      "id": 159,
      "name": "Heart of Gnash",
      "description": "Equipped champion gains <ability value=543>Attack: Fire</ability> and <ability value=539>Attack: Acid</ability>. If it already has Attack: Fire or Attack: Acid, it also gains <ability value=910>Amplify: Fire</ability> and <ability value=2497>Amplify: Acid</ability>.",
      "flavorText": "\"Gnash was merely in my way. However, he was kind enough to provide me with a parting gift.\" - Vex the Godmother",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jf1Ae9Af1Bf1AJ8Jj9Aerlggyvxtftfgpf",
      "deckLimit": 2
    },
    {
      "id": 20,
      "name": "Heart of Ice",
      "description": "This champion gains <ability value=544>Attack: Magical</ability> and <ability value=384>Frost Nova 3</ability>.",
      "flavorText": "\"The frozen magic ran swiftly out of the Heart of Ice protecting the travellers from those who would do them harm.\"  Marlow Kurtz, Valdec Scholar",
      "noraCost": 20,
      "artist": "Layne Johnson",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2AE8Df1Be9Aj9Bj9Cemegnyiyrzxkrqf",
      "deckLimit": 2
    },
    {
      "id": 50,
      "name": "Heavy Crossbow",
      "description": "Equipped champion gains <ability value=943>Heavy Crossbow</ability>. If it has Race: Dwarf, it also gains <ability value=1486>Strike</ability>.",
      "flavorText": "A heavy crossbow can allow even the clumsiest Golem or the drunkest Dwarf to pierce the toughest armor from a distance. That is, when they are not reloading...",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9BE8Df1BF0BJ8GJ8Hoqoqoyiykeegkn",
      "deckLimit": 2
    },
    {
      "id": 189,
      "name": "Hekatian Blood Draught",
      "description": "Equipped champion with 3 or less MAX RNG gains <ability value=316>Melee Specialist 2</ability> and <ability value=2790>Bloodsport</ability>. If equipped champion is Race: Archdemon, it also gains <ability value=2551>Bloodseeker</ability>. If equipped champion is Race: Demon, it gains <ability value=2197>Blood Magic</ability> instead.",
      "flavorText": "The price of victory is an acquired taste.",
      "noraCost": 30,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1Be9Af1BG2Aj9Aj9Binphneironyztqf",
      "deckLimit": 2
    },
    {
      "id": 6,
      "name": "Helm of Chaos",
      "description": "Equipped Size: Small champion with Race: Archdemon or Class: Knight gains <ability value=3266>Combat Awareness 1</ability>, <ability value=1317>Absorb</ability> and <ability value=1037>Deception</ability>.",
      "flavorText": "\"No matter how many arrows we shoot, that winged demon wont die!\" - Alaena, Elven Archer",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1AE8Df1BE8DJ8Jj9Aevsmnnjyonhnepf",
      "deckLimit": 2
    },
    {
      "id": 209,
      "name": "Heretic Collar",
      "description": "At the start of its turn, this champion loses 3 HP.  When this equipment or equipped champion is destroyed, its owner gains 1 Nora for every HP lost this way.",
      "flavorText": "Since the events surrounding the Plague, the Jakei leadership have taken to ferreting out potential Heretics and marking them long before they have a chance to cause real trouble.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1Ae9BG2AE8DJ8Jj9Aeiyvkrllwoyklpf",
      "deckLimit": 2
    },
    {
      "id": 213,
      "name": "Heretic Shackle",
      "description": "Equipped champion has <ability value=3064>Weighty</ability>.",
      "flavorText": "As the Overlord's restraint of choice, the Heretic Shackle gives its bearer the potential of escape, only to drag them back down later.",
      "noraCost": 20,
      "artist": "Rogier van de Beek",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8De9BG2Ae9Aj9Ej9Fgnukwtqqzgggpqf",
      "deckLimit": 2
    },
    {
      "id": 87,
      "name": "Holy Blade of Valdac",
      "description": "Equipped champion gains <ability value=543>Attack: Fire</ability>, <ability value=1882>Burn 1</ability>, and <ability value=1382>Prestige</ability>. If it has Class: Paladin, it also gains <ability value=1255>Inhibiting Touch</ability>. This equipment can be dropped as a relic with <ability value=1823>Consecrated Zone</ability> and <ability value=1827>Wieldable</ability>.",
      "flavorText": "\"This blade belonged to the nation of Valdac, not to Akakios or his Draks. If they want our holy blade, they can take it to the hilt.\" - King Rugolth of Ironfist",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0AE8Df1BG2BJ8HJ8Iplgiwkeetfkwipf",
      "deckLimit": 2
    },
    {
      "id": 32,
      "name": "Holy Mace",
      "description": "Equipped champion gains <ability value=1235>Hunter: Wrath</ability>.",
      "flavorText": "\"The lands south of Valdec are dangerous, and crawling with the damned, may the Holy bless your weapons.\"",
      "noraCost": 20,
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2BE8Df1Be9Bj9Cj9Derljyrqjwxmwzo",
      "deckLimit": 2
    },
    {
      "id": 214,
      "name": "Honor Coin",
      "description": "Equipped champion gains <ability value=3130>Karmic Reward</ability> (The first time each turn this champion activates a non-basic attack ability, it is healed for 6 HP.  If that ability targets a friendly champion, this champion also gains 2 MAX HP.) and <ability value=2559>Commander</ability> (Friendly champions within 5 spaces that share a race or class with this champion have +2 DMG. This does not stack with other Commanders.).",
      "flavorText": "Honor Coins are not currency, but a symbol of dedication and respect.  Obtaining one from high ranking members of the Throne is considered to be an especially great honor.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1AF0AG2AG2AJ8Jj9Aeevkgpfkwinevqf",
      "deckLimit": 2
    },
    {
      "id": 129,
      "name": "Horn of Order",
      "description": "Equipped champion gains <ability value=656>Drive</ability> and <ability value=579>Invigorate 2.</ability>. If it has Race: Tortun, it also permanently loses <ability value=2093>Ponderous.</ability>",
      "flavorText": "\"When the captain blows that horn, you better shut yer yap. If ye don't, ye'll be on his bad side. And ye don't want to be on his bad side. Ever.\" - First Mate Kulagin Greenclaw of the Gygurnaut",
      "noraCost": 50,
      "artist": "Michele Chang",
      "factions": [
        "Forglar Swamp",
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1Ae9Af1Be9BJ8Jj9Aeemjethpwoyrqo",
      "deckLimit": 2
    },
    {
      "id": 98,
      "name": "Hunter's Charm",
      "description": "Equipped champion has <ability value=1842>Trail: Vegetation</ability> and <ability value=1327>Domain: Vegetation</ability>.",
      "flavorText": "The Wilderkin believed themselves to be the greatest predators of K`thir. Some even dared to hunt rangers of K`thir. To protect themselves, the Rangers appointed a few to counter the Wilderkin advances. They were known simply as the Hunters, marked by a wooden charm around their necks.",
      "noraCost": 20,
      "artist": "Michele Chang",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0BE8Df1Bg3AJ8IJ8Jiwtmuqsztxquqqf",
      "deckLimit": 2
    },
    {
      "id": 42,
      "name": "Ice Carved Greaves",
      "description": "Equipped champion gains <ability value=2817>Freezing Discipline</ability> and <ability value=1476>Resilient</ability>. If it is  Race: Jakei or Class: Monk, it also gains <ability value=390>Frost Armor</ability>.",
      "flavorText": "Deep beneath the snowy surface of the Tundra lies a layer of Nora infused ice so strong it can deflect even the strongest of blades.",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2BE8Df1BF0Aj9Cj9Dvkpjpuhvxqwvhpf",
      "deckLimit": 2
    },
    {
      "id": 89,
      "name": "Iceguard Bracers",
      "description": "Equipped champion gains <ability value=1818>Defensive Strike</ability>.  This equipment can be dropped as a relic with <ability value=1825>Iceguard Bracers</ability> and <ability value=1827>Wieldable</ability>.",
      "flavorText": "\"We draw our strength from the tundra. Ice is our weapon and our shield. No matter the threat, your Iceguard will protect J`thir, Queen J`orea.\" - R`inol, Iceguard",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1AE8Df1BG2BJ8Jj9Aerzthiexkpqwqqf",
      "deckLimit": 2
    },
    {
      "id": 67,
      "name": "Iceguard Visor",
      "description": "Equipped champion gains <ability value=1241>Motivate</ability> and has +1 DMG for each Savage Tundra champion you have on cooldown (up to a maximum of 6 champions). If there are 4 or more champions on cooldown, this unit also gets +1 DEF. When equipped champion is destroyed, this equipment is equipped onto the closest valid friendly champion.",
      "flavorText": "Blessed by Queen J'orea, the visor of the Iceguard grants its wearer the strength of the tundra. It is a symbol of the allegiances between Jakei, Lonx, and the beasts of J'thir.\r\n",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0AE8Df1Bf1BJ8HJ8Ijnlyrqonuhiiwo",
      "deckLimit": 2
    },
    {
      "id": 43,
      "name": "Idol of Elements",
      "description": "This champion gains <ability value=37>Immunity: Fire</ability>, <ability value=38>Immunity: Frost</ability>, and <ability value=39>Immunity: Electricity</ability>.",
      "flavorText": "\"He walked through flames, he shattered ice. Even the most potent venom of the swamp could not fell the great cyclops emperor.\" - Lore of the Ancient Cyclops Empire",
      "noraCost": 30,
      "artist": "Yi-Piao Yeoh",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IE8DE8Df1BF0Bj9Ej9Fsmsmsxqfinsfvo",
      "deckLimit": 2
    },
    {
      "id": 217,
      "name": "Indignation",
      "description": "Equipped champion gains <ability value=3096>Cull</ability>. If champion has max range of 2 or less, it also gains <ability value=594>Energy Thief</ability>.",
      "flavorText": "\"I tell my troops that if they can't march on, they will die. The same goes for you.\"",
      "noraCost": 30,
      "artist": "Amber Jones",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0AF0AG2Ag3AJ8HJ8Iukpqjwxqlumwvqf",
      "deckLimit": 2
    },
    {
      "id": 157,
      "name": "Keeneye Crown",
      "description": "Equipped champion gains <ability value=1775>Precision</ability> and <ability value=1486>Strike</ability>. If it has <condition value=flying>Flying</condition> or Race: Jakei, it also gains +1 MAX RNG.",
      "flavorText": "\"Sight beyond sight. Aim without fault.\" - Inscription",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0Ae9Af1Bf1AJ8HJ8Ihyxxzgtowfxmuo",
      "deckLimit": 2
    },
    {
      "id": 100,
      "name": "L'usara's Staff",
      "description": "Equipped champion gains <ability value=1271>Tempo</ability> and <ability value=737>Spellswallower</ability>. If equipped champion has range 3 or more it also gains <ability value=1932>Loyalty</ability>.",
      "flavorText": "As sister of the Frostqueen, L`usara wanted no special treatment from the Jakei. She spent most of her time away from J`thir, traveling across the world. Every time she returned, she had many stories for her sister. Her signature, like her sister, was her ice staff.",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1BE8Df1Bg3Aj9Aj9Bmszvxirossjeerf",
      "deckLimit": 2
    },
    {
      "id": 62,
      "name": "Lasher Helm",
      "description": "At the start of its turn, equipped champion takes 5 Physical damage. When equipped champion is destroyed, this equipment is equipped onto the closest valid enemy champion to this equipment's owner.\r\n",
      "flavorText": "The Lasher skitters from host to host, latching onto their heads and striking their backs with a razor tail.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2BE8Df1Bf1Aj9Cj9Dusmuojlplnjwqqf",
      "deckLimit": 2
    },
    {
      "id": 155,
      "name": "Legion Standard",
      "description": "Equipped champion has <ability value=1241>Motivate</ability>. If equipped champion has Race: Draksar, it also gains <ability value=1382>Prestige</ability> and <ability value=1138>Command: Block</ability>. If equipped champion has Race: Skeezick, it gains <ability value=456>Fear 3</ability> and <ability value=1717>Command: Charge</ability>.",
      "flavorText": "\"Whosoever bears my standard shall not falter. March without fear for the Sundered Lands and lay waste to all who would oppose our right to rule Poxanthuru.\" - Vex the Godmother\r\n",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9Ae9Af1Bf1Aj9Fj9Ggnyxvfmnwthvkpf",
      "deckLimit": 2
    },
    {
      "id": 39,
      "name": "Lichbone Staff",
      "description": "Equipped Champion gains <ability value=805>Chain Lightning</ability>, <ability value=189>Death Nova: Electricity</ability> and <ability value=562>Self Destruct</ability>. If it has Race: Lich, it also gains <ability value=488>Soulsift 1</ability>.",
      "flavorText": "\"Kanos, Lord Serkan has determined you will no longer be of use in this form...\" - Xulos upon entering the Sanctum of the Lich of Kanos",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1AE8Df1BF0AJ8Jj9Aerumykykepsoso",
      "deckLimit": 2
    },
    {
      "id": 151,
      "name": "Lightning Rod",
      "description": "All Electricity damage dealt to champions via Spells and Abilities (including basic attacks) within 5 spaces without Lighting Rod is prevented, and this champion takes 80% of the prevented damage.",
      "flavorText": "When Zeventrech returned to the Cyclops tribes, he brought weapons and armor from the Old Empire. These would be the beginning of their glorious return to power.",
      "noraCost": 25,
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2Ae9Af1BF0Bj9Bj9Ceeeeerlgpnhykpf",
      "deckLimit": 2
    },
    {
      "id": 239,
      "name": "Lonx Bonecharm",
      "description": "Equipped champion gains <ability value=2324>Pounce</ability>. If it has Race: Lonx, it also gains <ability value=474>Blood Rage</ability>. If this equipment is destroyed, this champion permanently has <ability value=86>Vulnerability: Physical</ability>.",
      "flavorText": "\"We are a people of extremes. More than accept it, we embrace it.\" -- Lonx Chieftan",
      "noraCost": 35,
      "artist": "Caio Monteiro",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0BG2BG2AE8DJ8IJ8Jytmpnllluqshtqf",
      "deckLimit": 2
    },
    {
      "id": 180,
      "name": "Looting Bag",
      "description": "Equipped champion gains <ability value=2212>Banditry</ability> and <ability value=1393>Pillage</ability>. If it already has Banditry or Pillage, it also gains <ability value=15>Multiattack 1</ability>.",
      "flavorText": "The \"vendor\" pulled item after item out of his seemingly bottomless bag. It was not until later that I realized why some of the items looked so familiar...",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2Be9Af1Bf1Bj9Cj9Dnpythkrjpjpfxqf",
      "deckLimit": 2
    },
    {
      "id": 225,
      "name": "Lost Grimoire",
      "description": "Equipped champion gains <ability value=3134>Suppression</ability>. If it has Race: Fairy or Race: Elf, it also gains <ability value=3211>Portent</ability>.",
      "flavorText": "\"Menalaus, one seeks you from within the crowd. Ready yourself.\" ~ Voice of Amareth, from within the Grimoire wherein she is trapped",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0Bf1AG2Af1BJ8IJ8Jirfgeeplyxkyrqf",
      "deckLimit": 2
    },
    {
      "id": 111,
      "name": "L`ilim's Boots",
      "description": "Equipped champion Class: Archer gains +1 SPD, <ability value=1441>Confuse Enemy</ability> and <ability value=1378>Evasive 3</ability>.",
      "flavorText": "During his days as an archer, L'ilim was able to outrun the fastest hawks in K'thir. Rumors say that his agility came from his boots.",
      "noraCost": 20,
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1Be9Af1BE8Dj9Aj9Byzirsojnpfillpf",
      "deckLimit": 2
    },
    {
      "id": 142,
      "name": "Mail of Barbs",
      "description": "Equipped champion with Race: Leoss gains <ability value=2165>Abuse Charged 3</ability>, <ability value=2167>Attack Charged 2</ability>, and <ability value=2190>Charged Attack</ability>.",
      "flavorText": "\"To Hraken, every wound was its own punishment. Each scar was a reminder of a careless defense. They say his armor was made to leave a mark whenever he made such mistakes.\" - Mosharn the Barricade",
      "noraCost": 30,
      "artist": "Slawomir Maniak",
      "factions": [
        "Ironfist Stronghold",
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2Be9Af1BF0Aj9Cj9Drqsxzigykgevkpf",
      "deckLimit": 2
    },
    {
      "id": 46,
      "name": "Mammoth Club",
      "description": "Equipped champion gains <ability value=958>Mammoth Club</ability>. If it is Size: Large and has max range of 2 or less, it also gains <ability value=2704>Crushing Blow</ability>. If it is Size: Small, it has -2 SPD.",
      "flavorText": "\"Does Vrap actually think he can wield that in battle? It's bigger than he is...\"  - Moga Scout",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ie9AE8Df1BF0Bj9Fj9Ggygyoqljyofxzo",
      "deckLimit": 2
    },
    {
      "id": 124,
      "name": "Mark of Kiergana",
      "description": "When equipped champion is attacked, the attacking champion gains 1 AP. If the attacking champion has Race: Kanen, the equipped champion has -1 DEF for the attack. When equipped champion is destroyed, this equipment is equipped onto the closest valid enemy champion to this equipment's owner.",
      "flavorText": "\"Many have come to take my place from me. They have all failed. If a Cultist wishes to challenge me, I welcome them. I would love to show them how I've kept my place for so long.\" - Kiergana, Crone",
      "noraCost": 35,
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GE8De9Af1Be9Bj9Ej9Feeemnnempnhnpn",
      "deckLimit": 2
    },
    {
      "id": 222,
      "name": "Medal of Valor",
      "description": "Equipped champion with MAX RNG of 2 or less has <ability value=2392>Battle Leader</ability> and +1 SPD.",
      "flavorText": "A symbol of valor and victory, whether granted or pulled from a corpse.",
      "noraCost": 25,
      "artist": "Rogier van de Beek",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1Af1AG2Ae9BJ8Jj9Aeerqousmuxoyzo",
      "deckLimit": 2
    },
    {
      "id": 237,
      "name": "Mind Orb",
      "description": "Equipped champion gains <ability value=3261>Mind Lock</ability>. If the champion is Race: Firk, it gains 2 AP on equip and gains +1 DEF and <ability value=3376>Noetic Mind</ability> instead.",
      "flavorText": "Awareness... Extremities... Emergence... ",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9BG2BG2AE8DJ8GJ8Hmwkggtszrfxzkpf",
      "deckLimit": 2
    },
    {
      "id": 118,
      "name": "Mind Shackle",
      "description": "Equipped champion becomes <condition value=paralyzed>Paralyzed</condition> for 2 turns. At the start of every other of your turns, it becomes Paralyzed for 2 turns.",
      "flavorText": "Baen opened his eyes to the endless desert. There were fragments of stone jutting from the ground, pointing in different directions. He tried to move, but his body didn't respond. His worst fear was confirmed; he was wearing his new invention.",
      "noraCost": 30,
      "artist": "Simon Dominic",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Be9Af1Be9AJ8IJ8Juonhitfrqfinhpf",
      "deckLimit": 2
    },
    {
      "id": 190,
      "name": "Mindflayer",
      "description": "Equipped champion gains <ability value=2685>Restraining Aura</ability> and <ability value=2251>Combat Awareness 2</ability>.",
      "flavorText": "Mindflayer Beetles feed off the mental energies of a person, in return, it bestows its victims with an array of powers.",
      "noraCost": 25,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2Ae9Af1BG2Aj9Bj9Ceeiyiwtxqhygyrf",
      "deckLimit": 2
    },
    {
      "id": 44,
      "name": "Mirrored Shield",
      "description": "Equipped champion gains <ability value=2209>Mirrored</ability>.",
      "flavorText": "\"The magic in the ice reflects more than just light.\"",
      "noraCost": 35,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IG2BE8Df1BF0Bj9Cj9Dukuklyxtxfvvmpf",
      "deckLimit": 2
    },
    {
      "id": 203,
      "name": "Moga Magnet",
      "description": "Equipped champion gains <ability value=2717>Gravity Well</ability> and <ability value=1891>Magnetic Pulse</ability>.",
      "flavorText": "As objects of various sizes and destructiveness hurtled towards him, Naar vowed that this was the last time he volunteered as a test subject for the Cyclops... unless they increased the compensation, of course.",
      "noraCost": 30,
      "artist": "Kirill Chepizhko",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1Be9Af1BG2Bj9Aj9Bouxvoyoszoufxqf",
      "deckLimit": 2
    },
    {
      "id": 194,
      "name": "Moga Rumble Pack",
      "description": "Equipped champion gains  +1 SPD.  If it has Race: Moga, it also gains <ability value=2626>Scrapper</ability>.",
      "flavorText": "Moga who use the Rumble Pack report a 47% increase in reaction time and combat efficiency.",
      "noraCost": 25,
      "artist": "Asa Enochs",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CE8De9Af1BG2Bj9Ej9Fqouzojlukpjtsqf",
      "deckLimit": 2
    },
    {
      "id": 139,
      "name": "Molten Cloak",
      "description": "Equipped champion gains +1 DEF, <ability value=543>Attack: Fire</ability>, <ability value=1255>Inhibiting Touch</ability> and <ability value=229>Damage Shield: Fire 3</ability>.",
      "flavorText": "The original Flamehearts were Nefari warriors who lived by fire. They wore cloaks of flame that scorched whoever dared to attack. It is said that these cloaks still exist, but in a different form.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1Ae9Af1BF0AJ8Jj9Aeipyzkwfgrumuo",
      "deckLimit": 2
    },
    {
      "id": 123,
      "name": "Murder",
      "description": "Equipped champion gains <ability value=1486>Strike</ability> and <ability value=2166>Attack Charged 1</ability>. If it has Class: Archer or Class: Rogue, it also gains <ability value=2232>Nora Thief</ability>",
      "flavorText": "\"Did you touch her? I'll kill you if you had your grubby paws on her! No one else touches the bow, no one.\" - Ash the Bandit Prince",
      "noraCost": 20,
      "artist": "Bartek Gawel",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fg3Ae9Af1Be9Aj9Dj9Eemnpwfkumufrhrf",
      "deckLimit": 2
    },
    {
      "id": 61,
      "name": "Nefari Mind Tomb",
      "description": "Equipped champion gains <ability value=3006>Nora Induction</ability> and <ability value=1913>Backlash</ability>. When equipped champion is destroyed, this equipment is equipped onto the closest valid enemy champion to this equipment's owner.",
      "flavorText": "\"The skin stays unharmed, but the mind is completely ruined. Even the most stalwart elf is reduced to fits of shaking. What a wonderful device!\" - Jaezian, Nefari Torturer",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2AE8Df1Bf1Aj9Bj9Ceiymjyvkwxtxmpf",
      "deckLimit": 2
    },
    {
      "id": 7,
      "name": "Night Blade",
      "description": "Equipped champion gains <ability value=1775>Precision</ability> and <ability value=2646>Heart Strike</ability>. If the champion is Race: Archdemon, it also gains <ability value=3154>Enervating Touch</ability>. If the champion is Race: Imp, it gains <ability value=99>Life Siphon</ability> instead.",
      "flavorText": "\"Never in my life have I held a blade with better balance.\" - Tyer Galenne, Elven Blade Master upon defeating a Bok Guardian",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2BE8Df1BE8Dj9Cj9Dussmyzzgruxirqf",
      "deckLimit": 2
    },
    {
      "id": 8,
      "name": "Oaken Mace",
      "description": "Equipped champion gains <ability value=1055>Oaken Mace</ability>. If it has Race: Garu, it also gains <ability value=3097>Toss Equipment</condition> (starts on cooldown).",
      "flavorText": "\"Menalaus does not realize that this IS the forest defending itself\" - Godwin, Elder Garu",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3AE8Df1BE8Dj9Dj9Eerqwinwvmeeiwqf",
      "deckLimit": 2
    },
    {
      "id": 29,
      "name": "Octopi Helm",
      "description": "Equipped champion gains <ability value=718>Ink</ability> (Target champion within 3 spaces becomes Blinded 4 (its attacks automatically miss).).",
      "flavorText": "\"Not again...\" - Dorn Grimbeard",
      "noraCost": 35,
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1BE8Df1Be9Bj9Aj9Bemjiepjwirwmso",
      "deckLimit": 2
    },
    {
      "id": 148,
      "name": "Ol' Sok",
      "description": "The first time each turn equipped champion makes a basic attack, all spaces within Area 2 of the target become <mechanic value=poison_cloud>Poison Cloud</mechanic>. If equipped champion is friendly, it gains <ability value=40>Immunity: Poison</ability>.",
      "flavorText": "\"What on Pox is that wretched odor?! Did Sok make his disgusting stew again?! Damnation I think I'm going to be sick...\" - Bilgen, Houndmaster\r\n",
      "noraCost": 35,
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0Be9Af1BF0BJ8IJ8Jukukuszrwvfmuo",
      "deckLimit": 2
    },
    {
      "id": 241,
      "name": "Paper Wings",
      "description": "Equipped champion gains +1 SPD, <ability value=1>Flight</ability> and <ability value=2324>Pounce</ability>. If this equipment is destroyed, this champion loses 5 HP and permanently has -1 SPD.",
      "flavorText": "\"I got da wings! I got 'em! Ahhhhhhhh!\" -- Urtog, first flight",
      "noraCost": 25,
      "artist": "Paul Guzenko",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1BG2BG2AE8Dj9Aj9Betqftfiwmhnphrf",
      "deckLimit": 2
    },
    {
      "id": 188,
      "name": "Peridot Sphere",
      "description": "When this champion takes damage, opposing champions (to this equipment's owner) within 4 spaces of this champion takes 50% damage of the same damage type (to a maximum of 12).  This triggers 2 times per turn.",
      "flavorText": "\"That is no ordinary gemstone. The stench of Ba'lah reeks from it. Still, our artificers may be able to make use of its properties.\" ~ Draksar High Priest",
      "noraCost": 25,
      "artist": "Paul Guzenko",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1Ae9Af1BG2AJ8Jj9Aeevszvxfvonyoqf",
      "deckLimit": 2
    },
    {
      "id": 219,
      "name": "Pestilence",
      "description": "Equipped champion gains <ability value=3041>Hunter: Meek</ability>, <ability value=2646>Heart Strike</ability> and <ability value=1966>Rotting Blows</ability>.",
      "flavorText": "As the wars dragged on, Xulos's cabal of apprentices and experimentors produced inventions of increasing complexity and cruelty.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1AF0AG2Ag3AJ8Jj9Aeeerwmwqlwkljrf",
      "deckLimit": 2
    },
    {
      "id": 167,
      "name": "Phoenix Anklet",
      "description": "If equipped champion would be destroyed, this equipment is destroyed instead and the champion is set to full HP, gains <condition value=flying>Flying</condition>, <ability value=107>Immortality</ability>, and <ability value=875>Short Lived 1</ability>.",
      "flavorText": "\"Vincatis fro sinstris\" ~ Inscription on the Phoenix Anklet, roughly translated as, \"From the crystal\"",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9Ae9Af1Bf1Bj9Fj9Ggtxtxtsqsszvoqf",
      "deckLimit": 2
    },
    {
      "id": 35,
      "name": "Poison Dart",
      "description": "Equipped champion gains <ability value=730>Poison Sting</ability> and <ability value=912>Amplify: Poison</ability>.",
      "flavorText": "\"You see, even the mosquito's sting can be quite deadly.\" - Gekaal, Forglar High One",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9AE8Df1BF0Aj9Fj9Gigyknplgtmpfvo",
      "deckLimit": 2
    },
    {
      "id": 181,
      "name": "Processing Collar",
      "description": "Equipped champion gains <ability value=2005>Careless</ability> and loses 4 HP after it uses any ability (including attacks).",
      "flavorText": "Don't touch please, that's a precision instrument.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ag3Ae9Af1Bf1Bj9Dj9Eemekwqjiyvshgrf",
      "deckLimit": 2
    },
    {
      "id": 138,
      "name": "Protean Chains",
      "description": "Equipped champion gains <ability value=5>Lumbering</ability> and <ability value=2260>Pariah</ability>. If the equipped champion has Race: Dragon or Race: Beast, it instead gains <ability value=2707>Vivify</ability> and <ability value=15>Multiattack 1</ability>.",
      "flavorText": "T'iern's bindings seemed simple enough, until he tried to pull at them. With each tug, the chains grew longer. T'iern thought he had the advantage, until the chains began to snake around his legs.",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks",
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0Be9Af1BF0AJ8IJ8Jeiymyruvkyosqo",
      "deckLimit": 2
    },
    {
      "id": 117,
      "name": "Providence",
      "description": "Equipped champion with a range of 3 or less and with Class: Warrior or Race: Leoss gains <ability value=1987>Hold the Line</ability>, <ability value=2568>Vigilance</ability>, <ability value=2230>Barricade</ability>.",
      "flavorText": "When Kanen Cultists speak of the mighty Mosharn, they tell of a Leoss made of obsidian who swallows Mongrels whole. In battle, Mosharn held his Bulwark in front of him and smashed Kanen who came close.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold",
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0Ae9Af1Be9AJ8HJ8Ilrsshvkepfipyo",
      "deckLimit": 2
    },
    {
      "id": 133,
      "name": "Pulsing Globule",
      "description": "Equipped champion has <ability value=2305>Toss Globule</ability>.  When this equipment has been on the same unit at the end of 4 consecutive turns, this equipment is destroyed and that champion takes 30 Poison damage.",
      "flavorText": "Originally, pulsing globules were meant as a practical joke; the boghopper left holding one the longest was covered in marsh muck. It was the Darkmarsh Defilers who began filling the globules with lethal poisons.",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gg3Ae9Af1Be9Bj9Dj9Eeevfirofmsmsjpf",
      "deckLimit": 2
    },
    {
      "id": 212,
      "name": "Quarry Mark",
      "description": "The closest opposing champion to the equipped champion within 5 spaces gains <ability value=2974>Hunter: Equipped</ability> and +2 DMG.",
      "flavorText": "\"Oh, you got one of these too?\" \"I know, it's so pretty!\"",
      "noraCost": 20,
      "artist": "Darcie Banfield",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3Ae9BG2AE8Dj9Dj9Eemsxthipqqjphrf",
      "deckLimit": 2
    },
    {
      "id": 97,
      "name": "Rage Band",
      "description": "Equipped champion gains <ability value=1880>Violent</ability>. If champion has max range 2 or less, it also gains <ability value=260>Enrage 2</ability> and <ability value=597>Unstoppable</ability>.",
      "flavorText": "\"Stay close to your frenzied brothers; the bands have taken their senses from them. They will need a clear-thinking compatriot to help guide their blinding rage.\" - Ardain the Zealot",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DF0AE8Df1Bg3AJ8HJ8Iiwqszvxmlwztmpf",
      "deckLimit": 2
    },
    {
      "id": 90,
      "name": "Reaper's Blade",
      "description": "Equipped champion's DMG is set to 0 and it gains <ability value=1791>Soulstrike</ability>.",
      "flavorText": "\"Bring me the false king, and I will make a use for him. I will use his ether to temper a blade and his body will be fashioned into a hilt. I will make your old king into a weapon.\" - Serkan, Lich Master",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1BE8Df1BG2Bj9Aj9Bsoszkyvfxxmyvqf",
      "deckLimit": 2
    },
    {
      "id": 247,
      "name": "Red Griffin's Brew",
      "description": "Equipped Champion is <condition value=intoxicated>Intoxicated</condition>, gains <ability value=396>Charge 3</ability>, and <ability value=1979>Running Start</ability>.",
      "flavorText": "This brew be making me wan' to fly.",
      "noraCost": 25,
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2BE8Df1Bf1Bj9Cj9Dxqwfgvfexthyvqf",
      "deckLimit": 2
    },
    {
      "id": 71,
      "name": "Rejuvenation Ring",
      "description": "Equipped champion gains <ability value=1561>Growth 4</ability>. At the start of each turn, this champion heals 3 HP. When this champion makes a basic attack, it heals 3 HP.",
      "flavorText": "The Ring of Rejuvenation is said to bestow life force to its wearer, healing injuries as well. Another ring was crafted to counteract its power. If the rings were to meet, their powers would clash.",
      "noraCost": 25,
      "artist": "Anthony Lopes",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AG2AE8Df1Bf1Bj9Bj9Cemsjgrlufvxxqqf",
      "deckLimit": 2
    },
    {
      "id": 153,
      "name": "Remote Control",
      "description": "Equipped champion gains <ability value=2636>Rev 'Em Up</ability>.",
      "flavorText": "\"It's easy, just twist this knob once to the left, push this button three times, then the other button over there once. Once that's done then twist the knob counterclockwise twice and push the red button on the back. After the lights start flashing th-\" Blitter, Dwarven Tinkerer",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8Ig3Ae9Af1BF0Bj9Dj9Eeeeeevojtzzvsqf",
      "deckLimit": 2
    },
    {
      "id": 223,
      "name": "Reverberating Bracelet",
      "description": "Equipped champion gains <ability value=2649>Void Shield</ability>. If it has Class: Monk or Race: Salaman, it also gains <ability value=3189>Sonicburst</ability>.",
      "flavorText": "The Salaman quickly began experimenting with imported minerals, often with unexpected results. ",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Af1AG2Ae9Bj9Bj9Ceemsjtjpnwitmpf",
      "deckLimit": 2
    },
    {
      "id": 199,
      "name": "Rock Collection",
      "description": "Equipped champion gains <ability value=2662>Surge: Rock</ability> and <ability value=2764>Stone Barrage</ability>.  After this champion has made 3 basic attacks, it also gains <ability value=1361>Trail: Rock</ability> and this equipment's owner gains 10 nora.",
      "flavorText": "\"I swear, these here be magical rocks!\" - Anonymous Dwarven Merchant",
      "noraCost": 30,
      "artist": "Darcie Banfield",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9Be9Af1BG2BJ8GJ8Hwqofkrjtxtsxfpf",
      "deckLimit": 2
    },
    {
      "id": 76,
      "name": "Rugolth's Fist",
      "description": "Equipped champion gains <ability value=1699>Rugolth's Fist</ability> (Non-Flying enemy Champions within 4 spaces take 12 Physical damage and lose all AP. This damage ignores DEF). If equipped champion has Race: Dwarf, you are refunded 10 nora.",
      "flavorText": "During his escape from Valdac, it is said that Rugolth split the earth with his fist.",
      "noraCost": 40,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9BE8Df1BG2AJ8GJ8Hiwzgiymwthkgvo",
      "deckLimit": 2
    },
    {
      "id": 69,
      "name": "Sacred Peaks Amulet ",
      "description": "Equipped champion with Race: Moga gain <ability value=1377>Evasive 2</ability>. Equipped champion with Race: Cyclops gains <ability value=1225>Bastion of Mobility</ability>. Equipped champion with Race: Voil gain <ability value=8>Battlemaster 2</ability>.",
      "flavorText": "Despite inner-turmoil, the Shattered Peaks are well defended by its inhabitants. An amulet was crafted to celebrate the moments when they cooperate.",
      "noraCost": 20,
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Af1AE8Df1Bf1BJ8Jj9Aerqolplegrszipf",
      "deckLimit": 2
    },
    {
      "id": 106,
      "name": "Sacred Peaks Amulet ",
      "description": "Equipped champion with Race: Moga gain <ability value=1377>Evasive 2</ability>. Equipped champion with Race: Cyclops gains <ability value=1225>Bastion of Mobility</ability>. Equipped champion with Race: Voil gain <ability value=8>Battlemaster 2</ability>.",
      "flavorText": "Despite inner-turmoil, the Shattered Peaks are well defended by its inhabitants. An amulet was crafted to celebrate the moments when they cooperate.",
      "noraCost": 20,
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "LIMITED",
      "runeSet": "Nora Surge",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Be9Af1BE8DJ8GJ8Hqssqhtfxzigyro",
      "deckLimit": 2
    },
    {
      "id": 68,
      "name": "Sacred Tundra Amulet",
      "description": "Equipped champion with Race: Jakei gains <ability value=1214>Encouraged</ability>. Equipped champion with Race: Lonx gains <ability value=1320>Assault</ability>. Equipped champion with Race: Yeti gains <ability value=2471>Protective</ability>.",
      "flavorText": "\"The tundra holds us together. We have learned to survive as a community. With this amulet, made of the tundra, we will continue to prosper.\" - J'orea, Frost Queen",
      "noraCost": 20,
      "artist": "Anthony Lopes",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AF0BE8Df1Bf1BJ8IJ8Johiwqjetzitfepf",
      "deckLimit": 2
    },
    {
      "id": 107,
      "name": "Sacred Tundra Amulet",
      "description": "Equipped champion with Race: Jakei gains <ability value=1214>Encouraged</ability>. Equipped champion with Race: Lonx gains <ability value=1320>Assault</ability>. Equipped champion with Race: Yeti gains <ability value=2471>Protective</ability>.",
      "flavorText": "\"The tundra holds us together. We have learned to survive as a community. With this amulet, made of the tundra, we will continue to prosper.\" - J'orea, Frost Queen",
      "noraCost": 20,
      "artist": "Anthony Lopes",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "LIMITED",
      "runeSet": "Nora Surge",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Ae9Af1BE8DJ8HJ8Ihyofrwqjiyztuo",
      "deckLimit": 2
    },
    {
      "id": 10,
      "name": "Sacrificial Dagger",
      "description": "Equipped champion gains +2 DMG and <ability value=2837>Psychotic Break</ability>. If equipped champion has Race: Vampyre, it also gains <ability value=2706>Blood Knowledge</ability>.",
      "flavorText": "When a blade drinks from enough corpses, it develops a taste for blood.",
      "noraCost": 30,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9AE8Df1Be9Aj9Fj9Gkwkgnlgvzxkgnpf",
      "deckLimit": 2
    },
    {
      "id": 51,
      "name": "Scepter of Onus",
      "description": "Equipped champion gains <ability value=737>Spellswallower</ability> and <ability value=1780>Radiant Blow</ability>.  If it has Class: Wizard or Race: Imp, it also gains <ability value=3088>Flameburst</ability>.",
      "flavorText": "\"Kalaxa, for your careful razing of the north villagers, the Lord Tyrux present you the staff of their leader.\" - Nefari Messenger",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1AE8Df1BF0BJ8Jj9Aeeeeeitmepqjwo",
      "deckLimit": 2
    },
    {
      "id": 11,
      "name": "Scimitar of the Deep",
      "description": "Equipped champion gains <ability value=2>Amphibious</ability> (This champion ignores restrictions and penalties imposed by Water.) and <ability value=833>Scimitar of the Deep</ability> (This champion makes a Physical attack at RNG 1. When this champion occupies Water, it gets +10 DMG on this attack.).",
      "flavorText": "The swamps of Forglar are filled with treasures left by those who did not wish to be found.",
      "noraCost": 35,
      "artist": "Dan Kopycienski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Fe9BE8Df1Be9AJ8GJ8Houhkymhymwouso",
      "deckLimit": 2
    },
    {
      "id": 226,
      "name": "Scorched Earth",
      "description": "After 6 turns, this equipment is destroyed, the equipped champ takes 10 Fire damage and becomes <condition value=charred>Charred</condition> for 3 turns.  When this triggers or if the champion is destroyed while equipped, a Young Naria Seedling is summoned to the closest available space under the control of this equipment's owner.",
      "flavorText": "Everything is fertile ground, so long as the right type of life takes root.",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest",
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JE8Df1BG2Af1Aj9Ej9Fofevxkljlgitsqf",
      "deckLimit": 2
    },
    {
      "id": 125,
      "name": "Scythe of Gore",
      "description": "Equipped champion gains <ability value=1850>Frightful Blows</ability>. If it has Race: Kanen, it also gains <ability value=15>Multiattack 1</ability>.",
      "flavorText": "When Garin arrived in Valdac, he had nothing. He crafted a crude scythe from scrap, to protect himself. As he gained renown as a reliable mercenary, his scythe became a symbol of fear.",
      "noraCost": 30,
      "artist": "Simon Dominic",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9Ae9Af1Be9Bj9Fj9Gevxxmumwvmphto",
      "deckLimit": 2
    },
    {
      "id": 86,
      "name": "Seed of Potential",
      "description": "Equipped champion has <ability value=3332>Vine Whip</ability> and <ability value=1458>Forest Front</ability>.  This equipment can be dropped as a relic that has <ability value=2674>Nature's Connections</ability> and <ability value=1458>Forest Front</ability>.",
      "flavorText": "To the elves of K`thir, each seed has the potential to become something extraordinary. This is celebrated throughout the forest.",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Ce9BE8Df1BG2BJ8GJ8Hggnhnplrsxxxzo",
      "deckLimit": 2
    },
    {
      "id": 204,
      "name": "Serpentor Scale Armor",
      "description": "Equipped champion gains <ability value=2646>Heart Strike</ability>. If equipped champion has max range of 2 or less, it also gains <ability value=2619>Zeal: Speed</ability> and +1 DEF.",
      "flavorText": "The scales of the Serpentor are remarkably tough and when a Serpentor falls in battle, their remains become property of the Draksar Legion.",
      "noraCost": 25,
      "artist": "Anthony Lopes",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2Ae9Af1BG2Bj9Bj9Cevonjljnsxojgrf",
      "deckLimit": 2
    },
    {
      "id": 37,
      "name": "Sheoul Brand",
      "description": "Equipped champion has -2 DMG and gains <ability value=2853>Trail: Fire Wall</ability> and <ability value=6>Mobility</ability>.",
      "flavorText": "Once the demons learned of the Nefari's fear of fire, they quickly adapted using it as a means to control them.",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HF0AE8Df1BF0AJ8HJ8Ivofvhemnethgkn",
      "deckLimit": 2
    },
    {
      "id": 36,
      "name": "Sheoul Firebow",
      "description": "Equipped champion gains <ability value=808>Sheoul Firebow</ability> (This champion makes a Fire attack at RNG 3-5 at +2 DMG) and <ability value=3002>Hunter: Quick</ability>. If it is Race: Demon Elf, it gains <ability value=3155>Declare Vengeance</ability>.",
      "flavorText": "\"It seems the flame-kissed Nefari have found new ways to share their recently acquired talents.\" - Xandra, Sheoul Succubus ",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8He9BE8Df1BF0AJ8GJ8Heiyvqzvzohephn",
      "deckLimit": 2
    },
    {
      "id": 12,
      "name": "Shield of Darkness",
      "description": "Equipped champion has +1 DEF and gains <ability value=2315>Oblivion Shield</ability>. If equipped champion has Race: Vampyre, it also gains <ability value=711>Siphoning Aura</ability>.",
      "flavorText": "\"Some consider darkness a hindrance. Those people are simply not resourceful.\" -  Xulos, Apprentice of Serkan",
      "noraCost": 30,
      "artist": "Dan Kopycienski",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0AE8Df1Be9AJ8HJ8Inevoqoqwiwtqwo",
      "deckLimit": 2
    },
    {
      "id": 13,
      "name": "Shield of Flame",
      "description": "Equipped Size: Small champion gains <ability value=180>Death Nova: Fire 2</ability> and <ability value=1404>Fire Feed</ability>. If equipped champion is Size: Small and has max 2 or less range, it gains <ability value=388>Flame Armor</ability>.",
      "flavorText": "\"It is as if the Nefari have learned to temper the very essence of fire into their steel.\" - Feofil, Assistant to Rugolth",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0BE8Df1BE8DJ8IJ8Jwzgeronhytuqwo",
      "deckLimit": 2
    },
    {
      "id": 14,
      "name": "Shield of Thorns",
      "description": "Equipped Champion gains <ability value=213>Block 1</ability> and <ability value=751>Spike Nova 3</ability>.",
      "flavorText": "\"They weren't kidding in training -- thorns really do hurt more when you willingly chose to hit them.\" - Szlaan, Draksar Footman",
      "noraCost": 25,
      "artist": "Dan Kopycienski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FF0BE8Df1Be9AJ8IJ8Jszonwvmethknepf",
      "deckLimit": 2
    },
    {
      "id": 127,
      "name": "Shimmering Flower",
      "description": "Equipped champion is <condition value=distracted>Distracted</condition>.",
      "flavorText": "\"Be careful in the jungles, friend. Even the plants will... try to... That's a lovely one, right there. This place is so beautiful. I think I might settle here, some day.\" - F'aridan, Elven Archer",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0Ae9Af1Be9BJ8HJ8Ieiphygrsqzgkjn",
      "deckLimit": 2
    },
    {
      "id": 183,
      "name": "Shredding Bracelet",
      "description": "Whenever this champion activates an ability, it loses 2 HP and a Blood Ball worth 6 HP is created on an adjacent space. When equipped champion is destroyed, this equipment is equipped onto the closest valid enemy champion to this equipment's owner.",
      "flavorText": "\"Shackles come in many forms. Some bind physically while others are psychological.  These ones are special. They mark you and then slowly drain you of all will to live.  Fascinating, really.\" ~ Lord Rangal",
      "noraCost": 30,
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9Ae9Af1BG2Aj9Fj9Guxxfexojnljwtqf",
      "deckLimit": 2
    },
    {
      "id": 110,
      "name": "Shroud of Al'Mara",
      "description": "Equipped champion with Class: Priest or Shaman gains <ability value=1728>Divert</ability> and <ability value=592>Cleanse</ability>.",
      "flavorText": "\"She spent many hours praying in her shroud. I dared not disturb her. Later, she would tell me that she prayed for strength from Al'Mara and that her prayer sustained her in Maljara.\" - Thomroy, Priets of Ironfist",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1Ae9Af1BE8DJ8Jj9Aerllexigekemhpf",
      "deckLimit": 2
    },
    {
      "id": 47,
      "name": "Skeezick Blade",
      "description": "Equipped champion gains <ability value=920>Skeezick Blade</ability> (This champion makes a Physical attack at RNG 1. If successfully damaged, the target becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns and <condition value=inhibitied>Inhibitied</condition>). If champion has Race: Skeezick, it also gains <ability value=2198>Decapitating Blow</ability>.",
      "flavorText": "\"This blade is a gift from Rugolth himself,  Giblip. Be sure the Draksar Lord is looking in your eyes when you separate head from neck.\" - Dwarven Minister to the Skeezick General",
      "noraCost": 25,
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8If1BE8Df1BF0Bj9Aj9Bkukushrlgpqfepf",
      "deckLimit": 2
    },
    {
      "id": 147,
      "name": "Skystorm Spear",
      "description": "Equipped champion gains <ability value=3128>Portal Dancer</ability> and <ability value=1263>Swap 2</ability>. If it has Class: Knight, it also gains <ability value=2291>Lightning Storm 3</ability>.",
      "flavorText": "Many myths surround the Skystorm Spear, but they all share one common thread: the spear was thrown from the sky by a god. Ospryans believe the spear was meant as a gift for the Silver General.",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "K'thir Forest",
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8JJ8IF0Ae9Af1BF0BJ8HJ8Iukukymsufrqsqo",
      "deckLimit": 2
    },
    {
      "id": 79,
      "name": "Slaver's Whip",
      "description": "Equipped champion gains <ability value=656>Drive</ability>. If equipped champion is Race: G'hern, it also gains <ability value=1717>Command: Charge</ability>. If equipped champion is Race: Voil, it gains <ability value=1138>Command: Block</ability> instead.",
      "flavorText": "\"They only understand pain. It is the one language we share with these dolts. If you are not forceful, they will turn on you. But if you are, they will build you a kingdom.\" - Eehiist, Voil Queen",
      "noraCost": 30,
      "artist": "Darcie Banfield",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bf1AE8Df1BG2AJ8Jj9Aeemwqwvvhvxxmpf",
      "deckLimit": 2
    },
    {
      "id": 54,
      "name": "Smooth Stone",
      "description": "This champion gets +1 DEF and +1 SPD and gains <ability value=855>Hidden: Water</ability> and <ability value=6>Mobility</ability>.",
      "flavorText": "Throw a smooth stone across the water, and it will run upon it for a time. Infuse that stone with the spirit of the lake, and bathe it in nora, and it will allow you to do the same.",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9AE8Df1Bf1Aj9Fj9Ghrzxmpqlggevhpf",
      "deckLimit": 2
    },
    {
      "id": 15,
      "name": "Snaptooth Helm",
      "description": "Equipped champion gains <ability value=3101>Ferocious Bite</ability> and <ability value=221>Damage Shield: Physical 3</ability>.",
      "flavorText": "\"The way of the swamp is mysterious at times, for what once would cause great harm now prevents it.\" Gekal, Forglar High One",
      "noraCost": 20,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ef1BE8Df1BE8Dj9Aj9Bjtuxinuohpykjpf",
      "deckLimit": 2
    },
    {
      "id": 185,
      "name": "Snowdrift Charm",
      "description": "Equipped champion gains <ability value=600>Arctic</ability>, <ability value=2669>Snowstrike</ability>, <ability value=2796>Snowbreach</ability> and <ability value=1324>Domain: Arctic</ability>.  After this champion has made 4 attacks, it also gains <ability value=2668>Surge: Tundra</ability> and this equipment's owner gains 10 nora.",
      "flavorText": "Not all who dwell in the arctic were born of the snow, but the Tundra welcomes those who see past the harshness and embrace its gifts.",
      "noraCost": 25,
      "artist": "Anthony Lopes",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9Be9Af1BG2AJ8GJ8Hsmjyknjnnpufxo",
      "deckLimit": 2
    },
    {
      "id": 200,
      "name": "Snowkite Messenger",
      "description": "When a friendly champion is deployed from the runedock, if it shares a race with equipped champion, equipped champion gains 2 AP and +2 DMG until end of turn. If the deployed champion has a Logistics ability, it also gains 2 AP and +2 DMG until end of turn.",
      "flavorText": "Snowkites are prized for their remarkable ability to find almost anyone they have previously encountered, even across great distances.  When Juya disappeared, Snowkites sent after her refused to take flight.",
      "noraCost": 25,
      "artist": "Thomas Babbey",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CF0Ae9Af1BG2BJ8HJ8Ihrzkjpwxztowkpf",
      "deckLimit": 2
    },
    {
      "id": 131,
      "name": "Soul Reaver",
      "description": "Equipped champion is <mechanic value=cleansed>Cleansed</mechanic>. On deploy, enemy champions within 5 spaces are <condition value=cursed>Cursed</condition>, <condition value=defiled>Defiled</condition> and <condition value=branded>Branded</condition> for 5 turns.  If equipped champion has Class: Paladin, it gains <ability value=3234>Truthseeker</ability>. If equipped champion has Race: Undead, it also gains <ability value=1850>Frightful Blows</ability>.",
      "flavorText": "When Magnus turned away from the Inquisition, he discarded his weapon and his armor. It is said that, over time, the Stitched created new armaments for their warrior. One of these creations was his Soul Reaver; a mace of bone and steel, both from unknown origins.",
      "noraCost": 30,
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes",
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2Ae9Af1Be9Bj9Bj9Ceerqwqjtzrlexo",
      "deckLimit": 2
    },
    {
      "id": 186,
      "name": "Special Prize",
      "description": "Equipped champion gains -3 DMG, <ability value=2260>Pariah</ability>, <ability value=1724>Depression</ability> and <ability value=2008>Liability</ability>.  After this champion has made 4 attacks, it also gains <ability value=2001>Defenseless</ability> and this equipment's owner gains 10 nora.",
      "flavorText": "Rodney was enjoying himself immensely. Despite it being his first campaign, he was proud of how much better he looked than the rest of the ranger corps.",
      "noraCost": 25,
      "artist": "Paul Guzenko",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0Ae9Af1BG2AJ8HJ8Igkumuqjiwqwzgpf",
      "deckLimit": 2
    },
    {
      "id": 162,
      "name": "Spike",
      "description": "Equipped champion with 2 or less MAX RNG gains <ability value=1901>Tough 2</ability>. If it is Race: Cyclops, it also gains <ability value=2392>Battle Leader</ability>.",
      "flavorText": "\"Das mine!\" - Klub the Devourer",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JG2Be9Af1Bf1Aj9Cj9Dfvfxfmwoyxiytqf",
      "deckLimit": 2
    },
    {
      "id": 158,
      "name": "Spinner's Greaves",
      "description": "Equipped champion gains +2 DEF and <ability value=1198>Cocoon</ability> .  If it has Race: Arthropod, it also gains <ability value=1248>Pull</ability>.",
      "flavorText": "\"Go! Get them quickly! You know how spiteful and mean Mistress can be when she wants something!\" - Sezs, Imp Trickster",
      "noraCost": 25,
      "artist": "Andrew Hou",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0Be9Af1Bf1AJ8IJ8Jmjytzziyiygiyo",
      "deckLimit": 2
    },
    {
      "id": 74,
      "name": "Spirit Stone",
      "description": "Equipped friendly champion has the AP cost of its non-basic attacks lowered by 1 to a minimum of 1. Equipped enemy champions have the AP cost of non-basic attacks increased by 1.",
      "flavorText": "\"You must achieve this balance through understanding one truth; that for every light, there is a darkness. This is true of all things.\" - Malalain, Almsgiver",
      "noraCost": 20,
      "artist": "Darcie Banfield",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8DE8Df1BG2Aj9Ej9Foqonuoytfpusmpf",
      "deckLimit": 2
    },
    {
      "id": 208,
      "name": "St. Semmir's Brew",
      "description": "Equipped champion is Cleansed and is <condition value=intoxicated>Intoxicated</condition> and gains <ability value=1052>Purified</ability>. If this equipment is destroyed while equipped to a Dwarf, it becomes Enraged 1 for 2 turns.",
      "flavorText": "St. Semmir's Men are a secretive sect who oppose the increasing radicalization of mainstream Ironfist culture. They are particularly against the Northern Cross Templars' heavy handed ways, although they do admit there's validity to the group's goals.",
      "noraCost": 25,
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Be9BG2AE8DJ8IJ8Jqsmumyxtjiplgpf",
      "deckLimit": 2
    },
    {
      "id": 126,
      "name": "Staff of Ascendance",
      "description": "Equipped champion gains <ability value=1340>Intensify.</ability> If it has a nora cost of 80 or more, it also gains <ability value=1237>Impenetrable</ability> and <ability value=2244>Jolt 1</ability>.",
      "flavorText": "\"I didn't know his face, but I knew his staff. I remembered seeing it a long time ago, while I was sailing across the Sea of Separation. It reminded me of home.\" - L'usara, explorer and sister to Queen J'orea",
      "noraCost": 30,
      "artist": "Andrew Hou",
      "factions": [
        "Savage Tundra",
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Ge9Be9Af1Be9BJ8GJ8Heevfekpuknjtfm",
      "deckLimit": 2
    },
    {
      "id": 114,
      "name": "Staff of the Solstice",
      "description": "Equipped champion with Class: Priest or Shaman has <ability value=371>Heal Mass 2</ability> and <ability value=1728>Divert</ability>.",
      "flavorText": "At the beginning of a season, the Seers would place ornamental staves in the center of their village. These staves of Solstice were believed to invite benevolent spirits to join them in the coming season.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Eg3Ae9Af1BE8Dj9Dj9Eeigygkjrqhnlyrf",
      "deckLimit": 2
    },
    {
      "id": 216,
      "name": "Star Catalog #16",
      "description": "Equipped champion gains <ability value=1744>Frost Acolyte</ability> and <ability value=137>Frost Aura 3</ability>.",
      "flavorText": "In an often barren and marker-less Tundra, the Jakei must use the crystal clear sky to navigate their sea of white.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2AF0AG2AG2Aj9Bj9Ceeiljeroljinjrf",
      "deckLimit": 2
    },
    {
      "id": 211,
      "name": "Static Bracelet",
      "description": "Equipped champion gains <ability value=1909>Storm Acolyte</ability>, <ability value=3090>Catalyst: Electricity</ability> and <ability value=1877>Static Aura</ability>.",
      "flavorText": "The power of a thousand storms, raging to be released.",
      "noraCost": 30,
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EG2Be9BG2AE8Dj9Cj9Dpwqsowvxvvzmyrf",
      "deckLimit": 2
    },
    {
      "id": 115,
      "name": "Stitched Hex Doll",
      "description": "Equipped champion with Class: Witch, Priest or Wizard gains <ability value=1398>Hex 2</ability>, <ability value=695>Curse 2</ability> and <ability value=738>Shielded</ability>.",
      "flavorText": "The doll was made from various materials, some including elven hair and skin. As she held it in her hands, H'aliel felt a darkness closing around her. She dropped the doll to the ground and left it there.",
      "noraCost": 25,
      "artist": "Joachim Barrum",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FE8De9Af1Be9Aj9Ej9Fukyirqsssoqhkpf",
      "deckLimit": 2
    },
    {
      "id": 99,
      "name": "Stonearm Sash",
      "description": "Equipped champion gains <ability value=1328>Domain: Rock</ability>, <ability value=2571>Rock Front</ability> and <ability value=2527>Rock Defiance</ability>.  If it already has Rock Defiance, it also gains <ability value=1199>Calcify</ability>.",
      "flavorText": "The Stonearm Sash was awarded to winners of the Stonearm Tournament. In this competition, participants are expected to perform feats of amazing strength. It is said that the sash holds a special power of its own.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Df1AE8Df1Bg3AJ8Jj9Aeeevqqwoyvsxvqf",
      "deckLimit": 2
    },
    {
      "id": 16,
      "name": "Sunder Axe",
      "description": "Equipped champion with a MAX RNG of 2 or less gains <ability value=330>Sunder 2</ability>. If equipped champion has Race: Barbarian, it also gains <ability value=1431>Barbaric Assault</ability>.",
      "flavorText": "\"The last thing you want when you are completely surrounded by baddies is a dull blade...\" - Dwarven Sergeant",
      "noraCost": 20,
      "artist": "Dan Kopycienski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1AE8Df1Be9AJ8Jj9Aerhvmhpnnymljpf",
      "deckLimit": 2
    },
    {
      "id": 92,
      "name": "Swamptouch Amulet",
      "description": "Equipped champion gains <ability value=1494>Escalation</ability>.",
      "flavorText": "The boghoppers of the Darkmarsh had accepted the Forglar's gift. In return, they were given power. To keep this power safe, Lemsu fashioned an amulet from the waters. Those who wore it would receive its blessing.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2BE8Df1BG2Bj9Cj9Dlleinhepnhpjirf",
      "deckLimit": 2
    },
    {
      "id": 202,
      "name": "Swampwasp Nectar",
      "description": "The first 5 damage dealt to equipped champion each turn is prevented.  This equipment is destroyed after it has prevented 50 damage.",
      "flavorText": "Of the many wonders found in the swamp, there are few as impressive as Swamp Wasp Nectar. The nectar is used by the wasps to coat their nests, making them particularly resilient. Some nests have even been found to have survived the tree they were located in being consumed by flame. ",
      "noraCost": 25,
      "artist": "Filip Burburan",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cf1Ae9Af1BG2BJ8Jj9Aeiyrwziyofpytqf",
      "deckLimit": 2
    },
    {
      "id": 83,
      "name": "Sword of Shadows",
      "description": "When this champion makes an attack, its target is <condition value=shadowtouched>Shadowtouched</condition> for 2 turns. This equipment can be dropped as a relic with <ability value=1820>Sword of Shadows</ability> and <ability value=1827>Wieldable</ability>.",
      "flavorText": "\"In darkness it was forged, of indescribable materials. In darkness, it drank the shadows and sharpened its edge with the blackness.\" - Inscription on the Sword of Shadows",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Bg3AE8Df1BG2Aj9Dj9Eeevkuzgkpfgiirf",
      "deckLimit": 2
    },
    {
      "id": 192,
      "name": "Tactical Manual",
      "description": "Equipped champion has +1 DMG for every 15 HP it currently has. At the end of its turn, it heals 1 HP with 1 additional HP for every 15 HP it is missing.\r\n",
      "flavorText": "\"This has everything you need to know, if it'??s not in here, then you don't need to know it!\" -Dwarven Sergeant.\r\n",
      "noraCost": 25,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2Be9Af1BG2Aj9Cj9Dwqwkgtsftsmjgrf",
      "deckLimit": 2
    },
    {
      "id": 119,
      "name": "Tempest Crown",
      "description": "Equipped champion gains <ability value=107>Immortality</ability> and <ability value=1382>Prestige</ability>. If it has Race: Lich, it also gains <ability value=2291>Lightning Storm 3</ability>. If it is Race: Voil, it gains <ability value=1330>Dread</ability>.",
      "flavorText": "The crown of the Voil King was buried with him, in his tomb. When word of his resurrection spread, many came to claim his crown for themselves. The crown and the king were gone.",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9Ff1Ae9Af1Be9AJ8Jj9Aeilwtuxftqsmlpf",
      "deckLimit": 2
    },
    {
      "id": 121,
      "name": "Thunder",
      "description": "Equipped champion gains <ability value=838>Explosive Attack 2</ability> and <ability value=3096>Cull</ability>. If it has Race: Tortun, it also permanently loses <ability value=2093>Ponderous.</ability>",
      "flavorText": "\"It be the only one of its kind. He only brings it out when he be lookin' ta kill somethin'. I've seen it punch a hole right through a Tortun shell wit' no trouble 'tall!\" - Mendal Rawtongue of the Rotmaw",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Gj9FG2Ae9Af1Be9Aj9Bj9Cevfeknygklymuqf",
      "deckLimit": 2
    },
    {
      "id": 220,
      "name": "Thunderaxe",
      "description": "Equipped champion has <ability value=1739>Paralytic Feedback</ability> and <ability value=3172>Chuck: Thunderaxe</ability>. If the champion is Race: Minotaur, it also gains <ability value=3251>Portal Blast</ability>.",
      "flavorText": "Not the best thing to have hurtling towards your head.",
      "noraCost": 30,
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "Underdepths"
      ],
      "rarity": "LIMITED",
      "runeSet": "Path of De'lim",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Af1AG2AE8Dj9Fj9Grjemwtusxtmjwqf",
      "deckLimit": 2
    },
    {
      "id": 248,
      "name": "Thunderaxe",
      "description": "Equipped champion has <ability value=1739>Paralytic Feedback</ability> and <ability value=3172>Chuck: Thunderaxe</ability>. If the champion is Race: Minotaur, it also gains <ability value=3251>Portal Blast</ability>.",
      "flavorText": "Not the best thing to have hurtling towards your head.",
      "noraCost": 30,
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "Underdepths"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9Ee9Af1AG2AE8Dj9Fj9Grjemwtusxtmjwqf",
      "deckLimit": 2
    },
    {
      "id": 103,
      "name": "Tidemaster's Bandoleer",
      "description": "Equipped champion gains <ability value=1325>Domain: Water</ability>, <ability value=2>Amphibious</ability>, and <ability value=1044>Trail: Water</ability>.",
      "flavorText": "To receive the title of Tidemaster, one must achieve an absolute understanding of the swamp. One must know every detail, from its rushing streams to its teeming marshes. When one receive the bandoleer of the Tidemaster, it is a monumental occasion.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9Dg3AE8Df1Bg3Aj9Dj9Eeeerllukyofvssf",
      "deckLimit": 2
    },
    {
      "id": 164,
      "name": "Tinder Box",
      "description": "Equipped unit gains <ability value=1908>Fire Acolyte</ability> and <ability value=133>Fire Aura 3</ability>.  If equipped on a champion with <ability value=543>Attack: Fire</ability>, it also gains +1 SPD.",
      "flavorText": "\"No one knows for sure what is sealed within the Tinder Box.  Some say it is a piece of star, others claim it is lava from the depths.  My favorite is the one that says it contains the eye of a Sheoul Demon.\" ~ Rallien, Bok Matron",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9AE8De9Af1Bf1Bj9Ej9Fgykrhyzgpquvkpf",
      "deckLimit": 2
    },
    {
      "id": 140,
      "name": "Tome of Faded Souls",
      "description": "Equipped champion gains <ability value=2103>Deconstruct</ability>. If it has Race: Stitched, it also gains <ability value=2175>Spell Charged 1</ability> and <ability value=2190>Charged Attack</ability>.",
      "flavorText": "\"We leave this tome to you. You will be its keeper, its sole protector. Guard their souls and they will protect you. Now you serve the Faded. Now you are Stitched.\" - Unknown source, translated from Old Elsari",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands",
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8Hf1Be9Af1BF0Aj9Aj9Bmepykwzinlnhyo",
      "deckLimit": 2
    },
    {
      "id": 108,
      "name": "Tome of the Arcanis",
      "description": "Equipped champion with Class: Wizard gains <ability value=406>Teleport 1</ability>, <ability value=896>Mindwipe Aura 1</ability>, <ability value=1271>Tempo</ability> and <ability value=630>Grant: Flight</ability>.",
      "flavorText": "\"We found the book beside a felled Leoss, his body still embracing it. Inside were many theories on Arcane magic, most of them proven; theories we had never thought to explore. I had a messenger send it to Forglar, to give it to Gekaal. He would know what to do with it.\" - Berkchani, Ambassador to Seljichan",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0Be9Af1BE8DJ8IJ8Jmjyxvzkemykpyo",
      "deckLimit": 2
    },
    {
      "id": 26,
      "name": "Traitorous Helm",
      "description": "Equipped friendly Race: Demon champion gains <ability value=2753>Noble Sacrifice</ability>, <ability value=725>Transfer Life 1</ability>, <ability value=2260>Pariah</ability>, and <ability value=876>Short Lived 2</ability>. When this champion dies, the closest enemy champion within 8 spaces gains <ability value=936>Surge: Demon</ability>, becomes  <condition value=possessed>Possessed</condition> and <condition value=defiled>Defiled</condition> for 3 turns, and gains <ability value=1408>Chasm Walker</ability> for 4 turns.",
      "flavorText": "Maxxarek's discovery of Gibir's deceit inspired an era of distrust within his inner circle.",
      "noraCost": 30,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GF0AE8Df1Be9BJ8HJ8Ieruzxqfiyrzohn",
      "deckLimit": 2
    },
    {
      "id": 34,
      "name": "Turtle Shell",
      "description": "Equipped champion gains <ability value=647>Turtle</ability>, <ability value=1899>Scale Armor</ability>, and <ability value=2093>Ponderous</ability>.",
      "flavorText": "\"...9, 10! Ready or not here I come!\" -- \"Do you think he'll find us?\" -- \"Shh...only if you keep talking!\" - Boghopper Youths",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HE8DE8Df1BF0Aj9Ej9Feerqzvsukgvkro",
      "deckLimit": 2
    },
    {
      "id": 187,
      "name": "Twisted Emerald",
      "description": "Equipped champion gains <ability value=2687>Confuse</ability> and <ability value=3138>Twisted Essence</ability>. <condition value=twisted> </condition>",
      "flavorText": "\"It can even touch stones. Fascinating. Look at how it has deformed the critical structures of the gem.\" Timothy the Vile",
      "noraCost": 25,
      "artist": "Paul Guzenko",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BF0Be9Af1BG2AJ8IJ8Jgyxiepleginykpf",
      "deckLimit": 2
    },
    {
      "id": 234,
      "name": "Valdaci Shield",
      "description": "Equipped champion has <ability value=3266>Combat Awareness 1</ability>.",
      "flavorText": "The remains of the Valdaci live on in a second form.",
      "noraCost": 20,
      "artist": "Caio Monteiro",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "rarity": "LIMITED",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8GG2AG2AG2Ae9Bj9Bj9Ceeipyxxtztmsqqf",
      "deckLimit": 2
    },
    {
      "id": 231,
      "name": "Valdaci Tracker",
      "description": "Equipped champion has <ability value=13>Detection 3</ability> and <ability value=2671>Illuminate</ability>.",
      "flavorText": "The remains of the Valdaci live on in a second form.",
      "noraCost": 15,
      "artist": "Markus Erdt",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9CG2Bf1BG2AG2Bj9Cj9Dneilgthitouvftf",
      "deckLimit": 2
    },
    {
      "id": 163,
      "name": "Vendetta",
      "description": "Equipped champion gains <ability value=2786>Spell Aegis</ability> and <ability value=2539>Lightning Blast</ability>.  If it has Race: Lich, it gains <ability value=2611>Soulharvester 1</ability>.",
      "flavorText": "\"Vengeance is the most powerful force in the universe\" - Serkan, Lich Master",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Jg3Ae9Af1Bf1Aj9Dj9Eeigpnephyvqzxqf",
      "deckLimit": 2
    },
    {
      "id": 57,
      "name": "Vial of Holy Water",
      "description": "Equipped champion is healed for 10 HP and gains <ability value=1304>Trail: Hallowed Ground</ability>. If this equipment was equipped from the runedock and equipped champion has Class: Paladin, it also becomes <condition value=shielded>Shielded</condition> while equipped.",
      "flavorText": "\"Holy water clouds my thinking,\" said the wizard, sinking low now. \"Keep on drinking...\" said the priest.",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JF0AE8Df1Bf1AJ8HJ8Iiwtoqsowoyvoso",
      "deckLimit": 2
    },
    {
      "id": 82,
      "name": "Vicious Harpoon",
      "description": "Equipped champion gains <ability value=1248>Pull</ability> and  <ability value=163>Rend 1</ability>. This equipment can be dropped as a relic with <ability value=1819>Vicious Harpoon</ability> and <ability value=1827>Wieldable</ability>.",
      "flavorText": "The harpoon is the little-known weapon of choice for the G`hern. Although it was originally used to hunt for food, it has proven effective against enemy infantry.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Rise of Serkan",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BG2BE8Df1BG2Aj9Cj9Dggrumuvvfxqferf",
      "deckLimit": 2
    },
    {
      "id": 55,
      "name": "Vindrax Scale Shield",
      "description": "Equipped champion has +1 DEF and gains <ability value=47>Resistance: Physical 2</ability>.",
      "flavorText": "The Jakei were able to encase the great dragon Vindrax in a trap of ice. Although it was a short-lived victory, they were able to claim several of his scales before they were incinerated.",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8Je9BE8Df1Bf1AJ8GJ8Huxkegvhpyvmuon",
      "deckLimit": 2
    },
    {
      "id": 168,
      "name": "Virtue",
      "description": "Equipped champion gains <ability value=1959>Cleansing Aura</ability> and <ability value=2409>Empathy</ability>. If it has Class: Priest, it also gains <ability value=372>Heal Mass 3</ability>.",
      "flavorText": "\"It is only with our virtue that we can take hold of our destiny.\" ~ Gekaal, the High One",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9Be9Af1Bf1BJ8GJ8Hsusfkyvkepjluo",
      "deckLimit": 2
    },
    {
      "id": 65,
      "name": "Visage of Ironfist",
      "description": "Equipped champion gains <ability value=1306>Mountaineer</ability> and has +1 DMG for each Ironfist champion you have on cooldown (up to a maximum of 6 champions). If there are 4 or more champions on cooldown, this unit also gets +1 DEF. When equipped champion is destroyed, this equipment is equipped onto the closest valid friendly champion.",
      "flavorText": "\"Many have claimed Ironfist as their home, and many have died for its safety. This helm was crafted to honor their sacrifice and to inspire those who still fight.\" - Janist, Master Armorer\r\n",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Bj9Ae9AE8Df1Bf1Bj9Fj9Gwfpukwouxknumpf",
      "deckLimit": 2
    },
    {
      "id": 75,
      "name": "Widowmaker",
      "description": "Equipped champion gains <ability value=1698>Widowmaker</ability>. If equipped champion has Race: Demon Elf or Race: Arthropod, it also gains <ability value=746>Dead Eater</ability>.",
      "flavorText": "\"Feed upon the weak! Do you hear me? Drink in their suffering! Do this, and I will make a warrior of you.\" - K`lzik, Matron of Lower Sheoul",
      "noraCost": 40,
      "artist": "Anthony Lopes",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9Be9AE8Df1BG2Aj9Fj9Gshtzkusssfkuqqf",
      "deckLimit": 2
    },
    {
      "id": 130,
      "name": "Wildeye Bracers",
      "description": "Equipped champion gains <ability value=2006>Blundering</ability> and becomes <condition value=scolded>Scolded</condition>. After the equipped champion has used 4 abilities, it also gains <ability value=3158>Reckless</ability>.",
      "flavorText": "\"Wildeye lived up to his name. He was one of the best sailors in my Navy. But, he never stayed in one place for too long.\" - Deblin Redjaw, Admiralty of Gharivol",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8HJ8Gf1Be9Af1Be9Bj9Aj9Bevojyoqhtqzkuo",
      "deckLimit": 2
    },
    {
      "id": 53,
      "name": "Withering Fern",
      "description": "At the start of each of its turns, this champion loses 3 HP and permanently loses 1 DEF.",
      "flavorText": "These ferns were created long ago to keep the forest intact. In life, they cause everything around them to live. Now as they wither, they will defend the forest by weakening its offenders.",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9AJ8JE8DE8Df1Bf1Aj9Ej9Fwigemetuofxxzo",
      "deckLimit": 2
    },
    {
      "id": 228,
      "name": "Wounded Kitten",
      "description": "After 6 turns, this equipment is destroyed, the equipped champ takes 10 Physical damage and becomes <condition value=eviscerated>Eviscerated</condition> for 3 turns. When this triggers or if the champion is destroyed while equipped, a Young Mountain Lion is summoned to the closest available space under the control of this equipment's owner.",
      "flavorText": "\"Poor little thing, he broke his leg... but don't you worry, I'll tend you, and feed you, and we'll be best friends forever...\" Dorn Stormbrunt (Deceased)",
      "noraCost": 30,
      "artist": "Caio Monteiro",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Cj9BE8Df1BG2AG2Aj9Ej9Fmsxknhexfmjegrf",
      "deckLimit": 2
    },
    {
      "id": 102,
      "name": "Wraith's Tear",
      "description": "Equipped champion gains <ability value=861>Tormented</ability>. If it has Race: Spirit or Race: Vampyre, it also gains <ability value=1147>Sonic Roar</ability>.",
      "flavorText": "The tear of a Wraith is said to be the remnant of a devoured soul. The tear cries out in pain, having spent its time in endless torture. If the tear is captured, it can protect its master.",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Ej9DG2BE8Df1Bg3Aj9Cj9Dsmpwmhnwqoyonsf",
      "deckLimit": 2
    },
    {
      "id": 238,
      "name": "Writ of Al'mara",
      "description": "Equipped champion gains <ability value=2409>Empathy</ability> and <ability value=3107>Ritual of Healing</ability>. If equipped on a Priest, it also gains <ability value=620>Lay Hands</ability>. If this equipment is destroyed, this champion permanently gains <ability value=2260>Pariah</ability> and <ability value=2007>Helpless</ability>.",
      "flavorText": "Bearing the power of Al'mara comes with a responsibility to protect that power. Those who lose a writ through recklessness, or disrespect its worth, face divine penalty. ",
      "noraCost": 35,
      "artist": "Rogier van de Beek",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Fj9EF0AG2BG2AE8DJ8HJ8Itqumytmwmlpfpqf",
      "deckLimit": 2
    },
    {
      "id": 93,
      "name": "Yeti Fang",
      "description": "Equipped champion with Race: Yeti has <ability value=1900>Tough 1</ability> and <ability value=1363>Unleash</ability>.",
      "flavorText": "To help train soldiers, the Jakei would make special necklaces from Yeti fangs. When they wore the fangs around their necks, recruits would lose all restraint.",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "ej9Dj9Cg3AE8Df1BG2Bj9Dj9Eeilerhymnhvonsf",
      "deckLimit": 2
    },
    {
      "id": 41,
      "name": "Yetihide Cape",
      "description": "This champion gains +1 DEF, <ability value=38>Immunity: Frost</ability>, <ability value=1019>Hidden: Arctic</ability> and <ability value=603>Frost Cone 2</ability>.",
      "flavorText": "Jakei hunter lore holds that the skin of a yeti slain without blades bears the very power of elder Jakkaris himself. ",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "hash": "eJ8IJ8HG2AE8Df1BF0Aj9Bj9Cemnuqzmjwitzzo",
      "deckLimit": 2
    }
  ],
  relics= [
    {
      "id": 140,
      "name": "Altar of Bones",
      "description": "This relic has Bone Altar (<mechanic value=sacrifice>Sacrifice</mechanic> target champion you own within 4 spaces with Race: Skeleton, friendly Skeletons gain +4 HP and +1 DMG.).",
      "flavorText": "\"We give this offering to you, Lord Serkan. Please, bless our soldiers with power! Fill them with your strength!\" - Tachrim, apprentice to Xulos",
      "noraCost": 25,
      "artist": "Alex Fang",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8JE8DE8DG2Af1Aj9Ej9Fgnuxvsuqsfpufpf",
      "deckLimit": 2
    },
    {
      "id": 66,
      "name": "Altar of Votaev",
      "description": "When a non-Summoned, non-Illusion champion that you own dies, the cooldown on your Demon champions is reduced by 3. This Relic has Motivate: Unholy (All other friendly champions with Race: Demon or Race: Undead have +1 DMG).",
      "flavorText": "\"Do not fear death. Votaev will guide you through the darkness. He will lead you through the deepest depths of Sheoul and back into your shell.\" - R'valna, Deep-elf Priestess",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0Bf1AF0AJ8HJ8IJ8Jeeeeeevztowouxf",
      "deckLimit": 2
    },
    {
      "id": 146,
      "name": "Ankh of Valdac",
      "description": "This relic has <ability value=843>Resurrect 2</ability> and <ability value=1776>Premonition</ability>. When this relic is deployed, friendly champions within 3 spaces are <mechanic value=cleansed>Cleansed</mechanic>. Friendly champions within 5 spaces that have Class: Priest gain <ability value=2409>Empathy</ability>.",
      "flavorText": "\"We carried the Ankh into Gharivol, into the temple of Al'Mara. The Tortuns watched as we placed it on the altar. They seemed to focus mostly on its craftsmanship; good steel, but the stones were cheap ruby.\" - Thomroy, Priest of Ironfist",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8Jf1BE8DG2Af1Aj9Aj9Bzgyohetsxkpwkpf",
      "deckLimit": 2
    },
    {
      "id": 169,
      "name": "Archery Bale",
      "description": "This unit has <ability value=2495>Archery Bale</ability>, <ability value=1317>Absorb</ability> and <ability value=1803>Volley Leader</ability>.",
      "flavorText": "K'thir archery bales are infused with small amounts of nora to induce a state of calm in archers in the area. Archers can shoot farther and more accurately in their presence.",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9Bg3AE8DG2AG2Aj9Dj9Eeemnllrjgkwklrf",
      "deckLimit": 2
    },
    {
      "id": 25,
      "name": "Ark of the Elsari",
      "description": "Whenever a spell is successfully cast, all friendly champions for the casting player lose 4 life. (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "\"I can't seem to be able to focus on it.  It's as if it wasn't even there.\" - Vaelina, Elven Wizard",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9Bf1AJ8Jj9Aj9Biwtsqlwqlluonyg",
      "deckLimit": 1
    },
    {
      "id": 73,
      "name": "Armory",
      "description": "When this relic is deployed, concealed equipment runes in your rune dock are revealed. When you deploy an equipment rune, you are refunded 40% of the nora cost. When your equipment is destroyed, cooldown is reduced by 2. This effect does not stack.",
      "flavorText": "With the advent of the field armory, soldiers could rearm themselves quickly in battle. Outposts could keep their weapons and armor maintained as well, without needing a steady supplyline.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9AJ8Jf1AF0Bg3Aj9Dj9Ej9Fjrowzgkluvvzthg",
      "deckLimit": 2
    },
    {
      "id": 260,
      "name": "Arroyo Portal",
      "description": "This relic has <ability value=1617>Desecrated Zone 1</ability> and <ability value=3281>Arroyo Portal</ability>.",
      "flavorText": "Arroyo portals can open almost anywhere. The Arroyo are drawn to nora, and its use, and so will ravenously pursue sources of nora.",
      "noraCost": 25,
      "artist": "Jordy Knoop",
      "factions": [
        "Forsaken Wastes",
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8JF0AG2AG2Af1AJ8HJ8Ivqlwfinwmetumpf",
      "deckLimit": 2
    },
    {
      "id": 134,
      "name": "Artillery Marker",
      "description": "This relic has Artillery Marker (When an opposing champion moves within 3 spaces of this unit, that unit takes 12 Physical damage and this unit loses 6 HP. Opposing champions successfully damaged are knocked back 1 space and becomes Stunned 1 (This champion has -2 DEF, cannot attack, move, activate abilities, or engage other champions). Being knocked into range does not trigger Artillery Marker. This damage ignores DEF.)",
      "flavorText": "\"Two Kanen, heading east across the beach-line. They're approaching marker two. Prepare to fire, Mr. Jadeside.\" - Captain Tremir Craghide of the Gygurnaut",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "eJ8JJ8IF0BE8DG2AF0BJ8IJ8Jiwiwthvkwvzkuo",
      "deckLimit": 2
    },
    {
      "id": 229,
      "name": "Aurora Banner",
      "description": "This relic has Illuminating Burst (When this unit comes into play and when it is destroyed, enemy champions within 5 spaces become Illuminated for 4 turns), Prestige (Friendly champions within 5 spaces have Iron Will and Fearless) and Relocate Self (This unit is relocated to target space within 5 spaces.  This ability begins on CD).",
      "flavorText": "The Aurora is an elven-fae coalition formed to oppose those who wish to disrupt the workings of the Circle, formed in the face of ever increasing power grabs by De'lim's faction.",
      "noraCost": 25,
      "artist": "Nakarin Sukontakorn",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Ge9Ae9BG2Ae9Bj9Fj9Gerluxfvhiyxxxo",
      "deckLimit": 2
    },
    {
      "id": 193,
      "name": "Blood Crest",
      "description": "This relic has <ability value=2550>Relocate Self</ability> and <ability value=2700>Blood Crest</ability>.",
      "flavorText": "The blood stained banners of the Bloodbinders remain vividly red and liquid longer after the blood used upon them should have dried, and suffocating the area with the faint metallic smell of blood.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9Ee9Ae9AG2AE8Dj9Fj9Ghvxfinhygtufmpf",
      "deckLimit": 2
    },
    {
      "id": 233,
      "name": "Bone Circle",
      "description": "This relic has Bone Circle: Skeletons (Friendly Skeletons gain Spell Resistance. This shares a CD with and removes the effects of Bone Circle: Lich when activated (AP0, CD2)), and Bone Circle: Lich (Friendly Lich gain +1 MAX RNG. This shares a CD with and removes the effects of Bone Circle: Skeletons when activated (AP0, CD2)).",
      "flavorText": "A host of hooded figures observed the ghastly ritual. Liches. The terrifying thought wormed its way into my mind. Liches and their skeletal servants from beyond. My body implored me to run, but my eyes were transfixed. I must stay... I must become the sacrifice... - Captain Dromus, final moments",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Gg3Ae9BG2Ae9Bj9Dj9Eeeruvvzirluqoqf",
      "deckLimit": 2
    },
    {
      "id": 249,
      "name": "Bone Mine",
      "description": "This relic has Bone Mine (When this unit is deployed, 8 Bone Spurs are deployed within 5 spaces of this unit. At the end of its turns, an additional Bone Spur is created.  Each space may only have one Bone Spur.  When a champion with Race: Skeleton captures a Bone Spur, it gains +3 MAX HP permanently. All other champions take 3 Physical damage when capturing a Bone Spur) and Death Nova: Skeletons (When this unit is destroyed, 3 Grave Warriors are randomly summoned within 3 spaces).",
      "flavorText": "\"Useless objections -- what good are corpses to the living?\" ~ Xulos",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Gg3Af1AG2Ae9Bj9Dj9Eeeipyrjytjrsuqf",
      "deckLimit": 2
    },
    {
      "id": 202,
      "name": "Bone Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability> and Bone Trap (When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Physical damage, becomes Frightened for 2 turns and a Scary Spooky Skeleton is summoned in the relic's place).",
      "flavorText": "One advantage of skeletons is their ability to look completely lifeless in one moment, and become fully animated and menacing in the next.",
      "noraCost": 25,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Gj9FE8De9AG2Ae9Aj9Ej9Fsmjeklrjggtfmpf",
      "deckLimit": 2
    },
    {
      "id": 191,
      "name": "Bridge to Nowhere",
      "description": "This relic has <ability value=3251>Portal Blast</ability>, <ability value=3346>Relocate: Fairy</ability>, <ability value=2474>Font Ignorance</ability> and <ability value=3396>Teleport (Relic)</ability>.",
      "flavorText": "The entrances to the Conclave seem to occupy no true location, seemingly to appear whenever a Fae wishes it.  No non-Fae, not even Menalaus, is known to have ever set foot inside the Conclave, so much so most common Elves believe the sanctuary's existence to be a myth.",
      "noraCost": 25,
      "artist": "Conceptopolis",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Ej9Dg3AE8DG2Ag3Aj9Dj9Eeeevknsmusqzvsf",
      "deckLimit": 2
    },
    {
      "id": 259,
      "name": "Burning Steel",
      "description": "This relic has Burning Steel (When this unit is deployed, equipped enemy champions take 10 Fire damage. If a champion affected by this ability is within 5 spaces of this unit, it also loses all AP).",
      "flavorText": "\"Strike while the iron is hot, and make it hotter!\"",
      "noraCost": 30,
      "artist": "Rogier van de Beek",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8Je9BG2AG2Af1AJ8GJ8Hkgkgnuztsqquhpf",
      "deckLimit": 2
    },
    {
      "id": 187,
      "name": "Caliginous Cauldron",
      "description": "This relic has Immunity: Fire and Caliginous Emulsion (When a champion within 3 spaces would take Fire damage, it loses an equal amount of HP instead).",
      "flavorText": "\"With the recovery of the Cauldron, none shall stand in our way.\" ~ Grimlic",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Ej9De9BE8DG2Ag3AJ8GJ8Hmsxiekusouvqjpf",
      "deckLimit": 2
    },
    {
      "id": 207,
      "name": "Catharsis Bloom",
      "description": "This unit has <ability value=2842>Catharsis Bloom</ability> and <ability value=2843>Propagate: Self 1</ability>.",
      "flavorText": "Menalaus' pet project, the Catharsis Bloom, bloomed for the first time the day Menalaus went missing.  Its flowers are essentially fountains of healing.\r\n",
      "noraCost": 30,
      "artist": "Asa Enochs",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9FF0Be9AG2Ae9AJ8IJ8Jszilggiigtfkjpf",
      "deckLimit": 2
    },
    {
      "id": 195,
      "name": "Celestial Spear",
      "description": "When this unit is deployed, opposing champions within 4 spaces takes 8 Electricity damage. This damage ignores DEF. When a friendly Paladin, Priest or Shaman within 4 spaces is successfully attacked, the attacker takes 3 Electricity damage.",
      "flavorText": "\"The Fae may have eradicated Ba'lah but we can plainly see that his corruption remains. Our work has only just begun, Aria.\" ~ Imann the Cardinal",
      "noraCost": 35,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EF0Ae9AG2AE8DJ8HJ8Iirlrfkrjrhipwo",
      "deckLimit": 2
    },
    {
      "id": 69,
      "name": "Chopping Block",
      "description": "At the end of your turn, the champion(s) with the lowest current HP loses 5 HP. When there are no champions in play, this relic is destroyed.",
      "flavorText": "Once used by the Valdaci to punish criminals, Serkan and his hordes have given it a more wicked purpose.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0Bf1Ae9BJ8GJ8HJ8Iukukgymssjrolwf",
      "deckLimit": 2
    },
    {
      "id": 186,
      "name": "Circadian Vault",
      "description": "This relic has Water Aura (When this unit comes into play, spaces within 3 spaces of this unit become Shallow Water) and Circadian Rites (Friendly champions within 3 spaces have Attack - Electricity. Friendly Mirefolk also gain Regeneration 3) and Hidden: Water (At the end of your turn, if this champion occupies Water, it becomes Stealthed. Otherwise, it loses Stealthed).",
      "flavorText": "\"You are the first in generations to even know about the Vault, much less be allowed to enter.  Do not disappoint us.\" ~ Vira, Circadian Enchantress",
      "noraCost": 25,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Ej9De9AE8DG2Ag3Aj9Fj9Gkufvferolwvxfrf",
      "deckLimit": 2
    },
    {
      "id": 153,
      "name": "Cleansing Emerald",
      "description": "This relic has Nora Gem (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces) and Cleansing Luminesence (When this unit is deployed and at the start of its turns, friendly champions within 4 spaces become Cleansed). ",
      "flavorText": "In K'thir, emeralds signify the ascension of a pupil to master. For excellence in study, K'thiras graduates are given an Equinox Emerald; a highly-valued gem worn by the brightest and best. ",
      "noraCost": 45,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest",
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9AF0AE8DG2Af1BJ8HJ8Iszkwoymphkpfxo",
      "deckLimit": 2
    },
    {
      "id": 51,
      "name": "Clutch of Vindrax",
      "description": "While in play, the Clutch of Vindrax will heal all Draksar, Dragon, and Skeezick champions within 5 spaces for 2 HP at the beginning of your turns. When this unit is destroyed, a Draksar Broodling will be spawned. This relic has <ability value=180>Death Nova - Fire 2</ability>.",
      "flavorText": "Vindrax clutched the ancient dormant eggs and his claws began to burn with draconic essence until the eggs pulsed in tandem with the same power. ",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0BF0Bg3Aj9Dj9Ej9Feeeepnyowvxqjgg",
      "deckLimit": 2
    },
    {
      "id": 196,
      "name": "Containment Unit",
      "description": "This relic has <ability value=600>Arctic</ability>, Ice Front and Containment Unit (At the end of its turn, adjacent friendly champions are Crystallized).",
      "flavorText": "Originally designed by the Jakei to preserve corpses, the containment units have been found to have miltary uses.",
      "noraCost": 35,
      "artist": "Paul Guzenko",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "ej9Fj9EF0Be9AG2AE8DJ8IJ8Jwztjeiwqllwmepf",
      "deckLimit": 2
    },
    {
      "id": 257,
      "name": "Contaminated Wreckage",
      "description": "This relic has Contaminated Wreckage (Friendly champions within 5 spaces have <ability value=546>Attack: Poison</ability> and <ability value=167>Poison 1</ability>.  Friendly champions within 5 spaces gains 2 AP when it becomes equipped or if it is already equipped when this unit is deployed).",
      "flavorText": "Debris and refuse from ships, new and old, began to collect upon the shore. All of it was sufused with nora -- useful, but equally worrying.",
      "noraCost": 40,
      "artist": "Blake Henriksen",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8JJ8IG2AG2AG2AF0Bj9Bj9Ceeeeeigirumeerf",
      "deckLimit": 2
    },
    {
      "id": 116,
      "name": "Coordination Tower",
      "description": "This relic has Arctic and Battlemaster 1 (Friendly champions within 2 spaces get +2 DMG and +1 DEF. This effect does not stack).  All friendly champions within 2 spaces of this relic gain Encouraged (When a friendly champion attacks, this champion gains +1 DMG for 1 turn).",
      "flavorText": "The Jakei began erecting towers to keep their commanders safe. With these in place, they could issue orders to their soldiers while staying out of harms way.",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8HE8DE8DG2AF0Aj9Ej9Feevmnwzkjyvfto",
      "deckLimit": 2
    },
    {
      "id": 198,
      "name": "Coralwood Lagoon",
      "description": "This relic has Mirrored and Coralwood Lagoon (Friendly Jellebrium within 5 spaces have Spell Resistance and Psychic Magnetism).",
      "flavorText": "\"Coralwood is the Jellebrium's most sacred substance.  Putting it at risk shows just how serious they are about fighting the corruption.\" ~ Tidemaster Dersok, envory to the Jellebrium",
      "noraCost": 25,
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9Ef1Be9AG2AE8Dj9Aj9Bjyxmshirwzmjnpf",
      "deckLimit": 2
    },
    {
      "id": 167,
      "name": "Corpse Pile",
      "description": "This relic has <ability value=157>Disease Aura 3</ability> (At the beginning of your opponent's turns, this unit deals 6 Disease damage to each champion within 2 spaces. This damage ignores DEF) and <ability value=2462>Corpse Pile</ability> (When this unit is deployed, it loses 5 HP and an Infected Zombie with no upgrades  is summoned on the nearest unoccupied space within 5 spaces. At the end of every 6 turns, this unit loses 5 HP and an Infected Zombie with no upgrades is summoned on the nearest unoccupied space within 5 spaces).",
      "flavorText": "\"Burn that pile of atrocities before they-damn it, too late!\"- Inquisitor Isran ",
      "noraCost": 55,
      "artist": "Bartek Gawel",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "ej9Cj9BG2AE8DG2AG2Aj9Bj9Ceevfgyvmnnpyxqf",
      "deckLimit": 2
    },
    {
      "id": 170,
      "name": "Corpse-a-Pult",
      "description": "This unit has <ability value=2498>Fling Corpse</ability>",
      "flavorText": "The risen dead make the best ammunition. Think of them as a bullet with 'bite'.",
      "noraCost": 55,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Dj9CE8DE8DG2AG2Bj9Ej9Fsmnwonshrlyrsqf",
      "deckLimit": 2
    },
    {
      "id": 119,
      "name": "Counterbalance",
      "description": "While this relic is in play, Nora globes captured by opposing units are worth 50% Nora.",
      "flavorText": "\"I know their Nora supplies are a problem, S`etra; I won't argue that. We can't simply destroy their stores, it would hurt us as well. However, we can make sure they never recover from their losses.\" - Menalaus of K`thir",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GG2BE8DG2Ae9Bj9Cj9Devvxxtqhgvztfpf",
      "deckLimit": 2
    },
    {
      "id": 251,
      "name": "Creeping Pustule",
      "description": "This relic has <ability value=3252>Portal</ability> and <ability value=3248>Creeping Pustule</ability> (When a champion within 3 spaces takes 5 or more damage, a Death Carrionling with no upgrades is summoned 4 spaces away from that champion (if there are no empty spaces, it will summoned farther away).  This triggers up to 2 times per turn).",
      "flavorText": "I swear, these just pop in out of nowhere. One moment it's clean and clear, then BAM, the whole place breaks out!",
      "noraCost": 40,
      "artist": "Caio Monteiro",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9Af1Bf1BG2Af1Bj9Aj9Byrlwtjiygpwkgrf",
      "deckLimit": 2
    },
    {
      "id": 150,
      "name": "Cursed Epitaph ",
      "description": "This relic has <ability value=2191>Nora Hex</ability>, <ability value=2172>Death Charged 1</ability>, <ability value=2145>Motivate: Unholy</ability> and <ability value=1489>Unspeakable</ability>.",
      "flavorText": "\"To curse one, recently dead, is a truly vile act. The very essence of life is corrupted with the wayward soul. By cursing the tomb, you doom all life and all creation.\" - From Necromancy and Its Dangers",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9AE8DE8DG2Af1Bj9Ej9Fkuqumleiekpsjpf",
      "deckLimit": 2
    },
    {
      "id": 41,
      "name": "Cursed Temple",
      "description": "Friendly champions with Race: Vampyre or Class: Witch gain +1 DMG, +1 DEF, <ability value=2628>Cursed Treasure</ability> and <ability value=2701>Shadestrike</ability> as long as a friendly champion with Lord of Strigoi or Queen of the Night is in play.",
      "flavorText": "\"This place is evil. I can feel it draining the life from the land itself.\"  - Guntar, Barbarian Shaman",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8IJ8HF0AF0AE8Dj9Ej9Fj9Gerhiytuqqwigkyg",
      "deckLimit": 1
    },
    {
      "id": 158,
      "name": "Defiling Spinel",
      "description": "This relic has Nora Gem (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces.) and Defiling Luminescence (When this unit is deployed and at the start of its turns, opposing champions within 4 spaces become Cursed 2 and Defiled 2). ",
      "flavorText": "Lavaburst Spinels are found in caves, many of which are directly connect to Sheoul. To Elsarin, these gems signified the use of dark magic; once a cautionary symbol, now a badge of pride. ",
      "noraCost": 25,
      "artist": "Slawomir Maniak",
      "factions": [
        "Forsaken Wastes",
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9AG2BE8DG2Af1Bj9Cj9Dwiirsfvsoqhyxqf",
      "deckLimit": 2
    },
    {
      "id": 194,
      "name": "Dimension Door",
      "description": "Friendly Minotaurs gain <ability value=2699>Dimension Shift</ability>.",
      "flavorText": "Maxxerek was not sure whether to be annoyed or pleased at the news. While having the Minotaurs' portals would be extremely useful, he did not relish the thought of having to deal with old Randgal again.",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Fj9Ee9Be9AG2AE8DJ8GJ8Huxojrusuqletso",
      "deckLimit": 2
    },
    {
      "id": 156,
      "name": "Dragon Artificer Portal",
      "description": "This relic has Summon Dragon (Summon a Dragon Homunculus on an adjacent space. This unit loses 5 HP).",
      "flavorText": "The altar sputtered to life, sending embers and dark smoke in every direction. When it finally settled and fell silent, Varia saw a small, scaled body resting at the center. The dragon looked to her, spread its wings, and slowly rose into the air.",
      "noraCost": 30,
      "artist": "Slawomir Maniak",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 30,
      "size": "1x1",
      "hash": "ej9Bj9Af1BE8DG2Af1Bj9Aj9Bhilnjyzkemlwoqf",
      "deckLimit": 2
    },
    {
      "id": 3,
      "name": "Dragon Skull",
      "description": "Fire and Acid damage dealt to champions are both increased by 20%.",
      "flavorText": "Some ancient clans believed that a Dragon's heart lay not in his chest, but in his head, as his skull burned long after his death.",
      "noraCost": 40,
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "cJ8IJ8HJ8Ge9Bg3AJ8GJ8HJ8Ivkgrszztxollerh",
      "deckLimit": 1
    },
    {
      "id": 161,
      "name": "Draining Azurite",
      "description": "This relic has Nora Gem (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces) and Draining Luminesence (When this unit is deployed and at the start of its turns, the controller of each opposing champion within 4 spaces loses 3 nora). ",
      "flavorText": "Starlight Azurite gets its name from its luminescence. The gem always glows, but glows brightest at night. On nights without a moon, it glows as bright as a star. ",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Forglar Swamp",
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9Be9AE8DG2AG2Aj9Fj9Giiemykemphytsqf",
      "deckLimit": 2
    },
    {
      "id": 222,
      "name": "Dreamblossom",
      "description": "This relic has Dreamblossom (When an opposing champion moves within 2 spaces of this unit, this unit is destroyed.  When this unit is destroyed, opposing champions within 2 spaces take 6 Magical damage and become Distracted for 4 turns and friendly champions within 2 spaces heal 6 HP) and Demolish (This unit destroys itself).",
      "flavorText": "\"The Dreamblossom is an insidious little weed that aids the forest-dwellers and brings death to us who would see their forest burn.\" - Sundra Flad, Nefari Griefsinger",
      "noraCost": 25,
      "artist": "Filip Burburan",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Ge9Be9AG2Ae9BJ8GJ8Heemwvzvhnsjnhn",
      "deckLimit": 2
    },
    {
      "id": 144,
      "name": "Dreambox",
      "description": "This relic has <ability value=601>Shadowspawn</ability> and <ability value=2226>Dreambox</ability>(The next time a relic is deployed by an opponent from the runedock, that relic is destroyed and this relic becomes a copy of that relic under your control and ownership).",
      "flavorText": "The young elf whispered his dream into the box and then closed it. A friend asked him about it and he replied with a smirk. It would stay a secret, if he wanted it to come true.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8JF0BE8DG2Af1AJ8IJ8Jgvkgvszvzoygyo",
      "deckLimit": 2
    },
    {
      "id": 55,
      "name": "Dwarven Mead Stash",
      "description": "This relic has <ability value=2713>On the House<ability>. Friendly adjacent champions with Race: Dwarf gain <ability value=3103>Drunken Revel</ability>.",
      "flavorText": "\"No Lad! I said fill the traps up with SPEARS, then bring us the BEERS. What are we supposed to do now? I canna' drink this bloody weapon!\" - Talgar Ironfist, unwillingly sober",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0BE8Dj9Ej9Fj9Geeeeiljyvouqjeg",
      "deckLimit": 2
    },
    {
      "id": 44,
      "name": "Earthshaker",
      "description": "This relic has Tremor (Opposing units without flying within 3 spaces of this unit are knocked back 1 space, take 6 Physical damage, and gain Lumbering (This champion's AP cost for each movement is increased by 1) for 2 turns. This damage ignores DEF).",
      "flavorText": "\"We need to keep those dragons off balance. Send some Earthshakers to the Rebellion, and hopefully this uprising will knock the Draksar down a few notches.\"",
      "noraCost": 35,
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8HJ8Ge9BF0AG2Aj9Bj9Cj9Dqlnygtmhkykrlyg",
      "deckLimit": 2
    },
    {
      "id": 65,
      "name": "Echo Chamber",
      "description": "Opposing champions and relics within 4 spaces take 8 Sonic damage. This damage ignores DEF. Champions that take damage become <condition value=distracted>Distracted 2</condition> (This unit may only activate base attacks).",
      "flavorText": "Normally used by the Cyclops to summon G'hern, these chambers have proven useful as defensive structures.",
      "noraCost": 40,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0Bf1AF0BJ8IJ8Jj9Awiwiievvkpnshyg",
      "deckLimit": 2
    },
    {
      "id": 232,
      "name": "Elemental Nexus",
      "description": "This relic has <ability value=3048>Elemental Nexus: Elementals</ability> and <ability value=3049>Elemental Nexus: Jakei</ability>.",
      "flavorText": "Less of an organization and more of a shift in focus in the Tundra towards exploring how ice can interact with other elements; particularly the increasingly frequent electrical storms that plague the tundra.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GG2Be9BG2Ae9Bj9Cj9Demlwxftukrwtjpf",
      "deckLimit": 2
    },
    {
      "id": 96,
      "name": "Elsari Bazaar",
      "description": "This relic has Market (Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.), Train Death: Nova Magical (When this unit is destroyed, it deals 5 Magical damage to each champion and Relic within 2 spaces and deals half that much damage to any Shrine within 2 spaces. This damage ignores DEF.) and Train Shrine Exertion (Target friendly champion within 5 spaces gains Shrine Exertion (Your Shrine or Avatar loses 10 HP, and this champion recovers 3 AP.)  This ability costs 5 nora).",
      "flavorText": "Many things are bought and sold in the streets of Elsarin, from the practical to the unspeakable. ",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9Ef1BE8DG2AE8Dj9Aj9Bzgphyxvxvszilpf",
      "deckLimit": 2
    },
    {
      "id": 34,
      "name": "Elsarin Vex",
      "description": "While this unit is in play, friendly Forsaken Wastes champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"We are the end.\"",
      "noraCost": 25,
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9Bf1Bj9Aj9Bj9Cemjnhtxofrhpjeg",
      "deckLimit": 1
    },
    {
      "id": 54,
      "name": "Elven Statue",
      "description": "At the end of your turn, each friendly non-Demon Elf within 5 spaces heals 1 HP for each friendly non-Demon Elf in play, and each Demon Elf within 5 spaces takes 1 Magical damage for each friendly non-Demon Elf in play.",
      "flavorText": "\"Though created to sustain and nurture life, the Nefari have put these magnificent relics to more sinister use in their interrogation chambers.\" - Etchen, the Chronicler",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0Be9Aj9Fj9Gj9Heepjlginnlumufg",
      "deckLimit": 2
    },
    {
      "id": 102,
      "name": "Elven Trading Post",
      "description": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack. Target friendly champion within 5 spaces gains +1 DEF.  This ability costs 2 nora and does not stack. (AP: 0, CD: 3). Target friendly champion within 5 spaces gains Damage Shield: Magical 3 (When this unit is attacked, if the attack is a close-combat attack, the attacking unit takes 6 Magical damage. This damage ignores DEF). This ability costs 3  Nora. (AP: 0, CD: 3)",
      "flavorText": "\"K`thir must not yield to its war effort. Our citizens need stability. If they don't, then there is no reason to fight. That is what I'm working for!\" - Darius, High Chancellor of the Eternal Circle",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9Fe9BE8DG2Ae9AJ8GJ8Hkllgnhvzmnpquo",
      "deckLimit": 2
    },
    {
      "id": 248,
      "name": "Endless Iceberg",
      "description": "This relic has Ice Eater, Freezing Aura (Enemy champions within 3 spaces are Frozen), Ice Front (At the beginning of each turn, all spaces within 3 spaces of this champion become Ice for 4 turns) and Propagate: Self.",
      "flavorText": "In the Savage Tundra, the land and sea and sky are all one -- barren, unforgiving, and endless.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "eJ8HJ8GF0Bf1AG2Ae9BJ8IJ8Jeeruvkplgvkgvo",
      "deckLimit": 2
    },
    {
      "id": 197,
      "name": "Epochal Oasis",
      "description": "This relic has Enduring Aura 4 (Damage to friendly champions within 3 spaces is reduced by 2) and Epochal Oasis (Friendly Elves within 3 spaces have Teleport 2).",
      "flavorText": "With Ba'lah's destruction and the on-going and increasingly dangerous experiments of the Throne, the barrier between Poxanthuru and that of the Epochal elves were weakened.",
      "noraCost": 30,
      "artist": "Conceptopolis",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9Ef1Ae9AG2AE8DJ8Jj9Aevkykuftjyxkjpf",
      "deckLimit": 2
    },
    {
      "id": 142,
      "name": "Ethereal Pool",
      "description": "This unit has <ability value=2550>Relocate Self</ability> and <ability value=3343>Enchant: Magic (Relic)</ability>. Friendly champions with Race: Archdemon within 5 spaces of this unit gain <ability value=1534>Spell Resistance</ability> and <ability value=1603>Reflection 2</ability>.",
      "flavorText": "They watched the Stitched as it stood over the fountain. Images began to appear on the water's surface, followed by symbols. The images were clear and the symbols began to make sense. It was communicating.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8Je9BE8DG2Af1AJ8GJ8Hshetfvqzkygpqo",
      "deckLimit": 2
    },
    {
      "id": 21,
      "name": "Failed Amplifier",
      "description": "No spells may be cast after one is successfully cast each turn. (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "Valdac only needed one spell.",
      "noraCost": 20,
      "artist": "Gabriel Garza",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9Ag3Aj9Dj9Ej9Fqzohgplgymjiwkg",
      "deckLimit": 1
    },
    {
      "id": 245,
      "name": "Fault Marker",
      "description": "This relic has Bastion of Courage (Friendly champions have Fearless) and Fractured Lands (When an enemy champion within 5 spaces makes a basic attack, it loses 2 AP).",
      "flavorText": "Called \"Fault Markers,\" these devices mark and amplify places of seismic activity.",
      "noraCost": 25,
      "artist": "Caio Monteiro",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9Ff1Af1AG2Ae9AJ8Jj9Aevfvhpwmshrowqf",
      "deckLimit": 2
    },
    {
      "id": 177,
      "name": "Ferren Hideout",
      "description": "This relic has Relocate: Ferren (Target friendly Ferren within 5 spaces is relocated to a space adjacent to this unit) and Relocate Self (This unit is relocated to target space within 5 spaces).",
      "flavorText": "\"I swear the Ferren were here just the other day!\"  \r\n\"Sure, and I am the King of Rugolth.\"",
      "noraCost": 35,
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Dj9CG2AE8DG2AG2Bj9Bj9Ceipuxztxosfggrf",
      "deckLimit": 2
    },
    {
      "id": 2,
      "name": "Fire Ruby",
      "description": "At the beginning of your turn, this relic deals 15 Fire damage to the closest enemy champion or relic within 3 spaces. When an enemy champion enters a space within 3 spaces of this relic, it takes 2 Fire damage. This damage ignores DEF.",
      "flavorText": "\"...and in the caverns deep underground, surrounded by lakes of living fire lies a chamber holding a stone that burns all who would approach.\" - Gye Danith, Treasure Hunter",
      "noraCost": 30,
      "artist": "Kelly Hamilton",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "cj9Hj9Gj9Fe9Ag3Aj9Fj9Gj9Hwqsqjipuvvxzirj",
      "deckLimit": 2
    },
    {
      "id": 250,
      "name": "Flaming Skull",
      "description": "Adjacent friendly champions have <ability value=3204>Kick Flaming Skull</ability> (This champion makes a ranged Fire attack against target champion within 2 - 5 spaces and the Flaming Skull relic is destroyed.  Champions within 2 spaces of the target take 50% DMG).",
      "flavorText": "\"Hey... guys... I think I am on fire!\" ~ Anonymous Skull",
      "noraCost": 30,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "LIMITED",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9AJ8JE8Df1AG2Af1Aj9Ej9Fukgkpljgirjtqqf",
      "deckLimit": 2
    },
    {
      "id": 208,
      "name": "Flash Bang",
      "description": "This relic has <ability value=601>Shadowspawn</ability> and Flashbang (When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Magical damage and become Blinded for 2 turns).\n",
      "flavorText": "The salaman are known for being ingenious engineers of weaponry.  They find all they need within the swamp.\r\n",
      "noraCost": 20,
      "artist": "Paul Guzenko",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Gj9Ff1Ae9AG2Ae9AJ8Jj9Aerlpyitfvqwknpf",
      "deckLimit": 2
    },
    {
      "id": 62,
      "name": "Flood Generator",
      "description": "This relic has Water Aura (When this unit is deployed, and at the beginning of each turn, spaces within 3 spaces from this unit become Shallow Water) and Water Generator (At the end of your turn, spaces adjacent to terrain generated by this ability become Water.  When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces).",
      "flavorText": "It is no secret that the creatures of the swamp fight best in the water, these magic stones help Forglar to bring the fight to their enemies!",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0BF0BG2Bj9Cj9Dj9Eeeeeeeerlpuvvfg",
      "deckLimit": 2
    },
    {
      "id": 165,
      "name": "Font of Restoration",
      "description": "This relic has Healing Waters (Target champion within 2 spaces heals HP equal to half its max HP) and and Instability (When this unit uses an ability, it loses 10 HP).",
      "flavorText": "In this place, death holds no sway. In this place, we live forever.",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9Bf1AE8DG2AG2AJ8Jj9Aeeilumnwkuhvoqf",
      "deckLimit": 2
    },
    {
      "id": 88,
      "name": "Forglar Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 89,
      "name": "Forsaken Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 12,
      "name": "G'hern Scarecrow",
      "description": "This relic has <ability value=678>Overseer: Moga 3</ability> and <ability value=1330>Dread</ability>",
      "flavorText": "\"It's too still, it can't be real... the Moga aren't that stupid, are they?\" - Jeniss, Elven Sharpshooter",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9Ae9Aj9Fj9Gj9Hyrhknnnyiempuhg",
      "deckLimit": 2
    },
    {
      "id": 184,
      "name": "Gatling Gun",
      "description": "This relic has Misfire (At the beginning of each turn, a random opposing champion within 5 spaces takes 5 Physical damage.  This damage ignores DEF).",
      "flavorText": "\"I think there may be a few bugs to work out.\" ~ Tok, Skeezick Machinist",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Dj9Cg3AE8DG2AG2Bj9Dj9Eerlgggvxilyrqsf",
      "deckLimit": 2
    },
    {
      "id": 61,
      "name": "Germination Engine",
      "description": "When this relic is deployed, a Level 3 Young Sapling is summoned on the nearest unoccupied space within 5 spaces. At the end of every 6 turns, a Level 3 Young Sapling is summoned on the nearest unoccupied space within 5 spaces. This relic loses 5 HP each time a Level 3 Young Sapling is summoned. This relic has Forest Front.",
      "flavorText": "The magic of life is stronger than most believe, it can take hold beside a calm pool, or in the midst of total chaos.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9AJ8Jf1AF0Be9BJ8GJ8HJ8Ieemsfkwinwthpwf",
      "deckLimit": 2
    },
    {
      "id": 63,
      "name": "Glacier Engine",
      "description": "This relic has <ability value=600>Arctic</ability>, Ice Aura (When this unit is deployed, and at the beginning of each turn, spaces within 3 spaces from this unit become Ice) and Ice Generator (At the end of your turn, spaces adjacent to terrain generated by this ability become Ice. When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces).",
      "flavorText": "The Jakei shamans learned they could bring the Tundras with them to battles in lands where the air was absent of cold.",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path to Conquest",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9AJ8Jf1AF0BE8Dj9Ej9Fj9Geeeilnwtuxmnjeg",
      "deckLimit": 2
    },
    {
      "id": 75,
      "name": "Globe of Deception",
      "description": "While this relic is in play, all Nora globes become Blood Balls (Demons and Vampyres heal damage, others are damaged).\r\n",
      "flavorText": "\"Feast upon this gift of life! Let it nourish your demonic soul and restore your body. Blood will sustain you. It will strengthen you.\" - R`valna, Priestess of Sheoul",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9Ee9AE8DG2AE8Dj9Fj9Gpygpqluohtmekpf",
      "deckLimit": 2
    },
    {
      "id": 31,
      "name": "Graveyard",
      "description": "This relic has Graveyard (A Skeleton champion with Font Ignorance is spawned to an unoccupied space adjacent to this relic. Your Shrine or Avatar loses 2 HP when you activate this ability).",
      "flavorText": "\"Damn the dead for spoiling the sanctity of our ancestors graves!  I despise that I must give this order, but we must destroy the village graveyard!\" -Rygaln  Denswenton, Ironfirst Colonel",
      "noraCost": 40,
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9BF0AJ8HJ8IJ8Jeemnwkgnplllyxf",
      "deckLimit": 2
    },
    {
      "id": 78,
      "name": "Greenhouse",
      "description": "All Plants within 5 spaces gain +2 DMG and +1 DEF. This effect does not stack. This relic has <ability value=1412>Germinate</ability>",
      "flavorText": "\"The forest protects us. As its residents, we must return this favor to the best of our abilities. If the forest will care for us, then we will care for the forest!\" - Darius of the Eternal Circle",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EF0BE8DG2AE8DJ8IJ8Jgkevsouonnhnyo",
      "deckLimit": 2
    },
    {
      "id": 133,
      "name": "Griefbearer's Fountain",
      "description": "This relic has Demon's Thirst (This unit loses 10 HP and a blood globe worth 6 HP spawns in all adjacent squares).",
      "flavorText": "The Griefbearers built a statue to remind the Nefari of their burden. When it was finished, they began to bleed themselves before their masterpiece. Now, their blood pools around the base of the shrine for any passing demon to partake.",
      "noraCost": 25,
      "artist": "Michele Chang",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8JJ8IF0AE8DG2AF0BJ8HJ8Iiwiwztfggepqqo",
      "deckLimit": 2
    },
    {
      "id": 220,
      "name": "Griffin Perch",
      "description": "This relic has <ability value=2550>Relocate Self</ability>, <ability value=1225>Bastion of Mobility</ability> and <ability value=1241>Motivate</ability>. While this unit is in play, Sigil abilities triggered on friendly champions last an additional 2 turns. When this unit is deployed, other Sigil abilities will trigger.",
      "flavorText": "As the griffin population has recovered, new perches have been sighted throughout the Stronghold.",
      "noraCost": 25,
      "artist": "Thomas Babbey",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GE8De9AG2Ae9Bj9Ej9Feeeiruzoquziro",
      "deckLimit": 2
    },
    {
      "id": 157,
      "name": "Grim Well",
      "description": "This unit has Grim Aura (Opposing champions moving within 3 spaces of this unit lose all AP).",
      "flavorText": "\"We went to the old well again, even when mom told us not to. I want to know why Karam got sick. I think they are poisoning our water, but I need proof.\" - Journal found in Cerlornas, Pre-Separation era",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9AG2AE8DG2Af1Bj9Bj9Ceitxxfgrshpwtqf",
      "deckLimit": 2
    },
    {
      "id": 10,
      "name": "Grimlic's Eye",
      "description": "This relic has <ability value=52>Resistance: Magical 3</ability>, <ability value=601>Shadowspawn</ability>, <ability value=13>Detection 3</ability>, and <ability value=1343>Mystic Push</ability>. Enemy champions within 5 spaces of this relic are <condition value=illuminated>Illuminated</condition>.",
      "flavorText": "\"It's said that at night Grimlic saw the whole world at once, but often by morning he forgot most of what he saw...\"",
      "noraCost": 30,
      "artist": "Layne Johnson",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9Ae9BJ8GJ8HJ8Ioqfpqzgyvzkrfvf",
      "deckLimit": 2
    },
    {
      "id": 30,
      "name": "Grimlic's Portal",
      "description": "This relic has Immunity - Physical. All champions, both friendly and opposing, adjacent to this relic gain Portal (This champion is relocated to a deployment zone its controller controls, 4AP).",
      "flavorText": "\"Godwin!  Be more mindful of where you step!  This is a very powerful artifact that requires  immense amounts of concentration to be able to control where it takes you.  You wouldn't want to end up in Sheoul would you?\"  - Menalaus, High Mage",
      "noraCost": 30,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9Be9Aj9Fj9Gj9Hohnwftjyinekufg",
      "deckLimit": 2
    },
    {
      "id": 190,
      "name": "Grumble Rock",
      "description": "This relic has Arctic, Ice Aura and Majestic 2.  Friendly Yeti within 5 spaces have Charge 3.",
      "flavorText": "Many statues similar to this one were found on S'haradesirin, the Broken Shard, suggesting that Yetis lived and thrived on the island at one point. The Jakei have taken to calling them \"Grumble Rocks\" for the sound they produce when the arctic winds strikes them.",
      "noraCost": 30,
      "artist": "Paul Guzenko",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Ej9DG2BE8DG2Ag3Aj9Cj9Dilgtjtzrqsfrqsf",
      "deckLimit": 2
    },
    {
      "id": 15,
      "name": "Guard Tower",
      "description": "Guard Tower has Detection 3, Battlemaster 2 and Resistance - Physical 1 and Guard Tower (At the start of your turns, enemy champions within 4 spaces take 2 Physical damage and are knocked back 1 space (does not affect Stealthed champions)).",
      "flavorText": "\"Keep em back boys! We can't let them get to the stronghold!\" - Dwarven Guards",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 28,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9AF0BJ8IJ8Jj9Aoqsfieirfxfpjeg",
      "deckLimit": 2
    },
    {
      "id": 241,
      "name": "Guardian's Treasure",
      "description": "This relic has Guardian's Treasure (Dragons and Beasts within 5 spaces have +2 DMG and +1 DEF.  This does not stack.), Majestic 1 (Opposing champions adjacent to this unit are <condition value=awestruck>Awestruck</condition>) and Fascinate (At the beginning of your turn, any enemy champion without Iron Will within 5 spaces of this unit is moved 2 spaces directly towards this unit).",
      "flavorText": "Preeecious.",
      "noraCost": 30,
      "artist": "Markus Erdt",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "LIMITED",
      "runeSet": "Path of De'lim",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Ej9Dg3AF0BG2Ag3Aj9Dj9Eeeeempsussxkluf",
      "deckLimit": 2
    },
    {
      "id": 239,
      "name": "Hahndor Memorial",
      "description": "Enemy champions within 5 spaces are <ability value=2004>Faithless</ability>.  When this relic is deployed and when enemy champions moves within 5 spaces of this unit, they take 2 Fire damage and become <condition value=branded>Branded</condition> for 4 turns.",
      "flavorText": "Upon his return from Maljara, the Inquisition sought to cast Magnus as a champion of the Stronghold. Isran's pleas were able to spare her weary brother from the more extravagant plans.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Path of De'lim",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9BG2BF0AG2AG2Aj9Cj9Dmeitowvvmwxtosf",
      "deckLimit": 2
    },
    {
      "id": 72,
      "name": "Halberd of J'thir",
      "description": "This unit has <ability value=1224>Bastion of Will</ability> and <ability value=1241>Motivate</ability>.",
      "flavorText": "\"This monument stands as a testament to the will of the Jakei.\" - Inscription on the Halberd of J'thir",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0Bf1AG2Bj9Cj9Dj9Eeeeeeeigyoluzgg",
      "deckLimit": 2
    },
    {
      "id": 211,
      "name": "Head of Osarius",
      "description": " This relic has <ability value=601>Shadowspawn</ability>, <ability value=2847>Burning Presence</ability>, and <ability value=2843>Propagate: Self 1</ability>.",
      "flavorText": "Osarius is the spirit of the Flame Hydra that protects Grimlic's private quarters from all intruders and has no understanding of friend or foe.  It has taken Grimlic's disappearance rather personally.\r\n",
      "noraCost": 35,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Gj9FG2Be9AG2Ae9Aj9Cj9Dpluojwfmjiepfrf",
      "deckLimit": 2
    },
    {
      "id": 171,
      "name": "Headshrinker's Totem",
      "description": "This relic has <ability value=2503>Shrinking Gaze</ability>. While a champion with Race: Hyaenid or Class: Witch is within 4 spaces of this unit, it also gains <ability value=1336>Fascinate</ability>.",
      "flavorText": "\"Don't get too close to that thing. Looks like it's staring right at us no matter where we stand.\" Becken, Deep Elf Scout",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Dj9Ce9AE8DG2AG2Bj9Fj9Gtxvssoqwzgruxqf",
      "deckLimit": 2
    },
    {
      "id": 176,
      "name": "Heartstone",
      "description": "This relic has Dampen (At the beginning of each turn, the opposing champion with the highest DMG within 5 spaces is Awestruck(This unit has -50% DMG and -1 SPD) for 1 turn) and Rock Defiance (When this unit is successfully attacked, friendly units within 5 spaces with this ability has +1 DMG for 3 turns and gains 1 MAX HP permanently).",
      "flavorText": "Rocks, for the Grintmaw, aren't just tools or scenery. Each tells a story, and from time to time, they discover a stone that can be imbued with great powers.",
      "noraCost": 35,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "ej9Dj9Cf1BE8DG2AG2Bj9Aj9Bxxfvhroqwvmyxqf",
      "deckLimit": 2
    },
    {
      "id": 203,
      "name": "Hekatian Fleshgrinder",
      "description": "This unit has <ability value=1489>Unspeakable</ability> and <ability value=2778>Fleshgrinder</ability>.",
      "flavorText": "\"Yes, my pet, you did serve me well. And now you will serve me well to the end.\"  ~ Sorsha, Hekatian Bloodguard",
      "noraCost": 25,
      "artist": "Conceptopolis",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "ej9Gj9Fe9Ae9AG2Ae9Aj9Fj9Gkjyvzmhyxinhrqf",
      "deckLimit": 2
    },
    {
      "id": 128,
      "name": "Hive",
      "description": "At the end of your turn, all enemy champions within 4 spaces of this relic take 3 Physical damage and become Poisoned 2.",
      "flavorText": "In the Sundered Lands, colonies of insects have grown out along the borders between Draksar and Cyclops. With their Anthromancers, the Skeezick trained many of them to fight with their armies. Ultimately, their insect armies would be in service to Akakios.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8HG2BE8DG2AF0Aj9Cj9Dmnukwvhnuxvsjpf",
      "deckLimit": 2
    },
    {
      "id": 164,
      "name": "Ice Dragon Statue",
      "description": "This relic has Arctic Bolt (All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Frost damage and become Chilled 2. This damage ignores DEF) and Instability (When this unit activates an ability, it loses 10 HP).",
      "flavorText": "Made during a time now lost, these statues are found throughout the Savage Tundra and into parts of the Forsaken Wastes as well.",
      "noraCost": 35,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "LIMITED",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Cj9BF0BE8DG2AG2AJ8IJ8Jkuztsjtjiyiwkpf",
      "deckLimit": 2
    },
    {
      "id": 11,
      "name": "Ice Shard",
      "description": "This relic has <ability value=600>Arctic</ability> and <ability value=628>Ice Shard</ability> (When a champion or relic takes Frost damage, that damage is increased by 20%. This effect does not stack).",
      "flavorText": "\"What's so valuable about this? It's just a worthless bit of hard snow.\" Dour Lin, Deep Elf Explorer",
      "noraCost": 40,
      "artist": "Shayne Bingham",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9AE8Dj9Ej9Fj9Geeevosmevzvztzg",
      "deckLimit": 2
    },
    {
      "id": 18,
      "name": "Ice Statue",
      "description": "This relic has <ability value=600>Arctic</ability> and <ability value=1236>Ice Veil</ability>. When an opposing champion moves within 3 spaces of the Ice Statue, it loses 1 AP and becomes <condition value=chilled>Chilled</condition> for 3 turns and <condition value=frozen>Frozen</condition> for 2 turns.",
      "flavorText": "\"We do not hide that we were once elves.\" - J'Orea, Queen of the North",
      "noraCost": 30,
      "artist": "Minn Hyuk Yum",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9BE8Dj9Ej9Fj9Geeeitxzzvonwxzg",
      "deckLimit": 2
    },
    {
      "id": 99,
      "name": "Icefishers' Hamlet",
      "description": "This relic has <ability value=600>Arctic</ability>, <ability value=1510>Market</ability>, <ability value=1517>Train: Damage</ability> and <ability value=1523>Train: Defense</ability>.",
      "flavorText": "The Icefishers of J`thir are considered pioneers of the Tundra. As they move from fishing hole to fishing hole, they establish settlements in their wake. These act as small outposts for travelers.",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9Eg3AE8DG2AE8Dj9Dj9Eevxxiillwmeiyrf",
      "deckLimit": 2
    },
    {
      "id": 138,
      "name": "Idol of Kain Taris",
      "description": "This relic has Will of Kain Taris (All friendly Kanen gain +1 DEF, +1 DMG and +5 HP if a friendly Kanen Witch is in play. This effect does not stack.)",
      "flavorText": "The Kanen follow the commands of Kain Taris. The Cultists and Crones are said to speak directly with this god, passing his word to their followers.",
      "noraCost": 30,
      "artist": "Cristian Giraldes",
      "factions": [
        "Shattered Peaks",
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8JJ8IG2BE8DG2AF0Bj9Cj9Dsmsmykpjgvftoqf",
      "deckLimit": 2
    },
    {
      "id": 152,
      "name": "Impairing Sapphire",
      "description": "This relic has <ability value=2373>Nora Gem</ability> (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces) and <ability value=2614>Impairing Luminescence</ability> (This unit has Impairing Feedback).",
      "flavorText": "Twlight Sapphires get their names from the same blue that paints the sky during twilight. These precious stones were worn by royalty in pre-Separation Valdac.",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Savage Tundra",
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9Ae9BE8DG2Af1BJ8GJ8Hytxousxxiphito",
      "deckLimit": 2
    },
    {
      "id": 90,
      "name": "Ironfist Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 35,
      "name": "Ironfist Standard ",
      "description": "While this unit is in play, friendly Ironfist Stronghold champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"We fight for King! We fight for country! We fight for The Holy!\"",
      "noraCost": 25,
      "artist": "Layne Johnson",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9BG2Aj9Bj9Cj9Dekuoqzxfxvfitfg",
      "deckLimit": 1
    },
    {
      "id": 206,
      "name": "Jakei Globe",
      "description": "At the beginning of each turn, spaces between this relic and the four closest friendly Jakei become Ice for 1 turn. This relic has Ice Front (At the beginning of each turn, all spaces within 3 spaces of this champion become Ice for 4 turns).",
      "flavorText": "The globe tracks the movement and locations of the royal Jakei.  Currently, it indicates that J'orea remains in the Palace, but appears to be mistaken.\r\n",
      "noraCost": 20,
      "artist": "Paul Guzenko",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9FF0Ae9AG2Ae9AJ8HJ8Insmyxqofknumepf",
      "deckLimit": 2
    },
    {
      "id": 91,
      "name": "K'thir Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 137,
      "name": "Land Mine",
      "description": "This relic has <ability value=601>Shadowspawn</ability>. When an enemy champion moves within 2 spaces of this relic, it is destroyed and enemy units within 2 spaces take 12 Fire damage. Units successfully damaged are knocked back 2 spaces and become Distracted 2 (This unit may only activate base attacks).",
      "flavorText": "\"It may look pretty and shiny, but it's very dangerous. Don't touch- Hey! I said to leave it alone! Drop it right now!\" -Uuraak, Voil Captain, last words",
      "noraCost": 35,
      "artist": "Joachim Barrum",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "eJ8JJ8IG2AE8DG2AF0Bj9Bj9Ceeeeemhethyvkpf",
      "deckLimit": 2
    },
    {
      "id": 246,
      "name": "Lava Font",
      "description": "This relic has Immunity: Fire, Lava Front and Lava Font (When an enemy champion within 5 spaces makes a basic attack, it takes 4 Fire damage).",
      "flavorText": "Fonts placed at the edge of the Breath, or even within the forest itself, cause terrible damage to the surrounding land.",
      "noraCost": 30,
      "artist": "Paul Guzenko",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9Fg3Af1AG2Ae9Aj9Dj9Eerllrjpfkexousf",
      "deckLimit": 2
    },
    {
      "id": 50,
      "name": "Lava Trap",
      "description": "This relic is deployed stealthed. When an enemy champion moves within 2 spaces of the trap, the relic is destroyed and enemy champions within range take 8 Fire damage and become Charred 3. This damage ignores DEF. The location of the relic becomes lava for 5 turns.",
      "flavorText": "In the Underdepths, no place is truly safe. The earth itself can silently swell with flame, and incinerate the unwary traveler. ",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0BF0BJ8IJ8Jj9Aeeemwzinnjnsmyg",
      "deckLimit": 2
    },
    {
      "id": 159,
      "name": "Living Diamond",
      "description": "This relic has Nora Gem (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces) and Living Luminescence  (This unit has Trailblaze (All friendly champions have Brushwalker (This champion ignores movement restrictions and movement penalties imposed by Vegetation), Ferocious Growth (At the beginning of each turn, all spaces within 3 spaces of this champion becomes Jungle (Impeding Vegetation) for 4 turns), Jungle Kingdom (Friendly champions with Race: Leoss within 3 spaces gain <ability value=2088>Tunnel: Vegetation</ability>)) and <ability value=2550>Relocate Self</ability>.",
      "flavorText": "Living Diamonds are found in the densest regions of Maljaran jungle. These diamonds are difficult to mine, because they are always surrounded by large, rapid-growing vines.",
      "noraCost": 25,
      "artist": "Michele Chang",
      "factions": [
        "Ironfist Stronghold",
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9Ag3AE8DG2Af1Bj9Dj9Eerzkyroqzrjegrf",
      "deckLimit": 2
    },
    {
      "id": 71,
      "name": "Lotus Altar",
      "description": "This relic has Lotus Altar (Friendly champions within 5 spaces of this relic are Shielded) and Weaken Spells (Friendly champions within 5 spaces take 5 less damage from spells).",
      "flavorText": "\"The swamp protects you from harm, young one. You need not fear it.\" - Bishguf, Boghopper elder",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0Bf1Af1AJ8Jj9Aj9Bsmsmszitouoyrzg",
      "deckLimit": 2
    },
    {
      "id": 151,
      "name": "Mangled Totem",
      "description": "This relic has <ability value=3367>Punishing Aura 1</ability> (At the end of each turn, opposing champions within 5 spaces lose 1 HP for each AP they have). Enemy champions that move within 3 spaces of this unit become <condition value=cursed>Cursed</condition> for 3 turns.",
      "flavorText": "\"The bloody thing's cursed, I tell you! I was just passin' by it, mindin' my own business, when I tripped on my own feet. When I got up, I tripped again! I could'a sworn the blasted totem was laughin' at me!\" - Redmun Kingjaw, Infantrytort on the Leviathan",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9Ae9AE8DG2Af1Bj9Fj9Gvmsuhgruoytsoqf",
      "deckLimit": 2
    },
    {
      "id": 40,
      "name": "Mark of Sheoul",
      "description": "While this unit is in play, friendly Underdepths champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"We are the revenge against those who abandoned us.\"",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Underdepths"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Cj9BG2Ae9Be9BJ8GJ8HJ8Iyojtoluztuqowxf",
      "deckLimit": 1
    },
    {
      "id": 127,
      "name": "Mason's Spire",
      "description": "Friendly relics within 8 spaces of this one have +10 MAX HP.  Relics and equipment you deploy receive a 10% nora refund. This effect does not stack.",
      "flavorText": "After the War of Kinsmen, it was from these spires that Serkan commanded his Bone Masons to rebuild the Barrier Wall using the corpses of the slain. The Barrier Wall was later renamed 'The Wall of Bone.'",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8Hf1BE8DG2AF0Aj9Aj9Brzgvsherlykexo",
      "deckLimit": 2
    },
    {
      "id": 175,
      "name": "Meat Pie",
      "description": "This unit has <ability value=812>Devourable</ability> and <ability value=2541>Mystery Meat</ability>",
      "flavorText": "Guaranteed to contain meat or meat by-products!",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "LIMITED",
      "runeSet": "Crusade of the Vashal",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "ej9Dj9Cf1AE8DG2AG2BJ8Jj9Aevfirojgkwiwtqf",
      "deckLimit": 2
    },
    {
      "id": 103,
      "name": "Merchant's Quarter",
      "description": "Relics and equipment you deploy receive a 10% Nora refund.  This effect does not stack. This relic has <ability value=1526>Train: Evasive</ability> (Target friendly champion within 5 spaces gains 1 rank of Evasive (This unit takes 20% less damage from ranged attacks). This ability costs 6 Nora and does not stack. (AP: 0, CD: 3)) and <ability value=1513>Train: Strike</ability> (Target friendly champion within 5 spaces permanently gains <ability value=1486>Strike</ability>. This ability costs 6 Nora).",
      "flavorText": "\"We've got bread, bows, hammers, helms, swords, spells, cakes, canes, ales, and arrows. Everything else is out of stock until tomorrow.\" - Higgin Lighthall, Head of the Ironfist Merchant's Quarter",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9FF0AE8DG2Ae9AJ8HJ8Iqosjrzvsqqfmyo",
      "deckLimit": 2
    },
    {
      "id": 42,
      "name": "Mindslicer Obelisk",
      "description": "This relic has Mindslice (While this unit is in play, all attacks and attack abilities with a range of 4 or greater cost +1 AP, and all champions gain <ability value=1603>Reflection 2</ability>) (Unique - You may have only one of this rune in your battlegroup)",
      "flavorText": "\"Captain, we can't seem to hit them with our arrows. Ralgan seems to think there is magic at work.\" -- \"Not magic...sorcery. How much do you want to bet it's that tower?\" - Gondry, K'thir Watchguard",
      "noraCost": 30,
      "artist": "Gabriel Garza",
      "factions": [
        "Underdepths"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8HJ8Ge9BF0Ag3Aj9Dj9Ej9Fsofinyofmhkjieg",
      "deckLimit": 1
    },
    {
      "id": 101,
      "name": "Mire Fair",
      "description": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack. This relic has <ability value=1515>Train: Healing Salve</ability> and <ability value=1522>Train: Mobility</ability>.",
      "flavorText": "\"If you can make it to the Mire Fair, you'll make it through Forglar Swamp just fine. As long as you're not a Drakkie or a G`hern, they'll sell you anything you need.\" - Tibbs McQuarries, IEF",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9Fe9AE8DG2Ae9Aj9Fj9Gftjemszmjirfpqf",
      "deckLimit": 2
    },
    {
      "id": 247,
      "name": "Misleading Signage",
      "description": "This relic has Misleading Signage (At the end of this unit's turns, a random enemy champion within 5 spaces without Wandering gains <ability value=2266>Wandering</ability> and <ability value=1303>Gain Control</ability>for 3 turns) and Incoherent Babbling (Champions within 3 spaces are <condition value=distracted>Distracted</condition>).",
      "flavorText": "\"I am SURE the sign said it was this way!\" ~ Marin the Lost",
      "noraCost": 40,
      "artist": "Paul Guzenko",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Ge9Bf1AG2Ae9BJ8GJ8Heeiphpqsfkgron",
      "deckLimit": 2
    },
    {
      "id": 113,
      "name": "Mist of the Dead",
      "description": "This relic has Frightful Aura 3 (All opposing champions within 3 spaces have -2 DMG. All friendly undead champions within 3 spaces have +2 DEF) and Arrow Eater (When this unit would take damage from a ranged attack, that damage is prevented, and this champion gets a bonus to DMG equal to 25% of the damage that would have been dealt for 2 turns)",
      "flavorText": "It surrounded them from all sides. The thick fog stung their eyes and filled their nostrils with putrescence. L`ilim stared out into the rank veil. Beyond its haze, he could hear the wail of Elsarin's cursed.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GF0AE8DG2Ae9BJ8HJ8Ievoszousmhgiin",
      "deckLimit": 2
    },
    {
      "id": 100,
      "name": "Moga Bartering Post",
      "description": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack. This relic has <ability value=1520>Train: Regeneration</ability> and <ability value=1519>Train: Spell Resistance</ability>.",
      "flavorText": "The economy of the Shattered Peaks is simple to understand: the G`hern trade with the Moga, the Moga trade with the G`hern, and the Voil confiscate everything for the queen.",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9FE8DE8DG2Ae9Aj9Ej9Filuvvztzkgkekpf",
      "deckLimit": 2
    },
    {
      "id": 14,
      "name": "Moga Den",
      "description": "At the start of every fourth turn, Moga Den spawns a Moga Pup on an adjacent space for 5 Nora.",
      "flavorText": "Out of breath, Gullish leapt into the camp, \"I've found where they're coming from.\"",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9Ae9BJ8GJ8HJ8Iiwmuzitsosqllyg",
      "deckLimit": 2
    },
    {
      "id": 205,
      "name": "Morin's Corner",
      "description": "This relic has <ability value=2848>Revitalizing Flavors</ability>.",
      "flavorText": "Morin's Corner came under scrutiny as just prior to his disappearance, Feofil had visited the establishment for a meal.  No wrong doing was able to be proven, and the publicity has increased business a hundredfold.\r\n",
      "noraCost": 35,
      "artist": "Alex Konstad",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9Fe9Be9AG2Ae9AJ8GJ8Houqfilumwtxowo",
      "deckLimit": 2
    },
    {
      "id": 225,
      "name": "Mystic Atelier",
      "description": "This relic has <ability value=3240>Clone Matter</ability> (Target an enemy relic or enemy equipped champion within 8 spaces. If the target is a Relic, a copy of that Relic is summoned to an adjacent space. If the target is an equipped champion, a copy of that Equipment is equipped on the closest valid friendly champion (including this one). The CD on this ability is reduced by 2 when a relic or equipment within 8 spaces is destroyed).",
      "flavorText": "\"I have returned to this world more powerful than any before me. Watch now as I lay all to waste!\" - Serkan, Lich Master",
      "noraCost": 30,
      "artist": "Cory Trego-Erdner",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Gf1Ae9AG2Ae9BJ8Jj9Aeeiplwztzgvmso",
      "deckLimit": 2
    },
    {
      "id": 130,
      "name": "Mystic Forge",
      "description": "Target champion within 5 spaces becomes equipped with either Heavy Crossbow, Axeman's Fate or Sunder Axe. This unit loses 5 HP. Equipment generated by this ability has a nora cost of 0.",
      "flavorText": "\"You don't craft a sword like this in any old forge. We made our weapons with the Ironfists' Forge. Their tools were blessed by the priestess and runes were etched on every anvil. The forge was mixed with fire and Nora. In that ancient forge, we made legends.\" - Euan Ironfist",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "eJ8JJ8IE8DE8DG2AF0Bj9Ej9Fiwiwtfxzxkyxxo",
      "deckLimit": 2
    },
    {
      "id": 126,
      "name": "Mystic Whirlpool",
      "description": "Whenever a non-Flying, non-Amphibious champion moves via normal movement within 4 spaces of this relic, it is pulled one space directly toward it.",
      "flavorText": "\"The greatest warrior of Forglar is not Finlord or Tidemaster, nor is it Moog or Hydraxor. It is not Boghopper, Salaman or Firk. It is Forglar. The marsh can swallow entire armies in its waters, even break their spirits in its murk. Remember this lesson.\" - Gekaal, High One of Forglar",
      "noraCost": 25,
      "artist": "Michele Chang",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "eJ8IJ8Hf1AE8DG2AF0AJ8Jj9Aevowxofphrsjto",
      "deckLimit": 2
    },
    {
      "id": 224,
      "name": "Myx Hive",
      "description": "This relic has Myx Hive (At the start of your next turn, a Myx Pupae is deployed on an adjacent space for 10 Nora. This repeats at the beginning of every sixth turn.)",
      "flavorText": "\"Is there no end to these blasted things, Thor? For every one we slay, ten more emerge from their den!\" - Ayla the Huntress",
      "noraCost": 25,
      "artist": "Kirill Chepizhko",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GF0Be9AG2Ae9BJ8IJ8Jeeiyklggnexton",
      "deckLimit": 2
    },
    {
      "id": 172,
      "name": "Myx Pupae",
      "description": "After 5 turns, this relic is destroyed and a Young Myx Drone with no upgrades is summoned in its place.",
      "flavorText": "With proper nurturing a Myx Drone Pupae can hatch in as little as 5 Days. If Pupae are in a hostile environment they will instinctively reduce hatching times drastically...at much cost to their lifespan.",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "ej9Dj9Ce9BE8DG2AG2BJ8GJ8Hohvkgykgvxoufpf",
      "deckLimit": 2
    },
    {
      "id": 17,
      "name": "Nature's Balance",
      "description": "This relic has <ability value=1567>Balance 3</ability> and <ability value=2409>Empathy</ability>.",
      "flavorText": "\"Curse those damn skeletons! There must be something we can do!\" -- \"There is...\"  - Godwin complaining to Menalaus",
      "noraCost": 25,
      "artist": "Layne Johnson",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9Af1Bj9Aj9Bj9Ceeemjevzkpykjgg",
      "deckLimit": 2
    },
    {
      "id": 98,
      "name": "Nefari Exchange",
      "description": "Relics and equipment you deploy receive a 10% nora refund. This effect does not stack. This relic has <ability value=1517>Train: Damage</ability> and <ability value=1515>Train: Healing Salve</ability>.",
      "flavorText": "\"You could just accept the shoddy blade that the Boks gave you. Or, you could purchase one of my fine scimitars. Of course, my expertise comes with a price.\" - Y`almi, Nefari Blacksmith",
      "noraCost": 20,
      "artist": "James Ryman",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EG2BE8DG2AE8Dj9Cj9Deggexxirlrqhtqf",
      "deckLimit": 2
    },
    {
      "id": 236,
      "name": "Nefari Resurrection",
      "description": "This relic has Nefari Resurrection (Friendly Elves within 5 spaces have Overkill: Healing (When a champion would be destroyed via a basic attack, the attacking champion is healed for an amount equal to the damage beyond the current health of the target) and Cull (This champion deals 4 additional damage to champions with 0 AP (Fatigued) on basic attacks)).",
      "flavorText": "The Nefari Resurrection claims to be a place for Elven transcendence, where even surface Elves are allowed. But in reality the organization has only one true goal - the subjugation of the Fae Conclave, whose meddlesome denizens the Nefari blame for their exile from the Forest.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8JJ8IE8De9BG2AF0Bj9Ej9Fgygyrsusjegvfpf",
      "deckLimit": 2
    },
    {
      "id": 24,
      "name": "Nefari Torch",
      "description": "Whenever a player successfully casts a spell, their opponent's champions gain +1 DMG for 6 turns and gain 1 AP and their champions have -1 DMG for 6 turns. (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "Fueled by the magical pyre-stone, the torches of the Underdepths burn with malevolent ferocity.",
      "noraCost": 25,
      "artist": "Layne Johnson",
      "factions": [
        "Underdepths"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9BF0BJ8IJ8Jj9Agyoqukjrjtmjexf",
      "deckLimit": 1
    },
    {
      "id": 5,
      "name": "Nora Mine",
      "description": "At the beginning of your turn, you gain 5 additional nora, as well as 1 additional nora for each Nora Miner in play (a Nora Miner is a unit with the Nora Miner ability).",
      "flavorText": "\"Patience your grace, these mines will profit if you only give them time.\" - Feofil, attempt to calm an angry Rugolth ",
      "noraCost": 30,
      "artist": "Kelly Hamilton",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "cj9AJ8JJ8IF0Bg3AJ8IJ8Jj9Aevkyoqzxxtsftxi",
      "deckLimit": 2
    },
    {
      "id": 22,
      "name": "Nora Pearls",
      "description": "When a player successfully casts a spell, the enemy gains Nora equal to 50% of that spells Nora cost.  This does not stack.  (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "\"Day 23: Further testing on the pearls concludes that they do react to the presence of channeled Nora. Perhaps this is why the pools glow blue?\" - Journal of Kali, Elven Apprentice Mage",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9Be9BJ8GJ8HJ8Ismevqwmsmevhiwf",
      "deckLimit": 1
    },
    {
      "id": 16,
      "name": "Nora Well",
      "description": "While this relic is in play, all Nora globes give twice the amount of Nora upon capture.",
      "flavorText": "\"As difficult as this wretched swamp makes combat, it certainly does not lack Nora.\"  - Jyat Cslen, Nefari Flame Warden",
      "noraCost": 30,
      "artist": "Gabriel Garza",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 16,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9Be9BJ8GJ8HJ8Ikwfegiwfpsjipwf",
      "deckLimit": 2
    },
    {
      "id": 231,
      "name": "Northern Cross Obelisk",
      "description": "This relic has Penance (When this unit is damaged, friendly champions within 3 spaces are healed for 50% of the damage (rounded down), and enemy champions within 3 spaces take Magical damage for 50% of the damage (rounded up, ignores DEF)).",
      "flavorText": "The Northern Cross Templars have gained serious ground in recent decades, consolidating power over a large portion of the country-side.  The Inquisition remains in control over most of the more heavily populated areas.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Gf1Ae9BG2Ae9BJ8Jj9Aeevkrqhgykukuo",
      "deckLimit": 2
    },
    {
      "id": 132,
      "name": "Obelisk of Foresight",
      "description": "This relic has Preordained (This rune is automatically revealed at the beginning of the game), Occlude (This unit loses 3 HP and 3 random runes in your runedock are concealed) and Augury (This unit loses 3 HP and you gain 3 rune reveals).",
      "flavorText": "Within the eye of the storm / Beginning and end collide / Dusk is 'twined with dawn / Till time itself demised - Inscription on the sides of the Obelisk of Foresight",
      "noraCost": 30,
      "artist": "Eric Belisle",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8JJ8Ie9BE8DG2AF0BJ8GJ8Hkukukneemlnwmn",
      "deckLimit": 2
    },
    {
      "id": 173,
      "name": "Orange Myx Pupae",
      "description": "After 5 turns, this relic is destroyed and a Young Myx Drone with no upgrades is summoned in its place.",
      "flavorText": "Myx Pupae are considered a delicacy among the Darkmarsh Boghoppers. They're incredibly hard to get ahold of and even harder to cook correctly since they hatch so fast when threatened. The shells and acid sacs are discarded and tasty tender meat is left. ",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "LIMITED",
      "runeSet": "Wild Alliance",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "ej9Dj9CF0AE8DG2AG2BJ8HJ8Ieirqofkllnjtjpf",
      "deckLimit": 2
    },
    {
      "id": 139,
      "name": "Orb of Frostfall",
      "description": "This relic has <ability value=600>Arctic</ability> and <ability value=2804>Orb of Frostfall 2</ability>.",
      "flavorText": "H'irol looked into the orb, watching frost swirl within its center. He touched its surface and felt a biting chill in his core. As he watched the falling snow, as the wind blew it towards him, he embraced the cold.",
      "noraCost": 25,
      "artist": "Michele Chang",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8JJ8Ig3AE8DG2AF0Bj9Dj9Eeeeeeipyxvsssqf",
      "deckLimit": 2
    },
    {
      "id": 118,
      "name": "Orb of Protection",
      "description": "Friendly Champions receive 20% less damage (after DEF) from spells and ranged attacks while Orb of Protection is in play. This unit loses 3 HP when this effect triggers. This unit also has <ability value=116>Regeneration 2</ability> and <ability value=1612>Searing Aura 4</ability>.",
      "flavorText": "\"Gather beneath my protection, friends. Bask in the warmth of its embers. Let it burn the arrows from your skin. I will protect you from their invocations.\" - Lord Maxxarek of Sheoul",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GG2AE8DG2Ae9Bj9Bj9Ceemnekjrhiiyxo",
      "deckLimit": 2
    },
    {
      "id": 23,
      "name": "Permafrost Obelisk",
      "description": "This relic has Arctic. When a player successfully casts a spell, the opponent's champions gains 3 HP permanently, up to a maximum of 100 HP. (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "\"The advantage of the Jakei building everything out of ice, is that a fresh snow will mend most routine wear.\" - IEF Field Report 9",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9BF0AJ8HJ8IJ8Jeepjymnerfmhrwf",
      "deckLimit": 1
    },
    {
      "id": 258,
      "name": "Phalanx Marker",
      "description": "This relic has Battlemaster 3 (Friendly champions within 4 spaces get +2 DMG and +1 DEF.  This effect does not stack) and Tough 3 (Any time this champion would take damage, it takes 3 less than normal) and Phalanx Marker (This unit has Arrow Eater and Regeneration 3 while there is an adjacent real friendly champion).",
      "flavorText": "The Draksar Legion is as physically disciplined as it is morally rigid: once entrenched, it won't move an inch.",
      "noraCost": 30,
      "artist": "Markus Erdt",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Planar Disturbances",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8JE8DG2AG2Af1Aj9Ej9Fiwxkjinlnshtuqf",
      "deckLimit": 2
    },
    {
      "id": 47,
      "name": "Plague Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability>. When an enemy champion moves within 2 spaces of this relic, this relic is destroyed, and enemy champions within 2 spaces take 6 Disease damage and become <condition value=diseased>Diseased 3</condition> and <condition value=inhibited>Inhibited</condition> for 3 turns. This damage ignores DEF.",
      "flavorText": "\"These plagued skulls will do nicely. After the disease takes their lives, and we raise them to undeath,  they will thank me for breaking their sickness.\" - Meder, High Lich",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0BG2Bj9Cj9Dj9Eeeeeeigykrjgigg",
      "deckLimit": 2
    },
    {
      "id": 52,
      "name": "Poison Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability>. When an enemy champion moves within 2 spaces of the trap, all enemy champions within 2 spaces become Poisoned 3 and lose all AP. This damage ignores DEF.",
      "flavorText": "The Forglar shaman believe that the swamp itself is alive. It has been said in times of great peril, the swamp has killed by turning itself to poison.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0BF0AJ8HJ8IJ8Jeepumjlyigymyxf",
      "deckLimit": 2
    },
    {
      "id": 178,
      "name": "Poisonquill Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability>, <ability value=144>Poison Aura 2</ability>, <ability value=156>Disease Aura 2</ability>, and <ability value=3166>Seal of the Vashal</ability>.",
      "flavorText": "These traps are built normal sized by Veasels which means the arrows are pointed at the tenderest of areas on taller creatures.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Crusade of the Vashal",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Dj9CG2BE8DG2AG2Bj9Cj9Dgpqsfegpuojllrf",
      "deckLimit": 2
    },
    {
      "id": 192,
      "name": "Pond of Lilies",
      "description": "Friendly champions with race: Salaman within 2 spaces gain <ability value=2309>Hallucinogenic</ability>. This relic has <ability value=601>Shadowspawn</ability>, <ability value=2685>Restraining Aura</ability> and <ability value=1561>Growth 4</ability>.",
      "flavorText": "\"Lily ponds are especially popular amongst Salaman as they are apparently very good for your skin, and we all know how picky Salaman are about their skin. When I tried it though it just made me sleepy.\" ~ Gillo's Guide to Poxanthuru",
      "noraCost": 25,
      "artist": "Conceptopolis",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Broken Shard",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EE8De9AG2AE8Dj9Ej9Fwirwonpwojwfipf",
      "deckLimit": 2
    },
    {
      "id": 160,
      "name": "Pool of Dreams",
      "description": "This relic has Dreamstate (Friendly champions that come into play within 3 spaces of this unit have Shielded, Spellswallower, Favor and Council: Spells for 6 turns) and <ability value=3252>Portal (Relic)</ability>.",
      "flavorText": "\"Look to the very bottom, not to your reflection in the surface. Do you see them now? Do they look familiar? They hide deep beneath the waters, but a watchful eye can see them.\" - Gekaal the High One",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9BE8DE8DG2AG2Aj9Ej9Fkuvsfthepferoqf",
      "deckLimit": 2
    },
    {
      "id": 36,
      "name": "Pride of K'thir",
      "description": "While this unit is in play, friendly K'thir Forest champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"We were the first to be born and we will be the last to die. We will not let our Forest fall.\"",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9BG2Bj9Cj9Dj9Eeerluosuzmpfigg",
      "deckLimit": 1
    },
    {
      "id": 4,
      "name": "Prismatic Crystals",
      "description": "When a non-Fairy champion moves within 3 spaces of this unit, it becomes Pacified (This champion cannot attack or use abilities to attack, and cannot engage other champions.  This cannot be cleansed) for 2 turns.",
      "flavorText": "\"These blasted crystals are of Menalaus' creation, seems he would prefer we not fight here.\" - Godwin, Elder Garu",
      "noraCost": 20,
      "artist": "Kelly Hamilton",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "cJ8JJ8IJ8HF0Ag3AJ8HJ8IJ8Jmsmsmsxohpsjluh",
      "deckLimit": 2
    },
    {
      "id": 37,
      "name": "Provincial Marker",
      "description": "While this unit is in play, friendly Savage Tundra champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"We may be unclear about our place in the world, but we must ensure that there is a world left to have a place in.\" ",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9Bg3Aj9Dj9Ej9Fofgvmwxipuqfthg",
      "deckLimit": 1
    },
    {
      "id": 174,
      "name": "Purple Myx Pupae",
      "description": "After 5 turns, this relic is destroyed and a Young Myx Drone with no upgrades is summoned in its place.",
      "flavorText": "Purple Myx pupae are extremely rare. To see one (and live) considered extremely good luck amongst Dune Walker tribes. ",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "LIMITED",
      "runeSet": "Wild Alliance",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "ej9Dj9CF0BE8DG2AG2BJ8IJ8Jshklwfxiluouoqf",
      "deckLimit": 2
    },
    {
      "id": 149,
      "name": "Rallying Flag ",
      "description": "Friendly champions within 3 spaces of this relic gain +2 DEF and <ability value=1476>Resilient</ability>. This relic has <ability value=2550>Relocate Self</ability>.",
      "flavorText": "The soldiers marched forward beneath the banner of the Ironfist Stronghold. Although they were tired and some were injured, they marched on. The soldiers knew as long as they stood beneath that flag, and as long as they fought for it, they would never falter.",
      "noraCost": 25,
      "artist": "Michele Chang",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8Jg3AE8DG2Af1Aj9Dj9Eevxkwmsufgiwxqf",
      "deckLimit": 2
    },
    {
      "id": 6,
      "name": "Rejuvenating Fountain",
      "description": "Spaces adjacent to this unit become Shallow Water. Friendly champions within 5 spaces gain <ability value=116>Regeneration 2</ability> and <ability value=1052>Purified</ability>.",
      "flavorText": "\"Bless the Forglar for their fountains.\" - Tibbs McQuarrie, IEF",
      "noraCost": 30,
      "artist": "Gabriel Garza",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "cj9Bj9AJ8Jf1Ag3AJ8Jj9Aj9Bohigkyztzvxvhei",
      "deckLimit": 2
    },
    {
      "id": 79,
      "name": "Rock Generator",
      "description": "This relic has <ability value=2617>Rock Aura</ability> (When this unit is deployed, spaces within 3 spaces from this unit become Rock) and <ability value=3405>Land of the Trolls</ablity> (Friendly champions with Race: Troll within 3 spaces gain <ability value=755>Tunnel: Earth</ability>).",
      "flavorText": "\"The Rock Generator will allow us to terraform large portions of the swamp and tundra to be suitable for building.\" - Feofil, Advisor to King Rugolth",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9Ef1AE8DG2AE8DJ8Jj9Aemsfkwvftmwkgpf",
      "deckLimit": 2
    },
    {
      "id": 56,
      "name": "Rock Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability>. When an enemy champion moves within 2 spaces of the trap, the trap is destroyed and all enemy champions within range take 4 Physical damage, are knocked back 2 spaces, and become Stunned 1. This damage ignores DEF.",
      "flavorText": "The denizens of the Shattered Peaks know a lot about the moving earth. Knowing where to step can mean the difference between life and death. ",
      "noraCost": 35,
      "artist": "Layne Johnson",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Ej9Dg3AF0Ag3Aj9Dj9Ej9Ftftjyojerqqhklg",
      "deckLimit": 2
    },
    {
      "id": 226,
      "name": "Ruby Catalyst",
      "description": "This relic has Ruby Catalyst (When a unit takes Fire damage, this unit gains +2 MAX HP.  This does not include damage from Charred. When this unit is destroyed, enemy champions within 5 spaces take Fire damage equal this unit's MAX HP, divided evenly (to a minimum of 2 and a maximum of 10)) and Demolish (This unit is Demolished).",
      "flavorText": "In the confusion that followed the disappearance of the heroes, a Nefari spy intercepted Jakei plans for a \"Sapphire Catalyst\". Due to the nature of the techniques used to create this device, it was a relatively easy task to substitute a fire ruby.",
      "noraCost": 30,
      "artist": "Kirill Chepizhko",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "eJ8HJ8Gf1Be9AG2Ae9Bj9Aj9Bemekrwxqhgggvo",
      "deckLimit": 2
    },
    {
      "id": 43,
      "name": "Sacred Temple",
      "description": "This relic has Cleansing Aura (Friendly champions within 3 spaces are cleansed at the start of your turns) and Premonition (When this unit comes is deployed, champions you own have Impenetrable for 2 turns).",
      "flavorText": "\"The swamp is our home. It will shelter us. It will empower us. It will defend us. It will heal us.\"  - Boghopper Shaman",
      "noraCost": 25,
      "artist": "Kelly Hamilton",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Skeezick Rebellion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8HJ8Ge9BF0AG2Bj9Cj9Dj9Eeerhipnyrhrwvzg",
      "deckLimit": 2
    },
    {
      "id": 28,
      "name": "Sacrificial Altar",
      "description": "Undead champions you own within 2 spaces gain Sacrifice at Altar (This unit is destroyed and the nearest opposing champion within 6 spaces loses 15 HP.   If this unit is Summoned, the HP loss is reduced to 8.).",
      "flavorText": "Abandoned after the Catastrophe like the religion they once served, the altars of the wind spirit are now used by the dead for darker purposes.",
      "noraCost": 40,
      "artist": "Layne Johnson",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9AG2Bj9Cj9Dj9Eeeeerlgtfknukjg",
      "deckLimit": 2
    },
    {
      "id": 117,
      "name": "Sanctuary of Hope",
      "description": "Friendly champions within 4 spaces of this unit have their AP cost for all abilities (excluding basic attacks) reduced by 1 AP. When a friendly Champion uses an ability (excluding basic attacks) within 4 spaces of this unit, this unit takes 3 Physical damage. This Relic has Consecrated Zone (Area Effect 3: On deploy, friendly Priests, Shamans, and Paladins are cleansed and healed for 5 HP, and terrain modifications are removed from this space. Affected spaces are <mechanic value=hallowed_ground>Hallowed Ground</mechanic>) and Regeneration 1 (At the beginning of your turn, this unit heals 2 HP).",
      "flavorText": "The ancestors of Ironfist made a sanctuary for their king. It took the current residents years to find it. When they did, they shared its shelter. All of Rugolth's subjects enjoyed its serenity.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8Gf1BE8DG2Ae9Bj9Aj9Beipytjnnyrwito",
      "deckLimit": 2
    },
    {
      "id": 68,
      "name": "Sand Generator",
      "description": "This relic has Sand Aura (When this unit is deployed, and at the beginning of each turn, spaces within 3 spaces from this unit become Sand) and Sand Generator (Friendly champions within 3 spaces of this unti gain <ability value=1907>Desert Camouflage</ability> permanently when this unit is deployed. At the end of your turn, spaces adjacent to terrain generated by this ability become Sand. When this relic leaves play, at end of turn, and the end of each turn thereafter, this terrain manipulation effect ends on the most recently affected spaces).\n",
      "flavorText": "\"The sand never ages or dies. Let us cover this dead kingdom in its timeless veil.\" - Derifos, Dune Walker",
      "noraCost": 25,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0Bf1AG2Aj9Bj9Cj9Dqoqoyowmhyxzofg",
      "deckLimit": 2
    },
    {
      "id": 221,
      "name": "Sapphire Catalyst",
      "description": "This relic has Sapphire Catalyst (When a unit takes Frost damage, this unit gains +2 MAX HP.  This does not include damage from Chilled. When this unit is destroyed, enemy champions within 5 spaces take Frost damage equal this unit's MAX HP, divided evenly (to a minimum of 2 and a maximum of 10)) and Demolish (This unit is Demolished).",
      "flavorText": "The Sapphire Conduit was a secret project ordered by the Queen to further develop the elemental capabilities of the Jakei. It was discovered early on that the entire concept was prone to spontaneously explode; naturally, this was adapted as a feature.",
      "noraCost": 30,
      "artist": "Nate Abell",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 10,
      "size": "1x1",
      "hash": "eJ8HJ8Ge9Ae9AG2Ae9Bj9Fj9Gemjegeevvsszvo",
      "deckLimit": 2
    },
    {
      "id": 92,
      "name": "Savage Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 155,
      "name": "Scouring Jasper",
      "description": "This relic has Nora Gem (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces) and Scouring Luminesence (When this unit is deployed and at the start of its turns, opposing champions within 4 spaces take 4 Acid damage and become Scoured 2).",
      "flavorText": "Black Smoke Jaspers have a reputation for cursing its owner with terrible misfortune. Elsari warriors would place these gems on the bodies of slain Valdaci, dooming the soul to eternal strife.",
      "noraCost": 35,
      "artist": "Slawomir Maniak",
      "factions": [
        "Forsaken Wastes",
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9Af1AE8DG2Af1BJ8Jj9Aevxtmwftfirwkpf",
      "deckLimit": 2
    },
    {
      "id": 252,
      "name": "Secluded Shrine",
      "description": "This relic has <ability value=3253>Secluded Shrine</ability> (When a real champion within 5 spaces is destroyed, friendly Paladins, Priests and Shamans within 5 spaces are Cleansed and heals for 6 HP), <ability value=1887>Roar of the Fallen</ability> (When this unit is destroyed, all opposing champions have -1 DEF and -5 DMG for 3 turns) and <ability value=3028>Demolish</ability>.",
      "flavorText": "Expansion and solidity from the Falgar Project allowed access to new territory, even beyond the ancient Valdaci city.",
      "noraCost": 30,
      "artist": "James Ryman",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Dj9CF0Af1BG2AG2BJ8HJ8Iztxtquqzitjyxqf",
      "deckLimit": 2
    },
    {
      "id": 189,
      "name": "Sepulcher of Kings",
      "description": "This relic has Legacy of Kings (The first 8 damage each turn that would be dealt to friendly units, including this one, within 5 spaces is prevented) and Remembrance of Kings (When this unit is deployed, this unit gains +2 MAX HP for each real friendly Dwarf).",
      "flavorText": "\"May our ancestors' might rescue us in this time of need.\" ~ Dwarven Magister",
      "noraCost": 35,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "RARE",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Ej9DF0BE8DG2Ag3AJ8IJ8Jyrhggnlpfeitsqf",
      "deckLimit": 2
    },
    {
      "id": 93,
      "name": "Shattered Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 253,
      "name": "Skeezick Banner",
      "description": "This relic has Prestige (All friendly champions, including this one, within 5 spaces have <ability value=4>Iron Will</ability> and <ability value=3>Fearless</ability>), Relocate Self (This unit is relocated to target space within 5 spaces.  This ability begins on CD), and Skeezick Banner (Friendly Skeezicks within 5 spaces gain <ability value=878>Skeezick Alliance</ability>.  If they already have Skeezick Alliance, they gain <ability value=2961>Skeezick Rebel</ability> instead).",
      "flavorText": "Considering the texture of Sundered Lands fish, they aren't good for much else.",
      "noraCost": 25,
      "artist": "Markus Erdt",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Dj9Cf1Af1BG2AG2BJ8Jj9Aerqfgvziwkeplrf",
      "deckLimit": 2
    },
    {
      "id": 200,
      "name": "Skeezick Furnace",
      "description": "This relic has Fire Feed (At the end of your turn, this unit deals 4 Fire damage to all adjacent enemy champions and heals HP equal to the damage dealt this way. This damage ignores DEF) and Skeezick Furnace (Destroy target relic within 3 spaces. Its owner gains 5 nora).",
      "flavorText": "\"If you can't kill it, you can always burn it!\" - Skeezick Grunt",
      "noraCost": 25,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EG2Be9AG2AE8Dj9Cj9Duolwtxouftukwqf",
      "deckLimit": 2
    },
    {
      "id": 48,
      "name": "Skull of Decay",
      "description": "This unit has <ability value=2307>Contaminate Nora</ability>, <ability value=3377>Corrupting Aura</ability> and <ability value=927>Amplify Disease</ability>.",
      "flavorText": "The skulls of the long fallen high shamans of the screaming hills still hold power over healing. In the torment of their undeath, however, it only serves as a bane.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0BG2Aj9Bj9Cj9Deephnjrzgtukufg",
      "deckLimit": 2
    },
    {
      "id": 26,
      "name": "Skull Totem",
      "description": "Whenever a player casts a spell, 3 of their revealed non-champion runes have their cooldown increased by 4. (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "\"The Moga, in particular, seem to hold that the skulls of fallen warriors have certain magical powers.\" - Religious Practices of the Shattered Peaks, pg. 374",
      "noraCost": 20,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9Bf1Bj9Aj9Bj9Ceeevszroyipwxzg",
      "deckLimit": 1
    },
    {
      "id": 141,
      "name": "Skywing Beacon",
      "description": "Starting on your next turn, spaces adjacent to this relic are deployment zones for the controller of this relic. This Relic has Desert Front (At the beginning of each turn, all spaces within 3 spaces of this champion become Sand for 4 turns).",
      "flavorText": "The Draksar built beacons to help the Skywing patrols with traveling at night. A Skywing Beacon means many things to a passing patrol: food, shelter, comfort, allies.",
      "noraCost": 30,
      "artist": "Darcie Banfield",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8Je9AE8DG2Af1Aj9Fj9Gpyoqsqwqjnytjpf",
      "deckLimit": 2
    },
    {
      "id": 243,
      "name": "Slipstream Fulcrum",
      "description": "When a champion moves within 3 spaces of this unit via normal movement, it gains 1 AP. This triggers up to 2 times a turn for each champion.",
      "flavorText": "The alternative to De'lim's portals, the Fulcrum system aids movement within the Forest without the danger of incursion.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9FE8Df1AG2Ae9Aj9Ej9Foqjemumnnekjwqf",
      "deckLimit": 2
    },
    {
      "id": 199,
      "name": "Sludge Pool",
      "description": "This unit has <ability value=1047>Acid Eater</ability>, <ability value=2757>Ooze Aura</ability> and <ability value=3382>Hidden: Ooze</ability>. Friendly champions within 5 spaces with Race: Slag gain Acid Eater and <ability value=2777>Tunnel Ooze</ability>. If they already have Acid Eater, they gain <ability value=2994>Vigor: Acid</ability> instead.",
      "flavorText": "The Sludge Pool utilizes only the freshest ingredients and refills its pool daily - no day old ooze here! Baby slags enjoy their soaks for free, so bring the whole family!",
      "noraCost": 25,
      "artist": "Mateusz Ozminksi",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Plague of Ba'lah",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EG2Ae9AG2AE8Dj9Bj9Ceilnwvfkrqljrqf",
      "deckLimit": 2
    },
    {
      "id": 97,
      "name": "Slum Market",
      "description": "Relics and equipment you deploy receive a 10% nora refund.  This effect does not stack.  Target friendly champion within 5 spaces gains Assault (This unit makes its base attack at no AP cost on any unit that attempts to disengage from it. Spells and abilities that relocate another unit do not trigger Assault). This ability costs 6 nora. (AP: 0, CD: 3)  Target friendly champion within 5 spaces gains Strike (This champion's next attack ignores DEF if the target's DEF is greater than 0). This ability costs 6 nora. (AP: 0, CD: 3) ",
      "flavorText": "\"They will contribute taxes to Lord Akakios, as all merchants do. If the Skeezicks wish to contribute to Valdac, then I will set my qualms aside.\" - Gerin, Valdac Council",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Ancient Awakenings",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EG2AE8DG2AE8Dj9Bj9Cerhrolruhnphpqf",
      "deckLimit": 2
    },
    {
      "id": 168,
      "name": "Snaptooth Crypt",
      "description": "Friendly champions with Race: Snaptooth within 5 spaces of this unit gain <ability value=2784>Hunter: Soultapped</ability> and <ability value=607>Essence Capture</ability>.",
      "flavorText": "\"Anyplace dark and murky enough for a Snaptooth to dwell is a place I prefer to steer well clear of.\" - Sabmep, Boghopper Spitter",
      "noraCost": 40,
      "artist": "Andrew Hou",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Wild Alliance",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9BG2BE8DG2AG2Aj9Cj9Dohyvvfxvqoyggrf",
      "deckLimit": 2
    },
    {
      "id": 46,
      "name": "Snow Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability> and Arctic. When an enemy unit moves within 2 spaces of the trap, all opposing champions within range take 8 frost damage and become Frozen 3 (This unit has -1 DMG, -1 DEF and -1 SPD). This damage ignores DEF. All effected spaces become Deep Snow (Impeding 1) for 3 turns.",
      "flavorText": "In this ice lies the heart of a storm, and with it the watchful eye of the Jakei. Any foe that treads near it will feel the bite of the cold, and our warriors will follow suit.",
      "noraCost": 20,
      "artist": "Jakub Kasper",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0Bg3Aj9Dj9Ej9Feephkrjrfklgthg",
      "deckLimit": 2
    },
    {
      "id": 129,
      "name": "Snowcat Burrow",
      "description": "This relic has Arctic. At the start of your next turn, the Snowcat Burrow will spawn a Snowcat on an adjacent space for 10 Nora. Additional Snowcats for 10 nora will be spawned at the beginning of every fourth turn after that.",
      "flavorText": "Dotted along the tundra, East of the Shyron Caverns, are homes of the Snowcats. Snowcats normally live at the deepest point, using their combined body heat for warmth. One burrow can hold as many as a hundred residents; an attack on a burrow brings every Snowcat to its defense.",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8Hg3AE8DG2AF0Aj9Dj9Eerhempnhvqsqoqf",
      "deckLimit": 2
    },
    {
      "id": 115,
      "name": "Soulsphere",
      "description": "All champions you own share damage equally with each other rounded up while this unit is in play (this ignores defense except on the target of an attack).  This unit loses 3 life when a unit you own takes damage.\r\n",
      "flavorText": "\"We share our lives through the Nora. Our souls are conduits, the Nora flowing through each of us as a singular web. An attack against one is an attack against all of us. Remember this lesson.\" - Gekaal, Forglar High One",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 21,
      "size": "1x1",
      "hash": "eJ8HJ8Gf1AE8DG2Ae9BJ8Jj9Aeerufgvkexxoqo",
      "deckLimit": 2
    },
    {
      "id": 162,
      "name": "Soultap Garnet",
      "description": "This relic has Nora Gem (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces) and Soultap Luminescence (When this unit is deployed and at the start of its turns, opposing champions within 4 spaces become Soultapped).",
      "flavorText": "Tempest Garnets are found in the particularly turbulent regions of Forglar Swamp. Their namesake comes from the \"tempest\" that rages beneath the gem's surface.",
      "noraCost": 30,
      "artist": "Matt Dixon",
      "factions": [
        "Forglar Swamp",
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9Be9BE8DG2AG2AJ8GJ8Hygkempfmphrzxo",
      "deckLimit": 2
    },
    {
      "id": 33,
      "name": "Spirit Altar",
      "description": "While this unit is in play, friendly Forglar Swamp champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"We do not serve the Swamp, and the Swamp does not serve us. We ARE the Swamp.\"",
      "noraCost": 25,
      "artist": "Layne Johnson",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Bj9Af1Be9Bf1AJ8Jj9Aj9Bolggtxirhpuzvzg",
      "deckLimit": 1
    },
    {
      "id": 210,
      "name": "Statue of Xulos",
      "description": "This relic has Preordained (This rune is automatically revealed at the beginning of the game) and Statue of Xulos (At the end of each turn, this relic gains 2 MAX HP. Xulos has +1 DMG and +2 MAX HP for every 10 HP this relic currently has. You may only have one copy of this rune in your battlegroup).",
      "flavorText": "\"I heard he's had that thing completed for ages, but didn't have to the guts to unveil it while Serkan was aroundâ?¦\" ~ Overheard in Elsarin\r\n",
      "noraCost": 25,
      "artist": "Alex Konstad",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "RARE",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "ej9Gj9FG2Ae9AG2Ae9Aj9Bj9Cemwvojyowkwmwqf",
      "deckLimit": 1
    },
    {
      "id": 94,
      "name": "Sundered Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 39,
      "name": "Sundered Warbanner",
      "description": "While this unit is in play, friendly Sundered Lands champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"With the blessings of our Gods, we will destroy those who were not worthy of our power.\"",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Cj9BG2Ae9Be9Aj9Fj9Gj9Holnyziignjtmhgg",
      "deckLimit": 1
    },
    {
      "id": 148,
      "name": "Suppression Crystal",
      "description": "This relic has <ability value=600>Arctic</ability>, <ability value=2373>Nora Gem</ability>, <ability value=1807>Deafening Aura</ability> and <ability value=1391>Ignorance</ability> (Enemy Wizards, Clerics and Priests within 5 spaces of this unit may not activate abilities).",
      "flavorText": "\"These magicks have been long forgotten, but they can help you. This crystal can suppress old magic, the same kind your ancients use. If the old magicks are resurfacing, you'll need protection.\" - Zeventrech the Last",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "Savage Tundra"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Maljaran War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8JG2BE8DG2Af1Aj9Cj9Deroszginwtxvsqf",
      "deckLimit": 2
    },
    {
      "id": 223,
      "name": "Swamp Warts",
      "description": "This relic has Marsh Gas (This relic loses 5 HP.  For 1 turn, all Poison damage is treated as Fire damage instead, CD1) and Amplify: Poison (Poison damage dealt to champions and relics is increased by 10%).",
      "flavorText": "\"Nasty place smell foul. Bad gas go boom!\" - Morgo, Cyclops Earthshaker",
      "noraCost": 20,
      "artist": "Filip Burburan",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "The Ronin",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "eJ8HJ8GF0Ae9AG2Ae9BJ8HJ8Ierzxtmhnexmekn",
      "deckLimit": 2
    },
    {
      "id": 27,
      "name": "Tainted Statue",
      "description": "While Tainted Statue is in play, all spells cost 35% more nora to cast. This does not stack. (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "Once celebrating the glory of some forgetten Valdeci general, this statue has been defiled to more closely resemble the Draksar.",
      "noraCost": 25,
      "artist": "Gabriel Garza",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8De9BG2Aj9Bj9Cj9Dukrljygggrumleg",
      "deckLimit": 1
    },
    {
      "id": 120,
      "name": "Target Dummy",
      "description": "This relic has Bodyguard and loses 2 HP at the beginning of each of your turns.",
      "flavorText": "Something troubled Lefir. The makeshift figure stared at him, from its place on the wall. Its crude grimace goaded him, tugging incessantly at his psyche. Lefir would have no more of it. He drew his sword against the burlap tormentor.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 30,
      "size": "1x1",
      "hash": "eJ8HJ8Gg3AE8DG2Ae9Bj9Dj9Eeeiyzxvmjnhpjpf",
      "deckLimit": 2
    },
    {
      "id": 125,
      "name": "Temple of Brutality",
      "description": "Friendly demons and beasts within 5 spaces of this relic gain <ability value=347>Berserk Attack 2</ability> and <ability value=260>Enrage 2</ability>.",
      "flavorText": "Within the Breath of Sheoul, there is a temple that pays homage to Erimalion. Demons in the Overlands frequent this temple to listen to the tales of Erimalion and his deeds. The tales inspire cruelty in its listener. The very sight of the temple often brings viewers into hysterical rage.",
      "noraCost": 30,
      "artist": "Slawomir Maniak",
      "factions": [
        "Underdepths"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8HG2AE8DG2AF0Aj9Bj9Ceigykgtfmllwfpf",
      "deckLimit": 2
    },
    {
      "id": 230,
      "name": "The Collective",
      "description": "This relic has <ability value=2118>Preordained</ability>. Friendly champions deployed from the runedock while this unit is in play that have at least one race not shared by another friendly champion gain +2 DMG and +5 MAX HP permanently. This does not stack.",
      "flavorText": "The Collective invites all those of the Swamp who wish to abandon partisan bickering between the races to form a new and stronger whole.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GF0Ae9BG2Ae9BJ8HJ8Iemnhnjphtssxmn",
      "deckLimit": 2
    },
    {
      "id": 235,
      "name": "The Farm",
      "description": "This relic has The Farm: Beasts (Friendly Beasts gain Opportunistic Assault. This shares a CD with removes the effects of The Farm: Mutants when activated (AP0, CD2)), and The Farm: Mutants (Friendly Mutants gain Pounce. This shares a CD with removes the effects of The Farm: Beasts when activated (AP0, CD2)).",
      "flavorText": "The name may be misleading to outsiders, but the Farm refers not to agriculture, but to the eclectic mix of outcasts and mutants that make up a large part of the Sundered Lands.  For these, representation has been a long time coming.",
      "noraCost": 30,
      "artist": "Alex Konstad",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8Hf1Ae9BG2AF0AJ8Jj9Aemnuhepjtzigyo",
      "deckLimit": 2
    },
    {
      "id": 145,
      "name": "The Foulest Mushroom",
      "description": "This relic has <ability value=907>Amplify Poison</ability>, <ability value=2612>Choking Aura</ability> and <ability value=2227>Choking Stench</ability>.",
      "flavorText": "\"Have you ever smelled a wet Kanen? It's like that, but worse. Imagine two wet Kanen, rubbing dry with Cyclops feet.\" - Pulgan, Boghopper Elite",
      "noraCost": 30,
      "artist": "Charles Chen",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "ej9AJ8Jf1AE8DG2Af1AJ8Jj9Aemsuohpqhipygpf",
      "deckLimit": 2
    },
    {
      "id": 234,
      "name": "The Resistance",
      "description": "This relic has <ability value=3052>The Resistance: Hyaenids</ability> and <ability value=3053>The Resistance: Elemental</ability>.",
      "flavorText": "A \"grassroots\" movement begun by the Hyaenid to fight against what many see as a return to power by their previous corrupt Cyclops overlords.  Some suspect it is the doing of the Djinn, however.",
      "noraCost": 30,
      "artist": "Alex Konstad",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Coalitions",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8He9Be9BG2AF0AJ8GJ8Hevojrjggrjtxmn",
      "deckLimit": 2
    },
    {
      "id": 53,
      "name": "Thorn Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability>. When an enemy unit moves within 2 spaces of the trap, the relic is destroyed and enemy units within range take 6 Physical damage and lose 40% SPD for 5 turns. This damage ignores DEF. All affected units become Eviscerated 5. ",
      "flavorText": "\"Let them come, the forest is old and can defend itself. It will swallow them whole and we will slay their commander\" - Jahne, Serpentine Druid",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0Be9BJ8GJ8HJ8Ieeemsszgphvkpwf",
      "deckLimit": 2
    },
    {
      "id": 123,
      "name": "Throne of the Circle",
      "description": "This relic has <ability value=2022>Throne of the Circle</ability> (Friendly Wizards have Spell Resistance and Magic Nova 3).",
      "flavorText": "The Throne of the Circle was meant as a forum for the Elves of K`thir to discuss the matters facing their home. Over time, only a few voices were allowed to speak and, eventually, these voices became the Circle itself.",
      "noraCost": 35,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8HF0AE8DG2AF0AJ8HJ8Imetxklgnnerwmn",
      "deckLimit": 2
    },
    {
      "id": 166,
      "name": "Thunderhead Totem",
      "description": "This relic has Lightning Skewer (All champions occupying spaces 1 to 6 spaces in a targeted straight line away from this champion take 12 Electricity damage and are Paralyzed 1. This damage ignores DEF), Electricity Aura 1 (At the beginning of your opponent's turns, this unit deals 2 Electricity damage to each champion within 2 spaces. This damage ignores DEF) and Instability (When this unit uses an ability, it loses 10 HP).",
      "flavorText": "Zickspit was the first moga spark to realize his affinity for lightning. In a stroke of divine irony he electrocuted himself after falling into the Slivershine River. This totem is a replica of what Zickspit looked like just before he died.",
      "noraCost": 40,
      "artist": "Matt Dixon",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Heritage",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9Bf1BE8DG2AG2Aj9Aj9Bqwipsofvhirwtqf",
      "deckLimit": 2
    },
    {
      "id": 1,
      "name": "Tome of Hate",
      "description": "At the end of your turn, if your shrine is damaged each real champion loses 2 HP, and then your shrine heals 1 HP for each champion that lost HP this way. Otherwise, this relic loses 4 HP.",
      "flavorText": "\"It would seem that even the books of Old Elsarin lament the Catastrophe.\" - Feofil, Assistant to Rugolth",
      "noraCost": 40,
      "artist": "Gabriel Garza",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Pox Nora Release Set",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "cj9Gj9Fj9EE8Dg3Aj9Ej9Fj9Geilwtfmwigeklnj",
      "deckLimit": 2
    },
    {
      "id": 136,
      "name": "Tortun Land Cannon",
      "description": "This unit has <ability value=2123>Cannon Shot</ability>",
      "flavorText": "\"She's a beauty, isn't she? Had her crafted in Gharivol, I forget the gunsmith's name. She once punched a hole straight through a ship's flank. Beauty and some bite; she's perfect.\" - Captain Tremir Craghide",
      "noraCost": 45,
      "artist": "James Ryman",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "eJ8JJ8If1BE8DG2AF0Bj9Aj9Bmsmsquqqhvhygpf",
      "deckLimit": 2
    },
    {
      "id": 74,
      "name": "Totem of the Muses",
      "description": "This relic has Preordained (This rune is automatically revealed at the beginning of the game). When a real (non-Illusion, non-Summoned) Moga champion you own dies, a Moga Pup is summoned adjacent to this relic. This effect does not stack.",
      "flavorText": "The Totem of the Muses had been hand-carved with exceptional skill. The Moga built it, in honor of their muses Leb and Fen. Until it was built, no one knew of the Moga's ingenuity or their religion.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EE8DE8DG2AE8Dj9Ej9Fgyzzxiyzxfvfgpf",
      "deckLimit": 2
    },
    {
      "id": 188,
      "name": "Tower of Amareth",
      "description": "This relic has Iridescent Projection (When a friendly champion within 8 spaces makes an attack, a random opposing unit within 8 spaces of this one takes 2 Magical damage.  If the attacking champion is a Fairy or a Wizard, the closest unit to this one takes the damage instead.  This damage ignores DEF) and Amplify: Magic (Magic damage dealt to champions and relics is increased by 10%).",
      "flavorText": "\"I don't understand, Menalaus, the towers have laid dormant for years.  What could have awoken them?\" ~ Gregor, Circle Messenger",
      "noraCost": 30,
      "artist": "Alexandur Alexandrov",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Ej9DF0AE8DG2Ag3AJ8HJ8Iyggnjiithnjroqf",
      "deckLimit": 2
    },
    {
      "id": 209,
      "name": "Transmission Relay",
      "description": "When this relic is deployed and at the end of each turn, a Dragon is revealed in your runedock.  If no Dragons are concealed, a random Dragon on CD has its CD reduced by 4.  This relic loses 3 HP when a friendly dragon is deployed.",
      "flavorText": "Valdac and Vindrax were convinced of Vex's demise when they were unable to contact her even after the deployment of additional Transmission Relays\r\n",
      "noraCost": 25,
      "artist": "Asa Enochs",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Bonds of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9Ff1Be9AG2Ae9Aj9Aj9Bonhymhtuxfgkrqf",
      "deckLimit": 2
    },
    {
      "id": 124,
      "name": "Tribal Hut",
      "description": "This rleic has Preordained (This rune is automatically revealed at the beginning of the game) and Tribal Hut (Friendly Cyclops Mauler, Cyclops Lurker, Drudge Cyclops and Cyclops Hauler have Sibling. When this relic is destroyed, Cyclops within 8 spaces gain 2 AP).",
      "flavorText": "To share a home is considered a bonding between Cyclopes. A home is considered a familial unit and those that share it are kin. This practice died out when Voil took over their lands, but was revived as Voil influence waned.",
      "noraCost": 25,
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Dire Covenant",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8IJ8HF0BE8DG2AF0AJ8IJ8Jevfxvsukllnpqo",
      "deckLimit": 2
    },
    {
      "id": 38,
      "name": "Tribal Post",
      "description": "While this unit is in play, friendly Shattered Peaks champions gain +5 HP and +1 DMG. This effect does not stack and does not affect teammates in 2v2 games.",
      "flavorText": "\"They come in waves.\"",
      "noraCost": 25,
      "artist": "Gabriel Garza",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Drums of War",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Cj9BG2Ae9BE8Dj9Ej9Fj9Geipuoqlnepymsfg",
      "deckLimit": 1
    },
    {
      "id": 135,
      "name": "Unassuming Tree",
      "description": "This relic has Remove Disguise (This ability begins play on cooldown.  This unit is destroyed and a Level 3 Garu Shaman, Garu Hunter, or Garu Primitive is spawned in the location this unit occupied).",
      "flavorText": "\"Day 3. I sat against a tree to take respite. I was enjoying a snack of seeds when I felt the trunk rumble. Then, the tree asked if it could have some.\" - Vahkosh, Headhunter",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Maljaran Frontier",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 2,
      "hitPoints": 25,
      "size": "1x1",
      "hash": "eJ8JJ8If1AE8DG2AF0BJ8Jj9Aeeeeerfietxfxo",
      "deckLimit": 2
    },
    {
      "id": 95,
      "name": "Underdepths Giving Tree",
      "description": "Drop a Mysterious Gift on an open location within 2 spaces. This gift may have positive or negative effects.",
      "flavorText": "The Giving Tree signifies a time of generosity, before the world was scarred by war. Gifts are placed underneath its shade for any passerby to partake, be they friend or foe.",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "Underdepths"
      ],
      "rarity": "LIMITED",
      "runeSet": "Dawn of Elements",
      "forSale": false,
      "allowRanked": true,
      "tradeable": true,
      "defense": 1,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Fj9EE8Df1BG2Aj9Bj9Cj9Dkumyrqhvfvvhggg",
      "deckLimit": 2
    },
    {
      "id": 8,
      "name": "Unholy Tomb",
      "description": "At the start of your turns, all enemy champions lose 1 HP and you gain 1 nora for each real champion that loses HP this way. This does not stack.",
      "flavorText": "\"It'll take more than some gargoyle carvings to scare me off this dig.\" -- Halver Mudknuckle, Grave Robber, last words",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "EXOTIC",
      "runeSet": "Savage Tundra Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "cj9Fj9Ej9Dg3Ag3Aj9Dj9Ej9Finyrwowkwtzxftj",
      "deckLimit": 2
    },
    {
      "id": 76,
      "name": "Unstable Powersource",
      "description": "This relic has Draw Power (Your Shrine or Avatar loses 10 life and you gain 5 nora) and Overload (Relics within 10 spaces take 10 Electricity damage). ",
      "flavorText": "The ruins of Old Valdac held many artifacts that would prove useful to the Draksar. However, some of them had unintended consequences. ",
      "noraCost": 35,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "RARE",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 29,
      "size": "1x1",
      "hash": "ej9Fj9Ee9BE8DG2AE8DJ8GJ8Hshpqqfgknpfvqo",
      "deckLimit": 2
    },
    {
      "id": 154,
      "name": "Unstable Tiger's Eye",
      "description": "This relic has Nora Gem (This unit is a Nora Gem. It gains the abilities of any friendly relic with Nora Gem within 5 spaces) and Destabilizing Luminesence (Spaces within 3 spaces of this unit is Unstable Ground). ",
      "flavorText": "Leoss Monks used Reflecting Tiger's Eye to view themselves in a different way. The confounding nature of its many reflective surfaces helped them to meditate.",
      "noraCost": 35,
      "artist": "Matt Dixon",
      "factions": [
        "Savage Tundra",
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dawn",
      "forSale": true,
      "allowRanked": false,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Bj9AF0BE8DG2Af1BJ8IJ8Jkpjexfevkplygpf",
      "deckLimit": 2
    },
    {
      "id": 255,
      "name": "Valdaci Emerald",
      "description": "This relic has <ability value=153>Acidic Aura 3</ability>.",
      "flavorText": "The remains of the Valdaci live on in a second form.",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "rarity": "LIMITED",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Ej9Df1Af1BG2Ag3AJ8Jj9Aeeekrzonegyvqsf",
      "deckLimit": 2
    },
    {
      "id": 275,
      "name": "Valdaci Emerald",
      "description": "This relic has <ability value=153>Acidic Aura 3</ability>.",
      "flavorText": "The remains of the Valdaci live on in a second form.",
      "noraCost": 25,
      "artist": "Bartek Gawel",
      "factions": [
        "Ironfist Stronghold",
        "Sundered Lands"
      ],
      "rarity": "LEGENDARY",
      "runeSet": "Spirits Beyond",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "ej9Ej9Df1Af1BG2Ag3AJ8Jj9Aeeekrzonegyvqsf",
      "deckLimit": 2
    },
    {
      "id": 49,
      "name": "Venom Trap",
      "description": "This relic has <ability value=601>Shadowspawn</ability>. When an enemy champion moves within 2 spaces of this relic, this relic is destroyed and enemy units within 2 spaces take 6 Acid damage, become Scoured 3 (This champion has -1 DEF and takes Acid damage equal to this effect's duration at the start of each turn), and Blinded (Any attack this unit makes will miss) for 1 turn. This damage ignores DEF.",
      "flavorText": "The traps created by the Draksar craftsmen are filled with the concentrated venom from the Cobra Spitter. It is the nora mixed with the poison that causes the magical blindness",
      "noraCost": 25,
      "artist": "Bryan Rypkowski",
      "factions": [
        "Sundered Lands"
      ],
      "rarity": "COMMON",
      "runeSet": "Grimlic's Descent",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 15,
      "size": "1x1",
      "hash": "dj9Fj9EE8DF0Bf1Bj9Aj9Bj9Ceeeevfvfiiwqjeg",
      "deckLimit": 2
    },
    {
      "id": 163,
      "name": "Vinetouch Pedestal",
      "description": "This relic has Vinetouch (Champions that come into play under your control within 3 spaces of this unit gain Race: Treefolk and Race: Plant) and Preordained (This rune is automatically revealed at the beginning of the game).",
      "flavorText": "\"Approach the pedestal and you will know what it is to be a Gnarlwood. You share this forest with our kind and it is time you understood who we are.\" - Sapaleh the Ancient ",
      "noraCost": 25,
      "artist": "James Ryman",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "COMMON",
      "runeSet": "Heroes' Dusk",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Cj9BF0AE8DG2AG2AJ8HJ8Iklrwvvsxousxfpf",
      "deckLimit": 2
    },
    {
      "id": 114,
      "name": "Voil Caverns",
      "description": "When an opposing real champion within 5 spaces is destroyed, a Young Bat with no upgrades is summoned adjacent to this unit.",
      "flavorText": "The Shattered Peaks have become a fortress for the Voil. With many intricate crevices and caverns, they found places to recover. Some of these places became permanent refuges.",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "COMMON",
      "runeSet": "Broodcall",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "eJ8HJ8GF0BE8DG2Ae9BJ8IJ8Jeeginlevzgkwmn",
      "deckLimit": 2
    },
    {
      "id": 143,
      "name": "Voil King's Crypt",
      "description": "Friendly champions with Race: Voil within 5 spaces gain <ability value=1276>Vengeful</ability> and <ability value=2557>Martyrdom</ability>.",
      "flavorText": "\"Here lies Ruubgaal, the king of the Voil, the master of the Shattered Peaks, the Voil who built an Empire. May he rest in peace. No stealing, no loitering.\" - Inscription on the crypt of the Voil King",
      "noraCost": 25,
      "artist": "Jakub Kasper",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Heroes of Maljara",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9AJ8JF0AE8DG2Af1AJ8HJ8Ikruzvfpqwfvkuo",
      "deckLimit": 2
    },
    {
      "id": 244,
      "name": "Watershed Anchor",
      "description": "This relic has Anchoring Force (Enemy champions within 5 spaces are Slowed). This Relic has Water Front (At the beginning of each turn, all spaces within 3 spaces of this champion becomes Shallow Water for 4 turns).",
      "flavorText": "Few things found beneath the waves are treasure, but many are still useful.",
      "noraCost": 35,
      "artist": "Maciej Janaszek",
      "factions": [
        "Forglar Swamp"
      ],
      "rarity": "RARE",
      "runeSet": "Visions of Amareth",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Gj9FF0Af1AG2Ae9AJ8HJ8Iwmjrzggpjyojnpf",
      "deckLimit": 2
    },
    {
      "id": 13,
      "name": "Wind Generator",
      "description": "All units within 5 spaces have Earthbound (This champion is Grounded and cannot gain Flying. It cannot be relocated, leap, or pounce).",
      "flavorText": "\"When will the generators be up and running?  The eastern wall is being picked apart by those blasted winged Draksar!\" - Tunkin, Ironfist General",
      "noraCost": 20,
      "artist": "Matt Dixon",
      "factions": [
        "Ironfist Stronghold"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9Af1AJ8Jj9Aj9Byrsjeipnjgilufg",
      "deckLimit": 2
    },
    {
      "id": 77,
      "name": "Witches' Hourglass",
      "description": "Friendly champions with Class: Witch within 5 spaces of this unit gain <ability value=2596>Forsaken Exploit</ability>.",
      "flavorText": "\"Each grain of sand is precious, but the loss of each grain holds an equal beauty. Yet, they do not see this. If only they had time to reflect upon it, as I have.\" - Xulos, Undead Sage",
      "noraCost": 25,
      "artist": "Anthony Lopes",
      "factions": [
        "Forsaken Wastes"
      ],
      "rarity": "UNCOMMON",
      "runeSet": "Dawn of Elements",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Fj9EF0AE8DG2AE8DJ8HJ8Ikrhvfgvhpwxquo",
      "deckLimit": 2
    },
    {
      "id": 20,
      "name": "Wooden Scales",
      "description": "When a player successfully casts a spell, each of that player's champions gets -1 DEF and the opponent's champions gets +1 DEF for the next three rounds. (Unique: Spell Seal - you may only have 2 Spell Seal runes in your Battlegroup)",
      "flavorText": "Originally built after the formation of the Eternal Circle as a monument to the old ways, the wooden scales have grown to be a symbol of unity in the elven nations.",
      "noraCost": 20,
      "artist": "Layne Johnson",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Shattered Peaks Expansion",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dj9Ej9Dg3Ae9AG2Aj9Bj9Cj9Dsxqlpyrjtolnuhg",
      "deckLimit": 1
    },
    {
      "id": 70,
      "name": "Woodland Portal",
      "description": "This relic has <ability value=2530>Seal of the Vashal</ability>. Champions adjacent to this relic gain Swap rank 3 (Exchange places with target friendly champion of the same size within 1 to 5 spaces).",
      "flavorText": "\"These forests hold many doors to many different places. They are woven through the trees. Their halls are the wind. They just need a special touch to open.\" - K'tarin, Elven Mage",
      "noraCost": 30,
      "artist": "Jakub Kasper",
      "factions": [
        "K'thir Forest"
      ],
      "rarity": "RARE",
      "runeSet": "Nora Surge",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "dJ8JJ8IF0Bf1Ag3Aj9Dj9Ej9Fiwiwqjgexolrohg",
      "deckLimit": 2
    },
    {
      "id": 185,
      "name": "Zemi of the Elements",
      "description": "This relic has Elemental Zephyr (Friendly Elementals within 5 spaces have Mobility and +1 SPD), Deafening Aura (Whenever an enemy champion moves within 2 spaces of this champion, it takes 3 Sonic damage and is Distracted 2 (This unit may only activate basic attacks). This damage ignores DEF) and Repulsion (At the beginning of your turn, any enemy champion without Iron Will within 5 spaces of this unit is moved 2 spaces directly away from this unit).",
      "flavorText": "\"Do not trifle with power you cannot even begin to comprehend.\" ~ Peaks Ifrit",
      "noraCost": 25,
      "artist": "Andrew Hou",
      "factions": [
        "Shattered Peaks"
      ],
      "rarity": "RARE",
      "runeSet": "Endless Wonder",
      "forSale": true,
      "allowRanked": true,
      "tradeable": true,
      "defense": 0,
      "hitPoints": 20,
      "size": "1x1",
      "hash": "ej9Ej9DE8DE8DG2Ag3Aj9Ej9Fyrsojiyvxklrwqf",
      "deckLimit": 2
    }
  ]

export {champs, relics, spells, equips}